// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/react-scripts/node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/primereact/resources/themes/lara-light-indigo/theme.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/react-scripts/node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/primeicons/primeicons.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/react-scripts/node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/primereact/resources/primereact.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/react-scripts/node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/react-time-picker/dist/TimePicker.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/react-scripts/node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/react-clock/dist/Clock.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/react-scripts/node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/react-datepicker/dist/react-datepicker.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/assets/img/theme/bg-1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../public/assets/img/theme/bg-2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../public/assets/img/theme/bg-3.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../public/assets/img/theme/bg-4.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27M6 8l4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../public/assets/img/authentication/login-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../public/assets/img/authentication/register-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../public/assets/img/authentication/forgot-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../public/assets/img/authentication/reset-bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Nunito:wght@300;400;500;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800;900&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/****** Utils ******/
/****** Layout ******/
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  border-radius: 50px !important;
}

::-webkit-scrollbar-track {
  background: #898989;
}

::-webkit-scrollbar-thumb {
  background: #E41F07;
}

::-webkit-scrollbar-thumb:hover {
  background: #898989;
}

.swal2-header .swal2-title {
  font-size: 18px;
}

.none {
  display: none !important;
}

.text-red {
  color: #FC0027 !important;
}

.text-green {
  color: #5CB85C !important;
}

.input-blocks input[type=text]:focus {
  border-color: #E8E8E8;
}

.input-group .scanner-set {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  background: #E41F07;
  border-radius: 5px !important;
  width: 40px;
  color: #FFF;
  font-weight: 600;
  padding: 0;
}
.input-group .scanner-set:hover {
  background: #262A2A;
}

::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  border-radius: 50px !important;
}

::-webkit-scrollbar-track {
  background: #898989;
}

::-webkit-scrollbar-thumb {
  background: #E41F07;
}

::-webkit-scrollbar-thumb:hover {
  background: #898989;
}

.swal2-header .swal2-title {
  font-size: 18px;
}

.none {
  display: none !important;
}

.text-red {
  color: #FC0027 !important;
}

.text-green {
  color: #5CB85C !important;
}

.input-blocks input[type=text]:focus {
  border-color: #E8E8E8;
}

.form-sorts {
  position: relative;
}
.form-sorts > a {
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
  background: #FFF;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  padding: 9px 21px;
}
@media (max-width: 991.98px) {
  .form-sorts > a {
    padding: 9px 12px;
  }
}
.form-sorts > a i {
  margin-right: 8px;
}
.form-sorts > a:hover {
  color: #262A2A;
}
.form-sorts > a.show {
  border: 1px solid #0092E4;
}
@media (max-width: 575.98px) {
  .form-sorts > a {
    width: 100%;
  }
}
.form-sorts .filter-dropdown-menu {
  padding: 24px;
  border-radius: 5px;
  background: #FFF;
  border: 1px solid #E8E8E8;
  box-shadow: 0px 4px 24px 0px rgba(188, 188, 188, 0.2509803922);
  position: absolute;
  z-index: 1;
  min-width: 400px;
  right: 0;
  top: 40px;
}
@media (max-width: 767.98px) {
  .form-sorts .filter-dropdown-menu {
    min-width: 270px;
  }
}
@media (max-width: 575.98px) {
  .form-sorts .filter-dropdown-menu {
    right: unset;
    left: 0;
  }
}
.form-sorts.table-filter-show .filter-dropdown-menu {
  display: block;
  opacity: 1;
}
.form-sorts .filter-set-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-bottom: 14px;
}
.form-sorts .filter-set-head h4 {
  margin-bottom: 10px;
}
.form-sorts .filter-set-head h4 i {
  margin-right: 8px;
}
@media (max-width: 991.98px) {
  .form-sorts .filter-set-head h4 {
    font-size: 16px;
  }
}
.form-sorts .filter-set-head a {
  color: #4A00E5;
  margin-bottom: 10px;
}
.form-sorts .filter-set-head a:hover {
  color: #E41F07;
}
.form-sorts .filter-set-content {
  margin-bottom: 24px;
}
.form-sorts .filter-set-content .filter-set-content-head a {
  display: flex;
  align-items: center;
  color: #262A2A;
  font-weight: 600;
  position: relative;
  padding-left: 16px;
}
.form-sorts .filter-set-content .filter-set-content-head a::before {
  content: "\\f054";
  font-family: "Font Awesome 5 Free";
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  font-size: 14px;
}
.form-sorts .filter-set-content .filter-set-content-head a:not(.collapsed) {
  padding-left: 20px;
}
.form-sorts .filter-set-content .filter-set-content-head a:not(.collapsed)::before {
  content: "\\f078";
}
.form-sorts .filter-reset-btns a {
  padding: 6px 10px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 5px;
  width: 100%;
}
@media (max-width: 575.98px) {
  .form-sorts .filter-reset-btns a {
    padding: 10px 30px;
  }
}
.form-sorts .filter-reset-btns .btn-light {
  background: #F5F5F5;
  border: 1px solid #E8E8E8;
}

.radio-btn-items {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 14px;
}
.radio-btn-items .radio-btn {
  margin: 0 30px 10px 0;
}
.radio-btn-items .radio-btn:last-child {
  margin-right: 0;
}

.filter-set-contents .filter-content-list {
  background: #F9F9FC;
  border-radius: 5px;
  padding: 15px;
  margin-top: 15px;
}
.filter-set-contents .filter-content-list .form-wrap {
  margin-bottom: 15px;
}
.filter-set-contents .filter-content-list .form-wrap .form-control {
  max-width: 100%;
}
.filter-set-contents .filter-content-list ul {
  max-height: 150px;
  overflow-y: auto;
  padding: 1px 0;
}
.filter-set-contents .filter-content-list ul::-webkit-scrollbar {
  width: 3px;
  background: #E41F07;
  height: 1px;
}
.filter-set-contents .filter-content-list ul::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgb(231, 231, 231);
  border-radius: 4px;
}
.filter-set-contents .filter-content-list ul::-webkit-scrollbar-thumb {
  background: #E41F07;
  border-radius: 4px;
}
.filter-set-contents .filter-content-list ul li {
  position: relative;
  display: flex;
  margin-bottom: 15px;
}
.filter-set-contents .filter-content-list ul li:last-child {
  margin-bottom: 0;
}
.filter-set-contents .filter-content-list ul li .checkboxs {
  padding-left: 0;
  display: flex;
  align-items: center;
}
.filter-set-contents .filter-content-list ul li .checkboxs .checkmarks {
  position: relative;
  top: 0;
  margin-right: 5px;
  display: flex;
}
.filter-set-contents .filter-content-list ul li .rating {
  margin-left: 0;
}
.filter-set-contents .filter-content-list ul li .rating i {
  color: #E8E8E8;
}
.filter-set-contents .filter-content-list ul li .rating i.filled {
  color: #FDA700;
}
.filter-set-contents .filter-content-list ul li .rating span {
  margin-left: 5px;
}
.filter-set-contents .filter-content-list ul li .collapse-inside-text {
  margin-left: 0;
}
.filter-set-contents .filter-content-list ul li .collapse-inside-text h5 {
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
}

.page-wrapper {
  transition: all 0.5s ease;
  margin: 0 0 0 276px;
  padding: 56px 0 0;
  position: relative;
  left: 0;
  transition: all 0.2s ease;
}
@media (max-width: 991.98px) {
  .page-wrapper {
    margin: 0;
    padding: 60px 0 0;
  }
}
.page-wrapper .content {
  padding: 24px;
  padding-bottom: 0;
}
@media (max-width: 991.98px) {
  .page-wrapper .content {
    padding: 15px 15px 0;
  }
}

.header {
  height: 56px;
  z-index: 999;
  background: #FFF;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  transition: all 0.5s ease;
}
.header .flag-nav > a img {
  border-radius: 50%;
  width: 22px;
  height: 22px;
}
.header .searchinputs {
  padding: 0;
  position: relative;
}
.header .searchinputs input {
  width: 335px;
  height: 42px;
  border: 1px solid #F6F6F6;
  background: #F6F6F6;
  padding: 5px 10px;
  padding-right: 35px;
  border-radius: 5px;
  color: #262A2A;
}
@media (max-width: 1199.98px) {
  .header .searchinputs input {
    width: 170px;
  }
}
.header .searchinputs input::placeholder {
  color: #6F6F6F;
}
.header .searchinputs .search-addon button {
  z-index: 9;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border-radius: 5px;
  cursor: pointer;
  background: transparent;
  border: 0;
  padding: 0;
  color: #262A2A;
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
}
@media (min-width: 992px) {
  .header .dropdown-menu {
    top: 85px;
    right: 0;
    left: auto;
    min-width: 200px;
    visibility: hidden;
    opacity: 0;
    border: 0;
    display: block;
    border-radius: 5px;
    box-shadow: 0px 4px 74px 0px rgba(208, 208, 208, 0.2509803922);
    margin: 0;
    padding: 0;
    transition: all 0.4s ease;
    transform: translateY(20px);
    -webkit-transform: translateY(20px);
    -ms-transform: translateY(20px);
  }
}
@media (max-width: 991.98px) {
  .header .dropdown-menu {
    transition: none;
  }
}
.header .dropdown-menu.show {
  visibility: visible;
  opacity: 1;
  margin-top: 8px !important;
  transform: translateY(0);
  -webkit-transform: translateY(0);
  -ms-transform: translateY(0);
  transition: all 0.4s ease;
}
.header .header-left {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  float: left;
  height: 56px;
  position: relative;
  text-align: center;
  width: 276px;
  z-index: 1;
  background: #FFF;
  padding: 0 15px;
  transition: all 0.5s ease;
}
.header .header-left .logo {
  display: inline-block;
  line-height: 0;
}
.header .header-left .logo img {
  width: 140px;
  display: block;
}
.header .header-left .logo img.white-logo {
  display: none;
}
@media (max-width: 991.98px) {
  .header .header-left .logo {
    text-align: center;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .header .header-left .logo img {
    width: 140px;
  }
}
.header .header-left .logo-small {
  display: none;
}
@media (max-width: 991.98px) {
  .header .header-left {
    position: absolute;
    width: 100%;
  }
}
@media (max-width: 991.98px) {
  .header .header-left #toggle_btn {
    display: none;
  }
}
@media (min-width: 991.98px) {
  .header #toggle_btn {
    font-size: 18px;
    padding: 4px;
    border-radius: 6px;
  }
  .header #toggle_btn .bar-icon {
    display: inline-block;
    width: 21px;
  }
  .header #toggle_btn .bar-icon span {
    background-color: #FFF;
    display: block;
    float: left;
    height: 2px;
    width: 21px;
    margin: 0 0 5px;
    border-radius: 50px;
  }
  .header #toggle_btn .bar-icon span:nth-child(2) {
    width: 15px;
  }
}
.header .bar-icon {
  display: inline-block;
  width: 31px;
  margin-top: 20px;
}
.header .bar-icon span {
  background-color: #E41F07;
  display: block;
  float: left;
  height: 3px;
  margin-bottom: 7px;
  width: 31px;
  border-radius: 2px;
  transition: all 0.5s;
}
.header .bar-icon span:nth-child(2) {
  width: 16px;
}
.header .menu-opened .slide-nav .bar-icon {
  display: inline-block;
  width: 31px;
  margin-top: 20px;
}
.header .menu-opened .slide-nav .bar-icon span:first-child {
  position: relative;
  top: 10px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
}
.header .menu-opened .slide-nav .bar-icon span:nth-child(2) {
  display: none;
}
.header .menu-opened .slide-nav .bar-icon span:last-child {
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  -ms-transform: rotate(135deg);
}
.header .menus-info {
  min-width: 500px;
  border-radius: 5px;
  padding: 8px;
}
@media (max-width: 1199.98px) {
  .header .menus-info {
    min-width: 430px;
  }
}
.header .menus-info .menu-list li {
  margin-bottom: 0;
  margin-right: 0;
}
.header .menus-info .menu-list li a {
  display: block;
  padding: 8px;
  background: #FFF;
  border-radius: 5px;
}
.header .menus-info .menu-list li a:hover {
  background: #F6F6F6;
}
.header .menus-info .menu-list li a .menu-details {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.header .menus-info .menu-list li a .menu-details .menu-list-icon {
  font-size: 18px;
  color: #FFF;
  width: 36px;
  min-width: 36px;
  height: 36px;
  padding: 5px;
  margin-right: 8px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.header .menus-info .menu-list li a .menu-details .menu-details-content p {
  font-weight: 600;
  color: #262A2A;
  margin-bottom: 0;
}
.header .menus-info .menu-list li a .menu-details .menu-details-content span {
  font-weight: 400;
  color: #6F6F6F;
}
@media (max-width: 1199.98px) {
  .header .menus-info .menu-list li a .menu-details .menu-details-content span {
    font-size: 13px;
  }
}
.header .profilename {
  padding: 0px;
}
.header .profilename .profileset {
  display: flex;
  padding: 10px 10px 3px;
}
.header .profilename .profileset h6 {
  font-size: 14px;
  color: #FFA201;
  font-weight: 500;
}
.header .profilename .profileset h5 {
  font-size: 14px;
  color: #565E5E;
}
.header .profilename .profileset .profilesets {
  margin-left: 10px;
}
.header .profilename .profileset .user-img img {
  margin-top: 0;
}
.header .show .user-info::after {
  transform: rotate(-140deg);
  top: 10px;
}
.header .user-info {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  position: relative;
  padding: 0;
}
@media (max-width: 1199.98px) {
  .header .user-info span.user-detail {
    display: none;
  }
}
.header .user-info::after {
  content: "";
  width: 8px;
  height: 8px;
  border-top: 0;
  border-left: 0;
  border-right: 2px solid #1B2950;
  border-bottom: 2px solid #1B2950;
  border-radius: 1px;
  transform: rotate(45deg);
  transition: all 0.5s;
  top: 8px;
  position: absolute;
  right: 12px;
  display: none;
}
@media (max-width: 1199.98px) {
  .header .user-info::after {
    top: 12px;
  }
}
.header .user-info .user-role {
  display: block;
  color: #67748E;
  font-size: 12px;
}
.header .user-info .user-letter {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #FFF;
  width: 36px;
  height: 36px;
  border-radius: 5px;
  font-weight: 600;
  font-size: 15px;
  margin-right: 0;
}
@media (max-width: 1199.98px) {
  .header .user-info .user-letter {
    margin-right: 0;
  }
}
.header .user-info .user-letter img {
  border-radius: 5px;
}
.header .user-info .user-name {
  font-size: 15px;
  font-weight: 600;
  color: #1B2950;
  display: flex;
  align-items: center;
}
.header .user-info .user-name img {
  margin-left: 10px;
}
.header .header-user {
  padding: 15px 24px;
  display: contents;
}
.header .header-user .user-menu {
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  margin: 0;
  position: relative;
  height: 100%;
  border-bottom: 0;
  padding: 0 24px;
  transition: all 0.5s ease;
}
@media (max-width: 991.98px) {
  .header .header-user .user-menu {
    display: none;
  }
}
.header .header-user .user-menu .status {
  position: absolute;
  content: "";
  background: #E41F07;
  width: 10px;
  height: 10px;
  border-radius: 50px;
  top: 3px;
  right: 3px;
}
.header .header-user .user-menu .header-title h3 {
  font-size: 24px;
  font-weight: 700;
}
.header .header-user .user-menu .header-title h6 {
  font-size: 12px;
  font-weight: 600;
}
.header .header-user .user-menu > li {
  margin-left: 10px;
  margin-inline-end: 0;
}
.header .header-user .user-menu > li:first-child {
  margin-left: 0;
}
@media (max-width: 1199.98px) {
  .header .header-user .user-menu > li {
    margin-left: 8px;
  }
}
.header .header-user .user-menu > li svg {
  width: 18px;
  color: #67748E;
}
.header .header-user .user-menu > li a:hover svg {
  color: #E41F07;
}
.header .header-user .user-menu .dropdown-toggle::after {
  border: 0;
  display: none;
}
.header .header-user .user-menu .nav-searchinputs {
  margin-right: auto;
  margin-left: 25px;
}
.header .header-user .user-menu .nav-item-box > a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  background: #F6F6F6;
  color: #262A2A;
  border-radius: 5px;
  width: 36px;
  height: 36px;
  position: relative;
  border: 0;
}
.header .header-user .user-menu .nav-item-box > a:hover {
  background: #EAEAEA;
}
.header .header-user .user-menu .nav-item-email.nav-item-box {
  margin-left: 15px;
}
.header .header-user .user-menu.nav > li > a {
  padding: 0;
  display: flex;
  line-height: normal;
  color: #3E4265;
}
.header .header-user .user-menu.nav > li > a.btn-header-list {
  color: #FFF;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
}
.header .header-user .user-menu.nav > li > a .badge {
  color: #FFF;
  font-weight: 700;
  position: absolute;
  top: 4px;
  right: 4px;
  background: #E41F07;
  width: 15px;
  height: 15px;
  font-size: 10px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.header .header-user .user-menu.nav > li > a i {
  font-size: 18px;
}
.header .header-user .user-menu.nav > li > a .badge-success {
  background: #5CB85C;
  border: 3px solid #FFF;
  padding: 0;
  top: inherit;
  bottom: -3px;
  right: -3px;
}
.header .header-user .user-menu.nav > li.flag-nav a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.header .header-user .user-menu.nav > li.flag-nav a .dropdown-menu {
  max-height: 150px;
  min-width: 120px;
  overflow-y: auto;
}
.header .header-user .user-menu.nav > li.flag-nav a .dropdown-menu .dropdown-item {
  padding: 5px 15px;
}
.header .header-user .user-menu.nav > li.flag-nav .dropdown-menu {
  padding: 15px;
  min-width: 210px;
}
.header .header-user .user-menu.nav > li.flag-nav .dropdown-menu .dropdown-item {
  padding: 10px 10px;
  color: #67748E;
  border-radius: 10px;
  transition: none;
}
.header .header-user .user-menu.nav > li.flag-nav .dropdown-menu .dropdown-item.active {
  color: #FFF;
}
.header .header-user .user-menu.nav > li.flag-nav .dropdown-menu .dropdown-item.active, .header .header-user .user-menu.nav > li.flag-nav .dropdown-menu .dropdown-item:hover {
  background: #F7F7F7 no-repeat calc(100% - 12px) center;
}
.header .header-user .user-menu.nav > li.flag-nav .dropdown-menu a img {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-right: 10px;
}
.header .page-title-box {
  float: left;
  height: 60px;
  margin-bottom: 0;
  padding: 17px 20px;
  border-radius: 0;
}
@media (max-width: 991.98px) {
  .header .page-title-box {
    display: none;
  }
}
.header .page-title-box a {
  color: #E41F07;
  font-size: 11px;
  font-weight: 700;
  border: 1px solid #E41F07;
  margin: 0;
  padding: 5px;
  border-radius: 5px;
}
.header .page-title-box a:hover {
  background: #E41F07;
  color: #FFF;
}
.header .mobile_btn {
  display: none;
  float: left;
}
@media (max-width: 991.98px) {
  .header .mobile_btn {
    color: #E41F07;
    font-size: 24px;
    height: 60px;
    line-height: 60px;
    width: 60px;
    z-index: 10;
    padding: 0 20px;
    position: absolute;
    top: 0;
    left: 0;
    display: block;
  }
}
.header .responsive-search {
  display: none;
  color: #FFF;
  font-size: 20px;
  height: 60px;
  line-height: 60px;
  padding: 0 15px;
}
@media (max-width: 991.98px) {
  .header .responsive-search {
    display: block;
  }
}
.header .top-nav-search form {
  position: relative;
}
@media (max-width: 991.98px) {
  .header .top-nav-search form {
    display: none;
  }
}
.header .top-nav-search form .form-control {
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.15);
  height: 40px;
  padding: 10px 50px 10px 15px;
  border-radius: 50px;
}
.header .top-nav-search form .form-control::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.7);
}
.header .top-nav-search form .btn {
  background-color: transparent;
  border-color: transparent;
  color: rgba(255, 255, 255, 0.7);
  min-height: 40px;
  position: absolute;
  top: 0;
  right: 0;
}
@media (max-width: 991.98px) {
  .header .top-nav-search.active form {
    display: block;
    position: absolute;
    left: 0;
  }
  .header .top-nav-search.active form .form-control {
    background-color: #FFF;
  }
  .header .top-nav-search.active form .btn {
    background-color: transparent;
    border-color: transparent;
    min-height: 40px;
    position: absolute;
    top: 0;
    right: 0;
    padding: 7px 15px;
  }
}
.header .userset {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.header .userset .usernames {
  line-height: initial;
  text-align: right;
  padding-right: 10px;
}
.header .userset .usernames span {
  display: block;
  line-height: initial;
}
.header .menu-drop-user .dropdown-item {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  font-size: 14px;
  color: #262A2A;
  padding: 10px;
  border-bottom: 1px solid #F5F5F5;
  border-radius: 0;
}
.header .menu-drop-user .dropdown-item:first-child {
  border-radius: 5px 5px 0 0;
}
.header .menu-drop-user .dropdown-item:last-child {
  border-radius: 0 0 5px 5px;
  border-bottom: 0;
}
.header .menu-drop-user .dropdown-item:hover {
  padding-left: 20px;
  letter-spacing: 0.5px;
}
.header .menu-drop-user .dropdown-item i {
  font-size: 16px;
  margin-right: 8px;
}
@media (max-width: 991.98px) {
  .header .has-arrow .dropdown-toggle > span:nth-child(2) {
    display: none;
  }
  .header .has-arrow .dropdown-toggle:after {
    display: none !important;
  }
}
.header .profilename .user-img .status {
  bottom: 10px;
}
.header .user-img {
  display: inline-block;
  position: relative;
}
.header .user-img img {
  width: 38px;
  border-radius: 50%;
}
.header .user-img .status {
  border: 2px solid #FFF;
  height: 10px;
  width: 10px;
  margin: 0;
  position: absolute;
  right: 0;
  bottom: 30px;
  border-radius: 50%;
  display: inline-block;
  background: #5CB85C;
}
.header .mobile-user-menu {
  color: #FFF;
  display: none;
  float: right;
  font-size: 24px;
  height: 60px;
  line-height: 60px;
  text-align: right;
  width: 60px;
  z-index: 10;
  padding: 0 20px;
  position: absolute;
  top: 0;
  right: 0;
}
@media (max-width: 991.98px) {
  .header .mobile-user-menu {
    display: block;
  }
}
.header .mobile-user-menu a {
  color: #E41F07;
  padding: 0;
}
.header .mobile-user-menu a::after {
  display: none;
}
.header .mobile-user-menu .dropdown-menu {
  padding: 0;
}
.header .mobile-user-menu .dropdown-menu a {
  color: #323737;
  line-height: 40px;
  padding: 0 10px;
}

.logo-small img {
  width: 30px;
}

@media (min-width: 992px) {
  .mini-sidebar.expand-menu .header-left {
    flex-direction: row;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    -ms-flex-pack: space-between;
  }
  .mini-sidebar .header-left {
    display: flex;
    align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    width: 80px;
    padding: 0;
    flex-direction: column;
  }
  .mini-sidebar .header-left .logo-small {
    display: block;
    padding: 10px 0 0;
  }
  .mini-sidebar .header-left .logo {
    display: none;
  }
  .mini-sidebar .menu-arrow {
    display: none !important;
  }
  .mini-sidebar .chat-user {
    display: none !important;
  }
  .mini-sidebar .user-menu .badge {
    display: flex !important;
  }
  .mini-sidebar.expand-menu .menu-arrow {
    display: block !important;
  }
  .mini-sidebar.expand-menu .chat-user {
    display: block !important;
  }
  .mini-sidebar.expand-menu .logo-small {
    display: none;
  }
  .mini-sidebar.expand-menu .logo {
    display: block;
  }
  .mini-sidebar.expand-menu #toggle_btn {
    opacity: 1;
  }
  .mini-sidebar.expand-menu .header-left {
    padding: 0 15px;
    display: flex;
  }
  .mini-sidebar .noti-dot:before {
    display: none;
  }
}
.nav-list {
  position: relative;
  padding-right: 15px;
}
.nav-list::before {
  content: "";
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0;
  width: 1px;
  height: 20px;
  background: #E8E8E8;
  z-index: 1;
}
.nav-list .nav .dark-mode-list .dark-mode-toggle {
  width: 66px;
  height: 36px;
  background: #F9F9FC;
  border: 1px solid #E8E8E8;
  font-size: 16px;
  border-radius: 5px;
  padding: 3px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.nav-list .nav .dark-mode-list .dark-mode-toggle i {
  font-size: 16px;
  color: #262A2A;
  border-radius: 5px;
  line-height: 26px;
  width: 26px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.nav-list .nav .dark-mode-list .dark-mode-toggle i.light-mode.active {
  color: #FFF;
  background: #5CB85C;
}
.nav-list .nav .dark-mode-list .dark-mode-toggle i.dark-mode.active {
  color: #FFF;
  background: #262A2A;
}
.nav-list .nav li {
  margin-right: 10px;
}
.nav-list .nav li:last-child {
  margin-right: 0;
}
.nav-list .nav li .btn {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  width: 36px;
  height: 36px;
  font-size: 16px;
  border-radius: 5px;
  border: 1px solid transparent;
}
.nav-list .nav li .btn-header-list {
  color: #00918E;
  background: #E0F5D7;
  border: 1px solid #00918E;
}
.nav-list .nav li .btn-header-list:hover {
  color: #FFF;
  background: #00918E;
}
.nav-list .nav li .btn-help {
  color: #3C2371;
  background: #F3EDFF;
}
.nav-list .nav li .btn-help:hover {
  color: #FFF;
  background: #3C2371;
}
.nav-list .nav li .btn-chart-pie {
  color: #FFA201;
  background: #FFF7D8;
}
.nav-list .nav li .btn-chart-pie:hover {
  color: #FFF;
  background: #FFA201;
}

.mobile-show {
  display: none;
}
@media (max-width: 991.98px) {
  .mobile-show {
    display: block;
  }
}

.sidebar {
  display: flex;
  background-color: #FFF;
  margin-top: 0;
  z-index: 1001;
  position: fixed;
  top: 56px;
  bottom: 0;
  left: 0;
  transition: all 0.5s ease;
  width: 276px;
}
@media (max-width: 991.98px) {
  .sidebar {
    margin-left: -575px;
    transition: all 0.4s ease;
    z-index: 1041;
    background: #FFF;
  }
}
@media (max-width: 575.98px) {
  .sidebar {
    width: 100%;
  }
}
.sidebar .slimScrollDiv {
  border-right: 1px solid transparent;
}
@media (max-width: 575.98px) {
  .sidebar .slimScrollDiv {
    width: 100% !important;
  }
}
.sidebar .sidebar-menu {
  padding: 15px;
}
.sidebar .sidebar-menu .clinicdropdown {
  margin-bottom: 24px;
}
.sidebar .sidebar-menu .clinicdropdown > a {
  background: #F6F6F6;
  border-radius: 5px;
  padding: 10px;
}
.sidebar .sidebar-menu .clinicdropdown > a img {
  width: 42px;
  height: 42px;
  border-radius: 5px;
}
.sidebar .sidebar-menu .clinicdropdown > a .user-names {
  margin-left: 10px;
  flex: 1 1;
}
.sidebar .sidebar-menu .clinicdropdown > a .user-names h5 {
  font-size: 16px;
  font-weight: 600;
  color: #262A2A;
  margin-bottom: 2px;
}
.sidebar .sidebar-menu .clinicdropdown > a .user-names h6 {
  font-size: 14px;
  font-weight: 400;
  color: #6F6F6F;
  margin-bottom: 0;
}
.sidebar .sidebar-menu .submenu-two .subdrop.active {
  background: transparent !important;
}
.sidebar .sidebar-menu > ul > li {
  margin-bottom: 24px;
}
.sidebar .sidebar-menu > ul > li.active a {
  color: #FFF;
}
.sidebar .sidebar-menu > ul > li.active svg {
  color: #FE9F43;
}
.sidebar .sidebar-menu > ul > li svg {
  min-width: 16px;
  width: 16px;
  height: 16px;
  margin-right: 10px;
}
.sidebar .sidebar-menu > ul > li > a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  padding: 10px 15px;
  position: relative;
  color: #FFA201;
}
.sidebar .sidebar-menu > ul > li > a svg {
  color: #637381;
}
.sidebar .sidebar-menu > ul > li > a img {
  color: #637381;
}
.sidebar .sidebar-menu > ul > li > a.active {
  background: rgba(254, 159, 67, 0.08);
  color: #FE9F43;
  border-radius: 5px;
}
.sidebar .sidebar-menu > ul > li > a.active svg {
  color: #FFF;
}
.sidebar .sidebar-menu > ul > li > a.active img {
  filter: invert(72%) sepia(76%) saturate(1430%) hue-rotate(327deg) brightness(103%) contrast(101%);
}
.sidebar .sidebar-menu > ul > li > a.active span {
  color: #FE9F43;
}
.sidebar .sidebar-menu > ul > li > a.active .menu-arrow {
  background: #FFEDDC;
}
.sidebar .sidebar-menu > ul > li > a.active .menu-arrow::before {
  border-color: #FE9F43;
}
.sidebar .sidebar-menu > ul > li > a span {
  font-size: 15px;
  font-weight: 500;
  color: #565E5E;
}
.sidebar .sidebar-menu > ul > li.active a {
  background: rgba(254, 159, 67, 0.08);
  border-radius: 5px;
}
.sidebar .sidebar-menu > ul > li.active a img {
  filter: invert(72%) sepia(76%) saturate(1430%) hue-rotate(327deg) brightness(103%) contrast(101%);
}
.sidebar .sidebar-menu > ul > li.active a span {
  color: #FE9F43;
}
.sidebar .sidebar-menu > ul > li.submenu ul {
  display: none;
}
.sidebar .sidebar-menu > ul > li.submenu ul li a {
  font-weight: 500;
  font-size: 14px;
  position: relative;
  display: block;
  padding: 8px 8px 8px 40px;
  padding-left: 30px;
}
.sidebar .sidebar-menu > ul > li ul {
  display: block;
  margin-bottom: 24px;
}
.sidebar .sidebar-menu > ul > li ul li {
  margin-bottom: 5px;
  border-radius: 5px;
  overflow: hidden;
}
.sidebar .sidebar-menu > ul > li ul li a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  font-weight: 400;
  font-size: 14px;
  color: #6F6F6F;
  position: relative;
  width: 100%;
  padding: 8px;
}
.sidebar .sidebar-menu > ul > li ul li a i {
  color: #262A2A;
  font-size: 16px;
  background: #F6F6F6;
  border-radius: 5px;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sidebar .sidebar-menu > ul > li ul li a span {
  font-size: 15px;
  font-weight: 500;
  white-space: nowrap;
  color: #262A2A;
  margin-left: 10px;
}
.sidebar .sidebar-menu > ul > li ul li a.active {
  color: #E41F07;
  background: #FCE9E6;
  border-radius: 5px;
}
.sidebar .sidebar-menu > ul > li ul li a.active span {
  color: #E41F07;
}
.sidebar .sidebar-menu > ul > li ul li a.active i {
  background: #E41F07;
  color: #FFF;
}
.sidebar .sidebar-menu > ul > li ul li a:hover {
  color: #E41F07;
}
.sidebar .sidebar-menu > ul > li ul li a:hover span {
  color: #E41F07;
}
.sidebar .sidebar-menu > ul > li ul > li.active a.subdrop {
  background: #FFEEEC;
  border-radius: 5px;
  color: #E41F07;
}
.sidebar .sidebar-menu > ul > li ul > li.active a.subdrop i {
  color: #FFF;
  background: #E41F07;
}
.sidebar .sidebar-menu > ul > li ul > li.active a.subdrop span {
  color: #E41F07;
}
.sidebar .sidebar-menu > ul > li .submenu-hdr {
  font-weight: 600;
  font-size: 12px;
  color: #6F6F6F;
  margin: 0 0 14px 0;
  text-transform: uppercase;
}
.sidebar .sidebar-menu > ul > li:first-child h6 {
  margin-top: 0;
}
.sidebar .sidebar-menu > ul > li .submenu ul {
  display: none;
  border: 0;
  padding-top: 0;
  padding-bottom: 0;
}
.sidebar .sidebar-menu > ul li {
  margin-bottom: 5px;
}
.sidebar .sidebar-menu > ul li .submenu > ul {
  margin: 0;
}
.sidebar .sidebar-menu > ul li .submenu > ul li a {
  padding-left: 44px;
  font-size: 14px;
  background: transparent;
  position: relative;
}
.sidebar .sidebar-menu > ul li .submenu > ul li a:after {
  position: absolute;
  content: "";
  background-color: #898989;
  width: 7px;
  height: 7px;
  border-radius: 50px;
  left: 16px;
  top: 14px;
}
.sidebar .sidebar-menu > ul li .submenu > ul li a:before {
  position: absolute;
  content: "";
  background-color: #898989;
  width: 0.5px;
  height: 8px;
  left: 19px;
  top: 0px;
}
.sidebar .sidebar-menu > ul li .submenu > a.subdrop {
  background: #F9F9FC;
}
.sidebar .sidebar-menu > ul li .submenu > a.subdrop i {
  background: #171724;
  color: #FFF;
}
.sidebar .sidebar-menu > ul li .submenu > a.subdrop.submenu-two {
  background: transparent;
}
.sidebar .sidebar-menu > ul li .submenu > a.active {
  background: #FCE9E6;
  border-radius: 5px;
}
.sidebar .sidebar-menu > ul li .submenu > a.active i {
  background: #E41F07;
  color: #FFF;
}
.sidebar .sidebar-menu > ul li .submenu > a.active span {
  color: #E41F07;
}
.sidebar .sidebar-menu > ul li .submenu > a.active .menu-arrow::before {
  border-right: 2px solid #E41F07;
  border-bottom: 2px solid #E41F07;
}
.sidebar .sidebar-menu .submenu-open:last-child {
  margin-bottom: 0;
}
.sidebar .sidebar-menu .submenu-open:last-child ul {
  border-bottom: none;
  padding-bottom: 0;
}
.sidebar .sidebar-menu .submenu-open .submenu.submenu-two ul li a {
  margin-left: 45px;
}
.sidebar .sidebar-menu .submenu-open .submenu.submenu-two.submenu-three ul li a {
  margin-left: 65px;
}
.sidebar .sidebar-menu .submenu-open .submenu ul li a {
  margin-left: 25px;
  padding-bottom: 4px;
  font-size: 14px;
  color: #B8BCC9;
}
.sidebar .sidebar-menu .submenu-open .submenu ul li a::after {
  content: "";
  background: rgba(50, 71, 92, 0.38);
  width: 8px;
  height: 8px;
  border: 2px solid #FFF;
  border-radius: 50px;
  position: absolute;
  top: 16px;
  left: 0;
}
.sidebar .sidebar-menu .submenu-open .submenu ul li a:hover {
  color: #E41F07;
}
.sidebar .sidebar-menu .submenu-open .submenu ul li a:hover:after {
  background: #FE9F43;
  border: 2px solid #FDB;
}
.sidebar .sidebar-menu .menu-arrow {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  text-rendering: auto;
  line-height: 40px;
  font-size: 18px;
  line-height: 16px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  position: absolute;
  top: 12px;
  right: 10px;
  transform: translate(0, 0);
  -webkit-transform: translate(0, 0);
  -ms-transform: translate(0, 0);
  transition: all 0.2s ease;
}
.sidebar .sidebar-menu .menu-arrow::before {
  height: 8px;
  width: 8px;
  border-top: 0;
  content: "";
  border-left: 0;
  border-right: 2px solid #262A2A;
  border-bottom: 2px solid #262A2A;
  transform: rotate(-45deg);
  position: absolute;
  left: 5px;
  top: 5px;
}
.sidebar .sidebar-menu .menu-arrow.inside-submenu {
  right: 10px;
}
.sidebar .sidebar-menu .menu-arrow.inside-submenu.inside-submenu-two {
  right: 60px;
}
.sidebar .sidebar-menu.subdrop .menu-arrow {
  transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  background: #FFEDDC;
}
.sidebar .nav-link {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  padding: 10px;
  color: #FFA201;
  position: relative;
}
.sidebar .nav-link.active {
  color: #E41F07;
  background: transparent;
  position: relative;
}
.sidebar .nav-link.active:after {
  content: "";
  border-width: 10px;
  border-color: transparent #E41F07 transparent transparent;
  border-style: solid;
  position: absolute;
  top: 36px;
  right: 0;
}
.sidebar .sidebar-left {
  width: 100px;
  box-shadow: 5px 0px 15px rgba(0, 0, 0, 0.05);
}
.sidebar .sidebar-right {
  width: 250px;
  height: 100%;
  transition: all 0.2s ease;
  display: none;
}
@media (max-width: 991.98px) {
  .sidebar .sidebar-right {
    width: calc(100% - 70px);
  }
}
.sidebar .sidebar-right .slimScrollDiv {
  width: 250px !important;
  overflow: visible !important;
}
@media (max-width: 991.98px) {
  .sidebar .sidebar-right .slimScrollDiv {
    width: 100% !important;
  }
}
.sidebar .sidebar-right .tab-content {
  padding: 20px 20px 40px;
}
@media (max-width: 991.98px) {
  .sidebar .sidebar-right .tab-content {
    padding: 10px;
  }
}
.sidebar .sidebar-right p {
  font-size: 10px;
  color: #6F7A7A;
  text-transform: uppercase;
  font-weight: 700;
  margin-bottom: 10px;
}
.sidebar .sidebar-right ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.sidebar .sidebar-right ul li.active a {
  background: linear-gradient(46.62deg, #E41F07 0%, #676DFF 93.64%);
  color: #FFF;
}
.sidebar .sidebar-right ul li a {
  font-weight: 400;
  font-size: 14px;
  color: #FFA201;
}
.sidebar .sidebar-right ul li a.active {
  color: #E41F07;
}
.sidebar .sidebar-right .menu-arrow {
  transition: transform 0.15s;
  display: inline-block;
  font-family: "Font Awesome 5 Free";
  text-rendering: auto;
  line-height: 40px;
  font-size: 18px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: 18px;
  top: 0px;
  position: relative;
  font-weight: 700;
  transform: translate(0, 0);
  -webkit-transform: translate(0, 0);
  -ms-transform: translate(0, 0);
}
.sidebar .sidebar-right .menu-arrow:before {
  content: "\\f105";
}
.sidebar .sub-menu a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.sidebar li a.subdrop .menu-arrow {
  transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
}
.sidebar .nav-items .nav-link {
  display: flex;
  flex-direction: column;
  border-radius: 0;
  border-bottom: 1px solid #6F6F6F;
  padding: 20px 0;
  transition: all 0.4s ease;
}
.sidebar .nav-items .nav-link:hover {
  box-shadow: 0 0 0 150px #676DFF inset;
  color: #FFF;
}
.sidebar .nav-items .nav-link span {
  margin-top: 15px;
  font-weight: 500;
}
.sidebar .sidemenu a {
  width: 100%;
  font-weight: 500;
  display: block;
  border-radius: 5px;
  margin: 0 0 10px;
  padding: 10px;
}
.sidebar .sidemenu a:hover {
  background: linear-gradient(46.62deg, #E41F07 0%, #676DFF 93.64%);
  color: #FFF;
}
.sidebar .sidemenu a:hover svg {
  color: #FFF;
}
.sidebar .sidemenu a svg {
  stroke-width: 1px;
}

@media (min-width: 991.98px) {
  .mini-sidebar .page-wrapper {
    margin-left: 80px;
  }
  .mini-sidebar .user-names {
    display: none;
  }
  .mini-sidebar .header-left #toggle_btn {
    opacity: 1;
    transform: rotate(180deg);
  }
  .mini-sidebar .header-left #toggle_btn:after {
    border: 0;
  }
  .mini-sidebar .sidebar .sidebar-menu .clinicdropdown > a {
    padding: 5px;
  }
  .mini-sidebar.expand-menu .header-left #toggle_btn {
    opacity: 1;
    transform: rotate(180deg);
  }
  .mini-sidebar.expand-menu .sidebar .sidebar-menu .clinicdropdown > a {
    padding: 10px;
  }
  .mini-sidebar .sidebar-right {
    display: none;
  }
  .mini-sidebar .sidebar .sidebar-menu ul li a span {
    display: none;
  }
  .mini-sidebar .sidebar .sidebar-menu ul li .submenu-hdr {
    display: none;
  }
  .mini-sidebar .sidebar .sidebar-menu ul li svg {
    margin-right: 0;
  }
  .mini-sidebar .sidebar {
    width: 80px;
    overflow: hidden;
  }
  .mini-sidebar.expand-menu .sidebar {
    display: block;
  }
  .expand-menu.mini-sidebar .sidebar .sidebar-menu .submenu-hdr {
    display: block;
  }
  .expand-menu.mini-sidebar .sidebar .user-names {
    display: block;
  }
  .expand-menu .sidebar-right {
    display: block;
    transition: all 0.2s ease;
  }
  .expand-menu .sidebar {
    width: 276px;
  }
  .expand-menu .sidebar .sidebar-menu ul > li > a span {
    display: inline-block;
    line-height: 0;
  }
  .expand-menu .sidebar .sidebar-menu ul > li svg {
    margin-right: 10px;
  }
  .expand-menu .sidebar .sidebar-menu .submenu-hdr {
    display: block;
  }
  .expand-menu .header-left {
    width: 276px;
  }
  #toggle_btn {
    display: flex;
    align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    float: left;
  }
}
body.mini-sidebar.expand-menu .sidebar .sidebar-menu > ul > li ul li a {
  justify-content: start;
}

body.mini-sidebar .sidebar .sidebar-menu > ul > li ul li a {
  justify-content: center;
}
body.mini-sidebar .sidebar .sidebar-menu > ul > li.submenu-open ul li a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  font-weight: 500;
  font-size: 15px;
  color: #67748E;
  position: relative;
  width: 100%;
  padding: 10px;
}
body.mini-sidebar .sidebar .sidebar-menu > ul > li ul > li.active a {
  padding: 10px;
  justify-content: center;
}
body.mini-sidebar.expand-menu .sidebar .sidebar-menu > ul > li.submenu-open ul li a {
  justify-content: left;
  -webkit-justify-content: left;
  -ms-flex-pack: left;
  padding-left: 18px;
}
body.mini-sidebar.expand-menu .sidebar .sidebar-menu > ul > li ul > li.active a {
  padding: 10px 15px;
  justify-content: start;
}

.sidebarrightmenu .sidebar-right {
  display: block;
}

.slide-nav .sidebar {
  margin-left: 0;
}

.sidebar-overlay {
  display: none;
  height: 100%;
  width: 100%;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 60px;
  left: 0;
}
.sidebar-overlay.opened {
  display: block;
}

.mini-sidebar .active.subdrop ~ ul {
  display: none !important;
}

.mini-sidebar.expand-menu .active.subdrop ~ ul {
  display: block !important;
}

.active.subdrop ~ ul {
  display: block !important;
}

.sidebar .sidebar-menu > ul li .submenu.submenu-two > ul li a {
  margin-left: 30px;
}
.sidebar .sidebar-menu > ul li .submenu.submenu-two.submenu-three > ul li a {
  margin-left: 60px;
}

.mini-sidebar .header #toggle_btn {
  opacity: 0;
  height: 0;
  width: 0;
}

[data-sidebar=dark] .sidebar {
  background-color: #171724;
}
[data-sidebar=dark] .sidebar .sidebar-menu .clinicdropdown a {
  background-color: #000000;
}
[data-sidebar=dark] .sidebar .sidebar-menu .clinicdropdown a .user-names h5 {
  color: #FFF;
}
[data-sidebar=dark] .sidebar .sidebar-menu ul > li ul li a span {
  color: #a3a6a6;
}
[data-sidebar=dark] .sidebar .sidebar-menu .menu-arrow:before {
  border-right: 2px solid #a3a6a6;
  border-bottom: 2px solid #a3a6a6;
}

[data-sidebar=blue] .sidebar {
  background-color: #3C2371;
}
[data-sidebar=blue] .sidebar .sidebar-menu .clinicdropdown a {
  background-color: #2f0093;
}
[data-sidebar=blue] .sidebar .sidebar-menu .clinicdropdown a .user-names h5 {
  color: #FFF;
}
[data-sidebar=blue] .sidebar .sidebar-menu .clinicdropdown a .user-names h6 {
  color: #e4e4e4;
}
[data-sidebar=blue] .sidebar .sidebar-menu > ul > li .submenu-hdr {
  color: #FFF;
}
[data-sidebar=blue] .sidebar .sidebar-menu ul > li .submenu-hdr {
  color: #FFF;
}
[data-sidebar=blue] .sidebar .sidebar-menu ul > li ul li a {
  color: #FFF;
}
[data-sidebar=blue] .sidebar .sidebar-menu ul > li ul li a.active i {
  background-color: #3C2371;
}
[data-sidebar=blue] .sidebar .sidebar-menu ul > li ul li a.active span {
  color: #3C2371;
}
[data-sidebar=blue] .sidebar .sidebar-menu ul > li ul li a.active .menu-arrow::before {
  border-right: 2px solid #3C2371;
  border-bottom: 2px solid #3C2371;
}
[data-sidebar=blue] .sidebar .sidebar-menu ul > li ul li a span {
  color: #FFF;
}
[data-sidebar=blue] .sidebar .sidebar-menu .menu-arrow:before {
  border-right: 2px solid #FFF;
  border-bottom: 2px solid #FFF;
}

[data-sidebar=green] .sidebar {
  background-color: #00918E;
}
[data-sidebar=green] .sidebar .sidebar-menu .clinicdropdown a {
  background-color: #005351;
}
[data-sidebar=green] .sidebar .sidebar-menu .clinicdropdown a .user-names h5 {
  color: #FFF;
}
[data-sidebar=green] .sidebar .sidebar-menu .clinicdropdown a .user-names h6 {
  color: #e4e4e4;
}
[data-sidebar=green] .sidebar .sidebar-menu > ul > li .submenu-hdr {
  color: #FFF;
}
[data-sidebar=green] .sidebar .sidebar-menu ul > li .submenu-hdr {
  color: #FFF;
}
[data-sidebar=green] .sidebar .sidebar-menu ul > li ul li a {
  color: #FFF;
}
[data-sidebar=green] .sidebar .sidebar-menu ul > li ul li a.active i {
  background-color: #00918E;
}
[data-sidebar=green] .sidebar .sidebar-menu ul > li ul li a.active span {
  color: #00918E;
}
[data-sidebar=green] .sidebar .sidebar-menu ul > li ul li a.active .menu-arrow::before {
  border-right: 2px solid #00918E;
  border-bottom: 2px solid #00918E;
}
[data-sidebar=green] .sidebar .sidebar-menu ul > li ul li a span {
  color: #FFF;
}
[data-sidebar=green] .sidebar .sidebar-menu .menu-arrow:before {
  border-right: 2px solid #FFF;
  border-bottom: 2px solid #FFF;
}

[data-color=red] .btn-primary {
  background: #E41F07;
  border: 1px solid #E41F07;
}
[data-color=red] .btn-primary:hover {
  background: #c11a06;
  border-color: #c11a06;
}

[data-color=yellow] .btn-primary:hover {
  background: #FF9901 !important;
  border-color: #FF9901 !important;
}
[data-color=yellow] .sidebar .sidebar-menu > ul > li ul li a.active {
  color: #FFA201;
  background: #FFF6E6;
}
[data-color=yellow] .sidebar .sidebar-menu > ul > li ul li a.active span {
  color: #FFA201;
}
[data-color=yellow] .sidebar .sidebar-menu > ul > li ul li a.active i {
  background: #FFA201;
}
[data-color=yellow] .sidebar .sidebar-menu > ul > li ul li a:hover {
  color: #FFA201;
}
[data-color=yellow] .sidebar .sidebar-menu > ul > li ul li a:hover span {
  color: #FFA201;
}
[data-color=yellow] .sidebar .sidebar-menu > ul > li .submenu .subdrop.active {
  background: #FFF6E6;
}
[data-color=yellow] .sidebar .sidebar-menu > ul > li .submenu ul li a.active {
  background: transparent;
}
[data-color=yellow] .sidebar .sidebar-menu > ul > li .submenu > a.active {
  background: transparent;
  color: #FFA201;
}
[data-color=yellow] .sidebar .sidebar-menu > ul > li .submenu > a.active i {
  background: #FFA201;
}
[data-color=yellow] .sidebar .sidebar-menu > ul > li .submenu > a.active span {
  color: #FFA201;
}
[data-color=yellow] .sidebar .sidebar-menu > ul > li .submenu > a.active .menu-arrow::before {
  border-right: 2px solid #FFA201;
  border-bottom: 2px solid #FFA201;
}
[data-color=yellow] .user-accordion-item .accordion-wrap:not(.collapsed) span {
  background: #FFA201;
}
[data-color=yellow] .page-header .btn-added {
  background: #FFA201;
}
[data-color=yellow] .settings-menu .nav li a.active {
  color: #FFA201;
  border-bottom: 4px solid #FFA201;
}
[data-color=yellow] .toggle-popup .sidebar-layout .sidebar-header .toggle-btn:hover,
[data-color=yellow] .toggle-popup1 .sidebar-layout .sidebar-header .toggle-btn:hover,
[data-color=yellow] .toggle-popup2 .sidebar-layout .sidebar-header .toggle-btn:hover {
  background: #FFA201;
  border-color: #FFA201;
}
[data-color=yellow] .todo-inbox-check .checkboxs input:checked ~ .checkmarks {
  border-color: #FFA201;
  background-color: #FFA201;
}
[data-color=yellow] .custom-pagination .paginations .page-wrap li a.active {
  background: #FFA201;
}
[data-color=yellow] .contact-nav li a:hover, [data-color=yellow] .contact-nav li a.active {
  color: #FFA201;
  border-color: #FFA201;
}
[data-color=yellow] .dataTables_paginate .pagination li.active a.page-link, [data-color=yellow] #dataTables_paginate .pagination li.active a.page-link {
  background: #FFA201;
  border-color: #FFA201;
}
[data-color=yellow] .btn-primary {
  background: #FFA201;
  border: 1px solid #FFA201;
}
[data-color=yellow] .select2-container--default .select2-results__option--selected {
  background: #FFA201;
  color: #FFF;
}
[data-color=yellow] .view-icons a.active,
[data-color=yellow] .view-icons a:hover {
  background: #FFA201;
}
[data-color=yellow] .btn.btn-primary {
  background-color: #FFA201;
  border: 1px solid #FFA201;
}
[data-color=yellow] .form-check-input:checked {
  background-color: #FFA201;
  border-color: #FFA201;
}
[data-color=yellow] .breadcrumb .breadcrumb-item.active {
  color: #FFA201;
}
[data-color=yellow] .btn-outline-primary {
  border: 1px solid #FFA201 !important;
  color: #FFA201 !important;
}

[data-color=blue] .btn-primary:hover {
  background: #3B4971 !important;
  border-color: #3B4971 !important;
}
[data-color=blue] .sidebar .sidebar-menu > ul > li ul li a.active {
  color: #3C2371;
  background: #ECE9F1;
}
[data-color=blue] .sidebar .sidebar-menu > ul > li ul li a.active span {
  color: #3C2371;
}
[data-color=blue] .sidebar .sidebar-menu > ul > li ul li a.active i {
  background: #3C2371;
}
[data-color=blue] .sidebar .sidebar-menu > ul > li ul li a:hover {
  color: #3C2371;
}
[data-color=blue] .sidebar .sidebar-menu > ul > li ul li a:hover span {
  color: #3C2371;
}
[data-color=blue] .sidebar .sidebar-menu > ul > li .submenu .subdrop.active {
  background: #ECE9F1;
}
[data-color=blue] .sidebar .sidebar-menu > ul > li .submenu ul li a.active {
  background: transparent;
}
[data-color=blue] .sidebar .sidebar-menu > ul > li .submenu > a.active {
  background: transparent;
  color: #3C2371;
}
[data-color=blue] .sidebar .sidebar-menu > ul > li .submenu > a.active i {
  background: #3C2371;
}
[data-color=blue] .sidebar .sidebar-menu > ul > li .submenu > a.active span {
  color: #3C2371;
}
[data-color=blue] .sidebar .sidebar-menu > ul > li .submenu > a.active .menu-arrow::before {
  border-right: 2px solid #3C2371;
  border-bottom: 2px solid #3C2371;
}
[data-color=blue] .user-accordion-item .accordion-wrap:not(.collapsed) span {
  background: #3C2371;
}
[data-color=blue] .page-header .btn-added {
  background: #3C2371;
}
[data-color=blue] .settings-menu .nav li a.active {
  color: #3C2371;
  border-bottom: 4px solid #3C2371;
}
[data-color=blue] .toggle-popup .sidebar-layout .sidebar-header .toggle-btn:hover,
[data-color=blue] .toggle-popup1 .sidebar-layout .sidebar-header .toggle-btn:hover,
[data-color=blue] .toggle-popup2 .sidebar-layout .sidebar-header .toggle-btn:hover {
  background: #3C2371;
  border-color: #3C2371;
}
[data-color=blue] .todo-inbox-check .checkboxs input:checked ~ .checkmarks {
  border-color: #3C2371;
  background-color: #3C2371;
}
[data-color=blue] .custom-pagination .paginations .page-wrap li a.active {
  background: #3C2371;
}
[data-color=blue] .contact-nav li a:hover, [data-color=blue] .contact-nav li a.active {
  color: #3C2371;
  border-color: #3C2371;
}
[data-color=blue] .dataTables_paginate .pagination li.active a.page-link, [data-color=blue] #dataTables_paginate .pagination li.active a.page-link {
  background: #3C2371;
  border-color: #3C2371;
}
[data-color=blue] .btn-primary {
  background: #3C2371;
  border: 1px solid #3C2371;
}
[data-color=blue] .select2-container--default .select2-results__option--selected {
  background: #3C2371;
  color: #FFF;
}
[data-color=blue] .view-icons a.active,
[data-color=blue] .view-icons a:hover {
  background: #3C2371;
}
[data-color=blue] .btn.btn-primary {
  background-color: #3C2371;
  border: 1px solid #3C2371;
}
[data-color=blue] .form-check-input:checked {
  background-color: #3C2371;
  border-color: #3C2371;
}
[data-color=blue] .breadcrumb .breadcrumb-item.active {
  color: #3C2371;
}
[data-color=blue] .btn-outline-primary {
  border: 1px solid #3C2371 !important;
  color: #3C2371 !important;
}

[data-color=green] .btn-primary:hover {
  background: #005e5c !important;
  border-color: #005e5c !important;
}
[data-color=green] .sidebar .sidebar-menu > ul > li ul li a.active {
  color: #00918E;
  background: #E6F4F4;
}
[data-color=green] .sidebar .sidebar-menu > ul > li ul li a.active span {
  color: #00918E;
}
[data-color=green] .sidebar .sidebar-menu > ul > li ul li a.active i {
  background: #00918E;
}
[data-color=green] .sidebar .sidebar-menu > ul > li ul li a:hover {
  color: #00918E;
}
[data-color=green] .sidebar .sidebar-menu > ul > li ul li a:hover span {
  color: #00918E;
}
[data-color=green] .sidebar .sidebar-menu > ul > li .submenu .subdrop.active {
  background: #E6F4F4;
}
[data-color=green] .sidebar .sidebar-menu > ul > li .submenu ul li a.active {
  background: transparent;
}
[data-color=green] .sidebar .sidebar-menu > ul > li .submenu > a.active {
  background: transparent;
  color: #00918E;
}
[data-color=green] .sidebar .sidebar-menu > ul > li .submenu > a.active i {
  background: #00918E;
}
[data-color=green] .sidebar .sidebar-menu > ul > li .submenu > a.active span {
  color: #00918E;
}
[data-color=green] .sidebar .sidebar-menu > ul > li .submenu > a.active .menu-arrow::before {
  border-right: 2px solid #00918E;
  border-bottom: 2px solid #00918E;
}
[data-color=green] .user-accordion-item .accordion-wrap:not(.collapsed) span {
  background: #00918E;
}
[data-color=green] .page-header .btn-added {
  background: #00918E;
}
[data-color=green] .settings-menu .nav li a.active {
  color: #00918E;
  border-bottom: 4px solid #00918E;
}
[data-color=green] .toggle-popup .sidebar-layout .sidebar-header .toggle-btn:hover,
[data-color=green] .toggle-popup1 .sidebar-layout .sidebar-header .toggle-btn:hover,
[data-color=green] .toggle-popup2 .sidebar-layout .sidebar-header .toggle-btn:hover {
  background: #00918E;
  border-color: #00918E;
}
[data-color=green] .todo-inbox-check .checkboxs input:checked ~ .checkmarks {
  border-color: #00918E;
  background-color: #00918E;
}
[data-color=green] .custom-pagination .paginations .page-wrap li a.active {
  background: #00918E;
}
[data-color=green] .contact-nav li a:hover, [data-color=green] .contact-nav li a.active {
  color: #00918E;
  border-color: #00918E;
}
[data-color=green] .dataTables_paginate .pagination li.active a.page-link, [data-color=green] #dataTables_paginate .pagination li.active a.page-link {
  background: #00918E;
  border-color: #00918E;
}
[data-color=green] .btn-primary {
  background: #00918E;
  border: 1px solid #00918E;
}
[data-color=green] .select2-container--default .select2-results__option--selected {
  background: #00918E;
  color: #FFF;
}
[data-color=green] .view-icons a.active,
[data-color=green] .view-icons a:hover {
  background: #00918E;
}
[data-color=green] .btn.btn-primary {
  background-color: #00918E;
  border: 1px solid #00918E;
}
[data-color=green] .form-check-input:checked {
  background-color: #00918E;
  border-color: #00918E;
}
[data-color=green] .breadcrumb .breadcrumb-item.active {
  color: #00918E;
}
[data-color=green] .btn-outline-primary {
  border: 1px solid #00918E !important;
  color: #00918E !important;
}

[data-theme=dark] body {
  background-color: #171724;
  color: #a3a6a6;
}
[data-theme=dark] h1, [data-theme=dark] h2, [data-theme=dark] h3, [data-theme=dark] h4, [data-theme=dark] h5, [data-theme=dark] h6, [data-theme=dark] .h1, [data-theme=dark] .h2, [data-theme=dark] .h3, [data-theme=dark] .h4, [data-theme=dark] .h5, [data-theme=dark] .h6 {
  color: #FFF;
}
[data-theme=dark] .header {
  background-color: #171724;
}
[data-theme=dark] .header .header-left {
  background-color: #171724;
}
[data-theme=dark] .header .header-left .logo img {
  display: none;
}
[data-theme=dark] .header .header-left .logo img.white-logo {
  display: block;
}
[data-theme=dark] .header .header-left #toggle_btn {
  color: #FFF;
}
[data-theme=dark] .header .dropdown-menu {
  background-color: #171724;
  box-shadow: none;
}
[data-theme=dark] .header .dropdown-menu a {
  color: #FFF;
}
[data-theme=dark] .header .dropdown-menu .topnav-dropdown-header {
  border-color: #393947;
}
[data-theme=dark] .header .dropdown-menu .topnav-dropdown-header .notification-title {
  color: #FFF;
}
[data-theme=dark] .header .menu-drop-user .dropdown-item {
  border-color: #393947;
}
[data-theme=dark] .header .notification-dropdown .notification-list li {
  border-bottom: 1px solid #393947;
}
[data-theme=dark] .header .notification-dropdown .notification-list li .noti-title {
  color: #FFF;
}
[data-theme=dark] .header .notification-dropdown .notification-list li .noti-details {
  color: #FFF;
}
[data-theme=dark] .header .notification-dropdown .notification-list li p.noti-time {
  color: #FFF;
}
[data-theme=dark] .header .notification-dropdown .notification-list li .noti-pdf .noti-pdf-icon span {
  border: 1px solid #393947;
}
[data-theme=dark] .header .notification-dropdown .notification-list li .noti-pdf .noti-pdf-text p {
  color: #FFF;
}
[data-theme=dark] .header .notification-dropdown .notification-list li .noti-pdf .noti-pdf-text span {
  color: #B5B5B5;
}
[data-theme=dark] .header .notification-dropdown .notification-list li .notification-time {
  font-size: 12px;
  line-height: 1.35;
  color: #565E5E;
}
[data-theme=dark] .header .notification-dropdown .topnav-dropdown-footer {
  background: #171724;
}
[data-theme=dark] .header .searchinputs input {
  border-color: #393947;
  background: transparent;
}
[data-theme=dark] .header .searchinputs .search-addon button {
  color: #B5B5B5;
}
[data-theme=dark] .header .menus-info .menu-list li a {
  background: transparent;
  border-radius: 5px;
}
[data-theme=dark] .header .menus-info .menu-list li a:hover {
  background: transparent;
}
[data-theme=dark] .header .menus-info .menu-list li a .menu-details .menu-list-icon {
  color: #FFF;
}
[data-theme=dark] .header .menus-info .menu-list li a .menu-details .menu-details-content p {
  color: #FFF;
  margin-bottom: 0;
}
[data-theme=dark] .header .menus-info .menu-list li a .menu-details .menu-details-content span {
  font-weight: 400;
  color: #B5B5B5;
}
[data-theme=dark] .sidebar {
  background-color: #171724;
}
[data-theme=dark] .sidebar .sidebar-menu .clinicdropdown a {
  background-color: #28283E;
}
[data-theme=dark] .sidebar .sidebar-menu .clinicdropdown a .user-names h5 {
  color: #FFF;
}
[data-theme=dark] .sidebar .sidebar-menu ul > li ul li a span {
  color: #a3a6a6;
}
[data-theme=dark] .sidebar .sidebar-menu .menu-arrow:before {
  border-right: 2px solid #a3a6a6;
  border-bottom: 2px solid #a3a6a6;
}
[data-theme=dark] .contact-grid.proposals-grid .grid-head .table-action .action-icon {
  background: #393947;
  color: #FFF;
}
[data-theme=dark] .contact-grid.proposals-grid .grid-footer {
  background: #171724;
  border-color: #393947;
  color: #FFF;
}
[data-theme=dark] .title-head {
  color: #FFF;
}
[data-theme=dark] .sidebar-themesettings {
  background: #171724;
}
[data-theme=dark] .sidebar-themesettings .themesettings-header {
  border-color: #393947;
}
[data-theme=dark] .sidebar-themesettings .themesettings-header h4 {
  color: #FFF;
}
[data-theme=dark] .sidebar-themesettings .themesettings-inner {
  background: #1E1E2D;
  border-color: #393947;
}
[data-theme=dark] .sidebar-themesettings .themesettings-inner .themesettings-content {
  border-color: #393947;
}
[data-theme=dark] .sidebar-themesettings .themesettings-inner .themesettings-content h6 {
  color: #FFF;
}
[data-theme=dark] .sidebar-themesettings .input-themeselect {
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .sidebar-themesettings .input-themeselect .checkboxs-theme:after {
  border-color: #393947;
}
[data-theme=dark] .form-check-label,
[data-theme=dark] .form-label,
[data-theme=dark] .sub-header {
  color: #a3a6a6;
}
[data-theme=dark] .form-select option {
  background: transparent;
}
[data-theme=dark] .icon-form .form-icon {
  color: #a3a6a6;
}
[data-theme=dark] .drop-down > a,
[data-theme=dark] .export-dropdwon > a,
[data-theme=dark] .form-sorts > a {
  border-color: #393947;
  box-shadow: none;
  background-color: #1A1A25;
  color: #a3a6a6;
}
[data-theme=dark] .drop-down > a:hover,
[data-theme=dark] .export-dropdwon > a:hover,
[data-theme=dark] .form-sorts > a:hover {
  color: #a3a6a6;
}
[data-theme=dark] .manage-dropdwon .dropdown-menu {
  border-color: #393947;
  background-color: #1A1A25;
  color: #a3a6a6;
  box-shadow: none;
}
[data-theme=dark] .form-sorts .filter-set-content .filter-set-content-head a {
  color: #a3a6a6;
}
[data-theme=dark] .header-set .select2-container--default .select2-selection--single {
  border-color: #393947;
}
[data-theme=dark] .form-sorts .filter-dropdown-menu {
  border-color: #393947;
  background-color: #1A1A25;
  color: #a3a6a6;
  box-shadow: none;
}
[data-theme=dark] .status-radio:checked + label,
[data-theme=dark] .status-radio:not(:checked) + label {
  color: #a3a6a6;
}
[data-theme=dark] .filter-set-contents .filter-content-list {
  border-color: #393947;
  background-color: #1A1A25;
  color: #a3a6a6;
}
[data-theme=dark] .dataTables_length label .form-select,
[data-theme=dark] #dataTables_length label .form-select {
  border-color: #393947;
  box-shadow: none;
  background-color: #1A1A25;
  color: #a3a6a6;
}
[data-theme=dark] .view-icons {
  border-color: #393947;
}
[data-theme=dark] .toast {
  background-color: #1A1A25;
}
[data-theme=dark] .select2-selection--multiple {
  border-color: #393947;
  background: #171724;
  box-shadow: none;
  color: #a3a6a6;
}
[data-theme=dark] .twitter-bs-wizard .twitter-bs-wizard-nav .step-icon {
  border-color: #FFF;
  color: #FFF;
}
[data-theme=dark] .text-dark {
  color: #a3a6a6 !important;
}
[data-theme=dark] .select2-container--default .select2-selection--single {
  border-color: #393947;
  background: #171724;
  box-shadow: none;
}
[data-theme=dark] .select2-container--default .select2-selection--single .select2-selection__rendered {
  box-shadow: none;
  border: 1px solid #393947;
  background: #171724;
  color: #a3a6a6;
}
[data-theme=dark] .select2-container--default .select2-selection--single .select2-selection__arrow {
  box-shadow: none;
}
[data-theme=dark] .toggle-popup .sidebar-layout,
[data-theme=dark] .toggle-popup1 .sidebar-layout,
[data-theme=dark] .toggle-popup2 .sidebar-layout {
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .user-accordion-item .accordion-wrap {
  color: #a3a6a6;
}
[data-theme=dark] .user-accordion-item .accordion-wrap:hover {
  color: #a3a6a6;
}
[data-theme=dark] .user-accordion-item .content-collapse {
  border-color: #393947;
}
[data-theme=dark] .bootstrap-tagsinput {
  background: #171724;
  border-color: #393947;
}
[data-theme=dark] .user-accordion-item,
[data-theme=dark] .files-wrap,
[data-theme=dark] .contact-wrap,
[data-theme=dark] .notes-activity .note-download,
[data-theme=dark] .contact-tab-wrap,
[data-theme=dark] .contact-tab-view,
[data-theme=dark] .calls-box,
[data-theme=dark] .notes-activity .reply-box,
[data-theme=dark] .note-download {
  border-color: #393947;
  background: #171724;
  box-shadow: none;
}
[data-theme=dark] .contact-sidebar, [data-theme=dark] .contact-tab-view {
  background-color: #1E1E2D;
  box-shadow: none;
}
[data-theme=dark] .action-drop .dropdown-toggle {
  border-color: #393947;
  color: #a3a6a6;
}
[data-theme=dark] .upcoming-info {
  border-color: #393947;
}
[data-theme=dark] .calls-box .caller-info .calls-user p span {
  color: #a3a6a6;
  font-weight: 500;
}
[data-theme=dark] .calls-box .caller-info .calls-action .dropdown-toggle {
  color: #a3a6a6;
  border-color: #393947;
}
[data-theme=dark] .bootstrap-tagsinput {
  box-shadow: none;
}
[data-theme=dark] .contact-grid {
  color: #a3a6a6;
  border-color: #393947;
  background: #171724;
  box-shadow: none;
}
[data-theme=dark] .contact-grid .grid-head .users-profile .name-user h6 a {
  color: #FFF;
}
[data-theme=dark] .contact-grid .grid-body .address-info p i {
  color: #a3a6a6;
}
[data-theme=dark] .contact-grid .grid-footer {
  border-color: #393947;
}
[data-theme=dark] .company-info li span {
  border-color: #393947;
}
[data-theme=dark] .contacts-action .btn-icon, [data-theme=dark] .contacts-action .btn-icon.rating {
  color: #a3a6a6;
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .contacts-action .act-dropdown > a {
  color: #a3a6a6;
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .social-info li a {
  color: #a3a6a6;
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .view-header .form-sort .select2-container .select2-selection .select2-selection__rendered {
  color: #a3a6a6;
}
[data-theme=dark] .basic-info li span {
  color: #a3a6a6;
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .badge-day {
  color: #a3a6a6;
  background: #3d3d64;
}
[data-theme=dark] .contact-nav li a {
  border-color: transparent;
}
[data-theme=dark] .upcoming-info .dropdown .dropdown-toggle {
  color: #a3a6a6;
}
[data-theme=dark] .contact-sidebar ul, [data-theme=dark] .view-header, [data-theme=dark] .activity-wrap {
  border-color: #393947;
}
[data-theme=dark] .search-section {
  border-color: #393947;
}
[data-theme=dark] .select2-container--default .select2-results__option--selected {
  background: #E41F07;
  color: #FFF;
}
[data-theme=dark] .form-floating > .form-control:not(:placeholder-shown) ~ label::after {
  background: transparent;
}
[data-theme=dark] .select2-dropdown {
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .select2-dropdown ul li {
  color: #FFF;
}
[data-theme=dark] .btn-outline-light {
  color: #a3a6a6 !important;
}
[data-theme=dark] .page-wrapper {
  background: #151525;
}
[data-theme=dark] .page-wrapper .page-header h3 {
  color: #FFF;
}
[data-theme=dark] .page-wrapper .page-header h4 {
  color: #FFF;
}
[data-theme=dark] .page-wrapper .page-header .head-icons a {
  border-color: #393947;
  background: transparent;
  color: #FFF;
}
[data-theme=dark] .page-wrapper .page-title {
  color: #FFF;
}
[data-theme=dark] .note-editable.card-block {
  color: #FFF;
}
[data-theme=dark] .accordion-item {
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .accordion-item .accordion-body {
  border-color: #393947;
  background: #28283E;
}
[data-theme=dark] .accordion-button {
  border-color: #393947;
  background: #28283E;
}
[data-theme=dark] .seprator-lg {
  border-color: #393947;
}
[data-theme=dark] .card {
  background: #1E1E2D;
  box-shadow: none;
}
[data-theme=dark] .card.bg-white {
  background: #1E1E2D !important;
}
[data-theme=dark] .card.main-card {
  background: #28283E;
  box-shadow: none;
}
[data-theme=dark] .card.custom-card {
  background: #28283E;
}
[data-theme=dark] .card.custom-card .card-header {
  border-color: #393947;
}
[data-theme=dark] .card.custom-card .card-footer {
  border-color: #393947;
}
[data-theme=dark] .card .card-header {
  border-color: #393947;
}
[data-theme=dark] .card .card-header .card-title {
  color: #FFF;
}
[data-theme=dark] .card .card-header .card-text {
  color: #a3a6a6;
}
[data-theme=dark] .card .card-body {
  color: #a3a6a6;
}
[data-theme=dark] .col-form-label {
  color: #a3a6a6;
}
[data-theme=dark] .custom-table .table-responsive {
  border-color: #393947;
}
[data-theme=dark] .btn-purple-light {
  background: #171724;
  border-color: #393947;
  color: #a3a6a6;
}
[data-theme=dark] .btn-purple-light:hover {
  background: #171724;
  border-color: #393947;
  color: #a3a6a6;
}
[data-theme=dark] .note-toolbar {
  background: #171724;
}
[data-theme=dark] .note-btn-group .note-btn {
  background: #171724;
  border-color: #393947;
  color: #a3a6a6;
}
[data-theme=dark] .note-toolbar {
  border-color: #393947;
}
[data-theme=dark] .table-action .action-icon {
  background: #171724;
  border-color: #393947;
  color: #FFF;
}
[data-theme=dark] .table-action .action-icon:hover {
  background: #1A1A25;
  color: #FFF;
}
[data-theme=dark] .table-action .action-icon:hover i {
  color: #FFF;
}
[data-theme=dark] .toggle-popup .sidebar-layout .sidebar-header {
  border-color: #171724;
}
[data-theme=dark] table.table.table-primary {
  background: #171724;
}
[data-theme=dark] table.table thead {
  border-color: #393947;
}
[data-theme=dark] table.table thead tr {
  border-color: #393947;
}
[data-theme=dark] table.table thead tr th {
  background: #171724;
  color: #FFF;
  border-color: #393947;
}
[data-theme=dark] table.table tbody tr td {
  background: #171724;
  color: #B5B5B5;
  border-color: #393947;
}
[data-theme=dark] table.table.dataTable {
  border-color: #393947;
}
[data-theme=dark] table.table.dataTable > thead {
  border-color: #393947;
}
[data-theme=dark] table.table.dataTable > thead > tr {
  border-color: #393947;
}
[data-theme=dark] table.table.dataTable > thead > tr th {
  background: #171724;
  color: #FFF;
  border-color: #393947;
}
[data-theme=dark] table.table.dataTable tbody tr td {
  background: #171724;
  color: #B5B5B5;
  border-color: #393947;
}
[data-theme=dark] .statistic-header h4 {
  color: #FFF;
}
[data-theme=dark] .statistic-header h4 i {
  color: #B5B5B5;
}
[data-theme=dark] .statistic-header .statistic-dropdown .dropdown-toggle {
  color: #FFF;
  border: 1px solid #1A1A25;
  box-shadow: none;
  background: #1A1A25;
}
[data-theme=dark] .statistic-header .statistic-dropdown .dropdown-toggle:after {
  border-bottom: 2px solid #B5B5B5;
  border-right: 2px solid #B5B5B5;
}
[data-theme=dark] .statistic-header .statistic-dropdown .dropdown-menu {
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .statistic-header .statistic-dropdown .dropdown-menu a {
  background: transparent;
  color: #FFF;
}
[data-theme=dark] .toggle-popup .sidebar-layout .sidebar-header,
[data-theme=dark] .toggle-popup1 .sidebar-layout .sidebar-header,
[data-theme=dark] .toggle-popup2 .sidebar-layout .sidebar-header {
  border-color: #393947;
}
[data-theme=dark] .form-control, [data-theme=dark] .form-select {
  border-color: #393947;
  background: #171724;
  color: #a3a6a6;
  box-shadow: none;
}
[data-theme=dark] .form-control:disabled, [data-theme=dark] .form-select:disabled {
  border-color: #393947;
  background: #171724;
  color: #a3a6a6;
}
[data-theme=dark] .form-control:focus, [data-theme=dark] .form-select:focus {
  border-color: #393947;
  background: #171724;
  color: #a3a6a6;
}
[data-theme=dark] .input-group-text {
  background: #393947;
  color: #a3a6a6;
  border-color: #393947;
}
[data-theme=dark] .radio label, [data-theme=dark] .checkbox label {
  color: #a3a6a6;
}
[data-theme=dark] .apexcharts-text tspan {
  fill: #FFF;
}
[data-theme=dark] a {
  color: #FFF;
}
[data-theme=dark] a.label-add {
  color: #E41F07;
}
[data-theme=dark] .settings-sub-header {
  border-color: #393947;
}
[data-theme=dark] .profile-details {
  border-color: #393947;
}
[data-theme=dark] .profile-upload .profile-upload-img {
  border-color: #393947;
}
[data-theme=dark] .settings-sidebar ul li a {
  color: #B5B5B5;
}
[data-theme=dark] .settings-sidebar ul li a:hover {
  color: #FFF;
}
[data-theme=dark] .settings-sidebar ul li a.active {
  background: #28283D;
  color: #FFF;
}
[data-theme=dark] .btn.btn-light {
  background-color: #1A1A25;
  border-color: #393947;
  color: #FFF;
}
[data-theme=dark] .btn.btn-light:hover {
  background-color: #030305;
  border-color: #393947;
  color: #FFF;
}
[data-theme=dark] .security-grid {
  border-color: #393947;
  background: #1E1E2D;
}
[data-theme=dark] .security-grid .security-heading h5 {
  color: #FFF;
}
[data-theme=dark] .notification-wrap ul li .security-checkbox .checkboxs {
  color: #FFF;
}
[data-theme=dark] .notificaion-table .table tbody tr td {
  color: #FFF;
}
[data-theme=dark] .integration-grid {
  background: #28283E;
  border-color: #28283E;
}
[data-theme=dark] .integration-grid .integration-content p {
  color: #FFF;
}
[data-theme=dark] .storage-wrap {
  background: #28283E;
  border-color: #393947;
}
[data-theme=dark] .storage-wrap .storage-icon h6 {
  color: #FFF;
}
[data-theme=dark] .black-text {
  color: #FFF !important;
}
[data-theme=dark] .theme-type-images .theme-image {
  background: #171724;
  border-color: #393947;
}
[data-theme=dark] .theme-type-images .theme-image span {
  color: #FFF;
}
[data-theme=dark] .table tbody tr td a {
  color: #FFF;
}
[data-theme=dark] .text-black {
  color: #FFF !important;
}
[data-theme=dark] .lang-flag a {
  border-color: #393947;
  color: #FFF;
}
[data-theme=dark] .modal .modal-content {
  background: #1E1E2D;
  border-color: #393947;
}
[data-theme=dark] .modal .modal-content .modal-header {
  border-color: #393947;
}
[data-theme=dark] .modal .modal-content .col-form-label {
  color: #FFF;
}
[data-theme=dark] .drag-attach {
  border-color: #393947;
}
[data-theme=dark] .upload-file {
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .lang-type li a {
  background: #171724;
}
[data-theme=dark] .dropdown-menu {
  background: #1E1E2D;
  border-color: #393947;
}
[data-theme=dark] .table-action .dropdown-menu a {
  color: #B5B5B5;
}
[data-theme=dark] .table-action .dropdown-menu a:hover {
  background: #28283D;
  color: #FFF;
}
[data-theme=dark] .btn-add {
  background: #1A1A25;
  border-color: #393947;
  color: #FFF;
}
[data-theme=dark] .settings-sub-header.setting-item .table-action .action-icon {
  background: #1A1A25;
  border-color: #393947;
}
[data-theme=dark] .settings-sub-header.setting-item .table-action .action-icon:hover {
  background: #1A1A25;
  color: #FFF;
}
[data-theme=dark] .settings-sub-header.setting-item .table-action .action-icon:hover i {
  color: #FFF;
}
[data-theme=dark] .mail-wrapper {
  background: #28283E;
  border-color: #393947;
}
[data-theme=dark] .mail-wrapper .mail-wrap .email-action .info-icon:hover {
  color: #FFF;
}
[data-theme=dark] .mail-wrapper .mail-wrap .email-action .info-icon::after {
  background: #393947;
}
[data-theme=dark] .mail-wrapper .mail-collapse {
  border-color: #393947;
}
[data-theme=dark] .bank-box {
  background: #28283E;
  border-color: #393947;
}
[data-theme=dark] .bank-box.active::after {
  background-color: #28283E;
}
[data-theme=dark] .bank-box .table-action .action-icon:hover {
  background: #1A1A25;
}
[data-theme=dark] .custom-modal .modal-header .btn-close {
  border-color: #393947;
  background: #1A1A25;
  box-shadow: none;
}
[data-theme=dark] .storage-wrap .storage-icon .system-app-icon {
  background: #1E1E2D;
  border-color: #393947;
}
[data-theme=dark] .storage-wrap .setting-gateway a {
  color: #B5B5B5;
}
[data-theme=dark] .ip-wrap {
  background: #28283E;
  border-color: #393947;
}
[data-theme=dark] .ip-wrap .table-action .action-icon {
  background: #28283E;
  border-color: #393947;
}
[data-theme=dark] .ip-wrap .table-action .action-icon:hover {
  background: #28283E;
  border-color: #393947;
}
[data-theme=dark] .action-drop .dropdown-item {
  color: #B5B5B5;
}
[data-theme=dark] .action-drop .dropdown-item:hover {
  background: #28283E;
  color: #FFF;
}
[data-theme=dark] .notes-activity .note-download:hover {
  background-color: transparent;
}
[data-theme=dark] .notes-activity .note-download:hover a {
  background: #28283D;
  color: #B5B5B5;
}
[data-theme=dark] .notes-activity .note-download a {
  background: #28283D;
  color: #B5B5B5;
}
[data-theme=dark] .calls-box .caller-info .calls-action .dropdown-menu {
  border-color: #393947;
}
[data-theme=dark] .calls-box .caller-info .calls-action .dropdown-menu .dropdown-item:hover {
  background: #28283E;
  color: #FFF;
}
[data-theme=dark] .bootstrap-tagsinput .tag {
  background: #28283D;
}
[data-theme=dark] .contacts-action .act-dropdown .dropdown-item {
  color: #B5B5B5;
}
[data-theme=dark] .contacts-action .act-dropdown .dropdown-item:hover {
  background: #28283E;
  color: #FFF;
}
[data-theme=dark] .profile-pic-upload .profile-pic {
  border-color: #393947;
}
[data-theme=dark] .contact-wrap .contact-profile .avatar.company-avatar {
  border-color: #393947;
}
[data-theme=dark] .select2-container--default.select2-container--focus .select2-selection--multiple,
[data-theme=dark] .select2-container--default .select2-selection--multiple {
  border-color: #393947;
}
[data-theme=dark] .select2-container--classic .select2-selection--multiple .select2-selection__choice,
[data-theme=dark] .select2-container--default .select2-selection--multiple .select2-selection__choice,
[data-theme=dark] .select2-container--default .select2-selection--multiple .select2-selection__choice__remove {
  background: #28283D;
  border-color: #393947;
}
[data-theme=dark] .title-name {
  color: #FFF !important;
}
[data-theme=dark] .kanban-list-items {
  border-color: #393947;
}
[data-theme=dark] .kanban-list-items .kanban-list-head {
  background: #28283E;
}
[data-theme=dark] .kanban-list-items .kanban-list-head .kanban-action-btns .table-action .action-icon {
  background: #28283E;
  border-color: #393947;
}
[data-theme=dark] .email-header .btn-white {
  border-color: #393947;
  color: #FFF;
}
[data-theme=dark] .pipeline-list {
  border-color: #393947;
}
[data-theme=dark] .priority-info .dropdown .dropdown-toggle {
  border-color: #393947;
  color: #B5B5B5;
}
[data-theme=dark] .priority-info .dropdown a {
  color: #B5B5B5;
}
[data-theme=dark] .pipeline-item {
  border-color: #393947;
}
[data-theme=dark] .pipeline-item p {
  color: #FFF;
}
[data-theme=dark] .kanban-card {
  background: #28283E;
  border-color: #393947;
}
[data-theme=dark] .kanban-card .kanban-card-body ul li {
  color: #B5B5B5;
}
[data-theme=dark] .kanban-card .kanban-card-footer {
  border-color: #393947;
}
[data-theme=dark] .kanban-card .kanban-card-footer span {
  border-color: #393947;
}
[data-theme=dark] .campaign-tab {
  background: #28283E;
}
[data-theme=dark] .campaign-tab ul li a {
  border-color: transparent;
}
[data-theme=dark] .campaign-tab ul li a.active {
  color: #E41F07;
}
[data-theme=dark] .campaign-tab ul li a span {
  border-color: #393947;
}
[data-theme=dark] ul.project-mem li.more-set a {
  background: #28283E;
  border-color: #393947;
  color: #B5B5B5;
}
[data-theme=dark] .pipeline-progress span, [data-theme=dark] .task-info p,
[data-theme=dark] .con-sidebar-title p, [data-theme=dark] .task-actions ul li {
  color: #FFF;
}
[data-theme=dark] .contact-grid.project .grid-head {
  background-color: #28283E;
}
[data-theme=dark] .contact-grid.project .grid-head .users-profile .con-avatar {
  background-color: #1E1E2D;
  border-color: #393947;
}
[data-theme=dark] .access-wrap li:hover {
  background: #28283E;
}
[data-theme=dark] .task-wrap {
  background: #28283E;
  border-color: #393947;
}
[data-theme=dark] .rate-icon, [data-theme=dark] .con-sidebar-title.border-line {
  border-color: #393947;
}
[data-theme=dark] .pipeline-list ul li a.bg-gray {
  color: #262A2A;
}
[data-theme=dark] .task-wrapper .task-accordion span {
  border-color: #393947;
  color: #B5B5B5;
}
[data-theme=dark] .task-drops .dropdown-toggle {
  background-color: transparent;
}
[data-theme=dark] .task-wrapper {
  border-color: #393947;
}
[data-theme=dark] .card.analytics-card {
  background-color: #1E1E2D;
}
[data-theme=dark] .card.analytics-card .card-header {
  background: transparent;
}
[data-theme=dark] .card.analytics-card .card-header .select2-container--default .select2-selection--single .select2-selection__rendered {
  color: #FFF;
}
[data-theme=dark] .activities-list ul li {
  background: #28283E;
}
[data-theme=dark] .activities-list ul li .activity-name h5 {
  color: #FFF;
}
[data-theme=dark] .campaign-card ul .campaign-wrap {
  background: #28283E;
}
[data-theme=dark] .campaign-card ul .campaign-wrap .campaign-info {
  border-color: #393947;
}
[data-theme=dark] .campaign-card ul .campaign-wrap .campaign-info h5 {
  color: #FFF;
}
[data-theme=dark] .card.analytics-card .card-body .table th {
  background: #171724;
  color: #FFF;
}
[data-theme=dark] .card.analytics-card .card-body .table th:first-child, [data-theme=dark] .card.analytics-card .card-body .table th:last-child {
  border-color: #393947;
}
[data-theme=dark] .card.analytics-card .card-body .table td:first-child, [data-theme=dark] .card.analytics-card .card-body .table td:last-child {
  border-color: #393947;
}
[data-theme=dark] .active-list ul li a {
  background: #1A1A25;
  border-color: #393947;
  color: #FFF;
}
[data-theme=dark] .activity-title h4::after {
  background: #393947;
}
[data-theme=dark] .header-set {
  border-color: #393947;
}
[data-theme=dark] .header-set .select2-container--default .select2-selection--single .select2-selection__rendered {
  color: #FFF;
}
[data-theme=dark] .radio-activity li .active-type input[type=radio] ~ label {
  background: #1A1A25;
  border-color: #393947;
  color: #FFF;
}
[data-theme=dark] .tab-activity {
  box-shadow: none;
}
[data-theme=dark] .tab-activity ul li a span {
  color: #B5B5B5;
  border-color: #393947;
}
[data-theme=dark] .report-header {
  border-color: #393947;
}
[data-theme=dark] .location-flag-img {
  border-color: #393947;
}
[data-theme=dark] .table-imgname.flag-image span {
  color: #FFF;
}
[data-theme=dark] .membership-plans .plan-selected h4 {
  color: #FFF;
}
[data-theme=dark] .membership-plan-grid {
  background-color: #28283E;
  border-color: #393947;
}
[data-theme=dark] .membership-plan-grid .plan-price-head {
  border-color: #393947;
}
[data-theme=dark] .membership-plan-grid .plan-price-head .plan-type {
  color: #FFF;
}
[data-theme=dark] .membership-plan-grid .plans-features ul li {
  color: #FFF;
}
[data-theme=dark] .membership-plan-grid.active {
  background-color: #1E1E2D;
}
[data-theme=dark] .membership-plan-grid.active .plan-price-head {
  border-color: #393947;
}
[data-theme=dark] .membership-plan-grid.active .plan-price-head .plan-type {
  color: #FFF;
}
[data-theme=dark] .membership-plan-grid.active .plans-features ul li {
  color: #FFF;
}
[data-theme=dark] .file-manager aside {
  border-color: #393947;
}
[data-theme=dark] .notes-dash {
  background-color: #28283E;
}
[data-theme=dark] .notes-dash .notes-top-head {
  border-color: #393947;
}
[data-theme=dark] .notes-dash .notes-top-head-submenu {
  border-color: #393947;
}
[data-theme=dark] .notes-page-wrapper .content .section-card-body .notes-card-details {
  background-color: #28283E;
  border-color: #393947;
  box-shadow: none;
}
[data-theme=dark] .search-set .search-input input[type=search] {
  background-color: #28283E;
  border-color: #393947;
}
[data-theme=dark] .search-set .search-input input[type=search]::placeholder {
  color: #B5B5B5;
}
[data-theme=dark] .todo-wrapper-list {
  background-color: #28283E;
  border-color: #393947;
}
[data-theme=dark] .notes-page-wrapper .content .section-bulk-wrap {
  background-color: #28283E;
  box-shadow: none;
}
[data-theme=dark] .notes-page-wrapper .content .page-add-notes {
  border-color: #393947;
}
[data-theme=dark] .notes-page-wrapper .content .section-notes-slider {
  border-color: #393947;
}
[data-theme=dark] .fc-day {
  background-color: #28283E;
}
[data-theme=dark] .file-manager .folders {
  border-color: #393947;
  background-color: #28283E;
}
[data-theme=dark] .file-manager .accordion .accordion-item .accordion-body {
  background: transparent;
}
[data-theme=dark] table tbody td.action-table-data a {
  background-color: #28283E;
}
[data-theme=dark] .main-chat-blk .chat {
  background-color: #28283E;
}
[data-theme=dark] .main-chat-blk .chat .chat-header {
  background-color: #28283E;
  border-color: #393947;
  box-shadow: none;
}
[data-theme=dark] .main-chat-blk .main-wrapper .content .sidebar-group .sidebar {
  background-color: #28283E;
}
[data-theme=dark] .main-chat-blk .chat-page-wrapper .left-chat-title {
  background-color: #28283E;
  border-color: #393947;
}
[data-theme=dark] .main-chat-blk .chat .chat-header .user-details h5 {
  color: #FFF;
}
[data-theme=dark] .main-chat-blk .sidebar .user-list li .users-list-body h5 {
  color: #FFF;
}
[data-theme=dark] .main-chat-blk .sidebar .user-list li .users-list-body p {
  color: #B5B5B5;
}
[data-theme=dark] .main-chat-blk .chat-page-wrapper .setting-title-head h4 {
  color: #FFF;
}
[data-theme=dark] .main-chat-blk .sidebar .user-list li .users-list-body .last-chat-time .text-muted {
  color: #B5B5B5 !important;
}
[data-theme=dark] .main-chat-blk .chat .chat-body .messages .chat-profile-name h6 {
  color: #FFF;
}
[data-theme=dark] .main-chat-blk .sidebar .user-list li a {
  border-color: #393947;
}
[data-theme=dark] .main-chat-blk .last-seen {
  color: #B5B5B5;
}
[data-theme=dark] .daterangepicker {
  background-color: #28283E;
  border-color: #393947;
}
[data-theme=dark] .daterangepicker.show-ranges.ltr .drp-calendar.left {
  border-color: #393947;
}
[data-theme=dark] .daterangepicker .drp-buttons {
  border-color: #393947;
}
[data-theme=dark] .daterangepicker .drp-buttons .btn-default {
  color: #B5B5B5;
}

[data-sidebar=sidebarbg1] .sidebar {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  background-color: transparent;
}
[data-sidebar=sidebarbg1] .sidebar .sidebar-menu {
  background: rgba(255, 255, 255, 0.85);
}

[data-sidebar=sidebarbg2] .sidebar {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  background-color: transparent;
}
[data-sidebar=sidebarbg2] .sidebar .sidebar-menu {
  background: rgba(255, 255, 255, 0.85);
}

[data-sidebar=sidebarbg3] .sidebar {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  background-color: transparent;
}
[data-sidebar=sidebarbg3] .sidebar .sidebar-menu {
  background: rgba(255, 255, 255, 0.85);
}

[data-sidebar=sidebarbg4] .sidebar {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  background-color: transparent;
}
[data-sidebar=sidebarbg4] .sidebar .sidebar-menu {
  background: rgba(255, 255, 255, 0.85);
}

[data-theme=dark] .border, [data-theme=dark] .border-top, [data-theme=dark] .border-bottom, [data-theme=dark] .border-start, [data-theme=dark] .border-end {
  border-color: #393947 !important;
}
[data-theme=dark] .dropdown .dropdown-toggle {
  border-color: #393947;
  color: #B5B5B5;
}
[data-theme=dark] .dropdown .dropdown-menu {
  background: #171724;
  border-color: #393947;
}
[data-theme=dark] .bg-white {
  background: #171724 !important;
}
[data-theme=dark] .bg-light-200, [data-theme=dark] .bg-light-300, [data-theme=dark] .bg-light-400 {
  background: #1A1A25;
}
[data-theme=dark] .dropdown .dropdown-menu .dropdown-item {
  background: #1A1A25;
}
[data-theme=dark] .offcanvas {
  background: #171724;
}
[data-theme=dark] .accordion-button:after {
  background: transparent;
}
[data-theme=dark] .bg-success.border {
  border-color: #5CB85C !important;
}
[data-theme=dark] .bg-purple.border {
  border-color: #4A00E5 !important;
}
[data-theme=dark] .bg-warning.border {
  border-color: #FDA700 !important;
}
[data-theme=dark] .bg-danger.border {
  border-color: #FC0027 !important;
}
[data-theme=dark] .btn-close {
  --bs-btn-close-color: \$dark-text;
  color: #FFF;
}
[data-theme=dark] .input-themeselect span {
  color: #FFF;
}

.sidebar-contact {
  position: fixed;
  top: 0%;
  right: -350px;
  transform: translateY(-50%);
  width: 350px;
  height: auto;
  background: #fff;
  box-sizing: border-box;
  transition: 0.5s;
  z-index: 9999;
}
.sidebar-contact .toggle-theme {
  position: absolute;
  width: 35px;
  text-align: center;
  cursor: pointer;
  background: #fed713;
  top: 225px;
  right: 350px;
  padding: 6px;
  height: 35px;
  color: #000;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
}
.sidebar-contact .toggle-theme .fa-spin {
  animation: fa-spin 2s infinite linear;
}

#theme-settings {
  width: 26px;
  height: 26px;
  border: 1px solid #E8E8E8;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
}

.input-themeselect label {
  width: 100%;
}

.sidebar-themesettings {
  position: fixed;
  right: -380px;
  top: 0;
  background: #fff;
  transition: all 0.5s;
  width: 380px;
  height: 100vh;
  z-index: 99999;
  padding: 15px;
  overflow: auto;
  max-width: 100%;
}
.sidebar-themesettings.open {
  right: 0;
}
.sidebar-themesettings .themesettings-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 20px;
  border-bottom: 1px solid #E8E8E8;
}
.sidebar-themesettings .themesettings-header h4 {
  color: #262A2A;
  font-size: 18px;
}
.sidebar-themesettings .themesettings-inner {
  padding: 24px;
  background: #fff;
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  margin-top: 15px;
  padding-bottom: 9px;
}
.sidebar-themesettings .themesettings-inner .themesettings-content {
  border-bottom: 1px solid #E8E8E8;
  margin-bottom: 15px;
}
.sidebar-themesettings .themesettings-inner .themesettings-content h6 {
  font-size: 14px;
  font-weight: 600;
  color: #000;
  margin-bottom: 15px;
}
.sidebar-themesettings .input-themeselect {
  background: #F6F6F6;
  padding: 10px;
  border-radius: 10px;
  border: 1px solid #E8E8E8;
  margin-bottom: 15px;
}
.sidebar-themesettings .input-themeselect input[type=radio] {
  display: none;
}
.sidebar-themesettings .input-themeselect input[type=radio]:checked ~ label .checkboxs-theme:after {
  background-color: #4A00E5;
  border-color: #4A00E5;
  content: "";
}
.sidebar-themesettings .input-themeselect input[type=radio]:checked ~ label .checkboxs-theme::before {
  content: "\\f00c";
  font-family: "Font Awesome 5 Free";
  color: #fff;
  font-weight: 700;
  font-size: 10px;
  right: 4px;
  position: absolute;
  top: -14px;
  z-index: 9;
}
.sidebar-themesettings .input-themeselect img {
  height: 80px;
}
.sidebar-themesettings .input-themeselect .checkboxs-theme {
  position: relative;
  width: 100%;
  display: block;
}
.sidebar-themesettings .input-themeselect .checkboxs-theme:after {
  position: absolute;
  content: "";
  border: 1px solid #E8E8E8;
  width: 16px;
  height: 16px;
  border-radius: 5px;
  right: 0;
  top: -17px;
}

.sidebar-themeoverlay {
  position: fixed;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.75);
  top: 0;
  left: -100%;
  z-index: 10000;
}
.sidebar-themeoverlay.open {
  left: 0;
}

.theme-colorsset {
  margin: 15px 0;
}
.theme-colorsset ul {
  display: flex;
  align-items: center;
}
.theme-colorsset ul li .input-themeselects label {
  width: 30px;
  height: 30px;
  border-radius: 2px;
  position: relative;
}
.theme-colorsset ul li .input-themeselects label.red-clr {
  background: #E41F07;
}
.theme-colorsset ul li .input-themeselects label.yellow-clr {
  background: #FFA201;
}
.theme-colorsset ul li .input-themeselects label.blue-clr {
  background: #3C2371;
}
.theme-colorsset ul li .input-themeselects label.green-clr {
  background: #00918E;
}
.theme-colorsset ul li .input-themeselects input[type=radio] {
  display: none;
}
.theme-colorsset ul li .input-themeselects input[type=radio]:checked ~ label:after {
  content: "\\f00c";
  font-family: "Font Awesome 5 Free";
  color: #fff;
  font-weight: 700;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
}
.theme-colorsset ul li + li {
  margin-left: 10px;
}

.themesettings-footer {
  margin-top: 15px;
}
.themesettings-footer ul {
  display: flex;
  align-items: center;
}
.themesettings-footer ul li {
  width: 50%;
}
.themesettings-footer ul li + li {
  margin-left: 10px;
}
.themesettings-footer ul li .btn {
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  padding: 8px;
}
.themesettings-footer ul li .btn-cancel {
  background: #F6F6F6;
  border: 1px solid #E8E8E8;
  color: #262A2A;
}
.themesettings-footer ul li .btn-cancel:hover {
  background: #E8E8E8;
}
.themesettings-footer ul li .btn-reset {
  background: #00918E;
  color: #fff;
}
.themesettings-footer ul li .btn-reset:hover {
  background: #005e5c;
}

.topnav-dropdown-header {
  padding: 15px;
  border-bottom: 1px solid #E8E8E8;
}
.topnav-dropdown-header .notification-title {
  font-size: 18px;
  font-weight: 600;
  color: #000;
  margin-bottom: 0;
}

.notification-dropdown .noti-content {
  width: 440px;
  height: 390px;
  overflow-y: auto;
  position: relative;
}
.notification-dropdown .notification-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.notification-dropdown .notification-list li {
  margin-top: 0;
  border-bottom: 1px solid #F4F4F4;
  font-size: 14px;
}
.notification-dropdown .notification-list li:last-child {
  border-bottom: 0;
}
.notification-dropdown .notification-list li a {
  display: block;
  padding: 15px;
}
.notification-dropdown .notification-list li .avatar {
  width: 36px;
  height: 36px;
  margin: 0 16px 0 0;
  border-radius: 5px;
  position: relative;
}
.notification-dropdown .notification-list li .avatar img {
  border-radius: 5px;
}
.notification-dropdown .notification-list li .avatar .badge {
  display: inline-block;
  position: absolute;
  top: -7px;
  left: -7px;
  padding: 4px;
}
.notification-dropdown .notification-list li .noti-title {
  color: #323737;
  font-weight: 500;
}
.notification-dropdown .notification-list li .noti-details {
  font-weight: 500;
  color: #6F6F6F;
  margin: 0 0 8px;
}
.notification-dropdown .notification-list li .noti-sub-details {
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  color: #6F6F6F;
  position: relative;
  margin: 0 0 8px;
  padding: 0 0 0 15px;
}
.notification-dropdown .notification-list li .noti-sub-details::before {
  content: "";
  position: absolute;
  left: 0;
  width: 4px;
  height: -webkit-fill-available;
  background: #6F6F6F;
  border-radius: 5px;
}
.notification-dropdown .notification-list li p.noti-time {
  font-size: 12px;
  color: #262A2A;
  margin: 0;
}
.notification-dropdown .notification-list li .noti-pdf {
  display: inline-flex;
  align-items: center;
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 8px;
}
.notification-dropdown .notification-list li .noti-pdf .noti-pdf-icon {
  margin-right: 10px;
}
.notification-dropdown .notification-list li .noti-pdf .noti-pdf-icon span {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #E41F07;
  width: 24px;
  min-width: 24px;
  height: 24px;
  border: 1px solid #E8E8E8;
  border-radius: 5px;
}
.notification-dropdown .notification-list li .noti-pdf .noti-pdf-text {
  line-height: normal;
}
.notification-dropdown .notification-list li .noti-pdf .noti-pdf-text p {
  font-size: 12px;
  color: #262A2A;
  margin-bottom: 0;
}
.notification-dropdown .notification-list li .noti-pdf .noti-pdf-text span {
  font-size: 12px;
  color: #6F6F6F;
}
.notification-dropdown .notification-list li .notification-time {
  font-size: 12px;
  line-height: 1.35;
  color: #565E5E;
}
.notification-dropdown .notification-list li .list-item {
  border: 0;
  padding: 0;
  position: relative;
}
.notification-dropdown .notification-list li .list-item .list-left {
  height: 48px;
  position: absolute;
  width: 48px;
}
.notification-dropdown .notification-list li .list-item .list-body {
  padding: 0 0 0 50px;
}
.notification-dropdown .notification-list li .list-item .list-body .message-author {
  color: #323737;
  float: left;
  font-weight: 500;
  width: 175px;
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.notification-dropdown .notification-list li .list-item .list-body .message-time {
  color: #565E5E;
  float: right;
  font-size: 11px;
}
.notification-dropdown .notification-list li .list-item .list-body .message-content {
  color: #323737;
  font-size: 13px;
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.topnav-dropdown-footer {
  background: #F9F9FC;
  text-align: right;
  padding: 15px;
}
.topnav-dropdown-footer a {
  font-weight: 600;
  margin-right: 15px;
}
.topnav-dropdown-footer a:last-child {
  margin-right: 0;
}
.topnav-dropdown-footer .view-link {
  color: #262A2A;
}
.topnav-dropdown-footer .view-link:hover {
  color: #6F6F6F;
}
.topnav-dropdown-footer .clear-link {
  color: #E41F07;
}
.topnav-dropdown-footer .clear-link:hover {
  color: #b31805;
}

.list-left {
  height: 48px;
  position: absolute;
  width: 48px;
}

.list-body {
  padding: 0 0 0 50px;
}
.list-body .message-author {
  color: #323737;
  float: left;
  font-weight: 500;
  width: 175px;
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.list-body .message-time {
  color: #565E5E;
  float: right;
  font-size: 11px;
}
.list-body .message-content {
  color: #323737;
  font-size: 13px;
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.activity {
  width: 100%;
}
.activity .activity-box {
  position: relative;
}
.activity .activity-list {
  list-style: none;
  padding: 0;
  margin: 0;
  position: relative;
}
.activity .activity-list li {
  background-color: #FFF;
  position: relative;
  border: 1px solid #6F6F6F;
  margin: 0 0 10px;
  padding: 20px 10px 10px;
  font-size: 15px;
}
.activity .activity-list li .activity-user {
  height: 50px;
  margin: 0;
  padding: 0;
  width: 50px;
  position: absolute;
  top: 12px;
  left: 8px;
}
.activity .activity-list li .activity-content {
  background-color: #FFF;
  position: relative;
  margin: 0 0 0 60px;
  padding: 0;
}
.activity .activity-list li .time {
  color: #6F7A7A;
  display: block;
  font-size: 12px;
  line-height: 1.35;
}
.activity .activity-list li a.name {
  color: #000;
}
.activity .activity-list li a {
  color: #FFA201;
  font-weight: 600;
  font-size: 15px;
}
.activity .activity-list li a img {
  width: 50px;
  height: 50px;
  border-radius: 5px;
}

/******* Components ******/
.avatar {
  position: relative;
  height: 2.625rem;
  width: 2.625rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  color: #FFF;
  font-weight: 500;
}
.avatar a.badge:hover {
  color: #FFF;
}
.avatar img {
  width: 100%;
  height: 100%;
  border-radius: 4px;
}
.avatar.avatar-rounded {
  border-radius: 50%;
}
.avatar.avatar-rounded img {
  border-radius: 50%;
}
.avatar.avatar-radius-0 {
  border-radius: 0;
}
.avatar.avatar-radius-0 img {
  border-radius: 0;
}
.avatar .avatar-badge {
  position: absolute;
  inset-block-start: -4%;
  inset-inline-end: -0.375rem;
  width: 1.4rem;
  height: 1.4rem;
  font-size: 0.625rem;
  border: 2px solid #FFF;
  border-radius: 50% !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.avatar.online:before, .avatar.offline:before {
  position: absolute;
  content: "";
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  inset-inline-end: 0;
  inset-block-end: 0;
  border: 2px solid #FFF !important;
  z-index: 1;
}
.avatar.online:before {
  background-color: #5CB85C;
}
.avatar.offline:before {
  background-color: #6F7A7A;
}
.avatar.avatar-xs {
  width: 1.25rem;
  height: 1.25rem;
  line-height: 1.25rem;
  font-size: 0.65rem;
}
.avatar.avatar-xs .avatar-badge {
  padding: 0.25rem;
  width: 1rem;
  height: 1rem;
  line-height: 1rem;
  font-size: 0.5rem;
  inset-block-start: -25%;
  inset-inline-end: -0.5rem;
}
.avatar.avatar-sm {
  width: 2rem;
  height: 2rem;
  line-height: 2rem;
  font-size: 0.65rem;
}
.avatar.avatar-sm .avatar-badge {
  padding: 0.3rem;
  width: 1.1rem;
  height: 1.1rem;
  line-height: 1.1rem;
  font-size: 0.5rem;
  inset-block-start: -28%;
  inset-inline-end: -0.45rem;
}
.avatar.avatar-sm.online:before, .avatar.avatar-sm.offline:before {
  width: 0.5rem;
  height: 0.5rem;
}
.avatar.avatar-md {
  width: 2.5rem;
  height: 2.5rem;
  line-height: 2.5rem;
  font-size: 0.8rem;
}
.avatar.avatar-md .avatar-badge {
  padding: 0.4rem;
  width: 1.2rem;
  height: 1.2rem;
  line-height: 1.2rem;
  font-size: 0.65rem;
  inset-block-start: -6%;
  inset-inline-end: -13%;
}
.avatar.avatar-md.online:before, .avatar.avatar-md.offline:before {
  width: 0.75rem;
  height: 0.75rem;
}
.avatar.avatar-md svg {
  width: 1.5rem;
  height: 1.5rem;
}
.avatar.avatar-lg {
  width: 3rem;
  height: 3rem;
  line-height: 3rem;
  font-size: 1rem;
}
.avatar.avatar-lg .avatar-badge {
  inset-block-start: -15%;
  inset-inline-end: -0.25%;
}
.avatar.avatar-lg.online:before, .avatar.avatar-lg.offline:before {
  width: 0.8rem;
  height: 0.8rem;
}
.avatar.avatar-lg svg {
  width: 1.8rem;
  height: 1.8rem;
}
.avatar.avatar-xl {
  width: 4rem;
  height: 4rem;
  line-height: 4rem;
  font-size: 1.25rem;
}
.avatar.avatar-xl .avatar-badge {
  inset-block-start: -8%;
  inset-inline-end: -0.2%;
}
.avatar.avatar-xl.online:before, .avatar.avatar-xl.offline:before {
  width: 0.95rem;
  height: 0.95rem;
}
.avatar.avatar-xxl {
  width: 5rem;
  height: 5rem;
  line-height: 5rem;
  font-size: 1.5rem;
}
.avatar.avatar-xxl .avatar-badge {
  inset-block-start: -4%;
  inset-inline-end: 0rem;
}
.avatar.avatar-xxl.online:before, .avatar.avatar-xxl.offline:before {
  width: 1.05rem;
  height: 1.05rem;
  inset-block-end: 0.25rem;
}
.avatar.avatar-xxl.online.online-sm:before, .avatar.avatar-xxl.offline.online-sm:before {
  width: 10px;
  height: 10px;
  inset-block-end: 0rem;
}
.avatar.avatar-xxxl {
  width: 6rem;
  height: 6rem;
  line-height: 6rem;
  font-size: 1.75rem;
}
.avatar.avatar-xxxl .avatar-badge {
  inset-block-start: -4%;
  inset-inline-end: 0rem;
}
.avatar.avatar-xxxl.online:before, .avatar.avatar-xxxl.offline:before {
  width: 1.05rem;
  height: 1.05rem;
  inset-block-end: 0.25rem;
}

.avatar-list-stacked {
  padding: 0;
}
.avatar-list-stacked.avatar-group-overlapped .avatar {
  margin-right: -0.875rem;
}
.avatar-list-stacked.avatar-group-overlapped .avatar:hover {
  z-index: 1;
}
.avatar-list-stacked.avatar-group-lg .avatar {
  width: 3.25rem;
  height: 3.25rem;
}
.avatar-list-stacked.avatar-group-lg .avatar > .initial-wrap {
  font-size: 0.95rem;
}
.avatar-list-stacked.avatar-group-lg.avatar-group-overlapped .avatar {
  margin-right: -1rem;
}
.avatar-list-stacked.avatar-group-sm .avatar {
  width: 2rem;
  height: 2rem;
}
.avatar-list-stacked.avatar-group-sm .avatar > .initial-wrap {
  font-size: 0.6rem;
}
.avatar-list-stacked.avatar-group-sm.avatar-group-overlapped .avatar {
  margin-right: -0.625rem;
}
.avatar-list-stacked.avatar-group-xs .avatar {
  width: 1.5rem;
  height: 1.5rem;
}
.avatar-list-stacked.avatar-group-xs .avatar > .initial-wrap {
  font-size: 0.6rem;
}
.avatar-list-stacked .avatar {
  margin-inline-end: -0.875rem !important;
  border: 1px solid rgba(0, 0, 0, 0.05);
  vertical-align: middle;
  transition: transform ease 200ms;
}
.avatar-list-stacked .avatar:last-child {
  margin-inline-end: 0 !important;
}
.avatar-list-stacked .avatar:hover {
  z-index: 1;
  transform: translateY(-0.188rem);
}

.avatar-group {
  display: inline-flex;
}
.avatar-group .avatar {
  width: 2.625rem;
  height: 2.625rem;
}
.avatar-group .avatar .avatar-img,
.avatar-group .avatar > .initial-wrap {
  border: 2px solid #FFF;
  font-size: 0.9rem;
}
.avatar-group.avatar-group-overlapped .avatar {
  margin-right: -0.875rem;
}
.avatar-group.avatar-group-overlapped .avatar:hover {
  z-index: 1;
}
.avatar-group.avatar-group-lg .avatar {
  width: 3.25rem;
  height: 3.25rem;
}
.avatar-group.avatar-group-lg .avatar > .initial-wrap {
  font-size: 0.95rem;
}
.avatar-group.avatar-group-lg.avatar-group-overlapped .avatar {
  margin-right: -1rem;
}
.avatar-group.avatar-group-sm .avatar {
  width: 2rem;
  height: 2rem;
}
.avatar-group.avatar-group-sm .avatar > .initial-wrap {
  font-size: 0.6rem;
}
.avatar-group.avatar-group-sm.avatar-group-overlapped .avatar {
  margin-right: -0.625rem;
}

.avatar-xxs {
  width: 16px;
  height: 16px;
}

.bootstrap-datetimepicker-widget table td.active,
.bootstrap-datetimepicker-widget table td.active:hover {
  background-color: #FDA700;
  text-shadow: unset;
}

.bootstrap-datetimepicker-widget table td.today:before {
  border-bottom-color: #FDA700;
}

.bootstrap-datetimepicker-widget table thead tr:first-child th:hover {
  background: transparent;
}

.bor-b1 {
  border-bottom: 1px solid #898989;
}

.link-purple {
  color: #4A00E5;
}
.link-purple:hover {
  color: #4700db;
}

hr {
  border-color: #E8E8E8;
}

.btn-primary {
  color: #FFF;
  background-color: #E41F07;
  border-color: #E41F07;
  font-size: 14px;
  font-size: 14px;
}

.btn-save {
  background: #E41F07;
  color: #FFF;
  font-size: 14px;
  font-size: 14px;
  border-radius: 5px;
  padding: 8px 20px;
  transition: all 0.2s ease;
}
.btn-save:hover {
  background: #b31805;
  color: #FFF;
}
@media (max-width: 991.98px) {
  .btn-save {
    min-width: auto;
    padding: 5px 7px;
  }
}

.btn-reset {
  background: #6F6F6F;
  color: #FFF;
  font-size: 14px;
  font-weight: 700;
  border-radius: 5px;
  padding: 8px 20px;
  transition: all 0.2s ease;
}
.btn-reset:hover {
  background: #FFA201;
  color: #FFF;
}
@media (max-width: 991.98px) {
  .btn-reset {
    min-width: auto;
    padding: 5px 7px;
  }
}

.btn-send {
  background: #E41F07;
  padding: 9px 14px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  margin-right: 15px;
  border-radius: 8px;
}
.btn-send:hover {
  background: #b31805;
  color: #FFF;
}
.btn-send .send-mail {
  margin-right: 10px;
  width: 16px;
  height: 16px;
}

.btn-download {
  background: #FFA201;
  padding: 9px 14px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  margin-right: 15px;
  border-radius: 8px;
}
.btn-download:hover {
  background: #262A2A;
  color: #FFF;
}
.btn-download .download {
  margin-right: 10px;
  width: 16px;
  height: 16px;
}

.btn-barcode {
  background: #FC0027;
  padding: 9px 14px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  margin-right: 15px;
  border-radius: 8px;
}
.btn-barcode:hover {
  background: #FC0027;
  color: #FFF;
}
.btn-barcode .print {
  margin-right: 10px;
  width: 16px;
  height: 16px;
}

.btn-primary.add-em-payroll {
  padding: 9px 11px;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  border-radius: 8px;
}
.btn-primary.add-em-payroll .me-2 {
  width: 16px;
  height: 16px;
}

.swal2-actions .swal2-confirm.btn:active {
  background-color: #E41F07;
  border-color: #E41F07;
}

.btn-check:checked + .btn, .btn.active, .btn.show, .btn:first-child:active, :not(.btn-check) + .btn:active {
  background-color: #E41F07;
  border-color: #E41F07;
  color: #FFF;
}

.modal .card {
  border: 0;
}

.search-input .btn-searchset:active {
  background-color: transparent;
  border-color: transparent;
}
.search-input .btn-searchset:active svg {
  color: #FFA201;
}

.input-blocks input[type=text].datetimepicker {
  padding-left: 35px;
}

.iti__country-list {
  z-index: 101;
}

button {
  cursor: pointer;
}
button:focus {
  outline: 0;
  box-shadow: none;
}

.btn {
  border-radius: 5px;
  padding: 0.625rem 1.25rem;
  padding: 0.5rem 0.85rem;
  font-size: 0.85rem;
  transition: all 0.5s;
  font-weight: 600;
}
.btn:focus {
  box-shadow: none !important;
}
.btn:hover {
  transition: all 0.5s;
}
.btn.btn-lg {
  padding: 0.65rem 1rem;
  font-size: 0.95rem;
}
.btn.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
}
.btn.btn-primary {
  background-color: #E41F07;
  border: 1px solid #E41F07;
  color: #FFF;
}
.btn.btn-primary:hover, .btn.btn-primary:focus, .btn.btn-primary.focus, .btn.btn-primary:active, .btn.btn-primary.active {
  background-color: #c11a06;
  border: 1px solid #c11a06;
  color: #FFF;
}
.btn.btn-secondary {
  background-color: #FFA201;
  border: 1px solid #FFA201;
  color: #FFF;
}
.btn.btn-secondary:hover, .btn.btn-secondary:focus, .btn.btn-secondary.focus, .btn.btn-secondary:active, .btn.btn-secondary.active {
  background-color: #dc8c00;
  border: 1px solid #dc8c00;
  color: #FFF;
}
.btn.btn-success {
  background-color: #5CB85C;
  border: 1px solid #5CB85C;
  color: #FFF;
}
.btn.btn-success:hover, .btn.btn-success:focus, .btn.btn-success.focus, .btn.btn-success:active, .btn.btn-success.active {
  background-color: #49a749;
  border: 1px solid #49a749;
  color: #FFF;
}
.btn.btn-info {
  background-color: #1ECBE2;
  border: 1px solid #1ECBE2;
  color: #FFF;
}
.btn.btn-info:hover, .btn.btn-info:focus, .btn.btn-info.focus, .btn.btn-info:active, .btn.btn-info.active {
  background-color: #19afc3;
  border: 1px solid #19afc3;
  color: #FFF;
}
.btn.btn-warning {
  background-color: #FDA700;
  border: 1px solid #FDA700;
  color: #FFF;
}
.btn.btn-warning:hover, .btn.btn-warning:focus, .btn.btn-warning.focus, .btn.btn-warning:active, .btn.btn-warning.active {
  background-color: #d98f00;
  border: 1px solid #d98f00;
  color: #FFF;
}
.btn.btn-danger {
  background-color: #FC0027;
  border: 1px solid #FC0027;
  color: #FFF;
}
.btn.btn-danger:hover, .btn.btn-danger:focus, .btn.btn-danger.focus, .btn.btn-danger:active, .btn.btn-danger.active {
  background-color: #d80021;
  border: 1px solid #d80021;
  color: #FFF;
}
.btn.btn-dark {
  background-color: #171724;
  border: 1px solid #171724;
  color: #FFF;
}
.btn.btn-dark:hover, .btn.btn-dark:focus, .btn.btn-dark.focus, .btn.btn-dark:active, .btn.btn-dark.active {
  background-color: #09090e;
  border: 1px solid #09090e;
  color: #FFF;
}
.btn.btn-light {
  background-color: #FDFDFE;
  border: 1px solid #FDFDFE;
  color: #FFF;
}
.btn.btn-light:hover, .btn.btn-light:focus, .btn.btn-light.focus, .btn.btn-light:active, .btn.btn-light.active {
  background-color: #e5e5f2;
  border: 1px solid #e5e5f2;
  color: #FFF;
}
.btn.btn-black {
  background-color: #000;
  border: 1px solid #000;
  color: #FFF;
}
.btn.btn-black:hover, .btn.btn-black:focus, .btn.btn-black.focus, .btn.btn-black:active, .btn.btn-black.active {
  background-color: black;
  border: 1px solid black;
  color: #FFF;
}
.btn.btn-purple {
  background-color: #4A00E5;
  border: 1px solid #4A00E5;
  color: #FFF;
}
.btn.btn-purple:hover, .btn.btn-purple:focus, .btn.btn-purple.focus, .btn.btn-purple:active, .btn.btn-purple.active {
  background-color: #3e00c1;
  border: 1px solid #3e00c1;
  color: #FFF;
}
.btn.btn-yellow {
  background-color: #ffff00;
  border: 1px solid #ffff00;
  color: #FFF;
}
.btn.btn-yellow:hover, .btn.btn-yellow:focus, .btn.btn-yellow.focus, .btn.btn-yellow:active, .btn.btn-yellow.active {
  background-color: #dbdb00;
  border: 1px solid #dbdb00;
  color: #FFF;
}
.btn.btn-teal {
  background-color: #02a8b5;
  border: 1px solid #02a8b5;
  color: #FFF;
}
.btn.btn-teal:hover, .btn.btn-teal:focus, .btn.btn-teal.focus, .btn.btn-teal:active, .btn.btn-teal.active {
  background-color: #028792;
  border: 1px solid #028792;
  color: #FFF;
}
.btn.btn-light {
  background-color: #F5F5F5;
  border: 1px solid #E8E8E8;
  color: #262A2A;
}
.btn.btn-light:hover, .btn.btn-light:focus, .btn.btn-light.focus, .btn.btn-light:active, .btn.btn-light.active {
  background-color: #ededed;
  border: 1px solid #E8E8E8;
  color: #262A2A;
}

.btn-group .btn {
  padding: 0.45rem 0.75rem;
}

.btn-group-lg .btn {
  padding: 0.65rem 1rem;
}

.btn-group-sm .btn {
  padding: 0.25rem 0.5rem;
}

.btn.btn-w-xs {
  min-width: 5.625rem;
}
.btn.btn-w-sm {
  min-width: 6.975rem;
}
.btn.btn-w-md {
  min-width: 8.125rem;
}
.btn.btn-w-lg {
  min-width: 9.375rem;
}

.btn-icon i {
  padding: 0rem;
  margin: -0.5rem;
}
.btn-icon.btn-sm {
  width: 1.75rem;
  height: 1.75rem;
  font-size: 0.8rem;
}
.btn-icon.btn-lg {
  width: 2.75rem;
  height: 2.75rem;
  font-size: 1.2rem;
}

.btn-list > button, .btn-list > a {
  margin: 0 0.375rem 0.375rem 0;
}

[dir=rtl] .btn-list button,
[dir=rtl] .btn-list div,
[dir=rtl] .btn-list a,
[dir=rtl] .btn-list input {
  margin: 0 0 0.375rem 0.375rem;
}

.btn-list {
  margin-block-end: -0.5rem;
}

.btn-square {
  border-radius: 0;
}

.btn-group-pill .btn:first-child {
  border-radius: 60px 0 0 60px;
}

.btn-group-pill .btn:last-child {
  border-radius: 0 60px 60px 0;
}

.btn-group-square .btn:first-child {
  border-radius: 0px 0 0 0px;
}

.btn-group-square .btn:last-child {
  border-radius: 0 0px 0px 0;
}

.btn.btn-primary-light {
  background-color: rgba(228, 31, 7, 0.1);
  color: #E41F07;
}
.btn.btn-primary-light:hover, .btn.btn-primary-light:focus, .btn.btn-primary-light:active {
  background-color: #E41F07;
  color: #FFF;
  border-color: #E41F07;
}
.btn.btn-secondary-light {
  background-color: rgba(255, 162, 1, 0.1);
  color: #FFA201;
}
.btn.btn-secondary-light:hover, .btn.btn-secondary-light:focus, .btn.btn-secondary-light:active {
  background-color: #FFA201;
  color: #FFF;
  border-color: #FFA201;
}
.btn.btn-warning-light {
  background-color: rgba(253, 167, 0, 0.1);
  color: #FDA700;
}
.btn.btn-warning-light:hover, .btn.btn-warning-light:focus, .btn.btn-warning-light:active {
  background-color: #FDA700;
  color: #FFF;
  border-color: #FDA700;
}
.btn.btn-info-light {
  background-color: rgba(30, 203, 226, 0.1);
  color: #1ECBE2;
}
.btn.btn-info-light:hover, .btn.btn-info-light:focus, .btn.btn-info-light:active {
  background-color: #1ECBE2;
  color: #FFF;
  border-color: #1ECBE2;
}
.btn.btn-success-light {
  background-color: rgba(92, 184, 92, 0.1);
  color: #5CB85C;
}
.btn.btn-success-light:hover, .btn.btn-success-light:focus, .btn.btn-success-light:active {
  background-color: #5CB85C;
  color: #FFF;
  border-color: #5CB85C;
}
.btn.btn-danger-light {
  background-color: rgba(252, 0, 39, 0.1);
  color: #FC0027;
}
.btn.btn-danger-light:hover, .btn.btn-danger-light:focus, .btn.btn-danger-light:active {
  background-color: #FC0027;
  color: #FFF;
  border-color: #FC0027;
}

.btn.btn-primary-ghost {
  background-color: transparent;
  color: #E41F07;
  border: 1px solid #E41F07;
}
.btn.btn-primary-ghost:active {
  color: #E41F07;
  border: 1px solid #E41F07;
  background-color: transparent;
}
.btn.btn-dark {
  background: #131022 !important;
  border-color: #131022 !important;
  box-shadow: none;
  color: #fff;
}
.btn.btn-dark:hover {
  background: #E41F07;
}
.btn.btn-secondary-ghost {
  background-color: transparent;
  color: #FFA201;
  border: 1px solid #FFA201;
}
.btn.btn-secondary-ghost:active {
  color: #FFA201;
  border: 1px solid #FFA201;
  background-color: transparent;
}
.btn.btn-warning-ghost {
  background-color: transparent;
  color: #FDA700;
  border: 1px solid #FDA700;
}
.btn.btn-warning-ghost:active {
  color: #FDA700;
  border: 1px solid #FDA700;
  background-color: transparent;
}
.btn.btn-info-ghost {
  background-color: transparent;
  color: #1ECBE2;
  border: 1px solid #1ECBE2;
}
.btn.btn-info-ghost:active {
  color: #1ECBE2;
  border: 1px solid #1ECBE2;
  background-color: transparent;
}
.btn.btn-success-ghost {
  background-color: transparent;
  color: #5CB85C;
  border: 1px solid #5CB85C;
}
.btn.btn-success-ghost:active {
  color: #5CB85C;
  border: 1px solid #5CB85C;
  background-color: transparent;
}
.btn.btn-danger-ghost {
  background-color: transparent;
  color: #FC0027;
  border: 1px solid #FC0027;
}
.btn.btn-danger-ghost:active {
  color: #FC0027;
  border: 1px solid #FC0027;
  background-color: transparent;
}

.btn-list button {
  margin: 0 0.375rem 0.375rem 0;
}

.btn-outline-primary {
  border: 1px solid #E41F07 !important;
  color: #E41F07 !important;
}
.btn-outline-primary:hover, .btn-outline-primary:focus, .btn-outline-primary.focus, .btn-outline-primary:active, .btn-outline-primary.active {
  background-color: #E41F07 !important;
  border: 1px solid #E41F07 !important;
  box-shadow: 0 3px 10px rgba(228, 31, 7, 0.5);
  color: #FFF !important;
}

.btn-outline-secondary {
  border: 1px solid #FFA201 !important;
  color: #FFA201 !important;
}
.btn-outline-secondary:hover, .btn-outline-secondary:focus, .btn-outline-secondary.focus, .btn-outline-secondary:active, .btn-outline-secondary.active {
  background-color: #FFA201 !important;
  border: 1px solid #FFA201 !important;
  box-shadow: 0 3px 10px rgba(255, 162, 1, 0.5);
  color: #FFF !important;
}

.btn-outline-success {
  border: 1px solid #5CB85C !important;
  color: #5CB85C !important;
}
.btn-outline-success:hover, .btn-outline-success:focus, .btn-outline-success.focus, .btn-outline-success:active, .btn-outline-success.active {
  background-color: #5CB85C !important;
  border: 1px solid #5CB85C !important;
  box-shadow: 0 3px 10px rgba(92, 184, 92, 0.5);
  color: #FFF !important;
}

.btn-outline-danger {
  border: 1px solid #FC0027 !important;
  color: #FC0027 !important;
}
.btn-outline-danger:hover, .btn-outline-danger:focus, .btn-outline-danger.focus, .btn-outline-danger:active, .btn-outline-danger.active {
  background-color: #FC0027 !important;
  border: 1px solid #FC0027 !important;
  box-shadow: 0 3px 10px rgba(252, 0, 39, 0.5);
  color: #FFF !important;
}

.btn-outline-warning {
  border: 1px solid #FDA700 !important;
  color: #FDA700 !important;
}
.btn-outline-warning:hover, .btn-outline-warning:focus, .btn-outline-warning.focus, .btn-outline-warning:active, .btn-outline-warning.active {
  background-color: #FDA700 !important;
  border: 1px solid #FDA700 !important;
  box-shadow: 0 3px 10px rgba(253, 167, 0, 0.5);
  color: #FFF !important;
}

.btn-outline-info {
  border: 1px solid #1ECBE2 !important;
  color: #1ECBE2 !important;
}
.btn-outline-info:hover, .btn-outline-info:focus, .btn-outline-info.focus, .btn-outline-info:active, .btn-outline-info.active {
  background-color: #1ECBE2 !important;
  border: 1px solid #1ECBE2 !important;
  box-shadow: 0 3px 10px rgba(30, 203, 226, 0.5);
  color: #FFF !important;
}

.btn-outline-light {
  border: 1px solid #FDFDFE;
  color: #323737 !important;
}
.btn-outline-light:hover, .btn-outline-light:focus, .btn-outline-light.focus, .btn-outline-light:active, .btn-outline-light.active {
  background-color: #FDFDFE;
  border: 1px solid #FDFDFE;
  color: #171724 !important;
}

.btn-outline-dark {
  border: 1px solid #171724 !important;
  color: #171724 !important;
}
.btn-outline-dark:hover, .btn-outline-dark:focus, .btn-outline-dark.focus, .btn-outline-dark:active, .btn-outline-dark.active {
  background-color: #171724 !important;
  border: 1px solid #171724 !important;
  box-shadow: 0 3px 10px rgba(23, 23, 36, 0.5);
  color: #FFF !important;
}

.btn-soft-primary {
  background-color: #F7BCB5 !important;
  color: #E41F07 !important;
}
.btn-soft-primary:hover, .btn-soft-primary:focus, .btn-soft-primary.focus, .btn-soft-primary:active, .btn-soft-primary.active {
  box-shadow: 0 3px 12px rgba(228, 31, 7, 0.2);
  border-color: #E41F07;
}

.btn-soft-secondary {
  background-color: #FFE3B3 !important;
  color: #FFA201 !important;
}
.btn-soft-secondary:hover, .btn-soft-secondary:focus, .btn-soft-secondary.focus, .btn-soft-secondary:active, .btn-soft-secondary.active {
  box-shadow: 0 3px 12px rgba(255, 162, 1, 0.2);
  border-color: #FFA201;
}

.btn-soft-success {
  background-color: #CEEACE !important;
  color: #5CB85C !important;
}
.btn-soft-success:hover, .btn-soft-success:focus, .btn-soft-success.focus, .btn-soft-success:active, .btn-soft-success.active {
  box-shadow: 0 3px 12px rgba(92, 184, 92, 0.2);
  border-color: #5CB85C;
}

.btn-soft-danger {
  background-color: #FEB3BE !important;
  color: #FC0027 !important;
}
.btn-soft-danger:hover, .btn-soft-danger:focus, .btn-soft-danger.focus, .btn-soft-danger:active, .btn-soft-danger.active {
  box-shadow: 0 3px 12px rgba(252, 0, 39, 0.2);
  border-color: #FC0027;
}

.btn-soft-warning {
  background-color: #FEE5B3 !important;
  color: #FDA700 !important;
}
.btn-soft-warning:hover, .btn-soft-warning:focus, .btn-soft-warning.focus, .btn-soft-warning:active, .btn-soft-warning.active {
  box-shadow: 0 3px 12px rgba(253, 167, 0, 0.2);
  border-color: #FDA700;
}

.btn-soft-info {
  background-color: rgba(30, 203, 226, 0.3) !important;
  color: #1ECBE2 !important;
}
.btn-soft-info:hover, .btn-soft-info:focus, .btn-soft-info.focus, .btn-soft-info:active, .btn-soft-info.active {
  box-shadow: 0 3px 12px rgba(30, 203, 226, 0.2);
  border-color: #1ECBE2;
}

.btn-soft-light {
  background-color: rgba(253, 253, 254, 0.9) !important;
  color: #6F6F6F !important;
}
.btn-soft-light:hover, .btn-soft-light:focus, .btn-soft-light.focus, .btn-soft-light:active, .btn-soft-light.active {
  box-shadow: 0 3px 12px rgba(253, 253, 254, 0.2);
  border-color: #FDFDFE;
  border-color: #6F6F6F;
}

.btn-soft-dark {
  background-color: rgba(23, 23, 36, 0.3) !important;
  color: #FFF !important;
}
.btn-soft-dark:hover, .btn-soft-dark:focus, .btn-soft-dark.focus, .btn-soft-dark:active, .btn-soft-dark.active {
  box-shadow: 0 3px 12px rgba(23, 23, 36, 0.2);
  border-color: #171724;
}

.custom-btn-close.btn-close {
  background-image: none;
  transition: 0.5s all;
}
.custom-btn-close.btn-close:hover {
  background: #FC0027;
  color: #FFF;
  border-color: #FC0027 !important;
  transition: 0.5s all;
  transform: rotateZ(360deg);
}

.modal .custom-btn-close.btn-close {
  background-image: none;
  transition: 0.5s all;
  width: auto !important;
  height: auto !important;
}
.modal .custom-btn-close.btn-close:hover {
  background: #FC0027 !important;
  color: #FFF !important;
  border-color: #FC0027 !important;
  transition: 0.5s all;
  transform: rotateZ(360deg);
}

.btn-purple-light {
  background-color: #F3EDFF;
  border-color: #F3EDFF;
  color: #4A00E5;
  font-size: 14px;
  font-weight: 500;
  border-radius: 5px;
  padding: 9px 20px;
  transition: all 0.2s ease;
  align-items: center;
  display: inline-flex;
}
@media (max-width: 991.98px) {
  .btn-purple-light {
    padding: 9px 14px;
  }
}

.btn-primary {
  background: #00918E;
  border: 1px solid #00918E;
  transition: all 0.2s ease;
  align-items: center;
  display: inline-flex;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.btn-primary:hover, .btn-primary:active {
  background: #c11a06;
  border-color: #c11a06;
  color: #FFF;
}
@media (max-width: 991.98px) {
  .btn-primary {
    min-width: auto;
  }
}

.badge.badge-primary {
  background: rgba(228, 31, 7, 0.1);
  box-shadow: 0 1px 1px rgba(228, 31, 7, 0.5);
  color: #E41F07;
}

.badge.badge-primary {
  background: #E41F07;
  box-shadow: 0 1px 1px rgba(228, 31, 7, 0.5);
  color: #FFF;
}
.badge.badge-soft-primary {
  background: rgba(228, 31, 7, 0.1);
  box-shadow: 0 1px 1px rgba(228, 31, 7, 0.5);
  color: #E41F07;
}

.badge.badge-secondary {
  background: #FFA201;
  box-shadow: 0 1px 1px rgba(255, 162, 1, 0.5);
  color: #FFF;
}
.badge.badge-soft-secondary {
  background: rgba(255, 162, 1, 0.1);
  box-shadow: 0 1px 1px rgba(255, 162, 1, 0.5);
  color: #FFA201;
}

.badge.badge-success {
  background: #5CB85C;
  box-shadow: 0 1px 1px rgba(92, 184, 92, 0.5);
  color: #FFF;
}
.badge.badge-soft-success {
  background: rgba(92, 184, 92, 0.1);
  box-shadow: 0 1px 1px rgba(92, 184, 92, 0.5);
  color: #5CB85C;
}

.badge.badge-info {
  background: #1ECBE2;
  box-shadow: 0 1px 1px rgba(30, 203, 226, 0.5);
  color: #FFF;
}
.badge.badge-soft-info {
  background: rgba(30, 203, 226, 0.1);
  box-shadow: 0 1px 1px rgba(30, 203, 226, 0.5);
  color: #1ECBE2;
}

.badge.badge-warning {
  background: #FDA700;
  box-shadow: 0 1px 1px rgba(253, 167, 0, 0.5);
  color: #FFF;
}
.badge.badge-soft-warning {
  background: rgba(253, 167, 0, 0.1);
  box-shadow: 0 1px 1px rgba(253, 167, 0, 0.5);
  color: #FDA700;
}

.badge.badge-danger {
  background: #FC0027;
  box-shadow: 0 1px 1px rgba(252, 0, 39, 0.5);
  color: #FFF;
}
.badge.badge-soft-danger {
  background: rgba(252, 0, 39, 0.1);
  box-shadow: 0 1px 1px rgba(252, 0, 39, 0.5);
  color: #FC0027;
}

.badge.badge-dark {
  background: #171724;
  box-shadow: 0 1px 1px rgba(23, 23, 36, 0.5);
  color: #FFF;
}
.badge.badge-soft-dark {
  background: rgba(23, 23, 36, 0.1);
  box-shadow: 0 1px 1px rgba(23, 23, 36, 0.5);
  color: #171724;
}

.badge.badge-light {
  background: #FDFDFE;
  box-shadow: 0 1px 1px rgba(253, 253, 254, 0.5);
  color: #FFF;
}
.badge.badge-soft-light {
  background: rgba(253, 253, 254, 0.1);
  box-shadow: 0 1px 1px rgba(253, 253, 254, 0.5);
  color: #FDFDFE;
}

.badge.badge-black {
  background: #000;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.5);
  color: #FFF;
}
.badge.badge-soft-black {
  background: rgba(0, 0, 0, 0.1);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.5);
  color: #000;
}

.badge.badge-purple {
  background: #4A00E5;
  box-shadow: 0 1px 1px rgba(74, 0, 229, 0.5);
  color: #FFF;
}
.badge.badge-soft-purple {
  background: rgba(74, 0, 229, 0.1);
  box-shadow: 0 1px 1px rgba(74, 0, 229, 0.5);
  color: #4A00E5;
}

.badge.badge-yellow {
  background: #ffff00;
  box-shadow: 0 1px 1px rgba(255, 255, 0, 0.5);
  color: #FFF;
}
.badge.badge-soft-yellow {
  background: rgba(255, 255, 0, 0.1);
  box-shadow: 0 1px 1px rgba(255, 255, 0, 0.5);
  color: #ffff00;
}

.badge.badge-teal {
  background: #02a8b5;
  box-shadow: 0 1px 1px rgba(2, 168, 181, 0.5);
  color: #FFF;
}
.badge.badge-soft-teal {
  background: rgba(2, 168, 181, 0.1);
  box-shadow: 0 1px 1px rgba(2, 168, 181, 0.5);
  color: #02a8b5;
}

.badge {
  padding: 0.25rem 0.45rem;
  text-transform: capitalize;
  font-weight: 600;
  letter-spacing: 0.5px;
  border-radius: 4px;
  color: #262A2A;
}
.badge.badge-xs {
  font-size: 10px;
  padding: 0px 5px;
  line-height: 18px;
}
.badge.badge-sm {
  font-size: 11px;
  padding: 5px 8px;
  line-height: 11px;
}
.badge.badge-md {
  font-size: 12px;
  padding: 5px 12px;
  line-height: 1.5;
}
.badge.badge-lg {
  font-size: 14px;
  padding: 0px 10px;
  line-height: 30px;
}
.badge.badge-xl {
  font-size: 16px;
  padding: 0px 15px;
  line-height: 35px;
}

.badge-soft-purple {
  background: #F3EDFF;
  color: #4A00E5;
}

.bg-light-danger {
  background-color: #FFEEEC !important;
}
.bg-light-danger .badge-dots {
  background-color: #FC1A3D;
}

.bg-light-success {
  background-color: #EFF8EF !important;
}
.bg-light-success .badge-dots {
  background-color: #6CBF6C;
}

.bg-light-info {
  background-color: #E9FAFC !important;
}
.bg-light-info .badge-dots {
  background-color: #35D0E5;
}

.bg-light-warning {
  background-color: #FFF7D8 !important;
}
.bg-light-warning .badge-dots {
  background-color: #FDB01A;
}

.badge-danger-light {
  background-color: #FFEEEC !important;
  color: #FC1A3D;
}

.badge-pending {
  background: #676DFF !important;
  color: #FFF !important;
}

.badge-tertiary {
  background: #3C2371;
  color: #FFF;
}

.badge-status {
  border-radius: 5px;
  font-size: 12px;
  padding: 4px 8px;
  min-width: 64px;
  color: #FFF;
}

.badge-tag {
  border-radius: 5px;
  font-size: 12px;
  padding: 4px 4px;
  font-weight: 400;
}
.badge-tag.badge-success-light {
  background: #E0F5D7;
  color: #5CB85C;
}
.badge-tag.badge-warning-light {
  background: #FFF7D8;
  color: #FDA700;
}
.badge-tag.badge-purple-light {
  background: #F3EDFF;
  color: #4A00E5;
}
.badge-tag.badge-danger-light {
  background: #FFEEEC;
  color: #FC0027;
}

.border-container {
  display: inline-block;
  width: 5rem;
  height: 5rem;
  margin: 0.25rem;
  background-color: #FDFDFE;
}

.border {
  border: 1px solid #E8E8E8 !important;
}
.border.border-dashed {
  border-style: dashed !important;
}
.border.border-dotted {
  border-style: dotted !important;
}
.border.border-primary {
  border: 1px solid #E41F07 !important;
  opacity: 1;
}
.border.border-primary.border-opacity-10 {
  border-color: rgba(228, 31, 7, 0.1) !important;
}
.border.border-primary.border-opacity-25 {
  border-color: rgba(228, 31, 7, 0.25) !important;
}
.border.border-primary.border-opacity-50 {
  border-color: rgba(228, 31, 7, 0.5) !important;
}
.border.border-primary.border-opacity-75 {
  border-color: rgba(228, 31, 7, 0.75) !important;
}
.border.border-primary.border-opacity-100 {
  border-color: #e41f07 !important;
}
.border.border-secondary {
  border: 1px solid #FFA201 !important;
  opacity: 1;
}
.border.border-secondary.border-opacity-10 {
  border-color: rgba(255, 162, 1, 0.1) !important;
}
.border.border-secondary.border-opacity-25 {
  border-color: rgba(255, 162, 1, 0.25) !important;
}
.border.border-secondary.border-opacity-50 {
  border-color: rgba(255, 162, 1, 0.5) !important;
}
.border.border-secondary.border-opacity-75 {
  border-color: rgba(255, 162, 1, 0.75) !important;
}
.border.border-secondary.border-opacity-100 {
  border-color: #ffa201 !important;
}
.border.border-info {
  border: 1px solid #1ECBE2 !important;
  opacity: 1;
}
.border.border-info.border-opacity-10 {
  border-color: rgba(30, 203, 226, 0.1) !important;
}
.border.border-info.border-opacity-25 {
  border-color: rgba(30, 203, 226, 0.25) !important;
}
.border.border-info.border-opacity-50 {
  border-color: rgba(30, 203, 226, 0.5) !important;
}
.border.border-info.border-opacity-75 {
  border-color: rgba(30, 203, 226, 0.75) !important;
}
.border.border-info.border-opacity-100 {
  border-color: #1ecbe2 !important;
}
.border.border-success {
  border: 1px solid #5CB85C !important;
  opacity: 1;
}
.border.border-success.border-opacity-10 {
  border-color: rgba(92, 184, 92, 0.1) !important;
}
.border.border-success.border-opacity-25 {
  border-color: rgba(92, 184, 92, 0.25) !important;
}
.border.border-success.border-opacity-50 {
  border-color: rgba(92, 184, 92, 0.5) !important;
}
.border.border-success.border-opacity-75 {
  border-color: rgba(92, 184, 92, 0.75) !important;
}
.border.border-success.border-opacity-100 {
  border-color: #5cb85c !important;
}
.border.border-warning {
  border: 1px solid #FDA700 !important;
  opacity: 1;
}
.border.border-warning.border-opacity-10 {
  border-color: rgba(253, 167, 0, 0.1) !important;
}
.border.border-warning.border-opacity-25 {
  border-color: rgba(253, 167, 0, 0.25) !important;
}
.border.border-warning.border-opacity-50 {
  border-color: rgba(253, 167, 0, 0.5) !important;
}
.border.border-warning.border-opacity-75 {
  border-color: rgba(253, 167, 0, 0.75) !important;
}
.border.border-warning.border-opacity-100 {
  border-color: #fda700 !important;
}
.border.border-danger {
  border: 1px solid #FC0027 !important;
  opacity: 1;
}
.border.border-danger.border-opacity-10 {
  border-color: rgba(252, 0, 39, 0.1) !important;
}
.border.border-danger.border-opacity-25 {
  border-color: rgba(252, 0, 39, 0.25) !important;
}
.border.border-danger.border-opacity-50 {
  border-color: rgba(252, 0, 39, 0.5) !important;
}
.border.border-danger.border-opacity-75 {
  border-color: rgba(252, 0, 39, 0.75) !important;
}
.border.border-danger.border-opacity-100 {
  border-color: #fc0027 !important;
}
.border.border-white {
  border: 1px solid #FFF !important;
  opacity: 1;
}
.border.border-white.border-opacity-10 {
  border-color: rgba(255, 255, 255, 0.1) !important;
}
.border.border-white.border-opacity-25 {
  border-color: rgba(255, 255, 255, 0.25) !important;
}
.border.border-white.border-opacity-50 {
  border-color: rgba(255, 255, 255, 0.5) !important;
}
.border.border-white.border-opacity-75 {
  border-color: rgba(255, 255, 255, 0.75) !important;
}
.border.border-white.border-opacity-100 {
  border-color: white !important;
}
.border.border-light {
  border: 1px solid #FDFDFE !important;
  opacity: 1;
}
.border.border-light.border-opacity-10 {
  border-color: rgba(253, 253, 254, 0.1) !important;
}
.border.border-light.border-opacity-25 {
  border-color: rgba(253, 253, 254, 0.25) !important;
}
.border.border-light.border-opacity-50 {
  border-color: rgba(253, 253, 254, 0.5) !important;
}
.border.border-light.border-opacity-75 {
  border-color: rgba(253, 253, 254, 0.75) !important;
}
.border.border-light.border-opacity-100 {
  border-color: #fdfdfe !important;
}
.border.border-dark {
  border: 1px solid #171724 !important;
  opacity: 1;
}
.border.border-dark.border-opacity-10 {
  border-color: rgba(23, 23, 36, 0.1) !important;
}
.border.border-dark.border-opacity-25 {
  border-color: rgba(23, 23, 36, 0.25) !important;
}
.border.border-dark.border-opacity-50 {
  border-color: rgba(23, 23, 36, 0.5) !important;
}
.border.border-dark.border-opacity-75 {
  border-color: rgba(23, 23, 36, 0.75) !important;
}
.border.border-dark.border-opacity-100 {
  border-color: #171724 !important;
}
.border.border-orange {
  border: 1px solid #FF9D0A !important;
  opacity: 1;
}
.border.border-orange.border-opacity-10 {
  border-color: rgba(255, 157, 10, 0.1) !important;
}
.border.border-orange.border-opacity-25 {
  border-color: rgba(255, 157, 10, 0.25) !important;
}
.border.border-orange.border-opacity-50 {
  border-color: rgba(255, 157, 10, 0.5) !important;
}
.border.border-orange.border-opacity-75 {
  border-color: rgba(255, 157, 10, 0.75) !important;
}
.border.border-orange.border-opacity-100 {
  border-color: #ff9d0a !important;
}
.border.border-opacity-10 {
  --bs-border-opacity: 0.1 !important;
}
.border.border-opacity-25 {
  --bs-border-opacity: 0.25 !important;
}
.border.border-opacity-50 {
  --bs-border-opacity: 0.5 !important;
}
.border.border-opacity-75 {
  --bs-border-opacity: 0.75 !important;
}
.border.border-opacity-100 {
  --bs-border-opacity: 1 !important;
}
.border.border-1 {
  border-width: 1px !important;
}
.border.border-2 {
  border-width: 2px !important;
}
.border.border-3 {
  border-width: 3px !important;
}
.border.border-4 {
  border-width: 4px !important;
}
.border.border-5 {
  border-width: 5px !important;
}
.border.border-block-start-dashed {
  border-top-style: dashed;
}
.border.border-block-start-dotted {
  border-top-style: dotted;
}
.border.border-inline-end-dashed {
  border-inline-end-style: dashed;
}
.border.border-inline-end-dotted {
  border-inline-end-style: dotted;
}
.border.border-block-end-dashed {
  border-bottom-style: dashed;
}
.border.border-block-end-dotted {
  border-bottom-style: dotted;
}
.border.border-inline-start-dashed {
  border-inline-start-style: dashed;
}
.border.border-inline-start-dotted {
  border-inline-start-style: dotted;
}
.border.border-0 {
  border: 0 !important;
}
.border.border-top-0 {
  border-block-start: 0 !important;
}
.border.border-end-0 {
  border-inline-end: 0 !important;
}
.border.border-bottom-0 {
  border-block-end: 0 !important;
}
.border.border-start-0 {
  border-inline-start: 0 !important;
}

.border-top {
  border-top: 1px solid #E8E8E8 !important;
}
.border-top.border-block-start-dashed {
  border-top-style: dashed !important;
}
.border-top.border-block-start-dotted {
  border-top-style: dotted !important;
}
.border-top.border-primary {
  border-color: #E41F07 !important;
}
.border-top.border-secondary {
  border-color: #FFA201 !important;
}
.border-top.border-warning {
  border-color: #FDA700 !important;
}
.border-top.border-info {
  border-color: #1ECBE2 !important;
}
.border-top.border-success {
  border-color: #5CB85C !important;
}
.border-top.border-danger {
  border-color: #FC0027 !important;
}
.border-top.border-light {
  border-color: #FDFDFE !important;
}
.border-top.border-dark {
  border-color: #171724 !important;
}

.border-end {
  border-inline-end: 1px solid #E8E8E8 !important;
}
.border-end.border-inline-end-dashed {
  border-inline-end-style: dashed !important;
}
.border-end.border-inline-end-dotted {
  border-inline-end-style: dotted !important;
}
.border-end.border-primary {
  border-color: #E41F07 !important;
}
.border-end.border-secondary {
  border-color: #FFA201 !important;
}
.border-end.border-warning {
  border-color: #FDA700 !important;
}
.border-end.border-info {
  border-color: #1ECBE2 !important;
}
.border-end.border-success {
  border-color: #5CB85C !important;
}
.border-end.border-danger {
  border-color: #FC0027 !important;
}
.border-end.border-light {
  border-color: #FDFDFE !important;
}
.border-end.border-dark {
  border-color: #171724 !important;
}

.border-bottom {
  border-bottom: 1px solid #E8E8E8 !important;
}
.border-bottom.border-block-end-dashed {
  border-bottom-style: dashed !important;
}
.border-bottom.border-block-end-dotted {
  border-bottom-style: dotted !important;
}
.border-bottom.border-primary {
  border-color: #E41F07 !important;
}
.border-bottom.border-secondary {
  border-color: #FFA201 !important;
}
.border-bottom.border-warning {
  border-color: #FDA700 !important;
}
.border-bottom.border-info {
  border-color: #1ECBE2 !important;
}
.border-bottom.border-success {
  border-color: #5CB85C !important;
}
.border-bottom.border-danger {
  border-color: #FC0027 !important;
}
.border-bottom.border-light {
  border-color: #FDFDFE !important;
}
.border-bottom.border-dark {
  border-color: #171724 !important;
}

.border-start {
  border-inline-start: 1px solid #E8E8E8 !important;
}
.border-start.border-inline-start-dashed {
  border-inline-start-style: dashed !important;
}
.border-start.border-inline-start-dotted {
  border-inline-start-style: dotted !important;
}
.border-start.border-primary {
  border-color: #E41F07 !important;
}
.border-start.border-secondary {
  border-color: #FFA201 !important;
}
.border-start.border-warning {
  border-color: #FDA700 !important;
}
.border-start.border-info {
  border-color: #1ECBE2 !important;
}
.border-start.border-success {
  border-color: #5CB85C !important;
}
.border-start.border-danger {
  border-color: #FC0027 !important;
}
.border-start.border-light {
  border-color: #FDFDFE !important;
}
.border-start.border-dark {
  border-color: #171724 !important;
}

.br-1 {
  border-radius: 0.0625rem;
}

.br-2 {
  border-radius: 0.125rem;
}

.br-3 {
  border-radius: 0.1875rem;
}

.br-4 {
  border-radius: 0.25rem;
}

.br-5 {
  border-radius: 0.3125rem;
}

.br-6 {
  border-radius: 0.375rem;
}

.br-7 {
  border-radius: 0.4375rem;
}

.br-8 {
  border-radius: 0.5rem;
}

.br-9 {
  border-radius: 0.5625rem;
}

.br-10 {
  border-radius: 0.625rem;
}

.br-15 {
  border-radius: 0.9375rem;
}

.br-20 {
  border-radius: 1.25rem;
}

.rounded {
  border-radius: 4px !important;
}

.calendar-events {
  border: 1px solid transparent;
  cursor: move;
  padding: 10px 15px;
}

.calendar-events:hover {
  border-color: #898989;
  background-color: #FFF;
}

.calendar-events i {
  margin-right: 8px;
}

.calendar {
  float: left;
  margin-bottom: 0;
}

.fc-toolbar.fc-header-toolbar {
  margin-bottom: 1.5rem;
}

.none-border .modal-footer {
  border-top: none;
}

.fc-toolbar h2 {
  font-size: 18px;
  font-weight: 600;
  font-family: "Roboto", sans-serif;
  line-height: 30px;
  text-transform: uppercase;
}

.fc-day-grid-event .fc-time {
  font-family: "Roboto", sans-serif;
}

.fc-day {
  background: #FFF;
}

.fc-toolbar .fc-state-active,
.fc-toolbar .ui-state-active,
.fc-toolbar button:focus,
.fc-toolbar button:hover,
.fc-toolbar .ui-state-hover {
  z-index: 0;
}

.fc th.fc-widget-header {
  background: #F6F6F6;
  font-size: 14px;
  line-height: 20px;
  padding: 10px 0;
  text-transform: uppercase;
}

.fc-unthemed th,
.fc-unthemed td,
.fc-unthemed thead,
.fc-unthemed tbody,
.fc-unthemed .fc-divider,
.fc-unthemed .fc-row,
.fc-unthemed .fc-popover {
  border-color: #f3f3f3;
}

.fc-basic-view .fc-day-number,
.fc-basic-view .fc-week-number {
  padding: 2px 5px;
}

.fc-button {
  background: #f1f1f1;
  border: none;
  color: #797979;
  text-transform: capitalize;
  box-shadow: none !important;
  border-radius: 3px !important;
  margin: 0 3px !important;
  padding: 6px 12px !important;
  height: auto !important;
}

.fc-text-arrow {
  font-family: inherit;
  font-size: 16px;
}

.fc-state-hover {
  background: #f3f3f3;
}

.fc-state-highlight {
  background: #f0f0f0;
}

.fc-state-down,
.fc-state-active,
.fc-state-disabled {
  background-color: #E41F07 !important;
  color: #FFF !important;
  text-shadow: none !important;
}

.fc-cell-overlay {
  background: #f0f0f0;
}

.fc-unthemed .fc-today {
  background: #FFF;
}

.fc-event {
  border-radius: 2px;
  border: none;
  color: #FFF !important;
  cursor: move;
  font-size: 13px;
  margin: 1px 7px;
  padding: 5px 5px;
  text-align: center;
}

.fc-basic-view td.fc-week-number span {
  padding-right: 8px;
  font-weight: 700;
  font-family: "Roboto", sans-serif;
}

.fc-basic-view td.fc-day-number {
  padding-right: 8px;
  font-weight: 700;
  font-family: "Roboto", sans-serif;
}

.event-form .input-group .form-control {
  height: 40px;
}

.submit-section {
  text-align: center;
  margin-top: 40px;
}

.submit-btn {
  border-radius: 50px;
  font-size: 18px;
  font-weight: 600;
  min-width: 200px;
  padding: 10px 20px;
}

.apexcharts-legend.apexcharts-align-center.position-right {
  display: none;
}

.apexcharts-toolbar {
  display: none !important;
}

#sales_charts,
.chart-set {
  overflow: hidden;
}

.apexcharts-canvas {
  width: 100% !important;
}

.h-250 {
  height: 250px;
}

.chat-user-actives .call-meet-blk {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  background: #FFF;
  border-radius: 5px;
  margin-bottom: 15px;
  padding: 10px;
  transition: all 0.5s ease;
}
.chat-user-actives .call-meet-blk:hover {
  background-color: #000;
  transition: all 0.5s ease;
}
.chat-user-actives .call-meet-blk .meet-border {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  width: 39px;
  height: 39px;
  background: #FFF;
  border: 0.5px solid #898989;
  border-radius: 10px;
  margin-right: 10px;
}
.chat-user-actives .call-meet-blk .meet-border svg {
  width: 16px;
  color: #339DFF;
}
.chat-user-actives .call-meet-blk .recent-user-titles h5 {
  font-size: 14px;
  font-weight: 600;
  color: #000;
  margin-bottom: 5px;
  width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.chat-user-actives .call-meet-blk .recent-user-titles p {
  font-size: 10px;
  color: #6F6F6F;
}

.new-join-link .chat-user-actives .meet-border {
  background: gray;
  border: 0;
  border-radius: 6px;
}
.new-join-link .chat-user-actives .meet-border:hover {
  background: #E41F07;
}
.new-join-link .chat-user-actives .meet-border:hover svg {
  color: #FFF;
}
.new-join-link .chat-user-actives .meet-border svg {
  color: #E41F07;
}
.new-join-link .chat-user-actives .recent-user-titles h5 {
  color: #E41F07;
  width: 100%;
  margin-bottom: 0;
  font-size: 15px;
}

.meet-chat-blk .join-call .join-video {
  position: relative;
  margin-bottom: 25px;
}
.meet-chat-blk .join-call .join-video img {
  border-radius: 10px;
}
.meet-chat-blk .join-call .join-video .video-avatar {
  color: #FFF;
  background: #5D5D5D;
  font-size: 50px;
  border-radius: 10px;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: none;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.meet-chat-blk .join-call .join-video .video-avatar.active {
  display: flex;
  position: relative;
  height: 426px;
}
.meet-chat-blk .join-call .join-video .call-icons {
  text-align: center;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
}
.meet-chat-blk .join-call .join-video .call-icons .call-items {
  border-radius: 5px;
  padding: 0;
  margin: 0;
  list-style: none;
  display: inline-flex;
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translate(-50%, 0);
}
.meet-chat-blk .join-call .join-video .call-icons .call-items .call-item {
  display: inline-block;
  text-align: center;
  margin-right: 15px;
}
.meet-chat-blk .join-call .join-video .call-icons .call-items .call-item:last-child {
  margin-right: 0px;
}
.meet-chat-blk .join-call .join-video .call-icons .call-items .call-item a {
  color: #FFF;
  background: #FFF;
  border-radius: 10px;
  width: 54px;
  height: 54px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  font-size: 20px;
  white-space: nowrap;
}
@media (max-width: 767.98px) {
  .meet-chat-blk .join-call .join-video .call-icons .call-items .call-item a {
    width: 45px;
    height: 45px;
  }
}
.meet-chat-blk .join-call .join-video .call-icons .call-items .call-item a i {
  color: #6F6F6F;
}
.meet-chat-blk .join-call .join-video .call-icons .call-items .call-item a.stop {
  color: #FFF;
  background: #FC0027;
}
.meet-chat-blk .join-call .join-video .call-icons .call-items .call-item a.stop i {
  color: #FFF;
}
.meet-chat-blk .join-call .join-video .meet-drop ul li i {
  font-size: 18px;
}
.meet-chat-blk .join-call .join-content {
  text-align: center;
  max-width: 500px;
  margin: auto;
}
.meet-chat-blk .join-call .join-content h4 {
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 20px;
}
@media (max-width: 767.98px) {
  .meet-chat-blk .join-call .join-content h4 {
    font-size: 18px;
  }
}
.meet-chat-blk .join-call .join-content .event-user-group {
  margin-bottom: 10px;
}
.meet-chat-blk .join-call .join-content .event-user-group .avatar-group .avatar {
  width: 38px;
  height: 38px;
  border: 3px solid #FFF;
}
.meet-chat-blk .join-call .join-content .event-user-group .avatar-group .avatar + .avatar {
  margin-left: -20px;
}
.meet-chat-blk .join-call .join-content .event-user-group .avatar-group .avatar .avatar-title {
  color: #000;
  font-size: 14px;
  font-weight: 600;
  background: gray;
}
.meet-chat-blk .join-call .join-content p {
  font-size: 13px;
  color: #6F6F6F;
}
.meet-chat-blk .join-call .join-content .btn-join-call .btn-primary {
  background: #E41F07;
  border-radius: 6px 6px 6px 6px;
  color: #FFF;
  font-size: 14px;
  border: 1px solid #E41F07;
  font-weight: 600;
  min-width: 105px;
  padding: 8px 15px;
}
.meet-chat-blk .join-call .join-content .btn-join-call .btn-primary:hover {
  background: #FC0027;
  border: 1px solid gray;
  color: #E41F07;
}

.conference-meet-group {
  display: flex;
}
.conference-meet-group .meeting-list {
  width: 100%;
  transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
}
.conference-meet-group .meeting-list.add-meeting {
  width: 65%;
  margin-right: 24px;
}
@media (max-width: 767.98px) {
  .conference-meet-group .meeting-list.add-meeting {
    display: none;
    margin-right: 0px;
  }
}
.conference-meet-group .right-user-side {
  width: 0;
  opacity: 0;
  transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
}
.conference-meet-group .right-user-side.right-side-party {
  width: 0;
  opacity: 0;
  transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
}
.conference-meet-group .right-user-side.right-side-party .party-msg-blk .last-call-time .call-recent {
  background: none;
}
.conference-meet-group .right-user-side.right-side-party .party-msg-blk .last-call-time .call-recent svg {
  color: #E41F07;
  width: 14px;
}
.conference-meet-group .right-user-side.chat-rooms {
  width: 0;
  opacity: 0;
  transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
}
.conference-meet-group .right-user-side.chat-rooms .slime-grp {
  padding: 0;
}
.conference-meet-group .right-user-side.chat-rooms .slime-grp .left-chat-title {
  padding: 20px;
  border-bottom: 1px solid #E1E8ED;
  border-radius: 10px 10px 0 0;
}
.conference-meet-group .right-user-side.chat-rooms.open-chats {
  width: 35%;
  opacity: 1;
}
@media (max-width: 767.98px) {
  .conference-meet-group .right-user-side.chat-rooms.open-chats {
    width: 100%;
  }
}
.conference-meet-group .right-user-side.open-message {
  width: 35%;
  opacity: 1;
}
@media (max-width: 767.98px) {
  .conference-meet-group .right-user-side.open-message {
    width: 100%;
  }
}

.meet-drop {
  background: rgba(255, 255, 255, 0.6);
  border-radius: 10px;
  position: absolute;
  top: 20px;
  right: 20px;
}
.meet-drop ul li .chats-dot a {
  width: 50px;
  height: 50px;
  color: #6B7280;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
@media (max-width: 767.98px) {
  .meet-drop ul li .chats-dot a {
    width: 38px;
    height: 38px;
  }
}
.meet-drop.meet-mutes {
  background: #E41F07;
  right: inherit;
  left: 20px;
}
.meet-drop.meet-mutes ul li a {
  color: #FFF;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
@media (max-width: 767.98px) {
  .meet-drop.meet-mutes ul li a {
    width: 38px;
    height: 38px;
  }
}
.meet-drop.meet-mutes-bottom {
  background: #E41F07;
  bottom: 20px;
  border-radius: 50px;
  top: inherit;
}
.meet-drop.meet-mutes-bottom ul li a {
  color: #FFF;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
@media (max-width: 767.98px) {
  .meet-drop.meet-mutes-bottom ul li a {
    width: 38px;
    height: 38px;
  }
}
.meet-drop.meet-mutes-bottom ul li a i {
  font-size: 20px;
}

.meet-call-menu-blk .video-call-action {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
@media (max-width: 767.98px) {
  .meet-call-menu-blk .video-call-action {
    display: block;
  }
}
.meet-call-menu-blk .video-call-action ul {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.meet-call-menu-blk .video-call-action ul li {
  margin-right: 5px;
}
.meet-call-menu-blk .video-call-action ul li:last-child {
  margin-right: 0;
}
.meet-call-menu-blk .video-call-action ul li a {
  width: 40px;
  height: 40px;
  border-radius: 50px;
  background: #D9D9D9;
  border: 1px solid #D9D9D9;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #000;
  font-size: 18px;
}
.meet-call-menu-blk .video-call-action ul li a.call-end {
  background-color: #FC0027;
  border-color: #FC0027;
  color: #FFF;
  width: 60px;
  height: 60px;
  rotate: 135deg;
  font-size: 20px;
}
.meet-call-menu-blk .video-call-action ul li a.stop {
  color: #FFF;
  background: #FC0027;
  border-color: #FC0027;
}
.meet-call-menu-blk .video-call-action ul li a.stop i {
  color: #FFF;
}
.meet-call-menu-blk .video-call-action ul li.active a {
  background: #E41F07;
  border-color: #E41F07;
  color: #FFF;
}
.meet-call-menu-blk .video-call-action ul li.active a img {
  filter: invert(1) brightness(100);
}
@media (max-width: 767.98px) {
  .meet-call-menu-blk .video-call-action ul {
    margin-bottom: 5px;
    justify-content: center;
  }
}
@media (max-width: 767.98px) {
  .meet-call-menu-blk .video-call-action ul:last-child {
    margin-bottom: 0px;
  }
}

.recession-meet-blk {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-bottom: 30px;
}
@media (max-width: 767.98px) {
  .recession-meet-blk {
    display: block;
  }
}
@media (max-width: 767.98px) {
  .recession-meet-blk .reccession-head {
    margin-bottom: 5px;
  }
}
.recession-meet-blk .reccession-head h5 {
  font-size: 20px;
  font-weight: 700;
  color: #262A2A;
  margin-bottom: 0px;
}
@media (max-width: 767.98px) {
  .recession-meet-blk .reccession-head h5 {
    font-size: 18px;
  }
}
.recession-meet-blk .reccession-head ul li {
  font-size: 15px;
  font-weight: 400;
  color: #6F6F6F;
  margin-right: 25px;
}
.recession-meet-blk .reccession-head ul li:last-child {
  margin-right: 0px;
}
@media (max-width: 767.98px) {
  .recession-meet-blk .reccession-head ul li {
    margin-bottom: 10px;
  }
}
.recession-meet-blk .partispant-blk {
  display: flex;
}
.recession-meet-blk .partispant-blk .btn-primary {
  background: #1b2950;
  border-radius: 6px;
  color: #FFF;
  border: 1px solid #1b2950;
  margin-right: 10px;
  font-weight: 700;
  font-size: 14px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.recession-meet-blk .partispant-blk .btn-primary:hover {
  background: #E41F07;
  border: 1px solid #E41F07;
}
@media (max-width: 767.98px) {
  .recession-meet-blk .partispant-blk .btn-primary {
    font-size: 13px;
  }
}
.recession-meet-blk .partispant-blk .btn-primary:last-child {
  margin-right: 0;
}
.recession-meet-blk .partispant-blk span a {
  width: 42px;
  height: 42px;
  background: #E8E8E8;
  border-radius: 5px;
  color: #6F6F6F;
  font-size: 18px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.recession-meet-blk .partispant-blk span a:hover {
  background: #E41F07;
  color: #FFF;
}

.recording-time {
  position: relative;
  padding-left: 20px;
}
.recording-time::before {
  content: "";
  position: absolute;
  left: 0px;
  top: 4px;
  background-color: #FC0027;
  width: 13px;
  height: 13px;
  border-radius: 50px;
}
.recording-time::after {
  content: "";
  position: absolute;
  left: 3px;
  top: 7px;
  background-color: #FFF;
  width: 7px;
  height: 7px;
  border-radius: 50px;
  animation: blink-animation 1.5s steps(5, start) infinite;
  -webkit-animation: blink-animation 1.5s steps(5, start) infinite;
}

.page-content {
  width: 100%;
}

.join-call {
  width: 100%;
  margin: 0 auto;
}

.join-video {
  position: relative;
  margin-bottom: 25px;
}
.join-video img {
  border-radius: 10px;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.join-video.join-video-front img {
  height: 423px;
}

.video-avatar {
  color: #FFF;
  background: #5D5D5D;
  font-size: 50px;
  border-radius: 10px;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: none;
  align-items: center;
  justify-content: center;
}
.video-avatar h4 {
  font-weight: 700;
  font-size: 24px;
  color: #FFF;
}

.video-avatar.active {
  display: flex;
}

.join-video.video-hide > img,
.video-wrap.video-hide > video {
  display: none;
}

.join-content p {
  font-weight: 400;
  font-size: 14px;
  margin-bottom: 25px;
  color: #000;
}
.join-content label {
  font-size: 18px;
  margin-bottom: 0;
  color: #000;
  font-weight: 700;
}

.part-name {
  position: absolute;
  top: 20px;
  left: 12px;
  text-align: left;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 50px;
  padding: 5px 15px;
}
.part-name h4 {
  font-weight: 500;
  font-size: 15px;
  color: #6F6F6F;
  margin-bottom: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
@media (max-width: 767.98px) {
  .part-name h4 {
    font-size: 13px;
  }
}
.part-name.sub-part-name {
  background: #FFF;
  bottom: 10px;
  top: inherit;
}
.part-name.sub-part-name h4 {
  color: #262A2A;
  font-size: 12px;
}

.grid-join .part-name {
  background: rgba(0, 0, 0, 0.3);
  top: inherit;
  bottom: 20px;
}
.grid-join .part-name h4 {
  color: #FFF;
}

.join-hover-img {
  position: absolute;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.join-hover-img .event-user-group .avatar-group {
  background: rgba(0, 0, 0, 0.3);
  padding: 2px 10px;
  border-radius: 50px;
}
.join-hover-img .event-user-group .avatar-group .avatar {
  width: 26px;
  height: 26px;
  border: 1px solid #FFF;
}
.join-hover-img .event-user-group .avatar-group .avatar + .avatar {
  margin-left: -16px;
}
.join-hover-img .event-user-group .avatar-group .avatar:last-child {
  margin-right: 0px;
}
.join-hover-img .event-user-group .avatar-group .avatar .avatar-title {
  color: #1F2937;
  font-size: 12px;
  font-weight: 600;
  background: #F3F4F6;
}

.more-icon {
  position: absolute;
  bottom: 10px;
  right: 12px;
}
@media (max-width: 767.98px) {
  .more-icon {
    bottom: 8px;
    right: 13px;
  }
}
.more-icon a {
  color: #6F6F6F;
  width: 30px;
  height: 30px;
  background: #FFF;
  border-radius: 50px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.more-icon a:hover {
  opacity: 0.8;
}
.more-icon a.other-mic-off.stop i {
  color: #FC0027;
}
.more-icon.audio-more-icon a.other-mic-off.stop {
  background-color: #FC0027 !important;
}
.more-icon.audio-more-icon a.other-mic-off.stop i {
  color: #FFF;
}

.call-recent.recent-part a.other-mic-off.stop, .call-recent.recent-part a.other-video-off.stop {
  background: #FC0027 !important;
}
.call-recent.recent-part a.other-mic-off.stop i, .call-recent.recent-part a.other-video-off.stop i {
  color: #FFF;
}

.meeting .part-name {
  top: 15px;
  left: 15px;
}
.meeting .more-icon {
  top: 15px;
  right: 15px;
  display: flex;
}

.vertical-view .vertical-sec .part-name h4 {
  font-size: 14px;
  font-weight: 400;
}

.horizontal-view .join-video.single-user .part-name h4 {
  font-size: 14px;
  font-weight: 400;
}

.meeting-wrapper, .meeting {
  width: inherit;
  max-width: inherit;
}

.meet-footer {
  position: fixed;
  bottom: 25px;
  width: 100%;
  max-width: 950px;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 3;
}

.show-chat-list, .show-invite-list,
.show-chat-list .user-sidebar-right,
.show-invite-list .invite-sidebar-right {
  transition: all 0.8s ease;
}

.user-sidebar-right, .invite-sidebar-right {
  background: #dedede;
  border-radius: 10px;
  width: 410px;
  position: absolute;
  top: 105px;
  bottom: 117px;
  right: 0;
  margin-right: -410px;
  transition: all 0.8s ease;
  overflow: hidden;
  font-size: 13px;
  z-index: 3;
}

.join-contents {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  box-sizing: border-box;
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
}
.join-contents.grid-view {
  align-content: center;
}

.ripple {
  width: 114px;
  height: 114px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.multigrid-view .text-box {
  height: 61px;
  width: 61px;
}

.multigrid-view .ripple {
  width: 80px;
  height: 80px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.meeting .join-video {
  margin: 0 5px 10px;
  width: 100%;
}

.join-video.user-active {
  background: #415B6A;
  border-radius: 10px;
  width: 100%;
  height: 370px;
}
.join-video.user-active.audio-calls {
  height: 520px;
}
.join-video.vertical-active {
  margin-right: 24px;
}
.join-video.single-user {
  width: 100%;
  min-height: 230px;
  box-sizing: border-box;
  margin-right: 24px;
  justify-content: space-between;
  text-align: center;
  height: auto;
  background: #415B6A;
  border-radius: 10px;
  padding: 0;
  flex-grow: 1;
}
@media (max-width: 1280px) {
  .join-video.single-user {
    width: 100%;
  }
}
@media (max-width: 1199.98px) {
  .join-video.single-user {
    min-height: 203px;
  }
}
@media (max-width: 991.98px) {
  .join-video.single-user {
    min-height: 230px;
  }
}
.join-video.single-user:nth-child(even) {
  margin-right: 0px;
}
@media (max-width: 767.98px) {
  .join-video.single-user:nth-child(even) {
    margin-right: 10px;
  }
}
@media (max-width: 767.98px) {
  .join-video.single-user {
    width: 100%;
    min-height: 257px;
  }
}

@media (max-width: 767.98px) {
  .multi-grid .join-video.single-user {
    width: 45%;
  }
}
.multi-grid .join-video.single-user:nth-child(even) {
  margin-right: 24px;
}
@media (max-width: 767.98px) {
  .multi-grid .join-video.single-user:nth-child(even) {
    margin-right: 0px;
  }
}
.multi-grid .join-video.single-user:nth-child(4n) {
  margin-right: 0px;
}
@media (max-width: 767.98px) {
  .multi-grid .join-video.single-user:nth-child(4n):nth-child(4n) {
    margin-right: 0px;
  }
}

.multigrid-view .join-video.single-user {
  flex-grow: 0;
}

.horizontal-view .join-video.single-user:nth-child(even) {
  margin-right: 24px;
}
.horizontal-view .join-video.single-user:nth-child(5) {
  margin-right: 0px;
}
@media (max-width: 767.98px) {
  .horizontal-view .join-video.single-user:nth-child(3n) {
    margin-right: 0;
  }
}

.text-avatar {
  color: #FFF;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.text-avatar h4 {
  color: #FFF;
}

.text-box {
  height: 86px;
  width: 86px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.2);
  font-size: 36px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.more-icon.mic-view .mic-on, .more-icon .mic-off {
  display: none;
}

.more-icon.mic-view .mic-off {
  display: inline-flex;
}

.grid-view .join-video.single-user {
  width: 47%;
}
@media (max-width: 767.98px) {
  .grid-view .join-video.single-user {
    width: 40%;
  }
}
@media (max-width: 767.98px) {
  .grid-view .join-video.single-user:nth-child(2n) {
    margin-right: 0px;
  }
}
@media (max-width: 767.98px) {
  .grid-view .join-video.single-user:nth-child(3n) {
    margin-right: 24px;
  }
}

.join-contents.multigrid-view {
  max-width: 100%;
  justify-content: center;
}

.meeting {
  position: absolute;
  top: 80px;
  bottom: 107px;
  left: 0;
  right: 0;
}

.meeting-list {
  flex-direction: column;
  height: 100%;
  width: 100%;
  position: relative;
}

.user-active .more-icon .handraise-on {
  display: none;
}
.user-active .more-icon .handraise-on.active {
  display: block;
  animation: mymove 5s;
}

.user-active .more-icon .handraise-on.active .meeting .join-video.user-active::before {
  animation: mymove 5s infinite;
  opacity: 1;
}

@keyframes mymove {
  from {
    color: #0074E0;
  }
  to {
    color: transparent;
  }
}
.join-contents.vertical-view {
  display: flex;
  align-items: center;
  align-content: center;
  max-width: 1300px;
}
@media (max-width: 767.98px) {
  .join-contents.vertical-view {
    display: block;
  }
}
.join-contents.vertical-view .join-video.user-active {
  flex: 1 1;
  margin-bottom: 24px;
}
.join-contents.vertical-view .join-video.single-user {
  width: 97%;
  flex-grow: 1;
  display: flex;
}
@media (max-width: 767.98px) {
  .join-contents.vertical-view .join-video.single-user {
    width: 100%;
  }
}
.join-contents.vertical-view .vertical-sec {
  width: 20%;
}
@media (max-width: 991.98px) {
  .join-contents.vertical-view .vertical-sec {
    width: 30%;
  }
}
@media (max-width: 767.98px) {
  .join-contents.vertical-view .vertical-sec {
    width: 100%;
  }
}
.join-contents.vertical {
  flex-direction: column;
  height: 200px;
}

.meeting .join-contents.vertical .join-video.user-active {
  flex: 1 0 100%;
}

.meeting .join-contents.vertical .join-video.single-user {
  flex: 0 1;
}

.meeting .join-contents.vertical .join-video {
  width: auto;
}

.chat-footer .btn:hover {
  background: #0066c5;
  color: #FFF;
}

.join-contents.show-whiteboard {
  display: none;
}
.join-contents.single-view {
  padding-top: 0;
  margin-top: 25px;
  position: relative;
}
.join-contents.single-view .single-user {
  position: absolute;
  right: 8px;
  top: 40px;
  width: 130px;
  height: 130px;
  min-height: 130px;
}
.join-contents.single-view .single-user img {
  height: 130px;
}

.record-time {
  position: absolute;
  top: 20px;
  z-index: 1;
  position: absolute;
  left: 20px;
}
.record-time span {
  background-color: rgba(255, 255, 255, 0.2);
  display: inline-block;
  border-radius: 130px;
  color: #FFF;
  font-size: 14px;
  font-weight: 600;
  width: 80px;
  height: 30px;
  text-align: center;
  line-height: 34px;
  position: relative;
  padding-left: 15px;
}
.record-time span:before {
  content: "";
  position: absolute;
  left: 7px;
  top: 7px;
  background-color: #FFF;
  width: 18px;
  height: 18px;
  border-radius: 50px;
}
.record-time span:after {
  content: "";
  position: absolute;
  left: 12px;
  top: 12px;
  background-color: #FC0027;
  width: 8px;
  height: 8px;
  border-radius: 50px;
  animation: blink-animation 1.5s steps(5, start) infinite;
  -webkit-animation: blink-animation 1.5s steps(5, start) infinite;
}

@keyframes blink-animation {
  to {
    visibility: hidden;
  }
}
.volume-col {
  position: absolute;
  left: 20px;
  bottom: 20px;
}

.volume-col .inner-volume-col {
  background-color: #898989;
  border-radius: 130px;
  width: 30px;
  height: 120px;
  position: relative;
  z-index: 9;
}

.volume-col #volume {
  position: absolute;
  left: 50%;
  top: 15px;
  margin: 0 auto;
  height: 80px;
  width: 5px;
  background: #FFF;
  border-radius: 15px;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
}

.volume-col #volume .ui-slider-range-min {
  height: 5px;
  width: 100%;
  position: absolute;
  bottom: 0;
  background: #E41F07;
  border: none;
  border-radius: 10px;
  outline: none;
}

.volume-col #volume .ui-slider-handle {
  width: 20px;
  height: 20px;
  border-radius: 20px;
  background: #E41F07;
  position: absolute;
  left: 50%;
  margin-top: -8px;
  cursor: pointer;
  outline: none;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
}

.volume-col #player {
  width: auto;
  height: 104px;
  position: relative;
  margin: 0 auto;
  top: 0px;
}

.volume-col #player i {
  position: absolute;
  margin-top: -6px;
  color: #666;
}

.volume-col .volume-icons {
  color: #FFF;
  margin-left: 0px;
  font-size: 18px;
  margin-top: 22px;
}

.chat-msg-blk {
  padding: 15px;
}
.chat-msg-blk .chats {
  max-width: 100%;
  margin-bottom: 1.5rem;
  display: flex;
  display: -webkit-flex;
}
@media (max-width: 767.98px) {
  .chat-msg-blk .chats {
    max-width: 100%;
  }
}
.chat-msg-blk .chats .chat-action-btns .chat-user-time .chats-dot a {
  color: #00918E;
}
.chat-msg-blk .chats.chats-right {
  margin-left: auto;
  flex-direction: row-reverse;
}
.chat-msg-blk .chats.chats-right .chat-content {
  order: 1;
  -webkit-order: 1;
}
.chat-msg-blk .chats.chats-right .chat-content .message-content {
  background-color: #E8E8E8;
  border-radius: 8px;
}
.chat-msg-blk .chats.chats-right .chat-content .message-content .chat-time {
  justify-content: flex-start;
  -webkit-justify-content: flex-start;
}
.chat-msg-blk .chats.chats-right .chat-content .message-content .download-col {
  position: relative;
}
.chat-msg-blk .chats.chats-right .chat-content .message-content .download-col ul li {
  margin-right: 8px;
}
.chat-msg-blk .chats.chats-right .chat-content .message-content .download-col ul li:last-child {
  margin-right: 0px;
}
.chat-msg-blk .chats.chats-right .chat-content .message-content .download-col ul li .image-download-col {
  position: relative;
}
.chat-msg-blk .chats.chats-right .chat-content .message-content .download-col ul li .image-download-col.image-not-download a img {
  filter: blur(1px);
  border-color: #000;
}
.chat-msg-blk .chats.chats-right .chat-content .message-content .download-col ul li .image-download-col.image-not-download span {
  position: absolute;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.chat-msg-blk .chats.chats-right .chat-content .message-content .download-col ul li .image-download-col.image-not-download span i {
  color: #FFF;
}
.chat-msg-blk .chats.chats-right .chat-content .message-content .download-col ul li .image-download-col .download-action {
  position: absolute;
  right: 8px;
  bottom: 8px;
  line-height: 0;
}
.chat-msg-blk .chats.chats-right .chat-content .message-content .download-col ul li .image-download-col .download-action a {
  color: #FFF;
  font-size: 10px;
}
.chat-msg-blk .chats.chats-right .chat-content .message-content .download-col ul li .image-download-col img {
  border-radius: 5px;
}
.chat-msg-blk .chats.chats-right .chat-content .message-content::before {
  border-bottom: 6px solid transparent;
  border-left: 6px solid #E8E8E8;
  border-right: 0;
  border-top: 6px solid transparent;
  content: "";
  height: 0;
  width: 0;
  position: absolute;
  top: 8px;
  right: -4px;
  left: auto;
}
.chat-msg-blk .chats.chats-right .chat-avatar {
  padding: 8px 0px 0 15px;
}
.chat-msg-blk .chats.chats-right .chat-action-btns {
  order: 2;
  -webkit-order: 2;
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  justify-content: center;
  -webkit-justify-content: center;
}
.chat-msg-blk .chats.chats-right .chat-action-btns .chat-user-time .chats-dot a {
  color: #00918E;
}
.chat-msg-blk .chats .chat-avatar {
  padding: 8px 15px 0 8px;
  display: flex;
  display: -webkit-flex;
  align-items: flex-start;
  -webkit-align-items: flex-start;
  flex-shrink: 0;
}
.chat-msg-blk .chats .chat-avatar .dreams_chat {
  width: 40px;
  height: 40px;
  object-fit: cover;
}
.chat-msg-blk .chats .message-content {
  background-color: #E8E8E8;
  border-radius: 8px;
  padding: 10px 20px;
  font-weight: 500;
  margin-bottom: 5px;
  position: relative;
}
.chat-msg-blk .chats .message-content h4 {
  font-size: 13px;
  color: #262A2A;
  margin-bottom: 0px;
  line-height: 1.4;
  font-weight: 500;
}
.chat-msg-blk .chats .message-content .chat-time {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  font-size: 10px;
  font-weight: 500;
  color: #00918E;
  margin-bottom: 0;
}
.chat-msg-blk .chats .message-content .chat-time svg {
  width: 10px;
}
.chat-msg-blk .chats .message-content::before {
  border-bottom: 6px solid transparent;
  border-right: 6px solid #E8E8E8;
  border-top: 6px solid transparent;
  content: "";
  height: 0;
  width: 0;
  position: absolute;
  top: 8px;
  left: -4px;
  right: auto;
}
.chat-msg-blk .chats .chat-profile-name h6 {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: left;
  -webkit-justify-content: left;
  -ms-flex-pack: left;
  font-size: 8px;
  font-weight: 500;
  color: #6F6F6F;
}
.chat-msg-blk .chats .chat-profile-name h6 i {
  font-size: 12px;
  color: #008024;
}
.chat-msg-blk .chat-line {
  margin: 0px 0 20px;
  position: relative;
  text-align: center;
  width: 100%;
}
.chat-msg-blk .chat-line:before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  background-color: #00918E;
  width: 100%;
  height: 1px;
}
.chat-msg-blk .chat-line .chat-date {
  background-color: #00918E;
  color: #00918E;
  font-size: 13px;
  padding: 7px 14px;
  border-radius: 3px;
  display: inline-block;
  font-weight: 600;
  position: relative;
}

.right-user-side.call-user-side .slime-grp .right-sidebar-profile {
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  border-bottom: 0;
  padding-bottom: 10px;
}
.right-user-side.call-user-side .slime-grp .right-sidebar-profile .profile-call-blk {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.right-user-side.call-user-side .slime-grp .right-sidebar-profile .edit-group svg {
  width: 16px;
  color: #00918E;
}
.right-user-side.call-user-side .slime-grp .chat-options {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border-bottom: 1px solid #00918E;
  padding-bottom: 20px;
}
.right-user-side.call-user-side .slime-grp .chat-options ul li a {
  color: #00918E;
  width: 30px;
  height: 30px;
  background-color: gray;
  padding: 0;
  border-radius: 50px;
}
.right-user-side.call-user-side .slime-grp .chat-options ul li a:hover {
  background: #E41F07;
  border-color: #E41F07;
}
.right-user-side.call-user-side .slime-grp .chat-options ul li a:hover svg {
  color: #FFF;
}
.right-user-side.call-user-side .slime-grp .chat-options ul li a svg {
  width: 15px;
}
.right-user-side.right-side-party .slime-grp {
  padding: 0px;
}
.right-user-side.right-side-party .slime-grp .left-chat-title {
  padding: 20px;
  margin-bottom: 0;
  background-color: #F9F9FC;
  border-radius: 10px 10px 0 0;
}
.right-user-side.right-side-party .slime-grp .left-chat-title h4 {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.right-user-side.right-side-party .slime-grp .left-chat-title h4 span {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  width: 25px;
  height: 25px;
  background-color: #FDA700;
  border-radius: 50px;
  font-size: 14px;
  color: #FFF;
  margin-left: 10px;
}
.right-user-side.right-side-party .slime-grp .card-body-blk {
  padding: 20px;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list {
  border-radius: 0.25rem;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  padding: 5px;
  display: flex;
  display: -webkit-flex;
  border-radius: 6px;
  background-color: #F6F7F8;
  margin-bottom: 10px;
  border: 0;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item:hover {
  background-color: #F6F7F8;
  transition: ease all 0.5s;
  -webkit-transition: ease all 0.5s;
  -ms-transition: ease all 0.5s;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .avatar {
  margin-right: 0.8rem;
  display: inline-block;
  margin-bottom: 0;
  height: 40px;
  width: 40px;
  position: relative;
  flex-shrink: 0;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .avatar::before {
  top: 0;
  bottom: inherit;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .avatar img {
  border-radius: 0px;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .users-list-body {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  flex-grow: 1;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .users-list-body .name-list-user {
  display: grid;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .users-list-body .name-list-user h5 {
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 2px;
  color: #6F6F6F;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .users-list-body .name-list-user p {
  font-size: 12px;
  color: #FC0027;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .users-list-body .name-list-user p svg {
  width: 14px;
  height: 14px;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .users-list-body .chat-user-time .chats-dot a {
  color: #FC0027;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .users-list-body .last-chat-time .text-muted {
  font-size: 10px;
  color: #262A2A;
  font-weight: 500;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .users-list-body .last-chat-time .new-message-count {
  width: 20px;
  height: 20px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  line-height: 0;
  font-size: 11px;
  background-color: #E41F07;
  color: #FFF;
  border-radius: 50%;
  margin-left: auto;
  margin-top: 5px;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .users-list-body .last-call-time {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .users-list-body .last-call-time .call-recent a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  width: 30px;
  height: 30px;
  background: #B8BCC9;
  color: #262A2A;
  border-radius: 50px;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .users-list-body .last-call-time .call-recent a svg {
  color: #262A2A;
}
.right-user-side .slimScrollDiv {
  height: calc(100vh - 110px) !important;
}
.right-user-side .slimScrollDiv .slimscroll {
  height: calc(100vh - 110px) !important;
}
.right-user-side .slime-grp {
  background: #FFF;
  box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.4705882353);
  border: 1px solid #E1E8ED;
  border-radius: 10px;
  padding: 15px;
}
.right-user-side .slime-grp .left-chat-title {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-bottom: 20px;
  background-color: #F9F9FC;
}
.right-user-side .slime-grp .left-chat-title .chat-title h4 {
  font-size: 18px;
  font-weight: 600;
  color: #262A2A;
  margin-bottom: 0;
}
.right-user-side .slime-grp .left-chat-title .contact-close_call .close_profile {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  width: 26px;
  height: 26px;
  background: transparent;
  border-radius: 50px;
}
.right-user-side .slime-grp .left-chat-title .contact-close_call .close_profile:hover {
  background: #E41F07;
}
.right-user-side .slime-grp .left-chat-title .contact-close_call .close_profile:hover svg {
  color: #FFF;
}
.right-user-side .slime-grp .left-chat-title .contact-close_call .close_profile svg {
  width: 16px;
  color: #FC0027;
}
.right-user-side .slime-grp .chat-footer {
  position: sticky;
  left: 0px;
  right: 0px;
  bottom: 0px;
  padding: 15px;
  background: #FFF;
}
.right-user-side .slime-grp .chat-footer form {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  position: relative;
}
.right-user-side .slime-grp .chat-footer form .comman-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
}
.right-user-side .slime-grp .chat-footer form .comman-icon a {
  color: #6F6F6F;
}
.right-user-side .slime-grp .chat-footer form .smile-col {
  right: inherit;
  left: 15px;
}
.right-user-side .slime-grp .chat-footer form .attach-col {
  right: inherit;
  left: 45px;
}
.right-user-side .slime-grp .chat-footer form .micro-col {
  right: 50px;
  left: inherit;
}
.right-user-side .slime-grp .chat-footer form .micro-col a {
  display: flex;
  align-items: center;
  font-size: 16px;
}
.right-user-side .slime-grp .chat-footer form .send-chat {
  right: 5px;
}
.right-user-side .slime-grp .chat-footer form .send-chat a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  width: 34px;
  height: 34px;
  background: #E41F07;
  border-radius: 50px;
}
.right-user-side .slime-grp .chat-footer form .send-chat a:hover {
  background: #1b2950;
}
.right-user-side .slime-grp .chat-footer form .send-chat a:hover svg {
  color: #FFF;
}
.right-user-side .slime-grp .chat-footer form .send-chat a svg {
  width: 14px;
  color: #FFF;
}
.right-user-side .slime-grp .chat-footer form .chat_form {
  border-radius: 20px;
  margin-right: 0px;
  background: #FFF;
  border: 1px solid rgba(145, 158, 171, 0.3);
  border-radius: 6px;
  height: 48px;
  padding: 10px 70px;
}
.right-user-side .slime-grp .chat-footer form .chat_form::placeholder {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.2);
}

.owl-carousel.video-slide .owl-nav.disabled {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  width: 100%;
}
.owl-carousel.video-slide .owl-nav {
  top: 50%;
  transform: translate(0, -50%);
}
@media (max-width: 1280px) {
  .owl-carousel.video-slide .owl-nav {
    width: 100%;
    display: flex;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    -ms-flex-pack: space-between;
  }
}
.owl-carousel.video-slide .owl-nav button.owl-next, .owl-carousel.video-slide .owl-nav button.owl-prev {
  background-color: #D9D9D9;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.owl-carousel.video-slide .owl-nav button.owl-next:hover, .owl-carousel.video-slide .owl-nav button.owl-prev:hover {
  background-color: #E41F07;
}
.owl-carousel.video-slide .owl-nav button.owl-next:hover i, .owl-carousel.video-slide .owl-nav button.owl-prev:hover i {
  color: #FFF;
}
.owl-carousel.video-slide .owl-nav button.owl-next i, .owl-carousel.video-slide .owl-nav button.owl-prev i {
  color: #6F6F6F;
}

.audio-call-group {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  height: 100%;
}
.audio-call-group ul {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  -webkit-justify-content: space-evenly;
  -ms-flex-pack: space-evenly;
  width: 100%;
}
.audio-call-group ul li {
  position: relative;
}
.audio-call-group ul li.active .avatar::before {
  content: "";
  width: 250px;
  height: 250px;
  position: absolute;
  border: 1px solid #E41F07;
  border-radius: 50%;
  left: -25px;
  top: -25px;
}
@media (max-width: 991.98px) {
  .audio-call-group ul li.active .avatar::before {
    width: 150px;
    height: 150px;
    left: -10px;
    top: -10px;
  }
}
@media (max-width: 767.98px) {
  .audio-call-group ul li.active .avatar::before {
    width: 100px;
    height: 100px;
    left: -5px;
    top: -5px;
  }
}
.audio-call-group ul li .avatar {
  width: 200px;
  height: 200px;
  margin: 0;
  position: relative;
}
@media (max-width: 991.98px) {
  .audio-call-group ul li .avatar {
    width: 130px;
    height: 130px;
  }
}
@media (max-width: 767.98px) {
  .audio-call-group ul li .avatar {
    width: 90px;
    height: 90px;
  }
}
.audio-call-group ul li .avatar img {
  width: 100%;
  position: relative;
}
.audio-call-group ul li .user-audio-call h5 {
  font-size: 14px;
  color: #FFF;
  font-weight: 400;
  text-transform: capitalize;
  text-align: center;
  margin-top: 35px;
}
@media (max-width: 767.98px) {
  .audio-call-group ul li .user-audio-call h5 {
    margin-top: 15px;
  }
}
.audio-call-group ul li .more-icon {
  position: absolute;
  bottom: 10px;
  right: inherit;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9;
}
@media (max-width: 767.98px) {
  .audio-call-group ul li .more-icon {
    bottom: 0px;
  }
}
.audio-call-group ul li .more-icon a {
  background-color: #E41F07;
  color: #FFF;
}

.audio-volume {
  position: absolute;
  width: fit-content;
  height: 134px;
  bottom: 20px;
  left: 20px;
  background: #898989;
  border-radius: 50px;
  padding: 10px 14px;
  width: 30px;
  padding-bottom: 30px;
}
.audio-volume .volume-icons a {
  position: absolute;
  bottom: 0;
  width: 30px;
  height: 30px;
  left: 0;
  border-radius: 50px;
  background: #FFF;
  border: 1px solid #FDA700;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}

.custom-input {
  width: 100%;
  height: 4px;
  width: 3px;
  height: 100%;
  background: #FFF;
  border-radius: 5px;
  writing-mode: vertical-lr;
}

.custom-input::-webkit-slider-thumb {
  appearance: none;
  width: 12px;
  height: 12px;
  background: #E41F07 !important;
  border-radius: 50%;
  cursor: pointer;
}

.custom-input::-moz-range-thumb {
  width: 12px;
  height: 12px;
  background: #E41F07 !important;
  border-radius: 50%;
  cursor: pointer;
}

.table-top-head {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
@media (max-width: 575.98px) {
  .table-top-head.low-stock-top-head {
    flex-wrap: wrap;
    justify-content: start;
  }
}
.table-top-head.low-stock-top-head li {
  margin-bottom: 10px;
}
.table-top-head.low-stock-top-head li:last-child {
  margin-right: 0;
}
.table-top-head li {
  margin-right: 10px;
  flex-shrink: 0;
}
.table-top-head li:last-child {
  margin-right: 0;
}
.table-top-head li #collapse-header {
  margin-right: 0;
}
@media (max-width: 991.98px) {
  .table-top-head li #collapse-header {
    display: none;
  }
}
.table-top-head li a {
  height: 38px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border: 1px solid #898989;
  background: #FFF;
  border-radius: 8px;
  padding: 6px;
}
.table-top-head li a svg {
  color: #262A2A;
}
.table-top-head li a:hover {
  background: #e3e3e3;
}
.table-top-head li a label {
  margin-right: 10px;
}
.table-top-head li a.btn-secondary {
  background-color: #262A2A;
  color: #FFF;
  padding: 10px;
  font-weight: 700;
  font-size: 14px;
}
.table-top-head li a.btn-secondary:hover {
  background-color: #E41F07;
}
.table-top-head li a.btn-secondary svg {
  width: 16px;
  margin-right: 5px;
  color: #FFF;
}
@media (max-width: 767.98px) {
  .table-top-head li a.btn-secondary {
    padding: 5px;
    font-size: 14px;
  }
}
.table-top-head li a .action-edit.sales-action {
  color: #339DFF;
}
.table-top-head li .status-toggle {
  height: 38px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border: 1px solid #C0C0C0;
  background: #FFF;
  border-radius: 8px;
  padding: 6px 10px;
}
.table-top-head li .status-toggle label {
  margin-right: 10px;
}

.main-chat-blk .slimscroll {
  height: calc(100vh - 60px) !important;
}
.main-chat-blk .slimscroll-active-sidebar a {
  color: #6F6F6F;
}
.main-chat-blk .emoj-group ul {
  display: flex;
  align-items: center;
}
.main-chat-blk .emoj-group ul li + li {
  margin-left: 10px;
}
.main-chat-blk .emoj-group ul li a {
  width: 34px;
  height: 34px;
  background: #f6f7f8;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.main-chat-blk .emoj-group ul li a i {
  color: #424242;
}
.main-chat-blk .message-content {
  position: relative;
}
.main-chat-blk .message-content:hover .emoj-group {
  opacity: 1;
  transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
}
.main-chat-blk .emoj-group {
  position: absolute;
  top: 50%;
  right: -100px;
  opacity: 0;
  transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  transform: translate(0, -50%);
}
.main-chat-blk .rig-emoji-group {
  position: absolute;
  right: 210px;
}
.main-chat-blk .wrap-emoji-group {
  position: absolute;
  right: 290px;
}
.main-chat-blk .emoj-group-list-foot {
  display: none;
  position: absolute;
  top: -50px;
  left: -90px;
  transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
}
.main-chat-blk .emoj-group-list-foot ul {
  display: flex;
  align-items: center;
  background: #f6f7f8;
  border-radius: 50px;
  padding: 5px;
}
.main-chat-blk .emoj-group-list-foot ul li a {
  padding: 0;
  display: flex;
  align-items: center;
}
.main-chat-blk .emoj-group-list-foot ul li.add-emoj a {
  background: #EDEDED;
}
.main-chat-blk .emoj-group-list-foot ul li.add-emoj a i {
  font-size: 20px;
  color: #424242;
}
.main-chat-blk .down-emoji-circle {
  position: absolute;
  left: 10px !important;
  top: -38px !important;
}
.main-chat-blk .emoj-action-foot .down-emoji-circle ul {
  padding: 10px;
}
.main-chat-blk .down-emoji-circle ul li + li {
  margin-left: 14px;
}
.main-chat-blk .emoj-action-foot .down-emoji-circle ul li:last-child a {
  width: 34px;
  height: 34px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-chat-blk .chat-page-wrapper .content {
  padding: 24px 0 0 24px;
}
.main-chat-blk .chat-page-wrapper .sidebar {
  position: initial;
}
@media (max-width: 991.98px) {
  .main-chat-blk .chat-page-wrapper .sidebar {
    margin-left: 0;
  }
}
.main-chat-blk .chat-page-wrapper .left-chat-title {
  padding: 12px;
  border-bottom: 1px solid #E0E0E0;
  min-height: 72px;
}
.main-chat-blk .chat-page-wrapper .setting-title-head h4 {
  font-size: 18px;
  color: #262A2A;
  font-weight: 700;
}
.main-chat-blk .chat-page-wrapper .chat .slimscroll {
  height: calc(100vh - 135px) !important;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item {
  font-size: 14px;
  cursor: pointer;
  padding: 7px 14px;
  font-weight: 500;
  color: #424242;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item i {
  font-size: 16px;
  color: #424242;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item span {
  float: right;
  font-size: 18px;
  color: #424242;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item.active {
  background: none;
  color: inherit;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item:focus,
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item:hover,
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item:active {
  background-color: #e6e6e6;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu {
  background: #FFF;
  border: 1px solid #E5E7EB;
  box-sizing: border-box;
  box-shadow: 0px 4px 3px 0px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  min-width: 173px;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item {
  margin: 0;
  position: relative;
  display: flex;
  align-items: center;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu.chat-drop-menu .dropdown-item i {
  font-size: 16px;
  color: #424242;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item:hover,
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item:focus,
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item:active {
  background-color: #F8ECFF;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item span {
  margin-right: 10px;
  display: flex;
  align-items: center;
}
.main-chat-blk .chat-page-wrapper .contact-close_call {
  display: flex;
  align-items: center;
}
@keyframes wave {
  0%, 100%, 60% {
    transform: initial;
  }
  30% {
    transform: translateY(-5px);
  }
}
.main-chat-blk .chat {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  background: #FFF;
}
.main-chat-blk .chat .chat-header {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  padding: 15px 24px;
  align-items: center;
  border-bottom: 1px solid var(--Stroke, rgba(145, 158, 171, 0.3));
  background: var(--White, #FFF);
  box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);
  position: relative;
}
.main-chat-blk .chat .chat-header .user-details {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
}
.main-chat-blk .chat .chat-header .user-details figure {
  margin-right: 1rem;
}
.main-chat-blk .chat .chat-header .user-details h5 {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 4px;
  line-height: 1;
  color: #262A2A;
}
.main-chat-blk .chat .chat-header .chat-options ul {
  margin-bottom: 0;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
}
.main-chat-blk .chat .chat-header .chat-options ul > li > a {
  font-size: 14px;
  color: #262A2A;
  cursor: pointer;
  width: 40px;
  height: 40px;
  padding: 0;
  border: none;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
}
.main-chat-blk .chat .chat-header .chat-options ul > li > a i {
  font-size: 20px;
}
.main-chat-blk .chat .chat-header .chat-options ul > li > a:not(.no-bg):hover {
  background-color: #C0C0C0;
  border-color: #C0C0C0;
}
.main-chat-blk .chat .chat-body {
  flex: 1 1;
  padding: 24px;
  padding-bottom: 40px;
}
.main-chat-blk .chat .chat-body:not(.no-message) {
  overflow: hidden;
}
.main-chat-blk .chat .chat-body .messages {
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  align-items: flex-start;
  -webkit-align-items: flex-start;
}
.main-chat-blk .chat .chat-body .messages .chats {
  max-width: 75%;
  margin-bottom: 1.5rem;
  display: flex;
  display: -webkit-flex;
}
.main-chat-blk .chat .chat-body .messages .chats:last-child {
  margin-bottom: 0;
}
.main-chat-blk .chat .chat-body .messages .chats .chat-time {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  margin-bottom: 0;
}
.main-chat-blk .chat .chat-body .messages .chats .chat-time .avatar {
  margin-right: 1rem;
}
.main-chat-blk .chat .chat-body .messages .chats .chat-time h5 {
  font-size: 15px;
  margin-bottom: 0;
}
.main-chat-blk .chat .chat-body .messages .chats .chat-time .time {
  color: #FFF;
  margin-top: 2px;
  font-size: 12px;
  font-weight: 400;
}
.main-chat-blk .chat .chat-body .messages .chats .chat-time .time i {
  color: rgba(247, 247, 247, 0.5);
}
.main-chat-blk .chat .chat-body .messages .chats .chat-time .time i img {
  width: 14px;
  height: auto;
  margin-left: 2px;
  vertical-align: 0px;
}
.main-chat-blk .chat .chat-body .messages .chats .message-content {
  border-radius: 0px 15px 15px 15px;
  background: var(--light-color, #F6F7F8);
  padding: 14px 20px;
  color: #262A2A;
  font-size: 14px;
  font-weight: 400;
  box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.031372549);
}
.main-chat-blk .chat .chat-body .messages .chats .message-content a {
  color: #299cdb;
}
.main-chat-blk .chat .chat-body .messages .chats .message-content.award-link a {
  color: #262A2A;
  margin-bottom: 2px;
  display: block;
}
.main-chat-blk .chat .chat-body .messages .chats .message-content.award-link img {
  border-radius: 10px;
}
.main-chat-blk .chat .chat-body .messages .chats .message-content.chat-award-link a {
  display: flex;
}
.main-chat-blk .chat .chat-body .messages .chats .message-content.fancy-msg-box .image-not-download span {
  position: absolute;
  color: #FFF;
  font-size: 13px;
  font-weight: 500;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.main-chat-blk .chat .chat-body .messages .chat-profile-name h6 {
  margin-bottom: 0;
  color: #262A2A;
  font-weight: 600;
  font-size: 15px;
}
.main-chat-blk .chat .chat-body .messages .chat-profile-name h6 span {
  font-size: 12px;
  color: #6F7A7A;
  font-weight: 400;
  padding-left: 10px;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right {
  margin-left: auto;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .chat-time {
  justify-content: flex-end;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .message-content {
  border-radius: 15px 0px 15px 15px;
  background: rgba(255, 159, 67, 0.12);
  color: #262A2A;
  padding: 15px;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .message-content .chat-time {
  justify-content: flex-start;
  -webkit-justify-content: flex-start;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .message-content .chat-time .time {
  color: #6F7A7A;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .message-content .chat-time .time i {
  color: #299cdb;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .chat-action-btns {
  order: 2;
  -webkit-order: 2;
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  justify-content: center;
  -webkit-justify-content: center;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .chat-action-btns .chat-action-col {
  width: 20px;
  text-align: center;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .chat-action-btns .chat-read-col {
  display: flex;
  display: -webkit-flex;
  align-items: flex-end;
  -webkit-align-items: flex-end;
  padding-bottom: 22px;
  color: #565E5E;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .chat-content {
  order: 1;
  -webkit-order: 1;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .chat-avatar {
  padding: 8px 0px 0 15px;
}
.main-chat-blk .chat .chat-body .messages .download-col {
  position: relative;
}
.main-chat-blk .chat .chat-body .messages .download-col ul {
  list-style: none;
  padding: 0;
  margin: 0 0 5px 0;
  display: flex;
  display: -webkit-flex;
}
.main-chat-blk .chat .chat-body .messages .download-col ul li + li {
  margin-left: 5px;
}
.main-chat-blk .chat .chat-body .messages .download-col .image-download-col {
  position: relative;
}
.main-chat-blk .chat .chat-body .messages .download-col .image-download-col a > img {
  border: 1px solid transparent;
  width: 80px;
  border-radius: 8px;
}
.main-chat-blk .chat .chat-body .messages .download-col .image-download-col.image-not-download a > img {
  filter: blur(1px);
}
.main-chat-blk .chat .chat-body .messages .download-col .download-action {
  position: absolute;
  right: 8px;
  bottom: 8px;
  line-height: 0;
}
.main-chat-blk .chat .chat-body .messages .download-col .download-action a {
  color: #FFF;
  font-size: 10px;
}
.main-chat-blk .chat .chat-body .messages .download-col .download-action div + div {
  margin-left: 8px;
}
.main-chat-blk .chat .chat-body .messages .download-col .download-action div img {
  width: 13px;
}
.main-chat-blk .chat .chat-body .messages .file-download {
  position: relative;
  background: #E8E8E8;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 7px;
}
.main-chat-blk .chat .chat-body .messages .file-download .download-action {
  position: absolute;
  right: 8px;
  bottom: 8px;
  line-height: 0;
  bottom: 14px;
}
.main-chat-blk .chat .chat-body .messages .file-download .download-action a {
  color: #FFF;
  font-size: 10px;
  color: #323737;
}
.main-chat-blk .chat .chat-body .messages .file-download .download-action div + div {
  margin-left: 8px;
}
.main-chat-blk .chat .chat-body .messages .file-download .download-action div img {
  width: 13px;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-type {
  width: 54px;
  height: 54px;
  background-color: #FFF;
  border-radius: 4px;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-type i {
  color: #6F7A7A;
  font-size: 24px;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-details span.file-name {
  color: #262A2A;
  display: inline-block;
  width: 100%;
  font-size: 15px;
  font-weight: 500;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-details span.file-size {
  color: #6F7A7A;
  display: inline-block;
  width: 100%;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-details ul {
  display: flex;
  align-items: center;
  padding: 0;
  margin-bottom: 0;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-details ul li {
  list-style: none;
  color: #262A2A;
  font-size: 14px;
  position: relative;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-details ul li::before {
  content: "";
  position: absolute;
  width: 1px;
  height: 13px;
  background: #C2C2C2;
  right: -8px;
  top: 5px;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-details ul li:last-child::before {
  display: none;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-details ul li a {
  color: #E41F07;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-details ul li + li {
  padding-left: 15px;
}
.main-chat-blk .chat .chat-body.no-message {
  -webkit-user-select: none;
          user-select: none;
}
.main-chat-blk .chat .chat-footer {
  position: relative;
}
.main-chat-blk .chat .chat-footer form {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 24px;
}
@media (max-width: 991.98px) {
  .main-chat-blk .chat .chat-footer form {
    padding-bottom: 15px;
  }
}
.main-chat-blk .chat .chat-footer form .form-buttons .btn {
  margin-left: 0px;
  color: #6F6F6F;
  font-size: 20px;
  padding: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
}
.main-chat-blk .chat .chat-footer form .form-buttons .btn:last-child {
  margin-right: 0;
}
.main-chat-blk .chat .chat-footer form .form-buttons .btn.send-btn {
  width: 40px;
  height: 40px;
  border-radius: 6px;
  background: #E41F07;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: #FFF !important;
  margin-left: 10px;
}
.main-chat-blk .chat .chat-footer form .form-buttons .btn.send-btn:hover {
  background-color: #FFF;
  border-color: #323737;
}
.main-chat-blk .chat .chat-footer form .form-buttons .btn.send-btn:hover i {
  color: #323737;
}
.main-chat-blk .chat .chat-footer form .form-buttons .btn.send-btn:focus {
  box-shadow: none;
}
.main-chat-blk .chat .chat-footer form .specker-col span {
  color: #323737;
  font-size: 25px;
}
.main-chat-blk .chat .chat-footer form .attach-col {
  right: inherit;
  left: 60px;
}
.main-chat-blk .chat .chat-footer form .attach-col i {
  color: #323737;
  font-size: 20px;
}
.main-chat-blk .chat .chat-footer form .smile-col {
  right: inherit;
  left: 15px;
}
.main-chat-blk .chat .chat-footer form .smile-col i {
  color: #323737;
  font-size: 20px;
  font-size: 22px;
}
.main-chat-blk .chat .chat-footer form .smile-foot {
  margin-right: 10px;
}
.main-chat-blk .chat .chat-footer form .smile-foot .action-circle {
  width: 38px;
  height: 38px;
  background: #FFF;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.main-chat-blk .chat .chat-footer form .smile-foot .action-circle:hover {
  background-color: #C0C0C0;
  border-color: #C0C0C0;
}
.main-chat-blk .chat .chat-footer form .smile-foot .action-circle i {
  color: #262A2A;
  font-size: 18px;
}
.main-chat-blk .chat .chat-footer form .form-control::-webkit-input-placeholder {
  color: #262A2A;
  opacity: 1;
}
.main-chat-blk .chat .chat-footer form .form-control::-moz-placeholder {
  color: #262A2A;
  opacity: 1;
}
.main-chat-blk .chat .chat-footer form .form-control:-ms-input-placeholder {
  color: #262A2A;
  opacity: 1;
}
.main-chat-blk .chat .chat-footer form .form-control:-moz-placeholder {
  color: #262A2A;
  opacity: 1;
}
.main-chat-blk .chat-options ul.list-inline .list-inline-item {
  margin-bottom: 0;
}
.main-chat-blk .last-seen {
  color: #262A2A;
  font-size: 14px;
}
.main-chat-blk .user_callog {
  display: flex;
  margin-top: 0px;
}
.main-chat-blk .calllog_p {
  margin-left: 5px;
}
.main-chat-blk .chat-options.chat-option-profile .list-inline-item a {
  background: #E41F07;
  width: 38px;
  height: 38px;
  border-radius: 50px;
  color: #262A2A;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #FFF !important;
}
.main-chat-blk .chat-options.chat-option-profile .list-inline-item a:hover {
  background: #1b2950;
  color: #FFF;
}
.main-chat-blk .chat-options.chat-option-profile .list-inline {
  border-bottom: 1px solid #EDEDED;
  margin-bottom: 0;
  padding-bottom: 15px;
}
.main-chat-blk .last-seen-profile span {
  color: #262A2A;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 12px;
  display: block;
}
.main-chat-blk .header_button {
  position: absolute;
  right: 5px;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  font-size: 14px;
  color: #FFF;
  text-align: center;
  background: #ffa977;
  bottom: 40px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
}
.main-chat-blk .btn-warning:hover {
  color: #FFF;
  background-color: #E94C39;
  border-color: #E73520;
}
.main-chat-blk .right_sidebar_profile {
  margin-top: 0px;
}
.main-chat-blk .account_details {
  background-color: #898989;
  border-color: #6F6F6F;
  border-radius: 5px !important;
  border-bottom: 0 !important;
}
.main-chat-blk .security_details {
  background-color: #898989;
  border-color: #6F6F6F;
  border-radius: 5px !important;
  border-bottom: 0 !important;
}
.main-chat-blk .close_icon {
  font-size: 18px;
}
.main-chat-blk .button_plus {
  margin-left: 0px;
}
.main-chat-blk .chat-search {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  transition: ease all 0.5s;
  -webkit-transition: ease all 0.5s;
  -ms-transition: ease all 0.5s;
  opacity: 0;
  visibility: hidden;
}
.main-chat-blk .chat-search input[type=text] {
  padding: 8px 8px 8px 35px;
  width: 100%;
  min-height: 47px;
  border-radius: 0px 0px 5px 5px;
  border: 1px solid #E5E7EB;
  font-size: 13px;
  background-color: #FFF;
  color: #262A2A;
  font-size: 15px;
  font-weight: 500;
}
.main-chat-blk .chat-search input[type=text]:hover {
  border-color: #9B9B9B;
}
.main-chat-blk .chat-search input[type=text]:focus {
  border-color: #9B9B9B;
}
.main-chat-blk .chat-search input[type=text]:focus-visible {
  border-color: #9B9B9B;
}
.main-chat-blk .chat-search.visible-chat {
  opacity: 1;
  visibility: visible;
  top: 100%;
  transition: ease all 0.5s;
  -webkit-transition: ease all 0.5s;
  -ms-transition: ease all 0.5s;
  z-index: 9;
}
.main-chat-blk .form-control-feedback {
  z-index: 2;
  display: block;
  text-align: center;
  pointer-events: none;
  color: rgba(0, 0, 0, 0.4);
  position: absolute;
  left: 13px;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
}
.main-chat-blk .form-control-feedback i {
  font-size: 16px;
  color: #262A2A;
}
.main-chat-blk .user-chat-search {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  transition: ease all 0.5s;
  -webkit-transition: ease all 0.5s;
  -ms-transition: ease all 0.5s;
  opacity: 0;
  visibility: hidden;
}
.main-chat-blk .user-chat-search input[type=text] {
  padding: 8px 8px 8px 35px;
  width: 100%;
  min-height: 47px;
  border-radius: 0px 0px 5px 5px;
  border: 1px solid #E5E7EB;
  font-size: 13px;
  background-color: #FFF;
  color: #262A2A;
  font-size: 15px;
  font-weight: 500;
}
.main-chat-blk .user-chat-search input[type=text]:hover {
  border-color: #9B9B9B;
}
.main-chat-blk .user-chat-search input[type=text]:focus {
  border-color: #9B9B9B;
}
.main-chat-blk .user-chat-search input[type=text]:focus-visible {
  border-color: #9B9B9B;
}
.main-chat-blk .user-chat-search.visible-chat {
  opacity: 1;
  visibility: visible;
  top: 100%;
  transition: ease all 0.5s;
  -webkit-transition: ease all 0.5s;
  -ms-transition: ease all 0.5s;
  z-index: 9;
}
.main-chat-blk .all-chats {
  position: relative;
}
.main-chat-blk .close-btn-chat {
  width: 25px;
  height: 25px;
  border-radius: 25px;
  color: #262A2A;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
  align-items: center;
  -webkit-align-items: center;
  position: absolute;
  right: 12px;
  top: 9px;
  cursor: pointer;
}
.main-chat-blk .user-close-btn-chat {
  width: 25px;
  height: 25px;
  border-radius: 25px;
  color: #262A2A;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
  align-items: center;
  -webkit-align-items: center;
  position: absolute;
  right: 12px;
  top: 9px;
  cursor: pointer;
}
.main-chat-blk .main_content {
  width: 100% !important;
}
.main-chat-blk .avatar-main {
  height: 50px;
  width: 50px;
}
.main-chat-blk .archive-btn {
  border: 1px solid #008024;
  color: #565E5E;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  padding: 2px 6px;
  margin-right: 1.5rem;
}
.main-chat-blk .archive-btn-grey {
  border: 1px solid #909090;
  color: #6F7A7A;
  border-radius: 4px;
  font-size: 9px;
  font-weight: 500;
  padding: 2px 6px;
  margin-top: 0.25rem;
}
.main-chat-blk .right_sidebar_icon {
  list-style: none;
}
.main-chat-blk .btn.btn-outline-light:hover {
  background: #e6e6e6;
}
.main-chat-blk .chat-avatar {
  padding: 8px 15px 0 8px;
  display: flex;
  display: -webkit-flex;
  align-items: flex-start;
  -webkit-align-items: flex-start;
  flex-shrink: 0;
}
.main-chat-blk .chat-profile-name {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}
.main-chat-blk .chat-profile-name .chat-action-col a {
  display: flex;
}
.main-chat-blk .delete-pop-btn .btn-primary {
  margin: 0 0 0 10px;
}
.main-chat-blk .delete-model-head {
  padding: 40px;
}
.main-chat-blk .delete-model-head .modal-header {
  padding: 0;
  margin-bottom: 32px;
}
.main-chat-blk .delete-model-head .modal-body {
  padding: 0;
}
.main-chat-blk .delete-chat-notify {
  margin-bottom: 32px;
}
.main-chat-blk .delete-chat-notify .form-check {
  margin-bottom: 14px;
}
.main-chat-blk .chats.chats-right {
  flex-direction: row-reverse;
}
.main-chat-blk .message-star {
  display: flex;
  align-items: center;
}
.main-chat-blk .message-star .avatar {
  width: 26px;
  height: 26px;
  margin-right: 10px;
}
.main-chat-blk .message-star .avatar img {
  width: 100%;
}
.main-chat-blk .message-star h6 {
  color: #262A2A;
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 0;
}
.main-chat-blk .message-star h6 span i {
  color: #FEC14D;
}
.main-chat-blk .chat-voice-group ul {
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  padding: 0;
  margin-bottom: 0;
}
.main-chat-blk .chat-voice-group ul li span {
  width: 28px;
  height: 28px;
  background: #E41F07;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.main-chat-blk .chat-voice-group li {
  margin-bottom: 0;
  color: #262A2A;
  font-size: 14px;
  font-weight: 400;
  list-style: none;
}
.main-chat-blk .chat-voice-group li + li {
  padding-left: 10px;
}
.main-chat-blk .file-download-col .download-action {
  position: absolute;
  right: 8px;
  bottom: 8px;
  line-height: 0;
}
.main-chat-blk .file-download-col .download-action a {
  color: #FFF;
  font-size: 10px;
}
.main-chat-blk .file-download-col .download-action div + div {
  margin-left: 8px;
}
.main-chat-blk .file-download-col .download-action div img {
  width: 13px;
}
.main-chat-blk .file-download-col:after {
  content: "";
  display: table;
  clear: both;
}
.main-chat-blk .file-download-col ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.main-chat-blk .file-download-col ul li {
  float: left;
  width: 50%;
  padding: 5px;
}
.main-chat-blk .file-download-col ul li .image-download-col {
  position: relative;
}
.main-chat-blk .file-download-col ul li .image-download-col a > img {
  width: 100%;
}
.main-chat-blk .file-download-col ul li.full-width {
  width: 100%;
}
.main-chat-blk .chat-select .select2-container .select2-selection--single {
  border: 0;
  height: 24px;
}
.main-chat-blk .chat-select .select2-container .select2-selection--single .select2-selection__rendered {
  padding-right: 40px;
  padding-left: 0px;
}
.main-chat-blk .chat-select .select2-container--default .select2-selection--single .select2-selection__rendered {
  color: #6F7A7A;
  font-size: 18px;
  font-weight: normal;
  line-height: 24px;
  font-weight: 600;
}
.main-chat-blk .chat-select .select2-container--default .select2-selection--single .select2-selection__arrow {
  height: 24px;
  right: 7px;
}
.main-chat-blk .chat-select .select2-container--default .select2-selection--single .select2-selection__arrow b {
  border-color: #424848;
  border-style: solid;
  border-width: 0 2px 2px 0;
  padding: 3px;
  height: 0;
  left: 50%;
  margin-left: -5px;
  margin-top: -5px;
  position: absolute;
  top: 50%;
  width: 0;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}
.main-chat-blk .chat-select .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #262A2A;
}
.main-chat-blk .chat-select .select2-container--default .select2-selection--multiple {
  border: 1px solid #ddd;
  min-height: 40px;
}
.main-chat-blk .chat-select .select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b {
  border-color: #424848;
  border-width: 2px 0 0 2px;
  padding: 3px;
  margin-top: -5px;
  border-color: #424848;
  border-style: solid;
  border-width: 0 2px 2px 0;
  padding: 3px;
}
.main-chat-blk .chat-select .select2-container--default.form-control-sm .select2-selection--single .select2-selection__arrow {
  top: 7px;
}
.main-chat-blk .chat-select .select2-container--open .select2-dropdown--below {
  margin-top: 10px;
}
.main-chat-blk .success-pass {
  margin-bottom: 40px;
  text-align: center;
}
.main-chat-blk .review-files p {
  margin-bottom: 5px;
  color: #262A2A;
  font-size: 14px;
}
.main-chat-blk .like-chat-grp ul {
  padding: 0;
  margin-bottom: 0;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  margin-top: 10px;
}
.main-chat-blk .like-chat-grp ul li {
  list-style: none;
}
.main-chat-blk .like-chat-grp ul li a {
  border: 1px solid #E0E0E0;
  border-radius: 50px;
  padding: 3px 12px;
  display: block;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #262A2A;
  font-weight: 400;
  font-size: 14px;
}
.main-chat-blk .like-chat-grp ul li a img {
  margin-left: 5px;
}
.main-chat-blk .like-chat-grp ul li + li {
  margin-left: 10px;
}
.main-chat-blk .like-chat-grp ul li.like-chat a {
  background: #FEF6DC;
}
.main-chat-blk .like-chat-grp ul li.comment-chat a {
  background: #FFE8E9;
}
.main-chat-blk .chat-line {
  margin: 0px 0 20px;
  position: relative;
  text-align: center;
  width: 100%;
}
.main-chat-blk .chat-line:before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  background-color: #E8E8E8;
  width: 100%;
  height: 1px;
}
.main-chat-blk .chat-date {
  border-radius: 100px;
  background: #E8E8E8;
  color: #262A2A;
  font-size: 14px;
  padding: 4px 20px;
  display: inline-block;
  font-weight: 400;
  position: relative;
  border: 1px solid #E0E0E0;
}
.main-chat-blk .chat + .sidebar-group {
  margin-right: 0px;
}
.main-chat-blk .chat + .sidebar-group .sidebar {
  margin-right: 0px;
}
.main-chat-blk .group-comman-theme {
  padding: 0 24px;
}
.main-chat-blk .group-comman-theme h6 {
  margin-bottom: 15px;
}
.main-chat-blk .group-comman-theme ul {
  padding: 0;
  padding-bottom: 15px;
  margin-bottom: 15px;
  border-bottom: 1px solid #EDEDED;
}
.main-chat-blk .group-comman-theme ul li {
  display: flex;
  align-items: center;
  list-style: none;
  border: 1px solid #E0E0E0;
  border-radius: 5px;
  padding: 5px;
  margin-bottom: 10px;
}
.main-chat-blk .group-comman-theme ul li:last-child {
  margin-bottom: 0;
}
.main-chat-blk .group-comman-theme ul li .avatar {
  flex-shrink: 0;
  margin-right: 10px;
}
.main-chat-blk .theme-content h6 {
  margin-bottom: 6px;
  color: #262A2A;
  font-size: 15px;
  font-weight: 500;
}
.main-chat-blk .theme-content p {
  margin-bottom: 0;
  text-align: start;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  color: #262A2A;
  font-size: 14px;
}
.main-chat-blk .chat-message-grp {
  padding: 24px;
  padding-top: 0;
}
.main-chat-blk .chat-message-grp ul {
  padding: 0;
}
.main-chat-blk .chat-message-grp ul li {
  list-style: none;
  margin-bottom: 15px;
}
.main-chat-blk .chat-message-grp ul li:last-child {
  margin-bottom: 0px;
}
.main-chat-blk .chat-message-grp ul li a {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.main-chat-blk .chat-message-grp ul li a:hover .stared-group h6 {
  color: #323737;
}
.main-chat-blk .stared-group {
  display: flex;
  align-items: center;
}
.main-chat-blk .stared-group span {
  width: 30px;
  height: 30px;
  border-radius: 6px;
  margin-right: 10px;
  background: #F6F7F8;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.main-chat-blk .stared-group span i {
  font-size: 16px;
}
.main-chat-blk .stared-group h6 {
  font-size: 15px;
  font-weight: 500;
  color: #6F6F6F;
  margin-bottom: 0;
}
.main-chat-blk .star-message {
  background: #FEF6DC;
}
.main-chat-blk .star-message i {
  color: #FEC14D;
}
.main-chat-blk .mute-message {
  background: rgba(235, 253, 255, 0.9803921569);
}
.main-chat-blk .mute-message i {
  color: #299cdb;
}
.main-chat-blk .block-message {
  background: #FFE8E9;
}
.main-chat-blk .block-message i {
  color: #4A00E5;
}
.main-chat-blk .report-message {
  background: #F8ECFF;
}
.main-chat-blk .report-message i {
  color: #262A2A;
}
.main-chat-blk .delete-message {
  background: #FFE8E9;
}
.main-chat-blk .delete-message i {
  color: #FD3352;
}
.main-chat-blk .count-group {
  display: flex;
  align-items: center;
}
.main-chat-blk .count-group span {
  width: 16px;
  height: 16px;
  border-radius: 50px;
  color: #FFF;
  font-size: 10px;
  background: #E41F07;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  margin-right: 5px;
}
.main-chat-blk .count-group i {
  color: #424242;
  font-size: 16px;
}
.main-chat-blk .nav.nav-tabs.chat-tabs .nav-item .nav-link {
  font-size: 16px;
  font-weight: bold;
  color: #FFF;
  background-color: transparent;
  border: 0;
}
.main-chat-blk .nav.nav-tabs.chat-tabs .nav-item .nav-link.active {
  font-size: 16px;
  font-weight: bold;
  color: #E94C39;
}
.main-chat-blk .header-top ul li a {
  color: #000;
  font-size: 18px;
}
.main-chat-blk .set-search {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  border-radius: 50px;
  width: 28px;
  height: 28px;
}
.main-chat-blk .set-search:hover {
  background: #F5F5F5;
  border-color: #C0C0C0;
}
.main-chat-blk .header-action {
  list-style: none;
  margin: 0;
  padding: 0;
}
.main-chat-blk .header-action li {
  display: inline-block;
  margin-left: 10px;
}
.main-chat-blk .header-action li a {
  color: #262A2A;
  font-size: 18px;
}
.main-chat-blk .user-list {
  border-radius: 0.25rem;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
}
.main-chat-blk .user-list li a {
  padding: 17px 20px;
  display: flex;
  display: -webkit-flex;
  cursor: pointer;
  border-radius: 6px;
  margin-bottom: 10px;
  border: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.main-chat-blk .user-list li .avatar {
  margin-right: 0.8rem;
  display: inline-block;
  margin-bottom: 0;
  height: 46px;
  width: 46px;
  border-radius: 50%;
  position: relative;
  z-index: 0;
}
.main-chat-blk .user-list li .avatar .letter-avatar {
  width: 45px;
  height: 45px;
  border-radius: 45px;
  margin-right: 0.8rem;
  margin-bottom: 0;
  position: relative;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  background-color: #6F6F6F;
  font-size: 16px;
  font-weight: 600;
  color: #676DFF;
}
.main-chat-blk .user-list li a.admin-shade {
  box-shadow: none;
}
.main-chat-blk .user-list .avatar > a > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.main-chat-blk .user-list .avatar > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.main-chat-blk .avatar-away::before {
  content: "";
  position: absolute;
  display: block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  top: 0px;
  right: 2px;
  border: 2px solid #FFF;
  z-index: 9;
  background-color: #ffff00;
}
.main-chat-blk .avatar-offline::before {
  content: "";
  position: absolute;
  display: block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  top: 0px;
  right: 2px;
  border: 2px solid #FFF;
  z-index: 9;
}
.main-chat-blk .avatar-online::before {
  content: "";
  position: absolute;
  display: block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  top: 0px;
  right: 2px;
  border: 2px solid #FFF;
  z-index: 9;
  background-color: #00918E;
}
.main-chat-blk .animate-typing-col {
  color: #5CB85C;
}
.main-chat-blk .animate-typing-col .dot {
  display: inline-block;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  margin-right: -1px;
  background: #0D9B35;
  animation: wave 1.3s linear infinite;
  opacity: 0.6;
}
.main-chat-blk .animate-typing-col .dot:nth-child(2) {
  animation-delay: -1.1s;
}
.main-chat-blk .animate-typing-col .dot:nth-child(3) {
  animation-delay: -0.9s;
}
.main-chat-blk .chat_form {
  border-radius: 20px;
  margin-right: 0px;
  background: #FFF;
  border: 1px solid #C2C2C2;
  box-shadow: 0px 4px 4px #F5F8FF;
  border-radius: 6px;
  height: 40px;
  padding: 10px 10px;
}
.main-chat-blk .contact-close a {
  color: #262A2A;
  opacity: 0.5;
  border-color: #898989;
}
.main-chat-blk .main-wrapper .content .sidebar-group.right-sidebar .sidebar {
  width: 310px;
}
.main-chat-blk .primary-title {
  color: #E94C39;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0;
}
.main-chat-blk .primary-title i {
  font-size: 14px;
}
.main-chat-blk .contact-action {
  padding: 0;
  margin: 0;
  list-style: none;
}
.main-chat-blk .contact-action li {
  padding: 11px 0;
  border-bottom: 1px solid #f1f1f1;
}
.main-chat-blk .contact-action li a {
  color: #262A2A;
  color: #262A2A;
  font-size: 14px;
  font-weight: bold;
}
.main-chat-blk .contact-action li.report-contact a {
  color: #FC0027;
}
.main-chat-blk .contact-action li.delete-chat a {
  color: #FC0027;
}
.main-chat-blk .contact-action li.sign-out a {
  color: #FC0027;
}
.main-chat-blk .left-sidebar {
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
}
.main-chat-blk .left-sidebar-wrap {
  background: #FBFBFB;
  overflow: hidden;
  width: 448px;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  flex: 1 1;
}
.main-chat-blk .right-sidebar {
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  background-color: #FDFDFE;
  opacity: 100%;
  transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  position: relative;
  width: 320px;
}
.main-chat-blk .right-sidebar .right-sidebar-wrap {
  background-color: #FFF;
  border-left: 1px solid #E0E0E0;
  border-radius: 0px;
  margin-top: 0px;
  margin-bottom: 0px;
  height: calc(100vh - 0px);
}
.main-chat-blk .right-sidebar .right-sidebar-wrap .sidebar-body {
  padding: 0;
}
.main-chat-blk .right-sidebar .right-sidebar-wrap .right-sidebar-profile {
  padding: 24px;
  padding-bottom: 0;
  margin-bottom: 15px;
}
.main-chat-blk .right-sidebar .contact-close_call .close_profile {
  width: 25px;
  height: 25px;
  border-radius: 25px;
  color: #262A2A;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
  align-items: center;
  -webkit-align-items: center;
}
.main-chat-blk .right-sidebar .contact-close_call .close_profile.close-star {
  color: #FDA700;
}
.main-chat-blk .right-sidebar .contact-close_call .close_profile.close-trash {
  color: #FC0027;
}
.main-chat-blk .right-sidebar.video-right-sidebar {
  width: 371px;
}
.main-chat-blk .right-sidebar.video-right-sidebar .chat {
  margin-left: 0 !important;
  display: block;
}
.main-chat-blk .right-sidebar.video-right-sidebar .chat .chat-body {
  padding-bottom: 110px;
}
.main-chat-blk .video-call-chat .left-chat-title.with-bg {
  background: transparent;
}
.main-chat-blk .video-call-chat .left-chat-title {
  border: 0;
}
.main-chat-blk .video-call-chat .chat-title h4 {
  font-size: 18px;
  font-weight: 600;
  color: #262A2A;
}
.main-chat-blk .video-call-chat .chat-title span {
  font-size: 12px;
  font-weight: 400;
  color: #262A2A;
}
.main-chat-blk .chat.video-call-chat .chat-body {
  background-image: none;
}
.main-chat-blk .chat.video-call-chat .chat-body .messages .chats .message-content {
  background: #F5F5F5;
}
.main-chat-blk .chat.video-call-chat .chat-body .messages .chats.chats-right .message-content {
  background: #F8ECFF;
}
.main-chat-blk .member-details {
  margin-bottom: 10px;
}
.main-chat-blk .chat-member-details {
  padding: 0 24px;
}
.main-chat-blk .chat-member-details .member-details ul {
  padding: 0;
  border-bottom: 1px solid #EDEDED;
}
.main-chat-blk .chat-member-details .member-details ul li {
  list-style: none;
  margin-bottom: 15px;
}
.main-chat-blk .chat-member-details .member-details ul li h6 {
  font-size: 15px;
  font-weight: 400;
  color: #262A2A;
  margin-bottom: 5px;
}
.main-chat-blk .chat-member-details .member-details ul li h5 {
  font-size: 15px;
  font-weight: 500;
  color: #262A2A;
  margin-bottom: 0px;
}
.main-chat-blk .chat-member-details .member-details ul li span {
  font-size: 16px;
  font-weight: 400;
  color: #262A2A;
}
.main-chat-blk .chat-member-details .member-details ul li a {
  font-size: 15px;
  font-weight: 500;
  color: #323737;
  border-radius: 100px;
  padding: 5px;
  background: #F5F5F5;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-chat-blk .chat-member-details .member-details ul li a:hover {
  color: #262A2A;
}
.main-chat-blk .chat-member-details .member-details ul li a + a {
  margin-left: 10px;
}
.main-chat-blk .right-sidebar.show-right-sidebar {
  margin-right: 0;
}
.main-chat-blk .right-sidebar.video-right-sidebar.show-right-sidebar {
  margin-right: 0;
}
.main-chat-blk .right-sidebar.hide-right-sidebar {
  margin-right: -320px;
}
.main-chat-blk .right-sidebar.video-right-sidebar.hide-right-sidebar {
  margin-right: -371px;
}
.main-chat-blk .status-modal .custom-status-close {
  width: 25px;
  height: 25px;
  border-radius: 25px;
  color: #262A2A;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
  align-items: center;
  -webkit-align-items: center;
  background-color: #C0C0C0;
  border-color: #C0C0C0;
}
.main-chat-blk .group-description .description-sub h5 span a {
  width: 25px;
  height: 25px;
  border-radius: 25px;
  color: #262A2A;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
  align-items: center;
  -webkit-align-items: center;
  border-color: #C0C0C0;
}
.main-chat-blk .list_group_notread {
  color: #E94C39 !important;
}
.main-chat-blk .chat-cont-type {
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-chat-blk .chat-cont-type .chat-type-wrapper {
  margin-bottom: 0;
}
.main-chat-blk .chat-cont-type .chat-type-wrapper p {
  color: #6F7A7A;
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 0;
}
.main-chat-blk .group-type-radio {
  display: block;
  position: relative;
  padding-left: 35px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  user-select: none;
  font-size: 16px;
  font-weight: 400;
  color: #262A2A;
  margin-right: 24px;
}
.main-chat-blk .group-type-radio input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}
.main-chat-blk .group-type-radio input:checked ~ .checkmark {
  background-color: #323737;
}
.main-chat-blk .group-type-radio input:checked ~ .checkmark:after {
  display: block;
}
.main-chat-blk .group-type-radio .checkmark:after {
  top: 4px;
  left: 4px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: white;
}
.main-chat-blk .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 22px;
  width: 22px;
  background-color: #FFF;
  border: 1px solid #E4E4E4;
  border-radius: 50%;
}
.main-chat-blk .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.main-chat-blk .pass-login label {
  color: #262A2A;
  font-size: 14px;
  font-weight: 500;
}
.main-chat-blk .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #323737 !important;
}
.main-chat-blk .right-sidebar-profile > .avatar {
  background: rgba(66, 11, 161, 0.1);
}
.main-chat-blk .group_img {
  position: relative;
  display: inline-block;
}
.main-chat-blk .group-name-search {
  margin-bottom: 14px;
}
.main-chat-blk .parti-wrapper {
  margin-bottom: 14px;
  display: flex;
  align-items: center;
}
.main-chat-blk .group_header {
  width: 38px !important;
  height: 38px !important;
  border: 2px solid #FFF;
}
.main-chat-blk .last-chat-time i.missed-col {
  width: 17px;
  display: inline-block;
  margin-top: 10px;
}
.main-chat-blk .last-chat-time i.missed-col img {
  max-width: 100%;
  height: auto;
}
.main-chat-blk .right-sidebar-head {
  padding: 0px 24px;
}
.main-chat-blk .right-sidebar-head h5 {
  font-size: 15px;
  font-weight: 600;
  color: #262A2A;
  margin-bottom: 0px;
}
.main-chat-blk .right-sidebar-head.share-media .share-media-blk {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs {
  border-bottom: 1px solid #EDEDED;
  padding-bottom: 10px;
  margin-bottom: 15px;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .nav-tabs {
  margin-bottom: 15px;
  padding: 5px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .nav .nav-item.active {
  background: #E41F07;
  border-radius: 6px;
  color: #262A2A;
  color: #FFF;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .nav .nav-item {
  padding: 2px 10px;
  font-size: 14px;
  color: #262A2A;
  font-weight: 500;
  border: 0;
  margin-right: 10px;
  background: #F9F9FC;
  color: #262A2A;
  border-radius: 6px;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .nav .nav-item:last-child {
  margin-right: 0px;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .share-media-img li {
  margin: 0px 6px 6px 0px;
  position: relative;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .share-media-img li img {
  border-radius: 8px;
  width: 84px;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .share-media-img li span {
  position: absolute;
  color: #FFF;
  font-size: 13px;
  font-weight: 500;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .share-media-img li span i {
  font-size: 20px;
  color: #FFF;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .share-media-img li:hover span i {
  color: #898989;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .share-media-img li.blur-media img {
  filter: blur(2px);
}
.main-chat-blk .media-file {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-bottom: 15px;
}
.main-chat-blk .media-file:last-child {
  margin-bottom: 0;
}
.main-chat-blk .media-doc-blk {
  display: flex;
  align-items: center;
}
.main-chat-blk .media-doc-blk span {
  width: 50px;
  height: 50px;
  border-radius: 5px;
  background: #F5F5F5;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  margin-right: 10px;
}
.main-chat-blk .media-doc-blk span i {
  font-size: 24px;
}
.main-chat-blk .document-detail ul {
  padding: 0;
  margin-bottom: 0;
  display: flex;
  align-items: center;
}
.main-chat-blk .document-detail ul li {
  list-style: none;
  color: #262A2A;
  font-size: 14px;
  font-weight: 400;
  position: relative;
}
.main-chat-blk .document-detail ul li::before {
  content: "";
  position: absolute;
  width: 1px;
  height: 13px;
  background: #C2C2C2;
  right: -8px;
  top: 5px;
}
.main-chat-blk .document-detail ul li:last-child::before {
  display: none;
}
.main-chat-blk .document-detail ul li + li {
  padding-left: 15px;
}
.main-chat-blk .document-detail h6 {
  color: #262A2A;
  font-size: 15px;
  font-weight: 500;
}
.main-chat-blk .media-download a {
  color: #262A2A;
}
.main-chat-blk .social-media-col {
  margin-top: 35px;
}
.main-chat-blk .social-media-col:after {
  content: "";
  display: table;
  clear: both;
}
.main-chat-blk .social-media-col ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.main-chat-blk .social-media-col ul li {
  float: left;
}
.main-chat-blk .social-media-col ul li a {
  color: #676DFF;
  font-size: 18px;
}
.main-chat-blk .social-media-col ul li + li {
  margin-left: 10px;
}
.main-chat-blk .social-media-col h6 {
  font-weight: 600;
  color: #000;
  font-size: 15px;
  margin-bottom: 20px;
}
.main-chat-blk .media-link-grp {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.main-chat-blk .media-link-detail h6 a {
  color: #262A2A;
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 5px;
}
.main-chat-blk .media-link-detail span a {
  color: #262A2A;
  font-size: 14px;
  font-weight: 400;
  word-break: break-all;
}
.main-chat-blk .media-link-detail a:hover {
  color: #323737;
}
.main-chat-blk .share-media-blk a {
  color: #323737;
  font-weight: 500;
}
.main-chat-blk .link-img {
  flex-shrink: 0;
}
.main-chat-blk .link-img img {
  border-radius: 4px;
  margin-right: 10px;
}
.main-chat-blk .settings-col {
  margin-top: 35px;
}
.main-chat-blk .settings-col h6 {
  font-weight: 600;
  color: #000;
  font-size: 15px;
  margin-bottom: 20px;
}
.main-chat-blk .settings-col:after {
  content: "";
  display: table;
  clear: both;
}
.main-chat-blk .settings-col ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.main-chat-blk .settings-col ul li {
  color: #565E5E;
  font-weight: 500;
}
.main-chat-blk .settings-col ul li + li {
  margin-top: 15px;
}
.main-chat-blk .settings-col .switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 23px;
  margin-bottom: 0;
  margin-right: 10px;
}
.main-chat-blk .settings-col .switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.main-chat-blk .settings-col .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #6F7A7A;
  transition: 0.4s;
}
.main-chat-blk .settings-col .slider:before {
  position: absolute;
  content: "";
  height: 15px;
  width: 15px;
  left: 4px;
  bottom: 4px;
  background-color: #FFF;
  transition: 0.4s;
}
.main-chat-blk .settings-col input:checked + .slider {
  background-color: #339DFF;
}
.main-chat-blk .settings-col input:checked + .slider:before {
  transform: translateX(16px);
}
.main-chat-blk .settings-col input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}
.main-chat-blk .settings-col .slider.round {
  border-radius: 34px;
}
.main-chat-blk .settings-col .slider.round:before {
  border-radius: 50%;
}
.main-chat-blk .report-col {
  margin-top: 35px;
  padding: 12px;
  padding-bottom: 50px;
}
.main-chat-blk .report-col:after {
  content: "";
  display: table;
  clear: both;
}
.main-chat-blk .report-col ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.main-chat-blk .report-col ul:after {
  content: "";
  display: table;
  clear: both;
}
.main-chat-blk .report-col ul li {
  display: block;
  width: 100%;
  font-weight: 500;
  position: relative;
}
.main-chat-blk .report-col ul li a {
  color: #FC0027;
  padding-left: 25px;
}
.main-chat-blk .report-col ul li a span {
  position: absolute;
  left: 0;
  top: 0px;
  font-size: 16px;
}
.main-chat-blk .report-col ul li + li {
  margin-top: 19px;
}
.main-chat-blk .load-more-btn {
  font-weight: 600;
  margin-top: 10px;
}
.main-chat-blk .load-more-btn i {
  background: #0057FF;
  border-radius: 50%;
  height: 12px;
  width: 12px;
  color: #FFF;
  line-height: 8px;
  font-size: 12px;
  vertical-align: top;
}
.main-chat-blk .chat-message-grp.chat-encrypt {
  padding-bottom: 0;
}
.main-chat-blk .chat-message-grp.chat-encrypt ul {
  border-bottom: 1px solid #EDEDED;
  padding-bottom: 15px;
  margin-bottom: 15px;
}
.main-chat-blk .participants-list {
  padding: 0px 24px;
}
.main-chat-blk .participants-list .participants-list-group h6.parti-search {
  font-size: 20px !important;
  display: flex;
  align-items: center;
}
.main-chat-blk .participants-list ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.main-chat-blk .participants-list ul li {
  border: 1px solid #E0E0E0;
  border-radius: 5px;
  background-color: #FFF;
  padding: 10px;
}
.main-chat-blk .participants-list ul li + li {
  margin-top: 10px;
}
.main-chat-blk .participants-list .users-list-body {
  flex: 1 1;
  position: relative;
  min-width: 0px;
  display: flex;
  display: -webkit-flex;
  width: 100%;
}
.main-chat-blk .participants-list .users-list-body h5 {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 5px;
  color: #262A2A;
}
.main-chat-blk .participants-list .users-list-body p {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-bottom: 0;
  color: #262A2A;
  font-size: 14px;
  font-weight: 400;
}
.main-chat-blk .participants-list .admin-profiles {
  display: inline-block;
  color: #323737;
  border-radius: 6px;
  font-size: 12px;
  padding: 2px 10px;
  font-weight: 500;
  background: #F8ECFF;
}
.main-chat-blk .participants-list .admin-profiles:hover {
  background: #680A83;
  color: #FFF;
}
.main-chat-blk .participants-list-group {
  border-bottom: 1px solid #EDEDED;
  padding-bottom: 15px;
  margin-bottom: 15px;
}
.main-chat-blk .participants-list-group h6 {
  margin-bottom: 15px;
  font-size: 15px;
  font-weight: 500;
  color: #262A2A;
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.main-chat-blk .chat-message-grp.group-exits {
  padding: 0px 24px;
  padding-bottom: 30px;
}
.main-chat-blk .grp-delete .chat-action-col {
  display: flex;
  align-items: center;
  height: 100%;
}
.main-chat-blk .grp-delete .chat-action-col > a {
  color: #6F7A7A;
}
.main-chat-blk .chat-action-col > a {
  color: #262A2A;
}
.main-chat-blk .darkmode-btn {
  width: 35px;
  height: 32px;
  background-color: #339DFF;
  border: 1px solid #FBFBFB;
  border-radius: 5px;
  color: #FFF;
  font-size: 16px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  margin: 0 auto;
}
.main-chat-blk .darkmode-btn:hover {
  color: #FFF;
}
.main-chat-blk .darkmode-btn:focus {
  color: #FFF;
}
.main-chat-blk .add-contacts-btn {
  width: 25px;
  height: 25px;
  border-radius: 30px;
  background-color: #323737;
  color: #FFF;
  font-size: 10px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  margin: 0 auto;
}
.main-chat-blk .add-contacts-btn:hover {
  color: #FFF;
}
.main-chat-blk .add-contacts-btn:focus {
  color: #FFF;
}
.main-chat-blk .group-call-tab .nav-tabs .nav-link {
  color: #323737;
  border: 0;
  border-radius: 10px;
  font-weight: 500;
  padding: 6px 25px;
}
.main-chat-blk .group-call-tab .nav-tabs .nav-link:hover {
  color: #323737;
}
.main-chat-blk .group-call-tab .nav-tabs .nav-link + .nav-link {
  margin-left: 10px;
}
.main-chat-blk .group-call-tab .nav-tabs .nav-link.active {
  background-color: rgba(90, 7, 139, 0.1);
  color: #323737;
}
.main-chat-blk .group-call-tab nav {
  padding: 0 15px 20px;
  position: relative;
}
.main-chat-blk .group-call-tab nav:before {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: #6F6F6F;
  height: 1px;
}
.main-chat-blk .header_image {
  width: 195px;
}
.main-chat-blk .chat_avator_img {
  position: relative;
}
.main-chat-blk .group_img {
  width: 40px;
  height: 40px;
  object-fit: cover;
}
.main-chat-blk .dreams_chat {
  width: 40px;
  height: 40px;
  object-fit: cover;
}
.main-chat-blk .voice_pop {
  padding-right: 17px;
}
.main-chat-blk .status_carousel {
  margin-top: 50px;
}
.main-chat-blk .carousel_img {
  width: 650px;
  height: 434px;
}
.main-chat-blk .video_content {
  min-height: 200px;
  margin-top: 70px;
}
.main-chat-blk .voice-call-content {
  min-height: 200px;
}
.main-chat-blk .chatimage img {
  width: 120px;
  height: 120px;
}
.main-chat-blk .send-btn_status {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: #FFF !important;
  background-color: #FFA977 !important;
  margin-left: 15px;
  font-size: 22px;
}
.main-chat-blk .status_telegram {
  color: #FFF;
}
.main-chat-blk .media-lists {
  display: flex;
  justify-content: flex-start;
  margin: 0 -5px 0px;
  flex-wrap: wrap;
}
.main-chat-blk .media-lists .media-image {
  margin: 5px;
  flex-basis: 74px;
  min-width: 74px;
}
.main-chat-blk .media-lists .media-image img {
  max-width: 100%;
}
.main-chat-blk .avatar-group .avatar + .avatar {
  margin-left: -0.75rem;
}
.main-chat-blk .list-group-item {
  background-color: inherit;
  border-color: #ebebeb;
}
.main-chat-blk ul.list-inline .list-inline-item {
  margin-bottom: 0.5rem;
}
.main-chat-blk .form-control {
  border-radius: 5px;
}
.main-chat-blk .form-control:focus {
  box-shadow: none;
  border-color: #e6e6e6;
}
.main-chat-blk .custom-control-label {
  line-height: 25px;
}
.main-chat-blk .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #0a80ff;
}
.main-chat-blk .open_drop {
  color: #FFF !important;
}
.main-chat-blk .send-btn_status:focus {
  box-shadow: none !important;
  border-color: #ffa977 !important;
}
.main-chat-blk .avatar {
  display: inline-block;
  margin-bottom: 0;
  height: 48px;
  width: 48px;
  border-radius: 50%;
}
.main-chat-blk .avatar .avatar-title {
  color: #FFF;
  background: #680A83;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  font-size: 19px;
  font-weight: 600;
}
.main-chat-blk .avatar > a {
  width: 100%;
  height: 100%;
  display: block;
  transition: color 0.3s;
  color: #0a80ff;
}
.main-chat-blk .avatar > a > img,
.main-chat-blk .avatar > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.main-chat-blk .avatar.avatar-sm {
  height: 1.3rem;
  width: 1.3rem;
}
.main-chat-blk .avatar.avatar-sm .avatar-title {
  font-size: 14px;
}
.main-chat-blk .avatar.avatar-lg {
  height: 3.8rem;
  width: 3.8rem;
}
.main-chat-blk .avatar.avatar-lg .avatar-title {
  font-size: 29px;
}
.main-chat-blk .avatar.avatar-xl {
  height: 100px;
  width: 100px;
}
.main-chat-blk .header_drop_icon {
  border-radius: 6px;
}
.main-chat-blk .accordion-col .accordion-title {
  cursor: pointer;
  padding: 15px 0 8px;
}
.main-chat-blk .accordion-col .accordion-title .primary-title i {
  transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
}
.main-chat-blk .accordion-col .accordion-title.active .primary-title i {
  transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  transform: rotate(270deg);
  -webkit-transform: rotate(270deg);
  -ms-transform: rotate(270deg);
}
.main-chat-blk .accordion-col .accordion-content {
  border-bottom: 1px solid #e6e6e6;
  padding-bottom: 15px;
}
.main-chat-blk .accordion-col .accordion-content:last-child {
  border-bottom: 0;
}
.main-chat-blk .accordion-col .accordion-content h6 {
  font-size: 14px;
}
.main-chat-blk .status-right {
  font-weight: 500;
  color: #444444;
  font-size: 16px;
  text-align: center;
}
.main-chat-blk .status-right p {
  margin-top: 20px;
  margin-bottom: 0;
}
.main-chat-blk .star-drop .btn-outline-light {
  color: #424242;
  border: 0;
  padding: 0;
}
.main-chat-blk .star-drop .btn-outline-light i {
  font-size: 20px;
}
.main-chat-blk .star-drop .btn.btn-outline-light:hover {
  background: transparent;
  border: 0;
}
.main-chat-blk .chat.star-chat-group {
  background-image: none;
}
.main-chat-blk .chat.star-chat-group .chat-body {
  background-image: none;
}
.main-chat-blk .chat.star-chat-group .chat-body .messages .chats {
  max-width: 100%;
}
.main-chat-blk .chat.star-chat-group .chat-body .messages .chats .message-content {
  background: #F5F5F5;
}
.main-chat-blk .chat.star-chat-group .chat-body .messages .chats .message-content.award-link a {
  word-break: break-all;
}
.main-chat-blk .chat.star-chat-group .chat-body .messages .chats .message-content.award-link img {
  max-width: 100%;
}
.main-chat-blk .chat .chat-body .messages .chats.forward-chat-msg {
  display: none;
}
.main-chat-blk .chats.forward-chat-msg {
  background: #EDEDED;
  border-radius: 15px;
  padding: 20px;
  border-left: 2px solid #680A83;
}
.main-chat-blk .chats.forward-chat-msg .chat-avatar {
  padding: 0;
  padding-right: 15px;
}
.main-chat-blk .chat-title h4 a {
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  color: #4B0973;
  margin-bottom: 0;
}
.main-chat-blk .left-chat-title .add-section > a {
  width: 30px;
  height: 30px;
  background-color: #680A83;
  border-radius: 30px;
  color: #FFF;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  font-size: 13px;
}
.main-chat-blk .add-section ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.main-chat-blk .add-section ul li {
  float: left;
  border-radius: 50px;
  width: 28px;
  height: 28px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
}
.main-chat-blk .add-section ul li + li {
  margin-left: 10px;
}
.main-chat-blk .add-section ul li a {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  font-size: 20px;
}
.main-chat-blk .all-chats .add-section ul li:hover {
  background-color: #F5F5F5;
  border-color: #F5F5F5;
}
.main-chat-blk .online {
  color: #008024;
  font-weight: 500;
}
.main-chat-blk .top-online-contacts {
  padding: 24px 24px 0px;
}
.main-chat-blk .fav-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-bottom: 15px;
}
.main-chat-blk .fav-title h6 {
  margin-bottom: 0;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
}
.main-chat-blk .fav-title h6 i {
  font-size: 22px;
}
.main-chat-blk .fav-title a {
  margin-bottom: 0;
  color: #E41F07;
  font-weight: 500;
}
.main-chat-blk .fav-title a:hover {
  color: #0A0A0A;
}
.main-chat-blk .top-contacts-box .profile-img {
  position: relative;
  width: 46px;
  height: 46px;
}
.main-chat-blk .top-contacts-box .profile-img img {
  max-width: 100%;
  height: auto;
  border-radius: 50px;
}
.main-chat-blk .profile-name span {
  color: #585858;
  font-size: 12px;
  display: inline-block;
  margin-top: 9px;
}
.main-chat-blk .top-contacts-box .profile-img.online:before {
  content: "";
  position: absolute;
  right: 0;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  top: 0px;
  background-color: #49E073;
  width: 10px;
  height: 10px;
  border: 2px solid #FFF;
  border-radius: 50px;
}
.main-chat-blk .dropdown-menu .dropdown-item span.edit-profile-icon,
.main-chat-blk .dropdown-menu .dropdown-item span.profile-icon-col {
  font-size: 15px;
}
.main-chat-blk .avatar {
  position: relative;
  display: inline-block;
  width: 46px;
  height: 46px;
  flex-shrink: 0;
}
.main-chat-blk .avatar > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.main-chat-blk .avatar-title {
  width: 100%;
  height: 100%;
  background-color: #650681;
  color: #FFF;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-chat-blk .avatar-away::before,
.main-chat-blk .avatar-offline::before,
.main-chat-blk .avatar-online::before {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 25%;
  height: 25%;
  border-radius: 50%;
  content: "";
  border: 2px solid #FFF;
}
.main-chat-blk .avatar-online::before {
  background-color: #00e65b;
}
.main-chat-blk .avatar-offline::before {
  background-color: #ff0100;
}
.main-chat-blk .avatar-away::before {
  background-color: #ffbc34;
}
.main-chat-blk .avatar .border {
  border-width: 3px !important;
}
.main-chat-blk .avatar .rounded {
  border-radius: 6px !important;
}
.main-chat-blk .avatar .avatar-title {
  font-size: 18px;
}
.main-chat-blk .avatar-xs {
  width: 1.65rem;
  height: 1.65rem;
}
.main-chat-blk .avatar-xs .border {
  border-width: 2px !important;
}
.main-chat-blk .avatar-xs .rounded {
  border-radius: 4px !important;
}
.main-chat-blk .avatar-xs .avatar-title {
  font-size: 10px;
}
.main-chat-blk .avatar-xs.avatar-away::before,
.main-chat-blk .avatar-xs.avatar-offline::before,
.main-chat-blk .avatar-xs.avatar-online::before {
  border-width: 1px;
}
.main-chat-blk .avatar-sm {
  width: 2.5rem;
  height: 2.5rem;
}
.main-chat-blk .avatar-sm .border {
  border-width: 3px !important;
}
.main-chat-blk .avatar-sm .rounded {
  border-radius: 4px !important;
}
.main-chat-blk .avatar-sm .avatar-title {
  font-size: 15px;
}
.main-chat-blk .avatar-sm.avatar-away::before,
.main-chat-blk .avatar-sm.avatar-offline::before,
.main-chat-blk .avatar-sm.avatar-online::before {
  border-width: 2px;
}
.main-chat-blk .avatar-lg {
  width: 3.75rem;
  height: 3.75rem;
}
.main-chat-blk .avatar-lg .border {
  border-width: 3px !important;
}
.main-chat-blk .avatar-lg .rounded {
  border-radius: 8px !important;
}
.main-chat-blk .avatar-lg .avatar-title {
  font-size: 24px;
}
.main-chat-blk .avatar-lg.avatar-away::before,
.main-chat-blk .avatar-lg.avatar-offline::before,
.main-chat-blk .avatar-lg.avatar-online::before {
  border-width: 3px;
}
.main-chat-blk .avatar-xl {
  width: 5rem;
  height: 5rem;
}
.main-chat-blk .avatar-xl .border {
  border-width: 4px !important;
}
.main-chat-blk .avatar-xl .rounded {
  border-radius: 8px !important;
}
.main-chat-blk .avatar-xl .avatar-title {
  font-size: 28px;
}
.main-chat-blk .avatar-xl.avatar-away::before,
.main-chat-blk .avatar-xl.avatar-offline::before,
.main-chat-blk .avatar-xl.avatar-online::before {
  border-width: 4px;
}
.main-chat-blk .avatar-xxl {
  width: 5.125rem;
  height: 5.125rem;
}
.main-chat-blk .avatar-xxl .border {
  border-width: 6px !important;
}
.main-chat-blk .avatar-xxl .rounded {
  border-radius: 8px !important;
}
.main-chat-blk .avatar-xxl .avatar-title {
  font-size: 30px;
}
.main-chat-blk .avatar-xxl.avatar-away::before,
.main-chat-blk .avatar-xxl.avatar-offline::before,
.main-chat-blk .avatar-xxl.avatar-online::before {
  border-width: 4px;
}
.main-chat-blk .avatar-group {
  display: flex;
  display: -webkit-flex;
  padding-left: 15px;
  margin-left: auto;
  margin-right: 15px;
  cursor: pointer;
}
.main-chat-blk .avatar-group .avatar + .avatar {
  margin-left: -0.75rem;
}
.main-chat-blk .avatar-group .avatar-xs + .avatar-xs {
  margin-left: -15px;
}
.main-chat-blk .avatar-group .avatar-sm + .avatar-sm {
  margin-left: -0.625rem;
}
.main-chat-blk .avatar-group .avatar-lg + .avatar-lg {
  margin-left: -1rem;
}
.main-chat-blk .avatar-group .avatar-xl + .avatar-xl {
  margin-left: -1.28125rem;
}
.main-chat-blk .avatar-group .avatar:hover {
  z-index: 1;
}
.main-chat-blk .avatar-group.group-col {
  display: block;
}
.main-chat-blk .avatar-group.group-col > div {
  display: flex;
  display: -webkit-flex;
  padding-bottom: 5px;
}
.main-chat-blk .avatar-group.group-col .avatar {
  margin-right: 0;
}
.main-chat-blk .contact-close {
  float: right;
  left: 95%;
  right: 0px;
  position: relative;
  top: 5%;
}
.main-chat-blk .status_contactclose {
  float: right;
  left: 95%;
  right: 0px;
  position: relative;
  top: 1%;
}
.main-chat-blk .status-active {
  border: 4px solid #650681;
}
.main-chat-blk .avatar.avatar-xl .avatar-title {
  font-size: 39px;
}
.main-chat-blk .nav.nav-tabs {
  border: none;
  line-height: 2;
}
.main-chat-blk .badge {
  padding: 5px 10px;
  font-size: 11px;
}
.main-chat-blk .badge.badge-success {
  background: #0abb87;
}
.main-chat-blk .badge.badge-danger {
  background: #fd397a;
}
.main-chat-blk .badge.badge-secondary {
  background: dimgray;
}
.main-chat-blk .badge.badge-info {
  background: #00bcd4;
}
.main-chat-blk .badge.badge-warning {
  background: #ffb822;
}
.main-chat-blk .badge.badge-dark {
  background: #3a3f51;
}
.main-chat-blk .badge.badge-primary {
  background: #0a80ff;
}
.main-chat-blk .badge.badge-light {
  background: #e6e6e6;
}
.main-chat-blk .btn {
  position: relative;
}
.main-chat-blk .btn .badge {
  padding: 2px 6px;
  right: 7px;
  top: -7px;
  position: absolute;
}
.main-chat-blk .input-group .input-group-text {
  font-size: 14px;
}
.main-chat-blk .tooltip > .tooltip-inner {
  text-align: left;
  max-width: 500px;
  --bs-tooltip-bg: \$primary;
}
.main-chat-blk .tooltip {
  --bs-tooltip-bg: \$primary;
}
.main-chat-blk .tooltip .arrow {
  display: none;
  background-color: #E41F07;
}
.main-chat-blk .tooltip .tooltip-inner {
  background-color: #E41F07;
}
.main-chat-blk .sticky-top {
  z-index: auto;
}
.main-chat-blk .tab-content {
  padding-top: 30px;
}
.main-chat-blk .tab-content .form-item {
  margin-bottom: 0.8rem;
}
.main-chat-blk .main-wrapper {
  height: 100vh;
  overflow: hidden;
}
.main-chat-blk .main-wrapper .content {
  display: flex;
  display: -webkit-flex;
}
@media (max-width: 991.98px) {
  .main-chat-blk .main-wrapper .content {
    display: block;
  }
}
.main-chat-blk .main-wrapper .content .sidebar-group {
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  position: relative;
  z-index: 99;
  width: 340px;
}
@media (max-width: 991.98px) {
  .main-chat-blk .main-wrapper .content .sidebar-group {
    width: 100%;
  }
}
@media (max-width: 575.98px) {
  .main-chat-blk .chats .chat-content {
    width: calc(100% - 55px);
  }
}
.main-chat-blk .main-wrapper .content .sidebar-group .sidebar {
  background: #FFF;
  overflow: hidden;
  width: 340px !important;
  display: flex;
  flex-direction: column;
  flex: 1 1;
  border-right: 1px solid rgb(224, 224, 224);
}
@media (max-width: 991.98px) {
  .main-chat-blk .main-wrapper .content .sidebar-group .sidebar {
    width: 100% !important;
  }
}
.main-chat-blk .main-wrapper .content .sidebar-group .sidebar:not(.active) {
  display: none;
}
.main-chat-blk .header-top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  font-weight: 600;
  background-color: #680A83;
}
.main-chat-blk .header-top .logo {
  margin-top: 0 !important;
}
.main-chat-blk .header-top > span {
  font-size: 22px;
}
.main-chat-blk .header-top ul {
  margin-bottom: 0;
  display: flex;
}
.main-chat-blk .header-top ul.header-action {
  margin-top: 14px !important;
}
.main-chat-blk .chat-header ul {
  margin-bottom: 0;
}
.main-chat-blk .chat-header ul li:not(.list-inline-item) {
  margin-bottom: 0;
  width: 48px;
  margin-right: 15px !important;
}
.main-chat-blk .chat-header ul li:last-child {
  margin-right: 0 !important;
}
.main-chat-blk .sidebar-body {
  flex: 1 1;
  overflow: auto;
  padding: 24px 24px 10px;
  width: 100%;
}
.main-chat-blk .pin-chat img {
  margin-right: 6px;
}
.main-chat-blk .sidebar-body .profile-name {
  font-weight: 600;
  color: #0A0A0A;
  font-size: 18px;
  margin-bottom: 0;
}
.main-chat-blk .online-profile {
  position: relative;
}
.main-chat-blk .online-profile span {
  position: relative;
  color: #565656;
  font-size: 13px;
  padding-left: 10px;
}
.main-chat-blk .online-profile span:before {
  content: "";
  position: absolute;
  left: 0;
  top: 7px;
  background-color: #49E073;
  width: 8px;
  height: 8px;
  border-radius: 50px;
}
.main-chat-blk .close_profile4 {
  color: #000;
  border-color: #e6e6e6;
}
.main-chat-blk .sidebar .user-list li a {
  padding: 10px;
  display: flex;
  display: -webkit-flex;
  cursor: pointer;
  margin-bottom: 15px;
  border: 1px solid #E0E0E0;
  box-shadow: none;
  border-radius: 5px;
  position: relative;
  transition: ease all 0.5s;
  -webkit-transition: ease all 0.5s;
  -ms-transition: ease all 0.5s;
}
.main-chat-blk .sidebar .user-list li a:hover {
  background-color: rgba(254, 159, 67, 0.08);
  border: 1px solid rgba(254, 159, 67, 0.08);
  transition: ease all 0.5s;
  -webkit-transition: ease all 0.5s;
  -ms-transition: ease all 0.5s;
}
.main-chat-blk .sidebar .user-list li.item-typing {
  background-color: #F1F6FF;
}
.main-chat-blk .sidebar .user-list li figure {
  margin-right: 1rem;
}
.main-chat-blk .sidebar .user-list li .users-list-body {
  flex: 1 1;
  position: relative;
  min-width: 0px;
  display: flex;
}
.main-chat-blk .lock-icon {
  color: #000000;
}
.main-chat-blk .sidebar .user-list li .users-list-body > div:first-child {
  min-width: 0;
  display: flex;
  flex-direction: column;
  flex: 1 1;
}
.main-chat-blk .parti-notify-check {
  margin-bottom: 0 !important;
  display: flex;
  align-items: center;
}
.main-chat-blk .sidebar .user-list li .users-list-body h5 {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 3px;
  color: #0A0A0A;
}
.main-chat-blk .sidebar .user-list li .users-list-body p {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-bottom: 0;
  color: #232323;
  font-size: 14px;
}
.main-chat-blk .sidebar .user-list li .users-list-body p.missed-call-col {
  color: #DE3E44;
}
.main-chat-blk .sidebar .user-list li .users-list-body .last-chat-time {
  padding-left: 15px;
  position: relative;
}
.main-chat-blk .sidebar .user-list li .users-list-body .last-chat-time .text-muted {
  color: #424242 !important;
  font-weight: 400;
  font-size: 12px;
  margin-bottom: 5px;
  display: block;
  text-align: right;
}
.main-chat-blk .sidebar .user-list li .users-list-body .last-chat-time .contact-toggle {
  color: #680A83;
}
.main-chat-blk .sidebar .user-list li .users-list-body .last-chat-time .new-message-count {
  width: 20px;
  height: 20px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  line-height: 0;
  font-size: 11px;
  background-color: #E41F07;
  color: #FFF;
  border-radius: 50%;
  margin-left: auto;
  margin-top: 10px;
  position: absolute;
  right: 0;
  bottom: 0;
}
.main-chat-blk .sidebar .user-list li .users-list-body .last-chat-time .chat-toggle {
  position: absolute;
  right: 0;
  bottom: 0;
  opacity: 0;
  text-align: right;
  transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  width: 18px;
  height: 24px;
}
.main-chat-blk .sidebar .user-list li.unread h5 {
  color: #FFF;
}
.main-chat-blk .sidebar .user-list li.unread p {
  color: #FFF;
}
.main-chat-blk .sidebar .user-list li.unread .text-muted {
  color: rgba(255, 255, 255, 0.4) !important;
}
.main-chat-blk .sidebar .user-list li.user-list-item.item-typing .users-list-body p {
  color: #0D9B35;
}
.main-chat-blk .rightside_tab {
  padding-top: 5px !important;
}
.main-chat-blk .chat-pin {
  display: flex;
  align-items: center;
  justify-content: end;
  -webkit-justify-content: end;
  -ms-flex-pack: end;
}
.main-chat-blk .chat-pin .green-check {
  color: #0D9B35;
}
.main-chat-blk .chat-pin img {
  width: 10px;
}
.main-chat-blk .chat-pin .check {
  color: #53BDEB;
}
.main-chat-blk .select-message-box {
  margin-top: 50px;
}
.main-chat-blk .select-message-box h4 {
  margin-bottom: 5px;
}
.main-chat-blk .select-message-box p {
  margin-top: 0;
  margin-bottom: 24px;
  color: #424242;
  font-size: 16px;
  font-weight: 400;
}
.main-chat-blk .select-message-box .btn i {
  font-size: 15px;
}
.main-chat-blk .group-description {
  padding: 0px 24px;
}
.main-chat-blk .group-description .description-sub {
  border-bottom: 1px solid #EDEDED;
  padding-bottom: 15px;
  margin-bottom: 15px;
}
.main-chat-blk .group-description h5 {
  font-size: 15px;
  font-weight: 500;
  color: #0A0A0A;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.main-chat-blk .group-description h5 a:hover {
  color: #650681 !important;
}
.main-chat-blk .group-description p {
  color: #424242;
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 10px;
}
.main-chat-blk .group-description p.description-date {
  color: #424242;
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 0px;
}
.main-chat-blk .encrypted-message p {
  font-size: 12px;
  color: #424242;
  font-weight: 400;
  margin-bottom: 0;
}
.main-chat-blk .group-view-all {
  margin-top: 10px;
}
.main-chat-blk .group-view-all a {
  color: #680A83;
  font-size: 14px;
  font-weight: 500;
}
.main-chat-blk .group-view-all a:hover {
  color: #0A0A0A;
}
.main-chat-blk .exit-bg-message {
  background: #FFE8E9;
}
.main-chat-blk .exit-bg-message i {
  color: #DE3E44;
}
.main-chat-blk .disapper-message {
  background: #E7FAF2;
}
.main-chat-blk .disapper-message i {
  color: #1BA345;
}
.main-chat-blk .group-setting-msg {
  background: #F8ECFF;
}
.main-chat-blk .group-setting-msg i {
  color: #680A83;
}
.main-chat-blk .group-setting .stared-group span {
  width: 50px;
  height: 50px;
}
.main-chat-blk .edit-set-details p {
  font-size: 14px;
  font-weight: 400;
  color: #424242;
  margin-bottom: 0;
}
.main-chat-blk .group-send-msg {
  background: #FEF6DC;
}
.main-chat-blk .parcipant-check p a {
  color: #680A83;
}
.main-chat-blk .select-group-chat .dropdown-toggle::after {
  display: none;
}
.main-chat-blk .select-group-chat .dropdown-toggle i {
  margin-left: 15px;
}
.main-chat-blk .select-group-chat .dropdown-toggle:hover {
  color: #0A0A0A;
}
.main-chat-blk .select-group-chat .dropdown-toggle {
  font-weight: 600;
  color: #0A0A0A;
  font-size: 18px;
}
.main-chat-blk .select-group-chat .dropdown-menu .dropdown-item {
  font-size: 14px;
  font-weight: 400;
  color: #0A0A0A;
}
.main-chat-blk .select-group-chat .dropdown-menu li:first-child .dropdown-item:hover {
  border-radius: 5px 5px 0 0;
}
.main-chat-blk .select-group-chat .dropdown-menu li:last-child .dropdown-item:hover {
  border-radius: 0 0 5px 5px;
}
.main-chat-blk .dropzone {
  background: #FFF;
  border: 1px dashed #C2C2C2;
  border-radius: 5px;
  padding: 10px;
  min-height: 70px;
  text-align: center;
}
.main-chat-blk .dropzone.dz-clickable .dz-message {
  display: none;
}
.main-chat-blk .dropzone p {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 500;
  color: #0A0A0A;
}
.main-chat-blk .dropzone span {
  color: #424242;
  font-size: 14px;
  font-weight: 400;
}
.main-chat-blk .uplaod-image img {
  border-radius: 20px;
}
.main-chat-blk .upload-img-file .modal-body {
  padding: 0;
}
.main-chat-blk .upload-img-file .modal-content {
  position: relative;
}
.main-chat-blk .upload-img-file .modal-header {
  position: absolute;
  top: 0;
  z-index: 9;
  left: 0;
  right: 0;
}
.main-chat-blk .upload-image-list {
  display: flex;
  align-items: center;
}
.main-chat-blk .upload-image-list li + li {
  margin-left: 10px;
}
.main-chat-blk .upload-img-file .modal-header .close {
  background-color: transparent;
  color: #FFF;
}
.main-chat-blk .check-star i {
  color: #FEC001;
}
.main-chat-blk .emoj-group-list {
  display: none;
  position: absolute;
  top: -50px;
  left: -90px;
  transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
}
.main-chat-blk .emoj-group-list ul {
  display: flex;
  align-items: center;
  background: #f6f7f8;
  border-radius: 50px;
  padding: 5px;
}
.main-chat-blk .emoj-group-list ul li a {
  padding: 0;
}
.main-chat-blk .emoj-group-list ul li.add-emoj a {
  background: #EDEDED;
}
.main-chat-blk .emoj-group-list ul li.add-emoj a i {
  font-size: 20px;
  color: #424242;
}
.main-chat-blk .chat .slimscroll {
  height: calc(100vh - 60px) !important;
}
.main-chat-blk .settings-option {
  display: none;
  text-align: right;
}
.main-chat-blk .settings-option a {
  font-size: 15px;
  font-weight: 500;
  color: #680A83;
}
.main-chat-blk .empty-dark-img {
  display: none;
}
.main-chat-blk .bootstrap-datetimepicker-widget span {
  position: relative;
}

.chat-window .card .card-header {
  background-color: #FFF;
  border-bottom: 1px solid #898989;
}
.chat-window .badge-success {
  background-color: #5CB85C !important;
}

.chat-page .footer {
  display: none;
}

.chat-search .input-group .form-control {
  margin: 0;
  padding: 0 0 0 36px;
  height: 46px;
}
.chat-search .input-group .input-group-prepend {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  color: #424848;
  pointer-events: none;
  z-index: 4;
  position: absolute;
  top: 0;
  right: 15px;
  bottom: 0;
}

.chat-cont-left .chat-scroll {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
  padding: 0;
}
.chat-cont-left .chat-scroll .media {
  border-bottom: 1px solid #898989;
  margin: 0;
  padding: 10px;
  transition: all 0.2s;
}
.chat-cont-left .chat-scroll .media.active {
  background-color: #C0C0C0;
}
.chat-cont-left .chat-scroll .media:hover {
  background-color: #C0C0C0;
}
.chat-cont-left .chat-scroll .media .media-img-wrap {
  margin: 0 15px 0 0;
  position: relative;
}
.chat-cont-left .chat-scroll .media .media-img-wrap .avatar > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.chat-cont-left .chat-scroll .media .media-body {
  display: flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.chat-cont-left .chat-scroll .media .media-body .user-name {
  max-width: 170px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #262A2A;
  font-size: 16px;
  font-weight: 700;
}
.chat-cont-left .chat-scroll .media .media-body .user-last-chat {
  color: #323737;
  font-size: 14px;
  line-height: 24px;
  max-width: 170px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.chat-cont-left .chat-scroll .media .media-body .last-chat-time {
  color: #565E5E;
  font-size: 13px;
}
.chat-cont-left .chat-scroll .media .media-body div:last-child {
  text-align: right;
}

.chat-cont-right {
  transition: all 0.4s;
}
.chat-cont-right .chat-scroll {
  max-height: calc(100vh - 293px);
  overflow-y: auto;
}
.chat-cont-right .msg_head .back-user-list {
  display: none;
  margin: 0 0 0 -10px;
  padding: 0 10px;
}
.chat-cont-right .img_cont {
  position: relative;
  height: 45px;
  width: 45px;
}
.chat-cont-right .img_cont .user_img {
  height: 45px;
  min-width: 45px;
  width: 45px;
  border: 1.5px solid #E41F07;
}
.chat-cont-right .user_info {
  margin: 0 auto 0 15px;
  padding: 0;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.chat-cont-right ul.list-unstyled {
  margin: 0 auto;
  padding: 0;
  width: 100%;
}
.chat-cont-right ul.list-unstyled .media.sent {
  margin-bottom: 20px;
}
.chat-cont-right ul.list-unstyled .media.sent .avatar {
  order: 3;
  height: 30px;
  width: 30px;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  margin: 0 20px 0 0;
  padding: 0;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .msg-box {
  margin: 0;
  padding: 0 0 0 50px;
  position: relative;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .msg-box + .msg-box {
  margin: 5px 0 0;
  padding: 0;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .msg-box p {
  margin: 0;
  padding: 0;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .msg-box:first-child::before {
  border-bottom: 6px solid transparent;
  border-left: 6px solid #e3e3e3;
  border-top: 6px solid #e3e3e3;
  border-right: 6px solid transparent;
  content: "";
  height: 0;
  width: 0;
  position: absolute;
  top: 0;
  right: -12px;
  left: auto;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .msg-box > div {
  margin: 0;
  padding: 10px 15px;
  border-radius: 10px;
  background-color: #e3e3e3;
  display: inline-block;
  position: relative;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .msg-box:first-child > div {
  border-radius: 10px 0 10px 10px;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-attachments {
  display: flex;
  margin: 0 -1px;
  padding: 4px 0;
  width: 100%;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-attachments .chat-attachment {
  position: relative;
  max-width: 130px;
  overflow: hidden;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-attachments .chat-attachment:before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #000;
  content: "";
  opacity: 0.4;
  transition: all 0.4s;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-attachments .chat-attachment:hover .chat-attach-download {
  opacity: 1;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-attachments > div {
  margin: 0 1px;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-attachments img {
  max-width: 100%;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-attachments .chat-attach-download {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: all 0.4s;
  color: #FFF;
  width: 32px;
  line-height: 32px;
  background: rgba(255, 255, 255, 0.2);
  text-align: center;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-info {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  margin: 5px 0 0;
  padding: 0;
  flex-wrap: wrap;
  clear: both;
  flex-direction: row-reverse;
  list-style: none;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-info li {
  margin: 0;
  padding: 0 0 0 16px;
  position: relative;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-info li:not(:last-child)::after {
  position: absolute;
  top: 50%;
  right: auto;
  left: 8px;
  transform: translate(-50%, -50%);
  background: #E41F07;
  content: "";
  height: 4px;
  width: 4px;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-info .chat-time {
  color: rgba(50, 65, 72, 0.4);
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-info a {
  color: #323737;
}
.chat-cont-right ul.list-unstyled .media.received {
  position: relative;
  margin-bottom: 20px;
}
.chat-cont-right ul.list-unstyled .media.received .media-body {
  position: relative;
  margin: 0 0 0 20px;
  padding: 0;
}
.chat-cont-right ul.list-unstyled .media.received .media-body::before {
  border-bottom: 6px solid transparent;
  border-right: 6px solid #E41F07;
  border-top: 6px solid #E41F07;
  border-left: 6px solid transparent;
  content: "";
  height: 0;
  position: absolute;
  top: 0px;
  right: auto;
  left: -6px;
  width: 0;
}
.chat-cont-right ul.list-unstyled .media.received .media-body > div {
  margin: 0;
  padding: 10px 15px;
  border-radius: 10px;
  background-color: #E41F07;
  display: table;
  position: relative;
}
.chat-cont-right ul.list-unstyled .media.received .media-body > div p {
  color: #FFF;
  margin: 0;
  padding: 0;
}
.chat-cont-right ul.list-unstyled .media.received .msg-box {
  display: block;
}
.chat-cont-right ul.list-unstyled .media.received .msg-box + .msg-box {
  margin-top: 5px;
}
.chat-cont-right ul.list-unstyled .media.received .chat-msg-info {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  flex-wrap: wrap;
  margin: 5px 0 0;
  padding: 0;
  clear: both;
  list-style: none;
}
.chat-cont-right ul.list-unstyled .media.received .chat-msg-info .chat-time {
  color: rgba(255, 255, 255, 0.8);
}
.chat-cont-right ul.list-unstyled .media.received .chat-msg-attachments {
  display: flex;
  margin: 0 -1px;
  padding: 4px 0;
  width: 100%;
}
.chat-cont-right ul.list-unstyled .media.received .chat-msg-attachments .chat-attachment {
  position: relative;
  max-width: 130px;
  overflow: hidden;
}
.chat-cont-right ul.list-unstyled .media.received .chat-msg-attachments .chat-attachment:before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #000;
  content: "";
  opacity: 0.4;
  transition: all 0.4s;
}
.chat-cont-right ul.list-unstyled .media.received .chat-msg-attachments .chat-attachment:hover .chat-attach-download {
  opacity: 1;
}
.chat-cont-right ul.list-unstyled .media.received .chat-msg-attachments > div {
  margin: 0 1px;
}
.chat-cont-right ul.list-unstyled .media.received .chat-msg-attachments img {
  max-width: 100%;
}
.chat-cont-right ul.list-unstyled .media.received .chat-msg-attachments .chat-attach-download {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transition: all 0.4s;
  opacity: 0;
  color: #FFF;
  width: 32px;
  line-height: 32px;
  background: rgba(255, 255, 255, 0.2);
  text-align: center;
}
.chat-cont-right ul.list-unstyled .chat-date {
  font-size: 14px;
  margin: 1.875rem 0;
  overflow: hidden;
  position: relative;
  text-align: center;
  text-transform: capitalize;
}
.chat-cont-right ul.list-unstyled .chat-date:before {
  background-color: #e0e3e4;
  content: "";
  height: 1px;
  margin-right: 28px;
  position: absolute;
  top: 50%;
  right: 50%;
  width: 100%;
}
.chat-cont-right ul.list-unstyled .chat-date:after {
  background-color: #e0e3e4;
  content: "";
  height: 1px;
  margin: 0 0 0 28px;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
}

.card-footer {
  background-color: #FFF;
  border-top: 1px solid #898989;
  margin: 0;
  padding: 1rem 1.5rem;
}
.card-footer .type_msg {
  background-color: rgba(0, 0, 0, 0.1) !important;
  border: 0 !important;
  overflow-y: auto;
}

@media (max-width: 992px) {
  .chat-window.chat-slide .chat-cont-right {
    right: 0;
    opacity: 1;
    visibility: visible;
  }
  .chat-cont-right {
    position: absolute;
    right: -100px;
    opacity: 0;
    visibility: hidden;
    z-index: 99;
  }
  .chat-cont-right .msg_head .back-user-list {
    display: flex;
    align-items: center;
  }
}
.page-header .breadcrumb {
  margin-bottom: 0;
}
.page-header h3 {
  font-weight: 700;
  color: #262A2A;
  font-size: 18px;
}
@media (max-width: 991.98px) {
  .page-header h3 {
    font-size: 14px;
  }
}
.page-header h4 {
  font-weight: 700;
  color: #262A2A;
  font-size: 18px;
  margin-bottom: 5px;
}
@media (max-width: 991.98px) {
  .page-header h4 {
    font-size: 18px;
  }
}
.page-header h6 {
  font-size: 14px;
  color: #424848;
  font-weight: 400;
}
@media (max-width: 991.98px) {
  .page-header h6 {
    font-size: 12px;
  }
}
@media (max-width: 575.98px) {
  .page-header h6 {
    font-size: 12px;
    margin-bottom: 20px;
  }
}
.page-header .btn-filter {
  background: #E41F07;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  padding: 0;
}
.page-header .btn-filter:hover {
  background: linear-gradient(46.62deg, #E41F07 0%, #676DFF 93.64%);
}
.page-header .page-btn {
  margin-left: 10px;
}
@media (max-width: 575.98px) {
  .page-header .page-btn {
    margin-left: 0;
    margin-top: 20px;
  }
}
.page-header .btn-added {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  background: #E41F07;
  padding: 8px 11px;
  color: #FFF;
  font-weight: 700;
  font-size: 14px;
  height: 40px;
  border-radius: 5px;
}
.page-header .btn-added:active {
  color: #FFF;
}
.page-header .btn-added img {
  filter: brightness(0) invert(1);
}
@media (max-width: 991.98px) {
  .page-header .btn-added {
    padding: 10px 10px;
  }
}
.page-header .btn-added:hover {
  background: #262A2A;
}
.page-header .btn-added .me-2 {
  width: 16px;
  height: 16px;
}
.page-header .btn-added.downloader {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  background: #262A2A;
  padding: 9px 11px;
  color: #FFF;
  font-weight: 700;
  font-size: 14px;
  border-radius: 8px;
  margin: 0 15px 0 15px;
}
.page-header .btn-added.downloader img {
  filter: brightness(0) invert(1);
}
@media (max-width: 991.98px) {
  .page-header .btn-added.downloader {
    padding: 10px 10px;
  }
}
.page-header .btn-added.downloader:hover {
  background: #E41F07;
}
.page-header .btn-added.downloader .me-2 {
  width: 16px;
  height: 16px;
}
.page-header .btn-added.printer {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  background: #FC0027;
  padding: 9px 11px;
  color: #FFF;
  font-weight: 700;
  font-size: 14px;
  border-radius: 8px;
}
.page-header .btn-added.printer img {
  filter: brightness(0) invert(1);
}
@media (max-width: 991.98px) {
  .page-header .btn-added.printer {
    padding: 10px 10px;
  }
}
.page-header .btn-added.printer:hover {
  background: #262A2A;
}
.page-header .btn-added.printer .me-2 {
  width: 16px;
  height: 16px;
}
@media (max-width: 767.98px) {
  .page-header .add-item {
    display: block !important;
  }
  .page-header .add-item .page-btn {
    margin-left: 0;
  }
}
@media (max-width: 575.98px) {
  .page-header .add-item .page-btn {
    margin-left: 0;
    margin-bottom: 24px;
  }
}
.page-header .add-item .page-title.modal-datail {
  line-height: 2;
}
.page-header .add-item.d-flex {
  margin-right: auto;
}
.page-header .add-item.payslip-list {
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  width: 100%;
}

.page-wrapper.details-blk {
  padding: 0;
  margin: 0;
}

.history-modal-profile .content {
  padding: 24px;
}
.history-modal-profile .right-sidebar-profile {
  background: #F9F9FC;
  border-radius: 8px;
  padding: 24px;
}
.history-modal-profile .right-sidebar-profile .list-inline-item a {
  background: #E41F07;
  width: 40px;
  height: 40px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.history-modal-profile .right-sidebar-profile .list-inline-item a:hover {
  background: #1b2950;
  color: #FFF !important;
}
.history-modal-profile .right-sidebar-profile .avatar {
  margin-bottom: 24px;
  width: 150px;
  height: 150px;
}
.history-modal-profile .right-sidebar-profile .avatar img {
  border-radius: 8px;
}

.msg-typing {
  width: auto;
  height: 24px;
  padding-top: 8px;
}
.msg-typing span {
  height: 8px;
  width: 8px;
  float: left;
  background-color: #FFF;
  display: block;
  opacity: 0.4;
  margin: 0 1px;
  border-radius: 50%;
}
.msg-typing span:nth-of-type(1) {
  animation: 1s blink infinite 0.33333s;
}
.msg-typing span:nth-of-type(2) {
  animation: 1s blink infinite 0.66666s;
}
.msg-typing span :nth-of-type(3) {
  animation: 1s blink infinite 0.99999s;
}

@keyframes blink {
  50% {
    opacity: 1;
  }
}
.phone-call-icon svg {
  width: 18px;
}
.phone-call-icon .income-success {
  color: #5CB85C;
}
.phone-call-icon .income-success-missed {
  color: #FC0027;
}

.history-modal-profile .content {
  padding: 24px;
}
.history-modal-profile .right-sidebar-profile {
  background: #F9F9FC;
  border-radius: 8px;
  padding: 24px;
}
.history-modal-profile .right-sidebar-profile .list-inline-item a {
  background: #E41F07;
  width: 40px;
  height: 40px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  color: #FFF !important;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.history-modal-profile .right-sidebar-profile .list-inline-item a:hover {
  background: #1b2950;
  color: #FFF !important;
}
.history-modal-profile .right-sidebar-profile .avatar {
  margin-bottom: 24px;
  width: 150px;
  height: 150px;
}
.history-modal-profile .right-sidebar-profile .avatar img {
  border-radius: 8px;
}

.modal-profile-detail .modal-userlist li {
  font-size: 14px;
  color: #000;
  margin-bottom: 10px;
}
.modal-profile-detail .modal-userlist li span {
  display: block;
  color: #6F6F6F;
}
.modal-profile-detail .modal-userlist li:last-child {
  margin-bottom: 0;
}

@media (max-width: 991.98px) {
  .chat_sidebar.hide-left-sidebar {
    display: none !important;
  }
}

@media (max-width: 991.98px) {
  .left-sidebar.hide-left-sidebar {
    margin-left: -991px;
  }
}

.img-cropper .dropup .dropdown-toggle::after {
  content: "";
  display: none;
}

.dropdown-auto {
  overflow: auto;
}

.dropdown-divider {
  margin: 0;
}

.dropdown .dropdown-toggle:after {
  display: inline-block;
  margin-inline-start: 0.25rem;
  vertical-align: 0;
  content: "\\f078";
  font-family: "Font Awesome 5 Free";
  border: 0;
  font-size: 0.6rem;
  font-weight: 600;
}
.dropdown .dropdown-toggle.btn-primary {
  color: #FFF;
}
.dropdown .dropdown-menu {
  font-family: "Noto Sans", sans-serif;
}

.dropdown > a {
  color: #262A2A;
  border: 1px solid #E8E8E8;
  padding: 9px 15px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
}

.dropdown-menu {
  border-color: #E8E8E8;
  box-shadow: 0 1rem 1.125rem rgba(169, 169, 169, 0.15);
  font-size: 0.875rem;
  color: #6F6F6F;
  background-color: #FFF;
  padding: 0;
  z-index: 10;
}

.dropdown-divider {
  border-color: #E8E8E8;
}

.dropdown-item-text {
  color: #6F6F6F;
}

.dropdown-header {
  color: #6F6F6F;
}

.dropdown-item {
  color: #6F6F6F;
  white-space: unset;
  padding: 0.5rem 0.9375rem;
  font-size: 0.8125rem;
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: #6F6F6F;
  opacity: 0.5;
}
.dropdown-item:not(.active):hover, .dropdown-item:not(.active):focus, .dropdown-item:not(.active):active {
  color: #E41F07;
  background-color: rgba(228, 31, 7, 0.05);
}
.dropdown-item.active {
  background-color: #E41F07 !important;
}

.dropdown-toggle::after {
  display: inline-block;
  margin-inline-start: 0.25rem;
  vertical-align: 0;
  content: "\\f078";
  font-family: "Font Awesome 5 Free";
  border: 0;
  font-size: 0.6rem;
  font-weight: 600;
}

.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-inline-start: 0.25rem;
  vertical-align: 0;
  content: "\\f078";
  font-family: "Font Awesome 5 Free";
  border: 0;
  font-size: 0.6rem;
  font-weight: 600;
}

.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-inline-start: 0.25rem;
  vertical-align: 0;
  content: "\\f077";
  font-family: "Font Awesome 5 Free";
  border: 0;
  font-size: 0.6rem;
  font-weight: 600;
}

.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-inline-start: 0.25rem;
  vertical-align: 0;
  content: "\\f054";
  font-family: "Font Awesome 5 Free";
  border: 0;
  font-size: 0.6rem;
  font-weight: 600;
}

.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-inline-start: 0.25rem;
  vertical-align: 0;
  content: "\\f053";
  font-family: "Font Awesome 5 Free";
  border: 0;
  font-size: 0.6rem;
  font-weight: 600;
}

.btn.dropdown-toggle-split {
  opacity: 0.85;
}

.dropdown-menu-dark {
  background-color: #171724;
  border-color: rgba(255, 255, 255, 0.1);
}
.dropdown-menu-dark li a {
  color: #FFF;
}

.btn-list a.dropdown-item {
  margin-block-end: 0;
}
.btn-list .btn-soft-success:hover {
  transform: translateY(0);
}
.btn-list .btn-soft-danger:hover {
  transform: translateY(0);
}
.dropdown-menu.dropdown-menu-primary {
  background-color: #E41F07;
}
.dropdown-menu.dropdown-menu-primary li a {
  color: rgba(255, 255, 255, 0.9);
}
.dropdown-menu.dropdown-menu-primary .dropdown-item:hover, .dropdown-menu.dropdown-menu-primary .dropdown-item:focus, .dropdown-menu.dropdown-menu-primary .dropdown-item:active, .dropdown-menu.dropdown-menu-primary .dropdown-item.active {
  color: #FFF;
}
.dropdown-menu.dropdown-menu-secondary {
  background-color: #FFA201;
}
.dropdown-menu.dropdown-menu-secondary li a {
  color: rgba(255, 255, 255, 0.9);
}
.dropdown-menu.dropdown-menu-secondary .dropdown-item:hover, .dropdown-menu.dropdown-menu-secondary .dropdown-item:focus, .dropdown-menu.dropdown-menu-secondary .dropdown-item:active, .dropdown-menu.dropdown-menu-secondary .dropdown-item.active {
  color: #FFF;
}
.dropdown-menu.dropdown-menu-warning {
  background-color: #FDA700;
}
.dropdown-menu.dropdown-menu-warning li a {
  color: rgba(255, 255, 255, 0.9);
}
.dropdown-menu.dropdown-menu-warning .dropdown-item:hover, .dropdown-menu.dropdown-menu-warning .dropdown-item:focus, .dropdown-menu.dropdown-menu-warning .dropdown-item:active, .dropdown-menu.dropdown-menu-warning .dropdown-item.active {
  color: #FFF;
}
.dropdown-menu.dropdown-menu-info {
  background-color: #1ECBE2;
}
.dropdown-menu.dropdown-menu-info li a {
  color: rgba(255, 255, 255, 0.9);
}
.dropdown-menu.dropdown-menu-info .dropdown-item:hover, .dropdown-menu.dropdown-menu-info .dropdown-item:focus, .dropdown-menu.dropdown-menu-info .dropdown-item:active, .dropdown-menu.dropdown-menu-info .dropdown-item.active {
  color: #FFF;
}
.dropdown-menu.dropdown-menu-success {
  background-color: #5CB85C;
}
.dropdown-menu.dropdown-menu-success li a {
  color: rgba(255, 255, 255, 0.9);
}
.dropdown-menu.dropdown-menu-success .dropdown-item:hover, .dropdown-menu.dropdown-menu-success .dropdown-item:focus, .dropdown-menu.dropdown-menu-success .dropdown-item:active, .dropdown-menu.dropdown-menu-success .dropdown-item.active {
  color: #FFF;
}
.dropdown-menu.dropdown-menu-danger {
  background-color: #FC0027;
}
.dropdown-menu.dropdown-menu-danger li a {
  color: rgba(255, 255, 255, 0.9);
}
.dropdown-menu.dropdown-menu-danger .dropdown-item:hover, .dropdown-menu.dropdown-menu-danger .dropdown-item:focus, .dropdown-menu.dropdown-menu-danger .dropdown-item:active, .dropdown-menu.dropdown-menu-danger .dropdown-item.active {
  color: #FFF;
}

.dropdown-menu.dropmenu-item-primary .dropdown-item:hover, .dropdown-menu.dropmenu-item-primary .dropdown-item:focus, .dropdown-menu.dropmenu-item-primary .dropdown-item:active, .dropdown-menu.dropmenu-item-primary .dropdown-item.active {
  background-color: rgba(228, 31, 7, 0.1) !important;
  color: #E41F07;
}
.dropdown-menu.dropmenu-item-secondary .dropdown-item:hover, .dropdown-menu.dropmenu-item-secondary .dropdown-item:focus, .dropdown-menu.dropmenu-item-secondary .dropdown-item:active, .dropdown-menu.dropmenu-item-secondary .dropdown-item.active {
  background-color: rgba(255, 162, 1, 0.1) !important;
  color: #FFA201;
}
.dropdown-menu.dropmenu-item-warning .dropdown-item:hover, .dropdown-menu.dropmenu-item-warning .dropdown-item:focus, .dropdown-menu.dropmenu-item-warning .dropdown-item:active, .dropdown-menu.dropmenu-item-warning .dropdown-item.active {
  background-color: rgba(253, 167, 0, 0.1) !important;
  color: #FDA700;
}
.dropdown-menu.dropmenu-item-info .dropdown-item:hover, .dropdown-menu.dropmenu-item-info .dropdown-item:focus, .dropdown-menu.dropmenu-item-info .dropdown-item:active, .dropdown-menu.dropmenu-item-info .dropdown-item.active {
  background-color: rgba(30, 203, 226, 0.1) !important;
  color: #1ECBE2;
}
.dropdown-menu.dropmenu-item-success .dropdown-item:hover, .dropdown-menu.dropmenu-item-success .dropdown-item:focus, .dropdown-menu.dropmenu-item-success .dropdown-item:active, .dropdown-menu.dropmenu-item-success .dropdown-item.active {
  background-color: rgba(var(--success-rgb), 0.1) !important;
  color: #5CB85C;
}
.dropdown-menu.dropmenu-item-danger .dropdown-item:hover, .dropdown-menu.dropmenu-item-danger .dropdown-item:focus, .dropdown-menu.dropmenu-item-danger .dropdown-item:active, .dropdown-menu.dropmenu-item-danger .dropdown-item.active {
  background-color: rgba(var(--danger-rgb), 0.1) !important;
  color: #FC0027;
}

.dropdown-menu.dropmenu-light-primary {
  background-color: rgba(var(#FFA201), 0.1);
  -webkit-backdrop-filter: blur(2rem);
          backdrop-filter: blur(2rem);
}
.dropdown-menu.dropmenu-light-primary .dropdown-item:hover, .dropdown-menu.dropmenu-light-primary .dropdown-item:focus, .dropdown-menu.dropmenu-light-primary .dropdown-item:active, .dropdown-menu.dropmenu-light-primary .dropdown-item.active {
  color: #FFF;
  background-color: #E41F07 !important;
}
.dropdown-menu.dropmenu-light-secondary {
  background-color: rgba(var(#FFA201), 0.1);
  -webkit-backdrop-filter: blur(2rem);
          backdrop-filter: blur(2rem);
}
.dropdown-menu.dropmenu-light-secondary .dropdown-item:hover, .dropdown-menu.dropmenu-light-secondary .dropdown-item:focus, .dropdown-menu.dropmenu-light-secondary .dropdown-item:active, .dropdown-menu.dropmenu-light-secondary .dropdown-item.active {
  color: #FFF;
  background-color: #FFA201 !important;
}
.dropdown-menu.dropmenu-light-info {
  background-color: rgba(30, 203, 226, 0.1);
  -webkit-backdrop-filter: blur(2rem);
          backdrop-filter: blur(2rem);
}
.dropdown-menu.dropmenu-light-info .dropdown-item:hover, .dropdown-menu.dropmenu-light-info .dropdown-item:focus, .dropdown-menu.dropmenu-light-info .dropdown-item:active, .dropdown-menu.dropmenu-light-info .dropdown-item.active {
  color: #FFF;
  background-color: #1ECBE2 !important;
}
.dropdown-menu.dropmenu-light-warning {
  background-color: rgba(253, 167, 0, 0.1);
  -webkit-backdrop-filter: blur(2rem);
          backdrop-filter: blur(2rem);
}
.dropdown-menu.dropmenu-light-warning .dropdown-item:hover, .dropdown-menu.dropmenu-light-warning .dropdown-item:focus, .dropdown-menu.dropmenu-light-warning .dropdown-item:active, .dropdown-menu.dropmenu-light-warning .dropdown-item.active {
  color: #FFF;
  background-color: #FDA700 !important;
}
.dropdown-menu.dropmenu-light-success {
  background-color: rgba(92, 184, 92, 0.1);
  -webkit-backdrop-filter: blur(2rem);
          backdrop-filter: blur(2rem);
}
.dropdown-menu.dropmenu-light-success .dropdown-item:hover, .dropdown-menu.dropmenu-light-success .dropdown-item:focus, .dropdown-menu.dropmenu-light-success .dropdown-item:active, .dropdown-menu.dropmenu-light-success .dropdown-item.active {
  color: #FFF;
  background-color: #5CB85C !important;
}
.dropdown-menu.dropmenu-light-danger {
  background-color: rgba(var(--danger-rgb), 0.1);
  -webkit-backdrop-filter: blur(2rem);
          backdrop-filter: blur(2rem);
}
.dropdown-menu.dropmenu-light-danger .dropdown-item:hover, .dropdown-menu.dropmenu-light-danger .dropdown-item:focus, .dropdown-menu.dropmenu-light-danger .dropdown-item:active, .dropdown-menu.dropmenu-light-danger .dropdown-item.active {
  color: #FFF;
  background-color: #FC0027 !important;
}

.dropdown-divider {
  margin: 0;
}

.bd-example > .dropdown-menu {
  position: static;
  display: block;
}

.dropdown-md {
  min-width: 315px;
}

.table-action .action-icon {
  width: 33px;
  height: 33px;
  background: #F6F6F6;
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #262A2A;
}
.table-action .action-icon:hover {
  color: #262A2A;
}
.table-action .action-icon:hover i {
  color: #262A2A;
}
.table-action .dropdown-toggle::after {
  display: none;
}
.table-action .dropdown-menu a {
  display: flex;
  align-items: center;
  padding: 5px;
  border-radius: 5px;
  color: #262A2A;
  white-space: nowrap;
}
.table-action .dropdown-menu a i {
  margin-right: 8px;
}
.table-action .dropdown-menu a:hover {
  background: #F6F6F6;
  color: #262A2A;
}

.daterangepicker {
  font-family: "Noto Sans", sans-serif;
}
.daterangepicker .calendar-table th {
  color: #262A2A;
}
.daterangepicker .calendar-table td {
  color: #262A2A;
}

.daterangepicker td.active, .daterangepicker td.active:hover {
  background-color: #FC0027;
  color: #FFEEEC;
}

.daterangepicker .ranges li.active {
  background-color: #00918E;
}

.sort-dropdown.drop-down .dropdown-menu li a {
  white-space: nowrap;
}

.drop-down {
  position: relative;
}
.drop-down > a {
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
  background: #FFF;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  min-height: 42px;
  padding: 9px 15px;
}
.drop-down > a i {
  margin-right: 8px;
}
.drop-down > a:hover {
  color: #262A2A;
}
.drop-down > a.show {
  border: 1px solid #0092E4;
}
.drop-down > a::after {
  font-size: 14px;
  margin-left: 8px;
}
.drop-down > a[aria-expanded=true]::after {
  transition: all 0.2s ease;
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
}
.drop-down .dropdown-menu li a {
  display: flex;
  align-items: center;
  padding: 5px;
  border-radius: 5px;
}
.drop-down .dropdown-menu li a i {
  margin-right: 8px;
}
.drop-down .dropdown-menu li a:hover {
  background: #F6F6F6;
  color: #262A2A;
}

.dropdown-menu {
  border: 1px solid #E8E8E8;
  padding: 15px;
  box-shadow: 0px 4px 74px 0px rgba(208, 208, 208, 0.2509803922);
}

.inbox-menu {
  display: inline-block;
  width: 100%;
  margin: 0 0 20px;
  padding: 0;
}
.inbox-menu li {
  display: inline-block;
  width: 100%;
}
.inbox-menu li a {
  color: #333;
  display: inline-block;
  padding: 10px 15px;
  width: 100%;
  font-weight: 600;
  text-transform: capitalize;
  transition: 0.3s ease;
}
.inbox-menu li a:hover {
  background: rgba(33, 33, 33, 0.05);
}
.inbox-menu li a i {
  font-size: 16px;
  padding-right: 10px;
  color: #878787;
}

.compose-btn {
  margin-bottom: 25px;
}

.top-action-left .btn-group {
  margin-bottom: 5px;
}
.top-action-left .dropdown-toggle {
  height: 40px;
}
.top-action-left .dropdown-toggle::after {
  display: none;
}

.table-inbox .starred.fas.fa-star {
  color: #FDA700;
}
.table-inbox .checked {
  background-color: #898989;
}
.table-inbox th {
  border-color: #F2ECFF;
}
.table-inbox tbody tr td {
  font-size: 14px;
  color: #FFA201;
  border-color: #E8E8E8;
}

.unread .name,
.unread .subject,
.unread .mail-date {
  color: #000;
  font-weight: 700;
}

.email-header .btn-white {
  min-width: auto;
  height: 38px;
  border: 1px solid #E8E8E8;
}
.email-header .btn-white i {
  margin-left: 5px;
}

.file-manager {
  color: #6F6F6F;
}
.file-manager .search-dropdown {
  height: auto;
}
.file-manager .form-sort {
  width: auto;
}
.file-manager .form-sort .select2-container--default .select2-selection--single .select2-selection__rendered {
  padding-right: 27px;
}
.file-manager .form-sort.owned-by {
  margin-right: 10px;
}
.file-manager.notes-page-wrapper .content .page-add-notes {
  padding-bottom: 30px;
  margin-bottom: 30px;
}
.file-manager.notes-page-wrapper .content .section-bulk-wrap {
  margin-top: 0;
}
.file-manager.notes-page-wrapper .content .section-bulk-wrap .form-sort svg.fa-filter {
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
}
.file-manager.notes-page-wrapper .content .section-bulk-wrap .bulk-action-type .select-bluk {
  margin-right: 15px;
}
.file-manager .page-header .btn-added {
  margin-left: 10px;
}
@media (max-width: 575.98px) {
  .file-manager .page-header .form-sort {
    margin-top: 0;
    margin-bottom: 15px;
  }
}
@media (max-width: 575.98px) {
  .file-manager .page-header .table-top-head {
    margin-bottom: 15px;
  }
}
@media (max-width: 991.98px) {
  .file-manager .page-header .table-top-head li:last-child {
    margin-right: 0;
  }
}
@media (max-width: 767.98px) {
  .file-manager .bulk-action-type {
    align-items: start !important;
  }
}
@media (max-width: 575.98px) {
  .file-manager .bulk-action-type {
    display: block !important;
  }
}
@media (max-width: 767.98px) {
  .file-manager .bulk-action-type .form-sort {
    margin-top: 0;
    margin-bottom: 15px;
    width: 100%;
  }
}
.file-manager aside {
  border: 1px solid #E8E8E8;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  border-radius: 8px;
}
.file-manager aside h5 {
  font-size: 18px;
  font-weight: 700;
  border-bottom: 1px solid #C0C0C0;
  margin: 0 0 15px 0;
  padding: 0 0 15px 0;
}
.file-manager aside .btn {
  font-weight: 700;
}
.file-manager aside .dropdown > a {
  width: auto;
  height: 40px;
  color: #FFF;
  border-radius: 5px;
}
.file-manager aside .dropdown > a:hover, .file-manager aside .dropdown > a:focus {
  border-color: #6F6F6F;
  background: #6F6F6F;
}
.file-manager aside .dropdown ul {
  width: 100%;
}
.file-manager aside .dropdown ul li a {
  font-size: 15px;
}
.file-manager aside ul li a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  color: #6F6F6F;
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 5px 0;
  padding: 7px 10px;
  border-radius: 5px;
  height: 40px;
}
.file-manager aside ul li a span {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  width: auto;
}
.file-manager aside ul li a:hover, .file-manager aside ul li a.active {
  background: #6F6F6F;
  color: #FFF;
}
.file-manager aside span {
  font-size: 13px;
  font-weight: 500;
  width: auto;
  height: auto;
}
.file-manager aside h6 {
  font-size: 16px;
  font-weight: 600;
  position: relative;
  z-index: 2;
}
.file-manager aside .space-manager {
  color: #FFF;
  background: #6F6F6F;
  border-radius: 8px;
  position: relative;
}
.file-manager aside .space-manager img {
  position: absolute;
  top: 0;
  right: 0;
}
.file-manager aside .space-manager h6 a {
  color: #FFF;
}
.file-manager aside .space-manager p {
  color: #B8BCC9;
}
.file-manager .progress {
  height: 6px;
  border-radius: 5px;
}
.file-manager .search-set .search-input input[type=search] {
  width: 170px;
  height: 40px;
}
.file-manager .budgeted-role-notes .search-set .search-input input[type=search] {
  width: 298px;
}
.file-manager h4 {
  font-size: 18px;
  font-weight: 600;
}
.file-manager h6 {
  font-size: 16px;
  font-weight: 600;
}
.file-manager h6 a {
  color: #6F6F6F;
}
.file-manager h6 a:hover {
  color: #E41F07;
}
.file-manager .overview .detail a.bg {
  border-radius: 8px 8px 0 0;
}
.file-manager .overview .detail a.bg span {
  width: 66px;
  height: 66px;
  border-radius: 100%;
}
.file-manager .overview .detail a.bg span img {
  transition: all 0.5s ease;
}
.file-manager .overview .detail a:hover img {
  transform: scale(1.2);
}
.file-manager .info {
  border-radius: 0 0 8px 8px;
  padding: 15px;
  background: #FFF;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
}
.file-manager .info span {
  color: #6F6F6F;
  font-size: 13px;
}
.file-manager .folders {
  border: 1px solid #E8E8E8;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  border-radius: 8px;
  background: #FFF;
}
.file-manager .folders h6 {
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-right: 8px;
}
.file-manager .dropdown > a {
  color: #6F6F6F;
  width: 25px;
  height: 25px;
  transition: all 0.5s ease;
  border-radius: 100%;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.file-manager .dropdown > a:hover {
  background: #E41F07;
}
.file-manager .dropdown > a:hover i {
  color: #FFF;
}
.file-manager .project-plan {
  font-size: 13px;
  font-weight: 600;
  margin-top: 10px;
}
.file-manager .project-plan label {
  color: #6F6F6F;
  margin-right: 9px;
  font-size: 13px;
}
.file-manager .project-plan ul li {
  font-size: 13px;
  position: relative;
  padding: 0 9px 0 14px;
  color: #6F6F6F;
}
.file-manager .project-plan ul li:before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  width: 5px;
  height: 5px;
  background: #6F6F6F;
  border-radius: 5px;
}
.file-manager .avatar-wrap a svg {
  color: #6F6F6F;
  width: 18px;
}
.file-manager .avatar-wrap a:hover svg {
  color: #E41F07;
}
.file-manager .accordion {
  border: none;
  --bs-accordion-border-width: none;
}
.file-manager .accordion .accordion-item {
  border: none;
  border-bottom: 1px solid #E8E8E8;
  background: none;
}
.file-manager .accordion .accordion-item:last-of-type {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  border-bottom: none;
}
.file-manager .accordion .accordion-item .accordion-button {
  background: none;
  border: none;
  font-size: 18px;
  font-weight: 600;
  color: #6F6F6F;
  padding: 0;
  display: inline-block;
  width: auto;
}
.file-manager .accordion .accordion-item .accordion-button:after {
  transition: all 0.8s ease;
  background-image: none;
  content: "View All";
  font-family: "Nunito", sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #6F6F6F;
  transform: none;
  width: 60px;
  text-align: right;
}
.file-manager .accordion .accordion-item .accordion-button:not(.collapsed)::after {
  content: "Hide";
}
.file-manager .accordion .accordion-item .accordion-button.collapsed {
  padding: 0;
}
.file-manager .accordion .accordion-item .accordion-button:hover:after {
  color: #E41F07;
}
.file-manager .accordion .accordion-item .accordion-body {
  border: none;
  padding: 0;
}
.file-manager .accordion .accordion-item .accordion-body .head img {
  min-width: 32px;
  width: 32px;
  height: 32px;
}
.file-manager .accordion .accordion-item .accordion-body .owl-carousel {
  padding-top: 15px;
}
.file-manager .owl-carousel .owl-item {
  margin-left: -0.1px !important;
}
.file-manager .owl-carousel .dropdown-menu {
  left: auto !important;
  right: 0 !important;
  top: 27px !important;
  transform: none !important;
  background: #FFF !important;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  z-index: 99999 !important;
}
.file-manager .owl-carousel .owl-nav {
  top: -20px;
  left: 43px;
  display: inline-table;
}
.file-manager .owl-carousel .owl-nav button {
  margin-top: 0;
  margin-bottom: 0;
  background: none;
  cursor: pointer;
}
.file-manager .owl-carousel .owl-nav button.owl-next, .file-manager .owl-carousel .owl-nav button.owl-prev {
  position: relative;
  width: 15px;
}
.file-manager .owl-carousel .owl-nav button.owl-next i, .file-manager .owl-carousel .owl-nav button.owl-prev i {
  color: #6F6F6F;
}
.file-manager .owl-carousel .owl-nav button.owl-next:hover, .file-manager .owl-carousel .owl-nav button.owl-prev:hover {
  background: none;
}
.file-manager .owl-carousel .owl-nav button.owl-next:hover i, .file-manager .owl-carousel .owl-nav button.owl-prev:hover i {
  color: #E41F07;
}
.file-manager .owl-carousel.folders-carousel .owl-nav {
  left: 75px;
}
.file-manager .owl-carousel.video-section .owl-nav {
  left: 60px;
}
.file-manager .owl-carousel.video-section .info a svg {
  color: #6F6F6F;
  width: 18px;
}
.file-manager .all-files {
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  border: none;
}
.file-manager .all-files .btn-grp a {
  padding: 6px 8px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
@media (max-width: 575.98px) {
  .file-manager .all-files .btn-grp a {
    margin-bottom: 15px;
    display: inline-block;
  }
}
.file-manager .all-files .btn-grp a.btn-outline-secondary {
  color: #6F6F6F;
  background: #F9F9FC;
  border-color: #F9F9FC;
}
.file-manager .all-files .btn-grp a:hover {
  background: #6F6F6F;
  border-color: #6F6F6F;
  color: #FFF;
}
.file-manager .all-files .table thead tr th {
  border-color: #E8E8E8;
}
.file-manager .all-files .table tbody tr td {
  display: table-cell;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  border-color: #E8E8E8;
}
.file-manager .all-files .table tbody tr td a {
  font-size: 14px;
  font-weight: 500;
}
.file-manager .all-files .table tbody tr td a.product-img img {
  width: 32px;
  height: 32px;
  border: 0;
}
.file-manager #file-delete {
  font-size: 14px;
}

aside {
  padding: 24px;
}

.color-primary {
  color: #6F6F6F;
}

.icon-select {
  position: relative;
  width: 149px;
  height: 38px;
}
.icon-select .icon {
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  z-index: 100;
}
.icon-select .select2-container--default .select2-selection--single .select2-selection__rendered {
  padding-left: 30px;
}

.bg-light-orange {
  background: #FAD2CD;
}
.bg-light-orange span {
  background: #FAD2CD;
}

.bg-light-red {
  background: #FECCD4;
}
.bg-light-red span {
  background: #FECCD4;
}

.bg-light-green {
  background: #CEEACE;
}
.bg-light-green span {
  background: #CEEACE;
}

.seprator-sm {
  margin: 0 0 24px 0;
  padding: 0 0 9px 0;
  border-bottom: 1px solid #C0C0C0;
}

.seprator-lg {
  margin: 0 0 24px 0;
  padding: 0 0 24px 0;
  border-bottom: 1px solid #E8E8E8;
}

.group-avatar .avatar {
  position: relative;
  width: 43px;
  height: 43px;
  line-height: 43px;
  margin: 0;
}
.group-avatar .avatar + .avatar {
  margin-left: -1.2rem;
}
.group-avatar .avatar:hover {
  z-index: 1;
}
.group-avatar .count a {
  color: #5CB85C;
  line-height: 27px;
  font-size: 13px;
  font-weight: 500;
}
.group-avatar .count a:hover {
  color: #E41F07;
}
.group-avatar .avatar img {
  display: block;
  border-radius: 100%;
  width: 100%;
  border: 2px solid #FFF;
}

.video-section .item {
  opacity: 0.4;
  transition: 0.4s ease all;
  transform: scale(0.8);
}

@media (max-width: 1000px) {
  .video-section .item {
    margin: 0;
    transform: scale(0.9);
  }
}
.video-section .active .item {
  opacity: 1;
  transform: scale(1);
}

.video-section .owl-item {
  -webkit-backface-visibility: hidden;
  -webkit-transform: translateZ(0) scale(1, 1);
}

.video-section video {
  max-width: 100%;
  height: 100%;
  border-radius: 10px 10px 0 0;
}

.delete-alert {
  padding: 10px 20px;
  background: #FECCD4;
  border: none;
  border-radius: 8px;
}
.delete-alert p {
  font-size: 15px;
}
.delete-alert .btn {
  font-weight: 700;
}

.deleted-info {
  display: none;
}
.deleted-info .bin-bg {
  width: 184px;
  height: 184px;
  border-radius: 100%;
  background: #FDFDFE;
  margin: 0 auto;
}

.popup-toggle {
  cursor: pointer;
}

.toggle-sidebar {
  width: 456px;
  padding: 25px;
  position: fixed;
  right: -456px;
  top: 0;
  height: 100%;
  background: #FFF;
  z-index: 100001;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
  overflow-y: auto;
  transition: all 0.5s ease;
}
@media (max-width: 575.98px) {
  .toggle-sidebar {
    width: 320px;
    right: -320px;
  }
}
.toggle-sidebar.open-sidebar {
  right: 0;
  transition: all 0.5s ease;
}
.toggle-sidebar .head .color-primary:hover {
  color: #FC0027;
}
.toggle-sidebar h4, .toggle-sidebar h5 {
  font-weight: 700;
}
.toggle-sidebar h4 {
  font-size: 20px;
}
.toggle-sidebar h5 {
  font-size: 18px;
}
.toggle-sidebar h6 {
  font-size: 15px;
  font-weight: 600;
}
.toggle-sidebar .nav-tabs {
  border-bottom: 1px solid #C0C0C0;
}
.toggle-sidebar .nav-tabs .nav-link {
  padding: 8px 20px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  border: none;
  background: #F9F9FC;
  color: #6F6F6F;
}
.toggle-sidebar .nav-tabs .nav-link:hover, .toggle-sidebar .nav-tabs .nav-link.active {
  background: #E41F07;
  color: #FFF;
}
.toggle-sidebar .tab-content .tab-pane ul li h6 {
  margin-bottom: 5px;
}
.toggle-sidebar .tab-content .tab-pane ul li p.location {
  background: #F9F9FC;
  border: 1px solid #C0C0C0;
  border-radius: 5px;
  padding: 5px;
  display: inline-block;
}
.toggle-sidebar .tab-content .tab-pane ul li p.location img {
  width: 20px;
  height: 20px;
}
.toggle-sidebar .tab-content .tab-pane ul li .note-editor.note-airframe .note-statusbar, .toggle-sidebar .tab-content .tab-pane ul li .note-editor.note-frame .note-statusbar {
  border-top: none;
}
.toggle-sidebar .tab-content .tab-pane .avatar-access span a {
  display: inline-flex;
  margin-right: 3px;
  padding-right: 3px;
}
.toggle-sidebar .tab-content .tab-pane .avatar-access span:first-child a {
  margin-right: 10px;
  padding-right: 10px;
  border-right: 1px solid #C0C0C0;
}
.toggle-sidebar .tab-content .tab-pane .avatar-access span:last-child a {
  margin-right: 0;
  padding-right: 0;
}
.toggle-sidebar .tab-content .tab-pane .avatar-access span .add {
  background: #E41F07;
  color: #FFF;
}
.toggle-sidebar .tab-content .tab-pane .avatar-access span .add:hover {
  background: #6F6F6F;
}
.toggle-sidebar p {
  color: #6F6F6F;
  font-size: 15px;
}
.toggle-sidebar .show-all {
  font-weight: 700;
}
.toggle-sidebar .show-all:hover {
  color: #6F6F6F;
}

.text-danger {
  color: #FC0027 !important;
}

.avatar-md {
  width: 45px;
  height: 45px;
  border-radius: 45px;
}

.text-secondary {
  color: #6F6F6F !important;
}

.text-primary {
  color: #E41F07 !important;
}

.text-default {
  color: #6F6F6F;
}

.btn-icon svg {
  width: 18px;
}

.file-manager-modal .modal-header h5 {
  font-size: 18px;
  font-weight: 700;
}
.file-manager-modal#hold-order h2 {
  font-size: 36px;
  font-weight: 700;
  color: #262A2A;
  margin-bottom: 10px;
  background-color: #F9F9FC;
  border-radius: 10px;
}
.file-manager-modal#hold-order .input-block label {
  margin-bottom: 5px;
}
.file-manager-modal#hold-order p {
  margin-top: 20px;
}
.file-manager-modal#recents .table tbody tr td {
  padding: 10px 15px;
}
.file-manager-modal .badge {
  padding: 5px 10px;
  font-size: 15px;
  font-weight: normal;
}
.file-manager-modal#orders .modal-dialog {
  max-width: 575px;
}
.file-manager-modal#orders .order-body {
  height: 50vh;
  overflow: auto;
}
.file-manager-modal#orders .order-body .default-cover {
  border: 1px solid #C0C0C0;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  border-radius: 8px;
}
.file-manager-modal#orders .order-body .record {
  font-size: 15px;
}
.file-manager-modal#orders .order-body .record td {
  padding-bottom: 15px;
}
.file-manager-modal#orders .order-body .record tr:last-child td {
  padding-bottom: 0;
}
.file-manager-modal#orders .order-body .record .colon {
  padding: 0 10px;
  color: #FFA201;
}
.file-manager-modal#orders .order-body .record .text {
  color: #6F6F6F;
  white-space: nowrap;
}
.file-manager-modal#orders .order-body p {
  font-size: 15px;
  background-color: #F9F9FC;
  border-radius: 8px;
}
.file-manager-modal#orders .order-body .search-set .search-input {
  width: 100%;
}
.file-manager-modal#orders .order-body .search-set .search-input label {
  width: 100%;
}
.file-manager-modal#orders .order-body .search-set .search-input label input {
  width: 100%;
}
.file-manager-modal.upload-modal .modal-body .drag-drop {
  position: relative;
  padding: 20px;
  border: 1px dashed #B8BCC9;
}
.file-manager-modal.upload-modal .modal-body .drag-drop input[type=file] {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}
.file-manager-modal.upload-modal .modal-body span {
  font-size: 13px;
  font-weight: 500;
  color: #6F6F6F;
}
.file-manager-modal.upload-modal .modal-body p {
  font-size: 16px;
  font-weight: 600;
  color: #FFA201;
  margin-bottom: 0;
}
.file-manager-modal.upload-modal .modal-body .progress {
  height: 6px;
  border-radius: 5px;
}
.file-manager-modal.upload-modal .modal-body ul li {
  margin: 0 0 15px 0;
  padding: 15px;
  border-radius: 8px;
  border: 1px solid #C0C0C0;
}
.file-manager-modal.upload-modal .modal-body ul li svg {
  width: 18px;
}
.file-manager-modal.upload-modal .modal-body ul li h6 a {
  font-size: 16px;
  font-weight: 600;
  color: #FFA201;
}
.file-manager-modal.upload-modal .modal-body ul li h6 a svg {
  color: #5CB85C;
}
.file-manager-modal.upload-modal .modal-body ul li h6:hover a {
  color: #E41F07;
}
.file-manager-modal.upload-modal .modal-body ul li:last-child {
  margin-bottom: 0;
}
.file-manager-modal#upload-message .modal-dialog {
  position: fixed;
  bottom: 0px;
  right: 24px;
  margin: 0px;
  left: auto;
  top: calc(100% - 300px);
  width: 600px;
}
.file-manager-modal#upload-message .progress {
  height: 6px;
  border-radius: 5px;
}

.datanew tr td svg {
  width: 18px;
}

.icons-list {
  padding: 0;
  display: flex;
  flex-wrap: wrap;
}
.icons-list li {
  display: block;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  font-size: 18px;
  border-radius: 50px;
  border: 1px solid #e6ebf1;
  color: #E41F07;
  margin: 5px;
  box-shadow: 0 2px 3px rgb(215, 197, 255);
}

.progress {
  background-color: #E8E8E8;
  height: 0.75rem;
  border-radius: 0.25rem;
}

.progress-stacked {
  background-color: #E8E8E8;
}

.progress-bar {
  color: #FFF;
  background-color: #E41F07;
}

@keyframes progress-animate {
  0% {
    width: 0;
  }
}
.progress-animate {
  position: relative;
  border-radius: 0.625rem;
}
.progress-animate .progress-bar {
  position: relative;
  border-radius: 0.625rem;
  animation: 2s progress-animate;
}

.progress.progress-xs, .progress-stacked.progress-xs {
  height: 0.3125rem;
}
.progress.progress-sm, .progress-stacked.progress-sm {
  height: 0.5rem;
}
.progress.progress-lg, .progress-stacked.progress-lg {
  height: 1rem;
}
.progress.progress-xl, .progress-stacked.progress-xl {
  height: 1.25rem;
}

.progress-vertical {
  min-height: 250px;
  height: 250px;
  width: 10px;
  position: relative;
  display: inline-block;
  margin-bottom: 0;
  margin-right: 20px;
}
.progress-vertical .progress-bar {
  width: 100%;
}
.progress-vertical.progress-xl {
  width: 15px;
}
.progress-vertical.progress-lg {
  width: 12px;
}
.progress-vertical.progress-sm {
  width: 8px;
}
.progress-vertical.progress-xs {
  width: 5px;
}

.progress-vertical-bottom {
  min-height: 250px;
  height: 250px;
  position: relative;
  width: 10px;
  display: inline-block;
  margin-bottom: 0;
  margin-right: 20px;
}
.progress-vertical-bottom .progress-bar {
  width: 100%;
  bottom: 0;
  position: absolute;
}
.progress-vertical-bottom.progress-xl {
  width: 15px;
}
.progress-vertical-bottom.progress-lg {
  width: 12px;
}
.progress-vertical-bottom.progress-sm {
  width: 8px;
}
.progress-vertical-bottom.progress-xs {
  width: 5px;
}

.progress-custom {
  overflow: visible;
  position: relative;
}
.progress-custom .progress-bar {
  position: relative;
  overflow: visible;
}
.progress-custom .progress-bar:after {
  content: "";
  width: 1.15rem;
  height: 1.15rem;
  border-radius: 50%;
  box-shadow: 0 0.313rem 0.313rem rgba(228, 31, 7, 0.5);
  background: #FFF;
  position: absolute;
  inset-inline-end: -0.375rem;
  inset-block-start: -0.375rem;
  border: 0.25rem solid #E41F07;
}
.progress-custom .progress-bar.bg-secondary:after {
  border: 0.25rem solid #FFA201;
  box-shadow: 0 0.313rem 0.313rem rgba(var(--secondary-rgb), 0.2);
}
.progress-custom .progress-bar.bg-warning:after {
  border: 0.25rem solid #FDA700;
  box-shadow: 0 0.313rem 0.313rem rgba(var(--warning-rgb), 0.2);
}
.progress-custom .progress-bar.bg-info:after {
  border: 0.25rem solid #1ECBE2;
  box-shadow: 0 0.313rem 0.313rem rgba(var(--info-rgb), 0.2);
}
.progress-custom .progress-bar.bg-success:after {
  border: 0.25rem solid #5CB85C;
  box-shadow: 0 0.313rem 0.313rem rgba(var(--success-rgb), 0.2);
}
.progress-custom .progress-bar.bg-danger:after {
  border: 0.25rem solid #FC0027;
  box-shadow: 0 0.313rem 0.313rem rgba(var(--danger-rgb), 0.2);
}
.progress-custom .progress-bar-value {
  width: 1.875rem;
  height: 1.25rem;
  line-height: 1.25rem;
  border-radius: 0.188rem;
  background: #E41F07;
  box-shadow: 0 0.313rem 0.313rem rgba(0, 0, 0, 0.4);
  font-size: 0.625rem;
  font-weight: 600;
  color: #FFF;
  text-align: center;
  position: absolute;
  inset-block-end: 1.5rem;
  inset-inline-end: -0.688rem;
}
.progress-custom .progress-bar-value:after {
  content: "";
  border-block-start: 0.438rem solid #E41F07;
  border-inline-start: 0.438rem solid transparent;
  border-inline-end: 0.438rem solid transparent;
  position: absolute;
  inset-block-end: -0.375rem;
  inset-inline-start: 28%;
}
.progress-custom .progress-bar-value.bg-secondary {
  background-color: #FFA201;
}
.progress-custom .progress-bar-value.bg-secondary:after {
  border-block-start: 0.438rem solid #FFA201;
}
.progress-custom .progress-bar-value.bg-success {
  background-color: #5CB85C;
}
.progress-custom .progress-bar-value.bg-success:after {
  border-block-start: 0.438rem solid #5CB85C;
}
.progress-custom .progress-bar-value.bg-warning {
  background-color: #FDA700;
}
.progress-custom .progress-bar-value.bg-warning:after {
  border-block-start: 0.438rem solid #FDA700;
}
.progress-custom .progress-bar-value.bg-danger {
  background-color: #FC0027;
}
.progress-custom .progress-bar-value.bg-danger:after {
  border-block-start: 0.438rem solid #FC0027;
}
.progress-custom .progress-bar-value.bg-info {
  background-color: #1ECBE2;
}
.progress-custom .progress-bar-value.bg-info:after {
  border-block-start: 0.438rem solid #1ECBE2;
}

[dir=rtl] .progress-bar-title {
  border-radius: 0 0.313rem 0.313rem 0;
}

.progress-item-1, .progress-item-2, .progress-item-3 {
  position: absolute;
  margin-block-start: -0.25rem;
  z-index: 1;
  height: 0.938rem;
  width: 0.938rem;
  border-radius: 1.563rem;
  background-color: #FDFDFE;
}

.progress-item-1 {
  inset-inline-start: 25%;
}

.progress-item-2 {
  inset-inline-start: 50%;
}

.progress-item-3 {
  inset-inline-start: 75%;
}

.custom-progress-3 {
  overflow: visible;
  border-radius: 0.625rem;
}
.custom-progress-3 .progress-bar {
  position: relative;
  overflow: visible;
  margin: 0.313rem;
  border-radius: 0.25rem;
}
.custom-progress-3 .progress-bar:before {
  content: "";
  position: absolute;
  width: 0.25rem;
  height: 0.25rem;
  inset-inline-start: 0.125rem;
  background-color: #FFF;
  border-radius: 50%;
}
.custom-progress-3 .progress-bar .progress-bar-value {
  border: 0.125rem solid #E41F07;
  width: 2.5rem;
  height: 1.563rem;
  line-height: 1.313rem;
  border-radius: 3.125rem;
  background: #FFF;
  font-size: 0.625rem;
  font-weight: 600;
  color: #E41F07;
  text-align: center;
  position: absolute;
  inset-inline-end: -0.625rem;
}
.custom-progress-3 .progress-bar .progress-bar-value.secondary {
  border: 0.125rem solid #FFA201;
  color: #FFA201;
}
.custom-progress-3 .progress-bar .progress-bar-value.warning {
  border: 0.125rem solid #FDA700;
  color: #FDA700;
}
.custom-progress-3 .progress-bar .progress-bar-value.info {
  border: 0.125rem solid #1ECBE2;
  color: #1ECBE2;
}
.custom-progress-3 .progress-bar .progress-bar-value.success {
  border: 0.125rem solid #5CB85C;
  color: #5CB85C;
}
.custom-progress-3 .progress-bar .progress-bar-value.danger {
  border: 0.125rem solid #FC0027;
  color: #FC0027;
}

.custom-progress-4.progress {
  background-color: rgba(228, 31, 7, 0.1);
  border-radius: 0.25rem;
}
.custom-progress-4.progress.secondary {
  background-color: rgba(255, 162, 1, 0.1);
}
.custom-progress-4.progress.secondary .progress-bar-label {
  color: #FFA201;
}
.custom-progress-4.progress.warning {
  background-color: rgba(253, 167, 0, 0.1);
}
.custom-progress-4.progress.warning .progress-bar-label {
  color: #FDA700;
}
.custom-progress-4.progress.info {
  background-color: rgba(30, 203, 226, 0.1);
}
.custom-progress-4.progress.info .progress-bar-label {
  color: #1ECBE2;
}
.custom-progress-4.progress.success {
  background-color: rgba(92, 184, 92, 0.1);
}
.custom-progress-4.progress.success .progress-bar-label {
  color: #5CB85C;
}
.custom-progress-4.progress.danger {
  background-color: rgba(252, 0, 39, 0.1);
}
.custom-progress-4.progress.danger .progress-bar-label {
  color: #FC0027;
}
.custom-progress-4.progress .progress-bar {
  border-radius: 0.25rem;
}
.custom-progress-4.progress .progress-bar-label {
  position: absolute;
  inset-inline-end: 0.313rem;
  font-weight: 600;
  font-size: 0.813rem;
  color: #E41F07;
}

.page-link {
  color: #6F6F6F;
  background-color: #FFF;
  border: 1px solid #E8E8E8;
}
.page-link:focus {
  box-shadow: none;
  background-color: #FDFDFE;
}
.page-link:hover {
  color: #E41F07;
  background-color: #FDFDFE;
  border-color: #E8E8E8;
}

.page-item.active .page-link {
  color: #FFF;
  background-color: #E41F07;
  border-color: #E41F07;
}

.disabled > .page-link, .page-link.disabled {
  color: #6F6F6F;
  background-color: #FFF;
  border-color: #E8E8E8;
  opacity: 0.7;
}

[dir=rtl] .pagination .page-link .bx-chevron-left::before {
  content: "\\ea50";
}
[dir=rtl] .pagination .page-link .bx-chevron-right::before {
  content: "\\ea4d";
}
[dir=rtl] .pagination .page-link .ri-arrow-right-s-line:before {
  content: "\\ea64";
}
[dir=rtl] .pagination .page-link .ri-arrow-left-s-line:before {
  content: "\\ea6e";
}

.pagination-style-1 .pagination .page-item {
  margin: 0 0.25rem;
}
.pagination-style-1 .pagination .page-item .page-link {
  border: 0;
  border-radius: 4px;
  font-size: 0.8125rem;
}
.pagination-style-1 .pagination .page-item .page-link i {
  font-weight: 600;
}
.pagination-style-1 .pagination .page-item.active .page-link {
  border-radius: 4px;
  background-color: #E41F07;
  color: #FFF;
}
.pagination-style-1 .pagination .page-item.active:hover .page-link {
  border-radius: 4px;
  background-color: #E41F07;
  color: #FFF;
}
.pagination-style-1 .pagination .page-item:hover .page-link {
  background-color: #FDFDFE;
  color: #E41F07;
}

.pagination-style-2 .pagination {
  border-radius: 4px;
}
.pagination-style-2 .pagination .page-item {
  margin: 0 0.25rem;
}
.pagination-style-2 .pagination .page-item .page-link {
  border: 0 !important;
  font-size: 0.8125rem;
}
.pagination-style-2 .pagination .page-item.active .page-link {
  background-color: #FFF;
  color: #E41F07;
  position: relative;
  font-weight: bold;
}
.pagination-style-2 .pagination .page-item.active .page-link:before {
  position: absolute;
  content: "";
  inset-block-end: 0;
  inset-inline-start: 0;
  width: 100%;
  height: 0.1rem;
  background-color: #E41F07;
}
.pagination-style-2 .pagination .page-item:hover .page-link {
  background-color: transparent;
}

.pagination-style-3 .pagination {
  border-radius: 50px;
  padding: 0.25rem;
  align-items: center;
}
.pagination-style-3 .pagination .page-item {
  margin: 0 0.25rem;
}
.pagination-style-3 .pagination .page-item .page-link {
  border: 0;
  border-radius: 50px;
  font-size: 0.8125rem;
}
.pagination-style-3 .pagination .page-item .page-link i {
  font-weight: 600;
}
.pagination-style-3 .pagination .page-item.active .page-link {
  background-color: #E41F07;
  color: #FFF;
}
.pagination-style-3 .pagination .page-item.active:hover .page-link {
  background-color: #E41F07;
}
.pagination-style-3 .pagination .page-item:hover .page-link {
  background-color: #FDFDFE;
}

.pagination-style-4 .pagination .page-item .page-link {
  border: 0 !important;
  font-size: 0.8125rem;
  border-radius: 4px;
}
.pagination-style-4 .pagination .page-item .page-link i {
  font-weight: 600;
}
.pagination-style-4 .pagination .page-item.active .page-link {
  border: 0;
  border-radius: 4px;
  background-color: #E41F07;
  color: #FFF;
}
.pagination-style-4 .pagination .page-item.active:hover .page-link {
  background-color: #E41F07;
}
.pagination-style-4 .pagination .page-item:hover .page-link {
  background-color: transparent;
}

h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  color: #262A2A;
  font-family: "Noto Sans", sans-serif;
  font-weight: 700;
  margin-bottom: 0;
}

h1,
.h1 {
  font-size: 2rem;
}

h2,
.h2 {
  font-size: 1.75rem;
}

h3,
.h3 {
  font-size: 1.5rem;
}

h4,
.h4 {
  font-size: 1.125rem;
}

h5,
.h5 {
  font-size: 1rem;
}

h6,
.h6 {
  font-size: 0.875rem;
}

.fs-sm {
  font-size: 0.6875rem;
}

.fs-base {
  font-size: 0.875rem;
}

.fs-lg {
  font-size: 1.125rem;
}

.fs-1 {
  font-size: 0.0625rem;
}

.fs-2 {
  font-size: 0.125rem;
}

.fs-3 {
  font-size: 0.1875rem;
}

.fs-4 {
  font-size: 0.25rem;
}

.fs-5 {
  font-size: 0.3125rem;
}

.fs-6 {
  font-size: 0.375rem;
}

.fs-7 {
  font-size: 0.4375rem;
}

.fs-8 {
  font-size: 0.5rem;
}

.fs-9 {
  font-size: 0.5625rem;
}

.fs-10 {
  font-size: 0.625rem;
}

.fs-11 {
  font-size: 0.6875rem;
}

.fs-12 {
  font-size: 0.75rem;
}

.fs-13 {
  font-size: 0.8125rem;
}

.fs-14 {
  font-size: 0.875rem;
}

.fs-15 {
  font-size: 0.9375rem;
}

.fs-16 {
  font-size: 1rem;
}

.fs-17 {
  font-size: 1.0625rem;
}

.fs-18 {
  font-size: 1.125rem;
}

.fs-19 {
  font-size: 1.1875rem;
}

.fs-20 {
  font-size: 1.25rem;
}

.fs-21 {
  font-size: 1.3125rem;
}

.fs-22 {
  font-size: 1.375rem;
}

.fs-23 {
  font-size: 1.4375rem;
}

.fs-24 {
  font-size: 1.5rem;
}

.fs-25 {
  font-size: 1.5625rem;
}

.fs-26 {
  font-size: 1.625rem;
}

.fs-27 {
  font-size: 1.6875rem;
}

.fs-28 {
  font-size: 1.75rem;
}
@media (max-width: 575.98px) {
  .fs-28 {
    font-size: 1.25rem;
  }
}

.fs-29 {
  font-size: 1.8125rem;
}

.fs-30 {
  font-size: 1.875rem;
}

.fs-32 {
  font-size: 2rem;
}

.fs-34 {
  font-size: 2.125rem;
}

.fs-36 {
  font-size: 2.25rem;
}

.fs-38 {
  font-size: 2.375rem;
}

.fs-40 {
  font-size: 2.5rem;
}

.fs-60 {
  font-size: 3.75rem;
}
@media (max-width: 991.98px) {
  .fs-60 {
    font-size: 2.125rem;
  }
}
@media (max-width: 575.98px) {
  .fs-60 {
    font-size: 1.125rem;
  }
}

.text-default {
  color: #6F6F6F !important;
}

.text-muted {
  color: #9595b5 !important;
}

.text-primary {
  color: #E41F07 !important;
  opacity: 1;
}
.text-primary.text-opacity-75 {
  color: rgba(228, 31, 7, 0.75) !important;
}
.text-primary.text-opacity-25 {
  color: rgba(228, 31, 7, 0.25) !important;
}
.text-primary.text-opacity-50 {
  color: rgba(228, 31, 7, 0.5) !important;
}

.text-secondary {
  color: #FFA201 !important;
  opacity: 1;
}

.text-info {
  color: #1ECBE2 !important;
  opacity: 1;
}

.text-success {
  color: #5CB85C !important;
  opacity: 1;
}

.text-warning {
  color: #FDA700 !important;
  opacity: 1;
}

.text-danger {
  color: #FC0027 !important;
  opacity: 1;
}

.text-blue {
  color: #339DFF !important;
}

.text-green {
  color: #00918E !important;
}

.text-pink {
  color: #EA00B7 !important;
}

.text-teal {
  color: #02a8b5 !important;
}

.text-orange {
  color: #FF9D0A !important;
}

.text-indigo {
  color: #0092E4 !important;
}

.text-purple {
  color: #4A00E5 !important;
}

.text-dark {
  color: #171724 !important;
}

.text-light {
  color: #FDFDFE !important;
}

.text-gray {
  color: #6F7A7A !important;
}

.text-black {
  color: #000 !important;
}

.text-white {
  color: #FFF !important;
}

.text-fixed-white {
  color: #FFF !important;
}

.text-fixed-black {
  color: #000 !important;
}

.text-gray-1 {
  color: #C0C0C0;
}

.text-gray-2 {
  color: #9B9B9B;
}

.text-gray-3 {
  color: #898989;
}

.text-gray-4 {
  color: #6F6F6F;
}

.text-gray-5 {
  color: #6F7A7A;
}

.text-gray-6 {
  color: #565E5E;
}

.text-gray-7 {
  color: #424848;
}

.text-gray-8 {
  color: #323737;
}

.text-gray-9 {
  color: #262A2A;
}

a {
  color: #262A2A;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.5s ease;
}
a:hover {
  color: #E41F07;
  transition: all 0.5s ease;
}
a:focus {
  outline: 0;
}

.link-primary {
  color: #E41F07 !important;
}
.link-primary:hover, .link-primary:focus, .link-primary:active {
  color: #E41F07 !important;
}

.link-secondary {
  color: #FFA201 !important;
}
.link-secondary:hover, .link-secondary:focus, .link-secondary:active {
  color: #FFA201 !important;
}

.link-success {
  color: #5CB85C !important;
}
.link-success:hover, .link-success:focus, .link-success:active {
  color: #5CB85C !important;
}

.link-danger {
  color: #FC0027 !important;
}
.link-danger:hover, .link-danger:focus, .link-danger:active {
  color: #FC0027 !important;
}

.link-warning {
  color: #FDA700 !important;
}
.link-warning:hover, .link-warning:focus, .link-warning:active {
  color: #FDA700 !important;
}

.link-info {
  color: #1ECBE2 !important;
}
.link-info:hover, .link-info:focus, .link-info:active {
  color: #1ECBE2 !important;
}

.link-light {
  color: #FDFDFE !important;
}
.link-light:hover, .link-light:focus, .link-light:active {
  color: #FDFDFE !important;
}

.link-dark {
  color: #171724 !important;
}
.link-dark:hover, .link-dark:focus, .link-dark:active {
  color: #171724 !important;
}

hr.text-danger {
  border-color: #FC0027 !important;
}

.text-purple {
  color: #4A00E5 !important;
}

.blockquote-container {
  padding: 1.25rem;
  border-left: 4px solid #E8E8E8;
  position: relative;
}
.blockquote-container.text-end {
  border-right: 4px solid #E8E8E8;
  border-left: 0;
}

.blockquote.custom-blockquote {
  font-size: 0.85rem;
  font-weight: 600;
  padding: 1rem;
  border-radius: 4px;
  position: relative;
}
.blockquote.custom-blockquote:before {
  content: "\\f10d";
  font-family: "Fontawesome";
  z-index: 0;
  font-size: 2rem;
  position: absolute;
  inset-block-start: 0;
  inset-inline-start: 0.5rem;
}
.blockquote.custom-blockquote.primary {
  background-color: rgba(228, 31, 7, 0.1);
  border-inline-start: 2px solid #E41F07;
}
.blockquote.custom-blockquote.primary:before {
  color: rgba(228, 31, 7, 0.1);
}
.blockquote.custom-blockquote.secondary {
  background-color: rgba(255, 162, 1, 0.1);
  border-inline-start: 2px solid #FFA201;
}
.blockquote.custom-blockquote.secondary:before {
  color: rgba(255, 162, 1, 0.1);
}
.blockquote.custom-blockquote.info {
  background-color: rgba(30, 203, 226, 0.1);
  border-inline-start: 2px solid #1ECBE2;
}
.blockquote.custom-blockquote.info:before {
  color: rgba(30, 203, 226, 0.1);
}
.blockquote.custom-blockquote.warning {
  background-color: rgba(253, 167, 0, 0.1);
  border-inline-start: 2px solid #FDA700;
}
.blockquote.custom-blockquote.warning:before {
  color: rgba(253, 167, 0, 0.1);
}
.blockquote.custom-blockquote.success {
  background-color: rgba(92, 184, 92, 0.1);
  border-inline-start: 2px solid #5CB85C;
}
.blockquote.custom-blockquote.success:before {
  color: rgba(92, 184, 92, 0.1);
}
.blockquote.custom-blockquote.danger {
  background-color: rgba(252, 0, 39, 0.1);
  border-inline-start: 2px solid #FC0027;
}
.blockquote.custom-blockquote.danger:before {
  color: rgba(252, 0, 39, 0.1);
}

[data-theme-mode=dark] .shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(33, 37, 41, 0.3) !important;
}
[data-theme-mode=dark] .shadow {
  box-shadow: 0 0.5rem 1rem rgba(33, 37, 41, 0.3) !important;
}
[data-theme-mode=dark] .shadow-lg {
  box-shadow: 0 1rem 3rem rgba(33, 37, 41, 0.3) !important;
}

@media screen and (min-width: 576px) {
  .w-sm-auto {
    width: auto;
  }
}
[dir=rtl] .text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

.transform-none {
  transform: none !important;
}

.w-9 {
  width: 9px;
}

.h-9 {
  height: 9px;
}

.list-circle {
  list-style: circle;
  padding-left: 2rem;
}

.alert {
  padding: 0.625rem 0.85rem;
  border-radius: 4px;
  font-size: 0.8125rem;
}
.alert.alert-dismissible {
  padding: 0.625rem 2.25rem 0.625rem 0.85rem;
}
.alert i {
  font-size: 20px;
}
.alert .btn-close {
  background-image: none;
  padding: 0.85rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.alert .btn-close i {
  font-size: 18px;
  line-height: 18px;
}
.alert:last-child {
  margin-bottom: 0;
}
.alert .alert-link {
  font-weight: 600;
}

[dir=rtl] .alert.alert-dismissible {
  padding: 0.625rem 0.85rem 0.625rem 2.25rem;
}

.alert-warning {
  background-color: rgba(253, 167, 0, 0.1);
  color: #FDA700;
  border-color: rgba(253, 167, 0, 0.1);
}
.alert-warning .alert-link {
  color: #FDA700;
}
.alert-warning .btn-close {
  color: #FDA700;
}
.alert-warning .btn-close.custom-close {
  background-color: #FDA700;
  color: #FFF;
  opacity: 1;
  border-radius: 50px;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  padding: 0.85rem;
}

.alert-primary {
  background-color: rgba(228, 31, 7, 0.1);
  color: #E41F07;
  border-color: rgba(228, 31, 7, 0.1);
}
.alert-primary .alert-link {
  color: #E41F07;
}
.alert-primary .custom-alert-icon {
  color: #E41F07;
}
.alert-primary .btn-close {
  color: #E41F07;
}
.alert-primary .btn-close.custom-close {
  background-color: #E41F07;
  color: #FFF;
  opacity: 1;
  border-radius: 50px;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  padding: 0.85rem;
}

.alert-secondary {
  background-color: rgba(255, 162, 1, 0.1);
  color: #FFA201;
  border-color: rgba(255, 162, 1, 0.1);
}
.alert-secondary .alert-link {
  color: #FFA201;
}
.alert-secondary .btn-close {
  color: #FFA201;
}
.alert-secondary .btn-close.custom-close {
  background-color: #FFA201;
  color: #FFF;
  opacity: 1;
  border-radius: 50px;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  padding: 0.85rem;
}

.alert-success {
  background-color: rgba(92, 184, 92, 0.1);
  color: #5CB85C;
  border-color: rgba(92, 184, 92, 0.1);
}
.alert-success .alert-link {
  color: #5CB85C;
}
.alert-success .btn-close {
  color: #5CB85C;
}
.alert-success .btn-close.custom-close {
  background-color: #5CB85C;
  color: #FFF;
  opacity: 1;
  border-radius: 50px;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  padding: 0.85rem;
}

.alert-info {
  background-color: rgba(30, 203, 226, 0.1);
  color: #1ECBE2;
  border-color: rgba(30, 203, 226, 0.1);
}
.alert-info .alert-link {
  color: #1ECBE2;
}
.alert-info .btn-close {
  color: #1ECBE2;
}
.alert-info .btn-close.custom-close {
  background-color: #1ECBE2;
  color: #FFF;
  opacity: 1;
  border-radius: 50px;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  padding: 0.85rem;
}

.alert-danger {
  background-color: rgba(252, 0, 39, 0.1);
  color: #FC0027;
  border-color: rgba(252, 0, 39, 0.1);
}
.alert-danger .alert-link {
  color: #FC0027;
}
.alert-danger .btn-close {
  color: #FC0027;
}
.alert-danger .btn-close.custom-close {
  background-color: #FC0027;
  color: #FFF;
  opacity: 1;
  border-radius: 50px;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  padding: 0.85rem;
}

.alert-light {
  background-color: #FDFDFE;
  color: #6F6F6F;
  border-color: #FDFDFE;
}
.alert-light .alert-link {
  color: #6F6F6F;
}
.alert-light .btn-close {
  color: #6F6F6F;
}
.alert-light .btn-close.custom-close {
  background-color: #FDFDFE;
  color: #FFF;
  opacity: 1;
  border-radius: 50px;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  padding: 0.85rem;
}

.alert-dark {
  background-color: rgba(23, 23, 36, 0.1);
  color: #6F6F6F;
  border-color: rgba(23, 23, 36, 0.1);
}
.alert-dark .alert-link {
  color: #6F6F6F;
}
.alert-dark .btn-close {
  color: #FFF;
}
.alert-dark .btn-close.custom-close {
  background-color: #171724;
  color: #FFF;
  opacity: 1;
  border-radius: 50px;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  padding: 0.85rem;
}

.alert-solid-primary {
  background-color: #E41F07;
  color: #FFF;
  border-color: #E41F07;
}
.alert-solid-primary .btn-close {
  color: #FFF;
}

.alert-solid-secondary {
  background-color: #FFA201;
  color: #FFF;
  border-color: #FFA201;
}
.alert-solid-secondary .btn-close {
  color: #FFF;
}

.alert-solid-warning {
  background-color: #FDA700;
  color: #FFF;
  border-color: #FDA700;
}
.alert-solid-warning .btn-close {
  color: #FFF;
}

.alert-solid-info {
  background-color: #1ECBE2;
  color: #FFF;
  border-color: #1ECBE2;
}
.alert-solid-info .btn-close {
  color: #FFF;
}

.alert-solid-success {
  background-color: #5CB85C;
  color: #FFF;
  border-color: #5CB85C;
}
.alert-solid-success .btn-close {
  color: #FFF;
}

.alert-solid-danger {
  background-color: #FC0027;
  color: #FFF;
  border-color: #FC0027;
}
.alert-solid-danger .btn-close {
  color: #FFF;
}

.alert-solid-light {
  background-color: #FDFDFE;
  color: #6F6F6F;
  border-color: #E8E8E8;
}

.alert-solid-dark {
  background-color: #171724;
  color: #FFF;
  border-color: #171724;
}
.alert-solid-dark .btn-close {
  color: #FFF;
}

.alert-outline-primary {
  background-color: #FFF;
  color: #E41F07;
  border-color: #E41F07;
}
.alert-outline-primary .btn-close {
  color: #E41F07;
}

.alert-outline-secondary {
  background-color: #FFF;
  color: #FFA201;
  border-color: #FFA201;
}
.alert-outline-secondary .btn-close {
  color: #FFA201;
}

.alert-outline-info {
  background-color: #FFF;
  color: #1ECBE2;
  border-color: #1ECBE2;
}
.alert-outline-info .btn-close {
  color: #1ECBE2;
}

.alert-outline-warning {
  background-color: #FFF;
  color: #FDA700;
  border-color: #FDA700;
}
.alert-outline-warning .btn-close {
  color: #FDA700;
}

.alert-outline-success {
  background-color: #FFF;
  color: #5CB85C;
  border-color: #5CB85C;
}
.alert-outline-success .btn-close {
  color: #5CB85C;
}

.alert-outline-danger {
  background-color: #FFF;
  color: #FC0027;
  border-color: #FC0027;
}
.alert-outline-danger .btn-close {
  color: #FC0027;
}

.alert-outline-light {
  background-color: #FFF;
  color: #6F6F6F;
  border-color: #FDFDFE;
}

.alert-outline-dark {
  background-color: #FFF;
  color: #171724;
  border-color: #171724;
}
.alert-outline-dark .btn-close {
  color: #171724;
}

.alert-primary.custom-alert-icon {
  border-inline-start: 0.313rem solid #E41F07 !important;
  color: #9595b5;
  background-color: #FFF;
  border: 1px solid #E8E8E8;
  font-size: 0.813rem;
}
.alert-primary.custom-alert-icon .btn-close {
  color: #6F6F6F;
}
.alert-primary.custom-alert-icon > i {
  color: #E41F07;
}

.alert-secondary.custom-alert-icon {
  border-inline-start: 0.313rem solid #FFA201 !important;
  color: #9595b5;
  background-color: #FFF;
  border: 1px solid #E8E8E8;
  font-size: 0.813rem;
}
.alert-secondary.custom-alert-icon .btn-close {
  color: #6F6F6F;
}
.alert-secondary.custom-alert-icon > i {
  color: #FFA201;
}

.alert-warning.custom-alert-icon {
  border-inline-start: 0.313rem solid #FDA700 !important;
  color: #9595b5;
  background-color: #FFF;
  border: 1px solid #E8E8E8;
  font-size: 0.813rem;
}
.alert-warning.custom-alert-icon .btn-close {
  color: #6F6F6F;
}
.alert-warning.custom-alert-icon > i {
  color: #FDA700;
}

.alert-danger.custom-alert-icon {
  border-inline-start: 0.313rem solid #FC0027 !important;
  color: #9595b5;
  background-color: #FFF;
  border: 1px solid #E8E8E8;
  font-size: 0.813rem;
}
.alert-danger.custom-alert-icon .btn-close {
  color: #6F6F6F;
}
.alert-danger.custom-alert-icon > i {
  color: #FC0027;
}

.alert-success.custom-alert-icon {
  border-inline-start: 0.313rem solid #5CB85C !important;
  color: #9595b5;
  background-color: #FFF;
  border: 1px solid #E8E8E8;
  font-size: 0.813rem;
}
.alert-success.custom-alert-icon .btn-close {
  color: #6F6F6F;
}

.alert-info.custom-alert-icon {
  border-inline-start: 0.313rem solid #1ECBE2 !important;
  color: #9595b5;
  background-color: #FFF;
  border: 1px solid #E8E8E8;
  font-size: 0.813rem;
}
.alert-info.custom-alert-icon .btn-close {
  color: #6F6F6F;
}

.alert-light.custom-alert-icon {
  border-inline-start: 0.313rem solid #FDFDFE !important;
  color: #9595b5;
  background-color: #FFF;
  border: 1px solid #E8E8E8;
  font-size: 0.813rem;
}
.alert-light.custom-alert-icon .btn-close {
  color: #6F6F6F;
}

.alert-dark.custom-alert-icon {
  border-inline-start: 0.313rem solid #171724 !important;
  color: #9595b5;
  background-color: #FFF;
  border: 1px solid #E8E8E8;
  font-size: 0.813rem;
}
.alert-dark.custom-alert-icon .btn-close {
  color: #6F6F6F;
}

.custom-alert1 {
  margin-block-end: 0;
  background-color: #FFF;
  border: 0;
  padding: 1.25rem;
  color: #6F6F6F;
}
.custom-alert1 p {
  margin-block-end: 2.5rem;
  color: #9595b5;
  font-size: 0.8rem;
}
.custom-alert1 .custom-alert-icon {
  font-size: 40px;
  margin-bottom: 0.85rem;
}
.custom-alert1 .custom-alert-icon i {
  font-size: 40px;
}
.custom-alert1 .btn-close {
  padding: 0;
  margin-block-end: 1rem;
}
.custom-alert1.alert-primary {
  border-block-start: 0.313rem solid #E41F07;
}
.custom-alert1.alert-primary .custom-alert-icon {
  color: #E41F07;
}
.custom-alert1.alert-secondary {
  border-block-start: 0.313rem solid #FFA201;
}
.custom-alert1.alert-secondary .custom-alert-icon {
  color: #FFA201;
}
.custom-alert1.alert-warning {
  border-block-start: 0.313rem solid #FDA700;
}
.custom-alert1.alert-warning .custom-alert-icon {
  color: #FDA700;
}
.custom-alert1.alert-danger {
  border-block-start: 0.313rem solid #FC0027;
}
.custom-alert1.alert-danger .custom-alert-icon {
  color: #FC0027;
}

.alert-img {
  display: flex;
  align-items: center;
}
.alert-img .avatar {
  border: 1px solid rgba(0, 0, 0, 0.1);
}

@media screen and (max-width: 400px) {
  .btn-close.custom-close {
    margin: 9px 9px 9px 0;
  }
}
.op-1-1 {
  opacity: 1;
}

.op-0 {
  opacity: 0;
}

.op-1 {
  opacity: 0.1;
}

.op-2 {
  opacity: 0.2;
}

.op-3 {
  opacity: 0.3;
}

.op-4 {
  opacity: 0.4;
}

.op-5 {
  opacity: 0.5;
}

.op-6 {
  opacity: 0.6;
}

.op-7 {
  opacity: 0.7;
}

.op-8 {
  opacity: 0.8;
}

.op-9 {
  opacity: 0.9;
}

.custom-popover {
  --bs-popover-max-width: 12.5rem;
  --bs-popover-border-color: #E41F07;
  --bs-popover-header-bg: #E41F07;
  --bs-popover-header-color: #FFF;
  --bs-popover-body-padding-x: 1rem;
  --bs-popover-body-padding-y: 0.5rem;
}

.popover {
  background-color: #FFF;
  border: 1px solid #E8E8E8;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  font-size: 0.8rem;
  border-radius: 4px;
  z-index: 999;
}
.popover .popover-header {
  background-color: #FFF;
  border-block-end: 1px solid #E8E8E8;
}
.popover .popover-body {
  color: #6F6F6F;
}
.popover.only-body {
  border-radius: 0.3rem;
}

.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after,
.bs-popover-top > .popover-arrow::after,
.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before,
.bs-popover-top > .popover-arrow::before {
  border-top-color: #FDFDFE;
}

.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after,
.bs-popover-end > .popover-arrow::after,
.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before,
.bs-popover-end > .popover-arrow::before {
  border-right-color: #FDFDFE;
}

.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after,
.bs-popover-start > .popover-arrow::after,
.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before,
.bs-popover-start > .popover-arrow::before {
  border-left-color: #FDFDFE;
}

.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after,
.bs-popover-bottom > .popover-arrow::after,
.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before,
.bs-popover-bottom > .popover-arrow::before,
.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before,
.bs-popover-bottom .popover-header::before {
  border-bottom-color: #FDFDFE;
}

.header-primary .popover-header {
  background-color: #E41F07;
  color: #FFF;
}
.header-primary.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .header-primary.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  border-bottom-color: #E41F07;
}

.header-secondary .popover-header {
  background-color: #FFA201;
  color: #FFF;
}
.header-secondary.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .header-secondary.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  border-bottom-color: #FFA201;
}

.header-warning .popover-header {
  background-color: #FDA700;
  color: #FFF;
}
.header-warning.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .header-warning.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  border-bottom-color: #FDA700;
}

.header-info .popover-header {
  background-color: #1ECBE2;
  color: #FFF;
}
.header-info.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .header-info.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  border-bottom-color: #1ECBE2;
}

.header-success .popover-header {
  background-color: #5CB85C;
  color: #FFF;
}
.header-success.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .header-success.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  border-bottom-color: #5CB85C;
}

.header-danger .popover-header {
  background-color: #FC0027;
  color: #FFF;
}
.header-danger.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .header-danger.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  border-bottom-color: #FC0027;
}

.popover-primary.popover {
  border: 1px solid #E41F07;
}
.popover-primary.popover .popover-header {
  background-color: #E41F07;
  border-block-end: 1px solid rgba(255, 255, 255, 0.1);
  color: #FFF;
  border-radius: 0.3rem 0.3rem 0 0;
}
.popover-primary.popover .popover-body {
  background-color: #E41F07;
  color: #FFF;
  border-radius: 0 0 0.3rem 0.3rem;
}
.popover-primary.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-primary.bs-popover-top > .popover-arrow::after, .popover-primary.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-primary.bs-popover-top > .popover-arrow::before {
  border-top-color: #E41F07;
}
.popover-primary.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-primary.bs-popover-end > .popover-arrow::after, .popover-primary.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-primary.bs-popover-end > .popover-arrow::before {
  border-right-color: #E41F07;
}
.popover-primary.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-primary.bs-popover-start > .popover-arrow::after, .popover-primary.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-primary.bs-popover-start > .popover-arrow::before {
  border-left-color: #E41F07;
}
.popover-primary.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-primary.bs-popover-bottom > .popover-arrow::after, .popover-primary.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-primary.bs-popover-bottom > .popover-arrow::before, .popover-primary.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-primary.bs-popover-bottom .popover-header::before {
  border-bottom-color: #E41F07;
}

.popover-secondary.popover {
  border: 1px solid #FFA201;
}
.popover-secondary.popover .popover-header {
  background-color: #FFA201;
  border-block-end: 1px solid rgba(255, 255, 255, 0.1);
  color: #FFF;
  border-radius: 0.3rem 0.3rem 0 0;
}
.popover-secondary.popover .popover-body {
  background-color: #FFA201;
  color: #FFF;
  border-radius: 0 0 0.3rem 0.3rem;
}
.popover-secondary.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-secondary.bs-popover-top > .popover-arrow::after, .popover-secondary.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-secondary.bs-popover-top > .popover-arrow::before {
  border-top-color: #FFA201;
}
.popover-secondary.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-secondary.bs-popover-end > .popover-arrow::after, .popover-secondary.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-secondary.bs-popover-end > .popover-arrow::before {
  border-right-color: #FFA201;
}
.popover-secondary.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-secondary.bs-popover-start > .popover-arrow::after, .popover-secondary.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-secondary.bs-popover-start > .popover-arrow::before {
  border-left-color: #FFA201;
}
.popover-secondary.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-secondary.bs-popover-bottom > .popover-arrow::after, .popover-secondary.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-secondary.bs-popover-bottom > .popover-arrow::before, .popover-secondary.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-secondary.bs-popover-bottom .popover-header::before {
  border-bottom-color: #FFA201;
}

.popover-warning.popover {
  border: 1px solid #FDA700;
}
.popover-warning.popover .popover-header {
  background-color: #FDA700;
  border-block-end: 1px solid rgba(255, 255, 255, 0.1);
  color: #FFF;
  border-radius: 0.3rem 0.3rem 0 0;
}
.popover-warning.popover .popover-body {
  background-color: #FDA700;
  color: #FFF;
  border-radius: 0 0 0.3rem 0.3rem;
}
.popover-warning.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-warning.bs-popover-top > .popover-arrow::after, .popover-warning.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-warning.bs-popover-top > .popover-arrow::before {
  border-top-color: #FDA700;
}
.popover-warning.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-warning.bs-popover-end > .popover-arrow::after, .popover-warning.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-warning.bs-popover-end > .popover-arrow::before {
  border-right-color: #FDA700;
}
.popover-warning.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-warning.bs-popover-start > .popover-arrow::after, .popover-warning.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-warning.bs-popover-start > .popover-arrow::before {
  border-left-color: #FDA700;
}
.popover-warning.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-warning.bs-popover-bottom > .popover-arrow::after, .popover-warning.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-warning.bs-popover-bottom > .popover-arrow::before, .popover-warning.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-warning.bs-popover-bottom .popover-header::before {
  border-bottom-color: #FDA700;
}

.popover-info.popover {
  border: 1px solid #1ECBE2;
}
.popover-info.popover .popover-header {
  background-color: #1ECBE2;
  border-block-end: 1px solid rgba(255, 255, 255, 0.1);
  color: #FFF;
  border-radius: 0.3rem 0.3rem 0 0;
}
.popover-info.popover .popover-body {
  background-color: #1ECBE2;
  color: #FFF;
  border-radius: 0 0 0.3rem 0.3rem;
}
.popover-info.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-info.bs-popover-top > .popover-arrow::after, .popover-info.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-info.bs-popover-top > .popover-arrow::before {
  border-top-color: #1ECBE2;
}
.popover-info.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-info.bs-popover-end > .popover-arrow::after, .popover-info.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-info.bs-popover-end > .popover-arrow::before {
  border-right-color: #1ECBE2;
}
.popover-info.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-info.bs-popover-start > .popover-arrow::after, .popover-info.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-info.bs-popover-start > .popover-arrow::before {
  border-left-color: #1ECBE2;
}
.popover-info.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-info.bs-popover-bottom > .popover-arrow::after, .popover-info.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-info.bs-popover-bottom > .popover-arrow::before, .popover-info.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-info.bs-popover-bottom .popover-header::before {
  border-bottom-color: #1ECBE2;
}

.popover-success.popover {
  border: 1px solid #5CB85C;
}
.popover-success.popover .popover-header {
  background-color: #5CB85C;
  border-block-end: 1px solid rgba(255, 255, 255, 0.1);
  color: #FFF;
  border-radius: 0.3rem 0.3rem 0 0;
}
.popover-success.popover .popover-body {
  background-color: #5CB85C;
  color: #FFF;
  border-radius: 0 0 0.3rem 0.3rem;
}
.popover-success.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-success.bs-popover-top > .popover-arrow::after, .popover-success.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-success.bs-popover-top > .popover-arrow::before {
  border-top-color: #5CB85C;
}
.popover-success.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-success.bs-popover-end > .popover-arrow::after, .popover-success.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-success.bs-popover-end > .popover-arrow::before {
  border-right-color: #5CB85C;
}
.popover-success.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-success.bs-popover-start > .popover-arrow::after, .popover-success.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-success.bs-popover-start > .popover-arrow::before {
  border-left-color: #5CB85C;
}
.popover-success.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-success.bs-popover-bottom > .popover-arrow::after, .popover-success.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-success.bs-popover-bottom > .popover-arrow::before, .popover-success.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-success.bs-popover-bottom .popover-header::before {
  border-bottom-color: #5CB85C;
}

.popover-danger.popover {
  border: 1px solid #FC0027;
}
.popover-danger.popover .popover-header {
  background-color: #FC0027;
  border-block-end: 1px solid rgba(255, 255, 255, 0.1);
  color: #FFF;
  border-radius: 0.3rem 0.3rem 0 0;
}
.popover-danger.popover .popover-body {
  background-color: #FC0027;
  color: #FFF;
  border-radius: 0 0 0.3rem 0.3rem;
}
.popover-danger.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-danger.bs-popover-top > .popover-arrow::after, .popover-danger.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-danger.bs-popover-top > .popover-arrow::before {
  border-top-color: #FC0027;
}
.popover-danger.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-danger.bs-popover-end > .popover-arrow::after, .popover-danger.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-danger.bs-popover-end > .popover-arrow::before {
  border-right-color: #FC0027;
}
.popover-danger.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-danger.bs-popover-start > .popover-arrow::after, .popover-danger.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-danger.bs-popover-start > .popover-arrow::before {
  border-left-color: #FC0027;
}
.popover-danger.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-danger.bs-popover-bottom > .popover-arrow::after, .popover-danger.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-danger.bs-popover-bottom > .popover-arrow::before, .popover-danger.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-danger.bs-popover-bottom .popover-header::before {
  border-bottom-color: #FC0027;
}

.popover-purple.popover {
  border: 1px solid #4A00E5;
}
.popover-purple.popover .popover-header {
  background-color: #4A00E5;
  border-block-end: 1px solid rgba(255, 255, 255, 0.1);
  color: #FFF;
  border-radius: 0.3rem 0.3rem 0 0;
}
.popover-purple.popover .popover-body {
  background-color: #4A00E5;
  color: #FFF;
  border-radius: 0 0 0.3rem 0.3rem;
}
.popover-purple.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-purple.bs-popover-top > .popover-arrow::after, .popover-purple.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-purple.bs-popover-top > .popover-arrow::before {
  border-top-color: #4A00E5;
}
.popover-purple.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-purple.bs-popover-end > .popover-arrow::after, .popover-purple.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-purple.bs-popover-end > .popover-arrow::before {
  border-right-color: #4A00E5;
}
.popover-purple.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-purple.bs-popover-start > .popover-arrow::after, .popover-purple.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-purple.bs-popover-start > .popover-arrow::before {
  border-left-color: #4A00E5;
}
.popover-purple.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-purple.bs-popover-bottom > .popover-arrow::after, .popover-purple.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-purple.bs-popover-bottom > .popover-arrow::before, .popover-purple.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-purple.bs-popover-bottom .popover-header::before {
  border-bottom-color: #4A00E5;
}

.popover-teal.popover {
  border: 1px solid #02a8b5;
}
.popover-teal.popover .popover-header {
  background-color: #02a8b5;
  border-block-end: 1px solid rgba(255, 255, 255, 0.1);
  color: #FFF;
  border-radius: 0.3rem 0.3rem 0 0;
}
.popover-teal.popover .popover-body {
  background-color: #02a8b5;
  color: #FFF;
  border-radius: 0 0 0.3rem 0.3rem;
}
.popover-teal.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-teal.bs-popover-top > .popover-arrow::after, .popover-teal.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-teal.bs-popover-top > .popover-arrow::before {
  border-top-color: #02a8b5;
}
.popover-teal.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-teal.bs-popover-end > .popover-arrow::after, .popover-teal.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-teal.bs-popover-end > .popover-arrow::before {
  border-right-color: #02a8b5;
}
.popover-teal.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-teal.bs-popover-start > .popover-arrow::after, .popover-teal.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-teal.bs-popover-start > .popover-arrow::before {
  border-left-color: #02a8b5;
}
.popover-teal.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-teal.bs-popover-bottom > .popover-arrow::after, .popover-teal.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-teal.bs-popover-bottom > .popover-arrow::before, .popover-teal.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-teal.bs-popover-bottom .popover-header::before {
  border-bottom-color: #02a8b5;
}

.popover-primary-light.popover {
  border: 1px solid rgba(228, 31, 7, 0.1);
}
.popover-primary-light.popover .popover-header {
  background-color: rgba(228, 31, 7, 0.1);
  border-block-end: 1px solid rgba(228, 31, 7, 0.1);
  color: #E41F07;
  border-radius: 0;
}
.popover-primary-light.popover .popover-body {
  background-color: rgba(228, 31, 7, 0.1);
  color: #E41F07;
}
.popover-primary-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-primary-light.bs-popover-top > .popover-arrow::after, .popover-primary-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-primary-light.bs-popover-top > .popover-arrow::before {
  border-top-color: rgba(228, 31, 7, 0.1);
}
.popover-primary-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-primary-light.bs-popover-end > .popover-arrow::after, .popover-primary-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-primary-light.bs-popover-end > .popover-arrow::before {
  border-right-color: rgba(228, 31, 7, 0.1);
}
.popover-primary-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-primary-light.bs-popover-start > .popover-arrow::after, .popover-primary-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-primary-light.bs-popover-start > .popover-arrow::before {
  border-left-color: rgba(228, 31, 7, 0.1);
}
.popover-primary-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-primary-light.bs-popover-bottom > .popover-arrow::after, .popover-primary-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-primary-light.bs-popover-bottom > .popover-arrow::before, .popover-primary-light.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-primary-light.bs-popover-bottom .popover-header::before {
  border-bottom-color: rgba(228, 31, 7, 0.1);
}

.popover-secondary-light.popover {
  border: 1px solid rgba(255, 162, 1, 0.1);
}
.popover-secondary-light.popover .popover-header {
  background-color: rgba(255, 162, 1, 0.1);
  border-block-end: 1px solid rgba(255, 162, 1, 0.1);
  color: #FFA201;
  border-radius: 0;
}
.popover-secondary-light.popover .popover-body {
  background-color: rgba(255, 162, 1, 0.1);
  color: #FFA201;
}
.popover-secondary-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-secondary-light.bs-popover-top > .popover-arrow::after, .popover-secondary-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-secondary-light.bs-popover-top > .popover-arrow::before {
  border-top-color: rgba(var(--secondary-rgb), 0.1);
}
.popover-secondary-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-secondary-light.bs-popover-end > .popover-arrow::after, .popover-secondary-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-secondary-light.bs-popover-end > .popover-arrow::before {
  border-right-color: rgba(255, 162, 1, 0.1);
}
.popover-secondary-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-secondary-light.bs-popover-start > .popover-arrow::after, .popover-secondary-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-secondary-light.bs-popover-start > .popover-arrow::before {
  border-left-color: rgba(var(--secondary-rgb), 0.1);
}
.popover-secondary-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-secondary-light.bs-popover-bottom > .popover-arrow::after, .popover-secondary-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-secondary-light.bs-popover-bottom > .popover-arrow::before, .popover-secondary-light.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-secondary-light.bs-popover-bottom .popover-header::before {
  border-bottom-color: rgba(var(--secondary-rgb), 0.1);
}

.popover-warning-light.popover {
  border: 1px solid rgba(253, 167, 0, 0.1);
}
.popover-warning-light.popover .popover-header {
  background-color: rgba(253, 167, 0, 0.1);
  border-block-end: 1px solid rgba(253, 167, 0, 0.1);
  color: #FDA700;
  border-radius: 0;
}
.popover-warning-light.popover .popover-body {
  background-color: rgba(253, 167, 0, 0.1);
  color: #FDA700;
}
.popover-warning-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-warning-light.bs-popover-top > .popover-arrow::after, .popover-warning-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-warning-light.bs-popover-top > .popover-arrow::before {
  border-top-color: rgba(253, 167, 0, 0.1);
}
.popover-warning-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-warning-light.bs-popover-end > .popover-arrow::after, .popover-warning-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-warning-light.bs-popover-end > .popover-arrow::before {
  border-right-color: rgba(253, 167, 0, 0.1);
}
.popover-warning-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-warning-light.bs-popover-start > .popover-arrow::after, .popover-warning-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-warning-light.bs-popover-start > .popover-arrow::before {
  border-left-color: rgba(253, 167, 0, 0.1);
}
.popover-warning-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-warning-light.bs-popover-bottom > .popover-arrow::after, .popover-warning-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-warning-light.bs-popover-bottom > .popover-arrow::before, .popover-warning-light.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-warning-light.bs-popover-bottom .popover-header::before {
  border-bottom-color: rgba(253, 167, 0, 0.1);
}

.popover-info-light.popover {
  border: 1px solid rgba(30, 203, 226, 0.1);
}
.popover-info-light.popover .popover-header {
  background-color: rgba(30, 203, 226, 0.1);
  border-block-end: 1px solid rgba(30, 203, 226, 0.1);
  color: #1ECBE2;
  border-radius: 0;
}
.popover-info-light.popover .popover-body {
  background-color: rgba(30, 203, 226, 0.1);
  color: #1ECBE2;
}
.popover-info-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-info-light.bs-popover-top > .popover-arrow::after, .popover-info-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-info-light.bs-popover-top > .popover-arrow::before {
  border-top-color: rgba(30, 203, 226, 0.1);
}
.popover-info-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-info-light.bs-popover-end > .popover-arrow::after, .popover-info-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-info-light.bs-popover-end > .popover-arrow::before {
  border-right-color: rgba(30, 203, 226, 0.1);
}
.popover-info-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-info-light.bs-popover-start > .popover-arrow::after, .popover-info-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-info-light.bs-popover-start > .popover-arrow::before {
  border-left-color: rgba(30, 203, 226, 0.1);
}
.popover-info-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-info-light.bs-popover-bottom > .popover-arrow::after, .popover-info-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-info-light.bs-popover-bottom > .popover-arrow::before, .popover-info-light.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-info-light.bs-popover-bottom .popover-header::before {
  border-bottom-color: rgba(30, 203, 226, 0.1);
}

.popover-success-light.popover {
  border: 1px solid rgba(92, 184, 92, 0.1);
}
.popover-success-light.popover .popover-header {
  background-color: rgba(92, 184, 92, 0.1);
  border-block-end: 1px solid rgba(92, 184, 92, 0.1);
  color: #5CB85C;
  border-radius: 0;
}
.popover-success-light.popover .popover-body {
  background-color: rgba(92, 184, 92, 0.1);
  color: #5CB85C;
}
.popover-success-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-success-light.bs-popover-top > .popover-arrow::after, .popover-success-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-success-light.bs-popover-top > .popover-arrow::before {
  border-top-color: rgba(92, 184, 92, 0.1);
}
.popover-success-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-success-light.bs-popover-end > .popover-arrow::after, .popover-success-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-success-light.bs-popover-end > .popover-arrow::before {
  border-right-color: rgba(92, 184, 92, 0.1);
}
.popover-success-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-success-light.bs-popover-start > .popover-arrow::after, .popover-success-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-success-light.bs-popover-start > .popover-arrow::before {
  border-left-color: rgba(92, 184, 92, 0.1);
}
.popover-success-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-success-light.bs-popover-bottom > .popover-arrow::after, .popover-success-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-success-light.bs-popover-bottom > .popover-arrow::before, .popover-success-light.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-success-light.bs-popover-bottom .popover-header::before {
  border-bottom-color: rgba(92, 184, 92, 0.1);
}

.popover-danger-light.popover {
  border: 1px solid rgba(252, 0, 39, 0.1);
}
.popover-danger-light.popover .popover-header {
  background-color: rgba(252, 0, 39, 0.1);
  border-block-end: 1px solid rgba(252, 0, 39, 0.1);
  color: #FC0027;
  border-radius: 0;
}
.popover-danger-light.popover .popover-body {
  background-color: rgba(252, 0, 39, 0.1);
  color: #FC0027;
}
.popover-danger-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-danger-light.bs-popover-top > .popover-arrow::after, .popover-danger-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-danger-light.bs-popover-top > .popover-arrow::before {
  border-top-color: rgba(252, 0, 39, 0.1);
}
.popover-danger-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-danger-light.bs-popover-end > .popover-arrow::after, .popover-danger-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-danger-light.bs-popover-end > .popover-arrow::before {
  border-right-color: rgba(252, 0, 39, 0.1);
}
.popover-danger-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-danger-light.bs-popover-start > .popover-arrow::after, .popover-danger-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-danger-light.bs-popover-start > .popover-arrow::before {
  border-left-color: rgba(252, 0, 39, 0.1);
}
.popover-danger-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-danger-light.bs-popover-bottom > .popover-arrow::after, .popover-danger-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-danger-light.bs-popover-bottom > .popover-arrow::before, .popover-danger-light.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-danger-light.bs-popover-bottom .popover-header::before {
  border-bottom-color: rgba(252, 0, 39, 0.1);
}

.popover-purple-light.popover {
  border: 1px solid rgba(var(--purple-rgb), 0.1);
}
.popover-purple-light.popover .popover-header {
  background-color: rgba(var(--purple-rgb), 0.1);
  border-block-end: 1px solid rgba(var(--purple-rgb), 0.1);
  color: #4A00E5;
  border-radius: 0;
}
.popover-purple-light.popover .popover-body {
  background-color: rgba(var(--purple-rgb), 0.1);
  color: #4A00E5;
}
.popover-purple-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-purple-light.bs-popover-top > .popover-arrow::after, .popover-purple-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-purple-light.bs-popover-top > .popover-arrow::before {
  border-top-color: rgba(var(--purple-rgb), 0.1);
}
.popover-purple-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-purple-light.bs-popover-end > .popover-arrow::after, .popover-purple-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-purple-light.bs-popover-end > .popover-arrow::before {
  border-right-color: rgba(var(--purple-rgb), 0.1);
}
.popover-purple-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-purple-light.bs-popover-start > .popover-arrow::after, .popover-purple-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-purple-light.bs-popover-start > .popover-arrow::before {
  border-left-color: rgba(var(--purple-rgb), 0.1);
}
.popover-purple-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-purple-light.bs-popover-bottom > .popover-arrow::after, .popover-purple-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-purple-light.bs-popover-bottom > .popover-arrow::before, .popover-purple-light.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-purple-light.bs-popover-bottom .popover-header::before {
  border-bottom-color: rgba(var(--purple-rgb), 0.1);
}

.popover-teal-light.popover {
  border: 1px solid rgba(var(--teal-rgb), 0.1);
}
.popover-teal-light.popover .popover-header {
  background-color: rgba(var(--teal-rgb), 0.1);
  border-block-end: 1px solid rgba(var(--teal-rgb), 0.1);
  color: #02a8b5;
  border-radius: 0;
}
.popover-teal-light.popover .popover-body {
  background-color: rgba(var(--teal-rgb), 0.1);
  color: #02a8b5;
}
.popover-teal-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-teal-light.bs-popover-top > .popover-arrow::after, .popover-teal-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-teal-light.bs-popover-top > .popover-arrow::before {
  border-top-color: rgba(var(--teal-rgb), 0.1);
}
.popover-teal-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-teal-light.bs-popover-end > .popover-arrow::after, .popover-teal-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-teal-light.bs-popover-end > .popover-arrow::before {
  border-right-color: rgba(var(--teal-rgb), 0.1);
}
.popover-teal-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-teal-light.bs-popover-start > .popover-arrow::after, .popover-teal-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-teal-light.bs-popover-start > .popover-arrow::before {
  border-left-color: rgba(var(--teal-rgb), 0.1);
}
.popover-teal-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-teal-light.bs-popover-bottom > .popover-arrow::after, .popover-teal-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-teal-light.bs-popover-bottom > .popover-arrow::before, .popover-teal-light.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-teal-light.bs-popover-bottom .popover-header::before {
  border-bottom-color: rgba(var(--teal-rgb), 0.1);
}

.timeline {
  position: relative;
  list-style: none;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 0 20px;
}
.timeline:before {
  content: " ";
  position: absolute;
  width: 3px;
  margin-left: -1.5px;
  background-color: #898989;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
}
.timeline > li {
  position: relative;
  margin-bottom: 20px;
}
.timeline > li::before, .timeline > li::after {
  content: " ";
  display: table;
}
.timeline > li > .timeline-panel {
  float: left;
  position: relative;
  width: 46%;
  padding: 20px;
  border: 1px solid #6F7A7A;
  border-radius: 0.25rem;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);
}
.timeline > li > .timeline-panel::before {
  content: " ";
  display: inline-block;
  position: absolute;
  border-top: 8px solid transparent;
  border-right: 0 solid #6F7A7A;
  border-bottom: 8px solid transparent;
  border-left: 8px solid #6F7A7A;
  position: absolute;
  top: 26px;
  right: -8px;
}
.timeline > li > .timeline-panel::after {
  content: " ";
  display: inline-block;
  position: absolute;
  top: 27px;
  right: -7px;
  border-top: 7px solid transparent;
  border-right: 0 solid #FFF;
  border-bottom: 7px solid transparent;
  border-left: 7px solid #FFF;
}

.timeline > li:after {
  clear: both;
}

.timeline > li > .timeline-badge {
  z-index: 1;
  width: 50px;
  height: 50px;
  margin-left: -25px;
  text-align: center;
  font-size: 1.4em;
  line-height: 50px;
  color: #FFF;
  overflow: hidden;
  border-radius: 50%;
  position: absolute;
  top: 16px;
  left: 50%;
}

.timeline > li.timeline-inverted > .timeline-panel {
  float: right;
}
.timeline > li.timeline-inverted > .timeline-panel::before {
  right: auto;
  left: -8px;
  border-right-width: 8px;
  border-left-width: 0;
}
.timeline > li.timeline-inverted > .timeline-panel::after {
  right: auto;
  left: -7px;
  border-right-width: 7px;
  border-left-width: 0;
}

.timeline-badge.primary {
  background-color: #E41F07;
}

.timeline-badge.success {
  background-color: #5CB85C;
}

.timeline-badge.warning {
  background-color: #FDA700;
}

.timeline-badge.danger {
  background-color: #FC0027;
}

.timeline-badge.info {
  background-color: #1ECBE2;
}

.timeline-title {
  margin-top: 0;
  color: inherit;
  font-weight: regular;
}

.timeline-body > p,
.timeline-body > ul {
  margin-bottom: 0;
}

.timeline-body > p + p {
  margin-top: 5px;
}

.form-wrap {
  margin-bottom: 24px;
}

.col-form-label {
  font-size: 14px;
  font-weight: 500;
  color: #262A2A;
}

.form-control {
  border-color: #E8E8E8;
  color: #6F6F6F;
  background-color: #ffffff;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.6;
  border-radius: 5px;
  padding: 0.5rem 0.85rem;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
  min-height: 42px;
}
.form-control:focus {
  box-shadow: none;
  border-color: #E8E8E8;
  background-color: #FFF;
  box-shadow: 0 0.0625rem 0.125rem 0 rgba(0, 0, 0, 0.05);
  color: #6F6F6F;
}

.form-control[type=file] {
  padding: 0.3rem 0.5rem;
  line-height: 2.2;
}
.form-control[type=file].form-control-sm {
  padding: 0.25rem 0.5rem !important;
}
.form-control[type=file].form-control-lg {
  padding: 0.5rem 1rem !important;
}

.col-form-label {
  font-size: 14px;
  font-weight: 500;
  color: #262A2A;
  padding: 0 0 5px;
}

.form-label {
  font-size: 14px;
  font-weight: 500;
  color: #262A2A;
}

.form-text {
  color: #9595b5;
}

.form-control-light {
  background-color: #FDFDFE;
  border: 0;
}
.form-control-light:focus {
  background-color: #FDFDFE;
}

.form-control-primary {
  background-color: rgba(228, 31, 7, 0.1);
  border: 0;
  color: #E41F07;
}
.form-control-primary:focus {
  background-color: rgba(228, 31, 7, 0.1);
  color: #E41F07;
}

.form-input-color {
  height: 2.25rem;
  width: 2.25rem;
  border-radius: 4px;
  overflow: hidden;
  padding: 0;
}

.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-select ~ label {
  color: #9595b5;
}

.form-floating > .form-control:not(:placeholder-shown) ~ label::after {
  background-color: transparent;
}

.input-group-text {
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
}

.form-select {
  background-color: #ffffff;
  border: 1px solid #E8E8E8;
  color: #6F6F6F;
  font-size: 14px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-size: 1.25rem;
  line-height: 2;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
}
.form-select option {
  background-color: #FFF;
  padding: 0.35rem 0.75rem;
  border-radius: 0.25rem;
  margin-block-end: 0.25rem;
}
.form-select option:last-child {
  margin-block-end: 0;
}
.form-select option:checked {
  background-color: rgba(var(#E41F07), 0.2);
  color: #E41F07;
}
.form-select option:select {
  background-color: rgba(var(#E41F07), 0.2);
  color: #E41F07;
}
.form-select option:hover {
  background-color: rgba(var(#E41F07), 0.2);
  color: #E41F07;
}
.form-select option:focus {
  background-color: rgba(var(#E41F07), 0.2);
  color: #E41F07;
}

.form-check-input {
  width: 0.9rem;
  height: 0.9rem;
  background-color: #FFF;
  border: 1px solid #E8E8E8;
}
.form-check-input:checked {
  background-color: #E41F07;
  border-color: #E41F07;
}
.form-check-input.form-checked-outline:checked {
  background-color: transparent;
  border-color: #E41F07;
}
.form-check-input.form-checked-secondary:checked {
  background-color: #FFA201;
  border-color: #FFA201;
}
.form-check-input.form-checked-warning:checked {
  background-color: #FDA700;
  border-color: #FDA700;
}
.form-check-input.form-checked-info:checked {
  background-color: #1ECBE2;
  border-color: #1ECBE2;
}
.form-check-input.form-checked-success:checked {
  background-color: #5CB85C;
  border-color: #5CB85C;
}
.form-check-input.form-checked-danger:checked {
  background-color: #FC0027;
  border-color: #FC0027;
}
.form-check-input.form-checked-light:checked {
  background-color: #FDFDFE;
  border-color: #FDFDFE;
}
.form-check-input.form-checked-dark:checked {
  background-color: #171724;
  border-color: #171724;
}
.form-check-input:focus {
  box-shadow: none;
}

.form-checked-outline:checked[type=checkbox] {
  background-image: none;
  position: relative;
  background-color: transparent;
}
.form-checked-outline:checked[type=checkbox]:before {
  content: "\\f633";
  font-family: bootstrap-icons !important;
  position: absolute;
  color: #E41F07;
  width: 0.625rem;
  height: 0.625rem;
  inset-block-start: -1px;
  inset-inline-start: 0px;
  font-size: 0.688rem;
}
.form-checked-outline:checked[type=checkbox].form-checked-secondary:before {
  color: #FFA201;
}
.form-checked-outline:checked[type=checkbox].form-checked-warning:before {
  color: #FDA700;
}
.form-checked-outline:checked[type=checkbox].form-checked-info:before {
  color: #1ECBE2;
}
.form-checked-outline:checked[type=checkbox].form-checked-success:before {
  color: #5CB85C;
}
.form-checked-outline:checked[type=checkbox].form-checked-danger:before {
  color: #FC0027;
}
.form-checked-outline:checked[type=checkbox].form-checked-light:before {
  color: #FDFDFE;
}
.form-checked-outline:checked[type=checkbox].form-checked-dark:before {
  color: #171724;
}

.form-checked-outline:checked[type=radio] {
  background-image: none;
  position: relative;
  background-color: transparent;
}
.form-checked-outline:checked[type=radio]:before {
  content: "\\f309";
  font-family: bootstrap-icons !important;
  position: absolute;
  color: #E41F07;
  width: 0.625rem;
  height: 0.625rem;
  inset-block-start: -1.13rem;
  inset-inline-start: -0.6rem;
  font-size: 2rem;
}
.form-checked-outline:checked[type=radio].form-checked-secondary:before {
  color: #FFA201;
}
.form-checked-outline:checked[type=radio].form-checked-warning:before {
  color: #FDA700;
}
.form-checked-outline:checked[type=radio].form-checked-info:before {
  color: #1ECBE2;
}
.form-checked-outline:checked[type=radio].form-checked-success:before {
  color: #5CB85C;
}
.form-checked-outline:checked[type=radio].form-checked-danger:before {
  color: #FC0027;
}
.form-checked-outline:checked[type=radio].form-checked-light:before {
  color: #FDFDFE;
}
.form-checked-outline:checked[type=radio].form-checked-dark:before {
  color: #171724;
}

fieldset:disabled .btn {
  color: #FFF;
  background-color: #E41F07;
  border-color: #E41F07;
}

.form-select:focus {
  border-color: rgba(var(#E41F07), 0.5);
  outline: 0;
  box-shadow: none;
}

.btn-check:focus + .btn,
.btn:focus {
  background-color: none;
  border-color: none;
  outline: 0;
}

.btn-check:active + .btn:focus,
.btn-check:checked + .btn:focus,
.btn.active:focus,
.btn.show:focus,
.btn:active:focus {
  box-shadow: none;
}

.form-control:disabled,
.form-select:disabled {
  background-color: #FDFDFE;
  color: #6F6F6F;
}

.form-control-plaintext {
  color: #6F6F6F;
}

.form-control::-webkit-file-upload-button {
  color: #6F6F6F;
  background-color: #f7f8f9;
}

.form-control:hover:not(:disabled):not([readonly])::-webkit-file-upload-button {
  background-color: #f7f8f9;
}

.form-control:focus::-webkit-input-placeholder, .form-control:focus::placeholder {
  padding-inline-start: 0.3rem;
  -webkit-transition: padding-inline-start 0.1s ease-in;
  transition: padding-inline-start 0.1s ease-in;
}
.form-control::-webkit-input-placeholder {
  font-size: 0.8rem;
  font-weight: 500;
  opacity: 0.7;
  color: #6F6F6F;
  padding-inline-start: 0px;
  -webkit-transition: padding-inline-start 0.1s ease-in;
  transition: padding-inline-start 0.1s ease-in;
}
.form-control:-moz-placeholder {
  font-size: 0.8rem;
  font-weight: 500;
  opacity: 0.4;
  color: #6F6F6F;
}
.form-control::-moz-placeholder {
  font-size: 0.8rem;
  font-weight: 500;
  opacity: 0.4;
  color: #6F6F6F;
}
.form-control:-ms-input-placeholder {
  font-size: 0.8rem;
  font-weight: 500;
  opacity: 0.4;
  color: #6F6F6F;
}

.form-control-sm {
  font-size: 0.8rem;
  padding: 0.25rem 0.8rem;
}

.form-control-lg {
  font-size: 1rem;
  padding: 0.5rem 1rem;
}

.form-check-md .form-check-input {
  width: 1.15rem;
  height: 1.15rem;
}
.form-check-md.form-switch .form-check-input {
  width: 2.25rem;
}
.form-check-md label {
  margin-inline-start: 0.5rem;
  font-size: 0.95rem;
  margin-block-start: 3px;
}

.form-check-lg .form-check-input {
  width: 1.35rem;
  height: 1.35rem;
}
.form-check-lg.form-switch .form-check-input {
  width: 2.5rem;
}
.form-check-lg label {
  margin-inline-start: 0.5rem;
  font-size: 1rem;
  margin-block-start: 3px;
}

.toggle {
  width: 3.75rem;
  height: 1.563rem;
  background-color: #FDFDFE;
  margin-inline-start: 0.625rem;
  margin-block-end: 0.313rem;
  padding: 0.125rem;
  border-radius: 0.188rem;
  position: relative;
  overflow: hidden;
  transition: all 0.2s ease;
}
.toggle span {
  position: absolute;
  inset-block-start: 0.188rem;
  inset-block-end: 0.25rem;
  inset-inline-start: 0.188rem;
  display: block;
  width: 1.25rem;
  border-radius: 0.125rem;
  background-color: #FFF;
  box-shadow: 0 0.125rem 0.125rem 0 rgba(0, 0, 0, 0.45);
  cursor: pointer;
  transition: all 0.2s ease;
}
.toggle span::before {
  content: "on";
  inset-inline-start: -1.563rem;
}
.toggle span::after {
  content: "off";
  inset-inline-end: -1.813rem;
  color: #9595b5;
}
.toggle span::before, .toggle span::after {
  position: absolute;
  font-size: 0.625rem;
  font-weight: 500;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  inset-block-start: 0.188rem;
  line-height: 1.38;
  transition: all 0.2s ease;
}
.toggle.on {
  background-color: rgba(var(#E41F07), 0.3);
}
.toggle.on span {
  background-color: #E41F07;
}
.toggle.on span::before {
  color: #E41F07;
}
.toggle.on.toggle-secondary {
  background-color: rgba(255, 162, 1, 0.4);
}
.toggle.on.toggle-secondary span {
  background-color: #FFA201;
}
.toggle.on.toggle-secondary span::before {
  color: #FFA201;
}
.toggle.on.toggle-warning {
  background-color: rgba(253, 167, 0, 0.4);
}
.toggle.on.toggle-warning span {
  background-color: #FDA700;
}
.toggle.on.toggle-warning span::before {
  color: #FDA700;
}
.toggle.on.toggle-info {
  background-color: rgba(30, 203, 226, 0.4);
}
.toggle.on.toggle-info span {
  background-color: #1ECBE2;
}
.toggle.on.toggle-info span::before {
  color: #1ECBE2;
}
.toggle.on.toggle-success {
  background-color: rgba(92, 184, 92, 0.4);
}
.toggle.on.toggle-success span {
  background-color: #5CB85C;
}
.toggle.on.toggle-success span::before {
  color: #5CB85C;
}
.toggle.on.toggle-danger {
  background-color: rgba(252, 0, 39, 0.4);
}
.toggle.on.toggle-danger span {
  background-color: #FC0027;
}
.toggle.on.toggle-danger span::before {
  color: #FC0027;
}
.toggle.on.toggle-light {
  background-color: rgba(253, 253, 254, 0.4);
}
.toggle.on.toggle-light span {
  background-color: #FDFDFE;
}
.toggle.on.toggle-light span::before, .toggle.on.toggle-light span::after {
  color: #9595b5;
}
.toggle.on.toggle-dark {
  background-color: rgba(23, 23, 36, 0.4);
}
.toggle.on.toggle-dark span {
  background-color: #171724;
}
.toggle.on.toggle-dark span::before {
  color: #FFF;
}
.toggle.on span {
  inset-inline-start: 2.313rem;
}
.toggle.on.toggle-sm span {
  inset-inline-start: 2.313rem;
}
.toggle.on.toggle-sm span::before {
  inset-block-start: -1px;
  inset-inline-start: -1.563rem;
}
.toggle.on.toggle-lg span {
  inset-inline-start: 2.563rem;
}
.toggle.on.toggle-lg span::before {
  inset-block-start: 0.5rem;
  inset-inline-start: -1.75rem;
}
.toggle.toggle-sm {
  height: 1.063rem;
  width: 3.125rem;
}
.toggle.toggle-sm span {
  width: 0.625rem;
  height: 0.625rem;
}
.toggle.toggle-sm span::after {
  inset-inline-end: -1.875rem;
  inset-block-start: -1px;
}
.toggle.toggle-lg {
  height: 2.125rem;
  width: 4.5rem;
}
.toggle.toggle-lg span {
  width: 1.75rem;
}
.toggle.toggle-lg span::after {
  inset-block-start: 0.5rem;
  inset-inline-end: -1.938rem;
}

.custom-toggle-switch > input[type=checkbox] {
  display: none;
}

.custom-toggle-switch > label {
  cursor: pointer;
  height: 0;
  position: relative;
  width: 2.5rem;
}

.label-primary {
  background: #E41F07;
  color: #FFF;
}

.label-secondary {
  background: #FFA201;
  color: #FFF;
}

.label-warning {
  background: #FDA700;
  color: #FFF;
}

.label-info {
  background: #1ECBE2;
  color: #FFF;
}

.label-success {
  background: #5CB85C;
  color: #FFF;
}

.label-danger {
  background: #FC0027;
  color: #FFF;
}

.label-light {
  background: #FDFDFE;
  color: #FFF;
}

.label-dark {
  background: #171724;
  color: #FFF;
}

.custom-toggle-switch > input[type=checkbox]:checked + label::before {
  background: inherit;
  opacity: 0.5;
}

.custom-toggle-switch > label::before {
  background: #9595b5;
  box-shadow: inset 0px 0px 0.625rem rgba(255, 255, 255, 0.5);
  border-radius: 0.5rem;
  content: "";
  height: 1rem;
  margin-block-start: -0.5rem;
  position: absolute;
  opacity: 0.3;
  transition: all 0.4s ease-in-out;
  width: 2.5rem;
}
.custom-toggle-switch > label::after {
  background: #FFF;
  border-radius: 1rem;
  box-shadow: 0 0 0.313rem rgba(228, 229, 237, 0.8);
  content: "";
  height: 1.5rem;
  inset-inline-start: -0.25rem;
  margin-block-start: -0.5rem;
  position: absolute;
  inset-block-start: -0.25rem;
  transition: all 0.3s ease-in-out;
  width: 1.5rem;
}

.custom-toggle-switch > input[type=checkbox]:checked + label::after {
  background: inherit;
  inset-inline-start: 50%;
}

.custom-toggle-switch.toggle-sm > label::before {
  height: 10px;
  width: 27px;
  border-radius: 10px;
}

.custom-toggle-switch.toggle-sm input[type=checkbox]:checked + label::after {
  inset-inline-start: 13px;
}

.custom-toggle-switch.toggle-sm > label::after {
  height: 17px;
  width: 17px;
  border-radius: 50%;
}

.custom-toggle-switch.toggle-lg > label::before {
  height: 27px;
  width: 55px;
  border-radius: 20px;
}

.custom-toggle-switch.toggle-lg input[type=checkbox]:checked + label::after {
  inset-inline-start: 77%;
}

.custom-toggle-switch.toggle-lg > label::after {
  height: 35px;
  width: 35px;
  margin-block-start: -8px;
  border-radius: 50%;
}

.form-floating > .form-control-plaintext::placeholder,
.form-floating > .form-control::placeholder {
  color: transparent !important;
}

.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem - 4px);
}

.form-floating.floating-primary label {
  color: #E41F07;
  opacity: 1;
}
.form-floating.floating-primary input {
  border: 1px solid #E41F07;
}
.form-floating.floating-primary > .form-control:focus ~ label {
  color: #E41F07 !important;
}
.form-floating.floating-secondary label {
  color: #FFA201;
  opacity: 1;
}
.form-floating.floating-secondary input {
  border: 1px solid #FFA201;
}
.form-floating.floating-secondary > .form-control:focus ~ label {
  color: #FFA201 !important;
}
.form-floating.floating-warning label {
  color: #FDA700;
  opacity: 1;
}
.form-floating.floating-warning input {
  border: 1px solid #FDA700;
}
.form-floating.floating-warning > .form-control:focus ~ label {
  color: #FDA700 !important;
}
.form-floating.floating-info label {
  color: #1ECBE2;
  opacity: 1;
}
.form-floating.floating-info input {
  border: 1px solid #1ECBE2;
}
.form-floating.floating-info > .form-control:focus ~ label {
  color: #1ECBE2 !important;
}
.form-floating.floating-success label {
  color: #5CB85C;
  opacity: 1;
}
.form-floating.floating-success input {
  border: 1px solid #5CB85C;
}
.form-floating.floating-success > .form-control:focus ~ label {
  color: #5CB85C !important;
}
.form-floating.floating-danger label {
  color: #FC0027;
  opacity: 1;
}
.form-floating.floating-danger input {
  border: 1px solid #FC0027;
}
.form-floating.floating-danger > .form-control:focus ~ label {
  color: #FC0027 !important;
}

.form-floating > .form-control-plaintext ~ label::after,
.form-floating > .form-control:focus ~ label::after,
.form-floating > .form-control:not(:placeholder-shown) ~ label::after,
.form-floating > .form-select ~ label::after {
  background-color: #FFF;
  border-radius: 4px;
}

.form-wizard-1 {
  border-bottom: 0;
  border-radius: 50px;
}
.form-wizard-1 .nav-link {
  border: 0;
}
.form-wizard-1.nav-tabs .nav-item {
  margin-inline-end: 1rem;
  position: relative;
}
.form-wizard-1.nav-tabs .nav-link {
  padding: 0.25rem 0.4rem;
  color: #9595b5;
  display: flex;
  align-items: center;
  border-radius: 50px;
  border: 2px solid transparent;
}
.form-wizard-1.nav-tabs .nav-link i {
  font-size: 12px;
  padding: 4px;
  line-height: 1;
  border-radius: 50px;
  border: 2px solid #E8E8E8;
}
.form-wizard-1.nav-tabs .nav-link:focus, .form-wizard-1.nav-tabs .nav-link:hover {
  border: 2px solid transparent;
}
.form-wizard-1.nav-tabs .nav-link.active {
  border: 2px solid #E41F07;
  border-radius: 50px;
  color: #E41F07;
  background-color: transparent;
}
.form-wizard-1.nav-tabs .nav-link.active i {
  border: 2px solid #E41F07;
}
.form-wizard-1 .nav-item:focus-visible {
  outline: none;
}

.form-control.is-valid:focus,
.was-validated .form-control:valid:focus {
  border-color: #5CB85C;
  box-shadow: none;
}

.form-control.is-valid,
.was-validated .form-control:valid {
  border-color: #5CB85C;
}

.form-control-color {
  width: 1.75rem;
  height: 1.75rem;
  overflow: hidden;
  padding: 0;
}

.example-picker .pcr-button {
  border-radius: 0.35rem !important;
  overflow: hidden;
}

[dir=rtl] [type=email],
[dir=rtl] [type=number],
[dir=rtl] [type=tel],
[dir=rtl] [type=url] {
  direction: rtl;
}

.form-select.is-invalid:not([multiple]):not([size]) {
  padding-right: 1.125rem;
  background-size: 16px 28px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.invoice-quantity-container .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: 0;
}

input[type=range]::-webkit-slider-runnable-track {
  background-color: #FDFDFE;
}

[dir=rtl] .form-checked-outline:checked[type=checkbox]:before {
  inset-inline-start: 1px;
}

.is-invalid ~ .invalid-feedback, .is-invalid ~ .invalid-tooltip, .was-validated :invalid ~ .invalid-feedback, .was-validated :invalid ~ .invalid-tooltip {
  display: inline-block;
}

.is-valid ~ .valid-feedback, .is-valid ~ .valid-tooltip, .was-validated :valid ~ .valid-feedback, .was-validated :valid ~ .valid-tooltip {
  display: inline-block;
}

.invalid-tooltip, .valid-tooltip {
  position: relative;
  top: 0;
}

.form-check {
  min-height: inherit !important;
}

.col-form-label-lg,
.col-form-label-sm,
.col-form-label {
  font-weight: 500;
}

#exampleColorInput::-webkit-color-swatch-wrapper {
  direction: rtl;
}

[data-theme-mode=dark] input[type=week]::-webkit-calendar-picker-indicator, [data-theme-mode=dark] input[type=month]::-webkit-calendar-picker-indicator, [data-theme-mode=dark] input[type=date]::-webkit-calendar-picker-indicator, [data-theme-mode=dark] input[type=datetime-local]::-webkit-calendar-picker-indicator, [data-theme-mode=dark] input[type=time]::-webkit-calendar-picker-indicator {
  filter: invert(1);
}

[dir=rtl] input[type=week], [dir=rtl] input[type=month], [dir=rtl] input[type=date], [dir=rtl] input[type=datetime-local], [dir=rtl] input[type=time] {
  text-align: end;
}

.form-control.form-control-lg {
  height: 46px;
}
.form-control.form-control-sm {
  height: 30px;
  min-height: 30px;
}

.input-group-sm .input-group-text {
  height: 35px;
}
.input-group-sm .form-control {
  height: 35px;
  min-height: 35px;
}

.input-icon-addon {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 2.5rem;
  color: #515B73;
  pointer-events: none;
  font-size: 1.2em;
}

.checkboxs {
  display: block;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  position: relative;
  padding-left: 25px;
}
.checkboxs input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkboxs input ~ .checkmarks {
  border: 1px solid #E8E8E8;
  border-radius: 5px;
}

.checkboxs input:checked ~ .checkmarks {
  background-color: #4A00E5;
  border-color: #4A00E5;
}

.checkboxs input:checked ~ .checkmarks:after {
  display: block;
}

.checkboxs .checkmarks {
  height: 16px;
  width: 16px;
  position: absolute;
  top: 0;
  left: 0;
}

.checkboxs .checkmarks:after {
  content: "";
  position: absolute;
  display: none;
}

.checkboxs .checkmarks:after {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  content: "\\f00c";
  font-family: "Font Awesome 5 Free";
  color: #FFF;
  font-weight: 600;
  font-size: 10px;
}

.status-radio:checked,
.status-radio:not(:checked) {
  position: absolute;
  left: -9999px;
}

.status-radio:checked + label,
.status-radio:not(:checked) + label {
  position: relative;
  padding-left: 24px;
  cursor: pointer;
  line-height: 16px;
  display: inline-block;
  color: #262A2A;
}

.status-radio:checked + label:before,
.status-radio:not(:checked) + label:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 16px;
  height: 16px;
  border: 1px solid #E8E8E8;
  border-radius: 100%;
  background: #FFF;
}

.status-radio:checked + label:before {
  background: #0092E4;
  border-color: #0092E4;
}

.status-radio[type=radio]:checked + label:after,
.status-radio[type=radio]:not(:checked) + label:after {
  content: "";
  width: 8px;
  height: 8px;
  background: #FFF;
  position: absolute;
  top: 4px;
  left: 4px;
  border-radius: 100%;
  transition: all 0.2s ease;
}

[type=radio]:not(:checked) + label:after {
  opacity: 0;
  transform: scale(0);
}

[type=radio]:checked + label:after {
  opacity: 1;
  transform: scale(1);
}

.bootstrap-tagsinput {
  border-color: #F6F6F6;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
  border-radius: 5px;
  font-size: 14px;
  color: #6F6F6F;
  min-height: 42px;
  line-height: 2;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  max-height: 42px;
  overflow-y: auto;
}
.bootstrap-tagsinput .tag {
  background: #F6F6F6;
  color: #6F6F6F;
  padding: 2px 5px;
  line-height: normal;
  border-radius: 5px;
  font-size: 14px;
}

.notes-page-wrapper .content {
  padding: 24px;
}
.notes-page-wrapper .content .page-add-notes {
  border-bottom: 1px solid #E8E8E8;
  padding-bottom: 25px;
  position: relative;
  margin-bottom: 0;
}
@media (max-width: 767.98px) {
  .notes-page-wrapper .content .page-add-notes {
    flex-direction: column;
    align-items: start;
  }
}
.notes-page-wrapper .content .page-add-notes .notes-tog {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  position: absolute;
  bottom: -12px;
  border-radius: 30px;
  background: #1B2850;
  color: #FFF;
  width: 24px;
  height: 24px;
  padding: 5px;
}
@media (max-width: 991.98px) {
  .notes-page-wrapper .content .page-add-notes .notes-tog {
    display: none;
  }
}
.notes-page-wrapper .content .section-bulk-wrap {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin: 30px 0 24px 0;
  padding: 20px;
  border-radius: 8px;
  background: #FFF;
  box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);
}
@media (max-width: 767.98px) {
  .notes-page-wrapper .content .section-bulk-wrap {
    flex-direction: column;
    align-items: start;
  }
}
.notes-page-wrapper .content .section-bulk-wrap .bulk-action-type {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
@media (max-width: 767.98px) {
  .notes-page-wrapper .content .section-bulk-wrap .bulk-action-type {
    margin-bottom: 20px;
  }
}
@media (max-width: 575.98px) {
  .notes-page-wrapper .content .section-bulk-wrap .bulk-action-type {
    margin-bottom: 0;
    flex-direction: column;
    align-items: self-start;
  }
}
.notes-page-wrapper .content .section-bulk-wrap .bulk-action-type .select-bluk {
  margin-right: 8px;
  height: 40px;
}
.notes-page-wrapper .content .section-bulk-wrap .bulk-action-type .select-bluk .select2-container .selection .select2-selection .select2-selection__rendered {
  padding-left: 10px !important;
}
.notes-page-wrapper .content .section-bulk-wrap .bulk-action-type .btn-added {
  background: #6F7A7A;
  padding: 8px 20px;
  color: #FFF;
  font-size: 15px;
  font-weight: 400;
  margin-right: 15px;
  height: 40px;
  line-height: normal;
}
.notes-page-wrapper .content .section-bulk-wrap .bulk-action-type .btn-added:hover {
  background: #E41F07;
}
@media (max-width: 575.98px) {
  .notes-page-wrapper .content .section-bulk-wrap .bulk-action-type .btn-added {
    margin: 20px 0;
  }
}
.notes-page-wrapper .content .section-bulk-wrap .form-sort .fa-filter {
  z-index: 100 !important;
  position: absolute;
  top: 15px;
  left: 15px;
  width: 16px;
  height: 16px;
}
.notes-page-wrapper .content .section-notes-slider {
  position: relative;
  padding-bottom: 40px;
  border-bottom: 1px solid #E8E8E8;
}
.notes-page-wrapper .content .section-notes-slider .notes-content {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-bottom: 20px;
}
.notes-page-wrapper .content .section-notes-slider .notes-content .notes-close a {
  color: #FC0027;
  font-size: 15px;
  font-weight: 400;
}
.notes-page-wrapper .content .section-notes-slider .notes-content .notes-close a i {
  margin-right: 6px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card {
  padding: 24px;
  border-radius: 8px;
  background: rgba(255, 159, 67, 0.03);
}
.notes-page-wrapper .content .section-notes-slider .notes-card.medium {
  background: rgba(116, 41, 248, 0.03);
}
.notes-page-wrapper .content .section-notes-slider .notes-card.high {
  background: rgba(234, 84, 85, 0.03);
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-card-body {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-card-body p.badged {
  border-radius: 8px;
  border: 1px solid #FDA700;
  padding: 4px 10px;
  margin-bottom: 0;
  color: #FDA700;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-card-body p.badged i {
  font-size: 7px;
  margin-right: 4px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-card-body p.badged.medium {
  color: #7429F8;
  border: 1px solid #7429F8;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-card-body p.badged.high {
  color: #FC0027;
  border: 1px solid #FC0027;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-card-body a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  color: #6F7A7A;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-card-body a.dropdown-item:hover {
  color: #262A2A;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-card-body a.dropdown-item:hover svg {
  color: #262A2A;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-content {
  margin: 24px 0;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-content h4 a {
  margin-bottom: 10px;
  color: #6F7A7A;
  font-size: 16px;
  font-weight: 600;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-content h4 a:hover {
  color: #FDA700;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-content p {
  color: #6F6F6F;
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 0px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo a {
  margin-right: 15px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo a span {
  width: 32px;
  height: 32px;
  display: flex;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo a span img {
  border-radius: 100px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo span.medium-square {
  margin-right: 5px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo span.medium-square i {
  color: #5CB85C;
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo span.high-square {
  margin-right: 5px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo span.high-square i {
  color: #FDA700;
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo span.low-square {
  margin-right: 5px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo span.low-square i {
  color: #288EC7;
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo p {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  color: #288EC7;
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 0px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo p i.fa-draw-polygon {
  margin-right: 5px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo p.medium {
  color: #5CB85C;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo p.high {
  color: #FDA700;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-star-delete {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-star-delete span .fa-star {
  color: #FDA700;
  width: 16px;
  height: 16px;
  margin-right: 10px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-star-delete span .feather-trash-2 {
  color: #FC0027;
  width: 16px;
  height: 16px;
}
.notes-page-wrapper .content .section-card-body {
  padding-top: 40px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details {
  border-radius: 8px;
  border: 1px solid rgba(145, 158, 171, 0.3);
  background: #FFF;
  box-shadow: 0px 4px 60px 0px rgba(190, 190, 190, 0.27);
  padding: 24px;
  margin-bottom: 24px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-card-body {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-card-body p.badged {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  border-radius: 8px;
  border: 1px solid #FDA700;
  padding: 4px 10px;
  margin-bottom: 0;
  color: #FDA700;
  font-size: 14px;
  font-weight: 600;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-card-body p.badged i {
  font-size: 7px;
  margin-right: 4px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-card-body p.badged.medium {
  color: #7429F8;
  border: 1px solid #7429F8;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-card-body p.badged.high {
  color: #FC0027;
  border: 1px solid #FC0027;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-card-body .dropdown-item span {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  color: #6F7A7A;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-card-body .dropdown-item span svg {
  width: 14px;
  height: 14px;
  color: #6F6F6F;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-card-body .dropdown-item:hover span svg {
  color: #FFF;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-wrap-content {
  padding: 20px 0;
  border-bottom: 1px solid #E8E8E8;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-wrap-content h4 a {
  color: #6F7A7A;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 5px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-wrap-content h4 a:hover {
  color: #FDA700;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-wrap-content .wrap-cal {
  color: #6F6F6F;
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-wrap-content .wrap-cal svg {
  margin-right: 5px;
  width: 16px;
  height: 16px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-wrap-content p {
  color: #6F6F6F;
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 0px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget.notes-widget-profile {
  padding-top: 20px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo a {
  margin-right: 15px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo a span img {
  border-radius: 100px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo span.medium-square {
  margin-right: 5px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo span.medium-square i {
  color: #5CB85C;
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo span.high-square {
  margin-right: 5px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo span.high-square i {
  color: #FDA700;
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo span.low-square {
  margin-right: 5px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo span.low-square i {
  color: #288EC7;
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo p {
  color: #288EC7;
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 0px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo p i.fa-draw-polygon {
  margin-right: 5px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo p.medium {
  color: #5CB85C;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo p.high {
  color: #FDA700;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-star-delete {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-star-delete span .feather-star {
  color: #6F6F6F;
  width: 16px;
  height: 16px;
  margin-right: 10px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-star-delete span .feather-trash-2 {
  color: #FC0027;
  width: 16px;
  height: 16px;
}

.notes-card-details .notes-card-body a {
  color: #6F7A7A;
}

.star-todo-inbox svg {
  width: 13px;
  height: 13px;
  color: #6F6F6F;
}

.inbox-call-profile {
  border-radius: 5px;
  background: #E92990;
  border: 1px solid #E92990;
  padding: 4px 10px;
  font-size: 14px;
  font-weight: 700;
  color: #FFF;
  margin: 0 20px;
}
.inbox-call-profile:hover {
  color: #E92990;
  background: #FFF;
}

.notes-tog i {
  transform: rotate(180deg);
}
.notes-tog.active i {
  transform: rotate(0deg);
}

.section-bulk-wrap .form-sort {
  position: relative;
}
.section-bulk-wrap .form-sort svg.feather-filter {
  position: absolute;
  z-index: 101;
  width: 16px;
  height: 16px;
  top: 12px;
  left: 10px;
}

.page-add-notes.active svg {
  transform: rotate(0) !important;
}

.dropdown-menu.notes-menu {
  z-index: 99999;
}
.dropdown-menu.notes-menu a.dropdown-item {
  color: #6F7A7A;
  font-size: 15px;
  font-weight: 400;
  display: flex;
  align-items: center;
  padding: 5px;
  border-radius: 5px;
}
.dropdown-menu.notes-menu a.dropdown-item:hover {
  background: #F6F6F6;
  color: #262A2A;
}
.dropdown-menu.notes-menu a.dropdown-item:hover svg {
  color: #262A2A;
}
.dropdown-menu.notes-menu span {
  margin-right: 8px;
}
.dropdown-menu.notes-menu svg {
  width: 14px;
  height: 14px;
  color: #6F6F6F;
}

.edit-note-head a {
  border-radius: 30px;
  border: 1px solid rgba(145, 158, 171, 0.3);
  background: #FFF;
  color: #6F7A7A;
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
}
.edit-note-head a:hover {
  border-radius: 20px;
  background: #E41F07;
  color: #FFF;
}

.custom-modal-body .select2-container .selection .select2-selection .select2-selection__rendered {
  padding-left: 10px !important;
}

.bulk-con-wrap {
  width: 100%;
}

.section-bulk-widget {
  transition: 0.6s all;
}

.section-notes-dashboard {
  display: none;
  transition: 0.6s all;
}

.notes-tog i {
  transition: 0.5s all;
}

.notes-tag-left .notes-tog i {
  transform: rotate(360deg);
  transition: 0.5s all;
}

.budgeted-role-notes {
  width: 100%;
}

.notes-summernote .card {
  margin-bottom: 0 !important;
}

.dropdown-item:active {
  background: transparent;
}

.notes-summernote p {
  color: #6F6F6F;
  font-size: 15px;
  font-weight: 400;
}

.budget-role-notes .owl-carousel .owl-nav {
  margin: 0;
  position: absolute;
}

.notes-dash {
  margin-top: 30px;
  padding: 24px;
  border-radius: 8px;
  border: 1px solid rgba(145, 158, 171, 0.3);
  background: #FFF;
  transition: 0.6s all;
}
.notes-dash .notes-top-head {
  border-bottom: 1px solid #E8E8E8;
}
.notes-dash .notes-top-head h5 {
  font-size: 18px;
  font-weight: 700;
  color: #6F7A7A;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}
.notes-dash .notes-top-head h5 svg {
  width: 19px;
  height: 19px;
  margin-right: 6px;
  color: #6F6F6F;
}
.notes-dash .notes-top-head-submenu {
  padding: 15px 0;
  border-bottom: 1px solid #E8E8E8;
}
.notes-dash .notes-top-head-submenu ul {
  padding: 15px 0;
}
.notes-dash .notes-top-head-submenu ul li {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  padding: 10px;
}
.notes-dash .notes-top-head-submenu ul li.active {
  border-radius: 10px;
  background: #6F7A7A;
}
.notes-dash .notes-top-head-submenu ul li.active svg {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}
.notes-dash .notes-top-head-submenu ul li.active p {
  color: #FFF;
}
.notes-dash .notes-top-head-submenu ul li p {
  font-size: 15px;
  font-weight: 600;
  color: #6F6F6F;
  margin-bottom: 0;
  display: flex;
  align-items: center;
}
.notes-dash .notes-top-head-submenu ul li p svg {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}
.notes-dash .notes-top-head-submenu ul li span {
  display: flex;
  width: 18px;
  height: 18px;
  padding: 0px 3px;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  background: #E41F07;
  color: #FFF;
}
.notes-dash .content-submenu-tag {
  margin-top: 15px;
  padding: 10px;
}
.notes-dash .content-submenu-tag h6 {
  font-size: 16px;
  font-weight: 600;
  color: #6F7A7A;
}
.notes-dash .content-submenu-tag ul {
  padding: 10px 0;
}
.notes-dash .content-submenu-tag ul.tags-list {
  margin-bottom: 24px;
}
.notes-dash .content-submenu-tag ul li {
  font-size: 15px;
  font-weight: 400;
  display: flex;
  align-items: center;
}
.notes-dash .content-submenu-tag ul li.personal span {
  margin-right: 8px;
}
.notes-dash .content-submenu-tag ul li.personal span i {
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-dash .content-submenu-tag ul li.personal a {
  color: #288EC7;
  display: flex;
  align-items: center;
}
.notes-dash .content-submenu-tag ul li.social span {
  margin-right: 8px;
}
.notes-dash .content-submenu-tag ul li.social span i {
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-dash .content-submenu-tag ul li.social a {
  color: #FDA700;
  display: flex;
  align-items: center;
}
.notes-dash .content-submenu-tag ul li.work span {
  margin-right: 8px;
}
.notes-dash .content-submenu-tag ul li.work span i {
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-dash .content-submenu-tag ul li.work a {
  color: #5CB85C;
  display: flex;
  align-items: center;
}
.notes-dash .content-submenu-tag ul li.public span {
  margin-right: 8px;
}
.notes-dash .content-submenu-tag ul li.public span i {
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-dash .content-submenu-tag ul li.public a {
  color: #A02F7A;
  display: flex;
  align-items: center;
}
.notes-dash .content-submenu-tag ul li.medium span {
  margin-right: 8px;
}
.notes-dash .content-submenu-tag ul li.medium span i {
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-dash .content-submenu-tag ul li.medium a {
  color: #4A00E5;
  display: flex;
  align-items: center;
}
.notes-dash .content-submenu-tag ul li.high span {
  margin-right: 8px;
}
.notes-dash .content-submenu-tag ul li.high span i {
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-dash .content-submenu-tag ul li.high a {
  color: #FC0027;
  display: flex;
  align-items: center;
}
.notes-dash .content-submenu-tag ul li.low span {
  margin-right: 8px;
}
.notes-dash .content-submenu-tag ul li.low span i {
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-dash .content-submenu-tag ul li.low a {
  color: #FDA700;
  display: flex;
  align-items: center;
}
.notes-dash .content-submenu-tag ul li + li {
  margin-top: 10px;
}

.notes-logo a {
  display: flex;
  align-items: center;
}
.notes-logo a span {
  width: 32px;
  height: 32px;
}
.notes-logo a span img {
  border-radius: 32px;
}

.notes-top-head-submenu {
  padding: 15px 0;
  border-bottom: 1px solid #6F6F6F;
}
.notes-top-head-submenu .nav.todo-inbox button.todo-inbox {
  display: flex;
  justify-content: start;
  align-items: center;
  padding: 10px;
  font-size: 15px;
  font-weight: 600;
  color: #6F6F6F;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  border-radius: 5px;
}
.notes-top-head-submenu .nav.todo-inbox button.todo-inbox.active {
  border-radius: 5px;
  background: #212B36;
  padding: 10px;
  color: #FFF;
}
.notes-top-head-submenu .nav.todo-inbox button.todo-inbox.active svg {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}
.notes-top-head-submenu .nav.todo-inbox button.todo-inbox:hover {
  background: #212B36;
  color: #FFF;
}
.notes-top-head-submenu .nav.todo-inbox button.todo-inbox svg {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}
.notes-top-head-submenu .nav.todo-inbox button.todo-inbox span {
  display: flex;
  width: 20px;
  height: 20px;
  padding: 0px 3px;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  background: #E41F07;
  color: #FFF;
}

.notes-trash-btn {
  background: #FC0027;
  color: #FFF;
  border-radius: 8px;
  margin: 4px 0 20px 0;
  padding: 10px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.notes-trash-btn span {
  display: flex;
  align-items: center;
}
.notes-trash-btn span svg {
  width: 16px;
  height: 16px;
  margin-right: 10px;
}

.delete-popup {
  padding: 24px;
  border-radius: 8px;
  background: #FFF;
}
.delete-popup .delete-image {
  margin-bottom: 20px;
}
.delete-popup .delete-heads {
  text-align: center;
}
.delete-popup .delete-heads h4 {
  color: #6F7A7A;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 5px;
}
.delete-popup .delete-heads p {
  color: #6F6F6F;
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 0px;
}
.delete-popup .delete-footer {
  text-align: center;
}

.edit-page-title {
  display: flex;
  align-items: center;
}
.edit-page-title h4 {
  font-size: 18px;
  font-weight: 700;
  color: #6F7A7A;
  margin-bottom: 0;
  margin-right: 10px;
}
.edit-page-title p {
  font-size: 15px;
  font-weight: 400;
  color: #288EC7;
}

.edit-head-view {
  margin-bottom: 20px;
  border-bottom: rgba(145, 158, 171, 0.3);
}
.edit-head-view h6 {
  font-size: 16px;
  font-weight: 600;
  color: #6F7A7A;
  margin-bottom: 15px;
}
.edit-head-view p {
  font-size: 15px;
  font-weight: 400;
  color: #6F6F6F;
  margin-bottom: 15px;
}
.edit-head-view p.badged {
  border-radius: 8px;
  border: 1px solid #FDA700;
  padding: 4px 10px;
  margin-bottom: 0;
  color: #FDA700;
  font-size: 14px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
}
.edit-head-view p.badged i {
  font-size: 7px;
  margin-right: 7px;
}

.edit-footer-menu a {
  background-color: #FC0027;
}

.edit-noted-head a span i.fa-trash-alt {
  color: #FC0027;
  margin-right: 10px;
}
.edit-noted-head a span i.fa-star {
  color: #FDA700;
}

.edit-head-view p.badged.high {
  border-radius: 8px;
  border: 1px solid #FC0027;
  padding: 4px 10px;
  margin-bottom: 0;
  color: #FC0027;
  font-size: 14px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
}
.edit-head-view p.badged.high i {
  font-size: 7px;
  margin-right: 7px;
}

.people-profile-pic {
  border: none !important;
  margin-left: 14px;
  position: relative;
}
.people-profile-pic img {
  border-radius: 10px;
}
.people-profile-pic a {
  position: absolute;
  top: 15px;
  right: 7px;
}
.people-profile-pic a .x-square-add {
  border-radius: 3px;
  background: #FC0027;
  color: #FFF;
}

.people-customer-walk {
  max-width: 35px;
}

.custom-pagination .paginations {
  align-items: center;
}
.custom-pagination .paginations span {
  display: flex;
  align-items: center;
  color: #6F6F6F;
  width: 16px;
  height: 16px;
}
.custom-pagination .paginations span .fa-chevron-left {
  margin-right: 8px;
}
.custom-pagination .paginations .page-wrap li a {
  margin-right: 8px;
  border-radius: 85px;
  color: #6F6F6F;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  width: 30px;
  height: 30px;
  padding: 5px;
  justify-content: center;
  align-items: center;
}
.custom-pagination .paginations .page-wrap li a.active {
  background: #E41F07;
  color: #FFF;
}
.custom-pagination .paginations .page-wrap li :hover {
  background: #E41F07;
  color: #FFF;
  transition: 0.3s all;
}

.section-notes-slider .notes-slider.owl-carousel .owl-nav {
  top: -42px;
  right: unset;
  left: 170px;
}
.section-notes-slider .notes-slider.owl-carousel .owl-nav button {
  background-color: transparent;
  width: 15px;
  height: auto;
}
.section-notes-slider .notes-slider.owl-carousel .owl-nav button i {
  color: #6F7A7A;
}
.section-notes-slider .notes-slider.owl-carousel .owl-nav button:hover {
  background-color: transparent;
}
.section-notes-slider .notes-slider.owl-carousel .owl-nav button:hover i {
  color: #E41F07;
}

.form-sort .select2-container--default .select2-selection--single .select2-selection__rendered {
  padding-left: 35px;
}
.form-sort span.select2-container.select2-container--default.select2-container--open {
  z-index: 99;
}

.accordion-button:after, .accordion-button:not(.collapsed)::after {
  display: none;
}

.todo-accordion .accordion-item {
  background: transparent;
  margin-bottom: 10px;
  border: 0;
  padding: 0;
}

.search-set {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.search-set .search-input {
  position: relative;
  margin-right: 15px;
}
.search-set .search-input input[type=search] {
  height: 38px;
  border: 1px solid var(--Stroke, rgba(145, 158, 171, 0.3));
  background: var(--White, #FFF);
  width: 298px;
  border-radius: 5px;
  padding: 10px;
}
.search-set .search-input input[type=search]::placeholder {
  color: #000;
}
@media (max-width: 1199.98px) {
  .search-set .search-input input[type=search] {
    width: 220px;
  }
}
@media (max-width: 991.98px) {
  .search-set .search-input input[type=search] {
    width: 200px;
  }
}
@media (max-width: 575.98px) {
  .search-set .search-input input[type=search] {
    width: auto;
  }
}
.search-set .search-input .btn-searchset {
  border-radius: 50px;
  position: absolute;
  top: 0;
  right: 0;
  border: 0;
}
.search-set .search-input .btn-searchset .feather-search {
  width: 14px;
  height: 14px;
}

.page-add-notes {
  display: flex;
  flex-wrap: wrap;
}

.todo-inbox-check {
  margin-right: 15px;
}
.todo-inbox-check .checkboxs {
  margin-bottom: 0;
  padding-left: 25px;
  display: flex;
  align-items: center;
}
.todo-inbox-check .checkboxs input ~ .checkmarks {
  border-color: rgba(145, 158, 171, 0.3);
  border-radius: 5px;
  margin-top: 2px;
  width: 20px;
  height: 20px;
}
.todo-inbox-check .checkboxs input:checked ~ .checkmarks {
  border-color: #E41F07;
  background-color: #E41F07;
}

.btn-cancel {
  background: #565E5E;
  color: #FFF;
  font-size: 14px;
  font-weight: 700;
  border-radius: 5px;
  transition: all 0.5s ease;
}
.btn-cancel:hover {
  background: #424b52;
  color: #FFF;
}
@media (max-width: 991.98px) {
  .btn-cancel {
    min-width: auto;
  }
}

.swal2-confirm {
  margin-right: 5px;
}

.btn-submit {
  background: #E41F07;
  color: #FFF;
  font-size: 14px;
  font-weight: 700;
  border-radius: 5px;
  transition: all 0.2s ease;
}
.btn-submit:hover {
  background: #b31805;
  color: #FFF;
}
@media (max-width: 991.98px) {
  .btn-submit {
    min-width: auto;
  }
}

.sections-notes-slider .accordion-button:after {
  display: none;
}

.todo-wrapper-list-content {
  margin-left: 5px;
}

.notes-header h3 {
  color: #6F7A7A;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 0;
}

.todo-inbox-check .checkboxs .checkmarks:after {
  left: 9px;
  top: 10px;
}

.checkboxs input:checked ~ .checkmarks:after {
  display: block;
}

.todo-widget {
  margin-bottom: 25px;
}

.todo-today-content {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.todo-today-content .todo-drop-down span i {
  color: #6F7A7A;
}
.todo-today-content .todo-today-header {
  display: flex;
  align-items: center;
}
.todo-today-content .todo-today-header span {
  margin-right: 5px;
  display: flex;
  align-items: center;
}
.todo-today-content .todo-today-header span svg {
  width: 16px;
  height: 16px;
  color: #6F6F6F;
}
.todo-today-content .todo-today-header h3 {
  font-size: 16px;
  font-weight: 600;
  color: #6F7A7A;
  margin-bottom: 0;
  margin-right: 5px;
}
.todo-today-content .todo-today-header h6 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  background-color: #E41F07;
  border-radius: 50px;
  color: #FFF;
  font-size: 10px;
  font-weight: 600;
  margin-bottom: 0;
}

.todo-wrapper-list {
  padding: 15px;
  border-radius: 8px;
  border: 1px solid rgba(145, 158, 171, 0.3);
  background: #FFF;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
@media (max-width: 575.98px) {
  .todo-wrapper-list {
    flex-direction: column;
  }
}
.todo-wrapper-list .todo-inbox-check {
  display: flex;
  align-items: center;
}
.todo-wrapper-list .todo-inbox-check .todo-wrapper-list-content h4 {
  font-size: 16px;
  font-weight: 700;
  color: #6F7A7A;
  margin-bottom: 5px;
}
.todo-wrapper-list .todo-inbox-check .todo-wrapper-list-content p {
  font-size: 13px;
  font-weight: 500;
  color: #6F6F6F;
  margin-bottom: 0;
}
.todo-wrapper-list .todo-inbox-check.todo-inbox-check-list {
  width: 45%;
}
@media (max-width: 575.98px) {
  .todo-wrapper-list .todo-inbox-check.todo-inbox-check-list {
    width: auto;
  }
}
.todo-wrapper-list .todo-inbox-check.todo-inbox-check-list .checkboxs {
  margin-bottom: 12px;
}
.todo-wrapper-list .todo-inbox-check.todo-inbox-check-list .checkboxs input ~ .checkmarks {
  border-radius: 5px;
  margin-top: 0;
}
.todo-wrapper-list .notes-card-body {
  width: 35%;
}
@media (max-width: 575.98px) {
  .todo-wrapper-list .notes-card-body {
    width: auto;
    margin: 20px 0;
  }
}
.todo-wrapper-list .notes-card-body p {
  display: flex;
  align-items: center;
}
.todo-wrapper-list .notes-card-body p.high {
  border-radius: 8px;
  border: 1px solid #FC0027;
  padding: 4px 10px;
  font-size: 14px;
  font-weight: 600;
  color: #FC0027;
  margin-right: 10px;
}
.todo-wrapper-list .notes-card-body p.medium {
  padding: 4px 10px;
  border-radius: 8px;
  border: 1px solid #423B93;
  font-size: 14px;
  font-family: 600;
  color: #423B93;
}
.todo-wrapper-list .notes-card-body p.pending {
  padding: 4px 10px;
  border-radius: 8px;
  border: 1px solid #288EC7;
  font-size: 14px;
  font-family: 600;
  color: #288EC7;
}
.todo-wrapper-list .notes-card-body p.low {
  padding: 4px 10px;
  border-radius: 8px;
  border: 1px solid #FDA700;
  font-size: 14px;
  font-family: 600;
  color: #FDA700;
}
.todo-wrapper-list .notes-card-body p.success {
  padding: 4px 10px;
  border-radius: 8px;
  border: 1px solid #5CB85C;
  font-size: 14px;
  font-family: 600;
  color: #5CB85C;
}
.todo-wrapper-list .notes-card-body p i.fa-circle {
  font-size: 7px;
  margin-right: 4px;
}
.todo-wrapper-list .todo-strike-content h4 {
  text-decoration-line: line-through;
}
.todo-wrapper-list .todo-strike-content p {
  text-decoration-line: line-through;
}
.todo-wrapper-list .todo-profile {
  width: 20%;
  justify-content: end;
}
.todo-wrapper-list .todo-profile img {
  border-radius: 30px;
  margin-right: 16px;
  width: 30px;
  height: 30px;
}
.todo-wrapper-list .todo-profile a .fa-ellipsis-v {
  color: #6F7A7A;
}

.datanew tbody {
  border-top: 1px solid #E8E8E8;
}

.form-sort {
  position: relative;
  width: 149px;
  height: 40px;
}
.form-sort .info-img {
  position: absolute;
  top: 52%;
  z-index: 100;
  width: 16px;
  height: 16px;
  left: 0;
  margin-left: 10px;
  color: #6F6F6F;
  transform: translateY(-50%);
  line-height: normal;
}
@media (max-width: 575.98px) {
  .form-sort {
    margin-top: 24px;
  }
}

.todo-calendar .input-groupicon.calender-input input {
  padding-left: 10px;
}

.todo-calendar {
  position: relative;
}
.todo-calendar .calender-input {
  position: relative;
}
.todo-calendar .calender-input .info-img {
  position: absolute;
  top: 11px;
  z-index: 100;
  width: 16px;
  height: 16px;
  right: 5px !important;
  color: #6F6F6F;
}

.todo-accordion .accordion-item {
  background: transparent;
  margin-bottom: 20px;
}
.todo-accordion .accordion-item .accordion-header {
  cursor: pointer;
}
.todo-accordion .accordion-item .accordion-header .accordion-button {
  background: transparent;
  padding: 0;
}
.todo-accordion .accordion-item .accordion-header .accordion-button.collapsed .todo-today-content {
  margin-bottom: 0;
}
.todo-accordion .accordion-item .accordion-header .todo-today-content {
  width: 100%;
}
.todo-accordion .accordion-item .accordion-header .todo-drop-down a span i {
  color: #6F6F6F;
}
.todo-accordion .accordion-item .accordion-body {
  padding: 0;
}
.todo-accordion .accordion-item .todo-widget {
  margin-bottom: 0;
}
.todo-accordion .accordion-item .todo-widget .todo-wrapper-list:last-child {
  margin-bottom: 0;
}

caption {
  color: #9595b5;
}

.table-active {
  --bs-table-color-state: var(--default-text-color);
}

.table {
  color: #6F6F6F;
  border-color: #E8E8E8;
  margin-block-end: 0;
}
.table .checkboxs {
  margin-bottom: 15px;
}
.table tbody tr th {
  font-weight: 500;
}
.table th,
.table td {
  padding: 0.75rem;
  vertical-align: middle;
  line-height: 1.462;
  font-size: 0.813rem;
  white-space: nowrap;
}
.table thead tr th {
  font-weight: 600;
  font-size: 15px;
}
.table.table-sm > :not(caption) > * > * {
  padding: 0.3rem;
}
.table.table-dark {
  color: #F2ECFF;
  border-color: rgba(255, 255, 255, 0.1);
}
.table .thead-primary th {
  background-color: #E41F07;
  color: #FFF;
}
.table .thead-secondary th {
  background-color: #FFA201;
  color: #FFF;
}
.table .thead-info th {
  background-color: #1ECBE2;
  color: #FFF;
}
.table .thead-warning th {
  background-color: #FDA700;
  color: #FFF;
}
.table .thead-danger th {
  background-color: #FC0027;
  color: #FFF;
}
.table .thead-success th {
  background-color: #5CB85C;
  color: #FFF;
}
.table .thead-dark th {
  background-color: #171724;
  color: #FFF;
}
.table .thead-light th {
  background-color: #FAFAFA;
  color: #171724;
}
.table.table-primary {
  background-color: #FFF;
  color: #000;
  --bs-table-color-state: \$black;
  border-color: var(--bs-table-border-color);
  --bs-table-bg: rgba(var(--primary-rgb), 0.1);
  --bs-table-border-color: rgba(var(--primary-rgb), 0.05);
  --bs-table-striped-bg: rgba(var(--primary-rgb), 0.2);
  --bs-table-active-bg: rgba(var(--primary-rgb), 0.2);
  --bs-table-hover-bg: rgba(var(--primary-rgb), 0.2);
}
.table.table-primary.table-striped > tbody > tr:nth-of-type(odd) > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--primary-rgb), 0.2);
  color: #000;
}
.table.table-primary.table.table-hover > tbody > tr:hover > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--primary-rgb), 0.4);
  color: #FFF;
}
.table.table-primary .table-active {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgb(var(--primary-rgb));
  color: #FFF;
}
.table.table-secondary {
  background-color: #FFF;
  color: #000;
  --bs-table-color-state: \$black;
  border-color: var(--bs-table-border-color);
  --bs-table-bg: rgba(var(--secondary-rgb), 0.1);
  --bs-table-border-color: rgba(var(--secondary-rgb), 0.05);
  --bs-table-striped-bg: rgba(var(--secondary-rgb), 0.2);
  --bs-table-active-bg: rgba(var(--secondary-rgb), 0.2);
  --bs-table-hover-bg: rgba(var(--secondary-rgb), 0.2);
}
.table.table-secondary.table-striped > tbody > tr:nth-of-type(odd) > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--secondary-rgb), 0.2);
  color: #000;
}
.table.table-secondary.table.table-hover > tbody > tr:hover > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--secondary-rgb), 0.4);
  color: #FFF;
}
.table.table-secondary .table-active {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgb(var(--secondary-rgb));
  color: #FFF;
}
.table.table-warning {
  background-color: #FFF;
  color: #000;
  --bs-table-color-state: \$black;
  border-color: var(--bs-table-border-color);
  --bs-table-bg: rgba(var(--warning-rgb), 0.1);
  --bs-table-border-color: rgba(var(--warning-rgb), 0.05);
  --bs-table-striped-bg: rgba(var(--warning-rgb), 0.2);
  --bs-table-active-bg: rgba(var(--warning-rgb), 0.2);
  --bs-table-hover-bg: rgba(var(--warning-rgb), 0.2);
}
.table.table-warning.table-striped > tbody > tr:nth-of-type(odd) > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--warning-rgb), 0.2);
  color: #000;
}
.table.table-warning.table.table-hover > tbody > tr:hover > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--warning-rgb), 0.4);
  color: #FFF;
}
.table.table-warning .table-active {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgb(var(--warning-rgb));
  color: #FFF;
}
.table.table-success {
  background-color: #FFF;
  color: #000;
  --bs-table-color-state: \$black;
  border-color: var(--bs-table-border-color);
  --bs-table-bg: rgba(var(--success-rgb), 0.1);
  --bs-table-border-color: rgba(var(--success-rgb), 0.05);
  --bs-table-striped-bg: rgba(var(--success-rgb), 0.2);
  --bs-table-active-bg: rgba(var(--success-rgb), 0.2);
  --bs-table-hover-bg: rgba(var(--success-rgb), 0.2);
}
.table.table-success.table-striped > tbody > tr:nth-of-type(odd) > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--success-rgb), 0.2);
  color: #000;
}
.table.table-success.table.table-hover > tbody > tr:hover > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--success-rgb), 0.4);
  color: #FFF;
}
.table.table-success .table-active {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgb(var(--success-rgb));
  color: #FFF;
}
.table.table-danger {
  background-color: #FFF;
  color: #000;
  --bs-table-color-state: \$black;
  border-color: var(--bs-table-border-color);
  --bs-table-bg: rgba(var(--danger-rgb), 0.1);
  --bs-table-border-color: rgba(var(--danger-rgb), 0.05);
  --bs-table-striped-bg: rgba(var(--danger-rgb), 0.2);
  --bs-table-active-bg: rgba(var(--danger-rgb), 0.2);
  --bs-table-hover-bg: rgba(var(--danger-rgb), 0.2);
}
.table.table-danger.table-striped > tbody > tr:nth-of-type(odd) > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--danger-rgb), 0.2);
  color: #000;
}
.table.table-danger.table.table-hover > tbody > tr:hover > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--danger-rgb), 0.4);
  color: #FFF;
}
.table.table-danger .table-active {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgb(var(--danger-rgb));
  color: #FFF;
}
.table.table-info {
  background-color: #FFF;
  color: #000;
  --bs-table-color-state: \$black;
  border-color: var(--bs-table-border-color);
  --bs-table-bg: rgba(var(--info-rgb), 0.1);
  --bs-table-border-color: rgba(var(--info-rgb), 0.05);
  --bs-table-striped-bg: rgba(var(--info-rgb), 0.2);
  --bs-table-active-bg: rgba(var(--info-rgb), 0.2);
  --bs-table-hover-bg: rgba(var(--info-rgb), 0.2);
}
.table.table-info.table-striped > tbody > tr:nth-of-type(odd) > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--info-rgb), 0.2);
  color: #000;
}
.table.table-info.table.table-hover > tbody > tr:hover > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--info-rgb), 0.4);
  color: #FFF;
}
.table.table-info .table-active {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgb(var(--info-rgb));
  color: #FFF;
}
.table.table-light {
  background-color: #FFF;
  color: #000;
  --bs-table-color-state: \$black;
  border-color: var(--bs-table-border-color);
  --bs-table-bg: rgba(var(--light-rgb), 0.1);
  --bs-table-border-color: rgba(var(--light-rgb), 0.05);
  --bs-table-striped-bg: rgba(var(--light-rgb), 0.2);
  --bs-table-active-bg: rgba(var(--light-rgb), 0.2);
  --bs-table-hover-bg: rgba(var(--light-rgb), 0.2);
}
.table.table-light.table-striped > tbody > tr:nth-of-type(odd) > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--light-rgb), 0.2);
  color: #000;
}
.table.table-light.table.table-hover > tbody > tr:hover > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--light-rgb), 0.4);
  color: #FFF;
}
.table.table-light .table-active {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgb(var(--light-rgb));
  color: #FFF;
}
.table.table-dark {
  background-color: #FFF;
  color: #000;
  --bs-table-color-state: \$black;
  border-color: var(--bs-table-border-color);
  --bs-table-bg: rgba(var(--dark-rgb), 0.1);
  --bs-table-border-color: rgba(var(--dark-rgb), 0.05);
  --bs-table-striped-bg: rgba(var(--dark-rgb), 0.2);
  --bs-table-active-bg: rgba(var(--dark-rgb), 0.2);
  --bs-table-hover-bg: rgba(var(--dark-rgb), 0.2);
}
.table.table-dark.table-striped > tbody > tr:nth-of-type(odd) > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--dark-rgb), 0.2);
  color: #000;
}
.table.table-dark.table.table-hover > tbody > tr:hover > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--dark-rgb), 0.4);
  color: #FFF;
}
.table.table-dark .table-active {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgb(var(--dark-rgb));
  color: #FFF;
}
.table.table-bordered.border-primary tbody,
.table.table-bordered.border-primary td,
.table.table-bordered.border-primary tfoot,
.table.table-bordered.border-primary th,
.table.table-bordered.border-primary thead,
.table.table-bordered.border-primary tr {
  border-color: rgba(228, 31, 7, 0.1);
}
.table.table-bordered.border-info tbody,
.table.table-bordered.border-info td,
.table.table-bordered.border-info tfoot,
.table.table-bordered.border-info th,
.table.table-bordered.border-info thead,
.table.table-bordered.border-info tr {
  border-color: rgba(30, 203, 226, 0.1);
}
.table.table-bordered.border-secondary tbody,
.table.table-bordered.border-secondary td,
.table.table-bordered.border-secondary tfoot,
.table.table-bordered.border-secondary th,
.table.table-bordered.border-secondary thead,
.table.table-bordered.border-secondary tr {
  border-color: rgba(255, 162, 1, 0.1);
}
.table.table-bordered.border-warning tbody,
.table.table-bordered.border-warning td,
.table.table-bordered.border-warning tfoot,
.table.table-bordered.border-warning th,
.table.table-bordered.border-warning thead,
.table.table-bordered.border-warning tr {
  border-color: rgba(253, 167, 0, 0.1);
}
.table.table-bordered.border-success tbody,
.table.table-bordered.border-success td,
.table.table-bordered.border-success tfoot,
.table.table-bordered.border-success th,
.table.table-bordered.border-success thead,
.table.table-bordered.border-success tr {
  border-color: rgba(92, 184, 92, 0.1);
}
.table.table-bordered.border-danger tbody,
.table.table-bordered.border-danger td,
.table.table-bordered.border-danger tfoot,
.table.table-bordered.border-danger th,
.table.table-bordered.border-danger thead,
.table.table-bordered.border-danger tr {
  border-color: rgba(252, 0, 39, 0.1);
}
.table.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-accent-bg: rgba(var(--dark-rgb),0.0125);
  color: #6F6F6F;
}
.table.table-striped-columns > :not(caption) > tr > :nth-child(2n) {
  --bs-table-accent-bg: rgba(var(--dark-rgb),0.025);
  color: #6F6F6F;
}
.table tbody.table-group-divider {
  border-top: 1px solid #E8E8E8;
}
.table.table-hover > tbody > tr:hover > * {
  --bs-table-accent-bg: #f7f8f9;
  color: #6F6F6F;
}
.table .table-active {
  --bs-table-accent-bg: #FDFDFE;
  color: #6F6F6F;
}
.table thead.table-primary {
  background-color: #FFF;
  color: var(--bs-table-color);
  --bs-table-color-state: #000;
  --bs-table-color: #000;
  --bs-table-bg: rgba(var(--primary-rgb), 0.1);
  --bs-table-border-color: rgba(var(--primary-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--primary-rgb), 0.5);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--primary-rgb), 0.5);
  --bs-table-hover-bg: rgba(var(--primary-rgb), 0.5);
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.table thead.table-secondary {
  background-color: #FFF;
  color: var(--bs-table-color);
  --bs-table-color-state: #000;
  --bs-table-color: #000;
  --bs-table-bg: rgba(var(--secondary-rgb), 0.1);
  --bs-table-border-color: rgba(var(--secondary-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--secondary-rgb), 0.5);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--secondary-rgb), 0.5);
  --bs-table-hover-bg: rgba(var(--secondary-rgb), 0.5);
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.table thead.table-warning {
  background-color: #FFF;
  color: var(--bs-table-color);
  --bs-table-color-state: #000;
  --bs-table-color: #000;
  --bs-table-bg: rgba(var(--warning-rgb), 0.1);
  --bs-table-border-color: rgba(var(--warning-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--warning-rgb), 0.5);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--warning-rgb), 0.5);
  --bs-table-hover-bg: rgba(var(--warning-rgb), 0.5);
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.table thead.table-success {
  background-color: #FFF;
  color: var(--bs-table-color);
  --bs-table-color-state: #000;
  --bs-table-color: #000;
  --bs-table-bg: rgba(var(--success-rgb), 0.1);
  --bs-table-border-color: rgba(var(--success-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--success-rgb), 0.5);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--success-rgb), 0.5);
  --bs-table-hover-bg: rgba(var(--success-rgb), 0.5);
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.table thead.table-danger {
  background-color: #FFF;
  color: var(--bs-table-color);
  --bs-table-color-state: #000;
  --bs-table-color: #000;
  --bs-table-bg: rgba(var(--danger-rgb), 0.1);
  --bs-table-border-color: rgba(var(--danger-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--danger-rgb), 0.5);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--danger-rgb), 0.5);
  --bs-table-hover-bg: rgba(var(--danger-rgb), 0.5);
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.table thead.table-info {
  background-color: #FFF;
  color: var(--bs-table-color);
  --bs-table-color-state: #000;
  --bs-table-color: #000;
  --bs-table-bg: rgba(var(--info-rgb), 0.1);
  --bs-table-border-color: rgba(var(--info-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--info-rgb), 0.5);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--info-rgb), 0.5);
  --bs-table-hover-bg: rgba(var(--info-rgb), 0.5);
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.table thead.table-light {
  background-color: #FFF;
  color: var(--bs-table-color);
  --bs-table-color-state: #000;
  --bs-table-color: #000;
  --bs-table-bg: rgba(var(--light-rgb), 0.1);
  --bs-table-border-color: rgba(var(--light-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--light-rgb), 0.5);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--light-rgb), 0.5);
  --bs-table-hover-bg: rgba(var(--light-rgb), 0.5);
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.table thead.table-dark {
  background-color: #FFF;
  color: var(--bs-table-color);
  --bs-table-color-state: #000;
  --bs-table-color: #000;
  --bs-table-bg: rgba(var(--dark-rgb), 0.1);
  --bs-table-border-color: rgba(var(--dark-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--dark-rgb), 0.5);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--dark-rgb), 0.5);
  --bs-table-hover-bg: rgba(var(--dark-rgb), 0.5);
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-primary {
  --bs-table-color: #000;
  --bs-table-color-state: \$black;
  --bs-table-bg: rgba(var(--primary-rgb), 0.1);
  --bs-table-border-color: rgba(var(--primary-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--primary-rgb), 0.3);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--primary-rgb), 0.3);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgba(var(--primary-rgb), 0.3);
  --bs-table-hover-color: #000;
  color: #000;
  border-color: rgba(var(--primary-rgb), 0.1);
  background-color: #FFF;
}

.table-secondary {
  --bs-table-color: #000;
  --bs-table-color-state: \$black;
  --bs-table-bg: rgba(var(--secondary-rgb), 0.1);
  --bs-table-border-color: rgba(var(--secondary-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--secondary-rgb), 0.3);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--secondary-rgb), 0.3);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgba(var(--secondary-rgb), 0.3);
  --bs-table-hover-color: #000;
  color: #000;
  border-color: rgba(var(--secondary-rgb), 0.1);
  background-color: #FFF;
}

.table-warning {
  --bs-table-color: #000;
  --bs-table-color-state: \$black;
  --bs-table-bg: rgba(var(--warning-rgb), 0.1);
  --bs-table-border-color: rgba(var(--warning-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--warning-rgb), 0.3);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--warning-rgb), 0.3);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgba(var(--warning-rgb), 0.3);
  --bs-table-hover-color: #000;
  color: #000;
  border-color: rgba(var(--warning-rgb), 0.1);
  background-color: #FFF;
}

.table-success {
  --bs-table-color: #000;
  --bs-table-color-state: \$black;
  --bs-table-bg: rgba(var(--success-rgb), 0.1);
  --bs-table-border-color: rgba(var(--success-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--success-rgb), 0.3);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--success-rgb), 0.3);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgba(var(--success-rgb), 0.3);
  --bs-table-hover-color: #000;
  color: #000;
  border-color: rgba(var(--success-rgb), 0.1);
  background-color: #FFF;
}

.table-info {
  --bs-table-color: #000;
  --bs-table-color-state: \$black;
  --bs-table-bg: rgba(var(--info-rgb), 0.1);
  --bs-table-border-color: rgba(var(--info-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--info-rgb), 0.3);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--info-rgb), 0.3);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgba(var(--info-rgb), 0.3);
  --bs-table-hover-color: #000;
  color: #000;
  border-color: rgba(var(--info-rgb), 0.1);
  background-color: #FFF;
}

.table-danger {
  --bs-table-color: #000;
  --bs-table-color-state: \$black;
  --bs-table-bg: rgba(var(--danger-rgb), 0.1);
  --bs-table-border-color: rgba(var(--danger-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--danger-rgb), 0.3);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--danger-rgb), 0.3);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgba(var(--danger-rgb), 0.3);
  --bs-table-hover-color: #000;
  color: #000;
  border-color: rgba(var(--danger-rgb), 0.1);
  background-color: #FFF;
}

.table-dark {
  --bs-table-color: #000;
  --bs-table-color-state: \$black;
  --bs-table-bg: rgba(var(--dark-rgb), 0.1);
  --bs-table-border-color: rgba(var(--dark-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--dark-rgb), 0.3);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--dark-rgb), 0.3);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgba(var(--dark-rgb), 0.3);
  --bs-table-hover-color: #000;
  color: #000;
  border-color: rgba(var(--dark-rgb), 0.1);
  background-color: #FFF;
}

.table-light {
  --bs-table-color: #000;
  --bs-table-color-state: \$black;
  --bs-table-bg: rgba(var(--light-rgb), 0.1);
  --bs-table-border-color: rgba(var(--light-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--light-rgb), 0.3);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--light-rgb), 0.3);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgba(var(--light-rgb), 0.3);
  --bs-table-hover-color: #000;
  color: #000;
  border-color: rgba(var(--light-rgb), 0.1);
  background-color: #FFF;
}

[data-theme-mode=dark] .table-dark {
  border-color: rgba(0, 0, 0, 0.025);
}

[dir=rtl] .table {
  margin-inline-end: 1px;
}

.table {
  margin: 0;
}
.table tbody tr td {
  color: #424848;
  font-size: 14px;
}
.table tbody tr td .product-img img {
  border: 0;
}
.table tbody tr td .userslist-img {
  width: 35px;
  height: 35px;
  margin-right: 8px;
}
.table tbody tr td .userslist-img img {
  border-radius: 0;
}
.table tbody tr td .userslist-img.bg-img img {
  border: 1px solid var(--stroke-table, #E8EBED);
}
.table tbody tr td a {
  color: #FFA201;
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
}
.table tbody tr td a.product-img {
  margin-right: 5px;
  flex-shrink: 0;
}
.table tbody tr td a .info-img {
  margin-right: 8px;
  width: 16px;
  height: 16px;
}
.table tbody tr td a:hover {
  color: #E41F07;
}
.table tbody tr td .emp-name {
  line-height: 1;
}
.table tbody tr td .emp-name a {
  color: #FFA201;
}
.table tbody tr td .emp-name p {
  line-height: 2;
  font-size: 15px;
  font-weight: 500;
  color: #6F6F6F;
}
.table tbody tr td .emp-name .role {
  line-height: unset;
}
.table tbody tr td .product-imgs {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  width: 40px;
  height: 40px;
  background: #FFEBD8;
  font-size: 14px;
  color: #FF9F43 !important;
  font-weight: 500;
  margin-right: 10px;
}
.table tbody tr .data-header {
  font-weight: 600;
  color: #FFA201;
  font-size: 15px;
  border-bottom: none;
}
.table tbody tr .ref-number {
  color: #4A00E5;
}
.table tbody tr.active {
  border-bottom: 0;
}
.table tbody tr.active td {
  font-size: 18px;
  color: #424848;
  font-weight: 600;
  border-bottom: 0;
}
.table tbody .loss-highlight td {
  font-weight: 700;
  color: #FFA201;
  font-size: 14px;
  border-top: 1px solid #898989;
}
.table tbody .userimgname {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.table tbody .userimgname img {
  margin-right: 8px;
  border-radius: 6px;
}
.table tbody .purchase-count td {
  padding-bottom: 20px;
}
.table .Expense-list tr td {
  padding: 15px 17px;
}
.table .Expense-list tr td a {
  margin-bottom: 0;
}
.table .sales-list tr td {
  padding: 20px 17px;
}
.table .Expense-list-blk tr td {
  padding: 20px 17px;
}

.new tbody tr td {
  border-bottom: none;
}

.table-height {
  min-height: 300px;
}
@media (max-width: 991.98px) {
  .table-height {
    min-height: auto;
    margin-bottom: 15px;
  }
}

.max-widthauto {
  max-width: 100% !important;
}

.dataTables_filter + .dataTables_filter {
  display: none;
}

.dataview .dataTables_length,
.dataview .dataTables_info,
.dataview .dataTables_paginate {
  display: none !important;
}

.dataTables_length {
  font-size: 12px;
}

.productimgname {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.productimgname a {
  color: #FFA201;
  font-weight: 500;
}
.productimgname .view-product {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  width: 50px;
  height: 50px;
  border-radius: 6px;
  background: #F8F8F8;
}

.input-blocks .calc-no {
  width: 50px !important;
  text-align: center;
}

.table .input-blocks input[type=text] {
  height: 40px;
}
.table .scanner-set {
  width: 40px;
  height: 40px;
}

.card.table-list-card .card-body {
  padding: 0;
}
.card.table-list-card .table-top {
  padding: 24px 24px 0;
}
.card.table-list-card .table-responsive {
  padding: 24px;
}
.card.table-list-card .table-responsive .dataTables_wrapper {
  border: 0;
  padding: 0;
}
.card.table-list-card .tabs-set .nav-tabs {
  padding: 24px 24px 0;
  margin-bottom: 0;
}

.table.profit-table thead {
  background-color: #FAFBFE;
  border-radius: 8px 8px 0px 0px;
}
.table.profit-table thead tr:hover {
  background-color: #FAFBFE;
}
.table.profit-table tbody td {
  border-bottom: 0;
}
.table.profit-table tbody .profit-table-bg td {
  color: #FFA201;
  font-weight: 700;
  border-top: 1px solid #C0C0C0;
  background-color: #FAFBFE;
}
.table.profit-table tbody .table-heading:hover {
  background-color: #FFF;
}
.table.profit-table tbody .table-heading td {
  color: #FFA201;
  font-weight: 700;
}

.profit-table-top .daterange-wraper {
  margin: 0 10px;
}
.profit-table-top .daterange-wraper input {
  padding-left: 35px;
}

table td .shield {
  width: 14px;
  height: 14px;
}

.paysilp-table-border {
  border: 1px solid #C0C0C0;
}
.paysilp-table-border th {
  border-right: 1px solid #C0C0C0;
  border-left: 1px solid #C0C0C0;
  padding: 15px;
  font-weight: 700;
  font-size: 16px;
}

.paysilp-table-borders td {
  border-right: 1px solid #C0C0C0;
  border-left: 1px solid #C0C0C0;
  padding: 5px 15px;
  color: #6F6F6F;
}

.payslip-border-bottom {
  border: 1px solid #C0C0C0;
}
.payslip-border-bottom th {
  padding: 5px 15px;
  font-weight: 700;
  font-size: 16px;
}
.payslip-border-bottom td {
  color: #6F6F6F;
}

.emp-details {
  margin: 20px 0;
}
.emp-details .pay-slip-salery h6 {
  font-weight: 700 !important;
  margin-bottom: 10px;
  font-size: 18px !important;
}
.emp-details .emp-name-id.pay-slip-salery {
  margin-right: 30px;
}

@media (max-width: 575.98px) {
  .slip-logo {
    flex-shrink: 0;
    margin-right: 15px;
  }
}

.product-name-slip h4 {
  color: #E41F07;
  font-weight: 700;
  font-size: 18px;
}

.pay-slip-box .modal-header {
  border-radius: 8px 8px 0 0;
}
.pay-slip-box .custom-modal-body {
  padding: 0;
}
.pay-slip-box .card {
  border: 0;
  border-radius: 0 0 10px 10px;
}
.pay-slip-box .card .card-body {
  padding: 20px;
}
.pay-slip-box .card .card-body .emp-details.justify-content-start {
  max-width: 760px;
  margin: 20px auto 20px;
}

.table {
  margin: 0;
}
.table tbody tr td {
  color: #424848;
  font-size: 14px;
}
.table tbody tr td .product-img img {
  border: 0;
}
.table tbody tr td .userslist-img {
  width: 35px;
  height: 35px;
  margin-right: 8px;
}
.table tbody tr td .userslist-img img {
  border-radius: 0;
}
.table tbody tr td .userslist-img.bg-img img {
  border: 1px solid var(--stroke-table, #E8EBED);
}
.table tbody tr td a {
  color: #262A2A;
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
}
.table tbody tr td a.product-img {
  margin-right: 5px;
  flex-shrink: 0;
}
.table tbody tr td a .info-img {
  margin-right: 8px;
  width: 16px;
  height: 16px;
}
.table tbody tr td a:hover {
  color: #E41F07;
}
.table tbody tr td a:hover i {
  color: #E41F07;
}
.table tbody tr td .emp-name {
  line-height: 1;
}
.table tbody tr td .emp-name a {
  color: #FFA201;
}
.table tbody tr td .emp-name p {
  line-height: 2;
  font-size: 15px;
  font-weight: 500;
  color: #6F6F6F;
}
.table tbody tr td .emp-name .role {
  line-height: unset;
}
.table tbody tr td .product-imgs {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  width: 40px;
  height: 40px;
  background: #FFEBD8;
  font-size: 14px;
  color: #FF9F43 !important;
  font-weight: 500;
  margin-right: 10px;
}
.table tbody tr .data-header {
  font-weight: 600;
  color: #FFA201;
  font-size: 15px;
  border-bottom: none;
}
.table tbody tr .ref-number {
  color: #4A00E5;
}
.table tbody tr.active {
  border-bottom: 0;
}
.table tbody tr.active td {
  font-size: 18px;
  color: #424848;
  font-weight: 600;
  border-bottom: 0;
}
.table tbody .loss-highlight td {
  font-weight: 700;
  color: #FFA201;
  font-size: 14px;
  border-top: 1px solid #898989;
}
.table tbody .userimgname {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.table tbody .userimgname img {
  margin-right: 8px;
  border-radius: 6px;
}
.table tbody .purchase-count td {
  padding-bottom: 20px;
}
.table .Expense-list tr td {
  padding: 15px 17px;
}
.table .Expense-list tr td a {
  margin-bottom: 0;
}
.table .sales-list tr td {
  padding: 20px 17px;
}
.table .Expense-list-blk tr td {
  padding: 20px 17px;
}
.table .userimgname .product-img {
  display: inherit;
  width: 35px;
  height: 35px;
  margin-right: 8px;
}

table tbody td.action-table-data {
  display: flex;
}
table tbody td.action-table-data a {
  border: 1px solid rgba(145, 158, 171, 0.3);
  background-color: #FFF;
  border-radius: 8px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  padding: 8px;
}
table tbody td.action-table-data a .feather-edit {
  color: #339DFF;
  width: 14px;
  height: 14px;
}
table tbody td.action-table-data a .action-edit {
  color: #6F6F6F;
  width: 14px;
  height: 14px;
}
table tbody td.action-table-data a .feather-trash-2 {
  color: #FC0027;
  width: 14px;
  height: 14px;
}
table tbody td.action-table-data a .feather-eye {
  width: 14px;
  height: 14px;
}
table tbody td.action-table-data a .action-download {
  color: #339DFF;
  width: 14px;
  height: 14px;
}
table tbody td.action-table-data a .action-eye {
  color: #FFA201;
  width: 14px;
  height: 14px;
}
table tbody .productimgname {
  min-width: 200px;
}
table tbody .productimgname a.stock-img.product-img {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  margin-right: 8px;
}
table tbody .productimgname a.stock-img.product-img img {
  width: 50px;
  height: 50px;
  max-width: 100%;
  margin-right: 0;
}
table .edit-delete-action {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  height: 50px;
}
table .edit-delete-action a {
  padding: 0;
}
table .edit-delete-action.data-view {
  min-height: 52px;
}
table .edit-delete-action.data-row {
  height: auto;
}
table .edit-delete-action.data {
  height: 44px;
}

.custom-table table td ul.social-links li a {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  color: #6F6F6F;
}
.custom-table table td ul.social-links li a:hover {
  background: #E8E8E8;
  color: #6F6F6F;
}

.accordion-button {
  background-color: #FFF;
  color: #6F6F6F;
  padding: 0.75rem 1rem;
  font-size: 0.85rem;
  font-weight: 500;
}
.accordion-button.accordion-custom-button:after {
  content: "\\f054";
}
.accordion-button.accordion-custom-button:not(.collapsed) {
  color: #6F6F6F;
  background-color: #f7f8f9;
  box-shadow: none;
}
.accordion-button.accordion-custom-button:not(.collapsed):after {
  content: "\\f078";
  display: block;
  transform: none;
}
.accordion-button:not(.collapsed) {
  color: #6F6F6F;
  background-color: #f7f8f9;
  box-shadow: none;
}
.accordion-button:focus {
  border-color: rgba(228, 31, 7, 0.3);
  box-shadow: none;
}
.accordion-button:after, .accordion-button:not(.collapsed)::after {
  background-image: none;
}
.accordion-button:after {
  content: "\\f078";
  font-family: "Fontawesome";
  font-size: 12px;
  line-height: 1;
  background-color: #FFF;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3.125rem;
  color: #6F6F6F;
}

.accordion-body {
  padding: 0.75rem 1rem;
  font-size: 0.8125rem;
  color: #9595b5;
}

.accordion-item {
  color: #6F6F6F;
  background-color: #FFF;
  border: 1px solid #E8E8E8;
}

.accordions-items-seperate .accordion-item:not(:first-of-type) {
  margin-block-start: 0.5rem;
}
.accordions-items-seperate .accordion-item {
  border-block-start: 1px solid #E8E8E8;
  border-radius: 4px;
  overflow: hidden;
}

.accordion-item:last-of-type {
  border-bottom-right-radius: 0.35rem;
  border-bottom-left-radius: 0.35rem;
}

.accordion-item:first-of-type {
  border-top-left-radius: 0.35rem;
  border-top-right-radius: 0.35rem;
}

.accordion.accordion-primary .accordion-button {
  background-color: rgba(228, 31, 7, 0.1);
  color: #E41F07;
}
.accordion.accordion-primary .accordion-button:after {
  background-color: #E41F07;
  color: #FFF;
}
.accordion.accordion-primary .accordion-button.collapsed {
  background-color: #FFF;
  color: #6F6F6F;
}
.accordion.accordion-primary .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #6F6F6F;
}
.accordion.accordion-secondary .accordion-button {
  background-color: rgba(255, 162, 1, 0.1);
  color: #FFA201;
}
.accordion.accordion-secondary .accordion-button:after {
  background-color: #FFA201;
  color: #FFF;
}
.accordion.accordion-secondary .accordion-button.collapsed {
  background-color: #FFF;
  color: #6F6F6F;
}
.accordion.accordion-secondary .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #6F6F6F;
}
.accordion.accordion-success .accordion-button {
  background-color: rgba(92, 184, 92, 0.1);
  color: #5CB85C;
}
.accordion.accordion-success .accordion-button:after {
  background-color: #5CB85C;
  color: #FFF;
}
.accordion.accordion-success .accordion-button.collapsed {
  background-color: #FFF;
  color: #6F6F6F;
}
.accordion.accordion-success .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #6F6F6F;
}
.accordion.accordion-danger .accordion-button {
  background-color: rgba(252, 0, 39, 0.1);
  color: #FC0027;
}
.accordion.accordion-danger .accordion-button:after {
  background-color: #FC0027;
  color: #FFF;
}
.accordion.accordion-danger .accordion-button.collapsed {
  background-color: #FFF;
  color: #6F6F6F;
}
.accordion.accordion-danger .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #6F6F6F;
}
.accordion.accordion-warning .accordion-button {
  background-color: rgba(253, 167, 0, 0.1);
  color: #FDA700;
}
.accordion.accordion-warning .accordion-button:after {
  background-color: #FDA700;
  color: #FFF;
}
.accordion.accordion-warning .accordion-button.collapsed {
  background-color: #FFF;
  color: #6F6F6F;
}
.accordion.accordion-warning .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #6F6F6F;
}
.accordion.accordion-info .accordion-button {
  background-color: rgba(30, 203, 226, 0.1);
  color: #1ECBE2;
}
.accordion.accordion-info .accordion-button:after {
  background-color: #1ECBE2;
  color: #FFF;
}
.accordion.accordion-info .accordion-button.collapsed {
  background-color: #FFF;
  color: #6F6F6F;
}
.accordion.accordion-info .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #6F6F6F;
}

.accordion.accordion-solid-primary .accordion-button {
  background-color: #E41F07;
  color: #FFF;
}
.accordion.accordion-solid-primary .accordion-button:after {
  background-color: #FFF;
  color: #E41F07;
}
.accordion.accordion-solid-primary .accordion-button.collapsed {
  background-color: #FFF;
  color: #6F6F6F;
}
.accordion.accordion-solid-primary .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #6F6F6F;
}
.accordion.accordion-solid-secondary .accordion-button {
  background-color: #FFA201;
  color: #FFF;
}
.accordion.accordion-solid-secondary .accordion-button:after {
  background-color: #FFF;
  color: #FFA201;
}
.accordion.accordion-solid-secondary .accordion-button.collapsed {
  background-color: #FFF;
  color: #6F6F6F;
}
.accordion.accordion-solid-secondary .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #6F6F6F;
}
.accordion.accordion-solid-success .accordion-button {
  background-color: #5CB85C;
  color: #FFF;
}
.accordion.accordion-solid-success .accordion-button:after {
  background-color: #FFF;
  color: #5CB85C;
}
.accordion.accordion-solid-success .accordion-button.collapsed {
  background-color: #FFF;
  color: #6F6F6F;
}
.accordion.accordion-solid-success .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #6F6F6F;
}
.accordion.accordion-solid-danger .accordion-button {
  background-color: #FC0027;
  color: #FFF;
}
.accordion.accordion-solid-danger .accordion-button:after {
  background-color: #FFF;
  color: #FC0027;
}
.accordion.accordion-solid-danger .accordion-button.collapsed {
  background-color: #FFF;
  color: #6F6F6F;
}
.accordion.accordion-solid-danger .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #6F6F6F;
}
.accordion.accordion-solid-warning .accordion-button {
  background-color: #FDA700;
  color: #FFF;
}
.accordion.accordion-solid-warning .accordion-button:after {
  background-color: #FFF;
  color: #FDA700;
}
.accordion.accordion-solid-warning .accordion-button.collapsed {
  background-color: #FFF;
  color: #6F6F6F;
}
.accordion.accordion-solid-warning .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #6F6F6F;
}
.accordion.accordion-solid-info .accordion-button {
  background-color: #1ECBE2;
  color: #FFF;
}
.accordion.accordion-solid-info .accordion-button:after {
  background-color: #FFF;
  color: #1ECBE2;
}
.accordion.accordion-solid-info .accordion-button.collapsed {
  background-color: #FFF;
  color: #6F6F6F;
}
.accordion.accordion-solid-info .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #6F6F6F;
}

.accordion.accordion-border-primary .accordion-item {
  border: 1px solid #E41F07;
}
.accordion.accordion-border-primary .accordion-button {
  background-color: #FFF;
  color: #E41F07;
  border-block-end: 0px;
}
.accordion.accordion-border-primary .accordion-button:after {
  background-color: #FFF;
  color: #E41F07;
  border: 1px solid #E41F07;
}
.accordion.accordion-border-primary .accordion-button:not(.collapsed) {
  border-block-end: 1px solid #E41F07;
}
.accordion.accordion-border-secondary .accordion-item {
  border: 1px solid #FFA201;
}
.accordion.accordion-border-secondary .accordion-button {
  background-color: #FFF;
  color: #FFA201;
  border-block-end: 0px;
}
.accordion.accordion-border-secondary .accordion-button:after {
  background-color: #FFF;
  color: #FFA201;
  border: 1px solid #FFA201;
}
.accordion.accordion-border-secondary .accordion-button:not(.collapsed) {
  border-block-end: 1px solid #FFA201;
}
.accordion.accordion-border-success .accordion-item {
  border: 1px solid #5CB85C;
}
.accordion.accordion-border-success .accordion-button {
  background-color: #FFF;
  color: #5CB85C;
  border-block-end: 0px;
}
.accordion.accordion-border-success .accordion-button:after {
  background-color: #FFF;
  color: #5CB85C;
  border: 1px solid #5CB85C;
}
.accordion.accordion-border-success .accordion-button:not(.collapsed) {
  border-block-end: 1px solid #5CB85C;
}
.accordion.accordion-border-danger .accordion-item {
  border: 1px solid #FC0027;
}
.accordion.accordion-border-danger .accordion-button {
  background-color: #FFF;
  color: #FC0027;
  border-block-end: 0px;
}
.accordion.accordion-border-danger .accordion-button:after {
  background-color: #FFF;
  color: #FC0027;
  border: 1px solid #FC0027;
}
.accordion.accordion-border-danger .accordion-button:not(.collapsed) {
  border-block-end: 1px solid #FC0027;
}
.accordion.accordion-border-warning .accordion-item {
  border: 1px solid #FDA700;
}
.accordion.accordion-border-warning .accordion-button {
  background-color: #FFF;
  color: #FDA700;
  border-block-end: 0px;
}
.accordion.accordion-border-warning .accordion-button:after {
  background-color: #FFF;
  color: #FDA700;
  border: 1px solid #FDA700;
}
.accordion.accordion-border-warning .accordion-button:not(.collapsed) {
  border-block-end: 1px solid #FDA700;
}
.accordion.accordion-border-info .accordion-item {
  border: 1px solid #1ECBE2;
}
.accordion.accordion-border-info .accordion-button {
  background-color: #FFF;
  color: #1ECBE2;
  border-block-end: 0px;
}
.accordion.accordion-border-info .accordion-button:after {
  background-color: #FFF;
  color: #1ECBE2;
  border: 1px solid #1ECBE2;
}
.accordion.accordion-border-info .accordion-button:not(.collapsed) {
  border-block-end: 1px solid #1ECBE2;
}

.accordion.accordionicon-none .accordion-button:after {
  display: none;
}

.accordion.accordionicon-left .accordion-button {
  padding-inline-start: 2.5rem;
}
.accordion.accordionicon-left .accordion-button:after {
  position: absolute;
  inset-inline-start: 0.625rem;
}

.accordion.accordion-customicon1 .accordion-button:after {
  content: "+";
  font-family: "Fontawesome";
  background-color: #f7f8f9;
}
.accordion.accordion-customicon1 .accordion-button:not(.collapsed)::after {
  content: "\\f068";
  font-family: "Fontawesome";
  background-color: #FFF;
}

.customized-accordion .accordion-item.custom-accordion-primary .accordion-button {
  background-color: rgba(228, 31, 7, 0.1);
  border-inline-start: 0.25rem solid rgba(228, 31, 7, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-primary .accordion-button:after {
  background-color: rgba(228, 31, 7, 0.6);
  color: #FFF;
}
.customized-accordion .accordion-item.custom-accordion-primary .accordion-body {
  background-color: rgba(228, 31, 7, 0.1);
  padding-block-start: 0;
  border-inline-start: 0.25rem solid rgba(228, 31, 7, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-secondary .accordion-button {
  background-color: rgba(255, 162, 1, 0.1);
  border-inline-start: 0.25rem solid rgba(255, 162, 1, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-secondary .accordion-button:after {
  background-color: rgba(255, 162, 1, 0.6);
  color: #FFF;
}
.customized-accordion .accordion-item.custom-accordion-secondary .accordion-body {
  background-color: rgba(255, 162, 1, 0.1);
  padding-block-start: 0;
  border-inline-start: 0.25rem solid rgba(255, 162, 1, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-warning .accordion-button {
  background-color: rgba(253, 167, 0, 0.1);
  border-inline-start: 0.25rem solid rgba(253, 167, 0, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-warning .accordion-button:after {
  background-color: rgba(253, 167, 0, 0.6);
  color: #FFF;
}
.customized-accordion .accordion-item.custom-accordion-warning .accordion-body {
  background-color: rgba(253, 167, 0, 0.1);
  padding-block-start: 0;
  border-inline-start: 0.25rem solid rgba(253, 167, 0, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-info .accordion-button {
  background-color: rgba(30, 203, 226, 0.1);
  border-inline-start: 0.25rem solid rgba(30, 203, 226, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-info .accordion-button:after {
  background-color: rgba(30, 203, 226, 0.6);
  color: #FFF;
}
.customized-accordion .accordion-item.custom-accordion-info .accordion-body {
  background-color: rgba(30, 203, 226, 0.1);
  padding-block-start: 0;
  border-inline-start: 0.25rem solid rgba(30, 203, 226, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-success .accordion-button {
  background-color: rgba(92, 184, 92, 0.1);
  border-inline-start: 0.25rem solid rgba(92, 184, 92, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-success .accordion-button:after {
  background-color: rgba(92, 184, 92, 0.6);
  color: #FFF;
}
.customized-accordion .accordion-item.custom-accordion-success .accordion-body {
  background-color: rgba(92, 184, 92, 0.1);
  padding-block-start: 0;
  border-inline-start: 0.25rem solid rgba(92, 184, 92, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-danger .accordion-button {
  background-color: rgba(252, 0, 39, 0.1);
  border-inline-start: 0.25rem solid rgba(252, 0, 39, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-danger .accordion-button:after {
  background-color: rgba(252, 0, 39, 0.6);
  color: #FFF;
}
.customized-accordion .accordion-item.custom-accordion-danger .accordion-body {
  background-color: rgba(252, 0, 39, 0.1);
  padding-block-start: 0;
  border-inline-start: 0.25rem solid rgba(252, 0, 39, 0.6);
}

.page-header-breadcrumb .breadcrumb-item + .breadcrumb-item::before {
  content: var(--bs-breadcrumb-divider, "\\ea65");
  font-family: "tabler-icons" !important;
}

[dir=rtl] .page-header-breadcrumb .breadcrumb-item + .breadcrumb-item::before {
  content: var(--bs-breadcrumb-divider, "\\ea64");
  font-family: "tabler-icons" !important;
}

.breadcrumb .breadcrumb-item a {
  color: #9595b5;
}
.breadcrumb .breadcrumb-item.active {
  color: #E41F07;
}

.breadcrumb-item + .breadcrumb-item::before {
  color: #9595b5;
  opacity: 0.4;
}

.breadcrumb-arrow .breadcrumb-item + .breadcrumb-item::before {
  color: #9595b5;
  content: "\\f101";
  font-family: "Fontawesome" !important;
}

.breadcrumb-pipe .breadcrumb-item + .breadcrumb-item::before {
  color: #9595b5;
  content: "\\f061";
  font-family: "Fontawesome" !important;
}

.breadcrumb-line .breadcrumb-item + .breadcrumb-item::before {
  color: #9595b5;
  content: "-";
}

.breadcrumb-dot .breadcrumb-item + .breadcrumb-item::before {
  color: #9595b5;
  content: "•";
}

.breadcrumb-divide .breadcrumb-item + .breadcrumb-item::before {
  color: #9595b5;
  content: "\\f054";
  font-family: "Fontawesome" !important;
}

.breadcrumb-separatorless .breadcrumb-item + .breadcrumb-item::before {
  content: "";
  display: none;
}

.breadcrumb-colored {
  padding: 12px 15px;
  border-radius: 4px;
}
.breadcrumb-colored li a {
  color: #FFF;
}
.breadcrumb-colored .breadcrumb-item a {
  color: #FFF;
}
.breadcrumb-colored .breadcrumb-item.active {
  color: #FFF;
  opacity: 0.8;
}
.breadcrumb-colored .breadcrumb-item + .breadcrumb-item a {
  color: #FFF;
}
.breadcrumb-colored .breadcrumb-item + .breadcrumb-item::before {
  color: #FFF;
}

.embedded-breadcrumb:before {
  opacity: 0.7;
}

[data-theme-mode=dark] .embedded-breadcrumb:before {
  filter: invert(1);
}

.card {
  margin-bottom: 24px;
  background-color: #FFF;
  transition: all 0.5s ease-in-out;
  position: relative;
  border-radius: 5px;
  border: 0;
  box-shadow: 0px 4px 74px 0px rgba(208, 208, 208, 0.2509803922);
  color: inherit;
}
.card .card-body {
  padding: 1rem;
}
.card .card-title {
  font-size: 18px;
  font-weight: 700;
  text-transform: capitalize;
}
.card .card-header {
  border-color: #E8E8E8;
  position: relative;
  background: transparent;
  padding: 1rem;
}
.card .card-header .card-title {
  margin-bottom: 0rem;
}
.card .card-header .subtitle {
  padding-top: 0.3125rem;
  font-size: 0.875rem;
  line-height: 1.5;
}
.card .card-footer {
  border-color: #E8E8E8;
  background: transparent;
  padding: 1rem 1.25rem 1rem;
}

.card-group .card {
  margin-bottom: 1.5rem;
}

.card.custom-card {
  border-radius: 4px;
  border: 0;
  background-color: #FFF;
  position: relative;
  margin-block-end: 1.5rem;
  width: 100%;
}
.card.custom-card .card-header {
  padding: 1rem 1.25rem;
  background-color: transparent !important;
  border-block-end: 1px solid #E8E8E8;
  display: flex;
  align-items: center;
  position: relative;
  flex-wrap: wrap;
  gap: 0.25rem;
}
.card.custom-card .card-header:first-child {
  border-radius: 0.625rem 0.625rem 0 0;
}
.card.custom-card .card-header .card-title {
  position: relative;
  margin-block-end: 0;
  font-size: 0.9375rem;
  font-weight: 700;
  text-transform: capitalize;
}
.card.custom-card .card-header .card-title .subtitle {
  margin-block-end: 0;
  text-transform: initial;
}
.card.custom-card .card-footer {
  background-color: transparent !important;
  border-block-start: 1px solid #E8E8E8;
  padding: 1rem 1.5rem;
  font-size: 14px;
}
.card.custom-card .card-body {
  padding: 1.5rem;
  color: #6F6F6F;
}
.card.custom-card .card-link {
  font-size: 0.75rem;
}
.card .card-text {
  font-size: 0.813rem;
}
.card .footer-card-icon {
  width: 60px;
  height: 60px;
}
.card.overlay-card {
  position: relative;
  overflow: hidden;
  color: rgba(255, 255, 255, 0.9);
}
.card.overlay-card .card-header {
  border-block-end: 1px solid rgba(255, 255, 255, 0.1);
}
.card.overlay-card .card-footer {
  border-block-start: 1px solid rgba(255, 255, 255, 0.1);
}
.card.overlay-card .over-content-bottom {
  top: auto;
}
.card.overlay-card:before {
  content: "";
  inset-inline-start: 0;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  background-color: rgba(0, 0, 0, 0.2);
  position: absolute;
}
.card.card-bg-primary {
  background-color: #E41F07;
  color: #FFF;
}
.card.card-bg-primary .card-header {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-end: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-primary .card-header:before {
  background-color: #FFF;
}
.card.card-bg-primary .card-body {
  color: #FFF;
}
.card.card-bg-primary .card-footer {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-start: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-secondary {
  background-color: #FFA201;
  color: #FFF;
}
.card.card-bg-secondary .card-header {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-end: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-secondary .card-header:before {
  background-color: #FFF;
}
.card.card-bg-secondary .card-body {
  color: #FFF;
}
.card.card-bg-secondary .card-footer {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-start: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-warning {
  background-color: #FDA700;
  color: #FFF;
}
.card.card-bg-warning .card-header {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-end: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-warning .card-header:before {
  background-color: #FFF;
}
.card.card-bg-warning .card-body {
  color: #FFF;
}
.card.card-bg-warning .card-footer {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-start: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-info {
  background-color: #1ECBE2;
  color: #FFF;
}
.card.card-bg-info .card-header {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-end: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-info .card-header:before {
  background-color: #FFF;
}
.card.card-bg-info .card-body {
  color: #FFF;
}
.card.card-bg-info .card-footer {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-start: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-success {
  background-color: #5CB85C;
  color: #FFF;
}
.card.card-bg-success .card-header {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-end: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-success .card-header:before {
  background-color: #FFF;
}
.card.card-bg-success .card-body {
  color: #FFF;
}
.card.card-bg-success .card-footer {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-start: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-danger {
  background-color: #FC0027;
  color: #FFF;
}
.card.card-bg-danger .card-header {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-end: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-danger .card-header:before {
  background-color: #FFF;
}
.card.card-bg-danger .card-body {
  color: #FFF;
}
.card.card-bg-danger .card-footer {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-start: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-light {
  background-color: #FDFDFE;
  color: #6F6F6F;
}
.card.card-bg-light .card-header {
  background-color: rgba(0, 0, 0, 0.05) !important;
  color: #6F6F6F;
  border-block-end: #E8E8E8;
}
.card.card-bg-light .card-body {
  color: #6F6F6F;
}
.card.card-bg-light .card-footer {
  background-color: rgba(0, 0, 0, 0.05) !important;
  color: #6F6F6F;
  border-block-start: #E8E8E8;
}
.card.card-bg-dark {
  background-color: #171724;
  color: #FFF;
}
.card.card-bg-dark .card-header {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-end: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-dark .card-header:before {
  background-color: #FFF;
}
.card.card-bg-dark .card-body {
  color: #FFF;
}
.card.card-bg-dark .card-footer {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-start: 1px solid rgba(255, 255, 255, 0.2);
}
.card .card-anchor {
  position: absolute;
  top: 0;
  inset-inline-end: 0;
  bottom: 0;
  inset-inline-start: 0;
  z-index: 1;
  pointer-events: auto;
  content: "";
}
.card .collapse-close {
  display: none;
}
.card.card .collapsed .collapse-close {
  display: block;
}
.card.card .collapsed .collapse-open {
  display: none;
}
.card.card-fullscreen {
  position: fixed;
  top: 0;
  inset-inline-start: 0;
  inset-inline-start: 0;
  bottom: 0;
  z-index: 9999;
  margin: 0;
}

.cals-icon {
  font-size: 50px;
  color: #6F7A7A;
}

.callout {
  padding: 1.25rem;
  margin-block-start: 1.25rem;
  margin-block-end: 1.25rem;
  background-color: #FDFDFE;
  border-inline-start: 0.25rem solid #E8E8E8;
}

.callout-info {
  background-color: rgba(30, 203, 226, 0.075);
  border-color: rgba(30, 203, 226, 0.5);
}

.callout-warning {
  background-color: rgba(253, 167, 0, 0.075);
  border-color: rgba(253, 167, 0, 0.5);
}

.callout-danger {
  background-color: rgba(252, 0, 39, 0.075);
  border-color: rgba(252, 0, 39, 0.5);
}

.btn-facebook {
  background-color: #3B5998;
  color: #FFF;
  border: 1px solid #3B5998;
}
.btn-facebook:hover, .btn-facebook:focus, .btn-facebook:active {
  background-color: #3B5998 !important;
  color: #FFF !important;
  border: 1px solid #3B5998 !important;
}

.btn-instagram {
  background: #f09433;
  background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="#f09433", endColorstr="#bc1888",GradientType=1 );
  color: #FFF;
  border: 1px solid transparent;
}
.btn-instagram:hover, .btn-instagram:focus, .btn-instagram:active {
  color: #FFF;
  border: 1px solid transparent;
}

.btn-twitter {
  background-color: #00ACEE;
  color: #FFF;
  border: 1px solid #00ACEE;
}
.btn-twitter:hover, .btn-twitter:focus, .btn-twitter:active {
  background-color: #00ACEE !important;
  color: #FFF !important;
  border: 1px solid #00ACEE !important;
}

.btn-icon {
  width: 2.313rem;
  height: 2.313rem;
  font-size: 0.95rem;
  flex-shrink: 0;
}

.btn-wave {
  display: inline-block !important;
}

@media (max-width: 575px) {
  .overlay-card .card-text {
    font-size: 0.613rem !important;
  }
}
@media (max-width: 400px) {
  .overlay-card .card-text {
    font-size: 0.413rem !important;
  }
}
.tooltip.tooltip-primary .tooltip-inner {
  background-color: #E41F07;
}
.tooltip.tooltip-primary.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before, .tooltip.tooltip-primary.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #E41F07;
}
.tooltip.tooltip-primary.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before, .tooltip.tooltip-primary.bs-tooltip-end .tooltip-arrow::before {
  border-right-color: #E41F07;
}
.tooltip.tooltip-primary.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before, .tooltip.tooltip-primary.bs-tooltip-start .tooltip-arrow::before {
  border-left-color: #E41F07;
}
.tooltip.tooltip-primary.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before, .tooltip.tooltip-primary.bs-tooltip-end .tooltip-arrow::before {
  border-bottom-color: #E41F07;
}
.tooltip.tooltip-secondary .tooltip-inner {
  background-color: #FFA201;
}
.tooltip.tooltip-secondary.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before, .tooltip.tooltip-secondary.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #FFA201;
}
.tooltip.tooltip-secondary.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before, .tooltip.tooltip-secondary.bs-tooltip-end .tooltip-arrow::before {
  border-right-color: #FFA201;
}
.tooltip.tooltip-secondary.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before, .tooltip.tooltip-secondary.bs-tooltip-start .tooltip-arrow::before {
  border-left-color: #FFA201;
}
.tooltip.tooltip-secondary.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before, .tooltip.tooltip-secondary.bs-tooltip-end .tooltip-arrow::before {
  border-bottom-color: #FFA201;
}
.tooltip.tooltip-warning .tooltip-inner {
  background-color: #FDA700;
}
.tooltip.tooltip-warning.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before, .tooltip.tooltip-warning.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #FDA700;
}
.tooltip.tooltip-warning.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before, .tooltip.tooltip-warning.bs-tooltip-end .tooltip-arrow::before {
  border-right-color: #FDA700;
}
.tooltip.tooltip-warning.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before, .tooltip.tooltip-warning.bs-tooltip-start .tooltip-arrow::before {
  border-left-color: #FDA700;
}
.tooltip.tooltip-warning.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before, .tooltip.tooltip-warning.bs-tooltip-end .tooltip-arrow::before {
  border-bottom-color: #FDA700;
}
.tooltip.tooltip-info .tooltip-inner {
  background-color: #1ECBE2;
}
.tooltip.tooltip-info.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before, .tooltip.tooltip-info.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #1ECBE2;
}
.tooltip.tooltip-info.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before, .tooltip.tooltip-info.bs-tooltip-end .tooltip-arrow::before {
  border-right-color: #1ECBE2;
}
.tooltip.tooltip-info.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before, .tooltip.tooltip-info.bs-tooltip-start .tooltip-arrow::before {
  border-left-color: #1ECBE2;
}
.tooltip.tooltip-info.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before, .tooltip.tooltip-info.bs-tooltip-end .tooltip-arrow::before {
  border-bottom-color: #1ECBE2;
}
.tooltip.tooltip-success .tooltip-inner {
  background-color: #5CB85C;
}
.tooltip.tooltip-success.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before, .tooltip.tooltip-success.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #5CB85C;
}
.tooltip.tooltip-success.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before, .tooltip.tooltip-success.bs-tooltip-end .tooltip-arrow::before {
  border-right-color: #5CB85C;
}
.tooltip.tooltip-success.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before, .tooltip.tooltip-success.bs-tooltip-start .tooltip-arrow::before {
  border-left-color: #5CB85C;
}
.tooltip.tooltip-success.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before, .tooltip.tooltip-success.bs-tooltip-end .tooltip-arrow::before {
  border-bottom-color: #5CB85C;
}
.tooltip.tooltip-danger .tooltip-inner {
  background-color: #FC0027;
}
.tooltip.tooltip-danger.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before, .tooltip.tooltip-danger.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #FC0027;
}
.tooltip.tooltip-danger.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before, .tooltip.tooltip-danger.bs-tooltip-end .tooltip-arrow::before {
  border-right-color: #FC0027;
}
.tooltip.tooltip-danger.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before, .tooltip.tooltip-danger.bs-tooltip-start .tooltip-arrow::before {
  border-left-color: #FC0027;
}
.tooltip.tooltip-danger.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before, .tooltip.tooltip-danger.bs-tooltip-end .tooltip-arrow::before {
  border-bottom-color: #FC0027;
}
.tooltip.tooltip-dark .tooltip-inner {
  background-color: #171724;
}
.tooltip.tooltip-dark.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before, .tooltip.tooltip-dark.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #171724;
}
.tooltip.tooltip-dark.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before, .tooltip.tooltip-dark.bs-tooltip-end .tooltip-arrow::before {
  border-right-color: #171724;
}
.tooltip.tooltip-dark.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before, .tooltip.tooltip-dark.bs-tooltip-start .tooltip-arrow::before {
  border-left-color: #171724;
}
.tooltip.tooltip-dark.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before, .tooltip.tooltip-dark.bs-tooltip-end .tooltip-arrow::before {
  border-bottom-color: #171724;
}
.tooltip.tooltip-dark .tooltip-inner {
  color: #FFF;
}
.tooltip.tooltip-light .tooltip-inner {
  background-color: #FDFDFE;
}
.tooltip.tooltip-light.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before, .tooltip.tooltip-light.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #FDFDFE;
}
.tooltip.tooltip-light.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before, .tooltip.tooltip-light.bs-tooltip-end .tooltip-arrow::before {
  border-right-color: #FDFDFE;
}
.tooltip.tooltip-light.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before, .tooltip.tooltip-light.bs-tooltip-start .tooltip-arrow::before {
  border-left-color: #FDFDFE;
}
.tooltip.tooltip-light.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before, .tooltip.tooltip-light.bs-tooltip-end .tooltip-arrow::before {
  border-bottom-color: #FDFDFE;
}
.tooltip.tooltip-light .tooltip-inner {
  color: #6F6F6F;
}

.nav-item {
  margin-inline-end: 0.5rem;
}
.nav-item:last-child {
  margin-inline-end: 0;
}

.nav-link {
  color: #6F6F6F;
  border-radius: 4px;
  font-weight: 600;
}
.nav-link.active {
  background-color: rgba(228, 31, 7, 0.1);
  color: #E41F07;
}

.navbar-brand {
  color: #6F6F6F;
}
.navbar-brand:focus, .navbar-brand:hover {
  color: #6F6F6F;
  opacity: 0.9;
}

.navbar-nav .nav-link.active,
.navbar-nav .show > .nav-link {
  color: #E41F07;
}

.nav-link.disabled {
  color: #6F6F6F;
  opacity: 0.3;
}

.nav-tabs .nav-link.disabled, .nav-tabs .nav-link:disabled {
  color: rgba(23, 23, 36, 0.5);
}

.navbar-text {
  color: #6F6F6F;
}

.navbar-dark.bg-dark .nav-link,
.navbar-dark.bg-dark .navbar-brand {
  color: #FFF;
}
.navbar-dark .navbar-nav .nav-link.active,
.navbar-dark .navbar-nav .show > .nav-link {
  color: #FFF;
}

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #FFF;
  background-color: #E41F07;
}

.nav.nav-style-1 {
  border: 0;
}
.nav.nav-style-1 .nav-item {
  margin-inline-end: 0.25rem;
}
.nav.nav-style-1 .nav-item:last-child {
  margin-inline-end: 0;
}
.nav.nav-style-1 .nav-link.active {
  background-color: rgba(228, 31, 7, 0.1);
  color: #E41F07;
}
.nav.nav-style-1 .nav-link.active:hover {
  background: rgba(228, 31, 7, 0.1);
}
.nav.nav-style-1 .nav-link:hover {
  background: transparent;
  color: #E41F07;
}

.nav.nav-style-2 .nav-item .nav-link {
  border-block-start: 3px solid transparent;
}
.nav.nav-style-2 .nav-item .nav-link.active {
  background-color: rgba(228, 31, 7, 0.1);
  border-block-start: 3px solid #E41F07;
  color: #E41F07;
}

.nav.nav-style-3 .nav-link {
  border-radius: 0;
}
.nav.nav-style-3 .nav-link {
  border-block-end: 3px solid transparent;
}
.nav.nav-style-3 .nav-link.active {
  background-color: transparent;
  border-block-end: 3px solid #E41F07;
  color: #E41F07;
}

.nav.nav-style-4 {
  border: 0;
}
.nav.nav-style-4 .nav-link {
  color: #9595b5;
  border: 0;
}
.nav.nav-style-4 .nav-link {
  margin-bottom: 3px;
}
.nav.nav-style-4 .nav-link.active {
  background-color: #FDFDFE;
  color: #6F6F6F;
  border: 0;
}
.nav.nav-style-4 .nav-link:hover, .nav.nav-style-4 .nav-link:focus {
  border: 0;
}
.nav.nav-style-4 .nav-link:hover {
  background-color: #FDFDFE;
  color: #6F6F6F;
}

.nav-tabs.nav-style-5 {
  border: 0;
}
.nav-tabs.nav-style-5 .nav-link {
  color: #9595b5;
  border: 0;
  margin-bottom: 3px;
}
.nav-tabs.nav-style-5 .nav-link.active {
  background-color: #E41F07;
  color: #FFF;
  border: 0;
}
.nav-tabs.nav-style-5 .nav-link:hover, .nav-tabs.nav-style-5 .nav-link:focus {
  border: 0;
  background-color: #E41F07;
  color: #FFF;
}

.nav-style-6 {
  border: 0;
}
.nav-style-6.nav-pills .nav-link.active {
  border: 1px solid #E41F07;
  border-block-end: 2px solid #E41F07;
  background-color: transparent;
  color: #E41F07;
}

.nav-tabs-header {
  border: 0 !important;
}
.nav-tabs-header .nav-item {
  margin-inline-end: 0.5rem;
}
.nav-tabs-header .nav-item:last-child {
  margin-inline-end: 0;
}
.nav-tabs-header .nav-item .nav-link {
  border: 1px solid transparent;
  font-size: 0.8rem;
  padding: 0.4rem 0.5rem;
  font-weight: 500;
}
.nav-tabs-header .nav-item .nav-link.active {
  background: rgba(228, 31, 7, 0.1);
  color: #E41F07;
  border: 1px solid transparent;
}
.nav-tabs-header .nav-item .nav-link:hover, .nav-tabs-header .nav-item .nav-link:focus {
  border: 1px solid transparent;
  background-color: transparent;
  color: #E41F07;
}

.nav-tabs-footer {
  border: 0;
}
.nav-tabs-footer .nav-item {
  margin-inline-end: 0.5rem;
}
.nav-tabs-footer .nav-item:last-child {
  margin-inline-end: 0;
}
.nav-tabs-footer .nav-item .nav-link {
  background-color: transparent;
  color: #E41F07;
  border: 1px solid #E41F07;
  font-size: 0.8rem;
}
.nav-tabs-footer .nav-item .nav-link.active {
  background: #E41F07;
  color: #FFF;
  border: 1px solid #E41F07;
}
.nav-tabs-footer .nav-item .nav-link:hover, .nav-tabs-footer .nav-item .nav-link:focus {
  border: 1px solid #E41F07;
  background-color: transparent;
  color: #E41F07;
}

.vertical-tabs-2 {
  border: 0;
}
.vertical-tabs-2 .nav-item {
  margin-inline-end: 0.5rem;
}
.vertical-tabs-2 .nav-item:last-child {
  margin-inline-end: 0;
}
.vertical-tabs-2 .nav-item .nav-link {
  min-width: 7.5rem;
  max-width: 7.5rem;
  text-align: center;
  border: 1px solid #E8E8E8;
  margin-bottom: 0.5rem;
  color: #9595b5;
  background-color: #FDFDFE;
}
.vertical-tabs-2 .nav-item .nav-link i {
  font-size: 1rem;
}
.vertical-tabs-2 .nav-item .nav-link.active {
  background-color: #E41F07;
  color: #FFF;
  position: relative;
}
.vertical-tabs-2 .nav-item .nav-link.active:before {
  content: "";
  position: absolute;
  inset-inline-end: -0.5rem;
  inset-block-start: 38%;
  transform: rotate(45deg);
  width: 1rem;
  height: 1rem;
  background-color: #E41F07;
}
.vertical-tabs-2 .nav-item .nav-link.active:hover {
  color: #FFF;
}
.vertical-tabs-2 .nav-item .nav-link:hover {
  color: #E41F07;
}

.vertical-tabs-3 {
  border: 0;
}
.vertical-tabs-3 .nav-item {
  border: 0;
  margin-inline-end: 0.5rem;
}
.vertical-tabs-3 .nav-item:last-child {
  margin-inline-end: 0;
}
.vertical-tabs-3 .nav-item .nav-link {
  min-width: 160px;
  max-width: 160px;
  border: 1px solid #E41F07;
  padding: 1.3rem;
  margin-block-end: 0.5rem;
}
.vertical-tabs-3 .nav-item .nav-link i {
  width: 2rem;
  height: 2rem;
  line-height: 2rem;
  text-align: center;
  font-size: 1rem;
  background: #E41F07;
  color: #FFF;
  border-radius: 3.125rem;
  font-weight: 500;
}
.vertical-tabs-3 .nav-item .nav-link.active {
  background: #E41F07;
  border: 1px solid #E41F07;
  color: #FFF;
}
.vertical-tabs-3 .nav-item .nav-link.active:hover {
  background: #E41F07;
  border: 1px solid #E41F07;
  color: #FFF;
}
.vertical-tabs-3 .nav-item .nav-link.active i {
  background: #FFF;
  color: #E41F07;
}
.vertical-tabs-3 .nav-item .nav-link:hover, .vertical-tabs-3 .nav-item .nav-link:focus {
  border: 1px solid #E41F07;
  color: #E41F07;
  background: transparent;
}

.nav.tab-style-1 {
  border-block-end: 0;
  padding: 0.65rem;
  background-color: #FDFDFE;
  border-radius: 7px;
  margin-block-end: 1rem;
}
.nav.tab-style-1 .nav-item {
  margin-inline-end: 0.5rem;
}
.nav.tab-style-1 .nav-item:last-child {
  margin-inline-end: 0;
}
.nav.tab-style-1 .nav-link {
  border-radius: 7px;
  padding: 0.35rem 1rem;
}
.nav.tab-style-1 .nav-link.active {
  background-color: #E41F07 !important;
  color: #FFF !important;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  transition: color 0.15s ease-in;
}

.nav-tabs.tab-style-1 .nav-link:hover {
  background: transparent;
  color: #E41F07;
}

.tab-style-2 {
  border-block-end: 0;
}
.tab-style-2 .nav-item {
  margin-inline-end: 0.5rem;
}
.tab-style-2 .nav-item:last-child {
  margin-inline-end: 0;
}
.tab-style-2 .nav-item .nav-link {
  border: 0;
}
.tab-style-2 .nav-item .nav-link i {
  width: 1.875rem;
  height: 1.875rem;
  padding: 0.4rem;
  border-radius: 50px;
  background-color: #FDFDFE;
  color: #6F6F6F;
  display: inline-block;
}
.tab-style-2 .nav-item .nav-link:hover {
  border: 0;
  background: transparent;
  color: #E41F07;
}
.tab-style-2 .nav-item .nav-link:hover i {
  color: #E41F07;
}
.tab-style-2 .nav-item .nav-link.active {
  background-color: transparent;
  position: relative;
  border: 0;
  color: #E41F07;
}
.tab-style-2 .nav-item .nav-link.active i {
  background-color: rgba(228, 31, 7, 0.1);
  color: #E41F07;
}
.tab-style-2 .nav-item .nav-link.active:before {
  content: "";
  position: absolute;
  inset-inline-start: 0;
  inset-inline-end: 0;
  inset-block-end: 0;
  width: 100%;
  height: 0.175rem;
  background-color: #E41F07;
  border-radius: 50px;
}

.tab-style-3 {
  border-block-end: 0;
}
.tab-style-3 .nav-item {
  position: relative;
  margin-inline-end: 0.5rem;
}
.tab-style-3 .nav-item:last-child {
  margin-inline-end: 0;
}
.tab-style-3 .nav-item .nav-link {
  position: relative;
  border: 0;
  font-size: 0.75rem;
}
.tab-style-3 .nav-item .nav-link:before {
  position: absolute;
  content: "";
  inset-block-end: -1.063rem;
  inset-inline-end: 0;
  inset-inline-start: 0;
  width: 100%;
  height: 0.1rem;
  background-color: #FDFDFE;
  border-radius: 50%;
}
.tab-style-3 .nav-item .nav-link:after {
  position: absolute;
  content: "";
  inset-block-end: -2rem;
  inset-inline-start: 1.75rem;
  inset-inline-end: 0;
  inset-inline-start: 30%;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #FFF;
  border-radius: 50%;
  border: 2px solid #E8E8E8;
}
.tab-style-3 .nav-item .nav-link.home:after {
  content: "1";
}
.tab-style-3 .nav-item .nav-link.about:after {
  content: "2";
}
.tab-style-3 .nav-item .nav-link.services:after {
  content: "3";
}
.tab-style-3 .nav-item .nav-link:hover {
  border: 0;
  background: transparent;
  color: #E41F07;
}
.tab-style-3 .nav-item .nav-link.active {
  background-color: transparent;
  border: 0;
  color: #E41F07;
}
.tab-style-3 .nav-item .nav-link.active:before {
  background-color: #E41F07;
}
.tab-style-3 .nav-item .nav-link.active:after {
  border-color: #E41F07;
  color: #E41F07;
}

.tab-style-4.nav-tabs {
  border: 0;
}
.tab-style-4.nav-tabs .nav-item {
  margin-inline-end: 0.5rem;
}
.tab-style-4.nav-tabs .nav-item:last-child {
  margin-inline-end: 0;
}
.tab-style-4.nav-tabs .nav-link {
  border: 0;
}
.tab-style-4.nav-tabs .nav-link:hover {
  border: 0;
  background: transparent;
  color: #E41F07;
}
.tab-style-4.nav-tabs .nav-link.active {
  background-color: transparent;
  border: 0;
  color: #E41F07;
  position: relative;
  overflow: hidden;
}
.tab-style-4.nav-tabs .nav-link.active::before {
  position: absolute;
  content: "";
  width: 0.75rem;
  inset-block-start: 31px;
  transform: rotate(45deg);
  inset-inline-start: 47%;
  overflow: hidden;
  z-index: 1;
  height: 0.75rem;
  background-color: #E41F07;
  border: 1px solid #E41F07;
}
.tab-style-4.nav-tabs .nav-link.active:after {
  position: absolute;
  content: "";
  width: 40%;
  height: 1px;
  inset-inline-start: 30%;
  inset-block-end: 0;
  background-color: #E41F07;
}

#tab-style-4 .tab-pane.active {
  border: 1px solid #E41F07;
  background-color: #E41F07;
  color: #FFF;
  padding: 16px;
  border-radius: 7px;
}

.tab-style-5 .nav-item {
  margin-inline-end: 0.5rem;
}
.tab-style-5 .nav-item:last-child {
  margin-inline-end: 0;
}
.tab-style-5 .nav-item .nav-link.active {
  background: #E41F07;
}

.tab-style-6 {
  border: 0;
  background-color: #FFF;
  border-radius: 7px;
  color: #E41F07;
  padding: 0.5rem;
}
.tab-style-6 .nav-item {
  border: 0;
  margin-inline-end: 0.5rem;
}
.tab-style-6 .nav-item:last-child {
  margin-inline-end: 0;
}
.tab-style-6 .nav-item .nav-link {
  color: #E41F07;
  padding: 0.5rem 1rem;
  font-size: 0.813rem;
  border: 0;
  font-weight: 500;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.tab-style-6 .nav-item .nav-link.active {
  border: 0;
  background-color: #E41F07;
  color: #FFF;
  border: 0;
  box-shadow: 0px 3px 10px 0px rgba(var(--dark-rgb), 0.05);
}
.tab-style-6 .nav-item .nav-link:hover, .tab-style-6 .nav-item .nav-link:focus {
  border: 0;
}

.tab-style-7 .nav-link {
  margin-block-end: 0.5rem;
  font-size: 0.813rem;
  color: #9595b5;
  text-align: left;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.tab-style-7 .nav-link:active, .tab-style-7 .nav-link.active {
  background-color: rgba(228, 31, 7, 0.1);
  color: #E41F07;
}

.nav-style-1 .nav-item .nav-link.active {
  background-color: rgba(228, 31, 7, 0.1);
  color: #E41F07;
}

@media screen and (max-width: 400px) {
  .tab-style-4 .nav-link {
    padding-inline: 0.5rem;
  }
}
.nav-tabs {
  border-bottom: 0;
}
.nav-tabs.nav-tabs-bottom li {
  margin-bottom: -1px;
}
.nav-tabs .nav-link {
  margin-bottom: -1px;
  background: 0 0;
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.nav-tabs .nav-link.active {
  border-color: #898989;
}
.nav-tabs li a {
  color: #565E5E;
  border-bottom-width: 2px;
}
.nav-tabs li a.active {
  border-color: transparent;
  border-bottom-color: #E41F07;
  background-color: transparent;
  transition: all 0.2s ease;
}

.nav-tabs .nav-tabs-solid {
  background-color: #FFF;
  border: 0;
}
.nav-tabs .nav-tabs-solid .active {
  background-color: #E41F07;
  border-color: #E41F07;
  color: #FFF;
}

.nav-tabs .nav-link:hover {
  border-color: transparent;
  color: #E41F07;
}
.nav-tabs.nav-tabs-top li a {
  border-width: 2px 0 0 0;
}
.nav-tabs.nav-tabs-top li a.active {
  border-top-color: #E41F07;
  border-radius: 0;
}
.nav-tabs.nav-tabs-top li a:hover {
  border-top-color: #E41F07;
  background-color: transparent;
  border-radius: 0;
}
.nav-tabs.nav-tabs-bottom li a {
  border-width: 0 0 2px 0;
}
.nav-tabs.nav-tabs-bottom li a.active, .nav-tabs.nav-tabs-bottom li a:hover {
  border-bottom-color: #E41F07;
  background: transparent;
  border-radius: 0;
}
.nav-tabs.nav-tabs-solid {
  background-color: #FFF;
  border: 0;
}
.nav-tabs.nav-tabs-solid.nav-tabs-rounded li a.active {
  background-color: #E41F07;
  border-color: #E41F07;
  color: #FFF;
  border-radius: 50px;
}
.nav-tabs.nav-tabs-solid li a.active {
  background-color: #E41F07;
  border-color: #E41F07;
  color: #FFF;
  border-radius: 0;
}

.nav-link:hover {
  color: #E41F07;
}

.page-menu .nav-tabs li a {
  font-size: 16px;
}

.tabs-set .nav-tabs {
  border-bottom: 0;
  margin-bottom: 20px;
}
.tabs-set .nav-tabs .nav-link {
  color: #FFA201;
  padding: 8px 15px;
  font-size: 16px;
  font-weight: 700;
  border: 0;
  min-width: 120px;
  margin-right: 10px;
  border-radius: 8px;
  background: var(--Stroke, rgba(145, 158, 171, 0.3));
}
.tabs-set .nav-tabs .nav-link:focus {
  border-color: transparent;
}
.tabs-set .nav-tabs .nav-link:hover {
  border-color: transparent;
}
.tabs-set .nav-tabs .nav-link.active {
  border: 0;
  border-bottom: 2px solid #E41F07;
  background: #E41F07;
  color: #FFF;
}

.tabs-sets .nav-tabs {
  border-bottom: 0;
  margin: 0 0 40px;
}
.tabs-sets .nav-tabs .nav-link {
  color: #000;
  font-size: 14px;
  font-weight: 700;
  border: 0;
  background: #898989;
  margin-right: 10px;
  padding: 8px 15px;
  border-radius: 8px;
  transition: all 0.5s ease;
}
.tabs-sets .nav-tabs .nav-link:focus, .tabs-sets .nav-tabs .nav-link:hover, .tabs-sets .nav-tabs .nav-link.active {
  background: #E41F07;
  color: #FFF;
}

@media (max-width: 768px) {
  .nav-tabs {
    border-bottom: 0;
    position: relative;
    background-color: #FFF;
    padding: 5px 0;
    border-radius: 3px;
  }
}
.ribbon1 {
  position: absolute;
  inset-block-start: -6.1px;
  inset-inline-end: 10px;
  color: #FFF;
  z-index: 1;
}
.ribbon1:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-inline-start: 20px solid transparent;
  border-inline-end: 24px solid transparent;
  border-block-start: 13px solid #FC0027;
}
.ribbon1 span {
  position: relative;
  display: block;
  text-align: center;
  background: #FC0027;
  font-size: 14px;
  line-height: 1;
  padding: 12px 8px 10px;
  border-start-end-radius: 8px;
}
.ribbon1 span:before, .ribbon1 span:after {
  position: absolute;
  content: "";
}
.ribbon1 span:before {
  height: 6px;
  width: 6px;
  inset-inline-start: -6px;
  inset-block-start: 0;
  background: #FC0027;
}
.ribbon1 span:after {
  height: 6px;
  width: 8px;
  inset-inline-start: -8px;
  inset-block-start: 0;
  border-radius: 8px 8px 0 0;
  background: #FC0027;
}

.ribbone {
  width: 100%;
  position: relative;
  background-size: cover;
  text-transform: uppercase;
  color: #FFF;
  width: 150px;
  height: 150px;
  overflow: hidden;
  position: absolute;
  z-index: 6;
}
.ribbone::after {
  position: absolute;
  z-index: -1;
  content: "";
  display: block;
  border: 5px solid;
}
.ribbone::before {
  position: absolute;
  z-index: -1;
  content: "";
  display: block;
  border: 5px solid;
}
.ribbone span {
  position: absolute;
  display: block;
  width: 225px;
  padding: 3px 0;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  color: #FFF;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  text-transform: capitalize;
  text-align: center;
  font-size: 11px;
}

.ribbone1 {
  position: absolute;
  inset-block-start: -6.1px;
  inset-inline-start: 10px;
  z-index: 1;
}
.ribbone1:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-inline-start: 20px solid transparent;
  border-inline-end: 24px solid transparent;
  border-block-start: 13px solid #FC0027;
}
.ribbone1 span {
  position: relative;
  display: block;
  text-align: center;
  background: #FC0027;
  font-size: 14px;
  line-height: 1;
  padding: 12px 8px 10px;
  border-start-end-radius: 8px;
}
.ribbone1 span:after {
  position: absolute;
  content: "";
  height: 6px;
  width: 8px;
  inset-inline-start: -8px;
  inset-block-start: 0;
  border-radius: 8px 8px 0 0;
  background: #FC0027;
}
.ribbone1 span:before {
  position: absolute;
  content: "";
  height: 6px;
  width: 6px;
  inset-inline-start: -6px;
  inset-block-start: 0;
  background: #FC0027;
}

.arrow-ribbone-left {
  color: #FFF;
  padding: 2px 8px;
  position: absolute;
  inset-block-start: 10px;
  inset-inline-start: 0;
  z-index: 6;
  font-size: 13px;
}

.arrow-ribbone-left.bg-purple:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -12px;
  border-block-start: 12px solid transparent;
  border-inline-start: 12px solid #4A00E5;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-left.bg-danger:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -12px;
  border-block-start: 112px solid transparent;
  border-inline-start: 12px solid #FC0027;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-left.bg-primary:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -12px;
  border-block-start: 12px solid transparent;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-left.bg-secondary:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -12px;
  border-block-start: 12px solid transparent;
  border-inline-start: 12px solid #FFA201;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-left.bg-success:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -12px;
  border-block-start: 12px solid transparent;
  border-inline-start: 12px solid #E41F07;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-left.bg-info:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -12px;
  border-block-start: 12px solid transparent;
  border-inline-start: 12px solid #1ECBE2;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-left.bg-warning:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -12px;
  border-block-start: 12px solid transparent;
  border-inline-start: 12px solid #FDA700;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-left.bg-pink:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -12px;
  border-block-start: 12px solid transparent;
  border-inline-start: 12px solid #EA00B7;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-left.bg-teal:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-inline-end: 12px solid #02a8b5;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-right {
  color: #FFF;
  padding: 2px 8px;
  position: absolute;
  inset-block-start: 10px;
  inset-inline-end: 0;
  z-index: 6;
  font-size: 13px;
}

.arrow-ribbone-right.bg-purple:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-inline-end: 12px solid #4A00E5;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-right.bg-danger:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-inline-end: 12px solid #FC0027;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-right.bg-primary:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-right.bg-secondary:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-inline-end: 12px solid #FFA201;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-right.bg-success:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-inline-end: 12px solid #E41F07;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-right.bg-info:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-inline-end: 12px solid #1ECBE2;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-right.bg-warning:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-inline-end: 12px solid #FDA700;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-right.bg-pink:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-inline-end: 12px solid #EA00B7;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-right.bg-teal:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-inline-end: 12px solid #02a8b5;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone2 {
  color: #FFF;
  padding: 3px 8px;
  position: absolute;
  inset-block-start: 10px;
  inset-inline-start: -1px;
  z-index: 6;
  font-size: 30px;
}
.arrow-ribbone2:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -24px;
  border-block-start: 24px solid transparent;
  border-block-end: 24px solid transparent;
  width: 0;
}

.power-ribbone {
  width: 56px;
  height: 56px;
  overflow: hidden;
  position: absolute;
  z-index: 6;
}
.power-ribbone span {
  position: absolute;
  display: block;
  width: 82px;
  padding: 8px 0;
  color: #FFF;
  font: 500 16px/1 Lato, sans-serif;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  text-transform: capitalize;
  text-align: center;
}

.power-ribbone-top-left {
  inset-block-start: -6px;
  inset-inline-start: -9px;
}
.power-ribbone-top-left span {
  inset-inline-end: -5px;
  inset-block-start: 1px;
  transform: rotate(-45deg);
}
.power-ribbone-top-left span i {
  transform: rotate(45deg);
  padding-block-start: 2px;
  padding-inline-start: 7px;
}

.power-ribbone-bottom-left {
  inset-block-end: -6px;
  inset-inline-start: -9px;
}
.power-ribbone-bottom-left span {
  inset-inline-end: -5px;
  inset-block-end: 1px;
  transform: rotate(45deg);
}
.power-ribbone-bottom-left span i {
  transform: rotate(-45deg);
  padding-block-end: 2px;
  padding-inline-start: 7px;
}

.power-ribbone-top-right {
  inset-block-start: -6px;
  inset-inline-end: -9px;
}
.power-ribbone-top-right span {
  inset-inline-start: -5px;
  inset-block-start: 1px;
  transform: rotate(45deg);
}
.power-ribbone-top-right span i {
  transform: rotate(-45deg);
  padding-block-start: 2px;
  padding-inline-end: 7px;
}

.power-ribbone-bottom-right {
  inset-block-end: -6px;
  inset-inline-end: -9px;
}
.power-ribbone-bottom-right span {
  inset-inline-start: -5px;
  inset-block-end: 1px;
  transform: rotate(-45deg);
}
.power-ribbone-bottom-right span i {
  transform: rotate(45deg);
  padding-block-end: 2px;
  padding-inline-end: 7px;
}

.ribbone-top-left {
  inset-block-start: -10px;
  inset-inline-start: -10px;
}
.ribbone-top-left::after {
  border-block-start-color: transparent;
  border-inline-start-color: transparent;
  inset-block-end: 50px;
  inset-inline-start: 0;
}
.ribbone-top-left::before {
  border-block-start-color: transparent;
  border-inline-start-color: transparent;
  inset-block-start: 0;
  inset-inline-end: 50px;
}
.ribbone-top-left span {
  inset-inline-end: 0px;
  inset-block-start: 24px;
  transform: rotate(-45deg);
}

.ribbone-top-right {
  inset-block-start: -10px;
  inset-inline-end: -10px;
}
.ribbone-top-right::after {
  border-block-start-color: transparent;
  border-inline-end-color: transparent;
  inset-block-end: 50px;
  inset-inline-end: 0;
}
.ribbone-top-right::before {
  border-block-start-color: transparent;
  border-inline-end-color: transparent;
  inset-block-start: 0;
  inset-inline-start: 50px;
}
.ribbone-top-right span {
  inset-inline-start: 0px;
  inset-block-start: 24px;
  transform: rotate(45deg);
}

.ribbone-warning-right {
  position: absolute;
  inset-block-start: -8px;
  inset-inline-end: 10px;
  color: #FFF;
}
.ribbone-warning-right:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-inline-start: 17px solid transparent;
  border-inline-end: 17px solid transparent;
  border-block-start: 10px solid #FDA700;
  z-index: 6;
}
.ribbone-warning-right span {
  position: relative;
  display: block;
  text-align: center;
  background: #FDA700;
  font-size: 13px;
  line-height: 1;
  padding: 10px 2px 5px;
  border-start-end-radius: 10px;
  z-index: 6;
}
.ribbone-warning-right span:after {
  position: absolute;
  content: "";
  inset-inline-end: -6px;
  background: #FDA700;
  height: 6px;
  width: 10px;
  inset-inline-start: -9px;
  inset-block-start: 0;
  border-start-start-radius: 50px;
  border-start-end-radius: 0;
  border-end-start-radius: 0;
  border-end-end-radius: 0;
}
.ribbone-warning-right span:before {
  position: absolute;
  content: "";
  height: 5px;
  width: 10px;
  inset-inline-start: -9px;
  inset-block-start: 3px;
  background: #FDA700;
}
.ribbone-warning-right i {
  color: #FFF;
  font-size: 16px;
  padding-inline-start: 7px;
  padding-inline-end: 7px;
}

.ribbone-danger-right {
  position: absolute;
  inset-block-start: -8px;
  inset-inline-end: 10px;
  color: #FFF;
}
.ribbone-danger-right:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-inline-start: 17px solid transparent;
  border-inline-end: 17px solid transparent;
  border-block-start: 10px solid #FC0027;
  z-index: 6;
}
.ribbone-danger-right span {
  position: relative;
  display: block;
  text-align: center;
  background: #FC0027;
  font-size: 13px;
  line-height: 1;
  padding: 10px 2px 5px;
  border-start-end-radius: 10px;
  z-index: 6;
}
.ribbone-danger-right span:after {
  position: absolute;
  content: "";
  inset-inline-end: -6px;
  background: #FC0027;
  height: 6px;
  width: 10px;
  inset-inline-start: -9px;
  inset-block-start: 0;
  border-start-start-radius: 50px;
  border-start-end-radius: 0;
  border-end-start-radius: 0;
  border-end-end-radius: 0;
}
.ribbone-danger-right span:before {
  position: absolute;
  content: "";
  height: 5px;
  width: 10px;
  inset-inline-start: -9px;
  inset-block-start: 3px;
  background: #FC0027;
}
.ribbone-danger-right i {
  color: #FFF;
  font-size: 16px;
  padding-inline-start: 7px;
  padding-inline-end: 7px;
}

.ribbone-success-left {
  position: absolute;
  inset-block-start: -8px;
  inset-inline-start: 10px;
  color: #FFF;
}
.ribbone-success-left:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-inline-start: 17px solid transparent;
  border-inline-end: 17px solid transparent;
  border-block-start: 10px solid #5CB85C;
  z-index: 6;
}
.ribbone-success-left span {
  position: relative;
  display: block;
  text-align: center;
  background: #5CB85C;
  font-size: 13px;
  line-height: 1;
  padding: 10px 2px 5px;
  border-start-start-radius: 10px;
  z-index: 6;
}
.ribbone-success-left span:after {
  position: absolute;
  content: "";
  inset-inline-end: -6px;
  background: #5CB85C;
  height: 6px;
  width: 10px;
  inset-inline-end: -9px;
  inset-block-start: 0;
  border-start-start-radius: 0;
  border-start-end-radius: 50px;
  border-end-start-radius: 0;
  border-end-end-radius: 0;
}
.ribbone-success-left span:before {
  position: absolute;
  content: "";
  height: 5px;
  width: 10px;
  inset-inline-end: -9px;
  inset-block-start: 3px;
  background: #5CB85C;
}
.ribbone-success-left i {
  color: #FFF;
  font-size: 16px;
  padding-inline-start: 7px;
  padding-inline-end: 7px;
}

.ribbone-info-left {
  position: absolute;
  inset-block-start: -8px;
  inset-inline-start: 10px;
  color: #FFF;
}
.ribbone-info-left:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-inline-start: 17px solid transparent;
  border-inline-end: 17px solid transparent;
  border-block-start: 10px solid #1ECBE2;
  z-index: 6;
}
.ribbone-info-left span {
  position: relative;
  display: block;
  text-align: center;
  background: #1ECBE2;
  font-size: 13px;
  line-height: 1;
  padding: 10px 2px 5px;
  border-start-start-radius: 10px;
  z-index: 6;
}
.ribbone-info-left span:after {
  position: absolute;
  content: "";
  inset-inline-end: -6px;
  background: #1ECBE2;
  height: 6px;
  width: 10px;
  inset-inline-end: -9px;
  inset-block-start: 0;
  border-start-start-radius: 0;
  border-start-end-radius: 50px;
  border-end-start-radius: 0;
  border-end-end-radius: 0;
}
.ribbone-info-left span:before {
  position: absolute;
  content: "";
  height: 5px;
  width: 10px;
  inset-inline-end: -9px;
  inset-block-start: 3px;
  background: #1ECBE2;
}
.ribbone-info-left i {
  color: #FFF;
  font-size: 16px;
  padding-inline-start: 7px;
  padding-inline-end: 7px;
}

.bookmark-ribbone-success-left {
  position: absolute;
  inset-inline-start: 10px;
  color: #FFF;
}
.bookmark-ribbone-success-left:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  z-index: 6;
  inset-inline-start: 0;
  border-inline-start: 18px solid #5CB85C;
  border-inline-end: 18px solid #5CB85C;
  border-block-end: 10px solid transparent;
}
.bookmark-ribbone-success-left span {
  position: relative;
  display: block;
  text-align: center;
  background: #5CB85C;
  font-size: 13px;
  line-height: 1;
  padding: 12px 3px 20px;
  z-index: 6;
}
.bookmark-ribbone-success-left i {
  color: #FFF;
  font-size: 16px;
  padding-inline-start: 7px;
  padding-inline-end: 7px;
}

.bookmark-ribbone-danger-left {
  position: absolute;
  inset-inline-start: 10px;
  color: #FFF;
  width: 30px;
}
.bookmark-ribbone-danger-left:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  z-index: 6;
  inset-inline-start: 0;
  border-inline-start: 15px solid #FC0027;
  border-inline-end: 15px solid #FC0027;
  border-block-end: 8px solid transparent;
}
.bookmark-ribbone-danger-left span {
  position: relative;
  display: block;
  text-align: center;
  background: #FC0027;
  font-size: 12px;
  line-height: 1;
  padding: 12px 0px;
  z-index: 6;
}
.bookmark-ribbone-danger-left i {
  color: #FFF;
  font-size: 16px;
  padding-inline-start: 7px;
  padding-inline-end: 7px;
}

.bookmark-ribbone-secondary-right {
  position: absolute;
  inset-inline-end: 10px;
  color: #FFF;
  width: 30px;
}
.bookmark-ribbone-secondary-right:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  z-index: 6;
  inset-inline-end: 0;
  border-inline-start: 15px solid #FFA201;
  border-inline-end: 15px solid #FFA201;
  border-block-end: 8px solid transparent;
}
.bookmark-ribbone-secondary-right span {
  position: relative;
  display: block;
  text-align: center;
  background: #FFA201;
  font-size: 11px;
  line-height: 1;
  padding: 12px 0px;
  z-index: 6;
}
.bookmark-ribbone-secondary-right i {
  color: #FFF;
  font-size: 16px;
  padding-inline-start: 7px;
  padding-inline-end: 7px;
}

.bookmark-sideleft-ribbone-success-left {
  position: absolute;
  inset-block-start: 10px;
  color: #FFF;
}
.bookmark-sideleft-ribbone-success-left:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  z-index: 6;
  inset-block-start: 0;
  inset-inline-end: -8px;
  border-block-start: 13px solid #5CB85C;
  border-block-end: 13px solid #5CB85C;
  border-inline-end: 8px solid transparent;
}
.bookmark-sideleft-ribbone-success-left span {
  position: relative;
  display: block;
  text-align: center;
  background: #5CB85C;
  font-size: 11px;
  padding: 5px 13px;
  z-index: 6;
  height: 26px;
}
.bookmark-sideleft-ribbone-success-left i {
  color: #FFF;
  font-size: 16px;
  padding-inline-start: 7px;
  padding-inline-end: 7px;
}

.bookmark-sideright-ribbone-primary-right {
  position: absolute;
  inset-block-start: 10px;
  inset-inline-end: 0;
  color: #FFF;
}
.bookmark-sideright-ribbone-primary-right:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  z-index: 6;
  inset-block-start: 0;
  inset-inline-start: -8px;
  border-block-start: 13px solid #E41F07;
  border-block-end: 13px solid #E41F07;
  border-inline-start: 8px solid transparent;
}
.bookmark-sideright-ribbone-primary-right span {
  position: relative;
  display: block;
  text-align: center;
  background: #E41F07;
  font-size: 11px;
  padding: 5px 13px;
  z-index: 6;
  height: 26px;
}
.bookmark-sideright-ribbone-primary-right i {
  color: #FFF;
  font-size: 16px;
  padding-inline-start: 7px;
  padding-inline-end: 7px;
}

.ribbone-1 span:after {
  position: absolute;
  content: "";
}

.arrow-ribbone-2 {
  color: #FFF;
  padding: 3px 8px;
  position: absolute;
  z-index: 6;
  font-size: 20px;
}
.arrow-ribbone-2:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -24px;
  border-block-start: 16px solid transparent;
  border-inline-start: 24px solid #4A00E5;
  border-block-end: 16px solid transparent;
  width: 0;
}

.ribbone-card {
  overflow: hidden;
}

.fullwidth-primary-ribbons .bar {
  color: #FFF;
  background-color: #E41F07;
  padding: 5px;
  text-align: center;
  position: relative;
  border: 2px transparent solid;
  box-shadow: 0 10px 30px -10px #FDFDFE;
}
.fullwidth-primary-ribbons .bar span {
  position: absolute;
}
.fullwidth-primary-ribbons .bar span:nth-child(1) {
  border-style: solid;
  border-width: 11px;
  z-index: -1;
  border-color: transparent;
  inset-block-start: 31px;
  inset-inline-start: -2px;
}
.fullwidth-primary-ribbons .bar span:nth-child(3) {
  border-style: solid;
  border-width: 11px;
  z-index: -1;
  border-color: transparent;
  inset-block-start: 31px;
  inset-inline-end: -2px;
}
.fullwidth-primary-ribbons .bar span:nth-child(2) {
  inset-block-start: 18px;
  border-style: solid;
  border-width: 18px;
  z-index: -2;
  border-color: #E41F07 #E41F07 #E41F07 transparent;
  border-block-start-color: #E41F07;
  border-inline-end-color: #E41F07;
  border-block-end-color: #E41F07;
  border-inline-start-color: transparent;
  inset-inline-start: -30px;
}
.fullwidth-primary-ribbons .bar span:nth-child(4) {
  inset-block-start: 18px;
  border-style: solid;
  border-width: 18px;
  z-index: -2;
  border-block-start-color: #E41F07;
  border-inline-end-color: transparent;
  border-block-end-color: #E41F07;
  border-inline-start-color: #E41F07;
  inset-inline-end: -30px;
}

.fullwidth-secondary-ribbons .bar {
  color: #FFF;
  background-color: #FFA201;
  padding: 5px;
  text-align: center;
  position: relative;
  border: 2px transparent solid;
  box-shadow: 0 10px 30px -10px #FDFDFE;
}
.fullwidth-secondary-ribbons .bar span {
  position: absolute;
}
.fullwidth-secondary-ribbons .bar span:nth-child(1) {
  border-style: solid;
  border-width: 11px;
  z-index: -1;
  border-color: transparent;
  inset-block-start: 31px;
  inset-inline-start: -2px;
}
.fullwidth-secondary-ribbons .bar span:nth-child(3) {
  border-style: solid;
  border-width: 11px;
  z-index: -1;
  border-color: transparent;
  inset-block-start: 31px;
  inset-inline-end: -2px;
}
.fullwidth-secondary-ribbons .bar span:nth-child(2) {
  inset-block-start: 18px;
  border-style: solid;
  border-width: 18px;
  z-index: -2;
  border-block-start-color: #FFA201;
  border-inline-end-color: #FFA201;
  border-block-end-color: #FFA201;
  border-inline-start-color: transparent;
  inset-inline-start: -30px;
}
.fullwidth-secondary-ribbons .bar span:nth-child(4) {
  inset-block-start: 18px;
  border-style: solid;
  border-width: 18px;
  z-index: -2;
  border-block-start-color: #FFA201;
  border-inline-end-color: transparent;
  border-block-end-color: #FFA201;
  border-inline-start-color: #FFA201;
  inset-inline-end: -30px;
}

.fullwidth-arrow-warning-ribbons .bar {
  color: #FFF;
  background-color: #FDA700;
  padding: 5px;
  text-align: center;
  position: relative;
  border: 2px transparent solid;
  box-shadow: 0 10px 30px -10px #FDFDFE;
}
.fullwidth-arrow-warning-ribbons .bar span {
  position: absolute;
}
.fullwidth-arrow-warning-ribbons .bar span:nth-child(1) {
  border-style: solid;
  border-width: 11px;
  z-index: -1;
  border-color: transparent;
  inset-block-start: 31px;
  inset-inline-start: -2px;
}
.fullwidth-arrow-warning-ribbons .bar span:nth-child(3) {
  border-style: solid;
  border-width: 11px;
  z-index: -1;
  border-color: transparent;
  inset-block-start: 31px;
  inset-inline-end: -2px;
}
.fullwidth-arrow-warning-ribbons .bar span:nth-child(2) {
  inset-block-start: 18px;
  border-style: solid;
  border-width: 18px;
  z-index: -2;
  border-block-start-color: #FDA700;
  border-inline-end-color: #FDA700;
  border-block-end-color: #FDA700;
  border-inline-start-color: transparent;
  inset-inline-start: -30px;
}
.fullwidth-arrow-warning-ribbons .bar span:nth-child(4) {
  inset-block-start: 18px;
  border-style: solid;
  border-width: 18px;
  z-index: -2;
  border-block-start: 18px solid transparent;
  border-inline-start: 18px solid #FDA700;
  border-block-end: 18px solid transparent;
  border-inline-end: transparent;
  inset-inline-end: -20px;
  inset-block-start: -2px;
}

.fullwidth-arrow-danger-ribbons-right .bar {
  color: #FFF;
  background-color: #FC0027;
  padding: 5px;
  text-align: center;
  position: relative;
  border: 2px transparent solid;
  box-shadow: 0 10px 30px -10px #FDFDFE;
}
.fullwidth-arrow-danger-ribbons-right .bar span {
  position: absolute;
}
.fullwidth-arrow-danger-ribbons-right .bar span:nth-child(1) {
  border-style: solid;
  border-width: 11px;
  z-index: -1;
  border-color: transparent;
  inset-block-start: 31px;
  inset-inline-end: -2px;
}
.fullwidth-arrow-danger-ribbons-right .bar span:nth-child(3) {
  border-style: solid;
  border-width: 11px;
  z-index: -1;
  border-color: transparent;
  inset-block-start: 31px;
  inset-inline-start: -2px;
}
.fullwidth-arrow-danger-ribbons-right .bar span:nth-child(2) {
  inset-block-start: 18px;
  border-style: solid;
  border-width: 18px;
  z-index: -2;
  border-block-start-color: #FC0027;
  border-inline-end-color: transparent;
  border-block-end-color: #FC0027;
  border-inline-start-color: #FC0027;
  inset-inline-end: -30px;
}
.fullwidth-arrow-danger-ribbons-right .bar span:nth-child(4) {
  inset-block-start: 18px;
  border-style: solid;
  border-width: 18px;
  z-index: -2;
  border-block-start: 18px solid transparent;
  border-inline-end: 18px solid #FC0027;
  border-block-end: 18px solid transparent;
  border-inline-start: transparent;
  inset-inline-start: -20px;
  inset-block-start: -2px;
}

.power-ribbone span svg {
  width: 15px;
  height: 15px;
}

.ribbone-card .card-body {
  padding: 25px;
}

.ribbone-row .feather-zap {
  width: 15px;
  height: 15px;
}

[data-bs-toggle=card-fullscreen] svg {
  width: 15px;
  height: 15px;
}

[data-bs-toggle=card-remove] svg {
  width: 15px;
  height: 15px;
}

svg.collapse-open, svg.collapse-close {
  width: 15px;
  height: 15px;
}

.btn-icon.btn-danger-light {
  color: #FC1A3D;
  background: #FFEEEC;
}

.live-rating.badge {
  background: #E0F5D7;
  color: #6CBF6C;
}

@media (min-width: 576px) {
  .mx-sm-7 {
    margin-inline: 3rem !important;
  }
}
[dir=rtl] .power-ribbone-top-left span {
  transform: rotate(45deg);
}
[dir=rtl] .power-ribbone-top-left span i {
  transform: rotate(-45deg);
}
[dir=rtl] .power-ribbone-bottom-left span {
  transform: rotate(-45deg);
}
[dir=rtl] .power-ribbone-bottom-left span i {
  transform: rotate(45deg);
}
[dir=rtl] .power-ribbone-top-right span {
  transform: rotate(-45deg);
}
[dir=rtl] .power-ribbone-top-right span i {
  transform: rotate(45deg);
}
[dir=rtl] .power-ribbone-bottom-right span {
  transform: rotate(45deg);
}
[dir=rtl] .power-ribbone-bottom-right span i {
  transform: rotate(-45deg);
}
[dir=rtl] .ribbone-top-left span {
  transform: rotate(45deg);
}
[dir=rtl] .ribbone-top-right span {
  transform: rotate(-45deg);
}
[dir=rtl] .ribbon-price .badge {
  transform: rotate(-45deg);
}

.modal-barcode ul {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  flex-wrap: wrap;
}
.modal-barcode ul li {
  border-radius: 7px;
  width: 25%;
  margin-bottom: 10px;
  padding: 0 5px;
}
@media (max-width: 991.98px) {
  .modal-barcode ul li {
    width: 50%;
  }
}
.modal-barcode ul li a {
  border: 1px solid #6F6F6F;
  border-radius: 10px;
  display: block;
  padding: 10px;
  text-align: center;
}

.modal .modal-content {
  border: 1px solid #E8E8E8;
  box-shadow: 0px 4px 74px 0px rgba(208, 208, 208, 0.2509803922);
  border-radius: 5px;
}
.modal .modal-title {
  font-weight: 700;
}
@media (max-width: 991.98px) {
  .modal .modal-title {
    font-size: 16px;
  }
}
.modal .logo-lg img {
  width: 150px;
}
.modal .modal-header {
  border-color: #E8E8E8;
  border-bottom: 1px solid #E8E8E8;
  justify-content: space-between;
}
.modal .modal-header .close,
.modal .modal-header .btn-close {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #FD4D68;
  opacity: 1;
  font-size: 12px;
  width: 22px;
  height: 22px;
  border: 0;
  font-weight: 700;
  background-color: transparent;
  border-radius: 50px;
}
.modal .modal-header .close:hover,
.modal .modal-header .btn-close:hover {
  background-color: transparent;
  color: #FFF;
}
.modal .modal-footer .btn-print {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border: 1px solid #E41F07;
  color: #E41F07;
}
.modal .modal-footer .btn-print img {
  margin-left: 10px;
}
.modal .modal-footer .btn-print:hover {
  background: #E41F07;
  color: #FFF;
}
.modal .modal-footer .btn-print:hover img {
  filter: brightness(0) invert(1);
}
.modal .modal-footer .btn-secondary {
  background: #FFA201;
}
.modal .modal-footer .btn-secondary:hover {
  box-shadow: inset 0 0px 0px 100px #FFF;
  color: #FFA201 !important;
}
.modal .modal-dialog.right-slider-modal {
  margin: 0;
  margin-left: auto;
  max-width: 1102px;
}
.modal .modal-dialog.add-centered {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  max-width: 1192px;
}
.modal .modal-dialog.sales-details-modal {
  max-width: 1192px;
}
.modal .modal-dialog.edit-sales-modal {
  max-width: 1192px;
}
.modal .edit-add.card.edit-expense {
  border: 1px solid rgba(0, 0, 0, 0.2);
}
.modal .note-editor.note-frame.card {
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
}

.offcanvas.offcanvas-end {
  width: auto !important;
}

.offcanvas.offcanvas-end.em-payrol-add {
  max-width: 1192px !important;
}

.modal.animated .modal-dialog {
  transform: translate(0, 0);
}
.modal.effect-scale .modal-dialog {
  transform: scale(0.7);
  opacity: 0;
  transition: all 0.3s;
}
.modal.effect-scale.show .modal-dialog {
  transform: scale(1);
  opacity: 1;
}
.modal.effect-slide-in-right .modal-dialog {
  transform: translateX(20%);
  opacity: 0;
  transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
}
.modal.effect-slide-in-right.show .modal-dialog {
  transform: translateX(0);
  opacity: 1;
}
.modal.effect-slide-in-bottom .modal-dialog {
  transform: translateY(20%);
  opacity: 0;
  transition: all 0.3s;
}
.modal.effect-slide-in-bottom.show .modal-dialog {
  transform: translateY(0);
  opacity: 1;
}
.modal.effect-newspaper .modal-dialog {
  transform: scale(0) rotate(720deg);
  opacity: 0;
}
.modal.effect-newspaper.show ~ .modal-backdrop, .modal.effect-newspaper .modal-dialog {
  transition: all 0.5s;
}
.modal.effect-newspaper.show .modal-dialog {
  transform: scale(1) rotate(0deg);
  opacity: 1;
}
.modal.effect-fall {
  perspective: 1300px;
}
.modal.effect-fall .modal-dialog {
  transform-style: preserve-3d;
  transform: translateZ(600px) rotateX(20deg);
  opacity: 0;
}
.modal.effect-fall.show .modal-dialog {
  transition: all 0.3s ease-in;
  transform: translateZ(0px) rotateX(0deg);
  opacity: 1;
}
.modal.effect-flip-horizontal {
  perspective: 1300px;
}
.modal.effect-flip-horizontal .modal-dialog {
  transform-style: preserve-3d;
  transform: rotateY(-70deg);
  transition: all 0.3s;
  opacity: 0;
}
.modal.effect-flip-horizontal.show .modal-dialog {
  transform: rotateY(0deg);
  opacity: 1;
}
.modal.effect-flip-vertical {
  perspective: 1300px;
}
.modal.effect-flip-vertical .modal-dialog {
  transform-style: preserve-3d;
  transform: rotateX(-70deg);
  transition: all 0.3s;
  opacity: 0;
}
.modal.effect-flip-vertical.show .modal-dialog {
  transform: rotateX(0deg);
  opacity: 1;
}
.modal.effect-super-scaled .modal-dialog {
  transform: scale(2);
  opacity: 0;
  transition: all 0.3s;
}
.modal.effect-super-scaled.show .modal-dialog {
  transform: scale(1);
  opacity: 1;
}
.modal.effect-sign {
  perspective: 1300px;
}
.modal.effect-sign .modal-dialog {
  transform-style: preserve-3d;
  transform: rotateX(-60deg);
  transform-origin: 50% 0;
  opacity: 0;
  transition: all 0.3s;
}
.modal.effect-sign.show .modal-dialog {
  transform: rotateX(0deg);
  opacity: 1;
}
.modal.effect-rotate-bottom {
  perspective: 1300px;
}
.modal.effect-rotate-bottom .modal-dialog {
  transform-style: preserve-3d;
  transform: translateY(100%) rotateX(90deg);
  transform-origin: 0 100%;
  opacity: 0;
  transition: all 0.3s ease-out;
}
.modal.effect-rotate-bottom.show .modal-dialog {
  transform: translateY(0%) rotateX(0deg);
  opacity: 1;
}
.modal.effect-rotate-left {
  perspective: 1300px;
}
.modal.effect-rotate-left .modal-dialog {
  transform-style: preserve-3d;
  transform: translateZ(100px) translateX(-30%) rotateY(90deg);
  transform-origin: 0 100%;
  opacity: 0;
  transition: all 0.3s;
}
.modal.effect-rotate-left.show .modal-dialog {
  transform: translateZ(0px) translateX(0%) rotateY(0deg);
  opacity: 1;
}

.offcanvas-end.offcanvas-large {
  width: 700px !important;
}

.modal {
  z-index: 1050 !important;
}

.modal-backdrop {
  z-index: 1001 !important;
}

.status-toggle.small-toggle-btn {
  float: unset;
}
.status-toggle.small-toggle-btn .label-text {
  color: #6F6F6F;
  font-size: 14px;
  font-weight: 400;
}
.status-toggle.small-toggle-btn .checktoggle {
  width: 24px;
  height: 12px;
}
.status-toggle.small-toggle-btn .checktoggle:after {
  width: 8px;
  height: 8px;
}
.status-toggle.small-toggle-btn .check:checked + .checktoggle:after {
  right: 0;
  width: 8px;
  height: 8px;
}
.status-toggle .check {
  display: block;
  height: 0;
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  margin: 0;
  padding: 0;
}
.status-toggle .check:checked + .checktoggle:after {
  left: 100%;
  transform: translate(calc(-100% - 3px), -50%);
  right: 0;
  width: 10px;
  height: 10px;
}
.status-toggle .check:checked + .checktoggle {
  background: #1ABE17;
}
.status-toggle .checktoggle {
  background: #CDCDCD;
  cursor: pointer;
  display: block;
  font-size: 0;
  margin-bottom: 0;
  position: relative;
  border-radius: 12px;
  width: 30px;
  height: 14px;
}
.status-toggle .checktoggle:after {
  content: " ";
  display: block;
  width: 10px;
  height: 10px;
  background-color: #FFF;
  transition: all 0.2s ease;
  transform: translate(3px, -50%);
  -webkit-transform: translate(3px, -50%);
  -ms-transform: translate(3px, -50%);
  position: absolute;
  top: 50%;
  left: 0;
  border-radius: 50%;
}

.modal-btn .btn {
  margin: 0 10px 0 0;
  padding: 7px 15px;
}
.modal-btn .btn:last-child {
  margin-right: 0;
}

.custom-modal .modal-header .btn-close {
  margin: 0;
  padding: 0;
  background: #FFF;
  border: 1px solid #E8E8E8;
  border-radius: 50%;
  color: #6F6F6F;
  font-weight: 400;
  font-size: 14px;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
  height: 26px;
  width: 26px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  transition: all 0.7s;
}
.custom-modal .modal-header .btn-close:hover {
  border: 1px solid #E41F07;
  background: #E41F07;
  color: #FFF;
  transition: all 0.7s;
  transform: rotateZ(360deg);
}

.grid-showcase {
  margin-bottom: -10px;
}
.grid-showcase span, .grid-showcase .grid-wrapper {
  display: block;
  padding: 10px;
  margin-bottom: 10px;
  text-align: center;
  background-color: rgba(242, 243, 247, 0.7);
}

.grid-align {
  margin-bottom: -16px;
}

.grid-align .row {
  padding: 15px 0;
  min-height: 7rem;
  margin-bottom: 16px;
}

.grid-vertical {
  min-height: 150px;
  padding: 10px;
  color: #000;
}

table.table-bordered thead tr th p {
  margin-bottom: 0;
}

/******* Base *******/
body {
  font-family: "Noto Sans", sans-serif;
  font-size: 14px;
  color: #6F6F6F;
  line-height: 1.5;
  background-color: #F9F9FC;
  overflow-y: auto;
  overflow-x: hidden;
}

html {
  font-family: "Noto Sans", sans-serif;
}

::selection {
  background: #E41F07;
  color: #FFF;
  text-shadow: none;
}

img {
  max-width: 100%;
  height: auto;
  vertical-align: inherit;
}

* {
  outline: none;
}

button {
  transition: all 0.5s ease;
}
button:focus {
  box-shadow: none !important;
}

p {
  margin-bottom: 20px;
}
p:last-child {
  margin-bottom: 0;
}

strong {
  font-weight: 700;
}

h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6 {
  color: #262A2A;
  font-family: "Noto Sans", sans-serif;
  font-weight: 700;
  margin-bottom: 0;
}

ol, ul {
  list-style: none;
  margin-block-end: 0;
  padding: 0;
}

ul {
  list-style: none;
}
ul.list-disc {
  list-style: disc;
  padding-left: 15px;
}
ul.list-disc ul {
  list-style-type: circle;
}
ul.list-decimal {
  list-style: decimal;
  padding-left: 15px;
}
ul.list-decimal ul {
  list-style-type: decimal;
}
ul.list-icon {
  list-style: none;
  padding-left: 0;
}
ul.list-icon > li {
  padding-left: 1.875rem;
  counter-increment: li;
}
ul.list-icon > li i,
ul.list-icon > li .feather-icon,
ul.list-icon > li .svg-icon {
  display: inline-block;
  height: 20px;
  width: 20px;
  text-align: center;
  margin-left: -1.25rem;
  position: relative;
  left: -10px;
  padding: 1px;
  top: -1px;
}
ul.list-icon > li i {
  font-size: 20px;
  top: 5px;
}
ul .btn-primary:not(:disabled):not(.disabled):active:focus, ul .btn-primary:not(:disabled):not(.disabled).active:focus {
  box-shadow: none;
}

.bg-primary {
  background-color: #E41F07 !important;
}

.bg-secondary {
  background-color: #FFA201 !important;
}

.bg-info {
  background-color: #1ECBE2 !important;
}

.bg-success {
  background-color: #5CB85C !important;
  color: #FFF !important;
}

.bg-warning {
  background-color: #FDA700 !important;
  color: #FFF !important;
}

.bg-danger {
  background-color: #FC0027 !important;
  color: #FFF !important;
}

.bg-dark {
  background-color: #171724 !important;
}

.bg-light {
  background-color: #FDFDFE !important;
}

.bg-light-300 {
  background-color: #F6F6F6 !important;
}

.bg-light-400 {
  background: #F5F5F5;
}

.bg-light-600 {
  background-color: #F4F4F4 !important;
}

.bg-white {
  background-color: #FFF !important;
}

.bg-pink {
  background-color: #EA00B7 !important;
}

.bg-purple {
  background-color: #4A00E5 !important;
}

.bg-teal {
  background-color: #02a8b5 !important;
}

.bg-blue {
  background-color: #339DFF !important;
}

.bg-tertiary {
  background-color: #3C2371 !important;
}

.bg-violet {
  background-color: #676DFF !important;
}

.bg-green {
  background-color: #00918E !important;
}

.bg-gray {
  background: #E0E2E7;
}

.bg-primary {
  background-color: #E41F07 !important;
}
.bg-primary.bg-opacity-10 {
  background-color: rgba(228, 31, 7, 0.1) !important;
}
.bg-primary.bg-opacity-25 {
  background-color: rgba(228, 31, 7, 0.25) !important;
}
.bg-primary.bg-opacity-50 {
  background-color: rgba(228, 31, 7, 0.5) !important;
}
.bg-primary.bg-opacity-75 {
  background-color: rgba(228, 31, 7, 0.75) !important;
}
.bg-primary.bg-opacity-100 {
  background-color: #e41f07 !important;
}

.bg-secondary {
  background-color: #FFA201 !important;
}
.bg-secondary.bg-opacity-10 {
  background-color: rgba(255, 162, 1, 0.1) !important;
}
.bg-secondary.bg-opacity-25 {
  background-color: rgba(255, 162, 1, 0.25) !important;
}
.bg-secondary.bg-opacity-50 {
  background-color: rgba(255, 162, 1, 0.5) !important;
}
.bg-secondary.bg-opacity-75 {
  background-color: rgba(255, 162, 1, 0.75) !important;
}
.bg-secondary.bg-opacity-100 {
  background-color: #ffa201 !important;
}

.bg-info {
  background-color: #1ECBE2 !important;
}
.bg-info.bg-opacity-10 {
  background-color: rgba(30, 203, 226, 0.1) !important;
}
.bg-info.bg-opacity-25 {
  background-color: rgba(30, 203, 226, 0.25) !important;
}
.bg-info.bg-opacity-50 {
  background-color: rgba(30, 203, 226, 0.5) !important;
}
.bg-info.bg-opacity-75 {
  background-color: rgba(30, 203, 226, 0.75) !important;
}
.bg-info.bg-opacity-100 {
  background-color: #1ecbe2 !important;
}

.bg-success {
  background-color: #5CB85C !important;
}
.bg-success.bg-opacity-10 {
  background-color: rgba(92, 184, 92, 0.1) !important;
}
.bg-success.bg-opacity-25 {
  background-color: rgba(92, 184, 92, 0.25) !important;
}
.bg-success.bg-opacity-50 {
  background-color: rgba(92, 184, 92, 0.5) !important;
}
.bg-success.bg-opacity-75 {
  background-color: rgba(92, 184, 92, 0.75) !important;
}
.bg-success.bg-opacity-100 {
  background-color: #5cb85c !important;
}

.bg-warning {
  background-color: #FDA700 !important;
}
.bg-warning.bg-opacity-10 {
  background-color: rgba(253, 167, 0, 0.1) !important;
}
.bg-warning.bg-opacity-25 {
  background-color: rgba(253, 167, 0, 0.25) !important;
}
.bg-warning.bg-opacity-50 {
  background-color: rgba(253, 167, 0, 0.5) !important;
}
.bg-warning.bg-opacity-75 {
  background-color: rgba(253, 167, 0, 0.75) !important;
}
.bg-warning.bg-opacity-100 {
  background-color: #fda700 !important;
}

.bg-danger {
  background-color: #FC0027 !important;
}
.bg-danger.bg-opacity-10 {
  background-color: rgba(252, 0, 39, 0.1) !important;
}
.bg-danger.bg-opacity-25 {
  background-color: rgba(252, 0, 39, 0.25) !important;
}
.bg-danger.bg-opacity-50 {
  background-color: rgba(252, 0, 39, 0.5) !important;
}
.bg-danger.bg-opacity-75 {
  background-color: rgba(252, 0, 39, 0.75) !important;
}
.bg-danger.bg-opacity-100 {
  background-color: #fc0027 !important;
}

.bg-dark {
  background-color: #171724 !important;
}
.bg-dark.bg-opacity-10 {
  background-color: rgba(23, 23, 36, 0.1) !important;
}
.bg-dark.bg-opacity-25 {
  background-color: rgba(23, 23, 36, 0.25) !important;
}
.bg-dark.bg-opacity-50 {
  background-color: rgba(23, 23, 36, 0.5) !important;
}
.bg-dark.bg-opacity-75 {
  background-color: rgba(23, 23, 36, 0.75) !important;
}
.bg-dark.bg-opacity-100 {
  background-color: #171724 !important;
}

.bg-light {
  background-color: #FDFDFE !important;
}
.bg-light.bg-opacity-10 {
  background-color: rgba(253, 253, 254, 0.1) !important;
}
.bg-light.bg-opacity-25 {
  background-color: rgba(253, 253, 254, 0.25) !important;
}
.bg-light.bg-opacity-50 {
  background-color: rgba(253, 253, 254, 0.5) !important;
}
.bg-light.bg-opacity-75 {
  background-color: rgba(253, 253, 254, 0.75) !important;
}
.bg-light.bg-opacity-100 {
  background-color: #fdfdfe !important;
}

.bg-primary {
  background-color: #E41F07 !important;
  border: 1px solid #E41F07 !important;
  color: #FFF;
}

.bg-secondary {
  background-color: #FFA201 !important;
  border: 1px solid #FFA201 !important;
  color: #FFF;
}

.bg-success {
  background-color: #5CB85C !important;
  border: 1px solid #5CB85C !important;
  color: #FFF;
}

.bg-info {
  background-color: #1ECBE2 !important;
  border: 1px solid #1ECBE2 !important;
  color: #FFF;
}

.bg-warning {
  background-color: #FDA700 !important;
  border: 1px solid #FDA700 !important;
  color: #FFF;
}

.bg-danger {
  background-color: #FC0027 !important;
  border: 1px solid #FC0027 !important;
  color: #FFF;
}

.bg-dark {
  background-color: #171724 !important;
  border: 1px solid #171724 !important;
  color: #FFF;
}

.bg-light {
  background-color: #FDFDFE !important;
  border: 1px solid #FDFDFE !important;
  color: #FFF;
}

.bg-black {
  background-color: #000 !important;
  border: 1px solid #000 !important;
  color: #FFF;
}

.bg-purple {
  background-color: #4A00E5 !important;
  border: 1px solid #4A00E5 !important;
  color: #FFF;
}

.bg-yellow {
  background-color: #ffff00 !important;
  border: 1px solid #ffff00 !important;
  color: #FFF;
}

.bg-teal {
  background-color: #02a8b5 !important;
  border: 1px solid #02a8b5 !important;
  color: #FFF;
}

.bg-soft-primary {
  background-color: #F7BCB5;
  color: #E41F07;
}

.bg-soft-secondary {
  background-color: #FFE3B3;
  color: #FFA201;
}

.bg-soft-success {
  background-color: #CEEACE;
  color: #5CB85C;
}

.bg-soft-danger {
  background-color: #FEB3BE;
  color: #FC0027;
}

.bg-soft-warning {
  background-color: #FEE5B3;
  color: #FDA700;
}

.bg-soft-info {
  background-color: rgba(30, 203, 226, 0.3);
  color: #1ECBE2;
}

.bg-soft-light {
  background-color: rgba(253, 253, 254, 0.9);
  color: #6F6F6F;
}

.bg-soft-dark {
  background-color: rgba(23, 23, 36, 0.3);
  color: #FFF;
}

.bg-light {
  color: #6F6F6F;
}

.bg-primary-gradient {
  background: linear-gradient(to right, #E41F07 0%, #8e77fa 100%) !important;
  color: #FFF;
}

.bg-secondary-gradient {
  background: linear-gradient(to right, #FFA201 0%, #28b7f9 100%) !important;
  color: #FFF;
}

.bg-warning-gradient {
  background: linear-gradient(to right, #FDA700 0%, #fbc434 100%) !important;
  color: #FFF;
}

.bg-info-gradient {
  background: linear-gradient(to right, #1ECBE2 0%, #00f2fe 100%) !important;
  color: #FFF;
}

.bg-success-gradient {
  background: linear-gradient(to right, #5CB85C 0%, #5cf9e2 100%) !important;
  color: #FFF;
}

.bg-danger-gradient {
  background: linear-gradient(to right, #FC0027 0%, #fd4a68 100%) !important;
  color: #FFF;
}

.bg-orange-gradient {
  background: linear-gradient(to right, #FF9D0A 0%, #FBB034 100%) !important;
  color: #FFF;
}

.bg-purple-gradient {
  background: linear-gradient(to right, #4A00E5 0%, #9b25b7 100%) !important;
  color: #FFF;
}

.bg-teal-gradient {
  background: linear-gradient(to right, #02a8b5 0%, #0695DD 100%) !important;
  color: #FFF;
}

.bg-light-gradient {
  background: linear-gradient(to right, #FDFDFE 0%, #D1D6DE 100%) !important;
  color: #000;
}

.bg-dark-gradient {
  background: linear-gradient(to right, #171724 0%, #54505D 100%) !important;
  color: #FFF;
}

.bg-outline-primary {
  background-color: #FFF;
  border: 1px solid #E41F07;
  color: #E41F07;
}

.bg-outline-secondary {
  background-color: #FFF;
  border: 1px solid #FFA201;
  color: #FFA201;
}

.bg-outline-warning {
  background-color: #FFF;
  border: 1px solid #FDA700;
  color: #FDA700;
}

.bg-outline-info {
  background-color: #FFF;
  border: 1px solid #1ECBE2;
  color: #1ECBE2;
}

.bg-outline-success {
  background-color: #FFF;
  border: 1px solid #5CB85C;
  color: #5CB85C;
}

.bg-outline-danger {
  background-color: #FFF;
  border: 1px solid #FC0027;
  color: #FC0027;
}

.bg-outline-dark {
  background-color: #FFF;
  border: 1px solid #171724;
  color: #171724;
}

.bg-outline-light {
  background-color: #FFF;
  border: 1px solid #FDFDFE !important;
  color: #000 !important;
}

.bg-primary-transparent {
  background-color: rgba(228, 31, 7, 0.1) !important;
  color: #E41F07 !important;
}
.bg-primary-transparent:hover {
  background-color: rgba(228, 31, 7, 0.1) !important;
  color: #E41F07 !important;
}

.bg-secondary-transparent {
  background-color: rgba(255, 162, 1, 0.1) !important;
  color: #FFA201 !important;
}
.bg-secondary-transparent:hover {
  background-color: rgba(255, 162, 1, 0.1) !important;
  color: #FFA201 !important;
}

.bg-info-transparent {
  background-color: rgba(30, 203, 226, 0.1) !important;
  color: #1ECBE2 !important;
}
.bg-info-transparent:hover {
  background-color: rgba(30, 203, 226, 0.1) !important;
  color: #1ECBE2 !important;
}

.bg-success-transparent {
  background-color: rgba(92, 184, 92, 0.1) !important;
  color: #5CB85C !important;
}
.bg-success-transparent:hover {
  background-color: rgba(92, 184, 92, 0.1) !important;
  color: #5CB85C !important;
}

.bg-warning-transparent {
  background-color: rgba(253, 167, 0, 0.1) !important;
  color: #FDA700 !important;
}
.bg-warning-transparent:hover {
  background-color: rgba(253, 167, 0, 0.1) !important;
  color: #FDA700 !important;
}

.bg-danger-transparent {
  background-color: rgba(252, 0, 39, 0.1) !important;
  color: #FC0027 !important;
}
.bg-danger-transparent:hover {
  background-color: rgba(252, 0, 39, 0.1) !important;
  color: #FC0027 !important;
}

.bg-light-transparent {
  background-color: rgba(253, 253, 254, 0.5) !important;
  color: #FDFDFE !important;
}
.bg-light-transparent:hover {
  background-color: rgba(253, 253, 254, 0.5) !important;
  color: #6F6F6F !important;
}

.bg-gray-100 {
  background-color: #C0C0C0;
}

.bg-gray-200 {
  background-color: #9B9B9B;
}

.bg-gray-300 {
  background-color: #898989;
}

.bg-gray-400 {
  background-color: #6F6F6F;
}

.bg-gray-500 {
  background-color: #6F7A7A;
}

.bg-gray-600 {
  background-color: #565E5E;
}

.bg-gray-700 {
  background-color: #424848;
}

.bg-gray-800 {
  background-color: #323737;
}

.bg-gray-900 {
  background-color: #262A2A;
}

.svg-primary {
  fill: #E41F07;
}

.svg-secondary {
  fill: #FFA201;
}

.svg-success {
  fill: #5CB85C;
}

.svg-danger {
  fill: #FC0027;
}

.svg-warning {
  fill: #FDA700;
}

.svg-white {
  fill: #FFF;
}

.svg-black {
  fill: #000;
}

.svg-pink {
  fill: #EA00B7;
}

.svg-orange {
  fill: #FF9D0A;
}

.svg-purple {
  fill: #4A00E5;
}

.svg-indigo {
  fill: #0092E4;
}

.svg-info {
  fill: #1ECBE2;
}

.svg-yellow {
  fill: #ffff00;
}

.svg-light {
  fill: #FDFDFE;
}

.svg-dark {
  fill: #171724;
}

.svg-teal {
  fill: #02a8b5;
}

.svg-default {
  fill: #6F6F6F;
}

.color-container {
  width: 5rem;
  height: 5rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 3rem;
}

.text-container {
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
}

.color-box {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  margin-right: 0.75rem;
  margin-bottom: 0.75rem;
}

.bg-soft-purple {
  background: #F3EDFF !important;
  border-color: #F3EDFF !important;
}

.text-purple {
  color: #4A00E5;
}

.bg-light-200 {
  background: #F9F9FC;
}

.bg-light-100 {
  background: #FAFAFA;
}

.bg-danger-light {
  background: #FFEEEC;
}

.bg-pending {
  background: #676DFF !important;
  color: #FFF !important;
}

.bg-secondary-success {
  background: #00918E !important;
}

.bg-orange {
  background: #FF9D0A;
}

.text-blue {
  color: #4A00E5 !important;
}

.text-blue-light {
  color: #0092E4 !important;
}

/******* Pages ******/
.page-header {
  margin-bottom: 14px;
}
.page-header .page-title {
  font-weight: 600;
  margin-bottom: 10px;
}
@media (max-width: 991.98px) {
  .page-header .page-title {
    font-size: 18px;
  }
}
@media (max-width: 767.98px) {
  .page-header .page-title {
    margin-bottom: 14px;
  }
}
.page-header .page-title .count-title {
  background: #F3EDFF;
  border-radius: 5px;
  margin: 0 0 0 8px;
  padding: 5px;
  color: #4A00E5;
  font-size: 12px;
  font-weight: 600;
}
@media (max-width: 991.98px) {
  .page-header .title-head {
    margin-top: 0;
  }
}
.page-header .head-icons {
  margin-bottom: 10px;
}
@media (max-width: 991.98px) {
  .page-header .head-icons {
    display: none;
  }
}
.page-header .head-icons a {
  width: 32px;
  height: 32px;
  background: #FFF;
  color: #262A2A;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  margin-right: 8px;
}
.page-header .head-icons a.active, .page-header .head-icons a:hover {
  background: #00918E;
  color: #FFF;
}
.page-header .head-icons a:last-child {
  margin-right: 0;
}
@media (max-width: 991.98px) {
  .page-header .head-icons a {
    margin-right: 4px !important;
  }
  .page-header .head-icons a:last-child {
    margin-right: 0 !important;
  }
}
.page-header .form-sort {
  margin-top: 0;
}

.set-star i {
  color: #E8E8E8;
}
.set-star i.filled {
  color: #FF9D0A;
}

.rating-select.filled i {
  color: #FF9D0A;
}

.icon-form {
  position: relative;
}
.icon-form .form-icon {
  position: absolute;
  top: 50%;
  left: 15px;
  transform: translateY(-50%);
  color: #262A2A;
}
.icon-form .form-control {
  padding: 8px 15px 8px 35px;
}
.icon-form .form-control:focus {
  padding: 8px 15px 8px 35px;
}

.icon-form-end {
  position: relative;
}
.icon-form-end .form-icon {
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  color: #262A2A;
}
.icon-form-end .form-control {
  padding: 8px 34px 8px 15px;
}

.view-icons {
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  padding: 2px;
  display: inline-flex;
  align-items: center;
}
.view-icons a {
  width: 34px;
  height: 36px;
  background: #FFF;
  color: #262A2A;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.view-icons a:first-child {
  border-radius: 5px 0 0 5px;
}
.view-icons a:last-child {
  border-radius: 0 5px 5px 0;
}
.view-icons a.active, .view-icons a:hover {
  background: #00918E;
  color: #FFF;
}

.sidebar-popoverlay {
  position: fixed;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.75);
  top: 0;
  left: -100%;
  z-index: 1003;
}
.sidebar-popoverlay.open {
  left: 0;
}

.sidebar-popoverlay-sign {
  position: fixed;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.75);
  top: 0;
  left: -100%;
  z-index: 1003;
}
.sidebar-popoverlay-sign.open {
  left: 0;
}

.profile-pic-upload {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}
.profile-pic-upload .profile-pic {
  border: 2px dashed #E8E8E8;
  margin: 0 15px 10px 0;
  width: 100px;
  height: 100px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  position: relative;
}
.profile-pic-upload .profile-pic span {
  display: flex;
}
.profile-pic-upload .profile-pic img {
  width: 70px;
  height: 70px;
  border-radius: 5px;
}
.profile-pic-upload .profile-pic .close-img {
  background: #FC0027;
  color: #FFF;
  width: 14px;
  height: 14px;
  border-radius: 2px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  position: absolute;
  top: 10px;
  right: 10px;
}
.profile-pic-upload .upload-content p {
  margin-bottom: 10px;
}
.profile-pic-upload .upload-btn {
  background: #F3EDFF;
  border-radius: 5px;
  position: relative;
  margin-bottom: 10px;
  display: inline-block;
}
.profile-pic-upload .upload-btn span {
  padding: 9px 12px;
  cursor: pointer;
  color: #4A00E5;
  display: inline-block;
}
.profile-pic-upload .upload-btn span i {
  margin-right: 10px;
}
.profile-pic-upload .upload-btn input {
  opacity: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  cursor: pointer;
}

.user-accordion-item {
  background: #FFF;
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  box-shadow: 0px 4px 74px 0px rgba(208, 208, 208, 0.2509803922);
  margin-bottom: 15px;
}
.user-accordion-item .accordion-wrap {
  padding: 10px 25px 10px 10px;
  font-weight: 500;
  display: flex;
  align-items: center;
  position: relative;
}
.user-accordion-item .accordion-wrap span {
  width: 36px;
  height: 36px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  margin-right: 8px;
}
.user-accordion-item .accordion-wrap:hover {
  color: #262A2A;
}
.user-accordion-item .accordion-wrap::before {
  content: "\\f054";
  font-family: "Font Awesome 5 Free";
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  font-size: 14px;
  font-weight: 600;
}
.user-accordion-item .accordion-wrap:not(.collapsed)::before {
  content: "\\f078";
}
.user-accordion-item .accordion-wrap:not(.collapsed) span {
  background: #E41F07;
  color: #FFF;
}
.user-accordion-item .content-collapse {
  border-top: 1px solid #E8E8E8;
  margin: 5px 10px 10px;
  padding: 15px 0 0;
}
.user-accordion-item .accordion-collapse .form-wrap {
  margin-bottom: 24px;
}
.user-accordion-item .accordion-collapse .form-wrap.mb-wrap {
  margin-bottom: 0;
}
@media (max-width: 767.98px) {
  .user-accordion-item .accordion-collapse .form-wrap.mb-wrap {
    margin-bottom: 24px;
  }
}

.submit-button .btn {
  font-size: 14px;
  font-weight: 600;
  border-radius: 5px;
  margin: 0 10px 0 0;
  padding: 7px 15px;
}
.submit-button .btn:last-child {
  margin-right: 0;
}

.radio-wrap .col-form-label {
  padding-bottom: 12px;
}
.radio-wrap .radio-btn {
  margin-right: 15px;
}
.radio-wrap .radio-btn:last-child {
  margin-right: 0;
}

.success-message h3 {
  margin-bottom: 10px;
  font-size: 20px;
}
.success-message .del-info {
  max-width: 300px;
  margin: 0 auto;
}
.success-message p {
  font-size: 16px;
  margin-bottom: 0;
}
@media (max-width: 767.98px) {
  .success-message p {
    font-size: 14px;
  }
}
.success-message .modal-btn {
  margin-top: 40px;
}

.success-popup-icon {
  background: #FFEEEC;
  color: #FC0027;
  width: 65px;
  height: 65px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 15px;
  font-size: 42px;
}
.success-popup-icon.bg-light-blue {
  background: #F3EDFF;
  color: #4A00E5;
}

.access-wrap {
  border-radius: 5px;
  margin: 0 0 20px;
  padding: 10px;
  box-shadow: 0px 4px 74px 0px rgba(208, 208, 208, 0.2509803922);
}
.access-wrap li {
  margin: 0 0 5px;
  padding: 0;
}
.access-wrap li.checkbox-checked label {
  background: #F6F6F6;
}
.access-wrap li label {
  width: 100%;
  position: relative;
  padding: 5px;
  background: transparent;
}
.access-wrap li label.checkboxs .checkmarks {
  right: 10px;
  left: unset;
  top: 50%;
  transform: translatey(-50%);
}
.access-wrap li label.checkboxs input:checked ~ .checkmark {
  background: #E41F07;
  border-color: #E41F07;
}
.access-wrap li label .people-profile {
  display: flex;
  align-items: center;
}
.access-wrap li label .people-profile img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-right: 10px;
}
.access-wrap li label .people-profile a {
  color: #6F6F6F;
  font-size: 14px;
}
.access-wrap li:hover {
  background-color: #F6F6F6;
}
.access-wrap li:last-child {
  margin-bottom: 0;
}

.load-btn .btn i {
  margin-left: 4px;
  animation: spin 3000ms linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
  }
}
.img-select {
  position: relative;
}
.img-select .select-box-img {
  width: 24px;
  height: 24px;
  position: absolute;
  top: 50%;
  left: 10px;
  z-index: 9999;
}
.img-select .select2-selection__rendered {
  padding-left: 40px !important;
}

.users-group ul {
  display: flex;
  align-items: center;
}
.users-group ul li a {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid #FFF;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: normal;
  margin-left: -11px;
}
.users-group ul li a img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}
.users-group ul li a.total-group-member {
  background: #E41F07;
  color: #FFF;
  font-size: 10px;
}
.users-group ul li a:hover {
  position: relative;
}
.users-group ul li:first-child a {
  margin-left: 0;
}

.add-new {
  color: #FC0027;
}

.contact-head {
  margin-bottom: 5px;
}
.contact-head .contact-breadcrumb {
  margin-bottom: 5px;
}
.contact-head .contact-breadcrumb li {
  color: #6F6F6F;
  position: relative;
  display: inline-block;
  margin: 0 2px 5px 0;
  padding: 0 0 0 10px;
}
.contact-head .contact-breadcrumb li a {
  color: #6F6F6F;
}
.contact-head .contact-breadcrumb li a i {
  color: #E41F07;
  margin-right: 8px;
}
.contact-head .contact-breadcrumb li a:hover {
  color: #E41F07;
}
.contact-head .contact-breadcrumb li:last-child {
  margin-right: 0;
}
.contact-head .contact-breadcrumb li:first-child {
  padding-left: 0;
}
.contact-head .contact-breadcrumb li:first-child::before {
  content: none;
}
.contact-head .contact-breadcrumb li::before {
  content: "/";
  position: absolute;
  top: 0;
  left: 0;
}
.contact-head .contact-breadcrumb li.before-none {
  padding-left: 5px;
}
.contact-head .contact-breadcrumb li.before-none::before {
  content: none;
}
.contact-head .contact-breadcrumb li .btn {
  color: #FFF;
}
.contact-head .contact-breadcrumb li .btn i {
  color: #FFF;
}
.contact-head .contact-breadcrumb li .btn:hover {
  color: #FFF;
}
.contact-head .contact-pagination {
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  margin-bottom: 10px;
}
.contact-head .contact-pagination p {
  margin: 0 15px 0 0;
}
.contact-head .contact-pagination ul li {
  display: inline-block;
  margin-right: 5px;
}
.contact-head .contact-pagination ul li a {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #FFF;
  color: #262A2A;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.contact-head .contact-pagination ul li a:hover {
  background: #E41F07;
  color: #FFF;
}
.contact-head .contact-pagination ul li:last-child {
  margin-right: 0;
}

.contacts-action {
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  flex-wrap: wrap;
}
.contacts-action > a {
  margin: 0 8px 8px 0;
}
.contacts-action > a:last-child {
  margin-right: 0;
}
.contacts-action .badge {
  margin: 0 8px 10px 0;
  padding: 7px 6px;
  font-size: 14px;
  font-weight: 400;
}
.contacts-action .badge.badge-light {
  background: #F4F4F4;
  color: #6F6F6F;
}
.contacts-action .badge i {
  margin-right: 8px;
}
.contacts-action .action-drops {
  margin-bottom: 10px;
}
.contacts-action .action-drops .dropdown-toggle {
  font-weight: 600;
  color: #FFF;
  display: inline-block;
}
.contacts-action .action-drops .dropdown-toggle span {
  display: inline-block;
  border-radius: 5px;
  padding: 4px 10px;
  color: #FFF;
}
.contacts-action .dropdown-toggle {
  margin-right: 0;
  color: #FFAB1A;
}
.contacts-action .dropdown-toggle::after {
  content: none;
}
.contacts-action .btn {
  border-radius: 5px;
  padding: 6px 13px;
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  font-size: 15px;
  font-weight: 500;
}
.contacts-action .btn i {
  margin-right: 5px;
}
.contacts-action .btn-icon {
  width: 36px;
  height: 36px;
  border-radius: 5px;
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  background: #F6F6F6;
  border: 1px solid #F6F6F6;
  color: #262A2A;
}
.contacts-action .btn-icon:hover {
  background: #E41F07;
  color: #FFF;
}
.contacts-action .btn-icon.rating {
  border-radius: 50%;
  background: #FFF;
  border: 1px solid #E8E8E8;
  color: #FF9D0A;
}
.contacts-action .act-dropdown {
  margin-bottom: 10px;
}
.contacts-action .act-dropdown > a {
  width: 34px;
  height: 34px;
  border-radius: 5px;
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  background: #FFF;
  border: 1px solid #E8E8E8;
}
.contacts-action .act-dropdown > a:hover {
  background: #E8E8E8;
  color: #262A2A;
}
.contacts-action .act-dropdown .dropdown-item {
  display: flex;
  align-items: center;
  padding: 5px;
  border-radius: 5px;
  color: #262A2A;
}
.contacts-action .act-dropdown .dropdown-item i {
  margin-right: 8px;
}
.contacts-action .act-dropdown .dropdown-item:hover {
  background: #F6F6F6;
  color: #262A2A;
}

.basic-info li {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  font-size: 14px;
}
.basic-info li span {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  background: #F6F6F6;
  color: #262A2A;
  margin-right: 10px;
  flex-shrink: 0;
}

.set-info li a {
  color: #6F6F6F;
}
.set-info li a:hover {
  color: #E41F07;
}
.set-info li i {
  margin-right: 5px;
}

.other-info li {
  display: flex;
}
.other-info li .other-title {
  min-width: 110px;
  display: inline-block;
}
.other-info li .avatar-xs {
  width: 16px;
  height: 16px;
  border-radius: 5px;
}

.con-sidebar-title {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  flex-wrap: wrap;
}
.con-sidebar-title a {
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  color: #4A00E5;
}
.con-sidebar-title a:hover {
  color: #E41F07;
}

.company-info li {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.company-info li span {
  width: 52px;
  height: 52px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border: 1px solid #E8E8E8;
  margin-right: 10px;
}
.company-info li h6 {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 2px;
}
.company-info li p {
  font-size: 14px;
  margin-bottom: 0;
}
.company-info.com-info li span {
  width: 32px;
  height: 32px;
  margin-right: 8px;
  border-radius: 50%;
}
.company-info.com-info li p i {
  margin-right: 5px;
  color: #FDA700;
}

.deals-info li {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.deals-info li img {
  width: 32px;
  height: 32px;
  border-radius: 5px;
  margin-right: 10px;
}
.deals-info li p {
  margin-bottom: 0;
}

.social-info li {
  display: inline-block;
}
.social-info li a {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  background: #FFF;
  color: #262A2A;
}
.social-info li a:hover {
  background: #262A2A;
  color: #FFF;
}

.tag-info li {
  margin-right: 5px;
  display: inline-block;
}
.tag-info li a {
  font-size: 12px;
  font-weight: 500;
  border-radius: 5px;
  padding: 5px 10px;
  display: inline-block;
}
.tag-info li:last-child {
  margin-right: 0;
}

.star-icon {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border: 1px solid #E8E8E8;
  color: #FF9D0A;
}
.star-icon i {
  font-size: 14px;
}

@media (max-width: 575.98px) {
  .contact-nav {
    display: block;
  }
}
.contact-nav li {
  display: inline-block;
  margin: 0 20px 0 0;
}
.contact-nav li a {
  color: #6F6F6F;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  font-size: 14px;
  font-weight: 500;
  border-bottom: 3px solid #FFF;
  text-align: center;
  padding: 5px 5px 10px 5px;
}
.contact-nav li a:hover, .contact-nav li a.active {
  color: #E41F07;
  border-color: #E41F07;
}
.contact-nav li a i {
  margin-right: 5px;
}
@media (max-width: 575.98px) {
  .contact-nav li {
    display: block;
  }
}

.form-sort {
  position: relative;
}
.form-sort i {
  position: absolute;
  z-index: 101;
  width: 16px;
  height: 16px;
  top: 14px;
  left: 7px;
}
.form-sort .select2-container--default .select2-selection--single .select2-selection__rendered {
  padding-left: 35px;
}
.form-sort span.select2-container.select2-container--default.select2-container--open {
  z-index: 99;
}

.badge-day {
  background: #F3EDFF;
  color: #4A00E5;
  border-radius: 5px;
  display: inline-block;
  font-size: 14px;
  margin: 0 0 20px;
  padding: 4px 8px;
}
.badge-day i {
  margin-right: 5px;
}

.contact-activity ul:last-child .activity-wrap:last-child {
  margin-bottom: 0;
}

.upcoming-info {
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  margin: 10px 0 0;
  padding: 15px 15px 5px;
}
.upcoming-info p {
  font-weight: 500;
  margin-bottom: 8px;
}
.upcoming-info .dropdown {
  margin-bottom: 10px;
}
.upcoming-info .dropdown .dropdown-toggle {
  color: #262A2A;
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  font-size: 14px;
}
.upcoming-info .dropdown .dropdown-toggle::after {
  content: none;
}
.upcoming-info .dropdown .avatar-xs {
  width: 16px;
  height: 16px;
  border-radius: 5px;
  margin-right: 10px;
}
.upcoming-info .dropdown .circle {
  font-size: 10px;
}
.upcoming-info .dropdown .dropdown-menu a {
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  font-size: 14px;
  color: #262A2A;
}

.notes-editor .dropdown-toggle::after {
  content: none;
}

.note-edit-wrap {
  display: none;
  margin-bottom: 15px;
}

.notes-activity .note-download {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  border: 1px solid #E8E8E8;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
  margin: 0 0 15px;
  padding: 15px;
  border-radius: 5px;
}
.notes-activity .note-download .note-info {
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-right: 24px;
}
.notes-activity .note-download .note-info h6 {
  font-weight: 500;
  margin-bottom: 5px;
}
.notes-activity .note-download .note-info p {
  margin-bottom: 0;
}
@media (max-width: 767.98px) {
  .notes-activity .note-download .note-info {
    margin-right: 15px;
  }
}
.notes-activity .note-download .note-icon {
  width: 44px;
  height: 44px;
  border-radius: 5px;
  color: #FFF;
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  margin-right: 8px;
  flex-shrink: 0;
}
.notes-activity .note-download .note-icon img {
  width: 44px;
  height: 44px;
  border-radius: 50%;
}
.notes-activity .note-download:hover {
  background: #F6F6F6;
}
.notes-activity .note-download:hover a {
  background: #FFF;
}
.notes-activity .note-download a {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border-radius: 50%;
  color: #262A2A;
  background: #F6F6F6;
}
@media (max-width: 767.98px) {
  .notes-activity .note-download {
    margin: 0 0 15px;
    padding: 10px;
  }
}
.notes-activity .reply-box {
  background: #F9F9FC;
  border-radius: 5px;
  margin: 0 0 15px;
  padding: 15px;
}
.notes-activity .reply-box p {
  margin-bottom: 10px;
}
.notes-activity .reply-box .btn {
  background: #FFF;
  border-color: #FFF;
  border-radius: 5px;
  color: #262A2A;
  font-size: 16px;
  font-weight: 400;
  margin: 0;
  padding: 5px 10px;
}
.notes-activity .reply-box .btn i {
  margin-right: 3px;
}
.notes-activity .reply-box .btn:hover {
  background: #FAFAFA;
}

.note-btns {
  margin-top: 5px;
}
.note-btns .btn {
  margin: 10px 10px 0 0;
  padding: 7px 15px;
}
.note-btns .btn:last-child {
  margin-right: 0;
}
.note-btns .btn.btn-primary {
  min-width: 110px;
}

.drag-attach {
  border: 1px dashed #E8E8E8;
  border-radius: 5px;
  position: relative;
  text-align: center;
  width: 100%;
  overflow: hidden;
}
.drag-attach input {
  opacity: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  cursor: pointer;
}
.drag-attach .img-upload {
  background: #F3EDFF;
  color: #4A00E5;
  font-size: 14px;
  display: inline-block;
  text-align: center;
  margin: 24px 0;
  padding: 9px 17px;
  border-radius: 5px;
}
.drag-attach .img-upload i {
  margin-right: 10px;
}

.drag-upload {
  background: #FAFAFA;
  border: 1px dashed #FFECCC;
  border-radius: 5px;
  position: relative;
}
.drag-upload input {
  opacity: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  cursor: pointer;
}
.drag-upload i {
  font-size: 24px;
  margin-bottom: 10px;
}
.drag-upload p {
  font-size: 14px;
  margin-bottom: 0;
}
.drag-upload .img-upload {
  text-align: center;
  padding: 36px 20px;
}

.upload-file {
  background: #F9F9FC;
  border: 1px solid #E8E8E8;
  margin: 0 0 5px;
  padding: 15px;
  border-radius: 5px;
}
.upload-file h6 {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 2px;
}
.upload-file p {
  font-size: 14px;
  margin-bottom: 0;
}
.upload-file p.black-text {
  color: #262A2A;
}
.upload-file .progress {
  height: 3px;
  margin: 15px 0 4px;
}
.upload-file.upload-list {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}

.form-title {
  font-weight: 600;
  margin-bottom: 15px;
}

.sync-radio .radio-item {
  margin-bottom: 15px;
}
.sync-radio .radio-item label {
  font-size: 14px;
}
.sync-radio .radio-item:last-child {
  margin-bottom: 0;
}

.signature-wrap {
  background: #F2ECFF;
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  margin: 0 0 15px;
  padding: 15px 15px 0;
}
.signature-wrap h4, .signature-wrap p {
  margin-bottom: 15px;
}
.signature-wrap h4 {
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .signature-wrap h4 {
    font-size: 16px;
  }
}

.add-sign {
  font-size: 16px;
  color: #FDA700;
}

.sign-item li {
  margin-bottom: 15px;
}
.sign-item li .sign-title {
  display: block;
  font-weight: 500;
  margin-bottom: 3px;
}

.trash-sign {
  color: #FC0027;
}

.send-success {
  border: 1px solid #5CB85C;
  background: #CEEACE;
  border-radius: 5px;
  margin: 0 0 15px;
  padding: 15px;
}
.send-success p {
  color: #262A2A;
  margin-bottom: 0;
}
.send-success p i {
  margin-right: 5px;
}

fieldset {
  display: none;
}
fieldset#first-field-file {
  display: block;
}

.add-details-wizard ul {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
@media (max-width: 575.98px) {
  .add-details-wizard ul {
    flex-direction: column;
  }
}
.add-details-wizard ul li {
  line-height: normal;
  background: #F6F6F6;
  padding: 10px 20px;
  display: flex;
  align-items: center;
}
@media (max-width: 575.98px) {
  .add-details-wizard ul li {
    width: 100%;
    margin-bottom: 10px;
  }
}
.add-details-wizard ul li span {
  margin-right: 5px;
}
.add-details-wizard ul li .multi-step-info h6 {
  margin-bottom: 0;
  font-weight: 500;
  font-size: 14px;
  color: #6F6F6F;
}
.add-details-wizard ul li.active {
  background: #E41F07;
  color: #FFF;
}
.add-details-wizard ul li.active h6 {
  color: #FFF;
}

.pipeline-item {
  border: 1px solid #E8E8E8;
  margin: 0 0 5px;
  padding: 15px 15px 5px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  position: relative;
}
.pipeline-item::before {
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  width: 2px;
  height: 100%;
  background: #FFA201;
}
.pipeline-item p {
  color: #262A2A;
  font-weight: 500;
  margin-bottom: 10px;
}
.pipeline-item .action-pipeline {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  flex-wrap: wrap;
}
.pipeline-item .action-pipeline a {
  margin: 0 15px 10px 0;
}
.pipeline-item .action-pipeline a i {
  margin-right: 5px;
}
.pipeline-item .action-pipeline a:last-child {
  margin-right: 0;
}
.pipeline-item:last-child {
  margin-bottom: 0;
}

.access-item .radio-btn {
  margin-right: 15px;
}
.access-item .radio-btn:last-child {
  margin-right: 0;
}

.access-wrapper {
  margin-top: 20px;
}

.access-view {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  border: 1px solid #E8E8E8;
  margin: 0 0 5px;
  padding: 15px 15px 15px;
  border-radius: 5px;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.access-view .access-img {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.access-view .access-img img {
  width: 32px;
  height: 32px;
  border-radius: 5px;
  margin-right: 10px;
}
.access-view a {
  font-weight: 600;
  color: #FC0027;
}

.header-collapse .header-user {
  display: none;
  height: 0;
}
.header-collapse .page-wrapper {
  padding-top: 0;
}
.header-collapse .header {
  border-bottom: none;
  background: transparent;
  width: 260px;
}
.header-collapse .header .header-left {
  background: white;
}
.header-collapse #collapse-header i {
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
}

.bootstrap-datetimepicker-widget {
  z-index: 99999;
}
.bootstrap-datetimepicker-widget table td.active, .bootstrap-datetimepicker-widget table td:hover {
  background-color: #00918E;
}

.note-modal-backdrop {
  z-index: 9;
}

.note-modal-footer {
  height: 57px;
}

.table tbody tr td a.title-name {
  color: #262A2A;
  font-weight: 500;
}
.table tbody tr td a.title-name:hover {
  color: #E41F07;
  text-decoration: underline;
}

.title-name {
  color: #262A2A;
  font-weight: 500;
}

.export-list > ul {
  display: flex;
  align-items: center;
  justify-content: end;
  flex-wrap: wrap;
}
@media (max-width: 575.98px) {
  .export-list > ul {
    justify-content: start;
  }
}

.grid-social-links a:hover {
  background: #FCE9E6 !important;
}

.daterange-picker .form-sort {
  margin-left: 10px;
}
.daterange-picker .form-sort input {
  padding-left: 25px;
  height: 38px;
}
.daterange-picker .form-sort .select2-container .select2-selection.select2-selection--single {
  height: 38px;
}
.daterange-picker .form-sort .select2-container .select2-selection.select2-selection--single .select2-selection__rendered {
  line-height: 38px;
}
.daterange-picker .form-sort .select2-container .select2-selection.select2-selection--single .select2-selection__arrow {
  height: 38px;
}

.card-select ul {
  display: flex;
  align-items: center;
}
.card-select ul li + li {
  margin-left: 12px;
}

.view-icons {
  float: right;
}
@media (max-width: 767.98px) {
  .view-icons {
    margin-right: 0;
  }
}
.view-icons .btn {
  background-color: #FFF;
  border: 1px solid #E8E8E8;
  color: #FFB534;
  font-size: 18px;
  min-width: 40px;
  margin: 0 5px 0 0;
  padding: 7px 0 3px 0;
}
.view-icons .btn.active {
  color: #FFAB1A;
}
@media (max-width: 767.98px) {
  .view-icons .btn {
    min-width: 37px;
    margin: 0 5px 0 0;
    padding: 5px 0 3px 0;
  }
}

@media (max-width: 767.98px) {
  .page-header .view-icons {
    margin-right: 10px;
  }
}
@media (max-width: 575.98px) {
  .page-header .view-icons {
    margin-right: 0;
  }
}

.title-head {
  justify-content: end;
  align-items: center;
}
@media (max-width: 767.98px) {
  .title-head {
    justify-content: start;
    margin-top: 20px;
  }
}
@media (max-width: 575.98px) {
  .title-head {
    flex-direction: column;
    row-gap: 20px;
    align-items: start;
  }
}
.title-head .add-btn {
  margin-left: 10px;
  border-radius: 5px;
}
@media (max-width: 575.98px) {
  .title-head .add-btn {
    margin-left: 0;
  }
}
.title-head .form-sort .list-view {
  padding: 10px 10px 10px 30px;
  background-color: #FFF;
  border: 1px solid #E8E8E8;
  color: #FFC767;
  font-size: 14px;
  text-decoration: none;
  line-height: normal;
}

.daterange-picker .form-sort {
  min-width: 200px;
}

.statistic-dropdown .btn-primary {
  padding: 6px 15px;
  height: 35px;
}

td .badge-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.badge-dots {
  width: 12px;
  height: 12px;
  border-radius: 5px;
  margin-right: 5px;
  display: inline-flex;
}

.title-head .daterange-picker .form-sort {
  height: auto;
  min-width: 212px;
}
.title-head .daterange-picker .form-sort i {
  left: 15px;
  top: 9px;
}
.title-head .daterange-picker .form-sort input {
  height: 32px;
  min-height: 32px;
}
.title-head .daterange-picker .bookingrange {
  padding-left: 35px;
}

.error-page {
  background: #FFF;
}

.comming-shapes {
  position: relative;
}
@media (max-width: 991.98px) {
  .comming-shapes {
    display: none;
  }
}
.comming-shapes .comming-right-shape {
  position: fixed;
  top: 0;
  left: 0;
}
.comming-shapes .comming-left-shape {
  position: fixed;
  bottom: -5px;
  right: 0;
}
.comming-shapes img {
  width: 500px;
}

.error-img {
  max-width: 500px;
}

.account-page {
  background: #FFF;
}

.form-wrap .form-wrap-icon {
  position: relative;
}
.form-wrap .form-wrap-icon i {
  font-size: 18px;
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
}

.form-wrap-checkbox {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-bottom: 20px;
}
.form-wrap-checkbox .check {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  color: #262A2A;
  margin-bottom: 0;
}
.form-wrap-checkbox .check input {
  display: none;
}
.form-wrap-checkbox .check input:checked + .box {
  background: #FFA201;
}
.form-wrap-checkbox .check input:checked + .box:after {
  top: 0;
}
.form-wrap-checkbox .check .box {
  width: 20px;
  height: 20px;
  display: block;
  margin-right: 8px;
  transition: all 1.1s cubic-bezier(0.19, 1, 0.22, 1);
  background: #F9F9FC;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid #E8E8E8;
  border-radius: 5px;
}
.form-wrap-checkbox .check .box:after {
  width: 12px;
  height: 6px;
  content: "";
  position: absolute;
  border-left: 2px solid;
  border-bottom: 2px solid;
  border-color: #FFF;
  transform: rotate(-45deg) translate3d(0, 0, 0);
  transform-origin: center center;
  transition: all 1.1s cubic-bezier(0.19, 1, 0.22, 1);
  left: 0;
  right: 0;
  top: 200%;
  bottom: 3px;
  margin: auto;
}

.hover-a {
  position: relative;
  color: #4A00E5;
}
.hover-a:after {
  content: "";
  height: 2px;
  width: 100%;
  background: #4A00E5;
  transform: scale(0);
  -webkit-transform: scale(0);
  -ms-transform: scale(0);
  transition: all 0.3s ease;
  position: absolute;
  bottom: -3px;
  left: 0;
}
.hover-a:hover:after {
  transform: scale(1);
  -webkit-transform: scale(1);
  -ms-transform: scale(1);
}
.hover-a:hover {
  color: #4A00E5;
}

.account-bg-01 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.account-bg-02 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.account-bg-03 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.account-bg-04 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.link-hover {
  position: relative;
  color: #E41F07;
  font-weight: 500;
}
.link-hover:after {
  content: "";
  height: 2px;
  width: 100%;
  background: #E41F07;
  transform: scale(0);
  -webkit-transform: scale(0);
  -ms-transform: scale(0);
  transition: all 0.3s ease;
  position: absolute;
  bottom: -3px;
  left: 0;
}
.link-hover:hover:after {
  transform: scale(1);
  -webkit-transform: scale(1);
  -ms-transform: scale(1);
}
.link-hover:hover {
  color: #E41F07 !important;
}

.bg-backdrop {
  background: rgba(255, 255, 255, 0.9490196078);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
}
@media (max-width: 767.98px) {
  .bg-backdrop {
    width: 100% !important;
  }
}

.form-set-login.or-text {
  max-width: 365px;
  margin: auto;
}

.toggle-password {
  cursor: pointer;
  width: 30px;
  height: 30px;
  color: #262A2A;
  font-size: 18px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border-radius: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  position: absolute;
  top: 50%;
  right: 10px;
}
.toggle-password:hover {
  color: #E41F07;
}

.toggle-passwords {
  cursor: pointer;
  width: 30px;
  height: 30px;
  color: #262A2A;
  font-size: 18px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border-radius: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  position: absolute;
  top: 50%;
  right: 10px;
}
.toggle-passwords:hover {
  color: #E41F07;
}

.toggle-password-new {
  cursor: pointer;
  width: 30px;
  height: 30px;
  color: #262A2A;
  font-size: 18px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border-radius: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  position: absolute;
  top: 50%;
  right: 10px;
}
.toggle-password-new:hover {
  color: #E41F07;
}

.pass-group {
  position: relative;
  font-size: 14px;
}

.form-set-login {
  text-align: center;
  position: relative;
  color: #B8BCC9;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 23px;
}
.form-set-login h4 {
  position: relative;
  font-size: 14px;
  color: #6F6F6F;
  font-weight: 700;
}
.form-set-login h4:after {
  content: "";
  background: #B8BCC9;
  width: 21px;
  height: 1px;
  position: absolute;
  top: 10px;
  left: 200px;
}
@media (max-width: 991.98px) {
  .form-set-login h4:after {
    height: 0px;
  }
}
.form-set-login h4:before {
  content: "";
  background: #B8BCC9;
  width: 21px;
  height: 1px;
  position: absolute;
  top: 10px;
  right: 200px;
}
@media (max-width: 991.98px) {
  .form-set-login h4:before {
    height: 0px;
  }
}

.mw-450 {
  max-width: 450px;
}

.wh-85 {
  width: 85px;
  height: 85px;
}
@media (max-width: 575.98px) {
  .wh-85 {
    width: 50px;
    height: 50px;
  }
}

.login-shapes {
  position: relative;
}
@media (max-width: 991.98px) {
  .login-shapes {
    display: none;
  }
}
.login-shapes .login-right-shape {
  position: fixed;
  top: 0;
  left: 0;
}
.login-shapes .login-left-shape {
  position: fixed;
  bottom: 0;
  right: 0;
  line-height: 0;
}

.settings-sidebar h4 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 24px;
}
@media (max-width: 767.98px) {
  .settings-sidebar h4 {
    font-size: 16px;
    margin-bottom: 15px;
  }
}
.settings-sidebar a {
  color: #6F6F6F;
  display: inline-flex;
  align-items: center;
  border-radius: 5px;
  padding: 10px;
  width: 100%;
  position: relative;
}
.settings-sidebar a.active {
  background: #F6F6F6;
  color: #262A2A;
}
.settings-sidebar a.active:before {
  position: absolute;
  content: "\\f054";
  font-family: "FontAwesome";
  font-size: 12px;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
}
.settings-sidebar a:hover {
  color: #262A2A;
}

.profile-upload {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.profile-upload .profile-upload-img {
  width: 100px;
  min-width: 100px;
  height: 100px;
  position: relative;
  margin-right: 15px;
  border-radius: 5px;
  border: 2px dashed #E8E8E8;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.profile-upload .profile-upload-img span {
  color: #6F6F6F;
  position: absolute;
}
.profile-upload .profile-upload-content .profile-upload-btn {
  display: inline-flex;
  align-items: center;
  position: relative;
  overflow: hidden;
  color: #4A00E5;
  background: #F3EDFF;
  border: 1px solid #F3EDFF;
  border-radius: 5px;
  padding: 8px 10px;
  margin-bottom: 15px;
  cursor: pointer;
  transition: all 0.5s;
}
.profile-upload .profile-upload-content .profile-upload-btn:hover {
  color: #FFF;
  background: #4A00E5;
  border: 1px solid #4A00E5;
  transition: all 0.5s;
}
.profile-upload .profile-upload-content .profile-upload-btn i {
  font-size: 16px;
  margin-right: 8px;
}
.profile-upload .profile-upload-content .profile-upload-btn input[type=file] {
  position: absolute;
  top: 0;
  right: 0;
  min-width: 100%;
  min-height: 100%;
  text-align: right;
  filter: alpha(opacity=0);
  opacity: 0;
  outline: none;
  cursor: inherit;
  display: block;
}
.profile-upload .profile-upload-content p {
  font-weight: 500;
  color: #6F6F6F;
}
.profile-upload .preview1 {
  display: none;
}
.profile-upload .it {
  width: 70px;
  height: 70px;
  border-radius: 5px;
  display: block;
  position: relative;
  background: #FFF;
  object-fit: cover;
}
.profile-upload .profile-remove {
  display: none;
}
.profile-upload .profile-remove-btn {
  width: 14px;
  height: 14px;
  font-size: 10px;
  color: #FFF;
  background: #FC0027;
  border: 1px solid #FC0027;
  border-radius: 5px;
  padding: 0;
  display: inline-block;
  position: absolute;
  top: 8px;
  right: 8px;
}
.profile-upload .profile-remove-btn:hover {
  background: #c9001f;
  border: 1px solid #c9001f;
}

.notificaion-table .table thead tr:first-child th {
  padding-top: 0;
}
.notificaion-table .table thead tr th {
  font-size: 16px;
  padding: 10px;
}
.notificaion-table .table tbody tr td {
  font-weight: 500;
  color: #262A2A;
  padding: 10px;
}
.notificaion-table .table tbody tr:last-child td {
  padding-bottom: 0;
}

.mod-toggle .status-toggle {
  margin-right: 20px;
}

.btn-add {
  width: 32px;
  height: 32px;
  background: #FFF;
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #262A2A;
}
.btn-add:hover {
  background: #00918E;
  color: #FFF;
}

.settings-form .setting-title {
  margin-bottom: 15px;
}
.settings-form .setting-title h6 {
  font-size: 14px;
  font-weight: 500;
}
.settings-form .setting-title p {
  font-size: 12px;
}
.settings-form .form-wrap {
  margin-bottom: 15px;
}
.settings-form .submit-button {
  margin-top: 14px;
}

.bank-box {
  background: #F9F9FC;
  border-radius: 5px;
  border: 1px solid #F9F9FC;
  position: relative;
  margin: 0 0 24px;
  padding: 40px;
}
@media (max-width: 991.98px) {
  .bank-box {
    margin: 0 0 24px;
    padding: 20px;
  }
}
.bank-box.active {
  border-color: #5CB85C;
}
.bank-box.active::after {
  position: absolute;
  top: -8px;
  right: -8px;
  content: "\\f058";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  color: #6CBF6C;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: #FFF;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.bank-box .table-action .action-icon {
  background-color: transparent;
}
.bank-box .table-action .action-icon:hover {
  background-color: #F6F6F6;
}

.inv-days .select2-container {
  min-width: 62px !important;
}
.inv-days p {
  color: #000;
  margin-left: 10px;
}

.lang-type {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.lang-type li {
  margin-right: 5px;
}
.lang-type li a {
  background-color: #F6F6F6;
  border-radius: 5px;
  color: #6F6F6F;
  font-weight: 500;
  padding: 8px 15px;
  display: inline-block;
}
.lang-type li a:hover {
  background-color: #00918E;
  color: #FFF !important;
}

.theme-type-images {
  flex-wrap: wrap;
}
.theme-type-images .theme-image {
  background: #FFF;
  border-radius: 5px;
  border: 1px solid #E8E8E8;
  padding: 10px;
  margin: 0 24px 15px 0;
  text-align: center;
}
.theme-type-images .theme-image img {
  width: 150px;
}
@media (max-width: 1399.98px) {
  .theme-type-images .theme-image img {
    width: 130px;
  }
}
.theme-type-images .theme-image:last-child {
  margin-right: 0;
}
.theme-type-images .theme-image span {
  font-weight: 500;
  font-size: 14px;
  color: #262A2A;
  margin-top: 10px;
  display: block;
}
.theme-type-images .theme-image.active {
  border-color: #E41F07;
}
.theme-type-images .theme-image.active span {
  color: #E41F07;
}

.theme-colors ul {
  display: flex;
  align-items: center;
}
.theme-colors ul li {
  margin-right: 10px;
}
.theme-colors ul li span {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #E41F07;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
}
.theme-colors ul li span.active {
  background-color: #FCE9E6;
}
.theme-colors ul li span.active:after {
  content: "";
  width: 25px;
  height: 25px;
  background-color: #E41F07;
  border-radius: 50%;
  opacity: 1;
}
.theme-colors ul li span.theme-secondary {
  background-color: #FFA201;
}
.theme-colors ul li span.theme-secondary.active {
  background-color: #FFF6E6;
}
.theme-colors ul li span.theme-secondary.active:after {
  background-color: #FFA201;
}
.theme-colors ul li span.theme-violet {
  background-color: #3C2371;
}
.theme-colors ul li span.theme-violet.active {
  background-color: rgba(60, 35, 113, 0.1);
}
.theme-colors ul li span.theme-violet.active:after {
  background-color: #3C2371;
}
.theme-colors ul li span.theme-blue {
  background-color: #0092E4;
}
.theme-colors ul li span.theme-blue.active {
  background-color: #E6F4FC;
}
.theme-colors ul li span.theme-blue.active:after {
  background-color: #0092E4;
}
.theme-colors ul li span.theme-brown {
  background-color: #4A00E5;
}
.theme-colors ul li span.theme-brown.active {
  background-color: #F3EDFF;
}
.theme-colors ul li span.theme-brown.active:after {
  background-color: #4A00E5;
}
.theme-colors ul li:last-child {
  margin-right: 0;
}

.lang-wrap {
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}

.lang-flag {
  margin-right: 15px;
}
.lang-flag a {
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  border: 1px solid #E8E8E8;
  border-radius: 8px;
  color: #262A2A;
  font-weight: 500;
  padding: 8px 8px;
}
.lang-flag a img {
  margin-right: 8px;
  border-radius: 50%;
  width: 20px;
  height: 20px;
}

.lang-direct li {
  margin: 0 8px 0 0;
}
.lang-direct li a {
  background-color: #9B9B9B;
  color: #262A2A;
  border-radius: 5px;
  padding: 8px 15px;
  display: inline-block;
}
.lang-direct li a:hover, .lang-direct li a.active {
  background-color: #3C2371;
  color: #FFF;
}
.lang-direct li:last-child {
  margin-right: 0;
}

.translate-wrap h6 {
  font-weight: 500;
  margin-bottom: 15px;
}
.translate-wrap .form-wrap {
  margin-bottom: 15px;
}
.translate-wrap.translate-title h6 {
  font-size: 16px;
  font-weight: 600;
}

.translate-item {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  flex-wrap: wrap;
  margin-bottom: 24px;
}
.translate-item .btn, .translate-item .lang-flag {
  margin-bottom: 24px;
}

.lang-flag {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}

.lang-progress {
  margin-bottom: 24px;
}
.lang-progress p {
  font-weight: 500;
}
.lang-progress .progress {
  min-width: 100px;
  max-width: 150px;
  height: 7px;
}

.black-text {
  color: #262A2A !important;
}

.settings-tab .card-body {
  padding-top: 0;
}
@media (max-width: 767.98px) {
  .settings-tab .card-body {
    padding-top: 16px;
  }
}
.settings-tab .card-body li a {
  padding-top: 24px;
}
@media (max-width: 767.98px) {
  .settings-tab .card-body li a {
    padding-top: 8px;
    padding-bottom: 8px;
  }
}

.payment-img {
  width: 80px;
  height: 40px;
}

.source-report {
  color: #00918E;
  font-weight: 500;
}

.dropdown.table-action .dropdown-toggle::after {
  display: none;
}
.dropdown .dropdown-toggle {
  color: #262A2A;
  border: 1px solid #E8E8E8;
  padding: 9px 15px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
}
.dropdown .dropdown-toggle:after {
  border-top: 0;
  border-left: 0;
  border-bottom: 2px solid #262A2A;
  border-right: 2px solid #262A2A;
  content: "";
  display: inline-block;
  pointer-events: none;
  width: 8px;
  height: 8px;
  vertical-align: 2px;
  transform-origin: 66% 66%;
  -webkit-transform-origin: 66% 66%;
  -ms-transform-origin: 66% 66%;
  transition: all 0.2s ease;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
}
.dropdown .dropdown-toggle[aria-expanded=true]:after {
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
  -ms-transform: rotate(-135deg);
}
.dropdown .dropdown-menu {
  padding: 10px;
  background: #FFF;
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  border: 1px solid #E8E8E8;
}
.dropdown .dropdown-menu .dropdown-item {
  padding: 5px 10px;
  color: #323737;
  background: #FFF;
  border-radius: 5px;
}
.dropdown .dropdown-menu .dropdown-item:hover {
  color: #262A2A;
  background: #F6F6F6;
}

.time-text p {
  font-weight: 500;
  white-space: nowrap;
  margin-left: 15px;
}

.activity-title {
  margin-bottom: 10px;
  display: inline-flex;
  align-items: center;
}
.activity-title h4 {
  font-weight: 600;
  margin: 0 15px 10px 0;
  padding: 0 15px 0 0;
  position: relative;
}
.activity-title h4::after {
  content: "";
  background-color: #E8E8E8;
  width: 1px;
  height: 24px;
  position: absolute;
  top: 0;
  right: 0;
}
@media (max-width: 767.98px) {
  .activity-title h4::after {
    content: none;
  }
}
@media (max-width: 767.98px) {
  .activity-title {
    display: block;
  }
}

.active-list ul {
  margin-bottom: 10px;
}
.active-list ul li {
  display: inline-block;
  margin-right: 10px;
}
.active-list ul li a {
  width: 34px;
  height: 34px;
  border-radius: 5px;
  border: 1px solid #E8E8E8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #262A2A;
}
.active-list ul li a:hover, .active-list ul li a.active {
  background-color: #00918E;
  border-color: #00918E;
  color: #FFF;
}
.active-list ul li:last-child {
  margin-right: 0;
}

.radio-activity li {
  display: inline-block;
}
.radio-activity li .active-type input[type=radio] {
  display: none;
}
.radio-activity li .active-type input[type=radio] ~ label {
  border: 1px solid #E8E8E8;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
  margin: 0 10px 5px 0;
  padding: 8px 20px;
  border-radius: 5px;
  color: #262A2A;
  cursor: pointer;
}
.radio-activity li .active-type input[type=radio] ~ label i {
  margin-right: 5px;
}
.radio-activity li .active-type input[type=radio]:checked ~ label {
  border-color: #00918E;
  color: #00918E;
}
.radio-activity li:last-child {
  margin-right: 0;
}

.label-add {
  color: #E41F07;
  margin-bottom: 5px;
  font-weight: 500;
}
.label-add i {
  margin-right: 8px;
}
.label-add:hover {
  color: #b31805;
}

.tab-activity {
  border-radius: 5px;
  margin: 0 0 20px;
  padding: 15px 15px 0;
  box-shadow: 0px 4px 74px 0px rgba(208, 208, 208, 0.2509803922);
}
.tab-activity ul li {
  display: inline-block;
  margin-right: 20px;
}
.tab-activity ul li a {
  padding: 10px 5px 10px;
  font-weight: 500;
  border-bottom: 4px solid #FFF;
  display: inline-block;
}
.tab-activity ul li a span {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #E8E8E8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  margin-left: 10px;
  color: #262A2A;
  font-weight: 600;
  font-size: 10px;
}
.tab-activity ul li a.active {
  color: #E41F07;
  border-color: #E41F07;
}

.comment-wrap {
  margin: 0 0 15px;
  padding: 15px;
  box-shadow: 0px 4px 74px 0px rgba(208, 208, 208, 0.2509803922);
  border: 1px solid #E8E8E8;
  border-radius: 5px;
}
.comment-wrap h6 {
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 10px;
  color: #6F6F6F;
}
.comment-wrap p span {
  color: #4A00E5;
}
.comment-wrap:last-child {
  margin-bottom: 0;
}

.activity-badge {
  color: #FFF;
  padding: 5px 7px;
  font-size: 12px;
  border-radius: 5px;
}
.activity-badge i {
  margin-right: 5px;
}

.title-head {
  font-weight: 500;
  color: #262A2A;
}

.tasks-activity.tasks > ul {
  margin-top: 15px;
}
.tasks-activity.tasks > ul .task-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  flex-wrap: wrap;
}
.tasks-activity.tasks > ul .task-wrap.pending::before {
  background-color: #676DFF;
}
.tasks-activity.tasks > ul .task-wrap.warning::before {
  background-color: #FDA700;
}
.tasks-activity.tasks > ul .task-wrap.success::before {
  background-color: #5CB85C;
}
.tasks-activity.tasks > ul .task-wrap .task-info .task-icon {
  margin: 0 20px 10px 0;
}
.tasks-activity.tasks > ul .task-wrap .task-info .task-checkbox {
  margin: 0 20px 10px 0;
}
.tasks-activity.tasks > ul .task-wrap .task-info .task-checkbox .checkboxs .checkmarks {
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
}
.tasks-activity.tasks > ul .task-wrap .task-info .set-star {
  margin: 0 20px 10px 0;
}
.tasks-activity.tasks > ul .task-wrap .task-info p {
  font-weight: 500;
}
.tasks-activity.tasks > ul .task-wrap .task-info .badge {
  font-weight: 600;
  font-size: 12px;
  margin: 0 5px 10px 0;
  padding: 5px 7px;
  color: #FFF;
}
.tasks-activity.tasks > ul .task-wrap .task-info .badge:last-child {
  margin-right: 0;
}
.tasks-activity.tasks > ul .task-wrap .task-actions ul li {
  margin: 0 10px 10px 0;
}
.tasks-activity.tasks > ul .task-wrap .task-actions ul li .badge-tag {
  padding: 5px 4px;
}
.tasks-activity.tasks > ul .task-wrap .task-actions ul li:last-child {
  margin-right: 0;
}

.all-read .checkboxs .checkmarks {
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
}

.task-drops .dropdown-toggle {
  border: 0;
  padding: 0;
  font-size: 18px;
  font-weight: 600;
  box-shadow: none;
}
.task-drops .dropdown-toggle.show {
  border: 0;
}
@media (max-width: 767.98px) {
  .task-drops .dropdown-toggle {
    font-size: 16px;
  }
}

.badge-purple-light {
  color: #4A00E5 !important;
  background: #F3EDFF !important;
}

.task-wrapper {
  border-bottom: 1px solid #E8E8E8;
  margin-bottom: 15px;
  padding-bottom: 15px;
}
.task-wrapper .tasks-activity.tasks > ul {
  margin-bottom: 15px;
}
.task-wrapper:last-child {
  padding-bottom: 0;
}
.task-wrapper:last-child .tasks-activity.tasks > ul {
  margin-bottom: 0;
}
.task-wrapper .task-accordion {
  font-size: 18px;
  font-weight: 600;
  position: relative;
  display: block;
}
@media (max-width: 767.98px) {
  .task-wrapper .task-accordion h4 {
    font-size: 16px;
  }
}
.task-wrapper .task-accordion span {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #E8E8E8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  margin-left: 10px;
  color: #262A2A;
  font-weight: 600;
  font-size: 10px;
}
.task-wrapper .task-accordion::before {
  content: "\\f054";
  font-family: "Font Awesome 5 Free";
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  font-size: 14px;
  font-weight: 600;
}
.task-wrapper .task-accordion:not(.collapsed)::before {
  content: "\\f078";
}
.task-wrapper:last-child {
  border: 0;
  margin-bottom: 0;
}

.preloader {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999999;
  width: 100%;
  height: 100%;
  background: #FFF;
  display: flex;
  align-items: center;
  justify-content: center;
}
.preloader .loader {
  width: 64px;
  height: 64px;
  position: relative;
  animation: rotate 1.5s ease-in infinite alternate;
}
.preloader .loader::before {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  color: #3C2371;
  background: currentColor;
  width: 64px;
  height: 32px;
  border-radius: 0 0 50px 50px;
}
.preloader .loader::after {
  content: "";
  position: absolute;
  left: 50%;
  top: 10%;
  background: #00918E;
  width: 8px;
  height: 64px;
  animation: rotate 1.2s linear infinite alternate-reverse;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}
.toggle-content-view {
  margin-bottom: 24px;
}
.toggle-content-view h5 {
  font-size: 20px;
  font-weight: 700;
  color: #262A2A;
  margin-bottom: 5px;
}
.toggle-content-view p {
  color: #6F6F6F;
  font-size: 14px;
}

.details-propsal h4 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 24px;
}
.details-propsal h6 {
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 12px;
}
.details-propsal h3 {
  color: #3C2371;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
}
.details-propsal span {
  color: #6F6F6F;
  font-size: 14px;
  display: block;
}
.details-propsal.details-propsals ul li {
  width: 33.3%;
}
.details-propsal ul {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  border-bottom: 1px solid #E8E8E8;
  margin-bottom: 20px;
}
.details-propsal ul li {
  width: 25%;
  margin-bottom: 10px;
}
.details-propsal ul li h5 {
  color: #565E5E;
  font-weight: 400;
  margin-bottom: 5px;
}
.details-propsal ul li h6 {
  color: #262A2A;
  font-weight: 400;
}
.details-propsal ul li img {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  border-radius: 5px;
}
.details-propsal ul li .btn {
  padding: 3px 15px;
}

.attached-div h5 {
  font-size: 16px;
  margin-bottom: 12px;
}

.attached-div {
  padding-bottom: 15px;
}

.attachement-download {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #E8E8E8;
  padding: 15px;
  border-radius: 5px;
  margin-bottom: 12px;
}

.attachement-download-icon span {
  background: #E41F07;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  color: #fff;
  border-radius: 5px;
}

.attachement-download-img {
  display: flex;
  align-items: center;
}

.attachement-download-content {
  margin-left: 10px;
}
.attachement-download-content h5 {
  font-size: 14px;
  margin-bottom: 3px;
  font-weight: 600;
}
.attachement-download-content h6 {
  font-size: 14px;
  font-weight: 400;
}

.table-view {
  margin-bottom: 24px;
  border: 1px solid #E8E8E8;
  border-radius: 10px;
}
.table-view th {
  background: #E8E8E8;
}

.table-view {
  margin-bottom: 24px;
  border: 1px solid #E8E8E8;
  border-radius: 10px;
}
.table-view th {
  background: #E8E8E8;
}

.subtotal-div {
  background: #F9F9FC;
  padding: 24px;
}
.subtotal-div ul li {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.subtotal-div ul li h5 {
  font-size: 14px;
  color: #6F6F6F;
  font-weight: 400;
  margin: 0;
}
.subtotal-div ul li h6 {
  font-size: 16px;
  color: #262A2A;
  font-weight: 600;
  margin: 0;
}
.subtotal-div ul li + li {
  margin-top: 15px;
}

.terms-condition {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #E8E8E8;
}
.terms-condition h2 {
  font-size: 14px;
  font-weight: 600;
  color: #262A2A;
  margin-bottom: 15px;
}
.terms-condition p {
  color: #6F6F6F;
  font-size: 14px;
  padding-bottom: 15px;
}

.contact-type h6 {
  font-weight: 600;
}
.contact-type ul {
  border: 0;
  display: inline;
}
.contact-type ul li {
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 5px;
}
.contact-type ul li h5 {
  position: relative;
  width: 40%;
  color: #6F6F6F;
  font-size: 14px;
  margin: 0;
}
.contact-type ul li h5:after {
  position: absolute;
  content: ":";
  right: 8px;
  top: 0px;
}
.contact-type ul li h6 {
  position: relative;
  width: 60%;
  color: #262A2A;
  font-size: 14px;
  margin: 0;
}

.renewal-history h4 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 15px;
}

.renewal-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border: 1px solid #E8E8E8;
  padding: 24px;
  box-shadow: 0px 4px 74px 0px rgba(208, 208, 208, 0.2509803922);
  border-radius: 5px;
  margin-bottom: 15px;
}
.renewal-content .renewal-content-history {
  width: 80%;
}
.renewal-content .contact-type h6 {
  color: #424848;
  margin-bottom: 15px;
}
.renewal-content .contact-type ul {
  flex-wrap: wrap;
  display: flex;
}
.renewal-content .contact-type ul li {
  width: 50%;
}
.renewal-content .contact-type ul li h6 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
}
.renewal-content .contact-type ul li h5 {
  font-size: 14px;
  font-weight: 400;
}

.toogle-header-select .select2-container {
  min-width: 150px !important;
}
.toogle-header-select .select2-container--default .select2-results__option--selected {
  color: #fff;
}
.toogle-header-select .toggle-btn {
  min-width: 26px;
}

.btn-downloads {
  font-size: 14px !important;
  border: 1px solid #E8E8E8;
  padding: 10px 15px;
  color: #262A2A !important;
  font-weight: 500;
  border-radius: 5px;
}
.btn-downloads:hover {
  background: #E41F07;
  color: #FFF !important;
}

.input-table.input-table-descripition input {
  width: 130px;
}
.input-table input {
  border: 1px solid #E8E8E8;
  height: 30px;
  border-radius: 5px;
  width: 75px;
  padding: 5px;
}
.input-table select {
  border: 1px solid #E8E8E8;
  height: 30px;
  border-radius: 5px;
  width: 75px;
}

.upload-signature {
  position: relative;
}
.upload-signature input {
  width: 100%;
  height: 42px;
  opacity: 0;
  z-index: 9;
}
.upload-signature a {
  border: 1px dashed #E8E8E8;
  border-radius: 5px;
  position: absolute;
  width: 100%;
  height: 42px;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  color: #6F6F6F;
  left: 0;
  padding: 10px;
  background: #fff;
}

.toggle-header-popup .btn-dropdowns {
  min-width: 125px;
  border: 1px solid #E8E8E8;
  padding: 8px 12px;
  font-size: 14px !important;
  color: #6F6F6F !important;
}
.toggle-header-popup .btn-dropdowns.dropdown-toggle:after {
  top: -2px;
  position: relative;
  font-size: 12px;
}
.toggle-header-popup .btn-dropdowns.dropdown-toggle-contract {
  min-width: 150px;
}
.toggle-header-popup .btn-dropdowns:hover {
  color: #FFF !important;
  background: #E41F07;
}
.toggle-header-popup .btn-dropdowns:active, .toggle-header-popup .btn-dropdowns:focus {
  color: #FFF !important;
}
.toggle-header-popup .dropdown-item {
  font-size: 14px !important;
  color: #6F6F6F !important;
}

.toggle-popup-sent .sidebar-layout .sidebar-header a, .toggle-popup-draft .sidebar-layout .sidebar-header a, .toggle-popup-declined .sidebar-layout .sidebar-header a {
  font-size: 14px;
  color: #fff;
}

.signature-contant {
  padding: 15px 0;
  border-top: 1px solid #E8E8E8;
  border-bottom: 1px solid #E8E8E8;
}
.signature-contant p {
  color: #B5B5B5;
  margin: 0;
}

.pay-now .btn {
  height: 42px;
}

.sidebar .sidebar-inner {
  width: 100% !important;
}

.activities-list ul li {
  background: #F6F6F6;
  padding: 15px 10px;
  margin-bottom: 20px;
}
.activities-list ul li:last-child {
  margin-bottom: 0;
}
.activities-list ul li .activity-name h5 {
  font-size: 14px;
  font-weight: 500;
  color: #262A2A;
  margin-bottom: 5px;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
}
.activities-list ul li .activity-name p {
  font-size: 14px;
  margin-bottom: 15px;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
}
.activities-list ul li .activity-name .badge {
  color: #FFF;
  padding: 5px 7px;
  font-size: 12px;
  border-radius: 5px;
}
.activities-list ul li .activity-name .badge i {
  margin-right: 5px;
}
.activities-list ul li .user-activity {
  display: flex;
  align-items: center;
}
@media (max-width: 767.98px) {
  .activities-list ul li .user-activity {
    margin: 20px 0;
  }
}
.activities-list ul li .user-activity span {
  flex-shrink: 0;
  display: inline-flex;
  margin-right: 5px;
}
.activities-list ul li .user-activity span img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
}
.activities-list ul li .user-activity h6 {
  margin-bottom: 0;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
}

@media (max-width: 575.98px) {
  .card-select ul {
    align-items: start !important;
  }
}

.campaign-card {
  overflow-x: auto;
}
.campaign-card ul {
  width: max-content;
}
.campaign-card ul .campaign-wrap {
  background-color: #F9F9FC;
  margin: 0 0 15px;
  padding: 15px 15px 5px;
}
.campaign-card ul .campaign-wrap .campaign-info {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  white-space: nowrap;
  border-bottom: 1px solid #E8E8E8;
  margin: 0 0 15px 0;
}
.campaign-card ul .campaign-wrap .campaign-info h5 {
  font-weight: 600;
  margin-bottom: 5px;
}
.campaign-card ul .campaign-wrap .campaign-info .campaign-name {
  margin: 0 50px 10px 0;
}
.campaign-card ul .campaign-wrap .campaign-info .list-progress {
  margin-bottom: 10px;
}
.campaign-card ul .campaign-wrap .campaign-action {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  flex-wrap: wrap;
}
.campaign-card ul .campaign-wrap .campaign-action .project-mem {
  margin-bottom: 10px;
}
.campaign-card ul .campaign-wrap .campaign-date {
  margin-bottom: 10px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
}
.campaign-card ul .campaign-wrap .campaign-date .badge {
  margin: 0 15px 0 0;
}
.campaign-card ul .campaign-wrap:last-child {
  margin-bottom: 0;
}

.priority.badge-tag {
  color: #262A2A;
  min-width: 80px;
  text-align: left;
  font-weight: 600;
}
.priority.badge-tag i {
  margin-right: 4px;
}
.priority.badge-tag.badge-danger-light i {
  color: #FC0027;
}
.priority.badge-tag.badge-success-light i {
  color: #5CB85C;
}
.priority.badge-tag.badge-warning-light i {
  color: #FDA700;
}

.task-wrap {
  border: 1px solid #E8E8E8;
  margin: 0 0 10px;
  padding: 15px 15px 5px;
  position: relative;
  border-radius: 5px;
}
.task-wrap::before {
  content: "";
  background-color: #FC0027;
  width: 3px;
  height: 100%;
  border-radius: 5px;
  position: absolute;
  top: 0;
  left: 0;
}
.task-wrap:last-child {
  margin-bottom: 0;
}

.task-info {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  flex-wrap: wrap;
}
.task-info p {
  display: inline-block;
  margin: 0 24px 10px 0;
  color: #262A2A;
}
.task-info p i {
  color: #6F6F6F;
  margin-right: 10px;
}
.task-info .badge {
  margin: 0 10px 10px 0;
}
.task-info .badge:last-child {
  margin-right: 0;
}
.task-info .badge.badge-pill i {
  margin-right: 5px;
}

.task-actions {
  float: right;
}
.task-actions ul {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  flex-wrap: wrap;
}
.task-actions ul li {
  margin: 0 24px 10px 0;
  color: #262A2A;
}
.task-actions ul li:last-child {
  margin-right: 0;
}
.task-actions ul li.task-time i {
  margin-right: 5px;
}
.task-actions ul li.task-date i {
  margin-right: 5px;
}
.task-actions ul li.task-owner {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
}
.task-actions ul li.task-owner .task-user {
  margin-right: 10px;
  height: 24px;
}
.task-actions ul li.task-owner .task-user img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}
@media (max-width: 767.98px) {
  .task-actions {
    float: left;
  }
}

.select-priority {
  position: relative;
}
.select-priority .select-icon {
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  z-index: 99999;
  color: #E41F07;
}
.select-priority .select2-container--default .select2-selection--single .select2-selection__rendered {
  padding-left: 30px;
}

.project-name {
  margin-bottom: 15px;
}
.project-name p {
  font-weight: 500;
  margin-bottom: 5px;
}
.project-name h4 {
  font-weight: 600;
}

.con-sidebar-title .priority {
  margin-bottom: 15px;
}
.con-sidebar-title p {
  font-weight: 500;
  color: #262A2A;
  margin-bottom: 15px;
}
.con-sidebar-title.border-line {
  border-bottom: 1px solid #E8E8E8;
  margin-bottom: 20px;
}

.kanban-list-items {
  border: 1px solid #E8E8E8;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
  border-radius: 5px;
  margin: 0 20px 20px 0;
  padding: 15px;
  width: 100%;
  min-width: 315px;
}
.kanban-list-items:last-child {
  margin-right: 0;
}

.icons-social a {
  width: 30px;
  height: 30px;
  background: #F6F6F6;
  border-radius: 50%;
  color: #262A2A;
}
.icons-social a:hover {
  background: #FFEEEC;
  color: #E41F07;
}

.kanban-drag-wrap > div:last-child .kanban-card {
  margin-bottom: 0;
}

.pipeline-progress .progress {
  background: transparent;
  width: 70px;
  height: 5px;
}
.pipeline-progress .progress .progress-bar {
  width: 70px;
  height: 5px;
  border-radius: 5px;
}
.pipeline-progress .progress .progress-bar.progress-bar-success {
  background: #5CB85C;
}
.pipeline-progress .progress .progress-bar.progress-bar-violet {
  background: #4A00E5;
}
.pipeline-progress .progress .progress-bar.progress-bar-info {
  background: #1ECBE2;
}
.pipeline-progress .progress .progress-bar.progress-bar-warning {
  background: #FDA700;
}
.pipeline-progress .progress .progress-bar.progress-bar-green {
  background: #00918E;
}
.pipeline-progress .progress .progress-bar.progress-bar-danger {
  background: #FC0027;
}
.pipeline-progress span {
  margin-left: 10px;
  color: #262A2A;
  font-weight: 500;
}

.pipe-title .add-stage {
  color: #E41F07;
  font-weight: 500;
  margin-bottom: 15px;
  display: inline-block;
}
.pipe-title .add-stage i {
  margin-right: 8px;
}

.priority-info .dropdown .dropdown-toggle {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  border: 1px solid #E8E8E8;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
  border-radius: 5px;
  padding: 5px 10px;
  font-weight: 500;
}
.priority-info .dropdown .dropdown-toggle[aria-expanded=true] > i {
  transition: all 0.2s ease;
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
}
.priority-info .dropdown .dropdown-toggle::after {
  content: none;
}
.priority-info .dropdown .dropdown-toggle span {
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.priority-info .dropdown .dropdown-toggle span i {
  font-size: 10px;
}
.priority-info .dropdown a {
  font-size: 14px;
  color: #262A2A;
}
.priority-info .dropdown a span {
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.priority-info .dropdown a span i {
  font-size: 10px;
}
.priority-info .dropdown .dropdown-menu {
  width: 100%;
}

.select-pipeline {
  position: relative;
  margin-right: 8px;
}
.select-pipeline .pipe-icon {
  position: absolute;
  top: 50%;
  left: 10px;
  z-index: 99999;
  transform: translateY(-50%);
  color: #262A2A;
}
.select-pipeline .select2-container .select2-selection.select2-selection--single {
  height: 40px;
  border-radius: 5px;
  color: #262A2A;
  font-weight: 500;
}
.select-pipeline .select2-container .select2-selection.select2-selection--single .select2-selection__rendered {
  padding-left: 30px;
  line-height: 40px;
  color: #262A2A;
  font-weight: 500;
  padding-right: 30px;
}
.select-pipeline .select2-container .select2-selection.select2-selection--single .select2-selection__arrow {
  height: 40px;
}

.pipeline-list {
  border-bottom: 1px solid #E8E8E8;
  margin-bottom: 15px;
}
.pipeline-list ul {
  margin-bottom: 15px;
}
.pipeline-list ul li {
  display: inline-block;
}
.pipeline-list ul li:first-child a {
  border-radius: 10px 0 0 10px;
}
.pipeline-list ul li:last-child a {
  border-radius: 0;
}
.pipeline-list ul li a {
  margin: 0 0 3px;
  padding: 12px 25px 12px 50px;
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
  text-align: center;
  background: #F6F6F6;
  color: #262A2A;
  position: relative;
  min-width: 185px;
}
.pipeline-list ul li a::after {
  content: "";
  position: absolute;
  top: 0;
  right: -23px;
  width: 45px;
  height: 45px;
  -webkit-transform: scale(0.707) rotate(45deg);
  -ms-transform: scale(0.707) rotate(45deg);
  -moz-transform: scale(0.707) rotate(45deg);
  -transform: scale(0.707) rotate(45deg);
  z-index: 1;
  background: #F6F6F6;
  box-shadow: 2px -2px 0 1px #fff, 3px -3px 0 2px rgba(255, 255, 255, 0.1);
  border-radius: 0 5px 0 50px;
}
.pipeline-list ul li a.bg-info {
  color: #FFF;
}
.pipeline-list ul li a.bg-info::after {
  background: #1ECBE2;
}
.pipeline-list ul li a.bg-info:hover {
  background: #1ECBE2 !important;
}
.pipeline-list ul li a.bg-warning {
  color: #FFF;
}
.pipeline-list ul li a.bg-warning::after {
  background: #FDA700;
}
.pipeline-list ul li a.bg-warning:hover {
  background: #FDA700 !important;
}
.pipeline-list ul li a.bg-pending {
  color: #FFF;
  background: #4A00E5 !important;
}
.pipeline-list ul li a.bg-pending::after {
  background: #4A00E5;
}
.pipeline-list ul li a.bg-pending:hover {
  background: #4A00E5 !important;
}
.pipeline-list ul li a.bg-pink {
  color: #FFF;
}
.pipeline-list ul li a.bg-pink::after {
  background: #EA00B7;
}
.pipeline-list ul li a.bg-pink:hover {
  background: #EA00B7 !important;
}
.pipeline-list ul li a.bg-success {
  color: #FFF;
}
.pipeline-list ul li a.bg-success::after {
  background: #5CB85C;
}
.pipeline-list ul li a.bg-success:hover {
  background: #5CB85C !important;
}
.pipeline-list ul li a.bg-danger {
  color: #FFF;
}
.pipeline-list ul li a.bg-danger::after {
  background: #FC0027;
}
.pipeline-list ul li a.bg-danger:hover {
  background: #FC0027 !important;
}
.pipeline-list ul li a.bg-gray {
  color: #FFF;
  background: #E0E2E7;
}
.pipeline-list ul li a.bg-gray::after {
  background: #E0E2E7;
}
.pipeline-list ul li a.bg-gray:hover {
  background: #E0E2E7 !important;
}
@media (max-width: 575.98px) {
  .pipeline-list ul li a {
    width: calc(100% - 25px);
  }
}
@media (max-width: 575.98px) {
  .pipeline-list ul li {
    display: block;
  }
}

.campaign-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin: 0 0 24px;
  padding: 24px;
  border-radius: 5px;
}
@media (max-width: 1399.98px) {
  .campaign-box {
    margin: 0 0 24px;
    padding: 15px;
  }
}
.campaign-box .campaign-img {
  display: flex;
  align-items: center;
}
.campaign-box .campaign-img span {
  width: 44px;
  height: 44px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #FFF;
  margin-right: 10px;
}
.campaign-box .campaign-img p {
  color: #262A2A;
  font-weight: 500;
}
.campaign-box h2 {
  color: #6F6F6F;
}
@media (max-width: 1399.98px) {
  .campaign-box h2 {
    font-size: 24px;
  }
}
@media (max-width: 991.98px) {
  .campaign-box h2 {
    font-size: 20px;
  }
}
.campaign-box.bg-danger-light {
  background-color: #FFEEEC;
}
.campaign-box.bg-danger-light span {
  background-color: #FC0027;
}
.campaign-box.bg-warning-light {
  background-color: #FFF7D8;
}
.campaign-box.bg-warning-light span {
  background-color: #FFA201;
}
.campaign-box.bg-purple-light {
  background-color: #F3EDFF;
}
.campaign-box.bg-purple-light span {
  background-color: #3C2371;
}
.campaign-box.bg-success-light {
  background-color: #E0F5D7;
}
.campaign-box.bg-success-light span {
  background-color: #00918E;
}

.campaign-tab {
  margin: 0 0 20px;
  padding: 15px 15px 0;
  box-shadow: 0px 4px 74px 0px rgba(208, 208, 208, 0.2509803922);
  background-color: #FFF;
  border-radius: 5px;
}
.campaign-tab ul li {
  margin-right: 15px;
}
.campaign-tab ul li a {
  position: relative;
  font-weight: 500;
  border-bottom: 4px solid #FFF;
  padding: 10px 10px 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.campaign-tab ul li a.active {
  border-color: #E41F07;
}
.campaign-tab ul li a span {
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border: 1px solid #E8E8E8;
  border-radius: 50%;
  margin-left: 10px;
  font-size: 10px;
  font-weight: 600;
  color: #6F6F6F;
}
.campaign-tab ul li:last-child {
  margin-right: 0;
}

ul.project-mem {
  display: inline-flex;
  align-items: center;
}
ul.project-mem li {
  margin-left: -10px;
  display: inline-flex;
}
ul.project-mem li a {
  width: 24px;
  height: 24px;
}
ul.project-mem li:first-child {
  margin-left: 0;
}
ul.project-mem li a img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid #FFF;
}
ul.project-mem li.more-set a {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #FFF;
  border: 1px solid #E8E8E8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  font-size: 12px;
  font-weight: 600;
  color: #6F6F6F;
}

.list-progress li {
  display: inline-block;
  margin-right: 15px;
}
.list-progress li h6 {
  font-weight: 600;
}
.list-progress li p {
  font-size: 12px;
  font-weight: 600;
  color: #6F6F6F;
}
.list-progress li:last-child {
  margin-right: 0;
}

.form-wrap .checkmarks.mem-plane-check {
  top: 3px;
}

.table-imgname.flag-image img {
  width: 24px;
  height: 18px;
  border-radius: 5px;
}

.table-imgname.flag-image {
  display: flex;
  align-items: center;
}

.location-flag-img {
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
}

.table-imgname.flag-image span {
  font-weight: 500;
  color: #262A2A;
}

#delete_request td span.badge {
  cursor: pointer;
}

.wh-14 {
  width: 14px;
  height: 14px;
}

/******* Vendors ******/
.select2-container {
  min-width: 100% !important;
  z-index: 99;
}
.select2-container .select2-selection--single {
  height: 40px;
}

.select2-container--default .select2-selection--single {
  border: 1px solid var(--Stroke, rgba(145, 158, 171, 0.3));
  border-radius: 5px;
}
.select2-container--default .select2-selection--single .select2-selection__rendered {
  color: #6F6F6F;
  line-height: 38px;
  border-radius: 5px;
  padding-left: 10px;
  font-size: 14px;
  font-weight: 400;
  padding-right: 25px;
}
.select2-container--default .select2-selection--single .select2-selection__rendered span {
  display: inline-flex;
  align-items: center;
}
.select2-container--default .select2-selection--single .select2-selection__rendered span img {
  width: 16px;
  height: 16px;
  border-radius: 5px;
  margin-right: 5px;
}
.select2-container--default .select2-selection--single .select {
  width: 219px;
}
.select2-container--default .select2-selection--single .select2-selection__arrow {
  height: 40px;
  right: 6px;
}

.select2-container--default .select2-selection--single .select2-selection__arrow b {
  position: absolute;
  top: 50%;
  left: 50%;
  border-color: #637381;
  border-style: solid;
  border-width: 0 2px 2px 0;
  padding: 3px;
  height: 0;
  margin-left: -6px;
  margin-top: -3px;
  width: 0;
  transform: rotate(45deg) translateY(-50%);
  -webkit-transform: rotate(45deg) translateY(-50%);
  -ms-transform: rotate(45deg) translateY(-50%);
}

.select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b {
  border-color: #000;
  border-width: 2px 0 0 2px;
  margin-top: 3px;
  padding: 3px;
}

.select2-container--default .select2-results__option--highlighted[aria-selected] {
  background: #E41F07;
  color: #FFF;
}

.select2-container--focus .select2-selection--single {
  background: #FFF !important;
  border-color: #E41F07;
}

span.select2-container.select2-container--default.select2-container--open {
  z-index: 9999;
}

.select2-container--default .select2-selection--single .select2-selection__rendered,
.select2-container--default .select2-selection--multiple {
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
}

.select2-container--classic .select2-selection--single,
.select2-container--default .select2-selection--single,
.select2-container--default .select2-selection--single .select2-selection__rendered,
.select2-container--default .select2-selection--single .select2-selection__arrow,
.select2-container--default .select2-selection--multiple,
.select2-container--classic .select2-selection--single .select2-selection__arrow,
.select2-container--classic .select2-selection--single .select2-selection__rendered {
  border-color: #E8E8E8;
  color: #6F6F6F;
  height: 40px;
  line-height: 40px;
}

.select2-container--default .select2-selection--multiple {
  line-height: 27px;
  height: auto;
  min-height: 40px;
}
.select2-container--default .select2-selection--multiple .select2-selection__choice {
  padding-left: 5px;
  padding-right: 20px;
}
.select2-container--default .select2-selection--multiple .select2-selection__choice__display span {
  display: inline-flex;
  align-items: center;
}
.select2-container--default .select2-selection--multiple .select2-selection__choice__display span img {
  width: 16px;
  height: 16px;
  border-radius: 5px;
  margin-right: 5px;
}
.select2-container--default .select2-selection--multiple .select2-selection__choice__remove {
  right: 0;
  left: auto;
}

.select2-results__option span {
  display: inline-flex;
  align-items: center;
}
.select2-results__option span img {
  width: 16px;
  height: 16px;
  border-radius: 5px;
  margin-right: 5px;
}

.select2-container--classic .select2-selection--multiple .select2-selection__choice,
.select2-container--default .select2-selection--multiple .select2-selection__choice,
.select2-container--default .select2-selection--multiple .select2-selection__choice__remove {
  background-color: #F6F6F6;
  border-color: #F6F6F6;
  color: #6F6F6F;
  border-radius: 5px;
}

.select2-container--default.select2-container--focus .select2-selection--multiple {
  border-color: #E8E8E8;
}

table.dataTable {
  margin: 0 !important;
  width: 100% !important;
}

table.dataTable > thead .sorting:after,
table.dataTable > thead .sorting_asc:after,
table.dataTable > thead .sorting_desc:after,
table.dataTable > thead .sorting_asc_disabled:after,
table.dataTable > thead .sorting_desc_disabled:after {
  right: 0.5em !important;
  content: "\\f175" !important;
  font-family: "Font Awesome 5 Free";
  bottom: 12px !important;
  color: #BABFC7 !important;
  font-size: 12px !important;
  opacity: 1 !important;
  position: absolute;
  font-weight: 600;
  line-height: 1px !important;
}

table.dataTable > thead .sorting:before,
table.dataTable > thead .sorting_asc:before,
table.dataTable > thead .sorting_desc:before,
table.dataTable > thead .sorting_asc_disabled:before,
table.dataTable > thead .sorting_desc_disabled:before {
  right: 13px !important;
  content: "\\f176" !important;
  font-family: "Font Awesome 5 Free";
  top: 50% !important;
  transform: translateY(-50%);
  color: #BABFC7 !important;
  font-size: 12px !important;
  opacity: 1 !important;
  position: absolute;
  font-weight: 600;
  line-height: 1px !important;
}

.dataTables_paginate .paging_numbers, #dataTables_paginate .paging_numbers {
  float: right;
}

.dataTables_info {
  padding-right: 15px;
  font-size: 12px;
  color: #424848;
  font-weight: 600;
}

.custom-select {
  min-width: 80px;
}

.dataTables_paginate .pagination, #dataTables_paginate .pagination {
  justify-content: end;
  -webkit-justify-content: end;
  -ms-flex-pack: end;
}
.dataTables_paginate .pagination li, #dataTables_paginate .pagination li {
  margin: 0 2px;
}
.dataTables_paginate .pagination li a, #dataTables_paginate .pagination li a {
  background: #FFF;
  border-color: transparent;
  border-radius: 5px !important;
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6F6F6F;
}
.dataTables_paginate .pagination li a:hover, #dataTables_paginate .pagination li a:hover {
  background: #00918E;
  color: #FFF;
}
.dataTables_paginate .pagination li.active a.page-link, #dataTables_paginate .pagination li.active a.page-link {
  background: #00918E;
  border-color: #00918E;
  border-radius: 5px;
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dataTables_paginate .pagination li.previous.disabled, .dataTables_paginate .pagination li.previous, #dataTables_paginate .pagination li.previous.disabled, #dataTables_paginate .pagination li.previous {
  width: auto;
  margin: 0 13px 0 0;
}
.dataTables_paginate .pagination li.previous.disabled a, .dataTables_paginate .pagination li.previous a, #dataTables_paginate .pagination li.previous.disabled a, #dataTables_paginate .pagination li.previous a {
  background-color: transparent;
  border: 0;
  width: auto;
  padding: 0;
}
.dataTables_paginate .pagination li.previous.disabled a i, .dataTables_paginate .pagination li.previous a i, #dataTables_paginate .pagination li.previous.disabled a i, #dataTables_paginate .pagination li.previous a i {
  margin-right: 8px;
}
.dataTables_paginate .pagination li.previous.disabled a:hover, .dataTables_paginate .pagination li.previous a:hover, #dataTables_paginate .pagination li.previous.disabled a:hover, #dataTables_paginate .pagination li.previous a:hover {
  color: #00918E;
}
.dataTables_paginate .pagination li.next.disabled, .dataTables_paginate .pagination li.next, #dataTables_paginate .pagination li.next.disabled, #dataTables_paginate .pagination li.next {
  width: auto;
  margin: 0 0 0 13px;
}
.dataTables_paginate .pagination li.next.disabled a, .dataTables_paginate .pagination li.next a, #dataTables_paginate .pagination li.next.disabled a, #dataTables_paginate .pagination li.next a {
  background-color: transparent;
  border: 0;
  width: auto;
  padding: 0;
}
.dataTables_paginate .pagination li.next.disabled a i, .dataTables_paginate .pagination li.next a i, #dataTables_paginate .pagination li.next.disabled a i, #dataTables_paginate .pagination li.next a i {
  margin-left: 8px;
}
.dataTables_paginate .pagination li.next.disabled a:hover, .dataTables_paginate .pagination li.next a:hover, #dataTables_paginate .pagination li.next.disabled a:hover, #dataTables_paginate .pagination li.next a:hover {
  color: #00918E;
}
@media (max-width: 767.98px) {
  .dataTables_paginate .pagination, #dataTables_paginate .pagination {
    justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
  }
}

.dataTables_length, #dataTables_length .dataTables_paginate,
#dataTables_paginate {
  margin-top: 15px !important;
}

.dataTables_length label, #dataTables_length label {
  display: flex;
  align-items: center;
  color: #6F6F6F;
  font-size: 14px;
}
.dataTables_length label .form-select, #dataTables_length label .form-select {
  width: 73px;
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  color: #262A2A;
  margin: 0 8px;
}
@media (max-width: 767.98px) {
  .dataTables_length label, #dataTables_length label {
    justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    margin-bottom: 10px;
  }
}

@media (max-width: 767.98px) {
  .datatable-length {
    text-align: center;
  }
}

div.dataTables_wrapper div.dataTables_info {
  padding-top: 23px;
}

table.dataTable thead > tr > th.no-sort.sorting_asc:before {
  display: none;
}

table.dataTable thead > tr > th.no-sort.sorting_asc::after {
  display: none;
}

table.dataTable thead > tr > th.no-sort.sorting:before {
  display: none;
}

table.dataTable thead > tr > th.no-sort.sorting::after {
  display: none;
}

.custom-table .table-responsive {
  border: 1px solid #E8E8E8;
  border-radius: 6px;
}

table.table.dataTable > tbody > tr {
  border-color: #E8E8E8;
}
table.table.dataTable > tbody > tr td {
  color: #6F6F6F;
}
table.table.dataTable > thead > tr {
  border-color: #E8E8E8;
}
table.table.dataTable > thead > tr th {
  color: #262A2A;
  font-size: 14px;
  font-weight: 500;
}

.active > .page-link, .page-link.active {
  z-index: unset;
}

a {
  text-decoration: none;
  color: #262a2a;
}

.ant-tooltip {
  display: none;
}

.data-table-card .ant-table-content .ant-table-tbody tr:nth-of-type(2n + 1) {
  background-color: #fff;
}
.data-table-card .ant-table-content .ant-table-tbody td {
  padding: 0.5rem;
}

.ant-table-cell-row-hover {
  background-color: #fff;
  background: #fff;
}

.ant-pagination-item.ant-pagination-item-1.ant-pagination-item-active {
  background: #00918e;
  border-color: #00918e;
  color: #fff;
}

h4,
.h4 {
  font-size: 1.125rem;
}

.daterangepicker td.active,
.daterangepicker td.active:hover {
  background-color: #00918e;
  color: #fff;
}

.daterangepicker .calendar-table td.in-range {
  background-color: #fff;
}

.applyBtn.btn.btn-sm.btn-primary {
  color: #fff;
  background-color: #00918e;
  border: 1px solid #00918e;
}

.css-1u9des2-indicatorSeparator {
  display: none;
}

div .badge-status {
  border-radius: 5px;
  font-size: 12px;
  padding: 4px 8px;
  min-width: 64px;
  color: #FFF;
}

div .bg-success {
  background-color: #5CB85C !important;
}
div .bg-success.bg-opacity-10 {
  background-color: rgba(92, 184, 92, 0.1) !important;
}
div .bg-success.bg-opacity-25 {
  background-color: rgba(92, 184, 92, 0.25) !important;
}
div .bg-success.bg-opacity-50 {
  background-color: rgba(92, 184, 92, 0.5) !important;
}
div .bg-success.bg-opacity-75 {
  background-color: rgba(92, 184, 92, 0.75) !important;
}
div .bg-success.bg-opacity-100 {
  background-color: #5cb85c !important;
}

:where(.css-dev-only-do-not-override-djtmh8).ant-table-wrapper .ant-table-tbody .ant-table-row.ant-table-row-selected > .ant-table-cell {
  background-color: #fff;
}

.css-1p3m7a8-multiValue {
  background-color: #f6f6f6;
  border-color: #f6f6f6;
  color: #6f6f6f;
  border-radius: 5px;
}

.stickybar {
  top: 0;
  position: sticky;
}

.select-details .css-1dimb5e-singleValue,
.select-details .css-1jqq78o-placeholder {
  padding-left: 15px;
}

div.css-13cymwt-control,
div.css-t3ipsp-control {
  min-width: 120px;
  border-color: #e8e8e8;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
  height: 41px;
  border-radius: 5px;
}

div.css-t3ipsp-control:hover {
  border-color: transparent;
}

span.p-dropdown-label.p-inputtext span {
  font-family: "Noto Sans", sans-serif;
}

.deals-details.react-datepicker__input-container {
  width: 450px !important;
}

div.react-datepicker-wrapper {
  display: block;
  padding: 0;
  border: 0;
}

span.form-icon {
  z-index: 1;
}

.img-checked {
  padding: 10px;
  background: rgb(49, 132, 199);
  color: white;
  border-radius: 20px;
  font-weight: bolder;
  position: relative;
  /* margin-top: 2px ; */
}

.section-notes-slider .notes-slider .slick-list .slick-slide div {
  margin-left: 12px !important;
}

.page-add-notes {
  display: flex;
  flex-wrap: wrap;
}

.visible .input-blocks .css-b62m3t-container .css-1dimb5e-singleValue {
  margin-left: 25px !important;
}

[data-layout-mode=dark_mode] .css-13cymwt-control {
  background-color: #1d1d42;
  border: 1px solid #67748E;
}

[data-layout-mode=dark_mode] .css-t3ipsp-control {
  background-color: #1d1d42;
}

[data-layout-mode=dark_mode] .css-1nmdiq5-menu {
  background-color: #1d1d42;
}

.form-sorts.dropdown .radio-btn-items {
  margin-top: 10px;
}

.select__control {
  background-color: #e41f07 !important;
  border-color: #e41f07 !important;
}

.select__control:hover {
  border-color: #e41f07 !important;
}

.p-dropdown-label.p-inputtext .p-d-flex.p-ai-center img,
.p-dropdown-item-label .p-d-flex.p-ai-center,
.p-dropdown-label.p-inputtext .p-clearfix img,
.p-dropdown-item-label .p-clearfix img {
  width: 16px;
  height: 16px;
  border-radius: 5px;
  margin-right: 5px;
}

.p-d-flex.p-ai-center {
  display: flex;
  align-items: center;
}

.p-dropdown-items-wrapper ul.p-dropdown-items,
.p-dropdown-panel.p-component.p-ripple-disabled.p-connected-overlay-enter-done {
  z-index: 100000000000 !important;
}

.swiper-container .slick-list {
  margin-left: -236px;
}

.p-dropdown.p-component.p-inputwrapper {
  height: 42px;
  line-height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-color: #e8e8e8;
  color: #6f6f6f;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
}

div.p-clearfix {
  display: flex;
  align-items: center;
}

div.p-clearfix span,
span.p-dropdown-label.p-inputtext.p-placeholder {
  font-size: 14px;
}

.p-dropdown-trigger svg {
  width: 13px;
}

div.rti--container {
  border-color: #e8e8e8;
  color: #6f6f6f;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
}

span.rti--tag button {
  font-size: 10px;
}

.filter-dropdown-menu.dropdown-menu.dropdown-menu-md-end.show,
.filter-dropdown-menu.dropdown-menu {
  z-index: 11;
}

span.ant-picker-suffix {
  display: none !important;
}

.stickybar {
  position: sticky;
  top: 0;
}

.right-user-side.chat-rooms.theiaStickySidebar {
  max-height: 500px;
  overflow: auto;
}

.send-chat.comman-icon i.feather.feather-send {
  color: #fff;
}

.chat-footer form {
  background-color: #fff;
}

.nav.flex-column.nav-pills.todo-inbox i {
  margin-right: 10px;
}

.select-priority .css-1jqq78o-placeholder,
.select-priority .css-1dimb5e-singleValue {
  padding-left: 15px;
}

.form-sort .css-1jqq78o-placeholder,
.form-sort .css-1dimb5e-singleValue {
  padding-left: 20px;
}

.form-sort.select-bluk.space-not-select .css-1jqq78o-placeholder,
.form-sort.select-bluk.space-not-select .css-1dimb5e-singleValue {
  padding: 0;
}

.owl-carousel.folders-carousel.owl-theme .slick-slide > div,
.owl-carousel.files-carousel.owl-theme .slick-slide > div {
  margin-right: 10px;
}

[data-theme=dark] .ant-table-content table,
[data-theme=dark] .ant-table-thead tr th,
[data-theme=dark] .ant-pagination.ant-table-pagination.ant-table-pagination-right {
  background-color: #171724;
  color: #a3a6a6;
}

[data-theme=dark] .table tbody tr td .table-avatar a,
[data-theme=dark] td.ant-table-cell {
  color: #a3a6a6;
}

td .badge-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.rsw-editor select {
  display: none;
}

.custom-table {
  border: 1px solid #e8e8e8;
  border-radius: 6px;
}

.join-contents .slick-slider div.slick-slide > div {
  margin-right: 10px;
}

.custom-react-clr {
  color: #6f6f6f;
}

div.popover {
  z-index: 9999;
}

div.rc-slider-track,
.rc-slider-tracks {
  background-color: #ed5565;
}

div.rc-slider-handle {
  border: solid 2px #ed5565;
}

span.rc-slider-dot-active {
  border-color: #ed5565;
}

div.rc-slider-handle:active {
  border-color: #ed5565;
  box-shadow: 0 0 5px #ed5565;
  cursor: grabbing;
}

.rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging {
  border-color: #ed5565;
  box-shadow: 0 0 0 5px #ed5565;
}

div.rc-slider-handle:hover {
  border-color: #ed5565;
}

div.rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging {
  border-color: #ed5565;
  box-shadow: 0 0 0 5px #ed5565;
}

[data-theme=dark] :where(.css-dev-only-do-not-override-11xg00t).ant-table-wrapper .ant-table-tbody .ant-table-row > .ant-table-cell-row-hover {
  background-color: #171724;
}
[data-theme=dark] :where(.css-dev-only-do-not-override-11xg00t).ant-table-wrapper .ant-table-tbody > tr > th,
[data-theme=dark] :where(.css-dev-only-do-not-override-11xg00t).ant-table-wrapper .ant-table-tbody > tr > td {
  border-color: #393947;
}
[data-theme=dark] :where(.css-11xg00t).ant-table-wrapper .ant-table-tbody .ant-table-row > .ant-table-cell-row-hover {
  background: #171724;
}
[data-theme=dark] :where(.css-dev-only-do-not-override-11xg00t).ant-table-wrapper .ant-table-thead th.ant-table-column-has-sorters:hover {
  background: #171724;
}
[data-theme=dark] .custom-table {
  border: 1px solid #393947;
}
[data-theme=dark] .css-13cymwt-control {
  background-color: #171724;
  border: 1px solid #393947;
}
[data-theme=dark] .react-datepicker__month-container,
[data-theme=dark] .react-datepicker__header {
  background-color: #393947;
}
[data-theme=dark] .css-t3ipsp-control {
  background: #171724;
  border: 1px solid #393947;
  color: #a3a6a6;
}
[data-theme=dark] .css-1dimb5e-singleValue {
  color: #a3a6a6;
}
[data-theme=dark] .css-b62m3t-container div.css-1nmdiq5-menu {
  background-color: #393947 !important;
}
[data-theme=dark] .react-select-29-listbox {
  background-color: #393947;
}
[data-theme=dark] .input-blocks input[type=text] {
  background: #1d1d42 !important;
}
[data-theme=dark] .p-dropdown.p-component.p-inputwrapper {
  background-color: #171724;
  border: 1px solid #393947;
  box-shadow: none;
}
[data-theme=dark] .p-dropdown-item {
  background-color: #171724;
  border: 1px solid #393947;
}
[data-theme=dark] .rti--container {
  background-color: #171724;
  border: 1px solid #393947;
  box-shadow: none;
}
[data-theme=dark] .rti--tag {
  background-color: #171724;
}
[data-theme=dark] .rti--input {
  background-color: #171724;
}

[data-sidebar=green] .clinicdropdown.theme a {
  background-color: #005351;
}

[data-sidebar=blue] .clinicdropdown.theme a {
  background-color: #2f0093;
}

[data-sidebar=dark] .clinicdropdown.theme a {
  background-color: #28283e;
}

[data-theme=dark] .header .header-left .logo img.white-logo {
  display: block;
}

[data-theme=dark] .chat-footer form {
  background-color: #28283e;
}

[data-theme=dark] .sidebar .sidebar-menu .clinicdropdown.theme a {
  background-color: #28283e;
}

[data-theme=dark] .rsw-toolbar {
  background: grey;
}

div.css-b62m3t-container .react-select__option--is-focused {
  background-color: #e41f07;
  color: #fff;
}

div.css-b62m3t-container .react-select__option--is-selected {
  background-color: #e41f07;
  color: #fff;
}

.submenu .ti-ticket:before {
  content: "\\eb3d";
}

.form-icon .ti-search:before {
  content: "\\eb1c";
}

.form-icon .ti-calendar:before {
  content: "\\ea53";
}

i.ti-trash:before {
  content: "\\eb41";
}

[data-theme=dark] .header .header-left #toggle_btn {
  color: #fff;
}

i.ti-lock:before {
  content: "\\eae2";
}

i.ti-bell:before {
  content: "\\ea35";
}

[data-theme=dark] .login-wrapper .form-control {
  background-color: #ffffff;
  border-color: #e8e8e8;
}

[data-theme=dark] div.css-13cymwt-control,
[data-theme=dark] div.css-t3ipsp-control {
  border-color: none;
  box-shadow: none;
}

.mini-sidebar.expand-menu .subdrop ~ ul {
  display: block !important;
}

.mini-sidebar .subdrop ~ ul {
  display: none !important;
}

.sidebar .sidebar-menu > ul li .submenu.submenu-two > ul li a {
  margin-left: 30px;
}

.ti.ti-eye:before {
  content: "\\ea9a";
}

.ti.ti-user:before {
  content: "\\eb4d";
}

div.sidebar-themesettings .input-themeselect input[type=radio]:checked ~ label .checkboxs-theme::before {
  content: "\\f00c";
  font-family: "Font Awesome 5 Free";
  color: #fff;
  font-weight: 700;
  font-size: 10px;
  right: 4px;
  position: absolute;
  top: -16px;
  z-index: 9;
}

.ti-check:before {
  content: "\\ea5e" !important;
}

.ti-arrow-down:before {
  content: "\\ea16" !important;
}

.select-pipeline .react-select__value-container {
  padding-left: 28px !important;
}

.modal-open .offcanvas.offcanvas-end {
  width: 700px !important;
}

.ant-table {
  font-family: "Noto Sans", sans-serif !important;
}

.ti-shield:before {
  content: "\\eb24" !important;
}`, "",{"version":3,"sources":["webpack://./src/index.scss","webpack://./src/style/scss/main.scss","webpack://./src/style/scss/layout/_common.scss","webpack://./src/style/scss/utils/_variables.scss","webpack://./src/style/scss/utils/_mixins.scss","webpack://./src/style/scss/layout/_content.scss","webpack://./src/style/scss/layout/_header.scss","webpack://./src/style/scss/layout/_sidebar.scss","webpack://./src/style/scss/layout/_theme.scss","webpack://./src/style/scss/layout/_theme-settings.scss","webpack://./src/style/scss/layout/_notification.scss","webpack://./src/style/scss/components/_avatar.scss","webpack://./src/style/scss/components/_boostrap.scss","webpack://./src/style/scss/components/_button.scss","webpack://./src/style/scss/components/_badge.scss","webpack://./src/style/scss/components/_border.scss","webpack://./src/style/scss/components/_calendar.scss","webpack://./src/style/scss/components/_chart.scss","webpack://./src/style/scss/components/_call.scss","webpack://./src/style/scss/components/_chat.scss","webpack://./src/style/scss/components/_dropdown.scss","webpack://./src/style/scss/components/_email.scss","webpack://./src/style/scss/components/_file-manager.scss","webpack://./src/style/scss/components/_icons.scss","webpack://./src/style/scss/components/_progress.scss","webpack://./src/style/scss/components/_pagination.scss","webpack://./src/style/scss/components/_typography.scss","webpack://./src/style/scss/components/_alerts.scss","webpack://./src/style/scss/components/_popovers.scss","webpack://./src/style/scss/components/_forms.scss","webpack://./src/style/scss/components/_notes.scss","webpack://./src/style/scss/components/_todo.scss","webpack://./src/style/scss/components/_tables.scss","webpack://./src/style/scss/components/_accordion.scss","webpack://./src/style/scss/components/_breadcrumb.scss","webpack://./src/style/scss/components/_cards.scss","webpack://./src/style/scss/components/_tooltips.scss","webpack://./src/style/scss/components/_navs-tabs.scss","webpack://./src/style/scss/components/_ribbon.scss","webpack://./src/style/scss/components/_popup.scss","webpack://./src/style/scss/components/_grid.scss","webpack://./src/style/scss/base/_base.scss","webpack://./src/style/scss/base/_background.scss","webpack://./src/style/scss/pages/_contact.scss","webpack://./src/style/scss/pages/_dashboard.scss","webpack://./src/style/scss/pages/_error.scss","webpack://./src/style/scss/pages/_login.scss","webpack://./src/style/scss/pages/_settings.scss","webpack://./src/style/scss/pages/_report.scss","webpack://./src/style/scss/pages/_activity.scss","webpack://./src/style/scss/pages/_tasks.scss","webpack://./src/style/scss/pages/_analytics.scss","webpack://./src/style/scss/pages/_project.scss","webpack://./src/style/scss/pages/_leads.scss","webpack://./src/style/scss/pages/_campaign.scss","webpack://./src/style/scss/pages/_membership-plans.scss","webpack://./src/style/scss/vendors/_select2.scss","webpack://./src/style/scss/vendors/_datatables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB,oBAAA;AAKA,qBAAA;ACLA;EACI,UAAA;EACA,WAAA;EACA,8BAAA;AFcJ;;AEZA;EACI,mBCqKO;AHtJX;;AEbA;EACI,mBCWM;AHKV;;AEdA;EACI,mBC+JO;AH9IX;;AEdI;EACI,eCwVO;AHvUf;;AEdA;EACI,wBAAA;AFiBJ;;AEfA;EAAU,yBAAA;AFmBV;;AEjBA;EACI,yBAAA;AFoBJ;;AEhBQ;EACI,qBCwIA;AHrHZ;;AEdI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,mBCzBE;ED0BF,6BAAA;EACA,WAAA;EACA,WCLA;EDMA,gBCtCe;EDuCf,UAAA;AFiBR;AEhBQ;EACI,mBCuNE;AHrMd;;AEdA;EACI,UAAA;EACA,WAAA;EACA,8BAAA;AFiBJ;;AEfA;EACI,mBC6GO;AH3FX;;AEhBA;EACI,mBC7CM;AHgEV;;AEjBA;EACI,mBCuGO;AHnFX;;AEjBI;EACI,eCgSO;AH5Qf;;AEjBA;EACI,wBAAA;AFoBJ;;AElBA;EACI,yBAAA;AFqBJ;;AEnBA;EACI,yBAAA;AFsBJ;;AEjBQ;EACI,qBC8EA;AH1DZ;;AEhBA;EACI,kBAAA;AFmBJ;AElBI;EACI,yBAAA;EACA,kBAAA;EACA,6DAAA;EACA,gBCvDA;EDwDA,gBCzFa;ED4Fb,oBAAA;EAGA,mBAAA;EEDL,iBFEmC;AFoBtC;AIjFI;EFiDA;IEUD,iBFIuC;EFsBxC;AACF;AErBQ;EACI,iBAAA;AFuBZ;AErBQ;EACI,cCyJE;AHlId;AErBQ;EACI,yBAAA;AFuBZ;AI/FI;EFiDA;IA0BQ,WAAA;EFwBV;AACF;AEtBI;EACI,aAAA;EACA,kBAAA;EACA,gBCnFA;EDoFA,yBAAA;EACA,8DAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,QAAA;EACA,SAAA;AFwBR;AIhHI;EF8EA;IAYQ,gBAAA;EF0BV;AACF;AIrHI;EF8EA;IAeQ,YAAA;IACA,OAAA;EF4BV;AACF;AEzBQ;EACI,cAAA;EACA,UAAA;AF2BZ;AExBI;EAGI,aAAA;EAGA,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;AF0BR;AEzBQ;EACI,mBAAA;AF2BZ;AE1BY;EACI,iBAAA;AF4BhB;AIjJI;EFkHI;IAMQ,eCkMD;EHrKb;AACF;AE3BQ;EACI,cC5HH;ED6HG,mBAAA;AF6BZ;AE5BY;EACI,cCxJN;AHsLV;AE1BI;EACI,mBAAA;AF4BR;AE1BY;EACI,aAAA;EACA,mBAAA;EACA,cCLL;EDMK,gBC5KO;ED6KP,kBAAA;EACA,kBAAA;AF4BhB;AE3BgB;EACI,gBAAA;EACA,kCAAA;EE7FlB,kBF8FoC;EE7FpC,QF6F8C;EE1F9C,OF0F+D;EEnI/D,2BFoIqC;EEnIrC,mCFmIqC;EElIrC,+BFkIqC;EACnB,eCsKL;AHrIf;AE/BgB;EACI,kBAAA;AFiCpB;AEhCoB;EACI,gBAAA;AFkCxB;AE3BQ;EACI,iBAAA;EACA,eCwJG;EDvJH,gBCnMW;EDoMX,kBAAA;EACA,WAAA;AF6BZ;AIhMI;EF8JI;IAOQ,kBAAA;EF+Bd;AACF;AE7BQ;EACI,mBCrDA;EDsDA,yBAAA;AF+BZ;;AE3BA;EAGI,aAAA;EAGA,mBAAA;EACA,eAAA;EACA,mBAAA;AF8BJ;AE7BI;EACI,qBAAA;AF+BR;AE9BQ;EACI,eAAA;AFgCZ;;AE3BI;EACI,mBC9EI;ED+EJ,kBAAA;EACA,aAAA;EACA,gBAAA;AF8BR;AE7BQ;EACI,mBAAA;AF+BZ;AE9BY;EACI,eAAA;AFgChB;AE7BQ;EACI,iBAAA;EACA,gBAAA;EACA,cAAA;AF+BZ;AE9BY;EACI,UAAA;EACA,mBCzON;ED0OM,WAAA;AFgChB;AE9BY;EACI,4CAAA;EACA,kBAAA;AFgChB;AE9BY;EACI,mBCjPN;EDkPM,kBAAA;AFgChB;AE9BY;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;AFgChB;AE/BgB;EACI,gBAAA;AFiCpB;AE/BgB;EACI,eAAA;EACA,aAAA;EACA,mBAAA;AFiCpB;AE/BgB;EACI,kBAAA;EACA,MAAA;EACA,iBAAA;EACA,aAAA;AFiCpB;AE/BgB;EACI,cAAA;AFiCpB;AEhCoB;EACI,cCvHZ;AHyJZ;AEjCwB;EACI,cCnQlB;AHsSV;AEhCoB;EACI,gBAAA;AFkCxB;AE/BgB;EACI,cAAA;AFiCpB;AEhCoB;EACI,gBAAA;EACA,eC2DT;ED1DS,gBClSH;AHoUrB;;AK7UA;ED2FE,yBC1FsB;EDsGrB,mBCrG0B;EDsG1B,iBCtGuC;ED6FxC,kBC5FoB;EDgGpB,OChG4C;EDwF5C,yBCvFsB;ALsVxB;AI7SI;EC7CJ;IDuGG,SCjG8B;IDkG9B,iBClGkC;ELyVnC;AACF;AKxVI;EDgGD,aC/FmC;EAC9B,iBAAA;AL0VR;AIvTI;ECrCA;IDgGD,oBC5FuC;EL4VxC;AACF;;AMzWA;EACI,YAAA;EACA,YAAA;EACA,gBHwCI;ECoDN,eE3FoB;EF4FpB,ME5F0B;EF6F1B,QE7F4B;EF+F5B,OE/FmC;EFuFnC,yBEtFsB;ANiXxB;AM9WY;EACI,kBAAA;EACA,WAAA;EACA,YAAA;ANgXhB;AM5WI;EFyFD,UExFoC;EAC/B,kBAAA;AN8WR;AM7WQ;EACI,YAAA;EACA,YAAA;EACA,yBAAA;EACA,mBH0IA;EGzIA,iBAAA;EACA,mBAAA;EACA,kBH0TO;EGzTP,cHuJD;AHwNX;AI5VI;EE3BI;IAUQ,YAAA;ENiXd;AACF;AMhXY;EACI,cH6IL;AHqOX;AM9WY;EACI,UAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EFkFd,kBEjF+B;EACjB,eAAA;EACA,uBAAA;EACA,SAAA;EACA,UAAA;EACA,cH8HL;EClFT,kBE3CgC;EF4ChC,QE5CyC;EF6CzC,WE7C6C;EFM7C,2BELiC;EFMjC,mCENiC;EFOjC,+BEPiC;ANoXnC;AInZI;EEmCA;IAEQ,SAAA;IACA,QAAA;IACA,UAAA;IACA,gBAAA;IACA,kBAAA;IACA,UAAA;IACA,SAAA;IACA,cAAA;IACA,kBHgRO;IG/QP,8DHuRI;ICpPb,SElCiC;IFmCjC,UEnCoC;IFsBrC,yBErB8B;IFZ9B,2BEa6B;IFZ7B,mCEY6B;IFX7B,+BEW6B;ENuX7B;AACF;AIlZI;EEYA;IAiBQ,gBAAA;ENyXV;AACF;AMvXI;EACI,mBAAA;EACA,UAAA;EACA,0BAAA;EFtBN,wBEuByB;EFtBzB,gCEsByB;EFrBzB,4BEqByB;EFUzB,yBET0B;AN6X5B;AM3XI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,gBHzDA;EC6DL,eEHmC;EFVpC,yBEW0B;AN+X5B;AM9XQ;EACI,qBAAA;EACA,cAAA;ANgYZ;AM/XY;EACI,YAAA;EACA,cAAA;ANiYhB;AMhYgB;EACI,aAAA;ANkYpB;AIncI;EE0DI;IAWQ,kBAAA;IACA,WAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;ENkYd;EMjYc;IACI,YAAA;ENmYlB;AACF;AMhYQ;EACI,aAAA;ANkYZ;AIldI;EEuCA;IA4CQ,kBAAA;IACA,WAAA;ENmYV;AACF;AIxdI;EE0FI;IACI,aAAA;ENiYV;AACF;AIpfI;EEuHI;IACI,eH0NG;IGzNH,YAAA;IACA,kBAAA;ENgYV;EM/XU;IACI,qBAAA;IACA,WAAA;ENiYd;EMhYc;IACI,sBH1GZ;IG2GY,cAAA;IACA,WAAA;IACA,WAAA;IACA,WAAA;IFlDjB,eEmDyC;IF3B1C,mBE4BmC;ENkYnC;EMjYkB;IACI,WAAA;ENmYtB;AACF;AM9XI;EACI,qBAAA;EACA,WAAA;EACA,gBAAA;ANgYR;AM/XQ;EACI,yBHpJF;EGqJE,cAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;ANiYZ;AMhYY;EACI,WAAA;ANkYhB;AM5XY;EACI,qBAAA;EACA,WAAA;EACA,gBAAA;AN8XhB;AM5XoB;EACI,kBAAA;EACA,SAAA;EFpItB,wBEqIyC;EFpIzC,gCEoIyC;EFnIzC,4BEmIyC;ANgY3C;AM9XoB;EACG,aAAA;ANgYvB;AM9XoB;EF1IlB,yBE2IyC;EF1IzC,iCE0IyC;EFzIzC,6BEyIyC;ANkY3C;AM5XI;EACI,gBAAA;EACA,kBHsIW;EGrIX,YAAA;AN8XR;AI/hBI;EE8JA;IAKQ,gBAAA;ENgYV;AACF;AM9XY;EACI,gBAAA;EACA,eAAA;ANgYhB;AM/XgB;EACI,cAAA;EACA,YAAA;EACA,gBH9KZ;EG+KY,kBHyHD;AHwQnB;AMhYoB;EACI,mBH5DZ;AH8bZ;AMhYoB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;ANkYxB;AMjYwB;EACI,eHkIb;EGjIa,WH5LpB;EG6LoB,WAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBHsGT;EGnGS,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;ANmY5B;AMhY4B;EACI,gBH/OT;EGgPS,cH1ErB;EG2EqB,gBAAA;ANkYhC;AMhY4B;EACI,gBHtPX;EGuPW,cHUnB;AHwXb;AIrlBI;EEiNwB;IAIQ,eHkGrB;EHkSb;AACF;AM5XI;EFnKD,YEoKmC;AN8XtC;AM7XQ;EAGI,aAAA;EFxKT,sBEyKuC;AN+X1C;AM9XY;EACI,eH/QC;EGgRD,cH9PJ;EG+PI,gBH3QK;AH2oBrB;AM9XY;EACI,eHpRC;EGqRD,cH3GL;AH2eX;AM9XY;EACI,iBAAA;ANgYhB;AM9XY;EACI,aAAA;ANgYhB;AM1XY;EACI,0BAAA;EACA,SAAA;AN4XhB;AMvXI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;ANyXR;AInoBI;EE4QQ;IAEQ,aAAA;ENyXlB;AACF;AMtXQ;EACI,WAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;EACA,+BAAA;EACA,gCAAA;EACA,kBAAA;EACA,wBAAA;EACA,oBAAA;EACA,QAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;ANwXZ;AIxpBI;EEkRI;IAgBQ,SAAA;EN0Xd;AACF;AMxXM;EACE,cAAA;EACA,cAAA;EACA,eAAA;AN0XR;AMxXM;EAGE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WHtTA;EGuTA,WAAA;EACA,YAAA;EACA,kBHjBW;EGkBX,gBH1Ve;EG2Vf,eAAA;EACA,eAAA;AN0XR;AIprBI;EE0SE;IAkBM,eAAA;EN4XV;AACF;AM3XQ;EACI,kBHzBO;AHsZnB;AM1XM;EACE,eHVO;EGWP,gBHtWe;EGuWf,cAAA;EACA,aAAA;EACA,mBAAA;AN4XR;AM1XM;EACE,iBAAA;AN4XR;AMzXI;EACI,kBAAA;EACA,iBAAA;AN2XR;AM1XQ;EACI,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EF7SV,yBE8S8B;AN8XhC;AI1tBI;EEgVI;IAcQ,aAAA;ENgYd;AACF;AM/XY;EACI,kBAAA;EACA,WAAA;EACA,mBH5XN;EG6XM,WAAA;EACA,YAAA;EACA,mBAAA;EACA,QAAA;EACA,UAAA;ANiYhB;AM9XgB;EACI,eAAA;EACA,gBAAA;ANgYpB;AM9XgB;EACI,eAAA;EACA,gBAAA;ANgYpB;AM7XY;EACI,iBAAA;EACA,oBAAA;AN+XhB;AM9XgB;EACI,cAAA;ANgYpB;AIxvBI;EEoXQ;IAOQ,gBAAA;ENiYlB;AACF;AMhYgB;EACI,WAAA;EACA,cAAA;ANkYpB;AM/XoB;EACI,cH5Zd;AH6xBV;AM5XgB;EACI,SAAA;EACA,aAAA;AN8XpB;AM3XY;EACI,kBAAA;EACA,iBAAA;AN6XhB;AM3XY;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,mBHxSJ;EGySI,cHxRL;EGyRK,kBHvHG;EGwHH,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;AN6XhB;AM5XgB;EACI,mBH3SR;AHyqBZ;AM1XgB;EACI,iBAAA;AN4XpB;AMvXgB;EACI,UAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;ANyXpB;AMxXoB;EACI,WHrbhB;EGsbgB,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBHnJL;AH6gBnB;AMxXoB;EACI,WH9bhB;EG+bgB,gBH9dL;ECmFjB,kBE4YwC;EF3YxC,QE2YiD;EF1YjD,UE0YqD;EAC/B,mBHxdd;EGydc,WAAA;EACA,YAAA;EACA,eH9IT;EGiJS,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AN4XxB;AM1XoB;EACI,eHnJT;AH+gBf;AM1XoB;EACI,mBHted;EGuec,sBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AN4XxB;AMxXqB;EAGG,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AN0XxB;AMzXwB;EACI,iBAAA;EACA,gBAAA;EACA,gBAAA;AN2X5B;AM1X4B;EF1azB,iBE2a2D;AN4X9D;AMxXoB;EACI,aAAA;EACA,gBAAA;AN0XxB;AMzXwB;EFlbrB,kBEmbuD;EAC9B,cAAA;EACA,mBAAA;EACA,gBAAA;AN2X5B;AM1X4B;EACI,WHrfxB;AHi3BR;AM1X4B;EACI,sDAAA;AN4XhC;AMxX4B;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AN0XhC;AMjXI;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EF/cL,kBEgdmC;EFzbpC,gBE0buB;ANmXzB;AI/3BI;EEugBA;IAOQ,aAAA;ENqXV;AACF;AMpXQ;EACI,cH1iBF;EG2iBE,eH7NG;EG8NH,gBHpjBO;EGqjBP,yBAAA;EF1dT,SE2diC;EF1djC,YE0doC;EFncrC,kBEoc2B;ANuX7B;AMtXY;EACI,mBHjjBN;EGkjBM,WH3hBR;AHm5BR;AMpXI;EACI,aAAA;EACA,WAAA;ANsXR;AIr5BI;EE6hBA;IAIQ,cH1jBF;IG2jBE,eHpOG;IGqOH,YAAA;IACA,iBAAA;IACA,WAAA;IACA,WAAA;IF3eT,eE4euC;IFrfxC,kBEsf4B;IFrf5B,MEqfqC;IFlfrC,OEkfiD;IACvC,cAAA;EN0XV;AACF;AMvXI;EACI,aAAA;EACA,WHjjBA;EGkjBA,eHpPO;EGqPP,YAAA;EACA,iBAAA;EFvfL,eEwfmC;ANyXtC;AI56BI;EE6iBA;IAQQ,cAAA;EN2XV;AACF;AMxXQ;EACI,kBAAA;AN0XZ;AIp7BI;EEyjBI;IAGQ,aAAA;EN4Xd;AACF;AM3XY;EACI,0CAAA;EACA,2CAAA;EACA,YAAA;EFtgBb,4BEugB2C;EFhf5C,mBEif+B;AN6XjC;AM5XgB;EACI,+BAAA;AN8XpB;AM3XY;EACI,6BAAA;EACA,yBAAA;EACA,+BAAA;EACA,gBAAA;EF1hBd,kBE2hBgC;EF1hBhC,ME0hByC;EFzhBzC,QEyhB2C;AN+X7C;AI58BI;EEklBY;IACI,cAAA;IFjiBlB,kBEkiBoC;IF9hBpC,OE8hB4D;EN8X5D;EM7XkB;IACI,sBHxlBhB;EHu9BN;EM7XkB;IACI,6BAAA;IACA,yBAAA;IACA,gBAAA;IFziBtB,kBE0iBwC;IFziBxC,MEyiBiD;IFxiBjD,QEwiBmD;IFjiBlD,iBEkiBmD;ENiYpD;AACF;AM5XI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AN8XR;AM7XQ;EACI,oBAAA;EACA,iBAAA;EACA,mBAAA;AN+XZ;AM9XY;EACI,cAAA;EACA,oBAAA;ANgYhB;AM3XQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,eHpUG;EGqUH,cHzfD;EG0fC,aAAA;EACA,gCAAA;EACA,gBAAA;AN6XZ;AM5XY;EACI,0BAAA;AN8XhB;AM5XY;EACI,0BAAA;EACA,gBAAA;AN8XhB;AM5XY;EACI,kBAAA;EACA,qBAAA;AN8XhB;AM5XY;EACI,eHnVD;EGoVC,iBAAA;AN8XhB;AI5gCI;EEspBgB;IACI,aAAA;ENyXtB;EMtXc;IACI,wBAAA;ENwXlB;AACF;AMlXY;EACI,YAAA;ANoXhB;AMhXI;EACI,qBAAA;EACA,kBAAA;ANkXR;AMjXQ;EACI,WAAA;EFzlBV,kBE0lB2B;ANmX7B;AMjXQ;EACI,sBAAA;EACA,YAAA;EACA,WAAA;EFvnBT,SEwnBiC;EFhoBlC,kBEioB4B;EF/nB5B,QE+nB0C;EF9nB1C,YE8nB4C;EFjmB5C,kBEkmB2B;EACjB,qBAAA;EACA,mBH3sBF;AHgkCV;AMlXI;EACI,WH5rBA;EG6rBA,aAAA;EACA,YAAA;EACA,eH/XO;EGgYP,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,WAAA;EFvoBL,eEwoBmC;EFjpBpC,kBEkpBwB;EFjpBxB,MEipBiC;EFhpBjC,QEgpBmC;ANsXrC;AI1jCI;EEyrBA;IAaQ,cAAA;ENwXV;AACF;AMvXQ;EACI,cHluBF;EGmuBE,UAAA;ANyXZ;AMxXY;EACI,aAAA;AN0XhB;AMvXQ;EACI,UAAA;ANyXZ;AMxXY;EACI,cH/kBL;EGglBK,iBAAA;EFxpBb,eEypB2C;AN0X9C;;AMrXA;EACI,WAAA;ANwXJ;;AIzmCI;EEsvBQ;IACI,mBAAA;IACA,8BAAA;IACA,sCAAA;IACA,4BAAA;ENuXd;EMpXM;IAGI,aAAA;IACA,mBAAA;IACA,yBAAA;IACA,sBAAA;IACA,uBAAA;IACA,+BAAA;IACA,qBAAA;IACA,WAAA;IFrrBT,UEsrBuC;IAC9B,sBAAA;ENsXV;EMrXU;IACI,cAAA;IACA,iBAAA;ENuXd;EMrXU;IACI,aAAA;ENuXd;EMpXM;IACI,wBAAA;ENsXV;EMpXM;IACI,wBAAA;ENsXV;EMnXU;IACI,wBAAA;ENqXd;EMjXU;IACI,yBAAA;ENmXd;EMjXU;IACI,yBAAA;ENmXd;EMjXU;IACI,aAAA;ENmXd;EMjXU;IACI,cAAA;ENmXd;EMjXU;IACG,UAAA;ENmXb;EMjXU;IF3tBT,eE4tB2C;IAC9B,aAAA;ENmXd;EM9WU;IACI,aAAA;ENgXd;AACF;AM5WA;EACI,kBAAA;EACA,mBAAA;AN8WJ;AM7WI;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,mBHrrBI;EGsrBJ,UAAA;AN+WR;AM3WY;EACI,WAAA;EACA,YAAA;EACA,mBHpsBJ;EGqsBI,yBAAA;EACA,eH9fD;EG+fC,kBHnhBG;EGohBH,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;AN6WhB;AM5WgB;EACI,eH3gBL;EG4gBK,cHlsBT;EGmsBS,kBHjiBD;EGkiBC,iBAAA;EACA,WAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AN8WpB;AM7WoB;EACI,WHt1BhB;EGu1BgB,mBH12Bd;AHytCV;AM7WoB;EACI,WH11BhB;EG21BgB,mBHrtBb;AHokCX;AM1WQ;EACI,kBAAA;AN4WZ;AM3WY;EACI,eAAA;AN6WhB;AM3WY;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,eHrjBD;EGsjBC,kBH1kBG;EG2kBH,6BAAA;AN6WhB;AM3WY;EACI,cH92BR;EG+2BQ,mBHluBF;EGmuBE,yBAAA;AN6WhB;AM5WgB;EACI,WH13BZ;EG23BY,mBHn3BZ;AHiuCR;AM3WY;EACI,cHn3BL;EGo3BK,mBH3sBH;AHwjCb;AM5WgB;EACI,WHl4BZ;EGm4BY,mBHv3BT;AHquCX;AM3WY;EACI,cH55BJ;EG65BI,mBH9tBF;AH2kCd;AM5WgB;EACI,WH14BZ;EG24BY,mBHh6BR;AH8wCZ;;AMxWA;EACI,aAAA;AN2WJ;AI3vCI;EE+4BJ;IAGQ,cAAA;EN6WN;AACF;;AO7yCA;EAGI,aAAA;EACA,sBJuCI;EItCJ,aAAA;EACA,aAAA;EHyFF,eGxFoB;EHyFpB,SGzF0B;EH2F1B,SG3FoC;EH4FpC,OG5FsC;EHoFtC,yBGnFsB;EACpB,YAAA;APqzCJ;AIjxCI;EG7CJ;IAWQ,mBAAA;IHgFN,yBG/E0B;IACpB,aAAA;IACA,gBJ6BA;EH4xCN;AACF;AI3xCI;EG7CJ;IAiBQ,WAAA;EP2zCN;AACF;AO1zCI;EACI,mCAAA;AP4zCR;AInyCI;EG1BA;IAGQ,sBAAA;EP8zCV;AACF;AO5zCI;EH+ED,aG9EmC;AP8zCtC;AO7zCQ;EACI,mBAAA;AP+zCZ;AO9zCW;EACK,mBJkIJ;EIjII,kBJoTG;EInTH,aAAA;APg0ChB;AO/zCgB;EACI,WAAA;EACA,YAAA;EACA,kBJ+SD;AHkhCnB;AO/zCgB;EACI,iBAAA;EACA,SAAA;APi0CpB;AOh0CoB;EACI,eJ6TT;EI5TS,gBJhCD;EIiCC,cJ+NV;EI9NU,kBAAA;APk0CxB;AOh0CoB;EACI,eJqTT;EIpTS,gBJxCH;EIyCG,cJwNX;EIvNW,gBAAA;APk0CxB;AO5zCY;EACI,kCAAA;AP8zChB;AO1zCY;EACI,mBAAA;AP4zChB;AO1zCoB;EACI,WJvBhB;AHm1CR;AO1zCoB;EACI,cAAA;AP4zCxB;AOzzCgB;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AP2zCpB;AOzzCgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EHoBjB,kBGnB+C;EAC9B,kBAAA;EACA,cJjER;AH43CZ;AO1zCoB;EACI,cAAA;AP4zCxB;AO1zCoB;EACI,cAAA;AP4zCxB;AOzzCoB;EACI,oCAAA;EACA,cAAA;EACA,kBAAA;AP2zCxB;AO1zCwB;EACI,WJzDpB;AHq3CR;AO1zCwB;EACI,iGAAA;AP4zC5B;AO1zCwB;EACI,cAAA;AP4zC5B;AO1zCwB;EACI,mBAAA;AP4zC5B;AO3zC4B;EACI,qBAAA;AP6zChC;AOzzCoB;EACI,eJkPT;EIjPS,gBJ3GH;EI4GG,cJwDb;AHmwCX;AOvzCoB;EACI,oCAAA;EACA,kBAAA;APyzCxB;AOxzCwB;EACI,iGAAA;AP0zC5B;AOxzCwB;EACI,cAAA;AP0zC5B;AOrzCoB;EACI,aAAA;APuzCxB;AOrzC4B;EACG,gBJhIV;EIiIU,eJvId;EIwIc,kBAAA;EACA,cAAA;EHrC5B,yBGsC0D;EAC9B,kBAAA;APuzC/B;AOlzCgB;EACI,cAAA;EACA,mBAAA;APozCpB;AOnzCoB;EACI,kBAAA;EACA,kBAAA;EACA,gBAAA;APqzCxB;AOpzCwB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBJzJP;EI0JO,eJkMb;EIjMa,cJQjB;EIPiB,kBAAA;EACA,WAAA;EH9DzB,YG+DuD;APszC1D;AOrzC4B;EACI,cJQrB;EIPqB,eJ6LjB;EI5LiB,mBJXpB;EIYoB,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;APuzChC;AOrzC4B;EACI,eJkLjB;EIjLiB,gBJ3KX;EI4KW,mBAAA;EACA,cJNrB;EIOqB,iBAAA;APuzChC;AOrzC4B;EACI,cJvKtB;EIwKsB,mBJjIlB;EIkIkB,kBJsJb;AHiqCnB;AOtzCgC;EACI,cJ3K1B;AHm+CV;AOtzCgC;EACI,mBJ9K1B;EI+K0B,WJxJ5B;AHg9CR;AOrzC4B;EACI,cJnLtB;AH0+CV;AOtzCgC;EACI,cJrL1B;AH6+CV;AOjzC4B;EACI,mBAAA;EACA,kBAAA;EACA,cAAA;APmzChC;AOlzCgC;EACI,WJ1K5B;EI2K4B,mBAAA;APozCpC;AOlzCgC;EACI,cAAA;APozCpC;AO7yCgB;EACI,gBJtNG;EIuNH,eJiIL;EIhIK,cJvDT;EIwDS,kBAAA;EACA,yBAAA;AP+yCpB;AO5yCoB;EACI,aAAA;AP8yCxB;AO1yCoB;EACI,aAAA;EACA,SAAA;EACA,cAAA;EACA,iBAAA;AP4yCxB;AOxyCY;EACI,kBAAA;AP0yChB;AOxyCoB;EACI,SAAA;AP0yCxB;AOxyC4B;EACI,kBAAA;EACA,eJzPf;EI0Pe,uBAAA;EACA,kBAAA;AP0yChC;AOzyCgC;EACI,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;AP2yCpC;AOzyCgC;EACI,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,QAAA;AP2yCpC;AOryCwB;EACI,mBJzHhB;AHg6CZ;AOtyC4B;EACI,mBJ1PzB;EI2PyB,WJhPxB;AHwhDR;AOtyC4B;EACI,uBAAA;APwyChC;AOryCwB;EACI,mBJvOd;EIwOc,kBAAA;APuyC5B;AOtyC4B;EACI,mBJjRtB;EIkRsB,WJ3PxB;AHmiDR;AOtyC4B;EACI,cJrRtB;AH6jDV;AOryCgC;EACI,+BAAA;EACA,gCAAA;APuyCpC;AO5xCY;EACI,gBAAA;AP8xChB;AO7xCgB;EACI,mBAAA;EACA,iBAAA;AP+xCpB;AOxxC4B;EACI,iBAAA;AP0xChC;AOnxCgC;EACI,iBAAA;APqxCpC;AO7wCwB;EACA,iBAAA;EACA,mBAAA;EACA,eJpVP;EIqVO,cJ7EZ;AH41CZ;AO9wCwB;EACI,WAAA;EACA,kCAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;EHhO1B,mBGiO2C;EHjQ3C,kBGkQ4C;EHjQ5C,SGiQqD;EH9PrD,OG8PoE;APkxCtE;AOhxC4B;EACI,cJhVtB;AHkmDV;AOjxCgC;EACA,mBAAA;EACA,sBAAA;APmxChC;AO3wCQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,oBAAA;EACA,iBAAA;EACA,eJnBG;EIoBH,iBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EHhSV,kBGiS4B;EHhS5B,SGgSqC;EH/RrC,WG+R0C;EHtU1C,0BGuU6B;EHtU7B,kCGsU6B;EHrU7B,8BGqU6B;EHtS7B,yBGuS8B;APmxChC;AOlxCY;EACI,WAAA;EACA,UAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;EACA,+BAAA;EACA,gCAAA;EACA,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;APoxChB;AOlxCY;EACI,WAAA;APoxChB;AOnxCgB;EACI,WAAA;APqxCpB;AOhxCY;EH9VV,wBG+ViC;EH9VjC,gCG8ViC;EH7VjC,4BG6ViC;EACnB,mBAAA;APoxChB;AOhxCI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EH/TL,aGgUmC;EAC9B,cJnZI;EIoZJ,kBAAA;APkxCR;AOjxCQ;EACI,cJxZF;EIyZE,uBAAA;EACA,kBAAA;APmxCZ;AOlxCY;EACI,WAAA;EACA,kBAAA;EACA,yDAAA;EACA,mBAAA;EHpVd,kBGqVgC;EHpVhC,SGoVyC;EHnVzC,QGmV8C;APsxChD;AOjxCI;EACI,YAAA;EH/SN,4CAAA;AJqkDF;AOnxCI;EACI,YAAA;EACA,YAAA;EHpWN,yBGqW0B;EACpB,aAAA;APuxCR;AI3qDI;EGgZA;IAMQ,wBAAA;EPyxCV;AACF;AOxxCQ;EACI,uBAAA;EACA,4BAAA;AP0xCZ;AIprDI;EGwZI;IAIQ,sBAAA;EP4xCd;AACF;AO1xCQ;EHpWL,uBGqWuC;AP4xC1C;AI5rDI;EG+ZI;IHpWL,aGuW0C;EP8xC3C;AACF;AO5xCQ;EACI,eJlHG;EImHH,cJvSD;EIwSC,yBAAA;EACA,gBJ1cO;EI2cP,mBAAA;AP8xCZ;AO5xCQ;EACI,gBAAA;EACA,UAAA;EACA,SAAA;AP8xCZ;AO3xCoB;EACI,iEAAA;EACA,WJtbhB;AHmtDR;AO1xCgB;EACI,gBJ5dC;EI6dD,eJleH;EImeG,cJjdR;AH6uDZ;AO3xCoB;EACI,cJrdd;AHkvDV;AOxxCQ;EAGI,2BAAA;EACA,qBAAA;EACA,kCAAA;EACA,oBAAA;EACA,iBAAA;EACA,eJ9IG;EI+IH,mCAAA;EACA,kCAAA;EACA,iBAAA;EACA,QAAA;EACA,kBAAA;EACA,gBJhfO;EC8CjB,0BGmc6B;EHlc7B,kCGkc6B;EHjc7B,8BGic6B;AP4xC/B;AO3xCY;EACI,gBAAA;AP6xChB;AOxxCI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;AP0xCR;AOtxCY;EHvdV,wBGwdiC;EHvdjC,gCGudiC;EHtdjC,4BGsdiC;AP0xCnC;AOrxCQ;EAGI,aAAA;EAEA,sBAAA;EH7ZV,gBG8Z2B;EACjB,gCAAA;EHtbT,eGubuC;EHpcxC,yBGqc8B;APyxChC;AOxxCY;EACI,qCAAA;EACA,WJxfR;AHkxDR;AOxxCY;EACI,gBAAA;EACA,gBJ7hBK;AHuzDrB;AOpxCQ;EACI,WAAA;EACA,gBJriBS;EIsiBT,cAAA;EHjbV,kBGkb2B;EH1c1B,gBG2ckC;EH1clC,aG0c4C;APuxC/C;AOtxCY;EACI,iEAAA;EACA,WJ1gBR;AHkyDR;AOvxCgB;EACI,WJ5gBZ;AHqyDR;AOtxCY;EACI,iBAAA;APwxChB;;AI7zDI;EG+iBI;IACI,iBAAA;EPkxCV;EOhxCM;IACI,aAAA;EPkxCV;EO/wCU;IACI,UAAA;IACA,yBAAA;EPixCd;EOhxCc;IACG,SAAA;EPkxCjB;EO5wCc;IACI,YAAA;EP8wClB;EOxwCc;IACI,UAAA;IACA,yBAAA;EP0wClB;EOrwCkB;IACI,aAAA;EPuwCtB;EOlwCM;IACI,aAAA;EPowCV;EO7vC0B;IACI,aAAA;EP+vC9B;EO5vCsB;IACI,aAAA;EP8vC1B;EO5vCsB;IACI,eAAA;EP8vC1B;EOxvCM;IACI,WAAA;IACA,gBAAA;EP0vCV;EOvvCU;IACI,cAAA;EPyvCd;EOjvCkB;IACI,cAAA;EPmvCtB;EOhvCc;IACI,cAAA;EPkvClB;EO9uCM;IACI,cAAA;IH7jBV,yBG8jB8B;EPkvC9B;EOhvCM;IACI,YAAA;EPkvCV;EO7uC0B;IACI,qBAAA;IACA,cAAA;EP+uC9B;EO5uCsB;IACI,kBAAA;EP8uC1B;EO1uCc;IACI,cAAA;EP4uClB;EOxuCM;IACI,YAAA;EP0uCV;EOvuCE;IAGI,aAAA;IACA,mBAAA;IACA,yBAAA;IACA,sBAAA;IACA,uBAAA;IACA,+BAAA;IACA,qBAAA;IACA,WAAA;EPyuCN;AACF;AOtuCI;EACI,sBAAA;APwuCR;;AOpuCI;EACI,uBAAA;APuuCR;AOpuCQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBJ3sBS;EI4sBT,eJhXG;EIiXH,cAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;APsuCZ;AOpuCQ;EACI,aAAA;EACA,uBAAA;APsuCZ;AOhuCY;EACI,qBAAA;EACA,6BAAA;EACA,mBAAA;EACA,kBAAA;APkuChB;AOhuCY;EACI,kBAAA;EACA,sBAAA;APkuChB;;AO3tCI;EACI,cAAA;AP8tCR;;AO1tCI;EACI,cAAA;AP6tCR;;AO1tCA;EACI,aAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,oCAAA;EHlqBF,eGmqBoB;EHlqBpB,SGkqB0B;EH/pB1B,OG+pByC;AP+tC3C;AO9tCI;EACI,cAAA;APguCR;;AO5tCI;EACI,wBAAA;AP+tCR;;AO3tCI;EACI,yBAAA;AP8tCR;;AO3tCA;EACI,yBAAA;AP8tCJ;;AOntCgC;EACI,iBAAA;APstCpC;AO/sCoC;EACI,iBAAA;APitCxC;;AOnsCQ;EACI,UAAA;EACA,SAAA;EACA,QAAA;APssCZ;;AQ5/DI;EACI,yBL8BD;AHi+DP;AQ5/DgB;EACI,yBAAA;AR8/DpB;AQ7/DoB;EACI,WLmChB;AH49DR;AQv/D4B;EACI,cLiBpB;AHw+DZ;AQl/De;EACK,+BAAA;EACA,gCAAA;ARo/DpB;;AQ5+DI;EACI,yBAAA;AR++DR;AQ5+DgB;EACI,yBAAA;AR8+DpB;AQ5+DwB;EACI,WLCpB;AH6+DR;AQ5+DwB;EACI,cAAA;AR8+D5B;AQz+Da;EACG,WLRR;AHm/DR;AQv+DoB;EACI,WLbhB;AHs/DR;AQr+D4B;EACI,WLlBxB;AHy/DR;AQr+DoC;EACI,yBAAA;ARu+DxC;AQr+DoC;EACI,cAAA;ARu+DxC;AQr+DoC;EACI,+BAAA;EACA,gCAAA;ARu+DxC;AQp+DgC;EACI,WLhC5B;AHsgER;AQ99De;EACK,4BAAA;EACA,6BAAA;ARg+DpB;;AQz9DI;EACI,yBAAA;AR49DR;AQz9DgB;EACI,yBAAA;AR29DpB;AQz9DwB;EACI,WLzDpB;AHohER;AQz9DwB;EACI,cAAA;AR29D5B;AQt9Da;EACG,WLlER;AH0hER;AQp9DoB;EACI,WLvEhB;AH6hER;AQl9D4B;EACI,WL5ExB;AHgiER;AQl9DoC;EACI,yBAAA;ARo9DxC;AQl9DoC;EACI,cAAA;ARo9DxC;AQl9DoC;EACI,+BAAA;EACA,gCAAA;ARo9DxC;AQj9DgC;EACI,WL1F5B;AH6iER;AQ38De;EACK,4BAAA;EACA,6BAAA;AR68DpB;;AQp8DI;EACI,mBAFM;EAGN,yBAAA;ARu8DR;AQt8DQ;EACI,mBAAA;EACA,qBAAA;ARw8DZ;;AQh8DQ;EACI,8BAAA;EACA,gCAAA;ARm8DZ;AQz7DgC;EACI,cAhBtB;EAiBsB,mBAhBhB;AR28DpB;AQ17DqC;EACG,cAnB1B;AR+8Dd;AQ17DoC;EACI,mBAtB1B;ARk9Dd;AQz7DgC;EACI,cA1BtB;ARq9Dd;AQ17DoC;EACI,cA5B1B;ARw9Dd;AQr7DwB;EACI,mBAnCR;AR09DpB;AQl7DgC;EACI,uBAAA;ARo7DpC;AQh7DwB;EACI,uBAAA;EACA,cAhDd;ARk+Dd;AQj7D4B;EACI,mBAlDlB;ARq+Dd;AQj7D4B;EACI,cArDlB;ARw+Dd;AQj7D4B;EACI,+BAAA;EACA,gCAAA;ARm7DhC;AQ16DI;EACI,mBAnEM;AR++Dd;AQ16DI;EACI,mBAtEM;ARk/Dd;AQ16DI;EACI,cAzEM;EA0EN,gCAAA;AR46DR;AQ16DI;;;EAGI,mBA/EM;EAgFN,qBAhFM;AR4/Dd;AQ16DI;EACI,qBAnFM;EAoFN,yBApFM;ARggEd;AQ16DI;EACI,mBAvFM;ARmgEd;AQ16DI;EACI,cA1FM;EA2FN,qBA3FM;ARugEd;AQ16DI;EACI,mBA9FM;EA+FN,qBA/FM;AR2gEd;AQ16DI;EACI,mBAlGM;EAmGN,yBAAA;AR46DR;AQ16DI;EACI,mBAtGM;EAuGN,WL9NA;AH0oER;AQ16DI;;EAEI,mBA3GM;ARuhEd;AQ16DI;EACI,yBA9GM;EA+GN,yBAAA;AR46DR;AQ16DI;EACI,yBAlHM;EAmHN,qBAnHM;AR+hEd;AQ16DI;EACI,cAtHM;ARkiEd;AQ16DI;EACI,oCAAA;EACA,yBAAA;AR46DR;;AQp6DQ;EACI,8BAAA;EACA,gCAAA;ARu6DZ;AQ75DgC;EACI,cAhBtB;EAiBsB,mBAhBhB;AR+6DpB;AQ95DqC;EACG,cAnB1B;ARm7Dd;AQ95DoC;EACI,mBAtB1B;ARs7Dd;AQ75DgC;EACI,cA1BtB;ARy7Dd;AQ95DoC;EACI,cA5B1B;AR47Dd;AQz5DwB;EACI,mBAnCR;AR87DpB;AQt5DgC;EACI,uBAAA;ARw5DpC;AQp5DwB;EACI,uBAAA;EACA,cAhDd;ARs8Dd;AQr5D4B;EACI,mBAlDlB;ARy8Dd;AQr5D4B;EACI,cArDlB;AR48Dd;AQr5D4B;EACI,+BAAA;EACA,gCAAA;ARu5DhC;AQ94DI;EACI,mBAnEM;ARm9Dd;AQ94DI;EACI,mBAtEM;ARs9Dd;AQ94DI;EACI,cAzEM;EA0EN,gCAAA;ARg5DR;AQ94DI;;;EAGI,mBA/EM;EAgFN,qBAhFM;ARg+Dd;AQ94DI;EACI,qBAnFM;EAoFN,yBApFM;ARo+Dd;AQ94DI;EACI,mBAvFM;ARu+Dd;AQ94DI;EACI,cA1FM;EA2FN,qBA3FM;AR2+Dd;AQ94DI;EACI,mBA9FM;EA+FN,qBA/FM;AR++Dd;AQ94DI;EACI,mBAlGM;EAmGN,yBAAA;ARg5DR;AQ94DI;EACI,mBAtGM;EAuGN,WL7VA;AH6uER;AQ94DI;;EAEI,mBA3GM;AR2/Dd;AQ94DI;EACI,yBA9GM;EA+GN,yBAAA;ARg5DR;AQ94DI;EACI,yBAlHM;EAmHN,qBAnHM;ARmgEd;AQ94DI;EACI,cAtHM;ARsgEd;AQ94DI;EACI,oCAAA;EACA,yBAAA;ARg5DR;;AQz4DQ;EACI,8BAAA;EACA,gCAAA;AR44DZ;AQl4DgC;EACI,cAhBtB;EAiBsB,mBAhBhB;ARo5DpB;AQn4DqC;EACG,cAnB1B;ARw5Dd;AQn4DoC;EACI,mBAtB1B;AR25Dd;AQl4DgC;EACI,cA1BtB;AR85Dd;AQn4DoC;EACI,cA5B1B;ARi6Dd;AQ93DwB;EACI,mBAnCR;ARm6DpB;AQ33DgC;EACI,uBAAA;AR63DpC;AQz3DwB;EACI,uBAAA;EACA,cAhDd;AR26Dd;AQ13D4B;EACI,mBAlDlB;AR86Dd;AQ13D4B;EACI,cArDlB;ARi7Dd;AQ13D4B;EACI,+BAAA;EACA,gCAAA;AR43DhC;AQn3DI;EACI,mBAnEM;ARw7Dd;AQn3DI;EACI,mBAtEM;AR27Dd;AQn3DI;EACI,cAzEM;EA0EN,gCAAA;ARq3DR;AQn3DI;;;EAGI,mBA/EM;EAgFN,qBAhFM;ARq8Dd;AQn3DI;EACI,qBAnFM;EAoFN,yBApFM;ARy8Dd;AQn3DI;EACI,mBAvFM;AR48Dd;AQn3DI;EACI,cA1FM;EA2FN,qBA3FM;ARg9Dd;AQn3DI;EACI,mBA9FM;EA+FN,qBA/FM;ARo9Dd;AQn3DI;EACI,mBAlGM;EAmGN,yBAAA;ARq3DR;AQn3DI;EACI,mBAtGM;EAuGN,WL3dA;AHg1ER;AQn3DI;;EAEI,mBA3GM;ARg+Dd;AQn3DI;EACI,yBA9GM;EA+GN,yBAAA;ARq3DR;AQn3DI;EACI,yBAlHM;EAmHN,qBAnHM;ARw+Dd;AQn3DI;EACI,cAtHM;AR2+Dd;AQn3DI;EACI,oCAAA;EACA,yBAAA;ARq3DR;;AQh3DI;EACI,yBL/fD;EKggBC,cL9fI;AHi3EZ;AQj3DI;EACI,WLxfA;AH22ER;AQj3DI;EACI,yBLtgBD;AHy3EP;AQl3DQ;EACI,yBLxgBL;AH43EP;AQl3DgB;EACI,aAAA;ARo3DpB;AQn3DoB;EACI,cAAA;ARq3DxB;AQj3DY;EACI,WLvgBR;AH03ER;AQh3DQ;EACI,yBLthBL;EKuhBK,gBAAA;ARk3DZ;AQj3DY;EACI,WL9gBR;AHi4ER;AQj3DY;EACI,qBL3hBF;AH84Ed;AQl3DgB;EACI,WLnhBZ;AHu4ER;AQ/2DQ;EACI,qBLniBE;AHo5Ed;AQ72DgB;EACI,gCAAA;AR+2DpB;AQ92DoB;EACI,WLhiBhB;AHg5ER;AQ92DoB;EACI,WLniBhB;AHm5ER;AQ92DoB;EACI,WLtiBhB;AHs5ER;AQ52D4B;EACI,yBAAA;AR82DhC;AQ12D4B;EACI,WLhjBxB;AH45ER;AQ12D4B;EACI,cL3jBf;AHu6EjB;AQx2DoB;EACI,eLhQT;EKiQS,iBAAA;EACA,cLvbb;AHiyEX;AQr2DY;EACI,mBL3kBT;AHk7EP;AQn2DY;EACI,qBL/kBF;EKglBE,uBAAA;ARq2DhB;AQn2DY;EACI,cLjlBC;AHs7EjB;AQ/1DoB;EACI,uBAAA;EACA,kBLzSL;AH0oEnB;AQh2DwB;EACI,uBAAA;ARk2D5B;AQ/1D4B;EACI,WLvlBxB;AHw7ER;AQ91DgC;EACI,WL3lB5B;EK4lB4B,gBAAA;ARg2DpC;AQ91DgC;EACI,gBLjoBf;EKkoBe,cLxmBnB;AHw8EjB;AQv1DI;EACI,yBLrnBD;AH88EP;AQt1DgB;EACI,yBAAA;ARw1DpB;AQv1DoB;EACI,WLhnBhB;AHy8ER;AQj1D4B;EACI,cLloBpB;AHq9EZ;AQ50De;EACK,+BAAA;EACA,gCAAA;AR80DpB;AQz0DI;EACI,mBAAA;EACA,WLzoBA;AHo9ER;AQz0DI;EACI,mBAAA;EACA,qBAAA;EACA,WL9oBA;AHy9ER;AQz0DI;EACI,WLjpBA;AH49ER;AQz0DI;EACI,mBL/pBD;AH0+EP;AQ10DQ;EACI,qBLhqBE;AH4+Ed;AQ30DY;EACI,WLxpBR;AHq+ER;AQ10DQ;EACI,mBLhqBF;EKiqBE,qBLvqBE;AHm/Ed;AQ30DY;EACI,qBLzqBF;AHs/Ed;AQ50DgB;EACI,WLjqBZ;AH++ER;AQ10DQ;EACI,qBLhrBE;EKirBF,mBLlrBL;AH8/EP;AQ30DY;EACI,qBLnrBF;AHggFd;AQz0DI;;;EAGI,cLzrBI;AHogFZ;AQx0DQ;EACI,uBAAA;AR00DZ;AQt0DQ;EACI,cLlsBA;AH0gFZ;AQr0DI;;;EAGI,qBLzsBM;EK0sBN,gBAAA;EACA,yBAAA;EACA,cL3sBI;AHkhFZ;AQt0DQ;;;EACI,cL7sBA;AHuhFZ;AQt0DQ;EACI,qBLntBE;EKotBF,yBAAA;EACA,cLptBA;EKqtBA,gBAAA;ARw0DZ;AQl0DgB;EACI,cL5tBR;AHgiFZ;AQ9zDQ;EACI,qBLpuBE;AHoiFd;AQ5zDQ;EACI,qBLzuBE;EK0uBF,yBAAA;EACA,cL1uBA;EK2uBA,gBAAA;AR8zDZ;AQ3zDI;;EAEI,cLhvBI;AH6iFZ;AQ1zDQ;EACI,qBLrvBE;EKsvBF,yBAAA;EACA,cLtvBA;AHkjFZ;AQzzDI;;EAEI,qBL5vBM;EK6vBN,gBAAA;EACA,yBAAA;EACA,cL9vBI;AHyjFZ;AQzzDI;EACI,qBLlwBM;AH6jFd;AQzzDI;EACI,yBAAA;AR2zDR;AQzzDI;EACI,qBLxwBM;EKywBN,mBL1wBD;EK2wBC,gBAAA;EACA,cL1wBI;AHqkFZ;AQxzDQ;EACI,kBLrwBJ;EKswBI,WLtwBJ;AHgkFR;AQvzDI;EACI,yBAAA;ARyzDR;AQtzDQ;EACI,qBLxxBE;EKyxBF,mBL1xBL;EK2xBK,gBAAA;ARwzDZ;AQvzDY;EACI,gBAAA;EACA,yBAAA;EACA,mBL/xBT;EKgyBS,cL9xBJ;AHulFZ;AQvzDY;EACI,gBAAA;ARyzDhB;AQrzDI;;;EAGI,qBLzyBM;EK0yBN,mBL3yBD;AHkmFP;AQpzDQ;EACI,cL7yBA;AHmmFZ;AQrzDY;EACI,cL/yBJ;AHsmFZ;AQpzDQ;EACI,qBLpzBE;AH0mFd;AQnzDI;EACI,mBLzzBD;EK0zBC,qBLzzBM;AH8mFd;AQnzDI;;;;;;;;;EAUI,qBLr0BM;EKs0BN,mBLv0BD;EKw0BC,gBAAA;ARozDR;AQlzDI;EACI,yBLp0BE;EKq0BF,gBAAA;ARozDR;AQjzDQ;EACI,qBL/0BE;EKg1BF,cL/0BA;AHkoFZ;AQhzDI;EACI,qBLp1BM;AHsoFd;AQ9yDY;EACI,cLx1BJ;EKy1BI,gBAAA;ARgzDhB;AQ9yDY;EACI,cL51BJ;EK61BI,qBL91BF;AH8oFd;AQ5yDI;EACI,gBAAA;AR8yDR;AQ5yDI;EACI,cLr2BI;EKs2BJ,qBLv2BM;EKw2BN,mBLz2BD;EK02BC,gBAAA;AR8yDR;AQzyDwB;EACI,WLr2BpB;AHgpFR;AQlyDoB;EACI,cLx3BZ;AH4pFZ;AQ/xDQ;EACI,qBL/3BE;AHgqFd;AQ9xDI;EACI,qBLn4BM;AHmqFd;AQ7xDQ;EACI,cLt4BA;EKu4BA,qBLx4BE;EKy4BF,mBL14BL;AHyqFP;AQ7xDQ;EACI,cL34BA;EK44BA,qBL74BE;EK84BF,mBL/4BL;AH8qFP;AQ5xDI;EACI,cLj5BI;EKk5BJ,qBLn5BM;EKo5BN,mBLr5BD;AHmrFP;AQxxDoB;EACI,cL15BZ;AHorFZ;AQpxDI;EACI,cLj6BI;EKk6BJ,qBLn6BM;EKo6BN,mBLr6BD;AH2rFP;AQpxDI;EACI,cLt6BI;EKu6BJ,mBAAA;ARsxDR;AQpxDI;EACI,yBAAA;ARsxDR;AQpxDI;EACI,cL76BI;AHmsFZ;AQpxDI;EACI,qBLj7BM;AHusFd;AQpxDI;EACI,qBLp7BM;AH0sFd;AQpxDI;EACI,mBLp8BE;EKq8BF,WL96BA;AHosFR;AQpxDI;EACI,uBAAA;ARsxDR;AQpxDI;EACI,qBL97BM;EK+7BN,mBLh8BD;AHstFP;AQnxDY;EACI,WLz7BR;AH8sFR;AQjxDI;EACI,yBAAA;ARmxDR;AQjxDI;EACI,mBAAA;ARmxDR;AQjxDY;EACI,WLp8BR;AHutFR;AQjxDY;EACI,WLv8BR;AH0tFR;AQjxDY;EACI,qBLp9BF;EKq9BE,uBAAA;EACA,WL58BR;AH+tFR;AQhxDQ;EACI,WLh9BJ;AHkuFR;AQ/wDI;EACI,WLp9BA;AHquFR;AQ/wDI;EACI,qBLj+BM;EKk+BN,mBLn+BD;AHovFP;AQhxDQ;EACI,qBLp+BE;EKq+BF,mBAAA;ARkxDZ;AQ/wDI;EACI,qBLz+BM;EK0+BN,mBAAA;ARixDR;AQ/wDI;EACI,qBL7+BM;AH8vFd;AQ/wDI;EACI,mBL1+BE;EK2+BF,gBAAA;ARixDR;AQhxDQ;EACI,8BAAA;ARkxDZ;AQhxDQ;EACI,mBAAA;EACA,gBAAA;ARkxDZ;AQhxDQ;EACI,mBAAA;ARkxDZ;AQjxDY;EACI,qBL5/BF;AH+wFd;AQjxDY;EACI,qBL//BF;AHkxFd;AQhxDQ;EACI,qBLngCE;AHqxFd;AQjxDY;EACI,WL3/BR;AH8wFR;AQjxDY;EACI,cLvgCJ;AH0xFZ;AQhxDQ;EACI,cL3gCA;AH6xFZ;AQ/wDI;EACI,cL/gCI;AHgyFZ;AQ9wDQ;EACI,qBLphCE;AHoyFd;AQ7wDI;EACI,mBLzhCD;EK0hCC,qBLzhCM;EK0hCN,cLzhCI;AHwyFZ;AQ9wDQ;EACI,mBL7hCL;EK8hCK,qBL7hCE;EK8hCF,cL7hCA;AH6yFZ;AQ7wDI;EACI,mBLniCD;AHkzFP;AQ7wDI;EACI,mBLtiCD;EKuiCC,qBLtiCM;EKuiCN,cLtiCI;AHqzFZ;AQ7wDI;EACI,qBL1iCM;AHyzFd;AQ5wDQ;EACI,mBL/iCL;EKgjCK,qBL/iCE;EKgjCF,WLtiCJ;AHozFR;AQ7wDY;EACQ,mBL7iCP;EK8iCO,WLziCZ;AHwzFR;AQ9wDoB;EACI,WL3iChB;AH2zFR;AQ1wDQ;EACI,qBL7jCL;AHy0FP;AQtwDY;EACI,mBLpkCT;AH40FP;AQtwDa;EACG,qBLtkCF;AH80Fd;AQvwDiB;EACG,qBLxkCN;AHi1Fd;AQxwDoB;EACI,mBL3kCjB;EK4kCiB,WLjkChB;EKkkCgB,qBL5kCV;AHs1Fd;AQpwDoB;EACI,mBLplCjB;EKqlCiB,cLllCP;EKmlCO,qBLrlCV;AH21Fd;AQlwDY;EACI,qBL1lCF;AH81Fd;AQnwDgB;EACI,qBL5lCN;AHi2Fd;AQpwDoB;EACI,qBL9lCV;AHo2Fd;AQrwDwB;EACI,mBLjmCrB;EKkmCqB,WLvlCpB;EKwlCoB,qBLlmCd;AHy2Fd;AQjwDwB;EACI,mBL1mCrB;EK2mCqB,cLxmCX;EKymCW,qBL3mCd;AH82Fd;AQ3vDQ;EAII,WL7mCJ;AHu2FR;AQ7vDY;EACI,cAAA;AR+vDhB;AQ1vDY;EACI,WLjnCR;EKknCQ,yBAAA;EACA,gBAAA;EACA,mBAAA;AR4vDhB;AQ3vDgB;EACI,gCAAA;EACA,+BAAA;AR6vDpB;AQ1vDY;EACI,qBLroCF;EKsoCE,mBLvoCT;AHm4FP;AQ3vDgB;EACI,uBAAA;EACA,WL/nCZ;AH43FR;AQxvDI;;;EAGI,qBLjpCM;AH24Fd;AQxvDI;EACI,qBLppCM;EKqpCN,mBLtpCD;EKupCC,cLrpCI;EKspCJ,gBAAA;AR0vDR;AQzvDQ;EACI,qBLzpCE;EK0pCF,mBL3pCL;EK4pCK,cL1pCA;AHq5FZ;AQzvDQ;EACI,qBL9pCE;EK+pCF,mBLhqCL;EKiqCK,cL/pCA;AH05FZ;AQxvDI;EACI,mBLpqCM;EKqqCN,cLpqCI;EKqqCJ,qBLtqCM;AHg6Fd;AQvvDQ;EACI,cLzqCA;AHk6FZ;AQtvDI;EACI,ULpqCA;AH45FR;AQtvDI;EACI,WLvqCA;AH+5FR;AQvvDQ;EACI,cLhsCF;AHy7FV;AQtvDI;EACI,qBLvrCM;AH+6Fd;AQtvDI;EACI,qBL1rCM;AHk7Fd;AQtvDI;EACI,qBL7rCM;AHq7Fd;AQnvDgB;EACI,cLjsCH;AHs7FjB;AQpvDoB;EACI,WL3rChB;AHi7FR;AQpvDoB;EACI,mBLpsCP;EKqsCO,WL/rChB;AHq7FR;AQ/uDQ;EACI,yBL5sCC;EK6sCD,qBLltCE;EKmtCF,WLzsCJ;AH07FR;AQhvDY;EACI,yBLltCH;EKmtCG,qBLttCF;EKutCE,WL7sCR;AH+7FR;AQ7uDI;EACI,qBL7tCM;EK8tCN,mBLxtCE;AHu8FV;AQ7uDY;EACI,WLvtCR;AHs8FR;AQvuDoB;EACI,WLhuChB;AHy8FR;AQhuDgB;EACI,WL1uCZ;AH48FR;AQ7tDI;EACI,mBLnvCE;EKovCF,qBLpvCE;AHm9FV;AQ7tDY;EACI,WLpvCR;AHm9FR;AQ3tDI;EACI,mBL5vCE;EK6vCF,qBLpwCM;AHi+Fd;AQ3tDY;EACI,WL7vCR;AH09FR;AQztDI;EACI,sBAAA;AR2tDR;AQxtDQ;EACI,mBLjxCL;EKkxCK,qBLjxCE;AH2+Fd;AQztDY;EACI,WLzwCR;AHo+FR;AQvtDI;EACI,WL9wCA;AHu+FR;AQvtDI;EACI,sBAAA;ARytDR;AQttDQ;EACI,qBL/xCE;EKgyCF,WLtxCJ;AH8+FR;AQptDQ;EACI,mBL/xCF;EKgyCE,qBLtyCE;AH4/Fd;AQrtDY;EACK,qBLxyCH;AH+/Fd;AQrtDY;EACI,WLjyCR;AHw/FR;AQntDI;EACI,qBLhzCM;AHqgGd;AQntDI;EACI,qBLnzCM;EKozCN,mBLrzCD;AH0gGP;AQltDQ;EACI,mBLzzCL;AH6gGP;AQjtDI;EACI,mBLtzCE;EKuzCF,qBL7zCM;AHghGd;AQhtDQ;EACI,cL/zCK;AHihGjB;AQjtDY;EACI,mBL/zCC;EKg0CD,WL1zCR;AH6gGR;AQ/sDI;EACI,mBLp0CK;EKq0CL,qBL10CM;EK20CN,WLj0CA;AHkhGR;AQ7sDY;EACI,mBL30CH;EK40CG,qBLj1CF;AHgiGd;AQ9sDgB;EACI,mBL90CP;EK+0CO,WL10CZ;AH0hGR;AQ/sDoB;EACI,WL50ChB;AH6hGR;AQ3sDI;EACI,mBLt1CE;EKu1CF,qBL91CM;AH2iGd;AQ1sDgB;EACI,WLx1CZ;AHoiGR;AQ1sDgB;EACI,mBLr2CN;AHijGd;AQxsDQ;EACK,qBL12CC;AHojGd;AQvsDI;EACI,mBLv2CE;EKw2CF,qBL/2CM;AHwjGd;AQvsDY;EACI,yBL32CN;AHojGV;AQpsDgB;EACI,mBLn3CP;AHyjGb;AQ/rDY;EACI,qBLh4CF;EKi4CE,mBL53CH;EK63CG,gBAAA;ARisDhB;AQ3rDY;EACI,mBLn4CN;EKo4CM,qBL14CF;AHukGd;AQzrDY;EACI,cL74CC;AHwkGjB;AQvrDI;EACI,mBL74CE;EK84CF,qBLr5CM;AH8kGd;AQvrDY;EACK,mBLj5CP;EKk5CO,qBLz5CH;AHklGd;AQxrDiB;EACG,mBLp5CV;EKq5CU,qBL55CN;AHslGd;AQprDQ;EACI,cLj6CK;AHulGjB;AQrrDY;EACI,mBL95CN;EK+5CM,WL55CR;AHmlGR;AQlrDQ;EACI,6BAAA;ARorDZ;AQnrDY;EACI,mBL16CC;EK26CD,cL76CC;AHkmGjB;AQlrDQ;EACI,mBL/6CK;EKg7CL,cLl7CK;AHsmGjB;AQjrDI;EACI,qBLx7CM;AH2mGd;AQjrDa;EACG,mBLp7CN;EKq7CM,WLl7CR;AHqmGR;AQ/qDI;EACI,mBL77CS;AH8mGjB;AQ/qDI;EACI,cLl8CS;AHmnGjB;AQhrDS;EACG,mBL/7CF;EKg8CE,WL77CJ;AH+mGR;AQ/qDI;EACI,qBL38CM;AH4nGd;AQ9qDQ;EACI,qBL/8CE;AH+nGd;AQ5qDI;;EAEI,qBLr9CM;AHmoGd;AQ5qDI;;;EAGI,mBLt9CS;EKu9CT,qBL39CM;AHyoGd;AQ5qDI;EACI,sBAAA;AR8qDR;AQ5qDI;EACI,qBLj+CM;AH+oGd;AQ7qDQ;EACI,mBL59CF;AH2oGV;AQ9qDY;EACI,mBL99CN;EK+9CM,qBLt+CF;AHspGd;AQ3qDI;EACI,qBL5+CM;EK6+CN,WLn+CA;AHgpGR;AQ3qDI;EACI,qBLh/CM;AH6pGd;AQ3qDI;EACI,qBLn/CM;EKo/CN,cLl/CS;AH+pGjB;AQ3qDI;EACI,cLr/CS;AHkqGjB;AQ3qDI;EACI,qBL1/CM;AHuqGd;AQ5qDQ;EACI,WLl/CJ;AHgqGR;AQ3qDI;EACI,mBLz/CE;EK0/CF,qBLjgDM;AH8qGd;AQ5qDQ;EACI,cLjgDK;AH+qGjB;AQ5qDQ;EACI,qBLtgDE;AHorGd;AQ7qDY;EACI,qBLxgDF;AHurGd;AQ3qDI;EACI,mBLtgDE;AHmrGV;AQ1qDgB;EACI,yBAAA;AR4qDpB;AQ3qDoB;EACI,cLhiDd;AH6sGV;AQ3qDoB;EACK,qBLthDX;AHmsGd;AQvqDI;EACI,mBLthDE;EKuhDF,qBL9hDM;EK+hDN,cL7hDS;AHssGjB;AQvqDI;;EAEI,WLzhDA;AHksGR;AQtqDQ;EACI,yBLhiDF;AHwsGV;AQvqDY;EACI,yBLniDN;EKoiDM,qBL1iDF;AHmtGd;AQrqDI;EACI,mBLxiDE;AH+sGV;AQrqDI;EACI,mBL3iDE;EK4iDF,qBLnjDM;AH0tGd;AQrqDI;EACI,qBLtjDM;AH6tGd;AQrqDI;EACI,cL/0CM;AHs/Fd;AQrqDI;EACI,qBL5jDM;EK6jDN,cL3jDS;AHkuGjB;AQrqDI;EACI,6BAAA;ARuqDR;AQrqDI;EACI,qBLnkDM;AH0uGd;AQrqDI;EACI,yBLhkDE;AHuuGV;AQtqDQ;EACI,uBAAA;ARwqDZ;AQtqDgB;EACI,WLjkDZ;AHyuGR;AQnqDI;EACI,mBL1kDE;AH+uGV;AQpqDQ;EACI,WLzkDJ;AH+uGR;AQnqDI;EACI,mBLhlDE;AHqvGV;AQpqDQ;EACI,qBLzlDE;AH+vGd;AQrqDY;EACI,WLjlDR;AHwvGR;AQlqDQ;EACI,mBLlmDL;EKmmDK,WLxlDJ;AH4vGR;AQnqDY;EACI,qBLpmDF;AHywGd;AQjqDY;EACI,qBLzmDF;AH4wGd;AQ9pDQ;EACI,mBL1mDC;EK2mDD,qBLhnDE;EKinDF,WLvmDJ;AHuwGR;AQ7pDI;EACI,mBLrnDM;AHoxGd;AQ7pDI;EACI,qBLxnDM;AHuxGd;AQ9pDQ;EACI,WLhnDJ;AHgxGR;AQ7pDI;EACI,mBLznDK;EK0nDL,qBL/nDM;EKgoDN,WLtnDA;AHqxGR;AQ7pDI;EACI,gBAAA;AR+pDR;AQ9pDQ;EACI,cLnoDK;EKooDL,qBLtoDE;AHsyGd;AQ7pDI;EACI,qBL1oDM;AHyyGd;AQ7pDI;EACI,qBL7oDM;AH4yGd;AQ5pDQ;EACI,WLvoDJ;AHqyGR;AQ3pDI;EACI,WL3oDA;AHwyGR;AQ3pDI;EACI,yBLjpDE;EKkpDF,qBLzpDM;AHszGd;AQ5pDQ;EACI,qBL3pDE;AHyzGd;AQ7pDY;EACI,WLnpDR;AHkzGR;AQ5pDQ;EACI,WLvpDJ;AHqzGR;AQ5pDQ;EACI,yBL9pDF;AH4zGV;AQ7pDY;EACI,qBLtqDF;AHq0Gd;AQ9pDgB;EACI,WL9pDZ;AH8zGR;AQ7pDY;EACI,WLlqDR;AHi0GR;AQ3pDI;EACI,qBLjrDM;AH80Gd;AQ3pDI;EACI,yBL7qDE;AH00GV;AQ5pDQ;EACI,qBLtrDE;AHo1Gd;AQ5pDQ;EACI,qBLzrDE;AHu1Gd;AQ3pDI;EACI,yBLtrDE;EKurDF,qBL9rDM;EK+rDN,gBAAA;AR6pDR;AQ3pDI;EACI,yBL3rDE;EK4rDF,qBLnsDM;AHg2Gd;AQ5pDQ;EACI,cLnsDK;AHi2GjB;AQ3pDI;EACI,yBLlsDE;EKmsDF,qBL1sDM;AHu2Gd;AQ1pDQ;EACI,yBLvsDF;EKwsDE,gBAAA;AR4pDZ;AQ1pDQ;EACI,qBLltDE;AH82Gd;AQ1pDQ;EACI,qBLrtDE;AHi3Gd;AQzpDI;EACI,yBLltDE;AH62GV;AQzpDI;EACI,qBL5tDM;EK6tDN,yBLttDE;AHi3GV;AQzpDI;EACI,uBAAA;AR2pDR;AQzpDI;EACI,yBL5tDE;AHu3GV;AQzpDI;EACI,yBL/tDE;AH03GV;AQzpDI;EACI,yBLluDE;EKmuDF,qBL1uDM;EK2uDN,gBAAA;AR2pDR;AQzpDI;EACI,yBLvuDE;AHk4GV;AQzpDI;EACI,yBL1uDE;EK2uDF,qBLlvDM;AH64Gd;AQzpDI;EACI,WL3uDA;AHs4GR;AQxpDQ;EACI,WL/uDJ;AHy4GR;AQxpDQ;EACI,cL1vDK;AHo5GjB;AQvpDI;EACI,WLtvDA;AH+4GR;AQvpDI;EACI,yBAAA;ARypDR;AQvpDI;EACI,WL5vDA;AHq5GR;AQvpDI;EACI,qBLzwDM;AHk6Gd;AQvpDI;EACK,cL1wDQ;AHm6GjB;AQvpDI;EACI,yBLxwDE;EKywDF,qBLhxDM;AHy6Gd;AQxpDQ;EACI,qBLlxDE;AH46Gd;AQxpDQ;EACI,qBLrxDE;AH+6Gd;AQzpDY;EACI,cLrxDC;AHg7GjB;;AQppDI;EACI,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,4BAAA;EACA,6BAAA;ARupDR;AQtpDQ;EACI,qCAAA;ARwpDZ;;AQlpDI;EACI,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,4BAAA;EACA,6BAAA;ARqpDR;AQppDQ;EACI,qCAAA;ARspDZ;;AQhpDI;EACI,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,4BAAA;EACA,6BAAA;ARmpDR;AQlpDQ;EACI,qCAAA;ARopDZ;;AQ9oDI;EACI,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,4BAAA;EACA,6BAAA;ARipDR;AQhpDQ;EACI,qCAAA;ARkpDZ;;AQ7oDI;EACI,gCAAA;ARgpDR;AQ9oDI;EACI,qBLr1DM;EKs1DN,cLp1DS;AHo+GjB;AQ9oDI;EACI,mBL11DD;EK21DC,qBL11DM;AH0+Gd;AQ9oDI;EACI,8BAAA;ARgpDR;AQ9oDI;EACI,mBL31DK;AH2+Gb;AQ9oDI;EACI,mBL91DK;AH8+Gb;AQ9oDI;EACI,mBLv2DD;AHu/GP;AQ9oDI;EACI,uBAAA;ARgpDR;AQ9oDI;EACI,gCAAA;ARgpDR;AQ9oDI;EACI,gCAAA;ARgpDR;AQ9oDI;EACI,gCAAA;ARgpDR;AQ9oDI;EACI,gCAAA;ARgpDR;AQ9oDI;EACI,gCAAA;EACA,WL/2DA;AH+/GR;AQ7oDQ;EACI,WLn3DJ;AHkgHR;;AS7iHA;EACI,eAAA;EACA,OAAA;EACA,aAAA;EACC,2BAAA;EACD,YAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;ATgjHJ;AS/iHI;EACI,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,2BAAA;EACA,8BAAA;ATijHR;AShjHQ;EAEI,qCAAA;ATkjHZ;;AS7iHA;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;ATgjHJ;;AS9iHA;EACI,WAAA;ATijHJ;;AS/iHA;EACI,eAAA;EACA,aAAA;EACA,MAAA;EACA,gBAAA;EACA,oBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;ATkjHJ;ASjjHI;EACI,QAAA;ATmjHR;ASjjHI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;EACA,gCAAA;ATmjHR;ASljHQ;EACI,cNgHD;EM/GC,eAAA;ATojHZ;ASjjHI;EACI,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ATmjHR;ASljHQ;EACI,gCAAA;EACA,mBAAA;ATojHZ;ASnjHY;EACI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;ATqjHhB;ASjjHI;EACI,mBN0EI;EMzEJ,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;ATmjHR;ASljHQ;EACI,aAAA;ATojHZ;AShjHwB;EACI,yBNtDnB;EMuDmB,qBNvDnB;EMwDmB,WAAA;ATkjH5B;AShjHwB;EACI,gBAAA;EACA,kCAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;ATkjH5B;AS5iHQ;EACI,YAAA;AT8iHZ;AS5iHQ;EACI,kBAAA;EACA,WAAA;EACA,cAAA;AT8iHZ;AS7iHY;EACI,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AT+iHhB;;AS1iHA;EACI,eAAA;EACA,WAAA;EACA,aAAA;EACA,+BAAA;EACA,MAAA;EACA,WAAA;EACA,cAAA;AT6iHJ;AS5iHI;EACI,OAAA;AT8iHR;;AS3iHA;EACI,cAAA;AT8iHJ;AS7iHI;EACI,aAAA;EACA,mBAAA;AT+iHR;AS5iHgB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AT8iHpB;AS7iHoB;EACI,mBN/Id;AH8rHV;AS7iHoB;EACI,mBNhJZ;AH+rHZ;AS7iHoB;EACI,mBAAA;AT+iHxB;AS7iHoB;EACI,mBAAA;AT+iHxB;AS5iHgB;EACI,aAAA;AT8iHpB;AS3iH4B;EACI,gBAAA;EACA,kCAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,kBAAA;AT6iHhC;ASviHY;EACI,iBAAA;ATyiHhB;;ASpiHA;EACI,gBAAA;ATuiHJ;AStiHI;EACI,aAAA;EACA,mBAAA;ATwiHR;ASviHQ;EACI,UAAA;ATyiHZ;ASxiHY;EACI,iBAAA;AT0iHhB;ASxiHY;EACI,WAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AT0iHhB;ASxiHY;EACI,mBN1DJ;EM2DI,yBAAA;EACA,cN7CL;AHulHX;ASziHgB;EACI,mBN1DR;AHqmHZ;ASxiHY;EACI,mBNjLR;EMkLQ,WAAA;AT0iHhB;ASziHgB;EACI,mBAAA;AT2iHpB;;AUlxHA;ENwGG,aMvG+B;EAC9B,gCAAA;AVqxHJ;AUpxHI;EACI,ePoWO;EOnWP,gBPMe;EOLf,WPsCA;EOrCA,gBAAA;AVsxHR;;AUlxHI;EACI,YAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;AVqxHR;AUnxHI;EACI,gBAAA;EACA,UAAA;EACA,SAAA;AVqxHR;AUpxHQ;EACI,aAAA;EACA,gCAAA;EACA,ePpBK;AH0yHjB;AUrxHY;EACI,gBAAA;AVuxHhB;AUrxHY;EACI,cAAA;EN2Eb,aM1E2C;AVuxH9C;AUrxHY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBP+SG;EO9SH,kBAAA;AVuxHhB;AUtxHgB;EACI,kBP4SD;AH4+GnB;AUtxHgB;EACI,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;AVwxHpB;AUrxHY;EACI,cP8HL;EO7HK,gBPzCK;AHg0HrB;AUrxHY;EACI,gBP5CK;EO6CL,cPqHL;ECrER,eM/CqC;AVuxHxC;AUrxHY;EACI,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,cP4GL;EO3GK,kBAAA;ENsCb,eMrCqC;ENsCrC,mBMtC8C;AVwxHjD;AUvxHgB;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,UAAA;EACA,8BAAA;EACA,mBPmGT;EOlGS,kBPyQD;AHghHnB;AUtxHY;EACI,ePqRD;EOpRC,cPkGL;EC1ER,SMvBqC;AVwxHxC;AUtxHY;EAGI,oBAAA;EAGA,mBAAA;EACA,yBAAA;EACA,kBPyPG;EOxPH,aAAA;EACA,kBAAA;AVwxHhB;AUvxHgB;EACI,kBAAA;AVyxHpB;AUxxHoB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,cPrFd;EOsFc,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,kBPqOL;AHqjHnB;AUvxHgB;EACI,mBAAA;AVyxHpB;AUxxHoB;EACI,eP+OT;EO9OS,cP4Db;EO3Da,gBAAA;AV0xHxB;AUxxHoB;EACI,eP0OT;EOzOS,cPgJX;AH0oHb;AUtxHY;EACI,ePoOD;EOnOC,iBAAA;EACA,cP6CL;AH2uHX;AUtxHY;EACI,SAAA;EACA,UAAA;EACA,kBAAA;AVwxHhB;AUvxHgB;EACI,YAAA;EACA,kBAAA;EACA,WAAA;AVyxHpB;AUvxHgB;ENpCb,mBMqC+C;AVyxHlD;AUxxHoB;EACI,cPiCb;EOhCa,WAAA;EACA,gBPvIH;EOwIG,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AV0xHxB;AUxxHoB;EACI,cPoBb;EOnBa,YAAA;EACA,ePsMT;AHolHf;AUxxHoB;EACI,cPiBb;EOhBa,ePoMT;EOnMS,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AV0xHxB;;AUnxHA;EACI,mBPdQ;EOeR,iBAAA;ENtED,aMuE+B;AVsxHlC;AUrxHI;EACI,gBPtKe;EOuKf,kBAAA;AVuxHR;AUtxHQ;EACI,eAAA;AVwxHZ;AUrxHI;EACI,cPPG;AH8xHX;AUtxHQ;EACI,cPdD;AHsyHX;AUrxHI;EACI,cP1KE;AHi8HV;AUtxHQ;EACI,cAAA;AVwxHZ;;AUpxHA;EACI,YAAA;EACA,kBAAA;EACA,WAAA;AVuxHJ;;AUrxHA;ENjGG,mBMkG+B;AVwxHlC;AUvxHI;EACI,cP5BG;EO6BH,WAAA;EACA,gBPpMa;EOqMb,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AVyxHR;AUvxHI;EACI,cPzCG;EO0CH,YAAA;EACA,ePyIO;AHgpHf;AUvxHI;EACI,cP5CG;EO6CH,ePuIO;EOtIP,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AVyxHR;;AUtxHA;EACI,WAAA;AVyxHJ;AUxxHI;EACI,kBAAA;AV0xHR;AUxxHI;EACI,gBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;AV0xHR;AUzxHQ;EACI,sBPrMJ;EOsMI,kBAAA;EACA,yBAAA;EN3IT,gBM4IiC;EN3IjC,uBM2I6C;EACpC,ePkHG;AH0qHf;AU3xHY;EACI,YAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EN1Jd,kBM2JgC;EN1JhC,SM0JyC;ENvJzC,SMuJwD;AV+xH1D;AU7xHY;EACI,sBPlNR;EOmNQ,kBAAA;ENvJb,kBMwJqC;ENvJrC,UMuJiD;AVgyHpD;AU9xHY;EACI,cPrFL;EOsFK,cAAA;EACA,eP+FD;EO9FC,iBAAA;AVgyHhB;AU9xHY;EACI,WP5NR;AH4/HR;AU9xHY;EACI,cPrPJ;EOsPI,gBPjQO;EOkQP,ePyFD;AHusHf;AU/xHgB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AViyHpB;;ACpiIA,0BAAA;AUdA;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBR0UY;EQzUZ,WRmCI;EQlCJ,gBRCiB;AHqjIrB;AWrjII;EACI,WRgCA;AHuhIR;AWrjII;EACI,WAAA;EACA,YAAA;EACA,kBRiUQ;AHsvHhB;AWrjII;EACI,kBAAA;AXujIR;AWtjIQ;EACI,kBAAA;AXwjIZ;AWrjII;EACI,gBAAA;AXujIR;AWtjIQ;EACI,gBAAA;AXwjIZ;AWrjII;EACI,kBAAA;EACA,sBAAA;EACA,2BAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AXujIR;AWpjIQ;EACI,kBAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iCAAA;EACA,UAAA;AXsjIZ;AWnjII;EACI,yBRjCE;AHslIV;AWnjII;EACI,yBRiHG;AHo8HX;AWnjII;EACI,cAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;AXqjIR;AWpjIQ;EACI,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,uBAAA;EACA,yBAAA;AXsjIZ;AWnjII;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AXqjIR;AWpjIQ;EACI,eAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EACA,0BAAA;AXsjIZ;AWnjIY;EACI,aAAA;EACA,cAAA;AXqjIhB;AWjjII;EACI,aAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;AXmjIR;AWljIQ;EACI,eAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,sBAAA;AXojIZ;AWjjIY;EACI,cAAA;EACA,eAAA;AXmjIhB;AWhjIQ;EACI,aAAA;EACA,cAAA;AXkjIZ;AW/iII;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AXijIR;AWhjIQ;EACI,uBAAA;EACA,wBAAA;AXkjIZ;AW/iIY;EACI,aAAA;EACA,cAAA;AXijIhB;AW9iIQ;EACI,aAAA;EACA,cAAA;AXgjIZ;AW7iII;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AX+iIR;AW9iIQ;EACI,sBAAA;EACA,uBAAA;AXgjIZ;AW7iIY;EACI,cAAA;EACA,eAAA;AX+iIhB;AW3iII;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;AX6iIR;AW5iIQ;EACI,sBAAA;EACA,sBAAA;AX8iIZ;AW3iIY;EACI,cAAA;EACA,eAAA;EACA,wBAAA;AX6iIhB;AW1iIgB;EACI,WAAA;EACA,YAAA;EACA,qBAAA;AX4iIpB;AWviII;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AXyiIR;AWxiIQ;EACI,sBAAA;EACA,sBAAA;AX0iIZ;AWviIY;EACI,cAAA;EACA,eAAA;EACA,wBAAA;AXyiIhB;;AWpiIA;EACI,UAAA;AXuiIJ;AWriIQ;EACI,uBAAA;AXuiIZ;AWtiIY;EACI,UAAA;AXwiIhB;AWniIQ;EACI,cAAA;EACA,eAAA;AXqiIZ;AWpiIY;EACI,kBAAA;AXsiIhB;AWniIQ;EACI,mBAAA;AXqiIZ;AWjiIQ;EACI,WAAA;EACA,YAAA;AXmiIZ;AWliIY;EACI,iBAAA;AXoiIhB;AWjiIQ;EACI,uBAAA;AXmiIZ;AW/hIQ;EACI,aAAA;EACA,cAAA;AXiiIZ;AWhiIY;EACI,iBAAA;AXkiIhB;AW9hII;EACI,uCAAA;EACA,qCAAA;EACA,sBAAA;EACA,gCAAA;AXgiIR;AW/hIQ;EACI,+BAAA;AXiiIZ;AW/hIQ;EACI,UAAA;EACA,gCAAA;AXiiIZ;;AW7hIA;EAGC,oBAAA;AXgiID;AW/hIC;EACC,eAAA;EACA,gBAAA;AXiiIF;AWhiIE;;EAEC,sBAAA;EACA,iBAAA;AXkiIH;AW9hIE;EACC,uBAAA;AXgiIH;AW/hIG;EACC,UAAA;AXiiIJ;AW5hIE;EACC,cAAA;EACA,eAAA;AX8hIH;AW7hIG;EACC,kBAAA;AX+hIJ;AW5hIE;EACC,mBAAA;AX8hIH;AW1hIE;EACC,WAAA;EACA,YAAA;AX4hIH;AW3hIG;EACC,iBAAA;AX6hIJ;AW1hIE;EACC,uBAAA;AX4hIH;;AWxhIA;EACI,WAAA;EACA,YAAA;AX2hIJ;;AY70IA;;EAEC,yBT0BS;ESzBT,kBAAA;AZg1ID;;AY90IA;EACC,4BTsBS;AH2zIV;;AY/0IA;EACI,uBAAA;AZk1IJ;;AYh1IA;EACI,gCAAA;AZm1IJ;;AYh1IA;EACC,cT6BQ;AHszIT;AYl1IC;EACE,cAAA;AZo1IH;;AYj1IA;EACC,qBTgJW;AHosIZ;;Aa12IA;EACI,WV0CI;EUzCJ,yBVkBM;EUjBN,qBViBM;EUhBN,eViWW;EUhWX,eVgWW;AH6gIf;;Aa32IA;EACI,mBVYM;EUXN,WVkCI;EUjCJ,eV2VW;EU1VX,eV0VW;EUzVX,kBAAA;ET4FD,iBS3F+B;ET8EhC,yBS7EsB;Abg3IxB;Aa/2II;EACI,mBVKQ;EUJR,WV0BA;AHu1IR;AIr1II;EStCJ;IAaQ,eAAA;IACA,gBAAA;Ebk3IN;AACF;;Aah3IA;EACI,mBViPS;EUhPT,WViBI;EUhBJ,eV0UW;EUzUX,gBVhBe;EUiBf,kBAAA;ET2ED,iBS1E+B;ET6DhC,yBS5DsB;Abq3IxB;Aap3II;EACI,mBVXI;EUYJ,WVSA;AH62IR;AI32II;ESrBJ;IAaQ,eAAA;IACA,gBAAA;Ebu3IN;AACF;;Aar3IA;EACI,mBVtBM;ECoFP,iBS7D+B;EAG9B,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,gBV1Ce;EU2Cf,eV8SW;EU7SX,kBAAA;EACA,kBAAA;Abw3IJ;Aav3II;EACI,mBVtCQ;EUuCR,WVjBA;AH04IR;Aav3II;EACI,kBAAA;EACA,WAAA;EACA,YAAA;Aby3IR;;Aat3IA;EACI,mBV/CQ;ECkFT,iBSlC+B;EAG9B,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,gBVrEe;EUsEf,eVmRW;EUlRX,kBAAA;EACA,kBAAA;Aby3IJ;Aax3II;EACI,mBV2FG;EU1FH,WV5CA;AHs6IR;Aax3II;EACI,kBAAA;EACA,WAAA;EACA,YAAA;Ab03IR;;Aav3IA;EACI,mBVlEK;EC0EN,iBSP+B;EAG9B,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,gBVhGe;EUiGf,eVwPW;EUvPX,kBAAA;EACA,kBAAA;Ab03IJ;Aaz3II;EACI,mBVnFC;EUoFD,WVvEA;AHk8IR;Aaz3II;EACI,kBAAA;EACA,WAAA;EACA,YAAA;Ab23IR;;Aav3IA;EACI,iBAAA;EACA,WAAA;EACA,gBVlHe;EUmHf,eVsOW;EUrOX,kBAAA;Ab03IJ;Aaz3II;EACI,WAAA;EACA,YAAA;Ab23IR;;Aax3IA;EACI,yBVnHM;EUoHN,qBVpHM;AH++IV;;Aaz3IA;EACI,yBVvHM;EUwHN,qBVxHM;EUyHN,WVlGI;AH89IR;;Aaz3II;EACI,SAAA;Ab43IR;;Aav3IQ;EACI,6BAAA;EACA,yBAAA;Ab03IZ;Aaz3IY;EACI,cVpIJ;AH+/IZ;;Aap3IQ;EACI,kBAAA;Abu3IZ;;Aan3IA;EACI,YAAA;Abs3IJ;;Aap3IA;EACI,eAAA;Abu3IJ;Aat3II;EACI,UAAA;EACA,gBAAA;Abw3IR;;Aar3IA;EACI,kBVkKe;EUjKf,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBV3KmB;AHmiJvB;Aav3II;EACI,2BAAA;Aby3IR;Aav3II;EACI,oBAAA;Aby3IR;Aav3II;EACI,qBAAA;EACA,kBAAA;Aby3IR;Aav3II;EACI,uBAAA;EACA,kBAAA;Aby3IR;Aar3IQ;EACI,yBAAA;EACA,yBAAA;EACA,WV/JJ;AHshJR;Aat3IY;EAKI,yBAAA;EACA,yBAAA;EACA,WVvKR;AH2hJR;Aa/3IQ;EACI,yBAAA;EACA,yBAAA;EACA,WV/JJ;AHgiJR;Aah4IY;EAKI,yBAAA;EACA,yBAAA;EACA,WVvKR;AHqiJR;Aaz4IQ;EACI,yBAAA;EACA,yBAAA;EACA,WV/JJ;AH0iJR;Aa14IY;EAKI,yBAAA;EACA,yBAAA;EACA,WVvKR;AH+iJR;Aan5IQ;EACI,yBAAA;EACA,yBAAA;EACA,WV/JJ;AHojJR;Aap5IY;EAKI,yBAAA;EACA,yBAAA;EACA,WVvKR;AHyjJR;Aa75IQ;EACI,yBAAA;EACA,yBAAA;EACA,WV/JJ;AH8jJR;Aa95IY;EAKI,yBAAA;EACA,yBAAA;EACA,WVvKR;AHmkJR;Aav6IQ;EACI,yBAAA;EACA,yBAAA;EACA,WV/JJ;AHwkJR;Aax6IY;EAKI,yBAAA;EACA,yBAAA;EACA,WVvKR;AH6kJR;Aaj7IQ;EACI,yBAAA;EACA,yBAAA;EACA,WV/JJ;AHklJR;Aal7IY;EAKI,yBAAA;EACA,yBAAA;EACA,WVvKR;AHulJR;Aa37IQ;EACI,yBAAA;EACA,yBAAA;EACA,WV/JJ;AH4lJR;Aa57IY;EAKI,yBAAA;EACA,yBAAA;EACA,WVvKR;AHimJR;Aar8IQ;EACI,sBAAA;EACA,sBAAA;EACA,WV/JJ;AHsmJR;Aat8IY;EAKI,uBAAA;EACA,uBAAA;EACA,WVvKR;AH2mJR;Aa/8IQ;EACI,yBAAA;EACA,yBAAA;EACA,WV/JJ;AHgnJR;Aah9IY;EAKI,yBAAA;EACA,yBAAA;EACA,WVvKR;AHqnJR;Aaz9IQ;EACI,yBAAA;EACA,yBAAA;EACA,WV/JJ;AH0nJR;Aa19IY;EAKI,yBAAA;EACA,yBAAA;EACA,WVvKR;AH+nJR;Aan+IQ;EACI,yBAAA;EACA,yBAAA;EACA,WV/JJ;AHooJR;Aap+IY;EAKI,yBAAA;EACA,yBAAA;EACA,WVvKR;AHyoJR;Aa99II;EACI,yBVtDI;EUuDJ,yBAAA;EACA,cVxCG;AHwgJX;Aa/9IQ;EAKI,yBAAA;EACA,yBAAA;EACA,cVhDD;AH6gJX;;Aav9II;EACE,wBAAA;Ab09IN;;Aat9II;EACE,qBAAA;Aby9IN;;Aar9II;EACE,uBAAA;Abw9IN;;Aap9II;EACE,mBAAA;Abu9IN;Aar9II;EACE,mBAAA;Abu9IN;Aar9II;EACE,mBAAA;Abu9IN;Aar9II;EACE,mBAAA;Abu9IN;;Aan9II;EACE,aAAA;EACA,eAAA;Abs9IN;Aap9II;EACE,cAAA;EACA,eAAA;EACA,iBAAA;Abs9IN;Aap9II;EACE,cAAA;EACA,eAAA;EACA,iBAAA;Abs9IN;;Aal9II;EACE,6BAAA;Abq9IN;;Aah9IM;;;;EAIE,6BAAA;Abm9IR;;Aa98IE;EACE,yBAAA;Abi9IJ;;Aa/8IE;EACE,gBAAA;Abk9IJ;;Aah9IA;EACI,4BAAA;Abm9IJ;;Aaj9IE;EACE,4BAAA;Abo9IJ;;Aaj9IE;EACE,0BAAA;Abo9IJ;;Aal9IE;EACE,0BAAA;Abq9IJ;;Aal9IE;EACE,uCAAA;EACA,cVrSM;AH0vJV;Aap9II;EAGE,yBVzSI;EU0SJ,WVnRE;EUoRF,qBV3SI;AH+vJV;Aah9IE;EACE,wCAAA;EACA,cV/SQ;AHiwJZ;Aaj9II;EAGE,yBVnTM;EUoTN,WV/RE;EUgSF,qBVrTM;AHswJZ;Aa98IE;EACE,wCAAA;EACA,cVpTM;AHowJV;Aa/8II;EAGE,yBVxTI;EUyTJ,WV1SE;EU2SF,qBV1TI;AHywJV;Aa58IE;EACE,yCAAA;EACA,cVjUG;AH+wJP;Aa78II;EAGE,yBVrUC;EUsUD,WVrTE;EUsTF,qBVvUC;AHoxJP;Aa18IE;EACE,wCAAA;EACA,cV9UM;AH0xJV;Aa38II;EAGE,yBVlVI;EUmVJ,WVhUE;EUiUF,qBVpVI;AH+xJV;Aax8IE;EACE,uCAAA;EACA,cVnVK;AH6xJT;Aaz8II;EAGE,yBVvVG;EUwVH,WV3UE;EU4UF,qBVzVG;AHkyJT;;Aap8IE;EACE,6BAAA;EACA,cV1WM;EU2WN,yBAAA;Abu8IJ;Aat8II;EACE,cV7WI;EU8WJ,yBAAA;EACA,6BAAA;Abw8IN;Aar8IE;EACE,8BAAA;EACA,gCAAA;EACA,gBAAA;EACA,WAAA;Abu8IJ;Aat8II;EACE,mBVxXI;AHg0JV;Aar8IE;EACE,6BAAA;EACA,cV3XQ;EU4XR,yBAAA;Abu8IJ;Aat8II;EACE,cV9XM;EU+XN,yBAAA;EACA,6BAAA;Abw8IN;Aar8IE;EACE,6BAAA;EACA,cV/XM;EUgYN,yBAAA;Abu8IJ;Aat8II;EACE,cVlYI;EUmYJ,yBAAA;EACA,6BAAA;Abw8IN;Aar8IE;EACE,6BAAA;EACA,cV3YG;EU4YH,yBAAA;Abu8IJ;Aat8II;EACE,cV9YC;EU+YD,yBAAA;EACA,6BAAA;Abw8IN;Aar8IE;EACE,6BAAA;EACA,cVvZM;EUwZN,yBAAA;Abu8IJ;Aat8II;EACE,cV1ZI;EU2ZJ,yBAAA;EACA,6BAAA;Abw8IN;Aar8IE;EACE,6BAAA;EACA,cV3ZK;EU4ZL,yBAAA;Abu8IJ;Aat8II;EACE,cV9ZG;EU+ZH,yBAAA;EACA,6BAAA;Abw8IN;;Aan8IE;EACE,6BAAA;Abs8IJ;;Aan8IA;EACI,oCAAA;EACA,yBAAA;Abs8IJ;Aar8II;EAKI,oCAAA;EACA,oCAAA;EACA,4CAAA;EACA,sBAAA;Abm8IR;;Aah8IA;EACI,oCAAA;EACA,yBAAA;Abm8IJ;Aal8II;EAKI,oCAAA;EACA,oCAAA;EACA,6CAAA;EACA,sBAAA;Abg8IR;;Aa77IA;EACI,oCAAA;EACA,yBAAA;Abg8IJ;Aa/7II;EAKI,oCAAA;EACA,oCAAA;EACA,6CAAA;EACA,sBAAA;Ab67IR;;Aa17IA;EACI,oCAAA;EACA,yBAAA;Ab67IJ;Aa57II;EAKI,oCAAA;EACA,oCAAA;EACA,4CAAA;EACA,sBAAA;Ab07IR;;Aav7IA;EACI,oCAAA;EACA,yBAAA;Ab07IJ;Aaz7II;EAKI,oCAAA;EACA,oCAAA;EACA,6CAAA;EACA,sBAAA;Abu7IR;;Aap7IA;EACI,oCAAA;EACA,yBAAA;Abu7IJ;Aat7II;EAKI,oCAAA;EACA,oCAAA;EACA,8CAAA;EACA,sBAAA;Abo7IR;;Aaj7IA;EACI,yBAAA;EACA,yBAAA;Abo7IJ;Aan7II;EAKI,yBV1fA;EU2fA,yBAAA;EACA,yBAAA;Abi7IR;;Aa96IA;EACI,oCAAA;EACA,yBAAA;Abi7IJ;Aah7II;EAKI,oCAAA;EACA,oCAAA;EACA,4CAAA;EACA,sBAAA;Ab86IR;;Aa36IA;EACI,oCAAA;EACA,yBAAA;Ab86IJ;Aa76II;EAKG,4CAAA;EACA,qBV3iBG;AHs9JV;;Aax6IA;EACI,oCAAA;EACA,yBAAA;Ab26IJ;Aa16II;EAKG,6CAAA;EACA,qBVrjBK;AH69JZ;;Aar6IA;EACI,oCAAA;EACA,yBAAA;Abw6IJ;Aav6II;EAKG,6CAAA;EACA,qBV/jBG;AHo+JV;;Aal6IA;EACI,oCAAA;EACA,yBAAA;Abq6IJ;Aap6II;EAKG,4CAAA;EACA,qBVrkBE;AHu+JT;;Aa/5IA;EACI,oCAAA;EACA,yBAAA;Abk6IJ;Aaj6II;EAKG,6CAAA;EACA,qBVnlBG;AHk/JV;;Aa55IA;EACI,oDAAA;EACA,yBAAA;Ab+5IJ;Aa95II;EAKG,8CAAA;EACA,qBVjmBA;AH6/JP;;Aaz5IA;EACI,qDAAA;EACA,yBAAA;Ab45IJ;Aa35II;EAKG,+CAAA;EACA,qBV9lBC;EU+lBD,qBV9XM;AHuxJb;;Aat5IA;EACI,kDAAA;EACA,sBAAA;Aby5IJ;Aax5II;EAKG,4CAAA;EACA,qBVpnBA;AH0gKP;;Aal5IE;EACE,sBAAA;EACA,oBAAA;Abq5IJ;Aap5II;EACE,mBV9nBG;EU+nBH,WVlnBE;EUmnBF,gCAAA;EACA,oBAAA;EACA,0BAAA;Abs5IN;;Aah5II;EACE,sBAAA;EACA,oBAAA;EACA,sBAAA;EACA,uBAAA;Abm5IN;Aal5IM;EACE,8BAAA;EACA,sBAAA;EACA,gCAAA;EACA,oBAAA;EACA,0BAAA;Abo5IR;;Aa/4IA;EACE,yBVtdW;EUudX,qBVvdW;EUwdX,cV3oBO;EU4oBP,eVpVa;EUqVb,gBVhrBmB;EUirBnB,kBAAA;ETnlBC,iBSolB6B;ETjmB9B,yBSkmBoB;EAGpB,mBAAA;EAGA,oBAAA;Abo5IF;AI1iKI;ESwoBJ;IT7kBG,iBS6lBiC;Ebs5IlC;AACF;;Aan5IA;EACE,mBVvpBM;EUwpBN,yBAAA;EThnBA,yBSinBoB;EAGpB,mBAAA;EAGA,oBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;Abw5IF;Aav5IE;EACI,mBAAA;EACA,qBAAA;EACA,WV9qBE;AHukKR;AIrkKI;ES4pBJ;IAmBM,eAAA;Eb05IJ;AACF;;ActnKI;EACI,iCAAA;EACA,2CAAA;EACA,cXgBE;AHymKV;;AcnnKQ;EACI,mBAAA;EACA,2CAAA;EACA,WX8BJ;AHwlKR;AcpnKQ;EACI,iCAAA;EACA,2CAAA;EACA,cXyOG;AH64Jf;;Ac9nKQ;EACI,mBAAA;EACA,4CAAA;EACA,WX8BJ;AHmmKR;Ac/nKQ;EACI,kCAAA;EACA,4CAAA;EACA,cXyOG;AHw5Jf;;AczoKQ;EACI,mBAAA;EACA,4CAAA;EACA,WX8BJ;AH8mKR;Ac1oKQ;EACI,kCAAA;EACA,4CAAA;EACA,cXyOG;AHm6Jf;;AcppKQ;EACI,mBAAA;EACA,6CAAA;EACA,WX8BJ;AHynKR;AcrpKQ;EACI,mCAAA;EACA,6CAAA;EACA,cXyOG;AH86Jf;;Ac/pKQ;EACI,mBAAA;EACA,4CAAA;EACA,WX8BJ;AHooKR;AchqKQ;EACI,kCAAA;EACA,4CAAA;EACA,cXyOG;AHy7Jf;;Ac1qKQ;EACI,mBAAA;EACA,2CAAA;EACA,WX8BJ;AH+oKR;Ac3qKQ;EACI,iCAAA;EACA,2CAAA;EACA,cXyOG;AHo8Jf;;AcrrKQ;EACI,mBAAA;EACA,2CAAA;EACA,WX8BJ;AH0pKR;ActrKQ;EACI,iCAAA;EACA,2CAAA;EACA,cXyOG;AH+8Jf;;AchsKQ;EACI,mBAAA;EACA,8CAAA;EACA,WX8BJ;AHqqKR;AcjsKQ;EACI,oCAAA;EACA,8CAAA;EACA,cXyOG;AH09Jf;;Ac3sKQ;EACI,gBAAA;EACA,wCAAA;EACA,WX8BJ;AHgrKR;Ac5sKQ;EACI,8BAAA;EACA,wCAAA;EACA,WXyOG;AHq+Jf;;ActtKQ;EACI,mBAAA;EACA,2CAAA;EACA,WX8BJ;AH2rKR;AcvtKQ;EACI,iCAAA;EACA,2CAAA;EACA,cXyOG;AHg/Jf;;AcjuKQ;EACI,mBAAA;EACA,4CAAA;EACA,WX8BJ;AHssKR;AcluKQ;EACI,kCAAA;EACA,4CAAA;EACA,cXyOG;AH2/Jf;;Ac5uKQ;EACI,mBAAA;EACA,4CAAA;EACA,WX8BJ;AHitKR;Ac7uKQ;EACI,kCAAA;EACA,4CAAA;EACA,cXyOG;AHsgKf;;Ac3uKA;EACI,wBAAA;EACA,0BAAA;EACA,gBXdmB;EWenB,qBAAA;EACA,kBXsTY;EWrTZ,cXqJO;AHylKX;Ac7uKI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;Ad+uKR;Ac7uKI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;Ad+uKR;Ac7uKI;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;Ad+uKR;Ac7uKI;EACI,eXwTO;EWvTP,iBAAA;EACA,iBAAA;Ad+uKR;Ac7uKI;EACI,eXqTO;EWpTP,iBAAA;EACA,iBAAA;Ad+uKR;;Ac3uKA;EACI,mBXuKS;EWtKT,cXbK;AH2vKT;;Ac3uKA;EACI,oCAAA;Ad8uKJ;Ac7uKI;EACI,yBXkJK;AH6lKb;;Ac5uKA;EACI,oCAAA;Ad+uKJ;Ac9uKI;EACI,yBXiIM;AH+mKd;;Ac7uKA;EACI,oCAAA;AdgvKJ;Ac/uKI;EACI,yBXgHG;AHioKX;;Ac9uKA;EACI,oCAAA;AdivKJ;AchvKI;EACI,yBX2IM;AHumKd;;Ac/uKA;EACI,oCAAA;EACA,cX2HS;AHunKb;;AchvKA;EACC,8BAAA;EACG,sBAAA;AdmvKJ;;AcjvKA;EACI,mBXvCO;EWwCP,WXpDI;AHwyKR;;AclvKA;EACI,kBAAA;EACA,eXgQW;EW/PX,gBAAA;EACA,eAAA;EACA,WX3DI;AHgzKR;;AcnvKA;EACI,kBAAA;EACA,eXyPW;EWxPX,gBAAA;EACA,gBXnGiB;AHy1KrB;AcrvKI;EACI,mBXkFM;EWjFN,cXvFE;AH80KV;AcrvKI;EACI,mBXmGM;EWlGN,cXvFE;AH80KV;AcrvKI;EACI,mBX0GK;EWzGL,cX1EC;AHi0KT;AcrvKI;EACI,mBXgFK;EW/EL,cX7FC;AHo1KT;;Ael3KA;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,yBZoCI;AHi1KR;;Aen3KA;EACI,oCAAA;Afs3KJ;Aer3KI;EACI,+BAAA;Afu3KR;Aer3KI;EACI,+BAAA;Afu3KR;Aer3KI;EACI,oCAAA;EACA,UAAA;Afu3KR;Aet3KQ;EACI,8CAAA;Afw3KZ;Aet3KQ;EACI,+CAAA;Afw3KZ;Aet3KQ;EACI,8CAAA;Afw3KZ;Aet3KQ;EACI,+CAAA;Afw3KZ;Aet3KQ;EACI,gCAAA;Afw3KZ;Aer3KI;EACI,oCAAA;EACA,UAAA;Afu3KR;Aet3KQ;EACI,+CAAA;Afw3KZ;Aet3KQ;EACI,gDAAA;Afw3KZ;Aet3KQ;EACI,+CAAA;Afw3KZ;Aet3KQ;EACI,gDAAA;Afw3KZ;Aet3KQ;EACI,gCAAA;Afw3KZ;Aer3KI;EACI,oCAAA;EACA,UAAA;Afu3KR;Aet3KQ;EACI,gDAAA;Afw3KZ;Aet3KQ;EACI,iDAAA;Afw3KZ;Aet3KQ;EACI,gDAAA;Afw3KZ;Aet3KQ;EACI,iDAAA;Afw3KZ;Aet3KQ;EACI,gCAAA;Afw3KZ;Aer3KI;EACI,oCAAA;EACA,UAAA;Afu3KR;Aet3KQ;EACI,+CAAA;Afw3KZ;Aet3KQ;EACI,gDAAA;Afw3KZ;Aet3KQ;EACI,+CAAA;Afw3KZ;Aet3KQ;EACI,gDAAA;Afw3KZ;Aet3KQ;EACI,gCAAA;Afw3KZ;Aer3KI;EACI,oCAAA;EACA,UAAA;Afu3KR;Aet3KQ;EACI,+CAAA;Afw3KZ;Aet3KQ;EACI,gDAAA;Afw3KZ;Aet3KQ;EACI,+CAAA;Afw3KZ;Aet3KQ;EACI,gDAAA;Afw3KZ;Aet3KQ;EACI,gCAAA;Afw3KZ;Aer3KI;EACI,oCAAA;EACA,UAAA;Afu3KR;Aet3KQ;EACI,8CAAA;Afw3KZ;Aet3KQ;EACI,+CAAA;Afw3KZ;Aet3KQ;EACI,8CAAA;Afw3KZ;Aet3KQ;EACI,+CAAA;Afw3KZ;Aet3KQ;EACI,gCAAA;Afw3KZ;Aer3KI;EACI,iCAAA;EACA,UAAA;Afu3KR;Aet3KQ;EACI,iDAAA;Afw3KZ;Aet3KQ;EACI,kDAAA;Afw3KZ;Aet3KQ;EACI,iDAAA;Afw3KZ;Aet3KQ;EACI,kDAAA;Afw3KZ;Aet3KQ;EACI,8BAAA;Afw3KZ;Aer3KI;EACI,oCAAA;EACA,UAAA;Afu3KR;Aet3KQ;EACI,iDAAA;Afw3KZ;Aet3KQ;EACI,kDAAA;Afw3KZ;Aet3KQ;EACI,iDAAA;Afw3KZ;Aet3KQ;EACI,kDAAA;Afw3KZ;Aet3KQ;EACI,gCAAA;Afw3KZ;Aer3KI;EACI,oCAAA;EACA,UAAA;Afu3KR;Aet3KQ;EACI,8CAAA;Afw3KZ;Aet3KQ;EACI,+CAAA;Afw3KZ;Aet3KQ;EACI,8CAAA;Afw3KZ;Aet3KQ;EACI,+CAAA;Afw3KZ;Aet3KQ;EACI,gCAAA;Afw3KZ;Aer3KI;EACI,oCAAA;EACA,UAAA;Afu3KR;Aet3KQ;EACI,gDAAA;Afw3KZ;Aet3KQ;EACI,iDAAA;Afw3KZ;Aet3KQ;EACI,gDAAA;Afw3KZ;Aet3KQ;EACI,iDAAA;Afw3KZ;Aet3KQ;EACI,gCAAA;Afw3KZ;Aer3KI;EACI,mCAAA;Afu3KR;Aer3KI;EACI,oCAAA;Afu3KR;Aer3KI;EACI,mCAAA;Afu3KR;Aer3KI;EACI,oCAAA;Afu3KR;Aer3KI;EACI,iCAAA;Afu3KR;Aer3KI;EACI,4BAAA;Afu3KR;Aer3KI;EACI,4BAAA;Afu3KR;Aer3KI;EACI,4BAAA;Afu3KR;Aer3KI;EACI,4BAAA;Afu3KR;Aer3KI;EACI,4BAAA;Afu3KR;Aer3KI;EACI,wBAAA;Afu3KR;Aer3KI;EACI,wBAAA;Afu3KR;Aer3KI;EACI,+BAAA;Afu3KR;Aer3KI;EACI,+BAAA;Afu3KR;Aer3KI;EACI,2BAAA;Afu3KR;Aer3KI;EACI,2BAAA;Afu3KR;Aer3KI;EACI,iCAAA;Afu3KR;Aer3KI;EACI,iCAAA;Afu3KR;Aer3KI;EACI,oBAAA;Afu3KR;Aer3KI;EACI,gCAAA;Afu3KR;Aer3KI;EACI,+BAAA;Afu3KR;Aer3KI;EACI,8BAAA;Afu3KR;Aer3KI;EACI,iCAAA;Afu3KR;;Aep3KA;EACI,wCAAA;Afu3KJ;Aet3KI;EACI,mCAAA;Afw3KR;Aet3KI;EACI,mCAAA;Afw3KR;Aet3KI;EACI,gCAAA;Afw3KR;Aet3KI;EACI,gCAAA;Afw3KR;Aet3KI;EACI,gCAAA;Afw3KR;Aet3KI;EACI,gCAAA;Afw3KR;Aet3KI;EACI,gCAAA;Afw3KR;Aet3KI;EACI,gCAAA;Afw3KR;Aet3KI;EACI,gCAAA;Afw3KR;Aet3KI;EACI,gCAAA;Afw3KR;;Aer3KA;EACI,+CAAA;Afw3KJ;Aev3KI;EACI,0CAAA;Afy3KR;Aev3KI;EACI,0CAAA;Afy3KR;Aev3KI;EACI,gCAAA;Afy3KR;Aev3KI;EACI,gCAAA;Afy3KR;Aev3KI;EACI,gCAAA;Afy3KR;Aev3KI;EACI,gCAAA;Afy3KR;Aev3KI;EACI,gCAAA;Afy3KR;Aev3KI;EACI,gCAAA;Afy3KR;Aev3KI;EACI,gCAAA;Afy3KR;Aev3KI;EACI,gCAAA;Afy3KR;;Aet3KA;EACI,2CAAA;Afy3KJ;Aex3KI;EACI,sCAAA;Af03KR;Aex3KI;EACI,sCAAA;Af03KR;Aex3KI;EACI,gCAAA;Af03KR;Aex3KI;EACI,gCAAA;Af03KR;Aex3KI;EACI,gCAAA;Af03KR;Aex3KI;EACI,gCAAA;Af03KR;Aex3KI;EACI,gCAAA;Af03KR;Aex3KI;EACI,gCAAA;Af03KR;Aex3KI;EACI,gCAAA;Af03KR;Aex3KI;EACI,gCAAA;Af03KR;;Aev3KA;EACI,iDAAA;Af03KJ;Aez3KI;EACI,4CAAA;Af23KR;Aez3KI;EACI,4CAAA;Af23KR;Aez3KI;EACI,gCAAA;Af23KR;Aez3KI;EACI,gCAAA;Af23KR;Aez3KI;EACI,gCAAA;Af23KR;Aez3KI;EACI,gCAAA;Af23KR;Aez3KI;EACI,gCAAA;Af23KR;Aez3KI;EACI,gCAAA;Af23KR;Aez3KI;EACI,gCAAA;Af23KR;Aez3KI;EACI,gCAAA;Af23KR;;Aex3KA;EACI,wBAAA;Af23KJ;;Aez3KA;EACI,uBAAA;Af43KJ;;Ae13KA;EACI,wBAAA;Af63KJ;;Ae33KA;EACI,sBAAA;Af83KJ;;Ae53KA;EACI,wBAAA;Af+3KJ;;Ae73KA;EACI,uBAAA;Afg4KJ;;Ae93KA;EACI,wBAAA;Afi4KJ;;Ae/3KA;EACI,qBAAA;Afk4KJ;;Aeh4KA;EACI,wBAAA;Afm4KJ;;Aej4KA;EACI,uBAAA;Afo4KJ;;Ael4KA;EACI,wBAAA;Afq4KJ;;Aen4KA;EACI,sBAAA;Afs4KJ;;Aep4KA;EACI,6BAAA;Afu4KJ;;AgBn0LA;EACI,6BAAA;EACA,YAAA;EZsGD,kBYrG4B;AhBs0L/B;;AgBp0LA;EACC,qBbqKU;EapKP,sBboCI;AHmyLR;;AgBr0LA;EACI,iBAAA;AhBw0LJ;;AgBt0LA;EACC,WAAA;EACA,gBAAA;AhBy0LD;;AgBv0LA;EACI,qBAAA;AhB00LJ;;AgBx0LA;EACC,gBAAA;AhB20LD;;AgBz0LA;EACC,ebiVc;EahVd,gBbbsB;EactB,iCAAA;EACA,iBAAA;EACA,yBAAA;AhB40LD;;AgB10LA;EACC,iCAAA;AhB60LD;;AgB30LA;EACC,gBbUO;AHo0LR;;AgB50LA;;;;;EAKC,UAAA;AhB+0LD;;AgB70LA;EACC,mBbuHW;EatHX,ebyTc;EaxTd,iBAAA;EACA,eAAA;EACA,yBAAA;AhBg1LD;;AgB90LA;;;;;;;EAOC,qBAAA;AhBi1LD;;AgB/0LA;;EAEI,gBAAA;AhBk1LJ;;AgBh1LA;EACC,mBAAA;EACA,YAAA;EACA,cAAA;EACA,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,wBAAA;EACA,4BAAA;EACA,uBAAA;AhBm1LD;;AgBj1LA;EACC,oBAAA;EACA,eb4Rc;AHwjLf;;AgBl1LA;EACC,mBAAA;AhBq1LD;;AgBn1LA;EACC,mBAAA;AhBs1LD;;AgBp1LA;;;EAGC,oCAAA;EACA,sBAAA;EACA,4BAAA;AhBu1LD;;AgBr1LA;EACC,mBAAA;AhBw1LD;;AgBt1LA;EACC,gBbnDO;AH44LR;;AgBv1LA;EACC,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AhB01LD;;AgBx1LA;EACC,kBAAA;EACA,gBbhGkB;EaiGlB,iCAAA;AhB21LD;;AgBz1LA;EACC,kBAAA;EACA,gBbrGkB;EasGlB,iCAAA;AhB41LD;;AgB11LA;EACC,YAAA;AhB61LD;;AgB31LA;EACC,kBAAA;EACA,gBAAA;AhB81LD;;AgB51LA;EACI,mBAAA;EACA,eb2OW;Ea1OX,gBbnHmB;EaoHnB,gBAAA;EACA,kBAAA;AhB+1LJ;;AiB/9LA;EACI,aAAA;AjBk+LJ;;AiBh+LA;EACI,wBAAA;AjBm+LJ;;AiBj+LA;;EAEI,gBAAA;AjBo+LJ;;AiBl+LA;EACI,sBAAA;AjBq+LJ;;AiBn+LA;EACI,aAAA;AjBs+LJ;;AkBn/LI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBfmCA;EelCA,kBAAA;EACA,mBAAA;EACA,aAAA;EdgFN,yBc/E0B;AlBw/L5B;AkBv/LQ;EACI,sBf8BJ;EC+CN,yBc5E8B;AlB2/LhC;AkBz/LQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,gBfiBJ;EehBI,2BAAA;EACA,mBAAA;EACA,kBAAA;AlB2/LZ;AkB1/LY;EACI,WAAA;EACA,cfeT;AH6+LP;AkBx/LY;EACI,efjCC;EekCD,gBf3BO;Ee4BP,WfKR;EeJQ,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AlB0/LhB;AkBx/LY;EACI,efkTD;EejTC,cf0NH;AHgyLb;;AkBn/LQ;EACI,gBAAA;EACA,SAAA;EACA,kBAAA;AlBs/LZ;AkBr/LY;EACI,mBfxCN;AH+hMV;AkBt/LgB;EACI,WfnBZ;AH2gMR;AkBr/LY;EACI,cf9CN;AHqiMV;AkBn/LY;EACI,cfnDN;EeoDM,WAAA;EACA,gBAAA;EACA,ef4RD;AHytLf;;AkB9+LQ;EACI,kBAAA;EACA,mBAAA;AlBi/LZ;AkBh/LY;EACI,mBAAA;AlBk/LhB;AkBh/LY;EACI,Wf7CR;Ee8CQ,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AlBk/LhB;AkBj/LgB;EAGI,aAAA;EACA,kBAAA;EACA,aAAA;AlBm/LpB;AkBh/LY;EACI,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;AlBk/LhB;AkBj/LgB;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EAGA,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,6BAAA;AlBm/LpB;AkBl/LoB;EACI,qBAAA;EACA,kBAAA;EACA,kBAAA;AlBo/LxB;AkBn/LwB;EACI,iBAAA;AlBq/L5B;AkBn/LwB;EACI,Wf/FpB;EegGoB,gBfhGpB;EeiGoB,mBAAA;EACA,WAAA;EACA,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,efiNb;EehNa,mBAAA;AlBq/L5B;AIjmMI;Ec4FoB;IAkBQ,WAAA;IACA,YAAA;ElBu/L9B;AACF;AkBt/L4B;EACI,cf2GnB;AH64Lb;AkBt/L4B;EACI,WfvHxB;EewHwB,mBfrIvB;AH6nMT;AkBv/LgC;EACI,Wf1H5B;AHmnMR;AkB/+LwB;EACI,efwLb;AHyzLf;AkB1+LQ;EACI,kBAAA;EACA,gBAAA;EACA,YAAA;AlB4+LZ;AkB3+LY;EACI,ef8KD;Ee7KC,gBflLO;EemLP,mBAAA;AlB6+LhB;AI9nMI;Ec8IQ;IAKQ,efwKL;EHu0Lb;AACF;AkB7+LY;EACI,mBAAA;AlB++LhB;AkB7+LoB;EACI,WAAA;EACA,YAAA;EACA,sBAAA;AlB++LxB;AkB9+LwB;EACI,kBAAA;AlBg/L5B;AkB9+LwB;EACI,WflKpB;EemKoB,ef3MX;Ee4MW,gBfrML;EesMK,gBAAA;AlBg/L5B;AkB3+LY;EACI,ef6ID;Ee5IC,cfkDH;AH27Lb;AkB1+LgB;EACI,mBfxMV;EeyMU,8BAAA;EACA,WfnLZ;EeoLY,ef3NH;Ee4NG,yBAAA;EACA,gBftNG;EeuNH,gBAAA;EACA,iBAAA;AlB4+LpB;AkB3+LoB;EACI,mBfvMf;EewMe,sBAAA;EACA,cfnNd;AHgsMV;;AkBt+LA;EAGI,aAAA;AlBy+LJ;AkBx+LI;EACI,WAAA;EACA,yBAAA;EACA,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,iCAAA;AlB0+LR;AkBz+LQ;EACI,UAAA;EACA,kBAAA;AlB2+LZ;AIzrMI;Ec4MI;IAIQ,aAAA;IACA,iBAAA;ElB6+Ld;AACF;AkB1+LI;EACI,QAAA;EACA,UAAA;EACA,yBAAA;EACA,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,iCAAA;AlB4+LR;AkB3+LQ;EACI,QAAA;EACA,UAAA;EACA,yBAAA;EACA,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,iCAAA;AlB6+LZ;AkB1+LoB;EACI,gBAAA;AlB4+LxB;AkB3+LwB;EACI,cfnQlB;EeoQkB,WAAA;AlB6+L5B;AkBv+LQ;EACI,QAAA;EACA,UAAA;EACA,yBAAA;EACA,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,iCAAA;AlBy+LZ;AkBx+LY;EACI,UAAA;AlB0+LhB;AkBz+LgB;EACI,aAAA;EACA,gCAAA;EACA,4BAAA;AlB2+LpB;AkBx+LY;EACI,UAAA;EACA,UAAA;AlB0+LhB;AI7uMI;EciQQ;IAIQ,WAAA;ElB4+LlB;AACF;AkBz+LQ;EACI,UAAA;EACA,UAAA;AlB2+LZ;AItvMI;EcyQI;IAIQ,WAAA;ElB6+Ld;AACF;;AkBz+LA;EACI,oCAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AlB4+LJ;AkBx+LgB;EACI,WAAA;EACA,YAAA;EACA,cAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AlB0+LpB;AIjxMI;Ec2RY;IAcQ,WAAA;IACA,YAAA;ElB4+LtB;AACF;AkBv+LI;EACI,mBf1UE;Ee2UF,cAAA;EACA,UAAA;AlBy+LR;AkBt+LgB;EACI,WfzTZ;Ee0TY,WAAA;EACA,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AlBw+LpB;AI1yMI;EcsTY;IAcQ,WAAA;IACA,YAAA;ElB0+LtB;AACF;AkBr+LI;EACI,mBfrWE;EesWF,YAAA;EACA,mBAAA;EACA,YAAA;AlBu+LR;AkBp+LgB;EACI,WfrVZ;EesVY,WAAA;EACA,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AlBs+LpB;AIp0MI;EckVY;IAcQ,WAAA;IACA,YAAA;ElBw+LtB;AACF;AkBv+LoB;EACI,efxCT;AHihMf;;AkBj+LI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AlBo+LR;AIz1MI;Ec4WA;IAWQ,cAAA;ElBs+LV;AACF;AkBr+LQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AlBu+LZ;AkBt+LY;EACI,iBAAA;AlBw+LhB;AkBv+LgB;EACI,eAAA;AlBy+LpB;AkBv+LgB;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WfxZZ;EeyZH,ef7FU;AHskMf;AkBx+LoB;EACI,yBfzaf;Ee0ae,qBf1af;Ee2ae,Wf9ZhB;Ee+ZF,WAAA;EACe,YAAA;EACf,cAAA;EACA,efpGS;AH8kMf;AkBx+LoB;EACI,WfrahB;EesagB,mBfnbf;Eeobe,qBfpbf;AH85MT;AkBz+LwB;EACI,WfzapB;AHo5MR;AkBt+LoB;EACI,mBftcd;Eeucc,qBfvcd;Eewcc,WfjbhB;AHy5MR;AkBv+LwB;EACI,iCAAA;AlBy+L5B;AI15MI;EcyXI;IA8DQ,kBAAA;IACA,uBAAA;ElBu+Ld;AACF;AIh6MI;Ec0bQ;IAEQ,kBAAA;ElBw+LlB;AACF;;AkBn+LA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EAGA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;AlBs+LJ;AIr7MI;EckcJ;IAeQ,cAAA;ElBw+LN;AACF;AI17MI;EcmdA;IAEQ,kBAAA;ElBy+LV;AACF;AkBx+LQ;EACI,ef5JG;Ee6JH,gBf1fO;Ee2fhB,cftVQ;EeuVC,kBAAA;AlB0+LZ;AIr8MI;EcudI;IAMQ,eflKD;EH8oMb;AACF;AkBz+LY;EACI,efzKD;Ee0KC,gBfvgBK;EewgBL,cfvQH;EewQG,kBAAA;AlB2+LhB;AkB1+LgB;EACI,iBAAA;AlB4+LpB;AIn9MI;EcieQ;IASQ,mBAAA;ElB6+LlB;AACF;AkBz+LI;EAGI,aAAA;AlB2+LR;AkB1+LQ;EACI,mBAAA;EACA,kBAAA;EACA,WfxfJ;EeyfI,yBAAA;EACA,kBAAA;EACA,gBf1hBO;Ee2hBP,efniBK;Ee6iBL,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AlBq+LZ;AkBj/LG;EACC,mBfrhBM;EeshBN,yBAAA;AlBm/LJ;AIh/MI;EcmfI;IAaQ,efzMD;EH6rMb;AACF;AkB7+LY;EACI,eAAA;AlB++LhB;AkB3+LY;EACI,WAAA;EACA,YAAA;EACA,mBfvZJ;EewZI,kBAAA;EACA,cfrTH;EesTT,efxNW;Ee2NC,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AlB6+LhB;AkB5+LI;EACC,mBfvjBK;EewjBL,WfjiBG;AH+gNR;;AkBx+LA;EACI,kBAAA;EACA,kBAAA;AlB2+LJ;AkB1+LI;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,yBf5jBC;Ee6jBD,WAAA;EACA,YAAA;EACA,mBAAA;AlB4+LR;AkB1+LI;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,sBfzjBA;Ee0jBA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,wDAAA;EACA,gEAAA;AlB4+LR;;AkBx+LA;EACC,WAAA;AlB2+LD;;AkBz+LA;EACI,WAAA;EACA,cAAA;AlB4+LJ;;AkB1+LA;EACC,kBAAA;EACA,mBAAA;AlB6+LD;AkB5+LI;EACI,mBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AlB8+LR;AkB3+LQ;EACI,aAAA;AlB6+LZ;;AkBz+LA;EACI,WfzlBI;Ee0lBJ,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EAGA,mBAAA;EAGA,uBAAA;AlB4+LJ;AkB3+LI;EACI,gBfzoBW;Ee0oBX,ef3SO;Ee4SP,Wf5mBA;AHylNR;;AkB1+LA;EAGI,aAAA;AlB6+LJ;;AkB3+LA;;EAEI,aAAA;AlB8+LJ;;AkB3+LI;EACI,gBf5pBa;Ee6pBb,efjUO;EekUP,mBAAA;EACA,Wf5nBA;AH0mNR;AkB5+LI;EACI,efnUO;EeoUP,gBAAA;EACA,WfjoBA;EekoBA,gBflqBW;AHgpNnB;;AkB3+LA;EACC,kBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACG,oCAAA;EACA,mBAAA;EACA,iBAAA;AlB8+LJ;AkB7+LI;EACI,gBfhrBa;EeirBb,efrVO;EesVP,cflbK;EembL,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AlB++LR;AIloNI;Ec4oBA;IASQ,ef9VG;EH+0Mb;AACF;AkB/+LI;EACI,gBf3pBA;Ee4pBA,YAAA;EACA,YAAA;AlBi/LR;AkBh/LQ;EACI,cfzhBD;Ee0hBC,efxWG;AH01Mf;;AkB7+LI;EACI,8BAAA;EACA,YAAA;EACA,YAAA;AlBg/LR;AkB/+LQ;EACI,Wf1qBJ;AH2pNR;;AkB7+LA;EACI,kBAAA;EdxpBF,kBAAA;EAcE,QAAA;EACA,SAAA;EAGA,gCAAA;AJ4nNJ;AkBn/LQ;EACI,8BAAA;EACA,iBAAA;EACA,mBAAA;AlBq/LZ;AkBp/LY;EACI,WAAA;EACA,YAAA;EACA,sBAAA;AlBs/LhB;AkBr/LgB;EACI,kBAAA;AlBu/LpB;AkBr/LgB;EACI,iBAAA;AlBu/LpB;AkBr/LgB;EACI,cAAA;EACA,eAAA;EACA,gBfnuBG;EeouBH,mBAAA;AlBu/LpB;;AkBj/LA;EACC,kBAAA;EACA,YAAA;EACA,WAAA;AlBo/LD;AI/rNI;EcwsBJ;IAKQ,WAAA;IACA,WAAA;ElBs/LN;AACF;AkBr/LI;EACI,cfpfK;EeqfL,WAAA;EACA,YAAA;EACA,gBfttBA;EeutBA,mBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AlBu/LR;AkBt/LQ;EACI,YAAA;AlBw/LZ;AkBp/LgB;EACI,cfpvBX;AH0uNT;AkB9+LgB;EACI,oCAAA;AlBg/LpB;AkB/+LoB;EACI,WflvBhB;AHmuNR;;AkBt+LgB;EACI,8BAAA;AlBy+LpB;AkBx+LoB;EACI,WfhwBhB;AH0uNR;;AkBl+LI;EACI,SAAA;EACA,UAAA;AlBq+LR;AkBn+LI;EACI,SAAA;EACA,WAAA;EAGA,aAAA;AlBq+LR;;AkB/9LY;EACI,ef9dD;Ee+dF,gBf3zBQ;AH6xNrB;;AkB19LY;EACI,efxeD;EeyeC,gBfr0BK;AHkyNrB;;AkBx9LA;EACC,cAAA;EACA,kBAAA;AlB29LD;;AkBz9LA;EACC,eAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,SAAA;EACG,6BAAA;EACH,UAAA;AlB49LD;;AkB19LA;;;EAGI,yBAAA;AlB69LJ;;AkB39LA;EACI,mBAAA;EACH,mBAAA;EACG,YAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,QAAA;EACA,oBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACH,UAAA;AlB89LD;;AkB59LA;EAGC,aAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;AlB+9LD;AkB99LI;EACI,qBAAA;AlBg+LR;;AkB79LA;EACC,YAAA;EACG,aAAA;EACA,8BAAA;EACA,kBAAA;EAGA,aAAA;EAGA,mBAAA;EAGA,uBAAA;AlBg+LJ;;AkB79LI;EACI,YAAA;EACA,WAAA;AlBg+LR;;AkB59LI;EACI,WAAA;EACA,YAAA;EACA,8BAAA;EACA,kBAAA;EAGA,aAAA;EAGA,mBAAA;EAGA,uBAAA;AlB+9LR;;AkB39LI;EACI,kBAAA;EACA,WAAA;AlB89LR;;AkB19LI;EACI,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;AlB69LR;AkB59LQ;EACI,aAAA;AlB89LZ;AkB39LI;EACI,kBAAA;AlB69LR;AkB39LI;EACI,WAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EAGA,8BAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;AlB69LR;AIv3NI;Ec64BA;IAeQ,WAAA;ElB+9LV;AACF;AI53NI;Ec64BA;IAkBQ,iBAAA;ElBi+LV;AACF;AIj4NI;Ec64BA;IAqBQ,iBAAA;ElBm+LV;AACF;AkBl+LQ;EACI,iBAAA;AlBo+LZ;AIz4NI;Eco6BI;IAGQ,kBAAA;ElBs+Ld;AACF;AI94NI;Ec64BA;IA8BQ,WAAA;IACA,iBAAA;ElBu+LV;AACF;;AIp5NI;Eck7BA;IAEO,UAAA;ElBq+LT;AACF;AkBp+LQ;EACI,kBAAA;AlBs+LZ;AI75NI;Ecs7BI;IAGQ,iBAAA;ElBw+Ld;AACF;AkBt+LQ;EACI,iBAAA;AlBw+LZ;AIr6NI;Ec+7BY;IACI,iBAAA;ElBy+LlB;AACF;;AkBl+LQ;EACI,YAAA;AlBq+LZ;;AkB/9LQ;EACI,kBAAA;AlBk+LZ;AkBh+LQ;EACI,iBAAA;AlBk+LZ;AIr7NI;Ecq9BI;IAEQ,eAAA;ElBk+Ld;AACF;;AkB99LA;EACC,Wf/9BO;Eeg+BJ,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AlBi+LJ;AkBh+LI;EACI,Wfr+BA;AHu8NR;;AkB/9LA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,efvqBW;EewqBd,gBf7gCkB;EeghCf,aAAA;EAGA,mBAAA;EAGA,uBAAA;AlBk+LJ;;AkBh+LA;EACC,aAAA;AlBm+LD;;AkBj+LA;EACI,oBAAA;AlBo+LJ;;AkBl+LA;EACI,UAAA;AlBq+LJ;AIn+NI;Ec6/BJ;IAGQ,UAAA;ElBu+LN;AACF;AIx+NI;EckgCA;IAEQ,iBAAA;ElBw+LV;AACF;AI7+NI;EcugCA;IAEQ,kBAAA;ElBw+LV;AACF;;AkBp+LA;EACC,eAAA;EACA,uBAAA;AlBu+LD;;AkBr+LA;EACC,kBAAA;EACA,SAAA;EACA,aAAA;EACA,OAAA;EACA,QAAA;AlBw+LD;;AkBt+LA;EACC,sBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AlBy+LD;;AkBr+LQ;EACI,aAAA;AlBw+LZ;AkBv+LY;EACI,cAAA;EACA,oBAAA;AlBy+LhB;;AkBp+LA;EACC,6BAAA;EACA,UAAA;AlBu+LD;;AkBr+LA;EACC;IAAM,cAAA;ElBy+LL;EkBx+LD;IAAI,kBAAA;ElB2+LH;AACF;AkBz+LI;EAGI,aAAA;EAGA,mBAAA;EACA,qBAAA;EACA,iBAAA;AlB2+LR;AItiOI;EcmjCA;IAUQ,cAAA;ElB6+LV;AACF;AkB3+LY;EACI,SAAA;EACA,mBAAA;AlB6+LhB;AkB3+LY;EACI,UAAA;EACA,YAAA;EACA,aAAA;AlB6+LhB;AIpjOI;EcokCQ;IAKQ,WAAA;ElB++LlB;AACF;AkB5+LQ;EACI,UAAA;AlB8+LZ;AI5jOI;Ec6kCI;IAGQ,UAAA;ElBg/Ld;AACF;AIjkOI;Ec6kCI;IAMQ,WAAA;ElBk/Ld;AACF;AkB/+LI;EACI,sBAAA;EACA,aAAA;AlBi/LR;;AkB9+LA;EACC,cAAA;AlBi/LD;;AkB/+LA;EACC,SAAA;AlBk/LD;;AkBh/LA;EACC,WAAA;AlBm/LD;;AkBj/LA;EACC,mBAAA;EACA,WfzmCO;AH6lOR;;AkBj/LI;EACI,aAAA;AlBo/LR;AkBl/LI;EACI,cAAA;EACA,gBAAA;EACA,kBAAA;AlBo/LR;AkBn/LQ;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;AlBq/LZ;AkBp/LY;EACI,aAAA;AlBs/LhB;;AkBj/LA;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;AlBo/LJ;AkBn/LC;EACC,0CAAA;EACA,qBAAA;EACA,oBAAA;EACA,Wf1oCM;Ee2oCN,efj1Ba;Eek1Bb,gBf5qCqB;Ee6qCrB,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AlBq/LF;AkBp/LE;EACC,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,sBfxpCK;EeypCL,WAAA;EACA,YAAA;EACA,mBAAA;AlBs/LH;AkBp/LE;EACC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,yBf/qCM;EegrCN,UAAA;EACA,WAAA;EACA,mBAAA;EACA,wDAAA;EACA,gEAAA;AlBs/LH;;AkBj/LA;EACC;IACC,kBAAA;ElBo/LA;AACF;AkB5+LA;EACC,kBAAA;EACA,UAAA;EACA,YAAA;AlBm/LD;;AkBj/LA;EACC,yBf7jCU;Ee8jCP,oBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;AlBo/LJ;;AkBl/LA;EACC,kBAAA;EACG,SAAA;EACA,SAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,gBf3sCI;Ee4sCJ,mBAAA;EACA,2BAAA;EACA,mCAAA;EACA,+BAAA;AlBq/LJ;;AkBn/LA;EACC,WAAA;EACG,WAAA;EACA,kBAAA;EACA,SAAA;EACA,mBf7uCM;Ee8uCN,YAAA;EACA,mBAAA;EACA,aAAA;AlBs/LJ;;AkBp/LA;EACC,WAAA;EACG,YAAA;EACA,mBAAA;EACA,mBftvCM;EeuvCN,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,2BAAA;EACA,mCAAA;EACA,+BAAA;AlBu/LJ;;AkBr/LA;EACC,WAAA;EACG,aAAA;EACA,kBAAA;EACA,cAAA;EACA,QAAA;AlBw/LJ;;AkBr/LA;EACC,kBAAA;EACA,gBAAA;EACA,WAAA;AlBw/LD;;AkBr/LA;EACC,WfxvCO;EeyvCP,gBAAA;EACA,ef77Bc;Ee87Bd,gBAAA;AlBw/LD;;AkBt/LA;EACI,aAAA;AlBy/LJ;AkBx/LI;EACI,eAAA;EACA,qBAAA;EACA,aAAA;EACA,qBAAA;AlB0/LR;AI3vOI;Ec6vCA;IAMQ,eAAA;ElB4/LV;AACF;AkBx/LoB;EACI,cfnwChB;AH6vOR;AkBr/LQ;EACI,iBAAA;EACA,2BAAA;AlBw/LZ;AkBt/LY;EACI,QAAA;EACA,gBAAA;AlBw/LhB;AkBv/LgB;EACI,yBf7pCR;Ee8pCQ,kBAAA;AlBy/LpB;AkBx/LoB;EACI,2BAAA;EACA,mCAAA;AlB0/LxB;AkBx/LoB;EACI,kBAAA;AlB0/LxB;AkBx/L4B;EACI,iBAAA;AlB0/LhC;AkBz/LgC;EACI,iBAAA;AlB2/LpC;AkBz/LgC;EACI,kBAAA;AlB2/LpC;AkBx/L4C;EAEI,iBAAA;EACA,kBf5yCxC;AHsyOR;AkBv/LwC;EACI,kBAAA;Ed1xC1C,kBAAA;EAcE,QAAA;EACA,SAAA;EAGA,gCAAA;AJuwOJ;AkB7/L4C;EACI,WfpzCxC;AHmzOR;AkB3/LoC;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;AlB6/LxC;AkB5/LwC;EACI,Wf9zCpC;Ee+zCoC,eAAA;AlB8/L5C;AkB3/LoC;EACI,kBAAA;AlB6/LxC;AkBv/LoB;EACI,oCAAA;EACA,8BAAA;EACA,eAAA;EACA,iCAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;AlBy/LxB;AkBr/LY;EACI,uBAAA;AlBu/LhB;AkBr/LY;EACI,QAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;EACA,uBAAA;EACA,uBAAA;EACA,+BAAA;AlBu/LhB;AkBp/LwB;EACI,cf/1CpB;AHq1OR;AkBh/LQ;EACI,uBAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,+BAAA;EACA,cAAA;AlBk/LZ;AkBj/LY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AlBm/LhB;AkBh/LQ;EACI,yBfhwCA;EeiwCA,kBAAA;EACA,kBAAA;EACA,gBf/5CS;Eeg6CT,kBAAA;EACA,kBAAA;AlBk/LZ;AkBj/LY;EACI,efzkCD;Ee0kCC,cf7vCL;Ee8vCK,kBAAA;EACA,gBAAA;EACA,gBfv6CK;AH05OrB;AkBj/LY;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,ef5lCD;Ee6lCC,gBfp7CK;Eeq7CL,cf54CR;Ee64CQ,gBAAA;AlBm/LhB;AkBl/LgB;EACI,WAAA;AlBo/LpB;AkBj/LY;EACI,oCAAA;EACA,+BAAA;EACA,iCAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;AlBm/LhB;AkB/+LY;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,6BAAA;EACA,mBAAA;EACA,cAAA;EACA,gBfp9CK;Eeq9CL,cfrtCH;AHssOb;AkBh/LI;EACC,eAAA;EACA,cAAA;AlBk/LL;AkB7+LI;EACI,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AlB++LR;AkB9+LQ;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,mCAAA;EACA,+BAAA;EACA,yBfj8CJ;Eek8CI,WAAA;EACA,WAAA;AlBg/LZ;AkB9+LQ;EACI,yBft8CJ;Eeu8CI,cfv8CJ;Eew8CI,efvpCG;EewpCH,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBfp/CW;Eeq/CX,kBAAA;AlBg/LZ;;AkBz+LY;EACI,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,gBAAA;EACA,oBAAA;AlB4+LhB;AkB3+LgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AlB6+LpB;AkB1+LoB;EACI,WAAA;EACA,cfx+ChB;AHo9OR;AkBx+LY;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,gCAAA;EACA,oBAAA;AlB0+LhB;AkBv+LwB;EACI,cf3/CpB;Ee4/CoB,WAAA;EACA,YAAA;EACA,sBAAA;EACA,UAAA;EACA,mBAAA;AlBy+L5B;AkBx+L4B;EACI,mBfjiDtB;EekiDsB,qBfliDtB;AH4gPV;AkBz+LgC;EACI,Wf7gD5B;AHw/OR;AkBx+L4B;EACI,WAAA;AlB0+LhC;AkBj+LQ;EACI,YAAA;AlBm+LZ;AkBl+LY;EACI,aAAA;EACA,gBAAA;EACA,yBf7zCN;Ee8zCM,4BAAA;AlBo+LhB;AkBn+LgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AlBq+LpB;AkBp+LoB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,yBfnkDd;EeokDc,mBAAA;EACA,ef5vCT;Ee6vCS,WfvjDhB;EewjDgB,iBAAA;AlBs+LxB;AkBl+LY;EACI,aAAA;AlBo+LhB;AkBn+LgB;EACI,sBAAA;EACA,aAAA;EACA,qBAAA;EAEA,sBAAA;EACA,eAAA;EACA,gBAAA;AlBq+LpB;AkBp+LoB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;AlBs+LxB;AkBr+LwB;EACI,yBAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;AlBu+L5B;AkBr+LwB;EACI,oBAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AlBu+L5B;AkBt+L4B;EACI,MAAA;EACA,eAAA;AlBw+LhC;AkBt+L4B;EACI,kBAAA;AlBw+LhC;AkBr+LwB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,YAAA;AlBu+L5B;AkBt+L4B;EACI,aAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AlBw+LhC;AkBv+LgC;EACI,efn0CrB;Eeo0CqB,gBfjqDf;EekqDe,kBAAA;EACA,cfl6CvB;Eem6CuB,mBAAA;EACA,gBAAA;EACA,uBAAA;AlBy+LpC;AkBv+LgC;EACI,ef/0CrB;Eeg1CqB,cfrpD3B;EewpD2B,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AlBy+LpC;AkBx+LoC;EACI,WAAA;EACA,YAAA;AlB0+LxC;AkBp+LoC;EACI,cfrqD/B;AH2oPT;AkBj+LgC;EACI,efx2CrB;Eey2CqB,cfzhDzB;Ee0hDyB,gBfjsDf;AHoqPrB;AkBj+LgC;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,+BAAA;EACA,cAAA;EACA,eAAA;EACA,yBfpsD1B;EeqsD0B,Wf9qD5B;Ee+qD4B,kBAAA;EACA,iBAAA;EACA,eAAA;AlBm+LpC;AkBh+L4B;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AlBk+LhC;AkBh+LoC;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cfnkD7B;EeokD6B,mBAAA;AlBk+LxC;AkBj+LwC;EACI,cftkDjC;AHyiPX;AkBx9LI;EACI,sCAAA;AlB09LR;AkBz9LQ;EACI,sCAAA;AlB29LZ;AkBx9LI;EACI,gBf9tDA;Ee+tDN,8DAAA;EACA,yBAAA;EACM,mBAAA;EACA,aAAA;AlB09LR;AkBz9LQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;EACT,yBf5gDO;AHu+OV;AkBz9LgB;EACI,efp7CL;Eeq7CK,gBflxDG;EemxDH,cf7mDT;Ee8mDS,gBAAA;AlB29LpB;AkBv9LgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;AlBy9LpB;AkBx9LoB;EACI,mBf9xDd;AHwvPV;AkBz9LwB;EACI,WfzwDpB;AHouPR;AkBx9LoB;EACI,WAAA;EACA,cf3xDf;AHqvPT;AkBr9LE;EACC,gBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,gBfzxDK;AHgvPR;AkBt9LG;EAGa,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACZ,kBAAA;AlBw9LJ;AkBv9LI;EACC,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,mCAAA;EACA,+BAAA;AlBy9LL;AkBx9LK;EACC,cf1kDO;AHoiPb;AkBv9LI;EACC,cAAA;EACA,UAAA;AlBy9LL;AkBv9LI;EACC,cAAA;EACA,UAAA;AlBy9LL;AkBv9LI;EACC,WAAA;EACA,aAAA;AlBy9LL;AkBx9LK;EAGC,aAAA;EAGA,mBAAA;EACA,eflgDS;AH49Of;AkBv9LI;EACC,UAAA;AlBy9LL;AkBx9LK;EAGmB,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EAClB,WAAA;EACA,YAAA;EACA,mBft2DI;Eeu2DJ,mBAAA;AlB09LN;AkBz9LM;EACC,mBAAA;AlB29LP;AkB19LO;EACC,Wfp1DA;AHgzPR;AkBz9LM;EACC,WAAA;EACA,Wfz1DC;AHozPR;AkBv9LI;EACC,mBAAA;EACA,iBAAA;EACA,gBfh2DG;Eei2DH,0CAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AlBy9LL;AkBx9LK;EACC,ef74DW;Ee84DX,yBAAA;AlB09LN;;AkBl9LI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,WAAA;AlBq9LR;AkBn9LI;EACI,QAAA;EAGA,6BAAA;AlBq9LR;AIl1PI;Ecy3DA;IAMQ,WAAA;IAGA,aAAA;IACA,8BAAA;IACA,sCAAA;IACA,4BAAA;ElBu9LV;AACF;AkBt9LQ;EACI,yBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AlBw9LZ;AkBv9LY;EACI,yBf56DN;AHq4PV;AkBx9LgB;EACI,Wfv5DZ;AHi3PR;AkBv9LY;EACI,cf5rDH;AHqpPb;;AkBp9LA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,YAAA;AlBu9LJ;AkBt9LI;EAGI,aAAA;EAGA,mBAAA;EACA,6BAAA;EACA,qCAAA;EACA,2BAAA;EACA,WAAA;AlBw9LR;AkBv9LQ;EACI,kBAAA;AlBy9LZ;AkBt9LoB;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AlBw9LxB;AIx5PI;Ecw7DgB;IAUQ,YAAA;IACA,aAAA;IACA,WAAA;IACA,UAAA;ElB09L1B;AACF;AIh6PI;Ecw7DgB;IAgBQ,YAAA;IACA,aAAA;IACA,UAAA;IACA,SAAA;ElB49L1B;AACF;AkBx9LY;EACI,YAAA;EACA,aAAA;EACA,SAAA;EACA,kBAAA;AlB09LhB;AI96PI;Ecg9DQ;IAMQ,YAAA;IACA,aAAA;ElB49LlB;AACF;AIp7PI;Ecg9DQ;IAUQ,WAAA;IACA,YAAA;ElB89LlB;AACF;AkB79LgB;EACI,WAAA;EACA,kBAAA;AlB+9LpB;AkB39LgB;EACI,ef5qDL;Ee6qDK,Wfv+DZ;Eew+DY,gBf1gEC;Ee2gED,0BAAA;EACA,kBAAA;EACA,gBAAA;AlB69LpB;AIt8PI;Ecm+DY;IAQQ,gBAAA;ElB+9LtB;AACF;AkB59LY;EACI,kBAAA;EACA,YAAA;EACA,cAAA;EACA,SAAA;EAGA,gCAAA;EACA,UAAA;AlB89LhB;AIr9PI;Ec++DQ;IAUQ,WAAA;ElBg+LlB;AACF;AkB/9LgB;EACI,yBfrhEV;EeshEU,Wf//DZ;AHg+PR;;AkB39LA;EACI,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBf34DO;Ee44DP,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;AlB89LJ;AkB59LQ;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,mBAAA;EACA,gBfxhEJ;EeyhEI,yBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AlB89LZ;;AkB19LA;EACI,WAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBf3iEI;Ee4iEJ,kBAAA;EACA,yBAAA;AlB69LJ;;AkB39LA;EAEI,gBAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,kBAAA;EACA,eAAA;AlB89LJ;;AkB59LA;EACI,WAAA;EACA,YAAA;EACA,8BAAA;EACA,kBAAA;EACA,eAAA;AlB+9LJ;;AkB59LA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AlB+9LJ;AItiQI;EcwkEA;IAEQ,eAAA;IACD,sBAAA;ElBg+LT;AACF;AkB/9LQ;EACI,mBAAA;AlBi+LZ;AkBh+LY;EACI,eAAA;AlBk+LhB;AkB99LI;EACI,kBAAA;EACA,cAAA;AlBg+LR;AkB/9LQ;EACI,eAAA;AlBi+LZ;AkB/9LQ;EACI,eAAA;AlBi+LZ;AI5jQI;Ec0lEI;IAGQ,aAAA;ElBm+Ld;AACF;AkBj+LQ;EACI,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,yBAAA;EACA,gBf9mEJ;Ee+mEI,kBAAA;EACA,YAAA;AlBm+LZ;AkBl+LY;EACI,cf5+DL;AHg9PX;AkBl+LY;EACI,mBAAA;AlBo+LhB;AkBl+LY;EACI,kBAAA;AlBo+LhB;AkBl+LY;EACI,yBfr/DL;Ees/DK,Wf5nER;Ee6nEQ,aAAA;EACA,gBf7pEG;Ee8pEH,eftqEC;AH0oQjB;AkBn+LgB;EACI,yBfxpEV;AH6nQV;AkBn+LgB;EACI,WAAA;EACA,iBAAA;EACA,WftoEZ;AH2mQR;AIzmQI;EcwnEQ;IAeQ,YAAA;IACA,efjrEH;EHupQf;AACF;AkBp+LY;EACI,cf1oET;AHgnQP;AkBn+LQ;EACI,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,yBAAA;EACA,gBf7pEJ;Ee8pEI,kBAAA;EACA,iBAAA;AlBq+LZ;AkBp+LY;EACI,kBAAA;AlBs+LhB;;AmBjrQI;EACF,qCAAA;AnBorQF;AmBjrQQ;EACI,chBoQC;AH+6Pb;AmB/qQI;EAGI,aAAA;EAGA,mBAAA;AnBirQR;AmB/qQI;EACI,iBAAA;AnBirQR;AmB/qQI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AnBirQR;AmB/qQI;EACI,cAAA;AnBirQR;AmB/qQI;EACI,kBAAA;AnBirQR;AmB/qQI;EACI,UAAA;EACA,yBAAA;EACA,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,iCAAA;AnBirQR;AmB9qQI;EACI,kBAAA;EACA,QAAA;EACA,aAAA;EACA,UAAA;EACA,yBAAA;EACA,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,iCAAA;EAGA,6BAAA;AnBgrQR;AmB9qQI;EACI,kBAAA;EACA,YAAA;AnBgrQR;AmB9qQI;EACI,kBAAA;EACA,YAAA;AnBgrQR;AmB9qQI;EACI,aAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,iCAAA;AnBgrQR;AmB9qQI;EAGI,aAAA;EAGA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AnBgrQR;AmB9qQI;EACI,UAAA;EACN,aAAA;EACA,mBAAA;AnBgrQF;AmB9qQI;EACI,mBAAA;AnBgrQR;AmB9qQI;EACI,ehBiQO;EgBhQP,cAAA;AnBgrQR;AmB7qQI;EACI,kBAAA;EACA,qBAAA;EACA,qBAAA;AnB+qQR;AmB7qQI;EACI,aAAA;AnB+qQR;AmB7qQI;EACI,iBAAA;AnB+qQR;AmB7qQI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AnB+qQR;AmB5qQE;EACC,sBAAA;AnB8qQH;AmB5qQE;EACC,iBAAA;AnB8qQH;AIrwQI;EesFF;IAGE,cAAA;EnBgrQF;AACF;AmB9qQE;EACC,aAAA;EACA,gCAAA;EACA,gBAAA;AnBgrQH;AmB7qQG;EACC,ehBwNW;EgBvNX,chBgCO;EgB/BP,gBhBtIe;AHqzQnB;AmB5qQE;EACC,sCAAA;AnB8qQH;AmB5qQE;EACC,ehB4MY;EgB3MZ,eAAA;EACA,iBAAA;EACA,gBhBlJkB;EgBmJlB,cAAA;AnB8qQH;AmB5qQE;EACC,ehBuMY;EgBtMZ,cAAA;AnB8qQH;AmB3qQE;EACC,YAAA;EACA,ehBkMY;EgBjMZ,cAAA;AnB6qQH;AmB1qQE;EACC,gBAAA;EACA,cAAA;AnB4qQH;AmBzqQE;;;EAGC,yBAAA;AnB2qQH;AmBzqQE;EACC,gBhB1IK;EgB2IL,yBAAA;EACA,sBAAA;EACA,8CAAA;EACA,kBAAA;EACA,gBAAA;AnB2qQH;AmBxqQE;EACC,SAAA;EACA,kBAAA;EAGA,aAAA;EAGA,mBAAA;AnB0qQH;AmBxqQE;EACC,ehB+JY;EgB9JZ,cAAA;AnB0qQH;AmBxqQE;;;EAGC,yBAAA;AnB0qQH;AmBxqQE;EACC,kBAAA;EAGA,aAAA;EAGA,mBAAA;AnB0qQH;AmBxqQE;EAGC,aAAA;EAGA,mBAAA;AnB0qQH;AmB5pQA;EACC;IAEC,kBAAA;EnBwqQA;EmBtqQD;IAEC,2BAAA;EnBwqQA;AACF;AmBtqQA;EACC,SAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;EACA,gBhBnNO;AH23QR;AmBvqQC;EACC,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,sCAAA;EACA,kBAAA;EACA,mBAAA;EACM,gEAAA;EACA,8BAAA;EACA,sDAAA;EACN,kBAAA;AnByqQF;AmBxqQE;EACC,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;AnB0qQH;AmBzqQG;EACC,kBAAA;AnB2qQJ;AmBzqQG;EACC,ehBmFW;EgBlFX,gBhBzQmB;EgB0QnB,kBAAA;EACA,cAAA;EACA,chBtGO;AHixQX;AmBvqQG;EACC,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;AnByqQJ;AmBvqQK;EACC,ehBkES;EgBjET,chBnHK;EgBoHL,eAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,+BAAA;AnByqQN;AmBxqQM;EACC,ehBwDQ;AHknQf;AmBvqQO;EACC,yBhB5IG;EgB6IH,qBhB7IG;AHszQX;AmBjqQC;EACC,SAAA;EACA,aAAA;EACA,oBAAA;AnBmqQF;AmBlqQE;EACC,gBAAA;AnBoqQH;AmBlqQE;EACC,aAAA;EACA,qBAAA;EACA,sBAAA;EAEA,uBAAA;EACA,+BAAA;AnBoqQH;AmBnqQG;EACC,cAAA;EACA,qBAAA;EACA,aAAA;EACA,qBAAA;AnBqqQJ;AmBpqQI;EACC,gBAAA;AnBsqQL;AmBpqQI;EACC,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;AnBsqQL;AmBrqQK;EACC,kBAAA;AnBuqQN;AmBrqQK;EACC,ehBQS;EgBPT,gBAAA;AnBuqQN;AmBrqQK;EACC,WhBvTE;EgBwTF,eAAA;EACA,eAAA;EACA,gBhB5Ve;AHmgRrB;AmBtqQM;EACC,+BAAA;AnBwqQP;AmBvqQO;EACC,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;AnByqQR;AmBpqQI;EACC,iCAAA;EACe,uCAAA;EACf,kBAAA;EACA,chBpMM;EgBqMN,ehBjBU;EgBkBV,gBhB9WgB;EgB+WhB,uDAAA;AnBsqQL;AmBrqQK;EACC,chBxUC;AH++QP;AmBnqQK;EACC,chB9MK;EgB+ML,kBAAA;EACA,cAAA;AnBqqQN;AmBnqQK;EACC,mBAAA;AnBqqQN;AmBjqQK;EACC,aAAA;AnBmqQN;AmB9pQM;EACC,kBAAA;EACA,WhBrWC;EgBsWD,eAAA;EACA,gBhBxYc;EgByYd,kBAAA;EACA,QAAA;EACA,SAAA;EAGA,gCAAA;AnBgqQP;AmB1pQI;EACC,gBAAA;EACA,chB/OM;EgBgPN,gBhBtZkB;EgBuZlB,ehB5DU;AHwtQf;AmB3pQK;EACC,eAAA;EACA,chBxPK;EgByPL,gBhB7Ze;EgB8Zf,kBAAA;AnB6pQN;AmBzpQG;EACC,iBAAA;AnB2pQJ;AmB1pQI;EACC,yBAAA;AnB4pQL;AmB1pQI;EACC,iCAAA;EACe,oCAAA;EACf,chBlQM;EgBmQN,aAAA;AnB4pQL;AmB3pQK;EACC,2BAAA;EACA,mCAAA;AnB6pQN;AmB5pQM;EACC,chB5QI;AH06QX;AmB7pQO;EACC,chBzYD;AHwiRP;AmB1pQI;EACC,QAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;EACA,uBAAA;EACA,uBAAA;EACA,+BAAA;AnB4pQL;AmB3pQK;EACC,WAAA;EACA,kBAAA;AnB6pQN;AmB3pQK;EACC,aAAA;EACA,qBAAA;EACA,qBAAA;EACA,6BAAA;EACA,oBAAA;EACA,chBrSK;AHk8QX;AmB1pQI;EACC,QAAA;EACA,gBAAA;AnB4pQL;AmB1pQI;EACC,uBAAA;AnB4pQL;AmBzpQG;EACC,kBAAA;AnB2pQJ;AmB1pQI;EACC,gBAAA;EACA,UAAA;EACA,iBAAA;EACA,aAAA;EACA,qBAAA;AnB4pQL;AmB3pQK;EACC,gBAAA;AnB6pQN;AmB1pQI;EACC,kBAAA;AnB4pQL;AmB1pQM;EACC,6BAAA;EACA,WAAA;EACA,kBAAA;AnB4pQP;AmBtpQM;EAEC,iBAAA;AnBwpQP;AmBppQI;EACC,kBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;AnBspQL;AmBrpQK;EACC,WhBvdE;EgBwdF,eAAA;AnBupQN;AmBrpQK;EACC,gBAAA;AnBupQN;AmBppQM;EACC,WAAA;AnBspQP;AmBjpQG;EAqBC,kBAAA;EACA,mBhB/XQ;EgBgYR,mBAAA;EACA,aAAA;EACA,kBAAA;AnB+nQJ;AmBvpQI;EACC,kBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;AnBypQL;AmBxpQK;EACC,WhB5eE;EgB6eF,eAAA;EACA,chBzWK;AHmgRX;AmBxpQK;EACC,gBAAA;AnB0pQN;AmBvpQM;EACC,WAAA;AnBypQP;AmBhpQI;EACC,WAAA;EACA,YAAA;EACA,sBhBjgBG;EgBkgBH,kBAAA;AnBkpQL;AmBjpQK;EACC,chBlYK;EgBmYL,ehBrMS;AHw1Qf;AmB/oQK;EACC,chBpYK;EgBqYL,qBAAA;EACA,WAAA;EACA,ehBlNS;EgBmNT,gBhB/iBe;AHgsRrB;AmB/oQK;EACC,chB/YK;EgBgZL,qBAAA;EACA,WAAA;AnBipQN;AmB/oQK;EAGC,aAAA;EAGA,mBAAA;EACA,UAAA;EACA,gBAAA;AnBipQN;AmBhpQM;EACC,gBAAA;EACA,chB1ZI;EgB2ZJ,ehBvOQ;EgBwOR,kBAAA;AnBkpQP;AmBjpQO;EACC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,QAAA;AnBmpQR;AmBhpQQ;EACC,aAAA;AnBkpQT;AmB/oQO;EACC,chBzkBE;AH0tRV;AmB9oQM;EACC,kBAAA;AnBgpQP;AmBzoQC;EACC,yBAAA;UAAA,iBAAA;AnB2oQF;AmBzoQC;EACC,kBAAA;AnB2oQF;AmB1oQE;EACC,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;AnB4oQH;AIrtRI;EegkBF;IAWE,oBAAA;EnB8oQF;AACF;AmB5oQI;EACC,gBAAA;EACA,chBjdM;EgBkdN,ehBrRU;EgBsRV,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AnB8oQL;AmB7oQK;EACC,eAAA;AnB+oQN;AmB5oQI;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACe,mBhB3nBV;EgB4nBL,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;AnB8oQL;AmB7oQK;EACC,sBhB3mBE;EgB4mBF,qBhBveK;AHsnRX;AmB9oQM;EACC,chBzeI;AHynRX;AmB7oQK;EACC,gBAAA;AnB+oQN;AmB1oQI;EACC,chBnfM;EgBofN,eAAA;AnB4oQL;AmBzoQG;EAKC,cAAA;EACA,UAAA;AnBuoQJ;AmB5oQI;EACC,chBzfM;EgB0fN,ehBjUU;AH+8Qf;AmBzoQG;EAMC,cAAA;EACA,UAAA;AnBsoQJ;AmB5oQI;EACC,chBjgBM;EgBkgBN,ehBzUU;EgB0UV,ehBzUU;AHu9Qf;AmBzoQG;EACC,kBAAA;AnB2oQJ;AmB1oQI;EACC,WAAA;EACA,YAAA;EACA,gBhBlpBG;EgBmpBH,mBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AnB4oQL;AmB3oQK;EACC,yBhBhiBK;EgBiiBL,qBhBjiBK;AH8qRX;AmB3oQK;EACC,chB5hBK;EgB6hBL,ehBtWS;AHm/Qf;AmBxoQI;EACC,chBniBM;EgBoiBN,UAAA;AnB0oQL;AmBxoQI;EACC,chBviBM;EgBwiBN,UAAA;AnB0oQL;AmBxoQI;EACC,chB3iBM;EgB4iBN,UAAA;AnB0oQL;AmBxoQI;EACC,chB/iBM;EgBgjBN,UAAA;AnB0oQL;AmBjoQE;EACC,gBAAA;AnBmoQH;AmB/nQA;EACC,chB/jBU;EgBgkBV,ehB5Yc;AH6gRf;AmB/nQA;EACC,aAAA;EACA,eAAA;AnBioQD;AmB/nQA;EACC,gBAAA;AnBioQD;AmB7nQE;EACC,mBhBzuBO;EgB0uBP,WAAA;EACA,YAAA;EACA,mBAAA;EACA,chBhlBQ;EgBilBR,UAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,sBAAA;AnB+nQH;AmB9nQG;EACC,mBAAA;EACA,WhBpuBI;AHo2RR;AmB5nQC;EACC,gCAAA;EACA,gBAAA;EACA,oBAAA;AnB8nQF;AmB1nQC;EACC,chB1mBS;EgB2mBT,ehBvba;EgBwbb,gBhBpxBmB;EgBqxBnB,mBAAA;EACA,cAAA;AnB4nQF;AmBznQA;EACC,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,ehBncc;EgBocd,WhB9vBO;EgB+vBP,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,+BAAA;AnB2nQD;AmBxnQC;EACC,WhB3wBM;EgB4wBN,yBhBrvBY;EgBsvBZ,qBhBrvBY;AH+2Rd;AmBvnQA;EACC,eAAA;AnBynQD;AmBvnQA;EACC,yBhBppBU;EgBqpBV,qBhBppBU;EgBqpBV,6BAAA;EACA,2BAAA;AnBynQD;AmBvnQA;EACC,yBhB1pBU;EgB2pBV,qBhB1pBU;EgB2pBV,6BAAA;EACA,2BAAA;AnBynQD;AmBvnQA;EACC,ehBnec;AH4lRf;AmBvnQA;EACC,gBAAA;AnBynQD;AmBvnQA;EACC,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;EACA,UAAA;EACA,kBAAA;AnBynQD;AmBxnQC;EACC,yBAAA;EACA,WAAA;EACA,gBAAA;EACA,8BAAA;EACA,yBAAA;EACA,eAAA;EACA,sBhBtzBM;EgBuzBN,chBjrBS;EgBkrBT,ehB7fa;EgB8fb,gBhB11BmB;AHo9RrB;AmBznQE;EACC,qBhB5rBQ;AHuzRX;AmBznQE;EACC,qBhB/rBQ;AH0zRX;AmBznQE;EACC,qBhBlsBQ;AH6zRX;AmBvnQA;EACC,UAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;EACA,UAAA;AnBynQD;AmBvnQA;EACC,UAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,mCAAA;EACA,+BAAA;AnBynQD;AmBxnQC;EACC,ehB/hBa;EgBgiBb,chBttBS;AHg1RX;AmBvnQA;EACC,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;EACA,UAAA;EACA,kBAAA;AnBynQD;AmBxnQC;EACC,yBAAA;EACA,WAAA;EACA,gBAAA;EACA,8BAAA;EACA,yBAAA;EACA,eAAA;EACA,sBhBh3BM;EgBi3BN,chB3uBS;EgB4uBT,ehBvjBa;EgBwjBb,gBhBp5BmB;AH8gSrB;AmBznQE;EACC,qBhBtvBQ;AHi3RX;AmBznQE;EACC,qBhBzvBQ;AHo3RX;AmBznQE;EACC,qBhB5vBQ;AHu3RX;AmBvnQA;EACC,UAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;EACA,UAAA;AnBynQD;AmBvnQA;EACC,kBAAA;AnBynQD;AmBvnQA;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,chBzwBU;EgB0wBV,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,+BAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,eAAA;AnBynQD;AmBvnQA;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,chBzxBU;EgB0xBV,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,+BAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,eAAA;AnBynQD;AmBvnQA;EACC,sBAAA;AnBynQD;AmBvnQA;EACC,YAAA;EACA,WAAA;AnBynQD;AmBvnQA;EACC,yBAAA;EACA,chBjzBU;EgBkzBV,kBAAA;EACA,eAAA;EACA,gBhBx9BoB;EgBy9BpB,gBAAA;EACA,oBAAA;AnBynQD;AmBvnQA;EACC,yBAAA;EACA,chB3zBU;EgB4zBV,kBAAA;EACA,cAAA;EACA,gBhBj+BoB;EgBk+BpB,gBAAA;EACA,mBAAA;AnBynQD;AmBvnQA;EACC,gBAAA;AnBynQD;AmBtnQC;EACC,mBAAA;AnBwnQF;AmBrnQA;EACC,uBAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,+BAAA;EACA,cAAA;AnBunQD;AmBrnQA;EAGC,aAAA;EAGA,mBAAA;EACA,kBAAA;AnBunQD;AmBrnQE;EAGC,aAAA;AnBunQH;AmBlnQC;EACC,kBAAA;AnBonQF;AmBjnQA;EACC,aAAA;AnBmnQD;AmBlnQC;EACC,UAAA;EACA,mBAAA;AnBonQF;AmBlnQC;EACC,UAAA;AnBonQF;AmBjnQA;EACC,mBAAA;AnBmnQD;AmBlnQC;EACC,mBAAA;AnBonQF;AmBjnQA;EACC,2BAAA;AnBonQD;AmBjnQA;EAGC,aAAA;EAGA,mBAAA;AnBmnQD;AmBlnQC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;AnBonQF;AmBnnQE;EACC,WAAA;AnBqnQH;AmBlnQC;EACC,chBv4BS;EgBw4BT,ehBntBa;EgBotBb,gBhBhjCmB;EgBijCnB,gBAAA;AnBonQF;AmBlnQG;EACC,chBn2BU;AHu9Rd;AmB9mQC;EAGC,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,UAAA;EACA,gBAAA;AnBgnQF;AmB9mQG;EACC,WAAA;EACA,YAAA;EACA,mBhBhkCM;EgBikCN,mBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AnBgnQJ;AmB5mQC;EACC,gBAAA;EACA,chBn7BS;EgBo7BT,ehBhwBa;EgBiwBb,gBhB7lCmB;EgB8lCnB,gBAAA;AnB8mQF;AmB5mQC;EACC,kBAAA;AnB8mQF;AmB1mQC;EACC,kBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;AnB4mQF;AmB3mQE;EACC,WhBzkCK;EgB0kCL,eAAA;AnB6mQH;AmB3mQE;EACC,gBAAA;AnB6mQH;AmB1mQG;EACC,WAAA;AnB4mQJ;AmBxmQC;EACC,WAAA;EACA,cAAA;EACA,WAAA;AnB0mQF;AmBxmQC;EACC,gBAAA;EACA,UAAA;EACA,SAAA;AnB0mQF;AmBzmQE;EACC,WAAA;EACA,UAAA;EACA,YAAA;AnB2mQH;AmB1mQG;EACC,kBAAA;AnB4mQJ;AmB1mQK;EACC,WAAA;AnB4mQN;AmBvmQE;EACC,WAAA;AnBymQH;AmBnmQE;EACC,SAAA;EACA,YAAA;AnBqmQH;AmBpmQG;EACC,mBAAA;EACA,iBAAA;AnBsmQJ;AmBhmQG;EACC,chB5/BO;EgB6/BP,ehBl0BW;EgBm0BX,mBAAA;EACA,iBAAA;EACA,gBhBlqCmB;AHowSvB;AmBhmQG;EACC,YAAA;EACA,UAAA;AnBkmQJ;AmBjmQI;EACC,qBhBpgCM;EgBqgCN,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,wBAAA;EACA,gCAAA;AnBmmQL;AmB/lQE;EACC,yBhBnhCQ;AHonSX;AmB/lQE;EACC,sBAAA;EACA,gBAAA;AnBimQH;AmB3lQI;EACC,qBhBhiCM;EgBiiCN,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,qBhBpiCM;EgBqiCN,mBAAA;EACA,yBAAA;EACA,YAAA;AnB6lQL;AmBtlQG;EACC,QAAA;AnBwlQJ;AmBnlQE;EACC,gBAAA;AnBqlQH;AmBjlQA;EACC,mBAAA;EACA,kBAAA;AnBmlQD;AmBhlQC;EACC,kBAAA;EACA,chB9jCS;EgB+jCT,ehB34Ba;AH69Rf;AmB9kQC;EACC,UAAA;EACA,gBAAA;EAGA,aAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;AnBglQF;AmB/kQE;EACC,gBAAA;AnBilQH;AmBhlQG;EACC,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,chB5lCO;EgB6lCP,gBhBrwCiB;EgBswCjB,ehB16BW;AH4/Rf;AmBjlQI;EACC,gBAAA;AnBmlQL;AmB/kQE;EACC,iBAAA;AnBilQH;AmB9kQG;EACC,mBAAA;AnBglQJ;AmB5kQG;EACC,mBAAA;AnB8kQJ;AmBzkQA;EACC,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AnB2kQD;AmB1kQC;EACC,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,mCAAA;EACA,+BAAA;EACA,yBhB3oCU;EgB4oCV,WAAA;EACA,WAAA;AnB4kQF;AmBzkQA;EACC,oBAAA;EACG,mBhBlpCQ;EgBmpCX,chBxoCU;EgByoCV,ehBr9Bc;EgBs9Bd,iBAAA;EACA,qBAAA;EACA,gBhBpzCoB;EgBqzCpB,kBAAA;EACA,yBAAA;AnB2kQD;AmBzkQA;EACC,iBAAA;AnB2kQD;AmB1kQC;EACC,iBAAA;AnB4kQF;AmBzkQA;EACC,eAAA;AnB2kQD;AmB1kQC;EACC,mBAAA;AnB4kQF;AmB1kQC;EACC,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,gCAAA;AnB4kQF;AmB3kQE;EAGC,aAAA;EAGA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;AnB6kQH;AmB5kQG;EACC,gBAAA;AnB8kQJ;AmB5kQG;EACC,cAAA;EACA,kBAAA;AnB8kQJ;AmBxkQC;EACC,kBAAA;EACA,chBzrCS;EgB0rCT,ehBrgCa;EgBsgCb,gBhBl2CmB;AH46SrB;AmBxkQC;EACC,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,chBrsCS;EgBssCT,ehBlhCa;AH4lSf;AmBvkQA;EACC,aAAA;EACA,cAAA;AnBykQD;AmBxkQC;EACC,UAAA;AnB0kQF;AmBzkQE;EACC,gBAAA;EACA,mBAAA;AnB2kQH;AmB1kQG;EACC,kBAAA;AnB4kQJ;AmB1kQG;EAGC,aAAA;EAGA,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;AnB4kQJ;AmBzkQM;EACC,chBluCI;AH6ySX;AmBnkQA;EAGC,aAAA;EAGA,mBAAA;AnBqkQD;AmBpkQC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AnBskQF;AmBrkQE;EACC,ehB1kCY;AHipSf;AmBpkQC;EACC,ehB/kCa;EgBglCb,gBhB56CmB;EgB66CnB,chB7qCW;EgB8qCX,gBAAA;AnBskQF;AmBnkQA;EACC,mBAAA;AnBqkQD;AmBpkQC;EACC,chBnuCY;AHyySd;AmBnkQA;EACC,6CAAA;AnBqkQD;AmBpkQC;EACC,chBl5CK;AHw9SP;AmBnkQA;EACC,mBAAA;AnBqkQD;AmBpkQC;EACC,chB75CO;AHm+ST;AmBnkQA;EACC,mBAAA;AnBqkQD;AmBpkQC;EACC,chB/xCS;AHq2SX;AmBnkQA;EACC,mBAAA;AnBqkQD;AmBpkQC;EACC,chBrwCW;AH20Sb;AmBnkQA;EAGC,aAAA;EAGA,mBAAA;AnBqkQD;AmBpkQC;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,WhBz7CM;EgB07CN,eAAA;EACA,mBhBl9CQ;EgBq9CR,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,iBAAA;AnBskQF;AmBpkQC;EACC,cAAA;EACA,ehB7oCa;AHmtSf;AmBjkQE;EACC,ehBnpCY;EgBopCZ,iBAAA;EACA,WhBj9CK;EgBk9CL,6BAAA;EACA,SAAA;AnBmkQH;AmBjkQE;EACC,ehB1pCY;EgB2pCZ,iBAAA;EACA,chBj8CW;AHogTd;AmB5jQG;EACC,WhB/9CI;EgBg+CJ,ehBpqCW;AHkuSf;AmBzjQA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,ehB9qCc;EgB+qCd,mBAAA;EACA,WAAA;EACA,YAAA;AnB2jQD;AmB1jQC;EACC,mBAAA;EACA,qBhBl3CS;AH86SX;AmBzjQA;EACC,gBAAA;EACA,SAAA;EACA,UAAA;AnB2jQD;AmB1jQC;EACC,qBAAA;EACA,iBAAA;AnB4jQF;AmB3jQE;EACC,chBr3CQ;EgBs3CR,ehB/rCY;AH4vSf;AmBzjQA;EACC,sBAAA;EACA,aAAA;EACA,qBAAA;EACA,sBAAA;EAEA,eAAA;EACA,gBAAA;AnB2jQD;AmBzjQE;EACC,kBAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;EACA,yCAAA;AnB2jQH;AmBzjQE;EACC,oBAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AnB2jQH;AmB1jQG;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,+BAAA;EACA,yBhBx6CO;EgBy6CP,ehB9uCW;EgB+uCX,gBhB3kDmB;EgB4kDnB,chBtiDK;AHkmTT;AmBzjQE;EACC,gBAAA;AnB2jQH;AmBtjQG;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AnBwjQJ;AmBrjQE;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AnBujQH;AmBljQC;EACC,WAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,sBAAA;EACA,UAAA;EACA,yBhBjkDO;AHqnTT;AmBhjQC;EACC,WAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,sBAAA;EACA,UAAA;AnBkjQF;AmB9iQC;EACC,WAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,sBAAA;EACA,UAAA;EACA,yBhBnmDM;AHmpTR;AmB7iQA;EACC,chBloDS;AHirTV;AmB9iQC;EACC,qBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EAEA,oCAAA;EACA,YAAA;AnBgjQF;AmB/iQE;EAEC,sBAAA;AnBijQH;AmB/iQE;EAEC,sBAAA;AnBijQH;AmB7iQA;EACC,mBAAA;EACA,iBAAA;EACA,gBhBvoDO;EgBwoDP,yBAAA;EACA,+BAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AnB+iQD;AmB5iQC;EACC,chB1gDS;EgB2gDT,YAAA;EACA,qBhBlhDS;AHgkTX;AmBxiQG;EACC,YAAA;AnB0iQJ;AmBriQA;EACC,chBxoDa;EgByoDb,ehBt2Cc;EgBu2Cd,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AnBuiQD;AmBtiQC;EACC,ehB52Ca;AHo5Sf;AmBriQA;EACC,UAAA;EACA,SAAA;EACA,gBAAA;AnBuiQD;AmBtiQC;EACC,eAAA;EACA,gCAAA;AnBwiQF;AmBviQE;EACC,chB3iDQ;EgB4iDR,chB5iDQ;EgB6iDR,ehBz3CY;EgB03CZ,iBAAA;AnByiQH;AmBriQE;EACC,chBtsDM;AH6uTT;AmBniQE;EACC,chB3sDM;AHgvTT;AmBjiQE;EACC,chBhtDM;AHmvTT;AmB/hQA;EACC,aAAA;EACA,qBAAA;EACA,sBAAA;EAEA,yBAAA;EACA,iCAAA;EACA,6BAAA;AnBiiQD;AmB/hQA;EACC,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,sBAAA;EAEA,SAAA;AnBiiQD;AmB/hQA;EACC,aAAA;EACA,qBAAA;EACA,sBAAA;EAEA,yBhBjuDO;EgBkuDP,aAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;EACA,kBAAA;EACA,YAAA;AnBiiQD;AmBhiQC;EACC,sBhBvuDM;EgBwuDN,8BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;AnBkiQF;AmBjiQE;EACC,UAAA;AnBmiQH;AmBjiQE;EACC,aAAA;EACA,iBAAA;EACA,mBAAA;AnBmiQH;AmB/hQE;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,chBrnDQ;EgBsnDR,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,+BAAA;EACA,mBAAA;EACA,2BAAA;AnBiiQH;AmBhiQG;EACC,chBlxDM;AHozTV;AmBhiQG;EACC,chBnxDK;AHqzTT;AmB7hQA;EACC,YAAA;AnB+hQD;AmB9hQC;EAIC,yBAAA;EACA,cAAA;AnB6hQF;AmBjiQE;EACC,qBAAA;AnBmiQH;AmB5hQC;EACC,uBAAA;AnB8hQF;AmB5hQC;EACC,SAAA;AnB8hQF;AmB3hQE;EACC,ehBj+CY;EgBk+CZ,gBhB/zDoB;EgBg0DpB,chB1pDQ;AHurTX;AmB3hQE;EACC,eAAA;EACA,gBhBt0DkB;EgBu0DlB,chB/pDQ;AH4rTX;AmBxhQC;EACC,sBAAA;AnB0hQF;AmBvhQI;EACC,mBAAA;AnByhQL;AmBrhQI;EACC,mBAAA;AnBuhQL;AmBjhQA;EACC,mBAAA;AnBmhQD;AmBjhQA;EACC,eAAA;AnBmhQD;AmBjhQE;EACC,UAAA;EACA,gCAAA;AnBmhQH;AmBlhQG;EACC,gBAAA;EACA,mBAAA;AnBohQJ;AmBnhQI;EACC,ehB5gDU;EgB6gDV,gBhB12DgB;EgB22DhB,chBnsDM;EgBosDN,kBAAA;AnBqhQL;AmBnhQI;EACC,ehBlhDU;EgBmhDV,gBhB/2DgB;EgBg3DhB,chBzsDM;EgB0sDN,kBAAA;AnBqhQL;AmBnhQI;EACC,ehBvhDU;EgBwhDV,gBhBt3DgB;EgBu3DhB,chB/sDM;AHouTX;AmBnhQI;EACC,ehB7hDU;EgB8hDV,gBhB13DgB;EgB23DhB,chBrtDM;EgBstDN,oBAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AnBqhQL;AmBphQK;EACC,chB5tDK;AHkvTX;AmBnhQI;EACC,iBAAA;AnBqhQL;AmB/gQA;EACC,eAAA;AnBihQD;AmB/gQA;EACC,eAAA;AnBihQD;AmB/gQA;EACC,oBAAA;AnBihQD;AmB/gQA;EACC,oBAAA;AnBihQD;AmB9gQC;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,chBvvDS;EgBwvDT,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,+BAAA;EACA,mBAAA;EACA,2BAAA;EACA,yBhBtwDS;EgBuwDT,qBhBvwDS;AHuxTX;AmBzgQI;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,chB1wDM;EgB2wDN,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,+BAAA;EACA,mBAAA;EACA,2BAAA;EACA,qBhBzxDM;AHoyTX;AmBrgQA;EACC,yBAAA;AnBugQD;AmBrgQA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;AnBugQD;AmBtgQC;EACC,gBAAA;AnBwgQF;AmBvgQE;EACC,chBryDQ;EgBsyDR,eAAA;EACA,gBhB38DkB;EgB48DlB,gBAAA;AnBygQH;AmBrgQA;EACC,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,ehBpnDc;EgBqnDd,yBAAA;EAGA,iBAAA;EACA,ehB5nDc;EgB6nDd,gBhB39DoB;EgB49DpB,chBpzDU;EgBqzDV,kBAAA;AnBugQD;AmBtgQC;EACC,kBAAA;EACA,UAAA;EACA,eAAA;AnBwgQF;AmBrgQI;EACC,yBhB9zDM;AHq0TX;AmBtgQK;EACC,cAAA;AnBwgQN;AmBjgQE;EACC,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AnBmgQH;AmB//PA;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,sBhB59DO;EgB69DP,yBAAA;EACA,kBAAA;AnBigQD;AmBhgQC;EACC,WAAA;EACA,kBAAA;EACA,aAAA;AnBkgQF;AmB9/PC;EACC,chBj2DS;EgBk2DT,ehB9qDa;EgB+qDb,gBhB1gEmB;AH0gUrB;AmB5/PC;EACC,oCAAA;AnB8/PF;AmB1/PC;EACC,kCAAA;AnB4/PF;AmBz/PA;EACC,kBAAA;EACA,qBAAA;AnB2/PD;AmBz/PA;EACC,mBAAA;AnB2/PD;AmBz/PA;EACC,mBAAA;EACA,aAAA;EACA,mBAAA;AnB2/PD;AmBz/PA;EACC,sBAAA;EACA,uBAAA;EACA,sBAAA;AnB2/PD;AmBx/PC;EACC,WAAA;EACA,qBAAA;EACA,gBAAA;AnB0/PF;AmBz/PE;EACC,eAAA;EACA,YAAA;AnB2/PH;AmBv/PA;EACC,iBAAA;AnBy/PD;AmBx/PC;EACC,ehB1tDa;EgB2tDb,gBhBtjEqB;EgBujErB,chBj5DS;EgBk5DT,kBAAA;AnB0/PF;AmBt/PC;EACC,mBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;AnBw/PF;AmBt/PC;EAQC,gCAAA;EACA,oBAAA;EACA,mBAAA;AnBi/PF;AmB1/PE;EACC,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;AnB4/PH;AmBt/PG;EACC,mBhB5kEM;EgB6kEN,kBAAA;EACA,chBj7DO;EgBk7DP,WhBxjEI;AHgjUR;AmBt/PG;EACC,iBAAA;EACA,ehBlwDW;EgBmwDX,chBv7DO;EgBw7DP,gBhB/lEiB;EgBgmEjB,SAAA;EACA,kBAAA;EACA,mBhB/1DM;EgBg2DN,chB57DO;EgB67DP,kBAAA;AnBw/PJ;AmBv/PI;EACC,iBAAA;AnBy/PL;AmBp/PG;EACC,uBAAA;EACA,kBAAA;AnBs/PJ;AmBr/PI;EACC,kBAAA;EACA,WAAA;AnBu/PL;AmBr/PI;EAKC,kBAAA;EACA,WhBvlEG;EgBwlEH,eAAA;EACA,gBhB1nEgB;EgB2nEhB,kBAAA;EACA,QAAA;EACA,SAAA;EAGA,gCAAA;AnBm/PL;AmBhgQK;EACC,ehBrxDS;EgBsxDT,WhBplEE;AHslUR;AmBn/PM;EACC,chBp+DI;AHy9TX;AmB/+PI;EACC,iBAAA;AnBi/PL;AmB3+PA;EAGC,aAAA;EAGA,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;AnB6+PD;AmB5+PC;EACC,gBAAA;AnB8+PF;AmB3+PA;EAGC,aAAA;EAGA,mBAAA;AnB6+PD;AmB5+PC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,kBAAA;AnB8+PF;AmB7+PE;EACC,ehBv1DY;AHs0Tf;AmB1+PC;EACC,UAAA;EACA,gBAAA;EAGA,aAAA;EAGA,mBAAA;AnB4+PF;AmB3+PE;EACC,gBAAA;EACA,chBjiEQ;EgBkiER,ehB92DY;EgB+2DZ,gBhB3sEkB;EgB4sElB,kBAAA;AnB6+PH;AmB5+PG;EACC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,QAAA;AnB8+PJ;AmB3+PI;EACC,aAAA;AnB6+PL;AmBz+PE;EACC,kBAAA;AnB2+PH;AmBx+PC;EACC,chBzjES;EgB0jET,ehBr4Da;EgBs4Db,gBhBluEmB;AH4sUrB;AmBt+PC;EACC,chBhkES;AHwiUX;AmBr+PA;EACC,gBAAA;AnBu+PD;AmBt+PC;EACC,WAAA;EACA,cAAA;EACA,WAAA;AnBw+PF;AmBt+PC;EACC,gBAAA;EACA,UAAA;EACA,SAAA;AnBw+PF;AmBv+PE;EACC,WAAA;AnBy+PH;AmBx+PG;EACC,chBjtEK;EgBktEL,ehB35DW;AHq4Tf;AmBv+PE;EACC,iBAAA;AnBy+PH;AmBt+PC;EACC,gBhBhwEqB;EgBiwErB,WhBhuEM;EgBiuEN,ehBv6Da;EgBw6Db,mBAAA;AnBw+PF;AmBr+PA;EAGC,aAAA;EAGA,mBAAA;EACA,mBAAA;AnBu+PD;AmBn+PE;EACC,chB5mEQ;EgB6mER,ehBx7DY;EgBy7DZ,gBhBrxEkB;EgBsxElB,kBAAA;AnBq+PH;AmBj+PE;EACC,chBpnEQ;EgBqnER,ehBj8DY;EgBk8DZ,gBhB9xEkB;EgB+xElB,qBAAA;AnBm+PH;AmB/9PE;EACC,chB7nEQ;AH8lUX;AmB59PC;EACC,chBnoES;EgBooET,gBhB1yEmB;AHwwUrB;AmB39PA;EACC,cAAA;AnB69PD;AmB59PC;EACC,kBAAA;EACA,kBAAA;AnB89PF;AmB39PA;EAOC,gBAAA;AnBu9PD;AmB79PC;EACC,gBhBrzEqB;EgBszErB,WhBrxEM;EgBsxEN,ehB59Da;EgB69Db,mBAAA;AnB+9PF;AmB59PC;EACC,WAAA;EACA,cAAA;EACA,WAAA;AnB89PF;AmB59PC;EACC,gBAAA;EACA,UAAA;EACA,SAAA;AnB89PF;AmB79PE;EACC,chBlqEQ;EgBmqER,gBhBv0EkB;AHsyUrB;AmB79PE;EACC,gBAAA;AnB+9PH;AmB59PC;EACC,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AnB89PF;AmB79PE;EACC,UAAA;EACA,QAAA;EACA,SAAA;AnB+9PH;AmB59PC;EACC,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBhB9rES;EgBgsET,gBAAA;AnB89PF;AmB79PE;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,sBhB10EK;EgB40EL,gBAAA;AnB+9PH;AmB39PE;EACC,yBhB70EI;AH0yUP;AmB59PG;EAGC,2BAAA;AnB89PJ;AmB39PE;EACC,2BAAA;AnB69PH;AmB19PC;EACC,mBAAA;AnB49PF;AmB39PE;EACC,kBAAA;AnB69PH;AmBz9PA;EACC,gBAAA;EACA,aAAA;EACA,oBAAA;AnB29PD;AmB19PC;EACC,WAAA;EACA,cAAA;EACA,WAAA;AnB49PF;AmB19PC;EACC,gBAAA;EACA,UAAA;EACA,SAAA;AnB49PF;AmB39PE;EACC,WAAA;EACA,cAAA;EACA,WAAA;AnB69PH;AmB39PE;EACC,cAAA;EACA,WAAA;EACA,gBhBz5EkB;EgB05ElB,kBAAA;AnB69PH;AmB59PG;EACC,chBx4EK;EgBy4EL,kBAAA;AnB89PJ;AmB79PI;EACC,kBAAA;EACA,OAAA;EACA,QAAA;EACA,ehBrkEU;AHoiUf;AmB39PE;EACC,gBAAA;AnB69PH;AmBz9PA;EACC,gBhB36EsB;EgB46EtB,gBAAA;AnB29PD;AmB19PC;EACC,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,WhBl5EM;EgBm5EN,gBAAA;EACA,eAAA;EACA,mBAAA;AnB49PF;AmBz9PA;EACC,iBAAA;AnB29PD;AmB19PC;EACC,gCAAA;EACA,oBAAA;EACA,mBAAA;AnB49PF;AmBz9PA;EACC,iBAAA;AnB29PD;AmBz9PE;EACC,0BAAA;EACA,aAAA;EACA,mBAAA;AnB29PH;AmBx9PC;EACC,gBAAA;EACA,UAAA;EACA,SAAA;AnB09PF;AmBz9PE;EACC,yBAAA;EACA,kBAAA;EACA,sBhBh7EK;EgBi7EL,aAAA;AnB29PH;AmBz9PE;EACC,gBAAA;AnB29PH;AmBx9PC;EAmBC,SAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,qBAAA;EACA,WAAA;AnBw8PF;AmB/9PE;EACC,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,ehBjoEY;EgBkoEZ,gBhB99EkB;EgB+9ElB,kBAAA;EACA,chBzzEQ;AH0xUX;AmB/9PE;EACC,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,chBh0EQ;EgBi0ER,ehB7oEY;EgB8oEZ,gBhB1+EkB;AH28UrB;AmBx9PC;EACC,qBAAA;EACA,chB90ES;EgB+0ET,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBhBx/EmB;EgBy/EnB,mBAAA;AnB09PF;AmBz9PE;EACC,mBAAA;EACA,WhB39EK;AHs7UR;AmBv9PA;EACC,gCAAA;EACA,oBAAA;EACA,mBAAA;AnBy9PD;AmBx9PC;EACC,mBAAA;EACA,ehB1qEa;EgB2qEb,gBhBvgFmB;EgBwgFnB,chBj2ES;EgBo2ET,aAAA;EAGA,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;AnB09PF;AmBv9PA;EACC,iBAAA;EACA,oBAAA;AnBy9PD;AmBt9PC;EACC,aAAA;EACA,mBAAA;EACA,YAAA;AnBw9PF;AmBv9PE;EACC,chB33EQ;AHo1UX;AmBp9PC;EACC,chB73ES;AHm1UX;AmBn9PA;EACC,WAAA;EACA,YAAA;EACA,yBhBrgFM;EgBsgFN,yBAAA;EACA,kBAAA;EACA,WhB5gFO;EgB6gFP,ehBjtEc;EgBktEd,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,+BAAA;EACA,cAAA;AnBq9PD;AmBp9PC;EACC,WhBthFM;AH4+UR;AmBp9PC;EACC,WhBzhFM;AH++UR;AmBn9PA;EAOC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBhBj6EU;EgBk6EV,WhBviFO;EgBwiFP,eAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,+BAAA;EACA,cAAA;AnB+8PD;AmBj+PC;EACC,WhB9hFM;AHigVR;AmBj+PC;EACC,WhBjiFM;AHogVR;AmBj9PE;EACC,chB/6EQ;EgBg7ER,SAAA;EACA,mBAAA;EACA,gBhBxlFkB;EgBylFlB,iBAAA;AnBm9PH;AmBl9PG;EACC,chBr7EO;AHy4UX;AmBj9PE;EACC,iBAAA;AnBm9PH;AmBj9PE;EACC,uCAAA;EACA,chB77EQ;AHg5UX;AmBh9PC;EACC,oBAAA;EACA,kBAAA;AnBk9PF;AmBj9PE;EACC,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,yBhB78EQ;EgB88ER,WAAA;AnBm9PH;AmB98PA;EACC,YAAA;AnBg9PD;AmB78PA;EACC,kBAAA;AnB+8PD;AmB58PA;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AnB88PD;AmB38PA;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AnB68PD;AmB18PA;EACC,mBAAA;AnB48PD;AmBz8PA;EACC,gBAAA;AnB28PD;AmBx8PA;EACC,YAAA;EACA,aAAA;AnB08PD;AmBv8PA;EACC,iBAAA;EACA,gBAAA;AnBy8PD;AmBt8PA;EACC,iBAAA;AnBw8PD;AmBr8PA;EACC,YAAA;EACA,aAAA;AnBu8PD;AmBp8PA;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,oCAAA;EACA,iBAAA;EACA,ehB90Ec;AHoxUf;AmBn8PA;EACC,WhBjpFO;AHslVR;AmBl8PA;EACC,aAAA;EACA,2BAAA;EACA,kBAAA;EACA,eAAA;AnBo8PD;AmBj8PA;EACC,WAAA;EACA,gBAAA;EACA,eAAA;AnBm8PD;AmBh8PA;EACC,eAAA;AnBk8PD;AmB/7PA;EACC,qBAAA;AnBi8PD;AmB97PA;EACC,yBAAA;EACA,qBAAA;AnBg8PD;AmB77PA;EACC,qBAAA;AnB+7PD;AmB57PA;EACC,kBAAA;AnB87PD;AmB37PA;EACC,gBAAA;EACA,qBAAA;AnB67PD;AmB17PA;EACC,iBAAA;AnB47PD;AmBz7PA;EACC,yBAAA;AnB27PD;AmBx7PA;EACC,sBAAA;AnB07PD;AmBv7PA;EACC,2BAAA;EACA,gCAAA;AnBy7PD;AmBt7PA;EACC,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AnBw7PD;AmBr7PA;EACC,WhBrtFO;EgBstFP,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBhB9vFsB;AHqrVvB;AmBp7PA;EACC,WAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;EACA,cAAA;AnBs7PD;AmBn7PA;;EAEC,WAAA;EACA,YAAA;EACA,iBAAA;AnBq7PD;AmBl7PA;EACC,cAAA;EACA,aAAA;AnBo7PD;AmBj7PA;EACC,ehB57Ec;AH+2Uf;AmBh7PA;EACC,cAAA;EACA,aAAA;AnBk7PD;AmB/6PA;EACC,eAAA;AnBi7PD;AmB96PA;EACC,aAAA;EACA,YAAA;AnBg7PD;AmB76PA;EACC,kBAAA;AnB+6PD;AmB56PA;EACC,eAAA;EACA,mBAAA;AnB86PD;AmB36PA;EACC,yBAAA;EACA,iCAAA;EACA,6BAAA;EACA,wBAAA;EACA,gCAAA;EACA,4BAAA;AnB66PD;AmB16PA;EACC,yBAAA;EACA,iCAAA;EACA,6BAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;AnB46PD;AmBz6PA;EACC,gCAAA;EACA,oBAAA;AnB26PD;AmBx6PA;EACC,gBAAA;AnB06PD;AmBv6PA;EACC,ehBl/Ec;AH25Uf;AmBp6PA;EACC,gBhBn1FoB;EgBo1FpB,cAAA;EACA,ehBx/Ec;EgBy/Ed,kBAAA;AnBs6PD;AmBn6PA;EACC,gBAAA;EACA,gBAAA;AnBq6PD;AmBl6PA;EACC,cAAA;EACA,SAAA;EACA,UAAA;AnBo6PD;AmBj6PA;EACC,ehBtgFc;AHy6Uf;AmBh6PA;EACC,uBAAA;EACA,SAAA;AnBk6PD;AmB/5PA;EACC,sBAAA;AnBi6PD;AmB95PA;EACC,sBAAA;AnBg6PD;AmB75PA;EACI,eAAA;AnB+5PJ;AmB55PA;EACC,mBAAA;AnB85PD;AmB35PA;EACI,qBAAA;AnB65PJ;AmB15PA;EACI,eAAA;AnB45PJ;AmB15PA;EACC,aAAA;AnB45PD;AmB15PA;EACC,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;AnB45PD;AmB15PA;EACC,UAAA;EACA,mBAAA;AnB45PD;AmBz5PA;EACC,ehBxjFc;EgByjFd,gBhBl5FkB;EgBm5FlB,yBAAA;EACA,cAAA;EACA,gBAAA;AnB25PD;AmBx5PA;EACC,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,WhB93FO;EgB+3FP,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,+BAAA;EACA,eAAA;AnB05PD;AmBv5PA;EACC,gBAAA;EACA,UAAA;EACA,SAAA;AnBy5PD;AmBt5PA;EACC,WAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACG,uBAAA;EACA,+BAAA;AnBw5PJ;AmBr5PA;EACC,iBAAA;AnBu5PD;AmBp5PA;EACC,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,ehBtmFc;AH4/Uf;AmBp5PA;EACE,yBAAA;EACA,qBAAA;AnBs5PF;AmBn5PA;EACC,cAAA;EACA,gBhB98FoB;AHm2VrB;AmBl5PA;EACC,sBAAA;AnBo5PD;AmBl5PA;EAGI,aAAA;EAGH,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;AnBo5PD;AmBl5PA;EACC,gBAAA;EACA,ehBpoFc;EgBqoFd,gBhBl+FsB;EgBq+FnB,aAAA;EAGH,mBAAA;AnBo5PD;AmBl5PA;EACC,ehB5oFc;AHgiVf;AmBl5PA;EACC,gBAAA;EACA,chBt+FS;EgBu+FT,gBhBj/FoB;AHq4VrB;AmBl5PA;EACC,cAAA;AnBo5PD;AmBj5PA;EACC,kBAAA;EACA,WAAA;EACA,YAAA;AnBm5PD;AmBh5PA;EACC,eAAA;EACA,YAAA;EACA,mBAAA;AnBk5PD;AmB/4PA;EACC,cAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;AnBi5PD;AmB94PA;EACC,WAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,mCAAA;EACA,+BAAA;EACA,QAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;AnBg5PD;AmB74PA;;EAEC,ehB/rFc;AH8kVf;AmB54PA;EACC,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AnB84PD;AmB34PA;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AnB64PD;AmB14PA;EACC,WAAA;EACA,YAAA;EACA,yBAAA;EACA,WhB/gGO;EgBghGP,aAAA;EACA,mBAAA;EACA,uBAAA;AnB44PD;AmBz4PA;;;EAGC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,sBAAA;AnB24PD;AmBx4PA;EACC,yBAAA;AnB04PD;AmBv4PA;EACC,yBAAA;AnBy4PD;AmBt4PA;EACC,yBAAA;AnBw4PD;AmBr4PA;EACC,4BAAA;AnBu4PD;AmBp4PA;EACC,6BAAA;AnBs4PD;AmBn4PA;EACC,ehB1vFc;AH+nVf;AmBl4PA;EACC,cAAA;EACA,eAAA;AnBo4PD;AmBj4PA;EACC,4BAAA;AnBm4PD;AmBh4PA;EACC,6BAAA;AnBk4PD;AmB/3PA;EACC,eAAA;AnBi4PD;AmB93PA;;;EAGC,iBAAA;AnBg4PD;AmB73PA;EACC,aAAA;EACA,cAAA;AnB+3PD;AmB53PA;EACC,4BAAA;AnB83PD;AmB33PA;EACC,6BAAA;AnB63PD;AmB13PA;EACC,ehBpyFc;AHgqVf;AmBz3PA;;;EAGC,iBAAA;AnB23PD;AmBx3PA;EACC,cAAA;EACA,eAAA;AnB03PD;AmBv3PA;EACC,4BAAA;AnBy3PD;AmBt3PA;EACC,6BAAA;AnBw3PD;AmBr3PA;EACC,ehBtzFc;AH6qVf;AmBp3PA;;;EAGC,iBAAA;AnBs3PD;AmBn3PA;EACC,WAAA;EACA,YAAA;AnBq3PD;AmBl3PA;EACC,4BAAA;AnBo3PD;AmBj3PA;EACC,6BAAA;AnBm3PD;AmBh3PA;EACC,ehB30Fc;AH6rVf;AmB/2PA;;;EAGC,iBAAA;AnBi3PD;AmB92PA;EACC,eAAA;EACA,gBAAA;AnBg3PD;AmB72PA;EACC,4BAAA;AnB+2PD;AmB52PA;EACC,6BAAA;AnB82PD;AmB32PA;EACC,ehBj2Fc;AH8sVf;AmB12PA;;;EAGC,iBAAA;AnB42PD;AmBz2PA;EACC,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AnB22PD;AmBx2PA;EACC,qBAAA;AnB02PD;AmBv2PA;EACC,kBAAA;AnBy2PD;AmBt2PA;EACC,sBAAA;AnBw2PD;AmBr2PA;EACC,kBAAA;AnBu2PD;AmBp2PA;EACC,wBAAA;AnBs2PD;AmBn2PA;EACC,UAAA;AnBq2PD;AmBl2PA;EACC,cAAA;AnBo2PD;AmBj2PA;EACC,aAAA;EACA,qBAAA;EACA,mBAAA;AnBm2PD;AmBh2PA;EACC,eAAA;AnBk2PD;AmB/1PA;EACC,YAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,OAAA;AnBi2PD;AmB91PA;EACC,YAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,OAAA;AnBg2PD;AmB71PA;EACC,yBAAA;AnB+1PD;AmB51PA;EACC,eAAA;AnB81PD;AmB31PA;EACC,YAAA;EACA,cAAA;AnB61PD;AmB11PA;EACC,iBAAA;EACA,eAAA;AnB41PD;AmBz1PA;EACC,mBAAA;AnB21PD;AmBx1PA;EACC,mBAAA;AnB01PD;AmBv1PA;EACC,mBAAA;AnBy1PD;AmBt1PA;EACC,mBAAA;AnBw1PD;AmBr1PA;EACC,mBAAA;AnBu1PD;AmBp1PA;EACC,mBAAA;AnBs1PD;AmBn1PA;EACC,mBAAA;AnBq1PD;AmBl1PA;EACC,mBAAA;AnBo1PD;AmBj1PA;EACC,kBAAA;AnBm1PD;AmBh1PA;EACC,gBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;AnBk1PD;AmB/0PA;EACC,ehBh/Fc;AHi0Vf;AmB90PA;EACI,gBAAA;EACA,gBAAA;EACA,yBAAA;AnBg1PJ;AmB90PA;EACI,yBAAA;AnBg1PJ;AmB90PA;EACC,aAAA;EACA,yBhB90GS;AH8pWV;AmB90PA;EACC,yBhBj1GS;AHiqWV;AmB70PA;EACC,aAAA;AnB+0PD;AmB50PA;EACC,iBAAA;AnB80PD;AmB30PA;EACC,qBAAA;AnB60PD;AmB10PA;EACC,aAAA;EACA,gBAAA;AnB40PD;AmBz0PA;EACC,aAAA;EACA,qBAAA;AnB20PD;AIzpWI;Ee40GJ;IAIE,cAAA;EnB60PA;AACF;AmB10PA;EACC,aAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AnB40PD;AItqWI;Eeo1GJ;IAQE,WAAA;EnB80PA;AACF;AI3qWI;Eei2GH;IAEE,wBAAA;EnB40PD;AACF;AmBz0PA;EACC,gBhB12GO;EgB22GP,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,0CAAA;AnB20PD;AIzrWI;Eeu2GJ;IASE,sBAAA;EnB60PA;AACF;AmB10PA;EACC,aAAA;AnB40PD;AmBz0PA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBhB95GsB;EgB+5GtB,yBAAA;AnB20PD;AmBx0PA;EACC,wBAAA;AnB00PD;AmBv0PA;EACC,ehBxkGc;AHi5Vf;AmBt0PA;EACC,gBAAA;EACA,aAAA;AnBw0PD;AmBr0PA;EACC,2BAAA;AnBu0PD;AmBp0PA;EACC,gBAAA;AnBs0PD;AmBn0PA;EACC,gBAAA;EACA,WAAA;EACA,6BAAA;AnBq0PD;AmBl0PA;EACC,0BAAA;AnBo0PD;AmBj0PA;EACC,SAAA;EACA,cAAA;EACA,uBAAA;EACA,WAAA;AnBm0PD;AmBj0PA;EACC,iBAAA;AnBm0PD;AmBj0PA;EACC,gBhB38GsB;EgB48GtB,cAAA;EACA,ehBhnGc;EgBinGd,gBAAA;AnBm0PD;AmBh0PA;EACC,kBAAA;AnBk0PD;AmB/zPA;EACC,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AnBi0PD;AmB9zPA;EACC,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,yBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;AnBg0PD;AmB7zPA;EACC,WhBv8GO;EgBw8GP,qBAAA;AnB+zPD;AmB5zPA;EACC,aAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;AnB8zPD;AmB3zPA;EACC,0CAAA;EACA,0CAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;AnB6zPD;AmB1zPA;EACC,yBAAA;AnB4zPD;AmBzzPA;EACC,kBAAA;AnB2zPD;AmBxzPA;EACC,SAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;AnB0zPD;AmBvzPA;EACC,cAAA;AnByzPD;AmBtzPA;EACC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AnBwzPD;AmBtzPA;EACC,2BAAA;EACA,aAAA;EACA,mBAAA;AnBwzPD;AmBrzPA;EACC,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,ehB3sGc;EgB4sGd,gBhBxiHoB;EgByiHpB,kBAAA;EACA,cAAA;AnBuzPD;AmBpzPA;EACC,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,ehBxtGc;AH8gWf;AmBpzPA;EACC,cAAA;AnBszPD;AmBpzPA;EACC,kBAAA;EACA,kBAAA;AnBszPD;AmBnzPA;EACC,yBAAA;EACA,gBhBhkHoB;EgBikHpB,eAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;AnBqzPD;AmBnzPA;EACC,cAAA;AnBqzPD;AmBlzPA;EACC,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,+BAAA;EACA,cAAA;EACA,eAAA;EACA,yBhB1kHS;EgB2kHT,WhBpjHO;EgBqjHP,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;AnBozPD;AmBjzPA;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;AnBmzPD;AmBhzPA;EACC,WhB3kHO;AH63WR;AmB/yPA;EACC,WhB/kHO;AHg4WR;AmB9yPA;EACC,0CAAA;AnBgzPD;AmB7yPA;EACC,cAAA;AnB+yPD;AmB5yPA;EACC,2BAAA;AnB8yPD;AmB5yPA;EAGI,aAAA;EAGH,mBAAA;EACA,oBAAA;EACA,4BAAA;EACA,kBAAA;AnB8yPD;AmB7yPC;EACC,cAAA;AnB+yPF;AmB5yPA;EACC,WAAA;AnB8yPD;AmB5yPA;EACC,cAAA;AnB8yPD;AmB5yPA;EACC,gBAAA;AnB8yPD;AmB5yPA;EACC,kBAAA;AnB8yPD;AmB5yPA;EACC,aAAA;EACA,mBAAA;EACA,cAAA;EACA,ehB/zGc;EgBg0Gd,gBhB9pHoB;AH48WrB;AmB5yPA;EACC,ehBp0Gc;AHknWf;AmB3yPA;EACC,iBAAA;AnB6yPD;AmB3yPA;EACC,gCAAA;EACA,oBAAA;EACA,mBAAA;AnB6yPD;AmB3yPA;EACC,ehBh1Gc;EgBi1Gd,gBhB7qHoB;EgB8qHpB,cAAA;EACA,mBAAA;EAGG,aAAA;EAGH,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;AnB6yPD;AmB3yPA;EACC,yBAAA;AnB6yPD;AmB3yPA;EACC,cAAA;EACA,ehBl2Gc;EgBm2Gd,gBhBjsHoB;EgBksHpB,mBAAA;AnB6yPD;AmB3yPA;EACC,cAAA;EACA,eAAA;EACA,gBhBvsHoB;EgBwsHpB,kBAAA;AnB6yPD;AmB3yPA;EACC,eAAA;EACA,cAAA;EACA,gBhB7sHoB;EgB8sHpB,gBAAA;AnB6yPD;AmB3yPA;EACC,gBAAA;AnB6yPD;AmB3yPA;EACC,cAAA;EACA,ehBz3Gc;EgB03Gd,gBhBrtHoB;AHkgXrB;AmB3yPA;EACC,cAAA;AnB6yPD;AmB3yPA;EACC,mBAAA;AnB6yPD;AmB3yPA;EACC,cAAA;AnB6yPD;AmB3yPA;EACC,mBAAA;AnB6yPD;AmB3yPA;EACC,cAAA;AnB6yPD;AmB3yPA;EACC,mBAAA;AnB6yPD;AmB3yPA;EACC,cAAA;AnB6yPD;AmB3yPA;EACC,WAAA;EACA,YAAA;AnB6yPD;AmB3yPA;EACC,ehBt5Gc;EgBu5Gd,gBhBnvHoB;EgBovHpB,cAAA;EACA,gBAAA;AnB6yPD;AmB3yPA;EACC,mBAAA;AnB6yPD;AmB3yPA;EACC,cAAA;AnB6yPD;AmB3yPA;EACC,aAAA;AnB6yPD;AmB3yPA;EACC,iBAAA;AnB6yPD;AmB3yPA;EACC,cAAA;AnB6yPD;AmB3yPA;EACC,gBhBrwHsB;EgBswHtB,cAAA;EACA,ehB16Gc;AHutWf;AmB3yPA;EACC,ehBh7Gc;EgBi7Gd,gBhB7wHoB;EgB8wHpB,cAAA;AnB6yPD;AmB3yPA;EACC,0BAAA;AnB6yPD;AmB3yPA;EACC,0BAAA;AnB6yPD;AmB3yPA;EACC,gBhBrvHO;EgBsvHP,0BAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;AnB6yPD;AmB3yPA;EACC,aAAA;AnB6yPD;AmB3yPA;EACC,mBAAA;EACA,ehBr8Gc;EgBs8Gd,gBhBnyHoB;EgBoyHpB,cAAA;AnB6yPD;AmB3yPA;EACC,cAAA;EACA,ehB78Gc;EgB88Gd,gBhB1yHoB;AHulXrB;AmB3yPA;EACC,mBAAA;AnB6yPD;AmB3yPA;EACC,UAAA;AnB6yPD;AmB3yPA;EACC,kBAAA;AnB6yPD;AmB3yPA;EACC,kBAAA;EACA,MAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;AnB6yPD;AmB3yPA;EAGI,aAAA;EAGH,mBAAA;AnB6yPD;AmB3yPA;EACC,iBAAA;AnB6yPD;AmB3yPA;EACC,6BAAA;EACA,WhBvyHO;AHolXR;AmB3yPA;EACC,cAAA;AnB6yPD;AmB3yPA;EACC,aAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACG,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,iCAAA;AnB6yPJ;AmB3yPA;EAGI,aAAA;EAGH,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AnB6yPD;AmB3yPA;EACC,UAAA;AnB6yPD;AmB3yPA;EACC,mBAAA;AnB6yPD;AmB3yPA;EACC,ehB3gHc;EgB4gHd,cAAA;AnB6yPD;AmB3yPA;EACC,qCAAA;AnB6yPD;AmB3yPA;EACC,aAAA;EACA,iBAAA;AnB6yPD;AmB3yPA;EACC,ehBzhHc;EgB0hHd,gBhBt3HoB;EgBu3HpB,cAAA;AnB6yPD;AmB3yPA;EACC,aAAA;AnB6yPD;AmB3yPA;EACC,kBAAA;AnB6yPD;;AmBvyPQ;EACI,sBhBn2HJ;EgBo2HI,gCAAA;AnB0yPZ;AmBvyPI;EACI,oCAAA;AnByyPR;;AmBryPI;EACI,aAAA;AnBwyPR;;AmBnyPQ;EftzHL,SeuzHiC;EftzHjC,mBeszHmC;EAC1B,YAAA;AnBuyPZ;AmBryPQ;EAGL,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACS,chBzvHD;EgB0vHC,oBAAA;EACA,UAAA;Ef30HV,kBe40H4B;Ef30H5B,Me20HqC;Ef10HrC,We00HuC;Efz0HvC,Sey0H4C;AnB0yP9C;;AmBryPI;EACI,+BAAA;EACA,gBAAA;EACA,UAAA;AnBwyPR;AmBvyPQ;EACI,gCAAA;Ef90HT,Se+0HiC;Ef90HjC,ae80HmC;Ef31HpC,oBe41H8B;AnB4yPhC;AmB3yPY;EACI,yBhBhxHL;AH6jXX;AmB3yPY;EACI,yBhBnxHL;AHgkXX;AmB3yPY;Efv1HT,kBew1HqC;EACxB,kBAAA;AnB6yPhB;AmB5yPgB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AnB8yPpB;AmB3yPY;EAGF,aAAA;EACA,8BAAA;EACH,sCAAA;EACA,4BAAA;AnB6yPP;AmB5yPgB;EACI,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,chBlyHT;EgBmyHS,ehB7mHL;EgB8mHK,gBhBz8HD;AHuvXnB;AmB5yPgB;EACI,chBxyHT;EgByyHS,ehBr9HH;EgBs9HG,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AnB8yPpB;AmB5yPgB;EACI,chBnzHT;EgBozHS,ehB9nHL;AH46Wf;AmB3yPoB;EACI,iBAAA;AnB6yPxB;;AmBryPA;Efn5HE,oBeo5HsB;AnB0yPxB;AmBzyPI;EACI,+BAAA;EACA,gBAAA;AnB2yPR;AmBvyPQ;EACI,aAAA;Efh5HT,mBei5HiC;Efh5HjC,eeg5H8C;AnB0yPjD;AmBvyPI;EACI,kBAAA;EACA,YAAA;EACA,WAAA;AnByyPR;AmBxyPQ;EACI,YAAA;EACA,eAAA;EACA,WAAA;EACA,2BAAA;AnB0yPZ;AmBvyPI;Ef/5HD,qBeg6H6B;Ef/5H7B,Ue+5H2C;EACtC,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AnB0yPR;AmBxyPI;Eft6HD,ceu6H6B;Eft6H7B,Ues6HoC;EAC/B,WAAA;AnB2yPR;AmBzyPY;EACI,mBAAA;AnB2yPhB;AmB1yPgB;EACI,QAAA;EACA,YAAA;EACA,WAAA;AnB4yPpB;AmB1yPgB;EAGL,aAAA;EAGJ,qBAAA;EAEA,sBAAA;Efz7HJ,kBe07HyC;Efz7HzC,Uey7HqD;AnB6yPxD;AmB5yPoB;Ef37HjB,Se47H6C;Ef37H7C,mBe27H+C;EAC1B,kBAAA;AnB+yPxB;AmB9yPwB;Ef97HrB,ee+7HiD;Ef97HjD,Ue87HyD;AnBizP5D;AmB/yPwB;Efj8HrB,Sek8HiD;Efj8HjD,Uei8HmD;AnBkzPtD;AmBhzPwB;EACI,oCAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;Efn9H1B,kBeo9H4C;Efn9H5C,Mem9HqD;Efl9HrD,Yek9HuD;Efh9HvD,Ueg9HkE;AnBqzPpE;AmBnzPuB;Ef98HpB,Se+8HiD;Ef98HjD,kBe88HmD;Efv7HpD,mBew7H2C;EACjB,yBAAA;EACA,qBAAA;EACA,kBAAA;AnBszP5B;AmBpzPwB;Ef77HtB,+Be87H2C;AnBszP7C;AmBnzPoB;EAGR,aAAA;Ef59HT,ce69H6C;Ef59H7C,ce49HoD;EAC/B,WAAA;AnBszPxB;AmBrzPwB;EACI,kBAAA;EACA,gBAAA;EACA,gBAAA;AnBuzP5B;AmBtzP4B;Ef3+H1B,kBe4+HgD;Ef3+HhD,Me2+HyD;Ef1+HzD,Qe0+H2D;Efz+H3D,Sey+H6D;Efx+H7D,Oew+H+D;EACjC,gBhBhiIxB;EgBiiIwB,WAAA;EACA,YAAA;Efn/H9B,oBeo/HkD;AnB8zPpD;AmB3zPgC;EACI,UAAA;AnB6zPpC;AmBzzPuB;EACK,aAAA;AnB2zP5B;AmBxzPwB;EACI,eAAA;AnB0zP5B;AmBxzPwB;Ef//HtB,kBeggI4C;Ef//H5C,Qe+/HqD;Ef5/HrD,Se4/HmE;EACzC,gCAAA;EACA,UAAA;EftgI1B,oBeugI8C;EACpB,WhBxjIpB;EgByjIoB,WAAA;EACA,iBAAA;EACA,oCAAA;EACA,kBAAA;AnB8zP5B;AmB3zPoB;EAGZ,aAAA;EACa,mBAAA;EACb,yBAAA;EACA,sBAAA;EfzgIL,ee0gI6C;EfzgI7C,UeygIqD;EAEhD,eAAA;EACgB,WAAA;EACA,2BAAA;EACA,gBAAA;AnB8zPxB;AmB7zPwB;EfhhIrB,SeihIiD;EfhhIjD,mBeghImD;EAC1B,kBAAA;AnBg0P5B;AmB9zP4B;Ef5hI1B,kBe6hIgD;Ef5hIhD,Qe4hIyD;Ef3hIzD,We2hI6D;EfzhI7D,SeyhIuE;EACzC,gCAAA;EACA,mBhB1mItB;EgB2mIsB,WAAA;EACA,WAAA;EACA,UAAA;AnBm0PhC;AmBh0PwB;EACI,4BAAA;AnBk0P5B;AmBh0PwB;EACI,chBx9HjB;AH0xXX;AmB7zPY;EACI,kBAAA;EACA,mBAAA;AnB+zPhB;AmB9zPgB;EACI,kBAAA;Ef1iIjB,kBe2iIyC;Ef1iIzC,Ue0iIoD;AnBi0PvD;AmBh0PoB;EACI,oCAAA;EACA,+BAAA;EACA,6BAAA;EACA,kCAAA;EACA,WAAA;EACA,SAAA;Ef1jItB,kBe2jIwC;Ef1jIxC,Qe0jIiD;EfzjIjD,WeyjIqD;EfvjIrD,UeujI+D;EACzC,QAAA;AnBq0PxB;AmBn0PoB;EftjIjB,SeujI6C;EftjI7C,kBesjI+C;Ef/hIhD,mBegiIuC;EACjB,yBhB5oId;EgB6oIc,cAAA;EACA,kBAAA;AnBs0PxB;AmBr0PwB;EACI,WhBznIpB;EC4DL,Se8jIiD;Ef7jIjD,Ue6jImD;AnBw0PtD;AmBp0PgB;EACI,cAAA;AnBs0PpB;AmBr0PoB;EACI,eAAA;AnBu0PxB;AmBn0PY;EAGR,aAAA;EACM,mBAAA;EACN,yBAAA;EACA,sBAAA;EAEE,eAAA;EfjlIH,eeklIqC;EfjlIrC,UeilI6C;EAChC,WAAA;EACA,gBAAA;AnBs0PhB;AmBr0PgB;EACI,+BAAA;AnBu0PpB;AmBp0PY;EAGR,aAAA;Ef5lID,ce6lIqC;Ef5lIrC,ce4lI4C;EAC/B,WAAA;AnBu0PhB;AmBt0PgB;EACI,kBAAA;EACA,gBAAA;EACA,gBAAA;AnBw0PpB;AmBv0PoB;Ef3mIlB,kBe4mIwC;Ef3mIxC,Me2mIiD;Ef1mIjD,Qe0mImD;EfzmInD,SeymIqD;EfxmIrD,OewmIuD;EACjC,gBhBhqIhB;EgBiqIgB,WAAA;EACA,YAAA;EfnnItB,oBeonI0C;AnB+0P5C;AmB50PwB;EACI,UAAA;AnB80P5B;AmB10Pe;EACK,aAAA;AnB40PpB;AmBz0PgB;EACI,eAAA;AnB20PpB;AmBz0PgB;Ef/nId,kBegoIoC;Ef/nIpC,Qe+nI6C;Ef5nI7C,Se4nI2D;EfrqI3D,gCesqIqC;EfrqIrC,wCeqqIqC;EfpqIrC,oCeoqIqC;EfroIrC,oBesoIsC;EACpB,UAAA;EACA,WhBxrIZ;EgByrIY,WAAA;EACA,iBAAA;EACA,oCAAA;EACA,kBAAA;AnBi1PpB;AmB30PQ;EACI,ehB1uIK;EgB2uIL,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,0BAAA;AnB60PZ;AmB50PY;EACI,yBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EfzpId,kBe0pIgC;EfzpIhC,QeypIyC;EfxpIzC,UewpI6C;EAC/B,WAAA;AnBg1PhB;AmB90PY;EACI,yBAAA;EACA,WAAA;EACA,WAAA;EfxpIb,kBeypIqC;EfjqItC,kBekqIgC;EfjqIhC,QeiqIyC;Ef9pIzC,Se8pIuD;EACzC,WAAA;AnBk1PhB;;AmB50PA;EACI,sBhB9tII;EgB+tIJ,6BAAA;EfnqID,SeoqIyB;EfnqIzB,oBemqI2B;AnBg1P9B;AmB/0PI;EACI,+CAAA;EACA,oBAAA;EACA,gBAAA;AnBi1PR;;AInjYI;EesuIA;IACI,QAAA;IACA,UAAA;IACA,mBAAA;EnBi1PN;EmB90PE;If1rIF,kBe2rIwB;IfzrIxB,aeyrIwC;IAClC,UAAA;IACA,kBAAA;IACA,WAAA;EnBi1PN;EmB/0PE;IACI,aAAA;IACA,mBAAA;EnBi1PN;AACF;AmB90PI;EACI,gBAAA;AnBg1PR;AmB90PI;EACI,gBhB7xIW;EgB8xIX,chBznIG;EgB0nIH,ehBn8HO;AHmxXf;AI9kYI;Ee2vIA;IAKQ,ehBzyIK;EH2nYf;AACF;AmBh1PI;EACI,gBhBryIW;EgBsyIX,chBjoIG;EgBkoIH,ehB38HO;EgB48HP,kBAAA;AnBk1PR;AIzlYI;EemwIA;IAMQ,ehB98HG;EHkyXb;AACF;AmBl1PI;EACI,ehBtzIS;EgBuzIT,chB5oIG;EgB6oIH,gBhBnzIa;AHuoYrB;AInmYI;Ee4wIA;IAKQ,ehB39HG;EHizXb;AACF;AIxmYI;Ee4wIA;IAQQ,ehB99HG;IgB+9HH,mBAAA;EnBw1PV;AACF;AmBt1PI;EACI,mBhBlzIE;EgBmzIF,WAAA;EACA,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,UAAA;AnBw1PR;AmBv1PQ;EACI,iEAAA;AnBy1PZ;AmBt1PI;EACI,iBAAA;AnBw1PR;AInoYI;Ee0yIA;IAGQ,cAAA;IACA,gBAAA;EnB01PV;AACF;AmBx1PI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBhBj1IE;EgBk1IF,iBAAA;EACA,WhB5zIA;EgB6zIA,gBhB51IW;EgB61IX,ehBpgIO;EgBqgIb,YAAA;EACM,kBAAA;AnB01PR;AmBz1PQ;EACI,WhBl0IJ;AH6pYR;AmBz1PQ;EACI,+BAAA;AnB21PZ;AI9pYI;EeizIA;IAqBQ,kBAAA;EnB41PV;AACF;AmB31PQ;EACI,mBhB3mIE;AHw8Xd;AmB31PQ;EACI,WAAA;EACA,YAAA;AnB61PZ;AmB11PI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBhBntIG;EgBotIH,iBAAA;EACA,WhB31IA;EgB41IA,gBhB33IW;EgB43IX,ehBniIO;EgBoiIP,kBAAA;EACA,qBAAA;AnB41PR;AmB31PQ;EACI,+BAAA;AnB61PZ;AI5rYI;Eeg1IA;IAkBQ,kBAAA;EnB81PV;AACF;AmB71PQ;EACI,mBhB93IF;AH6tYV;AmB71PQ;EACI,WAAA;EACA,YAAA;AnB+1PZ;AmB51PI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBhBl4IC;EgBm4ID,iBAAA;EACA,WhBv3IA;EgBw3IA,gBhBv5IW;EgBw5IX,ehB/jIO;EgBgkIP,kBAAA;AnB81PR;AmB71PQ;EACI,+BAAA;AnB+1PZ;AIztYI;Ee42IA;IAiBQ,kBAAA;EnBg2PV;AACF;AmB/1PQ;EACI,mBhB5vID;AH6lYX;AmB/1PQ;EACI,WAAA;EACA,YAAA;AnBi2PZ;AIruYI;Eeu4IA;IAEQ,yBAAA;EnBg2PV;EmB/1PU;IACI,cAAA;EnBi2Pd;AACF;AI7uYI;Ee84II;IAES,cAAA;IACA,mBAAA;EnBi2Pf;AACF;AmB/1PQ;EACI,cAAA;AnBi2PZ;AmB91PI;EACI,kBAAA;AnBg2PR;AmB91PI;EACI,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,WAAA;AnBg2PR;;AmB71PA;EACI,UAAA;EACA,SAAA;AnBg2PJ;;AmB71PC;EACC,aAAA;AnBg2PF;AmB91PC;EACC,mBhB9sIQ;EgB+sIR,kBAAA;EACA,aAAA;AnBg2PF;AmB91PG;EACC,mBhB58IM;EgB68IN,WAAA;EACA,YAAA;EACA,mBAAA;EAGY,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AnBg2PhB;AmB/1PI;EACC,mBAAA;EACA,sBAAA;AnBi2PL;AmB71PE;EACC,mBAAA;EACA,YAAA;EACA,aAAA;AnB+1PH;AmB91PG;EACC,kBAAA;AnBg2PJ;;AmB31PA;EACI,WAAA;EACA,YAAA;EACA,gBAAA;AnB81PJ;AmB71PC;EACC,WAAA;EACA,UAAA;EACA,WAAA;EACA,sBhB19IM;EgB29IN,cAAA;EACA,YAAA;Efh6IC,aei6IuB;Efz4IxB,kBe04IiB;AnB+1PnB;AmB91PE;EACC,qCAAA;AnBg2PH;AmB91PE;EACC,qCAAA;AnBg2PH;AmB91PE;EACC,qCAAA;AnBg2PH;;AmB51PA;EACC;IACC,UAAA;EnB+1PA;AACF;AmB31PC;EACC,WAAA;AnB61PF;AmB31PC;EACC,chBxgJQ;AHq2YV;AmB31PC;EACC,chBrgJO;AHk2YT;;AmBz1PC;EACC,aAAA;AnB41PF;AmB11PC;EACC,mBhB9xIQ;EgB+xIR,kBAAA;EACA,aAAA;AnB41PF;AmB11PG;EACC,mBhB5hJM;EgB6hJN,WAAA;EACA,YAAA;EACA,mBAAA;EAGY,aAAA;EACA,mBAAA;EACZ,sBAAA;EACY,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AnB41PhB;AmB31PI;EACC,mBAAA;EACA,sBAAA;AnB61PL;AmBz1PE;EACC,mBAAA;EACA,YAAA;EACA,aAAA;AnB21PH;AmB11PG;EACC,kBAAA;AnB41PJ;;AmBr1PE;EACC,ehB5uIY;EgB6uIZ,WhBtiJK;EgBuiJL,mBAAA;AnBw1PH;AmBv1PG;EACC,cAAA;EACA,chB50IS;AHqqYb;AmBv1PG;EACC,gBAAA;AnBy1PJ;;AIr4YI;EeijJJ;IAEG,wBAAA;EnBu1PD;AACF;;AI34YI;EesjJJ;IAEG,mBAAA;EnBw1PD;AACF;;AoB37YG;EACC,WAAA;EACA,aAAA;ApB87YJ;;AoBz7YA;EACC,cAAA;ApB47YD;;AoB17YA;EACC,SAAA;ApB67YD;;AoBx7YE;EACI,qBAAA;EACA,4BAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,SAAA;EACA,iBAAA;EACA,gBjBhBiB;AH28YvB;AoBx7YE;EACC,WjBYK;AH86YR;AoBv7YC;EACC,oCjBnBoB;AH48YtB;;AoBr7YE;EACI,cjByIK;EiBxIL,yBAAA;EACA,iBAAA;EACA,kBjBwSa;EiBvSb,aAAA;EACA,mBAAA;EACA,6DAAA;ApBw7YN;;AoBr7YA;EACE,qBjBoHU;EiBnHV,qDAAA;EACA,mBAAA;EACA,cjBqNW;EiBpNX,sBjBXM;EiBYN,UAAA;EACA,WAAA;ApBw7YF;;AoBt7YA;EACE,qBjB2GU;AH80YZ;;AoBt7YA;EACE,cjB2MW;AH8uYb;;AoBv7YA;EACE,cjBwMW;AHkvYb;;AoBx7YA;EACE,cjBqMW;EiBpMX,kBAAA;EACA,yBAAA;EACA,oBAAA;ApB27YF;AoBz7YE;EAEE,cjB8LS;EiB7LT,YAAA;ApB07YJ;AoBv7YI;EAGE,cjB/DI;EiBgEJ,wCAAA;ApBu7YN;AoBp7YE;EACE,oCAAA;ApBs7YJ;;AoBn7YA;EACE,qBAAA;EACA,4BAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,SAAA;EACA,iBAAA;EACA,gBjBxFqB;AH8gZvB;;AoBp7YA;EACE,qBAAA;EACA,4BAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,SAAA;EACA,iBAAA;EACA,gBjBlGqB;AHyhZvB;;AoBp7YA;EACE,qBAAA;EACA,4BAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,SAAA;EACA,iBAAA;EACA,gBjB7GqB;AHoiZvB;;AoBr7YA;EACE,qBAAA;EACA,4BAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,SAAA;EACA,iBAAA;EACA,gBjBvHqB;AH+iZvB;;AoBt7YA;EACE,qBAAA;EACA,4BAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,SAAA;EACA,iBAAA;EACA,gBjBjIqB;AH0jZvB;;AoBv7YA;EACE,aAAA;ApB07YF;;AoBv7YA;EACE,yBjBnHK;EiBoHL,sCAAA;ApB07YF;AoBz7YE;EACE,WjB3GI;AHsiZR;;AoBv7YC;EACC,mBAAA;ApB07YF;AoBv7YE;EACC,wBAAA;ApBy7YH;AoBr7YE;EACC,wBAAA;ApBu7YH;AoBh6YE;EAbE,yBjB1JM;AH0kZV;AoB/6YI;EACE,+BAAA;ApBi7YN;AoB96YM;EAIE,WjB5IA;AHyjZR;AoBt6YE;EAhBE,yBjBxJQ;AHilZZ;AoBx7YI;EACE,+BAAA;ApB07YN;AoBv7YM;EAIE,WjB5IA;AHkkZR;AoB56YE;EAnBE,yBjBlJM;AHolZV;AoBj8YI;EACE,+BAAA;ApBm8YN;AoBh8YM;EAIE,WjB5IA;AH2kZR;AoBl7YE;EAtBE,yBjBpJG;AH+lZP;AoB18YI;EACE,+BAAA;ApB48YN;AoBz8YM;EAIE,WjB5IA;AHolZR;AoBx7YE;EAzBE,yBjBtJM;AH0mZV;AoBn9YI;EACE,+BAAA;ApBq9YN;AoBl9YM;EAIE,WjB5IA;AH6lZR;AoB97YE;EA5BE,yBjBhJK;AH6mZT;AoB59YI;EACE,+BAAA;ApB89YN;AoB39YM;EAIE,WjB5IA;AHsmZR;;AoBh8YM;EAIE,kDAAA;EACA,cjBlME;AHkoZV;AoB17YM;EAIE,mDAAA;EACA,cjB3MI;AHooZZ;AoBn7YM;EAIE,mDAAA;EACA,cjBhNE;AHkoZV;AoB56YM;EAIE,oDAAA;EACA,cjB7ND;AHwoZP;AoBr6YM;EAIE,0DAAA;EACA,cjB1OE;AH8oZV;AoB95YM;EAIE,yDAAA;EACA,cjB/OC;AH4oZT;;AoB34YE;EACE,yCAAA;EAZA,mCAAA;UAAA,2BAAA;ApB25YJ;AoBz5YM;EAIE,WjB/OA;EiBgPA,oCAAA;ApBw5YR;AoBh5YE;EACE,yCAAA;EAhBA,mCAAA;UAAA,2BAAA;ApBm6YJ;AoBj6YM;EAIE,WjB/OA;EiBgPA,oCAAA;ApBg6YR;AoBp5YE;EACE,yCAAA;EApBA,mCAAA;UAAA,2BAAA;ApB26YJ;AoBz6YM;EAIE,WjB/OA;EiBgPA,oCAAA;ApBw6YR;AoBx5YE;EACE,wCAAA;EAxBA,mCAAA;UAAA,2BAAA;ApBm7YJ;AoBj7YM;EAIE,WjB/OA;EiBgPA,oCAAA;ApBg7YR;AoB55YE;EACE,wCAAA;EA5BA,mCAAA;UAAA,2BAAA;ApB27YJ;AoBz7YM;EAIE,WjB/OA;EiBgPA,oCAAA;ApBw7YR;AoBh6YE;EACE,8CAAA;EAhCA,mCAAA;UAAA,2BAAA;ApBm8YJ;AoBj8YM;EAIE,WjB/OA;EiBgPA,oCAAA;ApBg8YR;;AoBn6YA;EACE,SAAA;ApBs6YF;;AoBp6YA;EACE,gBAAA;EACA,cAAA;ApBu6YF;;AoBp6YA;EACE,gBAAA;ApBu6YF;;AoBp6YE;EACI,WAAA;EACA,YAAA;EACA,mBjBvKM;EiBwKN,yBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cjB5JK;AHmkZX;AoBt6YM;EACI,cjB9JC;AHskZX;AoBv6YU;EACI,cjBhKH;AHykZX;AoBp6YM;EACI,aAAA;ApBs6YV;AoBl6YU;EAGI,aAAA;EAGA,mBAAA;EhBzPX,YgB0PyC;EAC9B,kBAAA;EACA,cjBzFA;EiB0FA,mBAAA;ApBo6Yd;AoBn6Yc;EACI,iBAAA;ApBq6YlB;AoBn6Yc;EACI,mBjB1MN;EiB2MM,cjBhGJ;AHqgZd;;AoBh6YA;EACE,oCjBjWoB;AHowZtB;AoBj6YM;EACI,cjBnMC;AHsmZX;AoBj6YM;EACI,cjBtMC;AHymZX;;AoB95YA;EACE,yBjB/VO;EiBgWP,cjBpLW;AHqlZb;;AoB/5YA;EACE,yBjB9UM;AHgvZR;;AoB/5YE;EACI,mBAAA;ApBk6YN;;AoB/5YA;EACE,kBAAA;ApBk6YF;AoBj6YE;EACI,yBAAA;EACA,kBAAA;EACA,6DAAA;EACA,gBjBnWE;EiBoWF,gBjBrYe;EiBwYf,oBAAA;EAGA,mBAAA;EACA,gBAAA;EhB9SH,iBgB+SiC;ApBm6YpC;AoBl6YM;EACI,iBAAA;ApBo6YV;AoBl6YM;EACI,cjBjJI;AHqjZd;AoBl6YM;EACI,yBAAA;ApBo6YV;AoBl6YM;EACI,ejB7DK;EiB8DL,gBAAA;ApBo6YV;AoBj6YU;EhB3UR,yBgB4UgC;EhB7WhC,yBgB8W+B;EhB7W/B,iCgB6W+B;EhB5W/B,6BgB4W+B;ApBu6YjC;AoBj6YU;EAGI,aAAA;EAGA,mBAAA;EhB5UX,YgB6UyC;EAC9B,kBAAA;ApBm6Yd;AoBl6Yc;EACI,iBAAA;ApBo6YlB;AoBl6Yc;EACI,mBjB3RN;EiB4RM,cjBjLJ;AHqlZd;;AoB95YA;EACE,yBAAA;EACA,aAAA;EACA,8DjB1Gc;AH2gZhB;;AqBt2ZA;EACI,qBAAA;EAEA,WAAA;EjBoGD,gBiBnGyB;EjBoGzB,UiBpGkC;ArBy2ZrC;AqBx2ZI;EACI,qBAAA;EACA,WAAA;ArB02ZR;AqBz2ZQ;EACI,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBlBFW;EkBGX,0BAAA;EAGA,qBAAA;ArB22ZZ;AqB12ZY;EACI,kCAAA;ArB42ZhB;AqB12ZY;EACI,elBiVD;EkBhVC,mBAAA;EACA,cAAA;ArB42ZhB;;AqBv2ZA;EACI,mBAAA;ArB02ZJ;;AqBv2ZI;EACI,kBAAA;ArB02ZR;AqBx2ZI;EACI,YAAA;ArB02ZR;AqBz2ZQ;EACI,aAAA;ArB22ZZ;;AqBt2ZI;EACI,clBjBE;AH03ZV;AqBv2ZI;EACI,yBlB2HG;AH8uZX;AqBv2ZI;EACI,qBlBiHI;AHwvZZ;AqBr2ZY;EACI,elB6SD;EkB5SC,clBnCJ;EkBoCI,qBlB4GJ;AH2vZZ;;AqBj2ZI;;;EAGI,WlBvBA;EkBwBA,gBlBxDW;AH45ZnB;;AqBh2ZI;EACI,eAAA;EACA,YAAA;EACA,yBAAA;ArBm2ZR;AqBl2ZQ;EACI,gBAAA;ArBo2ZZ;;AsBj7ZA;EACI,cnByQS;AH2qZb;AsBn7ZI;EACI,YAAA;AtBq7ZR;AsBn7ZI;EACI,WAAA;AtBq7ZR;AsBp7ZQ;EACI,mBAAA;AtBs7ZZ;AsBp7ZQ;EACI,kBAAA;AtBs7ZZ;AsBj7ZY;EACI,oBAAA;EACA,mBAAA;AtBm7ZhB;AsBj7ZY;EACI,aAAA;AtBm7ZhB;AsBh7ZwB;EACI,QAAA;ElBiC1B,2BkBhC6C;ElBiC7C,mCkBjC6C;ElBkC7C,+BkBlC6C;AtBo7Z/C;AsB/6ZoB;EACI,kBAAA;AtBi7ZxB;AsB16ZQ;EACI,iBAAA;AtB46ZZ;AIv6ZI;EkBHI;IAEQ,aAAA;IACA,mBAAA;EtB46Zd;AACF;AI76ZI;EkBGI;IAEQ,mBAAA;EtB46Zd;AACF;AIl7ZI;EkBQY;IAEQ,eAAA;EtB46ZtB;AACF;AIv7ZI;EkBgBA;IAEQ,6BAAA;EtBy6ZV;AACF;AI57ZI;EkBgBA;IAKQ,yBAAA;EtB26ZV;AACF;AIj8ZI;EkBwBQ;IACI,aAAA;IACA,mBAAA;IACA,WAAA;EtB46Zd;AACF;AsBz6ZI;EACI,yBAAA;EACA,8DnB4QK;EC3NX,kBkBhDuB;AtB26ZzB;AsB16ZQ;EACI,enBuRG;EmBtRH,gBnBtEO;EmBuEP,gCAAA;ElBoBT,kBkBnBiC;ElBoBjC,mBkBpB6C;AtB66ZhD;AsB36ZQ;EACI,gBnB3EO;AHw/ZnB;AsB16ZY;EACI,WAAA;EACA,YAAA;EACA,WnBlDR;ECoFN,kBkBjC+B;AtB46ZjC;AsB36ZgB;EACI,qBnB4ET;EmB3ES,mBnB2ET;AHk2ZX;AsB16ZY;EACI,WAAA;AtB46ZhB;AsB16ZoB;EACI,enB8PT;AH8qZf;AsBr6ZgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cnBoJP;EmBnJO,enBnHH;EmBoHG,gBnB7GG;EC4FpB,iBkBkByC;ElBjBzC,iBkBiBoD;ElBMrD,kBkBLmC;EACjB,YAAA;AtBw6ZpB;AsBv6ZoB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;AtBy6ZxB;AsBv6ZoB;EACI,mBnBsCb;EmBrCa,WnB5FhB;AHqgaR;AsBp6ZQ;EACI,enBuNG;EmBtNH,gBnBpIS;EmBqIT,WAAA;EACA,YAAA;AtBs6ZZ;AsBp6ZQ;EACI,enBoNG;EmBnNH,gBnBzIW;EmB0IX,kBAAA;EACA,UAAA;AtBs6ZZ;AsBp6ZQ;EACI,WnB9GJ;EmB+GI,mBnBkBD;EC7CT,kBkB4B2B;EACjB,kBAAA;AtBs6ZZ;AsBr6ZY;ElB9DV,kBkB+DgC;ElB9DhC,MkB8DyC;ElB7DzC,QkB6D2C;AtBy6Z7C;AsBt6ZgB;EACI,WnBvHZ;AH+haR;AsBr6ZY;EACI,cnBsGJ;AHi0ZZ;AsBn6ZI;EACI,WAAA;ElB5CN,kBkB6CuB;AtBq6ZzB;AsBj6ZY;EACI,YAAA;EACA,YAAA;AtBm6ZhB;AsB15ZgB;EACI,YAAA;AtB45ZpB;AsBv5ZI;EACI,enBsKO;EmBrKP,gBnBxLe;AHilavB;AsBv5ZI;EACI,enBiKO;EmBhKP,gBnB5Le;AHqlavB;AsBx5ZQ;EACI,cnB7BD;AHu7ZX;AsBz5ZY;EACI,cnBvLN;AHklaV;AsBp5ZgB;ElBnFd,0BkBoFmC;AtBs5ZrC;AsBr5ZoB;EACI,WAAA;EACA,YAAA;ElBvFtB,mBkBwFuC;AtBu5ZzC;AsBt5ZwB;ElB7HtB,yBkB8H8C;AtB05ZhD;AsBr5ZoB;EACI,qBAAA;AtBu5ZxB;AsBj5ZI;ElBtGF,0BkBuGuB;EACjB,aAAA;EACA,gBnB7LA;EmB8LA,8DnBiHK;AHkyZb;AsBl5ZQ;EACI,cnB+BC;EmB9BD,enBwHG;AH4xZf;AsBj5ZI;EACI,yBAAA;EACA,8DnByGK;EC3NX,kBkBmHuB;EACjB,gBnBxMA;AH2laR;AsBl5ZQ;EACI,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;AtBo5ZZ;AsB/4ZQ;EACI,cnBnFD;EmBoFC,WAAA;EACA,YAAA;ElBtKV,yBkBuK8B;ElBnI9B,mBkBoI2B;EAGjB,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AtBm5ZZ;AsBl5ZY;EACI,mBnB1PN;AH8oaV;AsBn5ZgB;EACI,WnBrOZ;AH0naR;AsBh5ZI;EACI,enB8EO;EmB7EP,gBnB5Qe;EmB6Qf,gBAAA;AtBk5ZR;AsBj5ZQ;EACI,cnB9GD;EmB+GC,iBAAA;EACA,enBwEG;AH20Zf;AsBh5ZY;EACI,enBoED;EmBnEC,kBAAA;EACA,qBAAA;EACA,cnBzBH;AH26Zb;AsBj5ZgB;EACI,WAAA;ElBtMlB,kBkBuMoC;ElBtMpC,QkBsM6C;ElBnM7C,OkBmM2D;ElB5O3D,2BkB6OqC;ElB5OrC,mCkB4OqC;ElB3OrC,+BkB2OqC;EACnB,UAAA;EACA,WAAA;EACA,mBnB9HT;EC7CT,kBkB4KmC;AtBu5ZrC;AsBh5ZY;EACI,cnBzCH;EmB0CG,WAAA;AtBk5ZhB;AsB/4ZgB;EACI,cnBpSV;AHqraV;AsB34ZI;EACI,YAAA;EACA,iCAAA;AtB64ZR;AsB54ZQ;EACI,YAAA;EACA,gCAAA;EACA,gBAAA;AtB84ZZ;AsB74ZY;EACI,6BAAA;EACA,4BAAA;EACA,mBAAA;AtB+4ZhB;AsB74ZY;EACI,gBAAA;EACA,YAAA;EACA,enB2BD;EmB1BC,gBnBnUO;EmBoUP,cnBnKL;EmBoKK,UAAA;EACA,qBAAA;EACA,WAAA;AtB+4ZhB;AsB94ZgB;ElBxPd,yBkByPsC;EACpB,sBAAA;EACA,mBAAA;EACA,iCAAA;EACA,enBpVH;EmBqVG,gBnB7UD;EmB8UC,cnBhFP;EmBiFO,eAAA;EACA,WAAA;EACA,iBAAA;AtBk5ZpB;AsBh5ZgB;EACI,eAAA;AtBk5ZpB;AsBh5ZgB;EACI,UAAA;AtBk5ZpB;AsB/4ZoB;EACI,cnBnVd;AHouaV;AsB74ZY;EACI,YAAA;EACA,UAAA;AtB+4ZhB;AsB74ZoB;EACI,eAAA;EACA,WAAA;EACA,YAAA;AtB+4ZxB;AsB54ZgB;EACI,iBAAA;AtB84ZpB;AsBv4ZQ;EACI,8BAAA;AtBy4ZZ;AsBv4ZQ;EACI,qBAAA;EACA,mBAAA;EACA,oBAAA;EACA,0BAAA;EACA,2BAAA;EACA,8DnB5CC;EmB6CD,yBAAA;AtBy4ZZ;AsBv4ZQ;EACI,UAAA;EACA,UAAA;EACA,qBAAA;AtBy4ZZ;AsBx4ZY;EACI,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AtB04ZhB;AsBz4ZgB;EACI,kBAAA;EACA,WAAA;AtB24ZpB;AsB14ZoB;EACI,cnB5IX;AHwhab;AsB14ZoB;EACI,gBAAA;AtB44ZxB;AsB34ZwB;EACG,cnBvYjB;AHoxaV;AsBt4ZW;EACK,UAAA;AtBw4ZhB;AsBp4ZY;EACI,UAAA;AtBs4ZhB;AsBl4ZoB;EACI,cnBnKX;EmBoKW,WAAA;AtBo4ZxB;AsB93ZI;EACI,8DnB3FK;EmB4FL,YAAA;AtBg4ZR;AsB93ZY;EACI,gBAAA;ElB1Td,kBkB2T+B;EACjB,eAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AtBg4ZhB;AIvxaI;EkB2YQ;IAcQ,mBAAA;IACA,qBAAA;EtBk4ZlB;AACF;AsBj4ZgB;EACI,cnBhMP;EmBiMO,mBnB9LV;EmB+LU,qBnB/LV;AHkkaV;AsBj4ZgB;EACI,mBnBnST;EmBoSS,qBnBpST;EmBqSS,WnBtaZ;AHyyaR;AsB53ZoB;EACI,qBnBnTZ;AHiraZ;AsBx3ZoB;EACI,mBAAA;EACA,enB7dP;EmB8dO,gBnBxdH;EmBydG,mBAAA;EACA,qBnB9TZ;AHwraZ;AsBz3ZwB;EACI,enBleX;EmBmeW,gBnB7dP;AHw1arB;AsBz3ZgC;EACI,WAAA;EACA,YAAA;EACA,SAAA;AtB23ZpC;AsBl3ZI;EACI,enBlfS;AHs2ajB;;AsBj3ZA;EACI,aAAA;AtBo3ZJ;;AsBl3ZA;EACI,cnBnPS;AHwmab;;AsBn3ZA;EACI,kBAAA;EACA,YAAA;EACA,YAAA;AtBs3ZJ;AsBp3ZI;ElBraF,kBkBsawB;ElBraxB,QkBqaiC;ElBlajC,UkBka+C;ElB3c/C,2BkB4cyB;ElB3czB,mCkB2cyB;ElB1czB,+BkB0cyB;EACnB,YAAA;AtB03ZR;AsBx3ZI;EACI,kBAAA;AtB03ZR;;AsBv3ZA;EACI,mBnBldU;AH40ad;AsBz3ZI;EACI,mBnBpdM;AH+0ad;;AsBx3ZA;EACI,mBnBzUS;AHosab;AsB13ZI;EACI,mBnB3UK;AHusab;;AsBz3ZA;EACI,mBnBzVU;AHqtad;AsB33ZI;EACI,mBnB3VM;AHwtad;;AsB13ZA;ElBxbG,kBkBybyB;ElBxbzB,kBkBwbqC;EACpC,gCAAA;AtB83ZJ;;AsB53ZA;ElB5bG,kBkB6byB;ElB5bzB,mBkB4bqC;EACpC,gCAAA;AtBg4ZJ;;AsB73ZI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,SAAA;AtBg4ZR;AsB93ZS;EACG,oBAAA;AtBg4ZZ;AsB93ZQ;EACI,UAAA;AtBg4ZZ;AsB53ZQ;EACI,cnBhiBF;EmBiiBE,iBAAA;EACA,enBtNG;EmBuNH,gBnBjjBS;AH+6arB;AsB73ZY;EACI,cnBziBN;AHw6aV;AsB33ZI;EACE,cAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;AtB63ZN;;AsBz3ZA;EACE,YAAA;EACA,yBAAA;EACA,qBAAA;AtB43ZF;;AsBz3ZA;EACE;IAAqB,SAAA;IAAU,qBAAA;EtB83Z/B;AACF;AsB53ZA;EACE,UAAA;EACA,mBAAA;AtB83ZF;;AsB33ZA;EACI,mCAAA;EACA,4CAAA;AtB83ZJ;;AsB33ZA;EACE,eAAA;EACA,YAAA;ElBheA,4BkBieiB;AtB83ZnB;;AsB53ZA;EACI,kBAAA;EACA,mBnBzZS;EmB0ZT,YAAA;ElBteF,kBkBuemB;AtB+3ZrB;AsB93ZI;EACI,enBlQO;AHkoaf;AsB93ZI;EACI,gBnB/lBW;AH+9anB;;AsB73ZA;EACI,aAAA;AtBg4ZJ;AsB/3ZI;EACI,YAAA;EACA,aAAA;ElBnfN,mBkBofuB;EACjB,mBnB3kBA;EmB4kBA,cAAA;AtBi4ZR;;AsB93ZA;EACI,eAAA;AtBi4ZJ;;AsB/3ZA;EACI,YAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,MAAA;EACA,YAAA;EACA,gBnBvlBI;EmBwlBJ,eAAA;EACA,4BAAA;EACA,+BAAA;EACA,2FAAA;EACA,gBAAA;ElB5iBF,yBkB6iBsB;AtBo4ZxB;AI/9aI;EkB8kBJ;IAeQ,YAAA;IACA,aAAA;EtBs4ZN;AACF;AsBr4ZI;EACI,QAAA;ElBnjBN,yBkBojB0B;AtBy4Z5B;AsBr4ZY;EACI,cnBtnBP;AH6/aT;AsBn4ZI;EACI,gBnB7oBW;AHkhbnB;AsBn4ZI;EACI,enBnTO;AHwraf;AsBn4ZI;EACI,enBvTO;AH4raf;AsBn4ZI;EACK,enB5TM;EmB6TP,gBnBxpBe;AH6hbvB;AsBn4ZI;EACI,gCAAA;AtBq4ZR;AsBp4ZQ;EACI,iBAAA;EACA,enBlUG;EmBmUH,gBnB/pBW;ECoHrB,kBkB4iB2B;EACjB,YAAA;EACA,mBnBhaF;EmBiaE,cnBlgBD;AHw4aX;AsBr4ZY;EACI,mBnB5pBN;EmB6pBM,WnBtoBR;AH6gbR;AsB/3ZoB;EACI,kBAAA;AtBi4ZxB;AsB93ZwB;EACI,mBnBjblB;EmBkbkB,yBAAA;ElBhkB1B,kBkBikB2C;EACjB,YAAA;EACA,qBAAA;AtBg4Z5B;AsB/3Z4B;EACI,WAAA;EACA,YAAA;AtBi4ZhC;AsB73ZoB;EACI,gBAAA;AtB+3ZxB;AsBz3ZoB;EACI,oBAAA;EACA,iBAAA;EACA,kBAAA;AtB23ZxB;AsBx3ZwB;EACI,kBAAA;EACA,mBAAA;EACA,+BAAA;AtB03Z5B;AsBt3ZwB;EACI,eAAA;EACA,gBAAA;AtBw3Z5B;AsBr3ZoB;EACI,mBnB/sBd;EmBgtBc,WnBzrBhB;AHgjbR;AsBt3ZwB;EACI,mBnB1jBjB;AHk7aX;AsBj3ZI;EACI,cnBpeK;EmBqeL,enBzYO;AH4vaf;AsBj3ZI;EACI,gBnBtuBW;AHylbnB;AsBl3ZQ;EACI,cnBxkBD;AH47aX;;AsB/2ZA;EACI,yBAAA;AtBk3ZJ;;AsBh3ZA;EACI,WAAA;EACA,YAAA;ElB/nBF,mBkBgoBmB;AtBm3ZrB;;AsBj3ZA;EACI,yBAAA;AtBo3ZJ;;AsBl3ZA;EACI,yBAAA;AtBq3ZJ;;AsBn3ZA;EACI,cnB9fS;AHo3ab;;AsBn3ZI;EACI,WAAA;AtBs3ZR;;AsBh3ZQ;EACI,enB3aG;EmB4aH,gBnBxwBO;AH2nbnB;AsB/2ZQ;EACI,enBxaG;EmByaH,gBnB9wBO;EmB+wBP,cnB1mBD;EmB2mBC,mBAAA;EACA,yBnBhhBF;EC9IR,mBkB+pB2B;AtBi3Z7B;AsB92ZY;EACI,kBAAA;AtBg3ZhB;AsB72ZQ;EACI,gBAAA;AtB+2ZZ;AsBx2ZoB;EACI,kBAAA;AtB02ZxB;AsBn2ZI;EACI,iBAAA;EACA,enBjdO;EmBkdP,mBAAA;AtBq2ZR;AsBl2ZQ;EACI,gBAAA;AtBo2ZZ;AsBl2ZQ;EACI,YAAA;EACA,cAAA;AtBo2ZZ;AsBn2ZY;EACI,yBAAA;EACA,8DnBzeH;EC3NX,kBkBqsB+B;AtBq2ZjC;AsBn2ZY;EACI,enBjeD;AHs0af;AsBp2ZgB;EACI,oBAAA;AtBs2ZpB;AsBl2ZwB;EACI,iBAAA;AtBo2Z5B;AsBh2ZgB;EACI,eAAA;EACA,cnB9zBR;AHgqbZ;AsBh2ZgB;EACI,cnB7kBP;EmB8kBO,mBAAA;AtBk2ZpB;AsB/1ZY;EACI,enBtfD;EmBufC,yBnBhlBN;EC9IR,kBkB+tB+B;AtBi2ZjC;AsB91ZgB;EACI,WAAA;AtBg2ZpB;AsB/1ZoB;EACI,WAAA;AtBi2ZxB;AsBh2ZwB;EACI,WAAA;AtBk2Z5B;AsBz1ZY;EACI,kBAAA;EACA,aAAA;EACA,0BAAA;AtB21ZhB;AsB11ZgB;ElBpxBd,kBkBqxBoC;ElBpxBpC,MkBoxB6C;ElBnxB7C,QkBmxB+C;ElBjxB/C,OkBixBsD;EACpC,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;AtB+1ZpB;AsB51ZY;EACI,enBxhBD;EmByhBC,gBnBn3BK;EmBo3BL,cnBpnBH;AHk9ab;AsB51ZY;EACI,enB1hBD;EmB2hBC,gBnBv3BO;EmBw3BP,cnB72BJ;EmB82BI,gBAAA;AtB81ZhB;AsB51ZY;EACI,WAAA;ElBxwBd,kBkBywB+B;AtB81ZjC;AsB31ZgB;ElBpyBb,kBkBqyByC;ElBpyBzC,akBoyBqD;ElB7wBtD,kBkB8wBmC;EACjB,yBAAA;AtB81ZpB;AsB71ZoB;EACI,WAAA;AtB+1ZxB;AsB51ZwB;EACI,enB7iBb;EmB8iBa,gBnB14BL;EmB24BK,cnBh4BhB;AH8tbZ;AsB71Z4B;EACI,cnBh4BtB;AH+tbV;AsB31Z4B;EACI,cnBz4BtB;AHsubV;AsBz1ZoB;EACI,gBAAA;AtB21ZxB;AsBp1ZQ;EACI,eAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,uBAAA;EACA,YAAA;AtBs1ZZ;AsBp1ZQ;EACI,WAAA;ElBpzBV,kBkBqzB2B;AtBs1Z7B;;AsB/0ZY;EACI,WAAA;AtBk1ZhB;;AuB9wbA;EACI,UAAA;EAGE,aAAA;EAEA,eAAA;AvBixbN;AuBhxbM;EACE,cAAA;EACA,WAAA;EACA,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,epBoVO;ECzOb,mBmB1GuB;EACjB,yBAAA;EACA,cpBHE;ECmFP,WmB/E6B;EnBmH9B,wCAAA;AJkqbF;;AwB7ybA;EACI,yBrBqKQ;EqBpKR,eAAA;EACA,sBAAA;AxBgzbJ;;AwB9ybA;EACI,yBrBgKQ;AHipbZ;;AwB/ybA;EACI,WrBkCI;EqBjCJ,yBrBUM;AHwybV;;AwB/ybA;EACI;IACI,QAAA;ExBkzbN;AACF;AwBhzbA;EACI,kBAAA;EACA,uBAAA;AxBkzbJ;AwBjzbI;EACI,kBAAA;EACA,uBAAA;EACA,8BAAA;AxBmzbR;;AwB/ybI;EACI,iBAAA;AxBkzbR;AwBhzbI;EACI,cAAA;AxBkzbR;AwBhzbI;EACI,YAAA;AxBkzbR;AwBhzbI;EACI,eAAA;AxBkzbR;;AwB/ybA;EACI,iBAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AxBkzbJ;AwBhzbI;EACI,WAAA;AxBkzbR;AwB/ybI;EACI,WAAA;AxBizbR;AwB9ybI;EACI,WAAA;AxBgzbR;AwB7ybI;EACI,UAAA;AxB+ybR;AwB5ybI;EACI,UAAA;AxB8ybR;;AwB3ybA;EACI,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AxB8ybJ;AwB5ybI;EACI,WAAA;EACA,SAAA;EACA,kBAAA;AxB8ybR;AwB3ybI;EACI,WAAA;AxB6ybR;AwB1ybI;EACI,WAAA;AxB4ybR;AwBzybI;EACI,UAAA;AxB2ybR;AwBxybI;EACI,UAAA;AxB0ybR;;AwBvybA;EACI,iBAAA;EACA,kBAAA;AxB0ybJ;AwBzybI;EACI,kBAAA;EACA,iBAAA;AxB2ybR;AwB1ybQ;EACI,WAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,qDAAA;EACA,gBrBtEJ;EqBuEI,kBAAA;EACA,2BAAA;EACA,4BAAA;EACA,6BAAA;AxB4ybZ;AwB1ybQ;EACI,6BAAA;EACA,+DAAA;AxB4ybZ;AwB1ybQ;EACI,6BAAA;EACA,6DAAA;AxB4ybZ;AwB1ybQ;EACI,6BAAA;EACA,0DAAA;AxB4ybZ;AwB1ybQ;EACI,6BAAA;EACA,6DAAA;AxB4ybZ;AwB1ybQ;EACI,6BAAA;EACA,4DAAA;AxB4ybZ;AwBzybI;EACI,eAAA;EACA,eAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBrB7HE;EqB8HF,kDAAA;EACA,mBAAA;EACA,gBrBzIe;EqB0If,WrB1GA;EqB2GA,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,2BAAA;AxB2ybR;AwB1ybQ;EACI,WAAA;EACA,0CAAA;EACA,+CAAA;EACA,6CAAA;EACA,kBAAA;EACA,0BAAA;EACA,uBAAA;AxB4ybZ;AwB1ybQ;EACI,yBrB9IA;AH07bZ;AwB3ybY;EACI,0CAAA;AxB6ybhB;AwB1ybQ;EACI,yBrBlJF;AH87bV;AwB3ybY;EACI,0CAAA;AxB6ybhB;AwB1ybQ;EACI,yBrBpJF;AHg8bV;AwB3ybY;EACI,0CAAA;AxB6ybhB;AwB1ybQ;EACI,yBrBxJH;AHo8bT;AwB3ybY;EACI,0CAAA;AxB6ybhB;AwB1ybQ;EACI,yBrBlKL;AH88bP;AwB3ybY;EACI,0CAAA;AxB6ybhB;;AwBvybI;EACI,oCAAA;AxB0ybR;;AwBvybA;EACI,kBAAA;EACH,4BAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACG,yBrBtKI;AHg9bR;;AwBxybA;EACC,uBAAA;AxB2ybD;;AwBzybA;EACC,uBAAA;AxB4ybD;;AwB1ybA;EACC,uBAAA;AxB6ybD;;AwB3ybA;EACI,iBAAA;EACA,uBAAA;AxB8ybJ;AwB7ybI;EACI,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;AxB+ybR;AwB9ybQ;EACI,WAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,4BAAA;EACA,sBrB7LJ;EqB8LI,kBAAA;AxBgzbZ;AwB9ybQ;EACI,8BAAA;EACA,aAAA;EACA,gBAAA;EACA,qBAAA;EACA,uBAAA;EACA,gBrBtMJ;EqBuMI,mBAAA;EACA,gBrBxOW;EqByOX,crBhOF;EqBiOE,kBAAA;EACA,kBAAA;EACA,2BAAA;AxBgzbZ;AwB/ybY;EACI,8BAAA;EACA,crBpOJ;AHqhcZ;AwB/ybY;EACI,8BAAA;EACA,crBlON;AHmhcV;AwB/ybY;EACI,8BAAA;EACA,crBxOT;AHyhcP;AwB/ybY;EACI,8BAAA;EACA,crB9ON;AH+hcV;AwB/ybY;EACI,8BAAA;EACA,crB5OP;AH6hcT;;AwB3ybI;EACI,uCAAA;EACA,sBAAA;AxB8ybR;AwB7ybQ;EACI,wCAAA;AxB+ybZ;AwB9ybY;EACI,crBhQJ;AHgjcZ;AwB7ybQ;EACI,wCAAA;AxB+ybZ;AwB9ybY;EACI,crBhQN;AHgjcV;AwB7ybQ;EACI,yCAAA;AxB+ybZ;AwB9ybY;EACI,crBxQT;AHwjcP;AwB7ybQ;EACI,wCAAA;AxB+ybZ;AwB9ybY;EACI,crBhRN;AHgkcV;AwB7ybQ;EACI,uCAAA;AxB+ybZ;AwB9ybY;EACI,crBhRP;AHgkcT;AwB7ybQ;EACI,sBAAA;AxB+ybZ;AwB7ybQ;EACI,kBAAA;EACA,0BAAA;EACA,gBrB5SW;EqB6SX,mBAAA;EACA,crBrSF;AHolcV;;AyBxmcA;EACI,ctByQS;EsBxQT,sBtByCI;EsBxCJ,yBAAA;AzB2mcJ;AyB1mcI;EACI,gBAAA;EACA,yBtBmCA;AHykcR;AyB1mcI;EACI,ctBWE;EsBVF,yBtB+BA;EsB9BA,qBtB2JI;AHi9bZ;;AyBzmcA;EACI,WtB4BI;EsB3BJ,yBtBIM;EsBHN,qBtBGM;AHymcV;;AyB1mcA;EACI,ctBsPS;EsBrPT,sBtBsBI;EsBrBJ,qBtBgJQ;EsB/IR,YAAA;AzB6mcJ;;AyBvmcY;EACI,gBAAA;AzB0mchB;AyBxmcY;EACI,gBAAA;AzB0mchB;AyBxmcY;EACI,gBAAA;AzB0mchB;AyBxmcY;EACI,gBAAA;AzB0mchB;;AyBpmcI;EACI,iBAAA;AzBumcR;AyBtmcQ;EACI,SAAA;EACA,kBtBgSI;EsB/RJ,oBAAA;AzBwmcZ;AyBvmcY;EACI,gBtBzCO;AHkpcvB;AyBrmcY;EACI,kBtBwRA;EsBvRA,yBtBtCN;EsBuCM,WtBhBR;AHuncR;AyBpmcgB;EACI,kBtBkRJ;EsBjRI,yBtB5CV;EsB6CU,WtBtBZ;AH4ncR;AyBjmcY;EACI,yBtB9BR;EsB+BQ,ctBpDN;AHupcV;;AyB9lcA;EACI,kBtBmQY;AH81bhB;AyBhmcI;EACI,iBAAA;AzBkmcR;AyBjmcQ;EACI,oBAAA;EACA,oBAAA;AzBmmcZ;AyBhmcY;EACI,sBtB5CR;EsB6CQ,ctBpEN;EsBqEM,kBAAA;EACA,iBAAA;AzBkmchB;AyBjmcgB;EACI,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;EACA,yBtB9EV;AHircV;AyB9lcY;EACI,6BAAA;AzBgmchB;;AyB3lcA;EACI,mBAAA;EACA,gBAAA;EACA,mBAAA;AzB8lcJ;AyB7lcI;EACI,iBAAA;AzB+lcR;AyB9lcQ;EACI,SAAA;EACA,mBAAA;EACA,oBAAA;AzBgmcZ;AyB/lcY;EACI,gBtB7GO;AH8scvB;AyB7lcY;EACI,yBtBzGN;EsB0GM,WtBnFR;AHkrcR;AyB5lcgB;EACI,yBtB9GV;AH4scV;AyBzlcY;EACI,yBtB/FR;AH0rcR;;AyBplcQ;EACI,oBAAA;EACA,oBAAA;EACA,kBtB+LI;AHw5bhB;AyBtlcY;EACI,gBtBzIO;AHiucvB;AyBplcY;EACI,SAAA;EACA,kBtBuLA;EsBtLA,yBtBvIN;EsBwIM,WtBjHR;AHuscR;AyBnlcgB;EACI,yBtB5IV;AHiucV;AyBhlcY;EACI,6BAAA;AzBklchB;;A0BxvcA;;;;;;;;;;;;EAYE,cvB+PY;EuB9PZ,oCvBGoB;EuBFpB,gBvBFiB;EuBGjB,gBAAA;A1B2vcF;;A0BzvcA;;EAEE,eAAA;A1B4vcF;;A0B1vcA;;EAEE,kBAAA;A1B6vcF;;A0B3vcA;;EAEE,iBAAA;A1B8vcF;;A0B5vcA;;EAEE,mBAAA;A1B+vcF;;A0B7vcA;;EAEE,eAAA;A1BgwcF;;A0B9vcA;;EAEE,mBAAA;A1BiwcF;;A0B/vcA;EACE,oBAAA;A1BkwcF;;A0BhwcA;EACE,mBAAA;A1BmwcF;;A0BjwcA;EACE,mBAAA;A1BowcF;;A0BhwcA;EACE,oBAAA;A1BmwcF;;A0BjwcA;EACE,mBAAA;A1BowcF;;A0BlwcA;EACE,oBAAA;A1BqwcF;;A0BnwcA;EACE,kBAAA;A1BswcF;;A0BpwcA;EACE,oBAAA;A1BuwcF;;A0BrwcA;EACE,mBAAA;A1BwwcF;;A0BtwcA;EACE,oBAAA;A1BywcF;;A0BvwcA;EACE,iBAAA;A1B0wcF;;A0BxwcA;EACE,oBAAA;A1B2wcF;;A0BzwcA;EACE,mBAAA;A1B4wcF;;A0B1wcA;EACE,oBAAA;A1B6wcF;;A0B3wcA;EACE,kBAAA;A1B8wcF;;A0B5wcA;EACE,oBAAA;A1B+wcF;;A0B7wcA;EACE,mBAAA;A1BgxcF;;A0B9wcA;EACE,oBAAA;A1BixcF;;A0B/wcA;EACE,eAAA;A1BkxcF;;A0BhxcA;EACE,oBAAA;A1BmxcF;;A0BjxcA;EACE,mBAAA;A1BoxcF;;A0BlxcA;EACE,oBAAA;A1BqxcF;;A0BnxcA;EACE,kBAAA;A1BsxcF;;A0BpxcA;EACE,oBAAA;A1BuxcF;;A0BrxcA;EACE,mBAAA;A1BwxcF;;A0BtxcA;EACE,oBAAA;A1ByxcF;;A0BvxcA;EACE,iBAAA;A1B0xcF;;A0BxxcA;EACE,oBAAA;A1B2xcF;;A0BzxcA;EACE,mBAAA;A1B4xcF;;A0B1xcA;EACE,oBAAA;A1B6xcF;;A0B3xcA;EACE,kBAAA;A1B8xcF;AIv3cI;EsBwFJ;IAGI,kBAAA;E1BgycF;AACF;;A0B9xcA;EACE,oBAAA;A1BiycF;;A0B9xcA;EACE,mBAAA;A1BiycF;;A0B/xcA;EACE,eAAA;A1BkycF;;A0BhycA;EACE,mBAAA;A1BmycF;;A0BjycA;EACE,kBAAA;A1BoycF;;A0BlycA;EACE,mBAAA;A1BqycF;;A0BnycA;EACE,iBAAA;A1BsycF;;A0BpycA;EACE,kBAAA;A1BuycF;AI55cI;EsBoHJ;IAGI,mBAAA;E1ByycF;AACF;AIj6cI;EsBoHJ;IAMI,mBAAA;E1B2ycF;AACF;;A0BzycA;EACE,yBAAA;A1B4ycF;;A0B1ycA;EACE,yBAAA;A1B6ycF;;A0B3ycA;EACE,yBAAA;EACA,UAAA;A1B8ycF;A0B7ycE;EACE,wCAAA;A1B+ycJ;A0B7ycE;EACE,wCAAA;A1B+ycJ;A0B7ycE;EACE,uCAAA;A1B+ycJ;;A0B5ycA;EACE,yBAAA;EACA,UAAA;A1B+ycF;;A0B7ycA;EACE,yBAAA;EACA,UAAA;A1BgzcF;;A0B9ycA;EACE,yBAAA;EACA,UAAA;A1BizcF;;A0B/ycA;EACE,yBAAA;EACA,UAAA;A1BkzcF;;A0BhzcA;EACE,yBAAA;EACA,UAAA;A1BmzcF;;A0BjzcA;EACE,yBAAA;A1BozcF;;A0BlzcA;EACE,yBAAA;A1BqzcF;;A0BnzcA;EACE,yBAAA;A1BszcF;;A0BpzcA;EACE,yBAAA;A1BuzcF;;A0BrzcA;EACE,yBAAA;A1BwzcF;;A0BtzcA;EACE,yBAAA;A1ByzcF;;A0BvzcA;EACE,yBAAA;A1B0zcF;;A0BxzcA;EACE,yBAAA;A1B2zcF;;A0BzzcA;EACE,yBAAA;A1B4zcF;;A0B1zcA;EACE,yBAAA;A1B6zcF;;A0B3zcA;EACE,sBAAA;A1B8zcF;;A0B5zcA;EACE,sBAAA;A1B+zcF;;A0B7zcA;EACE,sBAAA;A1Bg0cF;;A0B9zcA;EACE,sBAAA;A1Bi0cF;;A0B/zcA;EACE,cvBnFS;AHq5cX;;A0Bh0cA;EACE,cvBrFS;AHw5cX;;A0Bj0cA;EACE,cvBvFS;AH25cX;;A0Bl0cA;EACE,cvBzFS;AH85cX;;A0Bn0cA;EACE,cvB3FS;AHi6cX;;A0Bp0cA;EACE,cvB7FS;AHo6cX;;A0Br0cA;EACE,cvB/FS;AHu6cX;;A0Bt0cA;EACE,cvBjGS;AH06cX;;A0Bv0cA;EACE,cvBnGS;AH66cX;;A0Bx0cA;EACE,cvBtGS;EuBuGT,eAAA;EACA,qBAAA;EtB9LA,yBsB+LoB;A1B60ctB;A0B50cE;EACE,cvBxQM;ECuER,yBsBkMsB;A1Bg1cxB;A0B90cE;EACE,UAAA;A1Bg1cJ;;A0B70cA;EACE,yBAAA;A1Bg1cF;A0B/0cE;EAGE,yBAAA;A1B+0cJ;;A0B50cA;EACE,yBAAA;A1B+0cF;A0B90cE;EAGE,yBAAA;A1B80cJ;;A0B30cA;EACE,yBAAA;A1B80cF;A0B70cE;EAGE,yBAAA;A1B60cJ;;A0B10cA;EACE,yBAAA;A1B60cF;A0B50cE;EAGE,yBAAA;A1B40cJ;;A0Bz0cA;EACE,yBAAA;A1B40cF;A0B30cE;EAGE,yBAAA;A1B20cJ;;A0Bx0cA;EACE,yBAAA;A1B20cF;A0B10cE;EAGE,yBAAA;A1B00cJ;;A0Bv0cA;EACE,yBAAA;A1B00cF;A0Bz0cE;EAGE,yBAAA;A1By0cJ;;A0Bt0cA;EACE,yBAAA;A1By0cF;A0Bx0cE;EAGE,yBAAA;A1Bw0cJ;;A0Bp0cE;EACE,gCAAA;A1Bu0cJ;;A0Bn0cA;EACE,yBAAA;A1Bs0cF;;A0Bp0cA;EACE,gBAAA;EACA,8BAAA;EACA,kBAAA;A1Bu0cF;A0Bt0cE;EACE,+BAAA;EACA,cAAA;A1Bw0cJ;;A0Br0cA;EACE,kBAAA;EACA,gBvB5WqB;EuB6WrB,aAAA;EACA,kBvBxCc;EuByCd,kBAAA;A1Bw0cF;A0Bv0cE;EACE,gBAAA;EACA,0BvB5WW;EuB6WX,UAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,0BAAA;A1By0cJ;A0Bv0cE;EACE,uCAAA;EACA,sCAAA;A1By0cJ;A0Bx0cI;EACE,4BAAA;A1B00cN;A0Bv0cE;EACE,wCAAA;EACA,sCAAA;A1By0cJ;A0Bx0cI;EACE,6BAAA;A1B00cN;A0Bv0cE;EACE,yCAAA;EACA,sCAAA;A1By0cJ;A0Bx0cI;EACE,8BAAA;A1B00cN;A0Bv0cE;EACE,wCAAA;EACA,sCAAA;A1By0cJ;A0Bx0cI;EACE,6BAAA;A1B00cN;A0Bv0cE;EACE,wCAAA;EACA,sCAAA;A1By0cJ;A0Bx0cI;EACE,6BAAA;A1B00cN;A0Bv0cE;EACE,uCAAA;EACA,sCAAA;A1By0cJ;A0Bx0cI;EACE,4BAAA;A1B00cN;;A0Bp0cE;EACE,+DAAA;A1Bu0cJ;A0Br0cE;EACE,0DAAA;A1Bu0cJ;A0Br0cE;EACE,wDAAA;A1Bu0cJ;;A0Bn0cA;EACE;IACE,WAAA;E1Bs0cF;AACF;A0Bl0cE;EACE,gCAAA;EACA,iCAAA;A1Bo0cJ;;A0Bj0cA;EACE,0BAAA;A1Bo0cF;;A0Bl0cA;EACE,UAAA;A1Bq0cF;;A0Bn0cA;EACE,WAAA;A1Bs0cF;;A0Bp0cA;EACI,kBAAA;EACA,kBAAA;A1Bu0cJ;;A2B1xdA;EACE,yBAAA;EACA,kBxB+Uc;EwB9Ud,oBAAA;A3B6xdF;A2B5xdE;EACE,0CAAA;A3B8xdJ;A2B5xdE;EACE,exBiWW;AH67cf;A2B5xdE;EACE,sBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A3B8xdJ;A2B7xdI;EACE,exBuVS;EwBtVT,iBAAA;A3B+xdN;A2B5xdE;EACE,gBAAA;A3B8xdJ;A2B5xdE;EACE,gBxBdmB;AH4ydvB;;A2B1xdE;EACE,0CAAA;A3B6xdJ;;A2BlxdA;EACE,wCAAA;EACA,cxBfQ;EwBgBR,oCAAA;A3BqxdF;A2BpxdE;EACE,cxBlBM;AHwydV;A2BpxdE;EACE,cxBrBM;AH2ydV;A2BrxdI;EAhBF,yBxBNQ;EwBOR,WxBQM;EwBPN,UAAA;EACA,mBAAA;EACA,8DxBoTW;EwBnTX,gBAAA;A3BwydF;;A2BxxdA;EACE,uCAAA;EACA,cxBrCQ;EwBsCR,mCAAA;A3B2xdF;A2B1xdE;EACE,cxBxCM;AHo0dV;A2B1xdE;EACD,cxB3CS;AHu0dV;A2B1xdE;EACE,cxB9CM;AH00dV;A2B3xdI;EAjCF,yBxBdQ;EwBeR,WxBQM;EwBPN,UAAA;EACA,mBAAA;EACA,8DxBoTW;EwBnTX,gBAAA;A3B+zdF;;A2B9xdA;EACE,wCAAA;EACA,cxBpDU;EwBqDV,oCAAA;A3BiydF;A2BhydE;EACE,cxBvDQ;AHy1dZ;A2BhydE;EACE,cxB1DQ;AH41dZ;A2BjydI;EA/CF,yBxBZU;EwBaV,WxBQM;EwBPN,UAAA;EACA,mBAAA;EACA,8DxBoTW;EwBnTX,gBAAA;A3Bm1dF;;A2BpydA;EACE,wCAAA;EACA,cxBhEQ;EwBiER,oCAAA;A3BuydF;A2BtydE;EACE,cxBnEM;AH22dV;A2BtydE;EACE,cxBtEM;AH82dV;A2BvydI;EA7DF,yBxBVQ;EwBWR,WxBQM;EwBPN,UAAA;EACA,mBAAA;EACA,8DxBoTW;EwBnTX,gBAAA;A3Bu2dF;;A2B1ydA;EACE,yCAAA;EACA,cxB5EK;EwB6EL,qCAAA;A3B6ydF;A2B5ydE;EACE,cxB/EG;AH63dP;A2B5ydE;EACE,cxBlFG;AHg4dP;A2B7ydI;EA3EF,yBxBRK;EwBSL,WxBQM;EwBPN,UAAA;EACA,mBAAA;EACA,8DxBoTW;EwBnTX,gBAAA;A3B23dF;;A2BhzdA;EACE,uCAAA;EACA,cxBtFO;EwBuFP,mCAAA;A3BmzdF;A2BlzdE;EACE,cxBzFK;AH64dT;A2BlzdE;EACE,cxB5FK;AHg5dT;A2BnzdI;EAzFF,yBxBJO;EwBKP,WxBQM;EwBPN,UAAA;EACA,mBAAA;EACA,8DxBoTW;EwBnTX,gBAAA;A3B+4dF;;A2BtzdA;EACE,yBxBxFM;EwByFN,cxBwIW;EwBvIX,qBxB1FM;AHm5dR;A2BxzdE;EACE,cxBqIS;AHqrdb;A2BxzdE;EACE,cxBkIS;AHwrdb;A2BzzdI;EAvGF,yBxBOM;EwBNN,WxBQM;EwBPN,UAAA;EACA,mBAAA;EACA,8DxBoTW;EwBnTX,gBAAA;A3Bm6dF;;A2B5zdA;EACE,uCAAA;EACA,cxB0HW;EwBzHX,mCAAA;A3B+zdF;A2B9zdE;EACE,cxBuHS;AHysdb;A2B9zdE;EACE,WxB3GI;AH26dR;A2B/zdI;EArHF,yBxBFK;EwBGL,WxBQM;EwBPN,UAAA;EACA,mBAAA;EACA,8DxBoTW;EwBnTX,gBAAA;A3Bu7dF;;A2B1zdA;EAPE,yBxBzIQ;EwB0IR,WxBnHM;EwBoHN,qBxB3IQ;AHg9dV;A2Bp0dE;EACE,WxBtHI;AH47dR;;A2Bh0dA;EAVE,yBxBvIU;EwBwIV,WxBnHM;EwBoHN,qBxBzIU;AHu9dZ;A2B70dE;EACE,WxBtHI;AHq8dR;;A2Bt0dA;EAbE,yBxBjIQ;EwBkIR,WxBnHM;EwBoHN,qBxBnIQ;AH09dV;A2Bt1dE;EACE,WxBtHI;AH88dR;;A2B50dA;EAhBE,yBxBnIK;EwBoIL,WxBnHM;EwBoHN,qBxBrIK;AHq+dP;A2B/1dE;EACE,WxBtHI;AHu9dR;;A2Bl1dA;EAnBE,yBxBrIQ;EwBsIR,WxBnHM;EwBoHN,qBxBvIQ;AHg/dV;A2Bx2dE;EACE,WxBtHI;AHg+dR;;A2Bx1dA;EAtBE,yBxB/HO;EwBgIP,WxBnHM;EwBoHN,qBxBjIO;AHm/dT;A2Bj3dE;EACE,WxBtHI;AHy+dR;;A2B91dA;EACE,yBxB9IM;EwB+IN,cxBkFW;EwBjFX,qBxBnBU;AHo3dZ;;A2B/1dA;EA9BE,yBxB7HK;EwB8HL,WxBnHM;EwBoHN,qBxB/HK;AHggeP;A2Bh4dE;EACE,WxBtHI;AHw/dR;;A2B71dA;EAPE,sBxBpJM;EwBqJN,cxB5KQ;EwB6KR,qBxB7KQ;AHqheV;A2Bv2dE;EACE,cxB/KM;AHwheV;;A2Bn2dA;EAVE,sBxBpJM;EwBqJN,cxB1KU;EwB2KV,qBxB3KU;AH4heZ;A2Bh3dE;EACE,cxB7KQ;AH+heZ;;A2Bz2dA;EAbE,sBxBpJM;EwBqJN,cxBtKK;EwBuKL,qBxBvKK;AHiieP;A2Bz3dE;EACE,cxBzKG;AHoieP;;A2B/2dA;EAhBE,sBxBpJM;EwBqJN,cxBpKQ;EwBqKR,qBxBrKQ;AHwieV;A2Bl4dE;EACE,cxBvKM;AH2ieV;;A2Br3dA;EAnBE,sBxBpJM;EwBqJN,cxBxKQ;EwByKR,qBxBzKQ;AHqjeV;A2B34dE;EACE,cxB3KM;AHwjeV;;A2B33dA;EAtBE,sBxBpJM;EwBqJN,cxBlKO;EwBmKP,qBxBnKO;AHwjeT;A2Bp5dE;EACE,cxBrKK;AH2jeT;;A2Bj4dA;EACE,sBxB9KM;EwB+KN,cxBgDW;EwB/CX,qBxBlLM;AHsjeR;;A2Bl4dA;EA9BE,sBxBpJM;EwBqJN,cxBhKK;EwBiKL,qBxBjKK;AHqkeP;A2Bn6dE;EACE,cxBnKG;AHwkeP;;A2B93dA;EATE,sDAAA;EACA,cxB6CW;EwB5CX,sBxBxLM;EwByLN,yBAAA;EACA,mBAAA;A3B24dF;A2B14dE;EACE,cxBmCS;AHy2db;A2Bv4dE;EACD,cxBzNS;AHkmeV;;A2Bt4dA;EAfE,sDAAA;EACA,cxB6CW;EwB5CX,sBxBxLM;EwByLN,yBAAA;EACA,mBAAA;A3By5dF;A2Bx5dE;EACE,cxBmCS;AHu3db;A2B/4dE;EACD,cxB7NW;AH8meZ;;A2B94dA;EArBE,sDAAA;EACA,cxB6CW;EwB5CX,sBxBxLM;EwByLN,yBAAA;EACA,mBAAA;A3Bu6dF;A2Bt6dE;EACE,cxBmCS;AHq4db;A2Bv5dE;EACD,cxB7NS;AHsneV;;A2Bt5dA;EA3BE,sDAAA;EACA,cxB6CW;EwB5CX,sBxBxLM;EwByLN,yBAAA;EACA,mBAAA;A3Bq7dF;A2Bp7dE;EACE,cxBmCS;AHm5db;A2B/5dE;EACD,cxBjOQ;AHkoeT;;A2B95dA;EAjCE,sDAAA;EACA,cxB6CW;EwB5CX,sBxBxLM;EwByLN,yBAAA;EACA,mBAAA;A3Bm8dF;A2Bl8dE;EACE,cxBmCS;AHi6db;;A2Bt6dA;EApCE,sDAAA;EACA,cxB6CW;EwB5CX,sBxBxLM;EwByLN,yBAAA;EACA,mBAAA;A3B88dF;A2B78dE;EACE,cxBmCS;AH46db;;A2B96dA;EAvCE,sDAAA;EACA,cxB6CW;EwB5CX,sBxBxLM;EwByLN,yBAAA;EACA,mBAAA;A3By9dF;A2Bx9dE;EACE,cxBmCS;AHu7db;;A2Bt7dA;EA1CE,sDAAA;EACA,cxB6CW;EwB5CX,sBxBxLM;EwByLN,yBAAA;EACA,mBAAA;A3Bo+dF;A2Bn+dE;EACE,cxBmCS;AHk8db;;A2B97dA;EACE,mBAAA;EACA,sBxBrOM;EwBsON,SAAA;EACA,gBAAA;EACA,cxBTW;AH08db;A2Bh8dE;EACE,wBAAA;EACA,cxBPS;EwBQT,iBAAA;A3Bk8dJ;A2Bh8dE;EACD,exBwFc;EwBvFX,sBAAA;A3Bk8dJ;A2Bj8dC;EACC,exBqFa;AH82df;A2Bh8dE;EACE,UAAA;EACA,sBAAA;A3Bk8dJ;A2Bh8dE;EACE,0CAAA;A3Bk8dJ;A2Bj8dC;EACC,cxBnRQ;AHsteV;A2Bh8dE;EACE,0CAAA;A3Bk8dJ;A2Bj8dC;EACC,cxBvRU;AH0teZ;A2Bh8dE;EACE,0CAAA;A3Bk8dJ;A2Bj8dC;EACC,cxBvRQ;AH0teV;A2Bh8dE;EACE,0CAAA;A3Bk8dJ;A2Bj8dC;EACC,cxB3RO;AH8teT;;A2B/7dA;EACE,aAAA;EACA,mBAAA;A3Bk8dF;A2Bj8dE;EACE,oCAAA;A3Bm8dJ;;A2Bh8dA;EACE;IACE,qBAAA;E3Bm8dF;AACF;A2Bj8dA;EACI,UAAA;A3Bm8dJ;;A2Bj8dA;EACI,UAAA;A3Bo8dJ;;A2Bl8dA;EACI,YAAA;A3Bq8dJ;;A2Bn8dA;EACI,YAAA;A3Bs8dJ;;A2Bp8dA;EACI,YAAA;A3Bu8dJ;;A2Br8dA;EACI,YAAA;A3Bw8dJ;;A2Bt8dA;EACI,YAAA;A3By8dJ;;A2Bv8dA;EACI,YAAA;A3B08dJ;;A2Bx8dA;EACI,YAAA;A3B28dJ;;A2Bz8dA;EACI,YAAA;A3B48dJ;;A2B18dA;EACI,YAAA;A3B68dJ;;A4BrzeA;EACE,+BAAA;EACA,kCAAA;EACA,+BAAA;EACA,+BAAA;EACA,iCAAA;EACA,mCAAA;A5BwzeF;;A4BtzeA;EACE,sBzBkCM;EyBjCN,yBAAA;EACA,8DzB+UW;EyB9UX,iBAAA;EACA,kBzBoUc;EyBnUd,YAAA;A5ByzeF;A4BxzeE;EACE,sBzB2BI;EyB1BJ,mCAAA;A5B0zeJ;A4BxzeE;EACE,czBsPS;AHokeb;A4BxzeE;EACE,qBAAA;A5B0zeJ;;A4BvzeA;;;;EAIE,yBzBWM;AH+yeR;;A4BxzeA;;;;EAIE,2BzBKM;AHszeR;;A4BzzeA;;;;EAIE,0BzBDM;AH6zeR;;A4B1zeA;;;;;;EAME,4BzBTM;AHs0eR;;A4BzzeE;EACE,yBzBnCM;EyBoCN,WzBbI;AHy0eR;A4B1zeE;EAEE,4BzBxCM;AHm2eV;;A4Bj0eE;EACE,yBzBjCQ;EyBkCR,WzBbI;AHi1eR;A4Bl0eE;EAEE,4BzBtCQ;AHy2eZ;;A4Bz0eE;EACE,yBzB3BM;EyB4BN,WzBbI;AHy1eR;A4B10eE;EAEE,4BzBhCM;AH22eV;;A4Bj1eE;EACE,yBzB7BG;EyB8BH,WzBbI;AHi2eR;A4Bl1eE;EAEE,4BzBlCG;AHq3eP;;A4Bz1eE;EACE,yBzB/BM;EyBgCN,WzBbI;AHy2eR;A4B11eE;EAEE,4BzBpCM;AH+3eV;;A4Bj2eE;EACE,yBzBzBK;EyB0BL,WzBbI;AHi3eR;A4Bl2eE;EAEE,4BzB9BK;AHi4eT;;A4B70eE;EACI,yBAAA;A5Bg1eN;A4B/0eI;EACE,yBzBjEI;EyBkEJ,oDAAA;EACA,WzB5CE;EyB6CF,gCAAA;A5Bi1eN;A4B/0eI;EACE,yBzBvEI;EyBwEJ,WzBjDE;EyBkDF,gCAAA;A5Bi1eN;A4B90eE;EAIE,yBzBhFM;AH65eV;A4B30eE;EAIE,2BzBtFM;AHg6eV;A4Bx0eE;EAIE,0BzB5FM;AHm6eV;A4Br0eE;EAME,4BzBpGM;AHs6eV;;A4Bx2eE;EACI,yBAAA;A5B22eN;A4B12eI;EACE,yBzB/DM;EyBgEN,oDAAA;EACA,WzB5CE;EyB6CF,gCAAA;A5B42eN;A4B12eI;EACE,yBzBrEM;EyBsEN,WzBjDE;EyBkDF,gCAAA;A5B42eN;A4Bz2eE;EAIE,yBzB9EQ;AHs7eZ;A4Bt2eE;EAIE,2BzBpFQ;AHy7eZ;A4Bn2eE;EAIE,0BzB1FQ;AH47eZ;A4Bh2eE;EAME,4BzBlGQ;AH+7eZ;;A4Bn4eE;EACI,yBAAA;A5Bs4eN;A4Br4eI;EACE,yBzBzDI;EyB0DJ,oDAAA;EACA,WzB5CE;EyB6CF,gCAAA;A5Bu4eN;A4Br4eI;EACE,yBzB/DI;EyBgEJ,WzBjDE;EyBkDF,gCAAA;A5Bu4eN;A4Bp4eE;EAIE,yBzBxEM;AH28eV;A4Bj4eE;EAIE,2BzB9EM;AH88eV;A4B93eE;EAIE,0BzBpFM;AHi9eV;A4B33eE;EAME,4BzB5FM;AHo9eV;;A4B95eE;EACI,yBAAA;A5Bi6eN;A4Bh6eI;EACE,yBzB3DC;EyB4DD,oDAAA;EACA,WzB5CE;EyB6CF,gCAAA;A5Bk6eN;A4Bh6eI;EACE,yBzBjEC;EyBkED,WzBjDE;EyBkDF,gCAAA;A5Bk6eN;A4B/5eE;EAIE,yBzB1EG;AHw+eP;A4B55eE;EAIE,2BzBhFG;AH2+eP;A4Bz5eE;EAIE,0BzBtFG;AH8+eP;A4Bt5eE;EAME,4BzB9FG;AHi/eP;;A4Bz7eE;EACI,yBAAA;A5B47eN;A4B37eI;EACE,yBzB7DI;EyB8DJ,oDAAA;EACA,WzB5CE;EyB6CF,gCAAA;A5B67eN;A4B37eI;EACE,yBzBnEI;EyBoEJ,WzBjDE;EyBkDF,gCAAA;A5B67eN;A4B17eE;EAIE,yBzB5EM;AHqgfV;A4Bv7eE;EAIE,2BzBlFM;AHwgfV;A4Bp7eE;EAIE,0BzBxFM;AH2gfV;A4Bj7eE;EAME,4BzBhGM;AH8gfV;;A4Bp9eE;EACI,yBAAA;A5Bu9eN;A4Bt9eI;EACE,yBzBvDG;EyBwDH,oDAAA;EACA,WzB5CE;EyB6CF,gCAAA;A5Bw9eN;A4Bt9eI;EACE,yBzB7DG;EyB8DH,WzBjDE;EyBkDF,gCAAA;A5Bw9eN;A4Br9eE;EAIE,yBzBtEK;AH0hfT;A4Bl9eE;EAIE,2BzB5EK;AH6hfT;A4B/8eE;EAIE,0BzBlFK;AHgifT;A4B58eE;EAME,4BzB1FK;AHmifT;;A4B/+eE;EACI,yBAAA;A5Bk/eN;A4Bj/eI;EACE,yBzBxCG;EyByCH,oDAAA;EACA,WzB5CE;EyB6CF,gCAAA;A5Bm/eN;A4Bj/eI;EACE,yBzB9CG;EyB+CH,WzBjDE;EyBkDF,gCAAA;A5Bm/eN;A4Bh/eE;EAIE,yBzBvDK;AHsifT;A4B7+eE;EAIE,2BzB7DK;AHyifT;A4B1+eE;EAIE,0BzBnEK;AH4ifT;A4Bv+eE;EAME,4BzB3EK;AH+ifT;;A4B1gfE;EACI,yBAAA;A5B6gfN;A4B5gfI;EACE,yBzBrCC;EyBsCD,oDAAA;EACA,WzB5CE;EyB6CF,gCAAA;A5B8gfN;A4B5gfI;EACE,yBzB3CC;EyB4CD,WzBjDE;EyBkDF,gCAAA;A5B8gfN;A4B3gfE;EAIE,yBzBpDG;AH8jfP;A4BxgfE;EAIE,2BzB1DG;AHikfP;A4BrgfE;EAIE,0BzBhEG;AHokfP;A4BlgfE;EAME,4BzBxEG;AHukfP;;A4Bl+eI;EACI,uCAAA;A5Bq+eR;A4Bp+eM;EACE,uCAAA;EACA,iDAAA;EACA,czBtIE;EyBuIF,gBAAA;A5Bs+eR;A4Bp+eM;EACE,uCAAA;EACA,czB3IE;AHinfV;A4Bn+eI;EAIE,uCAAA;A5Bk+eN;A4Bh+eI;EAIE,yCAAA;A5B+9eN;A4B79eI;EAIE,wCAAA;A5B49eN;A4B19eI;EAME,0CAAA;A5Bu9eN;;A4Bn9eI;EACI,wCAAA;A5Bs9eR;A4Br9eM;EACE,wCAAA;EACA,kDAAA;EACA,czB7KI;EyB8KJ,gBAAA;A5Bu9eR;A4Br9eM;EACE,wCAAA;EACA,czBlLI;AHyofZ;A4Bp9eI;EAIE,iDAAA;A5Bm9eN;A4Bj9eI;EAIE,0CAAA;A5Bg9eN;A4B98eI;EAIE,kDAAA;A5B68eN;A4B38eI;EAME,oDAAA;A5Bw8eN;;A4Bp8eI;EACI,wCAAA;A5Bu8eR;A4Bt8eM;EACE,wCAAA;EACA,kDAAA;EACA,czBhNE;EyBiNF,gBAAA;A5Bw8eR;A4Bt8eM;EACE,wCAAA;EACA,czBrNE;AH6pfV;A4Br8eI;EAIE,wCAAA;A5Bo8eN;A4Bl8eI;EAIE,0CAAA;A5Bi8eN;A4B/7eI;EAIE,yCAAA;A5B87eN;A4B57eI;EAME,2CAAA;A5By7eN;;A4Br7eI;EACI,yCAAA;A5Bw7eR;A4Bv7eM;EACE,yCAAA;EACA,mDAAA;EACA,czB3PD;EyB4PC,gBAAA;A5By7eR;A4Bv7eM;EACE,yCAAA;EACA,czBhQD;AHyrfP;A4Bt7eI;EAIE,yCAAA;A5Bq7eN;A4Bn7eI;EAIE,2CAAA;A5Bk7eN;A4Bh7eI;EAIE,0CAAA;A5B+6eN;A4B76eI;EAME,4CAAA;A5B06eN;;A4Bt6eI;EACI,wCAAA;A5By6eR;A4Bx6eM;EACE,wCAAA;EACA,kDAAA;EACA,czBtSE;EyBuSF,gBAAA;A5B06eR;A4Bx6eM;EACE,wCAAA;EACA,czB3SE;AHqtfV;A4Bv6eI;EAIE,wCAAA;A5Bs6eN;A4Bp6eI;EAIE,0CAAA;A5Bm6eN;A4Bj6eI;EAIE,yCAAA;A5Bg6eN;A4B95eI;EAME,2CAAA;A5B25eN;;A4Bv5eI;EACI,uCAAA;A5B05eR;A4Bz5eM;EACE,uCAAA;EACA,iDAAA;EACA,czBzUC;EyB0UD,gBAAA;A5B25eR;A4Bz5eM;EACE,uCAAA;EACA,czB9UC;AHyufT;A4Bx5eI;EAIE,uCAAA;A5Bu5eN;A4Br5eI;EAIE,yCAAA;A5Bo5eN;A4Bl5eI;EAIE,wCAAA;A5Bi5eN;A4B/4eI;EAME,0CAAA;A5B44eN;;A4Bx4eI;EACI,8CAAA;A5B24eR;A4B14eM;EACE,8CAAA;EACA,wDAAA;EACA,czBnWC;EyBoWD,gBAAA;A5B44eR;A4B14eM;EACE,8CAAA;EACA,czBxWC;AHovfT;A4Bz4eI;EAIE,8CAAA;A5Bw4eN;A4Bt4eI;EAIE,gDAAA;A5Bq4eN;A4Bn4eI;EAIE,+CAAA;A5Bk4eN;A4Bh4eI;EAME,iDAAA;A5B63eN;;A4Bz3eI;EACI,4CAAA;A5B43eR;A4B33eM;EACE,4CAAA;EACA,sDAAA;EACA,czBzYD;EyB0YC,gBAAA;A5B63eR;A4B33eM;EACE,4CAAA;EACA,czB9YD;AH2wfP;A4B13eI;EAIE,4CAAA;A5By3eN;A4Bv3eI;EAIE,8CAAA;A5Bs3eN;A4Bp3eI;EAIE,6CAAA;A5Bm3eN;A4Bj3eI;EAME,+CAAA;A5B82eN;;A4B32eA;EACI,kBAAA;EACA,gBAAA;EACA,iBAAA;ExBxXD,cwByXyB;ExBxXzB,oBwBwXiC;A5B+2epC;A4B92eI;EACE,YAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,yBzB3TK;EC5ET,kBwBwYwB;ExBvYxB,MwBuYiC;ExBrYjC,SwBqYwC;ExBpYxC,SwBoY0C;A5Bm3e5C;A4Bj3eI;EACE,kBAAA;EACA,mBAAA;A5Bm3eN;A4Bl3eM;EACI,YAAA;EACD,cAAA;A5Bo3eT;A4Bl3eM;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,yBAAA;ExBtXR,sBwBuX2B;ExB3W3B,yCAAA;AJkufF;A4Br3eY;EACI,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;EACA,6BAAA;EACA,oCAAA;EACA,8BAAA;ExBhad,kBwBiakC;ExBhalC,SwBga2C;ExB/Z3C,WwB+ZgD;A5By3elD;A4Bv3ec;EACI,YAAA;EACA,qBAAA;ExBrahB,kBwBsaoC;ExBrapC,SwBqa6C;ExBpa7C,WwBoakD;EAClC,iCAAA;EACA,0BAAA;EACA,oCAAA;EACA,2BAAA;A5B23elB;;A4Bt3eA;EACE,WAAA;A5By3eF;;A4Bv3eA;EACE,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WzB9eM;EyB+eN,gBAAA;ExB3ZA,kBwB4ZmB;ExB5bnB,kBwB6boB;ExB5bpB,SwB4b6B;ExBzb7B,SwByb4C;A5B43e9C;;A4B13eA;EACE,YAAA;A5B63eF;A4B53eE;EACI,WAAA;EACA,UAAA;EACA,uBAAA;EACA,oBAAA;A5B83eN;A4B53eI;EACI,WAAA;EACA,UAAA;EACA,uBAAA;EACA,oBAAA;A5B83eR;;A4B33eA;EACE,yBzB1hBQ;AHw5fV;;A4B53eA;EACE,yBzBzhBQ;AHw5fV;;A4B73eA;EACE,yBzBxhBQ;AHw5fV;;A4B93eA;EACE,yBzBzhBO;AH05fT;;A4B/3eA;EACE,yBzBhiBK;AHk6fP;;A4Bh4eA;EACE,aAAA;EACA,cAAA;EACA,oBAAA;A5Bm4eF;;A4Bj4eA;;EAEE,gBAAA;A5Bo4eF;;A4Bl4eA;EACE,eAAA;A5Bq4eF;;A6B38fA;EACI,mBAAA;A7B88fJ;;A6B58fA;EACI,e1BiWW;E0BhWX,gB1BKiB;E0BJjB,c1BqQU;AH0sfd;;A6B78fA;EACE,qB1B6JU;E0B5JV,c1BgQW;E0B/PX,yB1B2QgB;E0B1QhB,e1ByVa;E0BxVb,gB1BJmB;E0BKnB,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,6DAAA;EACA,gBAAA;A7Bg9fF;A6B/8fE;EACE,gBAAA;EACA,qB1BiJQ;E0BhJR,sB1BqBI;E0BpBJ,sDAAA;EACA,c1BkPS;AH+tfb;;A6B98fA;EACE,sBAAA;EACA,gBAAA;A7Bi9fF;A6Bh9fE;EACE,kCAAA;A7Bk9fJ;A6Bh9fE;EACE,+BAAA;A7Bk9fJ;;A6B/8fA;EACI,e1B+TW;E0B9TX,gB1B7BiB;E0B8BjB,c1BmOU;ECnKX,gByB/D+B;A7Bk9flC;;A6Bh9fA;EACE,e1ByTa;E0BxTb,gB1BnCmB;E0BoCnB,c1B6NY;AHsvfd;;A6Bj9fA;EACE,c1B8NW;AHsvfb;;A6Bj9fA;EACE,yB1BZM;E0BaN,SAAA;A7Bo9fF;A6Bl9fE;EACE,yB1BhBI;AHo+fR;;A6Bj9fA;EACE,uCAAA;EACA,SAAA;EACA,c1B3CQ;AH+/fV;A6Bl9fE;EACE,uCAAA;EACA,c1B/CM;AHmggBV;;A6Bj9fA;EACE,eAAA;EACA,cAAA;EACA,kB1BwQc;E0BvQd,gBAAA;EACA,UAAA;A7Bo9fF;;A6Bl9fA;;;;EAIE,c1B8LW;AHuxfb;;A6Bn9fA;EACE,6BAAA;A7Bs9fF;;A6Bp9fA;EACE,6DAAA;A7Bu9fF;;A6Br9fA;EACE,yB1B4LgB;E0B3LhB,yBAAA;EACA,c1B8KW;E0B7KX,e1BzFe;E0B0Ff,yDAAA;EACA,wBAAA;EACA,cAAA;EACA,6DAAA;A7Bw9fF;A6Bv9fE;EACE,sB1BxDI;E0ByDJ,wBAAA;EACA,sBAAA;EACA,yBAAA;A7By9fJ;A6Bx9fI;EACE,mBAAA;A7B09fN;A6Bv9fE;EACE,yCAAA;EACA,c1BzFM;AHkjgBV;A6Bv9fE;EACE,yCAAA;EACA,c1B7FM;AHsjgBV;A6Bv9fE;EACE,yCAAA;EACA,c1BjGM;AH0jgBV;A6Bv9fE;EACE,yCAAA;EACA,c1BrGM;AH8jgBV;;A6Bt9fA;EACE,aAAA;EACA,cAAA;EACA,sB1BpFM;E0BqFN,yBAAA;A7By9fF;A6Bx9fE;EACE,yB1B9GM;E0B+GN,qB1B/GM;AHykgBV;A6Bv9fI;EACE,6BAAA;EACA,qB1BpHI;AH6kgBV;A6Br9fI;EACE,yB1BvHM;E0BwHN,qB1BxHM;AH+kgBZ;A6Bn9fI;EACE,yB1BvHI;E0BwHJ,qB1BxHI;AH6kgBV;A6Bj9fI;EACE,yB1B/HC;E0BgID,qB1BhIC;AHmlgBP;A6B/8fI;EACE,yB1BvII;E0BwIJ,qB1BxII;AHylgBV;A6B78fI;EACE,yB1BvIG;E0BwIH,qB1BxIG;AHulgBT;A6B38fI;EACE,yB1BlIE;E0BmIF,qB1BnIE;AHglgBR;A6Bz8fI;EACE,yB1BjJC;E0BkJD,qB1BlJC;AH6lgBP;A6Bx8fE;EACE,gBAAA;A7B08fJ;;A6Bv8fA;EACE,sBAAA;EACA,kBAAA;EACA,6BAAA;A7B08fF;A6Bx8fE;EACE,gBAAA;EACA,uCAAA;EACA,kBAAA;EACA,c1B9KM;E0B+KN,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;A7B08fJ;A6Bt8fI;EACE,c1BtLM;AH8ngBZ;A6Bn8fI;EACE,c1BtLI;AH2ngBV;A6Bh8fI;EACE,c1B9LC;AHgogBP;A6B77fI;EACE,c1BtMI;AHqogBV;A6B17fI;EACE,c1BtMG;AHkogBT;A6Bv7fI;EACE,c1BjME;AH0ngBR;A6Bp7fI;EACE,c1BhNC;AHsogBP;;A6Bl7fA;EACE,sBAAA;EACA,kBAAA;EACA,6BAAA;A7Bq7fF;A6Bn7fE;EACE,gBAAA;EACA,uCAAA;EACA,kBAAA;EACA,c1BzOM;E0B0ON,eAAA;EACA,gBAAA;EACA,2BAAA;EACA,2BAAA;EACA,eAAA;A7Bq7fJ;A6Bj7fI;EACE,c1BjPM;AHoqgBZ;A6B96fI;EACE,c1BjPI;AHiqgBV;A6B36fI;EACE,c1BzPC;AHsqgBP;A6Bx6fI;EACE,c1BjQI;AH2qgBV;A6Br6fI;EACE,c1BjQG;AHwqgBT;A6Bl6fI;EACE,c1B5PE;AHgqgBR;A6B/5fI;EACE,c1B3QC;AH4qgBP;;A6B75fA;EACE,W1BrQM;E0BsQN,yB1B7RQ;E0B8RR,qB1B9RQ;AH8rgBV;;A6B95fA;EACE,qCAAA;EACA,UAAA;EACA,gBAAA;A7Bi6fF;;A6B/5fA;;EAEE,sBAAA;EACA,kBAAA;EACA,UAAA;A7Bk6fF;;A6Bh6fA;;;;;EAKE,gBAAA;A7Bm6fF;;A6B/5fI;;EACE,yB1BhSE;E0BiSF,c1BhEO;AHm+fb;;A6Bh6fA;EACE,c1BpEW;AHu+fb;;A6Bj6fA;EACE,c1BvEW;E0BwEX,yB1BlEmB;AHs+frB;;A6Bl6fA;EACE,yB1BrEmB;AH0+frB;;A6Bj6fI;EAEE,4BAAA;EACA,qDAAA;EAAA,6CAAA;A7Bm6fN;A6Bh6fE;EACE,iBAAA;EACA,gB1BvViB;E0BwVjB,YAAA;EACA,c1BzFS;E0B0FT,yBAAA;EACA,qDAAA;EAAA,6CAAA;A7Bk6fJ;A6Bh6fE;EACE,iBAAA;EACA,gB1B/ViB;E0BgWjB,YAAA;EACA,c1BjGS;AHmggBb;A6Bh6fE;EACE,iBAAA;EACA,gB1BrWiB;E0BsWjB,YAAA;EACA,c1BvGS;AHyggBb;A6Bh6fE;EACE,iBAAA;EACA,gB1B3WiB;E0B4WjB,YAAA;EACA,c1B7GS;AH+ggBb;;A6B/5fA;EACE,iBAAA;EACA,uBAAA;A7Bk6fF;;A6Bh6fA;EACE,eAAA;EACA,oBAAA;A7Bm6fF;;A6B/5fE;EACE,cAAA;EACA,eAAA;A7Bk6fJ;A6B95fI;EACE,cAAA;A7Bg6fN;A6B55fE;EACE,2BAAA;EACA,kBAAA;EACA,uBAAA;A7B85fJ;;A6Bz5fE;EACE,cAAA;EACA,eAAA;A7B45fJ;A6Bx5fI;EACE,aAAA;A7B05fN;A6Bt5fE;EACE,2BAAA;EACA,eAAA;EACA,uBAAA;A7Bw5fJ;;A6Br5fA;EACE,cAAA;EACA,gBAAA;EACA,yB1BlYM;E0BmYN,6BAAA;EACA,0BAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;A7Bw5fF;A6Bt5fE;EACE,kBAAA;EACA,2BAAA;EACA,wBAAA;EACA,4BAAA;EACA,cAAA;EACA,cAAA;EACA,uBAAA;EACA,sB1BjZI;E0BkZJ,qDAAA;EACA,eAAA;EACA,yBAAA;A7Bw5fJ;A6Bt5fI;EACE,aAAA;EACA,6BAAA;A7Bw5fN;A6Br5fI;EACE,cAAA;EACA,2BAAA;EACA,c1B1LO;AHilgBb;A6Bp5fI;EAEE,kBAAA;EACA,mBAAA;EACA,gB1Btce;E0Bucf,qBAAA;EACA,yBAAA;EACA,2BAAA;EACA,iBAAA;EACA,yBAAA;A7Bq5fN;A6Bj5fE;EACE,yCAAA;A7Bm5fJ;A6Bj5fI;EACE,yB1BzcI;AH41gBV;A6Bj5fM;EACE,c1B5cE;AH+1gBV;A6B/4fI;EACE,wCAAA;A7Bi5fN;A6B/4fM;EACE,yB1BldI;AHm2gBZ;A6B/4fQ;EACE,c1BrdE;AHs2gBZ;A6B54fI;EACE,wCAAA;A7B84fN;A6B54fM;EACE,yB1BxdE;AHs2gBV;A6B54fQ;EACE,c1B3dA;AHy2gBV;A6Bz4fI;EACE,yCAAA;A7B24fN;A6Bz4fM;EACE,yB1BteD;AHi3gBP;A6Bz4fQ;EACE,c1BzeH;AHo3gBP;A6Bt4fI;EACE,wCAAA;A7Bw4fN;A6Bt4fM;EACE,yB1BpfE;AH43gBV;A6Bt4fQ;EACE,c1BvfA;AH+3gBV;A6Bn4fI;EACE,uCAAA;A7Bq4fN;A6Bn4fM;EACE,yB1B1fC;AH+3gBT;A6Bn4fQ;EACE,c1B7fD;AHk4gBT;A6Bh4fI;EACE,0CAAA;A7Bk4fN;A6Bh4fM;EACE,yB1B3fA;AH63gBR;A6Bh4fQ;EAEE,c1BzRG;AH0pgBb;A6B53fI;EACE,uCAAA;A7B83fN;A6B53fM;EACE,yB1BjhBD;AH+4gBP;A6B53fQ;EACE,W1BzgBF;AHu4gBR;A6Bz3fI;EACE,4BAAA;A7B23fN;A6Bx3fI;EACE,4BAAA;A7B03fN;A6Bx3fM;EACE,uBAAA;EACA,6BAAA;A7B03fR;A6Bt3fI;EACE,4BAAA;A7Bw3fN;A6Bt3fM;EACE,yBAAA;EACA,4BAAA;A7Bw3fR;A6Bn3fE;EACE,gBAAA;EACA,eAAA;A7Bq3fJ;A6Bn3fI;EACE,eAAA;EACA,gBAAA;A7Bq3fN;A6Bn3fM;EACE,2BAAA;EACA,uBAAA;A7Bq3fR;A6Bh3fE;EACE,gBAAA;EACA,aAAA;A7Bk3fJ;A6Bh3fI;EACE,cAAA;A7Bk3fN;A6Bh3fM;EACE,yBAAA;EACA,2BAAA;A7Bk3fR;;A6B72fA;EACE,aAAA;A7Bg3fF;;A6B92fA;EACE,eAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;A7Bi3fF;;A6B92fA;EACE,mB1BpmBQ;E0BqmBR,W1B9kBM;AH+7gBR;;A6B92fA;EACE,mB1BvmBU;E0BwmBV,W1BnlBM;AHo8gBR;;A6B92fA;EACE,mB1BtmBQ;E0BumBR,W1BxlBM;AHy8gBR;;A6B92fA;EACE,mB1B7mBK;E0B8mBL,W1B7lBM;AH88gBR;;A6B92fA;EACE,mB1BpnBQ;E0BqnBR,W1BlmBM;AHm9gBR;;A6B92fA;EACE,mB1BnnBO;E0BonBP,W1BvmBM;AHw9gBR;;A6B92fA;EACE,mB1B7mBM;E0B8mBN,W1B5mBM;AH69gBR;;A6B92fA;EACE,mB1B3nBK;E0B4nBL,W1BjnBM;AHk+gBR;;A6B92fA;EACE,mBAAA;EACA,YAAA;A7Bi3fF;;A6B92fE;EACE,mB1BtZS;E0BuZT,2DAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,kBAAA;EACA,YAAA;EACA,gCAAA;EACA,aAAA;A7Bi3fJ;A6B92fE;EACE,gB1BvoBI;E0BwoBJ,mBAAA;EACA,iDAAA;EACA,WAAA;EACA,cAAA;EACA,4BAAA;EACA,2BAAA;EACA,kBAAA;EACA,2BAAA;EACA,gCAAA;EACA,aAAA;A7Bg3fJ;;A6B72fA;EACE,mBAAA;EACA,uBAAA;A7Bg3fF;;A6B72fA;EACE,YAAA;EACA,WAAA;EACA,mBAAA;A7Bg3fF;;A6B72fA;EACE,wBAAA;A7Bg3fF;;A6B72fA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;A7Bg3fF;;A6B72fA;EACE,YAAA;EACA,WAAA;EACA,mBAAA;A7Bg3fF;;A6B72fA;EACE,uBAAA;A7Bg3fF;;A6B72fA;EACE,YAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;A7Bg3fF;;A6B32fI;;EACE,6BAAA;A7B+2fN;;A6B32fA;;;EAGE,0BAAA;A7B82fF;;A6B12fI;EACE,c1BhuBI;E0BiuBJ,UAAA;A7B62fN;A6B12fI;EACE,yBAAA;A7B42fN;A6B12fI;EACE,yBAAA;A7B42fN;A6Bv2fI;EACE,c1B5uBM;E0B6uBN,UAAA;A7By2fN;A6Bt2fI;EACE,yBAAA;A7Bw2fN;A6Bt2fI;EACE,yBAAA;A7Bw2fN;A6Bn2fI;EACE,c1BpvBI;E0BqvBJ,UAAA;A7Bq2fN;A6Bl2fI;EACE,yBAAA;A7Bo2fN;A6Bl2fI;EACE,yBAAA;A7Bo2fN;A6B/1fI;EACE,c1BpwBC;E0BqwBD,UAAA;A7Bi2fN;A6B91fI;EACE,yBAAA;A7Bg2fN;A6B91fI;EACE,yBAAA;A7Bg2fN;A6B31fI;EACE,c1BpxBI;E0BqxBJ,UAAA;A7B61fN;A6B11fI;EACE,yBAAA;A7B41fN;A6B11fI;EACE,yBAAA;A7B41fN;A6Bv1fI;EACE,c1B5xBG;E0B6xBH,UAAA;A7By1fN;A6Bt1fI;EACE,yBAAA;A7Bw1fN;A6Bt1fI;EACE,yBAAA;A7Bw1fN;;A6Bp1fA;;;;EAIE,sB1B/xBM;E0BgyBN,kB1B1fc;AHi1gBhB;;A6Br1fA;EACE,gBAAA;EACA,mBAAA;A7Bw1fF;A6Bt1fE;EACE,SAAA;A7Bw1fJ;A6Bp1fI;EACE,uBAAA;EACA,kBAAA;A7Bs1fN;A6Bn1fI;EACE,uBAAA;EACA,c1B9kBO;E0B+kBP,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;A7Bq1fN;A6Bn1fM;EACE,eAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;A7Bq1fR;A6Bl1fM;EAEE,6BAAA;A7Bm1fR;A6Bh1fM;EACE,yBAAA;EACA,mBAAA;EACA,c1B/1BE;E0Bg2BF,6BAAA;A7Bk1fR;A6Bh1fQ;EACE,yBAAA;A7Bk1fV;A6B50fE;EACE,aAAA;A7B80fJ;;A6B30fA;;EAEE,qB1B32BQ;E0B42BR,gBAAA;A7B80fF;;A6B50fA;;EAEE,qB1Bh3BQ;AH+rhBV;;A6B70fA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;A7Bg1fF;;A6B70fE;EACE,iCAAA;EACA,gBAAA;A7Bg1fJ;;A6B50fE;;;;EAIE,cAAA;A7B+0fJ;;A6B50fA;EACE,uBAAA;EACA,2EAAA;A7B+0fF;;A6B70fA;EAKE,cAAA;A7B40fF;;A6B10fA;EACE,yB1Bj4BM;AH8shBR;;A6B10fE;EACE,uBAAA;A7B60fJ;;A6Bz0fA;EACE,qBAAA;A7B40fF;;A6B10fA;EACE,qBAAA;A7B60fF;;A6B30fA;EACE,kBAAA;EACA,MAAA;A7B80fF;;A6B50fA;EACE,8BAAA;A7B+0fF;;A6B70fA;;;EAGE,gB1Bx7BmB;AHwwhBrB;;A6B90fA;EACE,cAAA;A7Bi1fF;;A6Bx0fM;EACE,iBAAA;A7B20fR;;A6Bp0fI;EAKE,eAAA;A7Bm0fN;;A6B9zfE;EACE,YAAA;A7Bi0fJ;A6B/zfE;EACE,YAAA;EACA,gBAAA;A7Bi0fJ;;A6B7zfE;EACE,YAAA;A7Bg0fJ;A6B9zfE;EACE,YAAA;EACA,gBAAA;A7Bg0fJ;;A6B7zfA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,cAAA;EACA,oBAAA;EACA,gBAAA;A7Bg0fF;;A6B9zfA;EACE,cAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,kBAAA;EACA,kBAAA;A7Bi0fF;A6Bh0fE;EACI,kBAAA;EACA,UAAA;EACA,eAAA;EACA,SAAA;EACA,QAAA;A7Bk0fN;;A6B/zfA;EACE,yBAAA;EACA,kBAAA;A7Bk0fF;;A6Bh0fA;EACE,yB1Bp+BO;E0Bq+BP,qB1Br+BO;AHwyhBT;;A6Bj0fI;EACE,cAAA;A7Bo0fN;;A6Bl0fI;EACE,YAAA;EACA,WAAA;EzB17BJ,kByB27BsB;EzB17BtB,MyB07BgC;EzBv7BhC,OyBu7B+C;A7Bu0fjD;;A6Br0fI;EACE,WAAA;EACA,kBAAA;EACA,aAAA;A7Bw0fN;;A6Bt0fI;EACE,SAAA;EACA,QAAA;EACA,gCAAA;EACA,gBAAA;EACA,kCAAA;EACA,W1B5/BE;E0B6/BF,gB1B7hCiB;E0B8hCjB,eAAA;A7By0fN;;A6Bv0fA;;EAEE,kBAAA;EACA,aAAA;A7B00fF;;A6Bx0fA;;EAGE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,c1Bv4BS;AHithBX;;A6Bx0fA;;EAEE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,gB1BzhCM;AHo2hBR;;A6Bz0fA;EACE,mB1BlhCO;E0BmhCP,qB1BnhCO;AH+1hBT;;A6B10fA;;EAEE,WAAA;EACA,UAAA;EACA,WAAA;EACA,gB1BpiCM;E0BqiCN,kBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EAEA,yBAAA;A7B60fF;;A6B30fA;EACE,UAAA;EAEA,mBAAA;A7B80fF;;A6B50fA;EACE,UAAA;EAEA,mBAAA;A7B+0fF;;A6B70fA;EACE,qB1Bl8BU;E0Bm8BV,6DAAA;EACA,kBAAA;EACA,e1BhwBa;E0BiwBb,c1B51BW;E0B61BX,gBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;A7Bg1fF;A6B/0fE;EACI,mB1B/8BM;E0Bg9BN,c1Bt2BO;E0Bu2BP,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,e1B/wBS;AHgmhBf;;A8Bp8hBI;EACI,aAAA;A9Bu8hBR;A8Bt8hBQ;EACI,gCAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;A9Bw8hBZ;AIl6hBI;E0B1CI;IAMQ,sBAAA;IACA,kBAAA;E9B08hBd;AACF;A8Bz8hBY;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,W3BiBR;E2BhBQ,WAAA;EACA,YAAA;EACA,YAAA;A9B28hBhB;AI37hBI;E0BjCQ;IAmBQ,aAAA;E9B68hBlB;AACF;A8B18hBQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,qBAAA;EACA,aAAA;EACA,kBAAA;EACA,gB3BLJ;E2BMI,sDAAA;A9B48hBZ;AIh9hBI;E0BVI;IAgBQ,sBAAA;IACA,kBAAA;E9B88hBd;AACF;A8B78hBY;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A9B+8hBhB;AI99hBI;E0BSQ;IAQQ,mBAAA;E9Bi9hBlB;AACF;AIn+hBI;E0BSQ;IAWQ,gBAAA;IACA,sBAAA;IACA,uBAAA;E9Bm9hBlB;AACF;A8Bl9hBgB;EACI,iBAAA;EACA,YAAA;A9Bo9hBpB;A8Bh9hBgC;EACI,6BAAA;A9Bk9hBpC;A8B38hBgB;EACI,mB3ByFT;E2BxFS,iBAAA;EACA,W3B3CZ;E2B4CY,e3B+QL;E2B9QK,gB3B/EC;E2BgFD,kBAAA;EACA,YAAA;EACA,mBAAA;A9B68hBpB;A8B58hBoB;EACI,mB3BzEd;AHuhiBV;AI9/hBI;E0BsCY;IAaQ,cAAA;E9B+8hBtB;AACF;A8B38hBgB;EACI,uBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;A9B68hBpB;A8Bz8hBQ;EACI,kBAAA;EACA,oBAAA;EACA,gCAAA;A9B28hBZ;A8B18hBY;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;A9B48hBhB;A8B18hBoB;EACI,c3BlGf;E2BmGe,e3BqOT;E2BpOS,gB3BzHH;AHqkiBrB;A8B38hBwB;EACI,iBAAA;A9B68hB5B;A8Bx8hBY;EACI,aAAA;EACA,kBAAA;EACA,oCAAA;A9B08hBhB;A8Bz8hBgB;EACI,oCAAA;A9B28hBpB;A8Bz8hBgB;EACI,mCAAA;A9B28hBpB;A8Bz8hBgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;A9B28hBpB;A8Bz8hBwB;EACI,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,c3BvIlB;E2BwIkB,e3BhKX;E2BiKW,gB3B1JL;E2B2JK,aAAA;EACA,mBAAA;A9B28hB5B;A8B18hB4B;EACI,cAAA;EACA,iBAAA;A9B48hBhC;A8B18hB4B;EACI,cAAA;EACA,yBAAA;A9B48hBhC;A8B18hB4B;EACI,c3BnJvB;E2BoJuB,yBAAA;A9B48hBhC;A8Bx8hBoB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,c3BhBb;AH09hBX;A8Bx8hB4B;EACI,c3BfrB;AHy9hBX;A8Bz8hBgC;EACI,c3BjBzB;AH49hBX;A8Bp8hBgB;EACI,cAAA;A9Bs8hBpB;A8Bp8hBwB;EACI,mBAAA;EACA,c3BjCjB;E2BkCiB,e3BwJb;E2BvJa,gB3BrML;E2BsMK,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;A9Bs8hB5B;A8Br8hB4B;EACI,c3B1LtB;AHioiBV;A8Bn8hBoB;EACI,c3B+CX;E2B9CW,e3B0IT;E2BzIS,gB3BpNH;E2BqNG,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;A9Bq8hBxB;A8Bl8hBgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;A9Bo8hBpB;A8Bn8hBoB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A9Bq8hBxB;A8Bp8hBwB;EACI,kBAAA;A9Bs8hB5B;A8Br8hB4B;EACI,WAAA;EACA,YAAA;EACA,aAAA;A9Bu8hBhC;A8Bt8hBgC;EACI,oBAAA;A9Bw8hBpC;A8Bl8hB4B;EACI,iBAAA;A9Bo8hBhC;A8Bn8hBgC;EACI,c3B9O1B;E2B+O0B,wBAAA;EACA,eAAA;A9Bq8hBpC;A8Bl8hB4B;EACI,iBAAA;A9Bo8hBhC;A8Bn8hBgC;EACI,c3BlP1B;E2BmP0B,wBAAA;EACA,eAAA;A9Bq8hBpC;A8Bl8hB4B;EACI,iBAAA;A9Bo8hBhC;A8Bn8hBgC;EACI,cAAA;EACA,wBAAA;EACA,eAAA;A9Bq8hBpC;A8Bj8hBwB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,e3BkEb;E2BjEa,gB3B5RP;E2B6RO,kBAAA;A9Bm8hB5B;A8Bj8hBgC;EACI,iBAAA;A9Bm8hBpC;A8Bh8hB4B;EACI,c3BrRtB;AHutiBV;A8Bh8hB4B;EACI,c3BpRtB;AHstiBV;A8B97hBoB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A9Bg8hBxB;A8B97hB4B;EACI,c3BjStB;E2BkSsB,WAAA;EACA,YAAA;EACA,kBAAA;A9Bg8hBhC;A8B97hB4B;EACI,c3BrSvB;E2BsSuB,WAAA;EACA,YAAA;A9Bg8hBhC;A8Bz7hBQ;EACI,iBAAA;A9B27hBZ;A8B17hBY;EACI,kBAAA;EACA,0CAAA;EACA,gB3BtSR;E2BuSQ,sDAAA;EACA,aAAA;EACA,mBAAA;A9B47hBhB;A8B37hBgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;A9B67hBpB;A8B37hBwB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,c3B/UlB;E2BgVkB,e3BxWX;E2ByWW,gB3BlWL;AH+xiBvB;A8B57hB4B;EACI,cAAA;EACA,iBAAA;A9B87hBhC;A8B57hB4B;EACI,cAAA;EACA,yBAAA;A9B87hBhC;A8B57hB4B;EACI,c3BzVvB;E2B0VuB,yBAAA;A9B87hBhC;A8Bz7hBwB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,c3BvNjB;AHkpiBX;A8B17hB4B;EACI,WAAA;EACA,YAAA;EACA,c3B9HnB;AH0jiBb;A8Bv7hBgC;EACI,W3BnW5B;AH4xiBR;A8Bn7hBgB;EACI,eAAA;EACA,gCAAA;A9Bq7hBpB;A8Bn7hBwB;EACI,c3B5OjB;E2B6OiB,e3BnDb;E2BoDa,gB3BhZL;E2BiZK,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;A9Bq7hB5B;A8Bp7hB4B;EACI,c3BtYtB;AH4ziBV;A8Bl7hBoB;EACI,c3B7JX;E2B8JW,e3BlET;E2BmES,gB3BhaH;E2BiaG,mBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A9Bo7hBxB;A8Bn7hBwB;EACI,iBAAA;EACA,WAAA;EACA,YAAA;A9Bq7hB5B;A8Bl7hBoB;EACI,c3B9KX;E2B+KW,e3BnFT;E2BoFS,gB3BjbH;E2BkbG,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;A9Bo7hBxB;A8Bj7hBgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;A9Bm7hBpB;A8Bl7hBoB;EACI,iBAAA;A9Bo7hBxB;A8Bl7hBoB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A9Bo7hBxB;A8Bn7hBwB;EACI,kBAAA;A9Bq7hB5B;A8Bn7hBgC;EACI,oBAAA;A9Bq7hBpC;A8Bh7hB4B;EACI,iBAAA;A9Bk7hBhC;A8Bj7hBgC;EACI,c3B1c1B;E2B2c0B,wBAAA;EACA,eAAA;A9Bm7hBpC;A8Bh7hB4B;EACI,iBAAA;A9Bk7hBhC;A8Bj7hBgC;EACI,c3B9c1B;E2B+c0B,wBAAA;EACA,eAAA;A9Bm7hBpC;A8Bh7hB4B;EACI,iBAAA;A9Bk7hBhC;A8Bj7hBgC;EACI,cAAA;EACA,wBAAA;EACA,eAAA;A9Bm7hBpC;A8B/6hBwB;EACI,cAAA;EACA,e3BpJb;E2BqJa,gB3BlfP;E2BmfO,kBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A9Bi7hB5B;A8B/6hBgC;EACI,iBAAA;A9Bi7hBpC;A8B96hB4B;EACI,c3BjftB;AHi6iBV;A8B96hB4B;EACI,c3BhftB;AHg6iBV;A8B56hBoB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A9B86hBxB;A8B56hB4B;EACI,c3B/QnB;E2BgRmB,WAAA;EACA,YAAA;EACA,kBAAA;A9B86hBhC;A8B56hB4B;EACI,c3BjgBvB;E2BkgBuB,WAAA;EACA,YAAA;A9B86hBhC;;A8Bn6hBQ;EACI,c3BhYD;AHsyiBX;;A8Bh6hBI;EACI,WAAA;EACA,YAAA;EACA,c3B5SK;AH+siBb;;A8Bh6hBA;EACI,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,e3BzNW;E2B0NX,gB3BnjBe;E2BojBf,W3BrhBI;E2BshBJ,cAAA;A9Bm6hBJ;A8Bl6hBI;EACI,cAAA;EACA,gB3BzhBA;AH67iBR;;A8Bh6hBI;EACI,yBAAA;A9Bm6hBR;A8Bh6hBQ;EACI,uBAAA;A9Bk6hBZ;;A8B75hBI;EACI,kBAAA;A9Bg6hBR;A8B95hBY;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;A9Bg6hBhB;;A8Bz5hBA;EACI,+BAAA;A9B45hBJ;;A8Bz5hBI;EACI,cAAA;A9B45hBR;A8B15hBY;EACI,c3B7bL;E2B8bK,e3BrQD;E2BsQC,gB3BnmBK;E2BomBL,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;A9B45hBhB;A8B35hBgB;EACI,mB3BldR;E2BmdQ,c3BlcT;AH+1iBX;A8B55hBoB;EACI,c3Bpcb;AHk2iBX;A8Bx5hBQ;EACI,iBAAA;A9B05hBZ;A8Bx5hBQ;EACI,WAAA;EACA,YAAA;EACA,c3BvXC;AHixiBb;;A8Br5hBI;EACI,mBAAA;EACA,0CAAA;EACA,gB3B9lBA;E2B+lBA,c3B7dG;E2B8dH,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;A9Bw5hBR;A8Bv5hBQ;EACI,mBAAA;EACA,mB3B/nBF;E2BgoBE,W3BzmBJ;AHkgjBR;;A8Bj5hBgB;EACI,6BAAA;A9Bo5hBpB;;A8B74hBA;EACI,WAAA;A9Bg5hBJ;;A8B94hBA;EACI,oBAAA;A9Bi5hBJ;;A8B/4hBA;EACI,aAAA;EACA,oBAAA;A9Bk5hBJ;;A8B/4hBI;EACI,oBAAA;A9Bk5hBR;;A8B74hBQ;EACI,yBAAA;EACA,oBAAA;A9Bg5hBZ;;A8B54hBA;EACI,WAAA;A9B+4hBJ;;A8B74hBA;EACI,2BAAA;A9Bg5hBJ;;A8B94hBA;EACI,uBAAA;A9Bi5hBJ;;A8B/4hBA;EACI,c3B3bS;E2B4bT,e3BhWW;E2BiWX,gB3B9rBiB;AHgljBrB;;A8B/4hBI;EACI,SAAA;EACA,kBAAA;A9Bk5hBR;;A8B/4hBA;EACI,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,0CAAA;EACA,gB3BzqBI;E2B0qBJ,oBAAA;A9Bk5hBJ;A8Bj5hBI;EACI,gCAAA;A9Bm5hBR;A8Bl5hBQ;EACI,e3BjXG;E2BkXH,gB3B9sBO;E2B+sBP,c3B9iBD;E2B+iBC,mBAAA;EACA,aAAA;EACA,mBAAA;A9Bo5hBZ;A8Bn5hBY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,c3BzdH;AH82iBb;A8Bj5hBI;EACI,eAAA;EACA,gCAAA;A9Bm5hBR;A8Bl5hBQ;EACI,eAAA;A9Bo5hBZ;A8Bn5hBY;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,aAAA;A9Bq5hBhB;A8Bp5hBgB;EACI,mBAAA;EACA,mB3B5kBT;AHk+iBX;A8Br5hBoB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;A9Bu5hBxB;A8Br5hBoB;EACI,W3BrtBhB;AH4mjBR;A8Bn5hBgB;EACI,e3B/ZL;E2BgaK,gB3B3vBG;E2B4vBH,c3B7fP;E2B8fO,gBAAA;EACA,aAAA;EACA,mBAAA;A9Bq5hBpB;A8Bp5hBoB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;A9Bs5hBxB;A8Bn5hBgB;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mB3BrwBV;E2BswBU,W3B/uBZ;AHoojBR;A8B/4hBI;EACI,gBAAA;EACA,aAAA;A9Bi5hBR;A8Bh5hBQ;EACI,e3B7bG;E2B8bH,gB3B1xBW;E2B2xBX,c3BznBD;AH2gjBX;A8Bh5hBQ;EACI,eAAA;A9Bk5hBZ;A8Bj5hBY;EACI,mBAAA;A9Bm5hBhB;A8Bj5hBY;EA0GO,e3BjjBJ;E2BkjBI,gB3B/4BE;E2Bg5BF,aAAA;EACA,mBAAA;A9B0yhBnB;A8Br5hBoB;EACI,iBAAA;A9Bu5hBxB;A8Bt5hBwB;EACI,wBAAA;EACA,eAAA;A9Bw5hB5B;A8Br5hBoB;EACI,cAAA;EACA,aAAA;EACA,mBAAA;A9Bu5hBxB;A8Bl5hBoB;EACI,iBAAA;A9Bo5hBxB;A8Bn5hBwB;EACI,wBAAA;EACA,eAAA;A9Bq5hB5B;A8Bl5hBoB;EACI,c3B1yBd;E2B2yBc,aAAA;EACA,mBAAA;A9Bo5hBxB;A8B/4hBoB;EACI,iBAAA;A9Bi5hBxB;A8Bh5hBwB;EACI,wBAAA;EACA,eAAA;A9Bk5hB5B;A8B/4hBoB;EACI,c3B7zBd;E2B8zBc,aAAA;EACA,mBAAA;A9Bi5hBxB;A8B54hBoB;EACI,iBAAA;A9B84hBxB;A8B74hBwB;EACI,wBAAA;EACA,eAAA;A9B+4hB5B;A8B54hBqB;EACG,cAAA;EACA,aAAA;EACA,mBAAA;A9B84hBxB;A8Bz4hBoB;EACI,iBAAA;A9B24hBxB;A8B14hBwB;EACI,wBAAA;EACA,eAAA;A9B44hB5B;A8Bz4hBqB;EACG,c3Bt0Bf;E2Bu0Be,aAAA;EACA,mBAAA;A9B24hBxB;A8Bt4hBoB;EACI,iBAAA;A9Bw4hBxB;A8Bv4hBwB;EACI,wBAAA;EACA,eAAA;A9By4hB5B;A8Bt4hBoB;EACI,c3Bp2Bf;E2Bq2Be,aAAA;EACA,mBAAA;A9Bw4hBxB;A8Bn4hBoB;EACI,iBAAA;A9Bq4hBxB;A8Bp4hBwB;EACI,wBAAA;EACA,eAAA;A9Bs4hB5B;A8Bn4hBoB;EACI,c3Br3Bd;E2Bs3Bc,aAAA;EACA,mBAAA;A9Bq4hBxB;A8B73hBgB;EACI,gBAAA;A9B+3hBpB;;A8Bx3hBI;EACI,aAAA;EACA,mBAAA;A9B23hBR;A8B13hBQ;EACI,WAAA;EACA,YAAA;A9B43hBZ;A8B33hBY;EACI,mBAAA;A9B63hBhB;;A8Bx3hBA;EACI,eAAA;EACA,gCAAA;A9B23hBJ;A8Bx3hBY;EACG,aAAA;EACA,sBAAA;EACA,mBAAA;EACC,aAAA;EACA,e3BnlBD;E2BolBC,gB3B/6BO;E2Bg7BP,c3BjrBH;E2BkrBG,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;A9B03hBhB;A8Bz3hBgB;EACI,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,W3B15BZ;AHqxjBR;A8B13hBoB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;A9B43hBxB;A8Bz3hBgB;EACI,mBAAA;EACA,W3Bn6BZ;AH8xjBR;A8Bx3hBgB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;A9B03hBpB;A8Bx3hBgB;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mB3B18BV;E2B28BU,W3Bp7BZ;AH8yjBR;;A8Bl3hBA;EACI,mB3B18BK;E2B28BL,W3B97BI;E2B+7BJ,kBAAA;EACA,oBAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A9Bq3hBJ;A8Bp3hBI;EACI,aAAA;EACA,mBAAA;A9Bs3hBR;A8Br3hBQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;A9Bu3hBZ;;A8Bn3hBA;EACI,aAAA;EACA,kBAAA;EACA,gB3Bn9BI;AHy0jBR;A8Br3hBI;EACI,mBAAA;A9Bu3hBR;A8Br3hBI;EACI,kBAAA;A9Bu3hBR;A8Bt3hBQ;EACI,c3Bx1BD;E2By1BC,e3B7pBG;E2B8pBH,gB3B3/BO;E2B4/BP,kBAAA;A9Bw3hBZ;A8Bt3hBQ;EACI,c3BjwBC;E2BkwBD,e3BtqBG;E2BuqBH,gB3BpgCS;E2BqgCT,kBAAA;A9Bw3hBZ;A8Br3hBI;EACI,kBAAA;A9Bu3hBR;;A8Bp3hBA;EACI,aAAA;EACA,mBAAA;A9Bu3hBJ;A8Bt3hBI;EACI,e3BjrBO;E2BkrBP,gB3B9gCW;E2B+gCX,c3B92BG;E2B+2BH,gBAAA;EACA,kBAAA;A9Bw3hBR;A8Bt3hBI;EACI,e3B1rBO;E2B2rBP,gB3BxhCa;E2ByhCb,cAAA;A9Bw3hBR;;A8Br3hBA;EACI,mBAAA;EACA,uCAAA;A9Bw3hBJ;A8Bv3hBI;EACI,e3BlsBO;E2BmsBP,gB3B/hCe;E2BgiCf,c3B93BG;E2B+3BH,mBAAA;A9By3hBR;A8Bv3hBI;EACI,e3BzsBO;E2B0sBP,gB3BviCa;E2BwiCb,c3BvyBK;E2BwyBL,mBAAA;A9By3hBR;A8Bt3hBQ;EAKI,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,c3BliCF;E2BmiCE,e3B1tBG;E2B2tBH,gB3BrjCW;E2BsjCX,oBAAA;EACA,mBAAA;A9Bo3hBZ;A8Bh4hBY;EACI,cAAA;EACA,iBAAA;A9Bk4hBhB;;A8Bp3hBA;EACI,yB3BziCK;AHg6jBT;;A8Bj3hBiB;EACG,c3BhjCX;E2BijCW,kBAAA;A9Bo3hBpB;A8Bl3hBiB;EACG,c3BtjCV;AH06jBV;;A8B52hBQ;EAKI,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,c3BrkCH;E2BskCG,e3B/vBG;E2BgwBH,gB3B1lCW;E2B2lCX,oBAAA;EACA,mBAAA;A9B22hBZ;A8Bv3hBY;EACI,cAAA;EACA,iBAAA;A9By3hBhB;;A8B32hBA;EACI,uBAAA;EACA,iBAAA;EACA,kBAAA;A9B82hBJ;A8B72hBI;EACI,mBAAA;A9B+2hBR;A8B72hBI;EACI,kBAAA;EACA,SAAA;EACA,UAAA;A9B+2hBR;A8B92hBQ;EACI,kBAAA;EACA,mB3B1lCH;E2B2lCG,W3B9kCJ;AH87jBR;;A8B32hBA;EACI,eAAA;A9B82hBJ;;A8B32hBI;EACI,mBAAA;A9B82hBR;A8B72hBQ;EACI,aAAA;EACA,mBAAA;EACA,c3B73BC;E2B83BD,WAAA;EACA,YAAA;A9B+2hBZ;A8B92hBY;EACI,iBAAA;A9Bg3hBhB;A8B32hBgB;EACI,iBAAA;EACA,mBAAA;EACA,c3Bz4BP;E2B04BO,e3BhpCH;E2BipCG,gB3B3oCC;E2B4oCD,aAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;A9B62hBpB;A8B52hBoB;EACI,mB3BzoCd;E2B0oCc,W3BnnChB;AHi+jBR;A8B32hBgB;EACI,mB3B9oCV;E2B+oCU,W3BxnCZ;E2BynCY,oBAAA;A9B62hBpB;;A8Bp2hBY;EACI,UAAA;EACA,YAAA;EACA,WAAA;A9Bu2hBhB;A8Bt2hBgB;EACI,6BAAA;EACA,WAAA;EACA,YAAA;A9Bw2hBpB;A8Bv2hBoB;EACI,c3BzgCb;AHk3jBX;A8Bv2hBoB;EACI,6BAAA;A9By2hBxB;A8Bx2hBwB;EACI,c3BvqClB;AHihkBV;;A8Bj2hBI;EACI,kBAAA;A9Bo2hBR;A8Bl2hBI;EACI,WAAA;A9Bo2hBR;;A8Bj2hBA;EACI,aAAA;A9Bo2hBJ;;A8Bl2hBA;EACI,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;A9Bq2hBJ;;A8Bn2hBA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A9Bs2hBJ;A8Br2hBI;EACI,kBAAA;EACA,kBAAA;A9Bu2hBR;A8Bt2hBQ;EACI,YAAA;EACA,yDAAA;EACA,8BAAA;EACA,YAAA;E1BnmCV,kB0BomC2B;EACjB,aAAA;A9Bw2hBZ;A8Bv2hBY;EACI,W3B1rCR;AHmikBR;AIlikBI;E0BirCI;IAWQ,YAAA;E9B02hBd;AACF;AIvikBI;E0BirCI;IAcQ,YAAA;E9B42hBd;AACF;AI5ikBI;E0BirCI;IAiBQ,WAAA;E9B82hBd;AACF;A8B52hBQ;E1BnnCN,mB0BqnC2B;E1BrpC3B,kB0BspC4B;E1BrpC5B,M0BqpCqC;E1BppCrC,Q0BopCuC;EAC7B,SAAA;A9B+2hBZ;A8B92hBY;EACI,WAAA;EACA,YAAA;A9Bg3hBhB;;A8B32hBA;EACI,aAAA;EACA,eAAA;A9B82hBJ;;A+B9mkBA;EACI,kBAAA;A/BinkBJ;A+BhnkBI;EACI,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;A/BknkBR;A+BjnkBQ;EACI,sCAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;A/BmnkBZ;A+B/mkBgB;EACI,qB5BGV;E4BFU,yB5BEV;AH+mkBV;;A+B3mkBA;EACI,mB5BqJO;E4BpJP,W5BiBI;E4BhBJ,e5B0UW;E4BzUX,gB5BhBe;E4BiBf,kBAAA;E3B8DF,yB2B7DsB;A/BgnkBxB;A+B/mkBI;EACI,mBAAA;EACA,W5BUA;AHumkBR;AIrmkBI;E2BrBJ;IAYQ,eAAA;E/BknkBN;AACF;;A+BhnkBA;EACI,iBAAA;A/BmnkBJ;;A+BjnkBA;EACI,mB5BvBM;E4BwBN,W5BDI;E4BEJ,e5BwTW;E4BvTX,gB5BlCe;E4BmCf,kBAAA;E3B4CF,yB2B3CsB;A/BsnkBxB;A+BrnkBI;EACI,mB5B7BQ;E4B8BR,W5BRA;AH+nkBR;AI7nkBI;E2BHJ;IAYQ,eAAA;E/BwnkBN;AACF;;A+BrnkBI;EACI,aAAA;A/BwnkBR;;A+BrnkBA;EACI,gBAAA;A/BwnkBJ;;A+BtnkBA;EACI,c5B2GO;E4B1GP,e5BqSW;E4BpSX,gB5BxDe;E4ByDf,gBAAA;A/BynkBJ;;A+BvnkBA;EACI,SAAA;EACA,SAAA;A/B0nkBJ;;A+BxnkBA;EACI,cAAA;A/B2nkBJ;;A+BznkBA;EACI,mBAAA;A/B4nkBJ;;A+B1nkBA;EACI,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;A/B6nkBJ;A+B1nkBY;EACI,c5BoFL;AHwikBX;A+BxnkBI;EACI,aAAA;EACA,mBAAA;A/B0nkBR;A+BznkBQ;EACI,iBAAA;EACA,aAAA;EACA,mBAAA;A/B2nkBZ;A+B1nkBY;EACI,WAAA;EACA,YAAA;EACA,c5BmKH;AHy9jBb;A+BznkBQ;EACI,e5B4PG;E4B3PH,gB5BjGW;E4BkGX,c5BgED;E4B/DC,gBAAA;EACA,iBAAA;A/B2nkBZ;A+BznkBQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,yB5BnGF;E4BoGE,mBAAA;EACA,W5B9EJ;E4B+EI,eAAA;EACA,gB5BhHW;E4BiHX,gBAAA;A/B2nkBZ;;A+BvnkBA;EACI,aAAA;EACA,kBAAA;EACA,0CAAA;EACA,gB5BzFI;E4B0FJ,aAAA;EACA,mBAAA;EACA,mBAAA;A/B0nkBJ;AIptkBI;E2BmFJ;IASQ,sBAAA;E/B4nkBN;AACF;A+B3nkBI;EACI,aAAA;EACA,mBAAA;A/B6nkBR;A+B3nkBY;EACI,e5BuND;E4BtNC,gB5BrIG;E4BsIH,c5B2BL;E4B1BK,kBAAA;A/B6nkBhB;A+B3nkBY;EACI,eAAA;EACA,gB5B7IK;E4B8IL,c5BkHH;E4BjHG,gBAAA;A/B6nkBhB;A+B1nkBQ;EACI,UAAA;A/B4nkBZ;AI5ukBI;E2B+GI;IAGQ,WAAA;E/B8nkBd;AACF;A+B7nkBY;EACI,mBAAA;A/B+nkBhB;A+B9nkBgB;EACI,kBAAA;EACA,aAAA;A/BgokBpB;A+B3nkBI;EACI,UAAA;A/B6nkBR;AI3vkBI;E2B6HA;IAGQ,WAAA;IACA,cAAA;E/B+nkBV;AACF;A+B9nkBQ;EACI,aAAA;EACA,mBAAA;A/BgokBZ;A+B/nkBY;EACI,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,e5B8KD;E4B7KC,gB5B7KO;E4B8KP,c5B3JP;E4B4JO,kBAAA;A/BiokBhB;A+B/nkBY;EACI,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,e5BqKD;E4BpKC,gB5BtLO;E4BuLP,cAAA;A/BiokBhB;A+B/nkBY;EACI,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,e5B6JD;E4B5JC,gB5B9LO;E4B+LP,cAAA;A/BiokBhB;A+B/nkBY;EACI,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,e5BqJD;E4BpJC,gB5BtMO;E4BuMP,c5BtLN;AHuzkBV;A+B/nkBY;EACI,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,e5B6ID;E4B5IC,gB5B9MO;E4B+MP,c5BlMN;AHm0kBV;A+B9nkBgB;EACI,cAAA;EACA,iBAAA;A/BgokBpB;A+BznkBQ;EACI,kCAAA;A/B2nkBZ;A+BznkBQ;EACI,kCAAA;A/B2nkBZ;A+BxnkBI;EACI,UAAA;EACA,oBAAA;A/B0nkBR;A+BznkBQ;EACI,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;A/B2nkBZ;A+BxnkBY;EACI,c5B3EL;AHqskBX;;A+BpnkBI;EACI,6BAAA;A/BunkBR;;A+BpnkBA;EACI,kBAAA;EACA,YAAA;EACA,YAAA;A/BunkBJ;A+BtnkBI;EACI,kBAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,iBAAA;EACA,c5BJK;E4BKL,2BAAA;EACA,mBAAA;A/BwnkBR;AI31kBI;E2BqNJ;IAiBQ,gBAAA;E/BynkBN;AACF;;A+BvnkBA;EACI,kBAAA;A/B0nkBJ;;A+BxnkBA;EACI,kBAAA;A/B2nkBJ;A+B1nkBI;EACI,kBAAA;A/B4nkBR;A+B3nkBQ;EACI,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,c5B1BC;AHupkBb;;A+BxnkBI;EACI,uBAAA;EACA,mBAAA;A/B2nkBR;A+B1nkBQ;EACI,eAAA;A/B4nkBZ;A+B3nkBY;EACI,uBAAA;EACA,UAAA;A/B6nkBhB;A+B3nkBoB;EACI,gBAAA;A/B6nkBxB;A+BznkBY;EACI,WAAA;A/B2nkBhB;A+BtnkBwB;EACI,c5BpDf;AH4qkBb;A+BlnkBQ;EACI,UAAA;A/BonkBZ;A+BlnkBQ;EACI,gBAAA;A/BonkBZ;A+BlnkBgB;EACI,gBAAA;A/BonkBpB;;AgCr6kBA;EACE,c7BoPW;AHorkBb;;AgCt6kBA;EACE,iDAAA;AhCy6kBF;;AgC14kBA;EACE,c7B4MW;E6B3MX,qB7BuGU;E6BtGV,mBAAA;AhC64kBF;AgC54kBE;EACE,mBAAA;AhC84kBJ;AgC14kBM;EACE,gB7B7Da;AHy8kBrB;AgCx4kBE;;EAEE,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;AhC04kBJ;AgCx4kBE;EACE,gB7BzEmB;E6B0EnB,eAAA;AhC04kBJ;AgCx4kBE;EACE,eAAA;AhC04kBJ;AgCx4kBE;EACE,c7ByEQ;E6BxER,sCAAA;AhC04kBJ;AgCx4kBE;EACI,yB7B3EI;E6B4EJ,W7BrDE;AH+7kBR;AgCx4kBE;EACI,yB7B7EM;E6B8EN,W7BzDE;AHm8kBR;AgCx4kBE;EACI,yB7B7EC;E6B8ED,W7B7DE;AHu8kBR;AgCx4kBE;EACI,yB7B/EI;E6BgFJ,W7BjEE;AH28kBR;AgCx4kBE;EACI,yB7BjFG;E6BkFH,W7BrEE;AH+8kBR;AgCx4kBE;EACI,yB7B3FI;E6B4FJ,W7BzEE;AHm9kBR;AgCx4kBE;EACI,yB7BvFC;E6BwFD,W7B7EE;AHu9kBR;AgCx4kBE;EACI,yB7BmCM;E6BlCN,c7B5FC;AHs+kBP;AgCx4kBE;EA7HA,sB7B0CM;E6BzCN,W7B0CM;E6BzCN,8BAAA;EACA,0CAAA;EACA,4CAAA;EACA,uDAAA;EACA,oDAAA;EACA,mDAAA;EACA,kDAAA;AhCwglBF;AgCvglBE;EACE,2CAAA;EACA,mDAAA;EACA,W7B+BI;AH0+kBR;AgCvglBE;EACE,2CAAA;EACA,mDAAA;EACA,W7ByBI;AHg/kBR;AgCvglBE;EACE,2CAAA;EACA,6CAAA;EACA,W7BoBI;AHq/kBR;AgC/5kBE;EAhIA,sB7B0CM;E6BzCN,W7B0CM;E6BzCN,8BAAA;EACA,0CAAA;EACA,8CAAA;EACA,yDAAA;EACA,sDAAA;EACA,qDAAA;EACA,oDAAA;AhCkilBF;AgCjilBE;EACE,2CAAA;EACA,qDAAA;EACA,W7B+BI;AHoglBR;AgCjilBE;EACE,2CAAA;EACA,qDAAA;EACA,W7ByBI;AH0glBR;AgCjilBE;EACE,2CAAA;EACA,+CAAA;EACA,W7BoBI;AH+glBR;AgCt7kBE;EAnIA,sB7B0CM;E6BzCN,W7B0CM;E6BzCN,8BAAA;EACA,0CAAA;EACA,4CAAA;EACA,uDAAA;EACA,oDAAA;EACA,mDAAA;EACA,kDAAA;AhC4jlBF;AgC3jlBE;EACE,2CAAA;EACA,mDAAA;EACA,W7B+BI;AH8hlBR;AgC3jlBE;EACE,2CAAA;EACA,mDAAA;EACA,W7ByBI;AHoilBR;AgC3jlBE;EACE,2CAAA;EACA,6CAAA;EACA,W7BoBI;AHyilBR;AgC78kBE;EAtIA,sB7B0CM;E6BzCN,W7B0CM;E6BzCN,8BAAA;EACA,0CAAA;EACA,4CAAA;EACA,uDAAA;EACA,oDAAA;EACA,mDAAA;EACA,kDAAA;AhCsllBF;AgCrllBE;EACE,2CAAA;EACA,mDAAA;EACA,W7B+BI;AHwjlBR;AgCrllBE;EACE,2CAAA;EACA,mDAAA;EACA,W7ByBI;AH8jlBR;AgCrllBE;EACE,2CAAA;EACA,6CAAA;EACA,W7BoBI;AHmklBR;AgCp+kBE;EAzIA,sB7B0CM;E6BzCN,W7B0CM;E6BzCN,8BAAA;EACA,0CAAA;EACA,2CAAA;EACA,sDAAA;EACA,mDAAA;EACA,kDAAA;EACA,iDAAA;AhCgnlBF;AgC/mlBE;EACE,2CAAA;EACA,kDAAA;EACA,W7B+BI;AHkllBR;AgC/mlBE;EACE,2CAAA;EACA,kDAAA;EACA,W7ByBI;AHwllBR;AgC/mlBE;EACE,2CAAA;EACA,4CAAA;EACA,W7BoBI;AH6llBR;AgC3/kBE;EA5IA,sB7B0CM;E6BzCN,W7B0CM;E6BzCN,8BAAA;EACA,0CAAA;EACA,yCAAA;EACA,oDAAA;EACA,iDAAA;EACA,gDAAA;EACA,+CAAA;AhC0olBF;AgCzolBE;EACE,2CAAA;EACA,gDAAA;EACA,W7B+BI;AH4mlBR;AgCzolBE;EACE,2CAAA;EACA,gDAAA;EACA,W7ByBI;AHknlBR;AgCzolBE;EACE,2CAAA;EACA,0CAAA;EACA,W7BoBI;AHunlBR;AgClhlBE;EA/IA,sB7B0CM;E6BzCN,W7B0CM;E6BzCN,8BAAA;EACA,0CAAA;EACA,0CAAA;EACA,qDAAA;EACA,kDAAA;EACA,iDAAA;EACA,gDAAA;AhCoqlBF;AgCnqlBE;EACE,2CAAA;EACA,iDAAA;EACA,W7B+BI;AHsolBR;AgCnqlBE;EACE,2CAAA;EACA,iDAAA;EACA,W7ByBI;AH4olBR;AgCnqlBE;EACE,2CAAA;EACA,2CAAA;EACA,W7BoBI;AHiplBR;AgCzilBE;EAlJA,sB7B0CM;E6BzCN,W7B0CM;E6BzCN,8BAAA;EACA,0CAAA;EACA,yCAAA;EACA,oDAAA;EACA,iDAAA;EACA,gDAAA;EACA,+CAAA;AhC8rlBF;AgC7rlBE;EACE,2CAAA;EACA,gDAAA;EACA,W7B+BI;AHgqlBR;AgC7rlBE;EACE,2CAAA;EACA,gDAAA;EACA,W7ByBI;AHsqlBR;AgC7rlBE;EACE,2CAAA;EACA,0CAAA;EACA,W7BoBI;AH2qlBR;AgC9jlBM;;;;;;EAME,mCAAA;AhCgklBR;AgC5jlBM;;;;;;EAME,qCAAA;AhC8jlBR;AgC1jlBM;;;;;;EAME,oCAAA;AhC4jlBR;AgCxjlBM;;;;;;EAME,oCAAA;AhC0jlBR;AgCtjlBM;;;;;;EAME,oCAAA;AhCwjlBR;AgCpjlBM;;;;;;EAME,mCAAA;AhCsjlBR;AgCljlBE;EACE,kDAAA;EACA,c7BoDS;AHgglBb;AgCljlBE;EACE,iDAAA;EACA,c7BgDS;AHoglBb;AgCljlBE;EACE,6BAAA;AhCojlBJ;AgCljlBE;EACE,6BAAA;EACA,c7ByCS;AH2glBb;AgCljlBE;EACE,6BAAA;EACA,c7BqCS;AH+glBb;AgCjjlBI;EAvMF,sB7BUM;E6BTN,4BAAA;EACA,4BAAA;EACA,sBAAA;EACA,4CAAA;EACA,sDAAA;EACA,oDAAA;EACA,8BAAA;EACA,mDAAA;EACA,kDAAA;EACA,4BAAA;EACA,0CAAA;AhC2vlBF;AgC5jlBI;EA1MF,sB7BUM;E6BTN,4BAAA;EACA,4BAAA;EACA,sBAAA;EACA,8CAAA;EACA,wDAAA;EACA,sDAAA;EACA,8BAAA;EACA,qDAAA;EACA,oDAAA;EACA,4BAAA;EACA,0CAAA;AhCywlBF;AgCvklBI;EA7MF,sB7BUM;E6BTN,4BAAA;EACA,4BAAA;EACA,sBAAA;EACA,4CAAA;EACA,sDAAA;EACA,oDAAA;EACA,8BAAA;EACA,mDAAA;EACA,kDAAA;EACA,4BAAA;EACA,0CAAA;AhCuxlBF;AgClllBI;EAhNF,sB7BUM;E6BTN,4BAAA;EACA,4BAAA;EACA,sBAAA;EACA,4CAAA;EACA,sDAAA;EACA,oDAAA;EACA,8BAAA;EACA,mDAAA;EACA,kDAAA;EACA,4BAAA;EACA,0CAAA;AhCqylBF;AgC7llBI;EAnNF,sB7BUM;E6BTN,4BAAA;EACA,4BAAA;EACA,sBAAA;EACA,2CAAA;EACA,qDAAA;EACA,mDAAA;EACA,8BAAA;EACA,kDAAA;EACA,iDAAA;EACA,4BAAA;EACA,0CAAA;AhCmzlBF;AgCxmlBI;EAtNF,sB7BUM;E6BTN,4BAAA;EACA,4BAAA;EACA,sBAAA;EACA,yCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,+CAAA;EACA,4BAAA;EACA,0CAAA;AhCi0lBF;AgCnnlBI;EAzNF,sB7BUM;E6BTN,4BAAA;EACA,4BAAA;EACA,sBAAA;EACA,0CAAA;EACA,oDAAA;EACA,kDAAA;EACA,8BAAA;EACA,iDAAA;EACA,gDAAA;EACA,4BAAA;EACA,0CAAA;AhC+0lBF;AgC9nlBI;EA5NF,sB7BUM;E6BTN,4BAAA;EACA,4BAAA;EACA,sBAAA;EACA,yCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,+CAAA;EACA,4BAAA;EACA,0CAAA;AhC61lBF;;AgCvolBA;EAnNE,sBAAA;EACA,8BAAA;EACA,4CAAA;EACA,sDAAA;EACA,oDAAA;EACA,8BAAA;EACA,mDAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EACA,WAAA;EACA,2CAAA;EACA,sBAAA;AhC81lBF;;AgCpplBA;EAtNE,sBAAA;EACA,8BAAA;EACA,8CAAA;EACA,wDAAA;EACA,sDAAA;EACA,8BAAA;EACA,qDAAA;EACA,6BAAA;EACA,oDAAA;EACA,4BAAA;EACA,WAAA;EACA,6CAAA;EACA,sBAAA;AhC82lBF;;AgCjqlBA;EAzNE,sBAAA;EACA,8BAAA;EACA,4CAAA;EACA,sDAAA;EACA,oDAAA;EACA,8BAAA;EACA,mDAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EACA,WAAA;EACA,2CAAA;EACA,sBAAA;AhC83lBF;;AgC9qlBA;EA5NE,sBAAA;EACA,8BAAA;EACA,4CAAA;EACA,sDAAA;EACA,oDAAA;EACA,8BAAA;EACA,mDAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EACA,WAAA;EACA,2CAAA;EACA,sBAAA;AhC84lBF;;AgC3rlBA;EA/NE,sBAAA;EACA,8BAAA;EACA,yCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,+CAAA;EACA,4BAAA;EACA,WAAA;EACA,wCAAA;EACA,sBAAA;AhC85lBF;;AgCxslBA;EAlOE,sBAAA;EACA,8BAAA;EACA,2CAAA;EACA,qDAAA;EACA,mDAAA;EACA,8BAAA;EACA,kDAAA;EACA,6BAAA;EACA,iDAAA;EACA,4BAAA;EACA,WAAA;EACA,0CAAA;EACA,sBAAA;AhC86lBF;;AgCrtlBA;EArOE,sBAAA;EACA,8BAAA;EACA,yCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,+CAAA;EACA,4BAAA;EACA,WAAA;EACA,wCAAA;EACA,sBAAA;AhC87lBF;;AgClulBA;EAxOE,sBAAA;EACA,8BAAA;EACA,0CAAA;EACA,oDAAA;EACA,kDAAA;EACA,8BAAA;EACA,iDAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EACA,WAAA;EACA,yCAAA;EACA,sBAAA;AhC88lBF;;AgC9ulBE;EACE,kCAAA;AhCivlBJ;;AgC7ulBE;EACE,sBAAA;AhCgvlBJ;;AgC7ulBA;EACI,SAAA;AhCgvlBJ;AgC7ulBY;EACI,c7B1HL;E6B2HK,e7B2DD;AHorlBf;AgC7ulBoB;EACI,SAAA;AhC+ulBxB;AgC5ulBgB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AhC8ulBpB;AgC7ulBoB;EACI,gBAAA;AhC+ulBxB;AgC3ulBoB;EACI,8CAAA;AhC6ulBxB;AgCzulBgB;EACI,c7BzSR;E6B0SQ,e7BqCL;E6BpCK,gB7BxTC;E6ByTD,mBAAA;AhC2ulBpB;AgC1ulBoB;EACI,iBAAA;EACA,cAAA;AhC4ulBxB;AgC1ulBoB;EACI,iBAAA;EACA,WAAA;EACA,YAAA;AhC4ulBxB;AgC1ulBoB;EACI,c7BzTd;AHqimBV;AgCzulBgB;EACI,cAAA;AhC2ulBpB;AgC1ulBoB;EACI,c7B7TZ;AHyimBZ;AgC1ulBoB;EACI,cAAA;EACA,e7BeT;E6BdS,gB7B9UH;E6B+UG,c7B/EX;AH2zlBb;AgC1ulBoB;EACI,kBAAA;AhC4ulBxB;AgCzulBgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,e7BPL;E6BQK,yBAAA;EACA,gB7BpWC;E6BqWD,kBAAA;AhC2ulBpB;AgCxulBY;EACI,gB7BxWO;E6ByWP,c7B9VJ;E6B+VI,e7BfD;E6BgBC,mBAAA;AhC0ulBhB;AgCxulBY;EACI,c7B5UP;AHsjmBT;AgCxulBY;EACI,gBAAA;AhC0ulBhB;AgCzulBgB;EACI,e7BtBL;E6BuBK,c7BhNT;E6BiNS,gB7BrXG;E6BsXH,gBAAA;AhC2ulBpB;AgCtulBY;EACI,gB7B3XG;E6B4XH,c7BlXJ;E6BmXI,e7BrYC;E6BsYD,6BAAA;AhCwulBhB;AgCrulBQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AhCuulBZ;AgCtulBY;EACI,iBAAA;EACA,kBAAA;AhCwulBhB;AgCnulBY;EACI,oBAAA;AhCqulBhB;AgC9tlBQ;EACI,kBAAA;AhCgulBZ;AgC/tlBY;EACI,gBAAA;AhCiulBhB;AgC1tlBY;EACI,kBAAA;AhC4tlBhB;AgCttlBY;EACI,kBAAA;AhCwtlBhB;;AgC9slBY;EACI,mBAAA;AhCitlBhB;;AgC5slBA;EACI,iBAAA;AhC+slBJ;AIxmmBI;E4BwZJ;IAGQ,gBAAA;IACA,mBAAA;EhCitlBN;AACF;;AgC/slBA;EACI,0BAAA;AhCktlBJ;;AgC/slBI;EACI,aAAA;AhCktlBR;;AgC9slBI;;;EAGI,wBAAA;AhCitlBR;;AgC9slBA;EACI,e7BzHW;AH00lBf;;AgC/slBA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AhCktlBJ;AgCjtlBI;EACI,c7BhdI;E6BidJ,gB7B7da;AHgrmBrB;AgCjtlBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AhCmtlBR;;AgC/slBI;EACI,sBAAA;EACA,kBAAA;AhCktlBR;;AgC7slBQ;EACI,YAAA;AhCgtlBZ;AgC7slBI;EACI,WAAA;EACA,YAAA;AhC+slBR;;AgC3slBI;EACI,UAAA;AhC8slBR;AgC5slBI;EACI,oBAAA;AhC8slBR;AgC5slBI;EACI,aAAA;AhC8slBR;AgC7slBQ;EACI,SAAA;EACA,UAAA;AhC+slBZ;AgC3slBQ;EACI,oBAAA;EACA,gBAAA;AhC6slBZ;;AgCxslBI;EACI,yBAAA;EACA,8BAAA;AhC2slBR;AgCzslBY;EACI,yBAAA;AhC2slBhB;AgCrslBQ;EACI,gBAAA;AhCuslBZ;AgCpslBY;EACI,c7B1hBJ;E6B2hBI,gB7BriBG;E6BsiBH,6BAAA;EACA,yBAAA;AhCsslBhB;AgClslBY;EACI,sB7B7gBR;AHitmBR;AgClslBY;EACI,c7BriBJ;E6BsiBI,gB7BhjBG;AHovmBnB;;AgC9rlBI;EACI,cAAA;AhCislBR;AgChslBQ;EACI,kBAAA;AhCkslBZ;;AgC5rlBQ;EACI,WAAA;EACA,YAAA;AhC+rlBZ;;AgC3rlBA;EACI,yBAAA;AhC8rlBJ;AgC7rlBI;EACI,+BAAA;EACA,8BAAA;EACA,aAAA;EACA,gB7B3kBW;E6B4kBX,e7BjPO;AHg7lBf;;AgC3rlBI;EACI,+BAAA;EACA,8BAAA;EACA,iBAAA;EACA,c7BtVK;AHohmBb;;AgC3rlBA;EACI,yBAAA;AhC8rlBJ;AgC7rlBI;EACI,iBAAA;EACA,gB7B3lBW;E6B4lBX,e7BjQO;AHg8lBf;AgC7rlBI;EACI,c7BjWK;AHgimBb;;AgC5rlBA;EACI,cAAA;AhC+rlBJ;AgC7rlBQ;EACI,2BAAA;EACA,mBAAA;EACA,0BAAA;AhC+rlBZ;AgC5rlBI;EACI,kBAAA;AhC8rlBR;;AIzwmBI;E4B8kBJ;IAEQ,cAAA;IACA,kBAAA;EhC8rlBN;AACF;;AgC3rlBI;EACI,c7B/mBE;E6BgnBF,gB7BxnBW;E6BynBX,e7B7RO;AH29lBf;;AgC1rlBI;EACI,0BAAA;AhC6rlBR;AgC3rlBI;EACI,UAAA;AhC6rlBR;AgC3rlBI;EACI,SAAA;EACA,4BAAA;AhC6rlBR;AgC5rlBQ;EACI,aAAA;AhC8rlBZ;AgC7rlBY;EACI,gBAAA;EACA,sBAAA;AhC+rlBhB;;AgC1rlBA;EACE,SAAA;AhC6rlBF;AgC1rlBU;EACI,c7BjfH;E6BkfG,e7B5TC;AHw/lBf;AgC1rlBkB;EACI,SAAA;AhC4rlBtB;AgCzrlBc;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AhC2rlBlB;AgC1rlBkB;EACI,gBAAA;AhC4rlBtB;AgCxrlBkB;EACI,8CAAA;AhC0rlBtB;AgCtrlBc;EACI,c7B3aJ;E6B4aI,e7BlVH;E6BmVG,gB7B/qBG;E6BgrBH,mBAAA;AhCwrlBlB;AgCvrlBkB;EACI,iBAAA;EACA,cAAA;AhCyrlBtB;AgCvrlBkB;EACI,iBAAA;EACA,WAAA;EACA,YAAA;AhCyrlBtB;AgCvrlBkB;EACI,c7BhrBZ;AHy2mBV;AgCxrlBsB;EACI,c7BlrBhB;AH42mBV;AgCtrlBc;EACI,cAAA;AhCwrlBlB;AgCvrlBkB;EACI,c7BvrBV;AHg3mBZ;AgCvrlBkB;EACI,cAAA;EACA,e7B3WP;E6B4WO,gB7BxsBD;E6BysBC,c7BzcT;AHkomBb;AgCvrlBkB;EACI,kBAAA;AhCyrlBtB;AgCtrlBc;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,e7BjYH;E6BkYG,yBAAA;EACA,gB7B9tBG;E6B+tBH,kBAAA;AhCwrlBlB;AgCrrlBU;EACI,gB7BluBS;E6BmuBT,c7BxtBF;E6BytBE,e7BzYC;E6B0YD,mBAAA;AhCurlBd;AgCrrlBU;EACI,c7BtsBL;AH63mBT;AgCrrlBU;EACI,gBAAA;AhCurlBd;AgCtrlBc;EACI,e7BhZH;E6BiZG,c7B1kBP;E6B2kBO,gB7B/uBK;E6BgvBL,gBAAA;AhCwrlBlB;AgCnrlBU;EACI,gB7BrvBK;E6BsvBL,c7B5uBF;E6B6uBE,e7B/vBG;E6BgwBH,6BAAA;AhCqrlBd;AgClrlBM;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AhCorlBV;AgCnrlBU;EACI,iBAAA;EACA,kBAAA;AhCqrlBd;AgChrlBU;EACI,oBAAA;AhCkrlBd;AgC3qlBM;EACI,kBAAA;AhC6qlBV;AgC5qlBU;EACI,gBAAA;AhC8qlBd;AgCvqlBU;EACI,kBAAA;AhCyqlBd;AgCnqlBU;EACI,kBAAA;AhCqqlBd;AgCjqlBE;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AhCmqlBJ;;AgC5plBU;EAGI,aAAA;AhC+plBd;AgC9plBc;EACI,0CAAA;EACV,sB7BzxBA;E6B0xBU,kBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,YAAA;AhCgqlBlB;AgC/plBkB;EACI,c7BlyBf;E6BmyBe,WAAA;EACA,YAAA;AhCiqlBtB;AgC/plBkB;EACG,c7B5kBR;E6B6kBQ,WAAA;EACC,YAAA;AhCiqlBtB;AgC/plBkB;EACI,c7B7zBb;E6B8zBa,WAAA;EACA,YAAA;AhCiqlBtB;AgC/plBkB;EACI,WAAA;EACA,YAAA;AhCiqlBtB;AgC/plBkB;EACI,c7BrzBf;E6BszBe,WAAA;EACA,YAAA;AhCiqlBtB;AgC9plBkB;EACI,c7Bp1BV;E6Bq1BU,WAAA;EACA,YAAA;AhCgqlBtB;AgC1plBM;EACI,gBAAA;AhC4plBV;AgC1plBc;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,iBAAA;AhC4plBlB;AgC3plBkB;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AhC6plBtB;AgCvplBE;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,YAAA;AhCyplBN;AgCxplBM;EACI,UAAA;AhC0plBV;AgCtplBE;EACI,gBAAA;AhCwplBN;AgCtplBE;EACI,YAAA;AhCwplBN;AgCtplBE;EACI,YAAA;AhCwplBN;;AgC/olBwB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,c7BxqBf;AH0zmBb;AgCjplB4B;EACI,mB7B9wBpB;E6B+wBoB,c7B3qBnB;AH8zmBb;;AiCxknBA;EACI,sB9B0CI;E8BzCJ,c9BwQS;E8BvQT,qBAAA;EACA,kBAAA;EACA,gB9BKiB;AHsknBrB;AiCzknBQ;EACI,gBAAA;AjC2knBZ;AiCzknBQ;EACI,c9B+PC;E8B9PD,yB9BoQS;E8BnQT,gBAAA;AjC2knBZ;AiC1knBY;EACI,gBAAA;EACA,cAAA;EACA,eAAA;AjC4knBhB;AiCxknBI;EACI,c9BoPK;E8BnPL,yB9ByPa;E8BxPb,gBAAA;AjC0knBR;AiCxknBI;EACI,mCAAA;EACA,gBAAA;AjC0knBR;AiCxknBI;EACI,sBAAA;AjC0knBR;AiCxknBI;EACI,gBAAA;EACA,0B9BlBO;E8BmBP,e9B+TO;E8B9TP,cAAA;EACA,sB9BKA;E8BJA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,c9B+NK;AH22mBb;;AiCvknBA;EACI,qBAAA;EACA,oBAAA;EACA,c9B8NS;AH42mBb;;AiCxknBA;EACI,c9BsNS;E8BrNT,sB9BVI;E8BWJ,yBAAA;AjC2knBJ;;AiCxknBI;EACI,0BAAA;AjC2knBR;AiCzknBI;EACI,qCAAA;EACA,kB9BmRQ;E8BlRR,gBAAA;AjC2knBR;;AiCxknBA;EACI,mCAAA;EACA,kCAAA;AjC2knBJ;;AiCzknBA;EACI,+BAAA;EACA,gCAAA;AjC4knBJ;;AiCxknBQ;EACI,uCAAA;EACA,c9B1DF;AHqonBV;AiC1knBY;EACI,yB9B5DN;E8B6DM,W9BtCR;AHknnBR;AiC1knBY;EACI,sB9BzCR;E8B0CQ,c9BqLH;AHu5mBb;AiC3knBgB;EACI,yB9ByLC;E8BxLD,c9BkLP;AH25mBb;AiCvknBQ;EACI,wCAAA;EACA,c9B1EA;AHmpnBZ;AiCxknBY;EACI,yB9B5EJ;E8B6EI,W9BxDR;AHkonBR;AiCxknBY;EACI,sB9B3DR;E8B4DQ,c9BmKH;AHu6mBb;AiCzknBgB;EACI,yB9BuKC;E8BtKD,c9BgKP;AH26mBb;AiCrknBQ;EACI,wCAAA;EACA,c9B1FF;AHiqnBV;AiCtknBY;EACI,yB9B5FN;E8B6FM,W9B1ER;AHkpnBR;AiCtknBY;EACI,sB9B7ER;E8B8EQ,c9BiJH;AHu7mBb;AiCvknBgB;EACI,yB9BqJC;E8BpJD,c9B8IP;AH27mBb;AiCnknBQ;EACI,uCAAA;EACA,c9BtGH;AH2qnBT;AiCpknBY;EACI,yB9BxGP;E8ByGO,W9B5FR;AHkqnBR;AiCpknBY;EACI,sB9B/FR;E8BgGQ,c9B+HH;AHu8mBb;AiCrknBgB;EACI,yB9BmIC;E8BlID,c9B4HP;AH28mBb;AiCjknBQ;EACI,wCAAA;EACA,c9B1HF;AH6rnBV;AiClknBY;EACI,yB9B5HN;E8B6HM,W9B9GR;AHkrnBR;AiClknBY;EACI,sB9BjHR;E8BkHQ,c9B6GH;AHu9mBb;AiCnknBgB;EACI,yB9BiHC;E8BhHD,c9B0GP;AH29mBb;AiC/jnBQ;EACI,yCAAA;EACA,c9B9IL;AH+snBP;AiChknBY;EACI,yB9BhJT;E8BiJS,W9BhIR;AHksnBR;AiChknBY;EACI,sB9BnIR;E8BoIQ,c9B2FH;AHu+mBb;AiCjknBgB;EACI,yB9B+FC;E8B9FD,c9BwFP;AH2+mBb;;AiC3jnBQ;EACI,yB9BvKF;E8BwKE,W9BjJJ;AH+snBR;AiC7jnBY;EACI,sB9BnJR;E8BoJQ,c9B3KN;AH0unBV;AiC7jnBY;EACI,sB9BvJR;E8BwJQ,c9BuEH;AHw/mBb;AiC9jnBgB;EACI,yB9B2EC;E8B1ED,c9BoEP;AH4/mBb;AiC1jnBQ;EACI,yB9BvLA;E8BwLA,W9BnKJ;AH+tnBR;AiC3jnBY;EACI,sB9BrKR;E8BsKQ,c9B3LJ;AHwvnBZ;AiC3jnBY;EACI,sB9BzKR;E8B0KQ,c9BqDH;AHwgnBb;AiC5jnBgB;EACI,yB9ByDC;E8BxDD,c9BkDP;AH4gnBb;AiCxjnBQ;EACI,yB9BvMF;E8BwME,W9BrLJ;AH+unBR;AiCzjnBY;EACI,sB9BvLR;E8BwLQ,c9B3MN;AHswnBV;AiCzjnBY;EACI,sB9B3LR;E8B4LQ,c9BmCH;AHwhnBb;AiC1jnBgB;EACI,yB9BuCC;E8BtCD,c9BgCP;AH4hnBb;AiCtjnBQ;EACI,yB9BnNH;E8BoNG,W9BvMJ;AH+vnBR;AiCvjnBY;EACI,sB9BzMR;E8B0MQ,c9BvNP;AHgxnBT;AiCvjnBY;EACI,sB9B7MR;E8B8MQ,c9BiBH;AHwinBb;AiCxjnBgB;EACI,yB9BqBC;E8BpBD,c9BcP;AH4inBb;AiCpjnBQ;EACI,yB9BvOF;E8BwOE,W9BzNJ;AH+wnBR;AiCrjnBY;EACI,sB9B3NR;E8B4NQ,c9B3ON;AHkynBV;AiCrjnBY;EACI,sB9B/NR;E8BgOQ,c9BDH;AHwjnBb;AiCtjnBgB;EACI,yB9BGC;E8BFD,c9BJP;AH4jnBb;AiCljnBQ;EACI,yB9B3PL;E8B4PK,W9B3OJ;AH+xnBR;AiCnjnBY;EACI,sB9B7OR;E8B8OQ,c9B/PT;AHoznBP;AiCnjnBY;EACI,sB9BjPR;E8BkPQ,c9BnBH;AHwknBb;AiCpjnBgB;EACI,yB9BfC;E8BgBD,c9BtBP;AH4knBb;;AiC9inBQ;EACI,yBAAA;AjCijnBZ;AiC/inBQ;EACI,sB9BjQJ;E8BkQI,c9BzRF;E8B0RE,qBAAA;AjCijnBZ;AiChjnBY;EACI,sB9BrQR;E8BsQQ,c9B7RN;E8B8RM,yBAAA;AjCkjnBhB;AiChjnBY;EACI,mCAAA;AjCkjnBhB;AiC7inBQ;EACI,yBAAA;AjC+inBZ;AiC7inBQ;EACI,sB9BnRJ;E8BoRI,c9BzSA;E8B0SA,qBAAA;AjC+inBZ;AiC9inBY;EACI,sB9BvRR;E8BwRQ,c9B7SJ;E8B8SI,yBAAA;AjCgjnBhB;AiC9inBY;EACI,mCAAA;AjCgjnBhB;AiC3inBQ;EACI,yBAAA;AjC6inBZ;AiC3inBQ;EACI,sB9BrSJ;E8BsSI,c9BzTF;E8B0TE,qBAAA;AjC6inBZ;AiC5inBY;EACI,sB9BzSR;E8B0SQ,c9B7TN;E8B8TM,yBAAA;AjC8inBhB;AiC5inBY;EACI,mCAAA;AjC8inBhB;AiCzinBQ;EACI,yBAAA;AjC2inBZ;AiCzinBQ;EACI,sB9BvTJ;E8BwTI,c9BrUH;E8BsUG,qBAAA;AjC2inBZ;AiC1inBY;EACI,sB9B3TR;E8B4TQ,c9BzUP;E8B0UO,yBAAA;AjC4inBhB;AiC1inBY;EACI,mCAAA;AjC4inBhB;AiCvinBQ;EACI,yBAAA;AjCyinBZ;AiCvinBQ;EACI,sB9BzUJ;E8B0UI,c9BzVF;E8B0VE,qBAAA;AjCyinBZ;AiCxinBY;EACI,sB9B7UR;E8B8UQ,c9B7VN;E8B8VM,yBAAA;AjC0inBhB;AiCxinBY;EACI,mCAAA;AjC0inBhB;AiCrinBQ;EACI,yBAAA;AjCuinBZ;AiCrinBQ;EACI,sB9B3VJ;E8B4VI,c9B7WL;E8B8WK,qBAAA;AjCuinBZ;AiCtinBY;EACI,sB9B/VR;E8BgWQ,c9BjXT;E8BkXS,yBAAA;AjCwinBhB;AiCtinBY;EACI,mCAAA;AjCwinBhB;;AiCjinBQ;EACI,aAAA;AjCoinBZ;;AiC9hnBQ;EACI,4BAAA;AjCiinBZ;AiChinBY;EACI,kBAAA;EACA,4BAAA;AjCkinBhB;;AiC1hnBY;EACI,YAAA;EACA,0B9B1ZD;E8B2ZC,yB9B5JK;AHyrnBrB;AiC3hnBY;EACI,gBAAA;EACZ,0B9B/ZW;E8BgaC,sB9BtYR;AHm6nBR;;AiCrhnBY;EACI,uCAAA;EACA,wDAAA;AjCwhnBhB;AiCvhnBgB;EACI,uCAAA;EACA,W9BnZZ;AH46nBR;AiCthnBY;EACI,uCAAA;EACA,sBAAA;EACA,wDAAA;AjCwhnBhB;AiCphnBY;EACI,wCAAA;EACA,yDAAA;AjCshnBhB;AiCrhnBgB;EACI,wCAAA;EACA,W9BlaZ;AHy7nBR;AiCphnBY;EACI,wCAAA;EACA,sBAAA;EACA,yDAAA;AjCshnBhB;AiClhnBY;EACI,wCAAA;EACA,yDAAA;AjCohnBhB;AiCnhnBgB;EACI,wCAAA;EACA,W9BjbZ;AHs8nBR;AiClhnBY;EACI,wCAAA;EACA,sBAAA;EACA,yDAAA;AjCohnBhB;AiChhnBY;EACI,yCAAA;EACA,0DAAA;AjCkhnBhB;AiCjhnBgB;EACI,yCAAA;EACA,W9BhcZ;AHm9nBR;AiChhnBY;EACI,yCAAA;EACA,sBAAA;EACA,0DAAA;AjCkhnBhB;AiC9gnBY;EACI,wCAAA;EACA,yDAAA;AjCghnBhB;AiC/gnBgB;EACI,wCAAA;EACA,W9B/cZ;AHg+nBR;AiC9gnBY;EACI,wCAAA;EACA,sBAAA;EACA,yDAAA;AjCghnBhB;AiC5gnBY;EACI,uCAAA;EACA,wDAAA;AjC8gnBhB;AiC7gnBgB;EACI,uCAAA;EACA,W9B9dZ;AH6+nBR;AiC5gnBY;EACI,uCAAA;EACA,sBAAA;EACA,wDAAA;AjC8gnBhB;;AkC5hoBE;EACE,8CAAA;EACA,sCAAA;AlC+hoBJ;;AkC1hoBI;EACE,8CAAA;EACA,sCAAA;AlC6hoBN;;AkCvhoBI;EACE,c/B8PO;AH4xnBb;AkCvhoBI;EACE,c/BDI;AH0hoBV;;AkCrhoBA;EACE,c/BqPW;E+BpPX,YAAA;AlCwhoBF;;AkCrhoBE;EACE,c/BgPS;E+B/OT,gBAAA;EACA,qCAAA;AlCwhoBJ;;AkCphoBE;EACE,c/ByOS;E+BxOT,gBAAA;EACA,qCAAA;AlCuhoBJ;;AkCnhoBE;EACE,c/BkOS;E+BjOT,YAAA;AlCshoBJ;;AkClhoBE;EACE,c/B4NS;E+B3NT,YAAA;AlCqhoBJ;;AkCjhoBE;EACE,c/BsNS;E+BrNT,gBAAA;EACA,qCAAA;AlCohoBJ;;AkChhoBE;EACE,WAAA;EACA,aAAA;AlCmhoBJ;;AkChhoBA;EACE,kBAAA;EACA,kB/B2Qc;AHwwnBhB;AkCjhoBE;EACC,W/B9BK;AHijoBR;AkC/goBI;EACD,W/BnCK;AHojoBR;AkC/goBE;EACC,W/BtCK;E+BuCL,YAAA;AlCihoBH;AkC9goBM;EACE,W/B3CA;AH2joBR;AkC9goBG;EACC,W/B9CI;AH8joBR;;AkC3goBA;EACE,YAAA;AlC8goBF;;AkC3goBE;EACE,iBAAA;AlC8goBJ;;AmCjnoBA;EACI,mBAAA;EACA,sBhCyCI;EgCxCJ,gCAAA;EACA,kBAAA;EACA,kBhC8Ue;EgC7Uf,SAAA;EACA,8DhCoVY;EgCnVZ,cAAA;AnConoBJ;AmCnnoBI;EACI,aAAA;AnCqnoBR;AmCnnoBI;EACI,ehC2VO;EgC1VP,gBhCFW;EgCGX,0BAAA;AnCqnoBR;AmCnnoBI;EACI,qBhCoJI;EgCnJJ,kBAAA;EACA,uBAAA;EACA,aAAA;AnCqnoBR;AmCpnoBQ;EACI,mBAAA;AnCsnoBZ;AmCpnoBQ;EACI,sBAAA;EACA,mBAAA;EACA,gBAAA;AnCsnoBZ;AmCnnoBI;EACI,qBhCsII;EgCrIJ,uBAAA;EACA,0BAAA;AnCqnoBR;;AmCjnoBE;EACI,qBAAA;AnConoBN;;AmChnoBE;EACA,kBhCqSc;EgCpSd,SAAA;EACA,sBhCHM;EgCIN,kBAAA;EACA,wBAAA;EACA,WAAA;AnCmnoBF;AmClnoBE;EACE,qBAAA;EACA,wCAAA;EACA,mCAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AnConoBJ;AmCnnoBI;EACE,oCAAA;AnCqnoBN;AmCnnoBI;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBhCtDa;EgCuDb,0BAAA;AnCqnoBN;AmCpnoBM;EACE,mBAAA;EACA,uBAAA;AnCsnoBR;AmClnoBE;EACE,wCAAA;EACA,qCAAA;EACA,oBAAA;EACA,ehC1Ea;AH8roBjB;AmClnoBE;EACE,eAAA;EACA,chCwLS;AH47nBb;AmClnoBE;EACE,kBAAA;AnConoBJ;AmCjnoBE;EACE,mBAAA;AnCmnoBJ;AmCjnoBE;EACE,WAAA;EACA,YAAA;AnCmnoBJ;AmCjnoBE;EACE,kBAAA;EACA,gBAAA;EACA,+BAAA;AnCmnoBJ;AmClnoBI;EACE,oDAAA;AnConoBN;AmClnoBI;EACE,sDAAA;AnConoBN;AmClnoBI;EACE,SAAA;AnConoBN;AmClnoBI;EACE,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,oCAAA;EACA,kBAAA;AnConoBN;AmCjnoBE;EACE,yBhCnGM;EgCoGN,WhC7EI;AHgsoBR;AmClnoBI;EACE,qDAAA;EACA,WhChFE;EgCiFF,oDAAA;AnConoBN;AmCnnoBM;EACE,sBhCnFA;AHwsoBR;AmClnoBI;EACE,WhCvFE;AH2soBR;AmClnoBI;EACE,qDAAA;EACA,WhC3FE;EgC4FF,sDAAA;AnConoBN;AmCjnoBE;EACE,yBhCrHQ;EgCsHR,WhCjGI;AHotoBR;AmClnoBI;EACE,qDAAA;EACA,WhCpGE;EgCqGF,oDAAA;AnConoBN;AmCnnoBM;EACE,sBhCvGA;AH4toBR;AmClnoBI;EACE,WhC3GE;AH+toBR;AmClnoBI;EACE,qDAAA;EACA,WhC/GE;EgCgHF,sDAAA;AnConoBN;AmCjnoBE;EACE,yBhCnIM;EgCoIN,WhCrHI;AHwuoBR;AmClnoBI;EACE,qDAAA;EACA,WhCxHE;EgCyHF,oDAAA;AnConoBN;AmCnnoBM;EACE,sBhC3HA;AHgvoBR;AmClnoBI;EACE,WhC/HE;AHmvoBR;AmClnoBI;EACE,qDAAA;EACA,WhCnIE;EgCoIF,sDAAA;AnConoBN;AmCjnoBE;EACE,yBhCzJG;EgC0JH,WhCzII;AH4voBR;AmClnoBI;EACE,qDAAA;EACA,WhC5IE;EgC6IF,oDAAA;AnConoBN;AmCnnoBM;EACE,sBhC/IA;AHowoBR;AmClnoBI;EACE,WhCnJE;AHuwoBR;AmClnoBI;EACE,qDAAA;EACA,WhCvJE;EgCwJF,sDAAA;AnConoBN;AmCjnoBE;EACE,yBhC/KM;EgCgLN,WhC7JI;AHgxoBR;AmClnoBI;EACE,qDAAA;EACA,WhChKE;EgCiKF,oDAAA;AnConoBN;AmCnnoBM;EACE,sBhCnKA;AHwxoBR;AmClnoBI;EACE,WhCvKE;AH2xoBR;AmClnoBI;EACE,qDAAA;EACA,WhC3KE;EgC4KF,sDAAA;AnConoBN;AmCjnoBE;EACE,yBhC7LK;EgC8LL,WhCjLI;AHoyoBR;AmClnoBI;EACE,qDAAA;EACA,WhCpLE;EgCqLF,oDAAA;AnConoBN;AmCnnoBM;EACE,sBhCvLA;AH4yoBR;AmClnoBI;EACE,WhC3LE;AH+yoBR;AmClnoBI;EACE,qDAAA;EACA,WhC/LE;EgCgMF,sDAAA;AnConoBN;AmCjnoBE;EACE,yBhCtMI;EgCuMJ,chC0BS;AHyloBb;AmClnoBI;EACE,gDAAA;EACA,chCuBO;EgCtBP,yBhC9EM;AHksoBZ;AmClnoBI;EACE,chCmBO;AHimoBb;AmClnoBI;EACE,gDAAA;EACA,chCeO;EgCdP,2BhCtFM;AH0soBZ;AmCjnoBE;EACE,yBhChOG;EgCiOH,WhCtNI;AHy0oBR;AmClnoBI;EACE,qDAAA;EACA,WhCzNE;EgC0NF,oDAAA;AnConoBN;AmCnnoBM;EACE,sBhC5NA;AHi1oBR;AmClnoBI;EACE,WhChOE;AHo1oBR;AmClnoBI;EACE,qDAAA;EACA,WhCpOE;EgCqOF,sDAAA;AnConoBN;AmCjnoBE;EACE,kBAAA;EACA,MAAA;EACA,mBAAA;EACA,SAAA;EACA,qBAAA;EACA,UAAA;EACA,oBAAA;EACA,WAAA;AnCmnoBJ;AmCjnoBE;EACE,aAAA;AnCmnoBJ;AmChnoBI;EACE,cAAA;AnCknoBN;AmChnoBI;EACE,aAAA;AnCknoBN;AmC/moBE;EACE,eAAA;EACA,MAAA;EACA,qBAAA;EACA,qBAAA;EACA,SAAA;EACA,aAAA;EACA,SAAA;AnCinoBJ;;AmC9moBA;EACI,ehCiEW;EgChEX,chCvIO;AHwvoBX;;AmC/moBA;EACE,gBAAA;EACA,2BAAA;EACA,yBAAA;EACA,yBhCjRM;EgCkRN,0CAAA;AnCknoBF;;AmChnoBA;EACE,2CAAA;EACA,qCAAA;AnCmnoBF;;AmCjnoBA;EACE,0CAAA;EACA,oCAAA;AnConoBF;;AmClnoBA;EACE,yCAAA;EACA,mCAAA;AnCqnoBF;;AmCnnoBA;EACE,yBhChDS;EgCiDT,WhChSM;EgCiSN,yBAAA;AnCsnoBF;AmCrnoBE;EAGE,oCAAA;EACA,sBAAA;EACA,oCAAA;AnCqnoBJ;;AmClnoBA;EACE,mBAAA;EAiBA,mGAAA;EAQA,mHAAA;EACA,WhCrUM;EgCsUN,6BAAA;AnCgmoBF;AmC/loBE;EAGE,WhC1UI;EgC2UJ,6BAAA;AnC+loBJ;;AmC5loBA;EACE,yBhC/FQ;EgCgGR,WhChVM;EgCiVN,yBAAA;AnC+loBF;AmC9loBE;EAGE,oCAAA;EACA,sBAAA;EACA,oCAAA;AnC8loBJ;;AmC3loBA;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AnC8loBJ;;AmC5loBA;EACI,gCAAA;AnC+loBJ;;AmC5loBA;EAEM;IACI,8BAAA;EnC8loBR;AACF;AmC3loBA;EAEM;IACI,8BAAA;EnC4loBR;AACF;AoCp/oBI;EACE,yBjCiBI;AHq+oBV;AoCp/oBI;EAEE,yBjCaI;AHw+oBV;AoCn/oBI;EAEE,2BjCSI;AH2+oBV;AoCl/oBI;EAEE,0BjCKI;AH8+oBV;AoCj/oBI;EAEE,4BjCCI;AHi/oBV;AoCngpBI;EACE,yBjCmBM;AHk/oBZ;AoCngpBI;EAEE,yBjCeM;AHq/oBZ;AoClgpBI;EAEE,2BjCWM;AHw/oBZ;AoCjgpBI;EAEE,0BjCOM;AH2/oBZ;AoChgpBI;EAEE,4BjCGM;AH8/oBZ;AoClhpBI;EACE,yBjCyBI;AH2/oBV;AoClhpBI;EAEE,yBjCqBI;AH8/oBV;AoCjhpBI;EAEE,2BjCiBI;AHigpBV;AoChhpBI;EAEE,0BjCaI;AHogpBV;AoC/gpBI;EAEE,4BjCSI;AHugpBV;AoCjipBI;EACE,yBjCuBC;AH4gpBP;AoCjipBI;EAEE,yBjCmBC;AH+gpBP;AoChipBI;EAEE,2BjCeC;AHkhpBP;AoC/hpBI;EAEE,0BjCWC;AHqhpBP;AoC9hpBI;EAEE,4BjCOC;AHwhpBP;AoChjpBI;EACE,yBjCqBI;AH6hpBV;AoChjpBI;EAEE,yBjCiBI;AHgipBV;AoC/ipBI;EAEE,2BjCaI;AHmipBV;AoC9ipBI;EAEE,0BjCSI;AHsipBV;AoC7ipBI;EAEE,4BjCKI;AHyipBV;AoC/jpBI;EACE,yBjC2BG;AHsipBT;AoC/jpBI;EAEE,yBjCuBG;AHyipBT;AoC9jpBI;EAEE,2BjCmBG;AH4ipBT;AoC7jpBI;EAEE,0BjCeG;AH+ipBT;AoC5jpBI;EAEE,4BjCWG;AHkjpBT;AoC9kpBI;EACE,yBjC6BC;AHmjpBP;AoC9kpBI;EAEE,yBjCyBC;AHsjpBP;AoC7kpBI;EAEE,2BjCqBC;AHyjpBP;AoC5kpBI;EAEE,0BjCiBC;AH4jpBP;AoC3kpBI;EAEE,4BjCaC;AH+jpBP;AoCrjpBI;EACE,WAAA;ApCujpBN;AoChmpBI;EACE,yBjCsCE;AH4jpBR;AoChmpBI;EAEE,yBjCkCE;AH+jpBR;AoC/lpBI;EAEE,2BjC8BE;AHkkpBR;AoC9lpBI;EAEE,0BjC0BE;AHqkpBR;AoC7lpBI;EAEE,4BjCsBE;AHwkpBR;AoCjkpBI;EACE,cjCyNO;AH02oBb;;AqCpnpBA;EACI,yBAAA;ArCunpBJ;AqCtnpBI;EACE,oBAAA;ArCwnpBN;;AqCrnpBE;EACE,clCmQS;EkClQT,kBlCyUY;EkCxUZ,gBlCEmB;AHsnpBvB;AqCvnpBI;EACE,uCAAA;EACA,clCQI;AHinpBV;;AqCtnpBE;EACE,clC0PS;AH+3oBb;AqCxnpBI;EACE,clCwPO;EkCvPP,YAAA;ArC0npBN;;AqCvnpBE;;EAEE,clCJM;AH8npBV;;AqCxnpBE;EACE,clC+OS;EkC9OT,YAAA;ArC2npBJ;;AqCznpBE;EACE,4BAAA;ArC4npBJ;;AqC1npBE;EACE,clCwOS;AHq5oBb;;AqCznpBM;;EAEE,WlCGA;AHynpBR;AqCznpBI;;EAEE,WlCFE;AH6npBR;;AqCxnpBE;;EAEE,WlCPI;EkCQJ,yBlC/BM;AH0ppBV;;AqCxnpBA;EACE,SAAA;ArC2npBF;AqC1npBE;EACE,0BAAA;ArC4npBJ;AqC3npBI;EACE,oBAAA;ArC6npBN;AqCznpBI;EACI,uCAAA;EACA,clC7CE;AHwqpBV;AqC1npBQ;EACE,iCAAA;ArC4npBV;AqCznpBI;EACI,uBAAA;EACA,clCpDE;AH+qpBV;;AqCtnpBE;EACE,yCAAA;ArCynpBJ;AqCxnpBI;EACE,uCAAA;EACA,qCAAA;EACA,clC9DI;AHwrpBV;;AqCrnpBE;EACE,gBAAA;ArCwnpBJ;AqCtnpBE;EACE,uCAAA;ArCwnpBJ;AqCtnpBE;EACE,6BAAA;EACA,mCAAA;EACA,clC5EM;AHospBV;;AqCrnpBA;EACE,SAAA;ArCwnpBF;AqCvnpBE;EACE,clCyKS;EkCxKT,SAAA;ArCynpBJ;AqCvnpBE;EACE,kBAAA;ArCynpBJ;AqCxnpBI;EACE,yBlCnEE;EkCoEF,clC6JO;EkC5JP,SAAA;ArC0npBN;AqCxnpBI;EAEE,SAAA;ArCynpBN;AqCvnpBI;EACI,yBlC5EA;EkC6EA,clCoJK;AHq+oBb;;AqCrnpBA;EACE,SAAA;ArCwnpBF;AqCvnpBE;EACE,clCkJS;EkCjJT,SAAA;EACA,kBAAA;ArCynpBJ;AqCtnpBI;EACE,yBlC/GI;EkCgHJ,WlCzFE;EkC0FF,SAAA;ArCwnpBN;AqCtnpBI;EAEE,SAAA;EACA,yBlCtHI;EkCuHJ,WlChGE;AHutpBR;;AqCnnpBA;EACE,SAAA;ArCsnpBF;AqCpnpBI;EACE,yBAAA;EACA,mCAAA;EACA,6BAAA;EACA,clClII;AHwvpBV;;AqClnpBA;EACE,oBAAA;ArCqnpBF;AqCpnpBE;EACE,yBAAA;ArCsnpBJ;AqCrnpBI;EACE,oBAAA;ArCunpBN;AqCrnpBI;EACE,6BAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBlC3Je;AHkxpBrB;AqCtnpBM;EACE,iCAAA;EACA,clCpJE;EkCqJF,6BAAA;ArCwnpBR;AqCtnpBM;EACE,6BAAA;EACA,6BAAA;EACA,clC1JE;AHkxpBV;;AqCnnpBA;EACE,SAAA;ArCsnpBF;AqCrnpBE;EACE,yBAAA;ArCunpBJ;AqCtnpBI;EACE,oBAAA;ArCwnpBN;AqCtnpBI;EACE,6BAAA;EACA,clCxKI;EkCyKJ,yBAAA;EACA,iBAAA;ArCwnpBN;AqCvnpBM;EACE,mBlC5KE;EkC6KF,WlCtJA;EkCuJA,yBAAA;ArCynpBR;AqCvnpBM;EACE,yBAAA;EACA,6BAAA;EACC,clCnLC;AH4ypBV;;AqCpnpBA;EACE,SAAA;ArCunpBF;AqCtnpBE;EACE,yBAAA;ArCwnpBJ;AqCvnpBI;EACE,oBAAA;ArCynpBN;AqCvnpBI;EACE,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,clCsDO;EkCrDP,yBlCjLE;AH0ypBR;AqCxnpBM;EACE,eAAA;ArC0npBR;AqCxnpBM;EACE,yBlC3ME;EkC4MF,WlCrLA;EkCsLA,kBAAA;ArC0npBR;AqCznpBQ;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,wBAAA;EACA,WAAA;EACA,YAAA;EACA,yBlCtNA;AHi1pBV;AqCznpBQ;EACE,WlClMF;AH6zpBR;AqCxnpBM;EACE,clC7NE;AHu1pBV;;AqCrnpBA;EACE,SAAA;ArCwnpBF;AqCvnpBE;EACE,SAAA;EACA,yBAAA;ArCynpBJ;AqCxnpBI;EACE,oBAAA;ArC0npBN;AqCxnpBI;EACE,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,wBAAA;ArC0npBN;AqCznpBM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBlCtPE;EkCuPF,WlChOA;EkCiOA,uBAAA;EACA,gBlCnQa;AH83pBrB;AqCznpBM;EACE,mBlC5PE;EkC6PF,yBAAA;EACA,WlCvOA;AHk2pBR;AqC1npBQ;EACE,mBlChQA;EkCiQA,yBAAA;EACA,WlC3OF;AHu2pBR;AqC1npBQ;EACE,gBlC9OF;EkC+OE,clCtQA;AHk4pBV;AqCznpBM;EACE,yBAAA;EACA,clC3QE;EkC4QA,uBAAA;ArC2npBV;;AqCtnpBA;EACE,mBAAA;EACA,gBAAA;EACA,yBlC/PM;EkCgQN,kBAAA;EACA,sBAAA;ArCynpBF;AqCxnpBE;EACE,yBAAA;ArC0npBJ;AqCznpBI;EACE,oBAAA;ArC2npBN;AqCxnpBE;EACE,kBAAA;EACA,qBAAA;ArC0npBJ;AqCznpBI;EACE,oCAAA;EACA,sBAAA;EACA,8DlCmCO;EkClCP,+BAAA;ArC2npBN;;AqCrnpBQ;EACA,uBAAA;EACA,clC5SE;AHo6pBV;;AqClnpBA;EACE,mBAAA;ArCqnpBF;AqCpnpBE;EACE,yBAAA;ArCsnpBJ;AqCrnpBI;EACE,oBAAA;ArCunpBN;AqCrnpBI;EACE,SAAA;ArCunpBN;AqCtnpBM;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBlC3SA;EkC4SA,clC3EK;EkC4EL,qBAAA;ArCwnpBR;AqCtnpBM;EACE,SAAA;EACA,uBAAA;EACA,clCvUE;AH+7pBV;AqCvnpBQ;EACE,clCzUA;AHk8pBV;AqCtnpBM;EACE,6BAAA;EACA,kBAAA;EACA,SAAA;EACA,clChVE;AHw8pBV;AqCvnpBQ;EACE,uCAAA;EACA,clCnVA;AH48pBV;AqCvnpBQ;EACE,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,yBlC7VA;EkC8VA,mBAAA;ArCynpBV;;AqCnnpBA;EACE,mBAAA;ArCsnpBF;AqCrnpBE;EACE,kBAAA;EACA,yBAAA;ArCunpBJ;AqCtnpBI;EACE,oBAAA;ArCwnpBN;AqCtnpBI;EACE,kBAAA;EACA,SAAA;EACA,kBAAA;ArCwnpBN;AqCvnpBM;EACE,kBAAA;EACA,WAAA;EACA,0BAAA;EACA,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;EACA,yBlCnWA;EkCoWA,kBAAA;ArCynpBR;AqCvnpBM;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBlChXA;EkCiXA,kBAAA;EACA,yBAAA;ArCynpBR;AqCvnpBM;EACE,YAAA;ArCynpBR;AqCvnpBM;EACE,YAAA;ArCynpBR;AqCvnpBM;EACE,YAAA;ArCynpBR;AqCvnpBM;EACE,SAAA;EACA,uBAAA;EACA,clCvZE;AHghqBV;AqCvnpBM;EACE,6BAAA;EACA,SAAA;EACA,clC5ZE;AHqhqBV;AqCxnpBQ;EACE,yBlC9ZA;AHwhqBV;AqCxnpBQ;EACE,qBlCjaA;EkCkaA,clClaA;AH4hqBV;;AqCnnpBE;EACE,SAAA;ArCsnpBJ;AqCrnpBI;EACE,yBAAA;ArCunpBN;AqCtnpBM;EACE,oBAAA;ArCwnpBR;AqCrnpBI;EACE,SAAA;ArCunpBN;AqCtnpBM;EACE,SAAA;EACA,uBAAA;EACA,clCtbE;AH8iqBV;AqCtnpBM;EACE,6BAAA;EACA,SAAA;EACA,clC3bE;EkC4bF,kBAAA;EACA,gBAAA;ArCwnpBR;AqCvnpBQ;EACE,kBAAA;EACA,WAAA;EACA,cAAA;EACA,uBAAA;EACA,wBAAA;EACA,uBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,yBlCxcA;EkCycA,yBAAA;ArCynpBV;AqCvnpBQ;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBlCldA;AH2kqBV;;AqCnnpBA;EACE,yBAAA;EACA,yBlC1dQ;EkC2dR,WlCpcM;EkCqcN,aAAA;EACE,kBAAA;ArCsnpBJ;;AqCnnpBE;EACE,yBAAA;ArCsnpBJ;AqCrnpBI;EACE,oBAAA;ArCunpBN;AqCrnpBI;EACE,mBlCteI;AH6lqBV;;AqCnnpBA;EACE,SAAA;EACA,sBlCrdM;EkCsdN,kBAAA;EACA,clC9eQ;EkC+eR,eAAA;ArCsnpBF;AqCrnpBE;EACE,SAAA;EACA,yBAAA;ArCunpBJ;AqCtnpBI;EACE,oBAAA;ArCwnpBN;AqCtnpBI;EACE,clCvfI;EkCwfJ,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBlCrgBe;EkCwgBf,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;ArCwnpBN;AqCvnpBM;EACE,SAAA;EACA,yBlCpgBE;EkCqgBF,WlC9eA;EkC+eA,SAAA;EACA,wDAAA;ArCynpBR;AqCvnpBM;EAEE,SAAA;ArCwnpBR;;AqClnpBE;EACE,wBAAA;EACA,mBAAA;EACA,clCzRS;EkC0RT,gBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;ArCqnpBJ;AqCpnpBI;EAEE,uCAAA;EACA,clC/hBI;AHopqBV;;AqC9mpBM;EACE,uCAAA;EACA,clCxiBE;AHypqBV;;AqC5mpBA;EAEI;IACE,sBAAA;ErC8mpBJ;AACF;AqC1mpBA;EACI,gBAAA;ArC4mpBJ;AqC1mpBQ;EACI,mBAAA;ArC4mpBZ;AqCzmpBI;EACI,mBAAA;EACA,eAAA;EACA,6BAAA;EACA,+BAAA;EACA,gCAAA;ArC2mpBR;AqC1mpBQ;EACE,qBlC5aC;AHwhqBX;AqCxmpBQ;EACI,clC9aD;EkC+aC,wBAAA;ArC0mpBZ;AqCzmpBY;EACI,yBAAA;EACA,4BlC5kBN;EkC6kBM,6BAAA;EjCtgBd,yBiCugBkC;ArC6mpBpC;;AqCvmpBI;EACI,sBlC9jBA;EkC+jBA,SAAA;ArC0mpBR;AqCzmpBQ;EACI,yBlCxlBF;EkCylBE,qBlCzlBF;EkC0lBE,WlCnkBJ;AH8qqBR;;AqCrmpBQ;EACI,yBAAA;EACA,clClmBF;AH0sqBV;AqCnmpBY;EACI,uBAAA;ArCqmpBhB;AqCpmpBgB;EACI,yBlC1mBV;EC2GR,gBiCggBmC;ArCsmpBrC;AqCpmpBgB;EACI,yBlC9mBV;EkC+mBU,6BAAA;EjCpgBlB,gBiCqgBmC;ArCsmpBrC;AqC/lpBY;EACI,uBAAA;ArCimpBhB;AqChmpBgB;EACI,4BlC1nBV;EkC2nBU,uBAAA;EjChhBlB,gBiCihBmC;ArCkmpBrC;AqC7lpBI;EACI,sBlC3mBA;EkC4mBA,SAAA;ArC+lpBR;AqC3lpBoB;EACI,yBlCxoBd;EkCyoBc,qBlCzoBd;EkC0oBc,WlCnnBhB;ECoFN,mBiCgiBuC;ArC6lpBzC;AqCtlpBgB;EACI,yBlCnpBV;EkCopBU,qBlCppBV;EkCqpBU,WlC9nBZ;ECoFN,gBiC2iBmC;ArCwlpBrC;;AqCjlpBI;EACI,clC9pBE;AHkvqBV;;AqC9kpBY;EACI,elClVD;AHm6pBf;;AqC3kpBI;EACI,gBAAA;EACA,mBAAA;ArC8kpBR;AqC7kpBQ;EACI,clC7qBA;ECkFT,iBiC4lBuC;EAC9B,elC9VG;EkC+VH,gBlC1rBO;EkC2rBP,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mDAAA;ArC+kpBZ;AqC7kpBY;EACI,yBAAA;ArC+kpBhB;AqC7kpBY;EACI,yBAAA;ArC+kpBhB;AqC7kpBY;EACI,SAAA;EACA,gCAAA;EACA,mBlClsBN;EkCmsBM,WlC5qBR;AH2vqBR;;AqCzkpBI;EACI,gBAAA;EjCvnBL,gBiCwnB6B;ArC4kpBhC;AqC3kpBQ;EACI,WlCrrBJ;EkCsrBI,elC9tBK;EkC+tBL,gBlCvtBO;EkCwtBP,SAAA;EACA,mBlC1jBD;EkC2jBC,kBAAA;EjC9nBT,iBiC+nBuC;EjCxmBxC,kBiCymB2B;EjC7oB3B,yBiC8oB8B;ArC+kpBhC;AqC9kpBY;EACI,mBlCvtBN;EkCwtBM,WlCjsBR;AHixqBR;;AI/wqBI;EiCqsBA;IACI,gBAAA;IACA,kBAAA;IACA,sBlC1sBA;IC6DL,ciC8oBmC;IjCvnBpC,kBiCwnBuB;ErC8kpBvB;AACF;AsCt0qBA;EACE,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,WnCuCM;EmCtCN,UAAA;AtCw0qBF;AsCv0qBE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,2CAAA;EACA,yCAAA;EACA,sCAAA;AtCy0qBJ;AsCv0qBE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBnCWK;EmCVL,enCiVW;EmChVX,cAAA;EACA,sBAAA;EACA,4BAAA;AtCy0qBJ;AsCx0qBI;EAEE,kBAAA;EACA,WAAA;AtCy0qBN;AsCv0qBI;EACE,WAAA;EACA,UAAA;EACA,wBAAA;EACA,oBAAA;EACA,mBnCJG;AH60qBT;AsCv0qBI;EACE,WAAA;EACA,UAAA;EACA,wBAAA;EACA,oBAAA;EACA,0BAAA;EACA,mBnCZG;AHq1qBT;;AsCr0qBA;EACE,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,WnCRM;EmCSN,YAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AtCw0qBF;AsCv0qBE;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;AtCy0qBJ;AsCv0qBE;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;AtCy0qBJ;AsCv0qBE;EACE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,cAAA;EACA,yCAAA;EACA,WnClCI;EmCmCJ,yCAAA;EACA,0BAAA;EACA,kBAAA;EACA,eAAA;AtCy0qBJ;;AsCt0qBA;EACE,kBAAA;EACA,yBAAA;EACA,wBAAA;EACA,UAAA;AtCy0qBF;AsCx0qBE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,2CAAA;EACA,yCAAA;EACA,sCAAA;AtC00qBJ;AsCx0qBE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBnCxEK;EmCyEL,enC8PW;EmC7PX,cAAA;EACA,sBAAA;EACA,4BAAA;AtC00qBJ;AsCz0qBI;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,wBAAA;EACA,oBAAA;EACA,0BAAA;EACA,mBnCrFG;AHg6qBT;AsCz0qBI;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,wBAAA;EACA,oBAAA;EACA,mBnC9FG;AHy6qBT;;AsCv0qBA;EACE,WnCtFM;EmCuFN,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,qBAAA;EACA,UAAA;EACA,eAAA;AtC00qBF;;AsCv0qBE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,0CAAA;EACA,uCAAA;EACA,wCAAA;EACA,QAAA;AtC00qBJ;;AsCt0qBE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,2CAAA;EACA,uCAAA;EACA,wCAAA;EACA,QAAA;AtCy0qBJ;;AsCr0qBE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,0CAAA;EACA,wCAAA;EACA,QAAA;AtCw0qBJ;;AsCp0qBE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,0CAAA;EACA,uCAAA;EACA,wCAAA;EACA,QAAA;AtCu0qBJ;;AsCn0qBE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,0CAAA;EACA,uCAAA;EACA,wCAAA;EACA,QAAA;AtCs0qBJ;;AsCl0qBE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,0CAAA;EACA,uCAAA;EACA,wCAAA;EACA,QAAA;AtCq0qBJ;;AsCj0qBE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,0CAAA;EACA,uCAAA;EACA,wCAAA;EACA,QAAA;AtCo0qBJ;;AsCh0qBE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,0CAAA;EACA,uCAAA;EACA,wCAAA;EACA,QAAA;AtCm0qBJ;;AsC/zqBE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,QAAA;AtCk0qBJ;;AsC/zqBA;EACE,WnC5NM;EmC6NN,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,eAAA;AtCk0qBF;;AsC/zqBE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,QAAA;AtCk0qBJ;;AsC9zqBE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,QAAA;AtCi0qBJ;;AsC7zqBE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,wCAAA;EACA,QAAA;AtCg0qBJ;;AsC5zqBE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,QAAA;AtC+zqBJ;;AsC3zqBE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,QAAA;AtC8zqBJ;;AsC1zqBE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,QAAA;AtC6zqBJ;;AsCzzqBE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,QAAA;AtC4zqBJ;;AsCxzqBE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,QAAA;AtC2zqBJ;;AsCvzqBE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,QAAA;AtC0zqBJ;;AsCvzqBA;EACE,WnClWM;EmCmWN,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,wBAAA;EACA,UAAA;EACA,enCrCa;AH+1qBf;AsCzzqBE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,0CAAA;EACA,wCAAA;EACA,QAAA;AtC2zqBJ;;AsCxzqBA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AtC2zqBF;AsC1zqBE;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,cAAA;EACA,WnChYI;EmCiYJ,iCAAA;EACA,yCAAA;EACA,0BAAA;EACA,kBAAA;AtC4zqBJ;;AsCzzqBA;EACE,uBAAA;EACA,wBAAA;AtC4zqBF;AsC3zqBE;EACE,sBAAA;EACA,sBAAA;EACA,yBAAA;AtC6zqBJ;AsC5zqBI;EACE,wBAAA;EACA,wBAAA;EACA,yBAAA;AtC8zqBN;;AsC1zqBA;EACE,qBAAA;EACA,wBAAA;AtC6zqBF;AsC5zqBE;EACE,sBAAA;EACA,oBAAA;EACA,wBAAA;AtC8zqBJ;AsC7zqBI;EACE,yBAAA;EACA,sBAAA;EACA,yBAAA;AtC+zqBN;;AsC3zqBA;EACE,uBAAA;EACA,sBAAA;AtC8zqBF;AsC7zqBE;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AtC+zqBJ;AsC9zqBI;EACE,yBAAA;EACA,wBAAA;EACA,uBAAA;AtCg0qBN;;AsC5zqBA;EACE,qBAAA;EACA,sBAAA;AtC+zqBF;AsC9zqBE;EACE,wBAAA;EACA,oBAAA;EACA,yBAAA;AtCg0qBJ;AsC/zqBI;EACE,wBAAA;EACA,sBAAA;EACA,uBAAA;AtCi0qBN;;AsC7zqBA;EACE,wBAAA;EACA,yBAAA;AtCg0qBF;AsC/zqBE;EACE,qCAAA;EACA,sCAAA;EACA,qBAAA;EACA,qBAAA;AtCi0qBJ;AsC/zqBE;EACE,qCAAA;EACA,sCAAA;EACA,oBAAA;EACA,sBAAA;AtCi0qBJ;AsC/zqBE;EACE,qBAAA;EACA,uBAAA;EACA,yBAAA;AtCi0qBJ;;AsC9zqBA;EACE,wBAAA;EACA,uBAAA;AtCi0qBF;AsCh0qBE;EACE,qCAAA;EACA,oCAAA;EACA,qBAAA;EACA,mBAAA;AtCk0qBJ;AsCh0qBE;EACE,qCAAA;EACA,oCAAA;EACA,oBAAA;EACA,wBAAA;AtCk0qBJ;AsCh0qBE;EACE,uBAAA;EACA,uBAAA;EACA,wBAAA;AtCk0qBJ;;AsC/zqBA;EACE,kBAAA;EACA,uBAAA;EACA,sBAAA;EACA,WnC7eM;AH+yrBR;AsCj0qBE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,2CAAA;EACA,yCAAA;EACA,sCAAA;EACA,UAAA;AtCm0qBJ;AsCj0qBE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBnC3gBM;EmC4gBN,eAAA;EACA,cAAA;EACA,qBAAA;EACA,6BAAA;EACA,UAAA;AtCm0qBJ;AsCl0qBI;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,mBnCrhBI;EmCshBJ,WAAA;EACA,WAAA;EACA,wBAAA;EACA,oBAAA;EACA,+BAAA;EACA,0BAAA;EACA,0BAAA;EACA,wBAAA;AtCo0qBN;AsCl0qBI;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,sBAAA;EACA,mBnCtiBI;AH02rBV;AsCj0qBE;EACE,WnC3hBI;EmC4hBJ,enChOW;EmCiOX,yBAAA;EACA,uBAAA;AtCm0qBJ;;AsCh0qBA;EACE,kBAAA;EACA,uBAAA;EACA,sBAAA;EACA,WnCriBM;AHw2rBR;AsCl0qBE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,2CAAA;EACA,yCAAA;EACA,sCAAA;EACA,UAAA;AtCo0qBJ;AsCl0qBE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBnCjkBK;EmCkkBL,eAAA;EACA,cAAA;EACA,qBAAA;EACA,6BAAA;EACA,UAAA;AtCo0qBJ;AsCn0qBI;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,mBnC3kBG;EmC4kBH,WAAA;EACA,WAAA;EACA,wBAAA;EACA,oBAAA;EACA,+BAAA;EACA,0BAAA;EACA,0BAAA;EACA,wBAAA;AtCq0qBN;AsCn0qBI;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,sBAAA;EACA,mBnC5lBG;AHi6rBT;AsCl0qBE;EACE,WnCnlBI;EmColBJ,enCxRW;EmCyRX,yBAAA;EACA,uBAAA;AtCo0qBJ;;AsCj0qBA;EACE,kBAAA;EACA,uBAAA;EACA,wBAAA;EACA,WnC7lBM;AHi6rBR;AsCn0qBE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,2CAAA;EACA,yCAAA;EACA,sCAAA;EACA,UAAA;AtCq0qBJ;AsCn0qBE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBnC/nBM;EmCgoBN,eAAA;EACA,cAAA;EACA,qBAAA;EACA,+BAAA;EACA,UAAA;AtCq0qBJ;AsCp0qBI;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,mBnCzoBI;EmC0oBJ,WAAA;EACA,WAAA;EACA,sBAAA;EACA,oBAAA;EACA,4BAAA;EACA,6BAAA;EACA,0BAAA;EACA,wBAAA;AtCs0qBN;AsCp0qBI;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBnC1pBI;AHg+rBV;AsCn0qBE;EACE,WnC3oBI;EmC4oBJ,enChVW;EmCiVX,yBAAA;EACA,uBAAA;AtCq0qBJ;;AsCl0qBA;EACE,kBAAA;EACA,uBAAA;EACA,wBAAA;EACA,WnCrpBM;AH09rBR;AsCp0qBE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,2CAAA;EACA,yCAAA;EACA,sCAAA;EACA,UAAA;AtCs0qBJ;AsCp0qBE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBnCrrBG;EmCsrBH,eAAA;EACA,cAAA;EACA,qBAAA;EACA,+BAAA;EACA,UAAA;AtCs0qBJ;AsCr0qBI;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,mBnC/rBC;EmCgsBD,WAAA;EACA,WAAA;EACA,sBAAA;EACA,oBAAA;EACA,4BAAA;EACA,6BAAA;EACA,0BAAA;EACA,wBAAA;AtCu0qBN;AsCr0qBI;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBnChtBC;AHuhsBP;AsCp0qBE;EACE,WnCnsBI;EmCosBJ,enCxYW;EmCyYX,yBAAA;EACA,uBAAA;AtCs0qBJ;;AsCn0qBA;EACE,kBAAA;EACA,wBAAA;EACA,WnC5sBM;AHkhsBR;AsCr0qBE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,uCAAA;EACA,qCAAA;EACA,wCAAA;AtCu0qBJ;AsCr0qBE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBnC/uBM;EmCgvBN,eAAA;EACA,cAAA;EACA,sBAAA;EACA,UAAA;AtCu0qBJ;AsCr0qBE;EACE,WnCnuBI;EmCouBJ,enCxaW;EmCyaX,yBAAA;EACA,uBAAA;AtCu0qBJ;;AsCp0qBA;EACE,kBAAA;EACA,wBAAA;EACA,WnC5uBM;EmC6uBN,WAAA;AtCu0qBF;AsCt0qBE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,uCAAA;EACA,qCAAA;EACA,uCAAA;AtCw0qBJ;AsCt0qBE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBnC1wBK;EmC2wBL,eAAA;EACA,cAAA;EACA,iBAAA;EACA,UAAA;AtCw0qBJ;AsCt0qBE;EACE,WnCpwBI;EmCqwBJ,enCzcW;EmC0cX,yBAAA;EACA,uBAAA;AtCw0qBJ;;AsCr0qBA;EACE,kBAAA;EACA,sBAAA;EACA,WnC7wBM;EmC8wBN,WAAA;AtCw0qBF;AsCv0qBE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,uCAAA;EACA,qCAAA;EACA,uCAAA;AtCy0qBJ;AsCv0qBE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBnCnzBQ;EmCozBR,eAAA;EACA,cAAA;EACA,iBAAA;EACA,UAAA;AtCy0qBJ;AsCv0qBE;EACE,WnCryBI;EmCsyBJ,enC1eW;EmC2eX,yBAAA;EACA,uBAAA;AtCy0qBJ;;AsCt0qBA;EACE,kBAAA;EACA,uBAAA;EACA,WnC9yBM;AHunsBR;AsCx0qBE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,oBAAA;EACA,sBAAA;EACA,sCAAA;EACA,oCAAA;EACA,wCAAA;AtC00qBJ;AsCx0qBE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBnCl1BM;EmCm1BN,eAAA;EACA,iBAAA;EACA,UAAA;EACA,YAAA;AtC00qBJ;AsCx0qBE;EACE,WnCt0BI;EmCu0BJ,enC3gBW;EmC4gBX,yBAAA;EACA,uBAAA;AtC00qBJ;;AsCv0qBA;EACE,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WnCh1BM;AH0psBR;AsCz0qBE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,oBAAA;EACA,wBAAA;EACA,sCAAA;EACA,oCAAA;EACA,0CAAA;AtC20qBJ;AsCz0qBE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBnCx3BM;EmCy3BN,eAAA;EACA,iBAAA;EACA,UAAA;EACA,YAAA;AtC20qBJ;AsCz0qBE;EACE,WnCx2BI;EmCy2BJ,enC7iBW;EmC8iBX,yBAAA;EACA,uBAAA;AtC20qBJ;;AsCt0qBI;EACE,kBAAA;EACA,WAAA;AtCy0qBN;;AsCr0qBA;EACE,WnCv3BM;EmCw3BN,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,enC7jBa;AHq4rBf;AsCv0qBE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,0CAAA;EACA,uCAAA;EACA,wCAAA;EACA,QAAA;AtCy0qBJ;;AsCt0qBA;EACE,gBAAA;AtCy0qBF;;AsCt0qBE;EACE,WnC94BI;EmC+4BJ,yBnCt6BM;EmCu6BN,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,qCAAA;AtCy0qBJ;AsCx0qBI;EACE,kBAAA;AtC00qBN;AsCz0qBM;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,uBAAA;EACA,wBAAA;AtC20qBR;AsCz0qBM;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,uBAAA;EACA,sBAAA;AtC20qBR;AsCz0qBM;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,iDAAA;EACA,iCnCp8BE;EmCq8BF,gCnCr8BE;EmCs8BF,+BnCt8BE;EmCu8BF,sCAAA;EACA,yBAAA;AtC20qBR;AsCz0qBM;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,iCnC/8BE;EmCg9BF,oCAAA;EACA,+BnCj9BE;EmCk9BF,kCnCl9BE;EmCm9BF,uBAAA;AtC20qBR;;AsCr0qBE;EACE,WnCn8BI;EmCo8BJ,yBnCz9BQ;EmC09BR,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,qCAAA;AtCw0qBJ;AsCv0qBI;EACE,kBAAA;AtCy0qBN;AsCx0qBM;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,uBAAA;EACA,wBAAA;AtC00qBR;AsCx0qBM;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,uBAAA;EACA,sBAAA;AtC00qBR;AsCx0qBM;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,iCnCt/BI;EmCu/BJ,gCnCv/BI;EmCw/BJ,+BnCx/BI;EmCy/BJ,sCAAA;EACA,yBAAA;AtC00qBR;AsCx0qBM;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,iCnCjgCI;EmCkgCJ,oCAAA;EACA,+BnCngCI;EmCogCJ,kCnCpgCI;EmCqgCJ,uBAAA;AtC00qBR;;AsCp0qBE;EACE,WnCv/BI;EmCw/BJ,yBnCvgCM;EmCwgCN,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,qCAAA;AtCu0qBJ;AsCt0qBI;EACE,kBAAA;AtCw0qBN;AsCv0qBM;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,uBAAA;EACA,wBAAA;AtCy0qBR;AsCv0qBM;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,uBAAA;EACA,sBAAA;AtCy0qBR;AsCv0qBM;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,iCnCpiCE;EmCqiCF,gCnCriCE;EmCsiCF,+BnCtiCE;EmCuiCF,sCAAA;EACA,yBAAA;AtCy0qBR;AsCv0qBM;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,0CAAA;EACA,uCAAA;EACA,wCAAA;EACA,8BAAA;EACA,uBAAA;EACA,uBAAA;AtCy0qBR;;AsCn0qBE;EACE,WnC5iCI;EmC6iCJ,yBnC1jCK;EmC2jCL,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,qCAAA;AtCs0qBJ;AsCr0qBI;EACE,kBAAA;AtCu0qBN;AsCt0qBM;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,uBAAA;EACA,sBAAA;AtCw0qBR;AsCt0qBM;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,uBAAA;EACA,wBAAA;AtCw0qBR;AsCt0qBM;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,iCnCvlCC;EmCwlCD,oCAAA;EACA,+BnCzlCC;EmC0lCD,kCnC1lCC;EmC2lCD,uBAAA;AtCw0qBR;AsCt0qBM;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,gCAAA;EACA,yBAAA;EACA,uBAAA;AtCw0qBR;;AsCj0qBI;EACE,WAAA;EACA,YAAA;AtCo0qBN;;AsC/zqBE;EACE,aAAA;AtCk0qBJ;;AsC9zqBE;EACE,WAAA;EACA,YAAA;AtCi0qBJ;;AsC7zqBE;EACE,WAAA;EACA,YAAA;AtCg0qBJ;;AsC5zqBE;EACE,WAAA;EACA,YAAA;AtC+zqBJ;;AsC3zqBE;EACE,WAAA;EACA,YAAA;AtC8zqBJ;;AsC1zqBE;EACE,cnC/9BS;EmCg+BT,mBnCx+BS;AHqysBb;;AsCzzqBE;EACE,mBnCv/BU;EmCw/BV,cnCj/BU;AH6ysBd;;AsCzzqBA;EACE;IACE,8BAAA;EtC4zqBF;AACF;AsCzzqBE;EACE,wBAAA;AtC2zqBJ;AsCxzqBE;EACE,yBAAA;AtC0zqBJ;AsCvzqBE;EACE,yBAAA;AtCyzqBJ;AsCtzqBE;EACE,wBAAA;AtCwzqBJ;AsCrzqBE;EACE,yBAAA;AtCuzqBJ;AsCpzqBE;EACE,wBAAA;AtCszqBJ;AsCnzqBE;EACE,wBAAA;AtCqzqBJ;AsClzqBE;EACE,yBAAA;AtCozqBJ;AsCjzqBE;EACE,wBAAA;AtCmzqBJ;AsChzqBE;EACE,yBAAA;AtCkzqBJ;AsC/yqBE;EACE,yBAAA;AtCizqBJ;;AuC1htBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EAEA,eAAA;AvC6htBR;AuC5htBQ;EnCqHN,kBmCpH2B;EACjB,UAAA;EACA,mBAAA;EACA,cAAA;AvC8htBZ;AI//sBI;EmCnCI;IAMQ,UAAA;EvCgitBd;AACF;AuC/htBY;EACI,yBAAA;EnC4Gd,mBmC3G+B;EACjB,cAAA;EACA,aAAA;EACA,kBAAA;AvCiitBhB;;AuC1htBI;EACI,yBAAA;EACA,8DAAA;EACA,kBAAA;AvC6htBR;AuC3htBI;EACI,gBpCxBW;AHqjtBnB;AIphtBI;EmCVA;IAGQ,epCiUG;EH8tsBb;AACF;AuC5htBE;EACC,YAAA;AvC8htBH;AuC3htBI;EACI,qBpCuHI;EoCtHJ,gCAAA;EACA,8BAAA;AvC6htBR;AuC5htBQ;;EAII,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,cpCmJC;EoClJD,UAAA;EACA,epCoSG;EoCnSH,WAAA;EACA,YAAA;EACA,SAAA;EACA,gBpCvDO;EoCwDP,6BAAA;EnC2DV,mBmC1D2B;AvC8htB7B;AuC7htBY;;EACI,6BAAA;EACA,WpC7BR;AH6jtBR;AuC3htBQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,yBAAA;EACA,cpCpEF;AHimtBV;AuC5htBY;EACI,iBAAA;AvC8htBhB;AuC5htBY;EACI,mBpCzEN;EoC0EM,WpCnDR;AHiltBR;AuC7htBgB;EACI,+BAAA;AvC+htBpB;AuC3htBQ;EACI,mBpC/EA;AH4mtBZ;AuC5htBY;EnCqCV,sCAAA;EmCnCc,yBAAA;AvCgitBhB;AuC3htBI;EACI,SAAA;EACA,iBAAA;EACA,iBAAA;AvC6htBR;AuC1htBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,iBAAA;AvC4htBR;AuC1htBI;EACI,iBAAA;AvC4htBR;AuC1htBI;EACI,iBAAA;AvC4htBR;AuC1htBI;EACI,oCAAA;AvC4htBR;AuC1htBI;EACI,+CAAA;AvC4htBR;;AuCzhtBA;EACI,sBAAA;AvC4htBJ;;AuC1htBA;EACI,4BAAA;AvC6htBJ;;AuCzhtBI;EACI,0BAAA;AvC4htBR;AuCzhtBQ;EACI,qBAAA;EACA,UAAA;EACA,oBAAA;AvC2htBZ;AuCzhtBQ;EACI,mBAAA;EACA,UAAA;AvC2htBZ;AuCvhtBQ;EACI,0BAAA;EACA,UAAA;EACA,sDAAA;AvCyhtBZ;AuCvhtBQ;EACI,wBAAA;EACA,UAAA;AvCyhtBZ;AuCrhtBQ;EACI,0BAAA;EACA,UAAA;EACA,oBAAA;AvCuhtBZ;AuCrhtBQ;EACI,wBAAA;EACA,UAAA;AvCuhtBZ;AuCnhtBQ;EACI,kCAAA;EACA,UAAA;AvCqhtBZ;AuCnhtBQ;EACI,oBAAA;AvCqhtBZ;AuCnhtBQ;EACI,gCAAA;EACA,UAAA;AvCqhtBZ;AuClhtBI;EAGI,mBAAA;AvCohtBR;AuCnhtBQ;EAEI,4BAAA;EACA,2CAAA;EACA,UAAA;AvCqhtBZ;AuCnhtBQ;EACI,4BAAA;EACA,wCAAA;EACA,UAAA;AvCqhtBZ;AuClhtBI;EACI,mBAAA;AvCohtBR;AuCnhtBQ;EAEI,4BAAA;EACA,0BAAA;EACA,oBAAA;EACA,UAAA;AvCqhtBZ;AuCnhtBQ;EACI,wBAAA;EACA,UAAA;AvCqhtBZ;AuClhtBI;EACI,mBAAA;AvCohtBR;AuCnhtBQ;EAEI,4BAAA;EACA,0BAAA;EACA,oBAAA;EACA,UAAA;AvCqhtBZ;AuCnhtBQ;EACI,wBAAA;EACA,UAAA;AvCqhtBZ;AuCjhtBQ;EACI,mBAAA;EACA,UAAA;EACA,oBAAA;AvCmhtBZ;AuCjhtBQ;EACI,mBAAA;EACA,UAAA;AvCmhtBZ;AuChhtBI;EACI,mBAAA;AvCkhtBR;AuCjhtBQ;EAEI,4BAAA;EACA,0BAAA;EACA,uBAAA;EACA,UAAA;EACA,oBAAA;AvCmhtBZ;AuCjhtBQ;EACI,wBAAA;EACA,UAAA;AvCmhtBZ;AuChhtBI;EACI,mBAAA;AvCkhtBR;AuCjhtBQ;EAEI,4BAAA;EACA,0CAAA;EACA,wBAAA;EACA,UAAA;EACA,6BAAA;AvCmhtBZ;AuCjhtBQ;EACI,uCAAA;EACA,UAAA;AvCmhtBZ;AuChhtBI;EACI,mBAAA;AvCkhtBR;AuCjhtBQ;EAEI,4BAAA;EACA,4DAAA;EACA,wBAAA;EACA,UAAA;EACA,oBAAA;AvCmhtBZ;AuCjhtBQ;EACI,uDAAA;EACA,UAAA;AvCmhtBZ;;AuC/gtBA;EACI,uBAAA;AvCkhtBJ;;AuChhtBA;EACI,wBAAA;AvCmhtBJ;;AuCjhtBA;EACI,wBAAA;AvCohtBJ;;AuCjhtBI;EACI,YAAA;AvCohtBR;AuCnhtBQ;EACI,cpC7CC;EoC8CD,epC6CG;EoC5CH,gBpChTS;AHq0tBrB;AuCnhtBQ;EACI,WAAA;EACA,YAAA;AvCqhtBZ;AuCphtBY;EACI,UAAA;EACA,WAAA;AvCshtBhB;AuChhtBoB;EACI,QAAA;EACA,UAAA;EACA,WAAA;AvCkhtBxB;AuC3gtBI;EACI,cAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AvC6gtBR;AuC5gtBQ;EACI,UAAA;EACA,6CAAA;EACC,QAAA;EACD,WAAA;EACA,YAAA;AvC8gtBZ;AuC5gtBQ;EACI,mBAAA;AvC8gtBZ;AuC3gtBG;EACK,mBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AvC6gtBR;AuC5gtBQ;EACI,YAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EAGA,yBAAA;EACA,+BAAA;EACA,uCAAA;EACA,mCAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,kBAAA;AvC8gtBZ;;AuCzgtBI;EnC3RD,kBmC4R6B;EnC3R7B,iBmC2RyC;AvC6gtB5C;AuC5gtBQ;EACI,eAAA;AvC8gtBZ;;AuCxgtBQ;EnCpSL,SmCqSiC;EnCpSjC,UmCoSoC;EAC3B,gBpClWJ;EoCmWI,yBAAA;EACA,kBAAA;EACA,cpCpOD;EoCqOC,gBpCxYS;EoCyYT,epC7CG;EoC8CH,6DAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,+BAAA;EAIA,oBAAA;AvC4gtBZ;AuC3gtBY;EACI,yBAAA;EACA,mBpC9YN;EoC+YM,WpCxXR;EoC4XQ,oBAAA;EAGA,0BAAA;AvC6gtBhB;;AwCv7tBA;EACE,oBAAA;AxC07tBF;AwCz7tBE;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,0CAAA;AxC27tBJ;;AwCx7tBA;EACE,oBAAA;AxC27tBF;;AwCz7tBA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AxC47tBF;;AwC17tBA;EACE,iBAAA;EACA,aAAA;EACA,WrCuBM;AHs6tBR;;AwC37tBA;EACE,gBAAA;AxC87tBF;;ACv6tBA,qBAAA;AwC/CA;EACC,oCtCeqB;EsCdrB,etCmWc;EsClWd,ctCuQY;EsCtQZ,gBAAA;EACA,yBtCwQS;EsCvQT,gBAAA;EACA,kBAAA;AzC09tBD;;AyCx9tBA;EACC,oCtCMqB;AHq9tBtB;;AyCz9tBA;EACE,mBtCOQ;EsCNR,WtC6BM;EsC5BN,iBAAA;AzC49tBF;;AyC19tBA;EACC,eAAA;EACA,YAAA;EACA,uBAAA;AzC69tBD;;AyC39tBA;EACC,aAAA;AzC89tBD;;AyC59tBA;ErCkEE,yBqCjEmB;AzCi+tBrB;AyCh+tBC;EACC,2BAAA;AzCk+tBF;;AyC/9tBA;EACC,mBAAA;AzCk+tBD;AyCj+tBC;EACC,gBAAA;AzCm+tBF;;AyCh+tBA;EACC,gBtC1BkB;AH6/tBnB;;AyCj+tBA;EACG,ctCkOW;EsCjOX,oCtC1BmB;EsC2BrB,gBtC/BkB;EsCgChB,gBAAA;AzCo+tBH;;AyCl+tBA;EACE,gBAAA;EACA,mBAAA;EACA,UAAA;AzCq+tBF;;AyCn+tBA;EACE,gBAAA;AzCs+tBF;AyCr+tBC;EACE,gBAAA;EACA,kBAAA;AzCu+tBH;AyCt+tBG;EACE,uBAAA;AzCw+tBL;AyCr+tBC;EACE,mBAAA;EACA,kBAAA;AzCu+tBH;AyCt+tBG;EACE,wBAAA;AzCw+tBL;AyCr+tBC;EACE,gBAAA;EACA,eAAA;AzCu+tBH;AyCt+tBG;EACE,sBAAA;EACA,qBAAA;AzCw+tBL;AyCv+tBK;;;EAGE,qBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;AzCy+tBP;AyCt+tBK;EACE,etCiRQ;EsChRR,QAAA;AzCw+tBP;AyC/9tBe;EACI,gBAAA;AzCi+tBnB;;A0CpkuBA;EACI,oCAAA;A1CukuBJ;;A0CrkuBA;EACI,oCAAA;A1CwkuBJ;;A0CtkuBA;EACI,oCAAA;A1CykuBJ;;A0CvkuBA;EACI,oCAAA;EACA,sBAAA;A1C0kuBJ;;A0CxkuBA;EACI,oCAAA;EACA,sBAAA;A1C2kuBJ;;A0CzkuBA;EACI,oCAAA;EACA,sBAAA;A1C4kuBJ;;A0C1kuBA;EACI,oCAAA;A1C6kuBJ;;A0C3kuBA;EACI,oCAAA;A1C8kuBJ;;A0C5kuBA;EACI,oCAAA;A1C+kuBJ;;A0C7kuBA;EACI,mBvCkIQ;AH88tBZ;;A0C9kuBA;EACI,oCAAA;A1CiluBJ;;A0C/kuBA;EACI,iCAAA;A1CkluBJ;;A0ChluBA;EACI,oCAAA;A1CmluBJ;;A0CjluBA;EACI,oCAAA;A1ColuBJ;;A0ClluBA;EACI,oCAAA;A1CqluBJ;;A0CnluBA;EACI,oCAAA;A1CsluBJ;;A0CpluBA;EACI,oCAAA;A1CuluBJ;;A0CrluBA;EACI,oCAAA;A1CwluBJ;;A0CtluBA;EACI,oCAAA;A1CyluBJ;;A0CvluBA;EACI,mBvC0NW;AHg4tBf;;A0CxluBA;EACI,oCAAA;A1C2luBJ;A0C1luBI;EACI,kDAAA;A1C4luBR;A0C1luBI;EACI,mDAAA;A1C4luBR;A0C1luBI;EACI,kDAAA;A1C4luBR;A0C1luBI;EACI,mDAAA;A1C4luBR;A0C1luBI;EACI,oCAAA;A1C4luBR;;A0CzluBA;EACI,oCAAA;A1C4luBJ;A0C3luBI;EACI,mDAAA;A1C6luBR;A0C3luBI;EACI,oDAAA;A1C6luBR;A0C3luBI;EACI,mDAAA;A1C6luBR;A0C3luBI;EACI,oDAAA;A1C6luBR;A0C3luBI;EACI,oCAAA;A1C6luBR;;A0C1luBA;EACI,oCAAA;A1C6luBJ;A0C5luBI;EACI,oDAAA;A1C8luBR;A0C5luBI;EACI,qDAAA;A1C8luBR;A0C5luBI;EACI,oDAAA;A1C8luBR;A0C5luBI;EACI,qDAAA;A1C8luBR;A0C5luBI;EACI,oCAAA;A1C8luBR;;A0C3luBA;EACI,oCAAA;A1C8luBJ;A0C7luBI;EACI,mDAAA;A1C+luBR;A0C7luBI;EACI,oDAAA;A1C+luBR;A0C7luBI;EACI,mDAAA;A1C+luBR;A0C7luBI;EACI,oDAAA;A1C+luBR;A0C7luBI;EACI,oCAAA;A1C+luBR;;A0C5luBA;EACI,oCAAA;A1C+luBJ;A0C9luBI;EACI,mDAAA;A1CgmuBR;A0C9luBI;EACI,oDAAA;A1CgmuBR;A0C9luBI;EACI,mDAAA;A1CgmuBR;A0C9luBI;EACI,oDAAA;A1CgmuBR;A0C9luBI;EACI,oCAAA;A1CgmuBR;;A0C7luBA;EACI,oCAAA;A1CgmuBJ;A0C/luBI;EACI,kDAAA;A1CimuBR;A0C/luBI;EACI,mDAAA;A1CimuBR;A0C/luBI;EACI,kDAAA;A1CimuBR;A0C/luBI;EACI,mDAAA;A1CimuBR;A0C/luBI;EACI,oCAAA;A1CimuBR;;A0C9luBA;EACI,oCAAA;A1CimuBJ;A0ChmuBI;EACI,kDAAA;A1CkmuBR;A0ChmuBI;EACI,mDAAA;A1CkmuBR;A0ChmuBI;EACI,kDAAA;A1CkmuBR;A0ChmuBI;EACI,mDAAA;A1CkmuBR;A0ChmuBI;EACI,oCAAA;A1CkmuBR;;A0C/luBA;EACI,oCAAA;A1CkmuBJ;A0CjmuBI;EACI,qDAAA;A1CmmuBR;A0CjmuBI;EACI,sDAAA;A1CmmuBR;A0CjmuBI;EACI,qDAAA;A1CmmuBR;A0CjmuBI;EACI,sDAAA;A1CmmuBR;A0CjmuBI;EACI,oCAAA;A1CmmuBR;;A0C9luBI;EACI,oCAAA;EACA,oCAAA;EACA,WvCzKA;AH0wuBR;;A0CpmuBI;EACI,oCAAA;EACA,oCAAA;EACA,WvCzKA;AHgxuBR;;A0C1muBI;EACI,oCAAA;EACA,oCAAA;EACA,WvCzKA;AHsxuBR;;A0ChnuBI;EACI,oCAAA;EACA,oCAAA;EACA,WvCzKA;AH4xuBR;;A0CtnuBI;EACI,oCAAA;EACA,oCAAA;EACA,WvCzKA;AHkyuBR;;A0C5nuBI;EACI,oCAAA;EACA,oCAAA;EACA,WvCzKA;AHwyuBR;;A0ClouBI;EACI,oCAAA;EACA,oCAAA;EACA,WvCzKA;AH8yuBR;;A0CxouBI;EACI,oCAAA;EACA,oCAAA;EACA,WvCzKA;AHozuBR;;A0C9ouBI;EACI,iCAAA;EACA,iCAAA;EACA,WvCzKA;AH0zuBR;;A0CppuBI;EACI,oCAAA;EACA,oCAAA;EACA,WvCzKA;AHg0uBR;;A0C1puBI;EACI,oCAAA;EACA,oCAAA;EACA,WvCzKA;AHs0uBR;;A0ChquBI;EACI,oCAAA;EACA,oCAAA;EACA,WvCzKA;AH40uBR;;A0ChquBA;EACI,yBvC3JU;EuC4JV,cvCrMM;AHw2uBV;;A0CjquBA;EACI,yBvCpJY;EuCqJZ,cvCvMQ;AH22uBZ;;A0ClquBA;EACI,yBvC/BU;EuCgCV,cvCzMM;AH82uBV;;A0CnquBA;EACI,yBvCxBS;EuCyBT,cvCvMK;AH62uBT;;A0CpquBA;EACI,yBvCjBU;EuCkBV,cvC7MM;AHo3uBV;;A0CrquBA;EACI,yCAAA;EACA,cvCnNG;AH23uBP;;A0CtquBA;EACI,0CAAA;EACA,cvCyBS;AHgpuBb;;A0CvquBA;EACI,uCAAA;EACA,WvC1MI;AHo3uBR;;A0CxquBA;EACE,cvCkBW;AHypuBb;;A0CxquBA;EACE,0EAAA;EACA,WvClNM;AH63uBR;;A0CzquBA;EACE,0EAAA;EACA,WvCtNM;AHk4uBR;;A0C1quBA;EACE,0EAAA;EACA,WvC1NM;AHu4uBR;;A0C3quBA;EACE,0EAAA;EACA,WvC9NM;AH44uBR;;A0C5quBA;EACE,0EAAA;EACA,WvClOM;AHi5uBR;;A0C7quBA;EACE,0EAAA;EACA,WvCtOM;AHs5uBR;;A0C9quBA;EACE,0EAAA;EACA,WvC1OM;AH25uBR;;A0C/quBA;EACE,0EAAA;EACA,WvC9OM;AHg6uBR;;A0ChruBA;EACE,0EAAA;EACA,WvClPM;AHq6uBR;;A0CjruBA;EACE,0EAAA;EACA,WvCrPM;AHy6uBR;;A0ClruBA;EACE,0EAAA;EACA,WvC1PM;AH+6uBR;;A0CnruBA;EACE,sBvC7PM;EuC8PN,yBAAA;EACA,cvCtRQ;AH48uBV;;A0CpruBA;EACE,sBvClQM;EuCmQN,yBAAA;EACA,cvCzRU;AHg9uBZ;;A0CrruBA;EACE,sBvCvQM;EuCwQN,yBAAA;EACA,cvCxRQ;AHg9uBV;;A0CtruBA;EACE,sBvC5QM;EuC6QN,yBAAA;EACA,cvC/RK;AHw9uBP;;A0CvruBA;EACE,sBvCjRM;EuCkRN,yBAAA;EACA,cvCtSQ;AHg+uBV;;A0CxruBA;EACE,sBvCtRM;EuCuRN,yBAAA;EACA,cvCrSO;AHg+uBT;;A0CzruBA;EACE,sBvC3RM;EuC4RN,yBAAA;EACA,cvCxSK;AHo+uBP;;A0C1ruBA;EACE,sBvChSM;EuCiSN,oCAAA;EACA,sBAAA;A1C6ruBF;;A0C3ruBA;EACI,kDAAA;EACA,yBAAA;A1C8ruBJ;A0C7ruBI;EACI,kDAAA;EACA,yBAAA;A1C+ruBR;;A0C5ruBA;EACI,mDAAA;EACA,yBAAA;A1C+ruBJ;A0C9ruBI;EACI,mDAAA;EACA,yBAAA;A1CgsuBR;;A0C7ruBA;EACI,oDAAA;EACA,yBAAA;A1CgsuBJ;A0C/ruBI;EACI,oDAAA;EACA,yBAAA;A1CisuBR;;A0C9ruBA;EACI,mDAAA;EACA,yBAAA;A1CisuBJ;A0ChsuBI;EACI,mDAAA;EACA,yBAAA;A1CksuBR;;A0C/ruBA;EACI,mDAAA;EACA,yBAAA;A1CksuBJ;A0CjsuBI;EACI,mDAAA;EACA,yBAAA;A1CmsuBR;;A0ChsuBA;EACI,kDAAA;EACA,yBAAA;A1CmsuBJ;A0ClsuBI;EACI,kDAAA;EACA,yBAAA;A1CosuBR;;A0CjsuBA;EACI,qDAAA;EACA,yBAAA;A1CosuBJ;A0CnsuBI;EACI,qDAAA;EACA,yBAAA;A1CqsuBR;;A0ClsuBA;EACI,yBvC/NO;AHo6uBX;;A0CnsuBA;EACI,yBvCjOO;AHu6uBX;;A0CpsuBA;EACI,yBvCnOO;AH06uBX;;A0CrsuBA;EACI,yBvCrOO;AH66uBX;;A0CtsuBA;EACI,yBvCvOO;AHg7uBX;;A0CvsuBA;EACI,yBvCzOO;AHm7uBX;;A0CxsuBA;EACI,yBvC3OO;AHs7uBX;;A0CzsuBA;EACI,yBvC7OO;AHy7uBX;;A0C1suBA;EACI,yBvC/OO;AH47uBX;;A0C3suBA;EACI,avC/YM;AH6lvBV;;A0C5suBA;EACI,avChZQ;AH+lvBZ;;A0C7suBA;EACI,avCjZM;AHimvBV;;A0C9suBA;EACI,avC9YK;AH+lvBT;;A0C/suBA;EACI,avCnZM;AHqmvBV;;A0ChtuBA;EACI,UvCvYI;AH0lvBR;;A0CjtuBA;EACI,UvCzYI;AH6lvBR;;A0CltuBA;EACI,avC1YG;AH+lvBP;;A0CntuBA;EACI,avCvYK;AH6lvBT;;A0CptuBA;EACI,avCjZK;AHwmvBT;;A0CrtuBA;EACI,avC5YK;AHomvBT;;A0CttuBA;EACI,avC1aG;AHmovBP;;A0CvtuBA;EACI,avC/YK;AHymvBT;;A0CxtuBA;EACE,avCjaM;AH4nvBR;;A0CztuBA;EACE,avC7aK;AHyovBP;;A0C1tuBA;EACE,avChaK;AH6nvBP;;A0C3tuBA;EACE,avCzMW;AHu6uBb;;A0C5tuBA;EACE,WAAA;EACA,YAAA;EACA,kBvCvIc;EuCwId,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;A1C+tuBF;;A0C7tuBA;EACE,uBAAA;EACA,kBvC/Ic;EuCgJd,8DvCvIW;AHu2uBb;;A0C9tuBA;EACI,WAAA;EACA,YAAA;EACA,kBvCrJY;EuCsJZ,qBAAA;EACA,sBAAA;A1CiuuBJ;;A0C/tuBA;EACI,8BAAA;EACA,gCAAA;A1CkuuBJ;;A0ChuuBA;EACI,cvClcK;AHqqvBT;;A0CjuuBA;EACI,mBvCnVQ;AHujvBZ;;A0CluuBA;EACI,mBvCvVQ;AH4jvBZ;;A0CnuuBA;EACI,mBvC9SS;AHohvBb;;A0CpuuBA;EACI,8BAAA;EACA,sBAAA;A1CuuuBJ;;A0CruuBA;EACI,8BAAA;A1CwuuBJ;;A0CtuuBA;EACI,mBvC9cK;AHurvBT;;A0CvuuBA;EACI,yBAAA;A1C0uuBJ;;A0CxuuBA;EACI,yBAAA;A1C2uuBJ;;AC/rvBA,qBAAA;A0CpDA;EACI,mBAAA;A3CuvvBJ;A2CtvvBI;EACI,gBxCQe;EwCPf,mBAAA;A3CwvvBR;AI/svBI;EuC3CA;IAIQ,exCkWG;EHw5uBb;AACF;AIptvBI;EuC3CA;IAOQ,mBAAA;E3C4vvBV;AACF;A2C3vvBQ;EACI,mBAAA;EACA,kBAAA;EvC0FT,iBuCzFiC;EvC0FjC,YuC1F4C;EACnC,cxC8BH;EwC7BG,exCmVG;EwClVH,gBxCNW;AHowvBvB;AIluvBI;EuCzBA;IAEQ,aAAA;E3C6vvBV;AACF;A2C3vvBI;EACI,mBAAA;A3C6vvBR;AI1uvBI;EuCpBA;IAGO,aAAA;E3C+vvBT;AACF;A2C9vvBQ;EACI,WAAA;EACA,YAAA;EACA,gBxCUJ;EwCTI,cxC+ID;EwC5IC,oBAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;A3CgwvBZ;A2C/vvBY;EACI,mBxCGR;EwCFQ,WxCNR;AHuwvBR;A2C/vvBY;EACI,eAAA;A3CiwvBhB;AIxwvBI;EuCfI;IAyBQ,4BAAA;E3CkwvBd;E2CjwvBc;IACI,0BAAA;E3CmwvBlB;AACF;A2C/vvBI;EACI,aAAA;A3CiwvBR;;A2C7vvBI;EACI,cxCkGI;AH8pvBZ;A2C/vvBQ;EACI,cxClBH;AHmxvBT;;A2C3vvBQ;EACI,cxCzBH;AHuxvBT;;A2C1vvBA;EACI,kBAAA;A3C6vvBJ;A2C5vvBI;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,2BAAA;EACA,cxCyFG;AHqqvBX;A2C5vvBI;EvCcD,0BuCbmC;A3C8vvBtC;A2C7vvBQ;EvCYL,0BuCXuC;A3C+vvB1C;;A2C3vvBA;EACI,kBAAA;A3C8vvBJ;A2C7vvBI;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;EACA,cxCyEG;AHsrvBX;A2C7vvBI;EvCFD,0BuCGmC;A3C+vvBtC;;A2C5vvBA;EACI,yBAAA;EACA,kBAAA;EvCRD,YuCS+B;EAG1B,oBAAA;EAGA,mBAAA;A3C+vvBR;A2C9vvBI;EACI,WAAA;EACA,YAAA;EACA,gBxChFA;EwCiFA,cxCqDG;EwClDH,oBAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;A3CgwvBR;A2C/vvBQ;EACI,0BAAA;A3CiwvBZ;A2C/vvBQ;EACI,0BAAA;A3CiwvBZ;A2C/vvBQ;EACI,mBxC1FJ;EwC2FI,WxCnGJ;AHo2vBR;;A2C7vvBA;EACI,eAAA;EACA,WAAA;EACA,aAAA;EACA,+BAAA;EACA,MAAA;EACA,WAAA;EACA,aAAA;A3CgwvBJ;A2C/vvBI;EACI,OAAA;A3CiwvBR;;A2C9vvBA;EACI,eAAA;EACA,WAAA;EACA,aAAA;EACA,+BAAA;EACA,MAAA;EACA,WAAA;EACA,aAAA;A3CiwvBJ;A2ChwvBI;EACI,OAAA;A3CkwvBR;;A2C/vvBA;EAGI,aAAA;EAGA,mBAAA;EACA,kBAAA;A3CkwvBJ;A2CjwvBI;EACI,0BAAA;EACA,qBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,kBAAA;A3CmwvBR;A2ClwvBQ;EAGI,aAAA;A3CowvBZ;A2ClwvBQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;A3CowvBZ;A2ClwvBQ;EACI,mBxC/KH;EwCgLG,WxCnKJ;EwCoKI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EvC5HV,kBuC6H4B;EvC5H5B,SuC4HsC;EvC3HtC,WuC2H4C;A3CswvB9C;A2ClwvBQ;EACI,mBAAA;A3CowvBZ;A2CjwvBI;EACI,mBxCLK;EwCML,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;A3CmwvBR;A2ClwvBQ;EvClIL,iBuCmIuC;EAC9B,eAAA;EACA,cxChMH;EwCiMG,qBAAA;A3CowvBZ;A2CnwvBY;EACI,kBAAA;A3CqwvBhB;A2ClwvBQ;EACI,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;A3CowvBZ;;A2ChwvBA;EACI,gBxCnNI;EwCoNJ,yBAAA;EACA,kBAAA;EACA,8DAAA;EACA,mBAAA;A3CmwvBJ;A2ClwvBI;EvC3JD,4BuC4JmC;EAC9B,gBxC3Pa;EwC8Pb,aAAA;EAGA,mBAAA;EACA,kBAAA;A3CowvBR;A2CnwvBQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,iBAAA;A3CqwvBZ;A2CnwvBQ;EACI,cxC5GD;AHi3vBX;A2CnwvBQ;EACI,gBAAA;EACA,kCAAA;EvClMV,kBuCmM4B;EvClM5B,QuCkMsC;EvCjMtC,WuCiM2C;EvCxO3C,2BuCyO6B;EvCxO7B,mCuCwO6B;EvCvO7B,+BuCuO6B;EACnB,exCiEG;EwChEH,gBxC1RW;AHmiwBvB;A2CtwvBY;EACI,gBAAA;A3CwwvBhB;A2CtwvBY;EACI,mBxCxRN;EwCyRM,WxClQR;AH0gwBR;A2CpwvBI;EACI,6BAAA;EvC3ML,qBuC4M6B;EvC3M7B,iBuC2M4C;A3CuwvB/C;A2CpwvBQ;EACI,mBAAA;A3CswvBZ;A2CrwvBY;EACI,gBAAA;A3CuwvBhB;AInhwBI;EuC2QQ;IAGQ,mBAAA;E3CywvBlB;AACF;;A2CnwvBI;EACI,exCkCO;EwCjCP,gBxCzTe;EwC0Tf,kBxCcW;EC5OhB,kBuC+N6B;EvC9N7B,iBuC8NyC;A3CuwvB5C;A2CtwvBQ;EACI,eAAA;A3CwwvBZ;;A2CnwvBI;EACI,oBAAA;A3CswvBR;A2CpwvBI;EACI,kBAAA;A3CswvBR;A2CrwvBQ;EACI,eAAA;A3CuwvBZ;;A2ClwvBI;EACI,mBAAA;EACA,exCeO;AHsvvBf;A2CnwvBI;EACI,gBAAA;EvCtPL,cuCuP6B;A3CqwvBhC;A2CnwvBI;EACI,exCMO;EwCLP,gBAAA;A3CqwvBR;AI1jwBI;EuCmTA;IAIQ,exCCG;EHswvBb;AACF;A2CrwvBI;EACI,gBAAA;A3CuwvBR;;A2CpwvBA;EACI,mBxClKS;EwCmKT,cxC/UK;EwCgVL,WAAA;EACA,YAAA;EACA,kBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,exCNW;AH6wvBf;A2CtwvBI;EACI,mBxC3JK;EwC4JL,cxC/UC;AHulwBT;;A2CrwvBA;EACI,kBAAA;EvCzRD,gBuC0RyB;EvCzRzB,auCyRmC;EAClC,8DxCvCY;AHgzvBhB;A2CxwvBI;EvC5RD,euC6R6B;EvC5R7B,UuC4RsC;A3C2wvBzC;A2CzwvBY;EACI,mBxCvOJ;AHk/vBZ;A2CxwvBQ;EACI,WAAA;EACA,kBAAA;EvCpST,YuCqSuC;EAC9B,uBAAA;A3C0wvBZ;A2CxwvBgB;EACI,WAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;A3C0wvBpB;A2CxwvBgB;EACI,mBxCnYV;EwCoYU,qBxCpYV;AH8owBV;A2CvwvBY;EAGI,aAAA;EAGA,mBAAA;A3CywvBhB;A2CxwvBgB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;A3C0wvBpB;A2CxwvBgB;EACI,cxC/JP;EwCgKO,exCrEL;AH+0vBf;A2CtwvBQ;EACI,yBxC/QA;AHuhwBZ;A2CtwvBQ;EACI,gBAAA;A3CwwvBZ;;A2ClwvBQ;EACI,gBAAA;EACA,sCAAA;A3CqwvBZ;;A2CjwvBA;EACI;IvCrYF,yBuCsYuB;IvCrYvB,iCuCqYuB;IvCpYvB,6BuCoYuB;E3CswvBvB;AACF;A2CpwvBA;EACI,kBAAA;A3CswvBJ;A2CrwvBI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;A3CuwvBR;A2CrwvBI;EACI,6BAAA;A3CuwvBR;;A2CnwvBI;EACI,aAAA;EACA,mBAAA;A3CswvBR;A2CpwvBY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;A3CswvBhB;A2CrwvBgB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;A3CuwvBpB;A2CrwvBgB;EACI,mBxCldV;EwCmdU,WxC5bZ;EwC6bY,exCvIL;AH84vBf;A2CrwvBgB;EACI,kBAAA;A3CuwvBpB;A2CnwvBgB;EACI,cAAA;A3CqwvBpB;;A2C/vvBA;EACI,cxCzdK;AH2twBT;;A2ChwvBA;EACI,kBAAA;A3CmwvBJ;A2ClwvBI;EACI,kBAAA;A3CowvBR;A2CnwvBQ;EACI,cxCpPC;EwCqPD,kBAAA;EACA,qBAAA;EvCzZT,mBuC0ZiC;EvCzZjC,mBuCyZ8C;A3CswvBjD;A2CrwvBY;EACI,cxCzPH;AHggwBb;A2CtwvBgB;EACI,cxCjfV;EwCkfU,iBAAA;A3CwwvBpB;A2CtwvBgB;EACI,cxCrfV;AH6vwBV;A2CrwvBY;EACI,eAAA;A3CuwvBhB;A2CrwvBY;EACI,eAAA;A3CuwvBhB;A2CtwvBgB;EACI,aAAA;A3CwwvBpB;A2CrwvBY;EACI,YAAA;EvCvbd,kBuCwbgC;EvCvbhC,MuCub0C;EvCpb1C,OuCobyD;A3CywvB3D;A2CvwvBY;EACI,iBAAA;A3CywvBhB;A2CxwvBgB;EACI,aAAA;A3C0wvBpB;A2CvwvBY;EAII,WxCxfR;AH8vwBR;A2CzwvBgB;EACI,WxCtfZ;AHiwwBR;A2CxwvBgB;EACI,WxC1fZ;AHowwBR;A2CrwvBI;EAGI,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;A3CuwvBR;A2CtwvBQ;EvC3cL,kBuC4ciC;A3CwwvBpC;A2CrwvBY;EACI,qBAAA;EACA,iBAAA;A3CuwvBhB;A2CtwvBgB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBxClhBZ;EwCmhBY,cxCnTN;EwCsTM,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;A3CwwvBpB;A2CvwvBoB;EACI,mBxCrjBd;EwCsjBc,WxC/hBhB;AHwywBR;A2CtwvBgB;EACI,eAAA;A3CwwvBpB;;A2ClwvBA;EAGI,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,eAAA;A3CqwvBJ;A2CpwvBI;EACI,mBAAA;A3CswvBR;A2CrwvBQ;EACI,eAAA;A3CuwvBZ;A2CpwvBI;EvC3fD,oBuC4f6B;EvC3f7B,gBuC2f2C;EACtC,exC/PO;EwCgQP,gBxC5lBa;AHm2wBrB;A2CtwvBQ;EACI,mBxCpcA;EwCqcA,cxC5bD;AHoswBX;A2CtwvBQ;EACI,iBAAA;A3CwwvBZ;A2CrwvBI;EACI,mBAAA;A3CuwvBR;A2CtwvBQ;EACI,gBxCtmBW;EwCumBX,WxCvkBJ;EwCwkBI,qBAAA;A3CwwvBZ;A2CvwvBY;EACI,qBAAA;EACA,kBAAA;EvC9gBb,iBuC+gB2C;EAC9B,WxC7kBR;AHs1wBR;A2CrwvBI;EACI,eAAA;EACA,cxChjBQ;AHuzwBhB;A2CtwvBQ;EACI,aAAA;A3CwwvBZ;A2CrwvBI;EACI,kBAAA;EACA,iBAAA;EAGA,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,exCtSO;EwCuSP,gBxCnoBa;AH04wBrB;A2CtwvBQ;EACI,iBAAA;A3CwwvBZ;A2CrwvBI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EAGA,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,mBxC/fI;EwCggBJ,yBAAA;EACA,cxCtZM;AH6pwBd;A2CtwvBQ;EACI,mBxC/oBF;EwCgpBE,WxCznBJ;AHi4wBR;A2CtwvBQ;EACI,kBAAA;EACA,gBxC7nBJ;EwC8nBI,yBAAA;EACA,cxCtnBH;AH83wBT;A2CrwvBI;EACI,mBAAA;A3CuwvBR;A2CtwvBQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EAGA,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBxCjpBJ;EwCkpBI,yBAAA;A3CwwvBZ;A2CvwvBY;EACI,mBxCzhBJ;EwC0hBI,cxC/gBL;AHwxwBX;A2CtwvBQ;EAGI,aAAA;EAGA,mBAAA;EvCjmBT,YuCkmBuC;EAC9B,kBAAA;EACA,cxCjcE;AHyswBd;A2CvwvBY;EACI,iBAAA;A3CywvBhB;A2CvwvBY;EACI,mBxCjjBJ;EwCkjBI,cxCvcF;AHgtwBd;;A2CpwvBA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,exCzXW;AHgowBf;A2CtwvBI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EAGA,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,mBxC5kBI;EwC6kBJ,cxCleM;EwCmeN,kBAAA;EACA,cAAA;A3CwwvBR;;A2CnwvBQ;EACI,cxCzkBD;AH+0wBX;A2CrwvBY;EACI,cxCnuBN;AH0+wBV;A2CpwvBQ;EACI,iBAAA;A3CswvBZ;;A2CjwvBI;EAGI,aAAA;A3CowvBR;A2CnwvBQ;EACI,gBAAA;EACA,qBAAA;A3CqwvBZ;A2CnwvBQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;A3CqwvBZ;;A2CjwvBA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,eAAA;A3CowvBJ;A2CnwvBI;EAGI,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cxCpvBC;AHy/wBT;A2CpwvBQ;EACI,cxC/wBF;AHqhxBV;;A2CjwvBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A3CowvBR;A2CnwvBQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;A3CqwvBZ;A2CnwvBQ;EACI,exC3dG;EwC4dH,gBxCvzBS;EwCwzBT,kBAAA;A3CqwvBZ;A2ClwvBQ;EACI,exCjeG;EwCkeH,gBAAA;A3CowvBZ;A2C/vvBY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;A3CiwvBhB;A2C9vvBgB;EACI,iBAAA;EACA,cxCzzBV;AHyjxBV;;A2CzvvBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A3C4vvBR;A2C3vvBQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;A3C6vvBZ;A2C3vvBQ;EACI,gBAAA;A3C6vvBZ;;A2CxvvBI;EACI,qBAAA;A3C2vvBR;A2C1vvBQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EAGA,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBxCn1BJ;EwCo1BI,cxC9sBD;AH08wBX;A2C3vvBY;EACI,mBxChtBL;EwCitBK,WxCv1BR;AHolxBR;;A2CvvvBI;EACI,iBAAA;EACA,qBAAA;A3C0vvBR;A2CzvvBQ;EACI,exCziBG;EwC0iBH,gBxCn4BS;EwCo4BT,kBAAA;EvCtyBT,iBuCuyBuC;EAC9B,qBAAA;A3C2vvBZ;A2CzvvBQ;EACI,eAAA;A3C2vvBZ;;A2CvvvBA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EAGA,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,yBAAA;EACA,cxCj3BK;AH2mxBT;A2CzvvBI;EACI,exClkBO;AH6zwBf;;AIrnxBI;EuC63BJ;IAEQ,cAAA;E3C2vvBN;AACF;A2C1vvBI;EACI,qBAAA;EvCx0BL,kBuCy0B6B;A3C4vvBhC;A2C3vvBQ;EACI,cxCtwBD;EwCywBC,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACC,uBAAA;EACD,+BAAA;EACA,qBAAA;EACA,exCvlBG;EwCwlBH,gBxCn7BS;EwCo7BT,6BAAA;EACA,kBAAA;EvCv1BT,yBuCw1BuC;A3C6vvB1C;A2C5vvBY;EACI,cxC96BN;EwC+6BM,qBxC/6BN;AH6qxBV;A2C5vvBY;EACI,iBAAA;A3C8vvBhB;AIvpxBI;EuCi4BA;IA4BQ,cAAA;E3C8vvBV;AACF;;A2C3vvBA;EACI,kBAAA;A3C8vvBJ;A2C7vvBG;EACK,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;A3C+vvBR;A2C7vvBI;EACI,kBAAA;A3C+vvBR;A2C7vvBI;EACI,WAAA;A3C+vvBR;;A2C5vvBA;EACI,mBxChwBS;EwCiwBT,cxCp7BK;EwCq7BL,kBAAA;EACA,qBAAA;EACA,exC/nBW;EC9PZ,gBuC83ByB;EvC73BzB,gBuC63BmC;A3CgwvBtC;A2C/vvBI;EACI,iBAAA;A3CiwvBR;;A2C1vvBgB;EACI,gBAAA;A3C6vvBpB;;A2CvvvBA;EACI,yBAAA;EACA,kBAAA;EvCh5BD,gBuCi5ByB;EvCh5BzB,sBuCg5BmC;A3C2vvBtC;A2C1vvBI;EACI,gBxCh/Ba;EwCi/Bb,kBAAA;A3C4vvBR;A2C1vvBI;EACI,mBAAA;A3C4vvBR;A2C3vvBQ;EACI,cxC/0BD;EwCk1BC,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,exClqBG;AH+5wBf;A2C5vvBY;EACI,aAAA;A3C8vvBhB;A2C3vvBQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;A3C6vvBZ;A2C3vvBQ;EACI,eAAA;A3C6vvBZ;A2C1vvBY;EAGI,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,exCxrBD;EwCyrBC,cxC72BL;AHymxBX;;A2CtvvBI;EACI,aAAA;A3CyvvBR;;A2CtvvBA;EACI,aAAA;EACA,mBAAA;A3CyvvBJ;;A2CtvvBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,yBAAA;EACA,6DAAA;EvCj9BL,gBuCk9B6B;EvCj9B7B,auCi9BuC;EAClC,kBAAA;A3C0vvBR;A2CzvvBQ;EAGI,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,kBAAA;A3C2vvBZ;A2C1vvBY;EACI,gBxC7jCK;EwC8jCL,kBAAA;A3C4vvBhB;A2C1vvBY;EACI,gBAAA;A3C4vvBhB;AI1xxBI;EuC8gCI;IAmBQ,kBAAA;E3C6vvBd;AACF;A2C3vvBQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WxC1iCJ;EwC6iCI,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;A3C6vvBZ;A2C5vvBY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;A3C8vvBhB;A2C3vvBQ;EACI,mBxCx8BA;AHqsxBZ;A2C5vvBY;EACI,gBxC/jCR;AH6zxBR;A2C3vvBQ;EACI,WAAA;EACA,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,kBAAA;EACA,cxC/2BE;EwCg3BF,mBxC39BA;AHwtxBZ;AI30xBI;EuCggCA;IvCt8BD,gBuCuhCiC;IvCthCjC,auCshC2C;E3C+vvB5C;AACF;A2C7vvBI;EACI,mBxCn+BI;EwCo+BJ,kBAAA;EvC5hCL,gBuC6hC6B;EvC5hC7B,auC4hCuC;A3CgwvB1C;A2C/vvBQ;EACI,mBAAA;A3CiwvBZ;A2C/vvBQ;EACI,gBxC9lCJ;EwC+lCI,kBxC/lCJ;EwCgmCI,kBAAA;EACA,cxC39BD;EwC49BC,exCtyBG;EwCuyBH,gBxCroCS;EC8FlB,SuCwiCiC;EvCviCjC,iBuCuiCoC;A3CkwvBvC;A2CjwvBY;EACI,iBAAA;A3CmwvBhB;A2CjwvBY;EACI,mBxCt/BJ;AHyvxBZ;;A2C9vvBA;EACI,eAAA;A3CiwvBJ;A2ChwvBI;EvCpjCD,qBuCqjC6B;EvCpjC7B,iBuCojC4C;A3CmwvB/C;A2ClwvBQ;EACI,eAAA;A3CowvBZ;A2ClwvBQ;EACI,gBAAA;A3CowvBZ;;A2ChwvBA;EACI,0BAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;A3CmwvBJ;A2ClwvBI;EACI,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;A3CowvBR;A2ClwvBI;EACI,mBxCr9BK;EwCs9BL,cxCzoCC;EwC0oCD,exCl1BO;EwCm1BP,qBAAA;EACA,kBAAA;EvCllCL,cuCmlC6B;EvCllC7B,iBuCklCqC;EAChC,kBAAA;A3CqwvBR;A2CpwvBQ;EACI,kBAAA;A3CswvBZ;;A2ClwvBA;EACI,mBxCpiCQ;EwCqiCR,0BAAA;EACA,kBAAA;EACA,kBAAA;A3CqwvBJ;A2CpwvBI;EACI,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;A3CswvBR;A2CpwvBI;EACI,exCp2BO;EwCq2BP,mBAAA;A3CswvBR;A2CpwvBI;EACI,exC92BO;EwC+2BP,gBAAA;A3CswvBR;A2CpwvBI;EACI,kBAAA;EvC/mCL,kBuCgnCmC;A3CswvBtC;;A2CnwvBA;EACI,mBxC7jCQ;EwC8jCR,yBAAA;EvCtnCD,euCunCyB;EvCtnCzB,auCsnCkC;EACjC,kBAAA;A3CuwvBJ;A2CtwvBI;EACI,exC53BO;EwC63BP,gBxCxtCa;EwCytCb,kBAAA;A3CwwvBR;A2CtwvBI;EACI,exCj4BO;EwCk4BP,gBAAA;A3CwwvBR;A2CvwvBQ;EACI,cxCxjCD;AHi0xBX;A2CtwvBI;EACI,WAAA;EvCtoCL,kBuCuoC6B;A3CwwvBhC;A2CtwvBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;A3CwwvBR;;A2CrwvBA;EACI,gBxClvCmB;EwCmvCnB,mBAAA;A3CwwvBJ;;A2CrwvBI;EACI,mBAAA;A3CwwvBR;A2CvwvBQ;EACI,exC/5BG;AHwqxBf;A2CvwvBQ;EACI,gBAAA;A3CywvBZ;;A2CrwvBA;EACI,mBxCxmCQ;EwCymCR,yBAAA;EACA,kBAAA;EvCvqCD,gBuCwqCyB;EvCvqCzB,oBuCuqCmC;A3CywvBtC;A2CxwvBI;EACI,mBAAA;A3C0wvBR;A2CxwvBI;EACI,gBxCzwCe;AHmhyBvB;AIj/xBI;EuCsuCA;IAGQ,exC/6BG;EH2rxBb;AACF;;A2CzwvBA;EACI,exCp7BW;EwCq7BX,cxChwCM;AH4gyBV;;A2CzwvBI;EACI,mBAAA;A3C4wvBR;A2C3wvBQ;EACI,cAAA;EACA,gBxCzxCS;EwC0xCT,kBAAA;A3C6wvBZ;;A2CzwvBA;EACI,cxC3wCK;AHuhyBT;;A2C1wvBA;EACI,yBAAA;EACA,mBxC5mCU;EwC6mCV,kBAAA;EvCvsCD,gBuCwsCyB;EvCvsCzB,auCusCmC;A3C8wvBtC;A2C7wvBI;EACI,cxChoCG;EwCioCH,gBAAA;A3C+wvBR;A2C9wvBQ;EACI,iBAAA;A3CgxvBZ;;A2C5wvBA;EACI,aAAA;A3C+wvBJ;A2C9wvBI;EACI,cAAA;A3CgxvBR;;A2C5wvBI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;A3C+wvBR;AIpiyBI;EuCkxCA;IAKQ,sBAAA;E3CixvBV;AACF;A2ChxvBQ;EACI,mBAAA;EACA,mBxCxqCA;EwCyqCA,kBAAA;EACA,aAAA;EACA,mBAAA;A3CkxvBZ;AIhjyBI;EuCyxCI;IAOQ,WAAA;IACA,mBAAA;E3CoxvBd;AACF;A2CnxvBY;EACI,iBAAA;A3CqxvBhB;A2ClxvBgB;EACI,gBAAA;EACA,gBxC50CC;EwC60CD,exCl/BL;EwCm/BK,cxC5qCT;AHg8xBX;A2CjxvBY;EACI,mBxCx0CN;EwCy0CM,WxClzCR;AHqkyBR;A2ClxvBgB;EACI,WxCpzCZ;AHwkyBR;;A2C9wvBA;EACI,yBAAA;EvC/vCD,euCgwCyB;EvC/vCzB,sBuC+vCkC;EACjC,kBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,kBAAA;A3CkxvBJ;A2CjxvBI;EvCpxCF,kBuCqxCwB;EvCpxCxB,MuCoxCkC;EvCjxClC,OuCixCiD;EAC3C,WAAA;EACA,UAAA;EACA,YAAA;EACA,mBxCl2CI;AHunyBZ;A2CnxvBI;EACI,cxC1sCG;EwC2sCH,gBxCl3Ca;EwCm3Cb,mBAAA;A3CqxvBR;A2CnxvBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,eAAA;A3CqxvBR;A2CpxvBQ;EvChyCL,qBuCiyCgC;A3CsxvBnC;A2CrxvBW;EACK,iBAAA;A3CuxvBhB;A2CrxvBW;EACK,eAAA;A3CuxvBhB;A2CnxvBI;EACI,gBAAA;A3CqxvBR;;A2CjxvBI;EACI,kBAAA;A3CoxvBR;A2CnxvBQ;EACI,eAAA;A3CqxvBZ;;A2CjxvBA;EACI,gBAAA;A3CoxvBJ;;A2ClxvBA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,yBAAA;EvCh0CD,euCi0CyB;EvCh0CzB,uBuCg0CkC;EACjC,kBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;A3CsxvBJ;A2CrxvBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A3CuxvBR;A2CtxvBQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;A3CwxvBZ;A2CrxvBI;EACI,gBxCj7Ce;EwCk7Cf,cxC/5CC;AHsryBT;;A2CnxvBI;EACI,aAAA;EACA,SAAA;A3CsxvBR;A2CpxvBI;EACI,cAAA;A3CsxvBR;A2CpxvBI;EACI,mBAAA;EACA,uBAAA;EACA,YAAA;A3CsxvBR;A2CrxvBQ;EACI,iBAAA;A3CuxvBZ;A2CnxvBQ;EACI,yBAAA;EACA,iCAAA;EACA,6BAAA;A3CqxvBZ;;A2CjxvBA;EACI,cAAA;A3CoxvBJ;A2CjxvBY;EACI,yBxC16CR;AH6ryBR;;A2C9wvBA;EACI,UAAA;A3CixvBJ;;A2C/wvBA;EACI,YAAA;A3CkxvBJ;;A2C/wvBI;EACI,cxCzzCG;EwC0zCH,gBxCj+Ca;AHmvyBrB;A2CjxvBQ;EACI,cxCz9CF;EwC09CE,0BAAA;A3CmxvBZ;;A2C/wvBA;EACI,cxCl0CO;EwCm0CP,gBxC1+CiB;AH4vyBrB;;A2C/wvBI;EACI,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;A3CkxvBR;AIhuyBI;EuC08CA;IAMQ,sBAAA;E3CoxvBV;AACF;;A2C/wvBQ;EACI,8BAAA;A3CkxvBZ;;A4CrxyBI;EACI,iBAAA;A5CwxyBR;A4CvxyBO;EACK,kBAAA;EACA,YAAA;A5CyxyBZ;A4CtxyBY;EACI,YAAA;A5CwxyBhB;A4CvxyBgB;EACI,iBAAA;A5CyxyBpB;A4CvxyBgB;EACI,YAAA;A5CyxyBpB;;A4CjxyBI;EACI,aAAA;EACA,mBAAA;A5CoxyBR;A4ClxyBY;EACI,iBAAA;A5CoxyBhB;;A4C9wyBA;EACI,YAAA;A5CixyBJ;AItwyBI;EwCZJ;IAGQ,eAAA;E5CmxyBN;AACF;A4ClxyBI;EACI,sBzCIA;EyCHA,yBAAA;EACA,czCoCQ;EyCnCR,ezC8TO;EyC7TP,eAAA;ExC4DL,iBwC3D6B;ExC4D7B,oBwC5DwC;A5CqxyB3C;A4CpxyBQ;EACI,czCgCI;AHsvyBhB;AIvxyBI;EwCPA;IAWQ,eAAA;IxCsDT,iBwCrDiC;IxCsDjC,oBwCtD4C;E5CwxyB7C;AACF;;AI9xyBI;EwCUA;IAEQ,kBAAA;E5CuxyBV;AACF;AIpyyBI;EwCUA;IAKQ,eAAA;E5CyxyBV;AACF;;A4CtxyBA;EACI,oBAAA;EACA,mBAAA;A5CyxyBJ;AI9yyBI;EwCmBJ;IAIQ,sBAAA;IACA,gBAAA;E5C2xyBN;AACF;AIpzyBI;EwCmBJ;IAQQ,sBAAA;IACA,aAAA;IACA,kBAAA;E5C6xyBN;AACF;A4C5xyBI;EACI,iBAAA;EACA,kBAAA;A5C8xyBR;AI/zyBI;EwC+BA;IAIQ,cAAA;E5CgyyBV;AACF;A4C7xyBQ;EACI,4BAAA;EACA,sBzC3CJ;EyC4CI,yBAAA;EACA,czCbI;EyCcJ,ezC4QG;EyC3QH,qBAAA;EACA,mBAAA;A5C+xyBZ;;A4C1xyBI;EACI,gBAAA;A5C6xyBR;;A4CzxyBI;EACI,iBAAA;EACA,YAAA;A5C4xyBR;;A4CxxyBI;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;A5C2xyBR;;A4CxxyBA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;A5C2xyBJ;;A4CvxyBQ;EACI,YAAA;EACA,gBAAA;A5C0xyBZ;A4CzxyBY;EACI,UAAA;EACA,QAAA;A5C2xyBhB;A4CzxyBY;EACI,YAAA;EACA,gBAAA;A5C2xyBhB;A4CxxyBQ;EACI,kBAAA;A5C0xyBZ;;A6Cj6yBA;EACI,gB1C0CI;AH03yBR;;A6Cl6yBA;EACI,kBAAA;A7Cq6yBJ;AI53yBI;EyC1CJ;IAGQ,aAAA;E7Cu6yBN;AACF;A6Ct6yBI;EACI,eAAA;EACA,MAAA;EACA,OAAA;A7Cw6yBR;A6Ct6yBI;EACI,eAAA;EACA,YAAA;EACA,QAAA;A7Cw6yBR;A6Ct6yBI;EACI,YAAA;A7Cw6yBR;;A6Cr6yBA;EACI,gBAAA;A7Cw6yBJ;;A8C/7yBA;EACI,gB3C0CI;AHw5yBR;;A8C/7yBI;EACI,kBAAA;A9Ck8yBR;A8Cj8yBQ;EACI,e3CiWG;ECzQb,kB0CvF4B;E1CwF5B,Q0CxFqC;E1CyFrC,W0CzFyC;EAC/B,2BAAA;A9Cq8yBZ;;A8Cj8yBA;EACI,kBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;A9Co8yBJ;A8Cn8yBI;EAGI,oBAAA;EAGA,mBAAA;EACA,eAAA;EACA,c3CgJG;E2C/IH,gBAAA;A9Cq8yBR;A8Cp8yBQ;EACI,aAAA;A9Cs8yBZ;A8Cr8yBY;EACI,mB3ChBJ;AHu9yBZ;A8Ct8yBgB;EACI,MAAA;A9Cw8yBpB;A8Cp8yBQ;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,mDAAA;EACA,mB3C6GA;E2C5GA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,kB3C4RO;AH0qyBnB;A8Cr8yBY;EACI,WAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,wBAAA;EACA,kB3CpBR;E2CqBQ,8CAAA;EACA,+BAAA;EACA,mDAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;A9Cu8yBhB;;A8Cl8yBA;EACI,kBAAA;EACA,c3CjCK;AHs+yBT;A8Cp8yBI;EACI,WAAA;EACA,WAAA;EACA,WAAA;EACA,mB3CtCC;ECaP,mB0C0ByB;E1CzBzB,2B0CyByB;E1CxBzB,uB0CwByB;E1COzB,yB0CN0B;E1CU1B,kB0CTwB;E1CYxB,Y0CZ2C;E1Ca3C,O0CbgD;A9C48yBlD;A8C18yBI;E1C9BF,mB0C+ByB;E1C9BzB,2B0C8ByB;E1C7BzB,uB0C6ByB;A9C88yB3B;A8C58yBI;EACI,c3C/CC;AH6/yBT;;A8C38yBA;EACI,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,2BAAA;A9C88yBJ;;A8C58yBA;EACI,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,2BAAA;A9C+8yBJ;;A8C78yBA;EACI,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,2BAAA;A9Cg9yBJ;;A8C98yBA;EACI,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,2BAAA;A9Ci9yBJ;;A8C/8yBA;EACI,kBAAA;EACA,c3CrGM;E2CsGN,gB3ChHiB;AHkkzBrB;A8Cj9yBI;EACI,WAAA;EACA,WAAA;EACA,WAAA;EACA,mB3C3GE;ECsCR,mB0CsEyB;E1CrEzB,2B0CqEyB;E1CpEzB,uB0CoEyB;E1CrCzB,yB0CsC0B;E1ClC1B,kB0CmCwB;E1ChCxB,Y0CgC2C;E1C/B3C,O0C+BgD;A9Cy9yBlD;A8Cv9yBI;E1C1EF,mB0C2EyB;E1C1EzB,2B0C0EyB;E1CzEzB,uB0CyEyB;A9C29yB3B;A8Cz9yBI;EACI,yBAAA;A9C29yBR;;A8Cx9yBA;EACI,6CAAA;EACA,mCAAA;UAAA,2BAAA;A9C29yBJ;AI3jzBI;E0C8FJ;IAIQ,sBAAA;E9C69yBN;AACF;;A8C39yBA;EACI,gBAAA;EACC,YAAA;A9C89yBL;;A8C59yBA;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,c3CuBO;E2CtBP,e3C6MW;E2C1MX,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;E1CrCF,kB0CsCmB;E1C3GnB,2B0C4GqB;E1C3GrB,mC0C2GqB;E1C1GrB,+B0C0GqB;E1CvErB,kB0CwEoB;E1CvEpB,Q0CuE6B;E1CtE7B,W0CsEiC;A9Cm+yBnC;A8Cl+yBI;EACI,c3CrJE;AHynzBV;;A8Cj+yBA;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,c3CCO;E2CAP,e3CuLW;E2CpLX,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;E1C3DF,kB0C4DmB;E1CjInB,2B0CkIqB;E1CjIrB,mC0CiIqB;E1ChIrB,+B0CgIqB;E1C7FrB,kB0C8FoB;E1C7FpB,Q0C6F6B;E1C5F7B,W0C4FiC;A9Cw+yBnC;A8Cv+yBI;EACI,c3C3KE;AHopzBV;;A8Ct+yBA;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,c3CrBO;E2CsBP,e3CiKW;E2C9JX,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;E1CjFF,kB0CkFmB;E1CvJnB,2B0CwJqB;E1CvJrB,mC0CuJqB;E1CtJrB,+B0CsJqB;E1CnHrB,kB0CoHoB;E1CnHpB,Q0CmH6B;E1ClH7B,W0CkHiC;A9C6+yBnC;A8C5+yBI;EACI,c3CjME;AH+qzBV;;A8C3+yBA;EACI,kBAAA;EACA,e3CtNa;AHoszBjB;;A8C5+yBA;EACI,kBAAA;EACA,kBAAA;EACA,c3C6CQ;E2C5CR,e3C5Na;E2C6Nb,gB3CxNiB;E2CyNjB,mBAAA;A9C++yBJ;A8C9+yBI;EACI,kBAAA;EACA,e3CjOS;E2CkOT,c3CoCK;E2CnCL,gB3C3NW;AH2szBnB;A8C/+yBQ;EACI,WAAA;EACA,mB3CkCA;E2CjCA,WAAA;EACA,WAAA;E1C7IV,kB0C8I4B;E1C7I5B,S0C6IqC;E1C1IrC,W0C0IoD;A9Cm/yBtD;AInrzBI;E0C2LI;IAOQ,WAAA;E9Cq/yBd;AACF;A8Cn/yBQ;EACI,WAAA;EACA,mB3CwBA;E2CvBA,WAAA;EACA,WAAA;E1CvJV,kB0CwJ4B;E1CvJ5B,S0CuJqC;E1CtJrC,Y0CsJ0C;A9Cu/yB5C;AIjszBI;E0CqMI;IAOQ,WAAA;E9Cy/yBd;AACF;;A8Cr/yBA;EACI,gBAAA;A9Cw/yBJ;;A8Ct/yBA;EACI,WAAA;EACA,YAAA;A9Cy/yBJ;AI/szBI;E0CoNJ;IAIQ,WAAA;IACA,YAAA;E9C2/yBN;AACF;;A8Cz/yBA;EACI,kBAAA;A9C4/yBJ;AIztzBI;E0C4NJ;IAGQ,aAAA;E9C8/yBN;AACF;A8C7/yBI;EACI,eAAA;EACA,MAAA;EACA,OAAA;A9C+/yBR;A8C7/yBI;EACI,eAAA;EACA,SAAA;EACA,QAAA;EACA,cAAA;A9C+/yBR;;A+CrxzBI;EACI,e5CsWO;E4CrWP,gB5CQe;E4CPf,mBAAA;A/CwxzBR;AI/uzBI;E2C5CA;IAKQ,e5CiWG;I4ChWF,mBAAA;E/C0xzBX;AACF;A+CxxzBI;EACI,c5CiKG;E4C9JH,oBAAA;EAGA,mBAAA;EACA,kB5CiUW;E4ChUX,aAAA;EACA,WAAA;EACA,kBAAA;A/C0xzBR;A+CzxzBQ;EACI,mB5CyIA;E4CxIA,c5CyJD;AHkozBX;A+C1xzBY;EACI,kBAAA;EACA,gBAAA;EACA,0BAAA;EACA,e5CsUD;E4CrUC,QAAA;EACA,2BAAA;EACA,WAAA;A/C4xzBhB;A+CzxzBQ;EACI,c5C6ID;AH8ozBX;;A+CvxzBA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A/C0xzBJ;A+CzxzBI;EACI,YAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,kB5C8RW;E4C7RX,0BAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;A/C2xzBR;A+C1xzBQ;EACI,c5C2GD;E4C1GC,kBAAA;A/C4xzBZ;A+CxxzBQ;EAGI,oBAAA;EAGA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,c5ClCH;E4CmCG,mB5CgJC;E4C/ID,yBAAA;EACA,kB5CiQO;E4ChQP,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;A/C0xzBZ;A+CzxzBY;EACI,W5C7CR;E4C8CQ,mB5C5CP;E4C6CO,yBAAA;EACA,oBAAA;A/C2xzBhB;A+CzxzBY;EACI,e5CyQD;E4CxQC,iBAAA;A/C2xzBhB;A+CzxzBY;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;A/C2xzBhB;A+CxxzBQ;EACI,gB5CtGS;E4CuGT,c5C2DD;AH+tzBX;A+CvxzBI;EACI,aAAA;A/CyxzBR;A+CvxzBI;EACI,WAAA;EACA,YAAA;EACA,kB5CyNW;E4CxNX,cAAA;EACA,kBAAA;EACA,gB5ClFA;E4CmFA,iBAAA;A/CyxzBR;A+CvxzBI;EACI,aAAA;A/CyxzBR;A+CvxzBI;EACI,WAAA;EACA,YAAA;EACA,e5C2NO;E4C1NP,W5C5FA;E4C6FA,mB5C1GC;E4C2GD,yBAAA;EACA,kB5CyMW;E4CxMX,UAAA;EACA,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;A/CyxzBR;A+CvxzBI;EACI,mB5CnHO;E4CoHP,yBAAA;A/CyxzBR;;A+CjxzBoB;EACI,cAAA;A/CoxzBxB;A+CjxzBgB;EACI,e5CuML;E4CtMK,aAAA;A/CmxzBpB;A+C7wzBgB;EACI,gB5C9JC;E4C+JD,c5CQT;E4CPS,aAAA;A/C+wzBpB;A+C5wzBoB;EACI,iBAAA;A/C8wzBxB;;A+CtwzBI;EACI,kBAAA;A/CywzBR;;A+CtwzBA;EACI,WAAA;EACA,YAAA;EACA,gB5ClJI;E4CmJJ,yBAAA;EACA,kBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,c5CxBO;AHiyzBX;A+CxwzBI;EACI,mB5CxJA;E4CyJA,W5CjKA;AH26zBR;;A+CtwzBI;EACI,mBAAA;A/CywzBR;A+CxwzBQ;EACI,e5CkJG;E4CjJH,gB5C1MS;AHo9zBrB;A+CxwzBQ;EACI,e5C4IG;AH8nzBf;A+CvwzBI;EACI,mBAAA;A/CywzBR;A+CvwzBI;EACI,gBAAA;A/CywzBR;;A+CtwzBA;EACI,mB5CnEQ;E4CoER,kBAAA;EACA,yBAAA;EACA,kBAAA;E3C9HD,gB2C+HyB;E3C9HzB,a2C8HmC;A/C0wzBtC;AIn8zBI;E2CoLJ;I3C1HG,gB2CiI6B;I3ChI7B,a2CgIuC;E/C6wzBxC;AACF;A+C5wzBI;EACI,qB5CnNE;AHi+zBV;A+C7wzBQ;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,kCAAA;EACA,gBAAA;EACA,c5C5CE;E4C6CF,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sB5C5MJ;E4C+MI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;A/C+wzBZ;A+C3wzBQ;EACI,6BAAA;A/C6wzBZ;A+C5wzBY;EACI,yB5CvGJ;AHq3zBZ;;A+CxwzBI;EACI,0BAAA;A/C2wzBR;A+CzwzBI;EACI,W5CrOA;E4CsOA,iBAAA;A/C2wzBR;;A+CxwzBA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A/C2wzBJ;A+C1wzBI;EACI,iBAAA;A/C4wzBR;A+C3wzBQ;EACI,yB5C/HA;ECjCV,kB2CiK2B;EACjB,c5CrHD;E4CsHC,gB5CxRS;EC8FlB,iB2C2LuC;EAC9B,qBAAA;A/C6wzBZ;A+C5wzBY;EACI,yB5CnPR;E4CoPQ,sBAAA;A/C8wzBhB;;A+CzwzBA;EACI,eAAA;A/C4wzBJ;A+C3wzBI;EACI,gB5CpQA;E4CqQA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;A/C6wzBR;A+C5wzBQ;EACI,YAAA;A/C8wzBZ;AIvh0BI;E2CwQI;IAGO,YAAA;E/CgxzBb;AACF;A+C9wzBQ;EACI,eAAA;A/CgxzBZ;A+C9wzBQ;EACI,gB5CrTS;E4CsTT,e5CqCG;E4CpCH,c5ChJD;E4CiJC,gBAAA;EACA,cAAA;A/CgxzBZ;A+C9wzBQ;EACI,qB5ClTF;AHkk0BV;A+C/wzBY;EACI,c5CpTN;AHqk0BV;;A+C3wzBI;EACI,aAAA;EACA,mBAAA;A/C8wzBR;A+C7wzBQ;EACI,kBAAA;A/C+wzBZ;A+C9wzBY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yB5CnUN;E4CoUM,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;A/CgxzBhB;A+C/wzBgB;EACI,yB5CnSN;AHoj0Bd;A+ChxzBoB;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,yB5C/Ud;E4CgVc,kBAAA;EACA,UAAA;A/CkxzBxB;A+C/wzBgB;EACI,yB5CnVR;AHom0BZ;A+ChxzBoB;EACI,yB5CrSR;AHuj0BhB;A+CjxzBwB;EACI,yB5CvVhB;AH0m0BZ;A+C/wzBgB;EACI,yB5C3TT;AH4k0BX;A+ChxzBoB;EACI,wCAAA;A/CkxzBxB;A+CjxzBwB;EACI,yB5C/TjB;AHkl0BX;A+C/wzBgB;EACI,yB5CtUX;AHul0BT;A+ChxzBoB;EACI,yB5C1OX;AH4/zBb;A+CjxzBwB;EACI,yB5C1UnB;AH6l0BT;A+C/wzBgB;EACI,yB5CvVX;AHwm0BT;A+ChxzBoB;EACI,yB5CtKX;AHw7zBb;A+CjxzBwB;EACI,yB5C3VnB;AH8m0BT;A+C9wzBY;EACI,eAAA;A/CgxzBhB;;A+C3wzBA;EAGI,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A/C8wzBJ;;A+C5wzBA;EACI,kBAAA;A/C+wzBJ;A+C9wzBI;EAGI,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,yBAAA;E3CrSN,kB2CsSuB;EACjB,c5CrPG;E4CsPH,gB5C7Za;EC8FlB,gB2CgUmC;A/CgxzBtC;A+C/wzBQ;EACI,iBAAA;E3C3SV,kB2C4S2B;EACjB,WAAA;EACA,YAAA;A/CixzBZ;;A+C5wzBI;E3C3UD,iB2C4U6B;A/C+wzBhC;A+C9wzBQ;EACI,yB5C3QD;E4C4QC,c5CrQD;EClDT,kB2CwT2B;E3C/U1B,iB2CgVuC;EAC9B,qBAAA;A/CgxzBZ;A+C/wzBY;EACI,yB5CpYL;E4CqYK,W5CjZR;AHkq0BR;A+C9wzBQ;EACI,eAAA;A/CgxzBZ;;A+C3wzBI;EACI,gB5C5ba;E4C6bb,mBAAA;A/C8wzBR;A+C5wzBI;EACI,mBAAA;A/C8wzBR;A+C3wzBQ;EACI,e5CvGG;E4CwGH,gB5CpcW;AHit0BvB;;A+CzwzBA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,eAAA;EACA,mBAAA;A/C4wzBJ;A+C3wzBI;EACI,mBAAA;A/C6wzBR;;A+C1wzBA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A/C6wzBJ;;A+C3wzBA;EACI,mBAAA;A/C8wzBJ;A+C7wzBI;EACI,gB5Cpea;AHmv0BrB;A+C7wzBI;EACI,gBAAA;EACA,gBAAA;EACA,WAAA;A/C+wzBR;;A+C5wzBA;EACI,yBAAA;A/C+wzBJ;;A+C5wzBI;EACI,cAAA;A/C+wzBR;AI7t0BI;E2C6cA;IAGQ,iBAAA;E/CixzBV;AACF;A+C/wzBY;EACI,iBAAA;A/CixzBhB;AIru0BI;E2CmdQ;IAGS,gBAAA;IACA,mBAAA;E/CmxzBnB;AACF;;A+C9wzBA;EACI,WAAA;EACA,YAAA;A/CixzBJ;;AgD7x0BA;EACI,cAAA;EACA,gBAAA;AhDgy0BJ;;AgD3x0BY;EACI,aAAA;AhD8x0BhB;AgD1x0BI;EACI,c7CoKG;E6CnKH,yBAAA;EACA,iBAAA;EACA,kB7CmUW;E6ClUX,aAAA;EACA,mBAAA;EACA,6DAAA;AhD4x0BR;AgD3x0BQ;EACI,aAAA;EACA,cAAA;EACA,gCAAA;EACA,+BAAA;EACA,WAAA;EACA,qBAAA;EACA,oBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;E5CqGV,yB4CpGoC;E5CqGpC,iC4CrGoC;E5CsGpC,6B4CtGoC;E5C4DpC,yB4C3D8B;E5C0B9B,wB4CzB6B;E5C0B7B,gC4C1B6B;E5C2B7B,4B4C3B6B;AhDmy0B/B;AgDjy0BQ;E5CuBN,0B4CtB6B;E5CuB7B,kC4CvB6B;E5CwB7B,8B4CxB6B;AhDqy0B/B;AgDly0BI;EACI,aAAA;EACA,gB7CEA;E6CDA,6C7CkTQ;E6CjTR,yBAAA;AhDoy0BR;AgDny0BQ;EACI,iBAAA;EACA,c7CkID;E6CjIC,gB7CJJ;E6CKI,kB7CmSO;AHkg0BnB;AgDpy0BY;EACI,c7C+HL;E6C9HK,mB7C6GJ;AHyr0BZ;;AiDx10BC;EACC,gB9CQmB;E8CPnB,mBAAA;EACA,iBAAA;AjD210BF;;AiDx10BA;EACC,mBAAA;EAGA,oBAAA;EAGA,mBAAA;AjD210BD;AiD110BC;EACC,gB9CLqB;EC4FpB,qB6CtFuB;E7CuFvB,mB6CvFsC;EACvC,kBAAA;AjD610BF;AiD510BE;EACC,WAAA;EACA,yB9CiJS;E8ChJT,UAAA;EACA,YAAA;E7CwED,kB6CvEmB;E7CwEnB,M6CxE6B;E7CyE7B,Q6CzEgC;AjDg20BlC;AI300BI;E6C1BF;IAOE,aAAA;EjDk20BF;AACF;AIh10BI;E6CtCJ;IAwBE,cAAA;EjDk20BA;AACF;;AiD/10BC;EACC,mBAAA;AjDk20BF;AiDj20BE;EACC,qBAAA;EACA,kBAAA;AjDm20BH;AiDl20BG;EACC,WAAA;EACA,YAAA;E7CqFF,kB6CpFmB;EACjB,yBAAA;EAGS,oBAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,c9C2HF;AHyu0BX;AiDn20Ba;EACC,yB9CLN;E8CMM,qB9CNN;E8COM,W9CfN;AHo30BR;AiDl20BG;EACC,eAAA;AjDo20BJ;;AiD910BE;EACC,qBAAA;AjDi20BH;AiD/10BI;EACC,aAAA;AjDi20BL;AiDh20BK;EACC,yBAAA;EACA,6DAAA;E7C4BH,oB6C3B2B;E7C4B3B,iB6C5ByC;E7CmD1C,kB6ClDqB;EACjB,c9CmGK;E8ClGL,eAAA;AjDm20BN;AiDl20BM;EACC,iBAAA;AjDo20BP;AiDh20BM;EACC,qB9CnCC;E8CoCD,c9CpCC;AHs40BR;AiD710BG;EACC,eAAA;AjD+10BJ;;AiD310BA;EACC,c9C9ES;E8C+ET,kBAAA;EACA,gB9C1FoB;AHw70BrB;AiD710BC;EACC,iBAAA;AjD+10BF;AiD710BC;EACC,c9CpFc;AHm70BhB;;AiD510BA;E7CmBE,kB6ClBgB;E7CNf,gB6COsB;E7CNtB,oB6CMgC;EAClC,8DAAA;AjDg20BD;AiD910BE;EACC,qBAAA;EACA,kBAAA;AjDg20BH;AiD/10BG;E7CZA,sB6Ca+B;EAC9B,gB9C5GiB;E8C6GjB,6BAAA;EACA,qBAAA;AjDi20BJ;AiDh20BI;EACC,WAAA;EACA,YAAA;E7CIH,kB6CHoB;EAChB,yBAAA;EAGQ,oBAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,iBAAA;EACA,c9CyCH;E8CxCG,gB9C9HS;E8C+HT,e9CuNC;AH2o0Bf;AiDh20BI;EACC,c9CzHK;E8C0HL,qB9C1HK;AH490BV;;AiD510BA;E7C7CG,gB6C8CsB;E7C7CtB,a6C6CgC;EAClC,8DAAA;EACA,yBAAA;E7CxBC,kB6CyBgB;AjDg20BlB;AiD/10BC;EACC,e9C6Ma;E8C5Mb,gB9ClJmB;E8CmJnB,mBAAA;EACA,c9CeS;AHk10BX;AiD910BE;EACC,c9CpHM;AHo90BT;AiD710BC;EACC,gBAAA;AjD+10BF;;AiD510BA;EACC,W9C9HO;EC6DL,gB6CkE4B;EAC9B,e9CwLc;ECpOb,kB6C6CgB;AjD+10BlB;AiD910BC;EACC,iBAAA;AjDg20BF;;AiD710BA;EACC,gB9CxKoB;E8CyKpB,c9CFU;AHk20BX;;AkDjh1BE;EACC,gBAAA;AlDoh1BH;AkDnh1BG;EAGC,aAAA;EAGA,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,eAAA;AlDqh1BJ;AkDnh1BK;EACC,yB/CgCG;AHq/0BT;AkDjh1BK;EACC,yB/CMI;AH6g1BV;AkD/g1BK;EACC,yB/CHI;AHoh1BV;AkD7g1BK;EACC,qBAAA;AlD+g1BN;AkD7g1BK;EACC,qBAAA;AlD+g1BN;AkD9g1BM;EACC,QAAA;E9CqBL,2B8CpBwB;E9CqBxB,mC8CrBwB;E9CsBxB,+B8CtBwB;AlDkh1B1B;AkD/g1BK;EACC,qBAAA;AlDih1BN;AkD/g1BK;EACC,gB/CnCe;AHoj1BrB;AkD/g1BK;EACC,gB/CrCiB;E+CsCjB,e/CkTS;EC5PZ,oB8CrD2B;E9CsD3B,gB8CtDyC;EACtC,W/CRE;AH0h1BR;AkDjh1BM;EACC,eAAA;AlDmh1BP;AkD7g1BM;E9C4CH,qB8C3C4B;AlD+g1B/B;AkD9g1BO;EACC,gBAAA;AlDgh1BR;AkD9g1BO;EACC,eAAA;AlDgh1BR;;AkDrg1BE;EACC,QAAA;E9CnBD,2B8CoBoB;E9CnBpB,mC8CmBoB;E9ClBpB,+B8CkBoB;AlD0g1BtB;;AkDrg1BC;EACC,SAAA;EACA,UAAA;EACA,e/CkRa;E+CjRb,gB/C5EqB;E+C6ErB,gBAAA;AlDwg1BF;AkDvg1BE;EACC,SAAA;AlDyg1BH;AItj1BI;E8CsCH;IAUE,e/C0QY;EHgw0Bb;AACF;;AkDvg1BA;EACC,yBAAA;EACA,8BAAA;AlD0g1BD;;AkDxg1BA;EACC,gCAAA;EACA,mBAAA;EACA,oBAAA;AlD2g1BD;AkDxg1BI;EACC,mBAAA;AlD0g1BL;AkDtg1BC;EACC,iBAAA;AlDwg1BF;AkDrg1BI;EACC,gBAAA;AlDug1BL;AkDlg1BC;EACC,e/C6Oa;E+C5Ob,gB/CjHqB;E+CkHrB,kBAAA;EACA,cAAA;AlDog1BF;AIrl1BI;E8CkFF;IAEE,e/CsOW;EH+x0Bb;AACF;AkDng1BE;EACC,WAAA;EACA,YAAA;E9CPD,kB8CQkB;EACjB,yBAAA;EAGA,oBAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,iBAAA;EACA,c/C8BQ;E+C7BR,gB/CzIoB;E+C0IpB,e/C4MY;AHyz0Bf;AkDng1BE;EACU,gBAAA;EACA,kCAAA;E9C1DV,kB8C2D4B;E9C1D5B,Q8C0DsC;E9CzDtC,W8CyD2C;E9ChG3C,2B8CiG6B;E9ChG7B,mC8CgG6B;E9C/F7B,+B8C+F6B;EACnB,e/CyMG;E+CxMH,gB/ClJW;AH2p1BvB;AkDtg1BY;EACI,gBAAA;AlDwg1BhB;AkDpg1BC;EACC,SAAA;EACA,gBAAA;AlDsg1BF;;AkDjg1BA;EACC,eAAA;EACA,MAAA;EACA,OAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AlDog1BD;AkDng1BC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iDAAA;AlDqg1BF;AkDng1BG;EACD,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,c/C3IS;E+C4IT,wBAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;AlDqg1BF;AkDng1BG;EACD,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,mB/C1JM;E+C2JN,UAAA;EACA,YAAA;EACA,wDAAA;AlDqg1BF;;AkDhg1BE;EACD;IAAO,yBAAA;ElDog1BN;AACF;AkDlg1BA;EACI,mBAAA;AlDog1BJ;AkDng1BC;EACC,eAAA;EACA,gBAAA;EACA,c/C7CS;E+C8CT,kBAAA;AlDqg1BF;AkDng1BC;EACC,c/CtDS;E+CuDT,eAAA;AlDqg1BF;;AkDjg1BC;EACC,eAAA;EACA,gBAAA;EACA,mBAAA;AlDog1BF;AkDlg1BC;EACC,eAAA;EACA,gBAAA;EACA,mBAAA;AlDog1BF;AkDlg1BC;EACC,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AlDog1BF;AkDlg1BC;EACC,cAAA;EACA,eAAA;EACA,cAAA;AlDog1BF;AkDhg1BG;EACC,YAAA;AlDkg1BJ;AkD9/0BC;EACC,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gCAAA;EACA,mBAAA;AlDgg1BF;AkD//0BE;EACC,UAAA;EACA,mBAAA;AlDig1BH;AkDhg1BG;EACC,c/C/FO;E+CgGP,gBAAA;EACA,kBAAA;AlDkg1BJ;AkDhg1BG;EAEC,c/ClGO;E+CmGP,gBAAA;AlDig1BJ;AkD//0BG;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AlDig1BJ;AkD//0BG;EACC,iBAAA;AlDig1BJ;;AkD3/0BC;EACC,eAAA;EACA,mBAAA;AlD8/0BF;;AkD3/0BA;EACC,oBAAA;AlD8/0BD;;AkD5/0BA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACH,mBAAA;AlD+/0BD;;AkD5/0BC;EACC,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;AlD+/0BF;;AkD5/0BA;EACI,aAAA;EACA,mBAAA;AlD+/0BJ;;AkD7/0BA;EACI,iBAAA;AlDgg1BJ;AkD//0BC;EACC,eAAA;EACA,kBAAA;EACA,gBAAA;AlDig1BF;AkD//0BC;EACC,eAAA;EACA,gBAAA;AlDig1BF;;AkD7/0BA;EACI,mBAAA;EACA,yBAAA;EACA,mBAAA;AlDgg1BJ;AkD//0BC;EACC,mBAAA;AlDig1BF;;AkD9/0BA;EACC,mBAAA;EACG,yBAAA;EACA,mBAAA;AlDig1BJ;AkDhg1BC;EACC,mBAAA;AlDkg1BF;;AkD//0BA;EACI,mBAAA;EACA,aAAA;AlDkg1BJ;AkDhg1BE;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;AlDkg1BH;AkDjg1BG;EACC,eAAA;EACA,c/ChMO;E+CiMP,gBAAA;EACA,SAAA;AlDmg1BJ;AkDjg1BG;EACC,eAAA;EACA,c/CjMO;E+CkMP,gBAAA;EACA,SAAA;AlDmg1BJ;AkDjg1BG;EACC,gBAAA;AlDmg1BJ;;AkD9/0BA;EACC,gBAAA;EACA,iBAAA;EACA,6BAAA;AlDig1BD;AkDhg1BC;EACC,eAAA;EACA,gBAAA;EACA,c/ClNS;E+CmNT,mBAAA;AlDkg1BF;AkDhg1BC;EACC,c/C3NS;E+C4NT,eAAA;EACA,oBAAA;AlDkg1BF;;AkD9/0BC;EACC,gBAAA;AlDig1BF;AkD//0BC;EACC,SAAA;EACA,eAAA;AlDig1BF;AkDhg1BE;EACC,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AlDkg1BH;AkDjg1BG;EACC,kBAAA;EACA,UAAA;EACA,c/C/OO;E+CgPP,eAAA;EACA,SAAA;AlDmg1BJ;AkDlg1BI;EACC,kBAAA;EACA,YAAA;EACA,UAAA;EACA,QAAA;AlDog1BL;AkDjg1BG;EACC,kBAAA;EACA,UAAA;EACA,c/CvPO;E+CwPP,eAAA;EACA,SAAA;AlDmg1BJ;;AkD7/0BC;EACC,eAAA;EACA,gBAAA;EACA,mBAAA;AlDgg1BF;;AkD7/0BA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,8DAAA;EACA,kBAAA;EACH,mBAAA;AlDgg1BD;AkD//0BC;EACC,UAAA;AlDig1BF;AkD9/0BE;EACC,c/CtRQ;E+CuRR,mBAAA;AlDgg1BH;AkD9/0BE;EACC,eAAA;EACA,aAAA;AlDgg1BH;AkD//0BG;EACC,UAAA;AlDig1BJ;AkDhg1BI;EACC,SAAA;EACA,eAAA;EACA,gBAAA;AlDkg1BL;AkDhg1BI;EACC,eAAA;EACA,gBAAA;AlDkg1BL;;AkD3/0BC;EACC,2BAAA;AlD8/0BF;AkD5/0BC;EACC,WAAA;AlD8/0BF;AkD5/0BC;EACC,eAAA;AlD8/0BF;;AkD3/0BA;EACC,0BAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;AlD8/0BD;AkD7/0BC;EACC,mB/CzdQ;E+C0dR,sBAAA;AlD+/0BF;;AkDz/0BE;EACC,YAAA;AlD4/0BH;AkDz/0BC;EACC,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AlD2/0BF;AkDz/0BC;EACC,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AlD2/0BF;;AkDx/0BA;EACC,kBAAA;AlD2/0BD;AkD1/0BC;EACC,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;AlD4/0BF;AkD1/0BC;EACC,0BAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,c/C3WS;E+C4WT,OAAA;EACA,aAAA;EACA,gBAAA;AlD4/0BF;;AkDx/0BC;EACC,gBAAA;EACA,yBAAA;EACA,iBAAA;EACA,0BAAA;EACA,yBAAA;AlD2/0BF;AkD1/0BE;EACC,SAAA;EACA,kBAAA;EACA,eAAA;AlD4/0BH;AkD1/0BE;EACC,gBAAA;AlD4/0BH;AkD1/0BE;EACC,sBAAA;EACA,mB/C1hBO;AHsh2BV;AkD1/0BE;EACC,sBAAA;AlD4/0BH;AkDz/0BC;EACC,0BAAA;EACA,yBAAA;AlD2/0BF;;AkDt/0BC;EACC,eAAA;EACA,WAAA;AlDy/0BF;;AkDr/0BA;EACC,eAAA;EACA,6BAAA;EACA,gCAAA;AlDw/0BD;AkDv/0BC;EACC,cAAA;EACA,SAAA;AlDy/0BF;;AkDr/0BC;EACC,YAAA;AlDw/0BF;;AkDp/0BC;EACC,sBAAA;AlDu/0BF;;AmDtk2BQ;EACI,mBhD6JA;EgD5JA,kBAAA;EACA,mBAAA;AnDyk2BZ;AmDxk2BY;EACI,gBAAA;AnD0k2BhB;AmDvk2BgB;EACI,ehD0VL;EgDzVK,gBhDFC;EgDGD,chDoKT;EgDnKS,kBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;AnDyk2BpB;AmDvk2BgB;EACI,ehD+UL;EgD9UK,mBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;AnDyk2BpB;AmDvk2BgB;EACI,WhDYZ;EC6DL,gB+CxE+C;EAC9B,ehDkUL;ECpOb,kB+C7FmC;AnDyk2BrC;AmDxk2BoB;EACI,iBAAA;AnD0k2BxB;AmDtk2BY;EACI,aAAA;EACA,mBAAA;AnDwk2BhB;AIrk2BI;E+CLQ;IAIQ,cAAA;EnD0k2BlB;AACF;AmDxk2BgB;EACI,cAAA;EACA,oBAAA;EACA,iBAAA;AnD0k2BpB;AmDzk2BoB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AnD2k2BxB;AmDxk2BgB;EACI,gBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;AnD0k2BpB;;AI5l2BI;E+CyBA;IAEQ,6BAAA;EnDsk2BV;AACF;;AmDnk2BA;EACI,gBAAA;AnDsk2BJ;AmDrk2BI;EACI,kBAAA;AnDuk2BR;AmDtk2BQ;EACI,yBhD8EA;ECxDT,gB+CrBiC;E/CsBjC,sB+CtB2C;AnDyk2B9C;AmDxk2BY;EACI,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,8BAAA;EACA,sCAAA;EACA,mBAAA;EACA,gCAAA;EACA,kBAAA;AnD0k2BhB;AmDzk2BgB;EACI,gBhDnFG;EgDoFH,kBAAA;AnD2k2BpB;AmDzk2BgB;EACI,qBAAA;AnD2k2BpB;AmDzk2BgB;EACI,mBAAA;AnD2k2BpB;AmDxk2BY;EACI,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,8BAAA;EACA,sCAAA;EACA,eAAA;AnD0k2BhB;AmDzk2BgB;EACI,mBAAA;AnD2k2BpB;AmDxk2BY;EACI,mBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;AnD0k2BhB;AmDzk2BgB;EACI,kBAAA;AnD2k2BpB;AmDxk2BY;EACI,gBAAA;AnD0k2BhB;;AoDxs2BC;EACC,cjD+KS;EiD9KT,eAAA;EACA,gBAAA;EACA,gBjDMqB;AHqs2BvB;AoD1s2BE;EACC,iBAAA;ApD4s2BH;AoDzs2BG;EACC,cjDmBK;AHwr2BT;AoDvs2BG;EACC,cjDQM;AHis2BV;AoDrs2BG;EACC,cjDOM;AHgs2BV;;AoDls2BA;EACC,yBAAA;EhD4EE,gBgD3EsB;EhD4EtB,sBgD5EgC;EAClC,kBAAA;EhDkGC,kBgDjGgB;ApDss2BlB;AoDrs2BC;EACC,WAAA;EACA,yBjDHO;EiDIP,UAAA;EACA,YAAA;EhD4FA,kBgD3FiB;EhD2DjB,kBgD1DkB;EhD2DlB,MgD3D4B;EhD8D5B,OgD9D2C;ApDys2B7C;AoDvs2BC;EACC,gBAAA;ApDys2BF;;AoDts2BA;EACC,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;ApDys2BD;AoDxs2BC;EACC,qBAAA;EACA,qBAAA;EAKC,cjDyHQ;AH6k2BX;AoD1s2BE;EACC,cjDuHQ;EiDtHR,kBAAA;ApD4s2BH;AoDxs2BC;EACC,qBAAA;ApD0s2BF;AoDzs2BE;EACC,eAAA;ApD2s2BH;AoDxs2BG;EACC,iBAAA;ApD0s2BJ;;AoDrs2BA;EACC,YAAA;ApDws2BD;AoDvs2BC;EACC,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;ApDys2BF;AoDxs2BE;EACC,qBAAA;EACA,cjDiGQ;AHym2BX;AoDzs2BG;EACC,eAAA;ApD2s2BJ;AoDxs2BI;EACC,iBAAA;ApD0s2BL;AoDts2BI;EACC,iBAAA;ApDws2BL;AoDps2BG;EACC,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;ApDss2BJ;AoDrs2BI;EACC,kBAAA;EACA,YAAA;ApDus2BL;AoDts2BK;EACC,WAAA;EACA,YAAA;EhDsBJ,kBgDrBqB;ApDws2BvB;AIrw2BI;EgDyBJ;IA2CE,WAAA;EpDqs2BA;AACF;;AoDns2BA;EACC,kBAAA;ApDss2BD;AoDrs2BC;EhDvBC,kBgDwBkB;EhDvBlB,QgDuB4B;EhDpB5B,UgDoB6C;EhD7D7C,2BgD8DmB;EhD7DnB,mCgD6DmB;EhD5DnB,+BgD4DmB;EACnB,cAAA;EACA,cjDtGQ;AHiz2BV;AoDzs2BC;EACC,kBAAA;ApD2s2BF;;AoDxs2BA;EACC,mBAAA;ApD2s2BD;AoD1s2BC;EACC,gBjDzHmB;EiD0HnB,kBAAA;ApD4s2BF;AoD1s2BC;EACC,gBjD5HqB;AHw02BvB;;AoDxs2BC;EACC,mBAAA;ApD2s2BF;AoDzs2BC;EACC,gBjDrImB;EiDsInB,cjDiCS;EiDhCT,mBAAA;ApD2s2BF;AoDzs2BC;EACC,gCAAA;EACA,mBAAA;ApD2s2BF;;AqDh22BA;EACI,yBAAA;EACA,6DAAA;EACA,kBAAA;EjDoGD,qBiDnGyB;EjDoGzB,aiDpGwC;EACvC,WAAA;EACA,gBAAA;ArDo22BJ;AqDn22BI;EACI,eAAA;ArDq22BR;;AqDj22BI;EACI,WAAA;EACA,YAAA;EACA,mBlDmJI;EkDlJJ,kBAAA;EACA,clD0PM;AH0m2Bd;AqDn22BQ;EACI,mBlDuLC;EkDtLD,cAAA;ArDq22BZ;;AqD912BY;EACI,gBAAA;ArDi22BhB;;AqD112BI;EACI,uBAAA;EACA,WAAA;EACA,WAAA;ArD612BR;AqD512BQ;EACI,WAAA;EACA,WAAA;EACA,kBAAA;ArD812BZ;AqD712BY;EACI,mBlDpBN;AHm32BV;AqD712BY;EACI,mBlDFP;AHi22BT;AqD712BY;EACI,mBlDxBT;AHu32BP;AqD712BY;EACI,mBlDzBN;AHw32BV;AqD712BY;EACI,mBlDLR;AHo22BR;AqD712BY;EACI,mBlD7BP;AH432BT;AqD312BI;EACI,iBAAA;EACA,clDgHG;EkD/GH,gBlDxDa;AHq52BrB;;AqDz12BI;EACI,clDnDE;EkDoDF,gBlD9Da;EkD+Db,mBAAA;EACA,qBAAA;ArD412BR;AqD312BQ;EACI,iBAAA;ArD612BZ;;AqDv12BQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,yBAAA;EACA,6DAAA;EACA,kBAAA;EjDUT,iBiDTuC;EAC9B,gBlDtFS;AHg72BrB;AqDx12BgB;EjDPd,yBiDQsC;EjDzCtC,yBiD0CqC;EjDzCrC,iCiDyCqC;EjDxCrC,6BiDwCqC;ArD812BvC;AqD312BY;EACI,aAAA;ArD612BhB;AqD312BY;EAGI,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;ArD612BhB;AqD512BgB;EACI,elD+OL;AH+m2Bf;AqD112BQ;EACI,elD8OG;EkD7OH,clDyDD;AHmy2BX;AqD312BY;EAGG,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;ArD612Bf;AqD512Be;EACI,eAAA;ArD812BnB;AqD112BQ;EACI,WAAA;ArD412BZ;;AqDx12BA;EACI,kBAAA;EACA,iBAAA;ArD212BJ;AqD112BI;EjD9CF,kBiD+CwB;EjD9CxB,QiD8CkC;EjD3ClC,UiD2CmD;EAC7C,cAAA;EACA,2BAAA;EACA,clDgCG;AH8z2BX;AqD112BY;EACI,YAAA;EACA,kBAAA;EACA,clDyBL;EkDxBK,gBlD/IK;AH2+2BrB;AqD312BgB;EACI,kBAAA;EACA,iBAAA;EACA,clDoBT;EkDnBS,gBlDpJC;EkDqJD,mBAAA;ArD612BpB;AqD312BgB;EACI,YAAA;ArD612BpB;;AqDv12BA;EACI,gCAAA;EACA,mBAAA;ArD012BJ;AqDz12BI;EACI,mBAAA;ArD212BR;AqD112BQ;EACI,qBAAA;ArD412BZ;AqD112BgB;EACI,4BAAA;ArD412BpB;AqDx12BgB;EACI,gBAAA;ArD012BpB;AqDv12BY;EjDlFT,eiDmFqC;EjDlFrC,4BiDkF8C;EACjC,elD0KD;EkDzKC,gBlDlLK;EkDmLL,qBAAA;EACA,kBAAA;EACA,mBlD/BJ;EkDgCI,clD2EF;EkD1EE,kBAAA;EACA,gBAAA;ArD012BhB;AqDz12BgB;EACI,WAAA;EjDrGlB,kBiDsGoC;EjDrGpC,MiDqG8C;EjDpG9C,YiDoGgD;EAC9B,WAAA;EACA,YAAA;EACA,6CAAA;EACA,yCAAA;EACA,0CAAA;EACA,sCAAA;EACA,UAAA;EACA,mBlD7CR;EkD+CQ,wEAAA;EACA,2BAAA;ArD612BpB;AqD312BgB;EACI,WlDxKZ;AHqg3BR;AqD512BoB;EACI,mBlD3LjB;AHyh3BP;AqD512BoB;EACI,8BAAA;ArD812BxB;AqD312BgB;EACI,WlDjLZ;AH8g3BR;AqD512BoB;EACI,mBlDlMd;AHgi3BV;AqD512BoB;EACI,8BAAA;ArD812BxB;AqD312BgB;EACI,WlD1LZ;EkD2LY,8BAAA;ArD612BpB;AqD512BoB;EACI,mBlD3Lf;AHyh3BT;AqD512BoB;EACI,8BAAA;ArD812BxB;AqD312BgB;EACI,WlDpMZ;AHii3BR;AqD512BoB;EACI,mBlDnMjB;AHii3BP;AqD512BoB;EACI,8BAAA;ArD812BxB;AqD312BgB;EACI,WlD7MZ;AH0i3BR;AqD512BoB;EACI,mBlDlOd;AHgk3BV;AqD512BoB;EACI,8BAAA;ArD812BxB;AqD312BgB;EACI,WlDtNZ;AHmj3BR;AqD512BoB;EACI,mBlDrOf;AHmk3BT;AqD512BoB;EACI,8BAAA;ArD812BxB;AqD312BgB;EACI,WlD/NZ;EkDgOY,mBlDYL;AHi12Bf;AqD512BoB;EACI,mBlDUT;AHo12Bf;AqD512BoB;EACI,8BAAA;ArD812BxB;AIjk3BI;EiD4IQ;IA2FQ,wBAAA;ErD812BlB;AACF;AItk3BI;EiDgII;IA2GQ,cAAA;ErD+12Bd;AACF;;AsDxn3BA;EAGC,aAAA;EAGA,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;ElD8FE,gBkD7FsB;ElD8FtB,akD9FgC;ElDqHjC,kBkDpHgB;AtD4n3BlB;AI1l3BI;EkD7CJ;IlDuGG,gBkD1FuB;IlD2FvB,akD3FiC;EtD+n3BlC;AACF;AsD9n3BC;EAGC,aAAA;EAGA,mBAAA;AtDgo3BF;AsD/n3BE;EACC,WAAA;EACA,YAAA;ElDuGD,kBkDtGkB;EAGjB,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WnDQK;EmDPL,kBAAA;AtDio3BH;AsD/n3BE;EACC,cnD0IQ;EmDzIR,gBnD9BkB;AH+p3BrB;AsD9n3BC;EACC,cnDgIS;AHgg3BX;AI/n3BI;EkDFH;IAGE,enD6TY;EHq02Bb;AACF;AIpo3BI;EkDFH;IAME,enDwTY;EH402Bb;AACF;AsDlo3BC;EACC,yBnDqJW;AH++2Bb;AsDno3BE;EACC,yBnDzBM;AH8p3BT;AsDlo3BC;EACC,yBnD0JY;AH0+2Bd;AsDno3BE;EACC,yBnDvCS;AH4q3BZ;AsDlo3BC;EACC,yBnD+JW;AHq+2Bb;AsDno3BE;EACC,yBnDZQ;AHip3BX;AsDlo3BC;EACC,yBnDyHY;AH2g3Bd;AsDno3BE;EACC,yBnDtBK;AH2p3BR;;AsDjo3BA;ElD0BG,gBkDzBsB;ElD0BtB,oBkD1BgC;EAClC,8DAAA;EACA,sBnDrCO;ECoFN,kBkD9CgB;AtDqo3BlB;AsDno3BE;EACC,kBAAA;AtDqo3BH;AsDpo3BG;EACC,kBAAA;EACA,gBnD7EiB;EmD8EjB,6BAAA;ElDgBD,uBkDf+B;EAGrB,oBAAA;EAGN,mBAAA;EACH,uBAAA;EACG,+BAAA;EACA,qBAAA;AtDso3BP;AsDro3BI;EACC,qBnDhFK;AHut3BV;AsDro3BI;EACC,WAAA;EACA,YAAA;EAGS,oBAAA;EAGH,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,yBAAA;ElDaT,kBkDZ0B;EACjB,iBAAA;EACA,enD4OI;EmD3OJ,gBnD3GY;EmD4GZ,cnDqDA;AHkl3BX;AsDpo3BG;EACC,eAAA;AtDso3BJ;;AsDjo3BA;EAGC,oBAAA;EAGA,mBAAA;AtDoo3BD;AsDno3BG;EACC,kBAAA;EACF,oBAAA;AtDqo3BF;AsDpo3BE;EACC,WAAA;EACA,YAAA;AtDso3BH;AsDpo3BI;EACC,cAAA;AtDso3BL;AsDno3BK;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AtDqo3BN;AsDjo3BK;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBnDnHE;EmDoHF,yBAAA;EAGF,oBAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,enD0LW;EmDzLX,gBnD/JmB;EmDgKnB,cnDCO;AHko3BX;;AsD7n3BC;EACC,qBAAA;EACA,kBAAA;AtDgo3BF;AsD/n3BE;EACC,gBnD1KoB;AH2y3BvB;AsD/n3BE;EACC,eAAA;EACA,gBnD9KoB;EmD+KpB,cnDdQ;AH+o3BX;AsD/n3BE;EACC,eAAA;AtDio3BH;;AuD7z3BC;EACC,QAAA;AvDg03BF;;AuD7z3BA;EACC,WAAA;EACA,YAAA;EACA,kBAAA;AvDg03BD;;AuD9z3BA;EACC,aAAA;EACA,mBAAA;AvDi03BD;;AuD9z3BA;EACC,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AvDi03BD;;AuD/z3BA;EACC,gBAAA;EACA,cAAA;AvDk03BD;;AuD7z3BG;EACC,eAAA;AvDg03BJ;;AuD3z3BA;EACC,WAAA;EACA,YAAA;AvD8z3BD;;ACly3BA,uBAAA;AuDpEA;EACI,0BAAA;EACA,WAAA;AxD023BJ;AwDz23BI;EACI,YAAA;AxD223BR;;AwDv23BI;EACI,yDAAA;EpDsHN,kBoDrHuB;AxD023BzB;AwDz23BQ;EACI,crD8PC;EqD7PD,iBAAA;EpDkHV,kBoDjH2B;EACjB,kBAAA;EACA,erDqVG;EqDpVH,gBrDRS;EqDST,mBAAA;AxD223BZ;AwD123Ba;EAGG,oBAAA;EAGA,mBAAA;AxD423BhB;AwD323BgB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AxD623BpB;AwDz23BQ;EACI,YAAA;AxD223BZ;AwDz23BQ;EACI,YAAA;EACA,UAAA;AxD223BZ;;AwDv23BA;EpDoDE,kBoDnDoB;EpDoDpB,QoDpD6B;EpDuD7B,SoDvD2C;EACzC,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,QAAA;EpDMF,yCoDLqB;EpDMrB,iDoDNqB;EpDOrB,6CoDPqB;AxD823BvB;;AwD523BA;EACI,kBrDZI;EqDaJ,yBAAA;EACA,eAAA;EpD8CD,YoD7C+B;AxD+23BlC;;AwD723BA;EACI,mBrD1CM;EqD2CN,WrDpBI;AHo43BR;;AwD723BI;EACI,2BAAA;EACA,qBrDhDE;AHg63BV;;AwD723BA;EACI,aAAA;AxDg33BJ;;AwD923BA;;EAEI,6DAAA;AxDi33BJ;;AwD/23BA;;;;;;;EAOI,qBrDiFQ;EqDhFR,crDoLS;EqDnLT,YAAA;EACA,iBAAA;AxDk33BJ;;AwDh33BA;EACI,iBAAA;EACA,YAAA;EACA,gBAAA;AxDm33BJ;AwDl33BI;EACI,iBAAA;EACA,mBAAA;AxDo33BR;AwDj33BQ;EAGI,oBAAA;EAGA,mBAAA;AxDm33BZ;AwDl33BY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AxDo33BhB;AwDh33BI;EACI,QAAA;EACA,UAAA;AxDk33BR;;AwD923BI;EAGQ,oBAAA;EAGA,mBAAA;AxDi33BZ;AwDh33BY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AxDk33BhB;;AwD923BA;;;EAGI,yBrDsBQ;EqDrBR,qBrDqBQ;EqDpBR,crDgCO;EqD/BP,kBAAA;AxDi33BJ;;AwD/23BA;EACI,qBrDsBQ;AH413BZ;;AyDlg4BA;EACI,oBAAA;EACA,sBAAA;AzDqg4BJ;;AyDng4BA;;;;;EAKI,uBAAA;EACA,2BAAA;EACA,kCAAA;EACA,uBAAA;EACA,yBAAA;EACA,0BAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBtDNmB;EsDOnB,2BAAA;AzDsg4BJ;;AyDpg4BA;;;;;EAKI,sBAAA;EACA,2BAAA;EACA,kCAAA;EACA,mBAAA;EACA,2BAAA;EACA,yBAAA;EACA,0BAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBtDvBmB;EsDwBnB,2BAAA;AzDug4BJ;;AyDpg4BI;EACI,YAAA;AzDug4BR;;AyDpg4BA;EACI,mBAAA;EACA,etDuTW;EsDtTX,ctDkIO;EsDjIP,gBtDnCmB;AH0i4BvB;;AyDrg4BA;EACI,eAAA;AzDwg4BJ;;AyDpg4BI;EACI,oBAAA;EACA,4BAAA;EACA,kBAAA;AzDug4BR;AyDtg4BQ;ErD8CL,aqD7CiC;AzDwg4BpC;AyDvg4BY;EACI,gBtDjBR;EsDkBQ,yBAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,ctDwGL;AHi63BX;AyDxg4BgB;EACI,mBtDnBZ;EsDoBY,WtD5BZ;AHsi4BR;AyDvg4BY;EACI,mBtDxBR;EsDyBQ,qBtDzBR;EC4EN,kBqDlD+B;EACjB,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AzDyg4BhB;AyDvg4BY;EACI,WAAA;EACA,kBAAA;AzDyg4BhB;AyDxg4BgB;EACI,6BAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AzD0g4BpB;AyDzg4BoB;EACI,iBAAA;AzD2g4BxB;AyDzg4BoB;EACI,ctD7ChB;AHwj4BR;AyDvg4BY;EACI,WAAA;EACA,kBAAA;AzDyg4BhB;AyDxg4BgB;EACI,6BAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AzD0g4BpB;AyDzg4BoB;EACI,gBAAA;AzD2g4BxB;AyDzg4BoB;EACI,ctD7DhB;AHwk4BR;AI9k4BI;EqDQA;IAiEQ,uBAAA;IACA,+BAAA;IACA,qBAAA;EzDyg4BV;AACF;;AyDtg4BA;;EAEI,2BAAA;AzDyg4BJ;;AyDtg4BI;EAGI,aAAA;EAGA,mBAAA;EACA,ctDkIK;EsDjIL,etD4NO;AH6y3Bf;AyDxg4BQ;EACI,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,ctDmCD;EsDlCC,aAAA;AzD0g4BZ;AI5m4BI;EqDoFA;IAiBQ,uBAAA;IACA,+BAAA;IACA,qBAAA;IACA,mBAAA;EzD2g4BV;AACF;;AIpn4BI;EqD4GJ;IAEQ,kBAAA;EzD2g4BN;AACF;;AyDxg4BA;EACI,iBAAA;AzD2g4BJ;;AyDzg4BA;EACI,aAAA;AzD4g4BJ;;AyD1g4BA;EACI,aAAA;AzD6g4BJ;;AyD3g4BA;EACI,aAAA;AzD8g4BJ;;AyD5g4BA;EACI,aAAA;AzD+g4BJ;;AyD7g4BA;EACI,yBAAA;EACA,kBAAA;AzDgh4BJ;;AyD5g4BQ;EACI,qBtDfA;AH8h4BZ;AyD9g4BY;EACI,ctDXL;AH2h4BX;AyD5g4BI;EACI,qBtDtBI;AHoi4BZ;AyD7g4BY;EACI,ctDbL;EsDcK,etDsKD;EsDrKC,gBtDtLK;AHqs4BrB;;AyD3g4BA;EACI,cAAA;AzD8g4BJ;;AA3s4BA;EACE,qBAAA;EACA,cAAA;AA8s4BF;;AA3s4BA;EACE,aAAA;AA8s4BF;;AAvs4BQ;EACE,sBAAA;AA0s4BV;AAts4BM;EACE,eAAA;AAws4BR;;AAls4BA;EACE,sBAAA;EACA,gBAAA;AAqs4BF;;AAjs4BA;EACE,mBAAA;EACA,qBAAA;EACA,WAAA;AAos4BF;;AAhs4BA;;EAEE,mBAAA;AAms4BF;;AA/r4BA;;EAEE,yBAAA;EACA,WAAA;AAks4BF;;AA/r4BA;EACE,sBAAA;AAks4BF;;AA/r4BA;EACE,WAAA;EACA,yBAAA;EACA,yBAAA;AAks4BF;;AA9r4BA;EACE,aAAA;AAis4BF;;AA7r4BA;EACE,kBAAA;EACA,eGuRa;EHtRb,gBAAA;EACA,eAAA;EACA,WGpCM;AHou4BR;;AA7r4BA;EACE,oCAAA;AAgs4BF;AA9r4BE;EACE,mDAAA;AAgs4BJ;AA7r4BE;EACE,oDAAA;AA+r4BJ;AA5r4BE;EACE,mDAAA;AA8r4BJ;AA3r4BE;EACE,oDAAA;AA6r4BJ;AA1r4BE;EACE,oCAAA;AA4r4BJ;;AApr4BA;EAIE,sBAAA;AAor4BF;;AAlq4BA;EACE,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;AAqq4BF;;AAlq4BA;EACE,MAAA;EACA,gBAAA;AAqq4BF;;AAjq4BA;;EAEE,kBAAA;AAoq4BF;;AAjq4BA;;EAEE,gBAAA;EACA,qBAAA;EACA,6DAAA;EACA,YAAA;EACA,kBAAA;AAoq4BF;;AAjq4BA;EACE,yBAAA;AAoq4BF;;AAlq4BA;EACE,oCAAA;AAqq4BF;;AAjq4BA;EACE,uBAAA;AAoq4BF;;AAjq4BA;EACE,cAAA;EACA,UAAA;EACA,SAAA;AAoq4BF;;AAjq4BA;EACE,UAAA;AAoq4BF;;AAjq4BA;EACE,aAAA;EAEA,6BAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;AAmq4BF;;AAhq4BA;EACE,4BAAA;AAmq4BF;;AAhq4BA;EACE,aAAA;EACA,eAAA;AAmq4BF;;AAhq4BA;EACE,4BAAA;AAmq4BF;;AAhq4BA;EACE,yBAAA;EACA,yBAAA;AAmq4BF;;AAhq4BA;EACE,yBAAA;AAmq4BF;;AAhq4BA;EACE,yBAAA;AAmq4BF;;AA7p4BA;EACE,gBAAA;AAgq4BF;;AA7p4BA;EACE,oCAAA;EACA,gCAAA;AAgq4BF;;AA7p4BA;EACE,gCAAA;AAgq4BF;;AA1p4BA;;;;EAIE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AA6p4BF;;AA1p4BA;EACE,aAAA;EACA,mBAAA;AA6p4BF;;AA1p4BA;;EAEE,gCAAA;AA6p4BF;;AA1p4BA;EACE,mBAAA;AA6p4BF;;AA1p4BA;EACE,YAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,cAAA;EACA,6DAAA;AA6p4BF;;AA1p4BA;EACE,aAAA;EACA,mBAAA;AA6p4BF;;AA1p4BA;;EAEE,eAAA;AA6p4BF;;AA1p4BA;EACE,WAAA;AA6p4BF;;AA1p4BA;EACE,qBAAA;EACA,cAAA;EACA,6DAAA;AA6p4BF;;AA1p4BA;EACE,eAAA;AA6p4BF;;AA1p4BA;;EAEE,WAAA;AA6p4BF;;AA1p4BA;EACE,wBAAA;AA6p4BF;;AA1p4BA;EACE,gBAAA;EACA,MAAA;AA6p4BF;;AA1p4BA;EACE,iBAAA;EACA,cAAA;AA6p4BF;;AA1p4BA;EACE,WAAA;AA6p4BF;;AA1p4BA;EACE,sBAAA;AA6p4BF;;AA1p4BA;EACE,kBAAA;AA6p4BF;;AA1p4BA;;EAEE,kBAAA;AA6p4BF;;AA1p4BA;;EAEE,kBAAA;AA6p4BF;;AA1p4BA;;EAEE,UAAA;AA6p4BF;;AA1p4BA;;EAEE,kBAAA;AA6p4BF;;AA1p4BA;;;EAIE,yBAAA;EACA,cAAA;AA4p4BF;;AAzp4BA;;EAEE,cAAA;AA4p4BF;;AAvp4BA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;AA0p4BF;;AAxp4BA;EACE,aAAA;AA2p4BF;;AAzp4BA;EACE,yBAAA;EACA,kBAAA;AA4p4BF;;AA1p4BA;EACE,kBAAA;AA6p4BF;;AA3p4BA;EACE,cAAA;AA8p4BF;;AA5p4BA;EACE,aAAA;AA+p4BF;;AA7p4BA;;EAEE,yBAAA;AAgq4BF;;AA9p4BA;EACE,yBAAA;AAiq4BF;;AA/p4BA;EACE,qBAAA;AAkq4BF;;AAhq4BA;EACE,qBAAA;EACA,2BAAA;EACA,gBAAA;AAmq4BF;;AAjq4BA;EACE,qBAAA;EACA,6BAAA;AAoq4BF;;AAlq4BA;EACE,qBAAA;AAqq4BF;;AAnq4BA;EACE,qBAAA;EACA,6BAAA;AAsq4BF;;AAnq4BE;EAIE,yBAAA;AAmq4BJ;AAjq4BE;;EAQE,qBAAA;AA6p4BJ;AA3p4BE;EACE,mBAAA;AA6p4BJ;AA3p4BE;EAGE,mBAAA;AA2p4BJ;AAzp4BE;EACE,yBAAA;AA2p4BJ;AAzp4BE;EACE,yBAAA;EACA,yBAAA;AA2p4BJ;AAzp4BE;;EAEE,yBAAA;AA2p4BJ;AAxp4BE;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;AA0p4BJ;AAxp4BE;EACE,cAAA;AA0p4BJ;AAxp4BE;EACE,oCAAA;AA0p4BJ;AAxp4BE;EACE,yBAAA;AA0p4BJ;AAxp4BE;EACE,8BAAA;AA0p4BJ;AAxp4BE;EACE,yBAAA;EACA,yBAAA;EACA,gBAAA;AA0p4BJ;AAxp4BE;EACE,yBAAA;EACA,yBAAA;AA0p4BJ;AAxp4BE;EACE,yBAAA;EACA,yBAAA;EACA,gBAAA;AA0p4BJ;AAxp4BE;EACE,yBAAA;AA0p4BJ;AAxp4BE;EACE,yBAAA;AA0p4BJ;;AArp4BI;EACE,yBAAA;AAwp4BN;;AAlp4BI;EACE,yBAAA;AAqp4BN;;AA/o4BI;EACE,yBAAA;AAkp4BN;;AA9o4BA;EACE,cAAA;AAip4BF;;AA/o4BA;EACE,yBAAA;AAkp4BF;;AAhp4BA;EACE,yBAAA;AAmp4BF;;AAhp4BA;EACE,gBAAA;AAmp4BF;;AAjp4BA;EACE,yBAAA;EACA,WAAA;AAop4BF;;AAlp4BA;EACE,yBAAA;EACA,WAAA;AAqp4BF;;AAlp4BA;EACE,gBAAA;AAqp4BF;;AAnp4BA;EACE,gBAAA;AAsp4BF;;AApp4BA;EACE,gBAAA;AAup4BF;;AArp4BA;EACE,gBAAA;AAwp4BF;;AAtp4BA;EACE,WAAA;AAyp4BF;;AAvp4BA;EACE,gBAAA;AA0p4BF;;AAxp4BA;EACE,gBAAA;AA2p4BF;;AAzp4BA;EACE,yBAAA;EACA,qBAAA;AA4p4BF;;AA1p4BA;;EAEE,kBAAA;EACA,gBAAA;AA6p4BF;;AA3p4BA;EACE,yBAAA;AA8p4BF;;AA5p4BA;EACE,wBAAA;AA+p4BF;;AA7p4BA;EACE,iBAAA;AAgq4BF;;AA9p4BA;EACE,gBAAA;AAiq4BF;;AA/p4BA;EACE,gBAAA;AAkq4BF;;AAhq4BA;EAKE,gBAAA;EACA,kCAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;AA+p4BF;;AA5p4BA;EACE,2BAAA;AA+p4BF;;AA7p4BA;EACE,2BAAA;AAgq4BF;;AA9p4BA;EACE,6BAAA;AAiq4BF;;AA/p4BA;EACE,uBAAA;AAkq4BF;;AAhq4BA;EACE,+CAAA;AAmq4BF;;AAjq4BA;EACE,2BAAA;AAoq4BF","sourcesContent":["@import \"./style/scss/main.scss\";\r\n@import \"primereact/resources/themes/lara-light-indigo/theme.css\";\r\n@import \"primeicons/primeicons.css\";\r\n@import \"primereact/resources/primereact.css\";\r\n@import \"primereact/resources/themes/lara-light-indigo/theme.css\";\r\n@import \"react-time-picker/dist/TimePicker.css\";\r\n@import \"react-clock/dist/Clock.css\";\r\n@import 'react-datepicker/dist/react-datepicker.css';\r\na {\r\n  text-decoration: none;\r\n  color: #262a2a;\r\n}\r\n\r\n.ant-tooltip {\r\n  display: none;\r\n}\r\n\r\n.data-table-card {\r\n  .ant-table-content {\r\n    .ant-table-tbody {\r\n      tr {\r\n        &:nth-of-type(2n + 1) {\r\n          background-color: #fff;\r\n        }\r\n      }\r\n\r\n      td {\r\n        padding: 0.5rem;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.ant-table-cell-row-hover {\r\n  background-color: #fff;\r\n  background: #fff;\r\n}\r\n\r\n//ant datatable pagination\r\n.ant-pagination-item.ant-pagination-item-1.ant-pagination-item-active {\r\n  background: #00918e;\r\n  border-color: #00918e;\r\n  color: #fff;\r\n}\r\n\r\n// manage columns in datatable page\r\nh4,\r\n.h4 {\r\n  font-size: 1.125rem;\r\n}\r\n\r\n// date range picker\r\n.daterangepicker td.active,\r\n.daterangepicker td.active:hover {\r\n  background-color: #00918e;\r\n  color: #fff;\r\n}\r\n\r\n.daterangepicker .calendar-table td.in-range {\r\n  background-color: #fff;\r\n}\r\n\r\n.applyBtn.btn.btn-sm.btn-primary {\r\n  color: #fff;\r\n  background-color: #00918e;\r\n  border: 1px solid #00918e;\r\n}\r\n\r\n// react-select plugin\r\n.css-1u9des2-indicatorSeparator {\r\n  display: none;\r\n}\r\n\r\n//compaign data table\r\ndiv .badge-status {\r\n  border-radius: 5px;\r\n  font-size: $font-size-12;\r\n  padding: 4px 8px;\r\n  min-width: 64px;\r\n  color: $white;\r\n}\r\n\r\ndiv .bg-success {\r\n  background-color: $success !important;\r\n\r\n  &.bg-opacity-10 {\r\n    background-color: rgba($success, 0.1) !important;\r\n  }\r\n\r\n  &.bg-opacity-25 {\r\n    background-color: rgba($success, 0.25) !important;\r\n  }\r\n\r\n  &.bg-opacity-50 {\r\n    background-color: rgba($success, 0.5) !important;\r\n  }\r\n\r\n  &.bg-opacity-75 {\r\n    background-color: rgba($success, 0.75) !important;\r\n  }\r\n\r\n  &.bg-opacity-100 {\r\n    background-color: rgba($success, 1) !important;\r\n  }\r\n}\r\n\r\n// compaign page datatable\r\n// .list-progress {\r\n//   width: 380px;\r\n// }\r\n:where(.css-dev-only-do-not-override-djtmh8).ant-table-wrapper\r\n  .ant-table-tbody\r\n  .ant-table-row.ant-table-row-selected\r\n  > .ant-table-cell {\r\n  background-color: #fff;\r\n}\r\n\r\n// multi-select\r\n// .css-1xc3v61-indicatorContainer svg {\r\n//   display: none;\r\n// }\r\n\r\n// .css-15lsz6c-indicatorContainer svg {\r\n//   display: none;\r\n// }\r\n\r\n// .css-tj5bde-Svg {\r\n//   background-color: #F6F6F6;\r\n//   border-color: #F6F6F6;\r\n//   color: #6F6F6F;\r\n//   border-radius: 5px;\r\n// }\r\n.css-1p3m7a8-multiValue {\r\n  background-color: #f6f6f6;\r\n  border-color: #f6f6f6;\r\n  color: #6f6f6f;\r\n  border-radius: 5px;\r\n}\r\n\r\n.stickybar {\r\n  top: 0;\r\n  position: sticky;\r\n}\r\n\r\n// select\r\n.select-details .css-1dimb5e-singleValue,\r\n.select-details .css-1jqq78o-placeholder {\r\n  padding-left: 15px;\r\n}\r\n\r\ndiv.css-13cymwt-control,\r\ndiv.css-t3ipsp-control {\r\n  min-width: 120px;\r\n  border-color: #e8e8e8;\r\n  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);\r\n  height: 41px;\r\n  border-radius: 5px;\r\n}\r\n\r\ndiv.css-t3ipsp-control:hover {\r\n  border-color: transparent;\r\n}\r\nspan.p-dropdown-label.p-inputtext span {\r\n  font-family: \"Noto Sans\", sans-serif;\r\n}\r\n\r\n// datepicker\r\n.deals-details.react-datepicker__input-container {\r\n  width: 450px !important;\r\n}\r\n\r\ndiv.react-datepicker-wrapper {\r\n  display: block;\r\n  padding: 0;\r\n  border: 0;\r\n}\r\n\r\nspan.form-icon {\r\n  z-index: 1;\r\n}\r\n\r\n.img-checked {\r\n  padding: 10px;\r\n  // width: 30px;\r\n  background: rgb(49, 132, 199);\r\n  color: white;\r\n  border-radius: 20px;\r\n  font-weight: bolder;\r\n  position: relative;\r\n  /* margin-top: 2px ; */\r\n}\r\n\r\n.section-notes-slider .notes-slider .slick-list .slick-slide div {\r\n  margin-left: 12px !important;\r\n}\r\n\r\n.page-add-notes {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.visible .input-blocks .css-b62m3t-container .css-1dimb5e-singleValue {\r\n  margin-left: 25px !important;\r\n}\r\n\r\n[data-layout-mode=\"dark_mode\"] .css-13cymwt-control {\r\n  background-color: #1d1d42;\r\n  border: 1px solid#67748E;\r\n}\r\n\r\n[data-layout-mode=\"dark_mode\"] .css-t3ipsp-control {\r\n  background-color: #1d1d42;\r\n}\r\n\r\n[data-layout-mode=\"dark_mode\"] .css-1nmdiq5-menu {\r\n  background-color: #1d1d42;\r\n}\r\n\r\n// .bx-microphone:before {\r\n//   content: \"\\eb89\";\r\n// }\r\n.form-sorts.dropdown .radio-btn-items {\r\n  margin-top: 10px;\r\n}\r\n\r\n.select__control {\r\n  background-color: #e41f07 !important;\r\n  border-color: #e41f07 !important;\r\n}\r\n\r\n.select__control:hover {\r\n  border-color: #e41f07 !important;\r\n}\r\n\r\n// .slick-slide {\r\n//   margin-right: 5px;\r\n// }\r\n.p-dropdown-label.p-inputtext .p-d-flex.p-ai-center img,\r\n.p-dropdown-item-label .p-d-flex.p-ai-center,\r\n.p-dropdown-label.p-inputtext .p-clearfix img,\r\n.p-dropdown-item-label .p-clearfix img {\r\n  width: 16px;\r\n  height: 16px;\r\n  border-radius: 5px;\r\n  margin-right: 5px;\r\n}\r\n\r\n.p-d-flex.p-ai-center {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.p-dropdown-items-wrapper ul.p-dropdown-items,\r\n.p-dropdown-panel.p-component.p-ripple-disabled.p-connected-overlay-enter-done {\r\n  z-index: 100000000000 !important;\r\n}\r\n\r\n.swiper-container .slick-list {\r\n  margin-left: -236px;\r\n}\r\n\r\n.p-dropdown.p-component.p-inputwrapper {\r\n  height: 42px;\r\n  line-height: 42px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-color: #e8e8e8;\r\n  color: #6f6f6f;\r\n  box-shadow: 0px 4px 4px 0px #dbdbdb40;\r\n}\r\n\r\ndiv.p-clearfix {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\ndiv.p-clearfix span,\r\nspan.p-dropdown-label.p-inputtext.p-placeholder {\r\n  font-size: 14px;\r\n}\r\n\r\n.p-dropdown-trigger svg {\r\n  width: 13px;\r\n}\r\n\r\ndiv.rti--container {\r\n  border-color: #e8e8e8;\r\n  color: #6f6f6f;\r\n  box-shadow: 0px 4px 4px 0px #dbdbdb40;\r\n}\r\n\r\nspan.rti--tag button {\r\n  font-size: 10px;\r\n}\r\n\r\n.filter-dropdown-menu.dropdown-menu.dropdown-menu-md-end.show,\r\n.filter-dropdown-menu.dropdown-menu {\r\n  z-index: 11;\r\n}\r\n\r\nspan.ant-picker-suffix {\r\n  display: none !important;\r\n}\r\n\r\n.stickybar {\r\n  position: sticky;\r\n  top: 0;\r\n}\r\n\r\n.right-user-side.chat-rooms.theiaStickySidebar {\r\n  max-height: 500px;\r\n  overflow: auto;\r\n}\r\n\r\n.send-chat.comman-icon i.feather.feather-send {\r\n  color: #fff;\r\n}\r\n\r\n.chat-footer form {\r\n  background-color: #fff;\r\n}\r\n\r\n.nav.flex-column.nav-pills.todo-inbox i {\r\n  margin-right: 10px;\r\n}\r\n\r\n.select-priority .css-1jqq78o-placeholder,\r\n.select-priority .css-1dimb5e-singleValue {\r\n  padding-left: 15px;\r\n}\r\n\r\n.form-sort .css-1jqq78o-placeholder,\r\n.form-sort .css-1dimb5e-singleValue {\r\n  padding-left: 20px;\r\n}\r\n\r\n.form-sort.select-bluk.space-not-select .css-1jqq78o-placeholder,\r\n.form-sort.select-bluk.space-not-select .css-1dimb5e-singleValue {\r\n  padding: 0;\r\n}\r\n\r\n.owl-carousel.folders-carousel.owl-theme .slick-slide > div,\r\n.owl-carousel.files-carousel.owl-theme .slick-slide > div {\r\n  margin-right: 10px;\r\n}\r\n\r\n[data-theme=\"dark\"] .ant-table-content table,\r\n[data-theme=\"dark\"] .ant-table-thead tr th,\r\n[data-theme=\"dark\"]\r\n  .ant-pagination.ant-table-pagination.ant-table-pagination-right {\r\n  background-color: #171724;\r\n  color: #a3a6a6;\r\n}\r\n\r\n[data-theme=\"dark\"] .table tbody tr td .table-avatar a,\r\n[data-theme=\"dark\"] td.ant-table-cell {\r\n  color: #a3a6a6;\r\n}\r\n// a#theme-settings i {\r\n//   color: #262a2a;\r\n// }\r\ntd .badge-pill {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.rsw-editor select {\r\n  display: none;\r\n}\r\n.custom-table {\r\n  border: 1px solid #e8e8e8;\r\n  border-radius: 6px;\r\n}\r\n.join-contents .slick-slider div.slick-slide > div {\r\n  margin-right: 10px;\r\n}\r\n.custom-react-clr {\r\n  color: #6f6f6f;\r\n}\r\ndiv.popover {\r\n  z-index: 9999;\r\n}\r\ndiv.rc-slider-track,\r\n.rc-slider-tracks {\r\n  background-color: #ed5565;\r\n}\r\ndiv.rc-slider-handle {\r\n  border: solid 2px #ed5565;\r\n}\r\nspan.rc-slider-dot-active {\r\n  border-color: #ed5565;\r\n}\r\ndiv.rc-slider-handle:active {\r\n  border-color: #ed5565;\r\n  box-shadow: 0 0 5px #ed5565;\r\n  cursor: grabbing;\r\n}\r\n.rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging {\r\n  border-color: #ed5565;\r\n  box-shadow: 0 0 0 5px #ed5565;\r\n}\r\ndiv.rc-slider-handle:hover {\r\n  border-color: #ed5565;\r\n}\r\ndiv.rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging {\r\n  border-color: #ed5565;\r\n  box-shadow: 0 0 0 5px #ed5565;\r\n}\r\n[data-theme=\"dark\"] {\r\n  :where(.css-dev-only-do-not-override-11xg00t).ant-table-wrapper\r\n    .ant-table-tbody\r\n    .ant-table-row\r\n    > .ant-table-cell-row-hover {\r\n    background-color: #171724;\r\n  }\r\n  :where(.css-dev-only-do-not-override-11xg00t).ant-table-wrapper\r\n    .ant-table-tbody\r\n    > tr\r\n    > th,\r\n  :where(.css-dev-only-do-not-override-11xg00t).ant-table-wrapper\r\n    .ant-table-tbody\r\n    > tr\r\n    > td {\r\n    border-color: #393947;\r\n  }\r\n  :where(.css-11xg00t).ant-table-wrapper .ant-table-tbody .ant-table-row >.ant-table-cell-row-hover{\r\n    background: #171724;;\r\n  }\r\n  :where(.css-dev-only-do-not-override-11xg00t).ant-table-wrapper\r\n    .ant-table-thead\r\n    th.ant-table-column-has-sorters:hover {\r\n    background: #171724;\r\n  }\r\n  .custom-table {\r\n    border: 1px solid #393947;\r\n  }\r\n  .css-13cymwt-control {\r\n    background-color: #171724;\r\n    border: 1px solid #393947;\r\n  }\r\n  .react-datepicker__month-container,\r\n  .react-datepicker__header {\r\n    background-color: #393947;\r\n  }\r\n\r\n  .css-t3ipsp-control {\r\n    background: #171724;\r\n    border: 1px solid #393947;\r\n    color: #a3a6a6;\r\n  }\r\n  .css-1dimb5e-singleValue {\r\n    color: #a3a6a6;\r\n  }\r\n  .css-b62m3t-container div.css-1nmdiq5-menu {\r\n    background-color: #393947 !important;\r\n  }\r\n  .react-select-29-listbox {\r\n    background-color: #393947;\r\n  }\r\n  .input-blocks input[type=\"text\"] {\r\n    background: #1d1d42 !important;\r\n  }\r\n  .p-dropdown.p-component.p-inputwrapper {\r\n    background-color: #171724;\r\n    border: 1px solid #393947;\r\n    box-shadow: none;\r\n  }\r\n  .p-dropdown-item {\r\n    background-color: #171724;\r\n    border: 1px solid #393947;\r\n  }\r\n  .rti--container {\r\n    background-color: #171724;\r\n    border: 1px solid #393947;\r\n    box-shadow: none;\r\n  }\r\n  .rti--tag {\r\n    background-color: #171724;\r\n  }\r\n  .rti--input {\r\n    background-color: #171724;\r\n  }\r\n}\r\n[data-sidebar=\"green\"] {\r\n  .clinicdropdown.theme {\r\n    a {\r\n      background-color: #005351;\r\n    }\r\n  }\r\n}\r\n[data-sidebar=\"blue\"] {\r\n  .clinicdropdown.theme {\r\n    a {\r\n      background-color: #2f0093;\r\n    }\r\n  }\r\n}\r\n[data-sidebar=\"dark\"] {\r\n  .clinicdropdown.theme {\r\n    a {\r\n      background-color: #28283e;\r\n    }\r\n  }\r\n}\r\n[data-theme=\"dark\"] .header .header-left .logo img.white-logo {\r\n  display: block;\r\n}\r\n[data-theme=\"dark\"] .chat-footer form {\r\n  background-color: #28283e;\r\n}\r\n[data-theme=\"dark\"] .sidebar .sidebar-menu .clinicdropdown.theme a {\r\n  background-color: #28283e;\r\n}\r\n\r\n[data-theme=\"dark\"] .rsw-toolbar {\r\n  background: grey;\r\n}\r\ndiv.css-b62m3t-container .react-select__option--is-focused {\r\n  background-color: #e41f07;\r\n  color: #fff;\r\n}\r\ndiv.css-b62m3t-container .react-select__option--is-selected {\r\n  background-color: #e41f07;\r\n  color: #fff;\r\n}\r\n\r\n.submenu .ti-ticket:before {\r\n  content: \"\\eb3d\";\r\n}\r\n.form-icon .ti-search:before {\r\n  content: \"\\eb1c\";\r\n}\r\n.form-icon .ti-calendar:before {\r\n  content: \"\\ea53\";\r\n}\r\ni.ti-trash:before {\r\n  content: \"\\eb41\";\r\n}\r\n[data-theme=\"dark\"] .header .header-left #toggle_btn {\r\n  color: #fff;\r\n}\r\ni.ti-lock:before {\r\n  content: \"\\eae2\";\r\n}\r\ni.ti-bell:before {\r\n  content: \"\\ea35\";\r\n}\r\n[data-theme=\"dark\"] .login-wrapper .form-control {\r\n  background-color: #ffffff;\r\n  border-color: #e8e8e8;\r\n}\r\n[data-theme=\"dark\"] div.css-13cymwt-control,\r\n[data-theme=\"dark\"] div.css-t3ipsp-control {\r\n  border-color: none;\r\n  box-shadow: none;\r\n}\r\n.mini-sidebar.expand-menu .subdrop ~ ul {\r\n  display: block !important;\r\n}\r\n.mini-sidebar .subdrop ~ ul {\r\n  display: none !important;\r\n}\r\n.sidebar .sidebar-menu > ul li .submenu.submenu-two > ul li a {\r\n  margin-left: 30px;\r\n}\r\n.ti.ti-eye:before {\r\n  content: \"\\ea9a\";\r\n}\r\n.ti.ti-user:before {\r\n  content: \"\\eb4d\";\r\n}\r\ndiv.sidebar-themesettings\r\n  .input-themeselect\r\n  input[type=\"radio\"]:checked\r\n  ~ label\r\n  .checkboxs-theme::before {\r\n  content: \"\\f00c\";\r\n  font-family: \"Font Awesome 5 Free\";\r\n  color: #fff;\r\n  font-weight: 700;\r\n  font-size: 10px;\r\n  right: 4px;\r\n  position: absolute;\r\n  top: -16px;\r\n  z-index: 9;\r\n}\r\n\r\n.ti-check:before {\r\n  content: \"\\ea5e\" !important;\r\n}\r\n.ti-arrow-down:before {\r\n  content: \"\\ea16\" !important;\r\n}\r\n.select-pipeline .react-select__value-container {\r\n  padding-left: 28px !important;\r\n}\r\n.modal-open .offcanvas.offcanvas-end {\r\n  width: 700px !important;\r\n}\r\n.ant-table {\r\n  font-family: \"Noto Sans\", sans-serif !important;\r\n}\r\n.ti-shield:before {\r\n  content: \"\\eb24\" !important;\r\n}","/****** Utils ******/\r\n@import \"utils/variables\";\r\n@import \"utils/mixins\";\r\n\r\n\r\n/****** Layout ******/\r\n@import \"layout/common\";\r\n@import \"layout/content\";\r\n@import \"layout/header\";\r\n@import \"layout/sidebar\";\r\n@import \"layout/theme\";\r\n@import \"layout/theme-settings\";\r\n@import \"layout/notification\";\r\n\r\n/******* Components ******/\r\n@import \"components/avatar\";\r\n@import \"components/boostrap\";\r\n@import \"components/button\";\r\n@import \"components/badge\";\r\n@import \"components/border\";\r\n@import \"components/calendar\";\r\n@import \"components/chart\";\r\n@import \"components/call\";\r\n@import \"components/chat\";\r\n@import \"components/dropdown\";\r\n@import \"components/email\";\r\n@import \"components/file-manager\";\r\n@import \"components/icons\";\r\n@import \"components/progress\";\r\n@import \"components/pagination\";\r\n@import \"components/font\";\r\n@import \"components/typography\";\r\n@import \"components/alerts\";\r\n@import \"components/popovers\";\r\n@import \"components/forms\";\r\n@import \"components/notes\";\r\n@import \"components/todo\";\r\n@import \"components/tables\";\r\n@import \"components/accordion\";\r\n@import \"components/breadcrumb\";\r\n@import \"components/cards\";\r\n@import \"components/tooltips\";\r\n@import \"components/navs-tabs\";\r\n@import \"components/ribbon\";\r\n@import \"components/popup\";\r\n@import \"components/grid\";\r\n\r\n/******* Base *******/\r\n@import \"base/base\";\r\n@import \"base/background\";\r\n\r\n\r\n/******* Pages ******/\r\n@import \"pages/contact\";\r\n@import \"pages/dashboard\";\r\n@import \"pages/error\";\r\n@import \"pages/login\";\r\n@import \"pages/settings\";\r\n@import \"pages/report\";\r\n@import \"pages/activity\";\r\n@import \"pages/tasks\";\r\n@import \"pages/analytics\";\r\n@import \"pages/project\";\r\n@import \"pages/leads\";\r\n@import \"pages/campaign\";\r\n@import \"pages/membership-plans\";\r\n\r\n\r\n/******* Vendors ******/\r\n@import \"vendors/select2\";\r\n@import \"vendors/datatables\";\r\n\r\n","::-webkit-scrollbar {\r\n    width: 5px;\r\n    height: 5px;\r\n    border-radius: 50px !important;\r\n}\r\n::-webkit-scrollbar-track {\r\n    background: $gray-300;\r\n}\r\n::-webkit-scrollbar-thumb {\r\n    background: $primary;\r\n}\r\n::-webkit-scrollbar-thumb:hover {\r\n    background: $gray-300;\r\n}\r\n.swal2-header{\r\n    .swal2-title{\r\n        font-size: $font-size-18;\r\n    }\r\n}\r\n.none{\r\n    display: none !important;\r\n}\r\n.text-red{color: $danger !important;\r\n}\r\n.text-green{\r\n    color: $success !important;\r\n}\r\n.input-blocks{\r\n    input[type=text]{\r\n        &:focus{\r\n            border-color: $input-border;\r\n        }\r\n    }\r\n}\r\n.input-group{\r\n    .scanner-set {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        align-items: center;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        justify-content: center;\r\n        -webkit-justify-content: center;\r\n        -ms-flex-pack: center;\r\n        background: $primary;\r\n        border-radius: 5px !important;\r\n        width: 40px;\r\n        color: $white;\r\n        font-weight: $font-weight-semibold;\r\n        padding: 0;\r\n        &:hover{\r\n            background: $title-color;\r\n        }\r\n    }\r\n}\r\n::-webkit-scrollbar {\r\n    width: 5px;\r\n    height: 5px;\r\n    border-radius: 50px !important;\r\n}\r\n::-webkit-scrollbar-track {\r\n    background: $gray-300;\r\n}\r\n::-webkit-scrollbar-thumb {\r\n    background: $primary;\r\n}\r\n::-webkit-scrollbar-thumb:hover {\r\n    background: $gray-300;\r\n}\r\n.swal2-header{\r\n    .swal2-title{\r\n        font-size: $font-size-18;\r\n    }\r\n}\r\n.none{\r\n    display: none !important;\r\n}\r\n.text-red{\r\n    color: $danger !important;\r\n}\r\n.text-green{\r\n    color: $success !important; \r\n}\r\n\r\n.input-blocks{\r\n    input[type=text]{\r\n        &:focus{\r\n            border-color: $input-border;\r\n        }\r\n    }\r\n}\r\n.form-sorts {\r\n    position: relative;\r\n    & > a {\r\n        border: 1px solid $light-900;\r\n        border-radius: 5px;\r\n        box-shadow: 0px 4px 4px 0px #DBDBDB40;\r\n        background: $white;\r\n        font-weight: $font-weight-medium;\r\n        display: -webkit-inline-box;\r\n        display: -ms-inline-flexbox;\r\n        display: inline-flex;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        align-items: center;\r\n        @include margin-padding(null, 9px 21px);               \r\n        @include respond-below(custom991) {\r\n            @include margin-padding(null, 9px 12px);\r\n        }\r\n        i {\r\n            margin-right: 8px;\r\n        }   \r\n        &:hover {\r\n            color: $title-color;\r\n        }\r\n        &.show {\r\n            border: 1px solid #0092E4;\r\n        }  \r\n        @include respond-below(custom575) {\r\n            width: 100%;\r\n        }  \r\n    }\r\n    .filter-dropdown-menu {\r\n        padding: 24px;\r\n        border-radius: 5px;\r\n        background: $white;\r\n        border: 1px solid $light-900;\r\n        box-shadow: 0px 4px 24px 0px #BCBCBC40;\r\n        position: absolute;\r\n        z-index: 1;\r\n        min-width: 400px;\r\n        right: 0;\r\n        top: 40px;\r\n        @include respond-below(custom767) {\r\n            min-width: 270px;\r\n        }\r\n        @include respond-below(custom575) {\r\n            right: unset;\r\n            left: 0;\r\n        }\r\n    }\r\n    &.table-filter-show {\r\n        .filter-dropdown-menu {\r\n            display: block;\r\n            opacity: 1;\r\n        }\r\n    }\r\n    .filter-set-head {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n        -webkit-justify-content: space-between;\r\n        -ms-flex-pack: space-between;\r\n        margin-bottom: 14px;\r\n        h4 {\r\n            margin-bottom: 10px;\r\n            i {\r\n                margin-right: 8px;\r\n            }\r\n            @include respond-below(custom991) {\r\n                font-size: $font-size-16;\r\n            }\r\n        }\r\n        a {\r\n            color: $purple;\r\n            margin-bottom: 10px;\r\n            &:hover {\r\n                color: $primary;\r\n            }\r\n        }\r\n    }\r\n    .filter-set-content {\r\n        margin-bottom: 24px;\r\n        .filter-set-content-head {\r\n            a {\r\n                display: flex;\r\n                align-items: center;\r\n                color: $gray-900;\r\n                font-weight: $font-weight-semibold;\r\n                position: relative;\r\n                padding-left: 16px;\r\n                &::before {\r\n                    content: \"\\f054\";\r\n                    font-family: 'Font Awesome 5 Free';\r\n                    @include position(absolute, 50%, null, null, 0);\r\n                    @include transform(translateY(-50%));\r\n                    font-size: $font-size-14;\r\n                } \r\n                &:not(.collapsed) {  \r\n                    padding-left: 20px;                  \r\n                    &::before {\r\n                        content: \"\\f078\";\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .filter-reset-btns {\r\n        a {\r\n            padding: 6px 10px;\r\n            font-size: $font-size-14;\r\n            font-weight: $font-weight-semibold;\r\n            border-radius: 5px;\r\n            width: 100%;\r\n            @include respond-below(custom575) {\r\n                padding: 10px 30px;\r\n            }\r\n        }\r\n        .btn-light {\r\n            background: $light-400;\r\n            border: 1px solid $light-900;\r\n        }\r\n    }\r\n}\r\n.radio-btn-items {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    flex-wrap: wrap;\r\n    margin-bottom: 14px;\r\n    .radio-btn {\r\n        margin: 0 30px 10px 0;\r\n        &:last-child {\r\n            margin-right: 0;\r\n        }\r\n    }\r\n}\r\n.filter-set-contents {\r\n    .filter-content-list {\r\n        background: $light-200;\r\n        border-radius: 5px;\r\n        padding: 15px;\r\n        margin-top: 15px;\r\n        .form-wrap {\r\n            margin-bottom: 15px;\r\n            .form-control {\r\n                max-width: 100%;\r\n            }\r\n        }\r\n        ul {\r\n            max-height: 150px;\r\n            overflow-y: auto;\r\n            padding: 1px 0;\r\n            &::-webkit-scrollbar {\r\n                width: 3px;\r\n                background: $primary;\r\n                height: 1px;\r\n            }\r\n            &::-webkit-scrollbar-track {\r\n                box-shadow: inset 0 0 5px rgb(231, 231, 231); \r\n                border-radius: 4px;\r\n            }\r\n            &::-webkit-scrollbar-thumb {\r\n                background: $primary; \r\n                border-radius: 4px;\r\n            }\r\n            li {\r\n                position: relative;\r\n                display: flex;\r\n                margin-bottom: 15px;\r\n                &:last-child {\r\n                    margin-bottom: 0;\r\n                }\r\n                .checkboxs {\r\n                    padding-left: 0;\r\n                    display: flex;\r\n                    align-items: center;\r\n                }\r\n                .checkboxs .checkmarks {\r\n                    position: relative;\r\n                    top: 0;\r\n                    margin-right: 5px;\r\n                    display: flex;\r\n                }\r\n                .rating {\r\n                    margin-left: 0;\r\n                    i {\r\n                        color: $light-900;\r\n                        &.filled {\r\n                            color: $warning;\r\n                        }\r\n                    }\r\n                    span {\r\n                        margin-left: 5px;\r\n                    }\r\n                }\r\n                .collapse-inside-text {\r\n                    margin-left: 0;\r\n                    h5 {\r\n                        margin-bottom: 0;\r\n                        font-size: $font-size-14;\r\n                        font-weight: $font-weight-normal;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n","// Font import\r\n@import url('https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap');\r\n\r\n// Base Font\r\n$font-size-base: 14px;\r\n$font-size-sm: $font-size-base * .875;\r\n$font-size-lg: $font-size-base * 1.25;\r\n$font-weight-lighter: lighter;\r\n$font-weight-light: 300;\r\n$font-weight-normal: 400;\r\n$font-weight-medium: 500;\r\n$font-weight-semibold: 600;\r\n$font-weight-bold: 700;\r\n$font-weight-bolder: bolder;\r\n\r\n// Font Family\r\n$font-family-primary: \"Noto Sans\", sans-serif;\r\n$font-awesome: \"Fontawesome\";\r\n\t\r\n// Theme Colors Variables\r\n$primary: #E41F07;\r\n$primary-hover: darken($primary, 10%);\r\n$secondary: #FFA201;\r\n$secondary-hover: darken($secondary, 10%);\r\n$success: #5CB85C;\r\n$success-hover: darken($success, 10%);\r\n$info: #1ECBE2;\r\n$info-hover: darken($info, 10%);\r\n$warning: #FDA700;\r\n$warning-hover: darken($warning, 10%);\r\n$danger: #FC0027;\r\n$danger-hover: darken($danger, 10%);\r\n$dark: #171724;\r\n$dark-border: #393947;\r\n$dark-text: #a3a6a6;\r\n$dark-textcolor: #B5B5B5;\r\n$dark-hover: darken($dark, 10%);\r\n$darkmode-hover: #28283D;\r\n$dark-input: #1A1A25;\r\n$dark-bg: #1E1E2D;\r\n$gray-bg: #28283E;\r\n$light: #FDFDFE;\r\n$light-hover: darken($light, 10%);\r\n$white: #FFF;\r\n$black: #000;\r\n$purple: #4A00E5;\r\n$pink: #EA00B7;\r\n$blue: #339DFF;\r\n$teal: #02a8b5;\r\n$violet: #676DFF;\r\n$cyan: #299cdb;\r\n$green: #00918E;\r\n$orange: #FF9D0A;\r\n$indigo: #0092E4;\r\n$indigo-hover: darken($indigo, 10%);\r\n$tertiary: #3C2371;\r\n$yellow: #ffff00;\r\n\r\n// Primary\r\n$primary-100: #FCE9E6;\r\n$primary-200: #FAD2CD;\r\n$primary-300: #F7BCB5;\r\n$primary-400: #F4A59C;\r\n$primary-500: #F28F83;\r\n$primary-600: #EF796A;\r\n$primary-700: #EC6251;\r\n$primary-800: #E94C39;\r\n$primary-900: #E73520;\r\n\r\n// Secondary\r\n$secondary-100: #FFF6E6;\r\n$secondary-200: #FFECCC;\r\n$secondary-300: #FFE3B3;\r\n$secondary-400: #FFDA99;\r\n$secondary-500: #FFD180;\r\n$secondary-600: #FFC767;\r\n$secondary-700: #FFBE4D;\r\n$secondary-800: #FFB534;\r\n$secondary-900: #FFAB1A;\r\n\r\n// Tertiary\r\n$tertiary-100: #ECE9F1;\r\n$tertiary-200: #D8D3E3;\r\n$tertiary-300: #C5BDD4;\r\n$tertiary-400: #B1A7C6;\r\n$tertiary-500: #9E91B8;\r\n$tertiary-600: #8A7BAA;\r\n$tertiary-700: #77659C;\r\n$tertiary-800: #634F8D;\r\n$tertiary-900: #50397F;\r\n\r\n// Green\r\n$green-100: #E6F4F4;\r\n$green-200: #CCE9E8;\r\n$green-300: #B3DEDD;\r\n$green-400: #99D3D2;\r\n$green-500: #80C8C7;\r\n$green-600: #66BDBB;\r\n$green-700: #4DB2B0;\r\n$green-800: #33A7A5;\r\n$green-900: #1A9C99;\r\n\r\n// Blue\r\n$blue-100: #EBF5FF;\r\n$blue-200: #D6EBFF;\r\n$blue-300: #C2E2FF;\r\n$blue-400: #ADD8FF;\r\n$blue-500: #99CEFF;\r\n$blue-600: #85C4FF;\r\n$blue-700: #70BAFF;\r\n$blue-800: #5CB1FF;\r\n$blue-900: #47A7FF;\r\n\r\n// Orange\r\n$orange-100: #FFF5E7;\r\n$orange-200: #FFEBCE;\r\n$orange-300: #FFE2B6;\r\n$orange-400: #FFD89D;\r\n$orange-500: #FFCE85;\r\n$orange-600: #FFC46C;\r\n$orange-700: #FFBA54;\r\n$orange-800: #FFB13B;\r\n$orange-900: #FFA723;\r\n\r\n// Pink\r\n$pink-100: #FDE6F8;\r\n$pink-200: #FBCCF0;\r\n$pink-300: #F9B3E9;\r\n$pink-400: #F799E2;\r\n$pink-500: #F580DB;\r\n$pink-600: #F266D3;\r\n$pink-700: #F04DCC;\r\n$pink-800: #EE33C5;\r\n$pink-900: #EC1ABD;\r\n\r\n// Violet\r\n$violet-100: #F0F0FF;\r\n$violet-200: #E1E2FF;\r\n$violet-300: #D1D3FF;\r\n$violet-400: #C2C5FF;\r\n$violet-500: #B3B6FF;\r\n$violet-600: #A4A7FF;\r\n$violet-700: #9599FF;\r\n$violet-800: #858AFF;\r\n$violet-900: #767CFF;\r\n\r\n// Indigo\r\n$indigo-100: #E6F4FC;\r\n$indigo-200: #CCE9FA;\r\n$indigo-300: #B3DEF7;\r\n$indigo-400: #99D3F4;\r\n$indigo-500: #80C9F2;\r\n$indigo-600: #66BEEF;\r\n$indigo-700: #4DB3EC;\r\n$indigo-800: #33A8E9;\r\n$indigo-900: #1A9DE7;\r\n\r\n// Light\r\n$light-100: #FAFAFA;\r\n$light-200: #F9F9FC;\r\n$light-300: #F6F6F6;\r\n$light-400: #F5F5F5;\r\n$light-500: #F6F6F6;\r\n$light-600: #F4F4F4;\r\n$light-700: #F2ECFF;\r\n$light-800: #EAEAEA;\r\n$light-900: #E8E8E8;\r\n\r\n// Gray\r\n$gray-100: #C0C0C0;\r\n$gray-200: #9B9B9B;\r\n$gray-300: #898989;\r\n$gray-400: #6F6F6F;\r\n$gray-500: #6F7A7A;\r\n$gray-600: #565E5E;\r\n$gray-700: #424848;\r\n$gray-800: #323737;\r\n$gray-900: #262A2A;\r\n\r\n// Info\r\n$info-100: #E9FAFC;\r\n$info-200: #D2F5F9;\r\n$info-300: #BCEFF6;\r\n$info-400: #A5EAF3;\r\n$info-500: #8FE5F1;\r\n$info-600: #78E0EE;\r\n$info-700: #62DBEB;\r\n$info-800: #4BD5E8;\r\n$info-900: #35D0E5;\r\n\r\n// Success\r\n$success-100: #EFF8EF;\r\n$success-200: #E0F5D7;\r\n$success-300: #CEEACE;\r\n$success-400: #BEE3BE;\r\n$success-500: #AEDCAE;\r\n$success-600: #9DD49D;\r\n$success-700: #8DCD8D;\r\n$success-800: #7DC67D;\r\n$success-900: #6CBF6C;\r\n\r\n// Danger\r\n$danger-100: #FFEEEC;\r\n$danger-200: #FECCD4;\r\n$danger-300: #FEB3BE;\r\n$danger-400: #FE99A9;\r\n$danger-500: #FE8093;\r\n$danger-600: #FD667D;\r\n$danger-700: #FD4D68;\r\n$danger-800: #FD3352;\r\n$danger-900: #FC1A3D;\r\n\r\n// Warning\r\n$warning-100: #FFF7D8;\r\n$warning-200: #FFEDCC;\r\n$warning-300: #FEE5B3;\r\n$warning-400: #FEDC99;\r\n$warning-500: #FED380;\r\n$warning-600: #FECA66;\r\n$warning-700: #FEC14D;\r\n$warning-800: #FDB933;\r\n$warning-900: #FDB01A;\r\n\r\n// Purple\r\n$purple-100: #F3EDFF;\r\n$purple-200: #DBCCFA;\r\n$purple-300: #C9B3F7;\r\n$purple-400: #B799F5;\r\n$purple-500: #A580F2;\r\n$purple-600: #9266EF;\r\n$purple-700: #804DED;\r\n$purple-800: #6E33EA;\r\n$purple-900: #5C1AE8;\r\n\r\n\r\n\r\n$colors: (\r\n  \"blue\":       $blue,\r\n  \"indigo\":     $indigo,\r\n  \"purple\":     $purple,\r\n  \"pink\":       $pink,\r\n  \"orange\":     $orange,\r\n  \"yellow\":     $yellow,\r\n  \"green\":      $green,\r\n  \"teal\":       $teal,\r\n  \"cyan\":       $cyan,\r\n  \"white\":      $white,\r\n  \"gray\":       $gray-600,\r\n  \"gray-dark\":  $gray-800\r\n);\r\n\r\n$theme-colors: (\r\n    \"primary\": $primary,\r\n    \"secondary\": $secondary,\r\n    \"success\": $success,\r\n    \"info\": $info,\r\n    \"warning\": $warning,\r\n    \"danger\": $danger,\r\n    \"dark\": $dark,\r\n    \"light\": $light,\r\n    \"black\": $black,\r\n    \"purple\": $purple,\r\n    \"yellow\": $yellow,\r\n    \"teal\": $teal\r\n);\r\n\r\n$text-color: #6F6F6F;\r\n$title-color: #262A2A;\r\n$sub-title: #B8BCC9;\r\n$body-bg: #F9F9FC;\r\n$wrapper-bg: #f1f5f6;\r\n$text-muted: #9595b5;\r\n$default-background: #f7f8f9;\r\n$black-bg: #141432;\r\n$card-dark-bg: #1d1d42;\r\n$navy: #353570;\r\n$theme-title: #97A2D2;\r\n$input-bg: #2c2c50;\r\n$form-control-bg: #ffffff;\r\n$background-3: #E0E2E7;\r\n\r\n// Social Icons Colors\r\n$facebook: #3B5998;\r\n$twitter: #00ACEE;\r\n$google: #DD4B39;\r\n$telegram: #0088CC;\r\n$linkedin: #0E76A8;\r\n$youtube: #C4302B;\r\n$instagram: #3F729B;\r\n$reddit: #C6C6C6;\r\n$pinterest: #cc2127;\r\n$vk: #2B587A;\r\n$rss: #EE802F;\r\n$skype: #00AFF0;\r\n$xing: #126567;\r\n$tumblr: #34526F;\r\n$email: #6567A5;\r\n$delicious: #205CC0;\r\n$stumbleupon: #F74425;\r\n$digg: #191919;\r\n$blogger: #FC4F08;\r\n$flickr: #FF0084;\r\n$vimeo: #86C9EF;\r\n$yahoo: #720E9E;\r\n$gplus: #DD4B39;\r\n$appstore: #000;\r\n\r\n// Gradient Variables\r\n$primary-gradient: linear-gradient(to right, $primary 0%, #8e77fa 100%);\r\n$secondary-gradient: linear-gradient(to right, $secondary 0%, #28b7f9 100%);\r\n$success-gradient: linear-gradient(to right,$success 0%, #5cf9e2 100%);\r\n$warning-gradient: linear-gradient(to right, $warning 0%, #fbc434 100%);\r\n$danger-gradient: linear-gradient(to right,$danger 0%, #fd4a68  100%);\r\n$info-gradient: linear-gradient(to right, $info 0%, #00f2fe  100%);\r\n$pink-gradient: linear-gradient(to right, $pink 0%, #FFA795 100%);\r\n$teal-gradient: linear-gradient(to right, $teal 0%, #0695DD 100%);\r\n$orange-gradient: linear-gradient(to right,$orange 0%,#FBB034 100%);\r\n$purple-gradient: linear-gradient(to right, $purple 0%, #9b25b7 100%);\r\n$light-gradient: linear-gradient(to right, $light 0%, #D1D6DE 100%);\r\n$dark-gradient: linear-gradient(to right, $dark 0%, #54505D 100%);\r\n\r\n// Style Anchor Elements\r\n$link-color: $primary;\r\n$link-decoration: none;\r\n$link-shade-percentage: 20%;\r\n$link-hover-color: darken($link-color, 10%);\r\n$link-hover-decoration: null;\r\n$spacer: 1rem;\r\n\r\n// Border\r\n$border-width: 1px;\r\n$border-style: solid;\r\n$border-color: $light-900;\r\n$default-border: $light-900;\r\n$input-border: $light-900;\r\n\r\n// Border Radius\r\n$border-radius: 4px;\r\n$border-radius-sm: 3px;\r\n$border-radius-lg: 5px;\r\n$border-radius-xl: 8px;\r\n$border-radius-xxl: 12px;\r\n$rounded: 50%;\r\n$rounded-pill: 1.5rem;\r\n\r\n// Box Shadow\r\n$box-shadow: 0px 4px 54px 0px #E0E0E040;\r\n$box-shadow-sm: 0px 4px 74px 0px #D0D0D040;\r\n$box-shadow-lg: 0 5px 10px rgba(30, 32, 37, 0.12);\r\n\r\n// Font Size\r\n$font-size-8: 8px;\r\n$font-size-9: 9px;\r\n$font-size-10: 10px;\r\n$font-size-11: 11px;\r\n$font-size-12: 12px;\r\n$font-size-13: 13px;\r\n$font-size-14: 14px;\r\n$font-size-15: 15px;\r\n$font-size-16: 16px;\r\n$font-size-18: 18px;\r\n$font-size-20: 20px;\r\n$font-size-22: 22px;\r\n$font-size-24: 24px;\r\n$font-size-26: 26px;\r\n$font-size-28: 28px;\r\n$font-size-30: 30px;\r\n$font-size-32: 32px;\r\n$font-size-34: 34px;\r\n$font-size-36: 36px;\r\n$font-size-40: 40px;\r\n$font-size-42: 42px;\r\n$font-size-50: 50px;\r\n$font-size-54: 54px;\r\n$font-size-60: 60px;\r\n\r\n$h1-font-size: 28px;\r\n$h2-font-size: 24px;\r\n$h3-font-size: 20px;\r\n$h4-font-size: 18px;\r\n$h5-font-size: 16px;\r\n$h6-font-size: 14px;\r\n\r\n","$breakpoints: (\r\n  custom575: 575.98px,\r\n  custom767: 767.98px,\r\n  custom768: 768px,\r\n  custom991: 991.98px,\r\n  custom992: 992px,\r\n  custom1199: 1199.98px,\r\n  custom1399: 1399.98px,\r\n  custom1280: 1280px,\r\n);\r\n\r\n// Respond Above\r\n\r\n@mixin respond-above($breakpoint) {\r\n\r\n  // If the breakpoint exists in the map.\r\n  @if map-has-key($breakpoints, $breakpoint) {\r\n\r\n    // Get the breakpoint value.\r\n    $breakpoint-value: map-get($breakpoints, $breakpoint);\r\n\r\n    // Write the media query.\r\n    @media (min-width: $breakpoint-value) {\r\n      @content;\r\n    }\r\n\r\n  // If the breakpoint doesn't exist in the map.\r\n  } @else {\r\n\r\n    // Log a warning.\r\n    @warn 'Invalid breakpoint: #{$breakpoint}.';\r\n  }\r\n}\r\n\r\n// Respond Above\r\n\r\n@mixin respond-below($breakpoint) {\r\n\r\n  // If the breakpoint exists in the map.\r\n  @if map-has-key($breakpoints, $breakpoint) {\r\n\r\n    // Get the breakpoint value.\r\n    $breakpoint-value: map-get($breakpoints, $breakpoint);\r\n\r\n    // Write the media query.\r\n    @media (max-width: $breakpoint-value) {\r\n      @content;\r\n    }\r\n\r\n  // If the breakpoint doesn't exist in the map.\r\n  } @else {\r\n\r\n    // Log a warning.\r\n    @warn 'Invalid breakpoint: #{$breakpoint}.';\r\n  }\r\n}\r\n\r\n@mixin transform($property) {\r\n  transform: $property;\r\n  -webkit-transform: $property;\r\n  -ms-transform: $property;\r\n}\r\n\r\n// Define vertical, horizontal, or both position\r\n\r\n@mixin position-alignment($position) {\r\n  position: absolute;\r\n  @if $position == 'vertical' {\r\n    top: 50%;\r\n    -webkit-transform: translateY(-50%);\r\n    -ms-transform: translateY(-50%);\r\n    transform: translateY(-50%);\r\n  }\r\n  @else if $position == 'horizontal' {\r\n    left: 50%;\r\n    -webkit-transform: translateX(-50%);\r\n    -ms-transform: translateX(-50%);\r\n    transform: translate(-50%);\r\n  }\r\n  @else if $position == 'both' {\r\n    top: 50%;\r\n    left: 50%;\r\n    -webkit-transform: translate(-50%, -50%);\r\n    -ms-transform: translate(-50%, -50%);\r\n    transform: translate(-50%, -50%);\r\n  }\r\n}\r\n\r\n@mixin transition($property) {\r\n  -webkit-transition: $property;\r\n  -ms-transition: $property;\r\n  transition: $property;\r\n}\r\n\r\n@mixin position($position-value,$top-value,$right-value,$bottom-value,$left-value){\r\n  position: $position-value;\r\n  top: $top-value;\r\n  right: $right-value;\r\n  bottom: $bottom-value;\r\n  left: $left-value;\r\n}\r\n\r\n@mixin margin-padding($margin, $padding) {\r\n   margin: $margin;\r\n   padding:$padding;\r\n}\r\n\r\n@mixin placeholder-color($color) {\r\n  &::-webkit-input-placeholder { /* WebKit browsers */\r\n      color: $color;\r\n      opacity: 1;\r\n  }\r\n  &:-moz-placeholder { /* Mozilla Firefox 4 to 18 */\r\n      color: $color;\r\n      opacity: 1;\r\n  }\r\n  &::-moz-placeholder { /* Mozilla Firefox 19+ */\r\n      color: $color;\r\n      opacity: 1;\r\n  }\r\n  &:-ms-input-placeholder { /* Internet Explorer 10+ */\r\n      color: $color;\r\n      opacity: 1;\r\n  }\r\n}\r\n\r\n@mixin rounded($unit) {\r\n  border-radius: $unit;\r\n}\r\n\r\n@mixin transform-origin($property) {\r\n  transform-origin: $property;\r\n  -webkit-transform-origin: $property;\r\n  -ms-transform-origin: $property;\r\n}\r\n\r\n@mixin box-shadow($inset:inset,$horizontaloffset:10px,$verticaloffset:10px,$blur:10px,$spread:10px,$color: #000000) {\r\n  -webkit-box-shadow: $inset $horizontaloffset $verticaloffset $blur $spread $color;\r\n  -moz-box-shadow: $inset $horizontaloffset $verticaloffset $blur $spread $color;\r\n  box-shadow: $inset $horizontaloffset $verticaloffset $blur $spread $color;\r\n}\r\n\r\n%animation-effect {   \r\n  -webkit-transition: all 0.5s;\r\n  -moz-transition: all 0.5s;\r\n  -o-transition: all 0.5s;\r\n  transition: all 0.5s;\r\n}\r\n",".page-wrapper {\r\n    @include transition(all 0.5s ease);\r\n    @include margin-padding( 0 0 0 276px, 56px 0 0);\r\n    @include position(relative,null,null,null,0);\r\n    @include transition(all 0.2s ease);\r\n    @include respond-below(custom991) {\r\n        @include margin-padding( 0 , 60px 0 0);\r\n    }\r\n    .content {\r\n        @include margin-padding(null, 24px);\r\n        padding-bottom: 0;\r\n        @include respond-below(custom991) {\r\n            @include margin-padding(null, 15px 15px 0);\r\n        }\r\n    }\r\n}\r\n",".header {\r\n    height: 56px;\r\n    z-index: 999;\r\n    background: $white;\r\n    @include position(fixed,0,0,null,0);\r\n    @include transition(all 0.5s ease);\r\n    .flag-nav {\r\n        > a {\r\n            img {\r\n                border-radius: 50%;\r\n                width: 22px;\r\n                height: 22px;\r\n            }\r\n        }\r\n    }\r\n    .searchinputs {\r\n        @include margin-padding(null,  0);\r\n        position: relative;\r\n        input {\r\n            width: 335px;\r\n            height: 42px;\r\n            border: 1px solid $light-300;\r\n            background: $light-300;\r\n            padding: 5px 10px;\r\n            padding-right: 35px;\r\n            border-radius: $border-radius-lg;\r\n            color: $gray-900;\r\n            @include respond-below(custom1199) {\r\n                width: 170px;\r\n            }\r\n            &::placeholder {\r\n                color: $gray-400;\r\n            }\r\n        }   \r\n        .search-addon {\r\n            button {\r\n                z-index: 9;\r\n                display: -webkit-box;\r\n                display: -ms-flexbox;\r\n                display: flex;\r\n                align-items: center;\r\n                -webkit-box-align: center;\r\n                -ms-flex-align: center;\r\n                justify-content: center;\r\n                -webkit-justify-content: center;\r\n                -ms-flex-pack: center;\r\n                @include rounded(5px);\r\n                cursor: pointer;\r\n                background: transparent;\r\n                border: 0;\r\n                padding: 0;\r\n                color: $gray-900;\r\n                @include position(absolute,50%,16px,null,null);\r\n                @include transform(translateY(-50%));\r\n            }\r\n        }\r\n    }\r\n    .dropdown-menu {\r\n        @include respond-above(custom992) {\r\n            top: 85px;\r\n            right: 0;\r\n            left: auto;\r\n            min-width: 200px;\r\n            visibility: hidden;\r\n            opacity: 0;\r\n            border: 0;\r\n            display: block;\r\n            border-radius: $border-radius-lg;\r\n            box-shadow: $box-shadow-sm;\r\n            @include margin-padding(0, 0);\r\n            @include transition(all 0.4s ease);\r\n            @include transform(translateY(20px));\r\n        }\r\n        @include respond-below(custom991) {\r\n            transition: none;\r\n        }\r\n    }\r\n    .dropdown-menu.show {\r\n        visibility: visible;\r\n        opacity: 1;\r\n        margin-top: 8px !important;\r\n        @include transform(translateY(0));\r\n        @include transition(all 0.4s ease);\r\n    }\r\n    .header-left {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        align-items: center;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        justify-content: space-between;\r\n        -webkit-justify-content: space-between;\r\n        -ms-flex-pack: space-between;\r\n        float: left;\r\n        height: 56px;\r\n        position: relative;\r\n        text-align: center;\r\n        width: 276px;\r\n        z-index: 1;\r\n        background: $white;\r\n        @include margin-padding(null, 0 15px);\r\n        @include transition(all 0.5s ease);\r\n        .logo {\r\n            display: inline-block;\r\n            line-height: 0;\r\n            img{\r\n                width: 140px;\r\n                display: block;\r\n                &.white-logo{\r\n                    display: none;\r\n                }\r\n            }\r\n            @include respond-below(custom991) {\r\n                text-align: center;\r\n                width: 100%;\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: center;\r\n                img{\r\n                    width: 140px;\r\n                }\r\n            }\r\n        }\r\n        .logo-small{\r\n            display: none;\r\n        }\r\n        @include respond-below(custom991) {\r\n            position: absolute;\r\n            width:100%;\r\n        }\r\n    }\r\n\r\n    @include respond-below(custom991) {\r\n       .header-left {\r\n        #toggle_btn {\r\n            display: none;\r\n        }\r\n       }\r\n    }\r\n    @include respond-above(custom991) {\r\n        #toggle_btn {\r\n            font-size: $font-size-18;\r\n            padding: 4px;\r\n            border-radius:6px;\r\n            .bar-icon {\r\n                display: inline-block;\r\n                width: 21px;\r\n                span {\r\n                    background-color: $white;\r\n                    display: block;\r\n                    float: left;\r\n                    height: 2px;\r\n                    width: 21px;\r\n                    @include margin-padding(0 0 5px, null);\r\n                    @include rounded(50px);\r\n                    &:nth-child(2) {\r\n                        width: 15px;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .bar-icon {\r\n        display: inline-block;\r\n        width: 31px;\r\n        margin-top: 20px;\r\n        span {\r\n            background-color: $primary;\r\n            display: block;\r\n            float: left;\r\n            height: 3px;\r\n            margin-bottom: 7px;\r\n            width: 31px;\r\n            border-radius: 2px;\r\n            transition: all 0.5s;\r\n            &:nth-child(2) {\r\n                width: 16px;\r\n            }\r\n        }\r\n    }\r\n    .menu-opened{\r\n        .slide-nav{\r\n            .bar-icon {\r\n                display: inline-block;\r\n                width: 31px;\r\n                margin-top: 20px;\r\n                span {\r\n                    &:first-child {\r\n                        position: relative;\r\n                        top: 10px;\r\n                        @include transform(rotate(45deg));\r\n                     }\r\n                    &:nth-child(2) {\r\n                       display:none;\r\n                    }\r\n                    &:last-child {\r\n                        @include transform(rotate(135deg));\r\n                     }\r\n                }\r\n            } \r\n        }\r\n    }\r\n    .menus-info {\r\n        min-width: 500px;\r\n        border-radius: $border-radius-lg;\r\n        padding: 8px;\r\n        @include respond-below(custom1199) {\r\n            min-width: 430px;\r\n        }\r\n        .menu-list {\r\n            li {\r\n                margin-bottom: 0;\r\n                margin-right: 0;\r\n                a {\r\n                    display: block;\r\n                    padding: 8px;\r\n                    background: $white;\r\n                    border-radius: $border-radius-lg;\r\n                    &:hover {\r\n                        background: $light-300;\r\n                    }\r\n                    .menu-details {\r\n                        display: -webkit-box;\r\n                        display: -ms-flexbox;\r\n                        display: flex;\r\n                        align-items: center;\r\n                        -webkit-box-align: center;\r\n                        -ms-flex-align: center;\r\n                        .menu-list-icon {\r\n                            font-size: $font-size-18;\r\n                            color: $white;\r\n                            width: 36px;\r\n                            min-width: 36px;\r\n                            height: 36px;\r\n                            padding: 5px;\r\n                            margin-right: 8px;\r\n                            border-radius: $border-radius-lg;\r\n                            display: -webkit-box;\r\n                            display: -ms-flexbox;\r\n                            display: flex;\r\n                            align-items: center;\r\n                            -webkit-box-align: center;\r\n                            -ms-flex-align: center;\r\n                            justify-content: center;\r\n                            -webkit-justify-content: center;\r\n                            -ms-flex-pack: center;\r\n                        }\r\n                        .menu-details-content {\r\n                            p {\r\n                                font-weight: $font-weight-semibold;\r\n                                color: $gray-900;\r\n                                margin-bottom: 0;\r\n                            }\r\n                            span {\r\n                                font-weight: $font-weight-normal;\r\n                                color: $text-color;\r\n                                @include respond-below(custom1199) {\r\n                                    font-size: $font-size-13;\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .profilename {\r\n        @include margin-padding(null, 0px);\r\n        .profileset {\r\n            display: -webkit-box;\r\n            display: -ms-flexbox;\r\n            display: flex;\r\n            @include margin-padding(null, 10px 10px 3px);\r\n            h6 {\r\n                font-size: $font-size-base;\r\n                color: $secondary;\r\n                font-weight: $font-weight-medium;\r\n            }\r\n            h5 {\r\n                font-size: $font-size-base;\r\n                color: $gray-600;\r\n            }\r\n            .profilesets {\r\n                margin-left: 10px;\r\n            }\r\n            .user-img img {\r\n                margin-top: 0;\r\n            }\r\n        }\r\n    }\r\n    .show{\r\n        .user-info {\r\n            &::after{\r\n                transform: rotate(-140deg);\r\n                top: 10px;\r\n            }  \r\n        }\r\n    }\r\n    \r\n    .user-info {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        align-items: center;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        justify-content: center;\r\n        -webkit-justify-content: center;\r\n        -ms-flex-pack: center;\r\n        position: relative;\r\n        padding: 0;\r\n        span {\r\n            &.user-detail {\r\n                @include respond-below(custom1199) {\r\n                    display: none;\r\n                }\r\n            }\r\n        }\r\n        &::after {\r\n            content: \"\";\r\n            width: 8px;\r\n            height: 8px;\r\n            border-top: 0;\r\n            border-left: 0;\r\n            border-right: 2px solid #1B2950;\r\n            border-bottom: 2px solid #1B2950;\r\n            border-radius: 1px;\r\n            transform: rotate(45deg);\r\n            transition: all 0.5s;\r\n            top: 8px;\r\n            position: absolute;\r\n            right: 12px;\r\n            display: none;\r\n            @include respond-below(custom1199) {\r\n                top:  12px;\r\n            }\r\n        }\r\n      .user-role {\r\n        display: block;\r\n        color: #67748E;\r\n        font-size: 12px;\r\n      }\r\n      .user-letter {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        align-items: center;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        justify-content: center;\r\n        -webkit-justify-content: center;\r\n        -ms-flex-pack: center;\r\n        color: $white;\r\n        width: 36px;\r\n        height: 36px;\r\n        border-radius: $border-radius-lg;\r\n        font-weight: $font-weight-semibold;\r\n        font-size: $font-size-15;\r\n        margin-right: 0;\r\n        @include respond-below(custom1199) {\r\n            margin-right: 0;\r\n        }\r\n        img {\r\n            border-radius: $border-radius-lg;\r\n        }\r\n      }\r\n      .user-name {\r\n        font-size: $font-size-15;\r\n        font-weight: $font-weight-semibold;\r\n        color: #1B2950;\r\n        display: flex;\r\n        align-items: center;\r\n      }\r\n      .user-name img {\r\n        margin-left: 10px;\r\n      }\r\n    }\r\n    .header-user {\r\n        padding: 15px 24px;\r\n        display: contents;\r\n        .user-menu {\r\n            align-items: center;\r\n            -webkit-box-align: center;\r\n            -ms-flex-align: center;\r\n            justify-content: center;\r\n            -webkit-justify-content: center;\r\n            -ms-flex-pack: center;\r\n            margin: 0;\r\n            position: relative;\r\n            height: 100%;\r\n            border-bottom: 0;\r\n            padding:0 24px;\r\n            @include transition(all 0.5s ease);\r\n            @include respond-below(custom991) {\r\n                display: none;\r\n            }\r\n            .status {\r\n                position: absolute;\r\n                content: \"\";\r\n                background: $primary;\r\n                width: 10px;\r\n                height: 10px;\r\n                border-radius: 50px;\r\n                top: 3px;\r\n                right: 3px;\r\n            }\r\n            .header-title{\r\n                h3{\r\n                    font-size: 24px;\r\n                    font-weight: 700;\r\n                }\r\n                h6{\r\n                    font-size: 12px;\r\n                    font-weight: 600;\r\n                }\r\n            }\r\n            > li {\r\n                margin-left: 10px;\r\n                margin-inline-end: 0;\r\n                &:first-child{\r\n                    margin-left:0;\r\n                }\r\n                @include respond-below(custom1199) {\r\n                    margin-left: 8px;\r\n                }\r\n                svg {\r\n                    width: 18px;\r\n                    color: #67748E;            \r\n                }\r\n                a:hover{\r\n                    svg {\r\n                        color: $primary;\r\n                    }\r\n                }\r\n            }\r\n            .dropdown-toggle{\r\n                &::after {\r\n                    border: 0;\r\n                    display: none;\r\n                }\r\n            }\r\n            .nav-searchinputs {\r\n                margin-right: auto;\r\n                margin-left: 25px;\r\n            }\r\n            .nav-item-box > a {\r\n                display: -webkit-box;\r\n                display: -ms-flexbox;\r\n                display: flex;\r\n                align-items: center;\r\n                -webkit-box-align: center;\r\n                -ms-flex-align: center;\r\n                justify-content: center;\r\n                -webkit-justify-content: center;\r\n                -ms-flex-pack: center;\r\n                background: $light-300;\r\n                color: $gray-900;\r\n                border-radius: $border-radius-lg;\r\n                width: 36px;\r\n                height: 36px;\r\n                position: relative;\r\n                border: 0;\r\n                &:hover {\r\n                    background: $light-800;\r\n                }\r\n            }\r\n            .nav-item-email {\r\n                &.nav-item-box {\r\n                    margin-left: 15px;\r\n                }\r\n            }\r\n            &.nav{\r\n               > li{\r\n                >  a{\r\n                    padding: 0;\r\n                    display: flex;\r\n                    line-height: normal;\r\n                    color: #3E4265;\r\n                    &.btn-header-list{\r\n                        color: $white;\r\n                        width: 36px;\r\n                        height: 36px;\r\n                        display: flex;\r\n                        align-items: center;\r\n                        justify-content: center;\r\n                        border-radius: $border-radius-lg;\r\n                    }\r\n                    .badge {\r\n                        color: $white;\r\n                        font-weight: $font-weight-bold;\r\n                        @include position(absolute,4px,4px,null,null);\r\n                        background: $primary;\r\n                        width: 15px;\r\n                        height: 15px;\r\n                        font-size: $font-size-10;\r\n                        display: -webkit-box;\r\n                        display: -ms-flexbox;\r\n                        display: flex;\r\n                        align-items: center;\r\n                        -webkit-box-align: center;\r\n                        -ms-flex-align: center;\r\n                        justify-content: center;\r\n                        -webkit-justify-content: center;\r\n                        -ms-flex-pack: center;\r\n                    }\r\n                    i {\r\n                        font-size: $font-size-18;\r\n                    }\r\n                    .badge-success {\r\n                        background: $success;\r\n                        border: 3px solid #FFF;\r\n                        padding: 0;\r\n                        top: inherit;\r\n                        bottom: -3px;\r\n                        right: -3px;\r\n                    }\r\n                }\r\n                &.flag-nav{\r\n                     a{\r\n                        display: -webkit-box;\r\n                        display: -ms-flexbox;\r\n                        display: flex;\r\n                        align-items: center;\r\n                        -webkit-box-align: center;\r\n                        -ms-flex-align: center;\r\n                        .dropdown-menu {\r\n                            max-height: 150px;\r\n                            min-width: 120px;\r\n                            overflow-y: auto;\r\n                            .dropdown-item {\r\n                                @include margin-padding(null, 5px 15px);\r\n                            }\r\n                        }\r\n                    }\r\n                    .dropdown-menu {\r\n                        padding: 15px;\r\n                        min-width: 210px;\r\n                        .dropdown-item {\r\n                            @include margin-padding(null, 10px 10px);\r\n                            color: #67748E;                    \r\n                            border-radius: 10px;\r\n                            transition: none;\r\n                            &.active{\r\n                                color: $white;\r\n                            }\r\n                            &.active,&:hover{\r\n                                background: #F7F7F7  no-repeat calc(100% - 12px) center;\r\n                            }\r\n                        }\r\n                        a{\r\n                            img{\r\n                                width: 20px;\r\n                                height: 20px;\r\n                                border-radius: 50%;\r\n                                margin-right: 10px;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .page-title-box {\r\n        float: left;\r\n        height: 60px;\r\n        margin-bottom: 0;\r\n        @include margin-padding(null, 17px 20px);\r\n        @include rounded(0);\r\n        @include respond-below(custom991) {\r\n            display: none;\r\n        }\r\n        a {\r\n            color: $primary;\r\n            font-size: $font-size-11;\r\n            font-weight: $font-weight-bold;\r\n            border: 1px solid $primary;\r\n            @include margin-padding(0, 5px);\r\n            @include rounded(5px);\r\n            &:hover{\r\n                background: $primary;\r\n                color: $white;\r\n            }\r\n        }\r\n    }\r\n    .mobile_btn {\r\n        display: none;\r\n        float: left;\r\n        @include respond-below(custom991) {\r\n            color: $primary;\r\n            font-size: $font-size-24;\r\n            height: 60px;\r\n            line-height: 60px;\r\n            width: 60px;\r\n            z-index: 10;\r\n            @include margin-padding(null, 0 20px);\r\n            @include position(absolute,0,null,null,0);\r\n            display: block;\r\n        }\r\n       \r\n    }\r\n    .responsive-search {\r\n        display: none;\r\n        color: $white;\r\n        font-size: $font-size-20;\r\n        height: 60px;\r\n        line-height: 60px;\r\n        @include margin-padding(null, 0 15px);\r\n        @include respond-below(custom991) {\r\n            display: block;\r\n        }\r\n    }\r\n    .top-nav-search {\r\n        form {\r\n            position: relative;\r\n            @include respond-below(custom991) {\r\n                display: none;\r\n            }\r\n            .form-control {\r\n                background-color: rgba(255, 255, 255, 0.1);\r\n                border: 1px solid rgba(255, 255, 255, 0.15);\r\n                height: 40px;\r\n                @include margin-padding(null, 10px 50px 10px 15px);\r\n                @include rounded(50px);\r\n                &::-webkit-input-placeholder {\r\n                    color: rgba(255, 255, 255, 0.7);\r\n                }\r\n            }\r\n            .btn {\r\n                background-color: transparent;\r\n                border-color: transparent;\r\n                color: rgba(255, 255, 255, 0.7);\r\n                min-height: 40px;\r\n                @include position(absolute,0,0,null,null);\r\n            }\r\n        }\r\n        @include respond-below(custom991) {\r\n            &.active{\r\n                form {\r\n                    display: block;\r\n                    @include position(absolute,null,null,null,0);\r\n                    .form-control {\r\n                        background-color: $white;\r\n                    }\r\n                    .btn {\r\n                        background-color: transparent;\r\n                        border-color: transparent;\r\n                        min-height: 40px;\r\n                        @include position(absolute,0,0,null,null);\r\n                        @include margin-padding(null, 7px 15px);\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .userset {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        align-items: center;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        .usernames{\r\n            line-height: initial;\r\n            text-align: right;\r\n            padding-right: 10px;\r\n            span {\r\n                display: block;\r\n                line-height: initial;\r\n            }\r\n        } \r\n    }\r\n    .menu-drop-user {\r\n        .dropdown-item {\r\n            display: -webkit-box;\r\n            display: -ms-flexbox;\r\n            display: flex;\r\n            align-items: center;\r\n            -webkit-box-align: center;\r\n            -ms-flex-align: center;\r\n            font-size: $font-size-14;\r\n            color: $gray-900;\r\n            padding: 10px;\r\n            border-bottom: 1px solid $light-400;\r\n            border-radius: 0;\r\n            &:first-child {\r\n                border-radius: 5px 5px 0 0;\r\n            }\r\n            &:last-child {\r\n                border-radius: 0 0 5px 5px;\r\n                border-bottom: 0;\r\n            }\r\n            &:hover {\r\n                padding-left: 20px;\r\n                letter-spacing: 0.5px;\r\n            }\r\n            i {\r\n                font-size: $font-size-16;\r\n                margin-right: 8px;\r\n            }\r\n        }\r\n    }\r\n    .has-arrow{\r\n        .dropdown-toggle{\r\n            @include respond-below(custom991) {\r\n                > span{\r\n                    &:nth-child(2) {\r\n                        display: none;\r\n                    }\r\n                }\r\n                &:after{\r\n                    display: none !important;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .profilename {\r\n        .user-img {\r\n            .status {\r\n                bottom: 10px;\r\n            }\r\n        }\r\n    }\r\n    .user-img {\r\n        display: inline-block;\r\n        position: relative;\r\n        img {\r\n            width: 38px;\r\n            @include rounded(50%);\r\n        }\r\n        .status {\r\n            border: 2px solid $white;\r\n            height: 10px;\r\n            width: 10px;\r\n            @include margin-padding(0, null);\r\n            @include position(absolute,null,0,30px,null);\r\n            @include rounded(50%);\r\n            display: inline-block;\r\n            background: $success;\r\n        }\r\n    }\r\n    .mobile-user-menu {\r\n        color: $white;\r\n        display: none;\r\n        float: right;\r\n        font-size: $font-size-24;\r\n        height: 60px;\r\n        line-height: 60px;\r\n        text-align: right;\r\n        width: 60px;\r\n        z-index: 10;\r\n        @include margin-padding(null, 0 20px);\r\n        @include position(absolute,0,0,null,null);\r\n        @include respond-below(custom991) {\r\n            display: block;\r\n        }\r\n        a{\r\n            color: $primary;\r\n            padding: 0;\r\n            &::after{\r\n                display: none;\r\n            }\r\n        }\r\n        .dropdown-menu{\r\n            padding: 0;\r\n            a{\r\n                color:$gray-800;\r\n                line-height: 40px; \r\n                @include margin-padding(null, 0 10px);\r\n            }\r\n        }\r\n    }\r\n}\r\n.logo-small img {\r\n    width: 30px;\r\n}\r\n@include respond-above(custom992) {\r\n    .mini-sidebar{\r\n        &.expand-menu{\r\n            .header-left {\r\n                flex-direction:row;\r\n                justify-content: space-between;\r\n                -webkit-justify-content: space-between;\r\n                -ms-flex-pack: space-between;\r\n            }\r\n        }\r\n        .header-left {\r\n            display: -webkit-box;\r\n            display: -ms-flexbox;\r\n            display: flex;\r\n            align-items: center;\r\n            -webkit-box-align: center;\r\n            -ms-flex-align: center;\r\n            justify-content: center;\r\n            -webkit-justify-content: center;\r\n            -ms-flex-pack: center;\r\n            width: 80px;\r\n            @include margin-padding(null, 0);\r\n            flex-direction:column;\r\n            .logo-small{\r\n                display: block;\r\n                padding: 10px 0 0;\r\n            }\r\n            .logo{\r\n                display: none;\r\n            }\r\n        }\r\n        .menu-arrow{\r\n            display: none !important;\r\n        }\r\n        .chat-user{\r\n            display: none !important;\r\n        }\r\n        .user-menu{\r\n            .badge{\r\n                display: flex !important;\r\n            }  \r\n        }\r\n        &.expand-menu{\r\n            .menu-arrow{\r\n                display: block !important;\r\n            }\r\n            .chat-user{\r\n                display: block !important;\r\n            }\r\n            .logo-small{\r\n                display: none;\r\n            }\r\n            .logo{\r\n                display: block;\r\n            }\r\n            #toggle_btn{\r\n               opacity: 1;\r\n            }\r\n            .header-left{\r\n                @include margin-padding(null, 0 15px);\r\n                display: flex;\r\n            }\r\n            \r\n        }\r\n        .noti-dot{\r\n            &:before{\r\n                display: none;\r\n            }\r\n        }\r\n    }\r\n}\r\n.nav-list {\r\n    position: relative;\r\n    padding-right: 15px;\r\n    &::before {\r\n        content: \"\";\r\n        position: absolute;\r\n        top: 50%;\r\n        transform: translateY(-50%);\r\n        right: 0;\r\n        width: 1px;\r\n        height: 20px;\r\n        background: $light-900;\r\n        z-index: 1;\r\n    }\r\n    .nav {\r\n        .dark-mode-list {\r\n            .dark-mode-toggle {\r\n                width: 66px;\r\n                height: 36px;\r\n                background: $light-200;\r\n                border: 1px solid $light-900;\r\n                font-size: $font-size-16;\r\n                border-radius: $border-radius-lg;\r\n                padding: 3px;\r\n                display: -webkit-box;\r\n                display: -ms-flexbox;\r\n                display: flex;\r\n                align-items: center;\r\n                -webkit-box-align: center;\r\n                -ms-flex-align: center;\r\n                justify-content: space-between;\r\n                -webkit-justify-content: space-between;\r\n                -ms-flex-pack: space-between;\r\n                i {\r\n                    font-size: $font-size-16;\r\n                    color: $gray-900;\r\n                    border-radius: $border-radius-lg;\r\n                    line-height: 26px;\r\n                    width: 26px;\r\n                    display: -webkit-box;\r\n                    display: -ms-flexbox;\r\n                    display: flex;\r\n                    align-items: center;\r\n                    -webkit-box-align: center;\r\n                    -ms-flex-align: center;\r\n                    justify-content: center;\r\n                    -webkit-justify-content: center;\r\n                    -ms-flex-pack: center;\r\n                    &.light-mode.active {\r\n                        color: $white;\r\n                        background: $success;\r\n                    }\r\n                    &.dark-mode.active {\r\n                        color: $white;\r\n                        background: $gray-900;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n        li {\r\n            margin-right: 10px;\r\n            &:last-child {\r\n                margin-right: 0;\r\n            }\r\n            .btn {\r\n                display: -webkit-box;\r\n                display: -ms-flexbox;\r\n                display: flex;\r\n                align-items: center;\r\n                -webkit-box-align: center;\r\n                -ms-flex-align: center;\r\n                justify-content: center;\r\n                -webkit-justify-content: center;\r\n                -ms-flex-pack: center;\r\n                width: 36px;\r\n                height: 36px;\r\n                font-size: $font-size-16;\r\n                border-radius: $border-radius-lg;\r\n                border: 1px solid transparent;\r\n            }\r\n            .btn-header-list {\r\n                color: $green;\r\n                background: $success-200;\r\n                border: 1px solid $green;\r\n                &:hover {\r\n                    color: $white;\r\n                    background: $green;\r\n                }\r\n            }\r\n            .btn-help {\r\n                color: $tertiary;\r\n                background: $purple-100;\r\n                &:hover {\r\n                    color: $white;\r\n                    background: $tertiary;\r\n                }\r\n            }\r\n            .btn-chart-pie {\r\n                color: $secondary;\r\n                background: $warning-100;\r\n                &:hover {\r\n                    color: $white;\r\n                    background: $secondary;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}       \r\n.mobile-show {\r\n    display: none;\r\n    @include respond-below(custom991) {\r\n        display: block;\r\n    }\r\n}\r\n",".sidebar {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    background-color: $white;\r\n    margin-top: 0;\r\n    z-index: 1001;\r\n    @include position(fixed,56px,null,0,0);\r\n    @include transition(all 0.5s ease);\r\n    width: 276px;\r\n    @include respond-below(custom991) {\r\n        margin-left: -575px;\r\n        @include transition(all 0.4s ease);\r\n        z-index: 1041;\r\n        background: $white;\r\n    }\r\n    @include respond-below(custom575) {\r\n        width: 100%;\r\n    }\r\n    .slimScrollDiv {\r\n        border-right: 1px solid transparent;\r\n        @include respond-below(custom575) {\r\n            width: 100% !important;\r\n        }\r\n    }\r\n    .sidebar-menu{\r\n        @include margin-padding(null, 15px);\r\n        .clinicdropdown{\r\n            margin-bottom: 24px;\r\n           > a {\r\n                background: $light-300;\r\n                border-radius: $border-radius-lg;\r\n                padding: 10px;\r\n                img{\r\n                    width: 42px;\r\n                    height: 42px;\r\n                    border-radius: $border-radius-lg;\r\n                }\r\n                .user-names{\r\n                    margin-left: 10px;\r\n                    flex: 1;\r\n                    h5{\r\n                        font-size: $font-size-16;\r\n                        font-weight: $font-weight-semibold;\r\n                        color: $title-color;\r\n                        margin-bottom: 2px;\r\n                    }\r\n                    h6 {\r\n                        font-size: $font-size-14;\r\n                        font-weight: $font-weight-normal;\r\n                        color: $text-color;\r\n                        margin-bottom: 0;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n        .submenu-two{\r\n            .subdrop.active{\r\n                background: transparent !important;\r\n            }    \r\n        }\r\n        > ul{\r\n            > li{\r\n                margin-bottom: 24px;\r\n                &.active{\r\n                    a{\r\n                        color: $white;\r\n                    }\r\n                    svg {\r\n                        color: #FE9F43\r\n                    }\r\n                }\r\n                svg {\r\n                    min-width: 16px;\r\n                    width:  16px;\r\n                    height:  16px;\r\n                    margin-right: 10px;\r\n                }\r\n                > a{\r\n                    display: -webkit-box;\r\n                    display: -ms-flexbox;\r\n                    display: flex;\r\n                    align-items: center;\r\n                    -webkit-box-align: center;\r\n                    -ms-flex-align: center;\r\n                    @include margin-padding(null, 10px 15px);\r\n                    position: relative;\r\n                    color: $secondary;\r\n                    svg{\r\n                        color: #637381;\r\n                    }\r\n                    img{\r\n                        color: #637381;\r\n                    }\r\n                    \r\n                    &.active{\r\n                        background: rgba(254, 159, 67, 0.08);\r\n                        color: #FE9F43;\r\n                        border-radius: 5px;\r\n                        svg{\r\n                            color: $white;\r\n                        }\r\n                        img {\r\n                            filter: invert(72%) sepia(76%) saturate(1430%) hue-rotate(327deg) brightness(103%) contrast(101%);\r\n                        }\r\n                        span{\r\n                            color: #FE9F43;\r\n                        }\r\n                        .menu-arrow{\r\n                            background: #FFEDDC;\r\n                            &::before{\r\n                                border-color: #FE9F43;\r\n                            }\r\n                        }\r\n                    }\r\n                    span {\r\n                        font-size: $font-size-15;\r\n                        font-weight: $font-weight-medium;\r\n                        color: $gray-600;\r\n                    }\r\n                }\r\n                &.active {\r\n                    a {\r\n                        background: rgba(254, 159, 67, 0.08);\r\n                        border-radius: 5px;\r\n                        img{\r\n                            filter: invert(72%) sepia(76%) saturate(1430%) hue-rotate(327deg) brightness(103%) contrast(101%);\r\n                        }\r\n                        span{\r\n                            color: #FE9F43;\r\n                        }\r\n                    }\r\n                }\r\n                &.submenu {\r\n                    ul {\r\n                        display: none;\r\n                       li {\r\n                            a {\r\n                               font-weight: $font-weight-medium;\r\n                               font-size: $font-size-base;\r\n                               position: relative;\r\n                               display: block;\r\n                               @include margin-padding(null, 8px 8px 8px 40px);\r\n                               padding-left: 30px;\r\n                           }\r\n                       }\r\n                    }\r\n                }\r\n                ul {\r\n                    display: block;\r\n                    margin-bottom: 24px;\r\n                    li {\r\n                        margin-bottom: 5px;\r\n                        border-radius: 5px;\r\n                        overflow: hidden;\r\n                        a {\r\n                            display: -webkit-box;\r\n                            display: -ms-flexbox;\r\n                            display: flex;\r\n                            align-items: center;\r\n                            -webkit-box-align: center;\r\n                            -ms-flex-align: center;\r\n                            font-weight: $font-weight-normal;\r\n                            font-size: $font-size-14;\r\n                            color: $gray-400;\r\n                            position: relative;\r\n                            width: 100%;\r\n                            @include margin-padding(null, 8px);\r\n                            i {\r\n                                color: $gray-900;\r\n                                font-size: $font-size-16;\r\n                                background: $light-300;\r\n                                border-radius: 5px;\r\n                                width: 26px;\r\n                                height: 26px;\r\n                                display: flex;\r\n                                align-items: center;\r\n                                justify-content: center;\r\n                            }\r\n                            span {\r\n                                font-size: $font-size-15;\r\n                                font-weight: $font-weight-medium;\r\n                                white-space: nowrap;\r\n                                color: $gray-900;\r\n                                margin-left: 10px;\r\n                            }\r\n                            &.active {\r\n                                color: $primary;\r\n                                background: $primary-100;\r\n                                border-radius: $border-radius-lg;\r\n                                span {\r\n                                    color: $primary;\r\n                                }\r\n                                i {\r\n                                    background: $primary;\r\n                                    color: $white;\r\n                                }\r\n                            }\r\n                            &:hover{\r\n                                color: $primary;\r\n                                span {\r\n                                    color: $primary;\r\n                                }\r\n                            }\r\n                        }  \r\n                    }\r\n                    > li {\r\n                        &.active a{\r\n                            &.subdrop{\r\n                                background: #FFEEEC;\r\n                                border-radius: 5px;\r\n                                color: #E41F07;\r\n                                i{\r\n                                    color:$white;\r\n                                    background:#E41F07;\r\n                                }\r\n                                span {\r\n                                    color: #E41F07;\r\n                                    \r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n                .submenu-hdr {\r\n                    font-weight: $font-weight-semibold;\r\n                    font-size: $font-size-12;\r\n                    color: $gray-400;\r\n                    margin: 0 0 14px 0;\r\n                    text-transform: uppercase;\r\n                }\r\n                &:first-child {\r\n                    h6 {\r\n                        margin-top: 0;\r\n                    }\r\n                }\r\n                .submenu {\r\n                    ul {\r\n                        display: none;\r\n                        border: 0;\r\n                        padding-top: 0;\r\n                        padding-bottom: 0;\r\n                    }\r\n                }\r\n            }\r\n            li {\r\n                margin-bottom: 5px;\r\n                .submenu > {\r\n                    ul {\r\n                        margin: 0;\r\n                        li {\r\n                            a {\r\n                                padding-left: 44px;\r\n                                font-size: $font-size-base;\r\n                                background: transparent;\r\n                                position: relative;\r\n                                &:after{\r\n                                    position: absolute;\r\n                                    content: \"\";\r\n                                    background-color: #898989;\r\n                                    width: 7px;\r\n                                    height: 7px;\r\n                                    border-radius: 50px;\r\n                                    left: 16px;\r\n                                    top: 14px;\r\n                                }\r\n                                &:before{\r\n                                    position: absolute;\r\n                                    content: \"\";\r\n                                    background-color: #898989;\r\n                                    width: 0.5px;\r\n                                    height: 8px;\r\n                                    left: 19px;\r\n                                    top: 0px;\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n                    a {\r\n                        &.subdrop {\r\n                            background: $light-200;\r\n                            i {\r\n                                background: $dark;\r\n                                color: $white;\r\n                            }\r\n                            &.submenu-two{\r\n                                background: transparent;\r\n                            }\r\n                        }\r\n                        &.active {\r\n                            background: $primary-100;\r\n                            border-radius: 5px;\r\n                            i {\r\n                                background: $primary;\r\n                                color: $white;\r\n                            }\r\n                            span {\r\n                                color: $primary;\r\n                            }\r\n                            .menu-arrow {\r\n                                &::before {\r\n                                    border-right: 2px solid $primary;\r\n                                    border-bottom: 2px solid $primary;\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n                \r\n            }\r\n\r\n        }\r\n        .submenu-open {\r\n            &:last-child {\r\n                margin-bottom: 0;\r\n                ul {\r\n                    border-bottom: none;\r\n                    padding-bottom: 0;\r\n                }\r\n            }\r\n            .submenu {\r\n                &.submenu-two {\r\n                    ul {\r\n                        li {\r\n                            a {\r\n                                margin-left: 45px;\r\n                            }\r\n                        }\r\n                    }\r\n                    &.submenu-three {\r\n                        ul {\r\n                            li {\r\n                                a {\r\n                                    margin-left: 65px;\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n                ul {\r\n                    li {\r\n                        a {\r\n                        margin-left: 25px;\r\n                        padding-bottom: 4px;\r\n                        font-size: $font-size-base;\r\n                        color: $sub-title;\r\n                        &::after{\r\n                            content: \"\";\r\n                            background: rgba(50, 71, 92, 0.38);\r\n                            width: 8px;\r\n                            height: 8px;\r\n                            border: 2px solid $white;\r\n                            @include rounded(50px);\r\n                            @include position(absolute,16px,null,null,0);\r\n                            }\r\n                            &:hover{\r\n                                color:$primary;\r\n                                &:after{\r\n                                background: #FE9F43;\r\n                                border: 2px solid #FDB;\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n                } \r\n            } \r\n        }               \r\n        .menu-arrow {\r\n            display: -webkit-box;\r\n            display: -ms-flexbox;\r\n            display: flex;\r\n            align-items: center;\r\n            -webkit-box-align: center;\r\n            -ms-flex-align: center;\r\n            justify-content: center;\r\n            -webkit-justify-content: center;\r\n            -ms-flex-pack: center;\r\n            text-rendering: auto;\r\n            line-height: 40px;\r\n            font-size: $font-size-18;\r\n            line-height: 16px;\r\n            width: 16px;\r\n            height: 16px;\r\n            border-radius: 50%;\r\n            @include position(absolute,12px,10px,null,null);\r\n            @include transform(translate(0, 0));\r\n            @include transition(all 0.2s ease);\r\n            &::before {\r\n                height: 8px;\r\n                width: 8px;\r\n                border-top: 0;\r\n                content: \"\";\r\n                border-left: 0;\r\n                border-right: 2px solid $gray-900;\r\n                border-bottom: 2px solid $gray-900;\r\n                transform: rotate(-45deg);\r\n                position: absolute;\r\n                left: 5px;\r\n                top: 5px;\r\n            }\r\n            &.inside-submenu {\r\n                right: 10px;\r\n                &.inside-submenu-two {\r\n                    right: 60px;\r\n                }\r\n            }\r\n        }\r\n        &.subdrop{\r\n            .menu-arrow {\r\n                @include transform(rotate(90deg));                            \r\n                background: #FFEDDC;\r\n            }\r\n        }\r\n    }\r\n    .nav-link {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        align-items: center;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        justify-content: center;\r\n        -webkit-justify-content: center;\r\n        -ms-flex-pack: center;\r\n        @include margin-padding(null, 10px);\r\n        color: $secondary;\r\n        position: relative;\r\n        &.active{\r\n            color: $primary;\r\n            background: transparent;\r\n            position: relative;\r\n            &:after{\r\n                content: \"\";\r\n                border-width:10px;\r\n                border-color: transparent $primary transparent transparent;\r\n                border-style: solid;\r\n                @include position(absolute,36px,0,null,null);\r\n            }\r\n        }\r\n        \r\n    }\r\n    .sidebar-left {\r\n        width: 100px;\r\n        @include box-shadow(null, 5px, 0px, 15px, null, rgba(0, 0, 0, .05));\r\n    }\r\n    .sidebar-right {\r\n        width: 250px;\r\n        height: 100%;\r\n        @include transition(all 0.2s ease);\r\n        display: none;\r\n        @include respond-below(custom991) {\r\n            width: calc(100% - 70px);\r\n        }\r\n        .slimScrollDiv {\r\n            width: 250px !important;\r\n            overflow: visible !important;\r\n            @include respond-below(custom991) {\r\n                width: 100% !important;\r\n            }\r\n        }\r\n        .tab-content {\r\n            @include margin-padding(null, 20px 20px 40px);\r\n            @include respond-below(custom991) {\r\n                @include margin-padding(null,10px);\r\n            }\r\n        }\r\n        p {\r\n            font-size: $font-size-10;\r\n            color: $gray-500;\r\n            text-transform: uppercase;\r\n            font-weight: $font-weight-bold;\r\n            margin-bottom: 10px;\r\n        }\r\n        ul {\r\n            list-style: none;\r\n            padding: 0;\r\n            margin: 0;\r\n            li {\r\n                &.active{\r\n                    a{\r\n                        background: linear-gradient(46.62deg, $primary 0%, $violet 93.64%);\r\n                        color: $white;\r\n                    }\r\n                }\r\n                a {\r\n                    font-weight: $font-weight-normal;\r\n                    font-size: $font-size-base;\r\n                    color: $secondary;\r\n                    &.active {\r\n                        color: $primary;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n        .menu-arrow {\r\n            -webkit-transition: -webkit-transform 0.15s;\r\n            -o-transition: -o-transform 0.15s;\r\n            transition: transform .15s;\r\n            display: inline-block;\r\n            font-family: 'Font Awesome 5 Free';\r\n            text-rendering: auto;\r\n            line-height: 40px;\r\n            font-size: $font-size-18;\r\n            -webkit-font-smoothing: antialiased;\r\n            -moz-osx-font-smoothing: grayscale;\r\n            line-height: 18px;\r\n            top: 0px;\r\n            position: relative;\r\n            font-weight: $font-weight-bold;\r\n            @include transform(translate(0, 0));\r\n            &:before {\r\n                content: \"\\f105\";\r\n                \r\n            }\r\n        }\r\n    }\r\n    .sub-menu a {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        align-items: center;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        justify-content: space-between;\r\n        -webkit-justify-content: space-between;\r\n        -ms-flex-pack: space-between;\r\n    }\r\n    li {\r\n        a.subdrop {\r\n            .menu-arrow {\r\n                @include transform(rotate(90deg));\r\n            }\r\n        }\r\n    }\r\n    .nav-items{\r\n        .nav-link {\r\n            display: -webkit-box;\r\n            display: -ms-flexbox;\r\n            display: flex;\r\n            -ms-flex-direction: column;\r\n            flex-direction: column;\r\n            @include rounded(0);\r\n            border-bottom: 1px solid $gray-400;\r\n            @include margin-padding(null, 20px 0);\r\n            @include transition(all 0.4s ease);\r\n            &:hover{\r\n                box-shadow: 0  0 0 150px $violet inset;\r\n                color: $white;\r\n            }  \r\n            span{\r\n                margin-top: 15px;\r\n                font-weight:$font-weight-medium;\r\n            }\r\n        }\r\n       \r\n    }\r\n    .sidemenu {\r\n        a {\r\n            width: 100%;\r\n            font-weight: $font-weight-medium;\r\n            display: block;\r\n            @include rounded(5px);\r\n            @include margin-padding( 0 0 10px, 10px);\r\n            &:hover{\r\n                background: linear-gradient(46.62deg, $primary 0%, $violet 93.64%);\r\n                color: $white;\r\n                svg{\r\n                    color:$white;\r\n                }\r\n            }\r\n            svg {\r\n                stroke-width: 1px;\r\n            }\r\n           \r\n        }\r\n    }\r\n}\r\n\r\n\r\n@include respond-above(custom991) {\r\n    .mini-sidebar {\r\n        .page-wrapper {\r\n            margin-left: 80px;\r\n        }\r\n        .user-names{\r\n            display: none;\r\n        }\r\n        .header-left {\r\n            #toggle_btn{\r\n                opacity: 1;\r\n                transform: rotate(180deg);\r\n                &:after {\r\n                   border:0;\r\n                }\r\n            }\r\n        }\r\n        .sidebar {\r\n            .sidebar-menu {\r\n                .clinicdropdown > a {\r\n                    padding: 5px;\r\n                }\r\n            }\r\n        }\r\n        &.expand-menu{\r\n            .header-left {\r\n                #toggle_btn{\r\n                    opacity: 1;\r\n                    transform: rotate(180deg);\r\n                }\r\n            }  \r\n            .sidebar {\r\n                .sidebar-menu{\r\n                    .clinicdropdown > a {\r\n                        padding: 10px ;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n        .sidebar-right {\r\n            display: none;\r\n        }\r\n        .sidebar {\r\n            .sidebar-menu{\r\n                  ul{\r\n                    li{\r\n                        a {\r\n                            span{\r\n                                display:none;\r\n                            }\r\n                        }\r\n                        .submenu-hdr {\r\n                            display:none;\r\n                        }                                                       \r\n                        svg {\r\n                            margin-right:0;\r\n                        }\r\n                    }\r\n                }\r\n            } \r\n        }\r\n        .sidebar{\r\n            width: 80px;\r\n            overflow: hidden;\r\n        }\r\n        &.expand-menu{\r\n            .sidebar {\r\n                display:block\r\n            }\r\n        }\r\n    }\r\n    .expand-menu{\r\n        &.mini-sidebar{\r\n            .sidebar{\r\n                .sidebar-menu{\r\n                    .submenu-hdr {\r\n                        display:block;\r\n                    }\r\n                }\r\n                .user-names{\r\n                    display: block;\r\n                }\r\n            }\r\n        }\r\n        .sidebar-right {\r\n            display: block;\r\n            @include transition(all 0.2s ease);\r\n        }\r\n        .sidebar {\r\n            width: 276px;\r\n            .sidebar-menu{\r\n               ul{\r\n                   > li{\r\n                        > a {\r\n                            span{\r\n                                display:inline-block;\r\n                                line-height: 0;\r\n                            }\r\n                        }                        \r\n                        svg {\r\n                            margin-right:10px;\r\n                        }\r\n                    }\r\n                }\r\n                .submenu-hdr {\r\n                    display:block;\r\n                }\r\n            }\r\n        }\r\n        .header-left{\r\n            width: 276px;\r\n        }\r\n    }\r\n    #toggle_btn {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        align-items: center;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        justify-content: center;\r\n        -webkit-justify-content: center;\r\n        -ms-flex-pack: center;\r\n        float: left;\r\n    }\r\n}\r\nbody.mini-sidebar.expand-menu{\r\n    .sidebar .sidebar-menu > ul > li ul li a{\r\n        justify-content: start;\r\n    }\r\n}\r\nbody.mini-sidebar{\r\n    .sidebar .sidebar-menu > ul > li ul li a{\r\n        justify-content: center;\r\n    }\r\n    .sidebar {\r\n        .sidebar-menu > ul > li.submenu-open ul li a {\r\n            display: -webkit-box;\r\n            display: -ms-flexbox;\r\n            display: flex;\r\n            align-items: center;\r\n            -webkit-box-align: center;\r\n            -ms-flex-align: center;\r\n            justify-content: center;\r\n            -webkit-justify-content: center;\r\n            -ms-flex-pack: center;\r\n            font-weight: $font-weight-medium;\r\n            font-size: $font-size-15;\r\n            color: #67748E;\r\n            position: relative;\r\n            width: 100%;\r\n            padding: 10px;\r\n        }\r\n        .sidebar-menu > ul > li ul > li.active a{\r\n            padding: 10px;\r\n            justify-content: center;\r\n        }\r\n    }\r\n     \r\n    &.expand-menu {\r\n        .sidebar {\r\n            .sidebar-menu > ul > li.submenu-open ul li a {\r\n                justify-content: left;\r\n                -webkit-justify-content: left;\r\n                -ms-flex-pack: left;\r\n                padding-left:  18px;\r\n            }\r\n            .sidebar-menu > ul > li ul > li.active a{\r\n                padding: 10px 15px;\r\n                justify-content: start;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.sidebarrightmenu{\r\n    .sidebar-right{\r\n        display: block;\r\n    }\r\n}\r\n.slide-nav{\r\n    .sidebar {\r\n        margin-left: 0;\r\n    }\r\n}\r\n.sidebar-overlay {\r\n    display: none;\r\n    height: 100%;\r\n    width: 100%;\r\n    z-index: 99;\r\n    background-color: rgba(0, 0, 0, 0.6);\r\n    @include position(fixed,60px,null,null,0);\r\n    &.opened {\r\n        display: block;\r\n    }\r\n}\r\n.mini-sidebar{\r\n    .active.subdrop ~ ul{\r\n        display: none !important;\r\n    }\r\n}\r\n.mini-sidebar.expand-menu{\r\n    .active.subdrop ~ ul{\r\n        display: block !important;\r\n    }\r\n}\r\n.active.subdrop ~ ul{\r\n    display: block !important;\r\n}\r\n\r\n.sidebar {\r\n\t.sidebar-menu {\r\n\t\t>ul {\r\n\t\t\tli {\r\n\t\t\t\t.submenu {\r\n                    &.submenu-two {\r\n                        >ul {\r\n                            li {\r\n                                a {\r\n                                    margin-left: 30px;\r\n                                }\r\n                            }\r\n                        }\r\n                        &.submenu-three {\r\n                            >ul {\r\n                                li {\r\n                                    a {\r\n                                        margin-left: 60px;\r\n                                    }\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n                \r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n.mini-sidebar {\r\n    .header {\r\n        #toggle_btn {\r\n            opacity: 0;\r\n            height: 0;\r\n            width: 0;\r\n        }\r\n    }\r\n}"," [data-sidebar=\"dark\"]{\r\n    .sidebar {\r\n        background-color:$dark;\r\n        .sidebar-menu {\r\n            .clinicdropdown {\r\n                a{\r\n                    background-color:#000000;\r\n                    .user-names h5{\r\n                        color: $white;\r\n                    }\r\n                }\r\n            }\r\n            ul{\r\n                > li {\r\n                    ul {\r\n                        li a {\r\n                            span{\r\n                                color: $dark-text;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n            .menu-arrow{\r\n               &:before{\r\n                    border-right: 2px solid $dark-text;\r\n                    border-bottom: 2px solid $dark-text;\r\n               }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n [data-sidebar=\"blue\"]{\r\n    .sidebar {\r\n        background-color:#3C2371;\r\n        .sidebar-menu {\r\n            .clinicdropdown {\r\n                a{\r\n                    background-color:#2f0093;\r\n                    .user-names {\r\n                        h5{\r\n                            color: $white;\r\n                        }\r\n                        h6{\r\n                            color: #e4e4e4;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n             > ul > li .submenu-hdr{\r\n                color: $white;\r\n            }\r\n            ul{\r\n                > li {\r\n                    .submenu-hdr{\r\n                        color: $white;\r\n                    }\r\n                    ul {\r\n                        li {\r\n                            a {\r\n                                color: $white;\r\n                                &.active{\r\n                                    i{\r\n                                        background-color:#3C2371;\r\n                                    }\r\n                                    span{\r\n                                        color: #3C2371;\r\n                                    }\r\n                                    .menu-arrow::before {\r\n                                        border-right: 2px solid #3C2371;\r\n                                        border-bottom: 2px solid #3C2371;\r\n                                    }\r\n                                }\r\n                                span{\r\n                                    color: $white;\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n            .menu-arrow{\r\n               &:before{\r\n                    border-right: 2px solid $white;\r\n                    border-bottom: 2px solid $white;\r\n               }\r\n            }\r\n        }\r\n    }\r\n}\r\n [data-sidebar=\"green\"]{\r\n    .sidebar {\r\n        background-color:#00918E;\r\n        .sidebar-menu {\r\n            .clinicdropdown {\r\n                a{\r\n                    background-color:#005351;\r\n                    .user-names {\r\n                        h5{\r\n                            color: $white;\r\n                        }\r\n                        h6{\r\n                            color: #e4e4e4;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n             > ul > li .submenu-hdr{\r\n                color: $white;\r\n            }\r\n            ul{\r\n                > li {\r\n                    .submenu-hdr{\r\n                        color: $white;\r\n                    }\r\n                    ul {\r\n                        li {\r\n                            a {\r\n                                color: $white;\r\n                                &.active{\r\n                                    i{\r\n                                        background-color:#00918E;\r\n                                    }\r\n                                    span{\r\n                                        color: #00918E;\r\n                                    }\r\n                                    .menu-arrow::before {\r\n                                        border-right: 2px solid #00918E;\r\n                                        border-bottom: 2px solid #00918E;\r\n                                    }\r\n                                }\r\n                                span{\r\n                                    color: $white;\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n            .menu-arrow{\r\n               &:before{\r\n                    border-right: 2px solid $white;\r\n                    border-bottom: 2px solid $white;\r\n               }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n[data-color=\"red\"]{\r\n    $primary: #E41F07;\r\n    .btn-primary {\r\n        background: $primary;\r\n        border: 1px solid $primary;\r\n        &:hover {\r\n            background: #c11a06;\r\n            border-color: #c11a06;\r\n        }\r\n    }\r\n}\r\n [data-color=\"yellow\"]{\r\n    $primary: #FFA201;\r\n    $secondary-100: #FFF6E6;\r\n    .btn-primary {\r\n        &:hover {\r\n            background: #FF9901 !important;\r\n            border-color: #FF9901 !important;\r\n        }\r\n    }\r\n    .sidebar {\r\n        .sidebar-menu {\r\n            > ul {\r\n                > li {\r\n                    ul {\r\n                        li {\r\n                            a{\r\n                                &.active{\r\n                                    color: $primary;\r\n                                    background: $secondary-100;\r\n                                     span{\r\n                                        color: $primary;\r\n                                     }\r\n                                    i {\r\n                                        background:  $primary;\r\n                                    }\r\n                                }\r\n                                &:hover {\r\n                                    color: $primary;\r\n                                    span{\r\n                                        color: $primary;\r\n                                    }\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n                    .submenu  {\r\n                        .subdrop.active {\r\n                            background: $secondary-100;\r\n                            \r\n                        }\r\n                        ul{\r\n                            li{\r\n                                a.active{\r\n                                    background: transparent;\r\n                                }\r\n                            }\r\n                        }\r\n                        > a.active{\r\n                            background: transparent;\r\n                            color: $primary;\r\n                            i {\r\n                                background:  $primary;\r\n                            }\r\n                            span{\r\n                                color: $primary;\r\n                            }\r\n                            .menu-arrow::before {\r\n                                border-right: 2px solid $primary;\r\n                                border-bottom: 2px solid $primary;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n                \r\n            }\r\n        }\r\n    }\r\n    .user-accordion-item .accordion-wrap:not(.collapsed) span{\r\n        background: $primary;\r\n    }\r\n    .page-header .btn-added{\r\n        background: $primary;\r\n    }\r\n    .settings-menu .nav li a.active {\r\n        color: $primary;\r\n        border-bottom: 4px solid $primary;\r\n    }\r\n    .toggle-popup .sidebar-layout .sidebar-header .toggle-btn:hover, \r\n    .toggle-popup1 .sidebar-layout .sidebar-header .toggle-btn:hover, \r\n    .toggle-popup2 .sidebar-layout .sidebar-header .toggle-btn:hover{\r\n        background: $primary;\r\n        border-color: $primary;\r\n    }\r\n    .todo-inbox-check .checkboxs input:checked ~ .checkmarks {\r\n        border-color: $primary;\r\n        background-color: $primary;\r\n    }\r\n    .custom-pagination .paginations .page-wrap li a.active {\r\n        background: $primary;\r\n    }\r\n    .contact-nav li a:hover, .contact-nav li a.active {\r\n        color: $primary;\r\n        border-color: $primary;\r\n    }\r\n    .dataTables_paginate .pagination li.active a.page-link, #dataTables_paginate .pagination li.active a.page-link {\r\n        background:  $primary;\r\n        border-color:  $primary;\r\n    }\r\n    .btn-primary {\r\n        background: $primary;\r\n        border: 1px solid $primary;\r\n    }\r\n    .select2-container--default .select2-results__option--selected{\r\n        background: $primary;\r\n        color: $white;\r\n    }\r\n    .view-icons a.active, \r\n    .view-icons a:hover{\r\n        background: $primary;\r\n    }\r\n    .btn.btn-primary {\r\n        background-color: $primary;\r\n        border: 1px solid $primary;\r\n    }\r\n    .form-check-input:checked {\r\n        background-color: $primary;\r\n        border-color: $primary;\r\n    }\r\n    .breadcrumb .breadcrumb-item.active {\r\n        color: $primary;\r\n    }\r\n    .btn-outline-primary {\r\n        border: 1px solid $primary !important;\r\n        color: $primary !important;\r\n    }\r\n}\r\n\r\n [data-color=\"blue\"]{\r\n    $primary: #3C2371;\r\n    $secondary-100: #ECE9F1;\r\n    .btn-primary {\r\n        &:hover {\r\n            background: #3B4971 !important;\r\n            border-color: #3B4971 !important;\r\n        }\r\n    }\r\n    .sidebar {\r\n        .sidebar-menu {\r\n            > ul {\r\n                > li {\r\n                    ul {\r\n                        li {\r\n                            a{\r\n                                &.active{\r\n                                    color: $primary;\r\n                                    background: $secondary-100;\r\n                                     span{\r\n                                        color: $primary;\r\n                                     }\r\n                                    i {\r\n                                        background:  $primary;\r\n                                    }\r\n                                }\r\n                                &:hover {\r\n                                    color: $primary;\r\n                                    span{\r\n                                        color: $primary;\r\n                                    }\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n                    .submenu  {\r\n                        .subdrop.active {\r\n                            background: $secondary-100;\r\n                            \r\n                        }\r\n                        ul{\r\n                            li{\r\n                                a.active{\r\n                                    background: transparent;\r\n                                }\r\n                            }\r\n                        }\r\n                        > a.active{\r\n                            background: transparent;\r\n                            color: $primary;\r\n                            i {\r\n                                background:  $primary;\r\n                            }\r\n                            span{\r\n                                color: $primary;\r\n                            }\r\n                            .menu-arrow::before {\r\n                                border-right: 2px solid $primary;\r\n                                border-bottom: 2px solid $primary;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n                \r\n            }\r\n        }\r\n    }\r\n    .user-accordion-item .accordion-wrap:not(.collapsed) span{\r\n        background: $primary;\r\n    }\r\n    .page-header .btn-added{\r\n        background: $primary;\r\n    }\r\n    .settings-menu .nav li a.active {\r\n        color: $primary;\r\n        border-bottom: 4px solid $primary;\r\n    }\r\n    .toggle-popup .sidebar-layout .sidebar-header .toggle-btn:hover, \r\n    .toggle-popup1 .sidebar-layout .sidebar-header .toggle-btn:hover, \r\n    .toggle-popup2 .sidebar-layout .sidebar-header .toggle-btn:hover{\r\n        background: $primary;\r\n        border-color: $primary;\r\n    }\r\n    .todo-inbox-check .checkboxs input:checked ~ .checkmarks {\r\n        border-color: $primary;\r\n        background-color: $primary;\r\n    }\r\n    .custom-pagination .paginations .page-wrap li a.active {\r\n        background: $primary;\r\n    }\r\n    .contact-nav li a:hover, .contact-nav li a.active {\r\n        color: $primary;\r\n        border-color: $primary;\r\n    }\r\n    .dataTables_paginate .pagination li.active a.page-link, #dataTables_paginate .pagination li.active a.page-link {\r\n        background:  $primary;\r\n        border-color:  $primary;\r\n    }\r\n    .btn-primary {\r\n        background: $primary;\r\n        border: 1px solid $primary;\r\n    }\r\n    .select2-container--default .select2-results__option--selected{\r\n        background: $primary;\r\n        color: $white;\r\n    }\r\n    .view-icons a.active, \r\n    .view-icons a:hover{\r\n        background: $primary;\r\n    }\r\n    .btn.btn-primary {\r\n        background-color: $primary;\r\n        border: 1px solid $primary;\r\n    }\r\n    .form-check-input:checked {\r\n        background-color: $primary;\r\n        border-color: $primary;\r\n    }\r\n    .breadcrumb .breadcrumb-item.active {\r\n        color: $primary;\r\n    }\r\n    .btn-outline-primary {\r\n        border: 1px solid $primary !important;\r\n        color: $primary !important;\r\n    }\r\n}\r\n [data-color=\"green\"]{\r\n    $primary: #00918E;\r\n    $secondary-100: #E6F4F4;\r\n    .btn-primary {\r\n        &:hover {\r\n            background: #005e5c !important;\r\n            border-color: #005e5c !important;\r\n        }\r\n    }\r\n   .sidebar {\r\n        .sidebar-menu {\r\n            > ul {\r\n                > li {\r\n                    ul {\r\n                        li {\r\n                            a{\r\n                                &.active{\r\n                                    color: $primary;\r\n                                    background: $secondary-100;\r\n                                     span{\r\n                                        color: $primary;\r\n                                     }\r\n                                    i {\r\n                                        background:  $primary;\r\n                                    }\r\n                                }\r\n                                &:hover {\r\n                                    color: $primary;\r\n                                    span{\r\n                                        color: $primary;\r\n                                    }\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n                    .submenu  {\r\n                        .subdrop.active {\r\n                            background: $secondary-100;\r\n                            \r\n                        }\r\n                        ul{\r\n                            li{\r\n                                a.active{\r\n                                    background: transparent;\r\n                                }\r\n                            }\r\n                        }\r\n                        > a.active{\r\n                            background: transparent;\r\n                            color: $primary;\r\n                            i {\r\n                                background:  $primary;\r\n                            }\r\n                            span{\r\n                                color: $primary;\r\n                            }\r\n                            .menu-arrow::before {\r\n                                border-right: 2px solid $primary;\r\n                                border-bottom: 2px solid $primary;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n                \r\n            }\r\n        }\r\n    }\r\n    .user-accordion-item .accordion-wrap:not(.collapsed) span{\r\n        background: $primary;\r\n    }\r\n    .page-header .btn-added{\r\n        background: $primary;\r\n    }\r\n    .settings-menu .nav li a.active {\r\n        color: $primary;\r\n        border-bottom: 4px solid $primary;\r\n    }\r\n    .toggle-popup .sidebar-layout .sidebar-header .toggle-btn:hover, \r\n    .toggle-popup1 .sidebar-layout .sidebar-header .toggle-btn:hover, \r\n    .toggle-popup2 .sidebar-layout .sidebar-header .toggle-btn:hover{\r\n        background: $primary;\r\n        border-color: $primary;\r\n    }\r\n    .todo-inbox-check .checkboxs input:checked ~ .checkmarks {\r\n        border-color: $primary;\r\n        background-color: $primary;\r\n    }\r\n    .custom-pagination .paginations .page-wrap li a.active {\r\n        background: $primary;\r\n    }\r\n    .contact-nav li a:hover, .contact-nav li a.active {\r\n        color: $primary;\r\n        border-color: $primary;\r\n    }\r\n    .dataTables_paginate .pagination li.active a.page-link, #dataTables_paginate .pagination li.active a.page-link {\r\n        background:  $primary;\r\n        border-color:  $primary;\r\n    }\r\n    .btn-primary {\r\n        background: $primary;\r\n        border: 1px solid $primary;\r\n    }\r\n    .select2-container--default .select2-results__option--selected{\r\n        background: $primary;\r\n        color: $white;\r\n    }\r\n    .view-icons a.active, \r\n    .view-icons a:hover{\r\n        background: $primary;\r\n    }\r\n    .btn.btn-primary {\r\n        background-color: $primary;\r\n        border: 1px solid $primary;\r\n    }\r\n    .form-check-input:checked {\r\n        background-color: $primary;\r\n        border-color: $primary;\r\n    }\r\n    .breadcrumb .breadcrumb-item.active {\r\n        color: $primary;\r\n    }\r\n    .btn-outline-primary {\r\n        border: 1px solid $primary !important;\r\n        color: $primary !important;\r\n    }\r\n}\r\n\r\n [data-theme=\"dark\"]{\r\n    body{\r\n        background-color:$dark;\r\n        color: $dark-text;\r\n    }\r\n    h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {\r\n        color: $white;\r\n    }\r\n    .header{\r\n        background-color:$dark;\r\n        .header-left{\r\n            background-color:$dark;\r\n            .logo{\r\n                img{\r\n                    display: none;\r\n                    &.white-logo{\r\n                        display: block;\r\n                    }\r\n                }\r\n            }\r\n            #toggle_btn{\r\n                color: $white;\r\n            }\r\n        }\r\n        .dropdown-menu{\r\n            background-color:$dark;\r\n            box-shadow: none;\r\n            a{\r\n                color: $white;\r\n            }\r\n            .topnav-dropdown-header {\r\n                border-color: $dark-border;\r\n                .notification-title{\r\n                    color: $white;\r\n                }\r\n                \r\n            }\r\n        }\r\n        .menu-drop-user .dropdown-item{\r\n            border-color: $dark-border;\r\n        }\r\n        .notification-dropdown {\r\n            .notification-list {\r\n                li {\r\n                    border-bottom: 1px solid $dark-border;\r\n                    .noti-title {\r\n                        color: $white;\r\n                    }\r\n                    .noti-details {\r\n                        color: $white;\r\n                    }\r\n                    p.noti-time {\r\n                        color: $white;\r\n                    }\r\n                    .noti-pdf {\r\n                        .noti-pdf-icon {\r\n                            span {\r\n                                border: 1px solid $dark-border;\r\n                            }\r\n                        }\r\n                        .noti-pdf-text {\r\n                            p {\r\n                                color: $white;\r\n                            }\r\n                            span {\r\n                                color: $dark-textcolor;\r\n                            }\r\n                        }\r\n                    }\r\n                    .notification-time {\r\n                        font-size: $font-size-12;\r\n                        line-height: 1.35;\r\n                        color: $gray-600;\r\n                    }\r\n                    \r\n                }\r\n            }\r\n            .topnav-dropdown-footer{\r\n                background: $dark;\r\n            }\r\n        }\r\n        .searchinputs {\r\n            input{\r\n                border-color: $dark-border;\r\n                background: transparent;\r\n            }\r\n            .search-addon button{\r\n                color: $dark-textcolor;\r\n            }\r\n        }\r\n        .menus-info {\r\n            .menu-list {\r\n                li {\r\n                    a {\r\n                        background: transparent;\r\n                        border-radius: $border-radius-lg;\r\n                        &:hover {\r\n                            background: transparent;\r\n                        }\r\n                        .menu-details {\r\n                            .menu-list-icon {\r\n                                color: $white;\r\n                            }\r\n                            .menu-details-content {\r\n                                p {\r\n                                    color: $white;\r\n                                    margin-bottom: 0;\r\n                                }\r\n                                span {\r\n                                    font-weight: $font-weight-normal;\r\n                                    color: $dark-textcolor;\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .sidebar {\r\n        background-color:$dark;\r\n        .sidebar-menu {\r\n            .clinicdropdown {\r\n                a{\r\n                    background-color:#28283E;\r\n                    .user-names h5{\r\n                        color: $white;\r\n                    }\r\n                }\r\n            }\r\n            ul{\r\n                > li {\r\n                    ul {\r\n                        li a {\r\n                            span{\r\n                                color: $dark-text;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n            .menu-arrow{\r\n               &:before{\r\n                    border-right: 2px solid $dark-text;\r\n                    border-bottom: 2px solid $dark-text;\r\n               }\r\n            }\r\n        }\r\n    }\r\n    .contact-grid.proposals-grid .grid-head .table-action .action-icon{\r\n        background: #393947;\r\n        color: $white;\r\n    }\r\n    .contact-grid.proposals-grid .grid-footer {\r\n        background: #171724;\r\n        border-color: #393947;\r\n        color: $white;\r\n    }\r\n    .title-head {\r\n        color: $white;\r\n    }\r\n    .sidebar-themesettings {\r\n        background: $dark;\r\n        .themesettings-header {\r\n            border-color: $dark-border;\r\n            h4 {\r\n                color: $white;\r\n            }\r\n        } \r\n        .themesettings-inner {\r\n            background: $dark-bg;\r\n            border-color: $dark-border;\r\n            .themesettings-content {\r\n                border-color: $dark-border;\r\n                h6 {\r\n                    color: $white;\r\n                }\r\n            }\r\n        }\r\n        .input-themeselect {\r\n            border-color: $dark-border;\r\n            background: $dark;\r\n            .checkboxs-theme:after {\r\n                border-color: $dark-border;\r\n            }\r\n        }\r\n    }\r\n    .form-check-label,\r\n    .form-label,\r\n    .sub-header{\r\n        color: $dark-text;\r\n    }\r\n    .form-select {\r\n        option{\r\n            background: transparent;\r\n        }\r\n    }\r\n    .icon-form{\r\n        .form-icon {\r\n            color: $dark-text;\r\n        }\r\n    }\r\n    .drop-down > a,\r\n    .export-dropdwon > a,\r\n    .form-sorts > a{\r\n        border-color: $dark-border;\r\n        box-shadow: none;\r\n        background-color: #1A1A25;\r\n        color: $dark-text;\r\n        &:hover{\r\n            color: $dark-text;\r\n        }\r\n    }\r\n    .manage-dropdwon {\r\n        .dropdown-menu{\r\n            border-color: $dark-border;\r\n            background-color: #1A1A25;\r\n            color: $dark-text;\r\n            box-shadow: none;\r\n        }\r\n    }\r\n    .form-sorts {\r\n        .filter-set-content {\r\n            .filter-set-content-head {\r\n                a{\r\n                    color: $dark-text;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .header-set .select2-container--default {\r\n        .select2-selection--single {\r\n            border-color: $dark-border;\r\n        }\r\n    }\r\n    .form-sorts {\r\n        .filter-dropdown-menu{\r\n            border-color: $dark-border;\r\n            background-color: #1A1A25;\r\n            color: $dark-text;\r\n            box-shadow: none;\r\n        }\r\n    }\r\n    .status-radio:checked + label, \r\n    .status-radio:not(:checked) + label{\r\n        color: $dark-text;\r\n    }\r\n    .filter-set-contents {\r\n        .filter-content-list{\r\n            border-color: $dark-border;\r\n            background-color: #1A1A25;\r\n            color: $dark-text;\r\n        }\r\n    }\r\n    .dataTables_length label .form-select,\r\n     #dataTables_length label .form-select{\r\n        border-color: $dark-border;\r\n        box-shadow: none;\r\n        background-color: #1A1A25;\r\n        color: $dark-text;\r\n    }\r\n    .view-icons{\r\n        border-color: $dark-border;\r\n    }\r\n    .toast {\r\n        background-color: #1A1A25;\r\n    }\r\n    .select2-selection--multiple{\r\n        border-color: $dark-border;\r\n        background: $dark;\r\n        box-shadow: none;\r\n        color: $dark-text;\r\n    }\r\n    .twitter-bs-wizard {\r\n        .twitter-bs-wizard-nav .step-icon{\r\n            border-color: $white;\r\n            color: $white;\r\n        }\r\n    }\r\n    .text-dark {\r\n        color: $dark-text !important;\r\n    }\r\n    .select2-container--default {\r\n        .select2-selection--single{\r\n            border-color: $dark-border;\r\n            background: $dark;\r\n            box-shadow: none;\r\n            .select2-selection__rendered{\r\n                box-shadow: none;\r\n                border:1px solid $dark-border;\r\n                background: $dark;\r\n                color: $dark-text;\r\n            }\r\n            .select2-selection__arrow{\r\n                box-shadow: none;\r\n            }\r\n        }\r\n    }\r\n    .toggle-popup .sidebar-layout, \r\n    .toggle-popup1 .sidebar-layout, \r\n    .toggle-popup2 .sidebar-layout{\r\n        border-color: $dark-border;\r\n        background: $dark;\r\n    }\r\n    .user-accordion-item {\r\n        .accordion-wrap{\r\n            color: $dark-text;\r\n            &:hover {\r\n                color: $dark-text;\r\n            }\r\n        }\r\n        .content-collapse {\r\n            border-color: $dark-border;\r\n        }\r\n    }\r\n    .bootstrap-tagsinput{\r\n        background: $dark;\r\n        border-color: $dark-border;\r\n    }\r\n    .user-accordion-item,\r\n    .files-wrap,\r\n    .contact-wrap,\r\n    .notes-activity .note-download,\r\n    .contact-tab-wrap,\r\n    .contact-tab-view,\r\n    .calls-box,\r\n    .notes-activity .reply-box ,\r\n    .note-download\r\n    {\r\n        border-color: $dark-border;\r\n        background: $dark;\r\n        box-shadow: none;\r\n    }\r\n    .contact-sidebar, .contact-tab-view {\r\n        background-color: $dark-bg;\r\n        box-shadow: none;\r\n    }\r\n    .action-drop{\r\n        .dropdown-toggle{\r\n            border-color: $dark-border;\r\n            color: $dark-text;\r\n        }\r\n    }\r\n    .upcoming-info{\r\n        border-color: $dark-border;\r\n    }\r\n    .calls-box {\r\n        .caller-info {\r\n            .calls-user p span {\r\n                color: $dark-text;\r\n                font-weight: 500;\r\n            }\r\n            .calls-action .dropdown-toggle{\r\n                color: $dark-text;\r\n                border-color: $dark-border;\r\n            }\r\n        }\r\n    }\r\n    .bootstrap-tagsinput{\r\n        box-shadow: none;\r\n    }\r\n    .contact-grid {\r\n        color: $dark-text;\r\n        border-color: $dark-border;\r\n        background: $dark;\r\n        box-shadow: none;\r\n        .grid-head {\r\n            .users-profile {\r\n                .name-user {\r\n                    h6 {\r\n                        a{\r\n                            color: $white;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n        .grid-body{\r\n            .address-info{\r\n                p{\r\n                    i{\r\n                        color: $dark-text; \r\n                    }\r\n                }\r\n            }\r\n        }\r\n        .grid-footer{\r\n            border-color: $dark-border; \r\n        }\r\n    }\r\n    .company-info li span{\r\n        border-color: $dark-border; \r\n    }\r\n    .contacts-action{\r\n        .btn-icon,.btn-icon.rating{\r\n            color: $dark-text;\r\n            border-color: $dark-border;\r\n            background: $dark;\r\n        }\r\n        .act-dropdown > a{\r\n            color: $dark-text;\r\n            border-color: $dark-border;\r\n            background: $dark;\r\n        }\r\n    }\r\n    .social-info li a{\r\n        color: $dark-text;\r\n        border-color: $dark-border;\r\n        background: $dark; \r\n    }\r\n    .view-header {\r\n        .form-sort{\r\n            .select2-container {\r\n                .select2-selection {\r\n                    .select2-selection__rendered{\r\n                        color: $dark-text; \r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .basic-info li span{\r\n        color: $dark-text;\r\n        border-color: $dark-border;\r\n        background: $dark; \r\n    }\r\n    .badge-day{\r\n        color: $dark-text;\r\n        background: #3d3d64; \r\n    }\r\n    .contact-nav li a {\r\n        border-color: transparent;\r\n    }\r\n    .upcoming-info .dropdown .dropdown-toggle{\r\n        color: $dark-text;\r\n    }\r\n    .contact-sidebar ul,.view-header,.activity-wrap{\r\n        border-color: $dark-border;\r\n    }\r\n    .search-section{\r\n        border-color: $dark-border;\r\n    }\r\n    .select2-container--default .select2-results__option--selected{\r\n        background: $primary;\r\n        color: $white;\r\n    }\r\n    .form-floating > .form-control:not(:placeholder-shown) ~ label::after{\r\n        background: transparent;\r\n    }\r\n    .select2-dropdown{\r\n        border-color: $dark-border;\r\n        background: $dark;\r\n       \r\n        ul{\r\n            li{\r\n                color: $white;\r\n            }\r\n        }\r\n    }\r\n    .btn-outline-light{\r\n        color: $dark-text !important;\r\n    }\r\n    .page-wrapper {\r\n        background: #151525;\r\n        .page-header{\r\n            h3{\r\n                color: $white;\r\n            }\r\n            h4{\r\n                color: $white;\r\n            }\r\n            .head-icons a{\r\n                border-color: $dark-border;\r\n                background: transparent;\r\n                color: $white;\r\n            }\r\n        }\r\n        .page-title{\r\n            color: $white;\r\n        }\r\n    }\r\n    .note-editable.card-block{\r\n        color: $white;\r\n    }\r\n    .accordion-item{\r\n        border-color: $dark-border;\r\n        background: $dark;\r\n        .accordion-body{\r\n            border-color: $dark-border;\r\n            background: #28283E;\r\n        }\r\n    }\r\n    .accordion-button{\r\n        border-color: $dark-border;\r\n        background: #28283E;\r\n    }\r\n    .seprator-lg {\r\n        border-color: $dark-border;\r\n    }\r\n    .card{\r\n        background: $dark-bg;\r\n        box-shadow: none;\r\n        &.bg-white {\r\n            background: $dark-bg !important;\r\n        }\r\n        &.main-card{\r\n            background: #28283E;\r\n            box-shadow: none;\r\n        }\r\n        &.custom-card{\r\n            background: #28283E;\r\n            .card-header{\r\n                border-color: $dark-border;\r\n            }\r\n            .card-footer{\r\n                border-color: $dark-border;\r\n            }\r\n        }\r\n        .card-header {\r\n            border-color: $dark-border;\r\n            .card-title{\r\n                color: $white;\r\n            }\r\n            .card-text{\r\n                color: $dark-text;\r\n            }\r\n        }\r\n        .card-body{\r\n            color: $dark-text;\r\n        }\r\n    }\r\n    .col-form-label{\r\n        color: $dark-text;\r\n    }\r\n    .custom-table{\r\n        .table-responsive{\r\n            border-color: $dark-border;\r\n        }\r\n    }\r\n    .btn-purple-light{\r\n        background:$dark;\r\n        border-color: $dark-border;\r\n        color: $dark-text;\r\n        &:hover{\r\n            background:$dark;\r\n            border-color: $dark-border;\r\n            color: $dark-text;\r\n        }\r\n    }\r\n    .note-toolbar{\r\n        background:$dark;\r\n    }\r\n    .note-btn-group .note-btn{\r\n        background:$dark;\r\n        border-color: $dark-border;\r\n        color: $dark-text;\r\n    }\r\n    .note-toolbar{\r\n        border-color: $dark-border;\r\n    }\r\n    .table-action {\r\n        .action-icon{\r\n            background:$dark;\r\n            border-color: $dark-border;\r\n            color: $white;\r\n            &:hover {\r\n                    background: $dark-input;\r\n                    color: $white;\r\n                    i {\r\n                        color: $white;\r\n                    }\r\n                }\r\n        }\r\n    }\r\n    .toggle-popup {\r\n        .sidebar-layout .sidebar-header{\r\n            border-color: $dark;\r\n        }\r\n    }\r\n    table{\r\n        \r\n        &.table{\r\n            &.table-primary{\r\n                background:$dark;\r\n            }\r\n             thead  {\r\n                border-color: $dark-border;\r\n                 tr {\r\n                    border-color: $dark-border;\r\n                    th{\r\n                        background: $dark;\r\n                        color: $white;\r\n                        border-color: $dark-border;\r\n                    }\r\n                }\r\n            }\r\n            tbody{\r\n                tr{\r\n                    td{\r\n                        background:$dark;\r\n                        color: $dark-textcolor;\r\n                        border-color: $dark-border;\r\n                    }\r\n                }\r\n            }\r\n            &.dataTable {\r\n                border-color: $dark-border;\r\n                > thead  {\r\n                    border-color: $dark-border;\r\n                    >  tr {\r\n                        border-color: $dark-border;\r\n                        th{\r\n                            background: $dark;\r\n                            color: $white;\r\n                            border-color: $dark-border;\r\n                        }\r\n                    }\r\n                }\r\n                tbody{\r\n                    tr{\r\n                        td{\r\n                            background:$dark;\r\n                            color: $dark-textcolor;\r\n                            border-color: $dark-border;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .statistic-header {\r\n        h4{\r\n            i{\r\n                color:#B5B5B5;\r\n            }\r\n            color: $white;\r\n        }\r\n        .statistic-dropdown {\r\n            .dropdown-toggle {\r\n                color: $white;\r\n                border: 1px solid #1A1A25;\r\n                box-shadow: none;\r\n                background:  #1A1A25;\r\n                &:after{\r\n                    border-bottom: 2px solid #B5B5B5;\r\n                    border-right: 2px solid #B5B5B5;\r\n                }\r\n            }\r\n            .dropdown-menu{\r\n                border-color: $dark-border;\r\n                background: $dark;\r\n                a{\r\n                    background: transparent;\r\n                    color: $white;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .toggle-popup .sidebar-layout .sidebar-header, \r\n    .toggle-popup1 .sidebar-layout .sidebar-header, \r\n    .toggle-popup2 .sidebar-layout .sidebar-header {\r\n        border-color:$dark-border;\r\n    }\r\n    .form-control,.form-select{\r\n        border-color:$dark-border;\r\n        background: $dark;\r\n        color: $dark-text;\r\n        box-shadow: none; \r\n        &:disabled{\r\n            border-color:$dark-border;\r\n            background: $dark;\r\n            color: $dark-text;\r\n        }\r\n        &:focus{\r\n            border-color:$dark-border;\r\n            background: $dark;\r\n            color: $dark-text;\r\n        }\r\n    }\r\n    .input-group-text{\r\n        background:$dark-border;\r\n        color: $dark-text;\r\n        border-color:$dark-border;\r\n    }\r\n    .radio,.checkbox{\r\n        label{\r\n            color: $dark-text;\r\n        }\r\n    }\r\n    .apexcharts-text tspan{\r\n        fill: $white;\r\n    }\r\n    a {\r\n        color: $white;\r\n        &.label-add {\r\n            color: $primary;\r\n        }\r\n    }\r\n    .settings-sub-header {\r\n        border-color: $dark-border;\r\n    }\r\n    .profile-details {\r\n        border-color: $dark-border;\r\n    }\r\n    .profile-upload .profile-upload-img {\r\n        border-color: $dark-border; \r\n    }\r\n    .settings-sidebar {\r\n        ul {\r\n            li {\r\n                a {\r\n                    color: $dark-textcolor;\r\n                    &:hover {\r\n                        color: $white;\r\n                    }\r\n                    &.active {\r\n                        background: $darkmode-hover;    \r\n                        color: $white;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .btn {\r\n        &.btn-light {\r\n            background-color: $dark-input;\r\n            border-color: $dark-border;\r\n            color: $white;\r\n            &:hover {\r\n                background-color: $dark-hover;\r\n                border-color: $dark-border;\r\n                color: $white;\r\n            }\r\n            \r\n        }       \r\n    }\r\n    .security-grid {\r\n        border-color: $dark-border;\r\n        background: $dark-bg;\r\n        .security-heading {\r\n            h5 {\r\n                color: $white;\r\n            }\r\n        }\r\n    }\r\n    .notification-wrap {\r\n        ul {\r\n            li {\r\n                .security-checkbox {\r\n                    .checkboxs {\r\n                        color: $white;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .notificaion-table .table {\r\n         tbody {\r\n            tr {\r\n                td { \r\n                    color: $white;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .integration-grid {\r\n        background: $gray-bg;\r\n        border-color: $gray-bg;\r\n        .integration-content { \r\n            p {\r\n                color: $white;\r\n            }\r\n        }\r\n    }\r\n    .storage-wrap {\r\n        background: $gray-bg;\r\n        border-color: $dark-border;\r\n        .storage-icon {\r\n            h6 {\r\n                color: $white;\r\n            }\r\n        }\r\n    }\r\n    .black-text {\r\n        color: $white !important;\r\n    }\r\n    .theme-type-images {\r\n        .theme-image {\r\n            background: $dark;  \r\n            border-color: $dark-border;\r\n            span {\r\n                color: $white;\r\n            }\r\n        }\r\n    }\r\n    .table tbody tr td a {\r\n        color: $white;\r\n    }\r\n    .text-black {\r\n        color: $white !important;\r\n    }\r\n    .lang-flag {\r\n        a {\r\n            border-color: $dark-border;\r\n            color: $white;\r\n        }\r\n    }\r\n    .modal {\r\n        .modal-content {\r\n            background: $dark-bg;\r\n            border-color: $dark-border;\r\n            .modal-header {\r\n                 border-color: $dark-border;\r\n            }\r\n            .col-form-label {\r\n                color: $white;\r\n            }\r\n        }\r\n    }\r\n    .drag-attach {\r\n        border-color: $dark-border;\r\n    }\r\n    .upload-file {\r\n        border-color: $dark-border;\r\n        background: $dark;  \r\n    }\r\n    .lang-type li {\r\n        a {\r\n            background: $dark;  \r\n        }\r\n    }\r\n    .dropdown-menu {\r\n        background: $dark-bg;\r\n        border-color: $dark-border;\r\n    }\r\n    .table-action .dropdown-menu {\r\n        a {\r\n            color: $dark-textcolor;\r\n            &:hover {\r\n                background: $darkmode-hover;\r\n                color: $white;\r\n            }\r\n        }\r\n    }\r\n    .btn-add {\r\n        background: $dark-input;\r\n        border-color: $dark-border;\r\n        color: $white;\r\n    }\r\n    .settings-sub-header.setting-item {\r\n        .table-action {\r\n            .action-icon {\r\n                background: $dark-input;\r\n                border-color: $dark-border;\r\n                &:hover {\r\n                    background: $dark-input;\r\n                    color: $white;\r\n                    i {\r\n                        color: $white;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .mail-wrapper {\r\n        background: $gray-bg;\r\n        border-color: $dark-border;\r\n        .mail-wrap {\r\n            .email-action .info-icon {\r\n                &:hover {\r\n                    color: $white;\r\n                }\r\n                &::after {\r\n                    background: $dark-border;\r\n                }\r\n            }\r\n        }\r\n        .mail-collapse {\r\n             border-color: $dark-border;\r\n         }\r\n    }\r\n    .bank-box {\r\n        background: $gray-bg;\r\n        border-color: $dark-border;\r\n        &.active {\r\n            &::after {\r\n                background-color: $gray-bg;\r\n            }\r\n        }\r\n        .table-action {\r\n            .action-icon {\r\n                &:hover {\r\n                    background: $dark-input;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .custom-modal {\r\n        .modal-header {\r\n            .btn-close {\r\n                border-color: $dark-border;\r\n                background: $dark-input;\r\n                box-shadow: none;\r\n            }\r\n        }\r\n    }\r\n    .storage-wrap {\r\n        .storage-icon {\r\n            .system-app-icon {\r\n                background: $dark-bg;\r\n                border-color: $dark-border;\r\n            }\r\n        }\r\n        .setting-gateway {\r\n            a {\r\n                color: $dark-textcolor;\r\n            }\r\n        }\r\n    }\r\n    .ip-wrap {\r\n        background: $gray-bg;\r\n        border-color: $dark-border;\r\n        .table-action {\r\n            .action-icon {\r\n                 background: $gray-bg;\r\n                 border-color: $dark-border;\r\n                 &:hover {\r\n                    background: $gray-bg;\r\n                    border-color: $dark-border;\r\n                 }\r\n            }\r\n        }\r\n    }\r\n    .action-drop {\r\n        .dropdown-item {\r\n            color: $dark-textcolor;\r\n            &:hover {\r\n                background: $gray-bg;\r\n                color: $white;\r\n            }\r\n        }\r\n    }\r\n    .notes-activity .note-download {\r\n        &:hover {\r\n            background-color: transparent;\r\n            a {\r\n                background: $darkmode-hover;\r\n                color: $dark-textcolor;\r\n            }\r\n        }\r\n        a {\r\n            background: $darkmode-hover;\r\n            color: $dark-textcolor;\r\n        }\r\n    }\r\n    .calls-box .caller-info .calls-action .dropdown-menu {\r\n        border-color: $dark-border;\r\n        .dropdown-item {\r\n             &:hover {\r\n                background: $gray-bg;\r\n                color: $white;\r\n            }\r\n        }\r\n    }\r\n    .bootstrap-tagsinput .tag {\r\n        background: $darkmode-hover;\r\n    }\r\n    .contacts-action .act-dropdown .dropdown-item {\r\n        color: $dark-textcolor;\r\n         &:hover {\r\n            background: $gray-bg;\r\n            color: $white;\r\n        }\r\n    }\r\n    .profile-pic-upload .profile-pic {\r\n        border-color: $dark-border;\r\n    }\r\n    .contact-wrap .contact-profile {\r\n        .avatar.company-avatar {\r\n            border-color: $dark-border;\r\n        }\r\n\r\n    }\r\n    .select2-container--default.select2-container--focus .select2-selection--multiple,\r\n    .select2-container--default .select2-selection--multiple {\r\n        border-color: $dark-border;\r\n    }\r\n    .select2-container--classic .select2-selection--multiple .select2-selection__choice, \r\n    .select2-container--default .select2-selection--multiple .select2-selection__choice, \r\n    .select2-container--default .select2-selection--multiple .select2-selection__choice__remove {\r\n        background: $darkmode-hover;\r\n        border-color: $dark-border;\r\n    }\r\n    .title-name {\r\n        color: $white !important;\r\n    }\r\n    .kanban-list-items {\r\n        border-color: $dark-border;\r\n        .kanban-list-head {\r\n            background: $gray-bg;\r\n            .kanban-action-btns .table-action .action-icon {\r\n                background: $gray-bg;\r\n                border-color: $dark-border;\r\n            }\r\n\r\n        }\r\n    }\r\n    .email-header .btn-white {\r\n        border-color: $dark-border;\r\n        color: $white;\r\n    }\r\n    .pipeline-list {\r\n        border-color: $dark-border;\r\n    }\r\n    .priority-info .dropdown .dropdown-toggle {\r\n        border-color: $dark-border;\r\n        color: $dark-textcolor;\r\n    }\r\n    .priority-info .dropdown a {\r\n        color: $dark-textcolor;\r\n    }\r\n    .pipeline-item {\r\n        border-color: $dark-border;\r\n        p {\r\n            color: $white;\r\n        }\r\n    }\r\n    .kanban-card {\r\n        background: $gray-bg;\r\n        border-color: $dark-border;\r\n        .kanban-card-body ul li {\r\n            color: $dark-textcolor;\r\n        }\r\n        .kanban-card-footer {\r\n            border-color: $dark-border;\r\n            span {\r\n                border-color: $dark-border;\r\n            }\r\n        }\r\n    }\r\n    .campaign-tab {\r\n        background: $gray-bg;\r\n        ul {\r\n            li {\r\n                a {\r\n                    border-color: transparent;\r\n                    &.active {\r\n                        color: $primary;\r\n                    }\r\n                    span {\r\n                         border-color: $dark-border;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    ul.project-mem li.more-set a {\r\n        background: $gray-bg;\r\n        border-color: $dark-border;\r\n        color: $dark-textcolor;\r\n    }\r\n    .pipeline-progress span, .task-info p,\r\n    .con-sidebar-title p, .task-actions ul li {\r\n        color: $white;\r\n    }\r\n    .contact-grid.project {\r\n        .grid-head {\r\n            background-color: $gray-bg;\r\n            .users-profile .con-avatar {\r\n                background-color: $dark-bg;\r\n                border-color: $dark-border;\r\n            }\r\n        }\r\n    }\r\n    .access-wrap li:hover {\r\n        background: $gray-bg;\r\n    }\r\n    .task-wrap {\r\n        background: $gray-bg;\r\n        border-color: $dark-border;\r\n    }\r\n    .rate-icon, .con-sidebar-title.border-line {\r\n        border-color: $dark-border;\r\n    }\r\n    .pipeline-list ul li a.bg-gray {\r\n        color: $title-color;\r\n    }\r\n    .task-wrapper .task-accordion span {\r\n        border-color: $dark-border;\r\n        color: $dark-textcolor;\r\n    }\r\n    .task-drops .dropdown-toggle {\r\n        background-color: transparent;\r\n    }\r\n    .task-wrapper {\r\n        border-color: $dark-border;\r\n    }\r\n    .card.analytics-card {\r\n        background-color: $dark-bg;\r\n        .card-header {\r\n            background: transparent;\r\n            .select2-container--default .select2-selection--single {\r\n                .select2-selection__rendered {\r\n                    color: $white;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .activities-list ul li {\r\n        background: $gray-bg;\r\n        .activity-name h5 {\r\n            color: $white;\r\n        }\r\n    }\r\n    .campaign-card ul .campaign-wrap {\r\n        background: $gray-bg;\r\n        .campaign-info {\r\n            border-color: $dark-border;\r\n            h5 {\r\n                color: $white;\r\n            } \r\n        }\r\n    }\r\n    .card.analytics-card .card-body .table {\r\n        th {\r\n            background: $dark;\r\n            color: $white;\r\n            &:first-child,&:last-child {\r\n                border-color: $dark-border;\r\n            }\r\n        }\r\n        td {\r\n            &:first-child, &:last-child  {\r\n                border-color: $dark-border;\r\n            }\r\n        }\r\n    }\r\n    .active-list ul li {\r\n        a {\r\n            background: $dark-input;\r\n            border-color: $dark-border;\r\n            color: $white;\r\n        }\r\n    }\r\n    .activity-title h4::after {\r\n        background: $dark-border;\r\n    }\r\n    .header-set {\r\n        border-color: $dark-border;\r\n        .select2-container--default .select2-selection--single .select2-selection__rendered {\r\n            color: $white;\r\n        }\r\n    }\r\n    .radio-activity li .active-type input[type=radio] ~ label {\r\n        background: $dark-input;\r\n        border-color: $dark-border;\r\n        color: $white;\r\n    }\r\n    .tab-activity {\r\n        box-shadow: none;\r\n        ul li a span {\r\n            color: $dark-textcolor;\r\n            border-color: $dark-border;\r\n        }\r\n    }\r\n    .report-header {\r\n        border-color: $dark-border;\r\n    }\r\n    .location-flag-img {\r\n        border-color: $dark-border;        \r\n    }\r\n    .table-imgname.flag-image {\r\n        span {\r\n            color: $white;\r\n        }\r\n    }\r\n    .membership-plans .plan-selected h4 {\r\n        color: $white;\r\n    }\r\n    .membership-plan-grid {\r\n        background-color: $gray-bg;\r\n        border-color: $dark-border;\r\n        .plan-price-head {\r\n            border-color: $dark-border;\r\n            .plan-type {\r\n                color: $white;\r\n            }\r\n        }\r\n        .plans-features ul li {\r\n            color: $white;\r\n        }\r\n        &.active {\r\n            background-color: $dark-bg;\r\n            .plan-price-head {\r\n                border-color: $dark-border;\r\n                .plan-type {\r\n                    color: $white;\r\n                }\r\n            }\r\n            .plans-features ul li {\r\n                color: $white;\r\n            }\r\n        }\r\n    }\r\n    .file-manager aside {\r\n        border-color: $dark-border;\r\n    }\r\n    .notes-dash {\r\n        background-color: $gray-bg;\r\n        .notes-top-head {\r\n            border-color: $dark-border;\r\n        }\r\n        .notes-top-head-submenu {\r\n            border-color: $dark-border;\r\n        }\r\n    }\r\n    .notes-page-wrapper .content .section-card-body .notes-card-details {\r\n        background-color: $gray-bg;\r\n        border-color: $dark-border;\r\n        box-shadow: none;\r\n    }\r\n    .search-set .search-input input[type=search] {\r\n        background-color: $gray-bg;\r\n        border-color: $dark-border;\r\n        &::placeholder {\r\n            color: $dark-textcolor;\r\n        }\r\n    }\r\n    .todo-wrapper-list {\r\n        background-color: $gray-bg;\r\n        border-color: $dark-border;\r\n    }\r\n    .notes-page-wrapper .content {\r\n        .section-bulk-wrap {\r\n            background-color: $gray-bg;\r\n            box-shadow: none;\r\n        }\r\n        .page-add-notes {\r\n            border-color: $dark-border;\r\n        }\r\n        .section-notes-slider {\r\n            border-color: $dark-border;\r\n        }\r\n    }\r\n    .fc-day {\r\n        background-color: $gray-bg;\r\n    }\r\n    .file-manager .folders {\r\n        border-color: $dark-border;\r\n        background-color: $gray-bg;\r\n    }\r\n    .file-manager .accordion .accordion-item .accordion-body {\r\n        background: transparent;\r\n    }\r\n    table tbody td.action-table-data a {\r\n        background-color: $gray-bg;\r\n    }\r\n    .main-chat-blk .chat {\r\n        background-color: $gray-bg;\r\n    }\r\n    .main-chat-blk .chat .chat-header {\r\n        background-color: $gray-bg;\r\n        border-color: $dark-border;\r\n        box-shadow: none;\r\n    }\r\n    .main-chat-blk .main-wrapper .content .sidebar-group .sidebar {\r\n        background-color: $gray-bg;\r\n    }\r\n    .main-chat-blk .chat-page-wrapper .left-chat-title {\r\n        background-color: $gray-bg;\r\n        border-color: $dark-border;\r\n    }\r\n    .main-chat-blk .chat .chat-header .user-details h5 {\r\n        color: $white;\r\n    }\r\n    .main-chat-blk .sidebar .user-list li .users-list-body {\r\n        h5 {\r\n            color: $white;\r\n        }\r\n        p {\r\n            color: $dark-textcolor;\r\n        }\r\n    }\r\n    .main-chat-blk .chat-page-wrapper .setting-title-head h4 {\r\n        color: $white;\r\n    }\r\n    .main-chat-blk .sidebar .user-list li .users-list-body .last-chat-time .text-muted {\r\n        color: $dark-textcolor !important;\r\n    }\r\n    .main-chat-blk .chat .chat-body .messages .chat-profile-name h6 {\r\n        color: $white;\r\n    }\r\n    .main-chat-blk .sidebar .user-list li a {\r\n        border-color: $dark-border;\r\n    }\r\n    .main-chat-blk .last-seen {\r\n         color: $dark-textcolor;\r\n    }\r\n    .daterangepicker {\r\n        background-color: $gray-bg;\r\n        border-color: $dark-border;\r\n        &.show-ranges.ltr .drp-calendar.left {\r\n            border-color: $dark-border;\r\n        }\r\n        .drp-buttons {\r\n            border-color: $dark-border;\r\n            .btn-default {\r\n                color: $dark-textcolor;\r\n            }\r\n        }\r\n    } \r\n}\r\n\r\n[data-sidebar=\"sidebarbg1\"]{\r\n    .sidebar {\r\n        background-image: url(../../../../public/assets/img/theme/bg-1.png);\r\n        background-repeat: no-repeat;\r\n        background-size: cover;\r\n        background-position: 50% 50%;\r\n        background-color: transparent;\r\n        .sidebar-menu{\r\n            background: rgba(255,255,255,0.85);\r\n        }\r\n    }\r\n}\r\n\r\n[data-sidebar=\"sidebarbg2\"]{\r\n    .sidebar {\r\n        background-image: url(../../../../public/assets/img/theme/bg-2.png);\r\n        background-repeat: no-repeat;\r\n        background-size: cover;\r\n        background-position: 50% 50%;\r\n        background-color: transparent;\r\n        .sidebar-menu{\r\n            background: rgba(255,255,255,0.85);\r\n        }\r\n    }\r\n}\r\n\r\n[data-sidebar=\"sidebarbg3\"]{\r\n    .sidebar {\r\n        background-image: url(../../../../public/assets/img/theme/bg-3.png);\r\n        background-repeat: no-repeat;\r\n        background-size: cover;\r\n        background-position: 50% 50%;\r\n        background-color: transparent;\r\n        .sidebar-menu{\r\n            background: rgba(255,255,255,0.85);\r\n        }\r\n    }\r\n}\r\n\r\n[data-sidebar=\"sidebarbg4\"]{\r\n    .sidebar {\r\n        background-image: url(../../../../public/assets/img/theme/bg-4.png);\r\n        background-repeat: no-repeat;\r\n        background-size: cover;\r\n        background-position: 50% 50%;\r\n        background-color: transparent;\r\n        .sidebar-menu{\r\n            background: rgba(255,255,255,0.85);\r\n        }\r\n    }\r\n}\r\n[data-theme=\"dark\"]{\r\n    .border,.border-top,.border-bottom,.border-start,.border-end {\r\n        border-color: $dark-border !important;\r\n    }\r\n    .dropdown .dropdown-toggle {\r\n        border-color: $dark-border;\r\n        color: $dark-textcolor;\r\n    }\r\n    .dropdown .dropdown-menu {\r\n        background: $dark;\r\n        border-color: $dark-border;\r\n    }\r\n    .bg-white {\r\n        background: $dark !important;\r\n    }\r\n    .bg-light-200,.bg-light-300,.bg-light-400 {\r\n        background: $dark-input;\r\n    }\r\n    .dropdown .dropdown-menu .dropdown-item {\r\n        background: $dark-input;\r\n    }\r\n    .offcanvas {\r\n        background: $dark;\r\n    }\r\n    .accordion-button:after {\r\n        background: transparent;\r\n    }\r\n    .bg-success.border {\r\n        border-color: $success !important;\r\n    }\r\n    .bg-purple.border {\r\n        border-color: $purple !important;\r\n    }\r\n    .bg-warning.border {\r\n        border-color: $warning !important;\r\n    }\r\n    .bg-danger.border {\r\n        border-color: $danger !important;\r\n    }\r\n    .btn-close {\r\n        --bs-btn-close-color: $dark-text;\r\n        color: $white;\r\n    }\r\n    .input-themeselect{\r\n        span{\r\n            color: $white;\r\n        }\r\n    }\r\n}\r\n \r\n",".sidebar-contact {\r\n    position: fixed;\r\n    top: 0%;\r\n    right: -350px;\r\n     transform: translateY(-50%); \r\n    width: 350px;\r\n    height: auto;\r\n    background: #fff;\r\n    box-sizing: border-box;\r\n    transition: 0.5s;\r\n    z-index: 9999;\r\n    .toggle-theme {\r\n        position: absolute;\r\n        width: 35px;\r\n        text-align: center;\r\n        cursor: pointer;\r\n        background: #fed713;\r\n        top: 225px;\r\n        right: 350px;\r\n        padding: 6px;\r\n        height: 35px;\r\n        color: #000;\r\n        border-top-left-radius: 3px;\r\n        border-bottom-left-radius: 3px;\r\n        .fa-spin {\r\n            -webkit-animation: fa-spin 2s infinite linear;\r\n            animation: fa-spin 2s infinite linear;\r\n        }\r\n    }\r\n    \r\n}      \r\n#theme-settings{\r\n    width: 26px;\r\n    height: 26px;\r\n    border: 1px solid $light-900;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 50px;\r\n} \r\n.input-themeselect label {\r\n    width: 100%;\r\n}                                                                \r\n.sidebar-themesettings{\r\n    position: fixed;\r\n    right: -380px;\r\n    top: 0;\r\n    background: #fff;\r\n    transition: all 0.5s;\r\n    width: 380px;\r\n    height: 100vh;\r\n    z-index: 99999;\r\n    padding: 15px;\r\n    overflow: auto;\r\n    max-width: 100%;\r\n    &.open{\r\n        right: 0; \r\n    }\r\n    .themesettings-header{\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n        padding-bottom: 20px;\r\n        border-bottom: 1px solid $light-900;\r\n        h4{\r\n            color: $gray-900;\r\n            font-size: 18px;\r\n        }\r\n    }\r\n    .themesettings-inner{\r\n        padding: 24px;\r\n        background: #fff;\r\n        border: 1px solid $light-900;\r\n        border-radius: 5px;\r\n        margin-top: 15px;\r\n        padding-bottom: 9px;\r\n        .themesettings-content{\r\n            border-bottom: 1px solid $light-900;\r\n            margin-bottom: 15px;\r\n            h6{\r\n                font-size: 14px;\r\n                font-weight: 600;\r\n                color: #000; \r\n                margin-bottom: 15px;\r\n            }\r\n        }\r\n    }\r\n    .input-themeselect{\r\n        background: $light-500;\r\n        padding: 10px;\r\n        border-radius: 10px;\r\n        border:1px solid $light-900;\r\n        margin-bottom: 15px;\r\n        input[type=\"radio\"]{\r\n            display: none;\r\n            &:checked{\r\n                ~ label{\r\n                    .checkboxs-theme{\r\n                        &:after{\r\n                            background-color: $purple;\r\n                            border-color: $purple;\r\n                            content: \"\";\r\n                        }\r\n                        &::before{\r\n                            content: \"\\f00c\";\r\n                            font-family: \"Font Awesome 5 Free\";\r\n                            color: #fff;\r\n                            font-weight: 700;\r\n                            font-size: 10px;\r\n                            right: 4px;\r\n                            position: absolute;\r\n                            top: -14px;\r\n                            z-index: 9;\r\n                        }\r\n                    } \r\n                }\r\n            }\r\n        }\r\n        img{\r\n            height: 80px;\r\n        }\r\n        .checkboxs-theme{\r\n            position: relative;\r\n            width: 100%;\r\n            display: block;\r\n            &:after{\r\n                position: absolute;\r\n                content: \"\";\r\n                border: 1px solid #E8E8E8;\r\n                width: 16px;\r\n                height: 16px;\r\n                border-radius: 5px;\r\n                right: 0;\r\n                top: -17px;\r\n            }\r\n        }\r\n    }\r\n}\r\n.sidebar-themeoverlay{\r\n    position: fixed;\r\n    width: 100%;\r\n    height: 100vh;\r\n    background: rgba(0,0,0,0.75);\r\n    top: 0;\r\n    left: -100%;\r\n    z-index: 10000;\r\n    &.open{\r\n        left: 0;\r\n    }\r\n}\r\n.theme-colorsset{\r\n    margin: 15px 0;\r\n    ul{\r\n        display: flex;\r\n        align-items: center;\r\n        li{\r\n            .input-themeselects{\r\n                label{\r\n                    width: 30px;\r\n                    height: 30px;\r\n                    border-radius: 2px;\r\n                    position: relative;\r\n                    &.red-clr{\r\n                        background: $primary;\r\n                    }\r\n                    &.yellow-clr{\r\n                        background: $secondary;\r\n                    }\r\n                    &.blue-clr{\r\n                        background: #3C2371;\r\n                    }\r\n                    &.green-clr{\r\n                        background: #00918E;\r\n                    }\r\n                }\r\n                input[type=\"radio\"]{\r\n                    display: none;\r\n                    &:checked{\r\n                        ~ label{\r\n                            &:after{\r\n                                content: \"\\f00c\";\r\n                                font-family: \"Font Awesome 5 Free\";\r\n                                color: #fff;\r\n                                font-weight: 700;\r\n                                font-size: 12px;\r\n                                display: flex;\r\n                                align-items: center;\r\n                                justify-content: center;\r\n                                top: 50%;\r\n                                left: 50%;\r\n                                transform: translate(-50%,-50%);\r\n                                position: absolute;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n            + li{\r\n                margin-left: 10px;\r\n            }\r\n        }\r\n    }\r\n}\r\n.themesettings-footer{\r\n    margin-top: 15px;\r\n    ul{\r\n        display: flex;\r\n        align-items: center;\r\n        li{\r\n            width: 50%;\r\n            + li{\r\n                margin-left: 10px;\r\n            }\r\n            .btn{\r\n                width: 100%;\r\n                font-size: 14px;\r\n                font-weight: 600;\r\n                padding: 8px;\r\n            }\r\n            .btn-cancel{\r\n                background: $light-500;\r\n                border: 1px solid $light-900;\r\n                color: $gray-900;\r\n                &:hover {\r\n                    background: $light-900;\r\n                }\r\n            }\r\n            .btn-reset{\r\n                background: $green;\r\n                color: #fff;\r\n                &:hover {\r\n                    background: #005e5c;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}",".topnav-dropdown-header {\r\n    @include margin-padding(null, 15px);\r\n    border-bottom: 1px solid $light-900;\r\n    .notification-title {\r\n        font-size: $font-size-18;\r\n        font-weight: $font-weight-semibold;\r\n        color: $black;\r\n        margin-bottom: 0;\r\n    }\r\n}\r\n.notification-dropdown {\r\n    .noti-content {\r\n        width: 440px;\r\n        height: 390px;\r\n        overflow-y: auto;\r\n        position: relative;\r\n    }\r\n    .notification-list {\r\n        list-style: none;\r\n        padding: 0;\r\n        margin: 0;\r\n        li {\r\n            margin-top: 0;\r\n            border-bottom: 1px solid $light-600;\r\n            font-size: $font-size-base;\r\n            &:last-child {\r\n                border-bottom: 0;\r\n            }\r\n            a {\r\n                display: block;\r\n                @include margin-padding(null, 15px);\r\n            }\r\n            .avatar {\r\n                width: 36px;\r\n                height: 36px;\r\n                margin: 0 16px 0 0;\r\n                border-radius: $border-radius-lg;\r\n                position: relative;\r\n                img {\r\n                    border-radius: $border-radius-lg;\r\n                }\r\n                .badge {\r\n                    display: inline-block;\r\n                    position: absolute;\r\n                    top: -7px;\r\n                    left: -7px;\r\n                    padding: 4px;\r\n                }\r\n            }\r\n            .noti-title {\r\n                color: $gray-800;\r\n                font-weight: $font-weight-medium;\r\n            }\r\n            .noti-details {\r\n                font-weight: $font-weight-medium;\r\n                color: $gray-400;\r\n                @include margin-padding(0 0 8px, null);\r\n            }\r\n            .noti-sub-details {\r\n                -webkit-line-clamp: 2;\r\n                -webkit-box-orient: vertical;\r\n                overflow: hidden;\r\n                text-overflow: ellipsis;\r\n                display: -webkit-box;\r\n                color: $gray-400;\r\n                position: relative;\r\n                @include margin-padding(0 0 8px, 0 0 0 15px);\r\n                &::before {\r\n                    content: \"\";\r\n                    position: absolute;\r\n                    left: 0;\r\n                    width: 4px;\r\n                    height: -webkit-fill-available;\r\n                    background: $gray-400;\r\n                    border-radius: $border-radius-lg;\r\n                } \r\n            }\r\n            p.noti-time {\r\n                font-size: $font-size-12;\r\n                color: $gray-900;\r\n                @include margin-padding(0, null);\r\n            }\r\n            .noti-pdf {\r\n                display: -webkit-inline-box;\r\n                display: -ms-inline-flexbox;\r\n                display: inline-flex;\r\n                -webkit-box-align: center;\r\n                -ms-flex-align: center;\r\n                align-items: center;\r\n                border: 1px solid $light-900;\r\n                border-radius: $border-radius-lg;\r\n                padding: 10px;\r\n                margin-bottom: 8px;\r\n                .noti-pdf-icon {\r\n                    margin-right: 10px;\r\n                    span {\r\n                        display: -webkit-box;\r\n                        display: -ms-flexbox;\r\n                        display: flex;\r\n                        align-items: center;\r\n                        -webkit-box-align: center;\r\n                        -ms-flex-align: center;\r\n                        justify-content: center;\r\n                        -webkit-justify-content: center;\r\n                        -ms-flex-pack: center;\r\n                        color: $primary;\r\n                        width: 24px;\r\n                        min-width: 24px;\r\n                        height: 24px;\r\n                        border: 1px solid $light-900;\r\n                        border-radius: $border-radius-lg;\r\n                    }\r\n                }\r\n                .noti-pdf-text {\r\n                    line-height: normal;\r\n                    p {\r\n                        font-size: $font-size-12;\r\n                        color: $gray-900;\r\n                        margin-bottom: 0;\r\n                    }\r\n                    span {\r\n                        font-size: $font-size-12;\r\n                        color: $text-color;\r\n                    }\r\n                }\r\n            }\r\n            .notification-time {\r\n                font-size: $font-size-12;\r\n                line-height: 1.35;\r\n                color: $gray-600;\r\n            }\r\n            .list-item {\r\n                border: 0;\r\n                padding: 0;\r\n                position: relative;\r\n                .list-left {\r\n                    height: 48px;\r\n                    position: absolute;\r\n                    width: 48px;\r\n                }\r\n                .list-body {\r\n                    @include margin-padding(null, 0 0 0 50px);\r\n                    .message-author {\r\n                        color: $gray-800;\r\n                        float: left;\r\n                        font-weight: $font-weight-medium;\r\n                        width: 175px;\r\n                        display: block;\r\n                        max-width: 100%;\r\n                        overflow: hidden;\r\n                        text-overflow: ellipsis;\r\n                        white-space: nowrap;\r\n                    }\r\n                    .message-time {\r\n                        color: $gray-600;\r\n                        float: right;\r\n                        font-size: $font-size-11;\r\n                    }\r\n                    .message-content {\r\n                        color: $gray-800;\r\n                        font-size: $font-size-13;\r\n                        display: block;\r\n                        max-width: 100%;\r\n                        overflow: hidden;\r\n                        text-overflow: ellipsis;\r\n                        white-space: nowrap;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.topnav-dropdown-footer {\r\n    background: $light-200;\r\n    text-align: right;\r\n    @include margin-padding(null, 15px);\r\n    a {\r\n        font-weight: $font-weight-semibold;\r\n        margin-right: 15px;\r\n        &:last-child {\r\n            margin-right: 0;\r\n        }\r\n    }\r\n    .view-link {\r\n        color: $gray-900;\r\n        &:hover {\r\n            color: $gray-400;\r\n        }\r\n    }\r\n    .clear-link {\r\n        color: $primary;\r\n        &:hover {\r\n            color: darken($primary, 10%);\r\n        }\r\n    }\r\n}\r\n.list-left {\r\n    height: 48px;\r\n    position: absolute;\r\n    width: 48px;\r\n}\r\n.list-body {\r\n    @include margin-padding(null, 0 0 0 50px);\r\n    .message-author {\r\n        color: $gray-800;\r\n        float: left;\r\n        font-weight: $font-weight-medium;\r\n        width: 175px;\r\n        display: block;\r\n        max-width: 100%;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n        white-space: nowrap;\r\n    }\r\n    .message-time {\r\n        color: $gray-600;\r\n        float: right;\r\n        font-size: $font-size-11;\r\n    }\r\n    .message-content {\r\n        color: $gray-800;\r\n        font-size: $font-size-13;\r\n        display: block;\r\n        max-width: 100%;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n        white-space: nowrap;\r\n    }\r\n}\r\n.activity {\r\n    width: 100%;\r\n    .activity-box {\r\n        position: relative;\r\n    }\r\n    .activity-list {\r\n        list-style: none;\r\n        padding: 0;\r\n        margin: 0;\r\n        position: relative;\r\n        li {\r\n            background-color: $white;\r\n            position: relative;\r\n            border: 1px solid $gray-400;\r\n            @include margin-padding(0  0 10px,  20px 10px 10px);\r\n            font-size: $font-size-15;\r\n            .activity-user {\r\n                height: 50px;\r\n                margin: 0;\r\n                padding: 0;\r\n                width: 50px;\r\n                @include position(absolute,12px,null,null,8px);\r\n            }\r\n            .activity-content {\r\n                background-color: $white;\r\n                position: relative;\r\n                @include margin-padding(0 0 0 60px, 0);\r\n            }\r\n            .time {\r\n                color: $gray-500;\r\n                display: block;\r\n                font-size: $font-size-12;\r\n                line-height: 1.35;\r\n            }\r\n            a.name {\r\n                color: $black;;\r\n            }\r\n            a {\r\n                color: $secondary;\r\n                font-weight: $font-weight-semibold;\r\n                font-size: $font-size-15;\r\n                img{\r\n                    width:50px;\r\n                    height:50px;\r\n                    border-radius: 5px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n",".avatar {\r\n    position: relative;\r\n    height: 2.625rem;\r\n    width: 2.625rem;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: $border-radius;\r\n    color: $white;\r\n    font-weight: $font-weight-medium;\r\n    a.badge:hover {\r\n        color: $white;\r\n    }\r\n    img {\r\n        width: 100%;\r\n        height: 100%;\r\n        border-radius: $border-radius;\r\n    }\r\n    &.avatar-rounded {\r\n        border-radius: 50%;\r\n        img {\r\n            border-radius: 50%;\r\n        }\r\n    }\r\n    &.avatar-radius-0 {\r\n        border-radius: 0;\r\n        img {\r\n            border-radius: 0;\r\n        }\r\n    }\r\n    .avatar-badge {\r\n        position: absolute;\r\n        inset-block-start: -4%;\r\n        inset-inline-end: -0.375rem;\r\n        width: 1.4rem;\r\n        height: 1.4rem;\r\n        font-size: 0.625rem;\r\n        border: 2px solid $white;\r\n        border-radius: 50% !important;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n    &.online,&.offline {\r\n        &:before {\r\n            position: absolute;\r\n            content: \"\";\r\n            width: 0.5rem;\r\n            height: 0.5rem;\r\n            border-radius: 50%;\r\n            inset-inline-end: 0;\r\n            inset-block-end: 0;\r\n            border: 2px solid $white !important;\r\n            z-index: 1;\r\n        }\r\n    }\r\n    &.online:before {\r\n        background-color: $success;\r\n    }\r\n    &.offline:before {\r\n        background-color: $gray-500;\r\n    }\r\n    &.avatar-xs {\r\n        width: 1.25rem;\r\n        height: 1.25rem;\r\n        line-height: 1.25rem;\r\n        font-size: 0.65rem;\r\n        .avatar-badge {\r\n            padding: 0.25rem;\r\n            width:  1rem;\r\n            height: 1rem;\r\n            line-height: 1rem;\r\n            font-size: 0.5rem;\r\n            inset-block-start: -25%;\r\n            inset-inline-end: -0.5rem;\r\n        }\r\n    }\r\n    &.avatar-sm {\r\n        width: 2rem;\r\n        height: 2rem;\r\n        line-height: 2rem;\r\n        font-size: 0.65rem;\r\n        .avatar-badge {\r\n            padding: 0.3rem;\r\n            width:  1.1rem;\r\n            height: 1.1rem;\r\n            line-height: 1.1rem;\r\n            font-size: 0.5rem;\r\n            inset-block-start: -28%;\r\n            inset-inline-end: -0.45rem;\r\n        }\r\n        &.online,&.offline {\r\n            &:before {\r\n                width: 0.5rem;\r\n                height: 0.5rem;\r\n            }\r\n        }    \r\n    }\r\n    &.avatar-md {\r\n        width: 2.5rem;\r\n        height: 2.5rem;\r\n        line-height: 2.5rem;\r\n        font-size: 0.8rem;\r\n        .avatar-badge {\r\n            padding: 0.4rem;\r\n            width:  1.2rem;\r\n            height: 1.2rem;\r\n            line-height: 1.2rem;\r\n            font-size: 0.65rem;\r\n            inset-block-start: -6%;\r\n            inset-inline-end: -13%;\r\n        }\r\n        &.online,&.offline {\r\n            &:before {\r\n                width: 0.75rem;\r\n                height: 0.75rem;\r\n            }\r\n        }    \r\n        svg {\r\n            width: 1.5rem;\r\n            height: 1.5rem;\r\n        }\r\n    }\r\n    &.avatar-lg {\r\n        width: 3rem;\r\n        height: 3rem;\r\n        line-height: 3rem;\r\n        font-size: 1rem;\r\n        .avatar-badge {\r\n            inset-block-start: -15%;\r\n            inset-inline-end: -0.25%;\r\n        }\r\n        &.online,&.offline {\r\n            &:before {\r\n                width: 0.8rem;\r\n                height: 0.8rem;\r\n            }\r\n        }    \r\n        svg {\r\n            width: 1.8rem;\r\n            height: 1.8rem;\r\n        }\r\n    }\r\n    &.avatar-xl {\r\n        width: 4rem;\r\n        height: 4rem;\r\n        line-height: 4rem;\r\n        font-size: 1.25rem;\r\n        .avatar-badge {\r\n            inset-block-start: -8%;\r\n            inset-inline-end: -0.2%;\r\n        }\r\n        &.online,&.offline {\r\n            &:before {\r\n                width: 0.95rem;\r\n                height: 0.95rem;\r\n            }\r\n        }    \r\n    }\r\n    &.avatar-xxl {\r\n        width: 5rem;\r\n        height: 5rem;\r\n        line-height: 5rem;\r\n        font-size: 1.5rem;\r\n        .avatar-badge {\r\n            inset-block-start: -4%;\r\n            inset-inline-end: 0rem;\r\n        }\r\n        &.online,&.offline {\r\n            &:before {\r\n                width: 1.05rem;\r\n                height: 1.05rem;\r\n                inset-block-end: 0.25rem;\r\n            }\r\n            &.online-sm {\r\n                &:before {\r\n                    width: 10px;\r\n                    height: 10px;\r\n                    inset-block-end: 0rem;\r\n                }\r\n            }\r\n        }    \r\n    }\r\n    &.avatar-xxxl {\r\n        width: 6rem;\r\n        height: 6rem;\r\n        line-height: 6rem;\r\n        font-size: 1.75rem;\r\n        .avatar-badge {\r\n            inset-block-start: -4%;\r\n            inset-inline-end: 0rem;\r\n        }\r\n        &.online,&.offline {\r\n            &:before {\r\n                width: 1.05rem;\r\n                height: 1.05rem;\r\n                inset-block-end: 0.25rem;\r\n            }\r\n        }    \r\n    }\r\n}\r\n.avatar-list-stacked {\r\n    padding: 0;\r\n    &.avatar-group-overlapped {\r\n        .avatar {\r\n            margin-right: -.875rem;\r\n            &:hover{\r\n                z-index:1;\r\n            }\r\n        }\r\n    }\t\r\n    &.avatar-group-lg {\r\n        .avatar { \r\n            width: 3.25rem;\r\n            height: 3.25rem;\r\n            >.initial-wrap {\r\n                font-size: .95rem;\r\n            }\r\n        }\r\n        &.avatar-group-overlapped .avatar {\r\n            margin-right: -1rem;\r\n        }\t\r\n    }\r\n    &.avatar-group-sm {\r\n        .avatar { \r\n            width: 2rem;\r\n            height: 2rem;\r\n            >.initial-wrap {\r\n                font-size: .6rem;\r\n            }\r\n        }\r\n        &.avatar-group-overlapped .avatar {\r\n            margin-right: -0.625rem;\r\n        }\t\r\n    }\r\n    &.avatar-group-xs {\r\n        .avatar {\r\n            width: 1.50rem;\r\n            height: 1.50rem;\r\n            >.initial-wrap {\r\n                font-size: .6rem;\r\n            }\r\n        }\r\n    }\r\n    .avatar {\r\n        margin-inline-end: -0.875rem !important;\r\n        border: 1px solid rgba(0,0,0,0.05);\r\n        vertical-align: middle;\r\n        transition: transform ease 200ms;\r\n        &:last-child {\r\n            margin-inline-end: 0 !important;\r\n        }\r\n        &:hover {\r\n            z-index: 1;\r\n            transform: translateY(-0.188rem);\r\n        }\r\n    }\r\n}\r\n.avatar-group {\r\n\tdisplay: -webkit-inline-box;\r\n\tdisplay: -ms-inline-flexbox;\r\n\tdisplay: inline-flex;\r\n\t.avatar { \r\n\t\twidth: 2.625rem;\r\n\t\theight: 2.625rem;\r\n\t\t.avatar-img,\r\n\t\t>.initial-wrap {\r\n\t\t\tborder:2px solid $white;\r\n\t\t\tfont-size: .9rem;\r\n\t\t}\r\n\t}\r\n\t&.avatar-group-overlapped {\r\n\t\t.avatar {\r\n\t\t\tmargin-right: -.875rem;\r\n\t\t\t&:hover{\r\n\t\t\t\tz-index:1;\r\n\t\t\t}\r\n\t\t}\r\n\t}\t\r\n\t&.avatar-group-lg {\r\n\t\t.avatar { \r\n\t\t\twidth: 3.25rem;\r\n\t\t\theight: 3.25rem;\r\n\t\t\t>.initial-wrap {\r\n\t\t\t\tfont-size: .95rem;\r\n\t\t\t}\r\n\t\t}\r\n\t\t&.avatar-group-overlapped .avatar {\r\n\t\t\tmargin-right: -1rem;\r\n\t\t}\t\r\n\t}\r\n\t&.avatar-group-sm {\r\n\t\t.avatar { \r\n\t\t\twidth: 2rem;\r\n\t\t\theight: 2rem;\r\n\t\t\t>.initial-wrap {\r\n\t\t\t\tfont-size: .6rem;\r\n\t\t\t}\r\n\t\t}\r\n\t\t&.avatar-group-overlapped .avatar {\r\n\t\t\tmargin-right: -0.625rem;\r\n\t\t}\t\r\n\t}\r\n}\r\n.avatar-xxs {\r\n    width: 16px;\r\n    height: 16px;\r\n}",".bootstrap-datetimepicker-widget table td.active,\r\n.bootstrap-datetimepicker-widget table td.active:hover {\r\n\tbackground-color: $warning;\r\n\ttext-shadow: unset;\r\n}\r\n.bootstrap-datetimepicker-widget table td.today:before {\r\n\tborder-bottom-color: $warning;\r\n}\r\n.bootstrap-datetimepicker-widget table thead tr:first-child th:hover {\r\n    background: transparent;\r\n}\r\n.bor-b1{\r\n    border-bottom: 1px solid $gray-300;\r\n}\r\n\r\n.link-purple {\r\n\tcolor: $purple;\r\n\t&:hover {\r\n\t  color: darken($purple, 2);\r\n\t}\r\n}\r\nhr {\r\n\tborder-color: $light-900;\r\n}",".btn-primary {\r\n    color: $white;\r\n    background-color: $primary;\r\n    border-color: $primary;\r\n    font-size: $font-size-14;\r\n    font-size: $font-size-14;\r\n}\r\n.btn-save {\r\n    background: $primary;\r\n    color: $white;\r\n    font-size: $font-size-14;\r\n    font-size: $font-size-14;\r\n    border-radius: 5px;\r\n    @include margin-padding(null, 8px 20px);\r\n    @include transition(all 0.2s ease);\r\n    &:hover{\r\n        background: $primary-hover;\r\n        color: $white;\r\n    }\r\n    @include respond-below(custom991) {\r\n        min-width: auto;\r\n        padding: 5px 7px;\r\n    }\r\n}\r\n.btn-reset {\r\n    background: $text-color;\r\n    color: $white;\r\n    font-size: $font-size-14;\r\n    font-weight: $font-weight-bold;\r\n    border-radius: 5px;\r\n    @include margin-padding(null, 8px 20px);\r\n    @include transition(all 0.2s ease);\r\n    &:hover{\r\n        background: $secondary;\r\n        color: $white;\r\n    }\r\n    @include respond-below(custom991) {\r\n        min-width: auto;\r\n        padding: 5px 7px;\r\n    }\r\n}\r\n.btn-send {\r\n    background: $primary;\r\n    @include margin-padding(null, 9px 14px);\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    align-items: center;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    justify-content: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    color: #fff;\r\n    font-weight: $font-weight-bold;\r\n    font-size: $font-size-14;\r\n    margin-right: 15px;\r\n    border-radius: 8px;\r\n    &:hover{\r\n        background: $primary-hover;\r\n        color: $white;\r\n    }\r\n    .send-mail {\r\n        margin-right: 10px;\r\n        width: 16px;\r\n        height: 16px;\r\n    }\r\n}\r\n.btn-download {\r\n    background: $secondary;\r\n    @include margin-padding(null, 9px 14px);\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    align-items: center;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    justify-content: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    color: #fff;\r\n    font-weight: $font-weight-bold;\r\n    font-size: $font-size-14;\r\n    margin-right: 15px;\r\n    border-radius: 8px;\r\n    &:hover{\r\n        background: $gray-900;\r\n        color: $white;\r\n     }\r\n    .download {\r\n        margin-right: 10px;\r\n        width: 16px;\r\n        height: 16px;\r\n    }    \r\n}\r\n.btn-barcode {\r\n    background: $danger;\r\n    @include margin-padding(null, 9px 14px);\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    align-items: center;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    justify-content: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    color: #fff;\r\n    font-weight: $font-weight-bold;\r\n    font-size: $font-size-14;\r\n    margin-right: 15px;\r\n    border-radius: 8px;\r\n    &:hover{\r\n        background: $danger;\r\n        color: $white;\r\n     }\r\n    .print {\r\n        margin-right: 10px;\r\n        width: 16px;\r\n        height: 16px;\r\n    }\r\n    \r\n}\r\n.btn-primary.add-em-payroll {\r\n    padding: 9px 11px;\r\n    color: #fff;\r\n    font-weight: $font-weight-bold;\r\n    font-size: $font-size-14;\r\n    border-radius: 8px;\r\n    .me-2 {\r\n        width: 16px;\r\n        height: 16px;\r\n    }\r\n}\r\n.swal2-actions .swal2-confirm.btn:active {\r\n    background-color: $primary;\r\n    border-color: $primary;\r\n}\r\n.btn-check:checked+.btn, .btn.active, .btn.show, .btn:first-child:active, :not(.btn-check)+.btn:active {\r\n    background-color: $primary;\r\n    border-color: $primary;\r\n    color: $white;\r\n}\r\n.modal {\r\n    .card {\r\n        border: 0;\r\n    }\r\n}\r\n.search-input {\r\n    .btn-searchset {\r\n        &:active {\r\n            background-color: transparent;\r\n            border-color: transparent;\r\n            svg {\r\n                color: $secondary;\r\n            }\r\n        }\r\n    }\r\n}\r\n.input-blocks {\r\n    input[type=text] {\r\n        &.datetimepicker {\r\n            padding-left: 35px;\r\n        }\r\n    }\r\n}\r\n.iti__country-list {\r\n    z-index: 101;\r\n}\r\nbutton {\r\n    cursor: pointer;\r\n    &:focus{\r\n        outline: 0;\r\n        box-shadow: none;\r\n    }\r\n}\r\n.btn {\r\n    border-radius: $border-radius-lg;\r\n    padding: 0.625rem 1.25rem;\r\n    padding: 0.5rem 0.85rem;\r\n    font-size: 0.85rem;\r\n    transition: all 0.5s;\r\n    font-weight: $font-weight-semibold;\r\n    &:focus {\r\n        box-shadow: none !important;\r\n    }\r\n    &:hover {\r\n        transition: all 0.5s;\r\n    }\r\n    &.btn-lg {\r\n        padding: 0.65rem 1rem;\r\n        font-size: 0.95rem;\r\n    }\r\n    &.btn-sm {\r\n        padding: 0.25rem 0.5rem;\r\n        font-size: 0.75rem;\r\n    }\r\n    @each $color,\r\n    $value in $theme-colors {\r\n        &.btn-#{$color} {\r\n            background-color: #{$value};\r\n            border: 1px solid #{$value};\r\n            color: $white;\r\n            &:hover,\r\n            &:focus,\r\n            &.focus,\r\n            &:active,\r\n            &.active {\r\n                background-color: #{darken($value, 7%)};\r\n                border:1px solid #{darken($value, 7%)};\r\n                color: $white;\r\n            }\r\n        }\r\n    }\r\n    &.btn-light {\r\n        background-color: $light-400;\r\n        border: 1px solid $light-900;\r\n        color: $gray-900;\r\n        &:hover,\r\n        &:focus,\r\n        &.focus,\r\n        &:active,\r\n        &.active {\r\n            background-color: darken($light-400, 3%);\r\n            border: 1px solid $light-900;\r\n            color: $gray-900;\r\n        }\r\n    }\r\n}\r\n\r\n.btn-group {\r\n    .btn {\r\n      padding: 0.45rem 0.75rem;\r\n    }\r\n  }\r\n  .btn-group-lg {\r\n    .btn {\r\n      padding: 0.65rem 1rem;\r\n    }\r\n  }\r\n  .btn-group-sm {\r\n    .btn {\r\n      padding: 0.25rem 0.5rem;\r\n    }\r\n  }\r\n.btn {\r\n    &.btn-w-xs {\r\n      min-width: 5.625rem;\r\n    }\r\n    &.btn-w-sm {\r\n      min-width: 6.975rem;\r\n    }\r\n    &.btn-w-md {\r\n      min-width: 8.125rem;\r\n    }\r\n    &.btn-w-lg {\r\n      min-width: 9.375rem;\r\n    }\r\n  }\r\n  .btn-icon {\r\n    i {\r\n      padding: 0rem;\r\n      margin: -0.5rem;\r\n    }\r\n    &.btn-sm {\r\n      width: 1.75rem;\r\n      height: 1.75rem;\r\n      font-size: 0.8rem;\r\n    }\r\n    &.btn-lg {\r\n      width: 2.75rem;\r\n      height: 2.75rem;\r\n      font-size: 1.2rem;\r\n    }\r\n  }\r\n  .btn-list {\r\n    > button, > a {\r\n      margin: 0 0.375rem 0.375rem 0;\r\n    }\r\n  }\r\n  [dir=\"rtl\"] {\r\n    .btn-list {\r\n      button,\r\n      div,\r\n      a,\r\n      input {\r\n        margin: 0 0 0.375rem 0.375rem;\r\n      }\r\n    }\r\n  }\r\n  \r\n  .btn-list {\r\n    margin-block-end: -0.5rem;\r\n  }\r\n  .btn-square {\r\n    border-radius: 0;\r\n}\r\n.btn-group-pill .btn:first-child {\r\n    border-radius: 60px 0 0 60px;\r\n  }\r\n  .btn-group-pill .btn:last-child {\r\n    border-radius: 0 60px 60px 0;\r\n  }\r\n  \r\n  .btn-group-square .btn:first-child {\r\n    border-radius: 0px 0 0 0px;\r\n  }\r\n  .btn-group-square .btn:last-child {\r\n    border-radius: 0 0px 0px 0;\r\n  }\r\n.btn {\r\n  &.btn-primary-light {\r\n    background-color: rgba($primary, 0.1);\r\n    color: $primary;\r\n    &:hover,\r\n    &:focus,\r\n    &:active {\r\n      background-color: $primary;\r\n      color: $white;\r\n      border-color: $primary;\r\n    }\r\n  }\r\n \r\n  &.btn-secondary-light {\r\n    background-color: rgba($secondary, 0.1);\r\n    color: $secondary;\r\n    &:hover,\r\n    &:focus,\r\n    &:active {\r\n      background-color: $secondary;\r\n      color: $white;\r\n      border-color: $secondary;\r\n    }\r\n  }\r\n  &.btn-warning-light {\r\n    background-color: rgba($warning, 0.1);\r\n    color: $warning;\r\n    &:hover,\r\n    &:focus,\r\n    &:active {\r\n      background-color: $warning;\r\n      color: $white;\r\n      border-color: $warning;\r\n    }\r\n  }\r\n  &.btn-info-light {\r\n    background-color: rgba($info, 0.1);\r\n    color: $info;\r\n    &:hover,\r\n    &:focus,\r\n    &:active {\r\n      background-color: $info;\r\n      color: $white;\r\n      border-color: $info;\r\n    }\r\n  }\r\n  &.btn-success-light {\r\n    background-color: rgba($success, 0.1);\r\n    color: $success;\r\n    &:hover,\r\n    &:focus,\r\n    &:active {\r\n      background-color: $success;\r\n      color: $white;\r\n      border-color: $success;\r\n    }\r\n  }\r\n  &.btn-danger-light {\r\n    background-color: rgba($danger, 0.1);\r\n    color: $danger;\r\n    &:hover,\r\n    &:focus,\r\n    &:active {\r\n      background-color: $danger;\r\n      color: $white;\r\n      border-color: $danger;\r\n    }\r\n  }\r\n}\r\n.btn {\r\n  &.btn-primary-ghost {\r\n    background-color: transparent;\r\n    color: $primary;\r\n    border: 1px solid $primary;\r\n    &:active {\r\n      color: $primary;\r\n      border: 1px solid $primary;\r\n      background-color: transparent;\r\n    }\r\n  }\r\n  &.btn-dark{\r\n    background: #131022 !important;\r\n    border-color: #131022 !important;\r\n    box-shadow: none;\r\n    color: #fff;\r\n    &:hover{\r\n      background: $primary;\r\n    }\r\n  }\r\n  &.btn-secondary-ghost {\r\n    background-color: transparent;\r\n    color: $secondary;\r\n    border: 1px solid $secondary;\r\n    &:active {\r\n      color: $secondary;\r\n      border: 1px solid $secondary;\r\n      background-color: transparent;\r\n    }\r\n  }\r\n  &.btn-warning-ghost {\r\n    background-color: transparent;\r\n    color: $warning;\r\n    border: 1px solid $warning;\r\n    &:active {\r\n      color: $warning;\r\n      border: 1px solid $warning;\r\n      background-color: transparent;\r\n    }\r\n  }\r\n  &.btn-info-ghost {\r\n    background-color: transparent;\r\n    color: $info;\r\n    border: 1px solid $info;\r\n    &:active {\r\n      color: $info;\r\n      border: 1px solid $info;\r\n      background-color: transparent;\r\n    }\r\n  }\r\n  &.btn-success-ghost {\r\n    background-color: transparent;\r\n    color: $success;\r\n    border: 1px solid $success;\r\n    &:active {\r\n      color: $success;\r\n      border: 1px solid $success;\r\n      background-color: transparent;\r\n    }\r\n  }\r\n  &.btn-danger-ghost {\r\n    background-color: transparent;\r\n    color: $danger;\r\n    border: 1px solid $danger;\r\n    &:active {\r\n      color: $danger;\r\n      border: 1px solid $danger;\r\n      background-color: transparent;\r\n    }\r\n  }\r\n}\r\n.btn-list {\r\n  button {\r\n    margin: 0 0.375rem 0.375rem 0;\r\n  }\r\n}\r\n.btn-outline-primary {\r\n    border: 1px solid $primary !important;\r\n    color: $primary !important;\r\n    &:hover,\r\n    &:focus,\r\n    &.focus,\r\n    &:active,\r\n    &.active {\r\n        background-color: $primary !important;\r\n        border:1px solid $primary !important;\r\n        box-shadow: 0 3px 10px rgba($primary, 0.5);\r\n        color: $white !important;\r\n    }\r\n}\r\n.btn-outline-secondary {\r\n    border: 1px solid $secondary !important;\r\n    color: $secondary !important;\r\n    &:hover,\r\n    &:focus,\r\n    &.focus,\r\n    &:active,\r\n    &.active {\r\n        background-color: $secondary !important;\r\n        border:1px solid $secondary !important;\r\n        box-shadow: 0 3px 10px rgba($secondary, 0.5);\r\n        color: $white !important;\r\n    }\r\n}\r\n.btn-outline-success {\r\n    border: 1px solid $success !important;\r\n    color: $success !important;\r\n    &:hover,\r\n    &:focus,\r\n    &.focus,\r\n    &:active,\r\n    &.active {\r\n        background-color: $success !important;\r\n        border:1px solid $success !important;\r\n        box-shadow: 0 3px 10px rgba($success, 0.5);\r\n        color: $white !important;\r\n    }\r\n}\r\n.btn-outline-danger {\r\n    border: 1px solid $danger !important;\r\n    color: $danger !important;\r\n    &:hover,\r\n    &:focus,\r\n    &.focus,\r\n    &:active,\r\n    &.active {\r\n        background-color: $danger !important;\r\n        border:1px solid $danger !important;\r\n        box-shadow: 0 3px 10px rgba($danger, 0.5);\r\n        color: $white !important;\r\n    }\r\n}\r\n.btn-outline-warning {\r\n    border: 1px solid $warning !important;\r\n    color: $warning !important;\r\n    &:hover,\r\n    &:focus,\r\n    &.focus,\r\n    &:active,\r\n    &.active {\r\n        background-color: $warning !important;\r\n        border:1px solid $warning !important;\r\n        box-shadow: 0 3px 10px rgba($warning, 0.5);\r\n        color: $white !important;\r\n    }\r\n}\r\n.btn-outline-info {\r\n    border: 1px solid $info !important;\r\n    color: $info !important;\r\n    &:hover,\r\n    &:focus,\r\n    &.focus,\r\n    &:active,\r\n    &.active {\r\n        background-color: $info !important;\r\n        border:1px solid $info !important;\r\n        box-shadow: 0 3px 10px rgba($info, 0.5);\r\n        color: $white !important;\r\n    }\r\n}\r\n.btn-outline-light {\r\n    border: 1px solid $light;\r\n    color: $gray-800 !important;\r\n    &:hover,\r\n    &:focus,\r\n    &.focus,\r\n    &:active,\r\n    &.active {\r\n        background-color: $light;\r\n        border: 1px solid $light;\r\n        color: $dark !important;\r\n    }\r\n}\r\n.btn-outline-dark {\r\n    border: 1px solid $dark !important;\r\n    color: $dark !important;\r\n    &:hover,\r\n    &:focus,\r\n    &.focus,\r\n    &:active,\r\n    &.active {\r\n        background-color: $dark !important;\r\n        border:1px solid $dark !important;\r\n        box-shadow: 0 3px 10px rgba($dark, 0.5);\r\n        color: $white !important;\r\n    }\r\n}\r\n.btn-soft-primary {\r\n    background-color: $primary-300 !important;\r\n    color: $primary !important;\r\n    &:hover,\r\n    &:focus,\r\n    &.focus,\r\n    &:active,\r\n    &.active {\r\n       box-shadow: 0 3px 12px rgba($primary, .2);\r\n       border-color: $primary;\r\n    }    \r\n}\r\n.btn-soft-secondary {\r\n    background-color: $secondary-300 !important;\r\n    color: $secondary !important;\r\n    &:hover,\r\n    &:focus,\r\n    &.focus,\r\n    &:active,\r\n    &.active {\r\n       box-shadow: 0 3px 12px rgba($secondary, .2);\r\n       border-color: $secondary;\r\n    }    \r\n}\r\n.btn-soft-success {\r\n    background-color: $success-300 !important;\r\n    color: $success !important;\r\n    &:hover,\r\n    &:focus,\r\n    &.focus,\r\n    &:active,\r\n    &.active {\r\n       box-shadow: 0 3px 12px rgba($success, .2);\r\n       border-color: $success;\r\n    }    \r\n}\r\n.btn-soft-danger {\r\n    background-color: $danger-300 !important;\r\n    color: $danger !important;\r\n    &:hover,\r\n    &:focus,\r\n    &.focus,\r\n    &:active,\r\n    &.active {\r\n       box-shadow: 0 3px 12px rgba($danger, .2);\r\n       border-color: $danger;\r\n    }    \r\n}\r\n.btn-soft-warning {\r\n    background-color: $warning-300 !important;\r\n    color: $warning !important;\r\n    &:hover,\r\n    &:focus,\r\n    &.focus,\r\n    &:active,\r\n    &.active {\r\n       box-shadow: 0 3px 12px rgba($warning, .2);\r\n       border-color: $warning;\r\n    }    \r\n}\r\n.btn-soft-info {\r\n    background-color: rgba($info, 0.3) !important;\r\n    color: $info !important;\r\n    &:hover,\r\n    &:focus,\r\n    &.focus,\r\n    &:active,\r\n    &.active {\r\n       box-shadow: 0 3px 12px rgba($info, .2);\r\n       border-color: $info;\r\n    }    \r\n}\r\n.btn-soft-light {\r\n    background-color: rgba($light, .9) !important;\r\n    color: $text-color !important;\r\n    &:hover,\r\n    &:focus,\r\n    &.focus,\r\n    &:active,\r\n    &.active {\r\n       box-shadow: 0 3px 12px rgba($light, .2);\r\n       border-color: $light;\r\n       border-color: $text-color;\r\n    }    \r\n}\r\n.btn-soft-dark {\r\n    background-color: rgba($dark, 0.3) !important;\r\n    color: $white !important;\r\n    &:hover,\r\n    &:focus,\r\n    &.focus,\r\n    &:active,\r\n    &.active {\r\n       box-shadow: 0 3px 12px rgba($dark, .2);\r\n       border-color: $dark;\r\n    }    \r\n}\r\n.custom-btn-close {\r\n  &.btn-close {\r\n    background-image: none;\r\n    transition: 0.5s all;\r\n    &:hover {\r\n      background: $danger;\r\n      color: $white;\r\n      border-color: $danger !important;\r\n      transition: 0.5s all;\r\n      transform: rotateZ(360deg);\r\n    }\r\n  }\r\n}\r\n.modal {\r\n  .custom-btn-close {\r\n    &.btn-close {\r\n      background-image: none;\r\n      transition: 0.5s all;\r\n      width: auto !important;\r\n      height: auto !important;\r\n      &:hover {\r\n        background: $danger !important;\r\n        color: $white !important;\r\n        border-color: $danger !important;\r\n        transition: 0.5s all;\r\n        transform: rotateZ(360deg);\r\n      }\r\n    }\r\n  }\r\n}\r\n.btn-purple-light {\r\n  background-color: $purple-100;\r\n  border-color: $purple-100;\r\n  color: $purple;\r\n  font-size: $font-size-14;\r\n  font-weight: $font-weight-medium;\r\n  border-radius: 5px;\r\n  @include margin-padding(null, 9px 20px);\r\n  @include transition(all 0.2s ease);\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  display: -webkit-inline-box;\r\n  display: -ms-inline-flexbox;\r\n  display: inline-flex;        \r\n  @include respond-below(custom991) {\r\n      @include margin-padding(null, 9px 14px);\r\n  }\r\n}\r\n$green-hover:  darken($green, 10%);\r\n.btn-primary {\r\n  background: $green;\r\n  border: 1px solid $green;\r\n  @include transition(all 0.2s ease);\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  display: -webkit-inline-box;\r\n  display: -ms-inline-flexbox;\r\n  display: inline-flex;\r\n  justify-content: center;\r\n  -webkit-justify-content: center;\r\n  -ms-flex-pack: center;\r\n  &:hover, &:active{\r\n      background: #c11a06;\r\n      border-color: #c11a06;\r\n      color: $white;\r\n  }\r\n  @include respond-below(custom991) {\r\n      min-width: auto;\r\n  }\r\n}",".badge {\r\n    &.badge-primary {\r\n        background: rgba($primary, 0.1);\r\n        box-shadow: 0 1px 1px rgba($primary, 0.5);\r\n        color: $primary;\r\n        \r\n    }\r\n}\r\n@each $color, $value in $theme-colors {\r\n    .badge {\r\n        &.badge-#{$color} {\r\n            background: #{$value};\r\n            box-shadow: 0 1px 1px rgba($value, 0.5);\r\n            color: $white;\r\n        }\r\n        &.badge-soft-#{$color} {\r\n            background: rgba($value, 0.1);\r\n            box-shadow: 0 1px 1px rgba($value, 0.5);\r\n            color: $value;\r\n        }\r\n    }\r\n}\r\n.badge{\r\n    padding: .25rem .45rem;\r\n    text-transform:capitalize;\r\n    font-weight: $font-weight-semibold;\r\n    letter-spacing: 0.5px;\r\n    border-radius: $border-radius;\r\n    color: $gray-900;\r\n    &.badge-xs {\r\n        font-size: 10px;\r\n        padding: 0px 5px;\r\n        line-height: 18px;\r\n    }\r\n    &.badge-sm {\r\n        font-size: 11px;\r\n        padding: 5px 8px;\r\n        line-height: 11px;\r\n    }\r\n    &.badge-md {\r\n        font-size: 12px;\r\n        padding: 5px 12px;\r\n        line-height: 1.5;\r\n    }\r\n    &.badge-lg {\r\n        font-size: $font-size-14;\r\n        padding: 0px 10px;\r\n        line-height: 30px;\r\n    }\r\n    &.badge-xl {\r\n        font-size: $font-size-16;\r\n        padding: 0px 15px;\r\n        line-height: 35px;\r\n    }\r\n}\r\n\r\n.badge-soft-purple {\r\n    background: $purple-100;\r\n    color: $purple;\r\n    \r\n}\r\n.bg-light-danger {\r\n    background-color: $danger-100 !important;\r\n    .badge-dots{\r\n        background-color: $danger-900;\r\n    }\r\n}\r\n.bg-light-success {\r\n    background-color: $success-100 !important;\r\n    .badge-dots{\r\n        background-color: $success-900;\r\n    }\r\n}\r\n.bg-light-info {\r\n    background-color:$info-100 !important;\r\n    .badge-dots{\r\n        background-color: $info-900;\r\n    }\r\n}\r\n.bg-light-warning {\r\n    background-color: $warning-100 !important;\r\n    .badge-dots{\r\n        background-color: $warning-900;\r\n    }\r\n}\r\n.badge-danger-light{\r\n    background-color: $danger-100 !important;\r\n    color: $danger-900;\r\n}\r\n.badge-pending{\r\n\tbackground: #676DFF !important;\r\n    color: $white !important;\r\n}\r\n.badge-tertiary {\r\n    background: $tertiary;\r\n    color: $white;\r\n}\r\n.badge-status {\r\n    border-radius: 5px;\r\n    font-size: $font-size-12;\r\n    padding: 4px 8px;\r\n    min-width: 64px;\r\n    color: $white;\r\n}\r\n.badge-tag {\r\n    border-radius: 5px;\r\n    font-size: $font-size-12;\r\n    padding: 4px 4px;    \r\n    font-weight: $font-weight-normal;\r\n    &.badge-success-light {\r\n        background: $success-200;\r\n        color: $success;\r\n    }\r\n    &.badge-warning-light {\r\n        background: $warning-100;\r\n        color: $warning;\r\n    }\r\n    &.badge-purple-light {\r\n        background: $purple-100;\r\n        color: $purple;\r\n    }\r\n    &.badge-danger-light {\r\n        background: $danger-100;\r\n        color: $danger;\r\n    }\r\n}",".border-container {\r\n    display: inline-block;\r\n    width: 5rem;\r\n    height: 5rem;\r\n    margin: 0.25rem;\r\n    background-color: $light;\r\n}\r\n.border {\r\n    border: 1px solid $border-color !important;\r\n    &.border-dashed {\r\n        border-style: dashed !important;\r\n    }\r\n    &.border-dotted {\r\n        border-style: dotted !important;\r\n    }\r\n    &.border-primary {\r\n        border: 1px solid $primary !important;\r\n        opacity: 1;\r\n        &.border-opacity-10 {\r\n            border-color: rgba($primary, 0.1) !important;\r\n        }\r\n        &.border-opacity-25 {\r\n            border-color: rgba($primary, 0.25) !important;\r\n        }\r\n        &.border-opacity-50 {\r\n            border-color: rgba($primary, 0.50) !important;\r\n        }\r\n        &.border-opacity-75 {\r\n            border-color: rgba($primary, 0.75) !important;\r\n        }\r\n        &.border-opacity-100 {\r\n            border-color: rgba($primary,1) !important;\r\n        }\r\n    }\r\n    &.border-secondary {\r\n        border: 1px solid $secondary !important;\r\n        opacity: 1;\r\n        &.border-opacity-10 {\r\n            border-color: rgba($secondary,0.1) !important;\r\n        }\r\n        &.border-opacity-25 {\r\n            border-color: rgba($secondary,0.25) !important;\r\n        }\r\n        &.border-opacity-50 {\r\n            border-color: rgba($secondary,0.50) !important;\r\n        }\r\n        &.border-opacity-75 {\r\n            border-color: rgba($secondary,0.75) !important;\r\n        }\r\n        &.border-opacity-100 {\r\n            border-color: rgba($secondary,1) !important;\r\n        }\r\n    }\r\n    &.border-info {\r\n        border: 1px solid $info !important;\r\n        opacity: 1;\r\n        &.border-opacity-10 {\r\n            border-color: rgba($info,0.1) !important;\r\n        }\r\n        &.border-opacity-25 {\r\n            border-color: rgba($info,0.25) !important;\r\n        }\r\n        &.border-opacity-50 {\r\n            border-color: rgba($info,0.50) !important;\r\n        }\r\n        &.border-opacity-75 {\r\n            border-color: rgba($info,0.75) !important;\r\n        }\r\n        &.border-opacity-100 {\r\n            border-color: rgba($info,1) !important;\r\n        }\r\n    }\r\n    &.border-success {\r\n        border: 1px solid $success !important;\r\n        opacity: 1;\r\n        &.border-opacity-10 {\r\n            border-color: rgba($success,0.1) !important;\r\n        }\r\n        &.border-opacity-25 {\r\n            border-color: rgba($success,0.25) !important;\r\n        }\r\n        &.border-opacity-50 {\r\n            border-color: rgba($success,0.50) !important;\r\n        }\r\n        &.border-opacity-75 {\r\n            border-color: rgba($success,0.75) !important;\r\n        }\r\n        &.border-opacity-100 {\r\n            border-color: rgba($success,1) !important;\r\n        }\r\n    }\r\n    &.border-warning {\r\n        border: 1px solid $warning !important;\r\n        opacity: 1;\r\n        &.border-opacity-10 {\r\n            border-color: rgba($warning,0.1) !important;\r\n        }\r\n        &.border-opacity-25 {\r\n            border-color: rgba($warning,0.25) !important;\r\n        }\r\n        &.border-opacity-50 {\r\n            border-color: rgba($warning,0.50) !important;\r\n        }\r\n        &.border-opacity-75 {\r\n            border-color: rgba($warning,0.75) !important;\r\n        }\r\n        &.border-opacity-100 {\r\n            border-color: rgba($warning,1) !important;\r\n        }\r\n    }\r\n    &.border-danger {\r\n        border: 1px solid $danger !important;\r\n        opacity: 1;\r\n        &.border-opacity-10 {\r\n            border-color: rgba($danger,0.1) !important;\r\n        }\r\n        &.border-opacity-25 {\r\n            border-color: rgba($danger,0.25) !important;\r\n        }\r\n        &.border-opacity-50 {\r\n            border-color: rgba($danger,0.50) !important;\r\n        }\r\n        &.border-opacity-75 {\r\n            border-color: rgba($danger,0.75) !important;\r\n        }\r\n        &.border-opacity-100 {\r\n            border-color: rgba($danger,1) !important;\r\n        }\r\n    }\r\n    &.border-white {\r\n        border: 1px solid $white !important;\r\n        opacity: 1;\r\n        &.border-opacity-10 {\r\n            border-color: rgba($white,0.1) !important;\r\n        }\r\n        &.border-opacity-25 {\r\n            border-color: rgba($white,0.25) !important;\r\n        }\r\n        &.border-opacity-50 {\r\n            border-color: rgba($white,0.50) !important;\r\n        }\r\n        &.border-opacity-75 {\r\n            border-color: rgba($white,0.75) !important;\r\n        }\r\n        &.border-opacity-100 {\r\n            border-color: rgba($white,1) !important;\r\n        }\r\n    }\r\n    &.border-light {\r\n        border: 1px solid $light !important;\r\n        opacity: 1;\r\n        &.border-opacity-10 {\r\n            border-color: rgba($light,0.1) !important;\r\n        }\r\n        &.border-opacity-25 {\r\n            border-color: rgba($light,0.25) !important;\r\n        }\r\n        &.border-opacity-50 {\r\n            border-color: rgba($light,0.50) !important;\r\n        }\r\n        &.border-opacity-75 {\r\n            border-color: rgba($light,0.75) !important;\r\n        }\r\n        &.border-opacity-100 {\r\n            border-color: rgba($light,1) !important;\r\n        }\r\n    }\r\n    &.border-dark {\r\n        border: 1px solid $dark !important;\r\n        opacity: 1;\r\n        &.border-opacity-10 {\r\n            border-color: rgba($dark,0.1) !important;\r\n        }\r\n        &.border-opacity-25 {\r\n            border-color: rgba($dark,0.25) !important;\r\n        }\r\n        &.border-opacity-50 {\r\n            border-color: rgba($dark,0.50) !important;\r\n        }\r\n        &.border-opacity-75 {\r\n            border-color: rgba($dark,0.75) !important;\r\n        }\r\n        &.border-opacity-100 {\r\n            border-color: rgba($dark,1) !important;\r\n        }\r\n    }\r\n    &.border-orange {\r\n        border: 1px solid $orange !important;\r\n        opacity: 1;\r\n        &.border-opacity-10 {\r\n            border-color: rgba($orange,0.1) !important;\r\n        }\r\n        &.border-opacity-25 {\r\n            border-color: rgba($orange,0.25) !important;\r\n        }\r\n        &.border-opacity-50 {\r\n            border-color: rgba($orange,0.50) !important;\r\n        }\r\n        &.border-opacity-75 {\r\n            border-color: rgba($orange,0.75) !important;\r\n        }\r\n        &.border-opacity-100 {\r\n            border-color: rgba($orange,1) !important;\r\n        }\r\n    }\r\n    &.border-opacity-10 {\r\n        --bs-border-opacity: 0.1 !important;\r\n    }\r\n    &.border-opacity-25 {\r\n        --bs-border-opacity: 0.25 !important;\r\n    }\r\n    &.border-opacity-50 {\r\n        --bs-border-opacity: 0.5 !important;\r\n    }\r\n    &.border-opacity-75 {\r\n        --bs-border-opacity: 0.75 !important;\r\n    }\r\n    &.border-opacity-100 {\r\n        --bs-border-opacity: 1 !important;\r\n    }\r\n    &.border-1 {\r\n        border-width: 1px !important;\r\n    }\r\n    &.border-2 {\r\n        border-width: 2px !important;\r\n    }\r\n    &.border-3 {\r\n        border-width: 3px !important;\r\n    }\r\n    &.border-4 {\r\n        border-width: 4px !important;\r\n    }\r\n    &.border-5 {\r\n        border-width: 5px !important;\r\n    }\r\n    &.border-block-start-dashed {\r\n        border-top-style: dashed;\r\n    }\r\n    &.border-block-start-dotted {\r\n        border-top-style: dotted;\r\n    }\r\n    &.border-inline-end-dashed {\r\n        border-inline-end-style: dashed;\r\n    }\r\n    &.border-inline-end-dotted {\r\n        border-inline-end-style: dotted;\r\n    }\r\n    &.border-block-end-dashed {\r\n        border-bottom-style: dashed;\r\n    }\r\n    &.border-block-end-dotted {\r\n        border-bottom-style: dotted;\r\n    }\r\n    &.border-inline-start-dashed {\r\n        border-inline-start-style: dashed;\r\n    }\r\n    &.border-inline-start-dotted {\r\n        border-inline-start-style: dotted;\r\n    }\r\n    &.border-0 {\r\n        border: 0 !important;\r\n    }\r\n    &.border-top-0 {\r\n        border-block-start: 0 !important;\r\n    }\r\n    &.border-end-0 {\r\n        border-inline-end: 0 !important;\r\n    }\r\n    &.border-bottom-0 {\r\n        border-block-end: 0 !important;\r\n    }\r\n    &.border-start-0 {\r\n        border-inline-start: 0 !important;\r\n    }\r\n}\r\n.border-top {\r\n    border-top: 1px solid $border-color !important;\r\n    &.border-block-start-dashed {\r\n        border-top-style: dashed !important;\r\n    }\r\n    &.border-block-start-dotted {\r\n        border-top-style: dotted !important;\r\n    }\r\n    &.border-primary {\r\n        border-color: $primary !important;\r\n    }\r\n    &.border-secondary {\r\n        border-color: $secondary !important;\r\n    }\r\n    &.border-warning {\r\n        border-color: $warning !important;\r\n    }\r\n    &.border-info {\r\n        border-color: $info !important;\r\n    }\r\n    &.border-success {\r\n        border-color: $success !important;\r\n    }\r\n    &.border-danger {\r\n        border-color: $danger !important;\r\n    }\r\n    &.border-light {\r\n        border-color: $light !important;\r\n    }\r\n    &.border-dark {\r\n        border-color: $dark !important;\r\n    }\r\n}\r\n.border-end {   \r\n    border-inline-end: 1px solid $border-color !important;\r\n    &.border-inline-end-dashed {\r\n        border-inline-end-style: dashed !important;\r\n    }\r\n    &.border-inline-end-dotted {\r\n        border-inline-end-style: dotted !important;\r\n    }\r\n    &.border-primary {\r\n        border-color: $primary !important;\r\n    }\r\n    &.border-secondary {\r\n        border-color: $secondary !important;\r\n    }\r\n    &.border-warning {\r\n        border-color: $warning !important;\r\n    }\r\n    &.border-info {\r\n        border-color: $info !important;\r\n    }\r\n    &.border-success {\r\n        border-color: $success !important;\r\n    }\r\n    &.border-danger {\r\n        border-color: $danger !important;\r\n    }\r\n    &.border-light {\r\n        border-color: $light !important;\r\n    }\r\n    &.border-dark {\r\n        border-color: $dark !important;\r\n    }\r\n}\r\n.border-bottom {\r\n    border-bottom: 1px solid $border-color !important;\r\n    &.border-block-end-dashed {\r\n        border-bottom-style: dashed !important;\r\n    }\r\n    &.border-block-end-dotted {\r\n        border-bottom-style: dotted !important;\r\n    }\r\n    &.border-primary {\r\n        border-color: $primary !important;\r\n    }\r\n    &.border-secondary {\r\n        border-color: $secondary !important;\r\n    }\r\n    &.border-warning {\r\n        border-color: $warning !important;\r\n    }\r\n    &.border-info {\r\n        border-color: $info !important;\r\n    }\r\n    &.border-success {\r\n        border-color: $success !important;\r\n    }\r\n    &.border-danger {\r\n        border-color: $danger !important;\r\n    }\r\n    &.border-light {\r\n        border-color: $light !important;\r\n    }\r\n    &.border-dark {\r\n        border-color: $dark !important;\r\n    }\r\n}\r\n.border-start {\r\n    border-inline-start: 1px solid $border-color !important;\r\n    &.border-inline-start-dashed {\r\n        border-inline-start-style: dashed !important;\r\n    }\r\n    &.border-inline-start-dotted {\r\n        border-inline-start-style: dotted !important;\r\n    }\r\n    &.border-primary {\r\n        border-color: $primary !important;\r\n    }\r\n    &.border-secondary {\r\n        border-color: $secondary !important;\r\n    }\r\n    &.border-warning {\r\n        border-color: $warning !important;\r\n    }\r\n    &.border-info {\r\n        border-color: $info !important;\r\n    }\r\n    &.border-success {\r\n        border-color: $success !important;\r\n    }\r\n    &.border-danger {\r\n        border-color: $danger !important;\r\n    }\r\n    &.border-light {\r\n        border-color: $light !important;\r\n    }\r\n    &.border-dark {\r\n        border-color: $dark !important;\r\n    }\r\n}\r\n.br-1 {\r\n    border-radius: 0.0625rem;\r\n}\r\n.br-2 {\r\n    border-radius: 0.125rem;\r\n}\r\n.br-3 {\r\n    border-radius: 0.1875rem;\r\n}\r\n.br-4 {\r\n    border-radius: 0.25rem;\r\n}\r\n.br-5 {\r\n    border-radius: 0.3125rem;\r\n}\r\n.br-6 {\r\n    border-radius: 0.375rem;\r\n}\r\n.br-7 {\r\n    border-radius: 0.4375rem;\r\n}\r\n.br-8 {\r\n    border-radius: 0.5rem;\r\n}\r\n.br-9 {\r\n    border-radius: 0.5625rem;\r\n}\r\n.br-10 {\r\n    border-radius: 0.625rem;\r\n}\r\n.br-15 {\r\n    border-radius: 0.9375rem;\r\n}\r\n.br-20 {\r\n    border-radius: 1.25rem;\r\n}\r\n.rounded {\r\n    border-radius: $border-radius !important;\r\n}\r\n\r\n",".calendar-events {\r\n    border: 1px solid transparent;\r\n    cursor: move;\r\n\t@include margin-padding(null, 10px 15px);\r\n}\r\n.calendar-events:hover {\r\n\tborder-color: $gray-300;\r\n    background-color: $white;\r\n}\r\n.calendar-events i {\r\n    margin-right: 8px;\r\n}\r\n.calendar {\r\n\tfloat: left;\r\n\tmargin-bottom: 0;\r\n}\r\n.fc-toolbar.fc-header-toolbar {\r\n    margin-bottom: 1.5rem;\r\n}\r\n.none-border .modal-footer {\r\n\tborder-top: none;\r\n}\r\n.fc-toolbar h2 {\r\n\tfont-size: $font-size-18;\r\n\tfont-weight: $font-weight-semibold;\r\n\tfont-family: 'Roboto', sans-serif;\r\n\tline-height: 30px;\r\n\ttext-transform: uppercase;\r\n}\r\n.fc-day-grid-event .fc-time {\r\n\tfont-family: 'Roboto', sans-serif;\r\n}\r\n.fc-day {\r\n\tbackground: $white;\r\n}\r\n.fc-toolbar .fc-state-active,\r\n.fc-toolbar .ui-state-active,\r\n.fc-toolbar button:focus,\r\n.fc-toolbar button:hover,\r\n.fc-toolbar .ui-state-hover {\r\n\tz-index: 0;\r\n}\r\n.fc th.fc-widget-header {\r\n\tbackground: $light-500;\r\n\tfont-size: $font-size-14;\r\n\tline-height: 20px;\r\n\tpadding: 10px 0;\r\n\ttext-transform: uppercase;\r\n}\r\n.fc-unthemed th,\r\n.fc-unthemed td,\r\n.fc-unthemed thead,\r\n.fc-unthemed tbody,\r\n.fc-unthemed .fc-divider,\r\n.fc-unthemed .fc-row,\r\n.fc-unthemed .fc-popover {\r\n\tborder-color: #f3f3f3;\r\n}\r\n.fc-basic-view .fc-day-number, \r\n.fc-basic-view .fc-week-number {\r\n    padding: 2px 5px;\r\n}\r\n.fc-button {\r\n\tbackground: #f1f1f1;\r\n\tborder: none;\r\n\tcolor: #797979;\r\n\ttext-transform: capitalize;\r\n\tbox-shadow: none !important;\r\n\tborder-radius: 3px !important;\r\n\tmargin: 0 3px !important;\r\n\tpadding: 6px 12px !important;\r\n\theight: auto !important;\r\n}\r\n.fc-text-arrow {\r\n\tfont-family: inherit;\r\n\tfont-size: $font-size-16;\r\n}\r\n.fc-state-hover {\r\n\tbackground: #f3f3f3;\r\n}\r\n.fc-state-highlight {\r\n\tbackground: #f0f0f0;\r\n}\r\n.fc-state-down,\r\n.fc-state-active,\r\n.fc-state-disabled {\r\n\tbackground-color: $primary !important;\r\n\tcolor: $white !important;\r\n\ttext-shadow: none !important;\r\n}\r\n.fc-cell-overlay {\r\n\tbackground: #f0f0f0;\r\n}\r\n.fc-unthemed .fc-today {\r\n\tbackground: $white;\r\n}\r\n.fc-event {\r\n\tborder-radius: 2px;\r\n\tborder: none;\r\n\tcolor: $white !important;\r\n\tcursor: move;\r\n\tfont-size: 13px;\r\n\tmargin: 1px 7px;\r\n\tpadding: 5px 5px;\r\n\ttext-align: center;\r\n}\r\n.fc-basic-view td.fc-week-number span {\r\n\tpadding-right: 8px;\r\n\tfont-weight: $font-weight-bold;\r\n\tfont-family: 'Roboto', sans-serif;\r\n}\r\n.fc-basic-view td.fc-day-number {\r\n\tpadding-right: 8px;\r\n\tfont-weight: $font-weight-bold;\r\n\tfont-family: 'Roboto', sans-serif;\r\n}\r\n.event-form .input-group .form-control {\r\n\theight: 40px;\r\n}\r\n.submit-section {\r\n\ttext-align: center;\r\n\tmargin-top: 40px;\r\n}\r\n.submit-btn {\r\n    border-radius: 50px;\r\n    font-size: $font-size-18;\r\n    font-weight: $font-weight-semibold;\r\n    min-width: 200px;\r\n    padding: 10px 20px;\r\n}",".apexcharts-legend.apexcharts-align-center.position-right {\r\n    display: none;\r\n}\r\n.apexcharts-toolbar {\r\n    display: none !important;\r\n}\r\n#sales_charts,\r\n.chart-set{\r\n    overflow: hidden;\r\n}\r\n.apexcharts-canvas {\r\n    width: 100% !important;\r\n}\r\n.h-250 {\r\n    height: 250px;\r\n}\r\n",".chat-user-actives {\r\n    .call-meet-blk {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        align-items: center;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        background: $white;\r\n        border-radius: 5px;\r\n        margin-bottom: 15px;\r\n        padding: 10px;\r\n        @include transition(all 0.5s ease);\r\n        &:hover {\r\n            background-color: $black;\r\n            @include transition(all 0.5s ease);\r\n        }\r\n        .meet-border {\r\n            display: -webkit-box;\r\n            display: -ms-flexbox;\r\n            display: flex;\r\n            align-items: center;\r\n            -webkit-box-align: center;\r\n            -ms-flex-align: center;\r\n            width: 39px;\r\n            height: 39px;\r\n            background: $white;\r\n            border: 0.5px solid $gray-300;\r\n            border-radius: 10px;\r\n            margin-right: 10px;\r\n            svg {\r\n                width: 16px;\r\n                color: $blue;\r\n            }\r\n        }\r\n        .recent-user-titles {\r\n            h5 {\r\n                font-size: $font-size-base;\r\n                font-weight: $font-weight-semibold;\r\n                color: $black;\r\n                margin-bottom: 5px;\r\n                width: 150px;\r\n                white-space: nowrap;\r\n                overflow: hidden;\r\n                text-overflow: ellipsis;\r\n            }\r\n            p {\r\n                font-size: $font-size-10;\r\n                color: $text-color;\r\n            }\r\n        }\r\n    }\r\n}\r\n.new-join-link {\r\n    .chat-user-actives {\r\n        .meet-border {\r\n            background: gray;\r\n            border: 0;\r\n            border-radius: 6px;\r\n            &:hover {\r\n                background: $primary;\r\n                svg {\r\n                    color: $white;\r\n                }\r\n            }\r\n            svg {\r\n                color: $primary;\r\n            }\r\n        }\r\n        .recent-user-titles {\r\n            h5 {\r\n                color: $primary;\r\n                width: 100%;\r\n                margin-bottom: 0;\r\n                font-size: $font-size-15;\r\n            }\r\n        }\r\n    }\r\n}\r\n.meet-chat-blk {\r\n    .join-call {\r\n        .join-video {\r\n            position: relative;\r\n            margin-bottom: 25px;\r\n            img {\r\n                border-radius: 10px;\r\n            }\r\n            .video-avatar {\r\n                color: $white;\r\n                background: #5D5D5D;\r\n                font-size: 50px;\r\n                border-radius: 10px;\r\n                height: 100%;\r\n                width: 100%;\r\n                position: absolute;\r\n                top: 0;\r\n                left: 0;\r\n                display: none;\r\n                align-items: center;\r\n                -webkit-box-align: center;\r\n                -ms-flex-align: center;\r\n                justify-content: center;\r\n                -webkit-justify-content: center;\r\n                -ms-flex-pack: center;\r\n                &.active {\r\n                    display: -webkit-box;\r\n                    display: -ms-flexbox;\r\n                    display: flex;\r\n                    position: relative;\r\n                    height: 426px;\r\n                }\r\n            }\r\n            .call-icons {\r\n                text-align: center;\r\n                position: absolute;\r\n                width: 100%;\r\n                height: 100%;\r\n                top: 0;\r\n                .call-items {\r\n                    border-radius: 5px;\r\n                    padding: 0;\r\n                    margin: 0;\r\n                    list-style: none;\r\n                    display: -webkit-inline-box;\r\n                    display: -ms-inline-flexbox;\r\n                    display: inline-flex;\r\n                    position: absolute;\r\n                    bottom: 30px;\r\n                    left: 50%;\r\n                    transform: translate(-50%, 0);\r\n                    .call-item {\r\n                        display: inline-block;\r\n                        text-align: center;\r\n                        margin-right: 15px;\r\n                        &:last-child {\r\n                            margin-right: 0px;\r\n                        }\r\n                        a {\r\n                            color: $white;\r\n                            background: $white;\r\n                            border-radius: 10px;\r\n                            width: 54px;\r\n                            height: 54px;\r\n                            display: -webkit-box;\r\n                            display: -ms-flexbox;\r\n                            display: flex;\r\n                            align-items: center;\r\n                            -webkit-box-align: center;\r\n                            -ms-flex-align: center;\r\n                            justify-content: center;\r\n                            -webkit-justify-content: center;\r\n                            -ms-flex-pack: center;\r\n                            font-size: $font-size-20;\r\n                            white-space: nowrap;\r\n                            @include respond-below(custom767) {\r\n                                width: 45px;\r\n                                height: 45px;\r\n                            }\r\n                            i {\r\n                                color: $text-color;\r\n                            }\r\n                            &.stop {\r\n                                color: $white;\r\n                                background: $danger;\r\n                                i {\r\n                                    color: $white;\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n            .meet-drop {\r\n                ul {\r\n                    li {\r\n                        i {\r\n                            font-size: $font-size-18;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n            \r\n        }\r\n        .join-content {\r\n            text-align: center;\r\n            max-width: 500px;\r\n            margin: auto;\r\n            h4 {\r\n                font-size: $font-size-22;\r\n                font-weight: $font-weight-semibold;\r\n                margin-bottom: 20px;\r\n                @include respond-below(custom767) {\r\n                    font-size: $font-size-18;\r\n                }\r\n            }\r\n            .event-user-group {\r\n                margin-bottom: 10px;\r\n                .avatar-group {\r\n                    .avatar {\r\n                        width: 38px;\r\n                        height: 38px;\r\n                        border: 3px solid $white;\r\n                        &+.avatar {\r\n                            margin-left: -20px;\r\n                        }\r\n                        .avatar-title {\r\n                            color: $black;\r\n                            font-size: $font-size-base;\r\n                            font-weight: $font-weight-semibold;\r\n                            background: gray;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n            p {\r\n                font-size: $font-size-13;\r\n                color: $text-color;\r\n            }\r\n            .btn-join-call {\r\n                .btn-primary {\r\n                    background: $primary;\r\n                    border-radius: 6px 6px 6px 6px;\r\n                    color: $white;\r\n                    font-size: $font-size-base;\r\n                    border: 1px solid $primary;\r\n                    font-weight: $font-weight-semibold;\r\n                    min-width: 105px;\r\n                    padding: 8px 15px;\r\n                    &:hover {\r\n                        background: $danger;\r\n                        border: 1px solid gray;\r\n                        color: $primary;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.conference-meet-group {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    .meeting-list {\r\n        width: 100%;\r\n        transition: all 0.5s ease;\r\n        -moz-transition: all 0.5s ease;\r\n        -o-transition: all 0.5s ease;\r\n        -ms-transition: all 0.5s ease;\r\n        -webkit-transition: all 0.5s ease;\r\n        &.add-meeting {\r\n            width: 65%;\r\n            margin-right: 24px;\r\n            @include respond-below(custom767) {\r\n                display: none;\r\n                margin-right: 0px;\r\n            }\r\n        }\r\n    }\r\n    .right-user-side {\r\n        width: 0;\r\n        opacity: 0;\r\n        transition: all 0.5s ease;\r\n        -moz-transition: all 0.5s ease;\r\n        -o-transition: all 0.5s ease;\r\n        -ms-transition: all 0.5s ease;\r\n        -webkit-transition: all 0.5s ease;\r\n        &.right-side-party {\r\n            width: 0;\r\n            opacity: 0;\r\n            transition: all 0.5s ease;\r\n            -moz-transition: all 0.5s ease;\r\n            -o-transition: all 0.5s ease;\r\n            -ms-transition: all 0.5s ease;\r\n            -webkit-transition: all 0.5s ease;\r\n            .party-msg-blk  {\r\n                .last-call-time {\r\n                    .call-recent {\r\n                        background: none;\r\n                        svg {\r\n                            color: $primary;\r\n                            width: 14px;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n        &.chat-rooms {\r\n            width: 0;\r\n            opacity: 0;\r\n            transition: all 0.5s ease;\r\n            -moz-transition: all 0.5s ease;\r\n            -o-transition: all 0.5s ease;\r\n            -ms-transition: all 0.5s ease;\r\n            -webkit-transition: all 0.5s ease;\r\n            .slime-grp {\r\n                padding: 0;\r\n                .left-chat-title {\r\n                    padding: 20px;\r\n                    border-bottom: 1px solid #E1E8ED;\r\n                    border-radius: 10px 10px 0 0;\r\n                }\r\n            }\r\n            &.open-chats {\r\n                width: 35%;\r\n                opacity: 1;\r\n                @include respond-below(custom767) {\r\n                    width: 100%;\r\n                }\r\n            }\r\n        }\r\n        &.open-message {\r\n            width: 35%;\r\n            opacity: 1;\r\n            @include respond-below(custom767) {\r\n                width: 100%;\r\n            }\r\n        }\r\n    }\r\n}\r\n.meet-drop {\r\n    background: rgba(255, 255, 255, 0.6);\r\n    border-radius: 10px;\r\n    position: absolute;\r\n    top: 20px;\r\n    right: 20px;\r\n    ul {\r\n        li {\r\n            .chats-dot {\r\n                a {\r\n                    width: 50px;\r\n                    height: 50px;\r\n                    color: #6B7280;\r\n                    display: -webkit-box;\r\n                    display: -ms-flexbox;\r\n                    display: flex;\r\n                    align-items: center;\r\n                    -webkit-box-align: center;\r\n                    -ms-flex-align: center;\r\n                    justify-content: center;\r\n                    -webkit-justify-content: center;\r\n                    -ms-flex-pack: center;\r\n                    @include respond-below(custom767) {\r\n                        width: 38px;\r\n                        height: 38px;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    &.meet-mutes {\r\n        background: $primary;\r\n        right: inherit;\r\n        left: 20px;\r\n        ul {\r\n            li {\r\n                a {\r\n                    color: $white;\r\n                    width: 50px;\r\n                    height: 50px;\r\n                    display: -webkit-box;\r\n                    display: -ms-flexbox;\r\n                    display: flex;\r\n                    align-items: center;\r\n                    -webkit-box-align: center;\r\n                    -ms-flex-align: center;\r\n                    justify-content: center;\r\n                    -webkit-justify-content: center;\r\n                    -ms-flex-pack: center;\r\n                    @include respond-below(custom767) {\r\n                        width: 38px;\r\n                        height: 38px;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    &.meet-mutes-bottom {\r\n        background: $primary;\r\n        bottom: 20px;\r\n        border-radius: 50px;\r\n        top: inherit;\r\n        ul {\r\n            li {\r\n                a {\r\n                    color: $white;\r\n                    width: 50px;\r\n                    height: 50px;\r\n                    display: -webkit-box;\r\n                    display: -ms-flexbox;\r\n                    display: flex;\r\n                    align-items: center;\r\n                    -webkit-box-align: center;\r\n                    -ms-flex-align: center;\r\n                    justify-content: center;\r\n                    -webkit-justify-content: center;\r\n                    -ms-flex-pack: center;\r\n                    @include respond-below(custom767) {\r\n                        width: 38px;\r\n                        height: 38px;\r\n                    }\r\n                    i {\r\n                        font-size: $font-size-20;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.meet-call-menu-blk {\r\n    .video-call-action {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        align-items: center;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        justify-content: center;\r\n        -webkit-justify-content: center;\r\n        -ms-flex-pack: center;\r\n        @include respond-below(custom767) {\r\n            display: block;\r\n        }\r\n        ul {\r\n\t\t\tdisplay: -webkit-box;\r\n            display: -ms-flexbox;\r\n            display: flex;\r\n            align-items: center;\r\n            -webkit-box-align: center;\r\n            -ms-flex-align: center;\r\n            justify-content: center;\r\n            -webkit-justify-content: center;\r\n            -ms-flex-pack: center;\r\n            li {\r\n                margin-right: 5px;\r\n                &:last-child {\r\n                    margin-right: 0;\r\n                }\r\n                a {\r\n                    width: 40px;\r\n                    height: 40px;\r\n                    border-radius: 50px;\r\n                    background: #D9D9D9;\r\n                    border: 1px solid #D9D9D9;\r\n                    display: -webkit-box;\r\n                    display: -ms-flexbox;\r\n                    display: flex;\r\n                    align-items: center;\r\n                    -webkit-box-align: center;\r\n                    -ms-flex-align: center;\r\n                    justify-content: center;\r\n                    -webkit-justify-content: center;\r\n                    -ms-flex-pack: center;\r\n                    color: $black;\r\n\t\t\t\t\tfont-size: $font-size-18;\r\n                    &.call-end {\r\n                        background-color: $danger;\r\n                        border-color: $danger;\r\n                        color: $white;\r\n\t\t\t\t\t\twidth: 60px;\r\n                    \theight: 60px;\r\n\t\t\t\t\t\trotate: 135deg;\r\n\t\t\t\t\t\tfont-size: $font-size-20;\r\n                    }\r\n                    &.stop {\r\n                        color: $white;\r\n                        background: $danger;\r\n                        border-color: $danger;\r\n                        i {\r\n                            color: $white;\r\n                        }\r\n                    }\r\n                }\r\n                &.active {\r\n                    a {\r\n                        background: $primary;\r\n                        border-color: $primary;\r\n                        color: $white;\r\n                        img {\r\n                            filter: invert(1) brightness(100);\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n            @include respond-below(custom767) {\r\n                margin-bottom: 5px;\r\n                justify-content: center;\r\n            }\r\n            &:last-child {\r\n                @include respond-below(custom767) {\r\n                    margin-bottom: 0px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.recession-meet-blk {\r\n\tdisplay: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    align-items: center;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    justify-content: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: space-between;\r\n    -webkit-justify-content: space-between;\r\n    -ms-flex-pack: space-between;\r\n    margin-bottom: 30px;\r\n    @include respond-below(custom767) {\r\n        display: block;\r\n    }\r\n    .reccession-head {\r\n        @include respond-below(custom767) {\r\n            margin-bottom: 5px;\r\n        }\r\n        h5 {\r\n            font-size: $font-size-20;\r\n            font-weight: $font-weight-bold;\r\n\t\t\tcolor: $gray-900;\r\n            margin-bottom: 0px;\r\n            @include respond-below(custom767) {\r\n                font-size: $font-size-18;\r\n            }\r\n        }\r\n        ul {\r\n            li {\r\n                font-size: $font-size-15;\r\n                font-weight: $font-weight-normal;\r\n                color: $text-color;\r\n                margin-right: 25px;\r\n                &:last-child {\r\n                    margin-right: 0px;\r\n                }\r\n                @include respond-below(custom767) {\r\n                    margin-bottom: 10px\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .partispant-blk {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        .btn-primary {\r\n            background: #1b2950;\r\n            border-radius: 6px;\r\n            color: $white;\r\n            border: 1px solid #1b2950;\r\n            margin-right: 10px;\r\n            font-weight: $font-weight-bold;\r\n            font-size: $font-size-base;\r\n\t\t\t&:hover {\r\n\t\t\t\tbackground: $primary;\r\n\t\t\t\tborder: 1px solid $primary;\r\n\t\t\t}\r\n            @include respond-below(custom767) {\r\n                font-size: $font-size-13;\r\n            }\r\n            display: -webkit-box;\r\n            display: -ms-flexbox;\r\n            display: flex;\r\n            align-items: center;\r\n            -webkit-box-align: center;\r\n            -ms-flex-align: center;\r\n            &:last-child {\r\n                margin-right: 0;\r\n            }\r\n        }\r\n        span {\r\n            a {\r\n                width: 42px;\r\n                height: 42px;\r\n                background: $light-900;\r\n                border-radius: 5px;\r\n                color: $text-color;\r\n\t\t\t\tfont-size: $font-size-18;\r\n                display: -webkit-box;\r\n                display: -ms-flexbox;\r\n                display: flex;\r\n                align-items: center;\r\n                -webkit-box-align: center;\r\n                -ms-flex-align: center;\r\n                justify-content: center;\r\n                -webkit-justify-content: center;\r\n                -ms-flex-pack: center;\r\n\t\t\t\t&:hover {\r\n\t\t\t\t\tbackground: $primary;\r\n\t\t\t\t\tcolor: $white;\r\n\t\t\t\t}\r\n            }\r\n        }\r\n    }\r\n}\r\n.recording-time {\r\n    position: relative;\r\n    padding-left: 20px;\r\n    &::before {\r\n        content: \"\";\r\n        position: absolute;\r\n        left: 0px;\r\n        top: 4px;\r\n        background-color: $danger;\r\n        width: 13px;\r\n        height: 13px;\r\n        border-radius: 50px;\r\n    }\r\n    &::after {\r\n        content: \"\";\r\n        position: absolute;\r\n        left: 3px;\r\n        top: 7px;\r\n        background-color: $white;\r\n        width: 7px;\r\n        height: 7px;\r\n        border-radius: 50px;\r\n        animation: blink-animation 1.5s steps(5, start) infinite;\r\n        -webkit-animation: blink-animation 1.5s steps(5, start) infinite;\r\n    }\r\n}\r\n\r\n.page-content {\r\n\twidth: 100%;\r\n}\r\n.join-call {\r\n    width: 100%;\r\n    margin: 0 auto;\r\n}\r\n.join-video {\r\n\tposition: relative;\r\n\tmargin-bottom: 25px;\r\n    img {\r\n        border-radius: 10px;\r\n        width: 100%;\r\n        height: 100%;\r\n        object-fit: cover;\r\n    }\r\n    &.join-video-front {\r\n        img {\r\n            height: 423px;\r\n        }      \r\n    }\r\n}\r\n.video-avatar {\r\n    color: $white;\r\n    background: #5D5D5D;\r\n    font-size: 50px;\r\n    border-radius: 10px;\r\n    height: 100%;\r\n    width: 100%;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    display: none;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    -webkit-box-pack: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    h4 {\r\n        font-weight: $font-weight-bold;\r\n        font-size: $font-size-24;\r\n        color: $white;\r\n    }\r\n}\r\n.video-avatar.active {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n}\r\n.join-video.video-hide > img, \r\n.video-wrap.video-hide > video {\r\n    display: none;\r\n}\r\n.join-content {\r\n    p {\r\n        font-weight: $font-weight-normal;\r\n        font-size: $font-size-14;\r\n        margin-bottom: 25px;\r\n        color: $black;\r\n    }\r\n    label {\r\n        font-size: $font-size-18;\r\n        margin-bottom: 0;\r\n        color: $black;\r\n        font-weight: $font-weight-bold;\r\n    }\r\n}\r\n.part-name {\r\n\tposition: absolute;\r\n\ttop: 20px;\r\n\tleft: 12px;\r\n\ttext-align: left;\r\n    background: rgba(255, 255, 255, 0.6);\r\n    border-radius: 50px;\r\n    padding: 5px 15px;\r\n    h4 {\r\n        font-weight: $font-weight-medium;\r\n        font-size: $font-size-15;\r\n        color: $text-color; \r\n        margin-bottom: 0;\r\n        overflow: hidden;\r\n        white-space: nowrap;\r\n        text-overflow: ellipsis;\r\n        @include respond-below(custom767) {\r\n            font-size: $font-size-13;\r\n        }\r\n    }\r\n    &.sub-part-name {\r\n        background: $white;\r\n        bottom: 10px;\r\n        top: inherit;\r\n        h4 {\r\n            color: $gray-900;\r\n            font-size: $font-size-12;\r\n        }\r\n    }\r\n}\r\n.grid-join {\r\n    .part-name {\r\n        background: rgba(0, 0, 0, 0.3);\r\n        top: inherit;\r\n        bottom: 20px;\r\n        h4 {\r\n            color: $white;\r\n        }\r\n    }\r\n}\r\n.join-hover-img {\r\n    position: absolute;\r\n    @include position-alignment(both);\r\n    .event-user-group {\r\n        .avatar-group {\r\n            background: rgba(0, 0, 0, 0.3);\r\n            padding: 2px 10px;\r\n            border-radius: 50px;\r\n            .avatar {\r\n                width: 26px;\r\n                height: 26px;\r\n                border: 1px solid $white;\r\n                &+.avatar {\r\n                    margin-left: -16px;\r\n                }\r\n                &:last-child {\r\n                    margin-right: 0px;\r\n                }\r\n                .avatar-title {\r\n                    color: #1F2937;\r\n                    font-size: 12px;\r\n                    font-weight: $font-weight-semibold;\r\n                    background: #F3F4F6;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.more-icon {\r\n\tposition: absolute;\r\n\tbottom: 10px;\r\n\tright: 12px;\r\n    @include respond-below(custom767) {\r\n        bottom: 8px;\r\n        right: 13px;\r\n    }\r\n    a {\r\n        color: $text-color;\r\n        width: 30px;\r\n        height: 30px;\r\n        background: $white;\r\n        border-radius: 50px;\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        align-items: center;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        justify-content: center;\r\n        -webkit-justify-content: center;\r\n        -ms-flex-pack: center;\r\n        &:hover {\r\n            opacity: 0.8;\r\n        }\r\n        &.other-mic-off {\r\n            &.stop {\r\n                i {\r\n                    color: $danger;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    &.audio-more-icon {\r\n        a {\r\n            &.other-mic-off {\r\n                &.stop {\r\n                    background-color: $danger !important;\r\n                    i {\r\n                        color: $white;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.call-recent {\r\n    &.recent-part {\r\n        a {\r\n            &.other-mic-off, &.other-video-off {\r\n                &.stop {\r\n                    background: $danger !important;\r\n                    i {\r\n                        color: $white;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.meeting {\r\n    .part-name {\r\n        top: 15px;\r\n        left: 15px;\r\n    }\r\n    .more-icon {\r\n        top: 15px;\r\n        right: 15px;\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n    }\r\n}\r\n.vertical-view {\r\n    .vertical-sec {\r\n        .part-name {\r\n            h4 {\r\n                font-size: $font-size-14;\r\n\t            font-weight: $font-weight-normal;\r\n            }\r\n        }\r\n    }\r\n}\r\n.horizontal-view {\r\n    .join-video {\r\n        &.single-user {\r\n            .part-name h4 {\r\n                font-size: $font-size-14;\r\n                font-weight: $font-weight-normal;\r\n            }\r\n        }\r\n    }\r\n}\r\n.meeting-wrapper, .meeting {\r\n\twidth: inherit;\r\n\tmax-width: inherit;\r\n}\r\n.meet-footer {\r\n\tposition: fixed;\r\n\tbottom: 25px;    \r\n\twidth: 100%;\r\n\tmax-width: 950px;\r\n\tleft: 50%;\r\n    transform: translate(-50%, 0);\r\n\tz-index: 3;\r\n}\r\n.show-chat-list, .show-invite-list,\r\n.show-chat-list .user-sidebar-right,\r\n.show-invite-list .invite-sidebar-right {\r\n    transition: all 0.8s ease;\r\n}\r\n.user-sidebar-right, .invite-sidebar-right {\r\n    background: #dedede;\r\n\tborder-radius: 10px;\r\n    width: 410px;\r\n    position: absolute;\r\n    top: 105px;\r\n    bottom: 117px;\r\n    right: 0;\r\n    margin-right: -410px;\r\n    transition: all 0.8s ease;\r\n    overflow: hidden;\r\n    font-size: 13px;\r\n\tz-index: 3;\r\n}\r\n.join-contents {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\tflex-wrap: wrap;\r\n\talign-content: flex-start;\r\n\tbox-sizing: border-box;\r\n\twidth: 100%;\r\n\tmargin: 0 auto;\r\n\toverflow: hidden;\r\n    &.grid-view {\r\n        align-content: center;\r\n    }\r\n}\r\n.ripple {\r\n\twidth: 114px;\r\n    height: 114px;\r\n    background: rgba(0, 0, 0, 0.2);\r\n    border-radius: 50%;\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    -webkit-box-pack: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n}\r\n.multigrid-view {\r\n    .text-box {\r\n        height: 61px;\r\n        width: 61px;\r\n    }\r\n}\r\n.multigrid-view {\r\n    .ripple {\r\n        width: 80px;\r\n        height: 80px;\r\n        background: rgba(0, 0, 0, 0.2);\r\n        border-radius: 50%;\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        align-items: center;\r\n        -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n        justify-content: center;\r\n    }\r\n}\r\n.meeting {\r\n    .join-video {\r\n        margin: 0 5px 10px;\t\r\n        width: 100%;\r\n    }\r\n}\r\n.join-video {\r\n    &.user-active {\r\n        background: #415B6A;\r\n        border-radius: 10px;\r\n        width: 100%;\r\n        height: 370px;\r\n        &.audio-calls {\r\n            height: 520px;\r\n        }\r\n    }\r\n    &.vertical-active {\r\n        margin-right: 24px;\r\n    }\r\n    &.single-user {\r\n        width: 100%;\t\r\n        min-height: 230px;\r\n        box-sizing: border-box;\r\n        margin-right: 24px;\r\n        -webkit-box-pack: justify;\r\n        -ms-flex-pack: justify;\r\n        justify-content: space-between;\r\n        text-align: center;\r\n        height: auto;\r\n        background: #415B6A;\r\n        border-radius: 10px;\r\n        padding: 0;\r\n        flex-grow: 1;\r\n        @include respond-below(custom1280) {\r\n            width: 100%;\r\n        }\r\n        @include respond-below(custom1199) {\r\n            min-height: 203px;\r\n        }\r\n        @include respond-below(custom991) {\r\n            min-height: 230px;\r\n        }\r\n        &:nth-child(even) {\r\n            margin-right: 0px;\r\n            @include respond-below(custom767) {\r\n                margin-right: 10px;\r\n            }\r\n        }\r\n        @include respond-below(custom767) {\r\n            width: 100%;\r\n            min-height: 257px;\r\n        }\r\n    }\r\n\r\n}\r\n.multi-grid {\r\n    .join-video.single-user {\r\n        @include respond-below(custom767) {\r\n           width: 45%;\r\n        }\r\n        &:nth-child(even) {\r\n            margin-right: 24px;\r\n            @include respond-below(custom767) {\r\n                margin-right: 0px;\r\n            }\r\n        }\r\n        &:nth-child(4n) {\r\n            margin-right: 0px;\r\n            @include respond-below(custom767) {\r\n                &:nth-child(4n) {\r\n                    margin-right: 0px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.multigrid-view {\r\n    .join-video {\r\n        &.single-user {\r\n            flex-grow: 0;\r\n        }\r\n    }\r\n}\r\n.horizontal-view {\r\n    .join-video.single-user {\r\n        &:nth-child(even) {\r\n            margin-right: 24px;\r\n        }\r\n        &:nth-child(5) {\r\n            margin-right: 0px;\r\n        }\r\n        &:nth-child(3n) {\r\n            @include respond-below(custom767) {\r\n                margin-right: 0\r\n            }\r\n        }\r\n    }\r\n}\r\n.text-avatar {\r\n\tcolor: $white;\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    h4 {\r\n        color: $white;\r\n    }\r\n}\r\n.text-box {\r\n    height: 86px;\r\n    width: 86px;\t\r\n    border-radius: 50%;\r\n    background-color: rgba(0, 0, 0, 0.2);\r\n    font-size: $font-size-36;\r\n\tfont-weight: $font-weight-bold;\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    -webkit-box-pack: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n}\r\n.more-icon.mic-view .mic-on, .more-icon .mic-off {\r\n\tdisplay: none;\r\n}\r\n.more-icon.mic-view .mic-off {\r\n    display: inline-flex;\r\n}\r\n.grid-view .join-video.single-user {\r\n    width: 47%;\t\r\n    @include respond-below(custom767) {\r\n        width: 40%;\t\r\n    }\r\n    &:nth-child(2n) {\r\n        @include respond-below(custom767) {\r\n            margin-right: 0px;\r\n        }\r\n    }\r\n    &:nth-child(3n) {\r\n        @include respond-below(custom767) {\r\n            margin-right: 24px;\r\n        }\r\n    }\r\n}\r\n\r\n.join-contents.multigrid-view {\r\n\tmax-width: 100%;\r\n\tjustify-content: center;\r\n}\r\n.meeting {\t\r\n\tposition: absolute;\r\n\ttop: 80px;\r\n\tbottom: 107px;\r\n\tleft: 0;\r\n\tright: 0;\r\n}\r\n.meeting-list {\r\n\tflex-direction: column;\r\n\theight: 100%;\r\n\twidth: 100%;\r\n\tposition: relative;\r\n}\r\n.user-active {\r\n    .more-icon {\r\n        .handraise-on {\r\n            display: none;\r\n            &.active {\r\n                display: block;\r\n                animation: mymove 5s;\r\n            }\r\n        }\r\n    }\r\n}\r\n.user-active .more-icon .handraise-on.active .meeting .join-video.user-active::before {\r\n\tanimation: mymove 5s infinite;\r\n\topacity: 1;\r\n}\r\n@keyframes mymove {\r\n\tfrom {color: #0074E0;}\r\n\tto {color: transparent;}\r\n}\r\n.join-contents {\r\n    &.vertical-view {\r\n        display: -webkit-flex;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        align-items: center;\r\n        align-content: center;\r\n        max-width: 1300px;\r\n        @include respond-below(custom767) {\r\n            display: block;\r\n        }\r\n        .join-video {\r\n            &.user-active {\r\n                flex: 1;\r\n                margin-bottom: 24px;;\r\n            }\r\n            &.single-user {\r\n                width: 97%;\r\n                flex-grow: 1;\r\n                display: flex;\r\n                @include respond-below(custom767) {\r\n                    width: 100%;\r\n                }\r\n            }\r\n        }\r\n        .vertical-sec {\r\n            width: 20%;\r\n            @include respond-below(custom991) {\r\n                width: 30%;\r\n            }\r\n            @include respond-below(custom767) {\r\n                width: 100%;\r\n            }\r\n        }\r\n    }\r\n    &.vertical {\r\n        flex-direction: column;\r\n        height: 200px;\r\n    }\r\n}\r\n.meeting .join-contents.vertical .join-video.user-active {\r\n\tflex: 1 0 100%;\r\n}\r\n.meeting .join-contents.vertical .join-video.single-user {\r\n\tflex: 0;\r\n}\r\n.meeting .join-contents.vertical .join-video {\r\n\twidth: auto;\r\n}\r\n.chat-footer .btn:hover {\r\n\tbackground: #0066c5;\r\n\tcolor: $white;\r\n}\r\n.join-contents {\r\n    &.show-whiteboard {\r\n        display: none;\r\n    }\r\n    &.single-view {\r\n        padding-top: 0;\r\n        margin-top: 25px;\r\n        position: relative;\r\n        .single-user {\r\n            position: absolute;\r\n            right: 8px;\r\n            top: 40px;\r\n            width: 130px;\r\n            height: 130px ;\r\n            min-height: 130px ;\r\n            img {\r\n                height: 130px ;\t\r\n            }\r\n        }\r\n    }\r\n}\r\n.record-time {\r\n    position: absolute;\r\n    top: 20px;\r\n    z-index: 1;\r\n    position: absolute;\r\n    left: 20px;\r\n\tspan {\r\n\t\tbackground-color: rgba(255, 255, 255, 0.2);\r\n\t\tdisplay: inline-block;\r\n\t\tborder-radius: 130px;\r\n\t\tcolor: $white;\r\n\t\tfont-size: $font-size-14;\r\n\t\tfont-weight: $font-weight-semibold;\r\n\t\twidth: 80px;\r\n\t\theight: 30px;\r\n\t\ttext-align: center;\r\n\t\tline-height: 34px;\r\n\t\tposition: relative;\r\n\t\tpadding-left: 15px;\r\n\t\t&:before {\r\n\t\t\tcontent: \"\";\r\n\t\t\tposition: absolute;\r\n\t\t\tleft: 7px;\r\n\t\t\ttop: 7px;\r\n\t\t\tbackground-color: $white;\r\n\t\t\twidth: 18px;\r\n\t\t\theight: 18px;\r\n\t\t\tborder-radius: 50px;\r\n\t\t}\r\n\t\t&:after {\r\n\t\t\tcontent: \"\";\r\n\t\t\tposition: absolute;\r\n\t\t\tleft: 12px;\r\n\t\t\ttop: 12px;\r\n\t\t\tbackground-color: $danger;\r\n\t\t\twidth: 8px;\r\n\t\t\theight: 8px;\r\n\t\t\tborder-radius: 50px;\r\n\t\t\tanimation: blink-animation 1.5s steps(5, start) infinite;\r\n\t\t\t-webkit-animation: blink-animation 1.5s steps(5, start) infinite;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@keyframes blink-animation {\r\n\tto {\r\n\t\tvisibility: hidden;\r\n\t}\r\n}\r\n\r\n@-webkit-keyframes blink-animation {\r\n\tto {\r\n\t\tvisibility: hidden;\r\n\t}\r\n}\r\n.volume-col {\r\n\tposition: absolute;\r\n\tleft: 20px;\r\n\tbottom: 20px;\r\n}\r\n.volume-col .inner-volume-col {\r\n\tbackground-color: $gray-300;\r\n    border-radius: 130px;\r\n    width: 30px;\r\n    height: 120px;\r\n    position: relative;\r\n    z-index: 9;\r\n}\r\n.volume-col #volume {\r\n\tposition: absolute;\r\n    left: 50%;\r\n    top: 15px;\r\n    margin: 0 auto;\r\n    height: 80px;\r\n    width: 5px;\r\n    background: $white;\r\n    border-radius: 15px;\r\n    transform: translateX(-50%);\r\n    -webkit-transform: translateX(-50%);\r\n    -ms-transform: translateX(-50%);\r\n}\r\n.volume-col #volume .ui-slider-range-min {\r\n\theight: 5px;\r\n    width: 100%;\r\n    position: absolute;\r\n    bottom: 0;\r\n    background: $primary;\r\n    border: none;\r\n    border-radius: 10px;\r\n    outline: none;\r\n}\r\n.volume-col #volume .ui-slider-handle {\r\n\twidth: 20px;\r\n    height: 20px;\r\n    border-radius: 20px;\r\n    background: $primary;\r\n    position: absolute;\r\n    left: 50%;\r\n    margin-top: -8px;\r\n    cursor: pointer;\r\n    outline: none;\r\n    transform: translateX(-50%);\r\n    -webkit-transform: translateX(-50%);\r\n    -ms-transform: translateX(-50%);\r\n}\r\n.volume-col #player {\r\n\twidth: auto;\r\n    height: 104px;\r\n    position: relative;\r\n    margin: 0 auto;\r\n    top: 0px;\r\n}\r\n\r\n.volume-col #player i {\r\n\tposition: absolute;\r\n\tmargin-top: -6px;\r\n\tcolor: #666;\r\n}\r\n\r\n.volume-col .volume-icons {\r\n\tcolor: $white;\r\n\tmargin-left: 0px;\r\n\tfont-size: $font-size-18;\r\n\tmargin-top: 22px;\r\n}\r\n.chat-msg-blk {\r\n    padding: 15px;\r\n    .chats {\r\n        max-width: 100%;\r\n        margin-bottom: 1.5rem;\r\n        display: flex;\r\n        display: -webkit-flex;\r\n        @include respond-below(custom767) {\r\n            max-width: 100%;\r\n        }\r\n        .chat-action-btns {\r\n            .chat-user-time {\r\n                .chats-dot {\r\n                    a {\r\n                        color: $green;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n        &.chats-right {\r\n            margin-left: auto;\r\n            flex-direction: row-reverse;\r\n            -webkit-flex-direction: row-reverse;\r\n            .chat-content {\r\n                order: 1;\r\n                -webkit-order: 1;\r\n                .message-content {\r\n                    background-color: $light-900;\r\n                    border-radius: 8px;\r\n                    .chat-time {\r\n                        justify-content: flex-start;\r\n                        -webkit-justify-content: flex-start;\r\n                    }\r\n                    .download-col {\r\n                        position: relative;\r\n                         ul {\r\n                            li {\r\n                                margin-right: 8px;\r\n                                &:last-child {\r\n                                    margin-right: 0px;\r\n                                }\r\n                                .image-download-col {\r\n                                    position: relative;\r\n                                    &.image-not-download {\r\n                                        a {\r\n                                            img {\r\n                                                -webkit-filter: blur(4px);\r\n                                                filter: blur(1px);\r\n                                                border-color: $black;\r\n                                            }\r\n                                        }\r\n                                        span {\r\n                                            position: absolute;\r\n                                            @include position-alignment(both);\r\n                                            i {\r\n                                                color: $white;\r\n                                            }\r\n                                        }\r\n                                    }\r\n                                    .download-action {\r\n                                        position: absolute;\r\n                                        right: 8px;\r\n                                        bottom: 8px;\r\n                                        line-height: 0;\r\n                                        a {\r\n                                            color: $white;\r\n                                            font-size: 10px;\r\n                                        }\r\n                                    }\r\n                                    img {\r\n                                        border-radius: 5px;\r\n                                    }\r\n                                }\r\n                            }\r\n                         }\r\n                    }\r\n                    &::before {\r\n                        border-bottom: 6px solid transparent;\r\n                        border-left: 6px solid $light-900;\r\n                        border-right: 0;\r\n                        border-top: 6px solid transparent;\r\n                        content: \"\";\r\n                        height: 0;\r\n                        width: 0;\r\n                        position: absolute;\r\n                        top: 8px;\r\n                        right: -4px;\r\n                        left: auto;\r\n                    }\r\n                }\r\n            }\r\n            .chat-avatar {\r\n                padding: 8px 0px 0 15px;\r\n            }\r\n            .chat-action-btns {\r\n                order: 2;\r\n                -webkit-order: 2;\r\n                display: flex;\r\n                display: -webkit-flex;\r\n                flex-wrap: wrap;\r\n                -webkit-flex-wrap: wrap;\r\n                justify-content: center;\r\n                -webkit-justify-content: center;\r\n                .chat-user-time {\r\n                    .chats-dot {\r\n                        a {\r\n                            color: $green;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n        .chat-avatar {\r\n            padding: 8px 15px 0 8px;\r\n            display: flex;\r\n            display: -webkit-flex;\r\n            align-items: flex-start;\r\n            -webkit-align-items: flex-start;\r\n            flex-shrink: 0;\r\n            .dreams_chat {\r\n                width: 40px;\r\n                height: 40px;\r\n                object-fit: cover;\r\n            }\r\n        }\r\n        .message-content {\r\n            background-color: $light-900;\r\n            border-radius: 8px;\r\n            padding: 10px 20px;\r\n            font-weight: $font-weight-medium;\r\n            margin-bottom: 5px;\r\n            position: relative;\r\n            h4 {\r\n                font-size: $font-size-13;\r\n                color: $gray-900;\r\n                margin-bottom: 0px;\r\n                line-height: 1.4;\r\n                font-weight: $font-weight-medium;\r\n            }\r\n            .chat-time {\r\n                display: -webkit-box;\r\n                display: -ms-flexbox;\r\n                display: flex;\r\n                align-items: center;\r\n                -webkit-box-align: center;\r\n                -ms-flex-align: center;\r\n                justify-content: center;\r\n                -webkit-justify-content: center;\r\n                -ms-flex-pack: center;\r\n                font-size: $font-size-10;\r\n                font-weight: $font-weight-medium;\r\n                color: $green;\r\n                margin-bottom: 0;\r\n                svg {\r\n                    width: 10px;\r\n                }\r\n            }\r\n            &::before {\r\n                border-bottom: 6px solid transparent;\r\n                border-right: 6px solid $light-900;\r\n                border-top: 6px solid transparent;\r\n                content: \"\";\r\n                height: 0;\r\n                width: 0;\r\n                position: absolute;\r\n                top: 8px;\r\n                left: -4px;\r\n                right: auto;\r\n            }\r\n        }\r\n        .chat-profile-name {\r\n            h6 {\r\n                display: -webkit-box;\r\n                display: -ms-flexbox;\r\n                display: flex;\r\n                align-items: center;\r\n                -webkit-box-align: center;\r\n                -ms-flex-align: center;\r\n                justify-content: left;\r\n                -webkit-justify-content: left;\r\n                -ms-flex-pack: left;\r\n                font-size: 8px;\r\n                font-weight: $font-weight-medium;\r\n                color: $text-color;\r\n\t\t\t\ti {\r\n\t\t\t\t\tfont-size: 12px;\r\n\t\t\t\t\tcolor: #008024;\r\n\t\t\t\t}\r\n            }\r\n        }\r\n    }\r\n    .chat-line {\r\n        margin: 0px 0 20px;\r\n        position: relative;\r\n        text-align: center;\r\n        width: 100%;\r\n        &:before {\r\n            content: \"\";\r\n            position: absolute;\r\n            left: 0;\r\n            top: 50%;\r\n            transform: translateY(-50%);\r\n            -webkit-transform: translateY(-50%);\r\n            -ms-transform: translateY(-50%);\r\n            background-color: $green;\r\n            width: 100%;\r\n            height: 1px;\r\n        }\r\n        .chat-date {\r\n            background-color: $green;\r\n            color: $green;\r\n            font-size: $font-size-13;\r\n            padding: 7px 14px;\r\n            border-radius: 3px;\r\n            display: inline-block;\r\n            font-weight: $font-weight-semibold;\r\n            position: relative;\r\n        }\r\n    }\r\n}\r\n.right-user-side {\r\n    &.call-user-side {\r\n        .slime-grp {\r\n            .right-sidebar-profile {\r\n                justify-content: space-between;\r\n                -webkit-justify-content: space-between;\r\n                -ms-flex-pack: space-between;\r\n                border-bottom: 0;\r\n                padding-bottom: 10px;\r\n                .profile-call-blk {\r\n                    display: -webkit-box;\r\n                    display: -ms-flexbox;\r\n                    display: flex;\r\n                    align-items: center;\r\n                    -webkit-box-align: center;\r\n                    -ms-flex-align: center;\r\n                    justify-content: center;\r\n                    -webkit-justify-content: center;\r\n                    -ms-flex-pack: center;\r\n                }\r\n                .edit-group {\r\n                    svg {\r\n                        width: 16px;\r\n                        color: $green;\r\n                    }\r\n                }\r\n            }\r\n            .chat-options {\r\n                display: -webkit-box;\r\n                display: -ms-flexbox;\r\n                display: flex;\r\n                align-items: center;\r\n                -webkit-box-align: center;\r\n                -ms-flex-align: center;\r\n                justify-content: center;\r\n                -webkit-justify-content: center;\r\n                -ms-flex-pack: center;\r\n                border-bottom: 1px solid $green;\r\n                padding-bottom: 20px;\r\n                ul {\r\n                    li {\r\n                        a {\r\n                            color: $green;\r\n                            width: 30px;\r\n                            height: 30px;\r\n                            background-color: gray;\r\n                            padding: 0;\r\n                            border-radius: 50px;\r\n                            &:hover {\r\n                                background: $primary;\r\n                                border-color: $primary;\r\n                                svg {\r\n                                    color: $white;\r\n                                }\r\n                            }\r\n                            svg {\r\n                                width: 15px;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    &.right-side-party {\r\n        .slime-grp {\r\n            padding: 0px;\r\n            .left-chat-title {\r\n                padding: 20px;\r\n                margin-bottom: 0;\r\n                background-color: $body-bg;\r\n                border-radius: 10px 10px 0 0;\r\n                h4 {\r\n                    display: -webkit-box;\r\n                    display: -ms-flexbox;\r\n                    display: flex;\r\n                    align-items: center;\r\n                    -webkit-box-align: center;\r\n                    -ms-flex-align: center;\r\n                    span {\r\n                        display: -webkit-box;\r\n                        display: -ms-flexbox;\r\n                        display: flex;\r\n                        align-items: center;\r\n                        -webkit-box-align: center;\r\n                        -ms-flex-align: center;\r\n                        justify-content: center;\r\n                        -webkit-justify-content: center;\r\n                        -ms-flex-pack: center;\r\n                        width: 25px;\r\n                        height: 25px;\r\n                        background-color: $warning;\r\n                        border-radius: 50px;\r\n                        font-size: $font-size-14;\r\n                        color: $white;\r\n                        margin-left: 10px;\r\n                    }\r\n                }\r\n            }\r\n            .card-body-blk {\r\n                padding: 20px;\r\n                .user-list {\r\n                    border-radius: .25rem;\r\n                    display: flex;\r\n                    display: -webkit-flex;\r\n                    -ms-flex-direction: column;\r\n                    flex-direction: column;\r\n                    padding-left: 0;\r\n                    margin-bottom: 0;\r\n                    .user-list-item {\r\n                        display: -webkit-box;\r\n                        display: -ms-flexbox;\r\n                        display: flex;\r\n                        align-items: center;\r\n                        -webkit-box-align: center;\r\n                        -ms-flex-align: center;\r\n                        padding: 5px;\r\n                        display: flex;\r\n                        display: -webkit-flex;\r\n                        border-radius: 6px;\r\n                        background-color: #F6F7F8;\r\n                        margin-bottom: 10px;\r\n                        border: 0;\r\n                        &:hover {\r\n                            background-color: #F6F7F8;\r\n                            transition: ease all 0.5s;\r\n                            -webkit-transition: ease all 0.5s;\r\n                            -ms-transition: ease all 0.5s;\r\n                        }\r\n                        .avatar {\r\n                            margin-right: 0.8rem;\r\n                            display: inline-block;\r\n                            margin-bottom: 0;\r\n                            height: 40px;\r\n                            width: 40px;\r\n                            position: relative;\r\n                            flex-shrink: 0;\r\n                            &::before {\r\n                                top: 0;\r\n                                bottom: inherit;\r\n                            }\r\n                            img {\r\n                                border-radius: 0px;\r\n                            }\r\n                        }\r\n                        .users-list-body {\r\n                            display: -webkit-box;\r\n                            display: -ms-flexbox;\r\n                            display: flex;\r\n                            align-items: center;\r\n                            -webkit-box-align: center;\r\n                            -ms-flex-align: center;\r\n                            justify-content: space-between;\r\n                            -webkit-justify-content: space-between;\r\n                            -ms-flex-pack: space-between;\r\n                            flex-grow: 1;\r\n                            .name-list-user {\r\n                                display: grid;\r\n                                display: -webkit-box;\r\n                                display: -ms-flexbox;\r\n                                display: flex;\r\n                                align-items: center;\r\n                                -webkit-box-align: center;\r\n                                -ms-flex-align: center;\r\n                                h5 {\r\n                                    font-size: $font-size-15;\r\n                                    font-weight: $font-weight-normal;\r\n                                    margin-bottom: 2px;\r\n                                    color: $text-color;\r\n                                    white-space: nowrap;\r\n                                    overflow: hidden;\r\n                                    text-overflow: ellipsis;\r\n                                }\r\n                                p {\r\n                                    font-size: $font-size-12;\r\n                                    color: $danger;\r\n                                    display: -webkit-box;\r\n                                    display: -ms-flexbox;\r\n                                    display: flex;\r\n                                    align-items: center;\r\n                                    -webkit-box-align: center;\r\n                                    -ms-flex-align: center;\r\n                                    svg {\r\n                                        width: 14px;\r\n                                        height: 14px;\r\n                                    }\r\n                                }\r\n                            }\r\n                            .chat-user-time {\r\n                                .chats-dot {\r\n                                    a {\r\n                                        color: $danger;\r\n                                    }\r\n                                }\r\n                            }\r\n                            .last-chat-time {\r\n                                .text-muted {\r\n                                    font-size: $font-size-10;\r\n                                    color: $gray-900;\r\n                                    font-weight: $font-weight-medium;\r\n                                }\r\n                                .new-message-count {\r\n                                    width: 20px;\r\n                                    height: 20px;\r\n                                    display: flex;\r\n                                    display: -webkit-flex;\r\n                                    align-items: center;\r\n                                    -webkit-align-items: center;\r\n                                    justify-content: center;\r\n                                    -webkit-justify-content: center;\r\n                                    line-height: 0;\r\n                                    font-size: 11px;\r\n                                    background-color: $primary;\r\n                                    color: $white;\r\n                                    border-radius: 50%;\r\n                                    margin-left: auto;\r\n                                    margin-top: 5px;\r\n                                }\r\n                            }\r\n                            .last-call-time {\r\n                                display: -webkit-box;\r\n                                display: -ms-flexbox;\r\n                                display: flex;\r\n                                align-items: center;\r\n                                -webkit-box-align: center;\r\n                                -ms-flex-align: center;\r\n                                .call-recent {\r\n                                    a {\r\n                                        display: -webkit-box;\r\n                                        display: -ms-flexbox;\r\n                                        display: flex;\r\n                                        align-items: center;\r\n                                        -webkit-box-align: center;\r\n                                        -ms-flex-align: center;\r\n                                        justify-content: center;\r\n                                        -webkit-justify-content: center;\r\n                                        -ms-flex-pack: center;\r\n                                        width: 30px;\r\n                                        height: 30px;\r\n                                        background: #B8BCC9;\r\n                                        color: $gray-900;\r\n                                        border-radius: 50px;\r\n                                        svg {\r\n                                            color: $gray-900;\r\n                                        }\r\n                                    }\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .slimScrollDiv {\r\n        height: calc(100vh - 110px) !important;\r\n        .slimscroll {\r\n            height: calc(100vh - 110px) !important;\r\n        }\r\n    }\r\n    .slime-grp {\r\n        background: $white;\r\n\t\tbox-shadow: 0px 4px 60px 0px #E7E7E778;\r\n\t\tborder: 1px solid #E1E8ED;\r\n        border-radius: 10px;\r\n        padding: 15px;\r\n        .left-chat-title {\r\n            display: -webkit-box;\r\n            display: -ms-flexbox;\r\n            display: flex;\r\n            align-items: center;\r\n            -webkit-box-align: center;\r\n            -ms-flex-align: center;\r\n            justify-content: space-between;\r\n            -webkit-justify-content: space-between;\r\n            -ms-flex-pack: space-between;\r\n            margin-bottom: 20px;\r\n\t\t\tbackground-color: $body-bg;\r\n            .chat-title {\r\n                h4 {\r\n                    font-size: $font-size-18;\r\n                    font-weight: $font-weight-semibold;\r\n                    color: $gray-900;\r\n                    margin-bottom: 0;\r\n                }\r\n            }\r\n            .contact-close_call {\r\n                .close_profile {\r\n                    display: -webkit-box;\r\n                    display: -ms-flexbox;\r\n                    display: flex;\r\n                    align-items: center;\r\n                    -webkit-box-align: center;\r\n                    -ms-flex-align: center;\r\n                    justify-content: center;\r\n                    -webkit-justify-content: center;\r\n                    -ms-flex-pack: center;\r\n                    width: 26px;\r\n                    height: 26px;\r\n                    background: transparent;\r\n                    border-radius: 50px;\r\n                    &:hover {\r\n                        background: $primary;\r\n                        svg {\r\n                            color: $white;\r\n                        }\r\n                    }\r\n                    svg {\r\n                        width: 16px;\r\n                        color: $danger;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\t\t.chat-footer {\r\n\t\t\tposition: sticky;\r\n\t\t\tleft: 0px;\r\n\t\t\tright: 0px;\r\n\t\t\tbottom: 0px;\r\n\t\t\tpadding: 15px;\r\n\t\t\tbackground: $white;\r\n\t\t\tform {\r\n\t\t\t\tdisplay: -webkit-box;\r\n                display: -ms-flexbox;\r\n                display: flex;\r\n                align-items: center;\r\n                -webkit-box-align: center;\r\n                -ms-flex-align: center;\r\n\t\t\t\tposition: relative;\r\n\t\t\t\t.comman-icon {\r\n\t\t\t\t\tposition: absolute;\r\n\t\t\t\t\ttop: 50%;\r\n\t\t\t\t\ttransform: translateY(-50%);\r\n\t\t\t\t\t-webkit-transform: translateY(-50%);\r\n\t\t\t\t\t-ms-transform: translateY(-50%);\r\n\t\t\t\t\ta {\r\n\t\t\t\t\t\tcolor: $text-color;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t\t.smile-col {\r\n\t\t\t\t\tright: inherit;\r\n\t\t\t\t\tleft: 15px;\r\n\t\t\t\t}\r\n\t\t\t\t.attach-col {\r\n\t\t\t\t\tright: inherit;\r\n\t\t\t\t\tleft: 45px;\r\n\t\t\t\t}\r\n\t\t\t\t.micro-col {\r\n\t\t\t\t\tright: 50px;\r\n\t\t\t\t\tleft: inherit;\r\n\t\t\t\t\ta {\r\n\t\t\t\t\t\tdisplay: -webkit-box;\r\n\t\t\t\t\t\tdisplay: -ms-flexbox;\r\n\t\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\t\t-webkit-box-align: center;\r\n\t\t\t\t\t\t-ms-flex-align: center;\r\n\t\t\t\t\t\talign-items: center;\r\n\t\t\t\t\t\tfont-size: $font-size-16;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t\t.send-chat {\r\n\t\t\t\t\tright: 5px;\r\n\t\t\t\t\ta {\r\n                        display: -webkit-box;\r\n                        display: -ms-flexbox;\r\n                        display: flex;\r\n                        align-items: center;\r\n                        -webkit-box-align: center;\r\n                        -ms-flex-align: center;\r\n                        justify-content: center;\r\n                        -webkit-justify-content: center;\r\n                        -ms-flex-pack: center;\r\n\t\t\t\t\t\twidth: 34px;\r\n\t\t\t\t\t\theight: 34px;\r\n\t\t\t\t\t\tbackground: $primary;\r\n\t\t\t\t\t\tborder-radius: 50px;\r\n\t\t\t\t\t\t&:hover {\r\n\t\t\t\t\t\t\tbackground: #1b2950;\r\n\t\t\t\t\t\t\tsvg {\r\n\t\t\t\t\t\t\t\tcolor: $white;\r\n\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t\tsvg {\r\n\t\t\t\t\t\t\twidth: 14px;\r\n\t\t\t\t\t\t\tcolor: $white;\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t\t.chat_form {\r\n\t\t\t\t\tborder-radius: 20px;\r\n\t\t\t\t\tmargin-right: 0px;\r\n\t\t\t\t\tbackground: $white;\r\n\t\t\t\t\tborder: 1px solid rgba(145, 158, 171, 0.3);\r\n\t\t\t\t\tborder-radius: 6px;\r\n\t\t\t\t\theight: 48px;\r\n\t\t\t\t\tpadding: 10px 70px;\r\n\t\t\t\t\t&::placeholder {\r\n\t\t\t\t\t\tfont-size: $font-size-base;\r\n\t\t\t\t\t\tcolor: rgba(0, 0, 0, 0.2);\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n    }\r\n}\r\n.owl-carousel.video-slide {\r\n    .owl-nav.disabled {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        align-items: center;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        justify-content: space-between;\r\n        -webkit-justify-content: space-between;\r\n        -ms-flex-pack: space-between;\r\n        width: 100%;\r\n    }\r\n    .owl-nav {\r\n        top: 50%;\r\n        -webkit-transform: translate(0, -50%);\r\n        -ms-transform: translate(0, -50%);\r\n        transform: translate(0, -50%);\r\n        @include respond-below(custom1280) {\r\n            width: 100%;\r\n            display: -webkit-box;\r\n            display: -ms-flexbox;\r\n            display: flex;\r\n            justify-content: space-between;\r\n            -webkit-justify-content: space-between;\r\n            -ms-flex-pack: space-between;\r\n        }\r\n        button.owl-next, button.owl-prev {\r\n            background-color: #D9D9D9;\r\n            display: -webkit-box;\r\n            display: -ms-flexbox;\r\n            display: flex;\r\n            align-items: center;\r\n            -webkit-box-align: center;\r\n            -ms-flex-align: center;\r\n            justify-content: center;\r\n            -webkit-justify-content: center;\r\n            -ms-flex-pack: center;\r\n            &:hover {\r\n                background-color: $primary;\r\n                i {\r\n                    color: $white;\r\n                }\r\n            }\r\n            i {\r\n                color: $text-color;\r\n            }\r\n        }\r\n    }\r\n}\r\n.audio-call-group {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    align-items: center;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    justify-content: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    height: 100%;\r\n    ul {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        align-items: center;\r\n        justify-content: space-evenly;\r\n        -webkit-justify-content: space-evenly;\r\n        -ms-flex-pack: space-evenly;\r\n        width: 100%;\r\n        li {\r\n            position: relative;\r\n            &.active {\r\n                .avatar {\r\n                    &::before {\r\n                        content: \"\";\r\n                        width: 250px;\r\n                        height: 250px;\r\n                        position: absolute;\r\n                        border: 1px solid $primary;\r\n                        border-radius: 50%;\r\n                        left: -25px;\r\n                        top: -25px;\r\n                        @include respond-below(custom991) {\r\n                            width: 150px;\r\n                            height: 150px;\r\n                            left: -10px;\r\n                            top: -10px;\r\n                        }\r\n                        @include respond-below(custom767) {\r\n                            width: 100px;\r\n                            height: 100px;\r\n                            left: -5px;\r\n                            top: -5px;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n            .avatar {\r\n                width: 200px;\r\n                height: 200px;\r\n                margin: 0;\r\n                position: relative;\r\n                @include respond-below(custom991) {\r\n                    width: 130px;\r\n                    height: 130px;\r\n                }\r\n                @include respond-below(custom767) {\r\n                    width: 90px;\r\n                    height: 90px;\r\n                }\r\n                img {\r\n                    width: 100%;\r\n                    position: relative;\r\n                }\r\n            }\r\n            .user-audio-call {\r\n                h5 {\r\n                    font-size: $font-size-14;\r\n                    color: $white;\r\n                    font-weight: $font-weight-normal;\r\n                    text-transform: capitalize;\r\n                    text-align: center;\r\n                    margin-top: 35px;\r\n                    @include respond-below(custom767) {\r\n                        margin-top: 15px;\r\n                    }\r\n                }\r\n            }\r\n            .more-icon {\r\n                position: absolute;\r\n                bottom: 10px;\r\n                right: inherit;\r\n                left: 50%;\r\n                -webkit-transform: translate(-50%, -50%);\r\n                -ms-transform: translate(-50%, -50%);\r\n                transform: translate(-50%, -50%);\r\n                z-index: 9;\r\n                @include respond-below(custom767) {\r\n                    bottom: 0px;\r\n                }\r\n                a {\r\n                    background-color: $primary;\r\n                    color: $white;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.audio-volume {\r\n    position: absolute;\r\n    width: fit-content;\r\n    height: 134px;\r\n    bottom: 20px;\r\n    left: 20px;\r\n    background: $gray-300;\r\n    border-radius: 50px;\r\n    padding: 10px 14px;\r\n    width: 30px;\r\n    padding-bottom: 30px;\r\n    .volume-icons {\r\n        a {\r\n            position: absolute;\r\n            bottom: 0;\r\n            width: 30px;\r\n            height: 30px;\r\n            left: 0;\r\n            border-radius: 50px;\r\n            background: $white;\r\n            border: 1px solid $warning;\r\n            display: -webkit-box;\r\n            display: -ms-flexbox;\r\n            display: flex;\r\n            align-items: center;\r\n            -webkit-box-align: center;\r\n            -ms-flex-align: center;\r\n            justify-content: center;\r\n            -webkit-justify-content: center;\r\n            -ms-flex-pack: center;\r\n        }\r\n    }\r\n}\r\n.custom-input {\r\n    width: 100%;\r\n    height: 4px;\r\n    width: 3px;\r\n    height: 100%;\r\n    background: $white;\r\n    border-radius: 5px;\r\n    writing-mode: vertical-lr;\r\n}\r\n.custom-input::-webkit-slider-thumb {\r\n    -webkit-appearance: none;\r\n    appearance: none;\r\n    width: 12px;\r\n    height: 12px;\r\n    background: $primary !important;\r\n    border-radius: 50%;\r\n    cursor: pointer;\r\n}\r\n.custom-input::-moz-range-thumb {\r\n    width: 12px;\r\n    height: 12px;\r\n    background: $primary !important;\r\n    border-radius: 50%;\r\n    cursor: pointer;\r\n}\r\n\r\n.table-top-head {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    align-items: center;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    justify-content: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    &.low-stock-top-head {\r\n        @include respond-below(custom575) {\r\n            flex-wrap: wrap;  \r\n           justify-content: start;\r\n        }\r\n        li {\r\n            margin-bottom: 10px;\r\n            &:last-child {\r\n                margin-right: 0;\r\n            }\r\n        }\r\n    }\r\n    li {\r\n        margin-right: 10px;\r\n        flex-shrink: 0;\r\n        &:last-child {\r\n            margin-right: 0;\r\n        }\r\n        #collapse-header {\r\n            margin-right: 0;\r\n            @include respond-below(custom991) {\r\n                display: none;\r\n            }\r\n        }\r\n        a {\r\n            height: 38px;\r\n            display: -webkit-box;\r\n            display: -ms-flexbox;\r\n            display: flex;\r\n            align-items: center;\r\n            -webkit-box-align: center;\r\n            -ms-flex-align: center;\r\n            justify-content: center;\r\n            -webkit-justify-content: center;\r\n            -ms-flex-pack: center;\r\n            border: 1px solid $gray-300;\r\n            background: $white;\r\n            border-radius: 8px;\r\n            padding: 6px;\r\n            svg {\r\n                color: $gray-900;\r\n            }\r\n            &:hover {\r\n                background: #e3e3e3;\r\n            }\r\n            label {\r\n                margin-right: 10px;\r\n            }\r\n            &.btn-secondary {\r\n                background-color: $gray-900;\r\n                color: $white;\r\n                padding: 10px;\r\n                font-weight: $font-weight-bold;\r\n                font-size: $font-size-base;\r\n                &:hover {\r\n                    background-color: $primary;\r\n                }\r\n                svg {\r\n                    width: 16px;\r\n                    margin-right: 5px;\r\n                    color: $white;\r\n                }\r\n                @include respond-below(custom767) {\r\n                    padding: 5px;\r\n                    font-size: $font-size-base;\r\n                }\r\n            }\r\n            .action-edit.sales-action {\r\n                color: $blue;\r\n            }\r\n        }\r\n        .status-toggle {\r\n            height: 38px;\r\n            display: -webkit-box;\r\n            display: -ms-flexbox;\r\n            display: flex;\r\n            align-items: center;\r\n            -webkit-box-align: center;\r\n            -ms-flex-align: center;\r\n            justify-content: center;\r\n            -webkit-justify-content: center;\r\n            -ms-flex-pack: center;\r\n            border: 1px solid $gray-100;\r\n            background: $white;\r\n            border-radius: 8px;\r\n            padding: 6px 10px;\r\n            label {\r\n                margin-right: 10px;\r\n            }\r\n        }\r\n    }\r\n}",".main-chat-blk {\r\n    .slimscroll {\r\n\t\theight: calc(100vh - 60px) !important;\r\n    }\r\n    .slimscroll-active-sidebar {\r\n        a {\r\n            color: $text-color;\r\n        }\r\n    }\r\n\r\n    .emoj-group ul {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        align-items: center;\r\n    }\r\n    .emoj-group ul li+li {\r\n        margin-left: 10px;\r\n    }\r\n    .emoj-group ul li a {\r\n        width: 34px;\r\n        height: 34px;\r\n        background: #f6f7f8;\r\n        border-radius: 50px;\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        align-items: center;\r\n        justify-content: center;\r\n        -webkit-justify-content: center;\r\n        -ms-flex-pack: center;\r\n    }\r\n    .emoj-group ul li a i {\r\n        color: #424242;\r\n    }\r\n    .message-content {\r\n        position: relative;\r\n    }\r\n    .message-content:hover .emoj-group {\r\n        opacity: 1;\r\n        transition: all 0.5s ease;\r\n        -moz-transition: all 0.5s ease;\r\n        -o-transition: all 0.5s ease;\r\n        -ms-transition: all 0.5s ease;\r\n        -webkit-transition: all 0.5s ease;\r\n        \r\n    }\r\n    .emoj-group {\r\n        position: absolute;\r\n        top: 50%;\r\n        right: -100px;\r\n        opacity: 0;\r\n        transition: all 0.5s ease;\r\n        -moz-transition: all 0.5s ease;\r\n        -o-transition: all 0.5s ease;\r\n        -ms-transition: all 0.5s ease;\r\n        -webkit-transition: all 0.5s ease;\r\n        -webkit-transform: translate(0, -50%);\r\n        -ms-transform: translate(0, -50%);\r\n        transform: translate(0, -50%);\r\n    }\r\n    .rig-emoji-group {\r\n        position: absolute;\r\n        right: 210px;\r\n    }\r\n    .wrap-emoji-group {\r\n        position: absolute;\r\n        right: 290px;\r\n    }\r\n    .emoj-group-list-foot {\r\n        display: none;\r\n        position: absolute;\r\n        top: -50px;\r\n        left: -90px;\r\n        transition: all 0.5s ease;\r\n        -moz-transition: all 0.5s ease;\r\n        -o-transition: all 0.5s ease;\r\n        -ms-transition: all 0.5s ease;\r\n        -webkit-transition: all 0.5s ease;\r\n    }\r\n    .emoj-group-list-foot ul {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        align-items: center;\r\n        background: #f6f7f8;\r\n        border-radius: 50px;\r\n        padding: 5px;\r\n    }\r\n    .emoj-group-list-foot ul li a {\r\n        padding: 0;\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n    }\r\n    .emoj-group-list-foot ul li.add-emoj a {\r\n        background: #EDEDED;\r\n    }\r\n    .emoj-group-list-foot ul li.add-emoj a i {\r\n        font-size: $font-size-20;\r\n        color: #424242;\r\n    }\r\n\r\n    .down-emoji-circle {\r\n        position: absolute;\r\n        left: 10px !important;\r\n        top: -38px !important;\r\n    }\r\n    .emoj-action-foot .down-emoji-circle ul {\r\n        padding: 10px;\r\n    }\r\n    .down-emoji-circle ul li + li {\r\n        margin-left: 14px\t;\r\n    }\r\n    .emoj-action-foot .down-emoji-circle ul li:last-child a {\r\n        width: 34px;\r\n        height: 34px;\r\n        border-radius: 50px;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n\t.chat-page-wrapper {\r\n\t\t.content {\r\n\t\t\tpadding: 24px 0 0 24px;\r\n\t\t}\r\n\t\t.sidebar {\r\n\t\t\tposition: initial;\r\n\t\t\t@include respond-below(custom991) {\r\n\t\t\t\tmargin-left: 0;\r\n\t\t\t}\r\n\t\t}\r\n\t\t.left-chat-title {\r\n\t\t\tpadding: 12px;\r\n\t\t\tborder-bottom: 1px solid #E0E0E0;\r\n\t\t\tmin-height: 72px;\r\n\t\t}\r\n\t\t.setting-title-head {\r\n\t\t\th4 {\r\n\t\t\t\tfont-size: $font-size-18;\r\n\t\t\t\tcolor: $gray-900;\r\n\t\t\t\tfont-weight: $font-weight-bold;\r\n\t\t\t}\r\n\t\t}\r\n\t\t.chat .slimscroll {\r\n\t\t\theight: calc(100vh - 135px) !important;\r\n\t\t}\r\n\t\t.dropdown-menu .dropdown-item {\r\n\t\t\tfont-size: $font-size-14;\r\n\t\t\tcursor: pointer;\r\n\t\t\tpadding: 7px 14px;\r\n\t\t\tfont-weight: $font-weight-medium;\r\n\t\t\tcolor: #424242;\r\n\t\t}\r\n\t\t.dropdown-menu .dropdown-item i {\r\n\t\t\tfont-size: $font-size-16;\r\n\t\t\tcolor: #424242;\r\n\t\t}\r\n\t\t\r\n\t\t.dropdown-menu .dropdown-item span {\r\n\t\t\tfloat: right;\r\n\t\t\tfont-size: $font-size-18;\r\n\t\t\tcolor: #424242;\r\n\t\t}\r\n\t\t\r\n\t\t.dropdown-menu .dropdown-item.active {\r\n\t\t\tbackground: none;\r\n\t\t\tcolor: inherit;\r\n\t\t}\r\n\t\t\r\n\t\t.dropdown-menu .dropdown-item:focus,\r\n\t\t.dropdown-menu .dropdown-item:hover,\r\n\t\t.dropdown-menu .dropdown-item:active {\r\n\t\t\tbackground-color: #e6e6e6;\r\n\t\t}\r\n\t\t.dropdown-menu {\r\n\t\t\tbackground: $white;\r\n\t\t\tborder: 1px solid #E5E7EB;\r\n\t\t\tbox-sizing: border-box;\r\n\t\t\tbox-shadow: 0px 4px 3px 0px rgba(0, 0, 0, 0.1);\r\n\t\t\tborder-radius: 8px;\r\n\t\t\tmin-width: 173px;\r\n\t\t}\r\n\t\t\r\n\t\t.dropdown-menu .dropdown-item {\r\n\t\t\tmargin: 0;\r\n\t\t\tposition: relative;\r\n\t\t\tdisplay: -webkit-box;\r\n\t\t\tdisplay: -ms-flexbox;\r\n\t\t\tdisplay: flex;\r\n\t\t\t-webkit-box-align: center;\r\n\t\t\t-ms-flex-align: center;\r\n\t\t\talign-items: center;\r\n\t\t}\r\n\t\t.dropdown-menu.chat-drop-menu .dropdown-item i {\r\n\t\t\tfont-size: $font-size-16;\r\n\t\t\tcolor: #424242;\r\n\t\t}\r\n\t\t.dropdown-menu .dropdown-item:hover,\r\n\t\t.dropdown-menu .dropdown-item:focus,\r\n\t\t.dropdown-menu .dropdown-item:active {\r\n\t\t\tbackground-color: #F8ECFF;\r\n\t\t}\r\n\t\t.dropdown-menu .dropdown-item span {\r\n\t\t\tmargin-right: 10px;\r\n\t\t\tdisplay: -webkit-box;\r\n\t\t\tdisplay: -ms-flexbox;\r\n\t\t\tdisplay: flex;\r\n\t\t\t-webkit-box-align: center;\r\n\t\t\t-ms-flex-align: center;\r\n\t\t\talign-items: center;\r\n\t\t}\r\n\t\t.contact-close_call {\r\n\t\t\tdisplay: -webkit-box;\r\n\t\t\tdisplay: -ms-flexbox;\r\n\t\t\tdisplay: flex;\r\n\t\t\t-webkit-box-align: center;\r\n\t\t\t-ms-flex-align: center;\r\n\t\t\talign-items: center;\r\n\t\t}\r\n\t}\r\n    \t\t\r\n@-webkit-keyframes wave {\r\n\t0%,100%,60% {\r\n\t\t-webkit-transform: initial;\r\n\t\ttransform: initial;\r\n\t}\r\n\t30% {\r\n\t\t-webkit-transform: translateY(-5px);\r\n\t\ttransform: translateY(-5px);\r\n\t}\r\n}\r\n@keyframes wave {\r\n\t0%,100%,60% {\r\n\t\t-webkit-transform: initial;\r\n\t\ttransform: initial;\r\n\t}\r\n\t30% {\r\n\t\t-webkit-transform: translateY(-5px);\r\n\t\ttransform: translateY(-5px);\r\n\t}\r\n}\r\n.chat {\r\n\tflex: 1;\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\ttransition: all .5s ease;\r\n\t-webkit-transition: all .5s ease;\r\n\t-ms-transition: all .5s ease;\r\n\tbackground: $white;\r\n\t.chat-header {\r\n\t\tdisplay: flex;\r\n\t\tdisplay: -webkit-flex;\r\n\t\tjustify-content: space-between;\r\n\t\t-webkit-justify-content: space-between;\r\n\t\tpadding: 15px 24px;\r\n\t\talign-items: center;\r\n        border-bottom: 1px solid var(--Stroke, rgba(145, 158, 171, 0.30));\r\n        background: var(--White, #FFF);\r\n        box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);\r\n\t\tposition: relative;\r\n\t\t.user-details {\r\n\t\t\tdisplay: flex;\r\n\t\t\tdisplay: -webkit-flex;\r\n\t\t\talign-items: center;\r\n\t\t\t-webkit-align-items: center;\r\n\t\t\tfigure {\r\n\t\t\t\tmargin-right: 1rem;\r\n\t\t\t}\r\n\t\t\th5 {\r\n\t\t\t\tfont-size: $font-size-15;\r\n\t\t\t\tfont-weight: $font-weight-semibold;\r\n\t\t\t\tmargin-bottom: 4px;\r\n\t\t\t\tline-height: 1;\r\n\t\t\t\tcolor: $gray-900;\r\n\t\t\t}\r\n\t\t}\r\n\t\t.chat-options {\r\n\t\t\tul {\r\n\t\t\t\tmargin-bottom: 0;\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\tdisplay: -webkit-flex;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\t-webkit-align-items: center;\r\n\t\t\t\t>li {\r\n\t\t\t\t\t>a {\r\n\t\t\t\t\t\tfont-size: $font-size-14;\r\n\t\t\t\t\t\tcolor: $gray-900;\r\n\t\t\t\t\t\tcursor: pointer;\r\n\t\t\t\t\t\twidth: 40px;\r\n\t\t\t\t\t\theight: 40px;\r\n\t\t\t\t\t\tpadding: 0;\r\n\t\t\t\t\t\tborder: none;\r\n\t\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\t\tdisplay: -webkit-flex;\r\n\t\t\t\t\t\talign-items: center;\r\n\t\t\t\t\t\t-webkit-align-items: center;\r\n\t\t\t\t\t\tjustify-content: center;\r\n\t\t\t\t\t\t-webkit-justify-content: center;\r\n\t\t\t\t\t\ti {\r\n\t\t\t\t\t\t\tfont-size: $font-size-20;\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t\t&:not(.no-bg) {\r\n\t\t\t\t\t\t\t&:hover {\r\n\t\t\t\t\t\t\t\tbackground-color: $gray-100;\r\n\t\t\t\t\t\t\t\tborder-color: $gray-100;\r\n\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\t.chat-body {\r\n\t\tflex: 1;\r\n\t\tpadding: 24px;\r\n\t\tpadding-bottom: 40px;\r\n\t\t&:not(.no-message) {\r\n\t\t\toverflow: hidden;\r\n\t\t}\r\n\t\t.messages {\r\n\t\t\tdisplay: flex;\r\n\t\t\tdisplay: -webkit-flex;\r\n\t\t\tflex-direction: column;\r\n\t\t\t-webkit-flex-direction: column;\r\n\t\t\talign-items: flex-start;\r\n\t\t\t-webkit-align-items: flex-start;\r\n\t\t\t.chats {\r\n\t\t\t\tmax-width: 75%;\r\n\t\t\t\tmargin-bottom: 1.5rem;\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\tdisplay: -webkit-flex;\r\n\t\t\t\t&:last-child {\r\n\t\t\t\t\tmargin-bottom: 0;\r\n\t\t\t\t}\r\n\t\t\t\t.chat-time {\r\n\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\tdisplay: -webkit-flex;\r\n\t\t\t\t\talign-items: center;\r\n\t\t\t\t\t-webkit-align-items: center;\r\n\t\t\t\t\tmargin-bottom: 0;\r\n\t\t\t\t\t.avatar {\r\n\t\t\t\t\t\tmargin-right: 1rem;\r\n\t\t\t\t\t}\r\n\t\t\t\t\th5 {\r\n\t\t\t\t\t\tfont-size: $font-size-15;\r\n\t\t\t\t\t\tmargin-bottom: 0;\r\n\t\t\t\t\t}\r\n\t\t\t\t\t.time {\r\n\t\t\t\t\t\tcolor: $white;\r\n\t\t\t\t\t\tmargin-top: 2px;\r\n\t\t\t\t\t\tfont-size: 12px;\r\n\t\t\t\t\t\tfont-weight: $font-weight-normal;\r\n\t\t\t\t\t\ti {\r\n\t\t\t\t\t\t\tcolor: rgba(247, 247, 247, 0.5);\r\n\t\t\t\t\t\t\timg {\r\n\t\t\t\t\t\t\t\twidth: 14px;\r\n\t\t\t\t\t\t\t\theight: auto;\r\n\t\t\t\t\t\t\t\tmargin-left: 2px;\r\n\t\t\t\t\t\t\t\tvertical-align: 0px;\r\n\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t\t.message-content {\r\n\t\t\t\t\tborder-radius: 0px 15px 15px 15px;\r\n                    background: var(--light-color, #F6F7F8);\r\n\t\t\t\t\tpadding: 14px 20px;\r\n\t\t\t\t\tcolor: $gray-900;\r\n\t\t\t\t\tfont-size: $font-size-14;\r\n\t\t\t\t\tfont-weight: $font-weight-normal;\r\n\t\t\t\t\tbox-shadow: 0px 6px 12px 0px #00000008;\r\n\t\t\t\t\ta {\r\n\t\t\t\t\t\tcolor: $cyan;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t\t.message-content.award-link {\r\n\t\t\t\t\ta {\r\n\t\t\t\t\t\tcolor: $gray-900;\r\n\t\t\t\t\t\tmargin-bottom: 2px;\r\n\t\t\t\t\t\tdisplay: block;\r\n\t\t\t\t\t}\r\n\t\t\t\t\timg {\r\n\t\t\t\t\t\tborder-radius: 10px;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t\t.message-content.chat-award-link {\r\n\t\t\t\t\ta {\r\n\t\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t\t.message-content.fancy-msg-box {\r\n\t\t\t\t\t.image-not-download {\r\n\t\t\t\t\t\tspan {\r\n\t\t\t\t\t\t\tposition: absolute;\r\n\t\t\t\t\t\t\tcolor: $white;\r\n\t\t\t\t\t\t\tfont-size: 13px;\r\n\t\t\t\t\t\t\tfont-weight: $font-weight-medium;\r\n\t\t\t\t\t\t\tposition: absolute;\r\n\t\t\t\t\t\t\ttop: 50%;\r\n\t\t\t\t\t\t\tleft: 50%;\r\n\t\t\t\t\t\t\t-webkit-transform: translate(-50%, -50%);\r\n\t\t\t\t\t\t\t-ms-transform: translate(-50%, -50%);\r\n\t\t\t\t\t\t\ttransform: translate(-50%, -50%);\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t\t.chat-profile-name {\r\n\t\t\t\th6 {\r\n\t\t\t\t\tmargin-bottom: 0;\r\n\t\t\t\t\tcolor: $gray-900;\r\n\t\t\t\t\tfont-weight: $font-weight-semibold;\r\n\t\t\t\t\tfont-size: $font-size-15;\r\n\t\t\t\t\tspan {\r\n\t\t\t\t\t\tfont-size: 12px;\r\n\t\t\t\t\t\tcolor: $gray-500;\r\n\t\t\t\t\t\tfont-weight: $font-weight-normal;\r\n\t\t\t\t\t\tpadding-left: 10px;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t\t.chats.chats-right {\r\n\t\t\t\tmargin-left: auto;\r\n\t\t\t\t.chat-time {\r\n\t\t\t\t\tjustify-content: flex-end;\r\n\t\t\t\t}\r\n\t\t\t\t.message-content {\r\n\t\t\t\t\tborder-radius: 15px 0px 15px 15px;\r\n                    background: rgba(255, 159, 67, 0.12);\r\n\t\t\t\t\tcolor: $gray-900;\r\n\t\t\t\t\tpadding: 15px;\r\n\t\t\t\t\t.chat-time {\r\n\t\t\t\t\t\tjustify-content: flex-start;\r\n\t\t\t\t\t\t-webkit-justify-content: flex-start;\r\n\t\t\t\t\t\t.time {\r\n\t\t\t\t\t\t\tcolor: $gray-500;\r\n\t\t\t\t\t\t\ti {\r\n\t\t\t\t\t\t\t\tcolor: $cyan;\r\n\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t\t.chat-action-btns {\r\n\t\t\t\t\torder: 2;\r\n\t\t\t\t\t-webkit-order: 2;\r\n\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\tdisplay: -webkit-flex;\r\n\t\t\t\t\tflex-wrap: wrap;\r\n\t\t\t\t\t-webkit-flex-wrap: wrap;\r\n\t\t\t\t\tjustify-content: center;\r\n\t\t\t\t\t-webkit-justify-content: center;\r\n\t\t\t\t\t.chat-action-col {\r\n\t\t\t\t\t\twidth: 20px;\r\n\t\t\t\t\t\ttext-align: center;\r\n\t\t\t\t\t}\r\n\t\t\t\t\t.chat-read-col {\r\n\t\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\t\tdisplay: -webkit-flex;\r\n\t\t\t\t\t\talign-items: flex-end;\r\n\t\t\t\t\t\t-webkit-align-items: flex-end;\r\n\t\t\t\t\t\tpadding-bottom: 22px;\r\n\t\t\t\t\t\tcolor: $gray-600;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t\t.chat-content {\r\n\t\t\t\t\torder: 1;\r\n\t\t\t\t\t-webkit-order: 1;\r\n\t\t\t\t}\r\n\t\t\t\t.chat-avatar {\r\n\t\t\t\t\tpadding: 8px 0px 0 15px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t\t.download-col {\r\n\t\t\t\tposition: relative;\r\n\t\t\t\tul {\r\n\t\t\t\t\tlist-style: none;\r\n\t\t\t\t\tpadding: 0;\r\n\t\t\t\t\tmargin: 0 0 5px 0;\r\n\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\tdisplay: -webkit-flex;\r\n\t\t\t\t\tli+li {\r\n\t\t\t\t\t\tmargin-left: 5px;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t\t.image-download-col {\r\n\t\t\t\t\tposition: relative;\r\n\t\t\t\t\ta {\r\n\t\t\t\t\t\t>img {\r\n\t\t\t\t\t\t\tborder: 1px solid transparent;\r\n\t\t\t\t\t\t\twidth: 80px;\r\n\t\t\t\t\t\t\tborder-radius: 8px;\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t\t.image-download-col.image-not-download {\r\n\t\t\t\t\ta {\r\n\t\t\t\t\t\t>img {\r\n\t\t\t\t\t\t\t-webkit-filter: blur(1px);\r\n\t\t\t\t\t\t\tfilter: blur(1px);\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t\t.download-action {\r\n\t\t\t\t\tposition: absolute;\r\n\t\t\t\t\tright: 8px;\r\n\t\t\t\t\tbottom: 8px;\r\n\t\t\t\t\tline-height: 0;\r\n\t\t\t\t\ta {\r\n\t\t\t\t\t\tcolor: $white;\r\n\t\t\t\t\t\tfont-size: 10px;\r\n\t\t\t\t\t}\r\n\t\t\t\t\tdiv+div {\r\n\t\t\t\t\t\tmargin-left: 8px;\r\n\t\t\t\t\t}\r\n\t\t\t\t\tdiv {\r\n\t\t\t\t\t\timg {\r\n\t\t\t\t\t\t\twidth: 13px;\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t\t.file-download {\r\n\t\t\t\t.download-action {\r\n\t\t\t\t\tposition: absolute;\r\n\t\t\t\t\tright: 8px;\r\n\t\t\t\t\tbottom: 8px;\r\n\t\t\t\t\tline-height: 0;\r\n\t\t\t\t\tbottom: 14px;\r\n\t\t\t\t\ta {\r\n\t\t\t\t\t\tcolor: $white;\r\n\t\t\t\t\t\tfont-size: 10px;\r\n\t\t\t\t\t\tcolor: $gray-800;\r\n\t\t\t\t\t}\r\n\t\t\t\t\tdiv+div {\r\n\t\t\t\t\t\tmargin-left: 8px;\r\n\t\t\t\t\t}\r\n\t\t\t\t\tdiv {\r\n\t\t\t\t\t\timg {\r\n\t\t\t\t\t\t\twidth: 13px;\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t\tposition: relative;\r\n\t\t\t\tbackground: $light-900;\r\n\t\t\t\tborder-radius: 10px;\r\n\t\t\t\tpadding: 10px;\r\n\t\t\t\tmargin-bottom: 7px;\r\n\t\t\t\t.file-type {\r\n\t\t\t\t\twidth: 54px;\r\n\t\t\t\t\theight: 54px;\r\n\t\t\t\t\tbackground-color: $white;\r\n\t\t\t\t\tborder-radius: 4px;\r\n\t\t\t\t\ti {\r\n\t\t\t\t\t\tcolor: $gray-500;\r\n\t\t\t\t\t\tfont-size: $font-size-24;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t\t.file-details {\r\n\t\t\t\t\tspan.file-name {\r\n\t\t\t\t\t\tcolor: $gray-900;\r\n\t\t\t\t\t\tdisplay: inline-block;\r\n\t\t\t\t\t\twidth: 100%;\r\n\t\t\t\t\t\tfont-size: $font-size-15;\r\n\t\t\t\t\t\tfont-weight: $font-weight-medium;\r\n\t\t\t\t\t}\r\n\t\t\t\t\tspan.file-size {\r\n\t\t\t\t\t\tcolor: $gray-500;\r\n\t\t\t\t\t\tdisplay: inline-block;\r\n\t\t\t\t\t\twidth: 100%;\r\n\t\t\t\t\t}\r\n\t\t\t\t\tul {\r\n\t\t\t\t\t\tdisplay: -webkit-box;\r\n\t\t\t\t\t\tdisplay: -ms-flexbox;\r\n\t\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\t\t-webkit-box-align: center;\r\n\t\t\t\t\t\t-ms-flex-align: center;\r\n\t\t\t\t\t\talign-items: center;\r\n\t\t\t\t\t\tpadding: 0;\r\n\t\t\t\t\t\tmargin-bottom: 0;\r\n\t\t\t\t\t\tli {\r\n\t\t\t\t\t\t\tlist-style: none;\r\n\t\t\t\t\t\t\tcolor: $gray-900;\r\n\t\t\t\t\t\t\tfont-size: $font-size-14;\r\n\t\t\t\t\t\t\tposition: relative;\r\n\t\t\t\t\t\t\t&::before {\r\n\t\t\t\t\t\t\t\tcontent: \"\";\r\n\t\t\t\t\t\t\t\tposition: absolute;\r\n\t\t\t\t\t\t\t\twidth: 1px;\r\n\t\t\t\t\t\t\t\theight: 13px;\r\n\t\t\t\t\t\t\t\tbackground: #C2C2C2;\r\n\t\t\t\t\t\t\t\tright: -8px;\r\n\t\t\t\t\t\t\t\ttop: 5px;\r\n\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t\t&:last-child {\r\n\t\t\t\t\t\t\t\t&::before {\r\n\t\t\t\t\t\t\t\t\tdisplay: none;\r\n\t\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t\ta {\r\n\t\t\t\t\t\t\t\tcolor: $primary;\r\n\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t\tli+li {\r\n\t\t\t\t\t\t\tpadding-left: 15px;\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\t.chat-body.no-message {\r\n\t\tuser-select: none;\r\n\t}\r\n\t.chat-footer {\r\n\t\tposition: relative;\r\n\t\tform {\r\n\t\t\tdisplay: flex;\r\n\t\t\tdisplay: -webkit-flex;\r\n\t\t\talign-items: center;\r\n\t\t\t-webkit-align-items: center;\r\n\t\t\tposition: absolute;\r\n\t\t\tbottom: 0;\r\n\t\t\tleft: 0;\r\n\t\t\tright: 0;\r\n\t\t\tpadding: 24px;\r\n\t\t\t@include respond-below(custom991) {\r\n\t\t\t\tpadding-bottom: 15px;\r\n\t\t\t}\r\n\t\t\t.form-buttons {\r\n\t\t\t\t.btn {\r\n\t\t\t\t\tmargin-left: 0px;\r\n\t\t\t\t\tcolor: $gray-400;\r\n\t\t\t\t\tfont-size: $font-size-20;\r\n\t\t\t\t\tpadding: 0;\r\n\t\t\t\t\twidth: 20px;\r\n\t\t\t\t\theight: 20px;\r\n\t\t\t\t\tborder-radius: 50%;\r\n\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\tjustify-content: center;\r\n\t\t\t\t\talign-items: center;\r\n\t\t\t\t\tmargin-right: 10px;\r\n\t\t\t\t\t&:last-child {\r\n\t\t\t\t\t\tmargin-right: 0;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t\t.btn.send-btn {\r\n\t\t\t\t\twidth: 40px;\r\n\t\t\t\t\theight: 40px;\r\n\t\t\t\t\tborder-radius: 6px;\r\n                    background: $primary;\r\n\t\t\t\t\tdisplay: inline-flex;\r\n\t\t\t\t\tjustify-content: center;\r\n\t\t\t\t\talign-items: center;\r\n\t\t\t\t\tcolor: $white !important;\r\n\t\t\t\t\tmargin-left: 10px;\r\n\t\t\t\t\t&:hover {\r\n\t\t\t\t\t\tbackground-color: $white;\r\n\t\t\t\t\t\tborder-color: $gray-800;\r\n\t\t\t\t\t\ti {\r\n\t\t\t\t\t\t\tcolor: $gray-800;\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t\t&:focus {\r\n\t\t\t\t\t\tbox-shadow: none;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t\t.specker-col {\r\n\t\t\t\tspan {\r\n\t\t\t\t\tcolor: $gray-800;\r\n\t\t\t\t\tfont-size: 25px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t\t.attach-col {\r\n\t\t\t\ti {\r\n\t\t\t\t\tcolor: $gray-800;\r\n\t\t\t\t\tfont-size: $font-size-20;\r\n\t\t\t\t}\r\n\t\t\t\tright: inherit;\r\n\t\t\t\tleft: 60px;\r\n\t\t\t}\r\n\t\t\t.smile-col {\r\n\t\t\t\ti {\r\n\t\t\t\t\tcolor: $gray-800;\r\n\t\t\t\t\tfont-size: $font-size-20;\r\n\t\t\t\t\tfont-size: $font-size-22;\r\n\t\t\t\t}\r\n\t\t\t\tright: inherit;\r\n\t\t\t\tleft: 15px;\r\n\t\t\t}\r\n\t\t\t.smile-foot {\r\n\t\t\t\tmargin-right: 10px;\r\n\t\t\t\t.action-circle {\r\n\t\t\t\t\twidth: 38px;\r\n\t\t\t\t\theight: 38px;\r\n\t\t\t\t\tbackground: $white;\r\n\t\t\t\t\tborder-radius: 50px;\r\n\t\t\t\t\tdisplay: -webkit-box;\r\n\t\t\t\t\tdisplay: -ms-flexbox;\r\n\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\t-webkit-box-align: center;\r\n\t\t\t\t\t-ms-flex-align: center;\r\n\t\t\t\t\talign-items: center;\r\n\t\t\t\t\tjustify-content: center;\r\n\t\t\t\t\t-webkit-justify-content: center;\r\n\t\t\t\t\t-ms-flex-pack: center;\r\n\t\t\t\t\t&:hover {\r\n\t\t\t\t\t\tbackground-color: $gray-100;\r\n\t\t\t\t\t\tborder-color: $gray-100;\r\n\t\t\t\t\t}\r\n\t\t\t\t\ti {\r\n\t\t\t\t\t\tcolor: $gray-900;\r\n\t\t\t\t\t\tfont-size: $font-size-18;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t\t.form-control {\r\n\t\t\t\t&::-webkit-input-placeholder {\r\n\t\t\t\t\tcolor: $gray-900;\r\n\t\t\t\t\topacity: 1;\r\n\t\t\t\t}\r\n\t\t\t\t&::-moz-placeholder {\r\n\t\t\t\t\tcolor: $gray-900;\r\n\t\t\t\t\topacity: 1;\r\n\t\t\t\t}\r\n\t\t\t\t&:-ms-input-placeholder {\r\n\t\t\t\t\tcolor: $gray-900;\r\n\t\t\t\t\topacity: 1;\r\n\t\t\t\t}\r\n\t\t\t\t&:-moz-placeholder {\r\n\t\t\t\t\tcolor: $gray-900;\r\n\t\t\t\t\topacity: 1;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n}\r\n.chat-options {\r\n\tul.list-inline {\r\n\t\t.list-inline-item {\r\n\t\t\tmargin-bottom: 0;\r\n\t\t}\r\n\t}\r\n}\r\n.last-seen {\r\n\tcolor: $gray-900;\r\n\tfont-size: $font-size-14;\r\n}\r\n.user_callog {\r\n\tdisplay: flex;\r\n\tmargin-top: 0px;\r\n}\r\n.calllog_p {\r\n\tmargin-left: 5px;\r\n}\r\n.chat-options.chat-option-profile {\r\n\t.list-inline-item {\r\n\t\ta {\r\n\t\t\tbackground: $primary;\r\n\t\t\twidth: 38px;\r\n\t\t\theight: 38px;\r\n\t\t\tborder-radius: 50px;\r\n\t\t\tcolor: $gray-900;\r\n\t\t\tpadding: 0;\r\n\t\t\tdisplay: -webkit-box;\r\n\t\t\tdisplay: -ms-flexbox;\r\n\t\t\tdisplay: flex;\r\n\t\t\t-webkit-box-align: center;\r\n\t\t\t-ms-flex-align: center;\r\n\t\t\talign-items: center;\r\n\t\t\tjustify-content: center;\r\n\t\t\t-webkit-justify-content: center;\r\n\t\t\t-ms-flex-pack: center;\r\n\t\t\tcolor: $white !important; \r\n\t\t\t&:hover {\r\n\t\t\t\tbackground: #1b2950;\r\n\t\t\t\tcolor: $white;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\t.list-inline {\r\n\t\tborder-bottom: 1px solid #EDEDED;\r\n\t\tmargin-bottom: 0;\r\n\t\tpadding-bottom: 15px;\r\n\t}\r\n}\r\n.last-seen-profile {\r\n\tspan {\r\n\t\tcolor: $gray-900;\r\n\t\tfont-size: $font-size-14;\r\n\t\tfont-weight: $font-weight-normal;\r\n\t\tmargin-bottom: 12px;\r\n\t\tdisplay: block;\r\n\t}\r\n}\r\n.header_button {\r\n\tposition: absolute;\r\n\tright: 5px;\r\n\twidth: 40px;\r\n\theight: 40px;\r\n\tborder-radius: 20px;\r\n\tfont-size: $font-size-14;\r\n\tcolor: $white;\r\n\ttext-align: center;\r\n\tbackground: #ffa977;\r\n\tbottom: 40px;\r\n\tdisplay: flex;\r\n\tdisplay: -webkit-flex;\r\n\talign-items: center;\r\n\t-webkit-align-items: center;\r\n\tjustify-content: center;\r\n\t-webkit-justify-content: center;\r\n}\r\n.btn-warning {\r\n\t&:hover {\r\n\t\tcolor: $white;\r\n\t\tbackground-color: $primary-800;\r\n\t\tborder-color: $primary-900;\r\n\t}\r\n}\r\n.right_sidebar_profile {\r\n\tmargin-top: 0px;\r\n}\r\n.account_details {\r\n\tbackground-color: $gray-300;\r\n\tborder-color: $gray-400;\r\n\tborder-radius: 5px !important;\r\n\tborder-bottom: 0 !important;\r\n}\r\n.security_details {\r\n\tbackground-color: $gray-300;\r\n\tborder-color: $gray-400;\r\n\tborder-radius: 5px !important;\r\n\tborder-bottom: 0 !important;\r\n}\r\n.close_icon {\r\n\tfont-size: $font-size-18;\r\n}\r\n.button_plus {\r\n\tmargin-left: 0px;\r\n}\r\n.chat-search {\r\n\tposition: absolute;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\twidth: 100%;\r\n\ttransition: ease all 0.5s;\r\n\t-webkit-transition: ease all 0.5s;\r\n\t-ms-transition: ease all 0.5s;\r\n\topacity: 0;\r\n\tvisibility: hidden;\r\n\tinput[type=\"text\"] {\r\n\t\tpadding: 8px 8px 8px 35px;\r\n\t\twidth: 100%;\r\n\t\tmin-height: 47px;\r\n\t\tborder-radius: 0px 0px 5px 5px;\r\n\t\tborder: 1px solid #E5E7EB;\r\n\t\tfont-size: 13px;\r\n\t\tbackground-color: $white;\r\n\t\tcolor: $gray-900;\r\n\t\tfont-size: $font-size-15;\r\n\t\tfont-weight: $font-weight-medium;\r\n\t\t&:hover {\r\n\t\t\tborder-color: $gray-200;\r\n\t\t}\r\n\t\t&:focus {\r\n\t\t\tborder-color: $gray-200;\r\n\t\t}\r\n\t\t&:focus-visible {\r\n\t\t\tborder-color: $gray-200;\r\n\t\t}\r\n\t}\r\n}\r\n.chat-search.visible-chat {\r\n\topacity: 1;\r\n\tvisibility: visible;\r\n\ttop: 100%;\r\n\ttransition: ease all 0.5s;\r\n\t-webkit-transition: ease all 0.5s;\r\n\t-ms-transition: ease all 0.5s;\r\n\tz-index: 9;\r\n}\r\n.form-control-feedback {\r\n\tz-index: 2;\r\n\tdisplay: block;\r\n\ttext-align: center;\r\n\tpointer-events: none;\r\n\tcolor: rgba(0, 0, 0, 0.4);\r\n\tposition: absolute;\r\n\tleft: 13px;\r\n\ttop: 50%;\r\n\ttransform: translateY(-50%);\r\n\t-webkit-transform: translateY(-50%);\r\n\t-ms-transform: translateY(-50%);\r\n\ti {\r\n\t\tfont-size: $font-size-16;\r\n\t\tcolor: $gray-900;\r\n\t}\r\n}\r\n.user-chat-search {\r\n\tposition: absolute;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\twidth: 100%;\r\n\ttransition: ease all 0.5s;\r\n\t-webkit-transition: ease all 0.5s;\r\n\t-ms-transition: ease all 0.5s;\r\n\topacity: 0;\r\n\tvisibility: hidden;\r\n\tinput[type=\"text\"] {\r\n\t\tpadding: 8px 8px 8px 35px;\r\n\t\twidth: 100%;\r\n\t\tmin-height: 47px;\r\n\t\tborder-radius: 0px 0px 5px 5px;\r\n\t\tborder: 1px solid #E5E7EB;\r\n\t\tfont-size: 13px;\r\n\t\tbackground-color: $white;\r\n\t\tcolor: $gray-900;\r\n\t\tfont-size: $font-size-15;\r\n\t\tfont-weight: $font-weight-medium;\r\n\t\t&:hover {\r\n\t\t\tborder-color: $gray-200;\r\n\t\t}\r\n\t\t&:focus {\r\n\t\t\tborder-color: $gray-200;\r\n\t\t}\r\n\t\t&:focus-visible {\r\n\t\t\tborder-color: $gray-200;\r\n\t\t}\r\n\t}\r\n}\r\n.user-chat-search.visible-chat {\r\n\topacity: 1;\r\n\tvisibility: visible;\r\n\ttop: 100%;\r\n\ttransition: ease all 0.5s;\r\n\t-webkit-transition: ease all 0.5s;\r\n\t-ms-transition: ease all 0.5s;\r\n\tz-index: 9;\r\n}\r\n.all-chats {\r\n\tposition: relative;\r\n}\r\n.close-btn-chat {\r\n\twidth: 25px;\r\n\theight: 25px;\r\n\tborder-radius: 25px;\r\n\tcolor: $gray-900;\r\n\tdisplay: flex;\r\n\tdisplay: -webkit-flex;\r\n\tjustify-content: center;\r\n\t-webkit-justify-content: center;\r\n\talign-items: center;\r\n\t-webkit-align-items: center;\r\n\tposition: absolute;\r\n\tright: 12px;\r\n\ttop: 9px;\r\n\tcursor: pointer;\r\n}\r\n.user-close-btn-chat {\r\n\twidth: 25px;\r\n\theight: 25px;\r\n\tborder-radius: 25px;\r\n\tcolor: $gray-900;\r\n\tdisplay: flex;\r\n\tdisplay: -webkit-flex;\r\n\tjustify-content: center;\r\n\t-webkit-justify-content: center;\r\n\talign-items: center;\r\n\t-webkit-align-items: center;\r\n\tposition: absolute;\r\n\tright: 12px;\r\n\ttop: 9px;\r\n\tcursor: pointer;\r\n}\r\n.main_content {\r\n\twidth: 100% !important;\r\n}\r\n.avatar-main {\r\n\theight: 50px;\r\n\twidth: 50px;\r\n}\r\n.archive-btn {\r\n\tborder: 1px solid #008024;\r\n\tcolor: $gray-600;\r\n\tborder-radius: 4px;\r\n\tfont-size: 11px;\r\n\tfont-weight: $font-weight-medium;\r\n\tpadding: 2px 6px;\r\n\tmargin-right: 1.5rem;\r\n}\r\n.archive-btn-grey {\r\n\tborder: 1px solid #909090;\r\n\tcolor: $gray-500;\r\n\tborder-radius: 4px;\r\n\tfont-size: 9px;\r\n\tfont-weight: $font-weight-medium;\r\n\tpadding: 2px 6px;\r\n\tmargin-top: .25rem;\r\n}\r\n.right_sidebar_icon {\r\n\tlist-style: none;\r\n}\r\n.btn.btn-outline-light {\r\n\t&:hover {\r\n\t\tbackground: #e6e6e6;\r\n\t}\r\n}\r\n.chat-avatar {\r\n\tpadding: 8px 15px 0 8px;\r\n\tdisplay: flex;\r\n\tdisplay: -webkit-flex;\r\n\talign-items: flex-start;\r\n\t-webkit-align-items: flex-start;\r\n\tflex-shrink: 0;\r\n}\r\n.chat-profile-name {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tmargin-bottom: 5px;\r\n\t.chat-action-col {\r\n\t\ta {\r\n\t\t\tdisplay: -webkit-box;\r\n\t\t\tdisplay: -ms-flexbox;\r\n\t\t\tdisplay: flex;\r\n\t\t}\r\n\t}\r\n}\r\n.delete-pop-btn {\r\n\t.btn-primary {\r\n\t\tmargin: 0 0 0 10px;\r\n\t}\r\n}\r\n.delete-model-head {\r\n\tpadding: 40px;\r\n\t.modal-header {\r\n\t\tpadding: 0;\r\n\t\tmargin-bottom: 32px;\r\n\t}\r\n\t.modal-body {\r\n\t\tpadding: 0;\r\n\t}\r\n}\r\n.delete-chat-notify {\r\n\tmargin-bottom: 32px;\r\n\t.form-check {\r\n\t\tmargin-bottom: 14px;\r\n\t}\r\n}\r\n.chats.chats-right {\r\n\tflex-direction: row-reverse;\r\n\t-webkit-flex-direction: row-reverse;\r\n}\r\n.message-star {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\t.avatar {\r\n\t\twidth: 26px;\r\n\t\theight: 26px;\r\n\t\tmargin-right: 10px;\r\n\t\timg {\r\n\t\t\twidth: 100%;\r\n\t\t}\r\n\t}\r\n\th6 {\r\n\t\tcolor: $gray-900;\r\n\t\tfont-size: $font-size-15;\r\n\t\tfont-weight: $font-weight-medium;\r\n\t\tmargin-bottom: 0;\r\n\t\tspan {\r\n\t\t\ti {\r\n\t\t\t\tcolor: $warning-700;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n.chat-voice-group {\r\n\tul {\r\n\t\tdisplay: -webkit-box;\r\n\t\tdisplay: -ms-flexbox;\r\n\t\tdisplay: flex;\r\n\t\t-webkit-box-align: center;\r\n\t\t-ms-flex-align: center;\r\n\t\talign-items: center;\r\n\t\tjustify-content: center;\r\n\t\t-webkit-justify-content: center;\r\n\t\t-ms-flex-pack: center;\r\n\t\tpadding: 0;\r\n\t\tmargin-bottom: 0;\r\n\t\tli {\r\n\t\t\tspan {\r\n\t\t\t\twidth: 28px;\r\n\t\t\t\theight: 28px;\r\n\t\t\t\tbackground: $primary;\r\n\t\t\t\tborder-radius: 50px;\r\n\t\t\t\tdisplay: -webkit-box;\r\n\t\t\t\tdisplay: -ms-flexbox;\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\t-webkit-box-align: center;\r\n\t\t\t\t-ms-flex-align: center;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tjustify-content: center;\r\n\t\t\t\t-webkit-justify-content: center;\r\n\t\t\t\t-ms-flex-pack: center;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\tli {\r\n\t\tmargin-bottom: 0;\r\n\t\tcolor: $gray-900;\r\n\t\tfont-size: $font-size-14;\r\n\t\tfont-weight: $font-weight-normal;\r\n\t\tlist-style: none;\r\n\t}\r\n\tli+li {\r\n\t\tpadding-left: 10px;\r\n\t}\r\n}\r\n.file-download-col {\r\n\t.download-action {\r\n\t\tposition: absolute;\r\n\t\tright: 8px;\r\n\t\tbottom: 8px;\r\n\t\tline-height: 0;\r\n\t\ta {\r\n\t\t\tcolor: $white;\r\n\t\t\tfont-size: 10px;\r\n\t\t}\r\n\t\tdiv+div {\r\n\t\t\tmargin-left: 8px;\r\n\t\t}\r\n\t\tdiv {\r\n\t\t\timg {\r\n\t\t\t\twidth: 13px;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\t&:after {\r\n\t\tcontent: \"\";\r\n\t\tdisplay: table;\r\n\t\tclear: both;\r\n\t}\r\n\tul {\r\n\t\tlist-style: none;\r\n\t\tpadding: 0;\r\n\t\tmargin: 0;\r\n\t\tli {\r\n\t\t\tfloat: left;\r\n\t\t\twidth: 50%;\r\n\t\t\tpadding: 5px;\r\n\t\t\t.image-download-col {\r\n\t\t\t\tposition: relative;\r\n\t\t\t\ta {\r\n\t\t\t\t\t>img {\r\n\t\t\t\t\t\twidth: 100%;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t\tli.full-width {\r\n\t\t\twidth: 100%;\r\n\t\t}\r\n\t}\r\n}\r\n.chat-select {\r\n\t.select2-container {\r\n\t\t.select2-selection--single {\r\n\t\t\tborder: 0;\r\n\t\t\theight: 24px;\r\n\t\t\t.select2-selection__rendered {\r\n\t\t\t\tpadding-right: 40px;\r\n\t\t\t\tpadding-left: 0px;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\t.select2-container--default {\r\n\t\t.select2-selection--single {\r\n\t\t\t.select2-selection__rendered {\r\n\t\t\t\tcolor: $gray-500;\r\n\t\t\t\tfont-size: $font-size-18;\r\n\t\t\t\tfont-weight: normal;\r\n\t\t\t\tline-height: 24px;\r\n\t\t\t\tfont-weight: $font-weight-semibold;\r\n\t\t\t}\r\n\t\t\t.select2-selection__arrow {\r\n\t\t\t\theight: 24px;\r\n\t\t\t\tright: 7px;\r\n\t\t\t\tb {\r\n\t\t\t\t\tborder-color: $gray-700;\r\n\t\t\t\t\tborder-style: solid;\r\n\t\t\t\t\tborder-width: 0 2px 2px 0;\r\n\t\t\t\t\tpadding: 3px;\r\n\t\t\t\t\theight: 0;\r\n\t\t\t\t\tleft: 50%;\r\n\t\t\t\t\tmargin-left: -5px;\r\n\t\t\t\t\tmargin-top: -5px;\r\n\t\t\t\t\tposition: absolute;\r\n\t\t\t\t\ttop: 50%;\r\n\t\t\t\t\twidth: 0;\r\n\t\t\t\t\ttransform: rotate(45deg);\r\n\t\t\t\t\t-webkit-transform: rotate(45deg);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t\t.select2-results__option--highlighted[aria-selected] {\r\n\t\t\tbackground-color: $gray-900;\r\n\t\t}\r\n\t\t.select2-selection--multiple {\r\n\t\t\tborder: 1px solid #ddd;\r\n\t\t\tmin-height: 40px;\r\n\t\t}\r\n\t}\r\n\t.select2-container--default.select2-container--open {\r\n\t\t.select2-selection--single {\r\n\t\t\t.select2-selection__arrow {\r\n\t\t\t\tb {\r\n\t\t\t\t\tborder-color: $gray-700;\r\n\t\t\t\t\tborder-width: 2px 0 0 2px;\r\n\t\t\t\t\tpadding: 3px;\r\n\t\t\t\t\tmargin-top: -5px;\r\n\t\t\t\t\tborder-color: $gray-700;\r\n\t\t\t\t\tborder-style: solid;\r\n\t\t\t\t\tborder-width: 0 2px 2px 0;\r\n\t\t\t\t\tpadding: 3px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\t.select2-container--default.form-control-sm {\r\n\t\t.select2-selection--single {\r\n\t\t\t.select2-selection__arrow {\r\n\t\t\t\ttop: 7px;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\t.select2-container--open {\r\n\t\t.select2-dropdown--below {\r\n\t\t\tmargin-top: 10px;\r\n\t\t}\r\n\t}\r\n}\r\n.success-pass {\r\n\tmargin-bottom: 40px;\r\n\ttext-align: center;\r\n}\r\n.review-files {\r\n\tp {\r\n\t\tmargin-bottom: 5px;\r\n\t\tcolor: $gray-900;\r\n\t\tfont-size: $font-size-14;\r\n\t}\r\n}\r\n.like-chat-grp {\r\n\tul {\r\n\t\tpadding: 0;\r\n\t\tmargin-bottom: 0;\r\n\t\tdisplay: -webkit-box;\r\n\t\tdisplay: -ms-flexbox;\r\n\t\tdisplay: flex;\r\n\t\t-webkit-box-align: center;\r\n\t\t-ms-flex-align: center;\r\n\t\tmargin-top: 10px;\r\n\t\tli {\r\n\t\t\tlist-style: none;\r\n\t\t\ta {\r\n\t\t\t\tborder: 1px solid #E0E0E0;\r\n\t\t\t\tborder-radius: 50px;\r\n\t\t\t\tpadding: 3px 12px;\r\n\t\t\t\tdisplay: block;\r\n\t\t\t\tdisplay: -webkit-box;\r\n\t\t\t\tdisplay: -ms-flexbox;\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\t-webkit-box-align: center;\r\n\t\t\t\t-ms-flex-align: center;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tjustify-content: center;\r\n\t\t\t\t-webkit-justify-content: center;\r\n\t\t\t\t-ms-flex-pack: center;\r\n\t\t\t\tcolor: $gray-900;\r\n\t\t\t\tfont-weight: $font-weight-normal;\r\n\t\t\t\tfont-size: $font-size-14;\r\n\t\t\t\timg {\r\n\t\t\t\t\tmargin-left: 5px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t\tli+li {\r\n\t\t\tmargin-left: 10px;\r\n\t\t}\r\n\t\tli.like-chat {\r\n\t\t\ta {\r\n\t\t\t\tbackground: #FEF6DC;\r\n\t\t\t}\r\n\t\t}\r\n\t\tli.comment-chat {\r\n\t\t\ta {\r\n\t\t\t\tbackground: #FFE8E9;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n.chat-line {\r\n\tmargin: 0px 0 20px;\r\n\tposition: relative;\r\n\ttext-align: center;\r\n\twidth: 100%;\r\n\t&:before {\r\n\t\tcontent: \"\";\r\n\t\tposition: absolute;\r\n\t\tleft: 0;\r\n\t\ttop: 50%;\r\n\t\ttransform: translateY(-50%);\r\n\t\t-webkit-transform: translateY(-50%);\r\n\t\t-ms-transform: translateY(-50%);\r\n\t\tbackground-color: $light-900;\r\n\t\twidth: 100%;\r\n\t\theight: 1px;\r\n\t}\r\n}\r\n.chat-date {\r\n\tborder-radius: 100px;\r\n    background: $light-900;\r\n\tcolor: $gray-900;\r\n\tfont-size: $font-size-14;\r\n\tpadding: 4px 20px;\r\n\tdisplay: inline-block;\r\n\tfont-weight: $font-weight-normal;\r\n\tposition: relative;\r\n\tborder: 1px solid #E0E0E0;\r\n}\r\n.chat+.sidebar-group {\r\n\tmargin-right: 0px;\r\n\t.sidebar {\r\n\t\tmargin-right: 0px;\r\n\t}\r\n}\r\n.group-comman-theme {\r\n\tpadding: 0 24px;\r\n\th6 {\r\n\t\tmargin-bottom: 15px;\r\n\t}\r\n\tul {\r\n\t\tpadding: 0;\r\n\t\tpadding-bottom: 15px;\r\n\t\tmargin-bottom: 15px;\r\n\t\tborder-bottom: 1px solid #EDEDED;\r\n\t\tli {\r\n\t\t\tdisplay: -webkit-box;\r\n\t\t\tdisplay: -ms-flexbox;\r\n\t\t\tdisplay: flex;\r\n\t\t\t-webkit-box-align: center;\r\n\t\t\t-ms-flex-align: center;\r\n\t\t\talign-items: center;\r\n\t\t\tlist-style: none;\r\n\t\t\tborder: 1px solid #E0E0E0;\r\n\t\t\tborder-radius: 5px;\r\n\t\t\tpadding: 5px;\r\n\t\t\tmargin-bottom: 10px;\r\n\t\t\t&:last-child {\r\n\t\t\t\tmargin-bottom: 0;\r\n\t\t\t}\r\n\t\t\t.avatar {\r\n\t\t\t\tflex-shrink: 0;\r\n\t\t\t\tmargin-right: 10px;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n.theme-content {\r\n\th6 {\r\n\t\tmargin-bottom: 6px;\r\n\t\tcolor: $gray-900;\r\n\t\tfont-size: $font-size-15;\r\n\t\tfont-weight: $font-weight-medium;\r\n\t}\r\n\tp {\r\n\t\tmargin-bottom: 0;\r\n\t\ttext-align: start;\r\n\t\t-webkit-line-clamp: 1;\r\n\t\t-webkit-box-orient: vertical;\r\n\t\toverflow: hidden;\r\n\t\ttext-overflow: ellipsis;\r\n\t\tdisplay: -webkit-box;\r\n\t\tcolor: $gray-900;\r\n\t\tfont-size: $font-size-14;\r\n\t}\r\n}\r\n.chat-message-grp {\r\n\tpadding: 24px;\r\n\tpadding-top: 0;\r\n\tul {\r\n\t\tpadding: 0;\r\n\t\tli {\r\n\t\t\tlist-style: none;\r\n\t\t\tmargin-bottom: 15px;\r\n\t\t\t&:last-child {\r\n\t\t\t\tmargin-bottom: 0px;\r\n\t\t\t}\r\n\t\t\ta {\r\n\t\t\t\tdisplay: -webkit-box;\r\n\t\t\t\tdisplay: -ms-flexbox;\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\t-webkit-box-align: center;\r\n\t\t\t\t-ms-flex-align: center;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tjustify-content: space-between;\r\n\t\t\t\t-webkit-justify-content: space-between;\r\n\t\t\t\t-ms-flex-pack: space-between;\r\n\t\t\t\t&:hover {\r\n\t\t\t\t\t.stared-group {\r\n\t\t\t\t\t\th6 {\r\n\t\t\t\t\t\t\tcolor: $gray-800;\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n.stared-group {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tspan {\r\n\t\twidth: 30px;\r\n\t\theight: 30px;\r\n\t\tborder-radius: 6px;\r\n\t\tmargin-right: 10px;\r\n\t\tbackground: #F6F7F8;\r\n\t\tdisplay: -webkit-box;\r\n\t\tdisplay: -ms-flexbox;\r\n\t\tdisplay: flex;\r\n\t\t-webkit-box-align: center;\r\n\t\t-ms-flex-align: center;\r\n\t\talign-items: center;\r\n\t\tjustify-content: center;\r\n\t\t-webkit-justify-content: center;\r\n\t\t-ms-flex-pack: center;\r\n\t\ti {\r\n\t\t\tfont-size: $font-size-16;\r\n\t\t}\r\n\t}\r\n\th6 {\r\n\t\tfont-size: $font-size-15;\r\n\t\tfont-weight: $font-weight-medium;\r\n\t\tcolor: $text-color;\r\n\t\tmargin-bottom: 0;\r\n\t}\r\n}\r\n.star-message {\r\n\tbackground: #FEF6DC;\r\n\ti {\r\n\t\tcolor: $warning-700;\r\n\t}\r\n}\r\n.mute-message {\r\n\tbackground: #EBFDFFFA;\r\n\ti {\r\n\t\tcolor: $cyan;\r\n\t}\r\n}\r\n.block-message {\r\n\tbackground: #FFE8E9;\r\n\ti {\r\n\t\tcolor: $purple;\r\n\t}\r\n}\r\n.report-message {\r\n\tbackground: #F8ECFF;\r\n\ti {\r\n\t\tcolor: $gray-900;\r\n\t}\r\n}\r\n.delete-message {\r\n\tbackground: #FFE8E9;\r\n\ti {\r\n\t\tcolor: $danger-800;\r\n\t}\r\n}\r\n.count-group {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tspan {\r\n\t\twidth: 16px;\r\n\t\theight: 16px;\r\n\t\tborder-radius: 50px;\r\n\t\tcolor: $white;\r\n\t\tfont-size: 10px;\r\n\t\tbackground: $primary;\r\n\t\tdisplay: -webkit-box;\r\n\t\tdisplay: -ms-flexbox;\r\n\t\tdisplay: flex;\r\n\t\t-webkit-box-align: center;\r\n\t\t-ms-flex-align: center;\r\n\t\talign-items: center;\r\n\t\tjustify-content: center;\r\n\t\t-webkit-justify-content: center;\r\n\t\t-ms-flex-pack: center;\r\n\t\tmargin-right: 5px;\r\n\t}\r\n\ti {\r\n\t\tcolor: #424242;\r\n\t\tfont-size: $font-size-16;\r\n\t}\r\n}\r\n.nav.nav-tabs.chat-tabs {\r\n\t.nav-item {\r\n\t\t.nav-link {\r\n\t\t\tfont-size: $font-size-16;\r\n\t\t\tfont-weight: bold;\r\n\t\t\tcolor: $white;\r\n\t\t\tbackground-color: transparent;\r\n\t\t\tborder: 0;\r\n\t\t}\r\n\t\t.nav-link.active {\r\n\t\t\tfont-size: $font-size-16;\r\n\t\t\tfont-weight: bold;\r\n\t\t\tcolor: $primary-800;\r\n\t\t}\r\n\t}\r\n}\r\n.header-top {\r\n\tul {\r\n\t\tli {\r\n\t\t\ta {\r\n\t\t\t\tcolor: $black;\r\n\t\t\t\tfont-size: $font-size-18;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n.set-search {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tfont-size: $font-size-16;\r\n\tborder-radius: 50px;\r\n\twidth: 28px;\r\n\theight: 28px;\r\n\t&:hover {\r\n\t\tbackground: #F5F5F5;\r\n\t\tborder-color: $gray-100;\r\n\t}\r\n}\r\n.header-action {\r\n\tlist-style: none;\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n\tli {\r\n\t\tdisplay: inline-block;\r\n\t\tmargin-left: 10px;\r\n\t\ta {\r\n\t\t\tcolor: $gray-900;\r\n\t\t\tfont-size: $font-size-18;\r\n\t\t}\r\n\t}\r\n}\r\n.user-list {\r\n\tborder-radius: .25rem;\r\n\tdisplay: flex;\r\n\tdisplay: -webkit-flex;\r\n\tflex-direction: column;\r\n\t-webkit-flex-direction: column;\r\n\tpadding-left: 0;\r\n\tmargin-bottom: 0;\r\n\tli {\r\n\t\ta {\r\n\t\t\tpadding: 17px 20px;\r\n\t\t\tdisplay: flex;\r\n\t\t\tdisplay: -webkit-flex;\r\n\t\t\tcursor: pointer;\r\n\t\t\tborder-radius: 6px;\r\n\t\t\tmargin-bottom: 10px;\r\n\t\t\tborder: 0;\r\n\t\t\tbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\r\n\t\t}\r\n\t\t.avatar {\r\n\t\t\tmargin-right: 0.8rem;\r\n\t\t\tdisplay: inline-block;\r\n\t\t\tmargin-bottom: 0;\r\n\t\t\theight: 46px;\r\n\t\t\twidth: 46px;\r\n\t\t\tborder-radius: 50%;\r\n\t\t\tposition: relative;\r\n\t\t\tz-index: 0;\r\n\t\t\t.letter-avatar {\r\n\t\t\t\twidth: 45px;\r\n\t\t\t\theight: 45px;\r\n\t\t\t\tborder-radius: 45px;\r\n\t\t\t\tmargin-right: 0.8rem;\r\n\t\t\t\tmargin-bottom: 0;\r\n\t\t\t\tposition: relative;\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\tdisplay: -webkit-flex;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\t-webkit-align-items: center;\r\n\t\t\t\tjustify-content: center;\r\n\t\t\t\t-webkit-justify-content: center;\r\n\t\t\t\tbackground-color: $gray-400;\r\n\t\t\t\tfont-size: $font-size-16;\r\n\t\t\t\tfont-weight: $font-weight-semibold;\r\n\t\t\t\tcolor: $violet;\r\n\t\t\t}\r\n\t\t}\r\n\t\ta.admin-shade {\r\n\t\t\tbox-shadow: none;\r\n\t\t}\r\n\t}\r\n\t.avatar {\r\n\t\t>a {\r\n\t\t\t>img {\r\n\t\t\t\twidth: 100%;\r\n\t\t\t\theight: 100%;\r\n\t\t\t\tobject-fit: cover;\r\n\t\t\t}\r\n\t\t}\r\n\t\t>img {\r\n\t\t\twidth: 100%;\r\n\t\t\theight: 100%;\r\n\t\t\tobject-fit: cover;\r\n\t\t}\r\n\t}\r\n}\r\n.avatar-away {\r\n\t&::before {\r\n\t\tcontent: \"\";\r\n\t\tposition: absolute;\r\n\t\tdisplay: block;\r\n\t\twidth: 12px;\r\n\t\theight: 12px;\r\n\t\tborder-radius: 50%;\r\n\t\ttop: 0px;\r\n\t\tright: 2px;\r\n\t\tborder: 2px solid $white;\r\n\t\tz-index: 9;\r\n\t\tbackground-color: $yellow;\r\n\t}\r\n}\r\n.avatar-offline {\r\n\t&::before {\r\n\t\tcontent: \"\";\r\n\t\tposition: absolute;\r\n\t\tdisplay: block;\r\n\t\twidth: 12px;\r\n\t\theight: 12px;\r\n\t\tborder-radius: 50%;\r\n\t\ttop: 0px;\r\n\t\tright: 2px;\r\n\t\tborder: 2px solid $white;\r\n\t\tz-index: 9;\r\n\t}\r\n}\r\n.avatar-online {\r\n\t&::before {\r\n\t\tcontent: \"\";\r\n\t\tposition: absolute;\r\n\t\tdisplay: block;\r\n\t\twidth: 12px;\r\n\t\theight: 12px;\r\n\t\tborder-radius: 50%;\r\n\t\ttop: 0px;\r\n\t\tright: 2px;\r\n\t\tborder: 2px solid $white;\r\n\t\tz-index: 9;\r\n\t\tbackground-color: $green;\r\n\t}\r\n}\r\n.animate-typing-col {\r\n\tcolor: $success;\r\n\t.dot {\r\n\t\tdisplay: inline-block;\r\n\t\twidth: 4px;\r\n\t\theight: 4px;\r\n\t\tborder-radius: 50%;\r\n\t\tmargin-right: -1px;\r\n\t\tbackground: #0D9B35;\r\n\t\t-webkit-animation: wave 1.3s linear infinite;\r\n\t\tanimation: wave 1.3s linear infinite;\r\n\t\topacity: .6;\r\n\t\t&:nth-child(2) {\r\n\t\t\t-webkit-animation-delay: -1.1s;\r\n\t\t\tanimation-delay: -1.1s;\r\n\t\t}\r\n\t\t&:nth-child(3) {\r\n\t\t\t-webkit-animation-delay: -.9s;\r\n\t\t\tanimation-delay: -.9s;\r\n\t\t}\r\n\t}\r\n}\r\n.chat_form {\r\n\tborder-radius: 20px;\r\n\tmargin-right: 0px;\r\n\tbackground: $white;\r\n\tborder: 1px solid #C2C2C2;\r\n\tbox-shadow: 0px 4px 4px #F5F8FF;\r\n\tborder-radius: 6px;\r\n\theight: 40px;\r\n\tpadding: 10px 10px;\r\n}\r\n.contact-close {\r\n\ta {\r\n\t\tcolor: $gray-900;\r\n\t\topacity: 0.5;\r\n\t\tborder-color: $gray-300;\r\n\t}\r\n}\r\n.main-wrapper {\r\n\t.content {\r\n\t\t.sidebar-group.right-sidebar {\r\n\t\t\t.sidebar {\r\n\t\t\t\twidth: 310px;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n.primary-title {\r\n\tcolor: $primary-800;\r\n\tfont-size: $font-size-14;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: space-between;\r\n\tmargin-bottom: 0;\r\n\ti {\r\n\t\tfont-size: $font-size-14;\r\n\t}\r\n}\r\n.contact-action {\r\n\tpadding: 0;\r\n\tmargin: 0;\r\n\tlist-style: none;\r\n\tli {\r\n\t\tpadding: 11px 0;\r\n\t\tborder-bottom: 1px solid #f1f1f1;\r\n\t\ta {\r\n\t\t\tcolor: $gray-900;\r\n\t\t\tcolor: $gray-900;\r\n\t\t\tfont-size: $font-size-14;\r\n\t\t\tfont-weight: bold;\r\n\t\t}\r\n\t}\r\n\tli.report-contact {\r\n\t\ta {\r\n\t\t\tcolor: $danger;\r\n\t\t}\r\n\t}\r\n\tli.delete-chat {\r\n\t\ta {\r\n\t\t\tcolor: $danger;\r\n\t\t}\r\n\t}\r\n\tli.sign-out {\r\n\t\ta {\r\n\t\t\tcolor: $danger;\r\n\t\t}\r\n\t}\r\n}\r\n.left-sidebar {\r\n\tdisplay: flex;\r\n\tdisplay: -webkit-flex;\r\n\tflex-direction: column;\r\n\t-webkit-flex-direction: column;\r\n\ttransition: all .5s ease;\r\n\t-webkit-transition: all .5s ease;\r\n\t-ms-transition: all .5s ease;\r\n}\r\n.left-sidebar-wrap {\r\n\tbackground: #FBFBFB;\r\n\toverflow: hidden;\r\n\twidth: 448px;\r\n\tdisplay: flex;\r\n\tdisplay: -webkit-flex;\r\n\tflex-direction: column;\r\n\t-webkit-flex-direction: column;\r\n\tflex: 1;\r\n}\r\n.right-sidebar {\r\n\tdisplay: flex;\r\n\tdisplay: -webkit-flex;\r\n\tflex-direction: column;\r\n\t-webkit-flex-direction: column;\r\n\tbackground-color: $light;\r\n\topacity: 100%;\r\n\ttransition: all .5s ease;\r\n\t-webkit-transition: all .5s ease;\r\n\t-ms-transition: all .5s ease;\r\n\tposition: relative;\r\n\twidth: 320px;\r\n\t.right-sidebar-wrap {\r\n\t\tbackground-color: $white;\r\n\t\tborder-left: 1px solid #E0E0E0;\r\n\t\tborder-radius: 0px;\r\n\t\tmargin-top: 0px;\r\n\t\tmargin-bottom: 0px;\r\n\t\theight: calc(100vh - 0px);\r\n\t\t.sidebar-body {\r\n\t\t\tpadding: 0;\r\n\t\t}\r\n\t\t.right-sidebar-profile {\r\n\t\t\tpadding: 24px;\r\n\t\t\tpadding-bottom: 0;\r\n\t\t\tmargin-bottom: 15px;\r\n\t\t}\r\n\t}\r\n\t.contact-close_call {\r\n\t\t.close_profile {\r\n\t\t\twidth: 25px;\r\n\t\t\theight: 25px;\r\n\t\t\tborder-radius: 25px;\r\n\t\t\tcolor: $gray-900;\r\n\t\t\tdisplay: flex;\r\n\t\t\tdisplay: -webkit-flex;\r\n\t\t\tjustify-content: center;\r\n\t\t\t-webkit-justify-content: center;\r\n\t\t\talign-items: center;\r\n\t\t\t-webkit-align-items: center;\r\n\t\t\t&.close-star {\r\n\t\t\t\tcolor: $warning;\r\n\t\t\t}\r\n\t\t\t&.close-trash {\r\n\t\t\t\tcolor: $danger;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n.right-sidebar.video-right-sidebar {\r\n\twidth: 371px;\r\n\t.chat {\r\n\t\t.chat-body {\r\n\t\t\tpadding-bottom: 110px;\r\n\t\t}\r\n\t\tmargin-left: 0 !important;\r\n\t\tdisplay: block;\r\n\t}\r\n}\r\n.video-call-chat {\r\n\t.left-chat-title.with-bg {\r\n\t\tbackground: transparent;\r\n\t}\r\n\t.left-chat-title {\r\n\t\tborder: 0;\r\n\t}\r\n\t.chat-title {\r\n\t\th4 {\r\n\t\t\tfont-size: $font-size-18;\r\n\t\t\tfont-weight: $font-weight-semibold;\r\n\t\t\tcolor: $gray-900;\r\n\t\t}\r\n\t\tspan {\r\n\t\t\tfont-size: 12px;\r\n\t\t\tfont-weight: $font-weight-normal;\r\n\t\t\tcolor: $gray-900;\r\n\t\t}\r\n\t}\r\n}\r\n.chat.video-call-chat {\r\n\t.chat-body {\r\n\t\tbackground-image: none;\r\n\t\t.messages {\r\n\t\t\t.chats {\r\n\t\t\t\t.message-content {\r\n\t\t\t\t\tbackground: #F5F5F5;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t\t.chats.chats-right {\r\n\t\t\t\t.message-content {\r\n\t\t\t\t\tbackground: #F8ECFF;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n.member-details {\r\n\tmargin-bottom: 10px;\r\n}\r\n.chat-member-details {\r\n\tpadding: 0 24px;\r\n\t.member-details {\r\n\t\tul {\r\n\t\t\tpadding: 0;\r\n\t\t\tborder-bottom: 1px solid #EDEDED;\r\n\t\t\tli {\r\n\t\t\t\tlist-style: none;\r\n\t\t\t\tmargin-bottom: 15px;\r\n\t\t\t\th6 {\r\n\t\t\t\t\tfont-size: $font-size-15;\r\n\t\t\t\t\tfont-weight: $font-weight-normal;\r\n\t\t\t\t\tcolor: $gray-900;\r\n\t\t\t\t\tmargin-bottom: 5px;\r\n\t\t\t\t}\r\n\t\t\t\th5 {\r\n\t\t\t\t\tfont-size: $font-size-15;\r\n\t\t\t\t\tfont-weight: $font-weight-medium;\r\n\t\t\t\t\tcolor: $gray-900;\r\n\t\t\t\t\tmargin-bottom: 0px;\r\n\t\t\t\t}\r\n\t\t\t\tspan {\r\n\t\t\t\t\tfont-size: $font-size-16;\r\n\t\t\t\t\tfont-weight: $font-weight-normal;\r\n\t\t\t\t\tcolor: $gray-900;\r\n\t\t\t\t}\r\n\t\t\t\ta {\r\n\t\t\t\t\tfont-size: $font-size-15;\r\n\t\t\t\t\tfont-weight: $font-weight-medium;\r\n\t\t\t\t\tcolor: $gray-800;\r\n\t\t\t\t\tborder-radius: 100px;\r\n\t\t\t\t\tpadding: 5px;\r\n\t\t\t\t\tbackground: #F5F5F5;\r\n\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\talign-items: center;\r\n\t\t\t\t\tjustify-content: center;\r\n\t\t\t\t\t&:hover {\r\n\t\t\t\t\t\tcolor: $gray-900;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t\ta+a {\r\n\t\t\t\t\tmargin-left: 10px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n.right-sidebar.show-right-sidebar {\r\n\tmargin-right: 0;\r\n}\r\n.right-sidebar.video-right-sidebar.show-right-sidebar {\r\n\tmargin-right: 0;\r\n}\r\n.right-sidebar.hide-right-sidebar {\r\n\tmargin-right: -320px;\r\n}\r\n.right-sidebar.video-right-sidebar.hide-right-sidebar {\r\n\tmargin-right: -371px;\r\n}\r\n.status-modal {\r\n\t.custom-status-close {\r\n\t\twidth: 25px;\r\n\t\theight: 25px;\r\n\t\tborder-radius: 25px;\r\n\t\tcolor: $gray-900;\r\n\t\tdisplay: flex;\r\n\t\tdisplay: -webkit-flex;\r\n\t\tjustify-content: center;\r\n\t\t-webkit-justify-content: center;\r\n\t\talign-items: center;\r\n\t\t-webkit-align-items: center;\r\n\t\tbackground-color: $gray-100;\r\n\t\tborder-color: $gray-100;\r\n\t}\r\n}\r\n.group-description {\r\n\t.description-sub {\r\n\t\th5 {\r\n\t\t\tspan {\r\n\t\t\t\ta {\r\n\t\t\t\t\twidth: 25px;\r\n\t\t\t\t\theight: 25px;\r\n\t\t\t\t\tborder-radius: 25px;\r\n\t\t\t\t\tcolor: $gray-900;\r\n\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\tdisplay: -webkit-flex;\r\n\t\t\t\t\tjustify-content: center;\r\n\t\t\t\t\t-webkit-justify-content: center;\r\n\t\t\t\t\talign-items: center;\r\n\t\t\t\t\t-webkit-align-items: center;\r\n\t\t\t\t\tborder-color: $gray-100;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n.list_group_notread {\r\n\tcolor: $primary-800 !important;\r\n}\r\n.chat-cont-type {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\t.chat-type-wrapper {\r\n\t\tmargin-bottom: 0;\r\n\t\tp {\r\n\t\t\tcolor: $gray-500;\r\n\t\t\tfont-size: 12px;\r\n\t\t\tfont-weight: $font-weight-normal;\r\n\t\t\tmargin-bottom: 0;\r\n\t\t}\r\n\t}\r\n}\r\n.group-type-radio {\r\n\tdisplay: block;\r\n\tposition: relative;\r\n\tpadding-left: 35px;\r\n\tcursor: pointer;\r\n\tfont-size: $font-size-22;\r\n\t-webkit-user-select: none;\r\n\t-moz-user-select: none;\r\n\t-ms-user-select: none;\r\n\tuser-select: none;\r\n\tfont-size: $font-size-16;\r\n\tfont-weight: $font-weight-normal;\r\n\tcolor: $gray-900;\r\n\tmargin-right: 24px;\r\n\tinput {\r\n\t\tposition: absolute;\r\n\t\topacity: 0;\r\n\t\tcursor: pointer;\r\n\t\t&:checked {\r\n\t\t\t~ {\r\n\t\t\t\t.checkmark {\r\n\t\t\t\t\tbackground-color: $gray-800;\r\n\t\t\t\t\t&:after {\r\n\t\t\t\t\t\tdisplay: block;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\t.checkmark {\r\n\t\t&:after {\r\n\t\t\ttop: 4px;\r\n\t\t\tleft: 4px;\r\n\t\t\twidth: 12px;\r\n\t\t\theight: 12px;\r\n\t\t\tborder-radius: 50%;\r\n\t\t\tbackground: white;\r\n\t\t}\r\n\t}\r\n}\r\n.checkmark {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\theight: 22px;\r\n\twidth: 22px;\r\n\tbackground-color: $white;\r\n\tborder: 1px solid #E4E4E4;\r\n\tborder-radius: 50%;\r\n\t&:after {\r\n\t\tcontent: \"\";\r\n\t\tposition: absolute;\r\n\t\tdisplay: none;\r\n\t}\r\n}\r\n.pass-login {\r\n\tlabel {\r\n\t\tcolor: $gray-900;\r\n\t\tfont-size: $font-size-14;\r\n\t\tfont-weight: $font-weight-medium;\r\n\t}\r\n}\r\n.select2-container--default {\r\n\t.select2-results__option--highlighted[aria-selected] {\r\n\t\tbackground-color: $gray-800 !important;\r\n\t}\r\n}\r\n.right-sidebar-profile {\r\n\t>.avatar {\r\n\t\tbackground: rgba(66, 11, 161, 0.1);\r\n\t}\r\n}\r\n.group_img {\r\n\tposition: relative;\r\n\tdisplay: inline-block;\r\n}\r\n.group-name-search {\r\n\tmargin-bottom: 14px;\r\n}\r\n.parti-wrapper {\r\n\tmargin-bottom: 14px;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n}\r\n.group_header {\r\n\twidth: 38px !important;\r\n\theight: 38px !important;\r\n\tborder: 2px solid $white;\r\n}\r\n.last-chat-time {\r\n\ti.missed-col {\r\n\t\twidth: 17px;\r\n\t\tdisplay: inline-block;\r\n\t\tmargin-top: 10px;\r\n\t\timg {\r\n\t\t\tmax-width: 100%;\r\n\t\t\theight: auto;\r\n\t\t}\r\n\t}\r\n}\r\n.right-sidebar-head {\r\n\tpadding: 0px 24px;\r\n\th5 {\r\n\t\tfont-size: $font-size-15;\r\n\t\tfont-weight: $font-weight-semibold;\r\n\t\tcolor: $gray-900;\r\n\t\tmargin-bottom: 0px;\r\n\t}\r\n}\r\n.right-sidebar-head.share-media {\r\n\t.share-media-blk {\r\n\t\tmargin-bottom: 20px;\r\n\t\tdisplay: -webkit-box;\r\n\t\tdisplay: -ms-flexbox;\r\n\t\tdisplay: flex;\r\n\t\t-webkit-box-align: center;\r\n\t\t-ms-flex-align: center;\r\n\t\talign-items: center;\r\n\t\tjustify-content: space-between;\r\n\t\t-webkit-justify-content: space-between;\r\n\t\t-ms-flex-pack: space-between;\r\n\t}\r\n\t.about-media-tabs {\r\n\t\t.nav-tabs {\r\n\t\t\tmargin-bottom: 15px;\r\n\t\t\tpadding: 5px;\r\n\t\t\tborder-radius: 8px;\r\n\t\t\tdisplay: flex;\r\n\t\t\tjustify-content: space-between;\r\n\t\t}\r\n\t\tborder-bottom: 1px solid #EDEDED;\r\n\t\tpadding-bottom: 10px;\r\n\t\tmargin-bottom: 15px;\r\n\t\t.nav {\r\n\t\t\t.nav-item.active {\r\n\t\t\t\tbackground: $primary;\r\n\t\t\t\tborder-radius: 6px;\r\n\t\t\t\tcolor: $gray-900;\r\n\t\t\t\tcolor: $white;\r\n\t\t\t}\r\n\t\t\t.nav-item {\r\n\t\t\t\tpadding: 2px 10px;\r\n\t\t\t\tfont-size: $font-size-14;\r\n\t\t\t\tcolor: $gray-900;\r\n\t\t\t\tfont-weight: $font-weight-medium;\r\n\t\t\t\tborder: 0;\r\n\t\t\t\tmargin-right: 10px;\r\n\t\t\t\tbackground: $body-bg;\r\n\t\t\t\tcolor: $gray-900;\r\n\t\t\t\tborder-radius: 6px;\r\n\t\t\t\t&:last-child {\r\n\t\t\t\t\tmargin-right: 0px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t\t.share-media-img {\r\n\t\t\tli {\r\n\t\t\t\tmargin: 0px 6px 6px 0px;\r\n\t\t\t\tposition: relative;\r\n\t\t\t\timg {\r\n\t\t\t\t\tborder-radius: 8px;\r\n\t\t\t\t\twidth: 84px;\r\n\t\t\t\t}\r\n\t\t\t\tspan {\r\n\t\t\t\t\ti {\r\n\t\t\t\t\t\tfont-size: $font-size-20;\r\n\t\t\t\t\t\tcolor: $white;\r\n\t\t\t\t\t}\r\n\t\t\t\t\tposition: absolute;\r\n\t\t\t\t\tcolor: $white;\r\n\t\t\t\t\tfont-size: 13px;\r\n\t\t\t\t\tfont-weight: $font-weight-medium;\r\n\t\t\t\t\tposition: absolute;\r\n\t\t\t\t\ttop: 50%;\r\n\t\t\t\t\tleft: 50%;\r\n\t\t\t\t\t-webkit-transform: translate(-50%, -50%);\r\n\t\t\t\t\t-ms-transform: translate(-50%, -50%);\r\n\t\t\t\t\ttransform: translate(-50%, -50%);\r\n\t\t\t\t}\r\n\t\t\t\t&:hover {\r\n\t\t\t\t\tspan {\r\n\t\t\t\t\t\ti {\r\n\t\t\t\t\t\t\tcolor: $gray-300;\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t\tli.blur-media {\r\n\t\t\t\timg {\r\n\t\t\t\t\tfilter: blur(2px);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n.media-file {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tjustify-content: space-between;\r\n\t-webkit-justify-content: space-between;\r\n\t-ms-flex-pack: space-between;\r\n\tmargin-bottom: 15px;\r\n\t&:last-child {\r\n\t\tmargin-bottom: 0;\r\n\t}\r\n}\r\n.media-doc-blk {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tspan {\r\n\t\twidth: 50px;\r\n\t\theight: 50px;\r\n\t\tborder-radius: 5px;\r\n\t\tbackground: #F5F5F5;\r\n\t\tdisplay: -webkit-box;\r\n\t\tdisplay: -ms-flexbox;\r\n\t\tdisplay: flex;\r\n\t\t-webkit-box-align: center;\r\n\t\t-ms-flex-align: center;\r\n\t\talign-items: center;\r\n\t\tjustify-content: center;\r\n\t\t-webkit-justify-content: center;\r\n\t\t-ms-flex-pack: center;\r\n\t\tmargin-right: 10px;\r\n\t\ti {\r\n\t\t\tfont-size: $font-size-24;\r\n\t\t}\r\n\t}\r\n}\r\n.document-detail {\r\n\tul {\r\n\t\tpadding: 0;\r\n\t\tmargin-bottom: 0;\r\n\t\tdisplay: -webkit-box;\r\n\t\tdisplay: -ms-flexbox;\r\n\t\tdisplay: flex;\r\n\t\t-webkit-box-align: center;\r\n\t\t-ms-flex-align: center;\r\n\t\talign-items: center;\r\n\t\tli {\r\n\t\t\tlist-style: none;\r\n\t\t\tcolor: $gray-900;\r\n\t\t\tfont-size: $font-size-14;\r\n\t\t\tfont-weight: $font-weight-normal;\r\n\t\t\tposition: relative;\r\n\t\t\t&::before {\r\n\t\t\t\tcontent: \"\";\r\n\t\t\t\tposition: absolute;\r\n\t\t\t\twidth: 1px;\r\n\t\t\t\theight: 13px;\r\n\t\t\t\tbackground: #C2C2C2;\r\n\t\t\t\tright: -8px;\r\n\t\t\t\ttop: 5px;\r\n\t\t\t}\r\n\t\t\t&:last-child {\r\n\t\t\t\t&::before {\r\n\t\t\t\t\tdisplay: none;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t\tli+li {\r\n\t\t\tpadding-left: 15px;\r\n\t\t}\r\n\t}\r\n\th6 {\r\n\t\tcolor: $gray-900;\r\n\t\tfont-size: $font-size-15;\r\n\t\tfont-weight: $font-weight-medium;\r\n\t}\r\n}\r\n.media-download {\r\n\ta {\r\n\t\tcolor: $gray-900;\r\n\t}\r\n}\r\n.social-media-col {\r\n\tmargin-top: 35px;\r\n\t&:after {\r\n\t\tcontent: \"\";\r\n\t\tdisplay: table;\r\n\t\tclear: both;\r\n\t}\r\n\tul {\r\n\t\tlist-style: none;\r\n\t\tpadding: 0;\r\n\t\tmargin: 0;\r\n\t\tli {\r\n\t\t\tfloat: left;\r\n\t\t\ta {\r\n\t\t\t\tcolor: $violet;\r\n\t\t\t\tfont-size: $font-size-18;\r\n\t\t\t}\r\n\t\t}\r\n\t\tli+li {\r\n\t\t\tmargin-left: 10px;\r\n\t\t}\r\n\t}\r\n\th6 {\r\n\t\tfont-weight: $font-weight-semibold;\r\n\t\tcolor: $black;\r\n\t\tfont-size: $font-size-15;\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n}\r\n.media-link-grp {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tmargin-bottom: 15px;\r\n}\r\n.media-link-detail {\r\n\th6 {\r\n\t\ta {\r\n\t\t\tcolor: $gray-900;\r\n\t\t\tfont-size: $font-size-15;\r\n\t\t\tfont-weight: $font-weight-medium;\r\n\t\t\tmargin-bottom: 5px;\r\n\t\t}\r\n\t}\r\n\tspan {\r\n\t\ta {\r\n\t\t\tcolor: $gray-900;\r\n\t\t\tfont-size: $font-size-14;\r\n\t\t\tfont-weight: $font-weight-normal;\r\n\t\t\tword-break: break-all;\r\n\t\t}\r\n\t}\r\n\ta {\r\n\t\t&:hover {\r\n\t\t\tcolor: $gray-800;\r\n\t\t}\r\n\t}\r\n}\r\n.share-media-blk {\r\n\ta {\r\n\t\tcolor: $gray-800;\r\n\t\tfont-weight: $font-weight-medium;\r\n\t}\r\n}\r\n.link-img {\r\n\tflex-shrink: 0;\r\n\timg {\r\n\t\tborder-radius: 4px;\r\n\t\tmargin-right: 10px;\r\n\t}\r\n}\r\n.settings-col {\r\n\th6 {\r\n\t\tfont-weight: $font-weight-semibold;\r\n\t\tcolor: $black;\r\n\t\tfont-size: $font-size-15;\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\tmargin-top: 35px;\r\n\t&:after {\r\n\t\tcontent: \"\";\r\n\t\tdisplay: table;\r\n\t\tclear: both;\r\n\t}\r\n\tul {\r\n\t\tlist-style: none;\r\n\t\tpadding: 0;\r\n\t\tmargin: 0;\r\n\t\tli {\r\n\t\t\tcolor: $gray-600;\r\n\t\t\tfont-weight: $font-weight-medium;\r\n\t\t}\r\n\t\tli+li {\r\n\t\t\tmargin-top: 15px;\r\n\t\t}\r\n\t}\r\n\t.switch {\r\n\t\tposition: relative;\r\n\t\tdisplay: inline-block;\r\n\t\twidth: 40px;\r\n\t\theight: 23px;\r\n\t\tmargin-bottom: 0;\r\n\t\tmargin-right: 10px;\r\n\t\tinput {\r\n\t\t\topacity: 0;\r\n\t\t\twidth: 0;\r\n\t\t\theight: 0;\r\n\t\t}\r\n\t}\r\n\t.slider {\r\n\t\tposition: absolute;\r\n\t\tcursor: pointer;\r\n\t\ttop: 0;\r\n\t\tleft: 0;\r\n\t\tright: 0;\r\n\t\tbottom: 0;\r\n\t\tbackground-color: $gray-500;\r\n\t\t-webkit-transition: .4s;\r\n\t\ttransition: .4s;\r\n\t\t&:before {\r\n\t\t\tposition: absolute;\r\n\t\t\tcontent: \"\";\r\n\t\t\theight: 15px;\r\n\t\t\twidth: 15px;\r\n\t\t\tleft: 4px;\r\n\t\t\tbottom: 4px;\r\n\t\t\tbackground-color: $white;\r\n\t\t\t-webkit-transition: .4s;\r\n\t\t\ttransition: .4s;\r\n\t\t}\r\n\t}\r\n\tinput {\r\n\t\t&:checked+.slider {\r\n\t\t\tbackground-color: $blue;\r\n\t\t\t&:before {\r\n\t\t\t\t-webkit-transform: translateX(16px);\r\n\t\t\t\t-ms-transform: translateX(16px);\r\n\t\t\t\ttransform: translateX(16px);\r\n\t\t\t}\r\n\t\t}\r\n\t\t&:focus+.slider {\r\n\t\t\tbox-shadow: 0 0 1px #2196F3;\r\n\t\t}\r\n\t}\r\n\t.slider.round {\r\n\t\tborder-radius: 34px;\r\n\t\t&:before {\r\n\t\t\tborder-radius: 50%;\r\n\t\t}\r\n\t}\r\n}\r\n.report-col {\r\n\tmargin-top: 35px;\r\n\tpadding: 12px;\r\n\tpadding-bottom: 50px;\r\n\t&:after {\r\n\t\tcontent: \"\";\r\n\t\tdisplay: table;\r\n\t\tclear: both;\r\n\t}\r\n\tul {\r\n\t\tlist-style: none;\r\n\t\tpadding: 0;\r\n\t\tmargin: 0;\r\n\t\t&:after {\r\n\t\t\tcontent: \"\";\r\n\t\t\tdisplay: table;\r\n\t\t\tclear: both;\r\n\t\t}\r\n\t\tli {\r\n\t\t\tdisplay: block;\r\n\t\t\twidth: 100%;\r\n\t\t\tfont-weight: $font-weight-medium;\r\n\t\t\tposition: relative;\r\n\t\t\ta {\r\n\t\t\t\tcolor: $danger;\r\n\t\t\t\tpadding-left: 25px;\r\n\t\t\t\tspan {\r\n\t\t\t\t\tposition: absolute;\r\n\t\t\t\t\tleft: 0;\r\n\t\t\t\t\ttop: 0px;\r\n\t\t\t\t\tfont-size: $font-size-16;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t\tli+li {\r\n\t\t\tmargin-top: 19px;\r\n\t\t}\r\n\t}\r\n}\r\n.load-more-btn {\r\n\tfont-weight: $font-weight-semibold;\r\n\tmargin-top: 10px;\r\n\ti {\r\n\t\tbackground: #0057FF;\r\n\t\tborder-radius: 50%;\r\n\t\theight: 12px;\r\n\t\twidth: 12px;\r\n\t\tcolor: $white;\r\n\t\tline-height: 8px;\r\n\t\tfont-size: 12px;\r\n\t\tvertical-align: top;\r\n\t}\r\n}\r\n.chat-message-grp.chat-encrypt {\r\n\tpadding-bottom: 0;\r\n\tul {\r\n\t\tborder-bottom: 1px solid #EDEDED;\r\n\t\tpadding-bottom: 15px;\r\n\t\tmargin-bottom: 15px;\r\n\t}\r\n}\r\n.participants-list {\r\n\tpadding: 0px 24px;\r\n\t.participants-list-group {\r\n\t\th6.parti-search {\r\n\t\t\tfont-size: 20px !important;\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t}\r\n\t}\r\n\tul {\r\n\t\tlist-style: none;\r\n\t\tpadding: 0;\r\n\t\tmargin: 0;\r\n\t\tli {\r\n\t\t\tborder: 1px solid #E0E0E0;\r\n\t\t\tborder-radius: 5px;\r\n\t\t\tbackground-color: $white;\r\n\t\t\tpadding: 10px;\r\n\t\t}\r\n\t\tli+li {\r\n\t\t\tmargin-top: 10px;\r\n\t\t}\r\n\t}\r\n\t.users-list-body {\r\n\t\th5 {\r\n\t\t\twhite-space: nowrap;\r\n\t\t\ttext-overflow: ellipsis;\r\n\t\t\toverflow: hidden;\r\n\t\t\tfont-size: $font-size-15;\r\n\t\t\tfont-weight: $font-weight-medium;\r\n\t\t\tmargin-bottom: 5px;\r\n\t\t\tcolor: $gray-900;\r\n\t\t}\r\n\t\tp {\r\n\t\t\twhite-space: nowrap;\r\n\t\t\ttext-overflow: ellipsis;\r\n\t\t\toverflow: hidden;\r\n\t\t\tmargin-bottom: 0;\r\n\t\t\tcolor: $gray-900;\r\n\t\t\tfont-size: $font-size-14;\r\n\t\t\tfont-weight: $font-weight-normal;\r\n\t\t}\r\n\t\tflex: 1;\r\n\t\tposition: relative;\r\n\t\tmin-width: 0px;\r\n\t\tdisplay: flex;\r\n\t\tdisplay: -webkit-flex;\r\n\t\twidth: 100%;\r\n\t}\r\n\t.admin-profiles {\r\n\t\tdisplay: inline-block;\r\n\t\tcolor: $gray-800;\r\n\t\tborder-radius: 6px;\r\n\t\tfont-size: 12px;\r\n\t\tpadding: 2px 10px;\r\n\t\tfont-weight: $font-weight-medium;\r\n\t\tbackground: #F8ECFF;\r\n\t\t&:hover {\r\n\t\t\tbackground: #680A83;\r\n\t\t\tcolor: $white;\r\n\t\t}\r\n\t}\r\n}\r\n.participants-list-group {\r\n\tborder-bottom: 1px solid #EDEDED;\r\n\tpadding-bottom: 15px;\r\n\tmargin-bottom: 15px;\r\n\th6 {\r\n\t\tmargin-bottom: 15px;\r\n\t\tfont-size: $font-size-15;\r\n\t\tfont-weight: $font-weight-medium;\r\n\t\tcolor: $gray-900;\r\n\t\tdisplay: -webkit-box;\r\n\t\tdisplay: -ms-flexbox;\r\n\t\tdisplay: flex;\r\n\t\t-webkit-box-align: center;\r\n\t\t-ms-flex-align: center;\r\n\t\talign-items: center;\r\n\t\tjustify-content: space-between;\r\n\t\t-webkit-justify-content: space-between;\r\n\t\t-ms-flex-pack: space-between;\r\n\t}\r\n}\r\n.chat-message-grp.group-exits {\r\n\tpadding: 0px 24px;\r\n\tpadding-bottom: 30px;\r\n}\r\n.grp-delete {\r\n\t.chat-action-col {\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\theight: 100%;\r\n\t\t>a {\r\n\t\t\tcolor: $gray-500;\r\n\t\t}\r\n\t}\r\n}\r\n.chat-action-col {\r\n\t>a {\r\n\t\tcolor: $gray-900;\r\n\t}\r\n}\r\n.darkmode-btn {\r\n\twidth: 35px;\r\n\theight: 32px;\r\n\tbackground-color: $blue;\r\n\tborder: 1px solid #FBFBFB;\r\n\tborder-radius: 5px;\r\n\tcolor: $white;\r\n\tfont-size: $font-size-16;\r\n\tdisplay: flex;\r\n\tdisplay: -webkit-flex;\r\n\talign-items: center;\r\n\t-webkit-align-items: center;\r\n\tjustify-content: center;\r\n\t-webkit-justify-content: center;\r\n\tmargin: 0 auto;\r\n\t&:hover {\r\n\t\tcolor: $white;\r\n\t}\r\n\t&:focus {\r\n\t\tcolor: $white;\r\n\t}\r\n}\r\n.add-contacts-btn {\r\n\t&:hover {\r\n\t\tcolor: $white;\r\n\t}\r\n\t&:focus {\r\n\t\tcolor: $white;\r\n\t}\r\n\twidth: 25px;\r\n\theight: 25px;\r\n\tborder-radius: 30px;\r\n\tbackground-color: $gray-800;\r\n\tcolor: $white;\r\n\tfont-size: 10px;\r\n\tdisplay: flex;\r\n\tdisplay: -webkit-flex;\r\n\talign-items: center;\r\n\t-webkit-align-items: center;\r\n\tjustify-content: center;\r\n\t-webkit-justify-content: center;\r\n\tmargin: 0 auto;\r\n}\r\n.group-call-tab {\r\n\t.nav-tabs {\r\n\t\t.nav-link {\r\n\t\t\tcolor: $gray-800;\r\n\t\t\tborder: 0;\r\n\t\t\tborder-radius: 10px;\r\n\t\t\tfont-weight: $font-weight-medium;\r\n\t\t\tpadding: 6px 25px;\r\n\t\t\t&:hover {\r\n\t\t\t\tcolor: $gray-800;\r\n\t\t\t}\r\n\t\t}\r\n\t\t.nav-link+.nav-link {\r\n\t\t\tmargin-left: 10px;\r\n\t\t}\r\n\t\t.nav-link.active {\r\n\t\t\tbackground-color: rgba(90, 7, 139, 0.1);\r\n\t\t\tcolor: $gray-800;\r\n\t\t}\r\n\t}\r\n\tnav {\r\n\t\tpadding: 0 15px 20px;\r\n\t\tposition: relative;\r\n\t\t&:before {\r\n\t\t\tcontent: \"\";\r\n\t\t\tposition: absolute;\r\n\t\t\tleft: 0;\r\n\t\t\tbottom: 0;\r\n\t\t\twidth: 100%;\r\n\t\t\tbackground-color: $gray-400;\r\n\t\t\theight: 1px;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.header_image {\r\n\twidth: 195px;\r\n}\r\n\r\n.chat_avator_img {\r\n\tposition: relative;\r\n}\r\n\r\n.group_img {\r\n\twidth: 40px;\r\n\theight: 40px;\r\n\tobject-fit: cover;\r\n}\r\n\r\n.dreams_chat {\r\n\twidth: 40px;\r\n\theight: 40px;\r\n\tobject-fit: cover;\r\n}\r\n\r\n.voice_pop {\r\n\tpadding-right: 17px;\r\n}\r\n\r\n.status_carousel {\r\n\tmargin-top: 50px;\r\n}\r\n\r\n.carousel_img {\r\n\twidth: 650px;\r\n\theight: 434px;\r\n}\r\n\r\n.video_content {\r\n\tmin-height: 200px;\r\n\tmargin-top: 70px;\r\n}\r\n\r\n.voice-call-content {\r\n\tmin-height: 200px;\r\n}\r\n\r\n.chatimage img {\r\n\twidth: 120px;\r\n\theight: 120px;\r\n}\r\n\r\n.send-btn_status {\r\n\twidth: 52px;\r\n\theight: 52px;\r\n\tborder-radius: 50%;\r\n\tdisplay: inline-flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\tcolor: $white !important;\r\n\tbackground-color: #FFA977 !important;\r\n\tmargin-left: 15px;\r\n\tfont-size: $font-size-22;\r\n}\r\n\r\n.status_telegram {\r\n\tcolor: $white;\r\n}\r\n\r\n.media-lists {\r\n\tdisplay: flex;\r\n\tjustify-content: flex-start;\r\n\tmargin: 0 -5px 0px;\r\n\tflex-wrap: wrap;\r\n}\r\n\r\n.media-lists .media-image {\r\n\tmargin: 5px;\r\n\tflex-basis: 74px;\r\n\tmin-width: 74px;\r\n}\r\n\r\n.media-lists .media-image img {\r\n\tmax-width: 100%;\r\n}\r\n\r\n.avatar-group .avatar+.avatar {\r\n\tmargin-left: -.75rem;\r\n}\r\n\r\n.list-group-item {\r\n\tbackground-color: inherit;\r\n\tborder-color: #ebebeb;\r\n}\r\n\r\nul.list-inline .list-inline-item {\r\n\tmargin-bottom: .5rem;\r\n}\r\n\r\n.form-control {\r\n\tborder-radius: 5px;\r\n}\r\n\r\n.form-control:focus {\r\n\tbox-shadow: none;\r\n\tborder-color: #e6e6e6;\r\n}\r\n\r\n.custom-control-label {\r\n\tline-height: 25px;\r\n}\r\n\r\n.custom-control-input:checked~.custom-control-label::before {\r\n\tbackground-color: #0a80ff;\r\n}\r\n\r\n.open_drop {\r\n\tcolor: $white !important;\r\n}\r\n\r\n.send-btn_status:focus {\r\n\tbox-shadow: none !important;\r\n\tborder-color: #ffa977 !important;\r\n}\r\n\r\n.avatar {\r\n\tdisplay: inline-block;\r\n\tmargin-bottom: 0;\r\n\theight: 48px;\r\n\twidth: 48px;\r\n\tborder-radius: 50%;\r\n}\r\n\r\n.avatar .avatar-title {\r\n\tcolor: $white;\r\n\tbackground: #680A83;\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\ttext-transform: uppercase;\r\n\tfont-size: 19px;\r\n\tfont-weight: $font-weight-semibold;\r\n}\r\n\r\n.avatar > a {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tdisplay: block;\r\n\ttransition: color .3s;\r\n\tcolor: #0a80ff;\r\n}\r\n\r\n.avatar > a > img,\r\n.avatar > img {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tobject-fit: cover;\r\n}\r\n\r\n.avatar.avatar-sm {\r\n\theight: 1.3rem;\r\n\twidth: 1.3rem;\r\n}\r\n\r\n.avatar.avatar-sm .avatar-title {\r\n\tfont-size: $font-size-14;\r\n}\r\n\r\n.avatar.avatar-lg {\r\n\theight: 3.8rem;\r\n\twidth: 3.8rem;\r\n}\r\n\r\n.avatar.avatar-lg .avatar-title {\r\n\tfont-size: 29px;\r\n}\r\n\r\n.avatar.avatar-xl {\r\n\theight: 100px;\r\n\twidth: 100px;\r\n}\r\n\r\n.header_drop_icon {\r\n\tborder-radius: 6px;\r\n}\r\n\r\n.accordion-col .accordion-title {\r\n\tcursor: pointer;\r\n\tpadding: 15px 0 8px;\r\n}\r\n\r\n.accordion-col .accordion-title .primary-title i {\r\n\ttransition: all .5s ease;\r\n\t-webkit-transition: all .5s ease;\r\n\t-ms-transition: all .5s ease;\r\n\ttransform: rotate(90deg);\r\n\t-webkit-transform: rotate(90deg);\r\n\t-ms-transform: rotate(90deg);\r\n}\r\n\r\n.accordion-col .accordion-title.active .primary-title i {\r\n\ttransition: all .5s ease;\r\n\t-webkit-transition: all .5s ease;\r\n\t-ms-transition: all .5s ease;\r\n\ttransform: rotate(270deg);\r\n\t-webkit-transform: rotate(270deg);\r\n\t-ms-transform: rotate(270deg);\r\n}\r\n\r\n.accordion-col .accordion-content {\r\n\tborder-bottom: 1px solid #e6e6e6;\r\n\tpadding-bottom: 15px;\r\n}\r\n\r\n.accordion-col .accordion-content:last-child {\r\n\tborder-bottom: 0;\r\n}\r\n\r\n.accordion-col .accordion-content h6 {\r\n\tfont-size: $font-size-14;\r\n}\r\n\r\n\r\n\r\n.status-right {\r\n\tfont-weight: $font-weight-medium;\r\n\tcolor: #444444;\r\n\tfont-size: $font-size-16;\r\n\ttext-align: center;\r\n}\r\n\r\n.status-right p {\r\n\tmargin-top: 20px;\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.star-drop .btn-outline-light {\r\n\tcolor: #424242;\r\n\tborder: 0;\r\n\tpadding: 0;\r\n}\r\n\r\n.star-drop .btn-outline-light i {\r\n\tfont-size: $font-size-20;\r\n}\r\n\r\n.star-drop .btn.btn-outline-light:hover {\r\n\tbackground: transparent;\r\n\tborder: 0;\r\n}\r\n\r\n.chat.star-chat-group {\r\n\tbackground-image: none;\r\n}\r\n\r\n.chat.star-chat-group .chat-body {\r\n\tbackground-image: none;\r\n}\r\n\r\n.chat.star-chat-group .chat-body .messages .chats {\r\n    max-width: 100%;\r\n}\r\n\r\n.chat.star-chat-group .chat-body .messages .chats .message-content {\r\n\tbackground: #F5F5F5;\r\n}\r\n\r\n.chat.star-chat-group .chat-body .messages .chats .message-content.award-link a {\r\n    word-break: break-all;\r\n}\r\n\r\n.chat.star-chat-group .chat-body .messages .chats .message-content.award-link img {\r\n    max-width: 100%;\r\n}\r\n.chat .chat-body .messages .chats.forward-chat-msg {\r\n\tdisplay: none;\r\n}\r\n.chats.forward-chat-msg {\r\n\tbackground: #EDEDED;\r\n\tborder-radius: 15px;\r\n\tpadding: 20px;\r\n\tborder-left: 2px solid #680A83;\r\n}\r\n.chats.forward-chat-msg .chat-avatar {\r\n\tpadding: 0;\r\n\tpadding-right: 15px;\r\n}\r\n\r\n.chat-title h4 a {\r\n\tfont-size: $font-size-14;\r\n\tfont-weight: $font-weight-bold;\r\n\ttext-transform: uppercase;\r\n\tcolor: #4B0973;\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.left-chat-title .add-section > a {\r\n\twidth: 30px;\r\n\theight: 30px;\r\n\tbackground-color: #680A83;\r\n\tborder-radius: 30px;\r\n\tcolor: $white;\r\n\tdisplay: flex;\r\n\tdisplay: -webkit-flex;\r\n\talign-items: center;\r\n\t-webkit-align-items: center;\r\n\tjustify-content: center;\r\n\t-webkit-justify-content: center;\r\n\tfont-size: 13px;\r\n}\r\n\r\n.add-section ul {\r\n\tlist-style: none;\r\n\tpadding: 0;\r\n\tmargin: 0;\r\n}\r\n\r\n.add-section ul li {\r\n\tfloat: left;\r\n\tborder-radius: 50px;\r\n\twidth: 28px;\r\n\theight: 28px;\r\n\tdisplay: flex;\r\n\tdisplay: -webkit-flex;\r\n\talign-items: center;\r\n\t-webkit-align-items: center;\t\r\n    justify-content: center;\r\n    -webkit-justify-content: center;\r\n}\r\n\r\n.add-section ul li+li {\r\n\tmargin-left: 10px;\r\n}\r\n\r\n.add-section ul li a {\r\n\tdisplay: flex;\r\n\tdisplay: -webkit-flex;\r\n\talign-items: center;\r\n\t-webkit-align-items: center;\r\n\tfont-size: $font-size-20;\r\n}\r\n.all-chats .add-section ul li:hover{\r\n  background-color: #F5F5F5;\r\n  border-color: #F5F5F5;\r\n}\r\n\r\n.online {\r\n\tcolor: #008024;\r\n\tfont-weight: $font-weight-medium;\r\n}\r\n\r\n.top-online-contacts {\r\n\tpadding: 24px 24px 0px;\r\n}\r\n.fav-title {\r\n\tdisplay: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tjustify-content: space-between;\r\n\t-webkit-justify-content: space-between;\r\n\t-ms-flex-pack: space-between;\r\n\tmargin-bottom: 15px;\r\n}\r\n.fav-title h6 {\r\n\tmargin-bottom: 0;\r\n\tfont-size: $font-size-18;\r\n\tfont-weight: $font-weight-semibold;\r\n\tdisplay: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n}\r\n.fav-title h6 i {\r\n\tfont-size: $font-size-22;\r\n}\r\n.fav-title a {\r\n\tmargin-bottom: 0;\r\n\tcolor: $primary;\r\n\tfont-weight: $font-weight-medium;\r\n}\r\n.fav-title a:hover {\r\n\tcolor: #0A0A0A;\r\n}\r\n\r\n.top-contacts-box .profile-img {\r\n\tposition: relative;\r\n\twidth: 46px;\r\n\theight: 46px;\r\n}\r\n\r\n.top-contacts-box .profile-img img {\r\n\tmax-width: 100%;\r\n\theight: auto;\r\n\tborder-radius: 50px;\r\n}\r\n\r\n.profile-name span {\r\n\tcolor: #585858;\r\n\tfont-size: 12px;\r\n\tdisplay: inline-block;\r\n\tmargin-top: 9px;\r\n}\r\n\r\n.top-contacts-box .profile-img.online:before {\r\n\tcontent: \"\";\r\n\tposition: absolute;\r\n\tright: 0;\r\n\ttransform: translateX(-50%);\r\n\t-webkit-transform: translateX(-50%);\r\n\t-ms-transform: translateX(-50%);\r\n\ttop: 0px;\r\n\tbackground-color: #49E073;\r\n\twidth: 10px;\r\n\theight: 10px;\r\n\tborder: 2px solid $white;\r\n\tborder-radius: 50px;\r\n}\r\n\r\n.dropdown-menu .dropdown-item span.edit-profile-icon,\r\n.dropdown-menu .dropdown-item span.profile-icon-col {\r\n\tfont-size: $font-size-15;\r\n}\r\n\r\n.avatar {\r\n\tposition: relative;\r\n\tdisplay: inline-block;\r\n\twidth: 46px;\r\n\theight: 46px;\r\n\tflex-shrink: 0;\r\n}\r\n\r\n.avatar > img {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tobject-fit: cover;\r\n}\r\n\r\n.avatar-title {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tbackground-color: #650681;\r\n\tcolor: $white;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n}\r\n\r\n.avatar-away::before,\r\n.avatar-offline::before,\r\n.avatar-online::before {\r\n\tposition: absolute;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\twidth: 25%;\r\n\theight: 25%;\r\n\tborder-radius: 50%;\r\n\tcontent: '';\r\n\tborder: 2px solid $white;\r\n}\r\n\r\n.avatar-online::before {\r\n\tbackground-color: #00e65b;\r\n}\r\n\r\n.avatar-offline::before {\r\n\tbackground-color: #ff0100;\r\n}\r\n\r\n.avatar-away::before {\r\n\tbackground-color: #ffbc34;\r\n}\r\n\r\n.avatar .border {\r\n\tborder-width: 3px !important;\r\n}\r\n\r\n.avatar .rounded {\r\n\tborder-radius: 6px !important;\r\n}\r\n\r\n.avatar .avatar-title {\r\n\tfont-size: $font-size-18;\r\n}\r\n\r\n.avatar-xs {\r\n\twidth: 1.65rem;\r\n\theight: 1.65rem;\r\n}\r\n\r\n.avatar-xs .border {\r\n\tborder-width: 2px !important;\r\n}\r\n\r\n.avatar-xs .rounded {\r\n\tborder-radius: 4px !important;\r\n}\r\n\r\n.avatar-xs .avatar-title {\r\n\tfont-size: 10px;\r\n}\r\n\r\n.avatar-xs.avatar-away::before,\r\n.avatar-xs.avatar-offline::before,\r\n.avatar-xs.avatar-online::before {\r\n\tborder-width: 1px;\r\n}\r\n\r\n.avatar-sm {\r\n\twidth: 2.5rem;\r\n\theight: 2.5rem;\r\n}\r\n\r\n.avatar-sm .border {\r\n\tborder-width: 3px !important;\r\n}\r\n\r\n.avatar-sm .rounded {\r\n\tborder-radius: 4px !important;\r\n}\r\n\r\n.avatar-sm .avatar-title {\r\n\tfont-size: $font-size-15;\r\n}\r\n\r\n.avatar-sm.avatar-away::before,\r\n.avatar-sm.avatar-offline::before,\r\n.avatar-sm.avatar-online::before {\r\n\tborder-width: 2px;\r\n}\r\n\r\n.avatar-lg {\r\n\twidth: 3.75rem;\r\n\theight: 3.75rem;\r\n}\r\n\r\n.avatar-lg .border {\r\n\tborder-width: 3px !important;\r\n}\r\n\r\n.avatar-lg .rounded {\r\n\tborder-radius: 8px !important;\r\n}\r\n\r\n.avatar-lg .avatar-title {\r\n\tfont-size: $font-size-24;\r\n}\r\n\r\n.avatar-lg.avatar-away::before,\r\n.avatar-lg.avatar-offline::before,\r\n.avatar-lg.avatar-online::before {\r\n\tborder-width: 3px;\r\n}\r\n\r\n.avatar-xl {\r\n\twidth: 5rem;\r\n\theight: 5rem;\r\n}\r\n\r\n.avatar-xl .border {\r\n\tborder-width: 4px !important;\r\n}\r\n\r\n.avatar-xl .rounded {\r\n\tborder-radius: 8px !important;\r\n}\r\n\r\n.avatar-xl .avatar-title {\r\n\tfont-size: $font-size-28;\r\n}\r\n\r\n.avatar-xl.avatar-away::before,\r\n.avatar-xl.avatar-offline::before,\r\n.avatar-xl.avatar-online::before {\r\n\tborder-width: 4px;\r\n}\r\n\r\n.avatar-xxl {\r\n\twidth: 5.125rem;\r\n\theight: 5.125rem;\r\n}\r\n\r\n.avatar-xxl .border {\r\n\tborder-width: 6px !important;\r\n}\r\n\r\n.avatar-xxl .rounded {\r\n\tborder-radius: 8px !important;\r\n}\r\n\r\n.avatar-xxl .avatar-title {\r\n\tfont-size: $font-size-30;\r\n}\r\n\r\n.avatar-xxl.avatar-away::before,\r\n.avatar-xxl.avatar-offline::before,\r\n.avatar-xxl.avatar-online::before {\r\n\tborder-width: 4px;\r\n}\r\n\r\n.avatar-group {\r\n\tdisplay: flex;\r\n\tdisplay: -webkit-flex;\r\n\tpadding-left: 15px;\r\n\tmargin-left: auto;\r\n\tmargin-right: 15px;\r\n\tcursor: pointer;\r\n}\r\n\r\n.avatar-group .avatar+.avatar {\r\n\tmargin-left: -.75rem;\r\n}\r\n\r\n.avatar-group .avatar-xs+.avatar-xs {\r\n\tmargin-left: -15px;\r\n}\r\n\r\n.avatar-group .avatar-sm+.avatar-sm {\r\n\tmargin-left: -.625rem;\r\n}\r\n\r\n.avatar-group .avatar-lg+.avatar-lg {\r\n\tmargin-left: -1rem;\r\n}\r\n\r\n.avatar-group .avatar-xl+.avatar-xl {\r\n\tmargin-left: -1.28125rem;\r\n}\r\n\r\n.avatar-group .avatar:hover {\r\n\tz-index: 1;\r\n}\r\n\r\n.avatar-group.group-col {\r\n\tdisplay: block;\r\n}\r\n\r\n.avatar-group.group-col > div {\r\n\tdisplay: flex;\r\n\tdisplay: -webkit-flex;\r\n\tpadding-bottom: 5px;\r\n}\r\n\r\n.avatar-group.group-col .avatar {\r\n\tmargin-right: 0;\r\n}\r\n\r\n.contact-close {\r\n\tfloat: right;\r\n\tleft: 95%;\r\n\tright: 0px;\r\n\tposition: relative;\r\n\ttop: 5%;\r\n}\r\n\r\n.status_contactclose {\r\n\tfloat: right;\r\n\tleft: 95%;\r\n\tright: 0px;\r\n\tposition: relative;\r\n\ttop: 1%;\r\n}\r\n\r\n.status-active {\r\n\tborder: 4px solid #650681;\r\n}\r\n\r\n.avatar.avatar-xl .avatar-title {\r\n\tfont-size: 39px;\r\n}\r\n\r\n.nav.nav-tabs {\r\n\tborder: none;\r\n\tline-height: 2;\r\n}\r\n\r\n.badge {\r\n\tpadding: 5px 10px;\r\n\tfont-size: 11px;\r\n}\r\n\r\n.badge.badge-success {\r\n\tbackground: #0abb87;\r\n}\r\n\r\n.badge.badge-danger {\r\n\tbackground: #fd397a;\r\n}\r\n\r\n.badge.badge-secondary {\r\n\tbackground: dimgray;\r\n}\r\n\r\n.badge.badge-info {\r\n\tbackground: #00bcd4;\r\n}\r\n\r\n.badge.badge-warning {\r\n\tbackground: #ffb822;\r\n}\r\n\r\n.badge.badge-dark {\r\n\tbackground: #3a3f51;\r\n}\r\n\r\n.badge.badge-primary {\r\n\tbackground: #0a80ff;\r\n}\r\n\r\n.badge.badge-light {\r\n\tbackground: #e6e6e6;\r\n}\r\n\r\n.btn {\r\n\tposition: relative;\r\n}\r\n\r\n.btn .badge {\r\n\tpadding: 2px 6px;\r\n\tright: 7px;\r\n\ttop: -7px;\r\n\tposition: absolute;\r\n}\r\n\r\n.input-group .input-group-text {\r\n\tfont-size: $font-size-14;\r\n}\r\n\r\n.tooltip > .tooltip-inner {\r\n    text-align: left;\r\n    max-width: 500px;\r\n    --bs-tooltip-bg: $primary;\r\n}\r\n.tooltip {\r\n    --bs-tooltip-bg: $primary;\r\n}\r\n.tooltip .arrow {\r\n\tdisplay: none;\r\n\tbackground-color: $primary;\r\n}\r\n.tooltip .tooltip-inner {\r\n\tbackground-color: $primary;\r\n}\r\n\r\n.sticky-top {\r\n\tz-index: auto;\r\n}\r\n\r\n.tab-content {\r\n\tpadding-top: 30px;\r\n}\r\n\r\n.tab-content .form-item {\r\n\tmargin-bottom: .8rem;\r\n}\r\n\r\n.main-wrapper {\r\n\theight: 100vh;\r\n\toverflow: hidden;\r\n}\r\n\r\n.main-wrapper .content {\r\n\tdisplay: flex;\r\n\tdisplay: -webkit-flex;\r\n\t@include respond-below(custom991) {\r\n\t\tdisplay: block;\r\n\t}\r\n}\r\n\r\n.main-wrapper .content .sidebar-group {\r\n\tdisplay: flex;\r\n\tdisplay: -webkit-flex;\r\n\tflex-direction: column;\r\n\tposition: relative;\r\n\tz-index: 99;\r\n\twidth: 340px;\r\n\t@include respond-below(custom991) {\r\n\t\twidth: 100%;\r\n\t}\r\n}\r\n\r\n.chats {\r\n\t.chat-content {\r\n\t\t@include respond-below(custom575) {\r\n\t\t\twidth: calc(100% - 55px);\r\n\t\t}\r\n\t}\r\n}\r\n.main-wrapper .content .sidebar-group .sidebar {\r\n\tbackground: $white;\r\n\toverflow: hidden;\r\n\twidth: 340px !important;\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tflex: 1;\r\n\tborder-right: 1px solid rgba(224, 224, 224, 1);\r\n\t@include respond-below(custom991) {\r\n\t\twidth: 100%!important;\r\n\t}\r\n}\r\n\r\n.main-wrapper .content .sidebar-group .sidebar:not(.active) {\r\n\tdisplay: none;\r\n}\r\n\r\n.header-top {\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\tmargin-bottom: 30px;\r\n\tfont-weight: $font-weight-semibold;\r\n\tbackground-color: #680A83;\r\n}\r\n\r\n.header-top .logo {\r\n\tmargin-top: 0 !important;\r\n}\r\n\r\n.header-top > span {\r\n\tfont-size: $font-size-22;\r\n}\r\n\r\n.header-top ul {\r\n\tmargin-bottom: 0;\r\n\tdisplay: flex;\r\n}\r\n\r\n.header-top ul.header-action {\r\n\tmargin-top: 14px !important;\r\n}\r\n\r\n.chat-header ul {\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.chat-header ul li:not(.list-inline-item) {\r\n\tmargin-bottom: 0;\r\n\twidth: 48px;\r\n\tmargin-right: 15px !important;\r\n}\r\n\r\n.chat-header ul li:last-child {\r\n\tmargin-right: 0 !important;\r\n}\r\n\r\n.sidebar-body {\r\n\tflex: 1;\r\n\toverflow: auto;\r\n\tpadding: 24px 24px 10px;\r\n\twidth: 100%;\r\n}\r\n.pin-chat img {\r\n\tmargin-right: 6px;\r\n}\r\n.sidebar-body .profile-name {\r\n\tfont-weight: $font-weight-semibold;\r\n\tcolor: #0A0A0A;\r\n\tfont-size: $font-size-18;\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.online-profile {\r\n\tposition: relative;\r\n}\r\n\r\n.online-profile span {\r\n\tposition: relative;\r\n\tcolor: #565656;\r\n\tfont-size: 13px;\r\n\tpadding-left: 10px;\r\n}\r\n\r\n.online-profile span:before {\r\n\tcontent: \"\";\r\n\tposition: absolute;\r\n\tleft: 0;\r\n\ttop: 7px;\r\n\tbackground-color: #49E073;\r\n\twidth: 8px;\r\n\theight: 8px;\r\n\tborder-radius: 50px;\r\n}\r\n\r\n.close_profile4 {\r\n\tcolor: $black;\r\n\tborder-color: #e6e6e6;\r\n}\r\n\r\n.sidebar .user-list li a {\r\n\tpadding: 10px;\r\n\tdisplay: flex;\r\n\tdisplay: -webkit-flex;\r\n\tcursor: pointer;\r\n\tmargin-bottom: 15px;\r\n\tborder: 1px solid #E0E0E0;\r\n\tbox-shadow: none;\r\n\tborder-radius: 5px;\r\n\tposition: relative;\r\n\ttransition: ease all 0.5s;\r\n\t-webkit-transition: ease all 0.5s;\r\n\t-ms-transition: ease all 0.5s;\r\n}\r\n\r\n.sidebar .user-list li a:hover {\r\n\tbackground-color: rgba(254, 159, 67, 0.08);\r\n\tborder: 1px solid rgba(254, 159, 67, 0.08);\r\n\ttransition: ease all 0.5s;\r\n\t-webkit-transition: ease all 0.5s;\r\n\t-ms-transition: ease all 0.5s;\r\n}\r\n\r\n.sidebar .user-list li.item-typing {\r\n\tbackground-color: #F1F6FF;\r\n}\r\n\r\n.sidebar .user-list li figure {\r\n\tmargin-right: 1rem;\r\n}\r\n\r\n.sidebar .user-list li .users-list-body {\r\n\tflex: 1;\r\n\tposition: relative;\r\n\tmin-width: 0px;\r\n\tdisplay: flex;\r\n}\r\n\r\n.lock-icon {\r\n\tcolor: #000000;\r\n}\r\n\r\n.sidebar .user-list li .users-list-body > div:first-child {\r\n\tmin-width: 0;\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tflex: 1;\r\n}\r\n.parti-notify-check {\r\n\tmargin-bottom: 0 !important;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n}\r\n\r\n.sidebar .user-list li .users-list-body h5 {\r\n\twhite-space: nowrap;\r\n\ttext-overflow: ellipsis;\r\n\toverflow: hidden;\r\n\tfont-size: $font-size-15;\r\n\tfont-weight: $font-weight-medium;\r\n\tmargin-bottom: 3px;\r\n\tcolor: #0A0A0A;\r\n}\r\n\r\n.sidebar .user-list li .users-list-body p {\r\n\twhite-space: nowrap;\r\n\ttext-overflow: ellipsis;\r\n\toverflow: hidden;\r\n\tmargin-bottom: 0;\r\n\tcolor: #232323;\r\n\tfont-size: $font-size-14;\r\n}\r\n.sidebar .user-list li .users-list-body p.missed-call-col {\r\n\tcolor: #DE3E44;\r\n}\r\n.sidebar .user-list li .users-list-body .last-chat-time {\r\n\tpadding-left: 15px;\r\n\tposition: relative;\r\n}\r\n\r\n.sidebar .user-list li .users-list-body .last-chat-time .text-muted {\r\n\tcolor: #424242 !important;\r\n\tfont-weight: $font-weight-normal;\r\n\tfont-size: 12px;\r\n\tmargin-bottom: 5px;\r\n\tdisplay: block;\r\n\ttext-align: right;\r\n}\r\n.sidebar .user-list li .users-list-body .last-chat-time .contact-toggle {\r\n\tcolor: #680A83;\r\n}\r\n\r\n.sidebar .user-list li .users-list-body .last-chat-time .new-message-count {\r\n\twidth: 20px;\r\n\theight: 20px;\r\n\tdisplay: flex;\r\n\tdisplay: -webkit-flex;\r\n\talign-items: center;\r\n\t-webkit-align-items: center;\r\n\tjustify-content: center;\r\n\t-webkit-justify-content: center;\r\n\tline-height: 0;\r\n\tfont-size: 11px;\r\n\tbackground-color: $primary;\r\n\tcolor: $white;\r\n\tborder-radius: 50%;\r\n\tmargin-left: auto;\r\n\tmargin-top: 10px;\r\n\tposition: absolute;\r\n\tright: 0;\r\n\tbottom: 0;\r\n}\r\n\r\n.sidebar .user-list li .users-list-body .last-chat-time .chat-toggle {\r\n\tposition: absolute;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\topacity: 0;\r\n\ttext-align: right;\r\n\ttransition: all .5s ease;\r\n\t-webkit-transition: all .5s ease;\r\n\t-ms-transition: all .5s ease;\r\n\twidth: 18px;\r\n\theight: 24px;\r\n}\r\n\r\n.sidebar .user-list li.unread h5 {\r\n\tcolor: $white;\r\n}\r\n\r\n.sidebar .user-list li.unread p {\r\n\tcolor: $white;\r\n}\r\n\r\n.sidebar .user-list li.unread .text-muted {\r\n\tcolor: rgba(255, 255, 255, 0.4) !important;\r\n}\r\n\r\n.sidebar .user-list li.user-list-item.item-typing .users-list-body p {\r\n\tcolor: #0D9B35;\r\n}\r\n\r\n.rightside_tab {\r\n\tpadding-top: 5px !important;\r\n}\r\n.chat-pin {\r\n\tdisplay: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tjustify-content: end;\r\n\t-webkit-justify-content: end;\r\n\t-ms-flex-pack: end;\r\n\t.green-check {\r\n\t\tcolor: #0D9B35;\r\n\t}\r\n}\r\n.chat-pin img {\r\n\twidth: 10px;\r\n}\r\n.chat-pin .check {\r\n\tcolor: #53BDEB;\r\n}\r\n.select-message-box {\r\n\tmargin-top: 50px;\r\n}\r\n.select-message-box h4 {\r\n\tmargin-bottom: 5px;\r\n}\r\n.select-message-box p {\r\n\tmargin-top: 0;\r\n\tmargin-bottom: 24px;\r\n\tcolor: #424242;\r\n\tfont-size: $font-size-16;\r\n\tfont-weight: $font-weight-normal;\r\n}\r\n.select-message-box .btn i {\r\n\tfont-size: $font-size-15;\r\n}\r\n\r\n.group-description {\r\n\tpadding: 0px 24px;\r\n}\r\n.group-description .description-sub {\r\n\tborder-bottom: 1px solid #EDEDED;\r\n\tpadding-bottom: 15px;\r\n\tmargin-bottom: 15px;\r\n}\r\n.group-description h5 {\r\n\tfont-size: $font-size-15;\r\n\tfont-weight: $font-weight-medium;\r\n\tcolor: #0A0A0A;\r\n\tmargin-bottom: 10px;\r\n\tdisplay: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tjustify-content: space-between;\r\n\t-webkit-justify-content: space-between;\r\n\t-ms-flex-pack: space-between;\r\n}\r\n.group-description h5 a:hover {\r\n\tcolor: #650681 !important;\r\n}\r\n.group-description p { \r\n\tcolor: #424242;\r\n\tfont-size: $font-size-16;\r\n\tfont-weight: $font-weight-normal;\r\n\tmargin-bottom: 10px;\r\n}\r\n.group-description p.description-date { \r\n\tcolor: #424242;\r\n\tfont-size: 12px;\r\n\tfont-weight: $font-weight-normal;\r\n\tmargin-bottom: 0px;\r\n}\r\n.encrypted-message p {\r\n\tfont-size: 12px;\r\n\tcolor: #424242;\r\n\tfont-weight: $font-weight-normal;\r\n\tmargin-bottom: 0;\r\n}\r\n.group-view-all {\r\n\tmargin-top: 10px;\r\n}\r\n.group-view-all a {\r\n\tcolor: #680A83;\r\n\tfont-size: $font-size-14;\r\n\tfont-weight: $font-weight-medium;\r\n}\r\n.group-view-all a:hover {\r\n\tcolor: #0A0A0A;\r\n}\r\n.exit-bg-message {\r\n\tbackground: #FFE8E9;\r\n}\r\n.exit-bg-message i {\r\n\tcolor: #DE3E44;\r\n}\r\n.disapper-message {\r\n\tbackground: #E7FAF2;\r\n}\r\n.disapper-message i {\r\n\tcolor: #1BA345;\r\n}\r\n.group-setting-msg {\r\n\tbackground: #F8ECFF;\r\n}\r\n.group-setting-msg i {\r\n\tcolor: #680A83;\r\n}\r\n.group-setting .stared-group span {\r\n\twidth: 50px;\r\n\theight: 50px;\r\n}\r\n.edit-set-details p {\r\n\tfont-size: $font-size-14;\r\n\tfont-weight: $font-weight-normal;\r\n\tcolor: #424242;\r\n\tmargin-bottom: 0;\r\n}\r\n.group-send-msg {\r\n\tbackground: #FEF6DC;\r\n}\r\n.parcipant-check p a {\r\n\tcolor: #680A83;\r\n}\r\n.select-group-chat .dropdown-toggle::after {\r\n\tdisplay: none;\r\n}\r\n.select-group-chat .dropdown-toggle i {\r\n\tmargin-left: 15px;\r\n}\r\n.select-group-chat .dropdown-toggle:hover {\r\n\tcolor: #0A0A0A;\r\n}\r\n.select-group-chat .dropdown-toggle {\r\n\tfont-weight: $font-weight-semibold;\r\n\tcolor: #0A0A0A;\r\n\tfont-size: $font-size-18;\r\n}\r\n.select-group-chat .dropdown-menu .dropdown-item {\r\n\tfont-size: $font-size-14;\r\n\tfont-weight: $font-weight-normal;\r\n\tcolor: #0A0A0A;\r\n}\r\n.select-group-chat .dropdown-menu li:first-child .dropdown-item:hover {\r\n\tborder-radius: 5px 5px 0 0;\r\n}\r\n.select-group-chat .dropdown-menu li:last-child .dropdown-item:hover {\r\n\tborder-radius: 0 0 5px 5px;\r\n}\r\n.dropzone {\r\n\tbackground: $white;\r\n\tborder: 1px dashed #C2C2C2;\r\n\tborder-radius: 5px;\r\n\tpadding: 10px;\r\n\tmin-height: 70px;\r\n\ttext-align: center;\r\n}\r\n.dropzone.dz-clickable .dz-message {\r\n\tdisplay: none;\r\n}\r\n.dropzone p {\r\n\tmargin-bottom: 10px;\r\n\tfont-size: $font-size-16;\r\n\tfont-weight: $font-weight-medium;\r\n\tcolor: #0A0A0A;\r\n}\r\n.dropzone span {\r\n\tcolor: #424242;\r\n\tfont-size: $font-size-14;\r\n\tfont-weight: $font-weight-normal;\r\n}\r\n.uplaod-image img {\r\n\tborder-radius: 20px;\r\n}\r\n.upload-img-file .modal-body {\r\n\tpadding: 0;\r\n}\r\n.upload-img-file .modal-content {\r\n\tposition: relative;\r\n}\r\n.upload-img-file .modal-header {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tz-index: 9;\r\n\tleft:0;\r\n\tright: 0;\r\n}\r\n.upload-image-list {\r\n\tdisplay: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n}\r\n.upload-image-list li+li {\r\n\tmargin-left: 10px;\r\n}\r\n.upload-img-file .modal-header .close {\r\n\tbackground-color: transparent;\r\n\tcolor: $white;\r\n}\r\n.check-star i {\r\n\tcolor: #FEC001;\r\n}\r\n.emoj-group-list {\r\n\tdisplay: none;\r\n\tposition: absolute;\r\n\ttop: -50px;\r\n\tleft: -90px;\r\n\ttransition: all 0.5s ease;\r\n    -moz-transition: all 0.5s ease;\r\n    -o-transition: all 0.5s ease;\r\n    -ms-transition: all 0.5s ease;\r\n    -webkit-transition: all 0.5s ease;\r\n}\r\n.emoj-group-list ul {\r\n\tdisplay: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tbackground: #f6f7f8;\r\n\tborder-radius: 50px;\r\n\tpadding: 5px;\r\n}\r\n.emoj-group-list ul li a {\r\n\tpadding: 0;\r\n}\r\n.emoj-group-list ul li.add-emoj a {\r\n\tbackground: #EDEDED;\r\n}\r\n.emoj-group-list ul li.add-emoj a i {\r\n\tfont-size: $font-size-20;\r\n\tcolor: #424242;\r\n}\r\n.chat .slimscroll {\r\n\theight: calc(100vh - 60px) !important;\r\n}\r\n.settings-option {\r\n\tdisplay: none;\r\n\ttext-align: right;\r\n}\r\n.settings-option a {\r\n\tfont-size: $font-size-15;\r\n\tfont-weight: $font-weight-medium;\r\n\tcolor: #680A83;\r\n}\r\n.empty-dark-img {\r\n\tdisplay: none;\r\n}\r\n.bootstrap-datetimepicker-widget span {\r\n\tposition: relative;\r\n}\r\n\r\n}\r\n.chat-window{\r\n    .card{\r\n        .card-header {\r\n            background-color: $white;\r\n            border-bottom: 1px solid $gray-300;\r\n        }\r\n    }\r\n    .badge-success {\r\n        background-color: $success !important;\r\n    }\r\n}\r\n.chat-page {\r\n    .footer {\r\n        display: none;\r\n    }\r\n}\r\n.chat-search{\r\n    .input-group {\r\n        .form-control{\r\n            @include margin-padding(0,0 0 0 36px);\r\n            height: 46px;\r\n        }\r\n        .input-group-prepend {\r\n        \tdisplay: -webkit-box;\r\n\t\t\tdisplay: -ms-flexbox;\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\t-webkit-box-align: center;\r\n\t\t\t-ms-flex-align: center;\r\n            color: $gray-700;\r\n            pointer-events: none;\r\n            z-index: 4;\r\n            @include position(absolute,0,15px,0,null);\r\n        }\r\n    }\r\n}\r\n.chat-cont-left {\r\n    .chat-scroll {\r\n        max-height: calc(100vh - 200px);\r\n        overflow-y: auto;\r\n        padding: 0;\r\n        .media {\r\n            border-bottom: 1px solid $gray-300;\r\n            @include margin-padding(0,10px);\r\n            @include transition(all .2s);\r\n            &.active {\r\n                background-color:  $gray-100;\r\n            }\r\n            &:hover{\r\n                background-color:  $gray-100;\r\n            }\r\n            .media-img-wrap {\r\n                @include margin-padding(0  15px 0 0,null);\r\n                position: relative;\r\n                .avatar > img {\r\n                    width: 100%;\r\n                    height: 100%;\r\n                    object-fit: cover;\r\n                }\r\n            }\r\n            .media-body {\r\n                display: -webkit-box;\r\n\t\t        display: -ms-flexbox;\r\n\t\t        display: flex;\r\n\t\t        justify-content: space-between;\r\n    \t\t\t-webkit-justify-content: space-between;\r\n    \t\t\t-ms-flex-pack: space-between;\r\n                .user-name{\r\n                    max-width: 170px;\r\n                    overflow: hidden;\r\n                    text-overflow: ellipsis;\r\n                    white-space: nowrap;\r\n                    color: $gray-900;\r\n                    font-size: $font-size-16;\r\n                    font-weight: $font-weight-bold;\r\n                }\r\n                .user-last-chat {\r\n                    color: $gray-800;\r\n                    font-size: $font-size-base;\r\n                    line-height: 24px;\r\n                    max-width: 170px;\r\n                    overflow: hidden;\r\n                    text-overflow: ellipsis;\r\n                    white-space: nowrap;\r\n                }\r\n                .last-chat-time {\r\n                    color: $gray-600;\r\n                    font-size:$font-size-13;\r\n                }\r\n                 div{\r\n                    &:last-child {\r\n                        text-align: right;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    \r\n}\r\n.chat-cont-right {\r\n    @include transition(all 0.4s);\r\n    .chat-scroll {\r\n        max-height: calc(100vh - 293px);\r\n        overflow-y: auto;\r\n        \r\n    }\r\n    .msg_head {\r\n        .back-user-list {\r\n            display: none;\r\n            @include margin-padding(0 0 0 -10px ,0 10px);\r\n        }\r\n    }\r\n    .img_cont {\r\n        position: relative;\r\n        height: 45px;\r\n        width: 45px;\r\n        .user_img {\r\n            height: 45px;\r\n            min-width: 45px;\r\n            width: 45px;\r\n            border: 1.5px solid $primary;\r\n        }\r\n    }\r\n    .user_info {\r\n        @include margin-padding(0 auto 0 15px,0);\r\n        width: 100%;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n        white-space: nowrap;\r\n    }\r\n    ul.list-unstyled {\r\n        @include margin-padding(0 auto,0);\r\n        width: 100%;\r\n        .media{\r\n            &.sent {\r\n                margin-bottom: 20px;\r\n                .avatar {\r\n                    order: 3;\r\n                    height: 30px;\r\n                    width: 30px;\r\n                }\r\n                .media-body {\r\n                \tdisplay: -webkit-box;\r\n\t\t\t        display: -ms-flexbox;\r\n\t\t\t        display: flex;\r\n                    -webkit-box-align: flex-end;\r\n  \t\t\t\t\t-ms-flex-align: flex-end;\r\n  \t\t\t\t\talign-items: flex-end;\r\n                    -ms-flex-direction: column;\r\n  \t\t\t\t\tflex-direction: column;\r\n                    @include margin-padding(0 20px 0 0 ,0);\r\n                    .msg-box {\r\n                        @include margin-padding(0,0 0 0 50px);\r\n                        position: relative;\r\n                        + .msg-box{\r\n                            @include margin-padding(5px 0 0,0);\r\n                        }\r\n                        p{\r\n                            @include margin-padding(0,0);\r\n                        }\r\n                        &:first-child::before {\r\n                            border-bottom: 6px solid transparent;\r\n                            border-left: 6px solid #e3e3e3;\r\n                            border-top: 6px solid #e3e3e3;\r\n                            border-right: 6px solid transparent;\r\n                            content: \"\";\r\n                            height: 0;\r\n                            width: 0;\r\n                            @include position(absolute,0,-12px,null,auto);\r\n                        }\r\n                       > div {\r\n                            @include margin-padding(0,10px 15px);\r\n                            @include rounded(10px);\r\n                            background-color: #e3e3e3;\r\n                            display: inline-block;\r\n                            position: relative;\r\n                        }\r\n                        &:first-child > div {\r\n                            @include rounded(10px 0 10px 10px) ;\r\n                        }\r\n                    }\r\n                    .chat-msg-attachments {\r\n                    \tdisplay: -webkit-box;\r\n\t\t\t\t        display: -ms-flexbox;\r\n\t\t\t\t        display: flex;\r\n                        @include margin-padding(0 -1px,4px 0);\r\n                        width: 100%;\r\n                        .chat-attachment {\r\n                            position: relative;\r\n                            max-width: 130px;\r\n                            overflow: hidden;\r\n                            &:before {\r\n                                @include position(absolute,0,0,0,0);\r\n                                background: $black;\r\n                                content: \"\";\r\n                                opacity: 0.4;\r\n                                @include transition(all .4s);\r\n                            }\r\n                            &:hover{\r\n                                .chat-attach-download{\r\n                                    opacity: 1\r\n                                }\r\n                            }\r\n                        }\r\n                       > div {\r\n                            margin: 0 1px;\r\n                        }\r\n                        \r\n                        img {\r\n                            max-width: 100%;\r\n                        }\r\n                        .chat-attach-download {\r\n                            @include position(absolute,50%,null,null,50%);\r\n                            transform: translate(-50%, -50%);\r\n                            opacity: 0;\r\n                            @include transition(all .4s);\r\n                            color: $white;\r\n                            width: 32px;\r\n                            line-height: 32px;\r\n                            background: rgba(255, 255, 255, 0.2);\r\n                            text-align: center;\r\n                        }\r\n                    }\r\n                    .chat-msg-info {\r\n                    \tdisplay: -webkit-box;\r\n  \t\t\t\t\t\tdisplay: -ms-flexbox;\r\n  \t\t\t\t\t\tdisplay: flex;\r\n                    \talign-items: center;\r\n  \t\t\t\t\t\t-webkit-box-align: center;\r\n  \t\t\t\t\t\t-ms-flex-align: center;\r\n                        @include margin-padding(5px 0 0,0);\r\n                        -ms-flex-wrap: wrap;\r\n  \t\t\t\t\t\tflex-wrap: wrap;\r\n                        clear: both;\r\n                        flex-direction: row-reverse;\r\n                        list-style: none;\r\n                        li{\r\n                            @include margin-padding(0,0 0 0 16px);\r\n                            position: relative;\r\n\r\n                            &:not(:last-child)::after {\r\n                                @include position(absolute,50%,auto,null,8px);\r\n                                transform: translate(-50%, -50%);\r\n                                background: $primary;\r\n                                content: '';\r\n                                height: 4px;\r\n                                width: 4px;\r\n                            }\r\n                        }\r\n                        .chat-time {\r\n                            color: rgba(50, 65, 72, 0.4);\r\n                        }\r\n                        a {\r\n                            color: $gray-800;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n            &.received {\r\n                position: relative;\r\n                margin-bottom: 20px;\r\n                .media-body{\r\n                    position: relative;\r\n                    @include margin-padding(0 0 0 20px,0);\r\n                    &::before {\r\n                        border-bottom: 6px solid transparent;\r\n                        border-right: 6px solid $primary;\r\n                        border-top: 6px solid $primary;\r\n                        border-left: 6px solid transparent;\r\n                        content: \"\";\r\n                        height: 0;\r\n                        @include position(absolute,0px,auto,null,-6px);\r\n                        width: 0;\r\n                    }\r\n                    > div {\r\n                        @include margin-padding(0,10px 15px);\r\n                        @include rounded(10px);\r\n                        background-color: $primary;\r\n                        display: table;\r\n                        position: relative;\r\n                        p {\r\n                            color: $white;\r\n                            @include margin-padding(0,0);\r\n                        }\r\n                    }\r\n                }\r\n                .msg-box {\r\n                    display: block;\r\n                    + .msg-box {\r\n                        margin-top: 5px;\r\n                    }\r\n                    \r\n            }\r\n            .chat-msg-info {\r\n                display: -webkit-box;\r\n\t\t\t\tdisplay: -ms-flexbox;\r\n\t\t\t\tdisplay: flex;\r\n        \t\talign-items: center;\r\n\t\t\t\t-webkit-box-align: center;\r\n\t\t\t\t-ms-flex-align: center;\r\n                -ms-flex-wrap: wrap;\r\n  \t\t\t\tflex-wrap: wrap;\r\n                @include margin-padding(5px 0 0,0);\r\n                clear: both;\r\n                list-style: none;\r\n                .chat-time {\r\n                    color: rgba(255,255,255,.8);\r\n                }\r\n            }\r\n            .chat-msg-attachments {\r\n            \tdisplay: -webkit-box;\r\n\t\t\t\tdisplay: -ms-flexbox;\r\n\t\t\t\tdisplay: flex;\r\n                @include margin-padding(0 -1px,4px 0);\r\n                width: 100%;\r\n                .chat-attachment {\r\n                    position: relative;\r\n                    max-width: 130px;\r\n                    overflow: hidden;\r\n                    &:before {\r\n                        @include position(absolute,0,0,0,0);\r\n                        background: $black;\r\n                        content: \"\";\r\n                        opacity: 0.4;\r\n                        @include transition(all .4s);\r\n                    }\r\n                    &:hover{\r\n                        .chat-attach-download{\r\n                            opacity: 1\r\n                        }\r\n                    }\r\n                }\r\n               > div {\r\n                    margin: 0 1px;\r\n                }\r\n                \r\n                img {\r\n                    max-width: 100%;\r\n                }\r\n                .chat-attach-download {\r\n                    @include position(absolute,50%,null,null,50%);\r\n                    @include transform(translate(-50%, -50%));\r\n                    @include transition(all .4s);\r\n                    opacity: 0;\r\n                    color: $white;\r\n                    width: 32px;\r\n                    line-height: 32px;\r\n                    background: rgba(255, 255, 255, 0.2);\r\n                    text-align: center;\r\n                }\r\n            }\r\n        }\r\n           \r\n        }\r\n        .chat-date {\r\n            font-size: $font-size-base;\r\n            margin: 1.875rem 0;\r\n            overflow: hidden;\r\n            position: relative;\r\n            text-align: center;\r\n            text-transform: capitalize;\r\n            &:before {\r\n                background-color: #e0e3e4;\r\n                content: \"\";\r\n                height: 1px;\r\n                margin-right: 28px;\r\n                @include position(absolute,50%,50%,null,null);\r\n                width: 100%;\r\n            }\r\n            &:after {\r\n                background-color: #e0e3e4;\r\n                content: \"\";\r\n                height: 1px;\r\n                @include margin-padding(0 0 0 28px,null);\r\n                @include position(absolute,50%,null,null,50%);\r\n                width: 100%;\r\n            }\r\n        }\r\n    }\r\n    \r\n}\r\n.card-footer {\r\n    background-color: $white;\r\n    border-top: 1px solid $gray-300;\r\n    @include margin-padding(0,1rem 1.5rem);\r\n    .type_msg {\r\n        background-color: rgba(0,0,0,0.1) !important;\r\n        border: 0 !important;\r\n        overflow-y: auto;\r\n    }\r\n}\r\n@include respond-below(custom992) {\r\n    .chat-window.chat-slide .chat-cont-right {\r\n        right: 0;\r\n        opacity: 1;\r\n        visibility: visible;\r\n    }\r\n\r\n    .chat-cont-right {\r\n        @include position(absolute, null, -100px, null, null);\r\n        opacity: 0;\r\n        visibility: hidden;\r\n        z-index: 99;\r\n    }\r\n    .chat-cont-right .msg_head .back-user-list {\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n}\r\n.page-header {\r\n    .breadcrumb {\r\n        margin-bottom: 0;\r\n    }\r\n    h3{\r\n        font-weight: $font-weight-bold;\r\n        color: $gray-900;\r\n        font-size: $font-size-18;\r\n        @include respond-below(custom991) {\r\n            font-size: $font-size-base;\r\n        }\r\n    }\r\n    h4 {\r\n        font-weight: $font-weight-bold;\r\n        color: $gray-900;\r\n        font-size: $font-size-18;\r\n        margin-bottom: 5px;\r\n        @include respond-below(custom991) {\r\n            font-size: $font-size-18;\r\n        }\r\n    }\r\n    h6 {\r\n        font-size: $font-size-base;\r\n        color: $gray-700;\r\n        font-weight: $font-weight-normal;\r\n        @include respond-below(custom991) {\r\n            font-size: $font-size-12;\r\n        }\r\n        @include respond-below(custom575) {\r\n            font-size: $font-size-12;\r\n            margin-bottom: 20px;\r\n        }\r\n    }\r\n    .btn-filter {\r\n        background: $primary;\r\n        width: 34px;\r\n        height: 34px;\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        align-items: center;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        justify-content: center;\r\n        -webkit-justify-content: center;\r\n        -ms-flex-pack: center;\r\n        padding: 0;\r\n        &:hover{\r\n            background: linear-gradient(46.62deg, $primary 0%, $violet 93.64%);\r\n        }\r\n    }\r\n    .page-btn {\r\n        margin-left: 10px;\r\n        @include respond-below(custom575) {\r\n            margin-left: 0;\r\n            margin-top: 20px;\r\n        }\r\n    }\r\n    .btn-added {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        align-items: center;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        background: $primary;\r\n        padding: 8px 11px;\r\n        color: $white;\r\n        font-weight: $font-weight-bold;\r\n        font-size: $font-size-14;\r\n\t\theight: 40px;\r\n        border-radius: 5px;\r\n        &:active {\r\n            color: $white;\r\n        }\r\n        img{\r\n            filter: brightness(0) invert(1);\r\n        }\r\n        @include respond-below(custom991) {\r\n            padding: 10px 10px; \r\n        }\r\n        &:hover{\r\n            background: $title-color;\r\n        }\r\n        .me-2 {\r\n            width: 16px;\r\n            height: 16px;\r\n        }\r\n    }\r\n    .btn-added.downloader {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        align-items: center;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        background: $gray-900;\r\n        padding: 9px 11px;\r\n        color: $white;\r\n        font-weight: $font-weight-bold;\r\n        font-size: $font-size-14;\r\n        border-radius: 8px;\r\n        margin: 0 15px 0 15px;\r\n        img{\r\n            filter: brightness(0) invert(1);\r\n        }\r\n        @include respond-below(custom991) {\r\n            padding: 10px 10px; \r\n        }\r\n        &:hover{\r\n            background: $primary;\r\n        }\r\n        .me-2 {\r\n            width: 16px;\r\n            height: 16px;\r\n        }\r\n    }\r\n    .btn-added.printer {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        align-items: center;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        background: $danger;\r\n        padding: 9px 11px;\r\n        color: $white;\r\n        font-weight: $font-weight-bold;\r\n        font-size: $font-size-14;\r\n        border-radius: 8px;\r\n        img{\r\n            filter: brightness(0) invert(1);\r\n        }\r\n        @include respond-below(custom991) {\r\n            padding: 10px 10px; \r\n        }\r\n        &:hover{\r\n            background: $gray-900;\r\n        }\r\n        .me-2 {\r\n            width: 16px;\r\n            height: 16px;\r\n        }\r\n    }\r\n    .add-item {\r\n        @include respond-below(custom767) {\r\n            display: block !important;\r\n            .page-btn {\r\n                margin-left: 0;\r\n            }\r\n        }\r\n        .page-btn {\r\n            @include respond-below(custom575) {\r\n                 margin-left: 0;\r\n                 margin-bottom: 24px;\r\n            }\r\n        }\r\n        .page-title.modal-datail {\r\n            line-height: 2;\r\n        }\r\n    }\r\n    .add-item.d-flex {\r\n        margin-right: auto;\r\n    }\r\n    .add-item.payslip-list {\r\n        align-items: center;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        justify-content: space-between;\r\n        -webkit-justify-content: space-between;\r\n        -ms-flex-pack: space-between;\r\n        width: 100%;\r\n    }\r\n}\r\n.page-wrapper.details-blk {\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n.history-modal-profile {\r\n\t.content {\r\n\t\tpadding: 24px;\r\n\t}\r\n\t.right-sidebar-profile {\r\n\t\tbackground: $body-bg;\r\n\t\tborder-radius: 8px;\r\n\t\tpadding: 24px;\r\n\t\t.list-inline-item {\r\n\t\t\ta {\r\n\t\t\t\tbackground: $primary;\r\n\t\t\t\twidth: 40px;\r\n\t\t\t\theight: 40px;\r\n\t\t\t\tborder-radius: 50px;\r\n\t\t\t\tdisplay: -webkit-box;\r\n                display: -ms-flexbox;\r\n                display: flex;\r\n                align-items: center;\r\n                -webkit-box-align: center;\r\n                -ms-flex-align: center;\r\n                justify-content: center;\r\n                -webkit-justify-content: center;\r\n                -ms-flex-pack: center;\r\n\t\t\t\t&:hover {\r\n\t\t\t\t\tbackground: #1b2950;\r\n\t\t\t\t\tcolor: $white !important;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t\t.avatar {\r\n\t\t\tmargin-bottom: 24px;\r\n\t\t\twidth: 150px;\r\n\t\t\theight: 150px;\r\n\t\t\timg {\r\n\t\t\t\tborder-radius: 8px;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n.msg-typing {\r\n    width: auto;\r\n    height: 24px;\r\n    padding-top: 8px;\r\n\tspan {\r\n\t\theight: 8px;\r\n\t\twidth: 8px;\r\n\t\tfloat: left;\r\n\t\tbackground-color: $white;\r\n\t\tdisplay: block;\r\n\t\topacity: .4;\r\n\t\t@include margin-padding(0 1px, null);\r\n\t\t@include rounded(50%);\r\n\t\t&:nth-of-type(1) {\r\n\t\t\tanimation: 1s blink infinite .33333s;\r\n\t\t}\r\n\t\t&:nth-of-type(2) {\r\n\t\t\tanimation: 1s blink infinite .66666s;\r\n\t\t}\r\n\t\t:nth-of-type(3) {\r\n\t\t\tanimation: 1s blink infinite .99999s;\r\n\t\t}\r\n\t}\r\n}\r\n@keyframes blink {\r\n\t50% {\r\n\t\topacity: 1\r\n\t}\r\n}\r\n\r\n.phone-call-icon {\r\n\tsvg {\r\n\t\twidth: 18px;\r\n\t}\r\n\t.income-success {\r\n\t\tcolor: $success;\r\n\t}\r\n\t.income-success-missed {\r\n\t\tcolor: $danger;\r\n\t}\r\n}\r\n.history-modal-profile {\r\n\t.content {\r\n\t\tpadding: 24px;\r\n\t}\r\n\t.right-sidebar-profile {\r\n\t\tbackground: $body-bg;\r\n\t\tborder-radius: 8px;\r\n\t\tpadding: 24px;\r\n\t\t.list-inline-item {\r\n\t\t\ta {\r\n\t\t\t\tbackground: $primary;\r\n\t\t\t\twidth: 40px;\r\n\t\t\t\theight: 40px;\r\n\t\t\t\tborder-radius: 50px;\r\n\t\t\t\tdisplay: -webkit-box;\r\n                display: -ms-flexbox;\r\n                display: flex;\r\n                align-items: center;\r\n\t\t\t\tcolor: $white !important;\r\n                -webkit-box-align: center;\r\n                -ms-flex-align: center;\r\n                justify-content: center;\r\n                -webkit-justify-content: center;\r\n                -ms-flex-pack: center;\r\n\t\t\t\t&:hover {\r\n\t\t\t\t\tbackground: #1b2950;\r\n\t\t\t\t\tcolor: $white !important;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t\t.avatar {\r\n\t\t\tmargin-bottom: 24px;\r\n\t\t\twidth: 150px;\r\n\t\t\theight: 150px;\r\n\t\t\timg {\r\n\t\t\t\tborder-radius: 8px;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n.modal-profile-detail {\r\n\t.modal-userlist {\r\n\t\tli {\r\n\t\t\tfont-size: $font-size-14;\r\n\t\t\tcolor: $black;\r\n\t\t\tmargin-bottom: 10px;\r\n\t\t\tspan {\r\n\t\t\t\tdisplay: block;\r\n\t\t\t\tcolor: $text-color;\r\n\t\t\t}\r\n\t\t\t&:last-child {\r\n\t\t\t\tmargin-bottom: 0;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n.chat_sidebar.hide-left-sidebar {\r\n\t@include respond-below(custom991) {\r\n\t\t display: none !important;\r\n\t}   \r\n}\r\n.left-sidebar.hide-left-sidebar {\r\n\t@include respond-below(custom991) {\r\n\t\t margin-left: -991px;\r\n\t}      \r\n}\r\n\r\n\r\n",".img-cropper {\r\n\t.dropup {\r\n\t\t.dropdown-toggle {\r\n\t\t\t&::after {\r\n\t\t\t\tcontent: '';\r\n\t\t\t\tdisplay: none;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n.dropdown-auto {\r\n\toverflow: auto;\r\n}\r\n.dropdown-divider {\r\n\tmargin: 0;\r\n}\r\n.dropdown {\r\n\t.dropdown-toggle {\r\n\r\n\t\t&:after {\r\n      display: inline-block;\r\n      margin-inline-start: 0.25rem;\r\n      vertical-align: 0;\r\n      content: \"\\f078\";\r\n      font-family: \"Font Awesome 5 Free\";\r\n      border: 0;\r\n      font-size: 0.6rem;\r\n      font-weight: $font-weight-semibold;\r\n\t\t}\r\n\r\n\t\t&.btn-primary {\r\n\t\t\tcolor: $white;\r\n\t\t}\r\n\t}\r\n\t.dropdown-menu {\r\n\t\tfont-family: $font-family-primary;\r\n\t}\r\n}\r\n.dropdown {\r\n  & > a {\r\n      color: $gray-900;\r\n      border: 1px solid $light-900;\r\n      padding: 9px 15px;\r\n      border-radius: $border-radius-lg;\r\n      display: flex;\r\n      align-items: center;\r\n      box-shadow: 0px 4px 4px 0px #DBDBDB40;\r\n    }\r\n}\r\n.dropdown-menu {\r\n  border-color: $border-color;\r\n  box-shadow: 0 1rem 1.125rem rgba(169, 169, 169, 0.15);\r\n  font-size: 0.875rem;\r\n  color: $text-color;\r\n  background-color: $white;\r\n  padding: 0;\r\n  z-index: 10;\r\n}\r\n.dropdown-divider {\r\n  border-color: $border-color;\r\n}\r\n\r\n.dropdown-item-text {\r\n  color: $text-color;\r\n}\r\n.dropdown-header {\r\n  color: $text-color;\r\n}\r\n.dropdown-item {\r\n  color: $text-color;\r\n  white-space: unset;\r\n  padding: 0.5rem 0.9375rem;\r\n  font-size: 0.8125rem;\r\n\r\n  &.disabled,\r\n  &:disabled {\r\n    color: $text-color;\r\n    opacity: 0.5;\r\n  }\r\n  &:not(.active) {\r\n    &:hover,\r\n    &:focus,\r\n    &:active {\r\n      color: $primary;\r\n      background-color: rgba($primary, 0.05);\r\n    }\r\n  }\r\n  &.active {\r\n    background-color: $primary !important;\r\n  }\r\n}\r\n.dropdown-toggle::after {\r\n  display: inline-block;\r\n  margin-inline-start: 0.25rem;\r\n  vertical-align: 0;\r\n  content: \"\\f078\";\r\n  font-family: \"Font Awesome 5 Free\";\r\n  border: 0;\r\n  font-size: 0.6rem;\r\n  font-weight: $font-weight-semibold;\r\n}\r\n.dropup .dropdown-toggle::after {\r\n  display: inline-block;\r\n  margin-inline-start: 0.25rem;\r\n  vertical-align: 0;\r\n  content: \"\\f078\";\r\n  font-family: \"Font Awesome 5 Free\";\r\n  border: 0;\r\n  font-size: 0.6rem;\r\n  font-weight: $font-weight-semibold;\r\n}\r\n\r\n.dropup .dropdown-toggle::after {\r\n  display: inline-block;\r\n  margin-inline-start: 0.25rem;\r\n  vertical-align: 0;\r\n  content: \"\\f077\";\r\n  font-family: \"Font Awesome 5 Free\";\r\n  border: 0;\r\n  font-size: 0.6rem;\r\n  font-weight: $font-weight-semibold;\r\n}\r\n.dropend .dropdown-toggle::after {\r\n  display: inline-block;\r\n  margin-inline-start: 0.25rem;\r\n  vertical-align: 0;\r\n  content: \"\\f054\";\r\n  font-family: \"Font Awesome 5 Free\";\r\n  border: 0;\r\n  font-size: 0.6rem;\r\n  font-weight: $font-weight-semibold;\r\n}\r\n.dropstart .dropdown-toggle::before {\r\n  display: inline-block;\r\n  margin-inline-start: 0.25rem;\r\n  vertical-align: 0;\r\n  content: \"\\f053\";\r\n  font-family: \"Font Awesome 5 Free\";\r\n  border: 0;\r\n  font-size: 0.6rem;\r\n  font-weight: $font-weight-semibold;\r\n}\r\n.btn.dropdown-toggle-split {\r\n  opacity: 0.85;\r\n}\r\n\r\n.dropdown-menu-dark {\r\n  background-color: $dark;\r\n  border-color: rgba(255, 255, 255, 0.1);\r\n  li a {\r\n    color: $white;\r\n  }\r\n}\r\n.btn-list {\r\n\ta.dropdown-item {\r\n\t\tmargin-block-end: 0;\r\n\t}\r\n\t.btn-soft-success  {\r\n\t\t&:hover {\r\n\t\t\ttransform: translateY(0);\r\n\t\t}\r\n\t}\r\n\t.btn-soft-danger  {\r\n\t\t&:hover {\r\n\t\t\ttransform: translateY(0);\r\n\t\t}\r\n\t\t&:active {\r\n\t\t\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.dropdown-menu {\r\n  @mixin dropdown-menu-color($color) {\r\n    background-color: $color;\r\n    li a {\r\n      color: rgba(255, 255, 255, 0.9);\r\n    }\r\n    .dropdown-item {\r\n      &:hover,\r\n      &:focus,\r\n      &:active,\r\n      &.active {\r\n        color: $white;\r\n      }\r\n    }\r\n  }\r\n  &.dropdown-menu-primary {\r\n    @include dropdown-menu-color($primary);\r\n  }\r\n  &.dropdown-menu-secondary {\r\n    @include dropdown-menu-color($secondary);\r\n  }\r\n  &.dropdown-menu-warning {\r\n    @include dropdown-menu-color($warning);\r\n  }\r\n  &.dropdown-menu-info {\r\n    @include dropdown-menu-color($info);\r\n  }\r\n  &.dropdown-menu-success {\r\n    @include dropdown-menu-color($success);\r\n  }\r\n  &.dropdown-menu-danger {\r\n    @include dropdown-menu-color($danger);\r\n  }\r\n}\r\n.dropdown-menu {\r\n  &.dropmenu-item-primary {\r\n    .dropdown-item {\r\n      &:hover,\r\n      &:focus,\r\n      &:active,\r\n      &.active {\r\n        background-color: rgba($primary, 0.1) !important;\r\n        color: $primary;\r\n      }\r\n    }\r\n  }\r\n  &.dropmenu-item-secondary {\r\n    .dropdown-item {\r\n      &:hover,\r\n      &:focus,\r\n      &:active,\r\n      &.active {\r\n        background-color: rgba($secondary, 0.1) !important;\r\n        color: $secondary;\r\n      }\r\n    }\r\n  }\r\n  &.dropmenu-item-warning {\r\n    .dropdown-item {\r\n      &:hover,\r\n      &:focus,\r\n      &:active,\r\n      &.active {\r\n        background-color: rgba($warning, 0.1) !important;\r\n        color: $warning;\r\n      }\r\n    }\r\n  }\r\n  &.dropmenu-item-info {\r\n    .dropdown-item {\r\n      &:hover,\r\n      &:focus,\r\n      &:active,\r\n      &.active {\r\n        background-color: rgba($info, 0.1) !important;\r\n        color: $info;\r\n      }\r\n    }\r\n  }\r\n  &.dropmenu-item-success {\r\n    .dropdown-item {\r\n      &:hover,\r\n      &:focus,\r\n      &:active,\r\n      &.active {\r\n        background-color: rgba(var(--success-rgb), 0.1) !important;\r\n        color: $success;\r\n      }\r\n    }\r\n  }\r\n  &.dropmenu-item-danger {\r\n    .dropdown-item {\r\n      &:hover,\r\n      &:focus,\r\n      &:active,\r\n      &.active {\r\n        background-color: rgba(var(--danger-rgb), 0.1) !important;\r\n        color: $danger;\r\n      }\r\n    }\r\n  }\r\n}\r\n.dropdown-menu {\r\n  @mixin dropmenu-light-color($color) {\r\n    backdrop-filter: blur(2rem);\r\n    .dropdown-item {\r\n      &:hover,\r\n      &:focus,\r\n      &:active,\r\n      &.active {\r\n        color: $white;\r\n        background-color: $color !important;\r\n      }\r\n    }\r\n  }\r\n  &.dropmenu-light-primary {\r\n    background-color: rgba(var($secondary), 0.1);\r\n    @include dropmenu-light-color($primary);\r\n  }\r\n  &.dropmenu-light-secondary {\r\n    background-color: rgba(var($secondary), 0.1);\r\n    @include dropmenu-light-color($secondary);\r\n  }\r\n  &.dropmenu-light-info {\r\n    background-color: rgba($info, 0.1);\r\n    @include dropmenu-light-color($info);\r\n  }\r\n  &.dropmenu-light-warning {\r\n    background-color: rgba($warning, 0.1);\r\n    @include dropmenu-light-color($warning);\r\n  }\r\n  &.dropmenu-light-success {\r\n    background-color: rgba($success, 0.1);\r\n    @include dropmenu-light-color($success);\r\n  }\r\n  &.dropmenu-light-danger {\r\n    background-color: rgba(var(--danger-rgb), 0.1);\r\n    @include dropmenu-light-color($danger);\r\n  }\r\n}\r\n.dropdown-divider {\r\n  margin: 0;\r\n}\r\n.bd-example > .dropdown-menu {\r\n  position: static;\r\n  display: block;\r\n}\r\n\r\n.dropdown-md {\r\n  min-width: 315px;\r\n}\r\n.table-action {\r\n  .action-icon {\r\n      width: 33px;\r\n      height: 33px;\r\n      background: $light-300;\r\n      border: 1px solid $light-900;\r\n      border-radius: 5px;\r\n      display: inline-flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      color: $gray-900;\r\n      &:hover {\r\n          color: $gray-900;\r\n          i {\r\n              color: $gray-900;\r\n          }\r\n      }\r\n  }\r\n  .dropdown-toggle {\r\n      &::after {\r\n          display: none;\r\n      }\r\n  }\r\n  .dropdown-menu {       \r\n          a {\r\n              display: -webkit-box;\r\n              display: -ms-flexbox;\r\n              display: flex;\r\n              -webkit-box-align: center;\r\n              -ms-flex-align: center;\r\n              align-items: center;\r\n              @include margin-padding(null, 5px);\r\n              border-radius: 5px;\r\n              color: $title-color;\r\n              white-space: nowrap;\r\n              i {\r\n                  margin-right: 8px;\r\n              }\r\n              &:hover {\r\n                  background: $light-300;\r\n                  color: $title-color;\r\n              }\r\n          }       \r\n  } \r\n}\r\n.daterangepicker {\r\n  font-family: $font-family-primary;\r\n  .calendar-table {\r\n      th {\r\n          color: $gray-900;\r\n      }\r\n      td {\r\n          color: $gray-900;\r\n      }\r\n\r\n  }\r\n}\r\n.daterangepicker td.active, .daterangepicker td.active:hover {\r\n  background-color:$danger ;\r\n  color: $danger-100;\r\n}\r\n.daterangepicker .ranges li.active {\r\n  background-color: $green;\r\n}\r\n.sort-dropdown.drop-down {\r\n  .dropdown-menu li a {\r\n      white-space: nowrap;\r\n  }\r\n}\r\n.drop-down {\r\n  position: relative;\r\n  & > a {\r\n      border: 1px solid $light-900;\r\n      border-radius: 5px;\r\n      box-shadow: 0px 4px 4px 0px #DBDBDB40;\r\n      background: $white;\r\n      font-weight: $font-weight-medium;\r\n      display: -webkit-inline-box;\r\n      display: -ms-inline-flexbox;\r\n      display: inline-flex;\r\n      -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n      align-items: center;\r\n      min-height: 42px;\r\n      @include margin-padding(null, 9px 15px);\r\n      i {\r\n          margin-right: 8px;\r\n      }   \r\n      &:hover {\r\n          color: $title-color;\r\n      }\r\n      &.show {\r\n          border: 1px solid #0092E4;\r\n      }  \r\n      &::after {\r\n          font-size: $font-size-14;\r\n          margin-left: 8px;\r\n      }\r\n      &[aria-expanded=true] {\r\n          &::after {\r\n              @include transition(all 0.2s ease);\r\n              @include transform(rotate(180deg));\r\n          }\r\n      } \r\n  }  \r\n  .dropdown-menu {\r\n      li {\r\n          a {\r\n              display: -webkit-box;\r\n              display: -ms-flexbox;\r\n              display: flex;\r\n              -webkit-box-align: center;\r\n              -ms-flex-align: center;\r\n              align-items: center;\r\n              @include margin-padding(null, 5px);\r\n              border-radius: 5px;\r\n              i {\r\n                  margin-right: 8px;\r\n              }\r\n              &:hover {\r\n                  background: $light-300;\r\n                  color: $title-color;\r\n              }\r\n          }\r\n      }\r\n  } \r\n}\r\n.dropdown-menu {\r\n  border: 1px solid $light-900;\r\n  padding: 15px;\r\n  box-shadow: $box-shadow-sm;\r\n}",".inbox-menu {\r\n    display: inline-block;\r\n    \r\n    width: 100%;\r\n    @include margin-padding(0 0 20px,0 );\r\n    li {\r\n        display: inline-block;\r\n        width: 100%;\r\n        a {\r\n            color: #333;\r\n            display: inline-block;\r\n            padding: 10px 15px;\r\n            width: 100%;\r\n            font-weight: $font-weight-semibold;\r\n            text-transform: capitalize;\r\n            -webkit-transition: 0.3s ease;\r\n            -moz-transition: 0.3s ease;\r\n            transition: 0.3s ease;\r\n            &:hover{\r\n                background: rgba(33, 33, 33, 0.05);\r\n            }\r\n            i {\r\n                font-size: $font-size-16;\r\n                padding-right: 10px;\r\n                color: #878787;\r\n            }\r\n        }\r\n    }\r\n}\r\n.compose-btn {\r\n    margin-bottom: 25px;\r\n}\r\n.top-action-left{\r\n    .btn-group {\r\n        margin-bottom: 5px;\r\n    }\r\n    .dropdown-toggle{\r\n        height: 40px;\r\n        &::after{\r\n            display: none;\r\n        }\r\n    }\r\n}\r\n.table-inbox {\r\n    .starred.fas.fa-star {\r\n        color: $warning;\r\n    }\r\n    .checked {\r\n        background-color: $gray-300;\r\n    }\r\n    th{\r\n        border-color: $light-700;  \r\n    }\r\n    tbody{\r\n        tr{\r\n            td{\r\n                font-size: $font-size-14;\r\n                color: $secondary;\r\n                border-color: $light-900;\r\n            }\r\n        }\r\n    }\r\n}\r\n.unread{\r\n    .name,\r\n    .subject,\r\n    .mail-date{\r\n        color: $black;\r\n        font-weight: $font-weight-bold;\r\n    }\r\n}\r\n.email-header{\r\n    .btn-white{\r\n        min-width: auto;\r\n        height: 38px;\r\n        border: 1px solid $light-900;\r\n        i{\r\n            margin-left:5px;\r\n        }\r\n    }\r\n}",".file-manager {\r\n    color:  $text-color;\r\n    .search-dropdown {\r\n        height: auto;\r\n    }\r\n    .form-sort {\r\n        width:  auto;\r\n        .select2-container--default .select2-selection--single .select2-selection__rendered {\r\n            padding-right: 27px;\r\n        }\r\n        &.owned-by {\r\n            margin-right: 10px;\r\n        }\r\n    }\r\n    &.notes-page-wrapper { \r\n        .content {\r\n            .page-add-notes {\r\n                padding-bottom: 30px;\r\n                margin-bottom: 30px;\r\n            }\r\n            .section-bulk-wrap {\r\n                margin-top: 0;\r\n                .form-sort {\r\n                    svg {\r\n                        &.fa-filter {\r\n                            top: 50%;\r\n                            @include transform(translateY(-50%));                            \r\n                        }\r\n                    }\r\n                }\r\n                .bulk-action-type {\r\n                    .select-bluk {\r\n                        margin-right: 15px;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .page-header {\r\n        .btn-added {\r\n            margin-left: 10px;\r\n        }\r\n        .form-sort {\r\n            @include respond-below(custom575) {\r\n                margin-top: 0;\r\n                margin-bottom:  15px;\r\n            }\r\n        }\r\n        .table-top-head {\r\n            @include respond-below(custom575) {\r\n                margin-bottom: 15px;\r\n            }\r\n            li {\r\n                &:last-child {\r\n                    @include respond-below(custom991) {\r\n                        margin-right: 0;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .bulk-action-type {\r\n        @include respond-below(custom767) {\r\n            align-items: start!important;\r\n        }\r\n        @include respond-below(custom575) {\r\n            display: block!important;\r\n        }\r\n        @include respond-below(custom767) {\r\n            .form-sort {\r\n                margin-top: 0;\r\n                margin-bottom: 15px;\r\n                width: 100%;\r\n            }\r\n        }\r\n    }\r\n    aside {\r\n        border: 1px solid $light-900;\r\n        box-shadow: $box-shadow;\r\n        @include rounded(8px);\r\n        h5 {\r\n            font-size: $font-size-18;\r\n            font-weight: $font-weight-bold;\r\n            border-bottom:  1px solid $gray-100;\r\n            @include margin-padding(0 0 15px 0, 0 0 15px 0);\r\n        }\r\n        .btn {\r\n            font-weight: $font-weight-bold;\r\n        }\r\n        .dropdown {\r\n            > a { \r\n                width: auto;\r\n                height: 40px;\r\n                color:  $white;\r\n                @include rounded(5px);\r\n                &:hover, &:focus {\r\n                    border-color: $gray-400;\r\n                    background: $gray-400;\r\n                }\r\n            }\r\n            ul {\r\n                width: 100%;\r\n                li {\r\n                    a {\r\n                        font-size: $font-size-15;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n        ul {\r\n            li {\r\n                a {\r\n                    display: -webkit-box;\r\n                    display: -ms-flexbox;\r\n                    display: flex;\r\n                    align-items: center;\r\n                    -webkit-box-align: center;\r\n                    -ms-flex-align: center;\r\n                    color: $text-color;\r\n                    font-size: $font-size-base;\r\n                    font-weight: $font-weight-semibold;\r\n                    @include margin-padding(0 0 5px 0, 7px 10px);\r\n                    @include rounded(5px);\r\n                    height: 40px;\r\n                    span {\r\n                        display: -webkit-box;\r\n                        display: -ms-flexbox;\r\n                        display: flex;\r\n                        align-items: center;\r\n                        -webkit-box-align: center;\r\n                        -ms-flex-align: center;\r\n                        width: auto;\r\n                    }\r\n                    &:hover, &.active {\r\n                        background: $gray-400;\r\n                        color: $white;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n        span {\r\n            font-size: $font-size-13;\r\n            font-weight: $font-weight-medium; \r\n            width: auto;\r\n            height: auto;\r\n        }\r\n        h6 {\r\n            font-size: $font-size-16;\r\n            font-weight: $font-weight-semibold;\r\n            position: relative;\r\n            z-index: 2;\r\n        }\r\n        .space-manager {\r\n            color:  $white;\r\n            background: $gray-400;\r\n            @include rounded(8px);\r\n            position: relative;\r\n            img {\r\n                @include position(absolute,0,0,null,null);\r\n            }\r\n            h6 {\r\n                a {\r\n                    color:  $white;\r\n                }\r\n            }\r\n            p {\r\n                color:  $sub-title;\r\n            }\r\n        }\r\n    }\r\n    .progress {\r\n        height: 6px;\r\n        @include rounded(5px);\r\n    }\r\n    .search-set {\r\n         .search-input {\r\n            input[type=search] {\r\n                width:  170px;\r\n                height: 40px;\r\n            }\r\n\r\n         }\r\n\r\n    }\r\n    .budgeted-role-notes {\r\n        .search-set {\r\n            .search-input {\r\n                input[type=search] {\r\n                    width:  298px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    h4 {\r\n        font-size: $font-size-18;\r\n        font-weight: $font-weight-semibold;\r\n    }\r\n    h6 {\r\n        font-size: $font-size-16;\r\n        font-weight: $font-weight-semibold;\r\n        a {\r\n            color: $gray-400;\r\n            &:hover {\r\n                color: $primary;\r\n            }\r\n        }\r\n    }\r\n    .overview {\r\n        .detail {\r\n            a {\r\n                &.bg {\r\n                    @include rounded(8px 8px 0 0);\r\n                    span {\r\n                        width: 66px;\r\n                        height: 66px;\r\n                        @include rounded(100%);\r\n                        img {\r\n                            @include transition(all 0.5s ease);\r\n                        }\r\n                    }\r\n                }\r\n                &:hover {\r\n                    img {\r\n                        transform: scale(1.2);\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .info {\r\n        @include rounded(0 0 8px 8px);\r\n        padding: 15px;\r\n        background: $white;\r\n        box-shadow: $box-shadow;\r\n        span {\r\n            color:  $text-color;\r\n            font-size: $font-size-13;\r\n        }\r\n    }\r\n    .folders {\r\n        border: 1px solid $light-900;\r\n        box-shadow: $box-shadow;\r\n        @include rounded(8px);\r\n        background: $white;\r\n        h6 {\r\n            width: 100%;\r\n            white-space: nowrap;\r\n            text-overflow: ellipsis;\r\n            overflow: hidden;\r\n            margin-right: 8px;\r\n        }\r\n    }\r\n\r\n    .dropdown {\r\n        > a {\r\n            color: $gray-400;\r\n            width: 25px;\r\n            height: 25px;\r\n            @include transition(all 0.5s ease);\r\n            @include rounded(100%);\r\n            display: -webkit-box;\r\n            display: -ms-flexbox;\r\n            display: flex;\r\n            align-items: center;\r\n            -webkit-box-align: center;\r\n            -ms-flex-align: center;\r\n            justify-content: center;\r\n            -webkit-justify-content: center;\r\n            -ms-flex-pack: center;\r\n            &:hover {\r\n                background: $primary;\r\n                i {\r\n                    color: $white;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .project-plan {\r\n        font-size: $font-size-13;\r\n        font-weight: $font-weight-semibold;\r\n        margin-top: 10px;\r\n        label {\r\n            color: $gray-400;\r\n            margin-right: 9px;\r\n            font-size: $font-size-13;\r\n        }\r\n        ul {\r\n            li {\r\n                font-size: $font-size-13;\r\n                position: relative;\r\n                padding: 0 9px 0 14px;\r\n                color:  $text-color;\r\n                &:before {\r\n                    content:  '';\r\n                    @include position(absolute,50%,null,null,0);\r\n                    @include transform(translateY(-50%));\r\n                    width: 5px;\r\n                    height: 5px;\r\n                    background: $gray-400;\r\n                    @include rounded(5px);\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .avatar-wrap {\r\n        a {\r\n            svg {\r\n                color: $text-color;\r\n                width: 18px;\r\n            }\r\n            &:hover {\r\n                svg {\r\n                    color: $primary; \r\n                    \r\n                }\r\n            }\r\n        }\r\n    }\r\n    .accordion {\r\n        border:  none;\r\n        --bs-accordion-border-width: none;\r\n        .accordion-item {\r\n            border:  none;\r\n            border-bottom: 1px solid $light-900;\r\n            background: none;\r\n            &:last-of-type {\r\n                border-bottom-right-radius: 0;\r\n                border-bottom-left-radius: 0;\r\n                border-bottom: none;\r\n            }\r\n            .accordion-button {\r\n                background: none;\r\n                border:  none;\r\n                font-size: $font-size-18;\r\n                font-weight: $font-weight-semibold;\r\n                color: $gray-400;\r\n                padding: 0;\r\n                display: inline-block;\r\n                width: auto;\r\n                &:after {\r\n                    @include transition(all 0.8s ease);\r\n                    background-image: none;\r\n                    content: \"View All\";\r\n                    font-family: \"Nunito\", sans-serif;\r\n                    font-size: $font-size-base;\r\n                    font-weight: $font-weight-bold;\r\n                    color: $text-color;\r\n                    transform:  none;\r\n                    width: 60px;\r\n                    text-align: right;\r\n                }\r\n                &:not(.collapsed)::after {\r\n                    content: \"Hide\";\r\n                }\r\n                &.collapsed {\r\n                    padding: 0;\r\n                }\r\n                &:hover {\r\n                    &:after {\r\n                        color: $primary;\r\n                    }\r\n                }\r\n            }\r\n            .accordion-body {\r\n                border: none;\r\n                padding: 0;\r\n                .head {\r\n                    img {\r\n                        min-width: 32px;\r\n                        width:  32px;\r\n                        height: 32px;\r\n                    }\r\n                }\r\n                .owl-carousel {\r\n                    padding-top: 15px;\r\n                }\r\n            }\r\n\r\n        }\r\n    }\r\n    .owl-carousel {\r\n        .owl-item {\r\n            margin-left: -0.1px!important;\r\n        }\r\n        .dropdown-menu {\r\n            left: auto !important;\r\n            right: 0 !important;\r\n            top:  27px !important;\r\n            transform: none !important;\r\n            background: $white !important;\r\n            box-shadow: $box-shadow;\r\n            z-index: 99999 !important;\r\n        }\r\n        .owl-nav {\r\n            top: -20px;\r\n            left: 43px;\r\n            display: inline-table;\r\n            button {\r\n                margin-top: 0;\r\n                margin-bottom: 0;\r\n                background: none;\r\n                cursor: pointer;\r\n                &.owl-next, &.owl-prev {\r\n                    position: relative;\r\n                    width: 15px;\r\n                    i {\r\n                        color: $text-color;\r\n                    }\r\n                    &:hover {\r\n                        background: none;\r\n                        i {\r\n                           color: $primary;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n        &.folders-carousel {\r\n           .owl-nav {\r\n                left:  75px;\r\n            } \r\n        }\r\n        &.video-section {\r\n            .owl-nav {\r\n                left:  60px;\r\n            }\r\n            .info {\r\n                a {\r\n                    svg {\r\n                        color: $text-color;\r\n                        width: 18px;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .all-files {\r\n        box-shadow: $box-shadow;\r\n        border: none;\r\n        .btn-grp {\r\n            a {\r\n                padding: 6px 8px;\r\n                @include rounded(8px);\r\n                cursor: pointer;\r\n                display: -webkit-box;\r\n                display: -ms-flexbox;\r\n                display: flex;\r\n                align-items: center;\r\n                -webkit-box-align: center;\r\n                -ms-flex-align: center;\r\n                justify-content: center;\r\n                -webkit-justify-content: center;\r\n                -ms-flex-pack: center;\r\n                @include respond-below(custom575) {\r\n                    margin-bottom: 15px;\r\n                    display: inline-block;\r\n                }\r\n                &.btn-outline-secondary {\r\n                    color:  $text-color;\r\n                    background: $body-bg;\r\n                    border-color: $body-bg;\r\n                }\r\n                &:hover {\r\n                    background: $gray-400;\r\n                    border-color: $gray-400;\r\n                    color: $white;\r\n                }\r\n            }\r\n        }\r\n        .table { \r\n            thead {\r\n                tr {\r\n                    th {\r\n                        border-color: $light-900;\r\n                    }\r\n                }\r\n            }\r\n            tbody {\r\n                tr { \r\n                    td {  \r\n                        display: table-cell;\r\n                        font-size: $font-size-base;\r\n                        font-weight: $font-weight-medium;\r\n                        white-space: nowrap;\r\n                        border-color: $light-900;\r\n                        a {\r\n                            font-size: $font-size-base;\r\n                            font-weight: $font-weight-medium;\r\n                            &.product-img { \r\n                                img {\r\n                                    width: 32px;\r\n                                    height: 32px;\r\n                                    border: 0;\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    #file-delete {\r\n        font-size: $font-size-base;\r\n    }\r\n}\r\naside {\r\n    padding: 24px;\r\n}\r\n.color-primary {\r\n    color:  $text-color;\r\n}\r\n.icon-select {\r\n    position: relative;\r\n    width: 149px;\r\n    height: 38px;\r\n\r\n    .icon {\r\n        @include position(absolute,50%,null,null,10px);\r\n        @include transform(translateY(-50%));\r\n        z-index: 100;\r\n    }\r\n    .select2-container--default .select2-selection--single .select2-selection__rendered {\r\n        padding-left: 30px;\r\n    }\r\n}\r\n.bg-light-orange {\r\n    background: $primary-200;\r\n    span {\r\n        background: $primary-200;\r\n    }\r\n}\r\n.bg-light-red {\r\n    background: $danger-200;\r\n    span {\r\n        background: $danger-200;\r\n    }\r\n}\r\n.bg-light-green {\r\n    background: $success-300;\r\n    span {\r\n        background: $success-300;\r\n    }\r\n}\r\n.seprator-sm {\r\n    @include margin-padding(0 0 24px 0, 0 0 9px 0);\r\n    border-bottom: 1px solid $gray-100;\r\n}\r\n.seprator-lg {\r\n    @include margin-padding(0 0 24px 0, 0 0 24px 0);\r\n    border-bottom: 1px solid $light-900;\r\n}\r\n.group-avatar {\r\n    .avatar {\r\n        position: relative;\r\n        width: 43px;\r\n        height: 43px;\r\n        line-height: 43px;\r\n        margin: 0;\r\n    \r\n         & +.avatar {\r\n            margin-left: -1.2rem;\r\n        }\r\n        &:hover {\r\n            z-index: 1;\r\n        }\r\n    }\r\n    .count {\r\n        a { \r\n            color: $success;\r\n            line-height: 27px;\r\n            font-size: $font-size-13;\r\n            font-weight: $font-weight-medium;\r\n            &:hover {\r\n                color: $primary;\r\n            }\r\n        }\r\n    }\r\n    .avatar img {\r\n      display: block;\r\n      border-radius: 100%;\r\n      width: 100%;\r\n      border: 2px solid $white;\r\n    }\r\n}\r\n\r\n.video-section .item{\r\n  opacity:0.4;\r\n  transition:.4s ease all;\r\n  transform:scale(.8);\r\n}\r\n\r\n@media(max-width:1000px){\r\n  .video-section .item{margin:0; transform:scale(.9)}\r\n}\r\n\r\n.video-section .active .item{\r\n  opacity:1;\r\n  transform:scale(1);\r\n} \r\n\r\n.video-section .owl-item {\r\n    -webkit-backface-visibility: hidden;\r\n    -webkit-transform: translateZ(0) scale(1.0, 1.0);\r\n}\r\n\r\n.video-section video{\r\n  max-width:100%;\r\n  height:100%;\r\n  @include rounded(10px 10px 0 0);\r\n}\r\n.delete-alert {\r\n    padding: 10px 20px;\r\n    background: $danger-200;\r\n    border:  none;\r\n    @include rounded(8px);\r\n    p {\r\n        font-size: $font-size-15;\r\n    }\r\n    .btn {\r\n        font-weight: $font-weight-bold;\r\n    }\r\n}\r\n.deleted-info {\r\n    display: none;\r\n    .bin-bg {\r\n        width: 184px;\r\n        height: 184px;\r\n        @include rounded(100%);\r\n        background: $light;\r\n        margin: 0 auto;\r\n    }\r\n}\r\n.popup-toggle {\r\n    cursor: pointer;\r\n}\r\n.toggle-sidebar {\r\n    width: 456px;\r\n    padding: 25px;\r\n    position: fixed;\r\n    right: -456px;\r\n    top: 0;\r\n    height: 100%;\r\n    background: $white;\r\n    z-index: 100001;\r\n    border-top-left-radius: 15px;\r\n    border-bottom-left-radius: 15px;\r\n    box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;\r\n    overflow-y: auto;\r\n    @include transition(all 0.5s ease);\r\n    @include respond-below(custom575) {\r\n        width: 320px;\r\n        right: -320px;\r\n    }\r\n    &.open-sidebar {\r\n        right: 0;\r\n        @include transition(all 0.5s ease);\r\n    }\r\n    .head {\r\n        .color-primary {\r\n            &:hover {\r\n                color: $danger;\r\n            }\r\n        }\r\n    } \r\n    h4, h5 {\r\n        font-weight: $font-weight-bold;\r\n    }\r\n    h4 {\r\n        font-size: $font-size-20;\r\n    }\r\n    h5 {\r\n        font-size: $font-size-18;\r\n    }\r\n    h6 {\r\n         font-size: $font-size-15;\r\n        font-weight: $font-weight-semibold;\r\n    }\r\n    .nav-tabs {\r\n        border-bottom: 1px solid $gray-100;\r\n        .nav-link {\r\n            padding: 8px 20px;\r\n            font-size: $font-size-16;\r\n            font-weight: $font-weight-semibold;\r\n            @include rounded(8px);\r\n            border: none;\r\n            background: $body-bg;\r\n            color: $gray-400;\r\n            &:hover, &.active {\r\n                background: $primary;\r\n                color: $white;\r\n            }\r\n        }\r\n    }\r\n    .tab-content {\r\n        .tab-pane {\r\n            ul {\r\n                li {\r\n                    h6 {\r\n                        margin-bottom: 5px;\r\n                    }\r\n                    p {\r\n                        &.location {\r\n                            background: $body-bg;\r\n                            border: 1px solid $gray-100;\r\n                            @include rounded(5px);\r\n                            padding: 5px;\r\n                            display: inline-block;\r\n                            img {\r\n                                width: 20px;\r\n                                height: 20px;\r\n                            }\r\n                        }\r\n                    }\r\n                    .note-editor.note-airframe .note-statusbar, .note-editor.note-frame .note-statusbar {\r\n                        border-top: none;\r\n                    }\r\n                }\r\n            }\r\n            .avatar-access {\r\n                span {\r\n                    a {\r\n                        display: inline-flex; \r\n                        margin-right: 3px;\r\n                        padding-right: 3px;\r\n                    }\r\n                    &:first-child {\r\n                        a {\r\n                            margin-right: 10px;\r\n                            padding-right: 10px;\r\n                            border-right: 1px solid $gray-100;\r\n                        }\r\n                    }\r\n                    &:last-child {\r\n                        a {\r\n                            margin-right: 0;\r\n                            padding-right: 0;\r\n                        }\r\n                    }\r\n                    .add {\r\n                        background: $primary;\r\n                        color:  $white;\r\n                        &:hover {\r\n                            background: $gray-400;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    p {\r\n        color: $text-color;\r\n        font-size: $font-size-15;\r\n    }\r\n    .show-all {\r\n        font-weight: $font-weight-bold;\r\n        &:hover {\r\n            color: $gray-400;\r\n        }\r\n    }\r\n\r\n}\r\n.text-danger {\r\n    color: $danger!important;\r\n}\r\n.avatar-md {\r\n    width: 45px;\r\n    height: 45px;\r\n    @include rounded(45px);\r\n}\r\n.text-secondary {\r\n    color: $gray-400!important;\r\n}\r\n.text-primary {\r\n    color: $primary!important;\r\n}\r\n.text-default {\r\n    color: $text-color;\r\n}\r\n.btn-icon {\r\n    svg {\r\n        width: 18px;\r\n}\r\n}\r\n\r\n.file-manager-modal {\r\n    .modal-header {\r\n        h5 {\r\n            font-size: $font-size-18;\r\n            font-weight: $font-weight-bold;\r\n        }\r\n    }\r\n    &#hold-order {\r\n        h2 {\r\n            font-size: $font-size-36;\r\n            font-weight: $font-weight-bold;\r\n            color: $gray-900;\r\n            margin-bottom: 10px;\r\n            background-color: $body-bg;\r\n            @include rounded(10px);\r\n        }\r\n        .input-block {\r\n            label {\r\n                margin-bottom: 5px;\r\n            }\r\n        }\r\n        p {\r\n            margin-top: 20px;\r\n        }\r\n    }\r\n    &#recents {\r\n        .table {\r\n            tbody {\r\n                tr {\r\n                    td {\r\n                        padding: 10px 15px;\r\n                    }\r\n                }\r\n            }\r\n\r\n        }\r\n    }\r\n    .badge {\r\n        padding: 5px 10px;\r\n        font-size: $font-size-15;\r\n        font-weight: normal;\r\n    }\r\n    &#orders {\r\n        .modal-dialog {\r\n            max-width: 575px;\r\n        }\r\n        .order-body{\r\n            height: 50vh;\r\n            overflow: auto;\r\n            .default-cover {\r\n                border: 1px solid $gray-100;\r\n                box-shadow: $box-shadow;\r\n                @include rounded(8px);\r\n            }\r\n            .record {\r\n                font-size: $font-size-15;\r\n                td {\r\n                    padding-bottom: 15px;\r\n                }\r\n                tr {\r\n                    &:last-child {\r\n                        td {\r\n                            padding-bottom: 0;\r\n                        }\r\n                    }\r\n                }\r\n                .colon {\r\n                    padding: 0 10px;\r\n                    color: $secondary;\r\n                }\r\n                .text {\r\n                    color: $text-color;\r\n                    white-space: nowrap;\r\n                }\r\n            }\r\n            p {\r\n                font-size: $font-size-15;\r\n                background-color: $body-bg;\r\n                @include rounded(8px);\r\n            }\r\n            .search-set {\r\n                .search-input {\r\n                    width: 100%;\r\n                    label {\r\n                        width: 100%;\r\n                        input {\r\n                            width: 100%;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    &.upload-modal {\r\n        .modal-body{ \r\n            .drag-drop {\r\n                position: relative;\r\n                padding: 20px;\r\n                border:  1px dashed $sub-title;\r\n                input[type=\"file\"] {\r\n                    @include position(absolute,0,0,null,0);\r\n                    width: 100%;\r\n                    height: 100%;\r\n                    opacity: 0;\r\n                    cursor: pointer;\r\n                }\r\n            }\r\n            span {\r\n                font-size: $font-size-13;\r\n                font-weight: $font-weight-medium;\r\n                color: $text-color;\r\n            }\r\n            p {\r\n                font-size: $font-size-16;\r\n                font-weight: $font-weight-semibold;\r\n                color: $secondary;\r\n                margin-bottom: 0;\r\n            }\r\n            .progress {\r\n                height: 6px;\r\n                @include rounded(5px);\r\n            }\r\n            ul {\r\n                li {\r\n                    @include margin-padding(0 0 15px 0, 15px);\r\n                    @include rounded(8px);\r\n                    border: 1px solid $gray-100;\r\n                    svg {\r\n                        width: 18px;\r\n                    }\r\n                    h6 {\r\n                        a {\r\n                            font-size: $font-size-16;\r\n                            font-weight: $font-weight-semibold;\r\n                            color: $secondary;\r\n                            svg {\r\n                                color:  $success;\r\n                            }\r\n                        }\r\n                        &:hover {\r\n                            a {\r\n                                color: $primary;\r\n                            }\r\n                        }\r\n                    }\r\n                    &:last-child {\r\n                        margin-bottom: 0;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    &#upload-message {\r\n        .modal-dialog {\r\n            position:fixed;\r\n            bottom:0px;\r\n            right:24px;\r\n            margin:0px;\r\n            left:  auto;\r\n            top: calc(100% - 300px); \r\n            width: 600px;\r\n        }\r\n        .progress {\r\n            height: 6px;\r\n            @include rounded(5px);\r\n        }\r\n    }\r\n}\r\n.datanew {\r\n    tr {\r\n        td {\r\n            svg {\r\n                width: 18px;\r\n            }\r\n        }\r\n    }\r\n}",".icons-list {\r\n    padding: 0;\r\n    display: -webkit-box;\r\n      display: -ms-flexbox;\r\n      display: flex;\r\n      -ms-flex-wrap: wrap;\r\n      flex-wrap: wrap;\r\n      li {\r\n        display: block;\r\n        width: 40px;\r\n        height: 40px;\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        align-items: center;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        justify-content: center;\r\n        -webkit-justify-content: center;\r\n        -ms-flex-pack: center;\r\n        font-size: $font-size-18;\r\n        @include rounded(50px);\r\n        border: 1px solid #e6ebf1;\r\n        color: $primary;\r\n        @include margin-padding(5px, null);\r\n        @include box-shadow(null, 0, 2px, 3px, null, rgb(215, 197, 255));\r\n    }\r\n}",".progress {\r\n    background-color: $light-900;\r\n    height: 0.75rem;\r\n    border-radius: 0.25rem;\r\n}\r\n.progress-stacked {\r\n    background-color: $light-900;\r\n}\r\n.progress-bar {\r\n    color: $white;\r\n    background-color: $primary;\r\n}\r\n\r\n@keyframes progress-animate {\r\n    0% {\r\n        width: 0;\r\n    }\r\n}\r\n.progress-animate {\r\n    position: relative;\r\n    border-radius: 0.625rem;\r\n    .progress-bar {\r\n        position: relative;\r\n        border-radius: 0.625rem;\r\n        animation:  2s progress-animate;\r\n    }\r\n}\r\n.progress,.progress-stacked {\r\n    &.progress-xs {\r\n        height: .3125rem;\r\n    }\r\n    &.progress-sm {\r\n        height: 0.5rem;\r\n    }\r\n    &.progress-lg {\r\n        height: 1rem;\r\n    }\r\n    &.progress-xl {\r\n        height: 1.25rem;\r\n    }\r\n}\r\n.progress-vertical {\r\n    min-height: 250px;\r\n    height: 250px;\r\n    width: 10px;\r\n    position: relative;\r\n    display: inline-block;\r\n    margin-bottom: 0;\r\n    margin-right: 20px;\r\n\r\n    .progress-bar {\r\n        width: 100%;\r\n    }\r\n\r\n    &.progress-xl {\r\n        width: 15px;\r\n    }\r\n\r\n    &.progress-lg {\r\n        width: 12px;\r\n    }\r\n\r\n    &.progress-sm {\r\n        width: 8px;\r\n    }\r\n\r\n    &.progress-xs {\r\n        width: 5px;\r\n    }\r\n}\r\n.progress-vertical-bottom {\r\n    min-height: 250px;\r\n    height: 250px;\r\n    position: relative;\r\n    width: 10px;\r\n    display: inline-block;\r\n    margin-bottom: 0;\r\n    margin-right: 20px;\r\n\r\n    .progress-bar {\r\n        width: 100%;\r\n        bottom: 0;\r\n        position: absolute;\r\n    }\r\n\r\n    &.progress-xl {\r\n        width: 15px;\r\n    }\r\n\r\n    &.progress-lg {\r\n        width: 12px;\r\n    }\r\n\r\n    &.progress-sm {\r\n        width: 8px;\r\n    }\r\n\r\n    &.progress-xs {\r\n        width: 5px;\r\n    }\r\n}\r\n.progress-custom {\r\n    overflow: visible;\r\n    position: relative;\r\n    .progress-bar {\r\n        position: relative;\r\n        overflow: visible;\r\n        &:after {\r\n            content: \"\";\r\n            width: 1.15rem;\r\n            height: 1.15rem;\r\n            border-radius: 50%;\r\n            box-shadow: 0 0.313rem 0.313rem rgba($primary, 0.5);\r\n            background: $white;\r\n            position: absolute;\r\n            inset-inline-end: -0.375rem;\r\n            inset-block-start: -0.375rem;\r\n            border: 0.25rem solid $primary;\r\n        }\r\n        &.bg-secondary:after {\r\n            border: 0.25rem solid $secondary;\r\n            box-shadow: 0 0.313rem 0.313rem rgba(var(--secondary-rgb),0.2);\r\n        }\r\n        &.bg-warning:after {\r\n            border: 0.25rem solid $warning;\r\n            box-shadow: 0 0.313rem 0.313rem rgba(var(--warning-rgb),0.2);\r\n        }\r\n        &.bg-info:after {\r\n            border: 0.25rem solid $info;\r\n            box-shadow: 0 0.313rem 0.313rem rgba(var(--info-rgb),0.2);\r\n        }\r\n        &.bg-success:after {\r\n            border: 0.25rem solid $success;\r\n            box-shadow: 0 0.313rem 0.313rem rgba(var(--success-rgb),0.2);\r\n        }\r\n        &.bg-danger:after {\r\n            border: 0.25rem solid $danger;\r\n            box-shadow: 0 0.313rem 0.313rem rgba(var(--danger-rgb),0.2);\r\n        }\r\n    }\r\n    .progress-bar-value{\r\n        width: 1.875rem;\r\n        height: 1.25rem;\r\n        line-height: 1.25rem;\r\n        border-radius: 0.188rem;\r\n        background: $primary;\r\n        box-shadow: 0 0.313rem 0.313rem rgba(0,0,0,0.4);\r\n        font-size: 0.625rem;\r\n        font-weight: $font-weight-semibold;\r\n        color: $white;\r\n        text-align: center;\r\n        position: absolute;\r\n        inset-block-end: 1.5rem;\r\n        inset-inline-end: -0.688rem;\r\n        &:after{\r\n            content: \"\";\r\n            border-block-start: 0.438rem solid $primary;\r\n            border-inline-start: 0.438rem solid transparent;\r\n            border-inline-end: 0.438rem solid transparent;\r\n            position: absolute;\r\n            inset-block-end: -0.375rem;\r\n            inset-inline-start: 28%;\r\n        }\r\n        &.bg-secondary {\r\n            background-color: $secondary;\r\n            &:after {\r\n                border-block-start: 0.438rem solid $secondary;\r\n            }\r\n        }\r\n        &.bg-success {\r\n            background-color: $success;\r\n            &:after {\r\n                border-block-start: 0.438rem solid $success;\r\n            }\r\n        }\r\n        &.bg-warning {\r\n            background-color: $warning;\r\n            &:after {\r\n                border-block-start: 0.438rem solid $warning;\r\n            }\r\n        }\r\n        &.bg-danger {\r\n            background-color: $danger;\r\n            &:after {\r\n                border-block-start: 0.438rem solid $danger;\r\n            }\r\n        }\r\n        &.bg-info {\r\n            background-color: $info;\r\n            &:after {\r\n                border-block-start: 0.438rem solid $info;\r\n            }\r\n        }\r\n    }\r\n}\r\n[dir=\"rtl\"] {\r\n    .progress-bar-title{ \r\n        border-radius: 0 0.313rem 0.313rem 0;\r\n    }\r\n}\r\n.progress-item-1, .progress-item-2, .progress-item-3{\r\n    position:absolute;\r\n\tmargin-block-start:-0.25rem;\r\n\tz-index:1;\r\n\theight:0.938rem;\r\n\twidth:0.938rem;\r\n\tborder-radius:1.563rem;\r\n    background-color: $light;\r\n}\r\n.progress-item-1{\r\n\tinset-inline-start:25%;\r\n}\r\n.progress-item-2{\r\n\tinset-inline-start:50%;\r\n}\r\n.progress-item-3{\r\n\tinset-inline-start:75%;\r\n}\r\n.custom-progress-3 {\r\n    overflow: visible;\r\n    border-radius: 0.625rem;\r\n    .progress-bar {\r\n        position: relative;\r\n        overflow: visible;\r\n        margin: 0.313rem;\r\n        border-radius: 0.25rem;\r\n        &:before {\r\n            content: \"\";\r\n            position: absolute;\r\n            width: 0.25rem;\r\n            height: 0.25rem;\r\n            inset-inline-start: 0.125rem;\r\n            background-color: $white;\r\n            border-radius: 50%;\r\n        }\r\n        .progress-bar-value{\r\n            border: 0.125rem solid $primary;\r\n            width: 2.5rem;\r\n            height: 1.563rem;\r\n            line-height: 1.313rem;\r\n            border-radius: 3.125rem;\r\n            background: $white;\r\n            font-size: 0.625rem;\r\n            font-weight: $font-weight-semibold;\r\n            color: $primary;\r\n            text-align: center;\r\n            position: absolute;\r\n            inset-inline-end: -0.625rem;\r\n            &.secondary {\r\n                border: 0.125rem solid $secondary;\r\n                color: $secondary;\r\n            }\r\n            &.warning {\r\n                border: 0.125rem solid $warning;\r\n                color: $warning;\r\n            }\r\n            &.info {\r\n                border: 0.125rem solid $info;\r\n                color: $info;\r\n            }\r\n            &.success {\r\n                border: 0.125rem solid $success;\r\n                color: $success;\r\n            }\r\n            &.danger {\r\n                border: 0.125rem solid $danger;\r\n                color: $danger;\r\n            }\r\n        }\r\n    }\r\n}\r\n.custom-progress-4 {\r\n    &.progress {\r\n        background-color: rgba($primary, 0.1);\r\n        border-radius: 0.25rem;\r\n        &.secondary {\r\n            background-color: rgba($secondary, 0.1);\r\n            .progress-bar-label {\r\n                color: $secondary;\r\n            }\r\n        }\r\n        &.warning {\r\n            background-color: rgba($warning, 0.1);\r\n            .progress-bar-label {\r\n                color: $warning;\r\n            }\r\n        }\r\n        &.info {\r\n            background-color: rgba($info, 0.1);\r\n            .progress-bar-label {\r\n                color: $info;\r\n            }\r\n        }\r\n        &.success {\r\n            background-color: rgba($success, 0.1);\r\n            .progress-bar-label {\r\n                color: $success;\r\n            }\r\n        }\r\n        &.danger {\r\n            background-color: rgba($danger, 0.1);\r\n            .progress-bar-label {\r\n                color: $danger;\r\n            }\r\n        }\r\n        .progress-bar {\r\n            border-radius: 0.25rem;\r\n        }\r\n        .progress-bar-label {\r\n            position: absolute;\r\n            inset-inline-end: 0.313rem;\r\n            font-weight: $font-weight-semibold;\r\n            font-size: 0.813rem;\r\n            color: $primary;\r\n        }\r\n    }\r\n}",".page-link {\r\n    color: $text-color;\r\n    background-color: $white;\r\n    border: 1px solid $border-color;\r\n    &:focus {\r\n        box-shadow: none;\r\n        background-color: $light;\r\n    }\r\n    &:hover {\r\n        color: $primary;\r\n        background-color: $light;\r\n        border-color: $border-color;\r\n    }\r\n}\r\n.page-item.active .page-link {\r\n    color: $white;\r\n    background-color: $primary;\r\n    border-color: $primary;\r\n}\r\n.disabled>.page-link, .page-link.disabled {\r\n    color: $text-color;\r\n    background-color: $white;\r\n    border-color: $border-color;\r\n    opacity: 0.7;\r\n}\r\n\r\n[dir=\"rtl\"] { \r\n    .pagination{\r\n        .page-link{\r\n            .bx-chevron-left::before{\r\n                content: \"\\ea50\";\r\n            }\r\n            .bx-chevron-right::before{\r\n                content: \"\\ea4d\";\r\n            }\r\n            .ri-arrow-right-s-line:before{\r\n                content: \"\\ea64\";\r\n            }\r\n            .ri-arrow-left-s-line:before{\r\n                content: \"\\ea6e\";\r\n            }\r\n        }\r\n    }\r\n}\r\n.pagination-style-1 .pagination {\r\n    .page-item {\r\n        margin: 0 0.25rem;\r\n        .page-link {\r\n            border: 0;\r\n            border-radius: $border-radius;\r\n            font-size: 0.8125rem;\r\n            i {\r\n                font-weight: $font-weight-semibold;\r\n            }\r\n        }\r\n        &.active {\r\n            .page-link {\r\n                border-radius: $border-radius;\r\n                background-color: $primary;\r\n                color: $white;\r\n            }\r\n            &:hover {\r\n                .page-link {\r\n                    border-radius: $border-radius;\r\n                    background-color: $primary;\r\n                    color: $white;\r\n                }\r\n            } \r\n        }\r\n        &:hover {\r\n            .page-link {\r\n                background-color: $light;\r\n                color: $primary;\r\n            }\r\n        }\r\n    }\r\n}\r\n.pagination-style-2 .pagination {\r\n    border-radius: $border-radius;\r\n    .page-item {\r\n        margin: 0 0.25rem;\r\n        .page-link {\r\n            border: 0 !important;\r\n            font-size: 0.8125rem;\r\n        }\r\n        &.active {\r\n            .page-link {\r\n                background-color: $white;\r\n                color: $primary;\r\n                position: relative;\r\n                font-weight: bold;\r\n                &:before {\r\n                    position: absolute;\r\n                    content: \"\";\r\n                    inset-block-end: 0;\r\n                    inset-inline-start: 0;\r\n                    width: 100%;\r\n                    height: 0.1rem;\r\n                    background-color: $primary;\r\n                }\r\n            }\r\n        }\r\n        &:hover {\r\n            .page-link {\r\n                background-color: transparent;\r\n            }\r\n        }\r\n    }\r\n}\r\n.pagination-style-3 .pagination {\r\n    border-radius: 50px;\r\n    padding: 0.25rem;\r\n    align-items: center;\r\n    .page-item {\r\n        margin: 0 0.25rem;\r\n        .page-link {\r\n            border: 0;\r\n            border-radius: 50px;\r\n            font-size: 0.8125rem;\r\n            i {\r\n                font-weight: $font-weight-semibold;\r\n            }\r\n        }\r\n        &.active {\r\n            .page-link {\r\n                background-color: $primary;\r\n                color: $white;\r\n            }\r\n            &:hover {\r\n                .page-link {\r\n                    background-color: $primary;\r\n                }\r\n            }\r\n        }\r\n        &:hover {\r\n            .page-link {\r\n                background-color: $light;\r\n            }\r\n        }\r\n    }\r\n}\r\n.pagination-style-4 .pagination {\r\n    .page-item {\r\n        .page-link {\r\n            border: 0 !important;\r\n            font-size: 0.8125rem;\r\n            border-radius: $border-radius;\r\n            i {\r\n                font-weight: $font-weight-semibold;\r\n            }\r\n        }\r\n        &.active {\r\n            .page-link {\r\n                border: 0;\r\n                border-radius: $border-radius;\r\n                background-color: $primary;\r\n                color: $white;\r\n            }\r\n            &:hover {\r\n                .page-link {\r\n                    background-color: $primary;\r\n                }\r\n            }\r\n        }\r\n        &:hover {\r\n            .page-link {\r\n                background-color: transparent;\r\n            }\r\n        }\r\n    }\r\n}","h1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\n.h1,\r\n.h2,\r\n.h3,\r\n.h4,\r\n.h5,\r\n.h6 {\r\n  color: $title-color;\r\n  font-family: $font-family-primary;\r\n  font-weight: $font-weight-bold;\r\n  margin-bottom: 0;\r\n}\r\nh1,\r\n.h1 {\r\n  font-size: 2rem;\r\n}\r\nh2,\r\n.h2 {\r\n  font-size: 1.75rem;\r\n}\r\nh3,\r\n.h3 {\r\n  font-size: 1.5rem;\r\n}\r\nh4,\r\n.h4 {\r\n  font-size: 1.125rem;\r\n}\r\nh5,\r\n.h5 {\r\n  font-size: 1rem;\r\n}\r\nh6,\r\n.h6 {\r\n  font-size: 0.875rem;\r\n}\r\n.fs-sm {\r\n  font-size: 0.6875rem; //11px\r\n}\r\n.fs-base {\r\n  font-size: 0.875rem; //14px\r\n}\r\n.fs-lg {\r\n  font-size: 1.125rem; //18px\r\n}\r\n\r\n// (1px-30px are linear, above 30px are step increment of 1)\r\n.fs-1 {\r\n  font-size: 0.0625rem; //1px\r\n}\r\n.fs-2 {\r\n  font-size: 0.125rem; //2px\r\n}\r\n.fs-3 {\r\n  font-size: 0.1875rem; //3px\r\n}\r\n.fs-4 {\r\n  font-size: 0.25rem; //4px\r\n}\r\n.fs-5 {\r\n  font-size: 0.3125rem; //5px\r\n}\r\n.fs-6 {\r\n  font-size: 0.375rem; //6px\r\n}\r\n.fs-7 {\r\n  font-size: 0.4375rem; //7px\r\n}\r\n.fs-8 {\r\n  font-size: 0.5rem; //8px\r\n}\r\n.fs-9 {\r\n  font-size: 0.5625rem; //9px\r\n}\r\n.fs-10 {\r\n  font-size: 0.625rem; //10px\r\n}\r\n.fs-11 {\r\n  font-size: 0.6875rem; //11px\r\n}\r\n.fs-12 {\r\n  font-size: 0.75rem; //12px\r\n}\r\n.fs-13 {\r\n  font-size: 0.8125rem; //13px\r\n}\r\n.fs-14 {\r\n  font-size: 0.875rem; //14px\r\n}\r\n.fs-15 {\r\n  font-size: 0.9375rem; //15px\r\n}\r\n.fs-16 {\r\n  font-size: 1rem; //16px\r\n}\r\n.fs-17 {\r\n  font-size: 1.0625rem; //17px\r\n}\r\n.fs-18 {\r\n  font-size: 1.125rem; //18px\r\n}\r\n.fs-19 {\r\n  font-size: 1.1875rem; //19px\r\n}\r\n.fs-20 {\r\n  font-size: 1.25rem; //20px\r\n}\r\n.fs-21 {\r\n  font-size: 1.3125rem; //21px\r\n}\r\n.fs-22 {\r\n  font-size: 1.375rem; //22px\r\n}\r\n.fs-23 {\r\n  font-size: 1.4375rem; //23px\r\n}\r\n.fs-24 {\r\n  font-size: 1.5rem; //24px\r\n}\r\n.fs-25 {\r\n  font-size: 1.5625rem; //25px\r\n}\r\n.fs-26 {\r\n  font-size: 1.625rem; //26px\r\n}\r\n.fs-27 {\r\n  font-size: 1.6875rem; //27px\r\n}\r\n.fs-28 {\r\n  font-size: 1.75rem; //28px\r\n  @include respond-below(custom575) {\r\n    font-size: 1.25rem;\r\n  }\r\n}\r\n.fs-29 {\r\n  font-size: 1.8125rem; //29px\r\n \r\n}\r\n.fs-30 {\r\n  font-size: 1.875rem; //30px\r\n}\r\n.fs-32 {\r\n  font-size: 2rem; //32px\r\n}\r\n.fs-34 {\r\n  font-size: 2.125rem; //34px\r\n}\r\n.fs-36 {\r\n  font-size: 2.25rem; //36px\r\n}\r\n.fs-38 {\r\n  font-size: 2.375rem; //38px\r\n}\r\n.fs-40 {\r\n  font-size: 2.5rem; //40px\r\n}\r\n.fs-60 {\r\n  font-size: 3.75rem; //60px\r\n  @include respond-below(custom991) {\r\n    font-size: 2.125rem;\r\n  }\r\n  @include respond-below(custom575) {\r\n    font-size: 1.125rem;\r\n  }\r\n}\r\n.text-default {\r\n  color: $text-color !important;\r\n}\r\n.text-muted {\r\n  color: $text-muted !important;\r\n}\r\n.text-primary {\r\n  color: $primary !important;\r\n  opacity: 1;\r\n  &.text-opacity-75 {\r\n    color: rgba($primary, 0.75) !important;\r\n  }\r\n  &.text-opacity-25 {\r\n    color: rgba($primary, 0.25) !important;\r\n  }\r\n  &.text-opacity-50 {\r\n    color: rgba($primary, 0.50) !important;\r\n  }\r\n}\r\n.text-secondary {\r\n  color: $secondary !important;\r\n  opacity: 1;\r\n}\r\n.text-info {\r\n  color: $info !important;\r\n  opacity: 1;\r\n}\r\n.text-success {\r\n  color: $success !important;\r\n  opacity: 1;\r\n}\r\n.text-warning {\r\n  color: $warning !important;\r\n  opacity: 1;\r\n}\r\n.text-danger {\r\n  color: $danger !important;\r\n  opacity: 1;\r\n}\r\n.text-blue {\r\n  color: $blue !important;\r\n}\r\n.text-green {\r\n  color: $green !important;\r\n}\r\n.text-pink {\r\n  color: $pink !important;\r\n}\r\n.text-teal {\r\n  color: $teal !important;\r\n}\r\n.text-orange {\r\n  color: $orange !important;\r\n}\r\n.text-indigo {\r\n  color: $indigo !important;\r\n}\r\n.text-purple {\r\n  color: $purple !important;\r\n}\r\n.text-dark {\r\n  color: $dark !important;\r\n}\r\n.text-light {\r\n  color: $light !important;\r\n}\r\n.text-gray {\r\n  color: $gray-500 !important;\r\n}\r\n.text-black {\r\n  color: $black !important;\r\n}\r\n.text-white {\r\n  color: $white !important;\r\n}\r\n.text-fixed-white {\r\n  color: $white !important;\r\n}\r\n.text-fixed-black {\r\n  color: $black !important;\r\n}\r\n.text-gray-1 {\r\n  color: $gray-100;\r\n}\r\n.text-gray-2 {\r\n  color: $gray-200;\r\n}\r\n.text-gray-3 {\r\n  color: $gray-300;\r\n}\r\n.text-gray-4 {\r\n  color: $gray-400;\r\n}\r\n.text-gray-5 {\r\n  color: $gray-500;\r\n}\r\n.text-gray-6 {\r\n  color: $gray-600;\r\n}\r\n.text-gray-7 {\r\n  color: $gray-700;\r\n}\r\n.text-gray-8 {\r\n  color: $gray-800;\r\n}\r\n.text-gray-9 {\r\n  color: $gray-900;\r\n}\r\na {\r\n  color: $gray-900;\r\n  cursor: pointer;\r\n  text-decoration: none;\r\n  @include transition(all 0.5s ease);\r\n  &:hover {\r\n    color: $primary;\r\n    @include transition(all 0.5s ease);\r\n  }\r\n  &:focus {\r\n    outline: 0;\r\n  }\r\n}\r\n.link-primary {\r\n  color: $primary !important;\r\n  &:hover,\r\n  &:focus,\r\n  &:active {\r\n    color: $primary !important;\r\n  }\r\n}\r\n.link-secondary {\r\n  color: $secondary !important;\r\n  &:hover,\r\n  &:focus,\r\n  &:active {\r\n    color: $secondary !important;\r\n  }\r\n}\r\n.link-success {\r\n  color: $success !important;\r\n  &:hover,\r\n  &:focus,\r\n  &:active {\r\n    color: $success !important;\r\n  }\r\n}\r\n.link-danger {\r\n  color: $danger !important;\r\n  &:hover,\r\n  &:focus,\r\n  &:active {\r\n    color: $danger !important;\r\n  }\r\n}\r\n.link-warning {\r\n  color: $warning !important;\r\n  &:hover,\r\n  &:focus,\r\n  &:active {\r\n    color: $warning !important;\r\n  }\r\n}\r\n.link-info {\r\n  color: $info !important;\r\n  &:hover,\r\n  &:focus,\r\n  &:active {\r\n    color: $info !important;\r\n  }\r\n}\r\n.link-light {\r\n  color: $light !important;\r\n  &:hover,\r\n  &:focus,\r\n  &:active {\r\n    color: $light !important;\r\n  }\r\n}\r\n.link-dark {\r\n  color: $dark !important;\r\n  &:hover,\r\n  &:focus,\r\n  &:active {\r\n    color: $dark !important;\r\n  }\r\n}\r\nhr {\r\n  &.text-danger {\r\n    border-color: $danger !important;\r\n  }\r\n}\r\n\r\n.text-purple {\r\n  color: $purple !important;\r\n}\r\n.blockquote-container {\r\n  padding: 1.25rem;\r\n  border-left: 4px solid $default-border;\r\n  position: relative;\r\n  &.text-end {\r\n    border-right: 4px solid $default-border;\r\n    border-left: 0;\r\n  }\r\n}\r\n.blockquote.custom-blockquote {\r\n  font-size: 0.85rem;\r\n  font-weight: $font-weight-semibold;\r\n  padding: 1rem;\r\n  border-radius: $border-radius;\r\n  position: relative;\r\n  &:before {\r\n    content: \"\\f10d\";\r\n    font-family: $font-awesome;\r\n    z-index: 0;\r\n    font-size: 2rem;\r\n    position: absolute;\r\n    inset-block-start: 0;\r\n    inset-inline-start: 0.5rem;\r\n  }\r\n  &.primary {\r\n    background-color: rgba($primary, 0.1);\r\n    border-inline-start: 2px solid $primary;\r\n    &:before {\r\n      color: rgba($primary, 0.1);\r\n    }\r\n  }\r\n  &.secondary {\r\n    background-color: rgba($secondary, 0.1);\r\n    border-inline-start: 2px solid $secondary;\r\n    &:before {\r\n      color: rgba($secondary, 0.1);\r\n    }\r\n  }\r\n  &.info {\r\n    background-color: rgba($info, 0.1);\r\n    border-inline-start: 2px solid $info;\r\n    &:before {\r\n      color: rgba($info, 0.1);\r\n    }\r\n  }\r\n  &.warning {\r\n    background-color: rgba($warning, 0.1);\r\n    border-inline-start: 2px solid $warning;\r\n    &:before {\r\n      color: rgba($warning, 0.1);\r\n    }\r\n  }\r\n  &.success {\r\n    background-color: rgba($success, 0.1);\r\n    border-inline-start: 2px solid $success;\r\n    &:before {\r\n      color: rgba($success, 0.1);\r\n    }\r\n  }\r\n  &.danger {\r\n    background-color: rgba($danger, 0.1);\r\n    border-inline-start: 2px solid $danger;\r\n    &:before {\r\n      color: rgba($danger, 0.1);\r\n    }\r\n  }\r\n}\r\n\r\n[data-theme-mode=\"dark\"] {\r\n  .shadow-sm {\r\n    box-shadow: 0 0.125rem 0.25rem rgba(33, 37, 41, 0.3) !important;\r\n  }\r\n  .shadow {\r\n    box-shadow: 0 0.5rem 1rem rgba(33, 37, 41, 0.3) !important;\r\n  }\r\n  .shadow-lg {\r\n    box-shadow: 0 1rem 3rem rgba(33, 37, 41, 0.3) !important;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 576px) {\r\n  .w-sm-auto {\r\n    width: auto;\r\n  }\r\n}\r\n\r\n[dir=\"rtl\"] {\r\n  .text-break {\r\n    word-wrap: break-word !important;\r\n    word-break: break-word !important;\r\n  }\r\n}\r\n.transform-none {\r\n  transform: none !important;\r\n}\r\n.w-9 {\r\n  width: 9px;\r\n}\r\n.h-9 {\r\n  height: 9px;\r\n}\r\n.list-circle {\r\n    list-style: circle;\r\n    padding-left: 2rem;\r\n}\r\n",".alert {\r\n  padding: 0.625rem 0.85rem;\r\n  border-radius: $border-radius;\r\n  font-size: 0.8125rem;\r\n  &.alert-dismissible {\r\n    padding: 0.625rem 2.25rem 0.625rem 0.85rem;\r\n  }\r\n  i {\r\n    font-size: $font-size-20;\r\n  }\r\n  .btn-close {\r\n    background-image: none;\r\n    padding: 0.85rem;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    i {\r\n      font-size: $font-size-18;\r\n      line-height: 18px;\r\n    }\r\n  }\r\n  &:last-child {\r\n    margin-bottom: 0;\r\n  }\r\n  .alert-link {\r\n    font-weight: $font-weight-semibold;\r\n  }\r\n}\r\n[dir=\"rtl\"] {\r\n  .alert.alert-dismissible {\r\n    padding: 0.625rem 0.85rem 0.625rem 2.25rem;\r\n  }\r\n}\r\n@mixin custom-close($color) {\r\n  background-color: $color;\r\n  color: $white;\r\n  opacity: 1;\r\n  border-radius: 50px;\r\n  box-shadow: $box-shadow;\r\n  padding: 0.85rem;\r\n}\r\n.alert-warning {\r\n  background-color: rgba($warning, 0.1);\r\n  color: $warning;\r\n  border-color: rgba($warning, 0.1);\r\n  .alert-link {\r\n    color: $warning;\r\n  }\r\n  .btn-close {\r\n    color: $warning;\r\n    &.custom-close {\r\n      @include custom-close($warning);\r\n    }\r\n  }\r\n}\r\n.alert-primary {\r\n  background-color: rgba($primary, 0.1);\r\n  color: $primary;\r\n  border-color: rgba($primary, 0.1);\r\n  .alert-link {\r\n    color: $primary;\r\n  }\r\n  .custom-alert-icon {\t\r\n\tcolor: $primary;\r\n  }\r\n  .btn-close {\r\n    color: $primary;\r\n    &.custom-close {\r\n      @include custom-close($primary);\r\n    }\r\n  }\r\n}\r\n.alert-secondary {\r\n  background-color: rgba($secondary, 0.1);\r\n  color: $secondary;\r\n  border-color: rgba($secondary, 0.1);\r\n  .alert-link {\r\n    color: $secondary;\r\n  }\r\n  .btn-close {\r\n    color: $secondary;\r\n    &.custom-close {\r\n      @include custom-close($secondary);\r\n    }\r\n  }\r\n}\r\n.alert-success {\r\n  background-color: rgba($success, 0.1);\r\n  color: $success;\r\n  border-color: rgba($success, 0.1);\r\n  .alert-link {\r\n    color: $success;\r\n  }\r\n  .btn-close {\r\n    color: $success;\r\n    &.custom-close {\r\n      @include custom-close($success);\r\n    }\r\n  }\r\n}\r\n.alert-info {\r\n  background-color: rgba($info, 0.1);\r\n  color: $info;\r\n  border-color: rgba($info, 0.1);\r\n  .alert-link {\r\n    color: $info;\r\n  }\r\n  .btn-close {\r\n    color: $info;\r\n    &.custom-close {\r\n      @include custom-close($info);\r\n    }\r\n  }\r\n}\r\n.alert-danger {\r\n  background-color: rgba($danger, 0.1);\r\n  color: $danger;\r\n  border-color: rgba($danger, 0.1);\r\n  .alert-link {\r\n    color: $danger;\r\n  }\r\n  .btn-close {\r\n    color: $danger;\r\n    &.custom-close {\r\n      @include custom-close($danger);\r\n    }\r\n  }\r\n}\r\n.alert-light {\r\n  background-color: $light;\r\n  color: $text-color;\r\n  border-color: $light;\r\n  .alert-link {\r\n    color: $text-color;\r\n  }\r\n  .btn-close {\r\n    color: $text-color;\r\n    &.custom-close {\r\n      @include custom-close($light);\r\n    }\r\n  }\r\n}\r\n.alert-dark {\r\n  background-color: rgba($dark, 0.1);\r\n  color: $text-color;\r\n  border-color: rgba($dark, 0.1);\r\n  .alert-link {\r\n    color: $text-color;\r\n  }\r\n  .btn-close {\r\n    color: $white;\r\n    &.custom-close {\r\n      @include custom-close($dark);\r\n    }\r\n  }\r\n}\r\n@mixin alert-solid-color($color) {\r\n  background-color: $color;\r\n  color: $white;\r\n  border-color: $color;\r\n  .btn-close {\r\n    color: $white;\r\n  }\r\n}\r\n.alert-solid-primary {\r\n  @include alert-solid-color($primary);\r\n}\r\n.alert-solid-secondary {\r\n  @include alert-solid-color($secondary);\r\n}\r\n.alert-solid-warning {\r\n  @include alert-solid-color($warning);\r\n}\r\n.alert-solid-info {\r\n  @include alert-solid-color($info);\r\n}\r\n.alert-solid-success {\r\n  @include alert-solid-color($success);\r\n}\r\n.alert-solid-danger {\r\n  @include alert-solid-color($danger);\r\n}\r\n.alert-solid-light {\r\n  background-color: $light;\r\n  color: $text-color;\r\n  border-color: $default-border;\r\n}\r\n.alert-solid-dark {\r\n  @include alert-solid-color($dark);\r\n}\r\n@mixin outline-alert($color) {\r\n  background-color: $white;\r\n  color: $color;\r\n  border-color: $color;\r\n  .btn-close {\r\n    color: $color;\r\n  }\r\n}\r\n.alert-outline-primary {\r\n  @include outline-alert($primary);\r\n}\r\n.alert-outline-secondary {\r\n  @include outline-alert($secondary);\r\n}\r\n.alert-outline-info {\r\n  @include outline-alert($info);\r\n}\r\n.alert-outline-warning {\r\n  @include outline-alert($warning);\r\n}\r\n.alert-outline-success {\r\n  @include outline-alert($success);\r\n}\r\n.alert-outline-danger {\r\n  @include outline-alert($danger);\r\n}\r\n.alert-outline-light {\r\n  background-color: $white;\r\n  color: $text-color;\r\n  border-color: $light;\r\n}\r\n.alert-outline-dark {\r\n  @include outline-alert($dark);\r\n}\r\n@mixin custom-alert($color) {\r\n  border-inline-start: 0.313rem solid $color !important;\r\n  color: $text-muted;\r\n  background-color: $white;\r\n  border: 1px solid $default-border;\r\n  font-size: 0.813rem;\r\n  .btn-close {\r\n    color: $text-color;\r\n  }\r\n}\r\n.alert-primary.custom-alert-icon {\r\n  @include custom-alert($primary);\r\n  & > i {\r\n\tcolor: $primary;\r\n  }\r\n}\r\n.alert-secondary.custom-alert-icon {\r\n  @include custom-alert($secondary);\r\n  & > i {\r\n\tcolor: $secondary;\r\n  }\r\n}\r\n.alert-warning.custom-alert-icon {\r\n  @include custom-alert($warning);\r\n  & > i {\r\n\tcolor: $warning;\r\n  }\r\n}\r\n.alert-danger.custom-alert-icon {\r\n  @include custom-alert($danger);\r\n  & > i {\r\n\tcolor: $danger;\r\n  }\r\n}\r\n.alert-success.custom-alert-icon {\r\n  @include custom-alert($success);\r\n}\r\n.alert-info.custom-alert-icon {\r\n  @include custom-alert($info);\r\n}\r\n.alert-light.custom-alert-icon {\r\n  @include custom-alert($light);\r\n}\r\n.alert-dark.custom-alert-icon {\r\n  @include custom-alert($dark);\r\n}\r\n.custom-alert1 {\r\n  margin-block-end: 0;\r\n  background-color: $white;\r\n  border: 0;\r\n  padding: 1.25rem;\r\n  color: $text-color;\r\n  p {\r\n    margin-block-end: 2.5rem;\r\n    color: $text-muted;\r\n    font-size: 0.8rem;\r\n  }\r\n  .custom-alert-icon {\r\n\tfont-size: $font-size-40;\r\n    margin-bottom: 0.85rem;\r\n\ti {\t\t\r\n\t\tfont-size: $font-size-40;\r\n\t}\r\n  }\r\n  .btn-close {\r\n    padding: 0;\r\n    margin-block-end: 1rem;\r\n  }\r\n  &.alert-primary {\r\n    border-block-start: 0.313rem solid $primary;\t\r\n\t.custom-alert-icon {\t\r\n\t\tcolor: $primary;\r\n\t}\r\n  }\r\n  &.alert-secondary {\r\n    border-block-start: 0.313rem solid $secondary;\t\r\n\t.custom-alert-icon {\t\r\n\t\tcolor: $secondary;\r\n\t}\r\n  }\r\n  &.alert-warning {\r\n    border-block-start: 0.313rem solid $warning;\t\r\n\t.custom-alert-icon {\t\r\n\t\tcolor: $warning;\r\n\t}\r\n  }\r\n  &.alert-danger {\r\n    border-block-start: 0.313rem solid $danger;\t\r\n\t.custom-alert-icon {\t\r\n\t\tcolor: $danger;\r\n\t}\r\n  }\r\n}\r\n.alert-img {\r\n  display: flex;\r\n  align-items: center;\r\n  .avatar {\r\n    border: 1px solid rgba(0, 0, 0, 0.1);\r\n  }\r\n}\r\n@media screen and (max-width: 400px) {\r\n  .btn-close.custom-close {\r\n    margin: 9px 9px 9px 0;\r\n  }\r\n}\r\n.op-1-1 {\r\n    opacity: 1;\r\n}\r\n.op-0 {\r\n    opacity: 0;\r\n}\r\n.op-1 {\r\n    opacity: 0.1;\r\n}\r\n.op-2 {\r\n    opacity: 0.2;\r\n}\r\n.op-3 {\r\n    opacity: 0.3;\r\n}\r\n.op-4 {\r\n    opacity: 0.4;\r\n}\r\n.op-5 {\r\n    opacity: 0.5;\r\n}\r\n.op-6 {\r\n    opacity: 0.6;\r\n}\r\n.op-7 {\r\n    opacity: 0.7;\r\n}\r\n.op-8 {\r\n    opacity: 0.8;\r\n}\r\n.op-9 {\r\n    opacity: 0.9;\r\n}\r\n",".custom-popover {\r\n  --bs-popover-max-width: 12.5rem;\r\n  --bs-popover-border-color: #{$primary};\r\n  --bs-popover-header-bg: #{$primary};\r\n  --bs-popover-header-color: #{$white};\r\n  --bs-popover-body-padding-x: 1rem;\r\n  --bs-popover-body-padding-y: 0.5rem;\r\n}\r\n.popover {\r\n  background-color: $white;\r\n  border: 1px solid $default-border;\r\n  box-shadow: $box-shadow;\r\n  font-size: 0.8rem;\r\n  border-radius: $border-radius;\r\n  z-index: 999;\r\n  .popover-header {\r\n    background-color: $white;\r\n    border-block-end: 1px solid $default-border;\r\n  }\r\n  .popover-body {\r\n    color: $text-color;\r\n  }\r\n  &.only-body {\r\n    border-radius: 0.3rem;\r\n  }\r\n}\r\n.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\r\n.bs-popover-top > .popover-arrow::after,\r\n.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\r\n.bs-popover-top > .popover-arrow::before {\r\n  border-top-color: $light;\r\n}\r\n.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\r\n.bs-popover-end > .popover-arrow::after,\r\n.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\r\n.bs-popover-end > .popover-arrow::before {\r\n  border-right-color: $light;\r\n}\r\n.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\r\n.bs-popover-start > .popover-arrow::after,\r\n.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\r\n.bs-popover-start > .popover-arrow::before {\r\n  border-left-color: $light;\r\n}\r\n.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\r\n.bs-popover-bottom > .popover-arrow::after,\r\n.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\r\n.bs-popover-bottom > .popover-arrow::before,\r\n.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\r\n.bs-popover-bottom .popover-header::before {\r\n  border-bottom-color: $light;\r\n}\r\n\r\n@mixin pop-header-color($color) {\r\n  .popover-header {\r\n    background-color: $color;\r\n    color: $white;\r\n  }\r\n  &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\r\n  &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before {\r\n    border-bottom-color: $color;\r\n  }\r\n}\r\n.header-primary {\r\n  @include pop-header-color($primary);\r\n}\r\n.header-secondary {\r\n  @include pop-header-color($secondary);\r\n}\r\n.header-warning {\r\n  @include pop-header-color($warning);\r\n}\r\n.header-info {\r\n  @include pop-header-color($info);\r\n}\r\n.header-success {\r\n  @include pop-header-color($success);\r\n}\r\n.header-danger {\r\n  @include pop-header-color($danger);\r\n}\r\n@mixin pop-bgcolor($color) {\r\n  &.popover {\r\n      border: 1px solid $color;\r\n    .popover-header {\r\n      background-color: $color;\r\n      border-block-end: 1px solid rgba(255, 255, 255, 0.1);\r\n      color: $white;\r\n      border-radius: 0.3rem 0.3rem 0 0;\r\n    }\r\n    .popover-body {\r\n      background-color: $color;\r\n      color: $white;\r\n      border-radius: 0 0 0.3rem 0.3rem;\r\n    }\r\n  }\r\n  &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\r\n  &.bs-popover-top > .popover-arrow::after,\r\n  &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\r\n  &.bs-popover-top > .popover-arrow::before {\r\n    border-top-color: $color;\r\n  }\r\n  &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\r\n  &.bs-popover-end > .popover-arrow::after,\r\n  &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\r\n  &.bs-popover-end > .popover-arrow::before {\r\n    border-right-color: $color;\r\n  }\r\n  &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\r\n  &.bs-popover-start > .popover-arrow::after,\r\n  &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\r\n  &.bs-popover-start > .popover-arrow::before {\r\n    border-left-color: $color;\r\n  }\r\n  &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\r\n  &.bs-popover-bottom > .popover-arrow::after,\r\n  &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\r\n  &.bs-popover-bottom > .popover-arrow::before,\r\n  &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\r\n  &.bs-popover-bottom .popover-header::before {\r\n    border-bottom-color: $color;\r\n  }\r\n}\r\n.popover-primary {\r\n  @include pop-bgcolor($primary);\r\n}\r\n.popover-secondary {\r\n  @include pop-bgcolor($secondary);\r\n}\r\n.popover-warning {\r\n  @include pop-bgcolor($warning);\r\n}\r\n.popover-info {\r\n  @include pop-bgcolor($info);\r\n}\r\n.popover-success {\r\n  @include pop-bgcolor($success);\r\n}\r\n.popover-danger {\r\n  @include pop-bgcolor($danger);\r\n}\r\n.popover-purple {\r\n  @include pop-bgcolor($purple);\r\n}\r\n.popover-teal {\r\n  @include pop-bgcolor($teal);\r\n}\r\n\r\n.popover-primary-light {\r\n    &.popover {\r\n        border: 1px solid rgba($primary, 0.1);\r\n      .popover-header {\r\n        background-color: rgba($primary, 0.1);\r\n        border-block-end: 1px solid rgba($primary, 0.1);\r\n        color: $primary;\r\n        border-radius: 0;\r\n      }\r\n      .popover-body {\r\n        background-color: rgba($primary, 0.1);\r\n        color: $primary;\r\n      }\r\n    }\r\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\r\n    &.bs-popover-top > .popover-arrow::after,\r\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\r\n    &.bs-popover-top > .popover-arrow::before {\r\n      border-top-color: rgba($primary, 0.1);\r\n    }\r\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\r\n    &.bs-popover-end > .popover-arrow::after,\r\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\r\n    &.bs-popover-end > .popover-arrow::before {\r\n      border-right-color: rgba($primary, 0.1);\r\n    }\r\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\r\n    &.bs-popover-start > .popover-arrow::after,\r\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\r\n    &.bs-popover-start > .popover-arrow::before {\r\n      border-left-color: rgba($primary, 0.1);\r\n    }\r\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\r\n    &.bs-popover-bottom > .popover-arrow::after,\r\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\r\n    &.bs-popover-bottom > .popover-arrow::before,\r\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\r\n    &.bs-popover-bottom .popover-header::before {\r\n      border-bottom-color: rgba($primary, 0.1);\r\n    }\r\n}\r\n.popover-secondary-light {\r\n    &.popover {\r\n        border: 1px solid rgba($secondary,0.1);\r\n      .popover-header {\r\n        background-color: rgba($secondary,0.1);\r\n        border-block-end: 1px solid rgba($secondary,0.1);\r\n        color: $secondary;\r\n        border-radius: 0;\r\n      }\r\n      .popover-body {\r\n        background-color: rgba($secondary,0.1);\r\n        color: $secondary;\r\n      }\r\n    }\r\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\r\n    &.bs-popover-top > .popover-arrow::after,\r\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\r\n    &.bs-popover-top > .popover-arrow::before {\r\n      border-top-color: rgba(var(--secondary-rgb),0.1);\r\n    }\r\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\r\n    &.bs-popover-end > .popover-arrow::after,\r\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\r\n    &.bs-popover-end > .popover-arrow::before {\r\n      border-right-color: rgba($secondary,0.1);\r\n    }\r\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\r\n    &.bs-popover-start > .popover-arrow::after,\r\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\r\n    &.bs-popover-start > .popover-arrow::before {\r\n      border-left-color: rgba(var(--secondary-rgb),0.1);\r\n    }\r\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\r\n    &.bs-popover-bottom > .popover-arrow::after,\r\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\r\n    &.bs-popover-bottom > .popover-arrow::before,\r\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\r\n    &.bs-popover-bottom .popover-header::before {\r\n      border-bottom-color: rgba(var(--secondary-rgb),0.1);\r\n    }\r\n}\r\n.popover-warning-light {\r\n    &.popover {\r\n        border: 1px solid rgba($warning,0.1);\r\n      .popover-header {\r\n        background-color: rgba($warning,0.1);\r\n        border-block-end: 1px solid rgba($warning,0.1);\r\n        color: $warning;\r\n        border-radius: 0;\r\n      }\r\n      .popover-body {\r\n        background-color: rgba($warning,0.1);\r\n        color: $warning;\r\n      }\r\n    }\r\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\r\n    &.bs-popover-top > .popover-arrow::after,\r\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\r\n    &.bs-popover-top > .popover-arrow::before {\r\n      border-top-color: rgba($warning,0.1);\r\n    }\r\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\r\n    &.bs-popover-end > .popover-arrow::after,\r\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\r\n    &.bs-popover-end > .popover-arrow::before {\r\n      border-right-color: rgba($warning,0.1);\r\n    }\r\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\r\n    &.bs-popover-start > .popover-arrow::after,\r\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\r\n    &.bs-popover-start > .popover-arrow::before {\r\n      border-left-color: rgba($warning,0.1);\r\n    }\r\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\r\n    &.bs-popover-bottom > .popover-arrow::after,\r\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\r\n    &.bs-popover-bottom > .popover-arrow::before,\r\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\r\n    &.bs-popover-bottom .popover-header::before {\r\n      border-bottom-color: rgba($warning,0.1);\r\n    }\r\n}\r\n.popover-info-light {\r\n    &.popover {\r\n        border: 1px solid rgba($info,0.1);\r\n      .popover-header {\r\n        background-color: rgba($info,0.1);\r\n        border-block-end: 1px solid rgba($info,0.1);\r\n        color: $info;\r\n        border-radius: 0;\r\n      }\r\n      .popover-body {\r\n        background-color: rgba($info,0.1);\r\n        color: $info;\r\n      }\r\n    }\r\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\r\n    &.bs-popover-top > .popover-arrow::after,\r\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\r\n    &.bs-popover-top > .popover-arrow::before {\r\n      border-top-color: rgba($info,0.1);\r\n    }\r\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\r\n    &.bs-popover-end > .popover-arrow::after,\r\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\r\n    &.bs-popover-end > .popover-arrow::before {\r\n      border-right-color: rgba($info,0.1);\r\n    }\r\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\r\n    &.bs-popover-start > .popover-arrow::after,\r\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\r\n    &.bs-popover-start > .popover-arrow::before {\r\n      border-left-color: rgba($info,0.1);\r\n    }\r\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\r\n    &.bs-popover-bottom > .popover-arrow::after,\r\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\r\n    &.bs-popover-bottom > .popover-arrow::before,\r\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\r\n    &.bs-popover-bottom .popover-header::before {\r\n      border-bottom-color: rgba($info,0.1);\r\n    }\r\n}\r\n.popover-success-light {\r\n    &.popover {\r\n        border: 1px solid rgba($success,0.1);\r\n      .popover-header {\r\n        background-color: rgba($success,0.1);\r\n        border-block-end: 1px solid rgba($success,0.1);\r\n        color: $success;\r\n        border-radius: 0;\r\n      }\r\n      .popover-body {\r\n        background-color: rgba($success,0.1);\r\n        color: $success;\r\n      }\r\n    }\r\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\r\n    &.bs-popover-top > .popover-arrow::after,\r\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\r\n    &.bs-popover-top > .popover-arrow::before {\r\n      border-top-color: rgba($success,0.1);\r\n    }\r\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\r\n    &.bs-popover-end > .popover-arrow::after,\r\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\r\n    &.bs-popover-end > .popover-arrow::before {\r\n      border-right-color: rgba($success,0.1);\r\n    }\r\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\r\n    &.bs-popover-start > .popover-arrow::after,\r\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\r\n    &.bs-popover-start > .popover-arrow::before {\r\n      border-left-color: rgba($success,0.1);\r\n    }\r\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\r\n    &.bs-popover-bottom > .popover-arrow::after,\r\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\r\n    &.bs-popover-bottom > .popover-arrow::before,\r\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\r\n    &.bs-popover-bottom .popover-header::before {\r\n      border-bottom-color: rgba($success,0.1);\r\n    }\r\n}\r\n.popover-danger-light {\r\n    &.popover {\r\n        border: 1px solid rgba($danger,0.1);\r\n      .popover-header {\r\n        background-color: rgba($danger,0.1);\r\n        border-block-end: 1px solid rgba($danger,0.1);\r\n        color: $danger;\r\n        border-radius: 0;\r\n      }\r\n      .popover-body {\r\n        background-color: rgba($danger,0.1);\r\n        color: $danger;\r\n      }\r\n    }\r\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\r\n    &.bs-popover-top > .popover-arrow::after,\r\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\r\n    &.bs-popover-top > .popover-arrow::before {\r\n      border-top-color: rgba($danger,0.1);\r\n    }\r\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\r\n    &.bs-popover-end > .popover-arrow::after,\r\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\r\n    &.bs-popover-end > .popover-arrow::before {\r\n      border-right-color: rgba($danger,0.1);\r\n    }\r\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\r\n    &.bs-popover-start > .popover-arrow::after,\r\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\r\n    &.bs-popover-start > .popover-arrow::before {\r\n      border-left-color: rgba($danger,0.1);\r\n    }\r\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\r\n    &.bs-popover-bottom > .popover-arrow::after,\r\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\r\n    &.bs-popover-bottom > .popover-arrow::before,\r\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\r\n    &.bs-popover-bottom .popover-header::before {\r\n      border-bottom-color: rgba($danger,0.1);\r\n    }\r\n}\r\n.popover-purple-light {\r\n    &.popover {\r\n        border: 1px solid rgba(var(--purple-rgb),0.1);\r\n      .popover-header {\r\n        background-color: rgba(var(--purple-rgb),0.1);\r\n        border-block-end: 1px solid rgba(var(--purple-rgb),0.1);\r\n        color: $purple;\r\n        border-radius: 0;\r\n      }\r\n      .popover-body {\r\n        background-color: rgba(var(--purple-rgb),0.1);\r\n        color: $purple;\r\n      }\r\n    }\r\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\r\n    &.bs-popover-top > .popover-arrow::after,\r\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\r\n    &.bs-popover-top > .popover-arrow::before {\r\n      border-top-color: rgba(var(--purple-rgb),0.1);\r\n    }\r\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\r\n    &.bs-popover-end > .popover-arrow::after,\r\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\r\n    &.bs-popover-end > .popover-arrow::before {\r\n      border-right-color: rgba(var(--purple-rgb),0.1);\r\n    }\r\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\r\n    &.bs-popover-start > .popover-arrow::after,\r\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\r\n    &.bs-popover-start > .popover-arrow::before {\r\n      border-left-color: rgba(var(--purple-rgb),0.1);\r\n    }\r\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\r\n    &.bs-popover-bottom > .popover-arrow::after,\r\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\r\n    &.bs-popover-bottom > .popover-arrow::before,\r\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\r\n    &.bs-popover-bottom .popover-header::before {\r\n      border-bottom-color: rgba(var(--purple-rgb),0.1);\r\n    }\r\n}\r\n.popover-teal-light {\r\n    &.popover {\r\n        border: 1px solid rgba(var(--teal-rgb),0.1);\r\n      .popover-header {\r\n        background-color: rgba(var(--teal-rgb),0.1);\r\n        border-block-end: 1px solid rgba(var(--teal-rgb),0.1);\r\n        color: $teal;\r\n        border-radius: 0;\r\n      }\r\n      .popover-body {\r\n        background-color: rgba(var(--teal-rgb),0.1);\r\n        color: $teal;\r\n      }\r\n    }\r\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\r\n    &.bs-popover-top > .popover-arrow::after,\r\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\r\n    &.bs-popover-top > .popover-arrow::before {\r\n      border-top-color: rgba(var(--teal-rgb),0.1);\r\n    }\r\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\r\n    &.bs-popover-end > .popover-arrow::after,\r\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\r\n    &.bs-popover-end > .popover-arrow::before {\r\n      border-right-color: rgba(var(--teal-rgb),0.1);\r\n    }\r\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\r\n    &.bs-popover-start > .popover-arrow::after,\r\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\r\n    &.bs-popover-start > .popover-arrow::before {\r\n      border-left-color: rgba(var(--teal-rgb),0.1);\r\n    }\r\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\r\n    &.bs-popover-bottom > .popover-arrow::after,\r\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\r\n    &.bs-popover-bottom > .popover-arrow::before,\r\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\r\n    &.bs-popover-bottom .popover-header::before {\r\n      border-bottom-color: rgba(var(--teal-rgb),0.1);\r\n    }\r\n}\r\n.timeline {\r\n    position: relative;\r\n    list-style: none;\r\n    max-width: 1200px;\r\n    @include margin-padding(0 auto, 20px 0 20px);\r\n    &:before {\r\n      content: \" \";\r\n      position: absolute;\r\n      width: 3px;\r\n      margin-left: -1.5px;\r\n      background-color: $gray-300;\r\n        @include position(absolute,0,null,0,50%);\r\n    }\r\n    > li {\r\n      position: relative;\r\n      margin-bottom: 20px;\r\n      &::before, &::after {\r\n          content: \" \";\r\n         display: table;\r\n      }\r\n      >.timeline-panel {\r\n          float: left;\r\n          position: relative;\r\n          width: 46%;\r\n          padding: 20px;\r\n          border: 1px solid $gray-500;\r\n            @include rounded(0.25rem);\r\n            @include box-shadow(null, 0, 1px, 6px, null, rgba(0, 0, 0, .05));\r\n            &::before {\r\n                content: \" \";\r\n                display: inline-block;\r\n                position: absolute;\r\n                border-top: 8px solid transparent;\r\n                border-right: 0 solid $gray-500;\r\n                border-bottom: 8px solid transparent;\r\n                border-left: 8px solid $gray-500;\r\n                  @include position(absolute,26px,-8px,null,null);\r\n              }\r\n              &::after {\r\n                  content: \" \";\r\n                  display: inline-block;\r\n                    @include position(absolute,27px,-7px,null,null);\r\n                  border-top: 7px solid transparent;\r\n                  border-right: 0 solid $white;\r\n                  border-bottom: 7px solid transparent;\r\n                  border-left: 7px solid $white;\r\n                }\r\n        }\r\n    }\r\n}\r\n.timeline > li:after {\r\n  clear: both; \r\n}\r\n.timeline>li>.timeline-badge {\r\n  z-index: 1;\r\n  width: 50px;\r\n  height: 50px;\r\n  margin-left: -25px;\r\n  text-align: center;\r\n  font-size: 1.4em;\r\n  line-height: 50px;\r\n  color: $white;\r\n  overflow: hidden;\r\n    @include rounded(50%);\r\n    @include position(absolute,16px,null,null,50%);\r\n}\r\n.timeline>li.timeline-inverted>.timeline-panel {\r\n  float: right;\r\n  &::before {\r\n      right: auto;\r\n      left: -8px;\r\n      border-right-width: 8px;\r\n      border-left-width: 0;\r\n    }\r\n    &::after {\r\n        right: auto;\r\n        left: -7px;\r\n        border-right-width: 7px;\r\n        border-left-width: 0;\r\n      }\r\n}\r\n.timeline-badge.primary {\r\n  background-color: $primary;\r\n}\r\n.timeline-badge.success {\r\n  background-color: $success;\r\n}\r\n.timeline-badge.warning {\r\n  background-color: $warning; \r\n}\r\n.timeline-badge.danger {\r\n  background-color: $danger; \r\n}\r\n.timeline-badge.info {\r\n  background-color: $info; \r\n}\r\n.timeline-title {\r\n  margin-top: 0;\r\n  color: inherit;\r\n  font-weight: regular; \r\n}\r\n.timeline-body > p,\r\n.timeline-body > ul {\r\n  margin-bottom: 0; \r\n}\r\n.timeline-body > p + p {\r\n  margin-top: 5px; \r\n}\r\n",".form-wrap {\r\n    margin-bottom: 24px;\r\n}\r\n.col-form-label {\r\n    font-size: $font-size-14;\r\n    font-weight: $font-weight-medium;\r\n    color: $title-color;\r\n}\r\n.form-control {\r\n  border-color: $input-border;\r\n  color: $text-color;\r\n  background-color: $form-control-bg;\r\n  font-size: $font-size-14;\r\n  font-weight: $font-weight-normal;\r\n  line-height: 1.6;\r\n  border-radius: 5px;\r\n  padding: 0.5rem 0.85rem;\r\n  box-shadow: 0px 4px 4px 0px #DBDBDB40;\r\n  min-height: 42px;\r\n  &:focus {\r\n    box-shadow: none;\r\n    border-color: $input-border;\r\n    background-color: $white;\r\n    box-shadow: 0 0.0625rem 0.125rem 0 rgba(0, 0, 0, 0.05);\r\n    color: $text-color;\r\n  }\r\n}\r\n.form-control[type=\"file\"] {\r\n  padding: 0.3rem 0.5rem;\r\n  line-height: 2.2;\r\n  &.form-control-sm {\r\n    padding: 0.25rem 0.5rem !important;\r\n  }\r\n  &.form-control-lg {\r\n    padding: 0.5rem 1rem !important;\r\n  }\r\n}\r\n.col-form-label {\r\n    font-size: $font-size-14;\r\n    font-weight: $font-weight-medium;\r\n    color: $title-color;\r\n    @include margin-padding(null, 0 0 5px);\r\n}\r\n.form-label {\r\n  font-size: $font-size-14;\r\n  font-weight: $font-weight-medium;\r\n  color: $title-color;\r\n}\r\n.form-text {\r\n  color: $text-muted;\r\n}\r\n\r\n.form-control-light {\r\n  background-color: $light;\r\n  border: 0;\r\n\r\n  &:focus {\r\n    background-color: $light;\r\n  }\r\n}\r\n.form-control-primary {\r\n  background-color: rgba($primary, 0.1);\r\n  border: 0;\r\n  color: $primary;\r\n\r\n  &:focus {\r\n    background-color: rgba($primary, 0.1);\r\n    color: $primary;\r\n  }\r\n}\r\n.form-input-color {\r\n  height: 2.25rem;\r\n  width: 2.25rem;\r\n  border-radius: $border-radius;\r\n  overflow: hidden;\r\n  padding: 0;\r\n}\r\n.form-floating > .form-control-plaintext ~ label,\r\n.form-floating > .form-control:focus ~ label,\r\n.form-floating > .form-control:not(:placeholder-shown) ~ label,\r\n.form-floating > .form-select ~ label {\r\n  color: $text-muted;\r\n}\r\n.form-floating > .form-control:not(:placeholder-shown) ~ label::after {\r\n  background-color: transparent;\r\n}\r\n.input-group-text {\r\n  box-shadow: 0px 4px 4px 0px #DBDBDB40;\r\n } \r\n.form-select {\r\n  background-color: $form-control-bg;\r\n  border: 1px solid $input-border;\r\n  color: $text-color;\r\n  font-size: $font-size-base;\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e\");\r\n  background-size: 1.25rem;\r\n  line-height: 2;\r\n  box-shadow: 0px 4px 4px 0px #DBDBDB40; \r\n  option {\r\n    background-color: $white;\r\n    padding: 0.35rem 0.75rem;\r\n    border-radius: 0.25rem;\r\n    margin-block-end: 0.25rem;\r\n    &:last-child {\r\n      margin-block-end: 0;\r\n    }\r\n  }\r\n  option:checked {\r\n    background-color: rgba(var($primary), 0.2);\r\n    color: $primary;\r\n  }\r\n  option:select {\r\n    background-color: rgba(var($primary), 0.2);\r\n    color: $primary;\r\n  }\r\n  option:hover {\r\n    background-color: rgba(var($primary), 0.2);\r\n    color: $primary;\r\n  }\r\n  option:focus {\r\n    background-color: rgba(var($primary), 0.2);\r\n    color: $primary;\r\n  }\r\n}\r\n.form-check-input {\r\n  width: 0.9rem;\r\n  height: 0.9rem;\r\n  background-color: $white;\r\n  border: 1px solid $input-border;\r\n  &:checked {\r\n    background-color: $primary;\r\n    border-color: $primary;\r\n  }\r\n  &.form-checked-outline {\r\n    &:checked {\r\n      background-color: transparent;\r\n      border-color: $primary;\r\n    }\r\n  }\r\n  &.form-checked-secondary {\r\n    &:checked {\r\n      background-color: $secondary;\r\n      border-color: $secondary;\r\n    }\r\n  }\r\n  &.form-checked-warning {\r\n    &:checked {\r\n      background-color: $warning;\r\n      border-color: $warning;\r\n    }\r\n  }\r\n  &.form-checked-info {\r\n    &:checked {\r\n      background-color: $info;\r\n      border-color: $info;\r\n    }\r\n  }\r\n  &.form-checked-success {\r\n    &:checked {\r\n      background-color: $success;\r\n      border-color: $success;\r\n    }\r\n  }\r\n  &.form-checked-danger {\r\n    &:checked {\r\n      background-color: $danger;\r\n      border-color: $danger;\r\n    }\r\n  }\r\n  &.form-checked-light {\r\n    &:checked {\r\n      background-color: $light;\r\n      border-color: $light;\r\n    }\r\n  }\r\n  &.form-checked-dark {\r\n    &:checked {\r\n      background-color: $dark;\r\n      border-color: $dark;\r\n    }\r\n  }\r\n  &:focus {\r\n    box-shadow: none;\r\n  }\r\n}\r\n.form-checked-outline:checked[type=\"checkbox\"] {\r\n  background-image: none;\r\n  position: relative;\r\n  background-color: transparent;\r\n\r\n  &:before {\r\n    content: \"\\F633\";\r\n    font-family: bootstrap-icons !important;\r\n    position: absolute;\r\n    color: $primary;\r\n    width: 0.625rem;\r\n    height: 0.625rem;\r\n    inset-block-start: -1px;\r\n    inset-inline-start: 0px;\r\n    font-size: 0.688rem;\r\n  }\r\n\r\n  &.form-checked-secondary {\r\n    &:before {\r\n      color: $secondary;\r\n    }\r\n  }\r\n\r\n  &.form-checked-warning {\r\n    &:before {\r\n      color: $warning;\r\n    }\r\n  }\r\n\r\n  &.form-checked-info {\r\n    &:before {\r\n      color: $info;\r\n    }\r\n  }\r\n\r\n  &.form-checked-success {\r\n    &:before {\r\n      color: $success;\r\n    }\r\n  }\r\n\r\n  &.form-checked-danger {\r\n    &:before {\r\n      color: $danger;\r\n    }\r\n  }\r\n\r\n  &.form-checked-light {\r\n    &:before {\r\n      color: $light;\r\n    }\r\n  }\r\n\r\n  &.form-checked-dark {\r\n    &:before {\r\n      color: $dark;\r\n    }\r\n  }\r\n}\r\n.form-checked-outline:checked[type=\"radio\"] {\r\n  background-image: none;\r\n  position: relative;\r\n  background-color: transparent;\r\n\r\n  &:before {\r\n    content: \"\\F309\";\r\n    font-family: bootstrap-icons !important;\r\n    position: absolute;\r\n    color: $primary;\r\n    width: 0.625rem;\r\n    height: 0.625rem;\r\n    inset-block-start: -1.13rem;\r\n    inset-inline-start: -0.6rem;\r\n    font-size: 2rem;\r\n  }\r\n\r\n  &.form-checked-secondary {\r\n    &:before {\r\n      color: $secondary;\r\n    }\r\n  }\r\n\r\n  &.form-checked-warning {\r\n    &:before {\r\n      color: $warning;\r\n    }\r\n  }\r\n\r\n  &.form-checked-info {\r\n    &:before {\r\n      color: $info;\r\n    }\r\n  }\r\n\r\n  &.form-checked-success {\r\n    &:before {\r\n      color: $success;\r\n    }\r\n  }\r\n\r\n  &.form-checked-danger {\r\n    &:before {\r\n      color: $danger;\r\n    }\r\n  }\r\n\r\n  &.form-checked-light {\r\n    &:before {\r\n      color: $light;\r\n    }\r\n  }\r\n\r\n  &.form-checked-dark {\r\n    &:before {\r\n      color: $dark;\r\n    }\r\n  }\r\n}\r\nfieldset:disabled .btn {\r\n  color: $white;\r\n  background-color: $primary;\r\n  border-color: $primary;\r\n}\r\n.form-select:focus {\r\n  border-color: rgba(var($primary), 0.5);\r\n  outline: 0;\r\n  box-shadow: none;\r\n}\r\n.btn-check:focus + .btn,\r\n.btn:focus {\r\n  background-color: none;\r\n  border-color: none;\r\n  outline: 0;\r\n}\r\n.btn-check:active + .btn:focus,\r\n.btn-check:checked + .btn:focus,\r\n.btn.active:focus,\r\n.btn.show:focus,\r\n.btn:active:focus {\r\n  box-shadow: none;\r\n}\r\n.form-control,\r\n.form-select {\r\n    &:disabled {\r\n      background-color: $light;\r\n      color: $text-color;\r\n  }\r\n}\r\n.form-control-plaintext {\r\n  color: $text-color;\r\n}\r\n.form-control::-webkit-file-upload-button {\r\n  color: $text-color;\r\n  background-color: $default-background;\r\n}\r\n.form-control:hover:not(:disabled):not([readonly])::-webkit-file-upload-button {\r\n  background-color: $default-background;\r\n}\r\n.form-control {\r\n  &:focus {\r\n    &::-webkit-input-placeholder,\r\n    &::placeholder {\r\n      padding-inline-start: 0.3rem;\r\n      transition: padding-inline-start 0.1s ease-in;\r\n    }\r\n  }\r\n  &::-webkit-input-placeholder {\r\n    font-size: 0.8rem;\r\n    font-weight: $font-weight-medium;\r\n    opacity: 0.7;\r\n    color: $text-color;\r\n    padding-inline-start: 0px;\r\n    transition: padding-inline-start 0.1s ease-in;\r\n  }\r\n  &:-moz-placeholder {\r\n    font-size: 0.8rem;\r\n    font-weight: $font-weight-medium;\r\n    opacity: 0.4;\r\n    color: $text-color;\r\n  }\r\n  &::-moz-placeholder {\r\n    font-size: 0.8rem;\r\n    font-weight: $font-weight-medium;\r\n    opacity: 0.4;\r\n    color: $text-color;\r\n  }\r\n  &:-ms-input-placeholder {\r\n    font-size: 0.8rem;\r\n    font-weight: $font-weight-medium;\r\n    opacity: 0.4;\r\n    color: $text-color;\r\n  }\r\n}\r\n.form-control-sm {\r\n  font-size: 0.8rem;\r\n  padding: 0.25rem 0.8rem;\r\n}\r\n.form-control-lg {\r\n  font-size: 1rem;\r\n  padding: 0.5rem 1rem;\r\n}\r\n\r\n.form-check-md {\r\n  .form-check-input {\r\n    width: 1.15rem;\r\n    height: 1.15rem;\r\n  }\r\n\r\n  &.form-switch {\r\n    .form-check-input {\r\n      width: 2.25rem;\r\n    }\r\n  }\r\n\r\n  label {\r\n    margin-inline-start: 0.5rem;\r\n    font-size: 0.95rem;\r\n    margin-block-start: 3px;\r\n  }\r\n}\r\n\r\n.form-check-lg {\r\n  .form-check-input {\r\n    width: 1.35rem;\r\n    height: 1.35rem;\r\n  }\r\n\r\n  &.form-switch {\r\n    .form-check-input {\r\n      width: 2.5rem;\r\n    }\r\n  }\r\n\r\n  label {\r\n    margin-inline-start: 0.5rem;\r\n    font-size: 1rem;\r\n    margin-block-start: 3px;\r\n  }\r\n}\r\n.toggle {\r\n  width: 3.75rem;\r\n  height: 1.563rem;\r\n  background-color: $light;\r\n  margin-inline-start: 0.625rem;\r\n  margin-block-end: 0.313rem;\r\n  padding: 0.125rem;\r\n  border-radius: 0.188rem;\r\n  position: relative;\r\n  overflow: hidden;\r\n  transition: all 0.2s ease;\r\n\r\n  span {\r\n    position: absolute;\r\n    inset-block-start: 0.188rem;\r\n    inset-block-end: 0.25rem;\r\n    inset-inline-start: 0.188rem;\r\n    display: block;\r\n    width: 1.25rem;\r\n    border-radius: 0.125rem;\r\n    background-color: $white;\r\n    box-shadow: 0 0.125rem 0.125rem 0 rgba(0, 0, 0, 0.45);\r\n    cursor: pointer;\r\n    transition: all 0.2s ease;\r\n\r\n    &::before {\r\n      content: \"on\";\r\n      inset-inline-start: -1.563rem;\r\n    }\r\n\r\n    &::after {\r\n      content: \"off\";\r\n      inset-inline-end: -1.813rem;\r\n      color: $text-muted;\r\n    }\r\n\r\n    &::before,\r\n    &::after {\r\n      position: absolute;\r\n      font-size: 0.625rem;\r\n      font-weight: $font-weight-medium;\r\n      letter-spacing: 0.5px;\r\n      text-transform: uppercase;\r\n      inset-block-start: 0.188rem;\r\n      line-height: 1.38;\r\n      transition: all 0.2s ease;\r\n    }\r\n  }\r\n\r\n  &.on {\r\n    background-color: rgba(var($primary), 0.3);\r\n\r\n    span {\r\n      background-color: $primary;\r\n\r\n      &::before {\r\n        color: $primary;\r\n      }\r\n    }\r\n\r\n    &.toggle-secondary {\r\n      background-color: rgba($secondary, 0.4);\r\n\r\n      span {\r\n        background-color: $secondary;\r\n\r\n        &::before {\r\n          color: $secondary;\r\n        }\r\n      }\r\n    }\r\n\r\n    &.toggle-warning {\r\n      background-color: rgba($warning, 0.4);\r\n\r\n      span {\r\n        background-color: $warning;\r\n\r\n        &::before {\r\n          color: $warning;\r\n        }\r\n      }\r\n    }\r\n\r\n    &.toggle-info {\r\n      background-color: rgba($info, 0.4);\r\n\r\n      span {\r\n        background-color: $info;\r\n\r\n        &::before {\r\n          color: $info;\r\n        }\r\n      }\r\n    }\r\n\r\n    &.toggle-success {\r\n      background-color: rgba($success, 0.4);\r\n\r\n      span {\r\n        background-color: $success;\r\n\r\n        &::before {\r\n          color: $success;\r\n        }\r\n      }\r\n    }\r\n\r\n    &.toggle-danger {\r\n      background-color: rgba($danger, 0.4);\r\n\r\n      span {\r\n        background-color: $danger;\r\n\r\n        &::before {\r\n          color: $danger;\r\n        }\r\n      }\r\n    }\r\n\r\n    &.toggle-light {\r\n      background-color: rgba($light, 0.4);\r\n\r\n      span {\r\n        background-color: $light;\r\n\r\n        &::before,\r\n        &::after {\r\n          color: $text-muted;\r\n        }\r\n      }\r\n    }\r\n\r\n    &.toggle-dark {\r\n      background-color: rgba($dark, 0.4);\r\n\r\n      span {\r\n        background-color: $dark;\r\n\r\n        &::before {\r\n          color: $white;\r\n        }\r\n      }\r\n    }\r\n\r\n    span {\r\n      inset-inline-start: 2.313rem;\r\n    }\r\n\r\n    &.toggle-sm span {\r\n      inset-inline-start: 2.313rem;\r\n\r\n      &::before {\r\n        inset-block-start: -1px;\r\n        inset-inline-start: -1.563rem;\r\n      }\r\n    }\r\n\r\n    &.toggle-lg span {\r\n      inset-inline-start: 2.563rem;\r\n\r\n      &::before {\r\n        inset-block-start: 0.5rem;\r\n        inset-inline-start: -1.75rem;\r\n      }\r\n    }\r\n  }\r\n\r\n  &.toggle-sm {\r\n    height: 1.063rem;\r\n    width: 3.125rem;\r\n\r\n    span {\r\n      width: 0.625rem;\r\n      height: 0.625rem;\r\n\r\n      &::after {\r\n        inset-inline-end: -1.875rem;\r\n        inset-block-start: -1px;\r\n      }\r\n    }\r\n  }\r\n\r\n  &.toggle-lg {\r\n    height: 2.125rem;\r\n    width: 4.5rem;\r\n\r\n    span {\r\n      width: 1.75rem;\r\n\r\n      &::after {\r\n        inset-block-start: 0.5rem;\r\n        inset-inline-end: -1.938rem;\r\n      }\r\n    }\r\n  }\r\n}\r\n.custom-toggle-switch > input[type=\"checkbox\"] {\r\n  display: none;\r\n}\r\n.custom-toggle-switch > label {\r\n  cursor: pointer;\r\n  height: 0;\r\n  position: relative;\r\n  width: 2.5rem;\r\n}\r\n\r\n.label-primary {\r\n  background: $primary;\r\n  color: $white;\r\n}\r\n\r\n.label-secondary {\r\n  background: $secondary;\r\n  color: $white;\r\n}\r\n\r\n.label-warning {\r\n  background: $warning;\r\n  color: $white;\r\n}\r\n\r\n.label-info {\r\n  background: $info;\r\n  color: $white;\r\n}\r\n\r\n.label-success {\r\n  background: $success;\r\n  color: $white;\r\n}\r\n\r\n.label-danger {\r\n  background: $danger;\r\n  color: $white;\r\n}\r\n\r\n.label-light {\r\n  background: $light;\r\n  color: $white;\r\n}\r\n\r\n.label-dark {\r\n  background: $dark;\r\n  color: $white;\r\n}\r\n\r\n.custom-toggle-switch > input[type=\"checkbox\"]:checked + label::before {\r\n  background: inherit;\r\n  opacity: 0.5;\r\n}\r\n.custom-toggle-switch > label {\r\n  &::before {\r\n    background: $text-muted;\r\n    box-shadow: inset 0px 0px 0.625rem rgba(255,255,255, 0.5);\r\n    border-radius: 0.5rem;\r\n    content: \"\";\r\n    height: 1rem;\r\n    margin-block-start: -0.5rem;\r\n    position: absolute;\r\n    opacity: 0.3;\r\n    transition: all 0.4s ease-in-out;\r\n    width: 2.5rem;\r\n  }\r\n\r\n  &::after {\r\n    background: $white;\r\n    border-radius: 1rem;\r\n    box-shadow: 0 0 0.313rem rgba(228, 229, 237, 0.8);\r\n    content: \"\";\r\n    height: 1.5rem;\r\n    inset-inline-start: -0.25rem;\r\n    margin-block-start: -0.5rem;\r\n    position: absolute;\r\n    inset-block-start: -0.25rem;\r\n    transition: all 0.3s ease-in-out;\r\n    width: 1.5rem;\r\n  }\r\n}\r\n.custom-toggle-switch > input[type=\"checkbox\"]:checked + label::after {\r\n  background: inherit;\r\n  inset-inline-start: 50%;\r\n}\r\n\r\n.custom-toggle-switch.toggle-sm > label::before {\r\n  height: 10px;\r\n  width: 27px;\r\n  border-radius: 10px;\r\n}\r\n\r\n.custom-toggle-switch.toggle-sm input[type=\"checkbox\"]:checked + label::after {\r\n  inset-inline-start: 13px;\r\n}\r\n\r\n.custom-toggle-switch.toggle-sm > label::after {\r\n  height: 17px;\r\n  width: 17px;\r\n  border-radius: 50%;\r\n}\r\n\r\n.custom-toggle-switch.toggle-lg > label::before {\r\n  height: 27px;\r\n  width: 55px;\r\n  border-radius: 20px;\r\n}\r\n\r\n.custom-toggle-switch.toggle-lg input[type=\"checkbox\"]:checked + label::after {\r\n  inset-inline-start: 77%;\r\n}\r\n\r\n.custom-toggle-switch.toggle-lg > label::after {\r\n  height: 35px;\r\n  width: 35px;\r\n  margin-block-start: -8px;\r\n  border-radius: 50%;\r\n}\r\n.form-floating > {\r\n  .form-control-plaintext,\r\n  .form-control {\r\n    &::placeholder {\r\n      color: transparent !important;\r\n    }\r\n  }\r\n}\r\n.form-floating > .form-control,\r\n.form-floating > .form-control-plaintext,\r\n.form-floating > .form-select {\r\n  height: calc(3.5rem - 4px);\r\n}\r\n.form-floating {\r\n  &.floating-primary {\r\n    label {\r\n      color: $primary;\r\n      opacity: 1;\r\n    }\r\n\r\n    input {\r\n      border: 1px solid $primary;\r\n    }\r\n    & > .form-control:focus ~ label {\r\n      color: $primary !important;\r\n    }\r\n  }\r\n\r\n  &.floating-secondary {\r\n    label {\r\n      color: $secondary;\r\n      opacity: 1;\r\n    }\r\n\r\n    input {\r\n      border: 1px solid $secondary;\r\n    }\r\n    & > .form-control:focus ~ label {\r\n      color: $secondary !important;\r\n    }\r\n  }\r\n\r\n  &.floating-warning {\r\n    label {\r\n      color: $warning;\r\n      opacity: 1;\r\n    }\r\n\r\n    input {\r\n      border: 1px solid $warning;\r\n    }\r\n    & > .form-control:focus ~ label {\r\n      color: $warning !important;\r\n    }\r\n  }\r\n\r\n  &.floating-info {\r\n    label {\r\n      color: $info;\r\n      opacity: 1;\r\n    }\r\n\r\n    input {\r\n      border: 1px solid $info;\r\n    }\r\n    & > .form-control:focus ~ label {\r\n      color: $info !important;\r\n    }\r\n  }\r\n\r\n  &.floating-success {\r\n    label {\r\n      color: $success;\r\n      opacity: 1;\r\n    }\r\n\r\n    input {\r\n      border: 1px solid $success;\r\n    }\r\n    & > .form-control:focus ~ label {\r\n      color: $success !important;\r\n    }\r\n  }\r\n\r\n  &.floating-danger {\r\n    label {\r\n      color: $danger;\r\n      opacity: 1;\r\n    }\r\n\r\n    input {\r\n      border: 1px solid $danger;\r\n    }\r\n    & > .form-control:focus ~ label {\r\n      color: $danger !important;\r\n    }\r\n  }\r\n}\r\n.form-floating > .form-control-plaintext ~ label::after,\r\n.form-floating > .form-control:focus ~ label::after,\r\n.form-floating > .form-control:not(:placeholder-shown) ~ label::after,\r\n.form-floating > .form-select ~ label::after {\r\n  background-color: $white;\r\n  border-radius: $border-radius;\r\n}\r\n.form-wizard-1 {\r\n  border-bottom: 0;\r\n  border-radius: 50px;\r\n\r\n  .nav-link {\r\n    border: 0;\r\n  }\r\n\r\n  &.nav-tabs {\r\n    .nav-item {\r\n      margin-inline-end: 1rem;\r\n      position: relative;\r\n    }\r\n\r\n    .nav-link {\r\n      padding: 0.25rem 0.4rem;\r\n      color: $text-muted;\r\n      display: flex;\r\n      align-items: center;\r\n      border-radius: 50px;\r\n      border: 2px solid transparent;\r\n\r\n      i {\r\n        font-size: 12px;\r\n        padding: 4px;\r\n        line-height: 1;\r\n        border-radius: 50px;\r\n        border: 2px solid $default-border;\r\n      }\r\n\r\n      &:focus,\r\n      &:hover {\r\n        border: 2px solid transparent;\r\n      }\r\n\r\n      &.active {\r\n        border: 2px solid $primary;\r\n        border-radius: 50px;\r\n        color: $primary;\r\n        background-color: transparent;\r\n\r\n        i {\r\n          border: 2px solid $primary;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .nav-item:focus-visible {\r\n    outline: none;\r\n  }\r\n}\r\n.form-control.is-valid:focus,\r\n.was-validated .form-control:valid:focus {\r\n  border-color: $success;\r\n  box-shadow: none;\r\n}\r\n.form-control.is-valid,\r\n.was-validated .form-control:valid {\r\n  border-color: $success;\r\n}\r\n.form-control-color {\r\n  width: 1.75rem;\r\n  height: 1.75rem;\r\n  overflow: hidden;\r\n  padding: 0;\r\n}\r\n.example-picker {\r\n  .pcr-button {\r\n    border-radius: 0.35rem !important;\r\n    overflow: hidden;\r\n  }\r\n}\r\n[dir=\"rtl\"] {\r\n  [type=\"email\"],\r\n  [type=\"number\"],\r\n  [type=\"tel\"],\r\n  [type=\"url\"] {\r\n    direction: rtl;\r\n  }\r\n}\r\n.form-select.is-invalid:not([multiple]):not([size]) {\r\n  padding-right: 1.125rem;\r\n  background-size: 16px 28px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\r\n}\r\n.invoice-quantity-container\r\n  .input-group\r\n  > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(\r\n    .valid-feedback\r\n  ):not(.invalid-tooltip):not(.invalid-feedback) {\r\n  margin-left: 0;\r\n}\r\ninput[type=\"range\"]::-webkit-slider-runnable-track {\r\n  background-color: $light;\r\n}\r\n[dir=\"rtl\"] {\r\n  .form-checked-outline:checked[type=\"checkbox\"]:before {\r\n    inset-inline-start: 1px;\r\n  }\r\n}\r\n\r\n.is-invalid~.invalid-feedback, .is-invalid~.invalid-tooltip, .was-validated :invalid~.invalid-feedback, .was-validated :invalid~.invalid-tooltip{\r\n  display: inline-block;\r\n}\r\n.is-valid~.valid-feedback, .is-valid~.valid-tooltip, .was-validated :valid~.valid-feedback, .was-validated :valid~.valid-tooltip{\r\n  display: inline-block;\r\n}\r\n.invalid-tooltip,.valid-tooltip{\r\n  position: relative;\r\n  top: 0;\r\n}\r\n.form-check {\r\n  min-height: inherit !important;\r\n}\r\n.col-form-label-lg,\r\n.col-form-label-sm,\r\n.col-form-label {\r\n  font-weight: $font-weight-medium;\r\n}\r\n#exampleColorInput::-webkit-color-swatch-wrapper {\r\n  direction: rtl; \r\n}\r\n[data-theme-mode=\"dark\"] {\r\n  input {\r\n    &[type=\"week\"],\r\n    &[type=\"month\"],\r\n    &[type=\"date\"],\r\n    &[type=\"datetime-local\"],\r\n    &[type=\"time\"] {\r\n      &::-webkit-calendar-picker-indicator {\r\n        filter: invert(1);\r\n      }\r\n    }\r\n  }\r\n}\r\n[dir=\"rtl\"] {\r\n  input {\r\n    &[type=\"week\"],\r\n    &[type=\"month\"],\r\n    &[type=\"date\"],\r\n    &[type=\"datetime-local\"],\r\n    &[type=\"time\"] {\r\n      text-align: end;\r\n    }\r\n  }\r\n}\r\n.form-control {\r\n  &.form-control-lg {\r\n    height: 46px;\r\n  }\r\n  &.form-control-sm {\r\n    height: 30px;\r\n    min-height: 30px;\r\n  }\r\n}\r\n.input-group-sm {\r\n  .input-group-text {\r\n    height: 35px;\r\n  }\r\n  .form-control {\r\n    height: 35px;\r\n    min-height: 35px;\r\n  }\r\n}\r\n.input-icon-addon {\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  right: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-width: 2.5rem;\r\n  color: #515B73;\r\n  pointer-events: none;\r\n  font-size: 1.2em;\r\n}\r\n.checkboxs {\r\n  display: block;\r\n  cursor: pointer;\r\n  user-select: none;\r\n  position: relative;\r\n  padding-left: 25px;\r\n  input {\r\n      position: absolute;\r\n      opacity: 0;\r\n      cursor: pointer;\r\n      height: 0;\r\n      width: 0;\r\n  }\r\n}\r\n.checkboxs input ~ .checkmarks {\r\n  border: 1px solid $light-900;\r\n  border-radius: 5px;\r\n}\r\n.checkboxs input:checked ~ .checkmarks {\r\n  background-color: $purple;\r\n  border-color: $purple;\r\n}\r\n    .checkboxs input:checked ~ .checkmarks:after {\r\n      display: block;\r\n    }\r\n    .checkboxs .checkmarks {\r\n      height: 16px;\r\n      width: 16px;\r\n      @include position(absolute, 0, null, null, 0);\r\n    }\r\n    .checkboxs .checkmarks:after {\r\n      content: \"\";\r\n      position: absolute;\r\n      display: none;\r\n    }\r\n    .checkboxs .checkmarks:after {\r\n      left: 50%;\r\n      top: 50%;\r\n      transform: translate(-50%, -50%);\r\n      content: \"\\f00c\";\r\n      font-family: 'Font Awesome 5 Free';\r\n      color: $white;\r\n      font-weight: $font-weight-semibold;\r\n      font-size: 10px;\r\n  }\r\n.status-radio:checked,\r\n.status-radio:not(:checked) {\r\n  position: absolute;\r\n  left: -9999px;\r\n}\r\n.status-radio:checked + label,\r\n.status-radio:not(:checked) + label\r\n{\r\n  position: relative;\r\n  padding-left: 24px;\r\n  cursor: pointer;\r\n  line-height: 16px;\r\n  display: inline-block;\r\n  color: $gray-900;\r\n}\r\n.status-radio:checked + label:before,\r\n.status-radio:not(:checked) + label:before {\r\n  content: '';\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  width: 16px;\r\n  height: 16px;\r\n  border: 1px solid $light-900;\r\n  border-radius: 100%;\r\n  background: $white;\r\n}\r\n.status-radio:checked + label:before {\r\n  background: $indigo;\r\n  border-color: $indigo;\r\n}\r\n.status-radio[type=\"radio\"]:checked + label:after,\r\n.status-radio[type=\"radio\"]:not(:checked) + label:after {\r\n  content: '';\r\n  width: 8px;\r\n  height: 8px;\r\n  background: $white;\r\n  position: absolute;\r\n  top: 4px;\r\n  left: 4px;\r\n  border-radius: 100%;\r\n  -webkit-transition: all 0.2s ease;\r\n  transition: all 0.2s ease;\r\n}\r\n[type=\"radio\"]:not(:checked) + label:after {\r\n  opacity: 0;\r\n  -webkit-transform: scale(0);\r\n  transform: scale(0);\r\n}\r\n[type=\"radio\"]:checked + label:after {\r\n  opacity: 1;\r\n  -webkit-transform: scale(1);\r\n  transform: scale(1);\r\n}\r\n.bootstrap-tagsinput {\r\n  border-color: $light-300;\r\n  box-shadow: 0px 4px 4px 0px #DBDBDB40;\r\n  border-radius: 5px;\r\n  font-size:  $font-size-14;\r\n  color: $text-color;\r\n  min-height: 42px;\r\n  line-height: 2;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  max-height: 42px;\r\n  overflow-y: auto;\r\n  .tag {\r\n      background: $light-300;\r\n      color: $text-color;\r\n      padding: 2px 5px;\r\n      line-height: normal;\r\n      border-radius: 5px;\r\n      font-size: $font-size-14;\r\n  }\r\n}",".notes-page-wrapper {\r\n    .content {\r\n        padding: 24px;\r\n        .page-add-notes {\r\n            border-bottom: 1px solid $light-900;\r\n            padding-bottom: 25px;\r\n            position: relative;\r\n            margin-bottom: 0;\r\n            @include respond-below(custom767) {\r\n                flex-direction: column;\r\n                align-items: start;\r\n            }\r\n            .notes-tog {\r\n                display: -webkit-box;\r\n                display: -ms-flexbox;\r\n                display: flex;\r\n                align-items: center;\r\n                -webkit-box-align: center;\r\n                -ms-flex-align: center;\r\n                justify-content: center;\r\n                -webkit-justify-content: center;\r\n                -ms-flex-pack: center;\r\n                position: absolute;\r\n                bottom: -12px;\r\n                border-radius: 30px;\r\n                background: #1B2850;\r\n                color: $white;\r\n                width: 24px;\r\n                height: 24px;\r\n                padding: 5px;\r\n                @include respond-below(custom991) {\r\n                    display: none;\r\n                }\r\n            }\r\n        }\r\n        .section-bulk-wrap {\r\n            display: -webkit-box;\r\n            display: -ms-flexbox;\r\n            display: flex;\r\n            align-items: center;\r\n            -webkit-box-align: center;\r\n            -ms-flex-align: center;\r\n            justify-content: space-between;\r\n            -webkit-justify-content: space-between;\r\n            -ms-flex-pack: space-between;\r\n            margin: 30px 0 24px 0;\r\n            padding: 20px;\r\n            border-radius: 8px;\r\n            background:  $white;\r\n            box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);\r\n            @include respond-below(custom767) {\r\n                flex-direction: column;\r\n                align-items: start;\r\n            }\r\n            .bulk-action-type {\r\n                display: -webkit-box;\r\n                display: -ms-flexbox;\r\n                display: flex;\r\n                align-items: center;\r\n                -webkit-box-align: center;\r\n                -ms-flex-align: center;\r\n                @include respond-below(custom767) {\r\n                    margin-bottom: 20px;\r\n                }\r\n                @include respond-below(custom575) {\r\n                    margin-bottom: 0;\r\n                    flex-direction: column;\r\n                    align-items: self-start;\r\n                }\r\n                .select-bluk {\r\n                    margin-right: 8px;\r\n                    height: 40px;\r\n                    .select2-container {\r\n                        .selection {\r\n                            .select2-selection {\r\n                                .select2-selection__rendered {\r\n                                    padding-left: 10px!important;\r\n                                }\r\n                            }\r\n                        }\r\n                        \r\n                    }\r\n                }\r\n                .btn-added {\r\n                    background: $gray-500;\r\n                    padding: 8px 20px;\r\n                    color: $white;\r\n                    font-size: $font-size-15;\r\n                    font-weight: $font-weight-normal;  \r\n                    margin-right: 15px; \r\n                    height: 40px; \r\n                    line-height: normal;\r\n                    &:hover {\r\n                        background: $primary;\r\n                    }    \r\n                    @include respond-below(custom575) {\r\n                        margin: 20px 0;\r\n                    }           \r\n                }   \r\n            }  \r\n            .form-sort {\r\n                .fa-filter {\r\n                    z-index:100!important;\r\n                    position: absolute;\r\n                    top: 15px;\r\n                    left: 15px;\r\n                    width: 16px;\r\n                    height: 16px;\r\n                }\r\n            } \r\n        }\r\n        .section-notes-slider {\r\n            position: relative;\r\n            padding-bottom: 40px;\r\n            border-bottom: 1px solid $light-900;\r\n            .notes-content {\r\n                display: -webkit-box;\r\n                display: -ms-flexbox;\r\n                display: flex;\r\n                align-items: center;\r\n                -webkit-box-align: center;\r\n                -ms-flex-align: center;\r\n                justify-content: space-between;\r\n                -webkit-justify-content: space-between;\r\n                -ms-flex-pack: space-between;\r\n                margin-bottom: 20px;\r\n                .notes-close {\r\n                    a {\r\n                        color: $danger;\r\n                        font-size: $font-size-15;\r\n                        font-weight: $font-weight-normal;\r\n                        i {\r\n                            margin-right: 6px;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n            .notes-card {\r\n                padding: 24px;\r\n                border-radius: 8px;\r\n                background: rgba(255, 159, 67, 0.03);\r\n                &.medium {\r\n                    background: rgba(116, 41, 248, 0.03);\r\n                }\r\n                &.high {\r\n                    background: rgba(234, 84, 85, 0.03);\r\n                }\r\n                .notes-card-body {\r\n                    display: -webkit-box;\r\n                    display: -ms-flexbox;\r\n                    display: flex;\r\n                    align-items: center;\r\n                    -webkit-box-align: center;\r\n                    -ms-flex-align: center;\r\n                    justify-content: space-between;\r\n                    -webkit-justify-content: space-between;\r\n                    -ms-flex-pack: space-between;\r\n                    p {\r\n                        &.badged  {\r\n                            border-radius: 8px;\r\n                            border: 1px solid  $warning;\r\n                            padding: 4px 10px; \r\n                            margin-bottom: 0;\r\n                            color:$warning;\r\n                            font-size: $font-size-base;\r\n                            font-weight: $font-weight-semibold;\r\n                            display: flex;\r\n                            align-items: center;\r\n                            i {\r\n                                font-size: 7px;\r\n                                margin-right: 4px;\r\n                            }\r\n                            &.medium {\r\n                                color: #7429F8;\r\n                                border: 1px solid #7429F8;\r\n                            }\r\n                            &.high {\r\n                                color: $danger;\r\n                                border: 1px solid $danger;\r\n                            }\r\n                        }\r\n                    }\r\n                    a {\r\n                        display: -webkit-box;\r\n                        display: -ms-flexbox;\r\n                        display: flex;\r\n                        align-items: center;\r\n                        -webkit-box-align: center;\r\n                        -ms-flex-align: center;\r\n                        color: $gray-500;\r\n                        &.dropdown-item {\r\n                            &:hover {\r\n                                color: $gray-900;\r\n                                svg {\r\n                                    color: $gray-900;\r\n                                }\r\n                            }\r\n                        }   \r\n                    }\r\n                \r\n                }\r\n                .notes-slider-content {\r\n                    margin: 24px 0;\r\n                    h4 {\r\n                        a {\r\n                            margin-bottom: 10px;\r\n                            color:$gray-500;\r\n                            font-size: $font-size-16;\r\n                            font-weight: $font-weight-semibold;\r\n                            display: -webkit-box;\r\n                            -webkit-line-clamp: 1;\r\n                            -webkit-box-orient: vertical;\r\n                            overflow: hidden;\r\n                            &:hover {\r\n                                color: $warning;\r\n                            }\r\n                        }                      \r\n                    }\r\n                    p {\r\n                        color: $text-color;\r\n                        font-size: $font-size-15;\r\n                        font-weight: $font-weight-normal;\r\n                        margin-bottom: 0px;\r\n                        display: -webkit-box;\r\n                        -webkit-line-clamp: 2;\r\n                        -webkit-box-orient: vertical;\r\n                        overflow: hidden;\r\n                    }\r\n                }\r\n                .notes-slider-widget {\r\n                    display: -webkit-box;\r\n                    display: -ms-flexbox;\r\n                    display: flex;\r\n                    align-items: center;\r\n                    -webkit-box-align: center;\r\n                    -ms-flex-align: center;\r\n                    justify-content: space-between;\r\n                    -webkit-justify-content: space-between;\r\n                    -ms-flex-pack: space-between;\r\n                    .notes-logo {\r\n                        display: -webkit-box;\r\n                        display: -ms-flexbox;\r\n                        display: flex;\r\n                        align-items: center;\r\n                        -webkit-box-align: center;\r\n                        -ms-flex-align: center;\r\n                        a {\r\n                            margin-right: 15px;\r\n                            span {\r\n                                width: 32px;\r\n                                height: 32px;\r\n                                display: flex;                                \r\n                                img {\r\n                                    border-radius: 100px;\r\n                                }\r\n                                \r\n                            }                           \r\n                        }   \r\n                        span {\r\n                            &.medium-square {\r\n                                margin-right: 5px;\r\n                                i {\r\n                                    color: $success;\r\n                                    transform: rotate(45deg);\r\n                                    font-size: 10px;\r\n                                }\r\n                            }\r\n                            &.high-square {\r\n                                margin-right: 5px;\r\n                                i {\r\n                                    color: $warning;\r\n                                    transform: rotate(45deg);\r\n                                    font-size: 10px;\r\n                                }\r\n                            }\r\n                            &.low-square {\r\n                                margin-right: 5px;\r\n                                i {\r\n                                    color: #288EC7;\r\n                                    transform: rotate(45deg);\r\n                                    font-size: 10px;\r\n                                }\r\n                            }\r\n                        }                     \r\n                        p {\r\n                            display: -webkit-box;\r\n                            display: -ms-flexbox;\r\n                            display: flex;\r\n                            align-items: center;\r\n                            -webkit-box-align: center;\r\n                            -ms-flex-align: center;\r\n                            color:#288EC7;\r\n                            font-size: $font-size-15;\r\n                            font-weight: $font-weight-normal;\r\n                            margin-bottom: 0px;\r\n                            i {\r\n                                &.fa-draw-polygon {\r\n                                    margin-right: 5px;\r\n                                }\r\n                            }\r\n                            &.medium {\r\n                                color: $success;\r\n                            }\r\n                            &.high {\r\n                                color: $warning;\r\n                            }\r\n                        }\r\n                    }\r\n                    .notes-star-delete {\r\n                        display: -webkit-box;\r\n                        display: -ms-flexbox;\r\n                        display: flex;\r\n                        align-items: center;\r\n                        -webkit-box-align: center;\r\n                        -ms-flex-align: center;\r\n                        span {\r\n                            .fa-star {\r\n                                color: $warning;\r\n                                width: 16px;\r\n                                height: 16px;\r\n                                margin-right: 10px;\r\n                            }\r\n                            .feather-trash-2 {\r\n                                color: $danger;\r\n                                width: 16px;\r\n                                height: 16px;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n        .section-card-body {\r\n            padding-top: 40px;\r\n            .notes-card-details {\r\n                border-radius: 8px;\r\n                border: 1px solid  rgba(145, 158, 171, 0.30);\r\n                background: $white;\r\n                box-shadow: 0px 4px 60px 0px rgba(190, 190, 190, 0.27);\r\n                padding: 24px;\r\n                margin-bottom: 24px;\r\n                .notes-card-body {\r\n                    display: -webkit-box;\r\n                    display: -ms-flexbox;\r\n                    display: flex;\r\n                    align-items: center;\r\n                    -webkit-box-align: center;\r\n                    -ms-flex-align: center;\r\n                    justify-content: space-between;\r\n                    -webkit-justify-content: space-between;\r\n                    -ms-flex-pack: space-between;\r\n                    p {\r\n                        &.badged  {\r\n                            display: -webkit-box;\r\n                            display: -ms-flexbox;\r\n                            display: flex;\r\n                            align-items: center;\r\n                            -webkit-box-align: center;\r\n                            -ms-flex-align: center;\r\n                            border-radius: 8px;\r\n                            border: 1px solid  $warning;\r\n                            padding: 4px 10px; \r\n                            margin-bottom: 0;\r\n                            color:$warning;\r\n                            font-size: $font-size-base;\r\n                            font-weight: $font-weight-semibold;\r\n                            i {\r\n                                font-size: 7px;\r\n                                margin-right: 4px;\r\n                            }\r\n                            &.medium {\r\n                                color: #7429F8;\r\n                                border: 1px solid #7429F8;\r\n                            }\r\n                            &.high {\r\n                                color: $danger;\r\n                                border: 1px solid $danger;\r\n                            }\r\n                        }\r\n                    }\r\n                    .dropdown-item {\r\n                        span {\r\n                            display: -webkit-box;\r\n                            display: -ms-flexbox;\r\n                            display: flex;\r\n                            align-items: center;\r\n                            -webkit-box-align: center;\r\n                            -ms-flex-align: center;\r\n                            color: $gray-500;\r\n                            svg {\r\n                                width: 14px;\r\n                                height: 14px;\r\n                                color: $text-color;\r\n                            }\r\n                        }\r\n                        &:hover {\r\n                            span {\r\n                                svg {\r\n                                    color: $white;\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n                .notes-wrap-content {\r\n                    padding: 20px 0;\r\n                    border-bottom: 1px solid $light-900;\r\n                    h4 {\r\n                        a {\r\n                            color:$gray-500;\r\n                            font-size: $font-size-16;\r\n                            font-weight: $font-weight-semibold;\r\n                            margin-bottom: 5px;\r\n                            display: -webkit-box;\r\n                            -webkit-line-clamp: 1;\r\n                            -webkit-box-orient: vertical;\r\n                            overflow: hidden;\r\n                            &:hover {\r\n                                color: $warning;\r\n                            }\r\n                        }                    \r\n                    }\r\n                    .wrap-cal {\r\n                        color:$text-color;\r\n                        font-size: $font-size-15;\r\n                        font-weight: $font-weight-normal;\r\n                        margin-bottom: 20px;\r\n                        display: -webkit-box;\r\n                        display: -ms-flexbox;\r\n                        display: flex;\r\n                        align-items: center;\r\n                        -webkit-box-align: center;\r\n                        -ms-flex-align: center;\r\n                        svg {\r\n                            margin-right: 5px;\r\n                            width: 16px;\r\n                            height: 16px;\r\n                        }\r\n                    }\r\n                    p {\r\n                        color:$text-color;\r\n                        font-size: $font-size-15;\r\n                        font-weight: $font-weight-normal;\r\n                        margin-bottom: 0px;\r\n                        display: -webkit-box;\r\n                        -webkit-line-clamp: 2;\r\n                        -webkit-box-orient: vertical;\r\n                        overflow: hidden;\r\n                    }\r\n                }\r\n                .notes-slider-widget {\r\n                    display: -webkit-box;\r\n                    display: -ms-flexbox;\r\n                    display: flex;\r\n                    align-items: center;\r\n                    -webkit-box-align: center;\r\n                    -ms-flex-align: center;\r\n                    justify-content: space-between;\r\n                    -webkit-justify-content: space-between;\r\n                    -ms-flex-pack: space-between;\r\n                    &.notes-widget-profile {\r\n                        padding-top: 20px;\r\n                    }\r\n                    .notes-logo {\r\n                        display: -webkit-box;\r\n                        display: -ms-flexbox;\r\n                        display: flex;\r\n                        align-items: center;\r\n                        -webkit-box-align: center;\r\n                        -ms-flex-align: center;\r\n                        a{\r\n                            margin-right: 15px;\r\n                            span {                            \r\n                                img {\r\n                                    border-radius: 100px;\r\n                                }\r\n                            } \r\n                        }                                            \r\n                        span {\r\n                            &.medium-square {\r\n                                margin-right: 5px;\r\n                                i {\r\n                                    color: $success;\r\n                                    transform: rotate(45deg);\r\n                                    font-size: 10px;\r\n                                }\r\n                            }\r\n                            &.high-square {\r\n                                margin-right: 5px;\r\n                                i {\r\n                                    color: $warning;\r\n                                    transform: rotate(45deg);\r\n                                    font-size: 10px;\r\n                                }\r\n                            }\r\n                            &.low-square {\r\n                                margin-right: 5px;\r\n                                i {\r\n                                    color: #288EC7;\r\n                                    transform: rotate(45deg);\r\n                                    font-size: 10px;\r\n                                }\r\n                            }\r\n                        }\r\n                        p {\r\n                            color:#288EC7;\r\n                            font-size: $font-size-15;\r\n                            font-weight: $font-weight-normal;\r\n                            margin-bottom: 0px;\r\n                            display: -webkit-box;\r\n                            display: -ms-flexbox;\r\n                            display: flex;\r\n                            align-items: center;\r\n                            -webkit-box-align: center;\r\n                            -ms-flex-align: center;\r\n                            i {\r\n                                &.fa-draw-polygon {\r\n                                    margin-right: 5px;\r\n                                }\r\n                            }\r\n                            &.medium {\r\n                                color: $success;\r\n                            }\r\n                            &.high {\r\n                                color: $warning;\r\n                            }\r\n                        }\r\n                    }\r\n                    .notes-star-delete {\r\n                        display: -webkit-box;\r\n                        display: -ms-flexbox;\r\n                        display: flex;\r\n                        align-items: center;\r\n                        -webkit-box-align: center;\r\n                        -ms-flex-align: center;\r\n                        span {\r\n                            .feather-star {\r\n                                color: $text-color;\r\n                                width: 16px;\r\n                                height: 16px;\r\n                                margin-right: 10px;\r\n                            }\r\n                            .feather-trash-2 {\r\n                                color: $danger;\r\n                                width: 16px;\r\n                                height: 16px;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }      \r\n    }\r\n}\r\n.notes-card-details {\r\n    .notes-card-body {\r\n        a {\r\n            color: $gray-500;\r\n        }\r\n    }\r\n\r\n}\r\n.star-todo-inbox {\r\n    svg {\r\n        width: 13px;\r\n        height: 13px;\r\n        color: $text-color;\r\n    }\r\n}\r\n.inbox-call-profile {\r\n    border-radius: 5px;\r\n    background: #E92990;\r\n    border: 1px solid #E92990;\r\n    padding: 4px 10px;\r\n    font-size: $font-size-14;\r\n    font-weight: $font-weight-bold;\r\n    color: $white;\r\n    margin: 0 20px;\r\n    &:hover  {\r\n        color: #E92990;\r\n        background: $white;\r\n    }\r\n}\r\n.notes-tog {\r\n    i {\r\n        transform: rotate(180deg);\r\n    }\r\n    &.active {\r\n        i {\r\n            transform: rotate(0deg);\r\n        }\r\n    }\r\n}\r\n.section-bulk-wrap {\r\n    .form-sort {\r\n        position: relative;\r\n        svg {\r\n            &.feather-filter {\r\n                position: absolute;\r\n                z-index: 101;\r\n                width: 16px;\r\n                height: 16px;\r\n                top: 12px;\r\n                left: 10px;\r\n            }\r\n            \r\n        }\r\n    }\r\n}\r\n\r\n.page-add-notes.active svg {\r\n    transform: rotate(0) !important;\r\n}\r\n.dropdown-menu {\r\n    &.notes-menu {\r\n        z-index: 99999;\r\n        a {\r\n            &.dropdown-item {\r\n                color: $gray-500;\r\n                font-size: $font-size-15;\r\n                font-weight: $font-weight-normal;\r\n                display: flex;\r\n                align-items: center; \r\n                padding: 5px;   \r\n                border-radius: 5px;\r\n                &:hover {\r\n                    background: $light-300;\r\n                    color: $gray-900;\r\n                    svg {\r\n                        color: $gray-900;\r\n                    }\r\n                }                          \r\n            }\r\n            \r\n        }   \r\n        span {\r\n            margin-right: 8px;\r\n        }\r\n        svg {\r\n            width: 14px;\r\n            height: 14px;\r\n            color: $text-color;\r\n        }\r\n    } \r\n}\r\n.edit-note-head {\r\n    a {\r\n        border-radius: 30px;\r\n        border: 1px solid rgba(145, 158, 171, 0.30);\r\n        background:  $white;\r\n        color: $gray-500;\r\n        padding: 15px;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        width: 20px;\r\n        height: 20px;\r\n        &:hover {\r\n            border-radius: 20px;\r\n            background:  $primary;\r\n            color: $white;\r\n        }\r\n    }\r\n}\r\n.custom-modal-body {\r\n    .select2-container {\r\n        .selection {\r\n            .select2-selection {\r\n                .select2-selection__rendered {\r\n                    padding-left: 10px!important;\r\n                }\r\n            }\r\n        }\r\n        \r\n    }\r\n}\r\n.bulk-con-wrap {\r\n    width: 100%;\r\n}\r\n.section-bulk-widget {\r\n    transition: 0.6s all\r\n}\r\n.section-notes-dashboard {\r\n    display: none;\r\n    transition: 0.6s all\r\n}\r\n.notes-tog {\r\n    i {\r\n        transition: 0.5s all;\r\n    }\r\n}\r\n.notes-tag-left {\r\n    .notes-tog {\r\n        i {\r\n            transform: rotate(360deg);\r\n            transition: 0.5s all;\r\n        }\r\n    }\r\n}\r\n.budgeted-role-notes {\r\n    width: 100%;\r\n}\r\n.notes-summernote .card{\r\n    margin-bottom: 0 !important;\r\n}\r\n.dropdown-item:active {\r\n    background: transparent;\r\n}\r\n.notes-summernote p {\r\n    color: $text-color;\r\n    font-size: $font-size-15;\r\n    font-weight: $font-weight-normal;\r\n}\r\n.budget-role-notes {\r\n    .owl-carousel .owl-nav {\r\n        margin: 0;\r\n        position: absolute;\r\n    }\r\n}\r\n.notes-dash {\r\n    margin-top: 30px;\r\n    padding: 24px;\r\n    border-radius: 8px;\r\n    border: 1px solid  rgba(145, 158, 171, 0.30);\r\n    background: $white;\r\n    transition: 0.6s all;\r\n    .notes-top-head {       \r\n        border-bottom: 1px solid $light-900;\r\n        h5 {\r\n            font-size: $font-size-18;\r\n            font-weight: $font-weight-bold;\r\n            color: $gray-500;\r\n            margin-bottom: 15px;\r\n            display: flex;\r\n            align-items: center;\r\n            svg {\r\n                width: 19px;\r\n                height: 19px;\r\n                margin-right: 6px;\r\n                color: $text-color;\r\n            }\r\n        }\r\n    }\r\n    .notes-top-head-submenu {\r\n        padding: 15px 0;\r\n        border-bottom: 1px solid $light-900;\r\n        ul {\r\n            padding: 15px 0;\r\n            li {\r\n                display: -webkit-box;\r\n                display: -ms-flexbox;\r\n                display: flex;\r\n                align-items: center;\r\n                -webkit-box-align: center;\r\n                -ms-flex-align: center;\r\n                justify-content: space-between;\r\n                -webkit-justify-content: space-between;\r\n                -ms-flex-pack: space-between;               \r\n                padding: 10px;\r\n                &.active {\r\n                    border-radius: 10px;\r\n                    background:  $gray-500;\r\n                    svg {\r\n                        width: 16px;\r\n                        height: 16px;\r\n                        margin-right: 8px;\r\n                    }\r\n                    p {\r\n                        color: $white;                        \r\n                    }\r\n                }\r\n\r\n                p {\r\n                    font-size: $font-size-15;\r\n                    font-weight: $font-weight-semibold;\r\n                    color: $text-color;\r\n                    margin-bottom: 0;\r\n                    display: flex;\r\n                    align-items: center;\r\n                    svg {\r\n                        width: 16px;\r\n                        height: 16px;\r\n                        margin-right: 8px;\r\n                    }\r\n                }\r\n                span {\r\n                    display: flex;\r\n                    width: 18px;\r\n                    height: 18px;\r\n                    padding: 0px 3px;\r\n                    justify-content: center;\r\n                    align-items: center;\r\n                    border-radius: 12px;\r\n                    background:  $primary;\r\n                    color: $white;\r\n                }\r\n\r\n            }\r\n        }\r\n    }\r\n    .content-submenu-tag {\r\n        margin-top: 15px;\r\n        padding: 10px;\r\n        h6 {\r\n            font-size: $font-size-16;\r\n            font-weight: $font-weight-semibold;\r\n            color: $gray-500;\r\n        }\r\n        ul {\r\n            padding: 10px 0;\r\n            &.tags-list {\r\n                margin-bottom: 24px;\r\n            }\r\n            li {\r\n                &.personal {\r\n                    span {\r\n                        margin-right: 8px;\r\n                        i {\r\n                            transform: rotate(45deg);\r\n                            font-size: 10px;\r\n                        }\r\n                    }\r\n                    a {\r\n                        color: #288EC7;\r\n                        display: flex;\r\n                        align-items: center;\r\n                    }\r\n                    \r\n                }\r\n                &.social {\r\n                    span {\r\n                        margin-right: 8px;\r\n                        i {\r\n                            transform: rotate(45deg);\r\n                            font-size: 10px;\r\n                        }\r\n                    }\r\n                    a {\r\n                        color: $warning;\r\n                        display: flex;\r\n                        align-items: center;\r\n                    }\r\n                    \r\n                }\r\n                &.work {\r\n                    span {\r\n                        margin-right: 8px;\r\n                        i {\r\n                            transform: rotate(45deg);\r\n                            font-size: 10px;\r\n                        }\r\n                    }\r\n                    a{\r\n                        color: $success;\r\n                        display: flex;\r\n                        align-items: center;\r\n                    }\r\n                    \r\n                }\r\n                &.public {\r\n                    span {\r\n                        margin-right: 8px;\r\n                        i {\r\n                            transform: rotate(45deg);\r\n                            font-size: 10px;\r\n                        }\r\n                    }\r\n                     a{\r\n                        color: #A02F7A;\r\n                        display: flex;\r\n                        align-items: center;\r\n                     }\r\n                    \r\n                }\r\n                &.medium {\r\n                    span {\r\n                        margin-right: 8px;\r\n                        i {\r\n                            transform: rotate(45deg);\r\n                            font-size: 10px;\r\n                        }\r\n                    } \r\n                     a {\r\n                        color: $purple;\r\n                        display: flex;\r\n                        align-items: center;\r\n                     }\r\n                   \r\n                }\r\n                &.high {\r\n                    span {\r\n                        margin-right: 8px;\r\n                        i {\r\n                            transform: rotate(45deg);\r\n                            font-size: 10px;\r\n                        }\r\n                    }\r\n                    a {\r\n                        color: $danger;\r\n                        display: flex;\r\n                        align-items: center;\r\n                    }\r\n                    \r\n                }\r\n                &.low {\r\n                    span {\r\n                        margin-right: 8px;\r\n                        i {\r\n                            transform: rotate(45deg);\r\n                            font-size: 10px;\r\n                        }\r\n                    }\r\n                    a  {\r\n                        color: $warning;\r\n                        display: flex;\r\n                        align-items: center;\r\n                    }\r\n                    \r\n                }\r\n                   font-size: $font-size-15;\r\n                   font-weight: $font-weight-normal;\r\n                   display: flex;\r\n                   align-items: center;\r\n                +li {\r\n                    margin-top: 10px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.notes-logo {\r\n    a {\r\n        display: flex;\r\n        align-items: center;\r\n        span {\r\n            width: 32px;\r\n            height: 32px;  \r\n            img {\r\n                border-radius: 32px;               \r\n            }\r\n        }\r\n    }\r\n}\r\n.notes-top-head-submenu {\r\n    padding: 15px 0;\r\n    border-bottom: 1px solid $gray-400;\r\n    .nav {\r\n        &.todo-inbox {\r\n            button.todo-inbox {\r\n               display:flex;\r\n               justify-content: start; \r\n               align-items: center;             \r\n                padding: 10px;\r\n                font-size: $font-size-15;\r\n                font-weight: $font-weight-semibold;\r\n                color: $text-color;\r\n                margin-bottom: 0;\r\n                display: flex;\r\n                align-items: center;\r\n                margin-bottom: 5px;\r\n                border-radius: 5px;\r\n                &.active {\r\n                    border-radius: 5px;\r\n                    background:  #212B36;\r\n                    padding: 10px;\r\n                    color: $white;\r\n                    svg {\r\n                        width: 16px;\r\n                        height: 16px;\r\n                        margin-right: 8px;\r\n                    }               \r\n                }\r\n                &:hover {\r\n                    background:  #212B36;\r\n                    color: $white;\r\n                }\r\n               \r\n                svg {\r\n                    width: 16px;\r\n                    height: 16px;\r\n                    margin-right: 8px;\r\n                }\r\n                span {\r\n                    display: flex;\r\n                    width: 20px;\r\n                    height: 20px;\r\n                    padding: 0px 3px;\r\n                    justify-content: center;\r\n                    align-items: center;\r\n                    border-radius: 12px;\r\n                    background:  $primary;\r\n                    color: $white;\r\n                }\r\n                  \r\n            }            \r\n        }\r\n    }\r\n    \r\n}\r\n.notes-trash-btn {\r\n    background: $danger;\r\n    color: $white;\r\n    border-radius: 8px;\r\n    margin: 4px 0 20px 0;\r\n    padding: 10px;\r\n    height: 38px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    span {\r\n        display: flex;\r\n        align-items: center;\r\n        svg {\r\n            width: 16px;\r\n            height: 16px;\r\n            margin-right: 10px;\r\n        }\r\n    }\r\n}\r\n.delete-popup {\r\n    padding: 24px;\r\n    border-radius: 8px;\r\n    background: $white;\r\n    .delete-image {\r\n        margin-bottom: 20px;\r\n    }\r\n    .delete-heads {\r\n        text-align: center;\r\n        h4 {\r\n            color: $gray-500;\r\n            font-size: $font-size-20;\r\n            font-weight: $font-weight-bold;\r\n            margin-bottom: 5px;\r\n        }\r\n        p {\r\n            color: $text-color;\r\n            font-size: $font-size-15;\r\n            font-weight: $font-weight-normal;\r\n            margin-bottom: 0px;\r\n        }       \r\n    }\r\n    .delete-footer {\r\n        text-align: center;\r\n    }\r\n}\r\n.edit-page-title {\r\n    display: flex;\r\n    align-items: center;\r\n    h4 {\r\n        font-size: $font-size-18;\r\n        font-weight: $font-weight-bold;\r\n        color: $gray-500;\r\n        margin-bottom: 0;\r\n        margin-right: 10px;\r\n    }\r\n    p {\r\n        font-size: $font-size-15;\r\n        font-weight: $font-weight-normal;\r\n        color: #288EC7;\r\n    }\r\n}\r\n.edit-head-view {\r\n    margin-bottom: 20px;\r\n    border-bottom: rgba(145, 158, 171, 0.30);\r\n    h6 {\r\n        font-size: $font-size-16;\r\n        font-weight: $font-weight-semibold;\r\n        color: $gray-500;\r\n        margin-bottom: 15px;\r\n    }\r\n    p {\r\n        font-size: $font-size-15;\r\n        font-weight: $font-weight-normal;\r\n        color: $text-color;\r\n        margin-bottom: 15px;\r\n    }\r\n    p {\r\n        &.badged {\r\n            i {\r\n                font-size: 7px;\r\n                margin-right: 7px;\r\n            }\r\n            border-radius: 8px;\r\n            border: 1px solid $warning;\r\n            padding: 4px 10px;\r\n            margin-bottom: 0;\r\n            color: $warning;\r\n            font-size: $font-size-14;\r\n            font-weight: $font-weight-semibold;\r\n            display: inline-flex;\r\n            align-items: center;\r\n        }\r\n    }\r\n}\r\n.edit-footer-menu a {\r\n    background-color: $danger;\r\n}\r\n.edit-noted-head {\r\n    a {\r\n        span {\r\n            i{\r\n                 &.fa-trash-alt {\r\n                    color: $danger;\r\n                    margin-right: 10px;\r\n                 }\r\n                 &.fa-star {\r\n                    color: $warning;\r\n                 }\r\n            }\r\n        }\r\n    }\r\n}\r\n.edit-head-view {   \r\n    p {\r\n        &.badged.high {\r\n            i {\r\n                font-size: 7px;\r\n                margin-right: 7px;\r\n            }\r\n            border-radius: 8px;\r\n            border: 1px solid $danger;\r\n            padding: 4px 10px;\r\n            margin-bottom: 0;\r\n            color: $danger;\r\n            font-size: $font-size-14;\r\n            font-weight: $font-weight-semibold;\r\n            display: inline-flex;\r\n            align-items: center;\r\n        }\r\n    }\r\n}\r\n.people-profile-pic {\r\n    border: none !important;\r\n    margin-left: 14px;\r\n    position: relative;\r\n    img {\r\n        border-radius: 10px;\r\n    }\r\n    a {\r\n        position: absolute;\r\n        top: 15px;\r\n        right: 7px;\r\n        .x-square-add {\r\n            border-radius: 3px;\r\n            background:$danger;\r\n            color: $white;\r\n        }       \r\n    }\r\n}\r\n\r\n.people-customer-walk {\r\n    max-width: 35px;\r\n}\r\n.custom-pagination {\r\n    .paginations {\r\n        align-items: center;\r\n        span {\r\n            display: flex;\r\n            align-items: center;\r\n            color: $text-color;\r\n            width: 16px;\r\n            height: 16px;\r\n            .fa-chevron-left {\r\n                margin-right: 8px;\r\n            }\r\n        }\r\n        .page-wrap {\r\n            li {\r\n                a {\r\n                    margin-right: 8px;\r\n                    border-radius: 85px;\r\n                    color:$text-color;\r\n                    font-size: $font-size-base;\r\n                    font-weight: $font-weight-medium;                    \r\n                    display: flex;\r\n                    width: 30px;\r\n                    height: 30px;\r\n                    padding: 5px;\r\n                    justify-content: center;\r\n                    align-items: center;\r\n                    &.active {\r\n                        background: $primary;\r\n                        color: $white;\r\n                    }                         \r\n                }  \r\n                :hover {\r\n                    background: $primary;\r\n                    color: $white;\r\n                    transition: .3s all;\r\n                }                                   \r\n            }                \r\n        }\r\n    } \r\n}\r\n.section-notes-slider {\r\n    .notes-slider {\r\n        &.owl-carousel {\r\n            .owl-nav {\r\n                top: -42px;\r\n                right: unset;\r\n                left: 170px;\r\n                button {\r\n                    background-color: transparent;\r\n                    width: 15px;\r\n                    height: auto;\r\n                    i {\r\n                        color: $gray-500;\r\n                    }\r\n                    &:hover {\r\n                        background-color: transparent;\r\n                        i {\r\n                            color: $primary;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.form-sort {\r\n    .select2-container--default .select2-selection--single .select2-selection__rendered {\r\n        padding-left: 35px;\r\n    }\r\n    span.select2-container.select2-container--default.select2-container--open {\r\n        z-index: 99;\r\n    }\r\n}\r\n.accordion-button:after, .accordion-button:not(.collapsed)::after{\r\n    display:none;\r\n}\r\n.todo-accordion .accordion-item {\r\n    background: transparent;\r\n    margin-bottom: 10px;\r\n    border: 0;\r\n    padding: 0;\r\n}\r\n.search-set {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    align-items: center;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    .search-input{\r\n        position: relative;\r\n        margin-right: 15px;    \r\n        input[type=\"search\"] {\r\n            height: 38px;\r\n            border: 1px solid var(--Stroke, rgba(145, 158, 171, 0.30));\r\n            background: var(--White, #FFF);\r\n            width: 298px;\r\n            @include rounded(5px);\r\n            padding: 10px;\r\n            &::placeholder {\r\n                color: $black;\r\n            }\r\n            @include respond-below(custom1199) {\r\n                width: 220px;\r\n            }\r\n            @include respond-below(custom991) {\r\n                width: 200px;\r\n            }\r\n            @include respond-below(custom575) {\r\n                width: auto;\r\n            }\r\n        }\r\n        .btn-searchset {\r\n            @include margin-padding(null, null);\r\n            @include rounded(50px);\r\n            @include position(absolute,0,0,null,null);\r\n            border: 0;\r\n            .feather-search {\r\n                width: 14px;\r\n                height: 14px;\r\n            }\r\n        }\r\n    }\r\n}\r\n.page-add-notes {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n}",".todo-inbox-check {\r\n    margin-right: 15px;\r\n    .checkboxs {\r\n        margin-bottom: 0;\r\n        padding-left: 25px;\r\n        display: flex;\r\n        align-items: center;\r\n        input ~ .checkmarks {\r\n            border-color: rgba(145, 158, 171, 0.30);\r\n            border-radius: 5px;\r\n            margin-top: 2px;\r\n            width: 20px;\r\n            height: 20px;\r\n        }\r\n        input {\r\n            &:checked {\r\n                ~ .checkmarks{\r\n                    border-color: $primary;\r\n                    background-color:$primary;\r\n                }\r\n            }\r\n        }\r\n    }    \r\n}\r\n.btn-cancel {\r\n    background: $gray-600;\r\n    color: $white;\r\n    font-size: $font-size-14;\r\n    font-weight: $font-weight-bold;\r\n    border-radius: 5px;\r\n    @include transition(all 0.5s ease);\r\n    &:hover{\r\n        background: #424b52;\r\n        color: $white;\r\n     }\r\n    @include respond-below(custom991) {\r\n        min-width: auto;\r\n    }\r\n}\r\n.swal2-confirm{\r\n    margin-right: 5px;\r\n}\r\n.btn-submit {\r\n    background: $primary;\r\n    color: $white;\r\n    font-size: $font-size-14;\r\n    font-weight: $font-weight-bold;\r\n    border-radius: 5px;\r\n    @include transition(all 0.2s ease);\r\n    &:hover{\r\n        background: $primary-hover;\r\n        color: $white;\r\n    }\r\n    @include respond-below(custom991) {\r\n        min-width: auto;\r\n    }\r\n}\r\n.sections-notes-slider{\r\n    .accordion-button:after{\r\n        display: none;\r\n    }\r\n}\r\n.todo-wrapper-list-content {\r\n    margin-left: 5px;\r\n}\r\n.notes-header h3 {\r\n    color: $gray-500;\r\n    font-size: $font-size-18;\r\n    font-weight: $font-weight-bold;\r\n    margin-bottom: 0;\r\n}\r\n.todo-inbox-check .checkboxs .checkmarks:after {\r\n    left: 9px;\r\n    top: 10px;\r\n}\r\n.checkboxs input:checked ~ .checkmarks:after {\r\n    display: block;\r\n}\r\n.todo-widget {\r\n    margin-bottom: 25px;\r\n}\r\n.todo-today-content {\r\n    margin-bottom: 15px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    .todo-drop-down {\r\n        span {\r\n            i {\r\n                color: $gray-500;\r\n            }\r\n        }\r\n    }\r\n    .todo-today-header {\r\n        display: flex;\r\n        align-items: center;\r\n        span {\r\n            margin-right: 5px;\r\n            display: flex;\r\n            align-items: center;\r\n            svg {\r\n                width: 16px;\r\n                height: 16px;\r\n                color: $text-color;\r\n            }\r\n        }\r\n        h3 {\r\n            font-size: $font-size-16;\r\n            font-weight: $font-weight-semibold;\r\n            color: $gray-500;\r\n            margin-bottom: 0;\r\n            margin-right: 5px;\r\n        }\r\n        h6 {\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            width: 18px;\r\n            height: 18px;\r\n            background-color: $primary;\r\n            border-radius: 50px;\r\n            color: $white;\r\n            font-size: 10px;\r\n            font-weight: $font-weight-semibold;\r\n            margin-bottom: 0;\r\n        }\r\n    }\r\n}\r\n.todo-wrapper-list {\r\n    padding: 15px;\r\n    border-radius: 8px;\r\n    border: 1px solid  rgba(145, 158, 171, 0.30);\r\n    background:  $white;\r\n    display: flex;\r\n    align-items: center;\r\n    margin-bottom: 10px;\r\n    @include respond-below(custom575) {\r\n        flex-direction: column;\r\n    }\r\n    .todo-inbox-check {\r\n        display: flex;\r\n        align-items: center;\r\n        .todo-wrapper-list-content {\r\n            h4 {\r\n                font-size: $font-size-16;\r\n                font-weight: $font-weight-bold;\r\n                color: $gray-500;\r\n                margin-bottom: 5px;\r\n            }\r\n            p {\r\n                font-size: 13px;\r\n                font-weight: $font-weight-medium;\r\n                color: $text-color;\r\n                margin-bottom: 0;\r\n            }\r\n        }\r\n        &.todo-inbox-check-list {\r\n            width: 45%;\r\n            @include respond-below(custom575) {\r\n                width: auto;\r\n            }\r\n            .checkboxs {\r\n                margin-bottom: 12px;\r\n                input ~ .checkmarks {\r\n                    border-radius: 5px;\r\n                    margin-top: 0;                    \r\n                }\r\n            }    \r\n        }\r\n    }   \r\n    .notes-card-body {\r\n        width: 35%;\r\n        @include respond-below(custom575) {\r\n            width: auto;\r\n            margin: 20px 0;\r\n        }\r\n        p {\r\n            display: flex;\r\n            align-items: center;\r\n            &.high {\r\n                border-radius: 8px;\r\n                border: 1px solid $danger;\r\n                padding: 4px 10px;\r\n                font-size: $font-size-14;\r\n                font-weight: $font-weight-semibold;\r\n                color: $danger;\r\n                margin-right: 10px;\r\n            }\r\n            &.medium {\r\n                padding: 4px 10px;\r\n                border-radius: 8px;\r\n                border: 1px solid #423B93;\r\n                font-size: $font-size-14;\r\n                font-family: $font-weight-semibold;\r\n                color: #423B93;\r\n            }\r\n            &.pending {\r\n                padding: 4px 10px;\r\n                border-radius: 8px;\r\n                border: 1px solid #288EC7;\r\n                font-size: $font-size-14;\r\n                font-family: $font-weight-semibold;\r\n                color: #288EC7;\r\n            }\r\n            &.low {\r\n                padding: 4px 10px;\r\n                border-radius: 8px;\r\n                border: 1px solid $warning;\r\n                font-size: $font-size-14;\r\n                font-family: $font-weight-semibold;\r\n                color: $warning;                \r\n            }\r\n            &.success {\r\n                padding: 4px 10px;\r\n                border-radius: 8px;\r\n                border: 1px solid $success;\r\n                font-size: $font-size-14;\r\n                font-family: $font-weight-semibold;\r\n                color: $success;                \r\n            }\r\n            i {\r\n                &.fa-circle{\r\n                    font-size: 7px;\r\n                    margin-right: 4px;\r\n                }\r\n            }\r\n            \r\n        }\r\n    }\r\n    .todo-strike-content {\r\n        h4 {\r\n            text-decoration-line: line-through;\r\n        }\r\n        p {\r\n            text-decoration-line: line-through;\r\n        }\r\n    }\r\n    .todo-profile {\r\n        width: 20%;\r\n        justify-content: end;\r\n        img {\r\n            border-radius: 30px;\r\n            margin-right: 16px;\r\n            width: 30px;\r\n            height: 30px;\r\n        }\r\n        a {\r\n            .fa-ellipsis-v {\r\n                color: $gray-500;\r\n            }\r\n        }\r\n    }\r\n}\r\n.datanew{\r\n    tbody{\r\n        border-top: 1px solid $light-900;\r\n    }\r\n}\r\n.form-sort {\r\n    position: relative;\r\n    width: 149px;\r\n    height: 40px;\r\n    .info-img {\r\n        position: absolute;\r\n        top: 52%;\r\n        z-index: 100;\r\n        width: 16px;\r\n        height: 16px;\r\n        left: 0;\r\n        margin-left: 10px;\r\n        color: $text-color;\r\n        transform: translateY(-50%);\r\n        line-height: normal;\r\n    }\r\n    @include respond-below(custom575) {\r\n        margin-top: 24px;\r\n    }\r\n}\r\n.todo-calendar  .input-groupicon.calender-input input {\r\n    padding-left: 10px;\r\n}\r\n.todo-calendar {\r\n    position: relative;\r\n    .calender-input {\r\n        position: relative;\r\n        .info-img {\r\n            position: absolute;\r\n            top: 11px;\r\n            z-index: 100;\r\n            width: 16px;\r\n            height: 16px;\r\n            right: 5px !important;\r\n            color: $text-color;\r\n        } \r\n    }   \r\n}\r\n.todo-accordion {\r\n    .accordion-item {\r\n        background: transparent;\r\n        margin-bottom: 20px;\r\n        .accordion-header {\r\n            cursor: pointer;\r\n            .accordion-button {\r\n                background: transparent;\r\n                padding: 0;\r\n                &.collapsed {\r\n                    .todo-today-content {\r\n                        margin-bottom: 0;\r\n                    }\r\n                }\r\n            }\r\n            .todo-today-content {\r\n                width: 100%;\r\n            }\r\n            .todo-drop-down {\r\n                a {\r\n                    span {\r\n                        i {\r\n                            color: $text-color;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n        .accordion-body {\r\n            padding: 0;\r\n        }\r\n        .todo-widget {\r\n            margin-bottom: 0;\r\n            .todo-wrapper-list {\r\n                &:last-child {\r\n                    margin-bottom: 0;\r\n                }\r\n               \r\n            }\r\n        }\r\n\r\n    }\r\n}","@mixin tablecolor($color-bg) {\r\n  background-color: $white;\r\n  color: $black;\r\n  --bs-table-color-state: $black;\r\n  border-color: var(--bs-table-border-color);\r\n  --bs-table-bg: rgba(#{$color-bg}, 0.1);\r\n  --bs-table-border-color: rgba(#{$color-bg}, 0.05);\r\n  --bs-table-striped-bg: rgba(#{$color-bg}, 0.2);\r\n  --bs-table-active-bg: rgba(#{$color-bg}, 0.2);\r\n  --bs-table-hover-bg: rgba(#{$color-bg}, 0.2);\r\n  &.table-striped > tbody > tr:nth-of-type(odd) > * {\r\n    background-color: var(--bs-table-accent-bg);\r\n    --bs-table-accent-bg: rgba(#{$color-bg}, 0.2);\r\n    color: $black;\r\n  }\r\n  &.table.table-hover > tbody > tr:hover > * {\r\n    background-color: var(--bs-table-accent-bg);\r\n    --bs-table-accent-bg: rgba(#{$color-bg}, 0.4);\r\n    color: $white;\r\n  }\r\n  .table-active {\r\n    background-color: var(--bs-table-accent-bg);\r\n    --bs-table-accent-bg: rgb(#{$color-bg});\r\n    color: $white;\r\n  }\r\n}\r\ncaption {\r\n  color: $text-muted;\r\n}\r\n.table-active{\r\n  --bs-table-color-state: var(--default-text-color);\r\n}\r\n@mixin tablehead($color-bg) {\r\n  background-color: $white;\r\n  color: var(--bs-table-color);\r\n  --bs-table-color-state: #000;\r\n  --bs-table-color: #{$black};\r\n  --bs-table-bg: rgba(#{$color-bg}, 0.1);\r\n  --bs-table-border-color: rgba(#{$color-bg}, 0.1);\r\n  --bs-table-striped-bg: rgba(#{$color-bg}, 0.5);\r\n  --bs-table-striped-color: #{$black};\r\n  --bs-table-active-bg: rgba(#{$color-bg}, 0.5);\r\n  --bs-table-hover-bg: rgba(#{$color-bg}, 0.5);\r\n  color: var(--bs-table-color);\r\n  border-color: var(--bs-table-border-color);\r\n}\r\n@mixin table-color($color-bg) {\r\n  --bs-table-color: #{$black};\r\n  --bs-table-color-state: $black;\r\n  --bs-table-bg: rgba(#{$color-bg}, 0.1);\r\n  --bs-table-border-color: rgba(#{$color-bg}, 0.1);\r\n  --bs-table-striped-bg: rgba(#{$color-bg}, 0.3);\r\n  --bs-table-striped-color: #{$black};\r\n  --bs-table-active-bg: rgba(#{$color-bg}, 0.3);\r\n  --bs-table-active-color: #{$black};\r\n  --bs-table-hover-bg: rgba(#{$color-bg}, 0.3);\r\n  --bs-table-hover-color: #{$black};\r\n  color: #{$black};\r\n  border-color: rgba(#{$color-bg}, 0.1);\r\n  background-color: #{$white};\r\n}\r\n.table {\r\n  color: $text-color;\r\n  border-color: $default-border;\r\n  margin-block-end: 0;\r\n  .checkboxs {\r\n    margin-bottom: 15px;\r\n  }\r\n  tbody {\r\n    tr {\r\n      th {\r\n        font-weight: $font-weight-medium;\r\n      }\r\n    }\r\n  }\r\n  th,\r\n  td {\r\n    padding: 0.75rem;\r\n    vertical-align: middle;\r\n    line-height: 1.462;\r\n    font-size: 0.813rem;\r\n    white-space: nowrap;\r\n  }\r\n  thead tr th {\r\n    font-weight: $font-weight-semibold;\r\n    font-size: 15px;\r\n  }\r\n  &.table-sm > :not(caption) > * > * {\r\n    padding: 0.3rem;\r\n  }\r\n  &.table-dark {\r\n    color: $light-700;\r\n    border-color: rgba($white, 0.1);\r\n  }\r\n  .thead-primary th {\r\n      background-color: $primary;\r\n      color: $white;\r\n  }\r\n  .thead-secondary th {\r\n      background-color: $secondary;\r\n      color: $white;\r\n  }\r\n  .thead-info th {\r\n      background-color: $info;\r\n      color: $white;\r\n  }\r\n  .thead-warning th {\r\n      background-color: $warning;\r\n      color: $white;\r\n  }\r\n  .thead-danger th {\r\n      background-color: $danger;\r\n      color: $white;\r\n  }\r\n  .thead-success th {\r\n      background-color: $success;\r\n      color: $white;\r\n  }\r\n  .thead-dark th {\r\n      background-color: $dark;\r\n      color: $white;\r\n  }\r\n  .thead-light th {\r\n      background-color: $light-100;\r\n      color: $dark;\r\n  }\r\n  &.table-primary {\r\n    @include tablecolor(var(--primary-rgb));\r\n  }\r\n  &.table-secondary {\r\n    @include tablecolor(var(--secondary-rgb));\r\n  }\r\n  &.table-warning {\r\n    @include tablecolor(var(--warning-rgb));\r\n  }\r\n  &.table-success {\r\n    @include tablecolor(var(--success-rgb));\r\n  }\r\n  &.table-danger {\r\n    @include tablecolor(var(--danger-rgb));\r\n  }\r\n  &.table-info {\r\n    @include tablecolor(var(--info-rgb));\r\n  }\r\n  &.table-light {\r\n    @include tablecolor(var(--light-rgb));\r\n  }\r\n  &.table-dark {\r\n    @include tablecolor(var(--dark-rgb));\r\n  }\r\n  &.table-bordered {\r\n    &.border-primary {\r\n      tbody,\r\n      td,\r\n      tfoot,\r\n      th,\r\n      thead,\r\n      tr {\r\n        border-color: rgba($primary, 0.1);\r\n      }\r\n    }\r\n    &.border-info {\r\n      tbody,\r\n      td,\r\n      tfoot,\r\n      th,\r\n      thead,\r\n      tr {\r\n        border-color: rgba($info, 0.1);\r\n      }\r\n    }\r\n    &.border-secondary {\r\n      tbody,\r\n      td,\r\n      tfoot,\r\n      th,\r\n      thead,\r\n      tr {\r\n        border-color: rgba($secondary, 0.1);\r\n      }\r\n    }\r\n    &.border-warning {\r\n      tbody,\r\n      td,\r\n      tfoot,\r\n      th,\r\n      thead,\r\n      tr {\r\n        border-color: rgba($warning, 0.1);\r\n      }\r\n    }\r\n    &.border-success {\r\n      tbody,\r\n      td,\r\n      tfoot,\r\n      th,\r\n      thead,\r\n      tr {\r\n        border-color: rgba($success, 0.1);\r\n      }\r\n    }\r\n    &.border-danger {\r\n      tbody,\r\n      td,\r\n      tfoot,\r\n      th,\r\n      thead,\r\n      tr {\r\n        border-color: rgba($danger, 0.1);\r\n      }\r\n    }\r\n  }\r\n  &.table-striped > tbody > tr:nth-of-type(odd) > * {\r\n    --bs-table-accent-bg: rgba(var(--dark-rgb),0.0125);\r\n    color: $text-color;\r\n  }\r\n  &.table-striped-columns > :not(caption) > tr > :nth-child(2n) {\r\n    --bs-table-accent-bg: rgba(var(--dark-rgb),0.025);\r\n    color: $text-color;\r\n  }\r\n  tbody.table-group-divider {\r\n    border-top: 1px solid $default-border;\r\n  }\r\n  &.table-hover > tbody > tr:hover > * {\r\n    --bs-table-accent-bg: #{$default-background};\r\n    color: $text-color;\r\n  }\r\n  .table-active {\r\n    --bs-table-accent-bg: #{$light};\r\n    color: $text-color;\r\n  }\r\n  thead {\r\n    &.table-primary {\r\n      @include tablehead(var(--primary-rgb));\r\n    }\r\n    &.table-secondary {\r\n      @include tablehead(var(--secondary-rgb));\r\n    }\r\n    &.table-warning {\r\n      @include tablehead(var(--warning-rgb));\r\n    }\r\n    &.table-success {\r\n      @include tablehead(var(--success-rgb));\r\n    }\r\n    &.table-danger {\r\n      @include tablehead(var(--danger-rgb));\r\n    }\r\n    &.table-info {\r\n      @include tablehead(var(--info-rgb));\r\n    }\r\n    &.table-light {\r\n      @include tablehead(var(--light-rgb));\r\n    }\r\n    &.table-dark {\r\n      @include tablehead(var(--dark-rgb));\r\n    }\r\n  }\r\n}\r\n.table-primary {\r\n  @include table-color(var(--primary-rgb));\r\n}\r\n.table-secondary {\r\n  @include table-color(var(--secondary-rgb));\r\n}\r\n.table-warning {\r\n  @include table-color(var(--warning-rgb));\r\n}\r\n.table-success {\r\n  @include table-color(var(--success-rgb));\r\n}\r\n.table-info {\r\n  @include table-color(var(--info-rgb));\r\n}\r\n.table-danger {\r\n  @include table-color(var(--danger-rgb));\r\n}\r\n.table-dark {\r\n  @include table-color(var(--dark-rgb));\r\n}\r\n.table-light {\r\n  @include table-color(var(--light-rgb));\r\n}\r\n[data-theme-mode=\"dark\"] {\r\n  .table-dark {\r\n    border-color: rgba(0,0,0,0.025);\r\n  }\r\n}\r\n[dir=\"rtl\"] {\r\n  .table {\r\n    margin-inline-end: 1px;\r\n  }\r\n}\r\n.table{\r\n    margin: 0;\r\n    tbody{\r\n        tr{\r\n            td{\r\n                color: $gray-700;\r\n                font-size: $font-size-14; \r\n                .product-img{\r\n                    img{\r\n                        border: 0;\r\n                    }\r\n                }\r\n                .userslist-img {\r\n                    width:35px;\r\n                    height: 35px;\r\n                    margin-right: 8px;\r\n                    img {\r\n                        border-radius: 0;\r\n                    }\r\n                }\r\n                .userslist-img.bg-img {\r\n                    img {\r\n                        border: 1px solid var(--stroke-table, #E8EBED);\r\n                        // background: url(<path-to-image>), lightgray 50% / cover no-repeat;\r\n                    }\r\n                }\r\n                a {\r\n                    color: $secondary;\r\n                    font-size: $font-size-14;\r\n                    font-weight: $font-weight-normal;\r\n                    line-height: normal;\r\n                    &.product-img{\r\n                        margin-right: 5px;\r\n                        flex-shrink: 0;\r\n                    }\r\n                    .info-img {\r\n                        margin-right: 8px;\r\n                        width: 16px;\r\n                        height: 16px;\r\n                    }\r\n                    &:hover {\r\n                        color: $primary;\r\n                    }\r\n                }\r\n                .emp-name {\r\n                    line-height: 1;\r\n                    a {\r\n                        color: $secondary;\r\n                    }\r\n                    p {\r\n                        line-height: 2;\r\n                        font-size: $font-size-15;\r\n                        font-weight: $font-weight-medium;\r\n                        color: $text-color;\r\n                    }\r\n                    .role {\r\n                        line-height: unset;\r\n                    }\r\n                }\r\n                .product-imgs{\r\n                    display: -webkit-box;\r\n                    display: -ms-flexbox;\r\n                    display: flex;\r\n                    align-items: center;\r\n                    -webkit-box-align: center;\r\n                    -ms-flex-align: center;\r\n                    justify-content: center;\r\n                    -webkit-justify-content: center;\r\n                    -ms-flex-pack: center;\r\n                    width:40px;\r\n                    height:40px;\r\n                    background: #FFEBD8;\r\n                    font-size: $font-size-14;\r\n                    color: #FF9F43 !important;\r\n                    font-weight: $font-weight-medium;\r\n                    margin-right:10px;\r\n                }\r\n            }\r\n            .data-header {\r\n                font-weight: $font-weight-semibold;\r\n                color: $secondary;\r\n                font-size: $font-size-15;\r\n                border-bottom: none;\r\n            }\r\n            .ref-number {\r\n                color: $purple;\r\n            }\r\n            &.active{\r\n                border-bottom: 0;\r\n                td{\r\n                    font-size: $font-size-18;\r\n                    color: $gray-700;\r\n                    font-weight: $font-weight-semibold;\r\n                    border-bottom: 0;\r\n                }\r\n            }\r\n        }\r\n        .loss-highlight {\r\n            td {\r\n                font-weight: $font-weight-bold;\r\n                color: $secondary;\r\n                font-size: $font-size-base;\r\n                border-top: 1px solid $gray-300;\r\n            }\r\n        }\r\n        .userimgname {\r\n            display: -webkit-box;\r\n            display: -ms-flexbox;\r\n            display: flex;\r\n            align-items: center;\r\n            -webkit-box-align: center;\r\n            -ms-flex-align: center;\r\n            img {\r\n                margin-right: 8px;\r\n                border-radius: 6px;\r\n                \r\n            }\r\n        }\r\n        .purchase-count {\r\n            td {\r\n                padding-bottom: 20px;\r\n            }\r\n        }\r\n        \r\n    }\r\n    .Expense-list {\r\n       tr {\r\n        td {\r\n            padding: 15px 17px;\r\n            a {\r\n                margin-bottom: 0;\r\n            }\r\n        }\r\n       }\r\n    }\r\n    .sales-list {\r\n        tr {\r\n            td {\r\n                padding: 20px 17px;\r\n            }\r\n        }\r\n    }\r\n    .Expense-list-blk {\r\n        tr {\r\n            td {\r\n                padding: 20px 17px;\r\n            }\r\n        }\r\n    }\r\n        \r\n    \r\n}\r\n.new {\r\n    tbody {\r\n        tr {\r\n            td {\r\n                border-bottom: none;\r\n            }\r\n        }\r\n    }\r\n}\r\n.table-height{\r\n    min-height: 300px;\r\n    @include respond-below(custom991) {\r\n        min-height: auto;\r\n        margin-bottom: 15px;\r\n    }\r\n}\r\n.max-widthauto{\r\n    max-width: 100% !important;\r\n}\r\n.dataTables_filter {\r\n    & + .dataTables_filter {\r\n        display: none;\r\n    }\r\n}\r\n.dataview {\r\n    .dataTables_length,\r\n    .dataTables_info,\r\n    .dataTables_paginate{\r\n        display: none !important;\r\n    }\r\n}\r\n.dataTables_length {\r\n    font-size: $font-size-12;\r\n}\r\n.productimgname {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    align-items: center;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    a{\r\n        color: $secondary;\r\n        font-weight: $font-weight-medium;\r\n    }\r\n    .view-product {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        align-items: center;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        justify-content: center;\r\n        -webkit-justify-content: center;\r\n        -ms-flex-pack: center;\r\n        width: 50px;\r\n        height: 50px;\r\n        border-radius: 6px;\r\n        background: #F8F8F8;\r\n    }\r\n}\r\n.input-blocks{\r\n    .calc-no{\r\n        width: 50px !important;\r\n        text-align: center;\r\n    }\r\n}\r\n.table {\r\n    .input-blocks {\r\n        input[type=text] {\r\n            height:40px;\r\n        }\r\n    }\r\n    .scanner-set{\r\n        width:40px;\r\n        height:40px;\r\n    }\r\n}\r\n.card.table-list-card {\r\n    .card-body {\r\n        padding: 0;\r\n    }\r\n    .table-top {\r\n        padding: 24px 24px 0;\r\n    }\r\n    .table-responsive {\r\n        padding: 24px;\r\n        .dataTables_wrapper {\r\n            border: 0;\r\n            padding: 0;\r\n        }\r\n    }\r\n    .tabs-set {\r\n        .nav-tabs {\r\n            padding: 24px 24px 0;\r\n            margin-bottom: 0;\r\n        }\r\n    }\r\n}\r\n.table.profit-table {\r\n    thead {\r\n        background-color: #FAFBFE;\r\n        border-radius: 8px 8px 0px 0px;\r\n        tr {\r\n            &:hover {\r\n                background-color: #FAFBFE;\r\n            }\r\n        }\r\n\r\n    }\r\n    tbody {\r\n        td {\r\n            border-bottom: 0;\r\n        }\r\n        .profit-table-bg { \r\n            td {\r\n                color: $secondary;\r\n                font-weight: $font-weight-bold;\r\n                border-top: 1px solid $gray-100;\r\n                background-color: #FAFBFE;\r\n            }\r\n        }\r\n        .table-heading {\r\n            &:hover {\r\n                background-color: $white;\r\n            }\r\n            td {\r\n                color: $secondary;\r\n                font-weight: $font-weight-bold;\r\n            }\r\n        }\r\n    }\r\n} \r\n.profit-table-top {\r\n    .daterange-wraper {\r\n        margin: 0 10px;\r\n        input {\r\n            padding-left: 35px;\r\n        }\r\n    }\r\n}\r\ntable {\r\n    td {\r\n        .shield {\r\n            width: 14px;\r\n            height: 14px;\r\n        }\r\n    }\r\n}\r\n.paysilp-table-border {\r\n    border: 1px solid $gray-100;\r\n    th {\r\n        border-right: 1px solid $gray-100;\r\n        border-left: 1px solid $gray-100;\r\n        padding: 15px;\r\n        font-weight: $font-weight-bold;\r\n        font-size: $font-size-16;\r\n    }\r\n}\r\n.paysilp-table-borders {\r\n    td {\r\n        border-right: 1px solid $gray-100;\r\n        border-left: 1px solid $gray-100;\r\n        padding: 5px 15px;\r\n        color: $text-color;\r\n    }\r\n}\r\n.payslip-border-bottom {\r\n    border: 1px solid $gray-100;\r\n    th {\r\n        padding: 5px 15px;\r\n        font-weight: $font-weight-bold;\r\n        font-size: $font-size-16;\r\n    }\r\n    td {\r\n        color: $text-color;\r\n    }\r\n}\r\n.emp-details {\r\n    margin: 20px 0;\r\n    .pay-slip-salery {\r\n        h6 {\r\n            font-weight: $font-weight-bold !important;\r\n            margin-bottom: 10px;\r\n            font-size: $font-size-18 !important;\r\n        }\r\n    }\r\n    .emp-name-id.pay-slip-salery {\r\n        margin-right: 30px;\r\n    }\r\n}\r\n.slip-logo {\r\n    @include respond-below(custom575) {\r\n        flex-shrink: 0;\r\n        margin-right: 15px;\r\n    }\r\n}\r\n.product-name-slip {\r\n    h4 {\r\n        color: $primary;\r\n        font-weight: $font-weight-bold;\r\n        font-size: $font-size-18;\r\n    }\r\n}\r\n.pay-slip-box {\r\n    .modal-header {\r\n        border-radius: 8px 8px 0 0;\r\n    }\r\n    .custom-modal-body {\r\n        padding: 0;\r\n    }\r\n    .card {\r\n        border: 0;\r\n        border-radius: 0 0 10px 10px;\r\n        .card-body {\r\n            padding: 20px;\r\n            .emp-details.justify-content-start {\r\n                max-width: 760px;\r\n                margin: 20px auto 20px;\r\n            }\r\n        }\r\n    }\r\n}\r\n.table{\r\n  margin: 0;\r\n  tbody{\r\n      tr{\r\n          td{\r\n              color: $gray-700;\r\n              font-size: $font-size-14; \r\n              .product-img{\r\n                  img{\r\n                      border: 0;\r\n                  }\r\n              }\r\n              .userslist-img {\r\n                  width:35px;\r\n                  height: 35px;\r\n                  margin-right: 8px;\r\n                  img {\r\n                      border-radius: 0;\r\n                  }\r\n              }\r\n              .userslist-img.bg-img {\r\n                  img {\r\n                      border: 1px solid var(--stroke-table, #E8EBED);\r\n                    //   background: url(<path-to-image>), lightgray 50% / cover no-repeat;\r\n                  }\r\n              }\r\n              a {\r\n                  color: $title-color;\r\n                  font-size: $font-size-14;\r\n                  font-weight: $font-weight-normal;\r\n                  line-height: normal;\r\n                  &.product-img{\r\n                      margin-right: 5px;\r\n                      flex-shrink: 0;\r\n                  }\r\n                  .info-img {\r\n                      margin-right: 8px;\r\n                      width: 16px;\r\n                      height: 16px;\r\n                  }\r\n                  &:hover {\r\n                      color: $primary;\r\n                      i {\r\n                          color: $primary;\r\n                      }\r\n                  }\r\n              }\r\n              .emp-name {\r\n                  line-height: 1;\r\n                  a {\r\n                      color: $secondary;\r\n                  }\r\n                  p {\r\n                      line-height: 2;\r\n                      font-size: $font-size-15;\r\n                      font-weight: $font-weight-medium;\r\n                      color: $text-color;\r\n                  }\r\n                  .role {\r\n                      line-height: unset;\r\n                  }\r\n              }\r\n              .product-imgs{\r\n                  display: -webkit-box;\r\n                  display: -ms-flexbox;\r\n                  display: flex;\r\n                  align-items: center;\r\n                  -webkit-box-align: center;\r\n                  -ms-flex-align: center;\r\n                  justify-content: center;\r\n                  -webkit-justify-content: center;\r\n                  -ms-flex-pack: center;\r\n                  width:40px;\r\n                  height:40px;\r\n                  background: #FFEBD8;\r\n                  font-size: $font-size-14;\r\n                  color: #FF9F43 !important;\r\n                  font-weight: $font-weight-medium;\r\n                  margin-right:10px;\r\n              }\r\n          }\r\n          .data-header {\r\n              font-weight: $font-weight-semibold;\r\n              color: $secondary;\r\n              font-size: $font-size-15;\r\n              border-bottom: none;\r\n          }\r\n          .ref-number {\r\n              color: $purple;\r\n          }\r\n          &.active{\r\n              border-bottom: 0;\r\n              td{\r\n                  font-size: $font-size-18;\r\n                  color: $gray-700;\r\n                  font-weight: $font-weight-semibold;\r\n                  border-bottom: 0;\r\n              }\r\n          }\r\n      }\r\n      .loss-highlight {\r\n          td {\r\n              font-weight: $font-weight-bold;\r\n              color: $secondary;\r\n              font-size: $font-size-base;\r\n              border-top: 1px solid $gray-300;\r\n          }\r\n      }\r\n      .userimgname {\r\n          display: -webkit-box;\r\n          display: -ms-flexbox;\r\n          display: flex;\r\n          align-items: center;\r\n          -webkit-box-align: center;\r\n          -ms-flex-align: center;\r\n          img {\r\n              margin-right: 8px;\r\n              border-radius: 6px;\r\n              \r\n          }\r\n      }\r\n      .purchase-count {\r\n          td {\r\n              padding-bottom: 20px;\r\n          }\r\n      }\r\n      \r\n  }\r\n  .Expense-list {\r\n     tr {\r\n      td {\r\n          padding: 15px 17px;\r\n          a {\r\n              margin-bottom: 0;\r\n          }\r\n      }\r\n     }\r\n  }\r\n  .sales-list {\r\n      tr {\r\n          td {\r\n              padding: 20px 17px;\r\n          }\r\n      }\r\n  }\r\n  .Expense-list-blk {\r\n      tr {\r\n          td {\r\n              padding: 20px 17px;\r\n          }\r\n      }\r\n  }\r\n  .userimgname .product-img {\r\n    display: inherit;\r\n    width: 35px;\r\n    height: 35px;\r\n    margin-right: 8px;\r\n  }\r\n  \r\n}\r\ntable {\r\n  tbody {\r\n      td {\r\n          &.action-table-data {\r\n              display: -webkit-box;\r\n              display: -ms-flexbox;\r\n              display: flex;\r\n              a {\r\n                  border: 1px solid rgba(145, 158, 171, 0.30);\r\n        background-color: $white;\r\n                  border-radius: 8px;\r\n                  display: -webkit-box;\r\n                  display: -ms-flexbox;\r\n                  display: flex;\r\n                  align-items: center;\r\n                  -webkit-box-align: center;\r\n                  -ms-flex-align: center;\r\n                  justify-content: center;\r\n                  -webkit-justify-content: center;\r\n                  -ms-flex-pack: center;\r\n                  padding: 8px;\r\n                  .feather-edit {\r\n                      color: $blue;\r\n                      width: 14px;\r\n                      height: 14px;\r\n                  }\r\n                  .action-edit {\r\n                     color: $text-color;\r\n                     width: 14px;\r\n                      height: 14px;\r\n                  }\r\n                  .feather-trash-2 {\r\n                      color: $danger;\r\n                      width: 14px;\r\n                      height: 14px;\r\n                  }\r\n                  .feather-eye {\r\n                      width: 14px;\r\n                      height: 14px;\r\n                  }\r\n                  .action-download {\r\n                      color: $blue;\r\n                      width: 14px;\r\n                      height: 14px;\r\n                      \r\n                  }\r\n                  .action-eye {\r\n                      color: $secondary;\r\n                      width: 14px;\r\n                      height: 14px;\r\n                  }\r\n              }\r\n             \r\n          }\r\n      }\r\n      .productimgname {\r\n          min-width: 200px;\r\n          a {\r\n              &.stock-img.product-img {\r\n                  display: -webkit-box;\r\n                  display: -ms-flexbox;\r\n                  display: flex;\r\n                  align-items: center;\r\n                  -webkit-box-align: center;\r\n                  -ms-flex-align: center;\r\n                  justify-content: center;\r\n                  -webkit-justify-content: center;\r\n                  -ms-flex-pack: center;\r\n                  margin-right: 8px;\r\n                  img {\r\n                      width: 50px;\r\n                      height: 50px;\r\n                      max-width: 100%;\r\n                      margin-right: 0;\r\n                  }\r\n              }\r\n          }\r\n      }\r\n  }\r\n  .edit-delete-action {\r\n      display: -webkit-box;\r\n      display: -ms-flexbox;\r\n      display: flex;\r\n      align-items: center;\r\n      -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n      justify-content: center;\r\n      -webkit-justify-content: center;\r\n      -ms-flex-pack: center;\r\n      height: 50px;\r\n      a {\r\n          padding: 0;\r\n      }\r\n\r\n  }\r\n  .edit-delete-action.data-view {\r\n      min-height: 52px;\r\n  }\r\n  .edit-delete-action.data-row {\r\n      height: auto;\r\n  }\r\n  .edit-delete-action.data {\r\n      height: 44px;\r\n  }\r\n}\r\n.custom-table {\r\n    table {\r\n        td {\r\n            ul {\r\n                &.social-links {\r\n                    li {\r\n                        a {\r\n                            width: 24px;\r\n                            height: 24px;\r\n                            border-radius: 50%;\r\n                            display: inline-flex;\r\n                            align-items: center;\r\n                            justify-content: center;\r\n                            margin-right: 5px;\r\n                            color: $text-color;\r\n                            &:hover {\r\n                                background: $light-900;\r\n                                color: $text-color;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}",".accordion-button {\r\n    background-color: $white;\r\n    color: $text-color;\r\n    padding: 0.75rem 1rem;\r\n    font-size: 0.85rem;\r\n    font-weight: $font-weight-medium;\r\n    &.accordion-custom-button {\r\n        &:after {\r\n            content: \"\\f054\";\r\n        }\r\n        &:not(.collapsed) {\r\n            color: $text-color;\r\n            background-color: $default-background;\r\n            box-shadow: none;\r\n            &:after {\r\n                content: \"\\f078\";\r\n                display: block;\r\n                transform: none;\r\n            }\r\n        }\r\n    }\r\n    &:not(.collapsed) {\r\n        color: $text-color;\r\n        background-color: $default-background;\r\n        box-shadow: none;\r\n    }\r\n    &:focus {\r\n        border-color: rgba($primary, 0.3);\r\n        box-shadow: none;\r\n    }\r\n    &:after,&:not(.collapsed)::after {\r\n        background-image: none;\r\n    }\r\n    &:after {\r\n        content: \"\\f078\";\r\n        font-family: $font-awesome;\r\n        font-size: $font-size-12;\r\n        line-height: 1;\r\n        background-color: $white;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        border-radius: 3.125rem;\r\n        color: $text-color;\r\n    }\r\n}    \r\n.accordion-body {\r\n    padding: 0.75rem 1rem;\r\n    font-size: 0.8125rem;\r\n    color: $text-muted;\r\n}\r\n.accordion-item {\r\n    color: $text-color;\r\n    background-color: $white;\r\n    border: 1px solid $light-900;\r\n}\r\n.accordions-items-seperate {\r\n    .accordion-item:not(:first-of-type) {\r\n        margin-block-start: 0.5rem;\r\n    }\r\n    .accordion-item {\r\n        border-block-start: 1px solid $light-900;\r\n        border-radius: $border-radius;\r\n        overflow: hidden;\r\n    }\r\n}\r\n.accordion-item:last-of-type {\r\n    border-bottom-right-radius: 0.35rem;\r\n    border-bottom-left-radius: 0.35rem;\r\n}\r\n.accordion-item:first-of-type {\r\n    border-top-left-radius: 0.35rem;\r\n    border-top-right-radius: 0.35rem;\r\n}\r\n.accordion {\r\n    &.accordion-primary {\r\n        .accordion-button {\r\n            background-color: rgba($primary, 0.1);\r\n            color: $primary;\r\n            &:after { \r\n                background-color: $primary;\r\n                color: $white;\r\n            }\r\n            &.collapsed {\r\n                background-color: $white;\r\n                color: $text-color;\r\n                &:after { \r\n                    background-color: $default-background;\r\n                    color: $text-color;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    &.accordion-secondary {\r\n        .accordion-button {\r\n            background-color: rgba($secondary,0.1);\r\n            color: $secondary;\r\n            &:after { \r\n                background-color: $secondary;\r\n                color: $white;\r\n            }\r\n            &.collapsed {\r\n                background-color: $white;\r\n                color: $text-color;\r\n                &:after { \r\n                    background-color: $default-background;\r\n                    color: $text-color;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    &.accordion-success {\r\n        .accordion-button {\r\n            background-color: rgba($success,0.1);\r\n            color: $success;\r\n            &:after { \r\n                background-color: $success;\r\n                color: $white;\r\n            }\r\n            &.collapsed {\r\n                background-color: $white;\r\n                color: $text-color;\r\n                &:after { \r\n                    background-color: $default-background;\r\n                    color: $text-color;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    &.accordion-danger {\r\n        .accordion-button {\r\n            background-color: rgba($danger,0.1);\r\n            color: $danger;\r\n            &:after { \r\n                background-color: $danger;\r\n                color: $white;\r\n            }\r\n            &.collapsed {\r\n                background-color: $white;\r\n                color: $text-color;\r\n                &:after { \r\n                    background-color: $default-background;\r\n                    color: $text-color;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    &.accordion-warning {\r\n        .accordion-button {\r\n            background-color: rgba($warning,0.1);\r\n            color: $warning;\r\n            &:after { \r\n                background-color: $warning;\r\n                color: $white;\r\n            }\r\n            &.collapsed {\r\n                background-color: $white;\r\n                color: $text-color;\r\n                &:after { \r\n                    background-color: $default-background;\r\n                    color: $text-color;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    &.accordion-info {\r\n        .accordion-button {\r\n            background-color: rgba($info,0.1);\r\n            color: $info;\r\n            &:after { \r\n                background-color: $info;\r\n                color: $white;\r\n            }\r\n            &.collapsed {\r\n                background-color: $white;\r\n                color: $text-color;\r\n                &:after { \r\n                    background-color: $default-background;\r\n                    color: $text-color;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.accordion {\r\n    &.accordion-solid-primary {\r\n        .accordion-button {\r\n            background-color: $primary;\r\n            color: $white;\r\n            &:after { \r\n                background-color: $white;\r\n                color: $primary;\r\n            }\r\n            &.collapsed {\r\n                background-color: $white;\r\n                color: $text-color;\r\n                &:after { \r\n                    background-color: $default-background;\r\n                    color: $text-color;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    &.accordion-solid-secondary {\r\n        .accordion-button {\r\n            background-color: $secondary;\r\n            color: $white;\r\n            &:after { \r\n                background-color: $white;\r\n                color: $secondary;\r\n            }\r\n            &.collapsed {\r\n                background-color: $white;\r\n                color: $text-color;\r\n                &:after { \r\n                    background-color: $default-background;\r\n                    color: $text-color;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    &.accordion-solid-success {\r\n        .accordion-button {\r\n            background-color: $success;\r\n            color: $white;\r\n            &:after { \r\n                background-color: $white;\r\n                color: $success;\r\n            }\r\n            &.collapsed {\r\n                background-color: $white;\r\n                color: $text-color;\r\n                &:after { \r\n                    background-color: $default-background;\r\n                    color: $text-color;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    &.accordion-solid-danger {\r\n        .accordion-button {\r\n            background-color: $danger;\r\n            color: $white;\r\n            &:after { \r\n                background-color: $white;\r\n                color: $danger;\r\n            }\r\n            &.collapsed {\r\n                background-color: $white;\r\n                color: $text-color;\r\n                &:after { \r\n                    background-color: $default-background;\r\n                    color: $text-color;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    &.accordion-solid-warning {\r\n        .accordion-button {\r\n            background-color: $warning;\r\n            color: $white;\r\n            &:after { \r\n                background-color: $white;\r\n                color: $warning;\r\n            }\r\n            &.collapsed {\r\n                background-color: $white;\r\n                color: $text-color;\r\n                &:after { \r\n                    background-color: $default-background;\r\n                    color: $text-color;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    &.accordion-solid-info {\r\n        .accordion-button {\r\n            background-color: $info;\r\n            color: $white;\r\n            &:after { \r\n                background-color: $white;\r\n                color: $info;\r\n            }\r\n            &.collapsed {\r\n                background-color: $white;\r\n                color: $text-color;\r\n                &:after { \r\n                    background-color: $default-background;\r\n                    color: $text-color;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.accordion {\r\n    &.accordion-border-primary {\r\n        .accordion-item {\r\n            border: 1px solid $primary;\r\n        }\r\n        .accordion-button {\r\n            background-color: $white;\r\n            color: $primary;\r\n            border-block-end: 0px;\r\n            &:after { \r\n                background-color: $white;\r\n                color: $primary;\r\n                border: 1px solid $primary;\r\n            }\r\n            &:not(.collapsed) {\r\n                border-block-end: 1px solid $primary;\r\n            }\r\n        }\r\n    }\r\n    &.accordion-border-secondary {\r\n        .accordion-item {\r\n            border: 1px solid $secondary;\r\n        }\r\n        .accordion-button {\r\n            background-color: $white;\r\n            color: $secondary;\r\n            border-block-end: 0px;\r\n            &:after { \r\n                background-color: $white;\r\n                color: $secondary;\r\n                border: 1px solid $secondary;\r\n            }\r\n            &:not(.collapsed) {\r\n                border-block-end: 1px solid $secondary;\r\n            }\r\n        }\r\n    }\r\n    &.accordion-border-success {\r\n        .accordion-item {\r\n            border: 1px solid $success;\r\n        }\r\n        .accordion-button {\r\n            background-color: $white;\r\n            color: $success;\r\n            border-block-end: 0px;\r\n            &:after { \r\n                background-color: $white;\r\n                color: $success;\r\n                border: 1px solid $success;\r\n            }\r\n            &:not(.collapsed) {\r\n                border-block-end: 1px solid $success;\r\n            }\r\n        }\r\n    }\r\n    &.accordion-border-danger {\r\n        .accordion-item {\r\n            border: 1px solid $danger;\r\n        }\r\n        .accordion-button {\r\n            background-color: $white;\r\n            color: $danger;\r\n            border-block-end: 0px;\r\n            &:after { \r\n                background-color: $white;\r\n                color: $danger;\r\n                border: 1px solid $danger;\r\n            }\r\n            &:not(.collapsed) {\r\n                border-block-end: 1px solid $danger;\r\n            }\r\n        }\r\n    }\r\n    &.accordion-border-warning {\r\n        .accordion-item {\r\n            border: 1px solid $warning;\r\n        }\r\n        .accordion-button {\r\n            background-color: $white;\r\n            color: $warning;\r\n            border-block-end: 0px;\r\n            &:after { \r\n                background-color: $white;\r\n                color: $warning;\r\n                border: 1px solid $warning;\r\n            }\r\n            &:not(.collapsed) {\r\n                border-block-end: 1px solid $warning;\r\n            }\r\n        }\r\n    }\r\n    &.accordion-border-info {\r\n        .accordion-item {\r\n            border: 1px solid $info;\r\n        }\r\n        .accordion-button {\r\n            background-color: $white;\r\n            color: $info;\r\n            border-block-end: 0px;\r\n            &:after { \r\n                background-color: $white;\r\n                color: $info;\r\n                border: 1px solid $info;\r\n            }\r\n            &:not(.collapsed) {\r\n                border-block-end: 1px solid $info;\r\n            }\r\n        }\r\n    }\r\n}\r\n.accordion {\r\n    &.accordionicon-none {\r\n        .accordion-button:after {\r\n            display: none;\r\n        }\r\n    }\r\n}\r\n.accordion {\r\n    &.accordionicon-left {\r\n        .accordion-button {\r\n            padding-inline-start: 2.5rem;\r\n            &:after {\r\n                position: absolute;\r\n                inset-inline-start: 0.625rem;\r\n            }\r\n        }\r\n    }\r\n}\r\n.accordion {\r\n    &.accordion-customicon1 {\r\n        .accordion-button {\r\n            &:after {\r\n                content: \"\\2b\";\r\n                font-family: $font-awesome;\r\n                background-color: $default-background;\r\n            }\r\n            &:not(.collapsed)::after {\r\n                content: \"\\f068\";\r\n\t\t\t\tfont-family: $font-awesome;\r\n                background-color: $white;\r\n            }\r\n        }\r\n    }\r\n}\r\n.customized-accordion {\r\n    .accordion-item{\r\n        &.custom-accordion-primary {\r\n            .accordion-button {\r\n                background-color: rgba($primary, 0.1);\r\n                border-inline-start: 0.25rem solid rgba($primary, 0.6);\r\n                &:after {\r\n                    background-color: rgba($primary, 0.6);\r\n                    color: $white;\r\n                }\r\n            }\r\n            .accordion-body {\r\n                background-color: rgba($primary, 0.1);\r\n                padding-block-start: 0;\r\n                border-inline-start: 0.25rem solid rgba($primary, 0.6);\r\n            }\r\n        }\r\n        &.custom-accordion-secondary {\r\n            .accordion-button {\r\n                background-color: rgba($secondary,0.1);\r\n                border-inline-start: 0.25rem solid rgba($secondary,0.6);\r\n                &:after {\r\n                    background-color: rgba($secondary,0.6);\r\n                    color: $white;\r\n                }\r\n            }\r\n            .accordion-body {\r\n                background-color: rgba($secondary,0.1);\r\n                padding-block-start: 0;\r\n                border-inline-start: 0.25rem solid rgba($secondary,0.6);\r\n            }\r\n        }\r\n        &.custom-accordion-warning {\r\n            .accordion-button {\r\n                background-color: rgba($warning,0.1);\r\n                border-inline-start: 0.25rem solid rgba($warning,0.6);\r\n                &:after {\r\n                    background-color: rgba($warning,0.6);\r\n                    color: $white;\r\n                }\r\n            }\r\n            .accordion-body {\r\n                background-color: rgba($warning,0.1);\r\n                padding-block-start: 0;\r\n                border-inline-start: 0.25rem solid rgba($warning,0.6);\r\n            }\r\n        }\r\n        &.custom-accordion-info {\r\n            .accordion-button {\r\n                background-color: rgba($info,0.1);\r\n                border-inline-start: 0.25rem solid rgba($info,0.6);\r\n                &:after {\r\n                    background-color: rgba($info,0.6);\r\n                    color: $white;\r\n                }\r\n            }\r\n            .accordion-body {\r\n                background-color: rgba($info,0.1);\r\n                padding-block-start: 0;\r\n                border-inline-start: 0.25rem solid rgba($info,0.6);\r\n            }\r\n        }\r\n        &.custom-accordion-success {\r\n            .accordion-button {\r\n                background-color: rgba($success,0.1);\r\n                border-inline-start: 0.25rem solid rgba($success,0.6);\r\n                &:after {\r\n                    background-color: rgba($success,0.6);\r\n                    color: $white;\r\n                }\r\n            }\r\n            .accordion-body {\r\n                background-color: rgba($success,0.1);\r\n                padding-block-start: 0;\r\n                border-inline-start: 0.25rem solid rgba($success,0.6);\r\n            }\r\n        }\r\n        &.custom-accordion-danger {\r\n            .accordion-button {\r\n                background-color: rgba($danger,0.1);\r\n                border-inline-start: 0.25rem solid rgba($danger,0.6);\r\n                &:after {\r\n                    background-color: rgba($danger,0.6);\r\n                    color: $white;\r\n                }\r\n            }\r\n            .accordion-body {\r\n                background-color: rgba($danger,0.1);\r\n                padding-block-start: 0;\r\n                border-inline-start: 0.25rem solid rgba($danger,0.6);\r\n            }\r\n        }\r\n    }\r\n}",".page-header-breadcrumb {\r\n  .breadcrumb-item+.breadcrumb-item::before {\r\n    content: var(--bs-breadcrumb-divider, \"\\ea65\");\r\n    font-family: \"tabler-icons\" !important;\r\n  }\r\n}\r\n[dir=\"rtl\"] {\r\n  .page-header-breadcrumb {\r\n    .breadcrumb-item+.breadcrumb-item::before {\r\n      content: var(--bs-breadcrumb-divider, \"\\ea64\");\r\n      font-family: \"tabler-icons\" !important;\r\n    }\r\n  }\r\n}\r\n.breadcrumb {\r\n  .breadcrumb-item {\r\n    a {\r\n      color: $text-muted;\r\n    }\r\n\r\n    &.active {\r\n      color: $primary;\r\n    }\r\n  }\r\n}\r\n.breadcrumb-item+.breadcrumb-item::before {\r\n  color: $text-muted;\r\n  opacity: 0.4;\r\n}\r\n.breadcrumb-arrow {\r\n  .breadcrumb-item+.breadcrumb-item::before {\r\n    color: $text-muted;\r\n    content: \"\\f101\";\r\n    font-family: $font-awesome !important;\r\n  }\r\n}\r\n.breadcrumb-pipe {\r\n  .breadcrumb-item+.breadcrumb-item::before {\r\n    color: $text-muted;\r\n    content: \"\\f061\";\r\n    font-family: $font-awesome !important;\r\n  }\r\n}\r\n.breadcrumb-line {\r\n  .breadcrumb-item+.breadcrumb-item::before {\r\n    color: $text-muted;\r\n    content: \"-\";\r\n  }\r\n}\r\n.breadcrumb-dot {\r\n  .breadcrumb-item+.breadcrumb-item::before {\r\n    color: $text-muted;\r\n    content: \"•\";\r\n  }\r\n}\r\n.breadcrumb-divide {\r\n  .breadcrumb-item+.breadcrumb-item::before {\r\n    color: $text-muted;\r\n    content: \"\\f054\";\r\n    font-family: $font-awesome !important;\r\n  }\r\n}\r\n.breadcrumb-separatorless {\r\n  .breadcrumb-item+.breadcrumb-item::before {\r\n    content: \"\";\r\n    display: none;\r\n  }\r\n}\r\n.breadcrumb-colored {\r\n  padding: 12px 15px;\r\n  border-radius: $border-radius;\r\n\tli {\r\n\t\ta {\r\n\t\t\tcolor: $white;\r\n\t\t}\r\n\t}\r\n\t.breadcrumb-item {\r\n    a {\r\n\t\t\tcolor: $white;\r\n    }\r\n\t\t&.active {\r\n\t\t\tcolor: $white;\r\n\t\t\topacity: 0.8;\r\n\t\t}\r\n\t\t& + .breadcrumb-item {\r\n      a {\r\n        color: $white;\r\n      }\r\n\t\t\t&::before {\r\n\t\t\t\tcolor: $white;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n.embedded-breadcrumb:before {\r\n  opacity: 0.7;\r\n}\r\n[data-theme-mode=\"dark\"] {\r\n  .embedded-breadcrumb:before {\r\n    filter: invert(1);\r\n  }\r\n}",".card {\r\n    margin-bottom: 24px;\r\n    background-color: $white;\r\n    transition: all .5s ease-in-out;\r\n    position: relative;\r\n    border-radius: $border-radius-lg;\r\n    border: 0;\r\n    box-shadow: $box-shadow-sm;\r\n    color: inherit;\r\n    .card-body {\r\n        padding: 1rem;\r\n    }\r\n    .card-title {\r\n        font-size: $font-size-18;\r\n        font-weight: $font-weight-bold;\r\n        text-transform: capitalize;\r\n    }\r\n    .card-header {\r\n        border-color: $light-900;\r\n        position: relative;\r\n        background: transparent;\r\n        padding: 1rem;\r\n        .card-title {\r\n            margin-bottom: 0rem;\r\n        }\r\n        .subtitle {\r\n            padding-top: 0.3125rem;\r\n            font-size: 0.875rem;\r\n            line-height: 1.5; \r\n        }\r\n    }\r\n    .card-footer {\r\n        border-color: $light-900;\r\n        background: transparent;\r\n        padding: 1rem 1.25rem 1rem;\r\n    }    \r\n}\r\n.card-group {\r\n  .card {    \r\n      margin-bottom: 1.5rem;\r\n  }\r\n}\r\n.card {\r\n  &.custom-card {\r\n  border-radius: $border-radius;\r\n  border: 0;\r\n  background-color: $white;\r\n  position: relative;\r\n  margin-block-end: 1.5rem;\r\n  width: 100%;\r\n  .card-header {\r\n    padding: 1rem 1.25rem;\r\n    background-color: transparent !important;\r\n    border-block-end: 1px solid $default-border;\r\n    display: flex;\r\n    align-items: center;\r\n    position: relative;\r\n    flex-wrap: wrap;\r\n    gap: 0.25rem;\r\n    &:first-child {\r\n      border-radius: 0.625rem 0.625rem 0 0;\r\n    }\r\n    .card-title {\r\n      position: relative;\r\n      margin-block-end: 0;\r\n      font-size: 0.9375rem;\r\n      font-weight: $font-weight-bold;\r\n      text-transform: capitalize;\r\n      .subtitle {\r\n        margin-block-end: 0;\r\n        text-transform: initial;\r\n      }\r\n    }\r\n  }\r\n  .card-footer {\r\n    background-color: transparent !important;\r\n    border-block-start: 1px solid $default-border;\r\n    padding: 1rem 1.5rem;\r\n    font-size: $font-size-base;\r\n  }\r\n  .card-body {\r\n    padding: 1.5rem;\r\n    color: $text-color;\r\n  }\r\n  .card-link {\r\n    font-size: 0.75rem;\r\n  }\r\n  }\r\n  .card-text {\r\n    font-size: 0.813rem;\r\n  }\r\n  .footer-card-icon {\r\n    width: 60px;\r\n    height: 60px;\r\n  }\r\n  &.overlay-card {\r\n    position: relative;\r\n    overflow: hidden;\r\n    color: rgba(255, 255, 255, 0.9);\r\n    .card-header {\r\n      border-block-end: 1px solid rgba(255, 255, 255, 0.1);\r\n    }\r\n    .card-footer {\r\n      border-block-start: 1px solid rgba(255, 255, 255, 0.1);\r\n    }\r\n    .over-content-bottom {\r\n      top: auto;\r\n    }\r\n    &:before {\r\n      content: \"\";\r\n      inset-inline-start: 0;\r\n      inset-inline-end: 0;\r\n      inset-block-start: 0;\r\n      inset-block-end: 0;\r\n      background-color: rgba(0, 0, 0, 0.2);\r\n      position: absolute;\r\n    }\r\n  }\r\n  &.card-bg-primary {\r\n    background-color: $primary;\r\n    color: $white;\r\n    .card-header {\r\n      background-color: rgba(255, 255, 255, 0.1) !important;\r\n      color: $white;\r\n      border-block-end: 1px solid rgba(255, 255, 255, 0.2);\r\n      &:before {\r\n        background-color: $white;\r\n      }\r\n    }\r\n    .card-body {\r\n      color: $white;\r\n    }\r\n    .card-footer {\r\n      background-color: rgba(255, 255, 255, 0.1) !important;\r\n      color: $white;\r\n      border-block-start: 1px solid rgba(255, 255, 255, 0.2);\r\n    }\r\n  }\r\n  &.card-bg-secondary {\r\n    background-color: $secondary;\r\n    color: $white;\r\n    .card-header {\r\n      background-color: rgba(255, 255, 255, 0.1) !important;\r\n      color: $white;\r\n      border-block-end: 1px solid rgba(255, 255, 255, 0.2);\r\n      &:before {\r\n        background-color: $white;\r\n      }\r\n    }\r\n    .card-body {\r\n      color: $white;\r\n    }\r\n    .card-footer {\r\n      background-color: rgba(255, 255, 255, 0.1) !important;\r\n      color: $white;\r\n      border-block-start: 1px solid rgba(255, 255, 255, 0.2);\r\n    }\r\n  }\r\n  &.card-bg-warning {\r\n    background-color: $warning;\r\n    color: $white;\r\n    .card-header {\r\n      background-color: rgba(255, 255, 255, 0.1) !important;\r\n      color: $white;\r\n      border-block-end: 1px solid rgba(255, 255, 255, 0.2);\r\n      &:before {\r\n        background-color: $white;\r\n      }\r\n    }\r\n    .card-body {\r\n      color: $white;\r\n    }\r\n    .card-footer {\r\n      background-color: rgba(255, 255, 255, 0.1) !important;\r\n      color: $white;\r\n      border-block-start: 1px solid rgba(255, 255, 255, 0.2);\r\n    }\r\n  }\r\n  &.card-bg-info {\r\n    background-color: $info;\r\n    color: $white;\r\n    .card-header {\r\n      background-color: rgba(255, 255, 255, 0.1) !important;\r\n      color: $white;\r\n      border-block-end: 1px solid rgba(255, 255, 255, 0.2);\r\n      &:before {\r\n        background-color: $white;\r\n      }\r\n    }\r\n    .card-body {\r\n      color: $white;\r\n    }\r\n    .card-footer {\r\n      background-color: rgba(255, 255, 255, 0.1) !important;\r\n      color: $white;\r\n      border-block-start: 1px solid rgba(255, 255, 255, 0.2);\r\n    }\r\n  }\r\n  &.card-bg-success {\r\n    background-color: $success;\r\n    color: $white;\r\n    .card-header {\r\n      background-color: rgba(255, 255, 255, 0.1) !important;\r\n      color: $white;\r\n      border-block-end: 1px solid rgba(255, 255, 255, 0.2);\r\n      &:before {\r\n        background-color: $white;\r\n      }\r\n    }\r\n    .card-body {\r\n      color: $white;\r\n    }\r\n    .card-footer {\r\n      background-color: rgba(255, 255, 255, 0.1) !important;\r\n      color: $white;\r\n      border-block-start: 1px solid rgba(255, 255, 255, 0.2);\r\n    }\r\n  }\r\n  &.card-bg-danger {\r\n    background-color: $danger;\r\n    color: $white;\r\n    .card-header {\r\n      background-color: rgba(255, 255, 255, 0.1) !important;\r\n      color: $white;\r\n      border-block-end: 1px solid rgba(255, 255, 255, 0.2);\r\n      &:before {\r\n        background-color: $white;\r\n      }\r\n    }\r\n    .card-body {\r\n      color: $white;\r\n    }\r\n    .card-footer {\r\n      background-color: rgba(255, 255, 255, 0.1) !important;\r\n      color: $white;\r\n      border-block-start: 1px solid rgba(255, 255, 255, 0.2);\r\n    }\r\n  }\r\n  &.card-bg-light {\r\n    background-color: $light;\r\n    color: $text-color;\r\n    .card-header {\r\n      background-color: rgba(0, 0, 0, 0.05) !important;\r\n      color: $text-color;\r\n      border-block-end: $default-border;\r\n    }\r\n    .card-body {\r\n      color: $text-color;\r\n    }\r\n    .card-footer {\r\n      background-color: rgba(0, 0, 0, 0.05) !important;\r\n      color: $text-color;\r\n      border-block-start: $default-border;\r\n    }\r\n  }\r\n  &.card-bg-dark {\r\n    background-color: $dark;\r\n    color: $white;\r\n    .card-header {\r\n      background-color: rgba(255, 255, 255, 0.1) !important;\r\n      color: $white;\r\n      border-block-end: 1px solid rgba(255, 255, 255, 0.2);\r\n      &:before {\r\n        background-color: $white;\r\n      }\r\n    }\r\n    .card-body {\r\n      color: $white;\r\n    }\r\n    .card-footer {\r\n      background-color: rgba(255, 255, 255, 0.1) !important;\r\n      color: $white;\r\n      border-block-start: 1px solid rgba(255, 255, 255, 0.2);\r\n    }\r\n  }\r\n  .card-anchor {\r\n    position: absolute;\r\n    top: 0;\r\n    inset-inline-end: 0;\r\n    bottom: 0;\r\n    inset-inline-start: 0;\r\n    z-index: 1;\r\n    pointer-events: auto;\r\n    content: \"\";\r\n  }\r\n  .collapse-close {\r\n    display: none;\r\n  }\r\n  &.card .collapsed {\r\n    .collapse-close {\r\n      display: block;\r\n    }\r\n    .collapse-open {\r\n      display: none;\r\n    }\r\n  }\r\n  &.card-fullscreen {\r\n    position: fixed;\r\n    top: 0;\r\n    inset-inline-start: 0;\r\n    inset-inline-start: 0;\r\n    bottom: 0;\r\n    z-index: 9999;\r\n    margin: 0;\r\n  }\r\n}\r\n.cals-icon {\r\n    font-size: $font-size-50;\r\n    color: $gray-500;\r\n}\r\n.callout {\r\n  padding: 1.25rem;\r\n  margin-block-start: 1.25rem;\r\n  margin-block-end: 1.25rem;\r\n  background-color: $light;\r\n  border-inline-start: 0.25rem solid $default-border;\r\n}\r\n.callout-info {\r\n  background-color: rgba($info, 0.075);\r\n  border-color: rgba($info, 0.5);\r\n}\r\n.callout-warning {\r\n  background-color: rgba($warning, 0.075);\r\n  border-color: rgba($warning, 0.5);\r\n}\r\n.callout-danger {\r\n  background-color: rgba($danger, 0.075);\r\n  border-color: rgba($danger, 0.5);\r\n}\r\n.btn-facebook {\r\n  background-color: $facebook;\r\n  color: $white;\r\n  border: 1px solid $facebook;\r\n  &:hover,\r\n  &:focus,\r\n  &:active {\r\n    background-color: $facebook !important;\r\n    color: $white !important;\r\n    border: 1px solid $facebook !important;\r\n  }\r\n}\r\n.btn-instagram {\r\n  background: #f09433;\r\n  background: -moz-linear-gradient(\r\n    45deg,\r\n    #f09433 0%,\r\n    #e6683c 25%,\r\n    #dc2743 50%,\r\n    #cc2366 75%,\r\n    #bc1888 100%\r\n  );\r\n  background: -webkit-linear-gradient(\r\n    45deg,\r\n    #f09433 0%,\r\n    #e6683c 25%,\r\n    #dc2743 50%,\r\n    #cc2366 75%,\r\n    #bc1888 100%\r\n  );\r\n  background: linear-gradient(\r\n    45deg,\r\n    #f09433 0%,\r\n    #e6683c 25%,\r\n    #dc2743 50%,\r\n    #cc2366 75%,\r\n    #bc1888 100%\r\n  );\r\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f09433', endColorstr='#bc1888',GradientType=1 );\r\n  color: $white;\r\n  border: 1px solid transparent;\r\n  &:hover,\r\n  &:focus,\r\n  &:active {\r\n    color: $white;\r\n    border: 1px solid transparent;\r\n  }\r\n}\r\n.btn-twitter {\r\n  background-color: $twitter;\r\n  color: $white;\r\n  border: 1px solid $twitter;\r\n  &:hover,\r\n  &:focus,\r\n  &:active {\r\n    background-color: $twitter !important;\r\n    color: $white !important;\r\n    border: 1px solid $twitter !important;\r\n  }\r\n}\r\n.btn-icon {\r\n    width: 2.313rem;\r\n    height: 2.313rem;\r\n    font-size: .95rem;\r\n    flex-shrink: 0;\r\n}\r\n.btn-wave {\r\n    display: inline-block !important;\r\n}\r\n\r\n@media (max-width: 575px) {\r\n  .overlay-card {\r\n      .card-text {\r\n          font-size: .613rem !important;\r\n      }\r\n  }\r\n}\r\n@media (max-width: 400px) {\r\n  .overlay-card {\r\n      .card-text {\r\n          font-size: .413rem !important;\r\n      }\r\n  }\r\n}",".tooltip {\r\n  @mixin tooltip-color($color) {\r\n    .tooltip-inner {\r\n      background-color: $color;\r\n    }\r\n    &.bs-tooltip-auto[data-popper-placement^=\"top\"] .tooltip-arrow::before,\r\n    &.bs-tooltip-top .tooltip-arrow::before {\r\n      border-top-color: $color;\r\n    }\r\n    &.bs-tooltip-auto[data-popper-placement^=\"right\"] .tooltip-arrow::before,\r\n    &.bs-tooltip-end .tooltip-arrow::before {\r\n      border-right-color: $color;\r\n    }\r\n    &.bs-tooltip-auto[data-popper-placement^=\"left\"] .tooltip-arrow::before,\r\n    &.bs-tooltip-start .tooltip-arrow::before {\r\n      border-left-color: $color;\r\n    }\r\n    &.bs-tooltip-auto[data-popper-placement^=\"bottom\"] .tooltip-arrow::before,\r\n    &.bs-tooltip-end .tooltip-arrow::before {\r\n      border-bottom-color: $color;\r\n    }\r\n  }\r\n  &.tooltip-primary {\r\n    @include tooltip-color($primary);\r\n  }\r\n  &.tooltip-secondary {\r\n    @include tooltip-color($secondary);\r\n  }\r\n  &.tooltip-warning {\r\n    @include tooltip-color($warning);\r\n  }\r\n  &.tooltip-info {\r\n    @include tooltip-color($info);\r\n  }\r\n  &.tooltip-success {\r\n    @include tooltip-color($success);\r\n  }\r\n  &.tooltip-danger {\r\n    @include tooltip-color($danger);\r\n  }\r\n  &.tooltip-dark {\r\n    @include tooltip-color($dark);\r\n    .tooltip-inner {\r\n      color: $white;\r\n    }\r\n  }\r\n  &.tooltip-light {\r\n    @include tooltip-color($light);\r\n    .tooltip-inner {\r\n      color: $text-color;\r\n    }\r\n  }\r\n}\r\n",".nav-item {\r\n    margin-inline-end: 0.5rem;\r\n    &:last-child {\r\n      margin-inline-end: 0;\r\n    }\r\n  }\r\n  .nav-link {\r\n    color: $text-color;\r\n    border-radius: $border-radius;\r\n    font-weight: $font-weight-semibold;\r\n    &.active {\r\n      background-color: rgba($primary,0.1);\r\n      color: $primary;\r\n    }\r\n  }\r\n  .navbar-brand {\r\n    color: $text-color;\r\n    &:focus ,&:hover {\r\n      color: $text-color;\r\n      opacity: 0.9;\r\n    }\r\n  }\r\n  .navbar-nav .nav-link.active,\r\n  .navbar-nav .show > .nav-link {\r\n    color: $primary;\r\n  }\r\n  .nav-link.disabled {\r\n    color: $text-color;\r\n    opacity: 0.3;\r\n  }\r\n  .nav-tabs .nav-link.disabled, .nav-tabs .nav-link:disabled {\r\n    color: rgba($dark,0.5);\r\n  }\r\n  .navbar-text {\r\n    color: $text-color;\r\n  }\r\n  .navbar-dark {\r\n    &.bg-dark {\r\n      .nav-link,\r\n      .navbar-brand {\r\n        color: $white;\r\n      }\r\n    }\r\n    .navbar-nav .nav-link.active,\r\n    .navbar-nav .show > .nav-link {\r\n      color: $white;\r\n    }\r\n  }\r\n  .nav-pills .nav-link.active,\r\n  .nav-pills .show > .nav-link {\r\n    color: $white;\r\n    background-color: $primary;\r\n  }\r\n\r\n.nav.nav-style-1 {\r\n  border: 0;\r\n  .nav-item {\r\n    margin-inline-end: 0.25rem;\r\n    &:last-child {\r\n      margin-inline-end: 0;\r\n    }\r\n  }\r\n  .nav-link {\r\n    &.active {\r\n        background-color: rgba($primary, 0.1);\r\n        color: $primary;\r\n        &:hover {        \r\n          background: rgba($primary, 0.1);\r\n        }\r\n    }\r\n    &:hover {        \r\n        background: transparent;\r\n        color: $primary;\r\n    }\r\n  }\r\n}\r\n.nav.nav-style-2 {\r\n  .nav-item .nav-link {\r\n    border-block-start: 3px solid transparent;\r\n    &.active {\r\n      background-color: rgba($primary, 0.1);\r\n      border-block-start: 3px solid $primary;\r\n      color: $primary;\r\n    }\r\n  }\r\n}\r\n.nav.nav-style-3 {\r\n  .nav-link {\r\n    border-radius: 0;\r\n  }\r\n  .nav-link {\r\n    border-block-end: 3px solid transparent;\r\n  }\r\n  .nav-link.active {\r\n    background-color: transparent;\r\n    border-block-end: 3px solid $primary;\r\n    color: $primary;\r\n  }\r\n}\r\n.nav.nav-style-4 {\r\n  border: 0;\r\n  .nav-link {\r\n    color: $text-muted;\r\n    border: 0;\r\n  }\r\n  .nav-link {\r\n    margin-bottom: 3px;\r\n    &.active {\r\n      background-color: $light;\r\n      color: $text-color;\r\n      border: 0;\r\n    }\r\n    &:hover,\r\n    &:focus {\r\n      border: 0;\r\n    }\r\n    &:hover {\r\n        background-color: $light;\r\n        color: $text-color;   \r\n    }\r\n  }\r\n}\r\n.nav-tabs.nav-style-5 {\r\n  border: 0;\r\n  .nav-link {\r\n    color: $text-muted;\r\n    border: 0;\r\n    margin-bottom: 3px;\r\n  }\r\n  .nav-link {\r\n    &.active {\r\n      background-color: $primary;\r\n      color: $white;\r\n      border: 0;\r\n    }\r\n    &:hover,\r\n    &:focus {\r\n      border: 0;\r\n      background-color: $primary;\r\n      color: $white;\r\n    }\r\n  }\r\n}\r\n.nav-style-6 {\r\n  border: 0;\r\n  &.nav-pills .nav-link {\r\n    &.active {\r\n      border: 1px solid $primary;\r\n      border-block-end: 2px solid $primary;\r\n      background-color: transparent;\r\n      color: $primary;\r\n    }\r\n  }\r\n}\r\n.nav-tabs-header {\r\n  border: 0 !important;\r\n  .nav-item {\r\n    margin-inline-end: 0.5rem;\r\n    &:last-child {\r\n      margin-inline-end: 0;\r\n    }\r\n    .nav-link {\r\n      border: 1px solid transparent;\r\n      font-size: 0.8rem;\r\n      padding: 0.4rem 0.5rem;\r\n      font-weight: $font-weight-medium;\r\n      &.active {\r\n        background: rgba($primary, 0.1);\r\n        color: $primary;\r\n        border: 1px solid transparent;\r\n      }\r\n      &:hover,&:focus {\r\n        border: 1px solid transparent;\r\n        background-color: transparent;\r\n        color: $primary;\r\n      } \r\n    }\r\n  }\r\n}\r\n.nav-tabs-footer {\r\n  border: 0;\r\n  .nav-item {\r\n    margin-inline-end: 0.5rem;\r\n    &:last-child {\r\n      margin-inline-end: 0;\r\n    }\r\n    .nav-link {\r\n      background-color: transparent;\r\n      color: $primary;\r\n      border: 1px solid $primary;\r\n      font-size: 0.8rem;\r\n      &.active {\r\n        background: $primary;\r\n        color: $white;\r\n        border: 1px solid $primary;\r\n      }\r\n      &:hover,&:focus {\r\n        border: 1px solid $primary;\r\n        background-color: transparent;\r\n         color: $primary;\r\n      } \r\n    }\r\n  }\r\n}\r\n.vertical-tabs-2 {\r\n  border: 0;\r\n  .nav-item {\r\n    margin-inline-end: 0.5rem;\r\n    &:last-child {\r\n      margin-inline-end: 0;\r\n    }\r\n    .nav-link {\r\n      min-width: 7.5rem;\r\n      max-width: 7.5rem;\r\n      text-align: center;\r\n      border: 1px solid $default-border;\r\n      margin-bottom: 0.5rem;\r\n      color: $text-muted;\r\n      background-color: $light;\r\n      i {\r\n        font-size: 1rem;\r\n      }\r\n      &.active {\r\n        background-color: $primary;\r\n        color: $white;\r\n        position: relative;\r\n        &:before {\r\n          content: \"\";\r\n          position: absolute;\r\n          inset-inline-end: -0.5rem;\r\n          inset-block-start: 38%;\r\n          transform: rotate(45deg);\r\n          width: 1rem;\r\n          height: 1rem;\r\n          background-color: $primary;\r\n        }\r\n        &:hover {\r\n          color: $white;\r\n        }\r\n      }\r\n      &:hover {\r\n        color: $primary;\r\n      }\r\n    }\r\n  }\r\n}\r\n.vertical-tabs-3 {\r\n  border: 0;\r\n  .nav-item {\r\n    border: 0;\r\n    margin-inline-end: 0.5rem;\r\n    &:last-child {\r\n      margin-inline-end: 0;\r\n    }\r\n    .nav-link {\r\n      min-width: 160px;\r\n      max-width: 160px;\r\n      border: 1px solid $primary;\r\n      padding: 1.3rem;\r\n      margin-block-end: 0.5rem;\r\n      i {\r\n        width: 2rem;\r\n        height: 2rem;\r\n        line-height: 2rem;\r\n        text-align: center;\r\n        font-size: 1rem;\r\n        background: $primary;\r\n        color: $white;\r\n        border-radius: 3.125rem;\r\n        font-weight: $font-weight-medium;\r\n      }\r\n      &.active {\r\n        background: $primary;\r\n        border: 1px solid $primary;\r\n        color: $white;\r\n        &:hover {\r\n          background: $primary;\r\n          border: 1px solid $primary;\r\n          color: $white;          \r\n        }\r\n        i {\r\n          background: $white;\r\n          color: $primary;\r\n        }\r\n      }\r\n      &:hover,&:focus {\r\n        border: 1px solid $primary;\r\n        color: $primary;\r\n          background: transparent;\r\n      }\r\n    }\r\n  }\r\n}\r\n.nav.tab-style-1 {\r\n  border-block-end: 0;\r\n  padding: 0.65rem;\r\n  background-color: $light;\r\n  border-radius: 7px;\r\n  margin-block-end: 1rem;\r\n  .nav-item {\r\n    margin-inline-end: 0.5rem;\r\n    &:last-child {\r\n      margin-inline-end: 0;\r\n    }\r\n  }\r\n  .nav-link {\r\n    border-radius: 7px;\r\n    padding: 0.35rem 1rem;\r\n    &.active {\r\n      background-color: $primary !important;\r\n      color: $white !important;\r\n      box-shadow: $box-shadow;\r\n      transition: color 0.15s ease-in;\r\n    }\r\n  }\r\n}\r\n.nav-tabs.tab-style-1 {\r\n    .nav-link {\r\n        &:hover {\r\n        background: transparent;\r\n        color: $primary;\r\n      }  \r\n\r\n    }\r\n\r\n}\r\n.tab-style-2 {\r\n  border-block-end: 0;\r\n  .nav-item {\r\n    margin-inline-end: 0.5rem;\r\n    &:last-child {\r\n      margin-inline-end: 0;\r\n    }\r\n    .nav-link {\r\n      border: 0;\r\n      i { \r\n        width: 1.875rem;\r\n        height: 1.875rem;\r\n        padding: 0.4rem;\r\n        border-radius: 50px;\r\n        background-color: $light;\r\n        color: $text-color;\r\n        display: inline-block;\r\n      }\r\n      &:hover {\r\n        border: 0;\r\n        background: transparent;\r\n        color: $primary;\r\n        i {\r\n          color: $primary;          \r\n        }\r\n      }\r\n      &.active {\r\n        background-color: transparent;\r\n        position: relative;\r\n        border: 0;\r\n        color: $primary;\r\n        i { \r\n          background-color: rgba($primary, 0.1);\r\n          color: $primary;\r\n        }\r\n        &:before {\r\n          content: \"\";\r\n          position: absolute;\r\n          inset-inline-start: 0;\r\n          inset-inline-end: 0;\r\n          inset-block-end: 0;\r\n          width: 100%;\r\n          height: 0.175rem;\r\n          background-color: $primary;\r\n          border-radius: 50px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n.tab-style-3 {\r\n  border-block-end: 0;\r\n  .nav-item {\r\n    position: relative;\r\n    margin-inline-end: 0.5rem;\r\n    &:last-child {\r\n      margin-inline-end: 0;\r\n    }\r\n    .nav-link {\r\n      position: relative;\r\n      border: 0;\r\n      font-size: 0.75rem;\r\n      &:before {\r\n        position: absolute;\r\n        content: \"\";\r\n        inset-block-end: -1.063rem;\r\n        inset-inline-end: 0;\r\n        inset-inline-start: 0;\r\n        width: 100%;\r\n        height: 0.1rem;\r\n        background-color: $light;\r\n        border-radius: 50%;\r\n      }\r\n      &:after {\r\n        position: absolute;\r\n        content: \"\";\r\n        inset-block-end: -2rem;\r\n        inset-inline-start: 1.75rem;\r\n        inset-inline-end: 0;\r\n        inset-inline-start: 30%;\r\n        width: 2rem;\r\n        height: 2rem;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        background-color: $white;\r\n        border-radius: 50%;\r\n        border: 2px solid $default-border;\r\n      }\r\n      &.home:after {\r\n        content: \"1\";\r\n      }\r\n      &.about:after {\r\n        content: \"2\";\r\n      }\r\n      &.services:after {\r\n        content: \"3\";\r\n      }\r\n      &:hover {\r\n        border: 0;\r\n        background: transparent;\r\n        color: $primary;\r\n      }\r\n      &.active {\r\n        background-color: transparent;\r\n        border: 0;\r\n        color: $primary;\r\n        &:before {\r\n          background-color: $primary;\r\n        }\r\n        &:after {\r\n          border-color: $primary;\r\n          color: $primary;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n.tab-style-4 {\r\n  &.nav-tabs {\r\n    border: 0;\r\n    .nav-item {\r\n      margin-inline-end: 0.5rem;\r\n      &:last-child {\r\n        margin-inline-end: 0;\r\n      }\r\n    }\r\n    .nav-link {\r\n      border: 0;\r\n      &:hover {\r\n        border: 0;\r\n        background: transparent;\r\n        color: $primary;\r\n      }\r\n      &.active {\r\n        background-color: transparent;\r\n        border: 0;\r\n        color: $primary;\r\n        position: relative;\r\n        overflow: hidden;\r\n        &::before {\r\n          position: absolute;\r\n          content: \"\";\r\n          width: 0.75rem;\r\n          inset-block-start: 31px;\r\n          transform: rotate(45deg);\r\n          inset-inline-start: 47%;\r\n          overflow: hidden;\r\n          z-index: 1;\r\n          height: 0.75rem;\r\n          background-color: $primary;\r\n          border: 1px solid $primary;\r\n        }\r\n        &:after {\r\n          position: absolute;\r\n          content: \"\";\r\n          width: 40%;\r\n          height: 1px;\r\n          inset-inline-start: 30%;\r\n          inset-block-end: 0;\r\n          background-color: $primary;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n#tab-style-4 .tab-pane.active {\r\n  border: 1px solid $primary;\r\n  background-color: $primary;\r\n  color: $white;\r\n  padding: 16px;\r\n    border-radius: 7px;\r\n}\r\n.tab-style-5 {\r\n  .nav-item {\r\n    margin-inline-end: 0.5rem;\r\n    &:last-child {\r\n      margin-inline-end: 0;\r\n    }\r\n    .nav-link.active {\r\n      background: $primary;\r\n    }\r\n  }\r\n}\r\n.tab-style-6 {\r\n  border: 0;\r\n  background-color: $white;\r\n  border-radius: 7px;\r\n  color: $primary;\r\n  padding: 0.5rem;\r\n  .nav-item {\r\n    border: 0;\r\n    margin-inline-end: 0.5rem;\r\n    &:last-child {\r\n      margin-inline-end: 0;\r\n    }\r\n    .nav-link {\r\n      color: $primary;\r\n      padding: 0.5rem 1rem;\r\n      font-size: 0.813rem;\r\n      border: 0;\r\n      font-weight: $font-weight-medium;\r\n      display: -webkit-box;\r\n      display: -ms-flexbox;\r\n      display: flex;\r\n      align-items: center;\r\n      -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n      &.active {\r\n        border: 0;\r\n        background-color: $primary;\r\n        color: $white;\r\n        border: 0;\r\n        box-shadow: 0px 3px 10px 0px rgba(var(--dark-rgb),0.05);\r\n      }\r\n      &:hover,\r\n      &:focus {\r\n        border: 0;\r\n      }\r\n    }\r\n  }\r\n}\r\n.tab-style-7 {\r\n  .nav-link {\r\n    margin-block-end: 0.5rem;\r\n    font-size: 0.813rem;\r\n    color: $text-muted;\r\n    text-align: left;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    align-items: center;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    &:active,\r\n    &.active {\r\n      background-color: rgba($primary, 0.1);\r\n      color: $primary;\r\n    }\r\n  }\r\n}\r\n.nav-style-1 {\r\n  .nav-item {\r\n    .nav-link {\r\n      &.active {\r\n        background-color: rgba($primary, 0.1);\r\n        color: $primary;\r\n      }\r\n    }\r\n  }\r\n}\r\n@media screen and (max-width:400px) {\r\n  .tab-style-4 {\r\n    .nav-link{\r\n      padding-inline: 0.5rem;\r\n    }\r\n  }\r\n}\r\n\r\n.nav-tabs {\r\n    border-bottom: 0;\r\n    &.nav-tabs-bottom {\r\n        li {\r\n            margin-bottom: -1px;\r\n        }\r\n    }\r\n    .nav-link {\r\n        margin-bottom: -1px;\r\n        background: 0 0;\r\n        border: 1px solid transparent;\r\n        border-top-left-radius: 0.25rem;\r\n        border-top-right-radius: 0.25rem;\r\n        &.active {\r\n          border-color: $gray-300;\r\n        }\r\n    }\r\n    li{\r\n        a{\r\n            color: $gray-600;\r\n            border-bottom-width: 2px;\r\n            &.active{\r\n                border-color: transparent;\r\n                border-bottom-color: $primary;\r\n                background-color: transparent;\r\n                @include transition(all 0.2s ease);\r\n            }\r\n        }\r\n    }\r\n}\r\n.nav-tabs{\r\n    .nav-tabs-solid {\r\n        background-color: $white;\r\n        border: 0;\r\n        .active{\r\n            background-color: $primary;\r\n            border-color: $primary;\r\n            color: $white;\r\n        }\r\n    }\r\n}\r\n.nav-tabs{\r\n    .nav-link{\r\n        &:hover{\r\n            border-color: transparent;\r\n            color: $primary;\r\n        }\r\n    }\r\n    &.nav-tabs-top{\r\n        li{\r\n            a{\r\n                border-width: 2px 0 0 0;\r\n                &.active{\r\n                    border-top-color: $primary;                    \r\n                    @include rounded(0);\r\n                }\r\n                &:hover {\r\n                    border-top-color: $primary;  \r\n                    background-color: transparent;                    \r\n                    @include rounded(0);\r\n                }\r\n            }\r\n        }\r\n    }\r\n    &.nav-tabs-bottom{\r\n        li{\r\n            a{\r\n                border-width:0 0 2px  0;\r\n                &.active, &:hover {\r\n                    border-bottom-color: $primary;\r\n                    background: transparent;\r\n                    @include rounded(0);\r\n                }\r\n            }\r\n        }\r\n    }\r\n    &.nav-tabs-solid{\r\n        background-color: $white;\r\n        border: 0;\r\n        &.nav-tabs-rounded{\r\n            li{\r\n                a{\r\n                    &.active {\r\n                        background-color: $primary;\r\n                        border-color: $primary;\r\n                        color: $white;\r\n                        @include rounded(50px);\r\n                    }\r\n                }\r\n            }  \r\n        }\r\n        li{\r\n            a{\r\n                &.active{\r\n                    background-color: $primary;\r\n                    border-color: $primary;\r\n                    color: $white;\r\n                    @include rounded(0);\r\n                }\r\n            }\r\n        }   \r\n    }\r\n}\r\n.nav-link{\r\n    &:hover{\r\n        color: $primary;\r\n    }\r\n}\r\n.page-menu{\r\n    .nav-tabs {\r\n        li{\r\n            a{\r\n                font-size: $font-size-16;\r\n            }\r\n        }\r\n    }\r\n}\r\n.tabs-set{\r\n    .nav-tabs {\r\n        border-bottom: 0;\r\n        margin-bottom: 20px;\r\n        .nav-link{\r\n            color: $secondary;\r\n            @include margin-padding(null, 8px 15px);\r\n            font-size: $font-size-16;\r\n            font-weight: $font-weight-bold;\r\n            border: 0;\r\n            min-width: 120px;\r\n            margin-right: 10px;\r\n            border-radius: 8px;\r\n            background: var(--Stroke, rgba(145, 158, 171, 0.30));\r\n            @include margin-padding(null, null);\r\n            &:focus{\r\n                border-color: transparent;\r\n            }\r\n            &:hover{\r\n                border-color: transparent;\r\n            }\r\n            &.active{\r\n                border:0;\r\n                border-bottom:2px solid $primary;\r\n                background: $primary;\r\n                color: $white;\r\n            }\r\n        }\r\n    }\r\n}\r\n.tabs-sets{\r\n    .nav-tabs {\r\n        border-bottom: 0;\r\n        @include margin-padding(0 0 40px, null);\r\n        .nav-link{\r\n            color: $black;;\r\n            font-size: $font-size-base;\r\n            font-weight: $font-weight-bold;\r\n            border: 0;\r\n            background: $gray-300;\r\n            margin-right:10px;\r\n            @include margin-padding(null, 8px 15px);\r\n            @include rounded(8px);\r\n            @include transition(all 0.5s ease);\r\n            &:focus, &:hover, &.active{\r\n                background: $primary;\r\n                color: $white;\r\n            }\r\n        }\r\n    }\r\n}\r\n@include respond-below(custom768) {\r\n    .nav-tabs {\r\n        border-bottom: 0;\r\n        position: relative;\r\n        background-color: $white;\r\n        @include margin-padding(null, 5px 0);\r\n        @include rounded(3px);\r\n    }\r\n}",".ribbon1 {\r\n  position: absolute;\r\n  inset-block-start: -6.1px;\r\n  inset-inline-end: 10px;\r\n  color: $white;\r\n  z-index: 1;\r\n  &:after {\r\n    position: absolute;\r\n    content: \"\";\r\n    width: 0;\r\n    height: 0;\r\n    border-inline-start: 20px solid transparent;\r\n    border-inline-end: 24px solid transparent;\r\n    border-block-start: 13px solid $danger;\r\n  }\r\n  span {\r\n    position: relative;\r\n    display: block;\r\n    text-align: center;\r\n    background: $danger;\r\n    font-size: $font-size-14;\r\n    line-height: 1;\r\n    padding: 12px 8px 10px;\r\n    border-start-end-radius: 8px;\r\n    &:before,\r\n    &:after {\r\n      position: absolute;\r\n      content: \"\";\r\n    }\r\n    &:before {\r\n      height: 6px;\r\n      width: 6px;\r\n      inset-inline-start: -6px;\r\n      inset-block-start: 0;\r\n      background: $danger;\r\n    }\r\n    &:after {\r\n      height: 6px;\r\n      width: 8px;\r\n      inset-inline-start: -8px;\r\n      inset-block-start: 0;\r\n      border-radius: 8px 8px 0 0;\r\n      background: $danger;\r\n    }\r\n  }\r\n}\r\n.ribbone {\r\n  width: 100%;\r\n  position: relative;\r\n  background-size: cover;\r\n  text-transform: uppercase;\r\n  color: $white;\r\n  width: 150px;\r\n  height: 150px;\r\n  overflow: hidden;\r\n  position: absolute;\r\n  z-index: 6;\r\n  &::after {\r\n    position: absolute;\r\n    z-index: -1;\r\n    content: \"\";\r\n    display: block;\r\n    border: 5px solid;\r\n  }\r\n  &::before {\r\n    position: absolute;\r\n    z-index: -1;\r\n    content: \"\";\r\n    display: block;\r\n    border: 5px solid;\r\n  }\r\n  span {\r\n    position: absolute;\r\n    display: block;\r\n    width: 225px;\r\n    padding: 3px 0;\r\n    box-shadow: 0 5px 10px rgba(0,0,0, 0.1);\r\n    color: $white;\r\n    text-shadow: 0 1px 1px rgba(0,0,0, 0.1);\r\n    text-transform: capitalize;\r\n    text-align: center;\r\n    font-size: 11px;\r\n  }\r\n}\r\n.ribbone1 {\r\n  position: absolute;\r\n  inset-block-start: -6.1px;\r\n  inset-inline-start: 10px;\r\n  z-index: 1;\r\n  &:after {\r\n    position: absolute;\r\n    content: \"\";\r\n    width: 0;\r\n    height: 0;\r\n    border-inline-start: 20px solid transparent;\r\n    border-inline-end: 24px solid transparent;\r\n    border-block-start: 13px solid $danger;\r\n  }\r\n  span {\r\n    position: relative;\r\n    display: block;\r\n    text-align: center;\r\n    background: $danger;\r\n    font-size: $font-size-14;\r\n    line-height: 1;\r\n    padding: 12px 8px 10px;\r\n    border-start-end-radius: 8px;\r\n    &:after {\r\n      position: absolute;\r\n      content: \"\";\r\n      height: 6px;\r\n      width: 8px;\r\n      inset-inline-start: -8px;\r\n      inset-block-start: 0;\r\n      border-radius: 8px 8px 0 0;\r\n      background: $danger;\r\n    }\r\n    &:before {\r\n      position: absolute;\r\n      content: \"\";\r\n      height: 6px;\r\n      width: 6px;\r\n      inset-inline-start: -6px;\r\n      inset-block-start: 0;\r\n      background: $danger;\r\n    }\r\n  }\r\n}\r\n.arrow-ribbone-left {\r\n  color: $white;\r\n  padding: 2px 8px;\r\n  position: absolute;\r\n  inset-block-start: 10px;\r\n  inset-inline-start: 0;\r\n  z-index: 6;\r\n  font-size: 13px;\r\n}\r\n.arrow-ribbone-left.bg-purple {\r\n  &:before {\r\n    position: absolute;\r\n    inset-inline-end: 0;\r\n    inset-block-start: 0;\r\n    inset-block-end: 0;\r\n    content: \"\";\r\n    inset-inline-end: -12px;\r\n    border-block-start: 12px solid transparent;\r\n    border-inline-start: 12px solid $purple;\r\n    border-block-end: 11px solid transparent;\r\n    width: 0;\r\n  }\r\n}\r\n.arrow-ribbone-left.bg-danger {\r\n  &:before {\r\n    position: absolute;\r\n    inset-inline-end: 0;\r\n    inset-block-start: 0;\r\n    inset-block-end: 0;\r\n    content: \"\";\r\n    inset-inline-end: -12px;\r\n    border-block-start: 112px solid transparent;\r\n    border-inline-start: 12px solid $danger;\r\n    border-block-end: 11px solid transparent;\r\n    width: 0;\r\n  }\r\n}\r\n.arrow-ribbone-left.bg-primary {\r\n  &:before {\r\n    position: absolute;\r\n    inset-inline-end: 0;\r\n    inset-block-start: 0;\r\n    inset-block-end: 0;\r\n    content: \"\";\r\n    inset-inline-end: -12px;\r\n    border-block-start: 12px solid transparent;\r\n    border-block-end: 11px solid transparent;\r\n    width: 0;\r\n  }\r\n}\r\n.arrow-ribbone-left.bg-secondary {\r\n  &:before {\r\n    position: absolute;\r\n    inset-inline-end: 0;\r\n    inset-block-start: 0;\r\n    inset-block-end: 0;\r\n    content: \"\";\r\n    inset-inline-end: -12px;\r\n    border-block-start: 12px solid transparent;\r\n    border-inline-start: 12px solid $secondary;\r\n    border-block-end: 11px solid transparent;\r\n    width: 0;\r\n  }\r\n}\r\n.arrow-ribbone-left.bg-success {\r\n  &:before {\r\n    position: absolute;\r\n    inset-inline-end: 0;\r\n    inset-block-start: 0;\r\n    inset-block-end: 0;\r\n    content: \"\";\r\n    inset-inline-end: -12px;\r\n    border-block-start: 12px solid transparent;\r\n    border-inline-start: 12px solid $primary;\r\n    border-block-end: 11px solid transparent;\r\n    width: 0;\r\n  }\r\n}\r\n.arrow-ribbone-left.bg-info {\r\n  &:before {\r\n    position: absolute;\r\n    inset-inline-end: 0;\r\n    inset-block-start: 0;\r\n    inset-block-end: 0;\r\n    content: \"\";\r\n    inset-inline-end: -12px;\r\n    border-block-start: 12px solid transparent;\r\n    border-inline-start: 12px solid $info;\r\n    border-block-end: 11px solid transparent;\r\n    width: 0;\r\n  }\r\n}\r\n.arrow-ribbone-left.bg-warning {\r\n  &:before {\r\n    position: absolute;\r\n    inset-inline-end: 0;\r\n    inset-block-start: 0;\r\n    inset-block-end: 0;\r\n    content: \"\";\r\n    inset-inline-end: -12px;\r\n    border-block-start: 12px solid transparent;\r\n    border-inline-start: 12px solid $warning;\r\n    border-block-end: 11px solid transparent;\r\n    width: 0;\r\n  }\r\n}\r\n.arrow-ribbone-left.bg-pink {\r\n  &:before {\r\n    position: absolute;\r\n    inset-inline-end: 0;\r\n    inset-block-start: 0;\r\n    inset-block-end: 0;\r\n    content: \"\";\r\n    inset-inline-end: -12px;\r\n    border-block-start: 12px solid transparent;\r\n    border-inline-start: 12px solid $pink;\r\n    border-block-end: 11px solid transparent;\r\n    width: 0;\r\n  }\r\n}\r\n.arrow-ribbone-left.bg-teal {\r\n  &:before {\r\n    position: absolute;\r\n    inset-inline-start: 0;\r\n    inset-block-start: 0;\r\n    inset-block-end: 0;\r\n    content: \"\";\r\n    inset-inline-start: -12px;\r\n    border-block-start: 12px solid transparent;\r\n    border-inline-end: 12px solid $teal;\r\n    border-block-end: 11px solid transparent;\r\n    width: 0;\r\n  }\r\n}\r\n.arrow-ribbone-right {\r\n  color: $white;\r\n  padding: 2px 8px;\r\n  position: absolute;\r\n  inset-block-start: 10px;\r\n  inset-inline-end: 0;\r\n  z-index: 6;\r\n  font-size: 13px;\r\n}\r\n.arrow-ribbone-right.bg-purple {\r\n  &:before {\r\n    position: absolute;\r\n    inset-inline-start: 0;\r\n    inset-block-start: 0;\r\n    inset-block-end: 0;\r\n    content: \"\";\r\n    inset-inline-start: -12px;\r\n    border-block-start: 12px solid transparent;\r\n    border-inline-end: 12px solid $purple;\r\n    border-block-end: 11px solid transparent;\r\n    width: 0;\r\n  }\r\n}\r\n.arrow-ribbone-right.bg-danger {\r\n  &:before {\r\n    position: absolute;\r\n    inset-inline-start: 0;\r\n    inset-block-start: 0;\r\n    inset-block-end: 0;\r\n    content: \"\";\r\n    inset-inline-start: -12px;\r\n    border-block-start: 12px solid transparent;\r\n    border-inline-end: 12px solid $danger;\r\n    border-block-end: 11px solid transparent;\r\n    width: 0;\r\n  }\r\n}\r\n.arrow-ribbone-right.bg-primary {\r\n  &:before {\r\n    position: absolute;\r\n    inset-inline-start: 0;\r\n    inset-block-start: 0;\r\n    inset-block-end: 0;\r\n    content: \"\";\r\n    inset-inline-start: -12px;\r\n    border-block-start: 12px solid transparent;\r\n    border-block-end: 11px solid transparent;\r\n    width: 0;\r\n  }\r\n}\r\n.arrow-ribbone-right.bg-secondary {\r\n  &:before {\r\n    position: absolute;\r\n    inset-inline-start: 0;\r\n    inset-block-start: 0;\r\n    inset-block-end: 0;\r\n    content: \"\";\r\n    inset-inline-start: -12px;\r\n    border-block-start: 12px solid transparent;\r\n    border-inline-end: 12px solid $secondary;\r\n    border-block-end: 11px solid transparent;\r\n    width: 0;\r\n  }\r\n}\r\n.arrow-ribbone-right.bg-success {\r\n  &:before {\r\n    position: absolute;\r\n    inset-inline-start: 0;\r\n    inset-block-start: 0;\r\n    inset-block-end: 0;\r\n    content: \"\";\r\n    inset-inline-start: -12px;\r\n    border-block-start: 12px solid transparent;\r\n    border-inline-end: 12px solid $primary;\r\n    border-block-end: 11px solid transparent;\r\n    width: 0;\r\n  }\r\n}\r\n.arrow-ribbone-right.bg-info {\r\n  &:before {\r\n    position: absolute;\r\n    inset-inline-start: 0;\r\n    inset-block-start: 0;\r\n    inset-block-end: 0;\r\n    content: \"\";\r\n    inset-inline-start: -12px;\r\n    border-block-start: 12px solid transparent;\r\n    border-inline-end: 12px solid $info;\r\n    border-block-end: 11px solid transparent;\r\n    width: 0;\r\n  }\r\n}\r\n.arrow-ribbone-right.bg-warning {\r\n  &:before {\r\n    position: absolute;\r\n    inset-inline-start: 0;\r\n    inset-block-start: 0;\r\n    inset-block-end: 0;\r\n    content: \"\";\r\n    inset-inline-start: -12px;\r\n    border-block-start: 12px solid transparent;\r\n    border-inline-end: 12px solid $warning;\r\n    border-block-end: 11px solid transparent;\r\n    width: 0;\r\n  }\r\n}\r\n.arrow-ribbone-right.bg-pink {\r\n  &:before {\r\n    position: absolute;\r\n    inset-inline-start: 0;\r\n    inset-block-start: 0;\r\n    inset-block-end: 0;\r\n    content: \"\";\r\n    inset-inline-start: -12px;\r\n    border-block-start: 12px solid transparent;\r\n    border-inline-end: 12px solid $pink;\r\n    border-block-end: 11px solid transparent;\r\n    width: 0;\r\n  }\r\n}\r\n.arrow-ribbone-right.bg-teal {\r\n  &:before {\r\n    position: absolute;\r\n    inset-inline-start: 0;\r\n    inset-block-start: 0;\r\n    inset-block-end: 0;\r\n    content: \"\";\r\n    inset-inline-start: -12px;\r\n    border-block-start: 12px solid transparent;\r\n    border-inline-end: 12px solid $teal;\r\n    border-block-end: 11px solid transparent;\r\n    width: 0;\r\n  }\r\n}\r\n.arrow-ribbone2 {\r\n  color: $white;\r\n  padding: 3px 8px;\r\n  position: absolute;\r\n  inset-block-start: 10px;\r\n  inset-inline-start: -1px;\r\n  z-index: 6;\r\n  font-size: $font-size-30;\r\n  &:before {\r\n    position: absolute;\r\n    inset-inline-end: 0;\r\n    inset-block-start: 0;\r\n    inset-block-end: 0;\r\n    content: \"\";\r\n    inset-inline-end: -24px;\r\n    border-block-start: 24px solid transparent;\r\n    border-block-end: 24px solid transparent;\r\n    width: 0;\r\n  }\r\n}\r\n.power-ribbone {\r\n  width: 56px;\r\n  height: 56px;\r\n  overflow: hidden;\r\n  position: absolute;\r\n  z-index: 6;\r\n  span {\r\n    position: absolute;\r\n    display: block;\r\n    width: 82px;\r\n    padding: 8px 0;\r\n    color: $white;\r\n    font: 500 16px/1 Lato, sans-serif;\r\n    text-shadow: 0 1px 1px rgba(0,0,0, 0.1);\r\n    text-transform: capitalize;\r\n    text-align: center;\r\n  }\r\n}\r\n.power-ribbone-top-left {\r\n  inset-block-start: -6px;\r\n  inset-inline-start: -9px;\r\n  span {\r\n    inset-inline-end: -5px;\r\n    inset-block-start: 1px;\r\n    transform: rotate(-45deg);\r\n    i {\r\n      transform: rotate(45deg);\r\n      padding-block-start: 2px;\r\n      padding-inline-start: 7px;\r\n    }\r\n  }\r\n}\r\n.power-ribbone-bottom-left {\r\n  inset-block-end: -6px;\r\n  inset-inline-start: -9px;\r\n  span {\r\n    inset-inline-end: -5px;\r\n    inset-block-end: 1px;\r\n    transform: rotate(45deg);\r\n    i {\r\n      transform: rotate(-45deg);\r\n      padding-block-end: 2px;\r\n      padding-inline-start: 7px;\r\n    }\r\n  }\r\n}\r\n.power-ribbone-top-right {\r\n  inset-block-start: -6px;\r\n  inset-inline-end: -9px;\r\n  span {\r\n    inset-inline-start: -5px;\r\n    inset-block-start: 1px;\r\n    transform: rotate(45deg);\r\n    i {\r\n      transform: rotate(-45deg);\r\n      padding-block-start: 2px;\r\n      padding-inline-end: 7px;\r\n    }\r\n  }\r\n}\r\n.power-ribbone-bottom-right {\r\n  inset-block-end: -6px;\r\n  inset-inline-end: -9px;\r\n  span {\r\n    inset-inline-start: -5px;\r\n    inset-block-end: 1px;\r\n    transform: rotate(-45deg);\r\n    i {\r\n      transform: rotate(45deg);\r\n      padding-block-end: 2px;\r\n      padding-inline-end: 7px;\r\n    }\r\n  }\r\n}\r\n.ribbone-top-left {\r\n  inset-block-start: -10px;\r\n  inset-inline-start: -10px;\r\n  &::after {\r\n    border-block-start-color: transparent;\r\n    border-inline-start-color: transparent;\r\n    inset-block-end: 50px;\r\n    inset-inline-start: 0;\r\n  }\r\n  &::before {\r\n    border-block-start-color: transparent;\r\n    border-inline-start-color: transparent;\r\n    inset-block-start: 0;\r\n    inset-inline-end: 50px;\r\n  }\r\n  span {\r\n    inset-inline-end: 0px;\r\n    inset-block-start: 24px;\r\n    transform: rotate(-45deg);\r\n  }\r\n}\r\n.ribbone-top-right {\r\n  inset-block-start: -10px;\r\n  inset-inline-end: -10px;\r\n  &::after {\r\n    border-block-start-color: transparent;\r\n    border-inline-end-color: transparent;\r\n    inset-block-end: 50px;\r\n    inset-inline-end: 0;\r\n  }\r\n  &::before {\r\n    border-block-start-color: transparent;\r\n    border-inline-end-color: transparent;\r\n    inset-block-start: 0;\r\n    inset-inline-start: 50px;\r\n  }\r\n  span {\r\n    inset-inline-start: 0px;\r\n    inset-block-start: 24px;\r\n    transform: rotate(45deg);\r\n  }\r\n}\r\n.ribbone-warning-right {\r\n  position: absolute;\r\n  inset-block-start: -8px;\r\n  inset-inline-end: 10px;\r\n  color: $white;\r\n  &:after {\r\n    position: absolute;\r\n    content: \"\";\r\n    width: 0;\r\n    height: 0;\r\n    border-inline-start: 17px solid transparent;\r\n    border-inline-end: 17px solid transparent;\r\n    border-block-start: 10px solid $warning;\r\n    z-index: 6;\r\n  }\r\n  span {\r\n    position: relative;\r\n    display: block;\r\n    text-align: center;\r\n    background: $warning;\r\n    font-size: 13px;\r\n    line-height: 1;\r\n    padding: 10px 2px 5px;\r\n    border-start-end-radius: 10px;\r\n    z-index: 6;\r\n    &:after {\r\n      position: absolute;\r\n      content: \"\";\r\n      inset-inline-end: -6px;\r\n      background: $warning;\r\n      height: 6px;\r\n      width: 10px;\r\n      inset-inline-start: -9px;\r\n      inset-block-start: 0;\r\n      border-start-start-radius: 50px;\r\n      border-start-end-radius: 0;\r\n      border-end-start-radius: 0;\r\n      border-end-end-radius: 0;\r\n    }\r\n    &:before {\r\n      position: absolute;\r\n      content: \"\";\r\n      height: 5px;\r\n      width: 10px;\r\n      inset-inline-start: -9px;\r\n      inset-block-start: 3px;\r\n      background: $warning;\r\n    }\r\n  }\r\n  i {\r\n    color: $white;\r\n    font-size: $font-size-16;\r\n    padding-inline-start: 7px;\r\n    padding-inline-end: 7px;\r\n  }\r\n}\r\n.ribbone-danger-right {\r\n  position: absolute;\r\n  inset-block-start: -8px;\r\n  inset-inline-end: 10px;\r\n  color: $white;\r\n  &:after {\r\n    position: absolute;\r\n    content: \"\";\r\n    width: 0;\r\n    height: 0;\r\n    border-inline-start: 17px solid transparent;\r\n    border-inline-end: 17px solid transparent;\r\n    border-block-start: 10px solid $danger;\r\n    z-index: 6;\r\n  }\r\n  span {\r\n    position: relative;\r\n    display: block;\r\n    text-align: center;\r\n    background: $danger;\r\n    font-size: 13px;\r\n    line-height: 1;\r\n    padding: 10px 2px 5px;\r\n    border-start-end-radius: 10px;\r\n    z-index: 6;\r\n    &:after {\r\n      position: absolute;\r\n      content: \"\";\r\n      inset-inline-end: -6px;\r\n      background: $danger;\r\n      height: 6px;\r\n      width: 10px;\r\n      inset-inline-start: -9px;\r\n      inset-block-start: 0;\r\n      border-start-start-radius: 50px;\r\n      border-start-end-radius: 0;\r\n      border-end-start-radius: 0;\r\n      border-end-end-radius: 0;\r\n    }\r\n    &:before {\r\n      position: absolute;\r\n      content: \"\";\r\n      height: 5px;\r\n      width: 10px;\r\n      inset-inline-start: -9px;\r\n      inset-block-start: 3px;\r\n      background: $danger;\r\n    }\r\n  }\r\n  i {\r\n    color: $white;\r\n    font-size: $font-size-16;\r\n    padding-inline-start: 7px;\r\n    padding-inline-end: 7px;\r\n  }\r\n}\r\n.ribbone-success-left {\r\n  position: absolute;\r\n  inset-block-start: -8px;\r\n  inset-inline-start: 10px;\r\n  color: $white;\r\n  &:after {\r\n    position: absolute;\r\n    content: \"\";\r\n    width: 0;\r\n    height: 0;\r\n    border-inline-start: 17px solid transparent;\r\n    border-inline-end: 17px solid transparent;\r\n    border-block-start: 10px solid $success;\r\n    z-index: 6;\r\n  }\r\n  span {\r\n    position: relative;\r\n    display: block;\r\n    text-align: center;\r\n    background: $success;\r\n    font-size: 13px;\r\n    line-height: 1;\r\n    padding: 10px 2px 5px;\r\n    border-start-start-radius: 10px;\r\n    z-index: 6;\r\n    &:after {\r\n      position: absolute;\r\n      content: \"\";\r\n      inset-inline-end: -6px;\r\n      background: $success;\r\n      height: 6px;\r\n      width: 10px;\r\n      inset-inline-end: -9px;\r\n      inset-block-start: 0;\r\n      border-start-start-radius: 0;\r\n      border-start-end-radius: 50px;\r\n      border-end-start-radius: 0;\r\n      border-end-end-radius: 0;\r\n    }\r\n    &:before {\r\n      position: absolute;\r\n      content: \"\";\r\n      height: 5px;\r\n      width: 10px;\r\n      inset-inline-end: -9px;\r\n      inset-block-start: 3px;\r\n      background: $success;\r\n    }\r\n  }\r\n  i {\r\n    color: $white;\r\n    font-size: $font-size-16;\r\n    padding-inline-start: 7px;\r\n    padding-inline-end: 7px;\r\n  }\r\n}\r\n.ribbone-info-left {\r\n  position: absolute;\r\n  inset-block-start: -8px;\r\n  inset-inline-start: 10px;\r\n  color: $white;\r\n  &:after {\r\n    position: absolute;\r\n    content: \"\";\r\n    width: 0;\r\n    height: 0;\r\n    border-inline-start: 17px solid transparent;\r\n    border-inline-end: 17px solid transparent;\r\n    border-block-start: 10px solid $info;\r\n    z-index: 6;\r\n  }\r\n  span {\r\n    position: relative;\r\n    display: block;\r\n    text-align: center;\r\n    background: $info;\r\n    font-size: 13px;\r\n    line-height: 1;\r\n    padding: 10px 2px 5px;\r\n    border-start-start-radius: 10px;\r\n    z-index: 6;\r\n    &:after {\r\n      position: absolute;\r\n      content: \"\";\r\n      inset-inline-end: -6px;\r\n      background: $info;\r\n      height: 6px;\r\n      width: 10px;\r\n      inset-inline-end: -9px;\r\n      inset-block-start: 0;\r\n      border-start-start-radius: 0;\r\n      border-start-end-radius: 50px;\r\n      border-end-start-radius: 0;\r\n      border-end-end-radius: 0;\r\n    }\r\n    &:before {\r\n      position: absolute;\r\n      content: \"\";\r\n      height: 5px;\r\n      width: 10px;\r\n      inset-inline-end: -9px;\r\n      inset-block-start: 3px;\r\n      background: $info;\r\n    }\r\n  }\r\n  i {\r\n    color: $white;\r\n    font-size: $font-size-16;\r\n    padding-inline-start: 7px;\r\n    padding-inline-end: 7px;\r\n  }\r\n}\r\n.bookmark-ribbone-success-left {\r\n  position: absolute;\r\n  inset-inline-start: 10px;\r\n  color: $white;\r\n  &:after {\r\n    position: absolute;\r\n    content: \"\";\r\n    width: 0;\r\n    height: 0;\r\n    z-index: 6;\r\n    inset-inline-start: 0;\r\n    border-inline-start: 18px solid $success;\r\n    border-inline-end: 18px solid $success;\r\n    border-block-end: 10px solid transparent;\r\n  }\r\n  span {\r\n    position: relative;\r\n    display: block;\r\n    text-align: center;\r\n    background: $success;\r\n    font-size: 13px;\r\n    line-height: 1;\r\n    padding: 12px 3px 20px;\r\n    z-index: 6;\r\n  }\r\n  i {\r\n    color: $white;\r\n    font-size: $font-size-16;\r\n    padding-inline-start: 7px;\r\n    padding-inline-end: 7px;\r\n  }\r\n}\r\n.bookmark-ribbone-danger-left {\r\n  position: absolute;\r\n  inset-inline-start: 10px;\r\n  color: $white;\r\n  width: 30px;\r\n  &:after {\r\n    position: absolute;\r\n    content: \"\";\r\n    width: 0;\r\n    height: 0;\r\n    z-index: 6;\r\n    inset-inline-start: 0;\r\n    border-inline-start: 15px solid $danger;\r\n    border-inline-end: 15px solid $danger;\r\n    border-block-end: 8px solid transparent;\r\n  }\r\n  span {\r\n    position: relative;\r\n    display: block;\r\n    text-align: center;\r\n    background: $danger;\r\n    font-size: 12px;\r\n    line-height: 1;\r\n    padding: 12px 0px;\r\n    z-index: 6;\r\n  }\r\n  i {\r\n    color: $white;\r\n    font-size: $font-size-16;\r\n    padding-inline-start: 7px;\r\n    padding-inline-end: 7px;\r\n  }\r\n}\r\n.bookmark-ribbone-secondary-right {\r\n  position: absolute;\r\n  inset-inline-end: 10px;\r\n  color: $white;\r\n  width: 30px;\r\n  &:after {\r\n    position: absolute;\r\n    content: \"\";\r\n    width: 0;\r\n    height: 0;\r\n    z-index: 6;\r\n    inset-inline-end: 0;\r\n    border-inline-start: 15px solid $secondary;\r\n    border-inline-end: 15px solid $secondary;\r\n    border-block-end: 8px solid transparent;\r\n  }\r\n  span {\r\n    position: relative;\r\n    display: block;\r\n    text-align: center;\r\n    background: $secondary;\r\n    font-size: 11px;\r\n    line-height: 1;\r\n    padding: 12px 0px;\r\n    z-index: 6;\r\n  }\r\n  i {\r\n    color: $white;\r\n    font-size: $font-size-16;\r\n    padding-inline-start: 7px;\r\n    padding-inline-end: 7px;\r\n  }\r\n}\r\n.bookmark-sideleft-ribbone-success-left {\r\n  position: absolute;\r\n  inset-block-start: 10px;\r\n  color: $white;\r\n  &:after {\r\n    position: absolute;\r\n    content: \"\";\r\n    width: 0;\r\n    height: 0;\r\n    z-index: 6;\r\n    inset-block-start: 0;\r\n    inset-inline-end: -8px;\r\n    border-block-start: 13px solid $success;\r\n    border-block-end: 13px solid $success;\r\n    border-inline-end: 8px solid transparent;\r\n  }\r\n  span {\r\n    position: relative;\r\n    display: block;\r\n    text-align: center;\r\n    background: $success;\r\n    font-size: 11px;\r\n    padding: 5px 13px;\r\n    z-index: 6;\r\n    height: 26px;\r\n  }\r\n  i {\r\n    color: $white;\r\n    font-size: $font-size-16;\r\n    padding-inline-start: 7px;\r\n    padding-inline-end: 7px;\r\n  }\r\n}\r\n.bookmark-sideright-ribbone-primary-right {\r\n  position: absolute;\r\n  inset-block-start: 10px;\r\n  inset-inline-end: 0;\r\n  color: $white;\r\n  &:after {\r\n    position: absolute;\r\n    content: \"\";\r\n    width: 0;\r\n    height: 0;\r\n    z-index: 6;\r\n    inset-block-start: 0;\r\n    inset-inline-start: -8px;\r\n    border-block-start: 13px solid $primary;\r\n    border-block-end: 13px solid $primary;\r\n    border-inline-start: 8px solid transparent;\r\n  }\r\n  span {\r\n    position: relative;\r\n    display: block;\r\n    text-align: center;\r\n    background: $primary;\r\n    font-size: 11px;\r\n    padding: 5px 13px;\r\n    z-index: 6;\r\n    height: 26px;\r\n  }\r\n  i {\r\n    color: $white;\r\n    font-size: $font-size-16;\r\n    padding-inline-start: 7px;\r\n    padding-inline-end: 7px;\r\n  }\r\n}\r\n.ribbone-1 {\r\n  span {\r\n    &:after {\r\n      position: absolute;\r\n      content: \"\";\r\n    }\r\n  }\r\n}\r\n.arrow-ribbone-2 {\r\n  color: $white;\r\n  padding: 3px 8px;\r\n  position: absolute;\r\n  z-index: 6;\r\n  font-size: $font-size-20;\r\n  &:before {\r\n    position: absolute;\r\n    inset-inline-end: 0;\r\n    inset-block-start: 0;\r\n    inset-block-end: 0;\r\n    content: \"\";\r\n    inset-inline-end: -24px;\r\n    border-block-start: 16px solid transparent;\r\n    border-inline-start: 24px solid $purple;\r\n    border-block-end: 16px solid transparent;\r\n    width: 0;\r\n  }\r\n}\r\n.ribbone-card {\r\n  overflow: hidden;\r\n}\r\n.fullwidth-primary-ribbons {\r\n  .bar {\r\n    color: $white;\r\n    background-color: $primary;\r\n    padding: 5px;\r\n    text-align: center;\r\n    position: relative;\r\n    border: 2px transparent solid;\r\n    box-shadow: 0 10px 30px -10px $light;\r\n    span {\r\n      position: absolute;\r\n      &:nth-child(1) {\r\n        border-style: solid;\r\n        border-width: 11px;\r\n        z-index: -1;\r\n        border-color: transparent;\r\n        inset-block-start: 31px;\r\n        inset-inline-start: -2px;\r\n      }\r\n      &:nth-child(3) {\r\n        border-style: solid;\r\n        border-width: 11px;\r\n        z-index: -1;\r\n        border-color: transparent;\r\n        inset-block-start: 31px;\r\n        inset-inline-end: -2px;\r\n      }\r\n      &:nth-child(2) {\r\n        inset-block-start: 18px;\r\n        border-style: solid;\r\n        border-width: 18px;\r\n        z-index: -2;\r\n        border-color: $primary $primary $primary transparent;\r\n        border-block-start-color: $primary;\r\n        border-inline-end-color: $primary;\r\n        border-block-end-color: $primary;\r\n        border-inline-start-color: transparent;\r\n        inset-inline-start: -30px;\r\n      }\r\n      &:nth-child(4) {\r\n        inset-block-start: 18px;\r\n        border-style: solid;\r\n        border-width: 18px;\r\n        z-index: -2;\r\n        border-block-start-color: $primary;\r\n        border-inline-end-color: transparent;\r\n        border-block-end-color: $primary;\r\n        border-inline-start-color: $primary;\r\n        inset-inline-end: -30px;\r\n      }\r\n    }\r\n  }\r\n}\r\n.fullwidth-secondary-ribbons {\r\n  .bar {\r\n    color: $white;\r\n    background-color: $secondary;\r\n    padding: 5px;\r\n    text-align: center;\r\n    position: relative;\r\n    border: 2px transparent solid;\r\n    box-shadow: 0 10px 30px -10px $light;\r\n    span {\r\n      position: absolute;\r\n      &:nth-child(1) {\r\n        border-style: solid;\r\n        border-width: 11px;\r\n        z-index: -1;\r\n        border-color: transparent;\r\n        inset-block-start: 31px;\r\n        inset-inline-start: -2px;\r\n      }\r\n      &:nth-child(3) {\r\n        border-style: solid;\r\n        border-width: 11px;\r\n        z-index: -1;\r\n        border-color: transparent;\r\n        inset-block-start: 31px;\r\n        inset-inline-end: -2px;\r\n      }\r\n      &:nth-child(2) {\r\n        inset-block-start: 18px;\r\n        border-style: solid;\r\n        border-width: 18px;\r\n        z-index: -2;\r\n        border-block-start-color: $secondary;\r\n        border-inline-end-color: $secondary;\r\n        border-block-end-color: $secondary;\r\n        border-inline-start-color: transparent;\r\n        inset-inline-start: -30px;\r\n      }\r\n      &:nth-child(4) {\r\n        inset-block-start: 18px;\r\n        border-style: solid;\r\n        border-width: 18px;\r\n        z-index: -2;\r\n        border-block-start-color: $secondary;\r\n        border-inline-end-color: transparent;\r\n        border-block-end-color: $secondary;\r\n        border-inline-start-color: $secondary;\r\n        inset-inline-end: -30px;\r\n      }\r\n    }\r\n  }\r\n}\r\n.fullwidth-arrow-warning-ribbons {\r\n  .bar {\r\n    color: $white;\r\n    background-color: $warning;\r\n    padding: 5px;\r\n    text-align: center;\r\n    position: relative;\r\n    border: 2px transparent solid;\r\n    box-shadow: 0 10px 30px -10px $light;\r\n    span {\r\n      position: absolute;\r\n      &:nth-child(1) {\r\n        border-style: solid;\r\n        border-width: 11px;\r\n        z-index: -1;\r\n        border-color: transparent;\r\n        inset-block-start: 31px;\r\n        inset-inline-start: -2px;\r\n      }\r\n      &:nth-child(3) {\r\n        border-style: solid;\r\n        border-width: 11px;\r\n        z-index: -1;\r\n        border-color: transparent;\r\n        inset-block-start: 31px;\r\n        inset-inline-end: -2px;\r\n      }\r\n      &:nth-child(2) {\r\n        inset-block-start: 18px;\r\n        border-style: solid;\r\n        border-width: 18px;\r\n        z-index: -2;\r\n        border-block-start-color: $warning;\r\n        border-inline-end-color: $warning;\r\n        border-block-end-color: $warning;\r\n        border-inline-start-color: transparent;\r\n        inset-inline-start: -30px;\r\n      }\r\n      &:nth-child(4) {\r\n        inset-block-start: 18px;\r\n        border-style: solid;\r\n        border-width: 18px;\r\n        z-index: -2;\r\n        border-block-start: 18px solid transparent;\r\n        border-inline-start: 18px solid $warning;\r\n        border-block-end: 18px solid transparent;\r\n        border-inline-end: transparent;\r\n        inset-inline-end: -20px;\r\n        inset-block-start: -2px;\r\n      }\r\n    }\r\n  }\r\n}\r\n.fullwidth-arrow-danger-ribbons-right {\r\n  .bar {\r\n    color: $white;\r\n    background-color: $danger;\r\n    padding: 5px;\r\n    text-align: center;\r\n    position: relative;\r\n    border: 2px transparent solid;\r\n    box-shadow: 0 10px 30px -10px $light;\r\n    span {\r\n      position: absolute;\r\n      &:nth-child(1) {\r\n        border-style: solid;\r\n        border-width: 11px;\r\n        z-index: -1;\r\n        border-color: transparent;\r\n        inset-block-start: 31px;\r\n        inset-inline-end: -2px;\r\n      }\r\n      &:nth-child(3) {\r\n        border-style: solid;\r\n        border-width: 11px;\r\n        z-index: -1;\r\n        border-color: transparent;\r\n        inset-block-start: 31px;\r\n        inset-inline-start: -2px;\r\n      }\r\n      &:nth-child(2) {\r\n        inset-block-start: 18px;\r\n        border-style: solid;\r\n        border-width: 18px;\r\n        z-index: -2;\r\n        border-block-start-color: $danger;\r\n        border-inline-end-color: transparent;\r\n        border-block-end-color: $danger;\r\n        border-inline-start-color: $danger;\r\n        inset-inline-end: -30px;\r\n      }\r\n      &:nth-child(4) {\r\n        inset-block-start: 18px;\r\n        border-style: solid;\r\n        border-width: 18px;\r\n        z-index: -2;\r\n        border-block-start: 18px solid transparent;\r\n        border-inline-end: 18px solid $danger;\r\n        border-block-end: 18px solid transparent;\r\n        border-inline-start: transparent;\r\n        inset-inline-start: -20px;\r\n        inset-block-start: -2px;\r\n      }\r\n    }\r\n  }\r\n}\r\n.power-ribbone {\r\n  span {\r\n    svg {\r\n      width: 15px;\r\n      height: 15px;\r\n    }\r\n  }\r\n}\r\n.ribbone-card {\r\n  .card-body {\r\n    padding: 25px;\r\n  }\r\n}\r\n.ribbone-row {\r\n  .feather-zap {\r\n    width: 15px;\r\n    height: 15px;\r\n  }\r\n}\r\n[data-bs-toggle=\"card-fullscreen\"] {\r\n  svg {\r\n    width: 15px;\r\n    height: 15px;\r\n  }\r\n} \r\n[data-bs-toggle=\"card-remove\"] {\r\n  svg {\r\n    width: 15px;\r\n    height: 15px;\r\n  }\r\n} \r\nsvg {\r\n  &.collapse-open,&.collapse-close {\r\n    width: 15px;\r\n    height: 15px;\r\n  }\r\n}\r\n.btn-icon {\r\n  &.btn-danger-light {\r\n    color: $danger-900;\r\n    background: $danger-100;\r\n  }\r\n}\r\n.live-rating {\r\n  &.badge {\r\n    background: $success-200;\r\n    color: $success-900;\r\n  }\r\n}\r\n@media (min-width: 576px) {\r\n  .mx-sm-7 {\r\n    margin-inline: 3rem !important;\r\n  }\r\n}\r\n[dir=\"rtl\"] {\r\n  .power-ribbone-top-left span {\r\n    transform: rotate(45deg);\r\n  }\r\n\r\n  .power-ribbone-top-left span i {\r\n    transform: rotate(-45deg);\r\n  }\r\n\r\n  .power-ribbone-bottom-left span {\r\n    transform: rotate(-45deg);\r\n  }\r\n\r\n  .power-ribbone-bottom-left span i {\r\n    transform: rotate(45deg);\r\n  }\r\n\r\n  .power-ribbone-top-right span {\r\n    transform: rotate(-45deg);\r\n  }\r\n\r\n  .power-ribbone-top-right span i {\r\n    transform: rotate(45deg);\r\n  }\r\n\r\n  .power-ribbone-bottom-right span {\r\n    transform: rotate(45deg);\r\n  }\r\n\r\n  .power-ribbone-bottom-right span i {\r\n    transform: rotate(-45deg);\r\n  }\r\n\r\n  .ribbone-top-left span {\r\n    transform: rotate(45deg);\r\n  }\r\n\r\n  .ribbone-top-right span {\r\n    transform: rotate(-45deg);\r\n  }\r\n\r\n  .ribbon-price .badge {\r\n    transform: rotate(-45deg);\r\n  }\r\n}\r\n",".modal-barcode {\r\n    ul {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        align-items: center;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        -ms-flex-wrap: wrap;\r\n        flex-wrap: wrap;\r\n        li {\r\n            @include rounded(7px);\r\n            width: 25%;\r\n            margin-bottom: 10px;\r\n            padding: 0 5px;\r\n            @include respond-below(custom991) {\r\n                width: 50%;\r\n            }\r\n            a {\r\n                border: 1px solid $gray-400;\r\n                @include rounded(10px);\r\n                display: block;\r\n                padding: 10px;\r\n                text-align: center;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.modal {\r\n    .modal-content {\r\n        border: 1px solid $light-900;\r\n        box-shadow: 0px 4px 74px 0px #D0D0D040;\r\n        border-radius: 5px;\r\n    }\r\n    .modal-title {\r\n        font-weight: $font-weight-bold;\r\n        @include respond-below(custom991) {\r\n            font-size: $font-size-16;\r\n        }\r\n    }\r\n\t.logo-lg {\r\n\t\timg {\r\n\t\t\twidth: 150px;\r\n\t\t}\r\n\t}\r\n    .modal-header {\r\n        border-color: $light-900;        \r\n        border-bottom: 1px solid $light-900;\r\n        justify-content: space-between;\r\n        .close,\r\n        .btn-close {\r\n            display: -webkit-box;\r\n            display: -ms-flexbox;\r\n            display: flex;\r\n            align-items: center;\r\n            -webkit-box-align: center;\r\n            -ms-flex-align: center;\r\n            justify-content: center;\r\n            -webkit-justify-content: center;\r\n            -ms-flex-pack: center;\r\n            color: $danger-700;\r\n            opacity: 1;\r\n            font-size: $font-size-12;\r\n            width: 22px;\r\n            height: 22px;\r\n            border: 0;\r\n            font-weight: $font-weight-bold;\r\n            background-color: transparent;\r\n            @include rounded(50px);\r\n            &:hover{\r\n                background-color: transparent;\r\n                color:$white;\r\n            }\r\n        }\r\n    }\r\n    .modal-footer{\r\n        .btn-print {\r\n            display: -webkit-box;\r\n            display: -ms-flexbox;\r\n            display: flex;\r\n            align-items: center;\r\n            -webkit-box-align: center;\r\n            -ms-flex-align: center;\r\n            justify-content: center;\r\n            -webkit-justify-content: center;\r\n            -ms-flex-pack: center;\r\n            border: 1px solid $primary;\r\n            color: $primary;\r\n            img{\r\n                margin-left: 10px;\r\n            }\r\n            &:hover{\r\n                background: $primary;\r\n                color: $white;\r\n                img{\r\n                    filter: brightness(0) invert(1);\r\n                }\r\n            }\r\n        }\r\n        .btn-secondary{\r\n            background: $secondary;\r\n            &:hover{\r\n                @include box-shadow(inset, 0, 0px, 0px, 100px, $white);\r\n                color: $secondary !important;\r\n            }\r\n        }\r\n    }\r\n    \r\n    .modal-dialog.right-slider-modal {\r\n        margin: 0;\r\n        margin-left: auto;\r\n        max-width: 1102px;\r\n    }\r\n    \r\n    .modal-dialog.add-centered {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        align-items: center;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        justify-content: center;\r\n        -webkit-justify-content: center;\r\n        -ms-flex-pack: center;\r\n        max-width: 1192px;\r\n    }\r\n    .modal-dialog.sales-details-modal {\r\n        max-width: 1192px;\r\n    }\r\n    .modal-dialog.edit-sales-modal {\r\n        max-width: 1192px;\r\n    }\r\n    .edit-add.card.edit-expense {\r\n        border: 1px solid rgba(0,0,0,.2);\r\n    }\r\n    .note-editor.note-frame.card {\r\n        border: 1px solid rgba(0,0,0,.2) !important; \r\n    }\r\n}\r\n.offcanvas.offcanvas-end {\r\n    width: auto !important;\r\n}\r\n.offcanvas.offcanvas-end.em-payrol-add {\r\n    max-width: 1192px !important;\r\n}\r\n\r\n.modal {\r\n    &.animated .modal-dialog {\r\n        transform: translate(0, 0);\r\n    }\r\n    &.effect-scale {\r\n        .modal-dialog {\r\n            transform: scale(0.7);\r\n            opacity: 0;\r\n            transition: all 0.3s;\r\n        }\r\n        &.show .modal-dialog {\r\n            transform: scale(1);\r\n            opacity: 1;\r\n        }\r\n    }\r\n    &.effect-slide-in-right {\r\n        .modal-dialog {\r\n            transform: translateX(20%);\r\n            opacity: 0;\r\n            transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);\r\n        }\r\n        &.show .modal-dialog {\r\n            transform: translateX(0);\r\n            opacity: 1;\r\n        }\r\n    }\r\n    &.effect-slide-in-bottom {\r\n        .modal-dialog {\r\n            transform: translateY(20%);\r\n            opacity: 0;\r\n            transition: all 0.3s;\r\n        }\r\n        &.show .modal-dialog {\r\n            transform: translateY(0);\r\n            opacity: 1;\r\n        }\r\n    }\r\n    &.effect-newspaper {\r\n        .modal-dialog {\r\n            transform: scale(0) rotate(720deg);\r\n            opacity: 0;\r\n        }\r\n        &.show~.modal-backdrop, .modal-dialog {\r\n            transition: all 0.5s;\r\n        }\r\n        &.show .modal-dialog {\r\n            transform: scale(1) rotate(0deg);\r\n            opacity: 1;\r\n        }\r\n    }\r\n    &.effect-fall {\r\n        -webkit-perspective: 1300px;\r\n        -moz-perspective: 1300px;\r\n        perspective: 1300px;\r\n        .modal-dialog {\r\n            -moz-transform-style: preserve-3d;\r\n            transform-style: preserve-3d;\r\n            transform: translateZ(600px) rotateX(20deg);\r\n            opacity: 0;\r\n        }\r\n        &.show .modal-dialog {\r\n            transition: all 0.3s ease-in;\r\n            transform: translateZ(0px) rotateX(0deg);\r\n            opacity: 1;\r\n        }\r\n    }\r\n    &.effect-flip-horizontal {\r\n        perspective: 1300px;\r\n        .modal-dialog {\r\n            -moz-transform-style: preserve-3d;\r\n            transform-style: preserve-3d;\r\n            transform: rotateY(-70deg);\r\n            transition: all 0.3s;\r\n            opacity: 0;\r\n        }\r\n        &.show .modal-dialog {\r\n            transform: rotateY(0deg);\r\n            opacity: 1;\r\n        }\r\n    }\r\n    &.effect-flip-vertical {\r\n        perspective: 1300px;\r\n        .modal-dialog {\r\n            -moz-transform-style: preserve-3d;\r\n            transform-style: preserve-3d;\r\n            transform: rotateX(-70deg);\r\n            transition: all 0.3s;\r\n            opacity: 0;\r\n        }\r\n        &.show .modal-dialog {\r\n            transform: rotateX(0deg);\r\n            opacity: 1;\r\n        }\r\n    }\r\n    &.effect-super-scaled {\r\n        .modal-dialog {\r\n            transform: scale(2);\r\n            opacity: 0;\r\n            transition: all 0.3s;\r\n        }\r\n        &.show .modal-dialog {\r\n            transform: scale(1);\r\n            opacity: 1;\r\n        }\r\n    }\r\n    &.effect-sign {\r\n        perspective: 1300px;\r\n        .modal-dialog {\r\n            -moz-transform-style: preserve-3d;\r\n            transform-style: preserve-3d;\r\n            transform: rotateX(-60deg);\r\n            transform-origin: 50% 0;\r\n            opacity: 0;\r\n            transition: all 0.3s;\r\n        }\r\n        &.show .modal-dialog {\r\n            transform: rotateX(0deg);\r\n            opacity: 1;\r\n        }\r\n    }\r\n    &.effect-rotate-bottom {\r\n        perspective: 1300px;\r\n        .modal-dialog {\r\n            -moz-transform-style: preserve-3d;\r\n            transform-style: preserve-3d;\r\n            transform: translateY(100%) rotateX(90deg);\r\n            transform-origin: 0 100%;\r\n            opacity: 0;\r\n            transition: all 0.3s ease-out;\r\n        }\r\n        &.show .modal-dialog {\r\n            transform: translateY(0%) rotateX(0deg);\r\n            opacity: 1;\r\n        }\r\n    }\r\n    &.effect-rotate-left {\r\n        perspective: 1300px;\r\n        .modal-dialog {\r\n            -moz-transform-style: preserve-3d;\r\n            transform-style: preserve-3d;\r\n            transform: translateZ(100px) translateX(-30%) rotateY(90deg);\r\n            transform-origin: 0 100%;\r\n            opacity: 0;\r\n            transition: all 0.3s;\r\n        }\r\n        &.show .modal-dialog {\r\n            transform: translateZ(0px) translateX(0%) rotateY(0deg);\r\n            opacity: 1;\r\n        }\r\n    }\r\n}\r\n.offcanvas-end.offcanvas-large {\r\n    width: 700px !important;\r\n}\r\n.modal {\r\n    z-index: 1050 !important;\r\n}\r\n.modal-backdrop {\r\n    z-index: 1001 !important;\r\n}\r\n.status-toggle {\r\n    &.small-toggle-btn {\r\n        float: unset;\r\n        .label-text {\r\n            color: $text-color;\r\n            font-size: $font-size-14;\r\n            font-weight: $font-weight-normal;\r\n        }\r\n        .checktoggle {\r\n            width: 24px;\r\n            height: 12px;\r\n            &:after {\r\n                width: 8px;\r\n                height: 8px;\r\n            }\r\n        }\r\n        .check {\r\n            &:checked{\r\n                & + .checktoggle {\r\n                    &:after {\r\n                        right: 0;\r\n                        width: 8px;\r\n                        height: 8px;\r\n                    }\r\n                }\r\n            }\r\n           \r\n        }\r\n    }\r\n    .check {\r\n        display: block;\r\n        height: 0;\r\n        visibility: hidden;\r\n        opacity: 0;\r\n        pointer-events: none;\r\n        position: absolute;\r\n        margin: 0;\r\n        padding: 0;\r\n        &:checked + .checktoggle:after {\r\n            left: 100%;\r\n            transform: translate(calc(-100% - 3px), -50%);\r\n             right: 0;\r\n            width: 10px;\r\n            height: 10px;\r\n        }\r\n        &:checked + .checktoggle {\r\n            background: #1ABE17;\r\n        }\r\n    }\r\n   .checktoggle {\r\n        background: #CDCDCD;\r\n        cursor: pointer;\r\n        display: block;\r\n        font-size: 0;\r\n        margin-bottom: 0;\r\n        position: relative;\r\n        border-radius: 12px;\r\n        width: 30px;\r\n        height: 14px;\r\n        &:after {\r\n            content: \" \";\r\n            display: block;\r\n            width: 10px;\r\n            height: 10px;\r\n            background-color: #FFF;\r\n            -webkit-transition: all 0.2s ease;\r\n            -ms-transition: all 0.2s ease;\r\n            transition: all 0.2s ease;\r\n            transform: translate(3px, -50%);\r\n            -webkit-transform: translate(3px, -50%);\r\n            -ms-transform: translate(3px, -50%);\r\n            position: absolute;\r\n            top: 50%;\r\n            left: 0;\r\n            border-radius: 50%;\r\n        }\r\n    }\r\n}\r\n.modal-btn {\r\n    .btn {\r\n        @include margin-padding(0 10px 0 0, 7px 15px);\r\n        &:last-child {\r\n            margin-right: 0;\r\n        }\r\n    } \r\n}\r\n.custom-modal {\r\n    .modal-header {        \r\n        .btn-close {\r\n            @include margin-padding(0, 0);\r\n            background: $white;\r\n            border: 1px solid $light-900;\r\n            border-radius: 50%;\r\n            color: $gray-400;\r\n            font-weight: $font-weight-normal;\r\n            font-size: $font-size-14;\r\n            box-shadow: 0px 4px 4px 0px #DBDBDB40;\r\n            height: 26px;\r\n            width: 26px;\r\n            display: flex;\r\n            display: -webkit-flex;\r\n            align-items: center;\r\n            -webkit-align-items: center;\r\n            justify-content: center;\r\n            -webkit-justify-content: center;\r\n            -webkit-transition: all 0.7s;\r\n            -moz-transition: all 0.7s;\r\n            -o-transition: all 0.7s;\r\n            transition: all 0.7s;\r\n            &:hover {\r\n                border: 1px solid $primary;\r\n                background: $primary;\r\n                color: $white;\r\n                -webkit-transition: all 0.7s;\r\n                -moz-transition: all 0.7s;\r\n                -o-transition: all 0.7s;\r\n                transition: all 0.7s;\r\n                -webkit-transform: rotateZ(360deg);\r\n                -moz-transform: rotateZ(360deg);\r\n                transform: rotateZ(360deg);\r\n            }    \r\n        }\r\n    }\r\n\r\n}",".grid-showcase {\r\n  margin-bottom: -10px;\r\n  span, .grid-wrapper {\r\n    display: block;\r\n    padding: 10px;\r\n    margin-bottom: 10px;\r\n    text-align: center;\r\n    background-color: rgba(242, 243, 247, 0.7);\r\n  }\r\n}\r\n.grid-align {\r\n  margin-bottom: -16px;\r\n}\r\n.grid-align .row {\r\n  padding: 15px 0;\r\n  min-height: 7rem;\r\n  margin-bottom: 16px;\r\n}\r\n.grid-vertical {\r\n  min-height: 150px;\r\n  padding: 10px;\r\n  color: $black;\r\n}\r\ntable.table-bordered thead tr th p {\r\n  margin-bottom: 0;\r\n}","body {\r\n\tfont-family: $font-family-primary;\r\n\tfont-size: $font-size-14;\r\n\tcolor: $text-color;\r\n\tline-height: 1.5;\r\n\tbackground-color: $body-bg;\r\n\toverflow-y: auto;\r\n\toverflow-x: hidden;\r\n}\r\nhtml{\r\n\tfont-family: $font-family-primary;\t\r\n}\r\n::selection {\r\n  background: $primary;\r\n  color: $white;\r\n  text-shadow: none;\r\n}\r\nimg {\r\n\tmax-width: 100%;\r\n\theight: auto;\r\n\tvertical-align: inherit;\r\n}\r\n*{\r\n\toutline: none;\r\n}\r\nbutton {\r\n\t@include transition(all 0.5s ease);\r\n\t&:focus {\r\n\t\tbox-shadow: none !important;\r\n\t}\r\n}\r\np {\r\n\tmargin-bottom:20px;\r\n\t&:last-child {\r\n\t\tmargin-bottom: 0;\r\n\t}\r\n}\r\nstrong {\r\n\tfont-weight: $font-weight-bold;\r\n}\r\nh1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6 {\r\n  \tcolor: $title-color;\r\n  \tfont-family: $font-family-primary;\r\n\tfont-weight: $font-weight-bold;\r\n  \tmargin-bottom: 0;\r\n}\r\nol, ul {\r\n  list-style: none;\r\n  margin-block-end: 0;\r\n  padding: 0;\r\n}\r\nul {\r\n  list-style: none;\r\n\t&.list-disc {\r\n\t  list-style: disc;\r\n\t  padding-left: 15px;\r\n\t  ul {\r\n\t    list-style-type: circle;\r\n\t  }\r\n\t}\r\n\t&.list-decimal {\r\n\t  list-style: decimal;\r\n\t  padding-left: 15px;\r\n\t  ul{\r\n\t    list-style-type: decimal;\r\n\t  }\r\n\t}\r\n\t&.list-icon {\r\n\t  list-style: none;\r\n\t  padding-left: 0;\r\n\t  > li {\r\n\t    padding-left: 1.875rem;\r\n\t    counter-increment: li;\r\n\t    i,\r\n\t    .feather-icon,\r\n\t    .svg-icon {\r\n\t      display: inline-block;\r\n\t      height: 20px;\r\n\t      width: 20px;\r\n\t      text-align: center;\r\n\t      margin-left: -1.25rem;\r\n\t      position: relative;\r\n\t      left: -10px;\r\n\t      padding: 1px;\r\n\t      top: -1px;\r\n\t      \r\n\t    }\r\n\t    i {\r\n\t      font-size: $font-size-20;\r\n\t      top: 5px;\r\n\t    }\r\n\t  }\r\n\t}\r\n\t.btn {\r\n\t  &-primary {\r\n\t      &:not(:disabled):not(.disabled) {\r\n\t          &:active,\r\n\t          &.active {\r\n\t              &:focus {\r\n\t                  box-shadow: none;\r\n\t              \t}\r\n\t          \t}\r\n\t      \t}\r\n\t  \t}\r\n\t}\r\n}\r\n",".bg-primary {\r\n    background-color: $primary !important;\r\n}\r\n.bg-secondary {\r\n    background-color: $secondary !important;\r\n}\r\n.bg-info {\r\n    background-color: $info !important;\r\n}\r\n.bg-success {\r\n    background-color: $success !important;\r\n    color: $white !important;\r\n}\r\n.bg-warning {\r\n    background-color: $warning !important;\r\n    color: $white !important;\r\n}\r\n.bg-danger {\r\n    background-color: $danger !important;\r\n    color: $white !important;\r\n}\r\n.bg-dark {\r\n    background-color: $dark !important;\r\n}\r\n.bg-light {\r\n    background-color: $light !important;\r\n}\r\n.bg-light-300 {\r\n    background-color: $light-300 !important;\r\n}\r\n.bg-light-400 {\r\n    background: $light-400;\r\n}\r\n.bg-light-600 {\r\n    background-color: $light-600 !important;\r\n}\r\n.bg-white {\r\n    background-color: $white !important;\r\n}\r\n.bg-pink {\r\n    background-color: $pink !important;\r\n}\r\n.bg-purple {\r\n    background-color: $purple !important;\r\n}\r\n.bg-teal {\r\n    background-color: $teal !important;\r\n}\r\n.bg-blue {\r\n    background-color: $blue !important;\r\n}\r\n.bg-tertiary {\r\n    background-color: $tertiary !important;\r\n}\r\n.bg-violet {\r\n    background-color: $violet !important;\r\n}\r\n.bg-green {\r\n    background-color: $green !important;\r\n}\r\n.bg-gray {\r\n    background: $background-3;\r\n}\r\n.bg-primary {\r\n    background-color: $primary !important;\r\n    &.bg-opacity-10 {\r\n        background-color: rgba($primary,0.1) !important;\r\n    }\r\n    &.bg-opacity-25 {\r\n        background-color: rgba($primary,0.25) !important;\r\n    }\r\n    &.bg-opacity-50 {\r\n        background-color: rgba($primary,0.50) !important;\r\n    }\r\n    &.bg-opacity-75 {\r\n        background-color: rgba($primary,0.75) !important;\r\n    }\r\n    &.bg-opacity-100 {\r\n        background-color: rgba($primary,1) !important;\r\n    }\r\n}\r\n.bg-secondary {\r\n    background-color: $secondary !important;\r\n    &.bg-opacity-10 {\r\n        background-color: rgba($secondary,0.1) !important;\r\n    }\r\n    &.bg-opacity-25 {\r\n        background-color: rgba($secondary,0.25) !important;\r\n    }\r\n    &.bg-opacity-50 {\r\n        background-color: rgba($secondary,0.50) !important;\r\n    }\r\n    &.bg-opacity-75 {\r\n        background-color: rgba($secondary,0.75) !important;\r\n    }\r\n    &.bg-opacity-100 {\r\n        background-color: rgba($secondary,1) !important;\r\n    }\r\n}\r\n.bg-info {\r\n    background-color: $info !important;\r\n    &.bg-opacity-10 {\r\n        background-color: rgba($info,0.1) !important;\r\n    }\r\n    &.bg-opacity-25 {\r\n        background-color: rgba($info,0.25) !important;\r\n    }\r\n    &.bg-opacity-50 {\r\n        background-color: rgba($info,0.50) !important;\r\n    }\r\n    &.bg-opacity-75 {\r\n        background-color: rgba($info,0.75) !important;\r\n    }\r\n    &.bg-opacity-100 {\r\n        background-color: rgba($info,1) !important;\r\n    }\r\n}\r\n.bg-success {\r\n    background-color: $success !important;\r\n    &.bg-opacity-10 {\r\n        background-color: rgba($success,0.1) !important;\r\n    }\r\n    &.bg-opacity-25 {\r\n        background-color: rgba($success,0.25) !important;\r\n    }\r\n    &.bg-opacity-50 {\r\n        background-color: rgba($success,0.50) !important;\r\n    }\r\n    &.bg-opacity-75 {\r\n        background-color: rgba($success,0.75) !important;\r\n    }\r\n    &.bg-opacity-100 {\r\n        background-color: rgba($success,1) !important;\r\n    }\r\n}\r\n.bg-warning {\r\n    background-color: $warning !important;\r\n    &.bg-opacity-10 {\r\n        background-color: rgba($warning,0.1) !important;\r\n    }\r\n    &.bg-opacity-25 {\r\n        background-color: rgba($warning,0.25) !important;\r\n    }\r\n    &.bg-opacity-50 {\r\n        background-color: rgba($warning,0.50) !important;\r\n    }\r\n    &.bg-opacity-75 {\r\n        background-color: rgba($warning,0.75) !important;\r\n    }\r\n    &.bg-opacity-100 {\r\n        background-color: rgba($warning,1) !important;\r\n    }\r\n}\r\n.bg-danger {\r\n    background-color: $danger !important;\r\n    &.bg-opacity-10 {\r\n        background-color: rgba($danger,0.1) !important;\r\n    }\r\n    &.bg-opacity-25 {\r\n        background-color: rgba($danger,0.25) !important;\r\n    }\r\n    &.bg-opacity-50 {\r\n        background-color: rgba($danger,0.50) !important;\r\n    }\r\n    &.bg-opacity-75 {\r\n        background-color: rgba($danger,0.75) !important;\r\n    }\r\n    &.bg-opacity-100 {\r\n        background-color: rgba($danger,1) !important;\r\n    }\r\n}\r\n.bg-dark {\r\n    background-color: $dark !important;\r\n    &.bg-opacity-10 {\r\n        background-color: rgba($dark,0.1) !important;\r\n    }\r\n    &.bg-opacity-25 {\r\n        background-color: rgba($dark,0.25) !important;\r\n    }\r\n    &.bg-opacity-50 {\r\n        background-color: rgba($dark,0.50) !important;\r\n    }\r\n    &.bg-opacity-75 {\r\n        background-color: rgba($dark,0.75) !important;\r\n    }\r\n    &.bg-opacity-100 {\r\n        background-color: rgba($dark,1) !important;\r\n    }\r\n}\r\n.bg-light {\r\n    background-color: $light !important;\r\n    &.bg-opacity-10 {\r\n        background-color: rgba($light,0.1) !important;\r\n    }\r\n    &.bg-opacity-25 {\r\n        background-color: rgba($light,0.25) !important;\r\n    }\r\n    &.bg-opacity-50 {\r\n        background-color: rgba($light,0.50) !important;\r\n    }\r\n    &.bg-opacity-75 {\r\n        background-color: rgba($light,0.75) !important;\r\n    }\r\n    &.bg-opacity-100 {\r\n        background-color: rgba($light,1) !important;\r\n    }\r\n}\r\n@each $color,\r\n$value in $theme-colors {\r\n    .bg-#{$color} {\r\n        background-color: #{$value} !important;\r\n        border: 1px solid #{$value} !important;\r\n        color: $white;\r\n    }\r\n}\r\n.bg-soft-primary {\r\n    background-color: $primary-300;\r\n    color: $primary;\r\n}\r\n.bg-soft-secondary {\r\n    background-color: $secondary-300;\r\n    color: $secondary;\r\n}\r\n.bg-soft-success {\r\n    background-color: $success-300;\r\n    color: $success;\r\n}\r\n.bg-soft-danger {\r\n    background-color: $danger-300;\r\n    color: $danger;\r\n}\r\n.bg-soft-warning {\r\n    background-color: $warning-300;\r\n    color: $warning;\r\n}\r\n.bg-soft-info {\r\n    background-color: rgba($info, 0.3);\r\n    color: $info;\r\n}\r\n.bg-soft-light {\r\n    background-color: rgba($light, 0.9);\r\n    color: $text-color;\r\n}\r\n.bg-soft-dark {\r\n    background-color: rgba($dark, 0.3);\r\n    color: $white;\r\n}\r\n.bg-light {\r\n  color: $text-color;\r\n}\r\n\r\n.bg-primary-gradient {\r\n  background: $primary-gradient !important;\r\n  color: $white;\r\n}\r\n.bg-secondary-gradient {\r\n  background: $secondary-gradient !important;\r\n  color: $white;\r\n}\r\n.bg-warning-gradient {\r\n  background: $warning-gradient !important;\r\n  color: $white;\r\n}\r\n.bg-info-gradient {\r\n  background: $info-gradient !important;\r\n  color: $white;\r\n}\r\n.bg-success-gradient {\r\n  background: $success-gradient !important;\r\n  color: $white;\r\n}\r\n.bg-danger-gradient {\r\n  background: $danger-gradient !important;\r\n  color: $white;\r\n}\r\n.bg-orange-gradient {\r\n  background: $orange-gradient !important;\r\n  color: $white;\r\n}\r\n.bg-purple-gradient {\r\n  background: $purple-gradient !important;\r\n  color: $white;\r\n}\r\n.bg-teal-gradient {\r\n  background: $teal-gradient !important;\r\n  color: $white;\r\n}\r\n.bg-light-gradient {\r\n  background: $light-gradient !important;\r\n  color: $black;\r\n}\r\n.bg-dark-gradient {\r\n  background: $dark-gradient !important;\r\n  color: $white;\r\n}\r\n.bg-outline-primary {\r\n  background-color: $white;\r\n  border: 1px solid $primary;\r\n  color: $primary;\r\n}\r\n.bg-outline-secondary {\r\n  background-color: $white;\r\n  border: 1px solid $secondary;\r\n  color: $secondary;\r\n}\r\n.bg-outline-warning {\r\n  background-color: $white;\r\n  border: 1px solid $warning;\r\n  color: $warning;\r\n}\r\n.bg-outline-info {\r\n  background-color: $white;\r\n  border: 1px solid $info;\r\n  color: $info;\r\n}\r\n.bg-outline-success {\r\n  background-color: $white;\r\n  border: 1px solid $success;\r\n  color: $success;\r\n}\r\n.bg-outline-danger {\r\n  background-color: $white;\r\n  border: 1px solid $danger;\r\n  color: $danger;\r\n}\r\n.bg-outline-dark {\r\n  background-color: $white;\r\n  border: 1px solid $dark;\r\n  color: $dark;\r\n}\r\n.bg-outline-light {\r\n  background-color: $white;\r\n  border: 1px solid $light !important;\r\n  color: $black !important;\r\n}\r\n.bg-primary-transparent {\r\n    background-color: rgba($primary, 0.1) !important;\r\n    color: $primary !important;\r\n    &:hover {\r\n        background-color: rgba($primary, 0.1) !important;\r\n        color: $primary !important;\r\n    }\r\n}\r\n.bg-secondary-transparent {\r\n    background-color: rgba($secondary, 0.1) !important;\r\n    color: $secondary !important;\r\n    &:hover {\r\n        background-color: rgba($secondary, 0.1) !important;\r\n        color: $secondary !important;\r\n    }\r\n}\r\n.bg-info-transparent {\r\n    background-color: rgba($info, 0.1) !important;\r\n    color: $info !important;\r\n    &:hover {\r\n        background-color: rgba($info, 0.1) !important;\r\n        color: $info !important;\r\n    }\r\n}\r\n.bg-success-transparent {\r\n    background-color: rgba($success, 0.1) !important;\r\n    color: $success !important;\r\n    &:hover {\r\n        background-color: rgba($success, 0.1) !important;\r\n        color: $success !important;\r\n    }\r\n}\r\n.bg-warning-transparent {\r\n    background-color: rgba($warning, 0.1) !important;\r\n    color: $warning !important;\r\n    &:hover {\r\n        background-color: rgba($warning, 0.1) !important;\r\n        color: $warning !important;\r\n    }\r\n}\r\n.bg-danger-transparent {\r\n    background-color: rgba($danger, 0.1) !important;\r\n    color: $danger !important;\r\n    &:hover {\r\n        background-color: rgba($danger, 0.1) !important;\r\n        color: $danger !important;\r\n    }\r\n}\r\n.bg-light-transparent {\r\n    background-color: rgba($light, 0.5) !important;\r\n    color: $light !important;\r\n    &:hover {\r\n        background-color: rgba($light, 0.5) !important;\r\n        color: $text-color !important;\r\n    }\r\n}\r\n.bg-gray-100 {\r\n    background-color: $gray-100; \r\n}\r\n.bg-gray-200 {\r\n    background-color: $gray-200;\r\n}\r\n.bg-gray-300 {\r\n    background-color: $gray-300;\r\n}\r\n.bg-gray-400 {\r\n    background-color: $gray-400;\r\n}\r\n.bg-gray-500 {\r\n    background-color: $gray-500;\r\n}\r\n.bg-gray-600 {\r\n    background-color: $gray-600;\r\n}\r\n.bg-gray-700 {\r\n    background-color: $gray-700;\r\n}\r\n.bg-gray-800 {\r\n    background-color: $gray-800;\r\n}\r\n.bg-gray-900 {\r\n    background-color: $gray-900;\r\n}\r\n.svg-primary {\r\n    fill: $primary;\r\n}\r\n.svg-secondary {\r\n    fill: $secondary;\r\n}\r\n.svg-success {\r\n    fill: $success;\r\n}\r\n.svg-danger {\r\n    fill: $danger;\r\n}\r\n.svg-warning {\r\n    fill: $warning;\r\n}\r\n.svg-white {\r\n    fill: $white;\r\n}\r\n.svg-black {\r\n    fill: $black;\r\n}\r\n.svg-pink {\r\n    fill: $pink;\r\n}\r\n.svg-orange {\r\n    fill: $orange;\r\n}\r\n.svg-purple {\r\n    fill: $purple;\r\n}\r\n.svg-indigo {\r\n    fill: $indigo;\r\n}\r\n.svg-info {\r\n    fill: $info;\r\n}\r\n.svg-yellow {\r\n    fill: $yellow;\r\n}\r\n.svg-light {\r\n  fill: $light;\r\n}\r\n.svg-dark {\r\n  fill: $dark;\r\n}\r\n.svg-teal {\r\n  fill: $teal;\r\n}\r\n.svg-default {\r\n  fill: $text-color;\r\n}\r\n.color-container {\r\n  width: 5rem;\r\n  height: 5rem;\r\n  border-radius: $border-radius;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  line-height: 3rem;\r\n}\r\n.text-container {\r\n  padding: 0.25rem 0.5rem;\r\n  border-radius: $border-radius;\r\n  box-shadow: $box-shadow;\r\n}\r\n.color-box {\r\n    width: 80px;\r\n    height: 80px;\r\n    border-radius: $border-radius;\r\n    margin-right: 0.75rem;\r\n    margin-bottom: 0.75rem;\r\n}\r\n.bg-soft-purple {\r\n    background: $purple-100 !important;\r\n    border-color: $purple-100 !important;\r\n}\r\n.text-purple {\r\n    color: $purple;\r\n}\r\n.bg-light-200 {\r\n    background: $light-200;\r\n}\r\n.bg-light-100 {\r\n    background: $light-100;\r\n}\r\n.bg-danger-light {\r\n    background: $danger-100;\r\n}\r\n.bg-pending {\r\n    background: $violet !important;\r\n    color: $white !important;\r\n}\r\n.bg-secondary-success {\r\n    background: $green !important;\r\n}\r\n.bg-orange {\r\n    background: $orange;\r\n}\r\n.text-blue {\r\n    color: $purple !important;\r\n}\r\n.text-blue-light {\r\n    color: $indigo !important;\r\n}",".page-header {\r\n    margin-bottom: 14px;\r\n    .page-title {\r\n        font-weight: $font-weight-semibold;\r\n        margin-bottom: 10px;\r\n        @include respond-below(custom991) {\r\n            font-size: $font-size-18;\r\n        }\r\n        @include respond-below(custom767) {\r\n            margin-bottom: 14px;\r\n        }\r\n        .count-title {\r\n            background: #F3EDFF;\r\n            border-radius: 5px;\r\n            @include margin-padding(0 0 0 8px, 5px);\r\n            color: $purple;\r\n            font-size: $font-size-12;\r\n            font-weight: $font-weight-semibold;\r\n        }\r\n    }\r\n    .title-head {\r\n        @include respond-below(custom991) {\r\n            margin-top: 0;\r\n        }\r\n    }\r\n    .head-icons {\r\n        margin-bottom: 10px;\r\n        @include respond-below(custom991) {\r\n           display: none;\r\n        }\r\n        a {\r\n            width: 32px;\r\n            height: 32px;\r\n            background: $white;\r\n            color: $gray-900;\r\n            display: -webkit-inline-box;\r\n            display: -ms-inline-flexbox;\r\n            display: inline-flex;\r\n            -webkit-box-align: center;\r\n            -ms-flex-align: center;\r\n            align-items: center;\r\n            justify-content: center;\r\n            -webkit-justify-content: center;\r\n            -ms-flex-pack: center;\r\n            border: 1px solid $light-900;\r\n            border-radius: 5px;\r\n            margin-right: 8px;\r\n            &.active, &:hover {\r\n                background: $green;\r\n                color: $white;\r\n            }\r\n            &:last-child {\r\n                margin-right: 0;\r\n            }\r\n            @include respond-below(custom991) {\r\n                margin-right: 4px !important;\r\n                &:last-child {\r\n                    margin-right: 0 !important;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .form-sort {\r\n        margin-top: 0;\r\n    }\r\n}\r\n.set-star {\r\n    i {\r\n        color: $light-900;\r\n        &.filled {\r\n            color: $orange;\r\n        }\r\n    }\r\n}\r\n.rating-select {\r\n    &.filled {\r\n        i {\r\n            color: $orange;\r\n        }\r\n    }\r\n}\r\n.icon-form {\r\n    position: relative;\r\n    .form-icon {\r\n        position: absolute;\r\n        top: 50%;\r\n        left: 15px;\r\n        transform: translateY(-50%);\r\n        color: $gray-900;\r\n    }\r\n    .form-control {\r\n        @include margin-padding(null, 8px 15px 8px 35px);\r\n        &:focus{\r\n            @include margin-padding(null, 8px 15px 8px 35px);\r\n        }\r\n    }\r\n}\r\n.icon-form-end {\r\n    position: relative;\r\n    .form-icon {\r\n        position: absolute;\r\n        top: 50%;\r\n        right: 15px;\r\n        transform: translateY(-50%);\r\n        color: $gray-900;\r\n    }\r\n    .form-control {\r\n        @include margin-padding(null, 8px 34px 8px 15px);\r\n    }\r\n}\r\n.view-icons {\r\n    border: 1px solid $light-900;\r\n    border-radius: 5px;\r\n    @include margin-padding(null, 2px);\r\n        display: -webkit-inline-box;\r\n        display: -ms-inline-flexbox;\r\n        display: inline-flex;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        align-items: center;\r\n    a {\r\n        width: 34px;\r\n        height: 36px;\r\n        background: $white;\r\n        color: $gray-900;\r\n        display: -webkit-inline-box;\r\n        display: -ms-inline-flexbox;\r\n        display: inline-flex;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        align-items: center;\r\n        justify-content: center;\r\n        -webkit-justify-content: center;\r\n        -ms-flex-pack: center;\r\n        &:first-child {\r\n            border-radius: 5px 0 0 5px;\r\n        }\r\n        &:last-child {\r\n            border-radius: 0 5px 5px 0;\r\n        }\r\n        &.active, &:hover {\r\n            background: $green;\r\n            color: $white;\r\n        }\r\n    }\r\n}\r\n.sidebar-popoverlay{\r\n    position: fixed;\r\n    width: 100%;\r\n    height: 100vh;\r\n    background: rgba(0,0,0,0.75);\r\n    top: 0;\r\n    left: -100%;\r\n    z-index: 1003;\r\n    &.open{\r\n        left: 0;\r\n    }\r\n}\r\n.sidebar-popoverlay-sign{\r\n    position: fixed;\r\n    width: 100%;\r\n    height: 100vh;\r\n    background: rgba(0,0,0,0.75);\r\n    top: 0;\r\n    left: -100%;\r\n    z-index: 1003;\r\n    &.open{\r\n        left: 0;\r\n    }\r\n}\r\n.profile-pic-upload {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    margin-bottom: 5px;\r\n    .profile-pic {\r\n        border: 2px dashed $light-900;\r\n        margin: 0 15px 10px 0;\r\n        width: 100px;\r\n        height: 100px;\r\n        border-radius: 5px;\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        align-items: center;\r\n        justify-content: center;\r\n        -webkit-justify-content: center;\r\n        -ms-flex-pack: center;\r\n        position: relative;\r\n        span {\r\n            display: -webkit-box;\r\n            display: -ms-flexbox;\r\n            display: flex;\r\n        }\r\n        img {\r\n            width: 70px;\r\n            height: 70px;\r\n            border-radius: 5px;            \r\n        }\r\n        .close-img {\r\n            background: $danger;\r\n            color: $white;\r\n            width: 14px;\r\n            height: 14px;\r\n            border-radius: 2px;\r\n            border-radius: 5px;\r\n            display: -webkit-box;\r\n            display: -ms-flexbox;\r\n            display: flex;\r\n            -webkit-box-align: center;\r\n            -ms-flex-align: center;\r\n            align-items: center;\r\n            justify-content: center;\r\n            -webkit-justify-content: center;\r\n            -ms-flex-pack: center;\r\n            @include position(absolute, 10px, 10px, null, null);\r\n        }\r\n    }\r\n    .upload-content {\r\n        p {\r\n            margin-bottom: 10px;\r\n        }\r\n    }\r\n    .upload-btn {\r\n        background: $purple-100;\r\n        border-radius: 5px;\r\n        position: relative;\r\n        margin-bottom: 10px;\r\n        display: inline-block;\r\n        span {\r\n            @include margin-padding(null, 9px 12px);\r\n            cursor: pointer;\r\n            color: $purple;\r\n            display: inline-block;\r\n            i {\r\n                margin-right: 10px;\r\n            }\r\n        }\r\n        input {\r\n            opacity: 0;\r\n            width: 100%;\r\n            height: 100%;\r\n            position: absolute;\r\n            z-index: 1;\r\n            cursor: pointer;\r\n        }\r\n    }\r\n}\r\n.user-accordion-item {  \r\n    background: $white;\r\n    border: 1px solid #E8E8E8;  \r\n    border-radius: 5px;\r\n    box-shadow: 0px 4px 74px 0px #D0D0D040;\r\n    margin-bottom: 15px;\r\n    .accordion-wrap {\r\n        @include margin-padding(null, 10px 25px 10px 10px);\r\n        font-weight: $font-weight-medium;\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        align-items: center;\r\n        position: relative;\r\n        span {\r\n            width: 36px;\r\n            height: 36px;\r\n            border-radius: 5px;\r\n            display: -webkit-box;\r\n            display: -ms-flexbox;\r\n            display: flex;\r\n            -webkit-box-align: center;\r\n            -ms-flex-align: center;\r\n            align-items: center;\r\n            justify-content: center;\r\n            -webkit-justify-content: center;\r\n            -ms-flex-pack: center;\r\n            margin-right: 8px;\r\n        }\r\n        &:hover {\r\n            color: $gray-900;\r\n        }\r\n        &::before {\r\n            content: \"\\f054\";\r\n            font-family: 'Font Awesome 5 Free';\r\n            @include position(absolute, 50%, 10px, null, null);\r\n            @include transform(translateY(-50%));\r\n            font-size: $font-size-14;\r\n            font-weight: $font-weight-semibold;\r\n        } \r\n        &:not(.collapsed) {                 \r\n            &::before {\r\n                content: \"\\f078\";\r\n            } \r\n            span{\r\n                background: $primary;\r\n                color: $white;\r\n            }            \r\n        }\r\n    }\r\n    .content-collapse {\r\n        border-top: 1px solid $light-900;\r\n        @include margin-padding(5px 10px 10px, 15px 0 0);         \r\n    }\r\n    .accordion-collapse {\r\n        .form-wrap {\r\n            margin-bottom: 24px;\r\n            &.mb-wrap {\r\n                margin-bottom: 0;\r\n                @include respond-below(custom767) {\r\n                    margin-bottom: 24px;\r\n                }\r\n            }\r\n        }       \r\n    }\r\n}\r\n.submit-button {\r\n    .btn {\r\n        font-size: $font-size-14;\r\n        font-weight: $font-weight-semibold;\r\n        border-radius: $border-radius-lg;\r\n        @include margin-padding(0 10px 0 0, 7px 15px);\r\n        &:last-child {\r\n            margin-right: 0;\r\n        }\r\n    }\r\n}\r\n.radio-wrap {\r\n    .col-form-label {\r\n        padding-bottom: 12px;\r\n    }\r\n    .radio-btn {\r\n        margin-right: 15px;\r\n        &:last-child {\r\n            margin-right: 0;\r\n        }\r\n    }\r\n}\r\n.success-message {\r\n    h3 {\r\n        margin-bottom: 10px;\r\n        font-size: $font-size-20;\r\n    }\r\n    .del-info {\r\n        max-width: 300px;\r\n        @include margin-padding(0 auto, null);\r\n    }\r\n    p {\r\n        font-size: $font-size-16;\r\n        margin-bottom: 0;\r\n        @include respond-below(custom767) {\r\n            font-size: $font-size-14;\r\n        }\r\n    }    \r\n    .modal-btn {\r\n        margin-top: 40px;\r\n    }\r\n}\r\n.success-popup-icon {\r\n    background: $danger-100;\r\n    color: $danger;\r\n    width: 65px;\r\n    height: 65px;\r\n    border-radius: 50%;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin: 0 auto 15px;\r\n    font-size: $font-size-42;\r\n    &.bg-light-blue {\r\n        background: $purple-100;\r\n        color: $purple;\r\n    }\r\n}\r\n.access-wrap {\r\n    border-radius: 5px;\r\n    @include margin-padding(0 0 20px, 10px);\r\n    box-shadow: $box-shadow-sm;\r\n    li {\r\n        @include margin-padding(0 0 5px, 0);\r\n        &.checkbox-checked {\r\n            label {\r\n                background: $light-300;\r\n            }\r\n        }\r\n        label {\r\n            width: 100%;\r\n            position: relative;\r\n            @include margin-padding(null, 5px);\r\n            background: transparent;\r\n            &.checkboxs {\r\n                .checkmarks {\r\n                    right: 10px;\r\n                    left: unset;\r\n                    top: 50%;\r\n                    transform: translatey(-50%);\r\n                }\r\n                input:checked ~ .checkmark {\r\n                    background: $primary;\r\n                    border-color: $primary;\r\n                }\r\n            }\r\n            .people-profile {\r\n                display: -webkit-box;\r\n                display: -ms-flexbox;\r\n                display: flex;\r\n                -webkit-box-align: center;\r\n                -ms-flex-align: center;\r\n                align-items: center;\r\n                img {\r\n                    width: 32px;\r\n                    height: 32px;\r\n                    border-radius: 50%;\r\n                    margin-right: 10px;\r\n                }\r\n                a {\r\n                    color: $text-color;\r\n                    font-size: $font-size-14;\r\n                }\r\n            }\r\n        }\r\n        &:hover {\r\n            background-color: $light-300;\r\n        }\r\n        &:last-child {\r\n            margin-bottom: 0;\r\n        }\r\n    }\r\n}\r\n.load-btn {\r\n    .btn {\r\n        i {\r\n            margin-left: 4px;\r\n            animation: spin 3000ms linear infinite;\r\n        }\r\n    }\r\n}\r\n@keyframes spin {\r\n    to {\r\n      @include transform(rotate(360deg));\r\n    }\r\n}\r\n.img-select {\r\n    position: relative;\r\n    .select-box-img {\r\n        width: 24px;\r\n        height: 24px;\r\n        position: absolute;\r\n        top: 50%;\r\n        left: 10px;\r\n        z-index: 9999;\r\n    }\r\n    .select2-selection__rendered {\r\n        padding-left: 40px !important;\r\n    }\r\n}\r\n.users-group {\r\n    ul {\r\n        display: flex;\r\n        align-items: center;\r\n        li {\r\n            a {\r\n                width: 24px;\r\n                height: 24px;\r\n                border-radius: 50%;\r\n                border: 1px solid $white;\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: center;\r\n                line-height: normal;\r\n                margin-left: -11px;\r\n                img {\r\n                    width: 24px;\r\n                    height: 24px;\r\n                    border-radius: 50%;\r\n                }\r\n                &.total-group-member {\r\n                    background: $primary;\r\n                    color: $white;\r\n                    font-size: $font-size-10;\r\n                }\r\n                &:hover {\r\n                    position: relative;\r\n                }\r\n            }\r\n            &:first-child {\r\n                a {\r\n                    margin-left: 0;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.add-new {\r\n    color: $danger;\r\n}\r\n.contact-head {\r\n    margin-bottom: 5px;\r\n    .contact-breadcrumb {\r\n        margin-bottom: 5px;\r\n        li {\r\n            color: $text-color;\r\n            position: relative;\r\n            display: inline-block;\r\n            @include margin-padding(0 2px 5px 0, 0 0 0 10px);\r\n            a {\r\n                color: $text-color;\r\n                i {\r\n                    color: $primary;\r\n                    margin-right: 8px;\r\n                }\r\n                &:hover {\r\n                    color: $primary;\r\n                }\r\n            }\r\n            &:last-child {\r\n                margin-right: 0;\r\n            }\r\n            &:first-child {\r\n                padding-left: 0;\r\n                &::before {\r\n                    content: none;\r\n                }\r\n            }\r\n            &::before {\r\n                content: \"/\";\r\n                @include position(absolute, 0, null, null, 0);\r\n            }\r\n            &.before-none {\r\n                padding-left: 5px;\r\n                &::before {\r\n                    content: none;\r\n                }\r\n            }\r\n            .btn {\r\n                i {\r\n                    color: $white;\r\n                }\r\n                color: $white;\r\n                &:hover {                    \r\n                    color: $white;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .contact-pagination {\r\n        display: -webkit-inline-box;\r\n        display: -ms-inline-flexbox;\r\n        display: inline-flex;\r\n        align-items: center;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        margin-bottom: 10px;\r\n        p {\r\n            @include margin-padding(0 15px 0 0, null);\r\n        }\r\n        ul {\r\n            li {\r\n                display: inline-block;\r\n                margin-right: 5px;\r\n                a {\r\n                    width: 26px;\r\n                    height: 26px;\r\n                    border-radius: 50%;\r\n                    background: $white;\r\n                    color: $title-color;\r\n                    display: -webkit-box;\r\n                    display: -ms-flexbox;\r\n                    display: flex;\r\n                    align-items: center;\r\n                    -webkit-box-align: center;\r\n                    -ms-flex-align: center;\r\n                    justify-content: center;\r\n                    -webkit-justify-content: center;\r\n                    -ms-flex-pack: center;\r\n                    &:hover {\r\n                        background: $primary;\r\n                        color: $white;\r\n                    }\r\n                }\r\n                &:last-child {\r\n                    margin-right: 0;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.contacts-action {\r\n    display: -webkit-inline-box;\r\n    display: -ms-inline-flexbox;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    flex-wrap: wrap;\r\n    & > a {\r\n        margin: 0 8px 8px 0;\r\n        &:last-child {\r\n            margin-right: 0;\r\n        }\r\n    }\r\n    .badge {\r\n        @include margin-padding(0 8px 10px 0, 7px 6px);\r\n        font-size: $font-size-14;\r\n        font-weight: $font-weight-normal;\r\n        &.badge-light {\r\n            background: $light-600;\r\n            color: $gray-400;\r\n        }\r\n        i {\r\n            margin-right: 8px;\r\n        }\r\n    }\r\n    .action-drops {\r\n        margin-bottom: 10px;\r\n        .dropdown-toggle {\r\n            font-weight: $font-weight-semibold;\r\n            color: $white; \r\n            display: inline-block;\r\n            span {\r\n                display: inline-block;\r\n                border-radius: 5px;\r\n                @include margin-padding(null, 4px 10px);\r\n                color: $white; \r\n            }\r\n        }\r\n    }\r\n    .dropdown-toggle {\r\n        margin-right: 0;\r\n        color: $secondary-900;\r\n        &::after {\r\n            content: none;\r\n        }\r\n    }\r\n    .btn {\r\n        border-radius: 5px;\r\n        padding: 6px 13px;\r\n        display: -webkit-inline-box;\r\n        display: -ms-inline-flexbox;\r\n        display: inline-flex;\r\n        align-items: center;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        font-size: $font-size-15;\r\n        font-weight: $font-weight-medium;\r\n        i {\r\n            margin-right: 5px;\r\n        }\r\n    }\r\n    .btn-icon {\r\n        width: 36px;\r\n        height: 36px;\r\n        border-radius: 5px;\r\n        display: -webkit-inline-box;\r\n        display: -ms-inline-flexbox;\r\n        display: inline-flex;\r\n        align-items: center;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        justify-content: center;\r\n        -webkit-justify-content: center;\r\n        -ms-flex-pack: center;\r\n        background: $light-300;    \r\n        border: 1px solid $light-300; \r\n        color: $title-color;\r\n        &:hover {\r\n            background: $primary;\r\n            color: $white;\r\n        }\r\n        &.rating {\r\n            border-radius: 50%;     \r\n            background: $white;\r\n            border: 1px solid $light-900; \r\n            color: $orange;    \r\n        }\r\n    }\r\n    .act-dropdown {\r\n        margin-bottom: 10px;\r\n        & > a {\r\n            width: 34px;\r\n            height: 34px;\r\n            border-radius: 5px;\r\n            display: -webkit-inline-box;\r\n            display: -ms-inline-flexbox;\r\n            display: inline-flex;\r\n            align-items: center;\r\n            -webkit-box-align: center;\r\n            -ms-flex-align: center;\r\n            justify-content: center;\r\n            -webkit-justify-content: center;\r\n            -ms-flex-pack: center;   \r\n            background: $white;\r\n            border: 1px solid $light-900; \r\n            &:hover {\r\n                background: $light-900;\r\n                color: $gray-900;\r\n            }   \r\n        }\r\n        .dropdown-item {\r\n            display: -webkit-box;\r\n            display: -ms-flexbox;\r\n            display: flex;\r\n            -webkit-box-align: center;\r\n            -ms-flex-align: center;\r\n            align-items: center;\r\n            @include margin-padding(null, 5px);\r\n            border-radius: 5px;\r\n            color: $title-color;\r\n            i {\r\n                margin-right: 8px;\r\n            }\r\n            &:hover {\r\n                background: $light-300;\r\n                color: $title-color;\r\n            }\r\n        }  \r\n    }\r\n}\r\n.basic-info li {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    align-items: center;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    font-size: $font-size-14;\r\n    span {\r\n        width: 26px;\r\n        height: 26px;\r\n        border-radius: 50%;\r\n        display: -webkit-inline-box;\r\n        display: -ms-inline-flexbox;\r\n        display: inline-flex;\r\n        align-items: center;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        justify-content: center;\r\n        -webkit-justify-content: center;\r\n        -ms-flex-pack: center;\r\n        background: $light-300;\r\n        color: $title-color;\r\n        margin-right: 10px;\r\n        flex-shrink: 0;\r\n    }\r\n}\r\n.set-info {\r\n    li {\r\n        a {\r\n            color: $gray-400;\r\n            &:hover {\r\n                color: $primary;\r\n            }\r\n        }\r\n        i {\r\n            margin-right: 5px;\r\n        }\r\n    }\r\n}\r\n.other-info {\r\n    li {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        .other-title {\r\n            min-width: 110px;\r\n            display: inline-block;\r\n        }\r\n        .avatar-xs {\r\n            width: 16px;\r\n            height: 16px;\r\n            border-radius: 5px;\r\n        }\r\n    }\r\n}\r\n.con-sidebar-title {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    align-items: center;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    justify-content: space-between;\r\n    -webkit-justify-content: space-between;\r\n    -ms-flex-pack: space-between;\r\n    flex-wrap: wrap; \r\n    a {\r\n        display: -webkit-inline-box;\r\n        display: -ms-inline-flexbox;\r\n        display: inline-flex;\r\n        align-items: center;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        color: $purple;\r\n        &:hover {\r\n            color: $primary;\r\n        }\r\n    }\r\n}\r\n.company-info {\r\n    li {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        align-items: center;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        span {\r\n            width: 52px;\r\n            height: 52px;\r\n            border-radius: 5px;\r\n            display: -webkit-box;\r\n            display: -ms-flexbox;\r\n            display: flex;\r\n            align-items: center;\r\n            -webkit-box-align: center;\r\n            -ms-flex-align: center;\r\n            justify-content: center;\r\n            -webkit-justify-content: center;\r\n            -ms-flex-pack: center;\r\n            border: 1px solid $light-900;\r\n            margin-right: 10px;\r\n        }\r\n        h6 {\r\n            font-size: $font-size-14;\r\n            font-weight: $font-weight-medium;\r\n            margin-bottom: 2px;\r\n\r\n        }\r\n        p {\r\n            font-size: $font-size-14;\r\n            margin-bottom: 0;\r\n        }\r\n    }\r\n    &.com-info {\r\n        li {\r\n            span {\r\n                width: 32px;\r\n                height: 32px;\r\n                margin-right: 8px;\r\n                border-radius: 50%;\r\n            }\r\n            p {\r\n                i {\r\n                    margin-right: 5px;\r\n                    color: $warning;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.deals-info {\r\n    li {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        align-items: center;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        img {\r\n            width: 32px;\r\n            height: 32px;\r\n            border-radius: 5px;\r\n            margin-right: 10px;\r\n        }\r\n        p {\r\n            margin-bottom: 0;\r\n        }\r\n    }\r\n}\r\n.social-info {\r\n    li {\r\n        display: inline-block;\r\n        a {\r\n            width: 32px;\r\n            height: 32px;\r\n            border-radius: 50%;\r\n            display: -webkit-inline-box;\r\n            display: -ms-inline-flexbox;\r\n            display: inline-flex;\r\n            align-items: center;\r\n            -webkit-box-align: center;\r\n            -ms-flex-align: center;\r\n            justify-content: center;\r\n            -webkit-justify-content: center;\r\n            -ms-flex-pack: center;\r\n            background: $white;\r\n            color: $gray-900;\r\n            &:hover {\r\n                background: $gray-900;\r\n                color: $white;\r\n            }\r\n        }\r\n    }\r\n}\r\n.tag-info {\r\n    li {\r\n        margin-right: 5px;\r\n        display: inline-block;\r\n        a {\r\n            font-size: $font-size-12;\r\n            font-weight: $font-weight-medium;\r\n            border-radius: 5px;\r\n            @include margin-padding(null, 5px 10px);\r\n            display: inline-block;\r\n        }\r\n        &:last-child {\r\n            margin-right: 0;\r\n        }\r\n    }\r\n}\r\n.star-icon {\r\n    width: 26px;\r\n    height: 26px;\r\n    border-radius: 50%;\r\n    display: -webkit-inline-box;\r\n    display: -ms-inline-flexbox;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    justify-content: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    border: 1px solid $light-900;\r\n    color: $orange;\r\n    i {\r\n        font-size: $font-size-14;\r\n    }\r\n}\r\n.contact-nav {\r\n    @include respond-below(custom575) {\r\n        display: block;\r\n    }\r\n    li {\r\n        display: inline-block;\r\n        @include margin-padding(0 20px 0 0, null);\r\n        a {\r\n            color: $gray-400;\r\n            display: -webkit-box;\r\n            display: -ms-flexbox;\r\n            display: flex;\r\n            align-items: center;\r\n            -webkit-box-align: center;\r\n            -ms-flex-align: center;\r\n             justify-content: center;\r\n            -webkit-justify-content: center;\r\n            -ms-flex-pack: center;\r\n            font-size: $font-size-14;\r\n            font-weight: $font-weight-medium;\r\n            border-bottom: 3px solid $white;\r\n            text-align: center;\r\n            @include margin-padding(null, 5px 5px 10px 5px);\r\n            &:hover, &.active {\r\n                color: $primary;\r\n                border-color: $primary;\r\n            }\r\n            i {\r\n                margin-right: 5px;\r\n            }\r\n        }\r\n        @include respond-below(custom575) {\r\n            display: block;\r\n        }\r\n    }\r\n}\r\n.form-sort {\r\n    position: relative;\r\n   i {\r\n        position: absolute;\r\n        z-index: 101;\r\n        width: 16px;\r\n        height: 16px;\r\n        top: 14px;\r\n        left: 7px;\r\n    }\r\n    .select2-container--default .select2-selection--single .select2-selection__rendered {\r\n        padding-left: 35px;\r\n    }\r\n    span.select2-container.select2-container--default.select2-container--open {\r\n        z-index: 99;\r\n    }\r\n}\r\n.badge-day {\r\n    background: $purple-100;\r\n    color: $purple;\r\n    border-radius: 5px;\r\n    display: inline-block;\r\n    font-size: $font-size-14;\r\n    @include margin-padding(0 0 20px, 4px 8px);\r\n    i {\r\n        margin-right: 5px;\r\n    }\r\n}\r\n.contact-activity {\r\n    ul {\r\n        &:last-child {\r\n            .activity-wrap {\r\n                &:last-child {\r\n                    margin-bottom: 0;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.upcoming-info {\r\n    border: 1px solid $light-900;\r\n    border-radius: 5px;\r\n    @include margin-padding(10px 0 0, 15px 15px 5px);\r\n    p {\r\n        font-weight: $font-weight-medium;\r\n        margin-bottom: 8px;\r\n    }\r\n    .dropdown {\r\n        margin-bottom: 10px;\r\n        .dropdown-toggle {\r\n            color: $gray-900;\r\n            display: -webkit-inline-box;\r\n            display: -ms-inline-flexbox;\r\n            display: inline-flex;\r\n            align-items: center;\r\n            -webkit-box-align: center;\r\n            -ms-flex-align: center;\r\n            font-size: $font-size-14;\r\n            &::after {\r\n                content: none;\r\n            }                    \r\n        }\r\n        .avatar-xs {\r\n            width: 16px;\r\n            height: 16px;\r\n            border-radius: 5px;\r\n            margin-right: 10px;\r\n        }     \r\n        .circle {\r\n            font-size: 10px;\r\n        }       \r\n        .dropdown-menu {\r\n            a {\r\n                display: -webkit-inline-box;\r\n                display: -ms-inline-flexbox;\r\n                display: inline-flex;\r\n                align-items: center;\r\n                -webkit-box-align: center;\r\n                -ms-flex-align: center;\r\n                font-size: $font-size-14;\r\n                color: $gray-900;\r\n            }\r\n        }\r\n    }\r\n}\r\n.notes-editor {\r\n    .dropdown-toggle::after {\r\n        content: none;\r\n    }\r\n}\r\n.note-edit-wrap {\r\n    display: none;\r\n    margin-bottom: 15px;\r\n}\r\n.notes-activity {\r\n    .note-download {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        align-items: center;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        justify-content: space-between;\r\n        -webkit-justify-content: space-between;\r\n        -ms-flex-pack: space-between;  \r\n        border: 1px solid $light-900;\r\n        box-shadow: 0px 4px 4px 0px #DBDBDB40;\r\n        @include margin-padding(0 0 15px, 15px);\r\n        border-radius: 5px;\r\n        .note-info {\r\n            display: -webkit-inline-box;\r\n            display: -ms-inline-flexbox;\r\n            display: inline-flex;\r\n            align-items: center;\r\n            -webkit-box-align: center;\r\n            -ms-flex-align: center;\r\n            justify-content: space-between;\r\n            -webkit-justify-content: space-between;\r\n            -ms-flex-pack: space-between;  \r\n            margin-right: 24px;\r\n            h6 {\r\n                font-weight: $font-weight-medium;\r\n                margin-bottom: 5px;\r\n            }   \r\n            p {\r\n                margin-bottom: 0;\r\n            }  \r\n            @include respond-below(custom767) { \r\n                margin-right: 15px;\r\n            }     \r\n        }\r\n        .note-icon {\r\n            width: 44px;\r\n            height: 44px;\r\n            border-radius: 5px;\r\n            color: $white;\r\n            display: -webkit-inline-box;\r\n            display: -ms-inline-flexbox;\r\n            display: inline-flex;\r\n            align-items: center;\r\n            -webkit-box-align: center;\r\n            -ms-flex-align: center;\r\n            justify-content: center;\r\n            -webkit-justify-content: center;\r\n            -ms-flex-pack: center;\r\n            margin-right: 8px;\r\n            flex-shrink: 0;\r\n            img {\r\n                width: 44px;\r\n                height: 44px;\r\n                border-radius: 50%;                \r\n            }\r\n        }\r\n        &:hover {\r\n            background: $light-300;\r\n            a {\r\n                background: $white;\r\n            }\r\n        }\r\n        a {\r\n            width: 24px;\r\n            height: 24px;\r\n            display: -webkit-box;\r\n            display: -ms-flexbox;\r\n            display: flex;\r\n            align-items: center;\r\n            -webkit-box-align: center;\r\n            -ms-flex-align: center;\r\n            justify-content: center;\r\n            -webkit-justify-content: center;\r\n            -ms-flex-pack: center;\r\n            border-radius: 50%;\r\n            color: $title-color;\r\n            background: $light-300;\r\n        }\r\n        @include respond-below(custom767) { \r\n            @include margin-padding(0 0 15px, 10px);\r\n        }\r\n    }\r\n    .reply-box {\r\n        background: $light-200;\r\n        border-radius: 5px;\r\n        @include margin-padding(0 0 15px, 15px);\r\n        p {\r\n            margin-bottom: 10px;\r\n        }\r\n        .btn {\r\n            background: $white;\r\n            border-color: $white;\r\n            border-radius: 5px;\r\n            color: $gray-900;\r\n            font-size: $font-size-16;\r\n            font-weight: $font-weight-normal;\r\n            @include margin-padding(0, 5px 10px);\r\n            i {\r\n                margin-right: 3px;\r\n            }\r\n            &:hover {\r\n                background: $light-100;\r\n            }\r\n        }\r\n    }   \r\n}\r\n.note-btns {\r\n    margin-top: 5px;\r\n    .btn {\r\n        @include margin-padding(10px 10px 0 0, 7px 15px);\r\n        &:last-child {\r\n            margin-right: 0;\r\n        }\r\n        &.btn-primary {\r\n            min-width: 110px;\r\n        }\r\n    }\r\n}\r\n.drag-attach {\r\n    border: 1px dashed $light-900;\r\n    border-radius: 5px;\r\n    position: relative;\r\n    text-align: center;\r\n    width: 100%;\r\n    overflow: hidden;\r\n    input {\r\n        opacity: 0;\r\n        width: 100%;\r\n        height: 100%;\r\n        position: absolute;\r\n        z-index: 1;\r\n        cursor: pointer;\r\n    }\r\n    .img-upload {\r\n        background: $purple-100;\r\n        color: $purple;\r\n        font-size: $font-size-14;\r\n        display: inline-block;\r\n        text-align: center;\r\n        @include margin-padding(24px 0, 9px 17px); \r\n        border-radius: 5px;\r\n        i {\r\n            margin-right: 10px;\r\n        }       \r\n    }\r\n}\r\n.drag-upload {\r\n    background: $light-100;\r\n    border: 1px dashed $secondary-200;\r\n    border-radius: 5px;\r\n    position: relative;\r\n    input {\r\n        opacity: 0;\r\n        width: 100%;\r\n        height: 100%;\r\n        position: absolute;\r\n        z-index: 1;\r\n        cursor: pointer;\r\n    }\r\n    i {\r\n        font-size: $font-size-24;\r\n        margin-bottom: 10px;\r\n    }\r\n    p {\r\n        font-size: $font-size-14;\r\n        margin-bottom: 0;\r\n    }\r\n    .img-upload {\r\n        text-align: center;\r\n        @include margin-padding(null, 36px 20px);        \r\n    }\r\n}\r\n.upload-file {\r\n    background: $light-200;\r\n    border: 1px solid $light-900;\r\n    @include margin-padding(0 0 5px, 15px);   \r\n    border-radius: 5px; \r\n    h6 {\r\n        font-size: $font-size-14;\r\n        font-weight: $font-weight-medium;\r\n        margin-bottom: 2px;\r\n    }   \r\n    p {\r\n        font-size: $font-size-14;\r\n        margin-bottom: 0;\r\n        &.black-text {\r\n            color: $gray-900;\r\n        }\r\n    } \r\n    .progress {\r\n        height: 3px;\r\n        @include margin-padding(15px 0 4px, null);\r\n    }\r\n    &.upload-list {    \r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        align-items: center;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;        \r\n        justify-content: space-between;\r\n        -webkit-justify-content: space-between;\r\n        -ms-flex-pack: space-between;\r\n    }\r\n}\r\n.form-title {\r\n    font-weight: $font-weight-semibold;\r\n    margin-bottom: 15px;\r\n}\r\n.sync-radio {\r\n    .radio-item {\r\n        margin-bottom: 15px;\r\n        label {\r\n            font-size: $font-size-14;\r\n        }\r\n        &:last-child {\r\n            margin-bottom: 0;\r\n        }\r\n    }\r\n}\r\n.signature-wrap {\r\n    background: $light-700;\r\n    border: 1px solid $light-900;\r\n    border-radius: 5px;\r\n    @include margin-padding(0 0 15px, 15px 15px 0);\r\n    h4, p {\r\n        margin-bottom: 15px;\r\n    }\r\n    h4 {\r\n        font-weight: $font-weight-semibold;\r\n         @include respond-below(custom767) {\r\n            font-size: $font-size-16;\r\n        }\r\n    }\r\n}\r\n.add-sign {\r\n    font-size: $font-size-16;\r\n    color: $warning;\r\n}\r\n.sign-item {\r\n    li {\r\n        margin-bottom: 15px;\r\n        .sign-title {\r\n            display: block;\r\n            font-weight: $font-weight-medium;\r\n            margin-bottom: 3px;\r\n        }\r\n    }\r\n}\r\n.trash-sign {\r\n    color: $danger;\r\n}\r\n.send-success {\r\n    border: 1px solid $success;\r\n    background: $success-300;\r\n    border-radius: 5px;\r\n    @include margin-padding(0 0 15px, 15px);\r\n    p {\r\n        color: $gray-900;\r\n        margin-bottom: 0;\r\n        i {\r\n            margin-right: 5px;\r\n        }\r\n    }\r\n}\r\nfieldset {\r\n    display: none;\r\n    &#first-field-file {\r\n        display: block;\r\n   }\r\n}\r\n.add-details-wizard {\r\n    ul {\r\n        display: flex;\r\n        align-items: center;\r\n        margin-bottom: 15px;\r\n        @include respond-below(custom575) {\r\n            flex-direction: column;\r\n        }\r\n        li {\r\n            line-height: normal;\r\n            background: $light-300;\r\n            padding: 10px 20px;\r\n            display: flex;\r\n            align-items: center;\r\n            @include respond-below(custom575) {\r\n                width: 100%;\r\n                margin-bottom: 10px;\r\n            }\r\n            span {\r\n                margin-right: 5px;\r\n            }\r\n            .multi-step-info {\r\n                h6 {\r\n                    margin-bottom: 0;\r\n                    font-weight: $font-weight-medium;\r\n                    font-size: $font-size-14;\r\n                    color: $gray-400;\r\n                }\r\n            }\r\n            &.active {\r\n                background: $primary;\r\n                color: $white;\r\n                h6 {\r\n                    color: $white;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.pipeline-item {\r\n    border: 1px solid $light-900;\r\n    @include margin-padding(0 0 5px, 15px 15px 5px);\r\n    border-radius: 5px;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    align-items: center;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;       \r\n    justify-content: space-between;\r\n    -webkit-justify-content: space-between;\r\n    -ms-flex-pack: space-between;\r\n    position: relative;\r\n    &::before {\r\n        @include position(absolute, 0, null, null, 0);\r\n        content: \"\";\r\n        width: 2px;\r\n        height: 100%;\r\n        background: $secondary;\r\n    }\r\n    p {\r\n        color: $gray-900;\r\n        font-weight: $font-weight-medium;\r\n        margin-bottom: 10px;\r\n    }\r\n    .action-pipeline {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        align-items: center;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;   \r\n        flex-wrap: wrap;    \r\n        a {\r\n           @include margin-padding(0 15px 10px 0, null);\r\n           i {\r\n                margin-right: 5px;\r\n           }\r\n           &:last-child {\r\n                margin-right: 0;\r\n           }\r\n        }\r\n    }\r\n    &:last-child {\r\n        margin-bottom: 0;\r\n    }\r\n}\r\n.access-item {\r\n    .radio-btn {\r\n        margin-right: 15px;\r\n        &:last-child {\r\n            margin-right: 0;\r\n        }\r\n    }\r\n}\r\n.access-wrapper {\r\n    margin-top: 20px;\r\n}\r\n.access-view {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    align-items: center;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center; \r\n    border: 1px solid $light-900;\r\n    @include margin-padding(0 0 5px, 15px 15px 15px);\r\n    border-radius: 5px;\r\n    justify-content: space-between;\r\n    -webkit-justify-content: space-between;\r\n    -ms-flex-pack: space-between;\r\n    .access-img {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        align-items: center;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center; \r\n        img {\r\n            width: 32px;\r\n            height: 32px;\r\n            border-radius: 5px;\r\n            margin-right: 10px;\r\n        }\r\n    }\r\n    a {\r\n        font-weight: $font-weight-semibold;\r\n        color: $danger;\r\n    }\r\n}\r\n.header-collapse {\r\n    .header-user {\r\n        display: none;\r\n        height: 0;\r\n    }\r\n    .page-wrapper {\r\n        padding-top:  0;\r\n    }\r\n    .header {\r\n        border-bottom: none;\r\n        background: transparent;\r\n        width: 260px;\r\n        .header-left {\r\n            background: white;\r\n        }\r\n    }\r\n    #collapse-header {\r\n        i {            \r\n            transform: rotate(180deg);\r\n            -webkit-transform: rotate(180deg);\r\n            -ms-transform: rotate(180deg);\r\n        }\r\n    }\r\n}\r\n.bootstrap-datetimepicker-widget {\r\n    z-index: 99999;\r\n    table {\r\n        td {\r\n            &.active, &:hover {\r\n                background-color: $green\r\n            }\r\n        }\r\n    }\r\n}\r\n.note-modal-backdrop {\r\n    z-index: 9;\r\n}\r\n.note-modal-footer {\r\n    height: 57px;\r\n}\r\n.table tbody tr td a {\r\n    &.title-name {\r\n        color: $gray-900;\r\n        font-weight: $font-weight-medium;\r\n        &:hover {\r\n            color: $primary;\r\n            text-decoration: underline;\r\n        }\r\n    }\r\n}\r\n.title-name {\r\n    color: $gray-900;\r\n    font-weight: $font-weight-medium;\r\n}\r\n.export-list {\r\n    >ul {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: end;\r\n        flex-wrap: wrap;\r\n        @include respond-below(custom575) {\r\n            justify-content: start;\r\n        }\r\n    }\r\n}\r\n.grid-social-links {\r\n    a {\r\n        &:hover {\r\n            background: $primary-100 !important;\r\n        }\r\n    }\r\n}\r\n\r\n",".daterange-picker{\r\n    .form-sort{\r\n        margin-left: 10px;\r\n       input{\r\n            padding-left: 25px;\r\n            height:38px;\r\n       }\r\n       .select2-container {\r\n            .select2-selection.select2-selection--single {\r\n                height: 38px;\r\n                .select2-selection__rendered{\r\n                    line-height: 38px;\r\n                }\r\n                .select2-selection__arrow {\r\n                    height: 38px;\r\n                }\r\n            }\r\n\r\n        }\r\n    }\r\n}\r\n.card-select {\r\n    ul {\r\n        display: flex;\r\n        align-items: center;\r\n        li{\r\n            + li{\r\n                margin-left: 12px;\r\n                \r\n            }\r\n        }\r\n    }        \r\n}\r\n.view-icons {\r\n    float: right;\r\n    @include respond-below(custom767) {\r\n        margin-right: 0;\r\n    }\r\n    .btn{\r\n        background-color: $white;\r\n        border: 1px solid $light-900;\r\n        color: $secondary-800;\r\n        font-size: $font-size-18;\r\n        min-width: 40px;\r\n        @include margin-padding(0 5px 0 0, 7px 0 3px 0);\r\n        &.active {\r\n            color: $secondary-900;\r\n        }\r\n        @include respond-below(custom767) {\r\n            min-width: 37px;\r\n            @include margin-padding(0 5px 0 0, 5px 0 3px 0);\r\n        }\r\n    }\r\n}\r\n.page-header {\r\n    .view-icons {\r\n        @include respond-below(custom767) {\r\n            margin-right: 10px;\r\n        }\r\n        @include respond-below(custom575) {\r\n            margin-right: 0;\r\n        }\r\n    }\r\n}\r\n.title-head {\r\n    justify-content: end;\r\n    align-items: center;\r\n    @include respond-below(custom767) {\r\n        justify-content: start;\r\n        margin-top: 20px;\r\n    }\r\n    @include respond-below(custom575) {\r\n        flex-direction: column;\r\n        row-gap: 20px;\r\n        align-items: start;\r\n    }\r\n    .add-btn {\r\n        margin-left: 10px;\r\n        border-radius: 5px;\r\n        @include respond-below(custom575) {\r\n            margin-left: 0;\r\n        }\r\n    }\r\n    .form-sort {\r\n        .list-view {\r\n            padding: 10px 10px 10px 30px;\r\n            background-color: $white;\r\n            border: 1px solid $light-900;\r\n            color: $secondary-600;\r\n            font-size: $font-size-14;\r\n            text-decoration: none;\r\n            line-height: normal;\r\n        }\r\n    }\r\n}\r\n.daterange-picker {\r\n    .form-sort {\r\n        min-width: 200px;\r\n    }\r\n}\r\n.statistic-dropdown {\r\n    .btn-primary{\r\n        padding: 6px 15px;\r\n        height: 35px;\r\n    }\r\n}\r\ntd {\r\n    .badge-pill {\r\n        display: inline-flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n}\r\n.badge-dots {\r\n    width:12px; \r\n    height:12px;\r\n    border-radius: 5px;\r\n    margin-right:5px;\r\n    display: inline-flex;\r\n}\r\n.title-head {\r\n    .daterange-picker {\r\n        .form-sort {\r\n            height: auto;\r\n            min-width: 212px;\r\n            i {\r\n                left: 15px;\r\n                top: 9px;\r\n            }\r\n            input {\r\n                height: 32px;\r\n                min-height: 32px;\r\n            }\r\n        }\r\n        .bookingrange {\r\n            padding-left: 35px;\r\n        }\r\n    }\r\n}",".error-page {\r\n    background: $white;\r\n}\r\n.comming-shapes {\r\n    position: relative;\r\n    @include respond-below(custom991) {\r\n        display: none;\r\n    }\r\n    .comming-right-shape {\r\n        position: fixed;\r\n        top: 0;\r\n        left: 0;\r\n    }\r\n    .comming-left-shape {\r\n        position: fixed;\r\n        bottom: -5px;\r\n        right: 0;\r\n    }\r\n    img {\r\n        width: 500px;\r\n    }\r\n}\r\n.error-img {\r\n    max-width: 500px;\r\n }",".account-page {\r\n    background: $white;\r\n}\r\n.form-wrap {\r\n    .form-wrap-icon {\r\n        position: relative;\r\n        i {\r\n            font-size: $font-size-18;\r\n            @include position(absolute,50%,15px,null,null);\r\n            transform: translateY(-50%);\r\n        }\r\n    }\r\n}\r\n.form-wrap-checkbox {\r\n    position: relative;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    -webkit-justify-content: space-between;\r\n    -ms-flex-pack: space-between;\r\n    margin-bottom: 20px;\r\n    .check {\r\n        display: -webkit-inline-box;\r\n        display: -ms-inline-flexbox;\r\n        display: inline-flex;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        align-items: center;\r\n        cursor: pointer;\r\n        color: $gray-900;\r\n        margin-bottom: 0;\r\n        input {\r\n            display: none;\r\n            &:checked + .box {\r\n                background: $secondary;\r\n                &:after {\r\n                    top: 0;\r\n                }\r\n            }\r\n        }\r\n        .box {\r\n            width: 20px;\r\n            height: 20px;\r\n            display: block;\r\n            margin-right: 8px;\r\n            transition: all 1.1s cubic-bezier(.19,1,.22,1);\r\n            background: $light-200;\r\n            position: relative;\r\n            overflow: hidden;\r\n            cursor: pointer;\r\n            border: 1px solid $light-900;\r\n            border-radius: $border-radius-lg;\r\n            &:after {\r\n                width: 12px;\r\n                height: 6px;\r\n                content: \"\";\r\n                position: absolute;\r\n                border-left: 2px solid;\r\n                border-bottom: 2px solid;\r\n                border-color: $white;\r\n                transform: rotate(-45deg) translate3d(0, 0, 0);\r\n                transform-origin: center center;\r\n                transition: all 1.1s cubic-bezier(0.19, 1, 0.22, 1);\r\n                left: 0;\r\n                right: 0;\r\n                top: 200%;\r\n                bottom: 3px;\r\n                margin: auto;\r\n            }\r\n        }\r\n    }\r\n}\r\n.hover-a {\r\n    position: relative;\r\n    color: $purple;\r\n    &:after {\r\n        content:\"\";\r\n        height: 2px;\r\n        width: 100%;\r\n        background: $purple;\r\n        @include transform(scale(0));\r\n        @include transition(all 0.3s ease);\r\n        @include position(absolute,null,null,-3px,0);\r\n    }\r\n    &:hover:after {\r\n        @include transform(scale(1));\r\n    }\r\n    &:hover {\r\n        color: $purple;\r\n    }\r\n}\r\n.account-bg-01 {\r\n    background-image: url(../../../../public/assets/img/authentication/login-bg.jpg);\r\n    background-repeat: no-repeat;\r\n    background-size: cover;\r\n    background-position: center;\r\n}\r\n.account-bg-02 {\r\n    background-image: url(../../../../public/assets/img/authentication/register-bg.jpg);\r\n    background-repeat: no-repeat;\r\n    background-size: cover;\r\n    background-position: center;\r\n}\r\n.account-bg-03 {\r\n    background-image: url(../../../../public/assets/img/authentication/forgot-bg.jpg);\r\n    background-repeat: no-repeat;\r\n    background-size: cover;\r\n    background-position: center;\r\n}\r\n.account-bg-04 {\r\n    background-image: url(../../../../public/assets/img/authentication/reset-bg.jpg);\r\n    background-repeat: no-repeat;\r\n    background-size: cover;\r\n    background-position: center;\r\n}\r\n.link-hover {\r\n    position: relative;\r\n    color: $primary;\r\n    font-weight: $font-weight-medium;\r\n    &:after {\r\n        content:\"\";\r\n        height: 2px;\r\n        width: 100%;\r\n        background: $primary;\r\n        @include transform(scale(0));\r\n        @include transition(all 0.3s ease);\r\n        @include position(absolute,null,null,-3px,0);\r\n    }\r\n    &:hover:after {\r\n        @include transform(scale(1));\r\n    }\r\n    &:hover {\r\n        color: $primary !important;\r\n    }\r\n}\r\n.bg-backdrop {\r\n    background: #FFFFFFF2;\r\n    backdrop-filter: blur(10px);\r\n    @include respond-below(custom767) {\r\n        width: 100% !important;\r\n    }\r\n}\r\n.form-set-login.or-text {\r\n    max-width: 365px;\r\n     margin: auto;\r\n}\r\n.toggle-password {\r\n    cursor: pointer;\r\n    width: 30px;\r\n    height: 30px;\r\n    color: $gray-900;\r\n    font-size: $font-size-18;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    align-items: center;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    justify-content: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    @include rounded(50%);\r\n    @include transform(translateY(-50%));\r\n    @include position(absolute,50%,10px,null,null);\r\n    &:hover{\r\n        color: $primary;\r\n    }\r\n}\r\n.toggle-passwords {\r\n    cursor: pointer;\r\n    width: 30px;\r\n    height: 30px;\r\n    color: $gray-900;\r\n    font-size: $font-size-18;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    align-items: center;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    justify-content: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    @include rounded(50%);\r\n    @include transform(translateY(-50%));\r\n    @include position(absolute,50%,10px,null,null);\r\n    &:hover{\r\n        color:$primary;\r\n    }\r\n}\r\n.toggle-password-new {\r\n    cursor: pointer;\r\n    width: 30px;\r\n    height: 30px;\r\n    color: $gray-900;\r\n    font-size: $font-size-18;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    align-items: center;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    justify-content: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    @include rounded(50%);\r\n    @include transform(translateY(-50%));\r\n    @include position(absolute,50%,10px,null,null);\r\n    &:hover{\r\n        color:$primary;\r\n    }\r\n}\r\n.pass-group {\r\n    position: relative;\r\n    font-size: $font-size-base;\r\n}\r\n.form-set-login {\r\n    text-align: center;\r\n    position: relative;\r\n    color: $sub-title;\r\n    font-size: $font-size-base;\r\n    font-weight: $font-weight-normal;\r\n    margin-bottom: 23px;\r\n    h4 {\r\n        position: relative;\r\n        font-size: $font-size-base;\r\n        color: $text-color;\r\n        font-weight: $font-weight-bold;\r\n        &:after{\r\n            content: \"\";\r\n            background: $sub-title;\r\n            width:21px;\r\n            height: 1px;\r\n            @include position(absolute,10px,null,null,200px);\r\n            @include respond-below(custom991) {\r\n                height: 0px;\r\n            }\r\n        }\r\n        &:before{\r\n            content: \"\";\r\n            background:$sub-title;\r\n            width:21px;\r\n            height: 1px;\r\n            @include position(absolute,10px,200px,null,null);\r\n            @include respond-below(custom991) {\r\n                height: 0px;\r\n            }\r\n        }\r\n    }\r\n}\r\n.mw-450 {\r\n    max-width: 450px;\r\n}\r\n.wh-85 {\r\n    width: 85px;\r\n    height: 85px;\r\n    @include respond-below(custom575) {\r\n        width: 50px;\r\n        height: 50px;\r\n    }\r\n}\r\n.login-shapes {\r\n    position: relative;\r\n    @include respond-below(custom991) {\r\n        display: none;\r\n    }\r\n    .login-right-shape {\r\n        position: fixed;\r\n        top: 0;\r\n        left: 0;\r\n    }\r\n    .login-left-shape {\r\n        position: fixed;\r\n        bottom: 0;\r\n        right: 0;\r\n        line-height: 0;\r\n    }\r\n}",".settings-sidebar {\r\n    h4 {\r\n        font-size: $font-size-18;\r\n        font-weight: $font-weight-semibold;\r\n        margin-bottom: 24px;\r\n        @include respond-below(custom767) {\r\n            font-size: $font-size-16;\r\n             margin-bottom: 15px;\r\n        }\r\n    }\r\n    a {\r\n        color: $gray-400;\r\n        display: -webkit-inline-box;\r\n        display: -ms-inline-flexbox;\r\n        display: inline-flex;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        align-items: center;\r\n        border-radius: $border-radius-lg;\r\n        padding: 10px;\r\n        width: 100%;\r\n        position: relative;\r\n        &.active {\r\n            background: $light-300;\r\n            color: $gray-900;\r\n            &:before {\r\n                position: absolute;\r\n                content: '\\f054';\r\n                font-family: 'FontAwesome';\r\n                font-size: $font-size-12;\r\n                top: 50%;\r\n                transform: translateY(-50%);\r\n                right: 10px;\r\n            }\r\n        }\r\n        &:hover {\r\n            color: $gray-900;  \r\n        }\r\n    }\r\n}\r\n.profile-upload {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    align-items: center;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    .profile-upload-img {\r\n        width: 100px;\r\n        min-width: 100px;\r\n        height: 100px;\r\n        position: relative;\r\n        margin-right: 15px;\r\n        border-radius: $border-radius-lg;\r\n        border: 2px dashed $light-900;\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        align-items: center;\r\n        justify-content: center;\r\n        -webkit-justify-content: center;\r\n        -ms-flex-pack: center;\r\n        span {\r\n            color: $gray-400;\r\n            position: absolute;\r\n        }\r\n    }\r\n    .profile-upload-content {\r\n        .profile-upload-btn {\r\n            display: -webkit-inline-box;\r\n            display: -ms-inline-flexbox;\r\n            display: inline-flex;\r\n            -webkit-box-align: center;\r\n            -ms-flex-align: center;\r\n            align-items: center;\r\n            position: relative;\r\n            overflow: hidden;\r\n            color: $purple;\r\n            background: $purple-100;\r\n            border: 1px solid $purple-100;\r\n            border-radius: $border-radius-lg;\r\n            padding: 8px 10px;\r\n            margin-bottom: 15px;\r\n            cursor: pointer;\r\n            transition: all 0.5s;\r\n            &:hover {\r\n                color: $white;\r\n                background: $purple;\r\n                border: 1px solid $purple;\r\n                transition: all 0.5s;\r\n            }\r\n            i {\r\n                font-size: $font-size-16;\r\n                margin-right: 8px;\r\n            }\r\n            input[type=\"file\"] {\r\n                position: absolute;\r\n                top: 0;\r\n                right: 0;\r\n                min-width: 100%;\r\n                min-height: 100%;\r\n                text-align: right;\r\n                filter: alpha(opacity = 0);\r\n                opacity: 0;\r\n                outline: none;\r\n                cursor: inherit;\r\n                display: block;\r\n            }\r\n        }\r\n        p {\r\n            font-weight: $font-weight-medium;\r\n            color: $gray-400;\r\n        }\r\n    }\r\n    .preview1 {\r\n        display: none;\r\n    }\r\n    .it {\r\n        width: 70px;\r\n        height: 70px;\r\n        border-radius: $border-radius-lg;\r\n        display: block;\r\n        position: relative;\r\n        background: $white;\r\n        object-fit: cover;\r\n    }\r\n    .profile-remove {\r\n        display: none;\r\n    }\r\n    .profile-remove-btn {\r\n        width: 14px;\r\n        height: 14px;\r\n        font-size: $font-size-10;\r\n        color: $white;\r\n        background: $danger;\r\n        border: 1px solid $danger;\r\n        border-radius: $border-radius-lg;\r\n        padding: 0;\r\n        display: inline-block;\r\n        position: absolute;\r\n        top: 8px;\r\n        right: 8px;\r\n    }\r\n    .profile-remove-btn:hover {\r\n        background: $danger-hover;\r\n        border: 1px solid $danger-hover;\r\n    }\r\n}\r\n.notificaion-table {\r\n    .table {\r\n        thead {\r\n            tr {                \r\n                &:first-child {\r\n                    th {\r\n                        padding-top: 0;\r\n                    }\r\n                }\r\n                th {\r\n                    font-size: $font-size-16;\r\n                    padding: 10px;\r\n                }\r\n            }\r\n        }\r\n        tbody {\r\n            tr {\r\n                td {\r\n                    font-weight: $font-weight-medium;\r\n                    color: $gray-900;\r\n                    padding: 10px;\r\n                }\r\n                &:last-child {\r\n                    td {\r\n                        padding-bottom: 0;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.mod-toggle {\r\n    .status-toggle {\r\n        margin-right: 20px;\r\n    }\r\n}\r\n.btn-add {\r\n    width: 32px;\r\n    height: 32px;\r\n    background: $white;\r\n    border: 1px solid $light-900;\r\n    border-radius: 5px;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    justify-content: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    color: $gray-900;\r\n    &:hover {\r\n        background: $green;\r\n        color: $white;\r\n    }\r\n}\r\n.settings-form {\r\n    .setting-title {\r\n        margin-bottom: 15px;\r\n        h6 {\r\n            font-size: $font-size-14;\r\n            font-weight: $font-weight-medium;\r\n        }\r\n        p {\r\n            font-size: $font-size-12;\r\n        }\r\n    }\r\n    .form-wrap {\r\n        margin-bottom: 15px;\r\n    }\r\n    .submit-button {\r\n        margin-top: 14px;\r\n    }\r\n}\r\n.bank-box {\r\n    background: $light-200;\r\n    border-radius: 5px;\r\n    border: 1px solid $light-200;\r\n    position: relative;\r\n    @include margin-padding(0 0 24px, 40px);\r\n    @include respond-below(custom991) {\r\n        @include margin-padding(0 0 24px, 20px);\r\n    }\r\n    &.active {\r\n        border-color: $success;\r\n        &::after {\r\n            position: absolute;\r\n            top: -8px;\r\n            right: -8px;\r\n            content: \"\\f058\";\r\n            font-family: \"Font Awesome 5 Free\";\r\n            font-weight: 900;\r\n            color: $success-900;\r\n            width: 22px;\r\n            height: 22px;\r\n            border-radius: 50%;\r\n            background-color: $white;\r\n            display: -webkit-box;\r\n            display: -ms-flexbox;\r\n            display: flex;\r\n            align-items: center;\r\n            -webkit-box-align: center;\r\n            -ms-flex-align: center;\r\n            justify-content: center;\r\n            -webkit-justify-content: center;\r\n            -ms-flex-pack: center;\r\n        }\r\n    }\r\n    .table-action {\r\n        .action-icon {\r\n            background-color: transparent;\r\n            &:hover {\r\n                background-color: $light-300;\r\n            }\r\n        }\r\n    }\r\n}\r\n.inv-days {\r\n    .select2-container {\r\n        min-width: 62px !important;\r\n    }\r\n    p {\r\n        color: $black;\r\n        margin-left: 10px;\r\n    }\r\n}\r\n.lang-type {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    align-items: center;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    li {\r\n        margin-right: 5px;\r\n        a {\r\n            background-color: $light-300;\r\n            @include rounded(5px);\r\n            color: $gray-400;\r\n            font-weight: $font-weight-medium;\r\n            @include margin-padding(null, 8px 15px);\r\n            display: inline-block;\r\n            &:hover {\r\n                background-color: $green;\r\n                color: $white !important;\r\n            }\r\n        }\r\n    }\r\n}\r\n.theme-type-images {\r\n    flex-wrap: wrap;\r\n    .theme-image {\r\n        background: $white;\r\n        border-radius: 5px;\r\n        border: 1px solid $light-900;\r\n        padding: 10px;\r\n        margin: 0 24px 15px 0;\r\n        text-align: center;\r\n        img {\r\n            width: 150px;\r\n             @include respond-below(custom1399) {\r\n               width: 130px;      \r\n            }\r\n        }\r\n        &:last-child {\r\n            margin-right: 0;\r\n        }\r\n        span {\r\n            font-weight: $font-weight-medium;\r\n            font-size: $font-size-14;\r\n            color: $gray-900;\r\n            margin-top: 10px;\r\n            display: block;\r\n        }\r\n        &.active {\r\n            border-color: $primary;\r\n            span {\r\n                color: $primary;\r\n            }\r\n        }\r\n    }\r\n}\r\n.theme-colors {\r\n    ul {\r\n        display: flex;\r\n        align-items: center;\r\n        li {\r\n            margin-right: 10px;\r\n            span {\r\n                width: 30px;\r\n                height: 30px;\r\n                border-radius: 50%;\r\n                background-color: $primary;\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: center;\r\n                cursor: pointer;\r\n                position: relative;\r\n                &.active {\r\n                    background-color: $primary-100;\r\n                    &:after {\r\n                        content: \"\";\r\n                        width: 25px;\r\n                        height: 25px;\r\n                        background-color: $primary;\r\n                        border-radius: 50%;\r\n                        opacity: 1;\r\n                    }\r\n                }\r\n                &.theme-secondary {\r\n                    background-color: $secondary;\r\n                    &.active {\r\n                        background-color: $secondary-100;\r\n                        &:after {\r\n                            background-color: $secondary;\r\n                        }\r\n                    }\r\n                }\r\n                &.theme-violet {\r\n                    background-color: $tertiary;\r\n                    &.active {\r\n                        background-color: rgba($tertiary, 0.1);\r\n                        &:after {\r\n                            background-color: $tertiary;\r\n                        }\r\n                    }\r\n                }\r\n                &.theme-blue {\r\n                    background-color: $indigo;\r\n                    &.active {\r\n                        background-color: $indigo-100;\r\n                        &:after {\r\n                            background-color: $indigo;\r\n                        }\r\n                    }\r\n                }\r\n                &.theme-brown {\r\n                    background-color: $purple;\r\n                    &.active {\r\n                        background-color: $purple-100;\r\n                        &:after {\r\n                            background-color: $purple;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n            &:last-child {\r\n                margin-right: 0;\r\n            }\r\n        }\r\n    }\r\n}\r\n.lang-wrap {\r\n    display: -webkit-inline-box;\r\n    display: -ms-inline-flexbox;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n}\r\n.lang-flag {\r\n    margin-right: 15px;\r\n    a {\r\n        display: -webkit-inline-box;\r\n        display: -ms-inline-flexbox;\r\n        display: inline-flex;\r\n        align-items: center;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        border: 1px solid $light-900;\r\n        @include rounded(8px);\r\n        color: $gray-900;\r\n        font-weight: $font-weight-medium;\r\n        @include margin-padding(null, 8px 8px);\r\n        img {\r\n            margin-right: 8px;\r\n            @include rounded(50%);\r\n            width: 20px;\r\n            height: 20px;\r\n        }\r\n    }\r\n}\r\n.lang-direct { \r\n    li {\r\n        @include margin-padding(0 8px 0 0, null);\r\n        a {\r\n            background-color: $gray-200;\r\n            color: $gray-900;\r\n            @include rounded(5px);\r\n            @include margin-padding(null, 8px 15px);\r\n            display: inline-block;\r\n            &:hover, &.active {\r\n                background-color: $tertiary;\r\n                color: $white;\r\n            }\r\n        }\r\n        &:last-child {\r\n            margin-right: 0;\r\n        }\r\n    }\r\n}\r\n.translate-wrap {\r\n    h6 {\r\n        font-weight: $font-weight-medium;\r\n        margin-bottom: 15px;\r\n    }\r\n    .form-wrap {\r\n        margin-bottom: 15px;\r\n    }\r\n    &.translate-title {\r\n        h6 {\r\n            font-size: $font-size-16;\r\n            font-weight: $font-weight-semibold;\r\n        }\r\n    }\r\n}\r\n.translate-item {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    align-items: center;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center; \r\n    justify-content: space-between;\r\n    -webkit-justify-content: space-between;\r\n    -ms-flex-pack: space-between;\r\n    flex-wrap: wrap;\r\n    margin-bottom: 24px;\r\n    .btn, .lang-flag  {\r\n        margin-bottom: 24px;\r\n    }\r\n}\r\n.lang-flag {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    align-items: center;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center; \r\n}\r\n.lang-progress {\r\n    margin-bottom: 24px;\r\n    p {\r\n        font-weight: $font-weight-medium;\r\n    }\r\n    .progress {\r\n        min-width: 100px;\r\n        max-width: 150px;\r\n        height: 7px;\r\n    }\r\n}\r\n.black-text {\r\n    color: $gray-900 !important;\r\n}\r\n.settings-tab {\r\n    .card-body {\r\n        padding-top: 0;\r\n         @include respond-below(custom767) {\r\n            padding-top: 16px;        \r\n        }\r\n        li {\r\n            a {\r\n                padding-top: 24px;                \r\n                @include respond-below(custom767) {\r\n                     padding-top: 8px; \r\n                     padding-bottom: 8px;           \r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.payment-img {\r\n    width: 80px;\r\n    height: 40px;\r\n}\r\n\r\n\r\n",".source-report {\r\n    color: #00918E;\r\n    font-weight: 500;\r\n}\r\n.dropdown {\r\n    &.table-action {\r\n        .dropdown-toggle {\r\n            &::after {\r\n                display: none;\r\n            }\r\n        }\r\n    }\r\n    .dropdown-toggle {\r\n        color: $gray-900;\r\n        border: 1px solid $light-900;\r\n        padding: 9px 15px;\r\n        border-radius: $border-radius-lg;\r\n        display: flex;\r\n        align-items: center;\r\n        box-shadow: 0px 4px 4px 0px #DBDBDB40;\r\n        &:after {\r\n            border-top: 0;\r\n            border-left: 0;\r\n            border-bottom: 2px solid $gray-900;\r\n            border-right: 2px solid $gray-900;\r\n            content: '';\r\n            display: inline-block;\r\n            pointer-events: none;\r\n            width: 8px;\r\n            height: 8px;\r\n            vertical-align: 2px;\r\n            @include transform-origin(66% 66%);\r\n            @include transition(all 0.2s ease);\r\n            @include transform(rotate(45deg));\r\n        }\r\n        &[aria-expanded=\"true\"]:after {\r\n            @include transform(rotate(-135deg));\r\n        }\r\n    }\r\n    .dropdown-menu {\r\n        padding: 10px;\r\n        background: $white;\r\n        box-shadow: $box-shadow-lg;\r\n        border: 1px solid $light-900;\r\n        .dropdown-item {\r\n            padding: 5px 10px;\r\n            color: $gray-800;\r\n            background: $white;\r\n            border-radius: $border-radius-lg;\r\n            &:hover {\r\n                color: $gray-900;\r\n                background: $light-300;\r\n            }\r\n        }\r\n    }\r\n}",".time-text {\r\n\tp {\r\n\t\tfont-weight: $font-weight-medium;\r\n\t\twhite-space: nowrap;\r\n\t\tmargin-left: 15px;\r\n\t}\r\n}\r\n.activity-title {\r\n\tmargin-bottom: 10px;\r\n\tdisplay: -webkit-inline-box;\r\n\tdisplay: -ms-inline-flexbox;\r\n\tdisplay: inline-flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\th4 {\r\n\t\tfont-weight: $font-weight-semibold;\r\n\t\t@include margin-padding(0 15px 10px 0, 0 15px 0 0);\r\n\t\tposition: relative;\r\n\t\t&::after {\r\n\t\t\tcontent: \"\";\r\n\t\t\tbackground-color: $light-900;\r\n\t\t\twidth: 1px;\r\n\t\t\theight: 24px;\r\n\t\t\t@include position(absolute, 0, 0, null, null);\r\n\t\t\t@include respond-below(custom767) {\r\n\t\t\t\tcontent: none;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\t@include respond-below(custom767) {\r\n\t\tdisplay: block;\r\n\t}\r\n}\r\n.active-list {\r\n\tul {\r\n\t\tmargin-bottom: 10px;\r\n\t\tli {\r\n\t\t\tdisplay: inline-block;\r\n\t\t\tmargin-right: 10px;\r\n\t\t\ta {\r\n\t\t\t\twidth: 34px;\r\n\t\t\t\theight: 34px;\r\n\t\t\t\t@include rounded(5px);\r\n\t\t\t\tborder: 1px solid $light-900;\r\n\t            display: -webkit-inline-box;\r\n\t            display: -ms-inline-flexbox;\r\n\t            display: inline-flex;\r\n\t            -webkit-box-align: center;\r\n\t            -ms-flex-align: center;\r\n\t            align-items: center;\r\n\t            justify-content: center;\r\n\t            -webkit-justify-content: center;\r\n\t            -ms-flex-pack: center;\r\n\t            color: $gray-900;\r\n\t            &:hover, &.active {\r\n\t            \tbackground-color: $green;\r\n\t            \tborder-color: $green;\r\n\t            \tcolor: $white;\r\n\t            }\r\n\t\t\t}\r\n\t\t\t&:last-child {\r\n\t\t\t\tmargin-right: 0;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n.radio-activity {\r\n\t li {\r\n\t \tdisplay: inline-block;\r\n\t \t.active-type {\r\n\t \t\tinput[type=\"radio\"] {\r\n\t \t\t\tdisplay: none;\r\n\t \t\t\t~ label {\r\n\t \t\t\t\tborder: 1px solid $light-900;\r\n\t \t\t\t\tbox-shadow: 0px 4px 4px 0px #DBDBDB40;\r\n\t \t\t\t\t@include margin-padding(0 10px 5px 0, 8px 20px);\r\n\t \t\t\t\t@include rounded(5px);\r\n\t \t\t\t\tcolor: $gray-900;\r\n\t \t\t\t\tcursor: pointer;\r\n\t \t\t\t\ti {\r\n\t \t\t\t\t\tmargin-right: 5px;\r\n\t \t\t\t\t}\r\n\t \t\t\t}\r\n\t \t\t\t&:checked {\r\n\t \t\t\t\t~ label {\r\n\t \t\t\t\t\tborder-color: $green;\r\n\t \t\t\t\t\tcolor: $green;\r\n\t \t\t\t\t}\r\n\t \t\t\t}\r\n\t \t\t}\r\n\t \t}\r\n\t \t&:last-child {\r\n\t \t\tmargin-right: 0;\r\n\t \t}\r\n\t }\r\n}\r\n.label-add {\r\n\tcolor: $primary;\r\n\tmargin-bottom: 5px;\r\n\tfont-weight: $font-weight-medium;\r\n\ti {\r\n\t\tmargin-right: 8px;\r\n\t}\r\n\t&:hover {\r\n\t\tcolor: $primary-hover;\r\n\t}\r\n}\r\n.tab-activity {\r\n\t@include rounded(5px);\r\n\t@include margin-padding(0 0 20px, 15px 15px 0);\r\n\tbox-shadow: 0px 4px 74px 0px #D0D0D040;\t\r\n\tul {\r\n\t\tli {\r\n\t\t\tdisplay: inline-block;\r\n\t\t\tmargin-right: 20px;\r\n\t\t\ta {\r\n\t\t\t\t@include margin-padding(null, 10px 5px 10px);\r\n\t\t\t\tfont-weight: $font-weight-medium;\r\n\t\t\t\tborder-bottom: 4px solid $white;\r\n\t\t\t\tdisplay: inline-block;\r\n\t\t\t\tspan {\r\n\t\t\t\t\twidth: 20px;\r\n\t\t\t\t\theight: 20px;\r\n\t\t\t\t\t@include rounded(50%);\r\n\t \t\t\t\tborder: 1px solid $light-900;\r\n\t\t            display: -webkit-inline-box;\r\n\t\t            display: -ms-inline-flexbox;\r\n\t\t            display: inline-flex;\r\n\t\t            -webkit-box-align: center;\r\n\t\t            -ms-flex-align: center;\r\n\t\t            align-items: center;\r\n\t\t            justify-content: center;\r\n\t\t            -webkit-justify-content: center;\r\n\t\t            -ms-flex-pack: center;\r\n\t\t            margin-left: 10px;\r\n\t\t            color: $gray-900;\r\n\t\t            font-weight: $font-weight-semibold;\r\n\t\t            font-size: $font-size-10;\r\n\t\t\t\t}\r\n\t\t\t\t&.active {\r\n\t\t\t\t\tcolor: $primary;\r\n\t\t\t\t\tborder-color: $primary;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n.comment-wrap {\r\n\t@include margin-padding(0 0 15px, 15px);\r\n\tbox-shadow: 0px 4px 74px 0px #D0D0D040;\r\n\tborder: 1px solid $light-900;\r\n\t@include rounded(5px);\r\n\th6 {\r\n\t\tfont-size: $font-size-16;\r\n\t\tfont-weight: $font-weight-normal;\r\n\t\tmargin-bottom: 10px;\r\n\t\tcolor: $gray-400;\r\n\t}\r\n\tp {\r\n\t\tspan {\r\n\t\t\tcolor: $purple;\r\n\t\t}\r\n\t}\r\n\t&:last-child {\r\n\t\tmargin-bottom: 0;\r\n\t}\r\n}\r\n.activity-badge {\r\n\tcolor: $white;\r\n\t@include margin-padding(null, 5px 7px);\r\n\tfont-size: $font-size-12;\r\n\t@include rounded(5px);\r\n\ti {\r\n\t\tmargin-right: 5px;\r\n\t}\r\n}\r\n.title-head {\r\n\tfont-weight: $font-weight-medium;\r\n\tcolor: $gray-900;\r\n}",".tasks-activity {\r\n\t&.tasks {\r\n\t\t& > ul {\r\n\t\t\tmargin-top: 15px;\r\n\t\t\t.task-wrap {\r\n\t\t\t\tdisplay: -webkit-box;\r\n\t\t\t\tdisplay: -ms-flexbox;\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\t-webkit-box-align: center;\r\n\t\t\t\t-ms-flex-align: center;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tjustify-content: space-between;\r\n\t\t\t\t-webkit-justify-content: space-between;\r\n\t\t\t\t-ms-flex-pack: space-between;\r\n\t\t\t\tflex-wrap: wrap;\r\n\t\t\t\t&.pending {\r\n\t\t\t\t\t&::before { \r\n\t\t\t\t\t\tbackground-color: $violet;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t\t&.warning {\r\n\t\t\t\t\t&::before { \r\n\t\t\t\t\t\tbackground-color: $warning;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t\t&.success {\r\n\t\t\t\t\t&::before { \r\n\t\t\t\t\t\tbackground-color: $success;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t\t.task-info {\r\n\t\t\t\t\t.task-icon {\r\n\t\t\t\t\t\tmargin: 0 20px 10px 0;\r\n\t\t\t\t\t}\r\n\t\t\t\t\t.task-checkbox {\r\n\t\t\t\t\t\tmargin: 0 20px 10px 0;\r\n\t\t\t\t\t\t.checkboxs .checkmarks {\r\n\t\t\t\t\t\t\ttop: 50%;\r\n\t\t\t\t\t\t\t@include transform(translateY(-50%));\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t\t.set-star {\r\n\t\t\t\t\t\tmargin: 0 20px 10px 0;\r\n\t\t\t\t\t}\r\n\t\t\t\t\tp {\r\n\t\t\t\t\t\tfont-weight: $font-weight-medium;\r\n\t\t\t\t\t}\r\n\t\t\t\t\t.badge {\r\n\t\t\t\t\t\tfont-weight: $font-weight-semibold;\r\n\t\t\t\t\t\tfont-size: $font-size-12;\r\n\t\t\t\t\t\t@include margin-padding(0 5px 10px 0, 5px 7px);\r\n\t\t\t\t\t\tcolor: $white;\r\n\t\t\t\t\t\t&:last-child {\r\n\t\t\t\t\t\t\tmargin-right: 0;\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t}\t\r\n\t\t\t\t.task-actions {\r\n\t\t\t\t\tul {\t\r\n\t\t\t\t\t\tli {\r\n\t\t\t\t\t\t\t@include margin-padding(0 10px 10px 0, null);\r\n\t\t\t\t\t\t\t.badge-tag {\r\n\t\t\t\t\t\t\t\tpadding: 5px 4px; \r\n\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t\t&:last-child {\r\n\t\t\t\t\t\t\t\tmargin-right: 0;\r\n\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t}\t\t\t\r\n\t\t\t}\t\t\t\r\n\t\t}\r\n\t}\r\n}\r\n.all-read {\r\n\t.checkboxs {\r\n\t\t.checkmarks {\r\n\t\t\ttop: 50%;\r\n\t\t\t@include transform(translateY(-50%));\r\n\t\t}\r\n\t}\r\n}\r\n.task-drops {\r\n\t.dropdown-toggle {\r\n\t\tborder: 0;\r\n\t\tpadding: 0;\r\n\t\tfont-size: $font-size-18;\r\n\t\tfont-weight: $font-weight-semibold;\r\n\t\tbox-shadow: none;\r\n\t\t&.show {\r\n\t\t\tborder: 0;\r\n\t\t}\r\n\t\t@include respond-below(custom767) {\r\n\t\t\tfont-size: $font-size-16;\r\n\t\t}\r\n\t}\r\n}\r\n.badge-purple-light{\r\n\tcolor: #4A00E5 !important;\r\n\tbackground: #F3EDFF !important;\r\n}\r\n.task-wrapper {\r\n\tborder-bottom: 1px solid $light-900;\r\n\tmargin-bottom: 15px;\r\n\tpadding-bottom: 15px;\r\n\t.tasks-activity {\r\n\t\t\t&.tasks {\t\t\t\r\n\t\t\t\t& > ul {\r\n\t\t\t\t\tmargin-bottom: 15px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t&:last-child {\r\n\t\tpadding-bottom: 0;\r\n\t\t.tasks-activity {\r\n\t\t\t&.tasks {\t\t\t\r\n\t\t\t\t& > ul {\r\n\t\t\t\t\tmargin-bottom: 0;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\t.task-accordion {\r\n\t\tfont-size: $font-size-18;\r\n\t\tfont-weight: $font-weight-semibold;\r\n\t\tposition: relative;\r\n\t\tdisplay: block;\r\n\t\th4 {\r\n\t\t\t@include respond-below(custom767) {\r\n\t\t\t\tfont-size: $font-size-16;\r\n\t\t\t}\r\n\t\t}\r\n\t\tspan {\r\n\t\t\twidth: 20px;\r\n\t\t\theight: 20px;\r\n\t\t\t@include rounded(50%);\r\n\t\t\tborder: 1px solid $light-900;\r\n\t\t\tdisplay: -webkit-inline-box;\r\n\t\t\tdisplay: -ms-inline-flexbox;\r\n\t\t\tdisplay: inline-flex;\r\n\t\t\t-webkit-box-align: center;\r\n\t\t\t-ms-flex-align: center;\r\n\t\t\talign-items: center;\r\n\t\t\tjustify-content: center;\r\n\t\t\t-webkit-justify-content: center;\r\n\t\t\t-ms-flex-pack: center;\r\n\t\t\tmargin-left: 10px;\r\n\t\t\tcolor: $gray-900;\r\n\t\t\tfont-weight: $font-weight-semibold;\r\n\t\t\tfont-size: $font-size-10;\r\n\t\t}\r\n\t\t&::before {\r\n            content: \"\\f054\";\r\n            font-family: 'Font Awesome 5 Free';\r\n            @include position(absolute, 50%, 10px, null, null);\r\n            @include transform(translateY(-50%));\r\n            font-size: $font-size-14;\r\n            font-weight: $font-weight-semibold;\r\n        } \r\n        &:not(.collapsed) {                 \r\n            &::before {\r\n                content: \"\\f078\";\r\n            }           \r\n        }\r\n\t}\r\n\t&:last-child {\r\n\t\tborder: 0;\r\n\t\tmargin-bottom: 0;\r\n\t}\r\n}\r\n\r\n\r\n.preloader {\r\n\tposition: fixed;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\tz-index: 999999;\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tbackground: #FFF;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\t.loader {\r\n\t\twidth: 64px;\r\n\t\theight: 64px;\r\n\t\tposition: relative;\r\n\t\tanimation: rotate 1.5s ease-in infinite alternate;\r\n\t  }\r\n\t  .loader::before {\r\n\t\tcontent: '';\r\n\t\tposition: absolute;\r\n\t\tleft: 0;\r\n\t\tbottom: 0;\r\n\t\tcolor: $tertiary;\r\n\t\tbackground: currentColor;\r\n\t\twidth: 64px;\r\n\t\theight: 32px;\r\n\t\tborder-radius: 0 0 50px 50px;\r\n\t  }\r\n\t  .loader::after {\r\n\t\tcontent: '';\r\n\t\tposition: absolute;\r\n\t\tleft: 50%;\r\n\t\ttop: 10%;\r\n\t\tbackground: $green;\r\n\t\twidth: 8px;\r\n\t\theight: 64px;\r\n\t\tanimation: rotate 1.2s linear infinite alternate-reverse;\r\n\t  }\r\n\t\t\t \r\n  }\r\n\r\n  @keyframes rotate {\r\n\t100% { transform: rotate(360deg)}\r\n  }\r\n  \r\n.toggle-content-view {\r\n    margin-bottom: 24px;\r\n\th5{\r\n\t\tfont-size: 20px;\r\n\t\tfont-weight: 700;\r\n\t\tcolor: $gray-900;\r\n\t\tmargin-bottom: 5px;\r\n\t}\r\n\tp{\r\n\t\tcolor: $gray-400;\r\n\t\tfont-size: 14px;\r\n\t}\r\n}\r\n.details-propsal{\r\n\th4 {\r\n\t\tfont-size: 16px;\r\n\t\tfont-weight: 600;\r\n\t\tmargin-bottom: 24px;\r\n\t}\r\n\th6{\r\n\t\tfont-size: 14px;\r\n\t\tfont-weight: 400;\r\n\t\tmargin-bottom: 12px;\r\n\t}\r\n\th3{\r\n\t\tcolor: #3C2371;\r\n\t\tfont-size: 16px;\r\n\t\tfont-weight: 600;\r\n\t\tmargin-bottom: 12px;\r\n\t}\r\n\tspan{\r\n\t\tcolor: #6F6F6F;\r\n\t\tfont-size: 14px;\r\n\t\tdisplay: block;\r\n\t}\r\n\t&.details-propsals{\r\n\t\tul{\r\n\t\t\tli{\r\n\t\t\t\twidth: 33.3%;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\tul{\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tflex-wrap: wrap;\r\n\t\tborder-bottom: 1px solid $light-900;\r\n\t\tmargin-bottom: 20px;\r\n\t\tli{\r\n\t\t\twidth: 25%;\r\n\t\t\tmargin-bottom: 10px;\r\n\t\t\th5{\r\n\t\t\t\tcolor: $gray-600;\r\n\t\t\t\tfont-weight: 400;\r\n\t\t\t\tmargin-bottom: 5px;\r\n\t\t\t}\r\n\t\t\th6{\r\n\r\n\t\t\t\tcolor: $gray-900;\r\n\t\t\t\tfont-weight: 400;\r\n\t\t\t}\r\n\t\t\timg{\r\n\t\t\t\twidth: 16px;\r\n\t\t\t\theight: 16px;\r\n\t\t\t\tmargin-right: 8px;\r\n\t\t\t\tborder-radius: 5px;\r\n\t\t\t}\r\n\t\t\t.btn{\r\n\t\t\t\tpadding: 3px 15px;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n.attached-div{\r\n\th5 {\r\n\t\tfont-size: 16px;\r\n\t\tmargin-bottom: 12px;\r\n\t}\r\n}\r\n.attached-div{\r\n\tpadding-bottom: 15px;\r\n}\r\n.attachement-download {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    border: 1px solid #E8E8E8;\r\n    padding: 15px;\r\n    border-radius: 5px;\r\n\tmargin-bottom: 12px;\r\n}\r\n.attachement-download-icon {\r\n\tspan {\r\n\t\tbackground: #E41F07;\r\n\t\twidth: 44px;\r\n\t\theight: 44px;\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tjustify-content: center;\r\n\t\tfont-size: 22px;\r\n\t\tcolor: #fff;\r\n\t\tborder-radius: 5px;\r\n\t}\r\n}\r\n.attachement-download-img {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n.attachement-download-content {\r\n    margin-left: 10px;\r\n\th5 {\r\n\t\tfont-size: 14px;\r\n\t\tmargin-bottom: 3px;\r\n\t\tfont-weight: 600;\r\n\t}\r\n\th6 {\r\n\t\tfont-size: 14px;\r\n\t\tfont-weight: 400;\r\n\t}\r\n}\r\n\r\n.table-view {\r\n    margin-bottom: 24px;\r\n    border: 1px solid #E8E8E8;\r\n    border-radius: 10px;\r\n\tth {\r\n\t\tbackground: #E8E8E8;\r\n\t}\r\n}\r\n.table-view{\r\n\tmargin-bottom: 24px;\r\n    border: 1px solid #E8E8E8;\r\n    border-radius: 10px;\r\n\tth {\r\n\t\tbackground: #E8E8E8;\r\n\t}\r\n} \r\n.subtotal-div {\r\n    background: #F9F9FC;\r\n    padding: 24px;\r\n\tul {\r\n\t\tli {\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tjustify-content: space-between;\r\n\t\t\th5{\r\n\t\t\t\tfont-size: 14px;\r\n\t\t\t\tcolor: $gray-400;\r\n\t\t\t\tfont-weight: 400;\r\n\t\t\t\tmargin: 0;\r\n\t\t\t}\r\n\t\t\th6{\r\n\t\t\t\tfont-size: 16px;\r\n\t\t\t\tcolor: $gray-900;\r\n\t\t\t\tfont-weight: 600;\r\n\t\t\t\tmargin: 0;\r\n\t\t\t}\r\n\t\t\t+ li{\r\n\t\t\t\tmargin-top: 15px;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n.terms-condition{\r\n\tmargin-top: 15px;\r\n\tpadding-top: 15px;\r\n\tborder-top: 1px solid #E8E8E8;\r\n\th2{\r\n\t\tfont-size: 14px;\r\n\t\tfont-weight: 600;\r\n\t\tcolor: $gray-900;\r\n\t\tmargin-bottom: 15px;\r\n\t}\r\n\tp{\r\n\t\tcolor: $gray-400;\r\n\t\tfont-size: 14px;\r\n\t\tpadding-bottom: 15px;\r\n\t}\r\n}\r\n.contact-type{\r\n\th6{\r\n\t\tfont-weight: 600;\r\n\t}\r\n\tul{\r\n\t\tborder: 0;\r\n\t\tdisplay: inline;\r\n\t\tli{\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\twidth: 100%;\r\n\t\t\tmargin-bottom: 5px;\r\n\t\t\th5{\r\n\t\t\t\tposition: relative;\r\n\t\t\t\twidth: 40%;\r\n\t\t\t\tcolor: $gray-400;\r\n\t\t\t\tfont-size: 14px;\r\n\t\t\t\tmargin: 0;\r\n\t\t\t\t&:after{\r\n\t\t\t\t\tposition: absolute;\r\n\t\t\t\t\tcontent: \":\";\r\n\t\t\t\t\tright: 8px;\r\n\t\t\t\t\ttop: 0px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t\th6{\r\n\t\t\t\tposition: relative;\r\n\t\t\t\twidth: 60%;\r\n\t\t\t\tcolor: $gray-900;\r\n\t\t\t\tfont-size: 14px;\r\n\t\t\t\tmargin: 0;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n.renewal-history{\r\n\th4{\r\n\t\tfont-size: 16px;\r\n\t\tfont-weight: 600;\r\n\t\tmargin-bottom: 15px;\r\n\t}\r\n}\r\n.renewal-content {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    background: #fff;\r\n    border: 1px solid #E8E8E8;\r\n    padding: 24px;\r\n    box-shadow: 0px 4px 74px 0px #D0D0D040;\r\n    border-radius: 5px;\r\n\tmargin-bottom: 15px;\r\n\t.renewal-content-history{\r\n\t\twidth: 80%;\r\n\t}\r\n\t.contact-type{\r\n\t\th6{\r\n\t\t\tcolor: $gray-700;\r\n\t\t\tmargin-bottom: 15px;\r\n\t\t}\r\n\t\tul{\r\n\t\t\tflex-wrap: wrap;\r\n\t\t\tdisplay: flex;\r\n\t\t\tli{\r\n\t\t\t\twidth: 50%;\r\n\t\t\t\th6{\r\n\t\t\t\t\tmargin: 0;\r\n\t\t\t\t\tfont-size: 14px;\r\n\t\t\t\t\tfont-weight: 600;\r\n\t\t\t\t}\r\n\t\t\t\th5{\r\n\t\t\t\t\tfont-size: 14px;\r\n\t\t\t\t\tfont-weight: 400;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n.toogle-header-select{\r\n\t.select2-container{\r\n\t\tmin-width: 150px !important;\r\n\t}\r\n\t.select2-container--default .select2-results__option--selected {\r\n\t\tcolor: #fff;\r\n\t}\r\n\t.toggle-btn{\r\n\t\tmin-width: 26px;\r\n\t}\r\n}\r\n.btn-downloads{\r\n\tfont-size: 14px !important;\r\n\tborder: 1px solid #E8E8E8;\r\n\tpadding: 10px 15px;\r\n\tcolor: $gray-900 !important;\r\n\tfont-weight: 500;\r\n\tborder-radius: 5px;\r\n\t&:hover{\r\n\t\tbackground: $primary;\r\n\t\tcolor: $white !important;\r\n\t}\r\n\r\n}\r\n.input-table {\r\n\t&.input-table-descripition{\r\n\t\tinput{\r\n\t\t\twidth: 130px;\r\n\t\t}\r\n\t}\r\n\tinput {\r\n\t\tborder: 1px solid #E8E8E8;\r\n\t\theight: 30px;\r\n\t\tborder-radius: 5px;\r\n\t\twidth: 75px;\r\n\t\tpadding: 5px;\r\n\t}\r\n\tselect{\r\n\t\tborder: 1px solid #E8E8E8;\r\n\t\theight: 30px;\r\n\t\tborder-radius: 5px;\r\n\t\twidth: 75px;\r\n\t}\r\n}\r\n.upload-signature{\r\n\tposition: relative;\r\n\tinput{\r\n\t\twidth: 100%;\r\n\t\theight: 42px;\r\n\t\topacity: 0;\r\n\t\tz-index: 9;\r\n\t}\r\n\ta{\r\n\t\tborder: 1px dashed #E8E8E8;\r\n\t\tborder-radius: 5px;\r\n\t\tposition: absolute;\r\n\t\twidth: 100%;\r\n\t\theight: 42px;\r\n\t\ttext-align: center;\r\n\t\tfont-size: 14px;\r\n\t\tfont-weight: 400;\r\n\t\tcolor: $gray-400;\r\n\t\tleft: 0;\r\n\t\tpadding: 10px;\r\n\t\tbackground: #fff;\r\n\t}\r\n}\r\n.toggle-header-popup{\r\n\t.btn-dropdowns{\r\n\t\tmin-width: 125px;\r\n\t\tborder: 1px solid #E8E8E8;\r\n\t\tpadding: 8px 12px;\r\n\t\tfont-size: 14px !important;\r\n\t\tcolor: $gray-400 !important;\r\n\t\t&.dropdown-toggle:after{\r\n\t\t\ttop: -2px;\r\n\t\t\tposition: relative;\r\n\t\t\tfont-size: 12px;\r\n\t\t}\r\n\t\t&.dropdown-toggle-contract{\r\n\t\t\tmin-width: 150px;\r\n\t\t}\r\n\t\t&:hover{\r\n\t\t\tcolor: $white !important;\r\n\t\t\tbackground: $primary;\r\n\t\t}\r\n\t\t&:active,&:focus{\r\n\t\t\tcolor: $white !important;\r\n\t\t}\r\n\t}\r\n\t.dropdown-item{\r\n\t\tfont-size: 14px !important;\r\n\t\tcolor: $gray-400 !important;\r\n\t}\r\n}\r\n\r\n.toggle-popup-sent ,.toggle-popup-draft , .toggle-popup-declined{\r\n\t.sidebar-layout .sidebar-header a{\r\n\t\tfont-size: 14px;\r\n\t\tcolor: #fff;\r\n\t}\r\n}\r\n\r\n.signature-contant{\r\n\tpadding: 15px 0;\r\n\tborder-top: 1px solid #E8E8E8;\r\n\tborder-bottom: 1px solid #E8E8E8;\r\n\tp{\r\n\t\tcolor: #B5B5B5;\r\n\t\tmargin: 0;\r\n\t}\r\n}\r\n.pay-now{\r\n\t.btn{\r\n\t\theight: 42px;\r\n\t}\r\n}\r\n.sidebar {\r\n\t.sidebar-inner {\r\n\t\twidth: 100% !important;\r\n\t}\r\n}",".activities-list {\r\n    ul {\r\n        li {\r\n            background: $light-300;\r\n            padding: 15px 10px;\r\n            margin-bottom: 20px;\r\n            &:last-child {\r\n                margin-bottom: 0;\r\n            }\r\n            .activity-name {\r\n                h5 {\r\n                    font-size: $font-size-14;\r\n                    font-weight: $font-weight-medium;\r\n                    color: $gray-900;\r\n                    margin-bottom: 5px;\r\n                    -webkit-line-clamp: 1;\r\n                    -webkit-box-orient: vertical;\r\n                    overflow: hidden;\r\n                    text-overflow: ellipsis;\r\n                    display: -webkit-box;\r\n                }\r\n                p {\r\n                    font-size: $font-size-14;\r\n                    margin-bottom: 15px;\r\n                    -webkit-line-clamp: 1;\r\n                    -webkit-box-orient: vertical;\r\n                    overflow: hidden;\r\n                    text-overflow: ellipsis;\r\n                    display: -webkit-box;\r\n                }\r\n                .badge {\r\n                    color: $white;\r\n                    @include margin-padding(null, 5px 7px);\r\n                    font-size: $font-size-12;\r\n                    @include rounded(5px);\r\n                    i {\r\n                        margin-right: 5px;\r\n                    }\r\n                }\r\n            }\r\n            .user-activity {\r\n                display: flex;\r\n                align-items: center;\r\n                @include respond-below(custom767) {\r\n                    margin: 20px 0;\r\n                }\r\n               \r\n                span {\r\n                    flex-shrink: 0;\r\n                    display: inline-flex;\r\n                    margin-right: 5px;\r\n                    img {\r\n                        width: 32px;\r\n                        height: 32px;\r\n                        border-radius: 50%;\r\n                    }\r\n                }\r\n                h6 {\r\n                    margin-bottom: 0;\r\n                    -webkit-line-clamp: 1;\r\n                    -webkit-box-orient: vertical;\r\n                    overflow: hidden;\r\n                    text-overflow: ellipsis;\r\n                    display: -webkit-box;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.card-select {\r\n    ul {\r\n        @include respond-below(custom575) {\r\n            align-items: start !important;\r\n        }\r\n    }\r\n}\r\n.campaign-card {\r\n    overflow-x: auto;\r\n    ul {\r\n        width: max-content;\r\n        .campaign-wrap {\r\n            background-color: $light-200;\r\n            @include margin-padding(0 0 15px, 15px 15px 5px);\r\n            .campaign-info {\r\n                display: flex;\r\n                display: -webkit-flex;\r\n                align-items: center;\r\n                -webkit-align-items: center;\r\n                justify-content: space-between;\r\n                -webkit-justify-content: space-between;\r\n                white-space: nowrap;\r\n                border-bottom: 1px solid $light-900;\r\n                margin: 0 0 15px 0;\r\n                h5 {\r\n                    font-weight: $font-weight-semibold;\r\n                    margin-bottom: 5px;\r\n                }\r\n                .campaign-name {\r\n                    margin: 0 50px 10px 0;\r\n                }\r\n                .list-progress {\r\n                    margin-bottom: 10px;\r\n                }\r\n            }\r\n            .campaign-action {\r\n                display: flex;\r\n                display: -webkit-flex;\r\n                align-items: center;\r\n                -webkit-align-items: center;\r\n                justify-content: space-between;\r\n                -webkit-justify-content: space-between;\r\n                flex-wrap: wrap;\r\n                .project-mem {\r\n                    margin-bottom: 10px;\r\n                }\r\n            }\r\n            .campaign-date {\r\n                margin-bottom: 10px;\r\n                display: flex;\r\n                display: -webkit-flex;\r\n                align-items: center;\r\n                -webkit-align-items: center;\r\n                .badge {\r\n                    margin: 0 15px 0 0;\r\n                }\r\n            }\r\n            &:last-child {\r\n                margin-bottom: 0;\r\n            }\r\n        }\r\n    }\r\n}",".priority {\r\n\t&.badge-tag {\r\n\t\tcolor: $gray-900;\r\n\t\tmin-width: 80px;\r\n\t\ttext-align: left;\r\n\t\tfont-weight: $font-weight-semibold;\r\n\t\ti {\r\n\t\t\tmargin-right: 4px;\r\n\t\t}\r\n\t\t&.badge-danger-light {\r\n\t\t\ti {\r\n\t\t\t\tcolor: $danger;\r\n\t\t\t}\r\n\t\t}\r\n\t\t&.badge-success-light {\r\n\t\t\ti {\r\n\t\t\t\tcolor: $success;\r\n\t\t\t}\r\n\t\t}\r\n\t\t&.badge-warning-light {\r\n\t\t\ti {\r\n\t\t\t\tcolor: $warning;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n.task-wrap {\r\n\tborder: 1px solid $light-900;\r\n\t@include margin-padding(0 0 10px, 15px 15px 5px);\r\n\tposition: relative;\r\n\t@include rounded(5px);\r\n\t&::before {\r\n\t\tcontent: \"\";\r\n\t\tbackground-color: $danger;\r\n\t\twidth: 3px;\r\n\t\theight: 100%;\r\n\t\t@include rounded(5px);\r\n\t\t@include position(absolute, 0, null, null, 0);\r\n\t}\r\n\t&:last-child {\r\n\t\tmargin-bottom: 0;\r\n\t}\r\n}\r\n.task-info {\r\n\tdisplay: flex;\r\n\tdisplay: -webkit-flex;\r\n\talign-items: center;\r\n\t-webkit-align-items: center;\r\n\tflex-wrap: wrap;\r\n\tp {\r\n\t\tdisplay: inline-block;\r\n\t\tmargin: 0 24px 10px 0;\r\n\t\ti {\r\n\t\t\tcolor: $gray-400;\r\n\t\t\tmargin-right: 10px;\r\n\t\t}\r\n\t \tcolor: $gray-900;\r\n\t}\r\n\t.badge {\r\n\t\tmargin: 0 10px 10px 0;\r\n\t\t&:last-child {\r\n\t\t\tmargin-right: 0;\r\n\t\t}\r\n\t\t&.badge-pill {\r\n\t\t\ti {\r\n\t\t\t\tmargin-right: 5px;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n.task-actions {\r\n\tfloat: right;\r\n\tul {\r\n\t\tdisplay: flex;\r\n\t\tdisplay: -webkit-flex;\r\n\t\talign-items: center;\r\n\t\t-webkit-align-items: center;\r\n\t\tflex-wrap: wrap;\r\n\t\tli {\r\n\t\t\tmargin: 0 24px 10px 0;\r\n\t\t\tcolor: $gray-900;\r\n\t\t\t&:last-child {\r\n\t\t\t\tmargin-right: 0;\r\n\t\t\t}\r\n\t\t\t&.task-time {\r\n\t\t\t\ti {\r\n\t\t\t\t\tmargin-right: 5px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t\t&.task-date {\r\n\t\t\t\ti {\r\n\t\t\t\t\tmargin-right: 5px;\r\n\t\t\t\t}\r\n\r\n\t\t\t}\r\n\t\t\t&.task-owner {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\tdisplay: -webkit-flex;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\t-webkit-align-items: center;\r\n\t\t\t\t.task-user {\r\n\t\t\t\t\tmargin-right: 10px;\r\n\t\t\t\t\theight: 24px;\r\n\t\t\t\t\timg {\r\n\t\t\t\t\t\twidth: 24px;\r\n\t\t\t\t\t\theight: 24px;\r\n\t\t\t\t\t\t@include rounded(50%);\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\t@include respond-below(custom767) {\r\n\t\tfloat: left;\r\n\t}\r\n}\r\n.select-priority {\r\n\tposition: relative;\r\n\t.select-icon {\r\n\t\t@include position(absolute, 50%, null, null, 10px);\r\n\t\t@include transform(translateY(-50%));\r\n\t\tz-index: 99999;\r\n\t\tcolor: $primary;\r\n\t}\r\n\t.select2-container--default .select2-selection--single .select2-selection__rendered {\r\n\t\tpadding-left: 30px;\r\n\t}\r\n}\r\n.project-name {\r\n\tmargin-bottom: 15px;\r\n\tp {\r\n\t\tfont-weight: $font-weight-medium;\r\n\t\tmargin-bottom: 5px;\r\n\t}\r\n\th4 {\r\n\t\tfont-weight: $font-weight-semibold;\r\n\t}\r\n}\r\n.con-sidebar-title {\r\n\t.priority {\r\n\t\tmargin-bottom: 15px;\r\n\t}\r\n\tp {\r\n\t\tfont-weight: $font-weight-medium;;\r\n\t\tcolor: $gray-900;\r\n\t\tmargin-bottom: 15px;\r\n\t}\r\n\t&.border-line {\r\n\t\tborder-bottom: 1px solid $light-900;\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n}",".kanban-list-items {\r\n    border: 1px solid $light-900;\r\n    box-shadow: 0px 4px 4px 0px #DBDBDB40;\r\n    border-radius: 5px;\r\n    @include margin-padding(0 20px 20px 0, 15px);\r\n    width: 100%;\r\n    min-width: 315px;\r\n    &:last-child {\r\n        margin-right: 0;\r\n    }\r\n}\r\n.icons-social {\r\n    a {\r\n        width: 30px;\r\n        height: 30px;\r\n        background: $light-500;\r\n        border-radius: 50%;\r\n        color: $title-color;\r\n        &:hover {\r\n            background: $danger-100;\r\n            color: $primary;\r\n        }\r\n    }\r\n}\r\n.kanban-drag-wrap {\r\n    > div {\r\n        &:last-child {\r\n            .kanban-card {\r\n                margin-bottom: 0;\r\n            }\r\n        }\r\n       \r\n    }\r\n}\r\n.pipeline-progress {\r\n    .progress {\r\n        background: transparent;\r\n        width: 70px;\r\n        height: 5px;\r\n        .progress-bar {\r\n            width: 70px;\r\n            height: 5px;\r\n            border-radius: 5px;\r\n            &.progress-bar-success {\r\n                background: $success;\r\n            }\r\n            &.progress-bar-violet {\r\n                background: $purple;\r\n            }\r\n            &.progress-bar-info {\r\n                background: $info;\r\n            }\r\n            &.progress-bar-warning {\r\n                background: $warning;\r\n            }\r\n            &.progress-bar-green {\r\n                background: $green;\r\n            }\r\n            &.progress-bar-danger {\r\n                background: $danger;\r\n            }\r\n        }\r\n    }\r\n    span {\r\n        margin-left: 10px;\r\n        color: $gray-900;\r\n        font-weight: $font-weight-medium;\r\n    }\r\n}\r\n.pipe-title {\r\n    .add-stage {\r\n        color: $primary;\r\n        font-weight: $font-weight-medium;\r\n        margin-bottom: 15px;\r\n        display: inline-block;\r\n        i {\r\n            margin-right: 8px;\r\n        }\r\n    }\r\n}\r\n.priority-info {\r\n    .dropdown {\r\n        .dropdown-toggle {\r\n            display: -webkit-box;\r\n            display: -ms-flexbox;\r\n            display: flex;\r\n            align-items: center;\r\n            -webkit-box-align: center;\r\n            -ms-flex-align: center;\r\n            justify-content: space-between;\r\n            -webkit-justify-content: space-between;\r\n            -ms-flex-pack: space-between;\r\n            border: 1px solid $light-900;\r\n            box-shadow: 0px 4px 4px 0px #DBDBDB40;\r\n            border-radius: 5px;\r\n            @include margin-padding(null, 5px 10px);\r\n            font-weight: $font-weight-medium;\r\n            &[aria-expanded=true] {\r\n                & > i {\r\n                    @include transition(all 0.2s ease);\r\n                    @include transform(rotate(180deg));\r\n                }\r\n            }\r\n            &::after {\r\n                content: none;\r\n            }\r\n            span{\r\n                display: -webkit-inline-box;\r\n                display: -ms-inline-flexbox;\r\n                display: inline-flex;\r\n                align-items: center;\r\n                -webkit-box-align: center;\r\n                -ms-flex-align: center;\r\n                i {\r\n                    font-size: $font-size-10;\r\n                }                \r\n            }\r\n        }\r\n        a {\r\n            font-size: $font-size-14;\r\n            color: $gray-900;\r\n            span{\r\n               display: -webkit-inline-box;\r\n               display: -ms-inline-flexbox;\r\n               display: inline-flex;\r\n               align-items: center;\r\n               -webkit-box-align: center;\r\n               -ms-flex-align: center;\r\n               i {\r\n                   font-size: 10px;\r\n               }                \r\n            }\r\n        }\r\n        .dropdown-menu {\r\n            width: 100%;\r\n        }\r\n    }\r\n}\r\n.select-pipeline {\r\n    position: relative;\r\n    margin-right: 8px;\r\n    .pipe-icon {\r\n        @include position(absolute, 50%, null, null, 10px);\r\n        z-index: 99999;\r\n        transform: translateY(-50%);\r\n        color: $gray-900;\r\n    }\r\n    .select2-container {\r\n        .select2-selection {\r\n            &.select2-selection--single {\r\n                height: 40px;\r\n                border-radius: 5px;\r\n                color: $gray-900;\r\n                font-weight: $font-weight-medium;\r\n                .select2-selection__rendered {\r\n                    padding-left: 30px;\r\n                    line-height: 40px;\r\n                    color: $gray-900;\r\n                    font-weight: $font-weight-medium;\r\n                    padding-right: 30px;\r\n                }\r\n                .select2-selection__arrow {\r\n                    height: 40px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.pipeline-list {\r\n    border-bottom: 1px solid $light-900;\r\n    margin-bottom: 15px;\r\n    ul {\r\n        margin-bottom: 15px;\r\n        li {\r\n            display: inline-block;\r\n            &:first-child {\r\n                a {\r\n                    border-radius: 10px 0 0 10px;\r\n                }\r\n            }\r\n            &:last-child {\r\n                a {\r\n                    border-radius: 0;\r\n                }\r\n            }\r\n            a {\r\n                @include margin-padding(0 0 3px, 12px 25px 12px 50px);\r\n                font-size: $font-size-14;\r\n                font-weight: $font-weight-medium;\r\n                display: inline-block;\r\n                text-align: center;\r\n                background: $light-300;\r\n                color: $title-color;\r\n                position: relative;\r\n                min-width: 185px;\r\n                &::after {\r\n                    content: '';\r\n                    @include position(absolute, 0,-23px, null, null);\r\n                    width: 45px;\r\n                    height: 45px;\r\n                    -webkit-transform: scale(.707) rotate(45deg);\r\n                    -ms-transform: scale(.707) rotate(45deg);\r\n                    -moz-transform: scale(.707) rotate(45deg);\r\n                    -transform: scale(.707) rotate(45deg);\r\n                    z-index: 1;\r\n                    background: $light-300;\r\n                    -webkit-box-shadow: 2px -2px 0 1px #fff,3px -3px 0 2px rgba(255,255,255,.1);\r\n                    box-shadow: 2px -2px 0 1px #fff,3px -3px 0 2px rgba(255,255,255,.1);\r\n                    border-radius: 0 5px 0 50px;\r\n                } \r\n                &.bg-info {\r\n                    color: $white;\r\n                    &::after {\r\n                        background: $info;\r\n                    }\r\n                    &:hover {\r\n                        background: $info !important;\r\n                    }\r\n                }    \r\n                &.bg-warning {\r\n                    color: $white;\r\n                    &::after {\r\n                        background: $warning;\r\n                    }\r\n                    &:hover {\r\n                        background: $warning !important;\r\n                    }\r\n                }     \r\n                &.bg-pending {\r\n                    color: $white;\r\n                    background: $purple !important;\r\n                    &::after {\r\n                        background: $purple;\r\n                    }\r\n                    &:hover {\r\n                        background: $purple !important;\r\n                    }\r\n                }      \r\n                &.bg-pink {\r\n                    color: $white;\r\n                    &::after {\r\n                        background: $pink;\r\n                    }\r\n                    &:hover {\r\n                        background: $pink !important;\r\n                    }\r\n                }        \r\n                &.bg-success {\r\n                    color: $white;\r\n                    &::after {\r\n                        background: $success;\r\n                    }\r\n                    &:hover {\r\n                        background: $success !important;\r\n                    }\r\n                }         \r\n                &.bg-danger {\r\n                    color: $white;\r\n                    &::after {\r\n                        background: $danger;\r\n                    }\r\n                    &:hover {\r\n                        background: $danger !important;\r\n                    }\r\n                }          \r\n                &.bg-gray {\r\n                    color: $white;\r\n                    background: $background-3;\r\n                    &::after {\r\n                        background: $background-3;\r\n                    }\r\n                    &:hover {\r\n                        background: $background-3 !important;\r\n                    }\r\n                }   \r\n                @include respond-below(custom575) {  \r\n                    width: calc(100% - 25px);\r\n                }       \r\n            }               \r\n            @include respond-below(custom575) {  \r\n                display: block;\r\n            }  \r\n        }\r\n    }\r\n}",".campaign-box {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tjustify-content: space-between;\r\n\t-webkit-justify-content: space-between;\r\n\t-ms-flex-pack: space-between;\r\n\t@include margin-padding(0 0 24px, 24px);\r\n\t@include rounded(5px);\r\n\t@include respond-below(custom1399) {\r\n\t\t@include margin-padding(0 0 24px, 15px);\r\n\t}\r\n\t.campaign-img {\r\n\t\tdisplay: -webkit-box;\r\n\t\tdisplay: -ms-flexbox;\r\n\t\tdisplay: flex;\r\n\t\t-webkit-box-align: center;\r\n\t\t-ms-flex-align: center;\r\n\t\talign-items: center;\r\n\t\tspan {\r\n\t\t\twidth: 44px;\r\n\t\t\theight: 44px;\r\n\t\t\t@include rounded(5px);\r\n\t\t\tdisplay: -webkit-box;\r\n\t\t\tdisplay: -ms-flexbox;\r\n\t\t\tdisplay: flex;\r\n\t\t\t-webkit-box-align: center;\r\n\t\t\t-ms-flex-align: center;\r\n\t\t\talign-items: center;\r\n\t\t\tjustify-content: center;\r\n\t\t\t-webkit-justify-content: center;\r\n\t\t\t-ms-flex-pack: center;\r\n\t\t\tcolor: $white;\r\n\t\t\tmargin-right: 10px;\r\n\t\t}\r\n\t\tp {\r\n\t\t\tcolor: $gray-900;\r\n\t\t\tfont-weight: $font-weight-medium;\r\n\t\t}\t\t\r\n\t}\r\n\th2 {\r\n\t\tcolor: $gray-400;\r\n\t\t@include respond-below(custom1399) {\r\n\t\t\tfont-size: $font-size-24;\r\n\t\t}\r\n\t\t@include respond-below(custom991) {\r\n\t\t\tfont-size: $font-size-20;\r\n\t\t}\r\n\t}\r\n\t&.bg-danger-light {\r\n\t\tbackground-color: $danger-100;\r\n\t\tspan {\r\n\t\t\tbackground-color: $danger;\r\n\t\t}\r\n\t}\r\n\t&.bg-warning-light {\r\n\t\tbackground-color: $warning-100;\r\n\t\tspan {\r\n\t\t\tbackground-color: $secondary;\r\n\t\t}\r\n\t}\r\n\t&.bg-purple-light {\r\n\t\tbackground-color: $purple-100;\r\n\t\tspan {\r\n\t\t\tbackground-color: $tertiary;\r\n\t\t}\r\n\t}\r\n\t&.bg-success-light {\r\n\t\tbackground-color: $success-200;\r\n\t\tspan {\r\n\t\t\tbackground-color: $green;\r\n\t\t}\r\n\t}\r\n}\r\n.campaign-tab {\r\n\t@include margin-padding(0 0 20px, 15px 15px 0);\r\n\tbox-shadow: 0px 4px 74px 0px #D0D0D040;\r\n\tbackground-color: $white;\r\n\t@include rounded(5px);\r\n\tul {\r\n\t\tli {\r\n\t\t\tmargin-right: 15px;\r\n\t\t\ta {\r\n\t\t\t\tposition: relative;\r\n\t\t\t\tfont-weight: $font-weight-medium;\r\n\t\t\t\tborder-bottom: 4px solid $white;\r\n\t\t\t\t@include margin-padding(null, 10px 10px 20px);\r\n\t\t\t\tdisplay: -webkit-inline-box;\r\n\t\t\t\tdisplay: -ms-inline-flexbox;\r\n            \tdisplay: inline-flex;\r\n\t\t\t    -webkit-box-align: center;\r\n\t\t\t    -ms-flex-align: center;\r\n\t\t\t    align-items: center;\r\n\t\t\t\tjustify-content: center;\r\n\t\t\t    -webkit-justify-content: center;\r\n\t\t\t    -ms-flex-pack: center;\r\n\t\t\t\t&.active {\r\n\t\t\t\t\tborder-color: $primary;\r\n\t\t\t\t}\r\n\t\t\t\tspan {\r\n\t\t\t\t\twidth: 20px;\r\n\t\t\t\t\theight: 20px;\r\n\t\t\t\t\tdisplay: -webkit-inline-box;\r\n\t\t\t        display: -ms-inline-flexbox;\r\n            \t\tdisplay: inline-flex;\r\n\t\t\t        -webkit-box-align: center;\r\n\t\t\t        -ms-flex-align: center;\r\n\t\t\t        align-items: center;\r\n\t\t\t        justify-content: center;\r\n\t\t\t        -webkit-justify-content: center;\r\n\t\t\t        -ms-flex-pack: center;\r\n\t\t\t        border: 1px solid $light-900;\r\n\t\t\t        @include rounded(50%);\r\n\t\t\t        margin-left: 10px;\r\n\t\t\t        font-size: $font-size-10;\r\n\t\t\t        font-weight: $font-weight-semibold;\r\n\t\t\t        color: $gray-400;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t\t&:last-child {\r\n\t\t\t\tmargin-right: 0;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\nul.project-mem {\r\n\tdisplay: -webkit-inline-box;\r\n\tdisplay: -ms-inline-flexbox;\r\n\tdisplay: inline-flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n  \tli {\r\n  \t\tmargin-left: -10px;\r\n\t\tdisplay: inline-flex;\r\n\t\ta {\r\n\t\t\twidth: 24px;\r\n\t\t\theight: 24px;\r\n\t\t}\r\n  \t\t&:first-child {\r\n  \t\t\tmargin-left: 0;\r\n  \t\t}\r\n  \t\ta {\r\n  \t\t\timg {\r\n  \t\t\t\twidth: 24px;\r\n  \t\t\t\theight: 24px;\r\n  \t\t\t\tborder-radius: 50%;\r\n  \t\t\t\tborder: 1px solid $white;\r\n  \t\t\t}\r\n  \t\t}\r\n  \t\t&.more-set {\r\n  \t\t\ta {\r\n  \t\t\t\twidth: 24px;\r\n  \t\t\t\theight: 24px;\r\n  \t\t\t\tborder-radius: 50%;\r\n  \t\t\t\tbackground-color: $white;\r\n  \t\t\t\tborder: 1px solid $light-900;\r\n  \t\t\t\tdisplay: -webkit-inline-box;\r\n\t\t\t\tdisplay: -ms-inline-flexbox;\r\n\t\t\t\tdisplay: inline-flex;\r\n\t\t\t\t-webkit-box-align: center;\r\n\t\t\t\t-ms-flex-align: center;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tjustify-content: center;\r\n\t\t\t\t-webkit-justify-content: center;\r\n\t\t\t\t-ms-flex-pack: center;\r\n\t\t\t\tfont-size: $font-size-12;\r\n\t\t\t\tfont-weight: $font-weight-semibold;\r\n\t\t\t\tcolor: $gray-400;\r\n  \t\t\t}\r\n  \t\t}\r\n  \t}\r\n}\r\n.list-progress {\r\n\tli {\r\n\t\tdisplay: inline-block;\r\n\t\tmargin-right: 15px;\r\n\t\th6 {\r\n\t\t\tfont-weight: $font-weight-semibold;\r\n\t\t}\r\n\t\tp {\r\n\t\t\tfont-size: 12px;\r\n\t\t\tfont-weight: $font-weight-semibold;\r\n\t\t\tcolor: $gray-400;\r\n\t\t}\r\n\t\t&:last-child {\r\n\t\t\tmargin-right: 0;\r\n\t\t}\r\n\t}\r\n}",".form-wrap {\r\n\t.checkmarks.mem-plane-check {\r\n\t\ttop: 3px;\r\n\t}\r\n}\r\n.table-imgname.flag-image img {\r\n\twidth: 24px;\r\n\theight: 18px;\r\n\tborder-radius: 5px;\r\n}\r\n.table-imgname.flag-image {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\t\r\n}\r\n.location-flag-img {\r\n\tborder: 1px solid #E8E8E8;\r\n\tborder-radius: 5px;\r\n\twidth: 32px;\r\n\theight: 32px;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tmargin-right: 8px;\r\n}\r\n.table-imgname.flag-image span {\r\n\tfont-weight: 500;\r\n\tcolor: #262A2A;\r\n}\r\n#delete_request {\r\n\ttd {\r\n\t\tspan {\r\n\t\t\t&.badge {\r\n\t\t\t\tcursor: pointer;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n.wh-14 {\r\n\twidth: 14px;\r\n\theight: 14px;\r\n}",".select2-container {\r\n    min-width: 100% !important;\r\n    z-index: 99;\r\n    .select2-selection--single {\r\n        height: 40px;\r\n    }\r\n}\r\n.select2-container--default {\r\n    .select2-selection--single {\r\n        border: 1px solid var(--Stroke, rgba(145, 158, 171, 0.30));\r\n        @include rounded(5px);\r\n        .select2-selection__rendered {\r\n            color: $text-color;\r\n            line-height: 38px;\r\n            @include rounded(5px);\r\n            padding-left: 10px;\r\n            font-size: $font-size-14;\r\n            font-weight: $font-weight-normal;\r\n            padding-right: 25px;\r\n             span {\r\n                display: -webkit-inline-box;\r\n                display: -ms-inline-flexbox;\r\n                display: inline-flex;\r\n                -webkit-box-align: center;\r\n                -ms-flex-align: center;\r\n                align-items: center;\r\n                img {\r\n                    width: 16px;\r\n                    height: 16px;\r\n                    border-radius: 5px;\r\n                    margin-right: 5px;\r\n                }\r\n            }\r\n        }\r\n        .select {\r\n            width: 219px;\r\n        }\r\n        .select2-selection__arrow {\r\n            height: 40px;\r\n            right: 6px;\r\n        }\r\n    }\r\n}\r\n.select2-container--default .select2-selection--single .select2-selection__arrow b {\r\n    @include position(absolute,50%,null,null,50%);\r\n    border-color: #637381;\r\n    border-style: solid;\r\n    border-width: 0 2px 2px 0;\r\n    padding: 3px;\r\n    height: 0;\r\n    margin-left: -6px;\r\n    margin-top: -3px;\r\n    width: 0;\r\n    @include transform(rotate(45deg) translateY(-50%));\r\n}\r\n.select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b {\r\n    border-color: $black;;\r\n    border-width: 2px 0 0 2px;\r\n    margin-top: 3px;\r\n    @include margin-padding(null, 3px);\r\n}\r\n.select2-container--default .select2-results__option--highlighted[aria-selected] {\r\n    background: $primary;\r\n    color: $white;\r\n}\r\n.select2-container--focus  {\r\n    .select2-selection--single{\r\n        background: $white !important;\r\n        border-color: $primary;\r\n    }\r\n}\r\nspan.select2-container.select2-container--default.select2-container--open {\r\n    z-index: 9999;\r\n}\r\n.select2-container--default .select2-selection--single .select2-selection__rendered,\r\n.select2-container--default .select2-selection--multiple {\r\n    box-shadow: 0px 4px 4px 0px #DBDBDB40;\r\n}\r\n.select2-container--classic .select2-selection--single,\r\n.select2-container--default .select2-selection--single,\r\n.select2-container--default .select2-selection--single .select2-selection__rendered,\r\n.select2-container--default .select2-selection--single .select2-selection__arrow,\r\n.select2-container--default .select2-selection--multiple,\r\n.select2-container--classic .select2-selection--single .select2-selection__arrow,\r\n.select2-container--classic .select2-selection--single .select2-selection__rendered {\r\n    border-color: $light-900;\r\n    color: $text-color;\r\n    height: 40px;\r\n    line-height: 40px;\r\n}\r\n.select2-container--default .select2-selection--multiple {\r\n    line-height: 27px;\r\n    height: auto;\r\n    min-height: 40px;\r\n    .select2-selection__choice {\r\n        padding-left: 5px;\r\n        padding-right: 20px;\r\n    }\r\n    .select2-selection__choice__display {\r\n        span {\r\n            display: -webkit-inline-box;\r\n            display: -ms-inline-flexbox;\r\n            display: inline-flex;\r\n            -webkit-box-align: center;\r\n            -ms-flex-align: center;\r\n            align-items: center;\r\n            img {\r\n                width: 16px;\r\n                height: 16px;\r\n                border-radius: 5px;\r\n                margin-right: 5px;\r\n            }\r\n        }\r\n    }\r\n    .select2-selection__choice__remove {\r\n        right: 0;\r\n        left: auto;\r\n    }\r\n}\r\n.select2-results__option {\r\n    span {\r\n            display: -webkit-inline-box;\r\n            display: -ms-inline-flexbox;\r\n            display: inline-flex;\r\n            -webkit-box-align: center;\r\n            -ms-flex-align: center;\r\n            align-items: center;\r\n            img {\r\n                width: 16px;\r\n                height: 16px;\r\n                border-radius: 5px;\r\n                margin-right: 5px;\r\n            }\r\n        }\r\n}\r\n.select2-container--classic .select2-selection--multiple .select2-selection__choice,\r\n.select2-container--default .select2-selection--multiple .select2-selection__choice,\r\n.select2-container--default .select2-selection--multiple .select2-selection__choice__remove {\r\n    background-color: $light-300;\r\n    border-color: $light-300;\r\n    color: $gray-400;\r\n    border-radius: 5px;\r\n}\r\n.select2-container--default.select2-container--focus .select2-selection--multiple {\r\n    border-color: $light-900;\r\n}","table.dataTable {\r\n    margin: 0 !important;\r\n    width: 100% !important;\r\n}\r\ntable.dataTable>thead .sorting:after, \r\ntable.dataTable>thead .sorting_asc:after,\r\ntable.dataTable>thead .sorting_desc:after,\r\ntable.dataTable>thead .sorting_asc_disabled:after, \r\ntable.dataTable>thead .sorting_desc_disabled:after {\r\n    right: 0.5em !important;\r\n    content: \"\\f175\" !important;\r\n    font-family: 'Font Awesome 5 Free';\r\n    bottom: 12px !important;\r\n    color: #BABFC7 !important;\r\n    font-size: 12px !important;\r\n    opacity: 1 !important;\r\n    position: absolute;\r\n    font-weight: $font-weight-semibold;\r\n    line-height: 1px !important;\r\n}\r\ntable.dataTable>thead .sorting:before, \r\ntable.dataTable>thead .sorting_asc:before, \r\ntable.dataTable>thead .sorting_desc:before, \r\ntable.dataTable>thead .sorting_asc_disabled:before, \r\ntable.dataTable>thead .sorting_desc_disabled:before {\r\n    right: 13px !important;\r\n    content: \"\\f176\" !important;\r\n    font-family: 'Font Awesome 5 Free';\r\n    top: 50% !important;\r\n    transform: translateY(-50%);\r\n    color: #BABFC7 !important;\r\n    font-size: 12px !important;\r\n    opacity: 1 !important;\r\n    position: absolute;\r\n    font-weight: $font-weight-semibold;\r\n    line-height: 1px !important;\r\n}\r\n.dataTables_paginate, #dataTables_paginate {\r\n    .paging_numbers {\r\n        float: right;\r\n    }\r\n}\r\n.dataTables_info {\r\n    padding-right: 15px;\r\n    font-size: $font-size-12;\r\n    color: $gray-700;\r\n    font-weight: $font-weight-semibold;\r\n}\r\n.custom-select {\r\n    min-width: 80px;\r\n    // background: url(../img/icons/dropdown.svg) no-repeat 95% 50%;\r\n}\r\n.dataTables_paginate, #dataTables_paginate {\r\n    .pagination{\r\n        justify-content: end;\r\n        -webkit-justify-content: end;\r\n        -ms-flex-pack: end;\r\n        li{\r\n            @include margin-padding(0 2px, null);\r\n            a {\r\n                background: $white;\r\n                border-color: transparent;\r\n                border-radius: 5px !important;\r\n                width: 25px;\r\n                height: 25px;\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: center;\r\n                color: $gray-400;\r\n                &:hover{\r\n                    background: $green;\r\n                    color: $white;\r\n                }\r\n            }\r\n            &.active a.page-link{\r\n                background: $green;\r\n                border-color: $green;\r\n                @include rounded(5px);\r\n                width: 25px;\r\n                height: 25px;\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: center;\r\n            }\r\n            &.previous.disabled, &.previous {\r\n                width: auto;\r\n                margin: 0 13px 0 0;\r\n                a {\r\n                    background-color: transparent;\r\n                    border: 0;\r\n                    width: auto;\r\n                    padding: 0;\r\n                    i {\r\n                        margin-right: 8px;\r\n                    }\r\n                    &:hover {\r\n                        color: $green;\r\n                    }\r\n                }\r\n            }\r\n            &.next.disabled, &.next {\r\n                width: auto;\r\n                margin: 0 0 0 13px;\r\n                a {\r\n                    background-color: transparent;\r\n                    border: 0;\r\n                    width: auto;\r\n                    padding: 0;\r\n                    i {\r\n                        margin-left: 8px;\r\n                    }\r\n                    &:hover {\r\n                        color: $green;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n        @include respond-below(custom767) {\r\n            justify-content: center;\r\n            -webkit-justify-content: center;\r\n            -ms-flex-pack: center;\r\n        }\r\n    }\r\n}\r\n.dataTables_length, #dataTables_length\r\n.dataTables_paginate, #dataTables_paginate {\r\n    margin-top:15px !important;\r\n}\r\n.dataTables_length, #dataTables_length {\r\n    label {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        align-items: center;\r\n        color: $text-color;\r\n        font-size: $font-size-14;\r\n        .form-select {\r\n            width: 73px;\r\n            border: 1px solid #E8E8E8;\r\n            border-radius: 5px;\r\n            color: $gray-900;\r\n            margin: 0 8px;\r\n        }\r\n        @include respond-below(custom767) {\r\n            justify-content: center;\r\n            -webkit-justify-content: center;\r\n            -ms-flex-pack: center;\r\n            margin-bottom: 10px;\r\n        }\r\n    }\r\n}\r\n.datatable-length {\r\n    @include respond-below(custom767) {\r\n        text-align: center;\r\n    }\r\n\r\n}\r\ndiv.dataTables_wrapper div.dataTables_info {\r\n    padding-top: 23px;\r\n}\r\ntable.dataTable thead>tr>th.no-sort.sorting_asc:before {\r\n    display: none;\r\n}\r\ntable.dataTable thead>tr>th.no-sort.sorting_asc::after {\r\n    display: none;\r\n}\r\ntable.dataTable thead>tr>th.no-sort.sorting:before {\r\n    display: none;\r\n}\r\ntable.dataTable thead>tr>th.no-sort.sorting::after {\r\n    display: none;\r\n}\r\n.custom-table .table-responsive {\r\n    border: 1px solid $light-900;\r\n    border-radius: 6px;\r\n}\r\ntable.table.dataTable {\r\n    & > tbody {\r\n        > tr {\r\n            border-color: $light-900;\r\n            td {\r\n                color: $gray-400;\r\n            }\r\n        } \r\n    }\r\n    & > thead > tr {\r\n        border-color: $light-900;\r\n            th {\r\n                color: $gray-900;\r\n                font-size: $font-size-14;\r\n                font-weight: $font-weight-medium;\r\n            }\r\n    }\r\n}\r\n.active>.page-link, .page-link.active {\r\n    z-index: unset;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
